/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const prefix = 'far';
const fa0 = {
  prefix: 'far',
  iconName: '0',
  icon: [
    320,
    512,
    [],
    '30',
    'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 80C98.1 80 48 130.1 48 192l0 128c0 61.9 50.1 112 112 112s112-50.1 112-112l0-128c0-61.9-50.1-112-112-112z',
  ],
};
const fa1 = {
  prefix: 'far',
  iconName: '1',
  icon: [
    256,
    512,
    [],
    '31',
    'M152 56c0-8.7-4.7-16.7-12.3-21s-16.9-4-24.3 .5l-104 64c-11.3 6.9-14.8 21.7-7.9 33s21.7 14.8 33 7.9L104 98.9 104 432l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-376z',
  ],
};
const fa2 = {
  prefix: 'far',
  iconName: '2',
  icon: [
    320,
    512,
    [],
    '32',
    'M147.6 80c-26.6 0-52.2 10.6-71 29.4L41 145c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L42.6 75.5C70.4 47.6 108.2 32 147.6 32l7.3 0C232.8 32 296 95.2 296 173.2c0 39.1-16.2 76.4-44.7 103.1L84.8 432 296 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-9.9 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L218.5 241.2c18.8-17.6 29.5-42.2 29.5-68c0-51.5-41.7-93.2-93.2-93.2l-7.3 0z',
  ],
};
const fa3 = {
  prefix: 'far',
  iconName: '3',
  icon: [
    320,
    512,
    [],
    '33',
    'M0 56C0 42.7 10.7 32 24 32l256 0c9.8 0 18.6 6 22.3 15.1s1.4 19.5-5.7 26.3L147.7 216l40.3 0c72.9 0 132 59.1 132 132s-59.1 132-132 132l-90.6 0c-39.4 0-75.4-22.3-93-57.5l-1.9-3.8c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l1.9 3.8c9.5 19 28.9 31 50.1 31l90.6 0c46.4 0 84-37.6 84-84s-37.6-84-84-84L88 264c-9.8 0-18.6-6-22.3-15.1s-1.4-19.5 5.7-26.3L220.3 80 24 80C10.7 80 0 69.3 0 56z',
  ],
};
const fa4 = {
  prefix: 'far',
  iconName: '4',
  icon: [
    384,
    512,
    [],
    '34',
    'M189.2 67.2c6.2-11.7 1.7-26.2-10-32.4s-26.2-1.7-32.4 10l-144 272c-3.9 7.4-3.7 16.4 .6 23.6S15.6 352 24 352l248 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152L63.9 304 189.2 67.2z',
  ],
};
const fa5 = {
  prefix: 'far',
  iconName: '5',
  icon: [
    320,
    512,
    [],
    '35',
    'M32.4 51.9C34.4 40.4 44.3 32 56 32l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L76.2 80 52.5 216 188 216c72.9 0 132 59.1 132 132s-59.1 132-132 132l-95.5 0c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l4.1 8.2C57.7 421.7 74.3 432 92.5 432l95.5 0c46.4 0 84-37.6 84-84s-37.6-84-84-84L24 264c-7.1 0-13.8-3.1-18.4-8.6S-.9 242.9 .4 235.9l32-184z',
  ],
};
const fa6 = {
  prefix: 'far',
  iconName: '6',
  icon: [
    320,
    512,
    [],
    '36',
    'M272 320c0-61.9-50.1-112-112-112c-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3C56.8 269.7 48 294.5 48 320c0 61.9 50.1 112 112 112s112-50.1 112-112zM145.7 160.6c4.7-.4 9.5-.6 14.3-.6c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L181.4 40.8c8.4-10.3 23.5-11.8 33.8-3.4s11.8 23.5 3.4 33.8l-72.9 89.5z',
  ],
};
const fa7 = {
  prefix: 'far',
  iconName: '7',
  icon: [
    320,
    512,
    [],
    '37',
    'M0 56C0 42.7 10.7 32 24 32l272 0c8.6 0 16.6 4.7 20.9 12.2s4.1 16.8-.3 24.2l-240 400c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9L253.6 80 24 80C10.7 80 0 69.3 0 56z',
  ],
};
const fa8 = {
  prefix: 'far',
  iconName: '8',
  icon: [
    320,
    512,
    [],
    '38',
    'M304 156c0-68.5-55.5-124-124-124l-40 0C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124l72 0c68.5 0 124-55.5 124-124c0-44.8-23.7-84-59.3-105.8C287.2 227.4 304 193.7 304 156zM180.1 280l15.9 0c42 0 76 34 76 76s-34 76-76 76l-72 0c-42 0-76-34-76-76s34-76 76-76l15.9 0c0 0 0 0 .1 0l40 0c0 0 0 0 .1 0zm0-48c0 0 0 0 0 0l-40 0c0 0 0 0 0 0c-42 0-76-34-76-76c0-42 34-76 76-76l40 0c42 0 76 34 76 76c0 42-34 76-76 76z',
  ],
};
const fa9 = {
  prefix: 'far',
  iconName: '9',
  icon: [
    320,
    512,
    [],
    '39',
    'M48 192c0 61.9 50.1 112 112 112c32.3 0 61.5-13.7 81.9-35.6l5.1-6.3C263.2 242.3 272 217.5 272 192c0-61.9-50.1-112-112-112S48 130.1 48 192zM174.3 351.4c-4.7 .4-9.5 .6-14.3 .6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L138.6 471.2c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l72.9-89.5z',
  ],
};
const faFillDrip = {
  prefix: 'far',
  iconName: 'fill-drip',
  icon: [
    576,
    512,
    [],
    'f576',
    'M39 7C48.4-2.3 63.6-2.3 73 7l89.4 89.4 58.7-58.7c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l97.8-97.8L39 41C29.7 31.6 29.7 16.4 39 7zM231 233l-68.7-68.7L64.6 262.1c-7.3 7.3-11.8 16.4-13.4 25.9l358.2 0 31-31c9.4-9.4 9.4-24.6 0-33.9L289 71.6c-9.4-9.4-24.6-9.4-33.9 0l-58.7 58.7L265 199c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z',
  ],
};
const faArrowsToCircle = {
  prefix: 'far',
  iconName: 'arrows-to-circle',
  icon: [
    640,
    512,
    [],
    'e4bd',
    'M7 7C16.4-2.3 31.6-2.3 41 7l119 119L160 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l38.1 0L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-119 119 38.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 38.1L599 7c9.4-9.4 24.6-9.4 33.9 0zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM432 424l0-96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-38.1 0L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119 0 38.1c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-224 0c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-38.1L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119L88 352c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 96z',
  ],
};
const faCircleChevronRight = {
  prefix: 'far',
  iconName: 'circle-chevron-right',
  icon: [
    512,
    512,
    ['chevron-circle-right'],
    'f138',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377L345 273c9.4-9.4 9.4-24.6 0-33.9L241 135c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z',
  ],
};
const faChevronCircleRight = faCircleChevronRight;
const faWagonCovered = {
  prefix: 'far',
  iconName: 'wagon-covered',
  icon: [
    640,
    512,
    [],
    'f8ee',
    'M569.8 4.1c45.9-3.1 79.9 41.8 64.6 85.2L567.8 278c5 4.4 8.2 10.9 8.2 18c0 12.9-10.2 23.5-23 24c0 0 0 0 0 0l-10.6 0c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l-66.3 0c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80L87 320s0 0 0 0c-12.8-.5-23-11.1-23-24c0-7.2 3.2-13.6 8.2-18L5.6 89.3C-9.7 45.9 24.3 1 70.2 4.1l119.7 8c21.6 1.4 41 10.6 55.5 24.7C258.4 23.9 276.3 16 296 16l48 0c19.7 0 37.6 7.9 50.6 20.8c14.5-14.1 33.9-23.3 55.5-24.7l119.7-8zM519 272L589.2 73.3C593 62.4 584.5 51.2 573 52L453.3 60c-21 1.4-37.3 18.9-37.3 39.9L416 272l103 0zM186.7 60L67 52c-11.5-.8-20 10.5-16.2 21.3L121 272l103 0 0-172.1c0-21.1-16.3-38.5-37.3-39.9zM368 272l0-184c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 11.9L272 272l96 0zM160 416l-46 0c5.8 22.5 23.5 40.2 46 46l0-46zm0-32l0-46c-22.5 5.8-40.2 23.5-46 46l46 0zm32 78c22.5-5.8 40.2-23.5 46-46l-46 0 0 46zm0-124l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zM448 462l0-46-46 0c5.8 22.5 23.5 40.2 46 46zm-46-78l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm124 32l-46 0 0 46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46l0 46 46 0z',
  ],
};
const faLineHeight = {
  prefix: 'far',
  iconName: 'line-height',
  icon: [
    576,
    512,
    [],
    'f871',
    'M113.8 39.9c-4.6-5.1-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-72 80c-8.9 9.9-8.1 25 1.8 33.9s25 8.1 33.9-1.8L72 118.5l0 274.9L41.8 359.9c-8.9-9.9-24-10.7-33.9-1.8s-10.7 24-1.8 33.9l72 80c4.6 5.1 11 7.9 17.8 7.9s13.3-2.9 17.8-7.9l72-80c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L120 393.5l0-274.9 30.2 33.5c8.9 9.9 24 10.7 33.9 1.8s10.7-24 1.8-33.9l-72-80zM248 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L248 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM224 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faBagel = {
  prefix: 'far',
  iconName: 'bagel',
  icon: [
    640,
    512,
    [129391],
    'e3d7',
    'M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0A160 160 0 1 0 48 304zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm144-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z',
  ],
};
const faTransporter7 = {
  prefix: 'far',
  iconName: 'transporter-7',
  icon: [
    512,
    512,
    [],
    'e2a8',
    'M480 64l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zm56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z',
  ],
};
const faAt = {
  prefix: 'far',
  iconName: 'at',
  icon: [
    512,
    512,
    [61946],
    '40',
    'M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c13.3 0 24 10.7 24 24s-10.7 24-24 24C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 28c0 50.8-41.2 92-92 92c-31.1 0-58.7-15.5-75.3-39.2C322.7 360.9 291.1 376 256 376c-66.3 0-120-53.7-120-120s53.7-120 120-120c28.8 0 55.2 10.1 75.8 27c4.3-6.6 11.7-11 20.2-11c13.3 0 24 10.7 24 24l0 80 0 28c0 24.3 19.7 44 44 44s44-19.7 44-44l0-28c0-114.9-93.1-208-208-208zm72 208a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z',
  ],
};
const faRectanglesMixed = {
  prefix: 'far',
  iconName: 'rectangles-mixed',
  icon: [
    576,
    512,
    [],
    'e323',
    'M256 80c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L64 208c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l192 0zM64 32C28.7 32 0 60.7 0 96l0 96c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 32zM512 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l64 0zM448 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0zM128 352l144 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-144 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM64 368l0 48c0 35.3 28.7 64 64 64l144 0c35.3 0 64-28.7 64-64l0-48c0-35.3-28.7-64-64-64l-144 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faPhoneArrowUpRight = {
  prefix: 'far',
  iconName: 'phone-arrow-up-right',
  icon: [
    512,
    512,
    ['phone-arrow-up', 'phone-outgoing'],
    'e224',
    'M295 183l135-135L376 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm34 103.6c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z',
  ],
};
const faPhoneArrowUp = faPhoneArrowUpRight;
const faPhoneOutgoing = faPhoneArrowUpRight;
const faTrashCan = {
  prefix: 'far',
  iconName: 'trash-can',
  icon: [
    448,
    512,
    [61460, 'trash-alt'],
    'f2ed',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faTrashAlt = faTrashCan;
const faCircleL = {
  prefix: 'far',
  iconName: 'circle-l',
  icon: [
    512,
    512,
    [],
    'e114',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-184z',
  ],
};
const faHeadSideGoggles = {
  prefix: 'far',
  iconName: 'head-side-goggles',
  icon: [
    512,
    512,
    ['head-vr'],
    'f6ea',
    'M.6 240C3.9 287.4 22 330.8 50.3 365.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C66 308.7 52 275.9 48.7 240L.6 240zM122.8 80C151.4 59.8 186.3 48 224 48l24 0 1.5 0L288 48c-28.4 0-54 12.4-71.6 32l-93.7 0zM51.4 81.2C22.1 87.1 0 113 0 144c0 35.3 28.7 64 64 64l152.4 0c17.6 19.6 43.1 32 71.6 32l96 0 24 0 24 0 32 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-32 0-24 0-24 0-5.5 0C342.8 18.1 296.6 0 248 0L224 0C154.5 0 92.5 31.6 51.4 81.2zM464 272.4c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6l0-.4-48 0 0 .4zM64 128l129.3 0c-.9 5.2-1.3 10.5-1.3 16s.5 10.8 1.3 16L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM384 96l0 96-96 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l96 0zm48 0l32 0 0 96-32 0 0-96z',
  ],
};
const faHeadVr = faHeadSideGoggles;
const faTextHeight = {
  prefix: 'far',
  iconName: 'text-height',
  icon: [
    576,
    512,
    [],
    'f034',
    'M48 128l0-48 88 0 0 352-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-352 88 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24zM497 39c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 0 284.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-284.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L497 39z',
  ],
};
const faUserXmark = {
  prefix: 'far',
  iconName: 'user-xmark',
  icon: [
    640,
    512,
    ['user-times'],
    'f235',
    'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112l91.4 0zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304L224 304l-45.7 0zM455 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faUserTimes = faUserXmark;
const faFaceHandYawn = {
  prefix: 'far',
  iconName: 'face-hand-yawn',
  icon: [
    512,
    512,
    [],
    'e379',
    'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59.4-24.9 113-64.9 150.9c2.9 15.1-1.5 31.3-13.2 43l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-10.7C72.6 368.2 48 315 48 256zm208-48c-44.2 0-81.3 29.8-92.5 70.4l.5 0c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0c1 1 2 2.1 3 3.2c4.7-1.1 9.5-1.5 14.3-1.2C322.6 227.4 291.6 208 256 208zM226.7 105c-8.3-10.4-23.4-12-33.7-3.7l-80 64c-10.4 8.3-12 23.4-3.7 33.7s23.4 12 33.7 3.7l80-64c10.4-8.3 12-23.4 3.7-33.7zM289 138.7l80 64c10.3 8.3 25.5 6.6 33.7-3.7s6.6-25.5-3.8-33.7l-80-64c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7zm10.3 137.9c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faGaugeSimpleMin = {
  prefix: 'far',
  iconName: 'gauge-simple-min',
  icon: [
    512,
    512,
    ['tachometer-slowest'],
    'f62d',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-30.9-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56s56-25.1 56-56z',
  ],
};
const faTachometerSlowest = faGaugeSimpleMin;
const faStethoscope = {
  prefix: 'far',
  iconName: 'stethoscope',
  icon: [
    576,
    512,
    [129658],
    'f0f1',
    'M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5L80 200c0 57.4 46.6 104 104 104l8 0 8 0c57.4 0 104-46.6 104-104l0-129.8c0-3.3-2.1-6.3-5.2-7.5L255.6 46.5c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2C337.5 25.9 352 46.8 352 70.2L352 200c0 78.5-59.5 143.1-135.8 151.1C219.9 414.1 272.1 464 336 464c66.3 0 120-53.7 120-120l0-75.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 75.7c0 92.8-75.2 168-168 168c-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200L32 70.2c0-23.3 14.5-44.2 36.3-52.4L111.6 1.5c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
  ],
};
const faCoffin = {
  prefix: 'far',
  iconName: 'coffin',
  icon: [
    384,
    512,
    [9904],
    'f6c6',
    'M48.2 145.8L133.8 48l116.4 0 85.6 97.8L243.9 464l-103.8 0L48.2 145.8zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1l127.9 0c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0l-131 0c-9.2 0-18 4-24.1 10.9z',
  ],
};
const faMessage = {
  prefix: 'far',
  iconName: 'message',
  icon: [
    512,
    512,
    ['comment-alt'],
    'f27a',
    'M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z',
  ],
};
const faCommentAlt = faMessage;
const faSalad = {
  prefix: 'far',
  iconName: 'salad',
  icon: [
    512,
    512,
    [129367, 'bowl-salad'],
    'f81e',
    'M416 96c-70.7 0-128 57.3-128 128c0 11 1.4 21.8 4 32l-52 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 137.4L107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 96 256c-53 0-96-43-96-96s43-96 96-96c8.7 0 17.2 1.2 25.3 3.4C138.5 27.7 178 0 224 0s85.5 27.7 102.7 67.4c8-2.2 16.5-3.4 25.3-3.4c28.5 0 54.2 12.5 71.8 32.2c-2.6-.2-5.2-.2-7.8-.2zM117.9 422.3c12.9 5.7 22.7 16.7 26.8 30.3c2 6.6 8.2 11.4 15.3 11.4l192 0c7.2 0 13.4-4.8 15.3-11.4c4-13.5 13.8-24.6 26.8-30.3c35.2-15.4 61.2-47.6 68.1-86.3L49.8 336c6.9 38.7 32.9 70.9 68.1 86.3zM0 315.4C0 300.3 12.3 288 27.4 288l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 67.4-40.6 125.4-98.6 150.8C405.5 492.7 381 512 352 512l-192 0c-29 0-53.5-19.3-61.4-45.7C40.6 440.8 0 382.9 0 315.4zM464 224c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32l-54.8 0c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96c0 11.2-1.9 22-5.5 32l-54.8 0c7.6-8.5 12.2-19.7 12.2-32z',
  ],
};
const faBowlSalad = faSalad;
const faInfo = {
  prefix: 'far',
  iconName: 'info',
  icon: [
    192,
    512,
    [],
    'f129',
    'M56 72a40 40 0 1 1 80 0A40 40 0 1 1 56 72zM16 200c0-13.3 10.7-24 24-24l56 0c13.3 0 24 10.7 24 24l0 264 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-240-32 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faRobotAstromech = {
  prefix: 'far',
  iconName: 'robot-astromech',
  icon: [
    512,
    512,
    [],
    'e2d2',
    'M256 0C185.3 0 128 57.3 128 128l0 16-40 0c-30.9 0-56 25.1-56 56l0 210.9L2.1 478.3c-3.3 7.4-2.6 16 1.8 22.8S15.9 512 24 512l112 0c13.3 0 24-10.7 24-24l0-72.9 22.1 24.8c4.6 5.1 11.1 8.1 17.9 8.1l112 0c6.9 0 13.4-2.9 17.9-8.1L352 415.1l0 72.9c0 13.3 10.7 24 24 24l112 0c8.1 0 15.7-4.1 20.1-10.9s5.1-15.4 1.8-22.8L480 410.9 480 200c0-30.9-25.1-56-56-56l-40 0 0-16C384 57.3 326.7 0 256 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM88 192l24 0 0 160 0 112-51.1 0 17-38.3c1.4-3.1 2.1-6.4 2.1-9.7l0-216c0-4.4 3.6-8 8-8zm72 0l192 0 0 150.9L301.2 400l-90.4 0L160 342.9 160 192zm240 0l24 0c4.4 0 8 3.6 8 8l0 216c0 3.4 .7 6.7 2.1 9.7l17 38.3L400 464l0-112 0-160zM208 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z',
  ],
};
const faRingDiamond = {
  prefix: 'far',
  iconName: 'ring-diamond',
  icon: [
    384,
    512,
    [],
    'e5ab',
    'M144 0c-8 0-15.5 4-20 10.7l-32 48c-5 7.5-5.4 17.1-1 25l31.8 57.2C51 168.6 0 238.4 0 320C0 426 86 512 192 512s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7c4.4-7.9 4-17.5-1-25l-32-48C255.5 4 248 0 240 0L144 0zm68.8 129.1C206 128.4 199 128 192 128s-14 .4-20.8 1.1l-31.1-56L156.8 48l70.3 0 16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0A144 144 0 1 1 48 320z',
  ],
};
const faFonduePot = {
  prefix: 'far',
  iconName: 'fondue-pot',
  icon: [
    512,
    512,
    [129749],
    'e40d',
    'M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192l-33 0 10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192l-38.5 0 33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM48 320c0 61.9 50.1 112 112 112l128 0c61.9 0 112-50.1 112-112l0-48-208 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-32 0 0 48zM0 256c0-17.7 14.3-32 32-32l368 0 16 0 32 0 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 48c0 52.3-25.1 98.8-64 128l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-15.3c-15.2 4.8-31.3 7.3-48 7.3l-128 0c-16.7 0-32.8-2.6-48-7.3l0 15.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C25.1 418.8 0 372.3 0 320l0-64z',
  ],
};
const faTheta = {
  prefix: 'far',
  iconName: 'theta',
  icon: [
    384,
    512,
    [],
    'f69e',
    'M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256zM192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167s78.9 73 132.4 73s100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16zM120 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faFaceHandPeeking = {
  prefix: 'far',
  iconName: 'face-hand-peeking',
  icon: [
    640,
    512,
    [129763],
    'e481',
    'M496.4 145.7c.4-.5 .9-1 1.4-1.4c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c6.6 6.6 10.6 14.7 12.2 23.2C208.2 72.3 261.3 48 320 48c74.4 0 139.6 39 176.4 97.7zm40.7 246c-5.4 .7-10.8 1.1-16.3 1.1l-44.2 0C438.5 436.5 382.5 464 320 464c-79.9 0-149.3-45-184.1-111.1l-16.7 0c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2zM352.8 264c-10.4-10.2-16.8-24.3-16.8-40c0-28.5 21.2-52 48.7-55.5c1-5.5 3.3-10.9 6.7-15.7c5.1-7.1 12.1-12.1 19.7-14.6c-6.2-1.4-12.6-2.1-19.2-2.1c-48.6 0-88 39.4-88 88c0 40.3 27.1 74.3 64.1 84.7c.1-1.4 .3-2.8 .6-4.2C358.6 297.3 352 285.4 352 272c0-2.7 .3-5.4 .8-8zM320 432c35.3 0 64-21.5 64-48s-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48zm90.3-192c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16l35.8 0zM248 192c0-8.8-7.2-16-16-16l-113.8 0c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9l64.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-14 0c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5l62 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-62.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-78.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l84 0c2.2 0 4 1.8 4 4s-1.8 4-4 4l-68 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5l-19.5 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64.8 0c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z',
  ],
};
const faSquareUser = {
  prefix: 'far',
  iconName: 'square-user',
  icon: [
    448,
    512,
    [],
    'e283',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-1 0c-7.9-63.1-61.7-112-127-112l-64 0c-65.3 0-119.1 48.9-127 112l-1 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM334.4 432l-220.8 0c7.4-36.5 39.7-64 78.4-64l64 0c38.7 0 71 27.5 78.4 64zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 240a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z',
  ],
};
const faDownLeftAndUpRightToCenter = {
  prefix: 'far',
  iconName: 'down-left-and-up-right-to-center',
  icon: [
    512,
    512,
    ['compress-alt'],
    'f422',
    'M296 256l148.7 0c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L441.9 168 496 113.9c18.7-18.7 18.7-49.1 0-67.9L465.9 16c-18.7-18.7-49.1-18.7-67.9 0L344 70.1 316.3 42.3c-6.6-6.6-15.6-10.3-25-10.3C271.8 32 256 47.8 256 67.3L256 216c0 22.1 17.9 40 40 40zm95-71l23 23L304 208l0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0l71-71L462.1 80l-71 71c-9.4 9.4-9.4 24.6 0 33.9zM67.3 256C47.8 256 32 271.8 32 291.3c0 9.4 3.7 18.3 10.3 25L70.1 344 16 398.1c-18.7 18.7-18.7 49.1 0 67.9L46.1 496c18.7 18.7 49.1 18.7 67.9 0L168 441.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3L256 296c0-22.1-17.9-40-40-40L67.3 256zM121 327l-23-23L208 304l0 110.1-23-23c-9.4-9.4-24.6-9.4-33.9 0l-71 71L49.9 432l71-71c9.4-9.4 9.4-24.6 0-33.9z',
  ],
};
const faCompressAlt = faDownLeftAndUpRightToCenter;
const faExplosion = {
  prefix: 'far',
  iconName: 'explosion',
  icon: [
    576,
    512,
    [],
    'e4e9',
    'M543.2 30.2c3.1-11.6-2.8-23.7-13.9-28.3s-23.9-.4-30 9.9L344.7 274.1 311.2 145.9C308.5 135.4 298.9 128 288 128s-20.5 7.4-23.2 17.9L227.4 289.4 145 207c-7.6-7.6-19.4-9.2-28.8-3.9s-14.1 16.2-11.5 26.7l23.9 95.7-70.8-5.4c-9.2-.7-18 4-22.7 12s-4.2 18 1.1 25.6L87.7 432l58.4 0-41.7-60.2 53.7 4.1c7.7 .6 15.2-2.6 20.2-8.4s6.8-13.8 4.9-21.3l-11-43.9L223 353c6.1 6.1 15 8.4 23.3 6.2s14.8-8.8 16.9-17.1l24.8-95 24.8 95c2.4 9.4 10.3 16.4 19.9 17.7s19.1-3.2 24-11.6L451.2 188 408.8 345.8c-2 7.6-.2 15.7 4.8 21.7s12.7 9.2 20.5 8.4l36.9-3.4L429.9 432l58.4 0 51.5-74.3c5.3-7.7 5.7-17.7 1-25.8s-13.6-12.7-22.9-11.8L464.1 325 543.2 30.2zM465.9 464l-35.8 0s0 0 0 0l-40.9 0c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80l-40.9 0s0 0 0 0l-35.8 0s0 0 0 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0s0 0 0 0zm-228.5 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32l-101.2 0zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z',
  ],
};
const faFileLines = {
  prefix: 'far',
  iconName: 'file-lines',
  icon: [
    384,
    512,
    [128441, 128462, 61686, 'file-alt', 'file-text'],
    'f15c',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faFileAlt = faFileLines;
const faFileText = faFileLines;
const faWaveSquare = {
  prefix: 'far',
  iconName: 'wave-square',
  icon: [
    640,
    512,
    [],
    'f83e',
    'M136 56c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 376 112 0 0-176c0-13.3 10.7-24 24-24l136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 176c0 13.3-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24l0-376L184 80l0 176c0 13.3-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-176z',
  ],
};
const faRing = {
  prefix: 'far',
  iconName: 'ring',
  icon: [
    512,
    512,
    [],
    'f70b',
    'M59.7 168c8.9-9.4 22.9-19 42.1-27.6C140 123.2 194.5 112 256 112s116 11.2 154.2 28.4c19.1 8.6 33.2 18.2 42.1 27.6c8.8 9.3 11.7 17.4 11.7 24s-2.9 14.7-11.7 24c-.8 .9-1.7 1.7-2.5 2.6C402.4 191.8 332.2 176 256 176s-146.4 15.8-193.8 42.6c-.9-.9-1.7-1.7-2.5-2.6C50.9 206.7 48 198.6 48 192s2.9-14.7 11.7-24zM464 268.6l0 51.4c0 6.6-2.9 14.7-11.7 24c-8.9 9.4-22.9 19-42.1 27.6C372 388.8 317.5 400 256 400s-116-11.2-154.2-28.4c-19.1-8.6-33.2-18.2-42.1-27.6C50.9 334.7 48 326.6 48 320l0-51.4c10.3 7.1 21.8 13.3 34.1 18.9C127.9 307.9 189.4 320 256 320s128.1-12.1 173.9-32.6c12.4-5.5 23.9-11.8 34.1-18.9zM0 192L0 320c0 22.1 10.1 41.4 24.8 57c14.6 15.4 34.5 28.2 57.4 38.5C127.9 435.9 189.4 448 256 448s128.1-12.1 173.9-32.6c22.8-10.2 42.8-23 57.4-38.5c14.7-15.6 24.8-34.9 24.8-57l0-128c0-22.1-10.1-41.4-24.8-57c-14.6-15.4-34.5-28.2-57.4-38.5C384.1 76.1 322.6 64 256 64S127.9 76.1 82.1 96.6C59.3 106.8 39.3 119.6 24.8 135C10.1 150.6 0 169.9 0 192zm256 80c-56.1 0-106.4-9.3-143.8-24c37.1-14.5 87.3-24 143.8-24s106.7 9.5 143.8 24c-37.4 14.7-87.7 24-143.8 24z',
  ],
};
const faBuildingUn = {
  prefix: 'far',
  iconName: 'building-un',
  icon: [
    384,
    512,
    [],
    'e4d9',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM104 248l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM237.3 87.1l34.7 52L272 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 96l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faDiceThree = {
  prefix: 'far',
  iconName: 'dice-three',
  icon: [
    448,
    512,
    [9858],
    'f527',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faTirePressureWarning = {
  prefix: 'far',
  iconName: 'tire-pressure-warning',
  icon: [
    512,
    512,
    [],
    'f633',
    'M424 0c-13.3 0-24 10.7-24 24l0 30.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5c15 30.5 26.3 66.3 22 105.3c-4 36.7-22.3 79.2-70.5 124.8l-269.3 0c-48.2-45.6-66.4-88.1-70.5-124.8c-4.3-39 7-74.8 22-105.3c7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5L112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 30.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4C12.7 215.5-2.5 260.9 3.2 312.4c5.5 49.7 30 102.1 84.8 154.1L88 496c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-29.5c54.8-51.9 79.3-104.3 84.8-154.1c5.7-51.5-9.5-96.9-26.7-131.8c-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5L448 24c0-13.3-10.7-24-24-24zM256 96c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faWifiFair = {
  prefix: 'far',
  iconName: 'wifi-fair',
  icon: [
    640,
    512,
    ['wifi-2'],
    'f6ab',
    'M152.4 321.2C196.5 280.7 255.4 256 320 256s123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112z',
  ],
};
const faWifi2 = faWifiFair;
const faCalendarDays = {
  prefix: 'far',
  iconName: 'calendar-days',
  icon: [
    448,
    512,
    ['calendar-alt'],
    'f073',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z',
  ],
};
const faCalendarAlt = faCalendarDays;
const faMp3Player = {
  prefix: 'far',
  iconName: 'mp3-player',
  icon: [
    384,
    512,
    [],
    'f8ce',
    'M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM192 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM112 80c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32L112 80z',
  ],
};
const faAnchorCircleCheck = {
  prefix: 'far',
  iconName: 'anchor-circle-check',
  icon: [
    640,
    512,
    [],
    'e4aa',
    'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faTally4 = {
  prefix: 'far',
  iconName: 'tally-4',
  icon: [
    640,
    512,
    [],
    'e297',
    'M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zM384 40c-13.3 0-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384c0-13.3-10.7-24-24-24zM536 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384z',
  ],
};
const faRectangleHistory = {
  prefix: 'far',
  iconName: 'rectangle-history',
  icon: [
    512,
    512,
    [],
    'e4a2',
    'M464 224c0-8.8-7.2-16-16-16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224zm-16-64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0zm-8-80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0z',
  ],
};
const faBuildingCircleArrowRight = {
  prefix: 'far',
  iconName: 'building-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e4d1',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
  ],
};
const faVolleyball = {
  prefix: 'far',
  iconName: 'volleyball',
  icon: [
    512,
    512,
    [127952, 'volleyball-ball'],
    'f45f',
    'M371.5 429c-71.4 7-145.1-8.2-210-47.1c-8.8 14.8-16.2 30.3-22.3 46.3C172.5 450.8 212.7 464 256 464c42.7 0 82.5-12.9 115.5-35zm60.1-61.5c9.2-14.4 16.6-30.1 22.1-46.7c-65.9 7.3-134.5-4.3-197.1-37.1c-25.9 16.5-48.4 36.5-67.2 58.9c75.2 43.8 163.6 51 242.3 24.9zm31.8-96.4c.4-5 .5-10 .5-15.1c0-77.9-42.8-145.8-106.3-181.5c35.6 58.4 54.2 127.7 49.6 200.3c18.8 .5 37.6-.7 56.1-3.8zM101 394.7C127.6 334 172 280.5 231.7 242.7c-1.3-30-7.1-58.9-16.8-85.9C140.2 189.5 85.7 249.6 58.1 320.3c9 27.9 23.8 53.1 42.9 74.5zm-52-159.9C84.1 182.9 133.8 140 195.2 113c-8.7-15.7-18.7-30.4-29.9-44.2C101.9 99.6 56.5 161.6 49.1 234.8zM213.3 52.4c39.3 53.4 63.5 118.6 66.4 189.2c25.7 13.4 52.6 22.6 79.9 27.9c4.6-84.1-26.8-163-81.5-220.4c-7.2-.8-14.6-1.2-22.1-1.2c-14.6 0-28.9 1.5-42.7 4.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 0s0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faVolleyballBall = faVolleyball;
const faSunHaze = {
  prefix: 'far',
  iconName: 'sun-haze',
  icon: [
    640,
    512,
    [],
    'f765',
    'M439.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L320 61.1 237.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L83.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L125.1 256s0 0 0 0l53.2 0c0-4.8-1.4-9.5-4.2-13.6l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L306.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L466 242.4c-2.8 4.1-4.2 8.9-4.2 13.6l53.2 0s0 0 0 0l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L439.7 19.7zM432 256c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 0 0 0 0 0l48 0s0 0 0 0c0-35.3 28.7-64 64-64s64 28.7 64 64c0 0 0 0 0 0l48 0s0 0 0 0zm184 32l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-208 0L88 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM576 400c0-13.3-10.7-24-24-24L24 376c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0z',
  ],
};
const faTextSize = {
  prefix: 'far',
  iconName: 'text-size',
  icon: [
    640,
    512,
    [],
    'f894',
    'M48 128l0-48 120 0 0 352-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-352 120 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296l0-24 96 0 0 160-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-160 88 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-22.1-17.9-40-40-40l-248 0c-22.1 0-40 17.9-40 40l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faUfo = {
  prefix: 'far',
  iconName: 'ufo',
  icon: [
    640,
    512,
    [128760],
    'e047',
    'M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5s0 0 0 0c0 0 0 0 0 .1l.1 .1 .3 .3c.2 .2 .4 .4 .7 .7c.6 .5 1.3 1.2 2.2 2.1c1.8 1.6 4.3 3.7 7.6 6.2c6.6 4.8 16.1 10.9 29.1 16.8c26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8c3.3-2.4 5.8-4.5 7.6-6.2c.9-.8 1.6-1.5 2.2-2.1c.3-.3 .5-.5 .7-.7l.3-.3 .1-.1c0 0 0 0 0-.1c0 0 0 0 0 0l-17.5-16.5 17.5 16.4c3.7-3.9 6-9 6.4-14.4c.5-5.8 .7-11.6 .6-17.2c30 8.9 54.6 19.9 72.5 31.8c24.1 16.2 31.5 30.9 31.5 41.6c0 7.9-3.8 17.7-15.8 29.1c-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6c17.9-12 42.4-23 72.5-31.8c-.1 5.7 .1 11.4 .6 17.2c.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9c17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9c18-17.1 30.7-38.7 30.7-63.9c0-34.3-23.4-61.7-52.8-81.4c-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8c-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8C199.2 164.7 255 112 320 112s120.8 52.7 120 122.6zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faFork = {
  prefix: 'far',
  iconName: 'fork',
  icon: [
    512,
    512,
    ['utensil-fork'],
    'f2e3',
    'M398.4 43.2c10.6-8 12.8-23 4.8-33.6s-23-12.8-33.6-4.8l-122.7 92c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4c0 24.5 8.1 48.1 22.8 67.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L256.7 289.2C275.9 303.9 299.5 312 324 312c29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6l92-122.7c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8l-92 122.7c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264s-32.7-6.6-44.5-18.4l-6.5-6.5c0 0 0 0 0 0s0 0 0 0l-6.5-6.5C254.6 220.7 248 204.7 248 188s6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4l122.7-92zM457 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L307 171c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L457 89z',
  ],
};
const faUtensilFork = faFork;
const faArrowsUpToLine = {
  prefix: 'far',
  iconName: 'arrows-up-to-line',
  icon: [
    576,
    512,
    [],
    'e4c2',
    'M24 80l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80zM7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 135c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7L7 239zM327 273c9.4 9.4 24.6 9.4 33.9 0l63-63L424 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 135c-9.4-9.4-24.6-9.4-33.9 0L327 239c-9.4 9.4-9.4 24.6 0 33.9z',
  ],
};
const faMobileSignal = {
  prefix: 'far',
  iconName: 'mobile-signal',
  icon: [
    512,
    512,
    [],
    'e1ef',
    'M64 48l224 0c8.8 0 16 7.2 16 16l0 234.7c14.5-14.1 30.6-26.5 48-37L352 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l160 0 0-24c0-8.1 .4-16.1 1.1-24L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z',
  ],
};
const faBarcodeScan = {
  prefix: 'far',
  iconName: 'barcode-scan',
  icon: [
    640,
    512,
    [],
    'f465',
    'M88 32C74.7 32 64 42.7 64 56l0 136 48 0 0-136c0-13.3-10.7-24-24-24zM64 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm64-8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM336 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM464 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM160 192l32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144zM0 256c0 13.3 10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24z',
  ],
};
const faSortDown = {
  prefix: 'far',
  iconName: 'sort-down',
  icon: [
    320,
    512,
    ['sort-desc'],
    'f0dd',
    'M160 425.4L70.6 336l178.7 0L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z',
  ],
};
const faSortDesc = faSortDown;
const faFolderArrowDown = {
  prefix: 'far',
  iconName: 'folder-arrow-down',
  icon: [
    512,
    512,
    ['folder-download'],
    'e053',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 200z',
  ],
};
const faFolderDownload = faFolderArrowDown;
const faCircleMinus = {
  prefix: 'far',
  iconName: 'circle-minus',
  icon: [
    512,
    512,
    ['minus-circle'],
    'f056',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faMinusCircle = faCircleMinus;
const faFaceIcicles = {
  prefix: 'far',
  iconName: 'face-icicles',
  icon: [
    512,
    512,
    [],
    'e37c',
    'M256 48C141.1 48 48 141.1 48 256c0 1.4-.1 2.7-.3 4l-15 180c-.4 4.5-4.1 8-8.7 8s-8.3-3.5-8.7-8L.3 260c-.2-1.3-.3-2.6-.3-4C0 114.6 114.6 0 256 0S512 114.6 512 256c0 1-.1 2-.2 3L496.5 504c-.3 4.5-4 8-8.5 8s-8.2-3.5-8.5-8L464.2 259c-.1-1-.2-2-.2-3c0-114.9-93.1-208-208-208zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-8.9 86.7c-.5 5.3-5 9.3-10.3 9.3s-9.7-4-10.3-9.3l-7.3-70.8c-.8 0-1.6 .1-2.5 .1l-26.7 0-6.5 38.8c-.9 5.3-5.5 9.2-10.9 9.2s-10-3.9-10.9-9.2L282.7 400 168 400c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 512c-75.5 0-143.3-32.7-190.2-84.6L72 353.1C106.9 419.1 176.2 464 256 464c3.5 0 6.9-.1 10.3-.3c7.9 10 20.2 16.3 33.7 16.3c7.9 0 15.4-2.2 21.9-6c1 10.1 5.6 19.1 12.4 25.8c-24.7 7.9-51 12.2-78.3 12.2zm151.3-49.5l7.4-72c8.9-10.5 16.8-21.9 23.5-34.1l4.7 74.6c-10.8 11.6-22.8 22.2-35.6 31.6z',
  ],
};
const faShovel = {
  prefix: 'far',
  iconName: 'shovel',
  icon: [
    512,
    512,
    [],
    'f713',
    'M375 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9l-44.1 44.1c-17.2 17.2-40.6 26.9-65 26.9c-16.7 0-32.3-4.4-45.8-12.2L241 305l56.4 56.4c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9L32 512c-17.7 0-32-14.3-32-32l0-93.7c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0L207 271 316.2 161.9c-7.8-13.5-12.2-29.1-12.2-45.8c0-24.4 9.7-47.7 26.9-65L375 7zm17 50.9L364.9 85.1c-8.2 8.2-12.9 19.4-12.9 31c0 24.2 19.6 43.9 43.9 43.9c11.6 0 22.8-4.6 31-12.9L454.1 120 392 57.9zM125.7 464c29.7 0 58.2-11.8 79.2-32.8L252.1 384 128 259.9 80.8 307.1c-21 21-32.8 49.5-32.8 79.2L48 464l77.7 0z',
  ],
};
const faDoorOpen = {
  prefix: 'far',
  iconName: 'door-open',
  icon: [
    576,
    512,
    [],
    'f52b',
    'M272 49.7L272 464l-160 0 0-371.2L272 49.7zM320 464l0-421.6C320 19 301 0 277.6 0c-3.7 0-7.4 .5-11 1.5L99.5 46.4C78.6 52.1 64 71.1 64 92.8L64 464l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 32 0 16 0 160 0 48 0 0-48zM224 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM352 112l104 0c4.4 0 8 3.6 8 8l0 368c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-344c0-30.9-25.1-56-56-56L352 64l0 48z',
  ],
};
const faFilms = {
  prefix: 'far',
  iconName: 'films',
  icon: [
    576,
    512,
    [],
    'e17a',
    'M256 264l0-32 160 0 0 32 0 72-160 0 0-72zm0-80l0-32 0-72 160 0 0 72 0 32-160 0zM440 32l-24 0L256 32l-24 0-24 0-48 0c-35.3 0-64 28.7-64 64l0 32 0 24 0 24 0 64 0 24 0 24 0 32c0 35.3 28.7 64 64 64l48 0 24 0 24 0 160 0 24 0 24 0 48 0c35.3 0 64-28.7 64-64l0-32 0-24 0-24 0-64 0-24 0-24 0-32c0-35.3-28.7-64-64-64l-48 0-24 0zM160 80l48 0 0 48-64 0 0-32c0-8.8 7.2-16 16-16zm-16 96l64 0 0 32 0 32-64 0 0-64zm0 112l64 0 0 48-48 0c-8.8 0-16-7.2-16-16l0-32zm368 48l-48 0 0-48 64 0 0 32c0 8.8-7.2 16-16 16zm16-96l-64 0 0-32 0-32 64 0 0 64zm0-112l-64 0 0-48 48 0c8.8 0 16 7.2 16 16l0 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z',
  ],
};
const faRightFromBracket = {
  prefix: 'far',
  iconName: 'right-from-bracket',
  icon: [
    512,
    512,
    ['sign-out-alt'],
    'f2f5',
    'M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z',
  ],
};
const faSignOutAlt = faRightFromBracket;
const faFaceGlasses = {
  prefix: 'far',
  iconName: 'face-glasses',
  icon: [
    512,
    512,
    [],
    'e377',
    'M256 464C141.1 464 48 370.9 48 256c0-1.8 0-3.5 .1-5.3C49.5 280.4 74 304 104 304l80 0c30.9 0 56-25.1 56-56l0-48c0-2.7-.2-5.4-.6-8l33.1 0c-.4 2.6-.6 5.3-.6 8l0 48c0 30.9 25.1 56 56 56l80 0c30 0 54.5-23.6 55.9-53.3c0 1.8 .1 3.5 .1 5.3c0 114.9-93.1 208-208 208zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8l-80 0c-10.1 0-19.6 2.7-27.8 7.4C112.2 89.6 179.3 48 256 48s143.8 41.6 179.8 103.4c-8.2-4.7-17.7-7.4-27.8-7.4l-80 0c-15.7 0-29.8 6.4-40 16.8l0-.8-64 0 0 .8zM256 512c141.4 0 256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16l-2.6 0C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160L16 160c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM304 200c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48zM104 176l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm88.4 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faNfc = {
  prefix: 'far',
  iconName: 'nfc',
  icon: [
    448,
    512,
    [],
    'e1f7',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256c0-17.8-9.7-33.3-24-41.6l0-54.4 72 0 0 192-192 0 0-192 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40l208 0c22.1 0 40-17.9 40-40l0-208c0-22.1-17.9-40-40-40l-88 0c-22.1 0-40 17.9-40 40l0 62.4c-14.3 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48z',
  ],
};
const faAtom = {
  prefix: 'far',
  iconName: 'atom',
  icon: [
    512,
    512,
    [9883],
    'f5d2',
    'M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4c-17.1 7.5-34 13.6-50.3 18.4C224.1 455.5 243.1 464 256 464s31.9-8.5 50.3-46.8zM293 325.7c14.8-8.9 28.7-18.1 41.4-27.6c1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6c-12.5-7.5-24.9-14.2-37-20.2c-12.1 6-24.5 12.7-37 20.2c-14.8 8.9-28.7 18.1-41.4 27.6c-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6c12.5 7.5 24.9 14.2 37 20.2c12.1-6 24.5-12.7 37-20.2zm120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9c-2.4 20.1-5.8 39.2-10.3 57c37.2 2.2 51.9-9.1 57.8-19.7c6.5-11.7 8.2-32.8-14.1-67.2zM469.6 128c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7c-4.5-17.8-7.9-36.9-10.3-57c-12-9.7-23.2-19.8-33.4-29.9C76.2 327.8 77.8 349 84.4 360.7zM98.5 218.5c10.2-10.2 21.3-20.2 33.4-29.9c2.4-20.1 5.8-39.2 10.3-57c-37.2-2.3-51.9 9.1-57.8 19.7c-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9c22.3-34.3 20.6-55.5 14.1-67.2c-5.9-10.6-20.6-22-57.8-19.7c4.5 17.8 7.9 36.9 10.3 57zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faSoap = {
  prefix: 'far',
  iconName: 'soap',
  icon: [
    512,
    512,
    [129532],
    'e06e',
    'M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96 192l113.1 0c2.5 17.7 9.2 34 18.9 48L96 240c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-4.1 0c9.6-13.7 16.1-29.6 18.8-46.9c46 7.1 81.3 46.9 81.3 94.9l0 128c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 288c0-53 43-96 96-96zm224 96l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l160 0zM144 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zM320 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faIcons = {
  prefix: 'far',
  iconName: 'icons',
  icon: [
    512,
    512,
    ['heart-music-camera-bolt'],
    'f86d',
    'M59.6 54.4c11.1-9.4 30.8-8.7 43.5 3.7l8 8.1 17.5 17.8 17.1-18.3L153 58c12.5-12 31.7-13.1 43.8-3.4c14.2 12.1 14.8 33.3 2 46.2c0 0 0 0 0 0l-70.7 70.8-71-70.8s0 0 0 0C44.3 87.9 44.9 66.6 59.5 54.5c0 0 0 0 0 0l.1-.1zM28.8 17.6C-7.7 47.9-9.4 102 23.1 134.6c0 0 0 0 0 0L101.7 213c14.7 15.1 38.3 14.1 52.5 .4c0 0 0 0 0 0l.3-.3 78.3-78.5s0 0 0 0C265.4 102 263.6 48 227.6 17.7c0 0 0 0 0 0l-.3-.3c-29.9-24.3-71-21.9-99.3-1C99.7-4.4 58.2-7 28.8 17.6zM512 24c0-7.2-3.2-14-8.8-18.6s-12.9-6.4-19.9-5l-160 32C312.1 34.7 304 44.6 304 56l0 105.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-132.3L464 53.3l0 76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-152zM106.9 309.5l2.7-5.5 68.7 0 2.7 5.5c8.1 16.3 24.8 26.5 42.9 26.5c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16c18.2 0 34.8-10.3 42.9-26.5zM224 288l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-88.4 0c-12.1 0-23.2 6.8-28.6 17.7L64 288c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64zM192 392a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM473.4 259.1c-6-4.4-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4l55.7 0-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4l-55.7 0 38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2z',
  ],
};
const faHeartMusicCameraBolt = faIcons;
const faMicrophoneLinesSlash = {
  prefix: 'far',
  iconName: 'microphone-lines-slash',
  icon: [
    640,
    512,
    ['microphone-alt-slash'],
    'f539',
    'M472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5l0-160c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7zM272 187.9L272 96c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 64c0 2.3-.2 4.6-.5 6.8L272 187.9zm86.2 190.3C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z',
  ],
};
const faMicrophoneAltSlash = faMicrophoneLinesSlash;
const faClosedCaptioningSlash = {
  prefix: 'far',
  iconName: 'closed-captioning-slash',
  icon: [
    640,
    512,
    [],
    'e135',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6-92.1-72.2c10.5-5.4 19.9-12.7 27.7-21.4c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-1.4 0-2.7-.1-4.1-.2l-41.4-32.5c-1.6-4.8-2.5-10-2.5-15.4c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-45.4 0-83.4 31.5-93.4 73.8l-22.4-17.5c2.9-8.1 1.5-17.4-4.7-24.3c-16.6-18.5-40.4-30.6-67-31.9L134.4 80zm353 400l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM295 328.4l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4c-26.5 0-48-21.5-48-48c0-4.7 .7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256c0 53 43 96 96 96c24.1 0 46.2-8.9 63-23.6z',
  ],
};
const faCalculatorSimple = {
  prefix: 'far',
  iconName: 'calculator-simple',
  icon: [
    512,
    512,
    ['calculator-alt'],
    'f64c',
    'M256 0c13.3 0 24 10.7 24 24l0 208 208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-208c0-13.3 10.7-24 24-24zM400 32c13.3 0 24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24zM55.4 343.4c9.4-9.4 24.6-9.4 33.9 0L112 366.1l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L145.9 400l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L112 433.9 89.4 456.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L78.1 400 55.4 377.4c-9.4-9.4-9.4-24.6 0-33.9zM64 88l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM352 336l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCalculatorAlt = faCalculatorSimple;
const faBridgeCircleCheck = {
  prefix: 'far',
  iconName: 'bridge-circle-check',
  icon: [
    640,
    512,
    [],
    'e4c9',
    'M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z',
  ],
};
const faSlidersUp = {
  prefix: 'far',
  iconName: 'sliders-up',
  icon: [
    512,
    512,
    ['sliders-v'],
    'f3f1',
    'M96 0c13.3 0 24 10.7 24 24l0 59.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3L120 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-251.7C39.5 226.1 16 195.8 16 160s23.5-66.1 56-76.3L72 24C72 10.7 82.7 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 59.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-59.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 251.7c32.5 10.2 56 40.5 56 76.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8 76.3L440 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-219.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L392 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3z',
  ],
};
const faSlidersV = faSlidersUp;
const faLocationMinus = {
  prefix: 'far',
  iconName: 'location-minus',
  icon: [
    384,
    512,
    ['map-marker-minus'],
    'f609',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM120 168l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMapMarkerMinus = faLocationMinus;
const faPumpMedical = {
  prefix: 'far',
  iconName: 'pump-medical',
  icon: [
    448,
    512,
    [],
    'e06a',
    'M168 0l48 0c25.4 0 46.8 16.9 53.7 40l46.4 0c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7L272 88l0 40-48 0 0-72c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 72-48 0 0-72c0-30.9 25.1-56 56-56zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464l186.4 0c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7l-149.1 0c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zM216 296l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faFingerprint = {
  prefix: 'far',
  iconName: 'fingerprint',
  icon: [
    512,
    512,
    [],
    'f577',
    'M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9zm-96-24c-13.3 0-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9c0-13.3-10.7-24-24-24z',
  ],
};
const faSkiBoot = {
  prefix: 'far',
  iconName: 'ski-boot',
  icon: [
    512,
    512,
    [],
    'e3cc',
    'M364.1 .3c13.1 2.2 21.8 14.6 19.6 27.7l-45 262.4L449 345.7c19 9.5 31 28.9 31 50.1l0 68.2 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L63.2 512c-35.4 0-61.9-32.5-54.9-67.2L88.5 51.2C90.8 40 100.6 32 112 32l222.3 0 2.1-12.1C338.6 6.9 351-1.9 364.1 .3zM202.4 80l-70.8 0L97.7 246.4c37.7-27.1 79.9-76.4 104.7-166.4zm33.1 0C203.5 204.3 140 262.5 88.9 289.4l-33.6 165c-1 5 2.8 9.6 7.8 9.6L432 464l0-68.2c0-3-1.7-5.8-4.4-7.2L301.3 325.5c-2.8-1.4-5.2-3.3-7.2-5.5L224 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l66.4 0 11-64L256 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l50.8 0L326.1 80l-90.5 0z',
  ],
};
const faStandardDefinition = {
  prefix: 'far',
  iconName: 'standard-definition',
  icon: [
    576,
    512,
    ['rectangle-sd'],
    'e28a',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 184l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm48 24l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9c7.1-2.3 18.8-2.9 35.5-.6c5.1 .7 21 3.3 25.6 4.4c12.9 2.9 25.8-5.1 28.7-18.1s-5.1-25.8-18.1-28.7c-6.6-1.5-24.1-4.4-29.9-5.2c-19-2.5-39.3-3.1-56.7 2.5c-19.2 6.2-34.9 20.3-39.6 43.5c-.1 .4-.2 .9-.2 1.3c-1.7 11.7-.3 23 5.2 33.2c5.3 9.9 13.3 16.7 21.1 21.3c13.9 8.3 32 12.5 45.5 15.6l1.8 .4c16.1 3.8 26.9 6.5 33.6 10.5c1.4 .8 2.2 1.5 2.7 2c.5 .4 .6 .7 .6 .7c0 0 .1 .1 .1 .5c.1 .4 .1 1.4-.1 3.2c-.4 2.4-1 3.2-1.3 3.5c-.4 .5-1.8 1.6-5.1 2.7c-7.3 2.3-19.5 2.8-36.2 .6c-7.2-1-20-4.7-31.1-8c0 0 0 0 0 0s0 0 0 0c-2.6-.7-5-1.5-7.3-2.1c-12.7-3.6-26 3.7-29.7 16.5s3.7 26 16.5 29.7c1.4 .4 3.2 .9 5.3 1.5c10.8 3.2 28.6 8.4 39.7 9.9l.1 0c19 2.5 39.6 3.2 57.1-2.4c9.1-2.9 18.2-7.7 25.6-15.6c7.6-8.1 12.1-18.1 13.8-29.3c1.7-11.7 .3-23-5.2-33.2c-5.3-9.9-13.3-16.7-21.1-21.3c-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5c-1.4-.8-2.2-1.5-2.7-2c-.5-.4-.6-.7-.6-.7c0 0 0 0 0 0c0 0-.1-.1-.1-.5s-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z',
  ],
};
const faRectangleSd = faStandardDefinition;
const faH1 = {
  prefix: 'far',
  iconName: 'h1',
  icon: [
    576,
    512,
    [],
    'f313',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8 456 400l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-312z',
  ],
};
const faHandPointRight = {
  prefix: 'far',
  iconName: 'hand-point-right',
  icon: [
    512,
    512,
    [],
    'f0a4',
    'M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z',
  ],
};
const faMagnifyingGlassLocation = {
  prefix: 'far',
  iconName: 'magnifying-glass-location',
  icon: [
    512,
    512,
    ['search-location'],
    'f689',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faSearchLocation = faMagnifyingGlassLocation;
const faMessageBot = {
  prefix: 'far',
  iconName: 'message-bot',
  icon: [
    640,
    512,
    [],
    'e3b8',
    'M272 368l-48 0-64 0c-8.8 0-16-7.2-16-16l0-160 0-128c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 128 0 160c0 8.8-7.2 16-16 16l-106.7 0-16 0-12.8 9.6L272 432l0-16 0-48zM96 208l0 144c0 35.3 28.7 64 64 64l16 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76L480 416c35.3 0 64-28.7 64-64l0-144 36.3 0c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16L544 176l0-112c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 112-36.3 0c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16L96 208zm80-80l0 128c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L208 96c-17.7 0-32 14.3-32 32zm32 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faForwardStep = {
  prefix: 'far',
  iconName: 'forward-step',
  icon: [
    320,
    512,
    ['step-forward'],
    'f051',
    'M240 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 138.7 0 58.6L288 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-105.1L63.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C29.5 448 16 434.5 16 417.9L16 94.1C16 77.5 29.5 64 46.1 64c6.2 0 12.2 1.9 17.3 5.4L240 193.1 240 88zm0 172.3l0-8.6L64 128.5l0 255L240 260.3z',
  ],
};
const faStepForward = faForwardStep;
const faFaceSmileBeam = {
  prefix: 'far',
  iconName: 'face-smile-beam',
  icon: [
    512,
    512,
    [128522, 'smile-beam'],
    'f5b8',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faSmileBeam = faFaceSmileBeam;
const faLightCeiling = {
  prefix: 'far',
  iconName: 'light-ceiling',
  icon: [
    512,
    512,
    [],
    'e016',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 137.1C112.4 172.2 16.7 265.6 2 384.1C-.2 401.6 14.3 416 32 416l448 0c17.7 0 32.2-14.4 30-31.9c-14.7-118.5-110.5-211.8-230-223L280 24zM458.4 368L53.6 368C75.2 276.3 157.7 208 256 208s180.8 68.3 202.4 160zM256 512c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z',
  ],
};
const faMessageExclamation = {
  prefix: 'far',
  iconName: 'message-exclamation',
  icon: [
    512,
    512,
    ['comment-alt-exclamation'],
    'f4a5',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM256 80c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCommentAltExclamation = faMessageExclamation;
const faBowlScoop = {
  prefix: 'far',
  iconName: 'bowl-scoop',
  icon: [
    448,
    512,
    [127847, 'bowl-shaved-ice'],
    'e3de',
    'M32 224l384 0c0-106-86-192-192-192S32 118 32 224zM173.8 368l-2.2 0L145 368c-41.4 0-77.2-26.3-90.5-64l339.1 0c-13.3 37.7-49.1 64-90.5 64l-26.7 0-2.2 0-100.3 0zm36.9 78.7L224 430.8l13.3 15.9L251.7 464l-55.4 0 14.4-17.3zm92.3 3.9L274.2 416l28.8 0c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3l28.8 0L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2l19.2 0 8.5 0 .6 0 135.4 0 .6 0 8.5 0 19.2 0c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z',
  ],
};
const faBowlShavedIce = faBowlScoop;
const faSquareX = {
  prefix: 'far',
  iconName: 'square-x',
  icon: [
    448,
    512,
    [],
    'e286',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.3 40.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z',
  ],
};
const faBuildingMemo = {
  prefix: 'far',
  iconName: 'building-memo',
  icon: [
    640,
    512,
    [],
    'e61e',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 9.6c12-6.1 25.6-9.6 40-9.6l8 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l244.1 0c-11-13.3-18.1-29.8-19.8-48L240 464l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm232 56c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c2.9 0 5.6-.8 8-2.1l0-13.9c0-13.1 2.9-25.5 8-36.7l0-11.3zM280 216l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c2.9 0 5.6-.8 8-2.1l0-75.7c-2.4-1.4-5.1-2.1-8-2.1zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 128l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM384 96c-35.3 0-64 28.7-64 64l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L384 96zm16 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64-168c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM464 400c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
  ],
};
const faUtilityPoleDouble = {
  prefix: 'far',
  iconName: 'utility-pole-double',
  icon: [
    512,
    512,
    [],
    'e2c4',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56L128 80l0-24c0-13.3-10.7-24-24-24S80 42.7 80 56l0 24L64.2 80c-.2 0-.3 0-.5 0L48 80l0-24c0-13.3-10.7-24-24-24S0 42.7 0 56L0 88c0 22.1 17.9 40 40 40l43.2 0L232 227.2l0 44.8-104 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L48 272l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 22.1 17.9 40 40 40l43.2 0L232 419.2l0 68.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-68.8L428.8 320l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 272l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-104 0 0-44.8L428.8 128l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 80l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L280 80l0-56zm91.2 104L280 188.8l0-60.8 91.2 0zM232 188.8L140.8 128l91.2 0 0 60.8zM371.2 320L280 380.8l0-60.8 91.2 0zM232 380.8L140.8 320l91.2 0 0 60.8z',
  ],
};
const faFlagCheckered = {
  prefix: 'far',
  iconName: 'flag-checkered',
  icon: [
    448,
    512,
    [127937],
    'f11e',
    'M24 0C37.3 0 48 10.7 48 24l0 28 85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 388l0 100c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88 0-49.5L0 64 0 24C0 10.7 10.7 0 24 0zM48 150.7l80-17.4 0-51.9-80 20 0 49.3zm0 49.1l0 46.9 80-17.4 0-46.9L48 199.9zm0 96l0 42.7 68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5l0-40.4L48 295.9zm128 18.8c33.1 .7 65.9 8.7 96 23.7l0-49.8-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6l0 46zm144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1 0-46.7L374.3 294c-17.9 4.1-36.1 5.5-54.3 4.3l0 53.5zm80-113l0-46.7L374.3 198c-17.9 4.1-36.1 5.5-54.3 4.3l0 47.8c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zm0-96l0-49.8c-25.6 10.4-52.8 15.6-80 15.6l0 45.5c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zM272 103.1c-16.1-3.7-31.9-9.4-47-16.9c-15.3-7.7-32.1-11.8-49-12.3l0 50.6c18.2-1.3 36.5 .6 54.1 5.8L272 142.5l0-39.4zm0 89.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6l0 47.8c18.2-1.3 36.5 .6 54.1 5.8L272 238.5l0-46z',
  ],
};
const faChevronsUp = {
  prefix: 'far',
  iconName: 'chevrons-up',
  icon: [
    512,
    512,
    ['chevron-double-up'],
    'f325',
    'M273 47c-9.4-9.4-24.6-9.4-33.9 0L47 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 47zM465 431L273 239c-9.4-9.4-24.6-9.4-33.9 0L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z',
  ],
};
const faChevronDoubleUp = faChevronsUp;
const faFootball = {
  prefix: 'far',
  iconName: 'football',
  icon: [
    512,
    512,
    [127944, 'football-ball'],
    'f44e',
    'M442.6 69.4c-32.9-5-63.1-7.4-90.7-7.4l98 98c.5-32.1-2.4-63.1-7.3-90.6zm-217 12.7c-55.4 20.5-93.3 55.2-118.6 96.5c-20.6 33.7-33 72-39.5 110.9L223.6 445.6c23.2-3.4 44.1-8.8 62.8-15.8c55.4-20.5 93.3-55.2 118.6-96.5c20.6-33.7 33-72 39.5-110.9L288.4 66.4c-23.2 3.4-44.1 8.8-62.8 15.8zM62.1 352c-.5 32.1 2.4 63.1 7.3 90.6c32.9 5 63.1 7.4 90.7 7.4l-98-98zm4-198.4c30.6-50 76.8-92 142.9-116.5C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6zM297 151l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faFootballBall = faFootball;
const faUserVneck = {
  prefix: 'far',
  iconName: 'user-vneck',
  icon: [
    448,
    512,
    [],
    'e461',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM48.3 464l351.5 0c-3.1-47.3-33.7-87.3-76-103.8L274 422.4c-25.6 32-74.3 32-100 0l-49.7-62.2C82 376.7 51.4 416.7 48.3 464zm85-156.4c5.6-1.2 11.3 1.1 14.9 5.6l63.4 79.2c6.4 8 18.6 8 25 0l63.4-79.2c3.6-4.5 9.3-6.7 14.9-5.6C390.9 323.6 448 391.1 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.9 57.1-148.4 133.3-164.4z',
  ],
};
const faSchoolCircleExclamation = {
  prefix: 'far',
  iconName: 'school-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e56c',
    'M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faCrop = {
  prefix: 'far',
  iconName: 'crop',
  icon: [
    512,
    512,
    [],
    'f125',
    'M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24l0 326.1L350.1 128 160 128l0-48 238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384l56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384 352 384l0 48-216 0c-30.9 0-56-25.1-56-56l0-248-56 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l56 0 0-56z',
  ],
};
const faAnglesDown = {
  prefix: 'far',
  iconName: 'angles-down',
  icon: [
    448,
    512,
    ['angle-double-down'],
    'f103',
    'M401 113L241 273c-9.4 9.4-24.6 9.4-33.9 0L47 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 79c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm0 192L241 465c-9.4 9.4-24.6 9.4-33.9 0L47 305c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faAngleDoubleDown = faAnglesDown;
const faUsersRectangle = {
  prefix: 'far',
  iconName: 'users-rectangle',
  icon: [
    640,
    512,
    [],
    'e594',
    'M88 0C39.4 0 0 39.4 0 88L0 424c0 48.6 39.4 88 88 88l464 0c48.6 0 88-39.4 88-88l0-336c0-48.6-39.4-88-88-88L88 0zM48 88c0-22.1 17.9-40 40-40l464 0c22.1 0 40 17.9 40 40l0 336c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40L48 88zm272 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM268.4 274c-1.1 .2-2.2 .5-3.3 .7c-25.7 6.3-47.4 22.9-60.3 45.3c-8.2 14.1-12.8 30.5-12.8 48c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32c0-17.5-4.7-33.9-12.8-48c-1.1-1.8-2.2-3.6-3.3-5.4c-13.1-19.6-33.3-34.1-56.9-39.9c-1.1-.3-2.2-.5-3.3-.7c-6.3-1.3-12.9-2-19.6-2l-32 0-32 0c-6.7 0-13.3 .7-19.6 2zm7-49.5a72 72 0 1 0 89.2-113.1A72 72 0 1 0 275.4 224.5zM397.3 352l-154.5 0c6.6-18.6 24.4-32 45.3-32l64 0c20.9 0 38.7 13.4 45.3 32zM223.8 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 293.3c0 14.7 11.9 26.7 26.7 26.7l46.6 0c13.7-33.9 41.5-60.6 76.2-72.8c-7.9-4.6-17-7.2-26.8-7.2l-69.3 0C119.9 240 96 263.9 96 293.3zM470.7 320l46.6 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.8 0-18.9 2.6-26.8 7.2c34.6 12.2 62.5 38.9 76.2 72.8zM512 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faPeopleRoof = {
  prefix: 'far',
  iconName: 'people-roof',
  icon: [
    640,
    512,
    [],
    'e537',
    'M332.3 3.4l296 176c11.4 6.8 15.1 21.5 8.4 32.9s-21.5 15.1-32.9 8.4L320 51.9 36.3 220.6c-11.4 6.8-26.1 3-32.9-8.4s-3-26.1 8.4-32.9l296-176c7.6-4.5 17-4.5 24.5 0zM496 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5zm98.9 27.4l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35 0 39.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-39.7-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5l0 79.5 32 0 0-79.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5z',
  ],
};
const faSquareArrowRight = {
  prefix: 'far',
  iconName: 'square-arrow-right',
  icon: [
    448,
    512,
    ['arrow-square-right'],
    'f33b',
    'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM361 273l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9z',
  ],
};
const faArrowSquareRight = faSquareArrowRight;
const faLocationPlus = {
  prefix: 'far',
  iconName: 'location-plus',
  icon: [
    384,
    512,
    ['map-marker-plus'],
    'f60a',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM168 280l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faMapMarkerPlus = faLocationPlus;
const faLightbulbExclamationOn = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation-on',
  icon: [
    640,
    512,
    [],
    'e1ca',
    'M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM425.2 248.9C439.6 228.3 448 203.2 448 176c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L237 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM336 128l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPeopleLine = {
  prefix: 'far',
  iconName: 'people-line',
  icon: [
    640,
    512,
    [],
    'e534',
    'M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM304 176.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 79.5-32 0 0-79.5zm80 55.8l18.9 35c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35 0 23.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-23.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.4-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.4-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35L80 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-23.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l18.9-35 0 39.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-39.7zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM480 336l0-63.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 63.5-32 0zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM128 336l0-63.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 63.5-32 0z',
  ],
};
const faBeerMugEmpty = {
  prefix: 'far',
  iconName: 'beer-mug-empty',
  icon: [
    512,
    512,
    ['beer'],
    'f0fc',
    'M80 80l0 336c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-47.4c0-.4 0-.7 0-1.1L336 80 80 80zM384 383.7l0 32.3c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 59.2 0c38 0 68.8 30.8 68.8 68.8l0 117.9c0 27.3-16.2 52.1-41.2 63l-86.8 38zM384 144l0 187.3 67.5-29.5c7.6-3.3 12.5-10.8 12.5-19.1l0-117.9c0-11.5-9.3-20.8-20.8-20.8L384 144zM144 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z',
  ],
};
const faBeer = faBeerMugEmpty;
const faCarpool = {
  prefix: 'far',
  iconName: 'carpool',
  icon: [
    512,
    512,
    ['car-people'],
    'e69c',
    'M160.2 80l191.7 0c26.2 0 49 18.2 54.7 43.9l22.4 101c-4.2-.6-8.6-.9-12.9-.9l-22.4 0c-8.3-14.3-23.8-24-41.6-24l-32 0c-17.8 0-33.3 9.7-41.6 24l-44.8 0c-8.3-14.3-23.8-24-41.6-24l-32 0c-17.8 0-33.3 9.7-41.6 24L96 224c-4.4 0-8.7 .3-12.9 .9l22.4-101C111.2 98.2 133.9 80 160.2 80zM484.2 252.5l-30.9-139C442.8 65.9 400.6 32 351.8 32L160.2 32c-48.7 0-90.9 33.9-101.5 81.4l-30.9 139C10.6 269.8 0 293.7 0 320l0 64 0 16 0 32 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 416 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-32 0-16 0-64c0-26.3-10.6-50.2-27.8-67.5zM176 184a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm160 0a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM96 272l320 0c26.5 0 48 21.5 48 48l0 64L48 384l0-64c0-26.5 21.5-48 48-48zm48 56a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCarPeople = faCarpool;
const faCrateEmpty = {
  prefix: 'far',
  iconName: 'crate-empty',
  icon: [
    512,
    512,
    [],
    'e151',
    'M56 272c-4.4 0-8 3.6-8 8l0 64 416 0 0-64c0-4.4-3.6-8-8-8L56 272zM48 392l0 64c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-64L48 392zM0 280c0-30.9 25.1-56 56-56l400 0c30.9 0 56 25.1 56 56l0 176c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 280zm400 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faDiagramPredecessor = {
  prefix: 'far',
  iconName: 'diagram-predecessor',
  icon: [
    512,
    512,
    [],
    'e477',
    'M464 416l0-64c0-8.8-7.2-16-16-16L64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16zm-16 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c39.8 0 72 32.2 72 72l0 38.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23 0-38.1c0-13.3-10.7-24-24-24l-82 0c1.3 5.1 2 10.5 2 16l0 64z',
  ],
};
const faTransporter = {
  prefix: 'far',
  iconName: 'transporter',
  icon: [
    512,
    512,
    [],
    'e042',
    'M472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6zm-416 64L64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24zM208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 272l0 112-48 0 0-223.2-52.9 69.7c-8 10.6-23.1 12.6-33.6 4.6s-12.6-23.1-4.6-33.6l65.7-86.7c16.6-21.9 42.6-34.8 70.1-34.8l38.6 0c27.5 0 53.5 12.9 70.1 34.8l65.7 86.7c8 10.6 5.9 25.6-4.6 33.6s-25.6 5.9-33.6-4.6L320 208.8 320 432l-48 0 0-112-32 0zm0-48l32 0 0-96-32 0 0 96z',
  ],
};
const faCalendarCircleUser = {
  prefix: 'far',
  iconName: 'calendar-circle-user',
  icon: [
    576,
    512,
    [],
    'e471',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faArrowUpLong = {
  prefix: 'far',
  iconName: 'arrow-up-long',
  icon: [
    384,
    512,
    ['long-arrow-up'],
    'f176',
    'M209 7c-9.4-9.4-24.6-9.4-33.9 0L39 143c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l95-95L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-406.1 95 95c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7z',
  ],
};
const faLongArrowUp = faArrowUpLong;
const faPersonCarryBox = {
  prefix: 'far',
  iconName: 'person-carry-box',
  icon: [
    384,
    512,
    ['person-carry'],
    'f4cf',
    'M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM59.2 176C53 176 48 181 48 187.2l0 85.3c0 2.5 1.1 4.8 3.1 6.3L72 295.2 72 179c-3.9-1.9-8.3-3-12.8-3zM120 246.2l0 86.7 25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4l0-85.3C0 154.5 26.5 128 59.2 128c26.1 0 50.5 13.3 64.6 35.3L173.1 240l18.9 0 0-112c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-120 0-8 0-55.3 0c-13.6 0-26.3-6.9-33.6-18.4L120 246.2zM240 240l96 0 0-96-96 0 0 96z',
  ],
};
const faPersonCarry = faPersonCarryBox;
const faFireFlameSimple = {
  prefix: 'far',
  iconName: 'fire-flame-simple',
  icon: [
    384,
    512,
    ['burn'],
    'f46a',
    'M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zm72.6 281.4c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z',
  ],
};
const faBurn = faFireFlameSimple;
const faPerson = {
  prefix: 'far',
  iconName: 'person',
  icon: [
    320,
    512,
    [129485, 'male'],
    'f183',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0z',
  ],
};
const faMale = faPerson;
const faLaptop = {
  prefix: 'far',
  iconName: 'laptop',
  icon: [
    640,
    512,
    [128187],
    'f109',
    'M512 80L128 80c-8.8 0-16 7.2-16 16l0 224-48 0L64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 224-48 0 0-224c0-8.8-7.2-16-16-16zM96 432l448 0c20.9 0 38.7-13.4 45.3-32L50.7 400c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96L96 480c-53 0-96-43-96-96z',
  ],
};
const faFileCsv = {
  prefix: 'far',
  iconName: 'file-csv',
  icon: [
    512,
    512,
    [],
    'f6dd',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z',
  ],
};
const faMenorah = {
  prefix: 'far',
  iconName: 'menorah',
  icon: [
    640,
    512,
    [],
    'f676',
    'M2.7 49.7L20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1L64 64c0 17.7-14.3 32-32 32S0 81.7 0 64l0-1.2c0-4.5 .9-8.9 2.7-13.1zm96 0L116.8 7.4C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L212.8 7.4zm77.8 42.4L308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L404.8 7.4zm77.8 42.4L500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L596.8 7.4zM24 128c13.3 0 24 10.7 24 24l0 128c0 22.1 17.9 40 40 40l208 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168 208 0c22.1 0 40-17.9 40-40l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128c0 48.6-39.4 88-88 88l-208 0 0 96 144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-168 0-168 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0 0-96L88 368c-48.6 0-88-39.4-88-88L0 152c0-13.3 10.7-24 24-24zm128 24l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm192 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faUnion = {
  prefix: 'far',
  iconName: 'union',
  icon: [
    384,
    512,
    [8899],
    'f6a2',
    'M24 32c13.3 0 24 10.7 24 24l0 232c0 79.5 64.5 144 144 144s144-64.5 144-144l0-232c0-13.3 10.7-24 24-24s24 10.7 24 24l0 232c0 106-86 192-192 192S0 394 0 288L0 56C0 42.7 10.7 32 24 32z',
  ],
};
const faChevronsLeft = {
  prefix: 'far',
  iconName: 'chevrons-left',
  icon: [
    512,
    512,
    ['chevron-double-left'],
    'f323',
    'M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z',
  ],
};
const faChevronDoubleLeft = faChevronsLeft;
const faCircleHeart = {
  prefix: 'far',
  iconName: 'circle-heart',
  icon: [
    512,
    512,
    ['heart-circle'],
    'f4c7',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9L233.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108z',
  ],
};
const faHeartCircle = faCircleHeart;
const faTruckPlane = {
  prefix: 'far',
  iconName: 'truck-plane',
  icon: [
    640,
    512,
    [],
    'e58f',
    'M183.3 18.7C192.9 8.8 206.6 0 224 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9c7.8 17.9 13 38.3 15.3 56c-23.5 14.1-40.5 37.9-45.3 65.9c-.9-2.6-1.4-5.3-1.4-8.1l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 7.3-3.3 14.2-9 18.8L53.7 289.3c-.7 .5-1.3 1-2 1.5c-2.3 1.5-3.7 4-3.7 6.7l0 28.7 111-44.8c7.4-3 15.8-2.1 22.4 2.4s10.6 11.9 10.6 19.9l0 72.3c0 7.6-3.6 14.7-9.6 19.2L128 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c9.1 2.8 21.9 6.7 35.5 10.8c5.4 10.5 12.7 19.9 21.4 27.7l0 16.5c0 4.4 .5 8.7 1.5 12.9l-7.6-2.3c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C97 512 80 495 80 474.1L80 432c0-12.6 5.9-24.4 16-32l48-36 0-24.8L53.9 375.6c-.5 .2-1.1 .4-1.7 .6C26.4 384.4 0 365.2 0 338.1l0-40.6c0-18.6 9.2-36 24.6-46.4L144 155.8l0-27.8c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM288 192c0-16.2 6-31.1 16-42.3c11.7-13.3 28.9-21.7 48-21.7l224 0c35.3 0 64 28.7 64 64l0 184 0 24c0 23.7-12.9 44.4-32 55.4l0 32.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-192 0 0 10.1 0 13.9c0 13.3-10.7 24-24 24c-2.1 0-4.2-.3-6.1-.8c-4.9-1.3-9.2-4.1-12.3-7.9c0 0 0 0 0 0c-3.4-4.2-5.5-9.5-5.5-15.3l0-28.1 0-4.5c-15.5-9-26.9-24.3-30.7-42.4c-.9-4.2-1.3-8.5-1.3-13l0-24 0-94.9 0-76.6 0-12.5zM400 304l11.2 0 6.4 0 16.8 0 13.6 0 45.6 0 23.2 0 27.2 0-11.9-37c-2.5-6.5-8.4-11-15.3-11l-87.2 0-18.4 0c-6.9 0-12.9 4.5-15.3 11l-1.6 5-4.4 13.8L384 304l16 0zm-50.3-50.3l.5-1.4 .4-1.2 .5-1.2c.2-.6 .5-1.2 .7-1.8c3.6-8.7 9.2-16.7 16.3-23.3c3.5-3.3 7.5-6.2 11.7-8.6c9.1-5.2 19.8-8.3 31.5-8.3l105.6 0c28.8 0 51.4 18.7 60.2 41.9l.5 1.2 .4 1.2 11.9 37 2.3 7.2L592 192c0-8.8-7.2-16-16-16l-224 0c-5.7 0-10.6 2.9-13.5 7.4c-1.6 2.5-2.5 5.4-2.5 8.6l0 20.5 0 30.3 0 53.7 2.3-7.2 11.4-35.6zM445.5 352L422 352l-38 0-8 0-16 0c-5.1 0-9.8 1.6-13.7 4.3c-6.2 4.3-10.3 11.5-10.3 19.7l0 12 0 12c0 8.3 6.3 15.1 14.4 15.9c.5 .1 1.1 .1 1.6 .1l12.7 0L576 416c8.8 0 16-7.2 16-16l0-24c0-13.3-10.7-24-24-24l-24 0-98.5 0zM368 406.6a24 24 0 1 1 16-45.3 24 24 0 1 1 -16 45.3zM552 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faRecordVinyl = {
  prefix: 'far',
  iconName: 'record-vinyl',
  icon: [
    512,
    512,
    [],
    'f8d9',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faBringForward = {
  prefix: 'far',
  iconName: 'bring-forward',
  icon: [
    512,
    512,
    [],
    'f856',
    'M224 464l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-64 0 0-48 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 48 0 0 64c0 8.8 7.2 16 16 16zm64-112L64 352c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64z',
  ],
};
const faSquareP = {
  prefix: 'far',
  iconName: 'square-p',
  icon: [
    448,
    512,
    [],
    'e279',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z',
  ],
};
const faFaceGrinStars = {
  prefix: 'far',
  iconName: 'face-grin-stars',
  icon: [
    512,
    512,
    [129321, 'grin-stars'],
    'f587',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z',
  ],
};
const faGrinStars = faFaceGrinStars;
const faSigma = {
  prefix: 'far',
  iconName: 'sigma',
  icon: [
    384,
    512,
    [8721],
    'f68b',
    'M1.8 46.8C5.5 37.8 14.3 32 24 32l304 0c30.9 0 56 25.1 56 56l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-4.4-3.6-8-8-8L81.9 80 241 239c9.4 9.4 9.4 24.6 0 33.9L81.9 432 328 432c4.4 0 8-3.6 8-8l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 30.9-25.1 56-56 56L24 480c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l183-183L7 73C.2 66.1-1.9 55.8 1.8 46.8z',
  ],
};
const faCameraMovie = {
  prefix: 'far',
  iconName: 'camera-movie',
  icon: [
    576,
    512,
    [127909, 127910],
    'f8a9',
    'M224 120A72 72 0 1 0 80 120a72 72 0 1 0 144 0zM344 240l-192 0C85.7 240 32 186.3 32 120S85.7 0 152 0c39.3 0 74.1 18.8 96 48c21.9-29.1 56.7-48 96-48c66.3 0 120 53.7 120 120s-53.7 120-120 120zM272 120a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM112 336l0 112c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-208 0-16 0c-8.8 0-16 7.2-16 16zm32-64l208 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-112c0-5.5 .7-10.9 2-16l-42 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0 16 0zm384 36.6l-80 36 0-52.6 75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6l0 180.6c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476l0-52.6 80 36 0-150.7z',
  ],
};
const faBong = {
  prefix: 'far',
  iconName: 'bong',
  icon: [
    448,
    512,
    [],
    'f55c',
    'M144 208.5c0 23.3-12.4 43.2-29.9 54.4C92.3 276.9 74.5 296.7 63 320L321 320c-11.6-23.3-29.3-43.1-51.2-57.2c-17.4-11.2-29.9-31.1-29.9-54.4L240 48l-96 0 0 160.5zM288 48l0 160.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5L76.1 512c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14L96 48l-8 0C74.7 48 64 37.3 64 24S74.7 0 88 0l24 0L272 0l24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z',
  ],
};
const faClarinet = {
  prefix: 'far',
  iconName: 'clarinet',
  icon: [
    640,
    512,
    [],
    'f8ad',
    'M224 112c0-8.8 7.2-16 16-16l32 0 96 0 96 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 32 44.6 0c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136l0 240c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7l-411.2 0c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304l0-96c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7L256 160l0-32-16 0c-8.8 0-16-7.2-16-16zm64 48l64 0 0-32-64 0 0 32zm96 0l64 0 0-32-64 0 0 32zM248 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm133.4-62.8C559 202.9 542 208 524.6 208l-411.2 0c-3.9 0-7.8 .6-11.5 1.7L48 225.9l0 60.3 53.9 16.2c3.7 1.1 7.6 1.7 11.5 1.7l411.2 0c17.4 0 34.4 5.1 48.8 14.8L592 331.2l0-150.3-18.6 12.4z',
  ],
};
const faTruckFlatbed = {
  prefix: 'far',
  iconName: 'truck-flatbed',
  icon: [
    640,
    512,
    [],
    'e2b6',
    'M368 120c0-13.3 10.7-24 24-24l66.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96s-96-43-96-96l-8 0-120 0c0 53-43 96-96 96s-96-43-96-96l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L368 368l0-248zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faSpaghettiMonsterFlying = {
  prefix: 'far',
  iconName: 'spaghetti-monster-flying',
  icon: [
    640,
    512,
    ['pastafarianism'],
    'f67b',
    'M192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 58.3c10-11.3 16-26.1 16-42.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c1.7 0 3.4-.1 5.1-.2L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24s10.7 24 24 24c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-2.4 7.1-4.5 14.2-6.5 20.6L151 331c-3.4 11.2-6.4 20.3-9.8 27.8c-3.5 7.5-6.6 11.5-9.4 13.8c-2.3 1.8-5.5 3.4-11.7 3.4c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8c-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7c0 0 0 0 0 0C80.1 414 98.6 424 120 424c16.2 0 30.2-4.8 41.7-13.9c10.9-8.7 18-20.2 23-31.1c5-10.9 8.8-22.9 12.2-34l.8-2.7c16.4 12.2 36.1 23.6 58.9 31.3c-5.6 16.6-13.8 37.5-24.6 55.5C217.2 454 203.2 464 192 464c-13.3 0-24 10.7-24 24s10.7 24 24 24c39.1 0 65.6-32 81.2-58.2c14.5-24.2 24.6-51.4 30.7-70.4c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c6.1 19 16.3 46.3 30.7 70.4C382.4 480 408.9 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-11.2 0-25.2-10-40-34.8c-10.8-18-19-39-24.6-55.5c22.8-7.7 42.5-19 58.9-31.3l.8 2.7c3.4 11 7.2 23.1 12.2 34c5.1 10.9 12.1 22.4 23 31.1c11.5 9.1 25.5 13.9 41.7 13.9c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2c13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.3 0-9.5-1.6-11.7-3.4c-2.8-2.2-6-6.3-9.4-13.8c-3.5-7.5-6.4-16.6-9.8-27.8l-1.3-4.2c-2-6.5-4.1-13.5-6.5-20.6c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c1.7 .1 3.4 .2 5.1 .2c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 16.2 6 31.1 16 42.3l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3zM459.4 256.3c-.4 .6-.9 1.3-1.4 2c-6.3 8.8-15.8 20.5-28.3 32.2C404.5 313.8 368 336 320 336s-84.5-22.2-109.7-45.6c-12.6-11.7-22-23.4-28.3-32.2c-.5-.7-1-1.3-1.4-2c5.4-6.9 10.8-13.8 16.7-20.7c26.4-31 60.4-59.6 122.7-59.6s96.3 28.6 122.7 59.6c5.9 6.9 11.3 13.8 16.7 20.7zM448 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faPastafarianism = faSpaghettiMonsterFlying;
const faArrowDownUpAcrossLine = {
  prefix: 'far',
  iconName: 'arrow-down-up-across-line',
  icon: [
    576,
    512,
    [],
    'e4af',
    'M143 505c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 280l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-150.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L392 232l-208 0-48 0L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0 0 150.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm-7-313l48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136zM440 320l-48 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136z',
  ],
};
const faArrowsRotateReverse = {
  prefix: 'far',
  iconName: 'arrows-rotate-reverse',
  icon: [
    512,
    512,
    [],
    'e630',
    'M418 187.1C391.2 124.1 328.7 80 256 80c-39.7 0-77.8 15.8-105.9 43.9L97.9 176l54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 224c-13.3 0-24-10.7-24-24L16 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1 52.1-52.1C153.2 52.8 203.5 32 256 32c92.6 0 172.1 56.2 206.2 136.3c5.2 12.2-.5 26.3-12.7 31.5s-26.3-.5-31.5-12.7zM50 344.1c-5.2-12.2 .4-26.3 12.6-31.5s26.3 .4 31.5 12.6C121 388.1 183.4 432 256 432c39.7 0 77.8-15.8 105.9-43.9L414.1 336 360 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-52.1 52.1C358.8 459.2 308.5 480 256 480c-92.5 0-171.8-56-206-135.9z',
  ],
};
const faLeafHeart = {
  prefix: 'far',
  iconName: 'leaf-heart',
  icon: [
    512,
    512,
    [],
    'f4cb',
    'M272 144l104 0c31.6 0 61-9.1 85.7-24.9c1.5 12.2 2.3 24.7 2.3 37.5c0 143.2-93.8 242.9-191.2 243.4c0 0 0 0-.1 0l-.8 0c0 0 0 0-.1 0C201.3 400 144 342.7 144 272c0-70.7 57.3-128 128-128zM450.6 67.5C430.8 85.2 404.7 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-26.4-2.9-51.9-8.3-76.2c-.4-1.9-.9-3.8-1.3-5.6c-2.2-9.3-4.8-18.3-7.8-27.2c-1.2-3.6-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-4.9 7.7-10.8 14.7-17.4 20.9c-.7 .7-1.4 1.3-2.1 1.9zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z',
  ],
};
const faHouseBuilding = {
  prefix: 'far',
  iconName: 'house-building',
  icon: [
    640,
    512,
    [],
    'e1b1',
    'M352 48l224 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c0 18-6 34.6-16 48l176 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L352 0c-35.3 0-64 28.7-64 64l0 60.6 48 44L336 64c0-8.8 7.2-16 16-16zm61.2 208l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6 6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96l16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0 64zm64-144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM400 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faCheeseSwiss = {
  prefix: 'far',
  iconName: 'cheese-swiss',
  icon: [
    512,
    512,
    [129472],
    'f7f0',
    'M464 256l0-15.8C464 151.7 392.3 80 303.8 80c-.8 0-1.6 .2-2.3 .7l-35 23.3c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48c-23.4 0-42.9-16.7-47.1-38.9L53.3 246.2C50 248.4 48 252.1 48 256l274.7 0c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32l50.7 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-60.2 0c-8.8 9.8-21.6 16-35.8 16s-27-6.2-35.8-16L48 304zm464-63.8l0 15.8 0 160c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zM176 320a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faSpoon = {
  prefix: 'far',
  iconName: 'spoon',
  icon: [
    512,
    512,
    [129348, 61873, 'utensil-spoon'],
    'f2e5',
    'M286.1 193.9l32 32c9.3 9.4 21.5 14 33.8 14.1c21.1 0 48.8-13.5 73.2-42.7C449 168.6 464 131.2 464 96c0-26.5-21.5-48-48-48c-35.2 0-72.6 15-101.3 38.9C285.5 111.3 272 139 272 160.1c0 12.3 4.7 24.5 14.1 33.8zm-34.9 33c-18.1-18.6-27.1-42.6-27.2-66.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.1 0-48.2-9.1-66.7-27.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L251.2 226.9z',
  ],
};
const faUtensilSpoon = faSpoon;
const faJarWheat = {
  prefix: 'far',
  iconName: 'jar-wheat',
  icon: [
    320,
    512,
    [],
    'e517',
    'M32 24c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16l0 304c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-304c0-8.8 7.2-16 16-16l192 0zM64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64L64 80zm192 85.8c0-3.2-2.6-5.8-5.8-5.8L208 160c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2zM250.2 256L208 256c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8zM256 357.8c0-3.2-2.6-5.8-5.8-5.8L208 352c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416l21.8 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 21.8 0c32.1 0 58.2-26 58.2-58.2z',
  ],
};
const faEnvelopesBulk = {
  prefix: 'far',
  iconName: 'envelopes-bulk',
  icon: [
    640,
    512,
    ['mail-bulk'],
    'f674',
    'M112 48l320 0 0 48 48 0 0-48c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48l0 144 48 0 0-144zM48 272l288 0 0 6.9L192.1 385.4c0 0-.1 0-.1 0s-.1 0-.1 0L48 278.9l0-6.9zm0 66.6L163.3 424c8.3 6.2 18.4 9.5 28.7 9.5s20.4-3.3 28.7-9.5L336 338.6 336 464 48 464l0-125.4zM0 272L0 464c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L48 224c-26.5 0-48 21.5-48 48zm272-80l0-16 320 0 0 192-176 0 0 48 176 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-320 0c-26.5 0-48 21.5-48 48l0 16 48 0zm240 16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z',
  ],
};
const faMailBulk = faEnvelopesBulk;
const faFileCircleExclamation = {
  prefix: 'far',
  iconName: 'file-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e4eb',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faBowArrow = {
  prefix: 'far',
  iconName: 'bow-arrow',
  icon: [
    512,
    512,
    [127993],
    'f6b9',
    'M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM132.2 379.8l9.2 36.8L117 441.1l-5.7-22.9c-2.1-8.6-8.9-15.3-17.5-17.5L70.9 395l24.4-24.4 36.8 9.2zm-79.5-265L49 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L151.4 281.4l33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9L367 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-3.7-3.7c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z',
  ],
};
const faCartXmark = {
  prefix: 'far',
  iconName: 'cart-xmark',
  icon: [
    576,
    512,
    [],
    'e0dd',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3L575.2 62.2c3.4-12.8-4.1-26-16.9-29.4s-26 4.1-29.4 16.9L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8l-297.6 0-37-194.5C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257.8 65.8c-9.4 9.4-9.4 24.6 0 33.9L286.1 128l-28.3 28.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L320 161.9l28.3 28.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L353.9 128l28.3-28.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L320 94.1 291.7 65.8c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faHexagonXmark = {
  prefix: 'far',
  iconName: 'hexagon-xmark',
  icon: [
    512,
    512,
    ['times-hexagon', 'xmark-hexagon'],
    'f2ee',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faTimesHexagon = faHexagonXmark;
const faXmarkHexagon = faHexagonXmark;
const faCircleH = {
  prefix: 'far',
  iconName: 'circle-h',
  icon: [
    512,
    512,
    [9405, 'hospital-symbol'],
    'f47e',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80-128 0 0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80 128 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-104z',
  ],
};
const faHospitalSymbol = faCircleH;
const faMerge = {
  prefix: 'far',
  iconName: 'merge',
  icon: [
    512,
    512,
    [],
    'e526',
    'M0 88C0 74.7 10.7 64 24 64l72 0 48.2 0c17.5 0 34 8.2 44.5 22.1L297.5 228.8c1.5 2 3.9 3.2 6.4 3.2l126.2 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-126.2 0c-2.5 0-4.9 1.2-6.4 3.2L188.7 425.9c-10.6 13.9-27.1 22.1-44.5 22.1L96 448l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 48.2 0c2.5 0 4.9-1.2 6.4-3.2L257.8 256 150.5 115.2c-1.5-2-3.9-3.2-6.4-3.2L96 112l-72 0C10.7 112 0 101.3 0 88z',
  ],
};
const faPager = {
  prefix: 'far',
  iconName: 'pager',
  icon: [
    512,
    512,
    [128223],
    'f815',
    'M448 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM96 192l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32zm16 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z',
  ],
};
const faCartMinus = {
  prefix: 'far',
  iconName: 'cart-minus',
  icon: [
    576,
    512,
    [],
    'e0db',
    'M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 96l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faAddressBook = {
  prefix: 'far',
  iconName: 'address-book',
  icon: [
    512,
    512,
    [62138, 'contact-book'],
    'f2b9',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z',
  ],
};
const faContactBook = faAddressBook;
const faPanFrying = {
  prefix: 'far',
  iconName: 'pan-frying',
  icon: [
    576,
    512,
    [127859],
    'e42c',
    'M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faGrid = {
  prefix: 'far',
  iconName: 'grid',
  icon: [
    448,
    512,
    ['grid-3'],
    'e195',
    'M88 72l0 48-48 0 0-48 48 0zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32zM88 232l0 48-48 0 0-48 48 0zM40 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zM0 392l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM248 72l0 48-48 0 0-48 48 0zM200 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM360 72l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z',
  ],
};
const faGrid3 = faGrid;
const faFootballHelmet = {
  prefix: 'far',
  iconName: 'football-helmet',
  icon: [
    512,
    512,
    [],
    'f44f',
    'M434.6 185.3L275.1 205.2c-38.3 4.8-67.1 37.4-67.1 76c0 11.9 2.8 23.6 8.1 34.3L254.3 392c1.1 2.2 1.7 4.7 1.7 7.2l0 .9c0 8.8-7.2 16-16 16l-2.9 0c-2.2 0-4.3-.4-6.3-1.3l-93.9-40.2c-10-4.3-20.7-6.5-31.5-6.5l-5.4 0c-22.7-31.5-36-70.1-36-112C64 150 150 64 256 64c81 0 150.4 50.2 178.6 121.3zm27.9 44.9c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9l14 0c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2l2.9 0c35.3 0 64-28.7 64-64l0-.9c0-9.9-2.3-19.7-6.8-28.6L288 352l39.7 0 9.6 50.9c10.1 54 57.2 93.1 112.1 93.1l17 0c25.2 0 45.6-20.4 45.6-45.6l0-50.4 0-32c0-26.5-21.5-48-48-48l-109.7 0-14-74.5 122.2-15.3zM321.7 320L272 320l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4L321.7 320zm44.6 64l-6-32L464 352c8.8 0 16 7.2 16 16l0 16-113.7 0zM480 416l0 34.4c0 7.5-6.1 13.6-13.6 13.6l-17 0c-32.7 0-61.6-19.3-74.7-48L480 416zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faHandLove = {
  prefix: 'far',
  iconName: 'hand-love',
  icon: [
    512,
    512,
    [],
    'e1a5',
    'M176 48c8.8 0 16 7.2 16 16l0 15.9 0 .1 0 127.8 0 .2 0 96c0 35.3 28.7 64 64 64c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64l0-48 0-16 0-24s0 0 0 0l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16l0 209.9c-.3 1.2-.5 2.5-.7 3.7c-6.6 66.5-61.1 118.9-128.5 122.2c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 64c0-8.8 7.2-16 16-16zM352 256l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16zm0-104l0 26c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2l0-82c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 197.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c87.6-5.9 158.3-72.9 169.9-158.8c1.1-2.7 1.7-5.7 1.7-8.8l0-216c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 23.9 0 .1zM240 216l0-8.2c.1-8.8 7.2-15.8 16-15.8c8.8 0 16 7.2 16 16l0 32 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88s0 0 0 0z',
  ],
};
const faTrees = {
  prefix: 'far',
  iconName: 'trees',
  icon: [
    640,
    512,
    [],
    'f724',
    'M177.4 15.1c16-19 45.2-19 61.2 0L354.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9l-14.1 0 64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6l-25.7 0 62.1 88 3.6 0 0-184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 113.7 0-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13l22.1 0-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6l12.4 0L432 53.3l-59.9 71.1L339.9 88.1l61.5-73c16-19 45.2-19 61.2 0L578.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9l-14.1 0 64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6l-25.7 0 69.3 98.2c5.2 7.3 5.8 16.9 1.7 24.9s-12.3 13-21.3 13l-160 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-16 0-24 0-112 0-24 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0L24 448c-9 0-17.2-5-21.3-13s-3.5-17.6 1.7-24.9L73.7 312 48 312c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64.8-81L80 192c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L177.4 15.1zM256 400l89.7 0-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13l22.1 0-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6l12.4 0L208 53.3 131.6 144l12.4 0c9.2 0 17.6 5.3 21.6 13.6s2.9 18.2-2.9 25.4L97.9 264l22.1 0c9 0 17.2 5 21.3 13s3.5 17.6-1.7 24.9L70.3 400l73.7 0 40 0 0-184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 24 0z',
  ],
};
const faStrikethrough = {
  prefix: 'far',
  iconName: 'strikethrough',
  icon: [
    512,
    512,
    [],
    'f0cc',
    'M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7L24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192.2 0c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6c0 0 0 0 0 0s0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7l-57.2 0c5.7 5.3 9.7 11 12.3 17.1z',
  ],
};
const faPage = {
  prefix: 'far',
  iconName: 'page',
  icon: [
    384,
    512,
    [],
    'e428',
    'M64 464l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm256 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64z',
  ],
};
const faK = {
  prefix: 'far',
  iconName: 'k',
  icon: [
    320,
    512,
    [107],
    '4b',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 328 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-118.1 79.6-79.6L276.4 469.8c7.6 10.8 22.6 13.5 33.4 5.8s13.4-22.6 5.8-33.4L162.1 223.9 313 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 270.1 48 56z',
  ],
};
const faDiagramPrevious = {
  prefix: 'far',
  iconName: 'diagram-previous',
  icon: [
    512,
    512,
    [],
    'e478',
    'M464 416c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 64zm48-64c0-35.3-28.7-64-64-64l-168 0 0-86.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 0 86.1L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64zM64 224l74.3 0c-5.7-19.1-1-40.5 14.1-55.6l64-64c21.9-21.9 57.3-21.9 79.2 0l64 64c15 15 19.7 36.5 14.1 55.6l74.3 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64z',
  ],
};
const faGaugeMin = {
  prefix: 'far',
  iconName: 'gauge-min',
  icon: [
    512,
    512,
    ['tachometer-alt-slowest'],
    'f628',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faTachometerAltSlowest = faGaugeMin;
const faFolderGrid = {
  prefix: 'far',
  iconName: 'folder-grid',
  icon: [
    512,
    512,
    [],
    'e188',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM104 240c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
  ],
};
const faEggplant = {
  prefix: 'far',
  iconName: 'eggplant',
  icon: [
    512,
    512,
    [],
    'e16c',
    'M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9L496 192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.7c-13.3-4.8-25.4-13-35.1-22.8c-9.7-9.8-17.9-21.9-22.8-35.2c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l141.9 0 9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c8.4 14.1 20.9 25.5 36 32.3c-19.3 17.1-40.4 31-61.2 42.9c-21.5 12.3-47 24.8-70.4 36.2c0 0 0 0 0 0c-13.9 6.8-27 13.2-38 18.9c-33.6 17.6-59 34.3-76.1 54.5c-15.7 18.5-26.2 42-25.6 77.9c1 70 59 128.7 128.5 128.7c59 .1 115.4-40.1 163.9-107c33.3-46 59.2-99.9 76.2-148.5c10.2 13.3 24.4 23.3 40.8 28.2C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z',
  ],
};
const faExcavator = {
  prefix: 'far',
  iconName: 'excavator',
  icon: [
    640,
    512,
    [],
    'e656',
    'M144 48l102.9 0c2.7 0 5.2 1.3 6.7 3.6L325.8 160 144 160l0-112zM384 224l0-16 0-25.5c0-14.2-4.2-28.1-12.1-39.9L293.5 24.9C283.1 9.4 265.6 0 246.9 0L136 0C113.9 0 96 17.9 96 40l0 120-48 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-48zm-48-16l0 16 0 48L48 272l0-64 288 0zM80 400l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L80 352c-44.2 0-80 35.8-80 80zm457.9 22.1c-6.4 6.4-9.9 15-9.9 24c0 18.7 15.2 33.9 33.9 33.9l78.1 0c44.2 0 80-35.8 80-80l0-48 0-48 0-16 0-176 0-97.4c0-2.7-.2-5.3-.7-7.8c-3.7-22-22.9-38.8-46-38.8c-11.2 0-22.1 4-30.5 11.4L416 138.7l0 63.5L592 49.7l0 30.6-31.6 27.7L416 234.2l0 63.8L544 186l48-42 0 63.8L592 320 457.9 454.1z',
  ],
};
const faRam = {
  prefix: 'far',
  iconName: 'ram',
  icon: [
    640,
    512,
    [128015],
    'f70a',
    'M336 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2 0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21L544 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3l0-1.3c0-35.3-28.7-64-64-64s-64 28.7-64 64zM306.5 88.7c-8-10.3-19-18-31.8-21.9C268.8 65 262.5 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L456 352c-14.2 0-27.7-2.8-40.1-8c-.9 0-1.7-.1-2.4-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.3 0 10 2.5 13 6.7c8.6 11.9 22 19.2 36.6 19.9c2.5-10 7.7-19.3 15.2-26.6c-6.5-6.4-11.5-14.3-14.3-23.3zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faLandmarkFlag = {
  prefix: 'far',
  iconName: 'landmark-flag',
  icon: [
    512,
    512,
    [],
    'e51c',
    'M272 0L256 0c-8.8 0-16 7.2-16 16l0 112L48 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0 0-32 80 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L272 0zM112 208l-48 0 0 176-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-176-48 0 0 176-64 0 0-176-48 0 0 176-64 0 0-176-48 0 0 176-64 0 0-176zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z',
  ],
};
const faLips = {
  prefix: 'far',
  iconName: 'lips',
  icon: [
    576,
    512,
    [128068, 128482],
    'f600',
    'M258.2 138.9c-22.5-17.8-42-26.9-58.2-26.9c-10.5 0-24.3 4.1-41.7 13.7c-17.2 9.5-34 22.1-50.5 34.9c-17.5 13.6-33.2 27.9-44.4 40.5c-6 6.8-10.3 12.2-13 17C48.3 222 48 223.8 48 224c0 .4 .1 1.7 .6 4.1s1.3 5.2 2.3 8.3c9.8 29.5 28.4 58.7 51.2 85.1C138.4 363.6 190.4 400 256 400l64 0c65.6 0 117.6-36.4 153.9-78.5c18.1-20.9 31.8-42.8 41-61.2c9.2-18.5 13-29.2 13.1-36.3c0-.2-.2-2-2.5-5.9c-2.7-4.8-6.9-10.2-13-17c-11.2-12.6-26.9-26.9-44.4-40.5c-16.5-12.8-33.3-25.4-50.5-34.9C400.3 116.1 386.5 112 376 112c-16.2 0-35.7 9.1-58.2 26.9c-17.5 13.8-42.1 13.8-59.5 0zm239.4-16.2c19.1 14.8 37.1 31.2 50.8 46.5c13.4 15 27.6 33.7 27.6 54.8c0 20-9.4 40.3-18.1 57.8c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448l-64 0c-84.7 0-148.8-47.1-190.2-95.1C40.3 323.4 17.7 288.8 5.3 251.5C2.6 243.1 0 233.2 0 224c0-21.1 14.2-39.7 27.6-54.8c13.6-15.3 31.7-31.7 50.8-46.5C111.5 97 156 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c44 0 88.5 33 121.6 58.7zM96 236c0-6.7 39.4-27.1 118.1-28c3.5 0 7 .5 10.3 1.6c11.8 3.7 42 12.4 63.6 12.4s51.7-8.7 63.6-12.4c3.3-1 6.8-1.6 10.3-1.6c78.7 .9 118.1 21.2 118.1 28c0 6.9-68.6 84-192 84s-192-77.1-192-84z',
  ],
};
const faPencil = {
  prefix: 'far',
  iconName: 'pencil',
  icon: [
    512,
    512,
    [9999, 61504, 'pencil-alt'],
    'f303',
    'M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z',
  ],
};
const faPencilAlt = faPencil;
const faBackward = {
  prefix: 'far',
  iconName: 'backward',
  icon: [
    512,
    512,
    [9194],
    'f04a',
    'M288 94c0-16.6-13.5-30-30-30c-6.3 0-12.5 2-17.6 5.7L9.9 236.6C3.7 241.1 0 248.3 0 256s3.7 14.9 9.9 19.4L240.3 442.3c5.1 3.7 11.3 5.7 17.6 5.7c16.6 0 30-13.4 30-30l0-99.1L464.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1l0-323.8C512 77.5 498.5 64 481.9 64c-6.2 0-12.2 1.9-17.3 5.4L288 193.1 288 94zm0 157.7L464 128.5l0 255L288 260.3l0-8.6zM64.9 256L240 129.2l0 253.6L64.9 256z',
  ],
};
const faCaretRight = {
  prefix: 'far',
  iconName: 'caret-right',
  icon: [
    256,
    512,
    [],
    'f0da',
    'M201.4 256L112 166.6l0 178.7L201.4 256zm45.3-22.6c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-256c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128z',
  ],
};
const faComments = {
  prefix: 'far',
  iconName: 'comments',
  icon: [
    640,
    512,
    [128490, 61670],
    'f086',
    'M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z',
  ],
};
const faPaste = {
  prefix: 'far',
  iconName: 'paste',
  icon: [
    512,
    512,
    ['file-clipboard'],
    'f0ea',
    'M104.6 48L64 48C28.7 48 0 76.7 0 112L0 384c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-272c0-8.8 7.2-16 16-16l16 0c0 17.7 14.3 32 32 32l72.4 0C202 108.4 227.6 96 256 96l62 0c-7.1-27.6-32.2-48-62-48l-40.6 0C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L464 243.9 464 448c0 8.8-7.2 16-16 16zM256 512l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L256 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64z',
  ],
};
const faFileClipboard = faPaste;
const faDesktopArrowDown = {
  prefix: 'far',
  iconName: 'desktop-arrow-down',
  icon: [
    576,
    512,
    [],
    'e155',
    'M64 0L224 0l0 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16L352 48l0-48L512 0c35.3 0 64 28.7 64 64l0 192 0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48zM312 24l0 118.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faCodePullRequest = {
  prefix: 'far',
  iconName: 'code-pull-request',
  icon: [
    512,
    512,
    [],
    'e13c',
    'M305.8 2.1C314.4 5.9 320 14.5 320 24l0 48 16 0c66.3 0 120 53.7 120 120l0 163.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L408 192c0-39.8-32.2-72-72-72l-16 0 0 48c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM112 80A32 32 0 1 0 48 80a32 32 0 1 0 64 0zm-8 76.3l0 199.3c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-199.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3zM112 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faPumpkin = {
  prefix: 'far',
  iconName: 'pumpkin',
  icon: [
    576,
    512,
    [],
    'f707',
    'M352 118.1l0-82.7c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4L229.4 115.7c-27.3 11.4-50.6 30.6-67 54.7c-7.5 11-4.6 25.9 6.3 33.3s25.9 4.6 33.3-6.3C220.8 170 252.3 152 288 152s67.2 18 86 45.5c7.5 11 22.4 13.8 33.3 6.3s13.8-22.4 6.3-33.3c-15.4-22.5-36.7-40.7-61.7-52.4zM141.3 144.9c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7c17.9 11.6 33.6 26.3 46.4 43.2c21.7 3.5 42.9 17.9 60.1 42.7c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z',
  ],
};
const faClipboardList = {
  prefix: 'far',
  iconName: 'clipboard-list',
  icon: [
    384,
    512,
    [],
    'f46d',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faPenField = {
  prefix: 'far',
  iconName: 'pen-field',
  icon: [
    640,
    512,
    [],
    'e211',
    'M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l432 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 128zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faChartSine = {
  prefix: 'far',
  iconName: 'chart-sine',
  icon: [
    512,
    512,
    [],
    'e69d',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM154.6 215.4c2.2-8 5.7-18.5 10.8-28.7C176.3 165 190.2 152 208 152c15.4 0 24.8 6.4 33.2 19.2c9.6 14.6 16.1 35 23.8 59.9l.5 1.8c7 22.7 15.3 49.5 29.1 70.3C310 326.4 333.1 344 368 344c46.2 0 72.3-35 85.5-61.3c6.9-13.8 11.4-27.4 14.2-37.3c3.3-12 4-17.4 4-17.4c0 0 0 0 0 0c2.2-13.1-6.7-25.4-19.7-27.6c-21.4-3.6-26.8 16.2-30.6 32.2c-2.2 8-5.7 18.5-10.8 28.7C399.7 283 385.8 296 368 296c-15.4 0-24.8-6.4-33.2-19.2c-9.6-14.6-16.1-35-23.8-59.9l-.5-1.8c-7-22.7-15.3-49.5-29.1-70.3C266.1 121.6 242.9 104 208 104c-46.2 0-72.3 35-85.5 61.3c-6.9 13.8-11.4 27.4-14.2 37.3c-4.8 17.4-4 17.5-4 17.5c-2.2 13.1 6.7 25.4 19.7 27.6s25.4-6.6 27.6-19.7c0 0 .3-3 3-12.5z',
  ],
};
const faBlueberries = {
  prefix: 'far',
  iconName: 'blueberries',
  icon: [
    512,
    512,
    [],
    'e2e8',
    'M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM384 64l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32z',
  ],
};
const faTruckRampBox = {
  prefix: 'far',
  iconName: 'truck-ramp-box',
  icon: [
    640,
    512,
    ['truck-loading'],
    'f4de',
    'M352 88c0-48.6 39.4-88 88-88L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 48c-22.1 0-40 17.9-40 40l0 272.7 25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8 352 88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z',
  ],
};
const faTruckLoading = faTruckRampBox;
const faNote = {
  prefix: 'far',
  iconName: 'note',
  icon: [
    448,
    512,
    [],
    'e1ff',
    'M384 80c8.8 0 16 7.2 16 16l0 224-80 0c-17.7 0-32 14.3-32 32l0 80L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 480l224 0 5.5 0c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3l0-5.5 0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64zm64-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 128a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faArrowDownToSquare = {
  prefix: 'far',
  iconName: 'arrow-down-to-square',
  icon: [
    512,
    512,
    [],
    'e096',
    'M385 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71L280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345c9.4 9.4 24.6 9.4 33.9 0L385 233zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-336c0-39.8-32.2-72-72-72l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z',
  ],
};
const faUserCheck = {
  prefix: 'far',
  iconName: 'user-check',
  icon: [
    640,
    512,
    [],
    'f4fc',
    'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM625 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 177z',
  ],
};
const faCloudXmark = {
  prefix: 'far',
  iconName: 'cloud-xmark',
  icon: [
    640,
    512,
    [],
    'e35f',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faVialVirus = {
  prefix: 'far',
  iconName: 'vial-virus',
  icon: [
    512,
    512,
    [],
    'e597',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 304c0 53 43 96 96 96c28 0 53.3-12 70.8-31.2c-.2-14.6 5.2-29.3 16.4-40.5c.2-.2 .2-.3 .3-.3c0 0 0 0 0 0c0-.1 0-.3-.1-.6s-.2-.4-.3-.5c0 0 0 0-.1 0c-.1 0-.2 0-.4 0c-15.2 0-29-6.1-39.1-15.9c-3.4 23.2-23.4 41-47.5 41c-26.5 0-48-21.5-48-48l0-144 96 0 0 70.3c10-9.6 23.6-15.4 38.6-15.4c.2 0 .4 0 .4 0c0 0 0 0 .1 0c.1-.1 .2-.2 .3-.5s.1-.5 .1-.6c0 0 0 0 0 0c0-.1-.1-.2-.3-.3c-21.9-21.9-21.9-57.3 0-79.2c2.7-2.7 5.7-5.1 8.8-7.2L224 80l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 32 32 32l-8 0zM80 192L80 80l96 0 0 112-96 0zm271.8-2.3c-13.3 0-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faBookBlank = {
  prefix: 'far',
  iconName: 'book-blank',
  icon: [
    448,
    512,
    [128213, 128215, 128216, 128217, 'book-alt'],
    'f5d9',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8L80 352z',
  ],
};
const faBookAlt = faBookBlank;
const faGolfFlagHole = {
  prefix: 'far',
  iconName: 'golf-flag-hole',
  icon: [
    512,
    512,
    [],
    'e3ac',
    'M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24l0 136 0 64 0 8 0 55.1 0 49.8 0 47.1c0 .7 0 1.5 .1 2.2c-.1 .6-.1 1.2-.1 1.8c0 19.9 35.8 36 80 36s80-16.1 80-36s-35.8-36-80-36c-11.4 0-22.2 1.1-32 3l0-28.8c24.6-3.9 51.5-6.2 80-6.2c61.7 0 116.4 10.4 154.9 26.3c19.3 8 33.3 16.9 42.1 25.5c8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5c-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3l0-51.6c-4.5 1.6-9 3.3-13.2 5.1c-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5c14.7 14.3 34.6 26.1 57.3 35.5C128.3 500.9 189.6 512 256 512s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5C501.3 432.1 512 413.7 512 392s-10.7-40.1-25.4-54.5c-14.6-14.3-34.6-26.1-57.3-35.5C383.7 283.1 322.4 272 256 272c-27.8 0-54.8 1.9-80 5.6l0-30.8 194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM176 193.2l0-130.3L306.3 128 176 193.2z',
  ],
};
const faMessageArrowDown = {
  prefix: 'far',
  iconName: 'message-arrow-down',
  icon: [
    512,
    512,
    ['comment-alt-arrow-down'],
    'e1db',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 120z',
  ],
};
const faCommentAltArrowDown = faMessageArrowDown;
const faFaceUnamused = {
  prefix: 'far',
  iconName: 'face-unamused',
  icon: [
    512,
    512,
    [],
    'e39f',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 392.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 344.3 221.4 328 256 328s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
  ],
};
const faSheetPlastic = {
  prefix: 'far',
  iconName: 'sheet-plastic',
  icon: [
    384,
    512,
    [],
    'e571',
    'M320 48c8.8 0 16 7.2 16 16l0 288-80 0c-17.7 0-32 14.3-32 32l0 80L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM0 448c0 35.3 28.7 64 64 64l172.1 0c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM203.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z',
  ],
};
const faCircle9 = {
  prefix: 'far',
  iconName: 'circle-9',
  icon: [
    512,
    512,
    [],
    'e0f6',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM230 316.4c-40.4-11.4-70-48.4-70-92.4c0-53 43-96 96-96s96 43 96 96c0 32.4-14.2 63.2-38.8 84.3l-81.6 70c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8L230 316.4z',
  ],
};
const faBlog = {
  prefix: 'far',
  iconName: 'blog',
  icon: [
    512,
    512,
    [],
    'f781',
    'M216 0C379.5 0 512 132.5 512 296c0 13.3-10.7 24-24 24s-24-10.7-24-24C464 159 353 48 216 48c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24l0 248c0 53 43 96 96 96s96-43 96-96s-43-96-96-96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368L0 120c0-13.3 10.7-24 24-24zm168 24c0-13.3 10.7-24 24-24c110.5 0 200 89.5 200 200c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-83.9-68.1-152-152-152c-13.3 0-24-10.7-24-24z',
  ],
};
const faUserNinja = {
  prefix: 'far',
  iconName: 'user-ninja',
  icon: [
    448,
    512,
    [129399],
    'f504',
    'M352 128c0 70.7-57.3 128-128 128c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128zM144 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96c-8.8 0-16 7.2-16 16zM49.3 464l163.1 0-6.5-7.7c-.2-.2-.4-.4-.6-.7l-78.4-93.1C85.9 380.1 55.7 418.3 49.3 464zm206.1-23.5L275.2 464l123.6 0c-6.4-45.7-36.6-83.9-77.7-101.5l-65.7 78zM418.3 512l-154.1 0-.3 0L29.7 512C13.3 512 0 498.7 0 482.3c0-83.7 57.6-153.9 135.4-173.1c5.6-1.4 11.4 .7 15.1 5.1l61.3 71.6c6.4 7.4 17.9 7.4 24.3 0l61.3-71.6c3.7-4.4 9.5-6.4 15.1-5.1C390.4 328.4 448 398.6 448 482.3c0 16.4-13.3 29.7-29.7 29.7z',
  ],
};
const faPencilSlash = {
  prefix: 'far',
  iconName: 'pencil-slash',
  icon: [
    640,
    512,
    [],
    'e215',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.3 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zm.9 123.2l-41.7 41.7-49.6-12.4-12.4-49.6 34.4-34.4-38-29.9-73.2 73.2c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9zM161 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1l11.1-7.4z',
  ],
};
const faBowlingPins = {
  prefix: 'far',
  iconName: 'bowling-pins',
  icon: [
    512,
    512,
    [],
    'f437',
    'M128 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM102.3 230.2L74 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L95.5 464l65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM48 80C48 35.8 83.8 0 128 0s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L227 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L200 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.5 0-23.9-7.3-29.1-18.8L34.4 445.6C22.3 419 16 390.1 16 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5l0-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7L48 80zM384 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM358.3 230.2L330 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L351.5 464l65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM304 80c0-44.2 35.8-80 80-80s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L483 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L456 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.6 0-23.9-7.3-29.1-18.8l-21.7-47.6C278.3 419 272 390.1 272 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5l0-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7l0-4.4z',
  ],
};
const faPersonArrowUpFromLine = {
  prefix: 'far',
  iconName: 'person-arrow-up-from-line',
  icon: [
    640,
    512,
    [],
    'e539',
    'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L208 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 464l0-112 32 0 0 112-32 0zm-48 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 80 0 384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-360 0 0-240.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 464zM600.1 118.2l-88-80c-9.2-8.3-23.1-8.3-32.3 0l-88 80c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6L472 110.3 472 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-281.7 47.9 43.5c9.8 8.9 25 8.2 33.9-1.6s8.2-25-1.6-33.9z',
  ],
};
const faDownRight = {
  prefix: 'far',
  iconName: 'down-right',
  icon: [
    384,
    512,
    [],
    'e16b',
    'M320 384l0-193.4c0-1.7-.8-3.2-2.1-4.2c-2.1-1.6-5-1.4-6.9 .5L257 241c-9.4 9.4-24.6 9.4-33.9 0L98.3 116.3c-2.7-2.7-6.5-4.3-10.3-4.3s-7.6 1.5-10.3 4.3L52.3 141.7c-2.7 2.7-4.3 6.5-4.3 10.3s1.5 7.6 4.3 10.3L177 287c9.4 9.4 9.4 24.6 0 33.9L122.9 375c-1.8 1.8-2.1 4.8-.5 6.9c1 1.3 2.5 2.1 4.2 2.1L320 384zm48 8c0 22.1-17.9 40-40 40l-201.4 0c-16.8 0-32.5-7.9-42.6-21.3c-15.9-21.2-13.8-50.9 4.9-69.6L126.1 304 18.3 196.3C6.6 184.5 0 168.6 0 152s6.6-32.5 18.3-44.3L43.7 82.4C55.5 70.6 71.4 64 88 64s32.5 6.6 44.3 18.3L240 190.1 277.1 153c18.7-18.7 48.4-20.8 69.6-5c13.4 10.1 21.3 25.8 21.3 42.6L368 392z',
  ],
};
const faScrollTorah = {
  prefix: 'far',
  iconName: 'scroll-torah',
  icon: [
    640,
    512,
    ['torah'],
    'f6a0',
    'M80 48C62.3 48 48 62.3 48 80l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 0-320 0-16c0-17.7-14.3-32-32-32zm73.3 416C141 492.3 112.8 512 80 512c-44.2 0-80-35.8-80-80L0 80C0 35.8 35.8 0 80 0c32.8 0 61 19.7 73.3 48l6.7 0 320 0 6.7 0C499 19.7 527.2 0 560 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80c-32.8 0-61-19.7-73.3-48l-6.7 0-320 0-6.7 0zm6.7-48l320 0 0-320L160 96l0 320zm368 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 0 320 0 16zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3l56.7 0 31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180l56.7 0c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3L369 332l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332l-56.7 0c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332l-42.4 0L320 368.4zM254.5 256l30.3 52 70.4 0 30.3-52-30.3-52-70.4 0-30.3 52zm144.9 23.8L383 308l32.8 0-16.4-28.2zM415.8 204L383 204l16.4 28.2L415.8 204zM320 143.6L298.8 180l42.4 0L320 143.6zM224.2 204l16.4 28.2L257 204l-32.8 0zM257 308l-16.4-28.2L224.2 308l32.8 0z',
  ],
};
const faTorah = faScrollTorah;
const faWebhook = {
  prefix: 'far',
  iconName: 'webhook',
  icon: [
    576,
    512,
    [],
    'e5d5',
    'M306 50.1c41.1 9.5 67.5 49.2 61.1 90.2c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20C424.8 82 382.6 18.5 316.8 3.3c-68.9-15.9-137.6 27-153.5 95.9c-10.7 46.3 5.2 92.6 37.7 122.7L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5c3.4-5.4 4.5-11.9 3-18.1s-5.3-11.6-10.7-15c-28.2-17.6-43.4-51.7-35.5-85.9C220 67 262.9 40.1 306 50.1zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0l82.8 132.5c3.4 5.4 8.8 9.2 15 10.7s12.7 .3 18.1-3c30.9-19.3 72.1-15.5 99 11.3c31.2 31.2 31.2 81.9 0 113.1c-26.8 26.8-68.1 30.6-99 11.3c-11.2-7-26-3.6-33.1 7.6s-3.6 26 7.6 33.1c49.4 31 115.4 25 158.4-18c50-50 50-131 0-181c-37-37-91-46.6-136.8-28.9L330.4 150.5zM112 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm320 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0c0-26.5-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24L232 360c-6.4 0-12.5 2.5-17 7s-7 10.6-7 17c0 36.4-25 69.4-62 77.9c-43.1 9.9-86-16.9-95.9-60c-8.9-38.6 11.7-77.1 47.1-91.8c12.2-5.1 18-19.1 12.9-31.4s-19.1-18-31.4-12.9C22.1 289.4-11 351 3.3 412.8c15.9 68.9 84.6 111.8 153.5 95.9c51-11.8 87.7-52.5 97-100.7l152.7 0c8.3 14.3 23.8 24 41.6 24c26.5 0 48-21.5 48-48z',
  ],
};
const faBlindsOpen = {
  prefix: 'far',
  iconName: 'blinds-open',
  icon: [
    512,
    512,
    [],
    'f8fc',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l120 0 0 112 0 48 0 36.1C116 254 96 280.7 96 312c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9l0-36.1 0-48 0-112 296 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM144 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM64.3 320L24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l56.3 0c-9-14.1-14.7-30.4-16-48zm191.3 48L488 368c13.3 0 24-10.7 24-24s-10.7-24-24-24l-216.3 0c-1.3 17.6-7 33.9-16 48zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0-48-88 0zm200 48l264 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-264 0 0 48z',
  ],
};
const faFence = {
  prefix: 'far',
  iconName: 'fence',
  icon: [
    512,
    512,
    [],
    'e303',
    'M64 32c7.8 0 15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 48 64 0 0-48c0-5 1.6-9.9 4.5-13.9l40-56C241 35.7 248.2 32 256 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 48 64 0 0-48c0-5 1.6-9.9 4.5-13.9l40-56C433 35.7 440.2 32 448 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 336c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-48-64 0 0 48c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-48-64 0 0 48c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 112c0-5 1.6-9.9 4.5-13.9l40-56C49 35.7 56.2 32 64 32zM320 352l64 0 0-144-64 0 0 144zM192 208l-64 0 0 144 64 0 0-144zM48 119.7L48 432l32 0 0-312.3L64 97.3 48 119.7zm192 0L240 432l32 0 0-312.3L256 97.3l-16 22.4zM432 432l32 0 0-312.3L448 97.3l-16 22.4L432 432z',
  ],
};
const faUp = {
  prefix: 'far',
  iconName: 'up',
  icon: [
    384,
    512,
    ['arrow-alt-up'],
    'f357',
    'M192 82.4L334.7 232.3c.8 .8 1.3 2 1.3 3.2c0 2.5-2 4.6-4.6 4.6L248 240c-13.3 0-24 10.7-24 24l0 168-64 0 0-168c0-13.3-10.7-24-24-24l-83.4 0c-2.5 0-4.6-2-4.6-4.6c0-1.2 .5-2.3 1.3-3.2L192 82.4zm192 153c0-13.5-5.2-26.5-14.5-36.3L222.9 45.2C214.8 36.8 203.7 32 192 32s-22.8 4.8-30.9 13.2L14.5 199.2C5.2 208.9 0 221.9 0 235.4c0 29 23.5 52.6 52.6 52.6l59.4 0 0 144c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-144 59.4 0c29 0 52.6-23.5 52.6-52.6z',
  ],
};
const faArrowAltUp = faUp;
const faBroomBall = {
  prefix: 'far',
  iconName: 'broom-ball',
  icon: [
    576,
    512,
    ['quidditch', 'quidditch-broom-ball'],
    'f458',
    'M569 7c9.4 9.4 9.4 24.6 0 33.9L369 241l39 39c5.1 5.1 8 12.1 8 19.4c0 12.2-8.1 23-19.9 26.3l-55.6 15.9 .1 .6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512L22.3 512C10 512 0 502 0 489.7c0-6.2 2.6-12.1 7.2-16.4l49.9-46.1 24.3-22.4L104 384l-22.7 0c-9.6 0-17.3-7.8-17.3-17.3c0-3.9 .2-7.8 .6-11.6c2.7-25.6 14-49.7 32.4-68l10.2-10.2c33.2-33.2 80.2-48.6 126.7-41.5l.6 .1 15.9-55.6c3.4-11.8 14.1-19.9 26.3-19.9c7.3 0 14.2 2.9 19.4 8l39 39L535 7c9.4-9.4 24.6-9.4 33.9 0zM321.2 297.2l28.1-8-62.4-62.4-8 28.1 42.3 42.3zm-84.9-12.9l-9.8-1.5c-31.3-4.8-63 5.6-85.4 28l-10.2 10.2c-5.1 5.1-9.3 11-12.4 17.3c13.5 4.3 24.8 14.5 30.1 28.3c7.2 18.4 2.4 39.3-12.1 52.7L88.1 464l106.8 0c26.4 0 51.7-10.5 70.3-29.1c22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8-55.4-55.4zM528 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
};
const faQuidditch = faBroomBall;
const faQuidditchBroomBall = faBroomBall;
const faDrumstick = {
  prefix: 'far',
  iconName: 'drumstick',
  icon: [
    512,
    512,
    [127831],
    'f6d6',
    'M240 304c-17.7 0-32-14.3-32-32l0-96c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128l-96 0zm-37.5 78c10.2-14.4 23.9-30 41.5-30l92 0c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176l0 92c0 17.7-15.6 31.3-30 41.5c-2.4 1.7-4.6 3.6-6.8 5.7c-12 12-31.5 11.1-47.9 6.8c-4.9-1.3-10-2-15.4-2c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5.3-.7-10.5-2-15.4c-4.3-16.4-5.2-35.9 6.8-47.9c2.1-2.1 4-4.4 5.7-6.7z',
  ],
};
const faSquareV = {
  prefix: 'far',
  iconName: 'square-v',
  icon: [
    448,
    512,
    [],
    'e284',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm141.5 53.3L224 314.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z',
  ],
};
const faFaceAwesome = {
  prefix: 'far',
  iconName: 'face-awesome',
  icon: [
    512,
    512,
    ['gave-dandy'],
    'e409',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-32l0-24c0-2-.1-3.9-.4-5.8c-4.2 3.6-9.6 5.8-15.6 5.8c-13.3 0-24-10.7-24-24c0-6 2.2-11.4 5.8-15.6c-1.9-.3-3.8-.4-5.8-.4c-22.1 0-40 17.9-40 40l0 24 80 0zm-40-96c39.8 0 72 32.2 72 72l0 24c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-24c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24c0-5.4 1.8-10.3 4.7-14.3c-4.1-1.1-8.3-1.7-12.7-1.7c-26.5 0-48 21.5-48 48l0 16 96 0 0-16c0-4.4-.6-8.7-1.7-12.7c-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80l0 17.9c0 16.6-13.5 30.1-30.1 30.1l-99.8 0c-16.6 0-30.1-13.5-30.1-30.1l0-17.9c0-44.2 35.8-80 80-80zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8c0 0 0 0 0 0l279.4 0s0 0 0 0c10.4 0 18.1 9.6 15.9 19.8c-3.9 17.4-10.6 33.6-19.5 48.2c0 0 0 0 0 0c-28.2 45.9-78.9 75.6-134.9 76l-1.1 0c-4.6 0-9.3-.2-13.8-.6c-68.5-5.9-126.7-55.6-141.8-123.6zm263.8 32.4c-8.2-2.7-16.9-4.2-25.9-4.2c-39.2 0-71.9 27.3-80.2 64c44.1-.7 83.8-24.1 106.2-59.8z',
  ],
};
const faGaveDandy = faFaceAwesome;
const faDialOff = {
  prefix: 'far',
  iconName: 'dial-off',
  icon: [
    576,
    512,
    [],
    'e162',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM264 288l0 109.4c-50.3-11-88-55.8-88-109.4c0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4L312 288c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faToggleOff = {
  prefix: 'far',
  iconName: 'toggle-off',
  icon: [
    576,
    512,
    [],
    'f204',
    'M384 112c79.5 0 144 64.5 144 144s-64.5 144-144 144l-192 0c-79.5 0-144-64.5-144-144s64.5-144 144-144l192 0zM576 256c0-106-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192zm-336 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 256a96 96 0 1 0 192 0A96 96 0 1 0 96 256z',
  ],
};
const faFaceSmileHorns = {
  prefix: 'far',
  iconName: 'face-smile-horns',
  icon: [
    640,
    512,
    [],
    'e391',
    'M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM207.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 350.5 357.2 368 320 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z',
  ],
};
const faBoxArchive = {
  prefix: 'far',
  iconName: 'box-archive',
  icon: [
    512,
    512,
    ['archive'],
    'f187',
    'M48 80l0 48 416 0 0-48L48 80zM32 32l448 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM32 416l0-208 48 0 0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208 48 0 0 208c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64z',
  ],
};
const faArchive = faBoxArchive;
const faGrapes = {
  prefix: 'far',
  iconName: 'grapes',
  icon: [
    512,
    512,
    [],
    'e306',
    'M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM408 264c0-44.2-35.8-80-80-80c0-44.2-35.8-80-80-80c-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48c-19.4 14.6-32 37.8-32 64c0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80c32.5 0 60.5-19.4 73-47.2c13.2 9.6 29.4 15.2 47 15.2c26.2 0 49.4-12.6 64-32c13.4 10 30 16 48 16c44.2 0 80-35.8 80-80c0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264zM248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM72 312a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm80 8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM184 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
  ],
};
const faPersonDrowning = {
  prefix: 'far',
  iconName: 'person-drowning',
  icon: [
    576,
    512,
    [],
    'e545',
    'M152 32c13.3 0 24 10.7 24 24l0 36.6c0 58 37.9 109.1 93.4 126c43.9 13.4 90.7 14.3 135.1 2.7l109.5-28.6c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3L416.5 267.8c-14.3 3.7-28.9 6.4-43.5 7.9L355.7 379.6c-10.6-3.5-21.2-8.8-30.9-15.5c-4.4-3.1-9.1-5.6-14-7.4l13.3-79.8c-23.2-1.4-46.3-5.5-68.8-12.3c-4.6-1.4-9-2.9-13.4-4.7L220.6 379.6c-9.2 3.1-18.9 4.9-28.6 4.9c-6.6 0-13.5-.9-20.6-2.7l26.3-147c-43-33.3-69.7-85.3-69.7-142.1L128 56c0-13.3 10.7-24 24-24zm112 96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faDialMax = {
  prefix: 'far',
  iconName: 'dial-max',
  icon: [
    576,
    512,
    [],
    'e15e',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 305l77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm130.1 96.2A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCircleM = {
  prefix: 'far',
  iconName: 'circle-m',
  icon: [
    512,
    512,
    [],
    'e115',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9c-6.1-8.4-16.9-12-26.8-8.8s-16.6 12.4-16.6 22.8l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-133.8 60.5 83.8c4.5 6.2 11.7 9.9 19.5 9.9s14.9-3.7 19.5-9.9L336 226.2 336 360c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.8L256 255 171.5 137.9z',
  ],
};
const faCalendarImage = {
  prefix: 'far',
  iconName: 'calendar-image',
  icon: [
    448,
    512,
    [],
    'e0d4',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm99.2 136.7L99.8 390.2c-8.1 10.5-.6 25.8 12.7 25.8l226.4 0c12.6 0 20.3-13.9 13.5-24.6L268.9 260.3c-6.1-9.7-20.1-9.9-26.7-.5L184 344l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCircleCaretDown = {
  prefix: 'far',
  iconName: 'circle-caret-down',
  icon: [
    512,
    512,
    ['caret-circle-down'],
    'f32d',
    'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-208 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z',
  ],
};
const faCaretCircleDown = faCircleCaretDown;
const faArrowDown91 = {
  prefix: 'far',
  iconName: 'arrow-down-9-1',
  icon: [
    576,
    512,
    ['sort-numeric-desc', 'sort-numeric-down-alt'],
    'f886',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm409-65c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5 0 86.7-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-120zM424 160a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm88-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.1 29.6 77.3 69.1 86l-15.6 18.7c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l64.6-77.6c13-15.6 20.3-35.1 20.9-55.3c0-.8 0-1.6 0-2.5z',
  ],
};
const faSortNumericDesc = faArrowDown91;
const faSortNumericDownAlt = faArrowDown91;
const faFaceGrinTongueSquint = {
  prefix: 'far',
  iconName: 'face-grin-tongue-squint',
  icon: [
    512,
    512,
    [128541, 'grin-tongue-squint'],
    'f58a',
    'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-23.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 22.9c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faGrinTongueSquint = faFaceGrinTongueSquint;
const faShishKebab = {
  prefix: 'far',
  iconName: 'shish-kebab',
  icon: [
    512,
    512,
    [],
    'f821',
    'M416 48c-26.5 0-48 21.5-48 48c0 5.7 1 11.1 2.7 16.1c6.8 19.2 11.3 51.8-11.3 74.5L337 209l24.4 24.4C375.9 247.9 384 267.5 384 288s-8.1 40.1-22.6 54.6l-18.7 18.7C328.1 375.9 308.5 384 288 384c0 20.5-8.1 40.1-22.6 54.6l-18.7 18.7C232.1 471.9 212.5 480 192 480s-40.1-8.1-54.6-22.6L113 433 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72L54.6 374.6C40.1 360.1 32 340.5 32 320s8.1-40.1 22.6-54.6l18.7-18.7C87.9 232.1 107.5 224 128 224c0-20.5 8.1-40.1 22.6-54.6l18.7-18.7C183.9 136.1 203.5 128 224 128s40.1 8.1 54.6 22.6L303 175l22.5-22.5c1.1-1.1 2.5-3.3 2.8-7.8c.3-4.7-.6-10.6-2.7-16.6C321.9 118 320 107.2 320 96c0-53 43-96 96-96s96 43 96 96c0 19.7-6 38.1-16.2 53.4c-7.4 11-22.3 14-33.3 6.6s-14-22.3-6.6-33.3c5.1-7.6 8.1-16.8 8.1-26.7c0-26.5-21.5-48-48-48zM88.6 340.7l82.7 82.7c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6L88.6 299.3C83.1 304.8 80 312.2 80 320s3.1 15.2 8.6 20.7zm178.7-13.3c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6l-18.7 18.7c-5.5 5.5-8.6 12.9-8.6 20.7s3.1 15.2 8.6 20.7l82.7 82.7z',
  ],
};
const faSprayCan = {
  prefix: 'far',
  iconName: 'spray-can',
  icon: [
    512,
    512,
    [],
    'f5bd',
    'M128 0C110.3 0 96 14.3 96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0zm96 208c26.5 0 48 21.5 48 48l0 184c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-184c0-26.5 21.5-48 48-48l128 0zM96 160c-53 0-96 43-96 96L0 440c0 39.8 32.2 72 72 72l176 0c39.8 0 72-32.2 72-72l0-184c0-53-43-96-96-96L96 160zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0zM320 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM512 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faAlarmSnooze = {
  prefix: 'far',
  iconName: 'alarm-snooze',
  icon: [
    512,
    512,
    [],
    'f845',
    'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.9 0L181.1 345.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-62.9 0 81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5l-112 0z',
  ],
};
const faScarecrow = {
  prefix: 'far',
  iconName: 'scarecrow',
  icon: [
    448,
    512,
    [],
    'f70d',
    'M168 104a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm131 72l69 0 0 32-45.4 0c-24.5 0-43.2 21.7-39.6 45.9l13.9 92.7-13-7.4c-7.9-4.5-17.7-4.2-25.2 .9L224 363.2 189.3 340c-7.6-5-17.3-5.4-25.2-.9l-13 7.4L165 253.9c3.6-24.2-15.1-45.9-39.6-45.9L80 208l0-32 69 0c18.9 19.7 45.6 32 75 32s56.1-12.3 75-32zM120 104c0 8.3 1 16.3 2.8 24L64 128l-8 0-24 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l7.6 11.4L6.4 179.2C2.4 182.2 0 187 0 192s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l24 0 8 0 52.1 0L96.3 388.4c-1.4 9.1 2.6 18.2 10.2 23.4s17.5 5.6 25.5 1L175 388.2 210.7 412c8.1 5.4 18.6 5.4 26.6 0L273 388.2l43.1 24.6c8 4.6 17.9 4.2 25.5-1s11.5-14.3 10.2-23.4L331.9 256l52.1 0 8 0 24 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2 .8-16.4s-8.2-8.5-14.1-8.5l-24 0-8 0-58.8 0c1.8-7.7 2.8-15.7 2.8-24C328 46.6 281.4 0 224 0S120 46.6 120 104zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-45.4c-15.2 7.2-32.8 7.2-48 0l0 45.4z',
  ],
};
const faTruckMonster = {
  prefix: 'far',
  iconName: 'truck-monster',
  icon: [
    640,
    512,
    [],
    'f63b',
    'M280 48l88.2 0c2.5 0 4.8 1.2 6.3 3.1L421.4 112 272 112l0-56c0-4.4 3.6-8 8-8zm202 64L412.6 21.9C402 8.1 385.6 0 368.2 0L280 0c-30.9 0-56 25.1-56 56l0 56-104 0c-48.6 0-88 39.4-88 88l0 30.3c-6.1 5.1-12 10.6-17.5 16.4c-9.1 9.6-8.7 24.8 1 33.9s24.8 8.7 33.9-1C77.2 250.3 116.4 232 160 232c53.3 0 100.3 27.5 127.4 69.1c4.4 6.8 12 10.9 20.1 10.9l24.9 0c8.1 0 15.7-4.1 20.1-10.9C379.7 259.5 426.7 232 480 232c43.6 0 82.8 18.3 110.5 47.7c9.1 9.6 24.3 10.1 33.9 1s10.1-24.3 1-33.9c-5.5-5.8-11.3-11.3-17.5-16.4l0-30.3c0-48.6-39.4-88-88-88l-38 0zm78 88.6c-24.5-10.7-51.6-16.6-80-16.6c-65.4 0-123.5 31.5-160 80c-36.5-48.5-94.5-80-160-80c-28.4 0-55.5 5.9-80 16.6l0-.6c0-22.1 17.9-40 40-40l400 0c22.1 0 40 17.9 40 40l0 .6zM152 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L63.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C40.9 353.9 32 363.9 32 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C190.1 264.9 180.1 256 168 256l-16 0zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm312-80c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C360.9 353.9 352 363.9 352 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C510.1 264.9 500.1 256 488 256l-16 0zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faGiftCard = {
  prefix: 'far',
  iconName: 'gift-card',
  icon: [
    576,
    512,
    [],
    'f663',
    'M353.5 68.8L318.7 128l1.3 0 72 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176 184 176 64 176c-8.8 0-16 7.2-16 16l0 128 480 0 0-128c0-8.8-7.2-16-16-16l-120 0-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384l0 64c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-64L48 384zM256 128l1.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l72 0zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40l41.6 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l41.6 0C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4z',
  ],
};
const faW = {
  prefix: 'far',
  iconName: 'w',
  icon: [
    576,
    512,
    [119],
    '57',
    'M15.9 33.4c12.5-4.5 26.2 2 30.7 14.5L165.9 379.4 265 49.1C268.1 39 277.4 32 288 32s19.9 7 23 17.1l99.1 330.3L529.4 47.9c4.5-12.5 18.2-18.9 30.7-14.5s18.9 18.2 14.5 30.7l-144 400c-3.5 9.7-12.9 16.1-23.2 15.9s-19.4-7.2-22.3-17.1L288 139.5 191 462.9c-3 9.9-12 16.8-22.3 17.1s-19.7-6.1-23.2-15.9L1.4 64.1c-4.5-12.5 2-26.2 14.5-30.7z',
  ],
};
const faCodePullRequestDraft = {
  prefix: 'far',
  iconName: 'code-pull-request-draft',
  icon: [
    448,
    512,
    [],
    'e3fa',
    'M48 80a32 32 0 1 1 64 0A32 32 0 1 1 48 80zm56 76.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3l0 199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-199.3zM48 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faSquareB = {
  prefix: 'far',
  iconName: 'square-b',
  icon: [
    448,
    512,
    [],
    'e264',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 56c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm144 52c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM176 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z',
  ],
};
const faElephant = {
  prefix: 'far',
  iconName: 'elephant',
  icon: [
    640,
    512,
    [128024],
    'f6da',
    'M299.8 48c-33 0-59.8 26.8-59.8 59.8l0 4.2c0 35.3 28.7 64 64 64l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0c-61.9 0-112-50.1-112-112l0-4.2c0-6.4 .6-12.7 1.6-18.9C127.5 111.6 80 174.2 80 248l0 19c0 15.5-1.5 31-4.6 46.3c-3.3 16.3-10.1 31.7-20.1 44.9L43.2 374.4c-8 10.6-23 12.8-33.6 4.8s-12.8-23-4.8-33.6l12.1-16.2c5.7-7.6 9.6-16.3 11.4-25.6C30.8 291.7 32 279.4 32 267l0-19C32 137.6 114.8 46.6 221.6 33.6C241.3 12.9 269.1 0 299.8 0c30.8 0 59 12.1 79.8 32l4.4 0c88.4 0 160 71.6 160 160l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-52.6-36.3-96.8-85.3-108.8c2.1 7.3 3.5 14.9 4.2 22.7l1 12.1c1.1 13.2-8.7 24.8-21.9 25.9s-24.8-8.7-25.9-21.9l-1-12.1c-2.9-35-32.1-61.9-67.2-61.9zM528 381l0 18.7c0 17.8 14.5 32.3 32.3 32.3c15.8 0 29.3-11.4 31.9-27l.2-1c2.2-13.1 14.5-21.9 27.6-19.7s21.9 14.5 19.7 27.6l-.2 1c-6.5 38.7-40 67.1-79.2 67.1C516 480 480 444 480 399.7l0-18.9c-24-4.1-45.9-13.9-64-28.1L416 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-52.3c-21.2 2.8-42.8 2.8-64 0l0 52.3c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 48 0 0-80c0-7 3-13.6 8.3-18.1s12.2-6.6 19.1-5.6l24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5c6.9-1 13.9 1.1 19.1 5.6S320 377 320 384l0 80 48 0 0-152c0-13.3 10.7-24 24-24c11.2 0 20.6 7.6 23.2 18c18.7 26.7 51.6 44.9 89.5 44.9c30.1 0 57.1-11.4 76.3-29.6c6.4-6.1 16.5-5.8 22.6 .6s5.8 16.5-.6 22.6c-19.9 18.9-46 31.9-75 36.5zM432 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faEarthAfrica = {
  prefix: 'far',
  iconName: 'earth-africa',
  icon: [
    512,
    512,
    [127757, 'globe-africa'],
    'f57c',
    'M464 256c0-19.4-2.6-38.1-7.6-55.9L429 194.6c-7.7-1.5-15.4 2.3-18.9 9.2c-5.8 11.6-19.2 17.1-31.5 13l-14.1-4.7c-7.7-2.6-16.1-.6-21.8 5.1c-3.7 3.7-3.7 9.7 0 13.4l33.5 33.5c5 5 7.8 11.8 7.8 18.9c0 12.3-8.4 23-20.3 26l-5.3 1.3c-3.8 .9-6.4 4.3-6.4 8.2l0 12.1c0 13.8-4.5 27.3-12.8 38.4l-25.6 34.1c-6 8.1-15.5 12.8-25.6 12.8c-17.7 0-32-14.3-32-32l0-48c0-8.8-7.2-16-16-16l-32 0c-26.5 0-48-21.5-48-48l0-28c0-12.6 5.9-24.4 16-32l39.4-29.5c5.6-4.2 12.4-6.5 19.4-6.5c3.5 0 6.9 .6 10.2 1.7l32 10.7c7.2 2.4 15 2.7 22.4 .9l35.4-8.8c10.2-2.5 17.3-11.7 17.3-22.2c0-8.7-4.9-16.6-12.6-20.5l-29.2-14.6c-3.7-1.8-8.1-1.1-11 1.8l-3.9 3.9c-4.6 4.6-10.9 7.2-17.4 7.2c-3.8 0-7.6-.9-11-2.6l-15.2-7.6c-6.7-3.4-14.9-1.6-19.6 4.3l-13.6 17c-5.5 6.9-15.8 7.4-22 1.2c-2.8-2.8-4.3-6.5-4.3-10.4l0-41.4c0-5.6-1.5-11-4.2-15.9l-10-17.4C101.7 94.1 48 168.8 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faGlobeAfrica = faEarthAfrica;
const faRainbow = {
  prefix: 'far',
  iconName: 'rainbow',
  icon: [
    640,
    512,
    [127752],
    'f75b',
    'M320 88C169.8 88 48 209.8 48 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C0 183.3 143.3 40 320 40s320 143.3 320 320l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-53 43-96 96-96s96 43 96 96l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-26.5-21.5-48-48-48zM160 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-114.9 93.1-208 208-208s208 93.1 208 208l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z',
  ],
};
const faCircleNotch = {
  prefix: 'far',
  iconName: 'circle-notch',
  icon: [
    512,
    512,
    [],
    'f1ce',
    'M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z',
  ],
};
const faTabletScreenButton = {
  prefix: 'far',
  iconName: 'tablet-screen-button',
  icon: [
    448,
    512,
    ['tablet-alt'],
    'f3fa',
    'M48 448c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-80L48 368l0 80zm0-128l352 0 0-256c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 256zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faTabletAlt = faTabletScreenButton;
const faPaw = {
  prefix: 'far',
  iconName: 'paw',
  icon: [
    512,
    512,
    [],
    'f1b0',
    'M193.9 189.7c-32.3 10.6-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8zm217.7 8.9c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.1zm-311.3 0c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM277.5 92.9c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8zM114.3 409.7c-1.4 3.7-2.3 8.5-2.3 14.2c0 4.5 3.6 8.1 8.1 8.1l3.4 0c2.2 0 4.3-.4 6.3-1.2l72.7-29.1c34.3-13.7 72.6-13.7 107 0l72.7 29.1c2 .8 4.2 1.2 6.3 1.2l3.4 0c4.5 0 8.1-3.6 8.1-8.1c0-5.7-.9-10.4-2.3-14.2C352.1 287.4 276.6 272 256 272s-96.1 15.4-141.7 137.7zM69.3 393C121.7 252.4 214.8 224 256 224s134.3 28.4 186.7 169c3.7 9.9 5.3 20.4 5.3 31c0 31-25.1 56.1-56.1 56.1l-3.4 0c-8.3 0-16.5-1.6-24.2-4.7l-72.7-29.1c-22.9-9.2-48.4-9.2-71.3 0l-72.7 29.1c-7.7 3.1-15.9 4.7-24.2 4.7l-3.4 0c-31 0-56.1-25.1-56.1-56.1c0-10.5 1.6-21.1 5.3-31z',
  ],
};
const faMessageQuestion = {
  prefix: 'far',
  iconName: 'message-question',
  icon: [
    512,
    512,
    [],
    'e1e3',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCloud = {
  prefix: 'far',
  iconName: 'cloud',
  icon: [
    640,
    512,
    [9729],
    'f0c2',
    'M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z',
  ],
};
const faTrowelBricks = {
  prefix: 'far',
  iconName: 'trowel-bricks',
  icon: [
    512,
    512,
    [],
    'e58a',
    'M240.8 4.8c-9.4-5.8-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2l0-72 89 0c3.6 13.8 16.1 24 31 24l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-88 0c-14.9 0-27.4 10.2-31 24l-89 0 0-72c0-11.1-5.7-21.4-15.2-27.2zM288 384l16 0 32 0 128 0 0 80-208 0 0-80 32 0zm-80 0l0 80L48 464l0-80 160 0zm256-48l-128 0 0-64 128 0 0 64zM288 272l0 16 0 48-48 0L48 336c-26.5 0-48 21.5-48 48l0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-80c0-1.3-.1-2.7-.2-4c.1-1.3 .2-2.7 .2-4l0-104c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faSquare3 = {
  prefix: 'far',
  iconName: 'square-3',
  icon: [
    448,
    512,
    [],
    'e258',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L208 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176 152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faFaceFlushed = {
  prefix: 'far',
  iconName: 'face-flushed',
  icon: [
    512,
    512,
    [128563, 'flushed'],
    'f579',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faFlushed = faFaceFlushed;
const faHospitalUser = {
  prefix: 'far',
  iconName: 'hospital-user',
  icon: [
    576,
    512,
    [],
    'f80d',
    'M64 48l192 0c8.8 0 16 7.2 16 16l0 351.7c11.3-20 27.9-36.7 48-47.9l0-95.9L320 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0L64 464c-8.8 0-16-7.2-16-16l0-32 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0L48 64c0-8.8 7.2-16 16-16zm72 64l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z',
  ],
};
const faMicrowave = {
  prefix: 'far',
  iconName: 'microwave',
  icon: [
    576,
    512,
    [],
    'e01b',
    'M512 80c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 352 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 32zM432 136l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-240 0z',
  ],
};
const faChfSign = {
  prefix: 'far',
  iconName: 'chf-sign',
  icon: [
    640,
    512,
    [],
    'e602',
    'M0 115.3C0 69 38.2 32 83.9 32c30.9 0 59.6 17.4 73.6 45.3c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7C108.9 87.4 96.9 80 83.9 80C64.1 80 48 96.1 48 115.3l0 281.3C48 415.9 64.1 432 83.9 432c13 0 25-7.4 30.6-18.7c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2C143.5 462.6 114.7 480 83.9 480C38.2 480 0 443 0 396.7L0 115.3zM216 32c13.3 0 24 10.7 24 24l0 168 128 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-184-128 0 0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM448 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L496 80l0 144 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400z',
  ],
};
const faTentArrowLeftRight = {
  prefix: 'far',
  iconName: 'tent-arrow-left-right',
  icon: [
    576,
    512,
    [],
    'e57f',
    'M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z',
  ],
};
const faCartCircleArrowUp = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-up',
  icon: [
    640,
    512,
    [],
    'e3f0',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z',
  ],
};
const faTrashClock = {
  prefix: 'far',
  iconName: 'trash-clock',
  icon: [
    576,
    512,
    [],
    'e2b0',
    'M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c2 0 3.9-.1 5.8-.3c-18.2-12.9-33.8-29.1-45.9-47.7l-161 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0-5.9 80.1c15.3-7.1 31.9-12 49.2-14.4l4.9-65.7 11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
  ],
};
const faReflectBoth = {
  prefix: 'far',
  iconName: 'reflect-both',
  icon: [
    512,
    512,
    [],
    'e66f',
    'M345.4 48L256 137.4 166.6 48l178.7 0zM384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S396.9 0 384 0zM137.4 256L48 345.4l0-178.7L137.4 256zM19.8 98.4C7.8 103.4 0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9zM374.6 256L464 166.6l0 178.7L374.6 256zM492.2 98.4c-12-5-25.7-2.2-34.9 6.9l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6zM256 374.6L345.4 464l-178.7 0L256 374.6zM413.6 492.2c5-12 2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8z',
  ],
};
const faGavel = {
  prefix: 'far',
  iconName: 'gavel',
  icon: [
    512,
    512,
    ['legal'],
    'f0e3',
    'M313 7c9.3 9.3 9.4 24.3 .2 33.7L471.3 198.8c9.4-9.2 24.4-9.1 33.7 .2c9.4 9.4 9.4 24.6 0 33.9l-16.7 16.8L393 345l-16 16c-9.4 9.4-24.6 9.4-33.9 0c-9-9-9.4-23.5-.9-32.9L184 169.9c-9.4 8.4-23.9 8.1-32.9-.9c-9.4-9.4-9.4-24.6 0-33.9l16-16 95.2-95.3L279 7c9.4-9.4 24.6-9.4 33.9 0zM279.2 74.7L217.9 136 376 294.1l61.3-61.3L279.2 74.7zM223.4 254.6l33.9 33.9-49.8 49.8 7 7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l7 7 49.8-49.8zm-79.4 88L54.6 432 80 457.4 169.4 368 144 342.6z',
  ],
};
const faLegal = faGavel;
const faSprinklerCeiling = {
  prefix: 'far',
  iconName: 'sprinkler-ceiling',
  icon: [
    384,
    512,
    [],
    'e44c',
    'M0 0L0 96c0 11.5 8.2 21.4 19.5 23.6L128 140.2l0-48.9L48 76.1 48 0 0 0zM256 91.4l0 48.9 108.5-20.7C375.8 117.4 384 107.5 384 96l0-96L336 0l0 76.1L256 91.4zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-152z',
  ],
};
const faBrowsers = {
  prefix: 'far',
  iconName: 'browsers',
  icon: [
    576,
    512,
    [],
    'e0cb',
    'M144 352l0-224 384 0 0 224c0 8.8-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-256z',
  ],
};
const faTrillium = {
  prefix: 'far',
  iconName: 'trillium',
  icon: [
    448,
    512,
    [],
    'e588',
    'M203.3 16.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 7.3-.8 14.5-2.2 21.5c7.3 2.3 14.4 5.3 21.2 9.3c0 0 0 0 0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-7-4-13.4-8.7-19.1-14c-5.7 5.3-12.1 10-19.1 14c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C14.3 380 5.1 364.4 8.8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9c0 0 0 0 0 0c6.9-3.9 14-7 21.3-9.3c-1.4-6.9-2.2-14.1-2.2-21.4c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zm122 224.5s0 0 0 0c-6.9-4-14.2-6.3-21.6-7.3c-9.9-1.3-18.6-7-23.6-15.6s-5.8-19-2-28.2c2.7-6.6 4.1-13.7 4.1-21.3c0 0 0 0 0 0c0-20.1-10-43.2-25.8-66.2C245.9 86.9 234 73.4 224 63.1c-9.9 10.2-21.9 23.8-32.4 39.1c-15.8 23-25.8 46.1-25.8 66.2c0 7.6 1.5 14.7 4.1 21.3c3.7 9.2 3 19.6-2 28.2s-13.8 14.3-23.6 15.6c-7.4 .9-14.8 3.3-21.7 7.3C105 250.9 89.8 271.1 77.7 296c-8 16.6-13.9 33.5-17.8 47.1c13.9 3.4 31.7 6.9 50.3 8.3c27.9 2.1 53.1-.9 70.8-11c7.1-4.1 12.9-9.3 17.4-15.4c6-8 15.5-12.8 25.6-12.8s19.5 4.7 25.6 12.8c4.5 6 10.4 11.3 17.4 15.4c17.6 10.1 42.9 13.1 70.8 11c18.6-1.4 36.4-4.9 50.3-8.3c-4-13.6-9.8-30.5-17.8-47.1c-12.1-25-27.3-45.1-44.9-55.2zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm249.9 55c.9-6 1.3-12.1 1.3-18.4c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3c-7.3-4.2-14.9-7.6-22.6-10.3zM205.1 497.1c-8.3-12.6-22.8-38.2-31-74.3c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0zM184 240a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z',
  ],
};
const faTableCellsUnlock = {
  prefix: 'far',
  iconName: 'table-cells-unlock',
  icon: [
    640,
    512,
    [],
    'e692',
    'M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l24 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 56 0 0 .6c-16.9 9.8-29 27.1-31.5 47.4L360 344l0 88zM200 296l112 0 0-80-112 0 0 80zm296-24l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
  ],
};
const faMusicSlash = {
  prefix: 'far',
  iconName: 'music-slash',
  icon: [
    640,
    512,
    [],
    'f8d1',
    'M545 0c17.1 0 31 13.9 31 31l0 112.5c0 .4 0 .7 0 1.1L576 368c0 16.7-6.2 32.2-16.7 45.1l71.5 56c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L208 137.7l0-17.7c0-10.5 6.9-19.8 16.9-22.9l311-95.7c3-.9 6-1.4 9.1-1.4zM256 175.3l31.7 24.9L528 126.3 528 54 256 137.7l0 37.6zm77.7 60.9l87.4 68.5C437.4 294.3 457.8 288 480 288c17.5 0 33.9 3.9 48 10.7l0-122.2L333.7 236.3zM463.4 337.9l58 45.4c4.6-5.6 6.6-11.4 6.6-15.3c0-9.8-12.9-32-48-32c-6.2 0-11.7 .7-16.6 1.9zM208 259.9l48 37.8L256 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c17.5 0 33.9 3.9 48 10.7l0-102.8zM160 400c-35.1 0-48 22.2-48 32s12.9 32 48 32s48-22.2 48-32s-12.9-32-48-32z',
  ],
};
const faTruckRamp = {
  prefix: 'far',
  iconName: 'truck-ramp',
  icon: [
    640,
    512,
    [],
    'f4e0',
    'M440 0c-48.6 0-88 39.4-88 88l0 285.8L17.7 464.8C4.9 468.3-2.6 481.5 .8 494.3s16.7 20.3 29.5 16.8L416.2 406c3.1 59.1 52 106 111.8 106c61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l-.4 .1-25.7 7L400 88c0-22.1 17.9-40 40-40l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L440 0zm88 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faBinoculars = {
  prefix: 'far',
  iconName: 'binoculars',
  icon: [
    512,
    512,
    [],
    'f1e5',
    'M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 16L96 80l0-16zM59.6 158c4.8-26.6 28-46 55.1-46l85.3 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24c0-13.3 10.7-24 24-24l85.3 0c27.1 0 50.3 19.4 55.1 46l5 27.3c3.6 19.9 10.8 39 21.2 56.4l2.6 4.4c20.1 33.6 30.8 72 30.8 111.1l0 66.8c0 30.9-25.1 56-56 56l-112 0c-30.9 0-56-25.1-56-56l0-136-64 0 0 136c0 30.9-25.1 56-56 56L56 480c-30.9 0-56-25.1-56-56l0-66.8C0 318 10.6 279.6 30.8 246l2.6-4.4c10.4-17.4 17.6-36.5 21.2-56.4l5-27.3zm55.1 2c-3.9 0-7.2 2.8-7.9 6.6l-5 27.3C97.2 219.5 88 244 74.6 266.4l-2.6 4.4C56.3 296.9 48 326.7 48 357.2L48 424c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-264-61.3 0zm282.6 0L336 160l0 264c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-66.8c0-30.4-8.3-60.3-23.9-86.4l-2.6-4.4c-13.4-22.3-22.6-46.9-27.3-72.5l-5-27.3c-.7-3.8-4-6.6-7.9-6.6zM352 32l32 0c17.7 0 32 14.3 32 32l0 16-96 0 0-16c0-17.7 14.3-32 32-32z',
  ],
};
const faMicrophoneSlash = {
  prefix: 'far',
  iconName: 'microphone-slash',
  icon: [
    640,
    512,
    [],
    'f131',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5l0-160c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zM272 187.9L272 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 2.3-.2 4.6-.5 6.8L272 187.9zm-80 59.4L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7z',
  ],
};
const faBoxTissue = {
  prefix: 'far',
  iconName: 'box-tissue',
  icon: [
    512,
    512,
    [],
    'e05b',
    'M208 48l-90.5 0 57.1 228.4 2.9 11.6 154.8 0 7.1-17.8L389.9 144 336 144c-31.1 0-56.2-9.9-75.5-28.2c-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8C222.3 56 219.8 52 217.5 49.8c-.5-.5-.8-.6-1.3-.8c-.7-.3-3-1-8.2-1zM384 288l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0-8-32-12-48L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0L208 0c40 0 52 24 64 48s24 48 64 48l85.2 0C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L416 208l-19.2 48L384 288zM75 208l12 48-39 0 0 112 416 0 0-112-32.7 0 19.2-48 13.5 0c26.5 0 48 21.5 48 48l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256c0-26.5 21.5-48 48-48l27 0zM48 416l0 48 416 0 0-48L48 416z',
  ],
};
const faCircleC = {
  prefix: 'far',
  iconName: 'circle-c',
  icon: [
    512,
    512,
    [],
    'e101',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z',
  ],
};
const faStarChristmas = {
  prefix: 'far',
  iconName: 'star-christmas',
  icon: [
    512,
    512,
    [],
    'f7d4',
    'M279.2 17.9C276.5 7.4 266.9 0 256 0s-20.5 7.4-23.2 17.9L188.3 188.3 17.9 232.8C7.4 235.5 0 245.1 0 256s7.4 20.5 17.9 23.2l170.4 44.4 44.4 170.4c2.8 10.6 12.3 17.9 23.2 17.9s20.5-7.4 23.2-17.9l44.4-170.4 170.4-44.4c10.6-2.8 17.9-12.3 17.9-23.2s-7.4-20.5-17.9-23.2L323.7 188.3 279.2 17.9zm-48 196.1l24.8-95 24.8 95c2.2 8.4 8.8 15 17.2 17.2l95 24.8-95 24.8c-8.4 2.2-15 8.8-17.2 17.2l-24.8 95-24.8-95c-2.2-8.4-8.8-15-17.2-17.2l-95-24.8 95-24.8c8.4-2.2 15-8.8 17.2-17.2zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z',
  ],
};
const faChartBullet = {
  prefix: 'far',
  iconName: 'chart-bullet',
  icon: [
    512,
    512,
    [],
    'e0e1',
    'M264 32c13.3 0 24 10.7 24 24l0 8 176 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-176 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l192 0 0-8c0-13.3 10.7-24 24-24zM160 112l0 64 80 0 0-64-80 0zm128 0l0 64 176 0 0-64-176 0zm-176 0l-64 0 0 64 64 0 0-64zM360 256c13.3 0 24 10.7 24 24l0 8 80 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 448c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l288 0 0-8c0-13.3 10.7-24 24-24zM224 336l0 64 112 0 0-64-112 0zm160 0l0 64 80 0 0-64-80 0zm-208 0L48 336l0 64 128 0 0-64z',
  ],
};
const faMotorcycle = {
  prefix: 'far',
  iconName: 'motorcycle',
  icon: [
    640,
    512,
    [127949],
    'f21c',
    'M292.5 224.7c11.1 14.3 20.4 30.2 27.5 47.2c15.3-36.5 40.6-67.8 72.6-90.2l-15.3-28.2-84.9 71.3zM304 384l-16 0 0-32c0-88.4-71.6-160-160-160l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c49.6 0 95.1 17.3 130.8 46.3l95.2-80L337.7 80 280 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l62.5 0c14.7 0 28.2 8.1 35.2 21l13.9 25.8 46.7-39.3c5.8-4.8 13.1-7.5 20.6-7.5L480 32c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-61.8 0 55.1 102c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-40 18.4-75.7 47.1-99.2l-15.4-28.6C377 253.4 352 299.8 352 352l0 32-48 0s0 0 0 0zm128-32c0 44.2 35.8 80 80 80s80-35.8 80-80s-35.8-80-80-80c-5.2 0-10.3 .5-15.2 1.4l36.3 67.1c6.3 11.7 2 26.2-9.7 32.5s-26.2 2-32.5-9.7l-36.3-67.1c-14 14.4-22.6 34.1-22.6 55.7zM204.3 328c-10.2-32.5-40.5-56-76.3-56c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56l-55.2 0c-5.6 5-13.1 8-21.2 8c-17.7 0-32-14.3-32-32s14.3-32 32-32c8.1 0 15.5 3 21.2 8l55.2 0zM128 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256z',
  ],
};
const faTreeChristmas = {
  prefix: 'far',
  iconName: 'tree-christmas',
  icon: [
    448,
    512,
    [127876],
    'f7db',
    'M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zm125.3 60.5l15.8-5.9 122 193.1c4.7 7.4 4.9 16.7 .7 24.4s-12.3 12.4-21 12.4l-25.3 0 76.5 119.5c4.7 7.4 5 16.8 .8 24.5s-12.3 12.5-21.1 12.5L24 512c-8.8 0-16.8-4.8-21.1-12.5s-3.9-17.1 .8-24.5L80.3 355.5l-25.3 0c-8.7 0-16.8-4.8-21-12.4s-3.9-17 .7-24.4l122-193.1 15.8 5.9L185 165c.4 1.2 .9 2.3 1.4 3.4L98.6 307.5l25.6 0c8.8 0 16.8 4.8 21.1 12.5s3.9 17.1-.8 24.5L67.9 464l312.3 0L303.6 344.5c-4.7-7.4-5.1-16.8-.8-24.5s12.3-12.5 21.1-12.5l25.6 0L261.5 168.4c.5-1.1 1-2.2 1.4-3.4l12.6-33.5zM160 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faTireFlat = {
  prefix: 'far',
  iconName: 'tire-flat',
  icon: [
    512,
    512,
    [],
    'f632',
    'M464 288c0-114.9-93.1-208-208-208S48 173.1 48 288c0 31 6.8 60.3 18.8 86.7c6.9 15.1 7 33-.8 48.5L48.4 458.5c-.3 .5-.4 1.1-.4 1.7c0 2.1 1.7 3.8 3.8 3.8l80.2 0L380 464l80.2 0c2.1 0 3.8-1.7 3.8-3.8c0-.6-.1-1.2-.4-1.7l-17.7-35.3c-7.8-15.6-7.7-33.4-.8-48.5C457.2 348.3 464 319 464 288zm48 0c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8L380 512 132 512l-80.2 0C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-136 0c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5l0 .9 39.2 12.8c.5-4.5 .8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3l0-41.3zM136 288c0 4.6 .3 9.2 .8 13.6L176 288.9l0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288zm120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 210l1.6 2.2c8-2.7 16.6-4.2 25.6-4.2zM88 288a168 168 0 1 1 336 0A168 168 0 1 1 88 288zm200 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faSunglasses = {
  prefix: 'far',
  iconName: 'sunglasses',
  icon: [
    576,
    512,
    [128374],
    'f892',
    'M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2 0 1.5 0 41.3 0 .6 0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 2.6 .2 5.2 .5 7.8l144.4-72.2c-18.8-5-38.3-7.6-57.2-7.6c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c0 .8 .1 1.7 .2 2.5l141-70.5c-18.6-4.9-38-7.5-56.7-7.5z',
  ],
};
const faBadge = {
  prefix: 'far',
  iconName: 'badge',
  icon: [
    512,
    512,
    [],
    'f335',
    'M256 48c-24.1 0-45.1 13.5-55.7 33.5C194.9 91.7 183 96.6 172 93.2c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7C91.7 317.1 96.6 329 93.2 340c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5c5.4-10.2 17.2-15.1 28.2-11.7c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1c-3.4-11 1.5-22.9 11.7-28.2c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7c-10.2-5.4-15.1-17.2-11.7-28.2c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.3-11.7C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z',
  ],
};
const faMessagePen = {
  prefix: 'far',
  iconName: 'message-pen',
  icon: [
    512,
    512,
    ['comment-alt-edit', 'message-edit'],
    'f4a4',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM340.8 123c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z',
  ],
};
const faCommentAltEdit = faMessagePen;
const faMessageEdit = faMessagePen;
const faBellConcierge = {
  prefix: 'far',
  iconName: 'bell-concierge',
  icon: [
    512,
    512,
    [128718, 'concierge-bell'],
    'f562',
    'M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C119.6 157.2 32 252.4 32 368l48 0c0-97.2 78.8-176 176-176s176 78.8 176 176l48 0c0-115.6-87.6-210.8-200-222.7l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0-40 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z',
  ],
};
const faConciergeBell = faBellConcierge;
const faPenRuler = {
  prefix: 'far',
  iconName: 'pen-ruler',
  icon: [
    512,
    512,
    ['pencil-ruler'],
    'f5ae',
    'M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM173.3 27.3l65.2 65.2-33.9 33.9-26.2-26.2-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23L139.3 61.3c-6.2-6.2-16.4-6.2-22.6 0L61.3 116.7c-6.2 6.2-6.2 16.4 0 22.6l65.2 65.2L92.5 238.5 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3c25-25 65.5-25 90.5 0zM372.7 450.7c6.2 6.2 16.4 6.2 22.6 0l55.4-55.4c6.2-6.2 6.2-16.4 0-22.6l-16.4-16.4-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23-26.2-26.2 33.9-33.9 65.2 65.2c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0l-65.2-65.2 33.9-33.9 65.2 65.2z',
  ],
};
const faPencilRuler = faPenRuler;
const faFileMp3 = {
  prefix: 'far',
  iconName: 'file-mp3',
  icon: [
    512,
    512,
    [],
    'e648',
    'M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm75.7-111.4c6.9-1.9 14.3 1 18 7.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4zM288 368c0-8.8 7.2-16 16-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zm144 80l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0c-8.8 0-16-7.2-16-16c0-.6 0-1.1 .1-1.6c.8-8.1 7.6-14.4 15.9-14.4l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48z',
  ],
};
const faArrowProgress = {
  prefix: 'far',
  iconName: 'arrow-progress',
  icon: [
    512,
    512,
    [],
    'e5df',
    'M472 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64zM0 160C0 93.7 53.7 40 120 40l136 0 0-22.1C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9L256 88 120 88c-39.8 0-72 32.2-72 72s32.2 72 72 72l272 0c66.3 0 120 53.7 120 120c0 59.5-43.3 108.8-100 118.3c-9.1 24.3-32.5 41.7-60 41.7c-35.3 0-64-28.7-64-64s28.7-64 64-64c25.9 0 48.3 15.4 58.3 37.6c30.9-8.1 53.7-36.2 53.7-69.6c0-39.8-32.2-72-72-72l-272 0C53.7 280 0 226.3 0 160zM123.3 424l36.7 0 0-22.1c0-9.9 8-17.9 17.9-17.9c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9l0-22.1-36.7 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40zM88 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm264 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faChessRookPiece = {
  prefix: 'far',
  iconName: 'chess-rook-piece',
  icon: [
    320,
    512,
    ['chess-rook-alt'],
    'f448',
    'M16 120c0-13.3 10.7-24 24-24l240 0c13.3 0 24 10.7 24 24l0 104c0 5.6-2 11.1-5.6 15.4l-33.9 40.7 4.2 71.9-48.1 0L216 273.4c-.4-6.1 1.6-12.1 5.5-16.8L256 215.3l0-71.3-40 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-40 0 0 71.3 34.4 41.3c3.9 4.7 5.9 10.7 5.5 16.8L99.3 352l-48.1 0 4.2-71.9L21.6 239.4C18 235.1 16 229.6 16 224l0-104zM136 280.9l0-32.9c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32.9c0 3.9-3.2 7.1-7.1 7.1l-33.8 0c-3.9 0-7.1-3.2-7.1-7.1zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z',
  ],
};
const faChessRookAlt = faChessRookPiece;
const faSquareRoot = {
  prefix: 'far',
  iconName: 'square-root',
  icon: [
    576,
    512,
    [8730],
    'f697',
    'M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.9 0c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L344.3 80z',
  ],
};
const faAlbumCollectionCirclePlus = {
  prefix: 'far',
  iconName: 'album-collection-circle-plus',
  icon: [
    640,
    512,
    [],
    'e48e',
    'M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16l-353 0c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l249.4 0c12.3 18.8 28 35.1 46.3 48L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faPeopleArrows = {
  prefix: 'far',
  iconName: 'people-arrows',
  icon: [
    640,
    512,
    ['people-arrows-left-right'],
    'e068',
    'M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 40 0c0 14.3 5.5 28.7 16.4 39.6L192 391.2l0 96.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c27 0 51 13.4 65.5 34.1c-2.6 1.8-5.2 4-7.5 6.3l-28.1 28.1c-4.6-12.1-16.3-20.5-29.9-20.5l-44.8 0zM448 488l0-96.8 47.6-47.6C506.5 332.7 512 318.3 512 304l40 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C564.9 220.8 551 208 534.4 208l-44.8 0c-13.5 0-25.2 8.4-29.9 20.5l-28.1-28.1c-2.4-2.4-4.9-4.5-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24zm0-424a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM265 257l-23 23 156.1 0-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-156.1 0 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faPeopleArrowsLeftRight = faPeopleArrows;
const faSignPost = {
  prefix: 'far',
  iconName: 'sign-post',
  icon: [
    512,
    512,
    [],
    'e624',
    'M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 137 0c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5l-137 0 0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232L80 256c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l152 0 0-40zM449.5 160l-40-48L80 112l0 96 329.5 0 40-48z',
  ],
};
const faFaceAngryHorns = {
  prefix: 'far',
  iconName: 'face-angry-horns',
  icon: [
    640,
    512,
    [],
    'e368',
    'M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zm72.4-102.5c9.7-9 10.2-24.2 1.2-33.9C379.3 360.3 354.6 344 320 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z',
  ],
};
const faMarsAndVenusBurst = {
  prefix: 'far',
  iconName: 'mars-and-venus-burst',
  icon: [
    640,
    512,
    [],
    'e523',
    'M520 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2l0 33.8-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-33.8c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L592 81.9l0 30.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88c0-13.3-10.7-24-24-24L520 0zM288 224a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM176 8c-8.9 0-17 4.9-21.2 12.7L124.7 77.5 61.6 65.6c-8.7-1.6-17.6 1.7-23.2 8.6s-6.8 16.4-3.3 24.5l25.6 58.9-48.6 42c-6.7 5.8-9.7 14.8-7.7 23.5s8.6 15.5 17.1 17.8l62 16.7 2.5 64.2c.3 8.9 5.6 16.8 13.6 20.7s17.5 3 24.6-2.3l51.7-38 51.7 38c6.4 4.7 14.7 5.9 22.1 3.3c-16.9-21.2-29.4-46.1-36.2-73.3l-23.4-17.2c-8.5-6.2-20-6.2-28.4 0l-29.5 21.7-1.4-36.6c-.4-10.5-7.6-19.5-17.7-22.2l-35.4-9.6 27.7-24c7.9-6.9 10.5-18.1 6.3-27.7L97.2 121.1l36 6.7c10.3 1.9 20.7-3.1 25.6-12.3L176 83.2l17.2 32.4c4.9 9.3 15.3 14.3 25.6 12.3l16.8-3.1c14.3-23.6 33.4-43.8 56.1-59.3c-.4 .1-.9 .1-1.3 .2L227.3 77.5 197.2 20.7C193 12.9 184.9 8 176 8z',
  ],
};
const faTombstone = {
  prefix: 'far',
  iconName: 'tombstone',
  icon: [
    448,
    512,
    [],
    'f720',
    'M368 432l0-240c0-79.5-64.5-144-144-144S80 112.5 80 192l0 240-48 0 0-240C32 86 118 0 224 0S416 86 416 192l0 240-48 0zM0 488c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM248 152l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSquareCaretRight = {
  prefix: 'far',
  iconName: 'square-caret-right',
  icon: [
    448,
    512,
    ['caret-square-right'],
    'f152',
    'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z',
  ],
};
const faCaretSquareRight = faSquareCaretRight;
const faScissors = {
  prefix: 'far',
  iconName: 'scissors',
  icon: [
    512,
    512,
    [9984, 9986, 9988, 'cut'],
    'f0c4',
    'M506.4 439.4c-8.5 10.2-23.7 11.5-33.8 3L312.4 308.2l37.4-31.3L503.4 405.6c10.2 8.5 11.5 23.7 3 33.8zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-48c61.9 0 112 50.1 112 112c0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6c10.2-8.5 25.3-7.2 33.8 3s7.2 25.3-3 33.8l-291 243.8c7.4 15 11.6 31.9 11.6 49.8c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8L250.1 256l-67.8-56.8C163.1 214.7 138.6 224 112 224C50.1 224 0 173.9 0 112S50.1 0 112 0zm64 400A64 64 0 1 0 48 400a64 64 0 1 0 128 0z',
  ],
};
const faCut = faScissors;
const faListMusic = {
  prefix: 'far',
  iconName: 'list-music',
  icon: [
    512,
    512,
    [],
    'f8c9',
    'M481.1 0C498.2 0 512 13.8 512 30.9L512 136c0 10.4-6.7 19.6-16.6 22.8L384 194.7 384 432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c23.8 0 45.9 5.3 64 14.3L336 64c0-10.3 6.6-19.5 16.4-22.8L471.4 1.6c3.1-1 6.4-1.6 9.8-1.6zM323.3 414.5c-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5C209.4 422.6 208 429.4 208 432s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5s-1.4-9.4-12.7-17.5zM384 144.3l80-25.8 0-63.9L384 81.3l0 63zM24 48l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 96C10.7 96 0 85.3 0 72S10.7 48 24 48zm0 128l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 352c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faSunPlantWilt = {
  prefix: 'far',
  iconName: 'sun-plant-wilt',
  icon: [
    640,
    512,
    [],
    'e57a',
    'M160-.2c-8.4 0-16.2 4.4-20.5 11.6L115.2 51.7 69.6 40.4c-8.2-2-16.8 .4-22.7 6.3s-8.3 14.6-6.3 22.7l11.3 45.6L11.6 139.4C4.4 143.7 0 151.5 0 159.9s4.4 16.2 11.6 20.5l40.2 24.3L40.5 250.4c-2 8.2 .4 16.8 6.3 22.7s14.6 8.3 22.7 6.3l45.6-11.3 24.3 40.2c4.3 7.2 12.1 11.6 20.5 11.6s16.2-4.4 20.5-11.6l24.3-40.2 45.6 11.3c8.2 2 16.8-.4 22.7-6.3s8.3-14.6 6.3-22.7l-11.3-45.6 40.2-24.3c7.2-4.3 11.6-12.1 11.6-20.5s-4.4-16.2-11.6-20.5l-40.2-24.3 11.3-45.6c2-8.2-.4-16.8-6.3-22.7s-14.6-8.3-22.7-6.3L204.9 51.7 180.6 11.4C176.2 4.2 168.5-.2 160-.2zm0 70.4l12.9 21.3c5.4 9 16.1 13.4 26.3 10.9l24.2-6-6 24.2c-2.5 10.2 1.9 20.9 10.9 26.3l21.3 12.9-21.3 12.9c-9 5.4-13.4 16.1-10.9 26.3l6 24.2-24.2-6c-10.2-2.5-20.9 1.9-26.3 10.9L160 249.6l-12.9-21.3c-5.4-9-16.1-13.4-26.3-10.9l-24.2 6 6-24.2c2.5-10.2-1.9-20.9-10.9-26.3L70.4 159.9 91.8 147c9-5.4 13.4-16.1 10.9-26.3l-6-24.2 24.2 6c10.2 2.5 20.9-1.9 26.3-10.9L160 70.3zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274.1c0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338.1c0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8 0 184L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-184 0-8 0-96z',
  ],
};
const faToiletsPortable = {
  prefix: 'far',
  iconName: 'toilets-portable',
  icon: [
    576,
    512,
    [],
    'e584',
    'M72 48l112 0c13.3 0 24 10.7 24 24l0 24L48 96l0-24c0-13.3 10.7-24 24-24zM48 432l0-288 160 0 0 80-24 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l24 0 0 112L48 432zm0 56l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-416c0-39.8-32.2-72-72-72L72 0C32.2 0 0 32.2 0 72L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM392 48l112 0c13.3 0 24 10.7 24 24l0 24L368 96l0-24c0-13.3 10.7-24 24-24zM368 432l0-288 160 0 0 80-24 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l24 0 0 112-160 0zm0 56l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-416c0-39.8-32.2-72-72-72L392 0c-39.8 0-72 32.2-72 72l0 416c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faHockeyPuck = {
  prefix: 'far',
  iconName: 'hockey-puck',
  icon: [
    512,
    512,
    [],
    'f453',
    'M48 184c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 245.6 194.3 256 256 256s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2s-2.3-11.7-11-20.2c-8.8-8.6-22.8-17.5-42.1-25.5C372.4 122.4 317.7 112 256 112s-116.4 10.4-154.9 26.3c-19.3 8-33.3 16.9-42.1 25.5c-8.7 8.6-11 15.4-11 20.2zM0 184c0-21.7 10.7-40.1 25.4-54.5c14.7-14.3 34.6-26.1 57.3-35.5C128.3 75.1 189.6 64 256 64s127.7 11.1 173.2 29.9c22.7 9.4 42.7 21.2 57.3 35.5C501.3 143.9 512 162.3 512 184l0 144c0 21.7-10.7 40.1-25.4 54.5c-14.6 14.3-34.6 26.1-57.3 35.5C383.7 436.9 322.4 448 256 448s-127.7-11.1-173.2-29.9c-22.7-9.4-42.7-21.2-57.3-35.5C10.7 368.1 0 349.7 0 328L0 184zm464 72.2c-10.5 6.7-22.2 12.6-34.8 17.9C383.7 292.9 322.4 304 256 304s-127.7-11.1-173.2-29.9c-12.6-5.2-24.3-11.1-34.8-17.9L48 328c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 389.6 194.3 400 256 400s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2l0-71.8z',
  ],
};
const faMustache = {
  prefix: 'far',
  iconName: 'mustache',
  icon: [
    640,
    512,
    [],
    'e5bc',
    'M233.4 112c-32.9 0-64.4 13.1-87.7 36.3c-28.5 28.5-74.2 29.8-104.3 3.1l-1.5-1.3c-2.7-2.4-5.8-4.1-9-5c-1.3-.4-2.7-.7-4.1-.9c-1.1-.1-2.2-.2-3.3-.2c-3.6 .1-7 .9-10.1 2.4c-2.2 1-4.2 2.4-6 4.2C2.9 154.9 0 161.1 0 168l0 34C0 311.4 88.6 400 198 400c42.8 0 84.5-13.9 118.8-39.6L320 358l3.2 2.4c34.3 25.7 76 39.6 118.8 39.6c109.4 0 198-88.6 198-198l0-34c0-6.9-2.9-13.1-7.5-17.4c-4.2-4-9.8-6.5-16.1-6.6c-.4 0-.9 0-1.3 0c-2.4 .1-4.8 .5-7.1 1.3c-2.9 1-5.6 2.6-8 4.7l-1.5 1.3c-30.1 26.7-75.8 25.4-104.3-3.1C471 125.1 439.5 112 406.6 112l-1.2 0c-29.7 0-58.5 10.4-81.3 29.5l-4 3.3-4-3.3c-22.8-19-51.6-29.5-81.3-29.5l-1.2 0zm358.3 98.7C587.3 289.5 521.9 352 442 352c-32.5 0-64-10.5-90-30l-17.6-13.2c-8.5-6.4-20.3-6.4-28.8 0L288 322c-26 19.5-57.5 30-90 30c-79.9 0-145.3-62.5-149.8-141.3c44.3 16.7 96 7 131.4-28.4C193.9 168 213.3 160 233.4 160l1.2 0c18.5 0 36.4 6.5 50.6 18.3l19.3 16.1c8.9 7.4 21.8 7.4 30.7 0l19.3-16.1c14.2-11.8 32.1-18.3 50.6-18.3l1.2 0c20.2 0 39.5 8 53.8 22.3c35.4 35.4 87.1 45.1 131.4 28.4z',
  ],
};
const faHyphen = {
  prefix: 'far',
  iconName: 'hyphen',
  icon: [
    320,
    512,
    [],
    '2d',
    'M0 256c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
  ],
};
const faTable = {
  prefix: 'far',
  iconName: 'table',
  icon: [
    512,
    512,
    [],
    'f0ce',
    'M48 264l0-104 184 0 0 104L48 264zm0 48l184 0 0 120L64 432c-8.8 0-16-7.2-16-16l0-104zM280 432l0-120 184 0 0 104c0 8.8-7.2 16-16 16l-168 0zM464 264l-184 0 0-104 184 0 0 104zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faUserChef = {
  prefix: 'far',
  iconName: 'user-chef',
  icon: [
    448,
    512,
    [],
    'e3d2',
    'M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 64c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-64 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM169.4 438c-5.7 2.6-9.4 8.3-9.4 14.6l0 11.4 237.1 0c-7.7-28.9-30.1-51.9-58.8-60.4L304 393.4l0-14.3-13.1 3.8L169.4 438zM128 452.6c0-18.8 11-35.9 28.1-43.7l35.6-16.2L144 379.1l0 14.3-34.3 10.2c-28.6 8.5-51 31.5-58.8 60.4l77.1 0 0-11.4zM0 486.4c0-60.9 40.5-112.3 96-128.8L96 334c0-7.8 6.3-14 14-14c1.3 0 2.6 .2 3.9 .5L224 352l110.1-31.5c1.3-.4 2.6-.5 3.9-.5c7.8 0 14 6.3 14 14l0 23.5c55.5 16.5 96 68 96 128.8c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faMessageImage = {
  prefix: 'far',
  iconName: 'message-image',
  icon: [
    512,
    512,
    ['comment-alt-image'],
    'e1e0',
    'M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492zm88-348c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-128 0-48 0-48 0c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCommentAltImage = faMessageImage;
const faUsersMedical = {
  prefix: 'far',
  iconName: 'users-medical',
  icon: [
    640,
    512,
    [],
    'f830',
    'M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-13.4 0c-6.6-18.6-24.4-32-45.3-32l-32 0c-20.9 0-38.7 13.4-45.3 32l-77.4 0zm-26.7 32c19.3 0 37.6 4.1 54.2 11.5C422.5 372.3 416 385.4 416 400l0 8.6c-11.3-5.5-23.9-8.6-37.3-8.6l-117.3 0c-39.8 0-73.2 27.2-82.6 64l249.5 0c8.8 9.8 21.6 16 35.8 16l16 0 0 16c0 5.6 1 11 2.7 16l-328.1 0c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352l117.3 0zM320 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM512 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faSensorTriangleExclamation = {
  prefix: 'far',
  iconName: 'sensor-triangle-exclamation',
  icon: [
    640,
    512,
    ['sensor-alert'],
    'e029',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 49.9c13.1-11.4 30.1-17.9 48-17.9l0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l161 0c-.6-4-1-8.1-1-12.3c0-12.5 3-24.7 8.9-35.7L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm21.8 293.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3l295.4 0c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272l0 88c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faSensorAlert = faSensorTriangleExclamation;
const faMagnifyingGlassArrowRight = {
  prefix: 'far',
  iconName: 'magnifying-glass-arrow-right',
  icon: [
    512,
    512,
    [],
    'e521',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm33-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L128 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z',
  ],
};
const faTachographDigital = {
  prefix: 'far',
  iconName: 'tachograph-digital',
  icon: [
    640,
    512,
    ['digital-tachograph'],
    'f566',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm112 16l224 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zM80 352c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM96 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faDigitalTachograph = faTachographDigital;
const faFaceMask = {
  prefix: 'far',
  iconName: 'face-mask',
  icon: [
    576,
    512,
    [],
    'e37f',
    'M128 388.9c-27.6-33.2-45.1-75.1-47.7-121l50.1 26.7c-1.6 5.5-2.4 11.4-2.4 17.4l0 76.9zM36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6zm45 23.6C93.2 128.5 181.2 48 288 48s194.8 80.5 206.7 184.2L429.5 267c-11.6-11.7-27.7-19-45.5-19l-192 0c-17.8 0-33.9 7.2-45.5 19L81.3 232.2zm414.3 35.7c-2.6 45.9-20.1 87.8-47.7 121l0-76.9c0-6-.8-11.9-2.4-17.4l50.1-26.7zM170.4 207.4c4.8-5.7 26.7-23.4 61.6-23.4c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.4 0-85.4 25-98.4 40.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1zM176 312c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16l0 8-224 0 0-8zm0 40l224 0 0 32-224 0 0-32zm0 64l224 0c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24zM344 184c36.4 0 58.7 15.3 63 19.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-13.5-13.5-48.1-33.7-97-33.7c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faPickleball = {
  prefix: 'far',
  iconName: 'pickleball',
  icon: [
    576,
    512,
    [],
    'e435',
    'M284.3 61.9c18.8-18.7 49.2-18.7 68 0L465.9 175.2c14.8 14.8 17.9 36.9 9.3 54.7c15.7 4.4 30.4 11.1 43.8 19.8c16.6-35.5 10.3-79.1-19.1-108.4L386.3 28C348.8-9.4 287.9-9.4 250.4 28L92.5 185.5c-22.9 22.9-29.8 57.3-17.3 87.2l18.3 43.8c5 12 2.2 25.7-6.9 34.9L34.8 402.9c-25 24.9-25 65.4 0 90.4s65.6 25 90.7 0l52-51.8c9.1-9.1 22.9-11.8 34.8-7l42.5 17.4c11.4 4.7 23.4 6.6 35.2 5.8c-8-15.3-13.6-32.1-16.2-49.9c-.3-.1-.5-.2-.8-.3l-42.5-17.4c-29.9-12.2-64.2-5.4-87.1 17.4l-52 51.8c-6.3 6.2-16.4 6.2-22.7 0c-6.3-6.2-6.2-16.3 0-22.6l51.7-51.5c23-22.9 29.8-57.3 17.3-87.2l-18.3-43.8c-4.5-10.9-2.7-23.3 4.6-32.3l148.4 148c1.7-19 6.6-37 14.3-53.5L158 187.9l126.3-126zM560 384a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM368 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM464 304a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
  ],
};
const faStarSharpHalf = {
  prefix: 'far',
  iconName: 'star-sharp-half',
  icon: [
    576,
    512,
    [],
    'e28c',
    'M291.7 .3C303.4 2.1 312 12.2 312 24l0 352c0 7.4-3.4 14.4-9.3 18.9l-144 112c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176l158.5 0L265.1 16.7C268.7 5.4 280-1.5 291.7 .3zM264 178.6l-9.1 28.7c-3.2 10-12.4 16.7-22.9 16.7L126 224l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6 264 364.3l0-185.7z',
  ],
};
const faUsersSlash = {
  prefix: 'far',
  iconName: 'users-slash',
  icon: [
    640,
    512,
    [],
    'e073',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320l178.1 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM281.5 195.3c8.8-11.7 22.7-19.3 38.5-19.3c26.5 0 48 21.5 48 48c0 11.6-4.1 22.2-11 30.5l-75.5-59.2zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192l-15.2 0zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c10.5 0 19.5-6 23.9-14.8l-49.7-39.1c.7 1.9 1.2 3.9 1.8 5.9l-282.6 0c9.5-36.8 42.9-64 82.6-64l117.3 0c2.6 0 5.1 .1 7.6 .3L324.9 352l-63.6 0zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z',
  ],
};
const faClover = {
  prefix: 'far',
  iconName: 'clover',
  icon: [
    448,
    512,
    [],
    'e139',
    'M174.4 80c-14.4 0-26 11.7-26 26c0 6.6 1.7 13.2 5 18.9l35.6 63.2c5.3 9.4 3.7 21.1-3.9 28.8s-19.4 9.2-28.8 3.9L93 185.3c-5.8-3.3-12.3-5-18.9-5c-14.4 0-26 11.7-26 26l0 2.6c0 7.6 3 14.9 8.4 20.3l9.8 9.8c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-9.8 9.8C51 288.2 48 295.4 48 303l0 2.6c0 14.4 11.7 26 26 26c6.6 0 13.2-1.7 18.9-5l63.2-35.6c9.4-5.3 21.1-3.7 28.8 3.9s9.2 19.4 3.9 28.8L153.3 387c-3.3 5.8-5 12.3-5 18.9c0 14.4 11.7 26 26 26l2.6 0c7.6 0 14.9-3 20.3-8.4l9.8-9.8c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l9.8 9.8c5.4 5.4 12.7 8.4 20.3 8.4l2.6 0c14.4 0 26-11.7 26-26c0-6.6-1.7-13.2-5-18.9l-35.6-63.2c-5.3-9.4-3.7-21.1 3.9-28.8s19.4-9.2 28.8-3.9L355 326.7c5.8 3.3 12.3 5 18.9 5c14.4 0 26-11.7 26-26l0-2.6c0-7.6-3-14.9-8.4-20.3l-9.8-9.8c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l9.8-9.8c5.4-5.4 8.4-12.7 8.4-20.3l0-2.8c0-14.3-11.6-25.9-25.9-25.9c-6.7 0-13.3 1.7-19.1 5.1l-61.9 35.5c-9.3 5.3-21.1 3.8-28.7-3.7s-9.4-19.2-4.2-28.7l34.7-63.4c3.1-5.7 4.8-12.2 4.8-18.7c0-14.6-11.8-26.4-26.4-26.4L271 80c-7.6 0-14.9 3-20.3 8.4L241 98.2c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-9.8-9.8C191.8 83 184.6 80 177 80l-2.6 0zm173.3 26.4c0 11.1-2.1 22.1-6.3 32.4c10.3-4.2 21.4-6.4 32.7-6.4c40.8 0 73.9 33.1 73.9 73.9l0 2.8c0 17.1-5.7 33.7-16.1 47c10.4 13.4 16.1 29.9 16.1 47l0 2.6c0 40.9-33.2 74-74 74c-11.2 0-22.3-2.2-32.7-6.4c4.2 10.3 6.4 21.4 6.4 32.7c0 40.9-33.2 74-74 74l-2.6 0c-17.1 0-33.7-5.7-47-16.1c-13.4 10.4-29.9 16.1-47 16.1l-2.6 0c-40.9 0-74-33.2-74-74c0-11.2 2.2-22.3 6.4-32.7c-10.3 4.2-21.4 6.4-32.7 6.4c-40.9 0-74-33.2-74-74L0 303c0-17.1 5.7-33.7 16.1-47C5.7 242.6 0 226.1 0 209l0-2.6c0-40.9 33.2-74 74-74c11.2 0 22.3 2.2 32.7 6.4c-4.2-10.3-6.4-21.4-6.4-32.7c0-40.9 33.2-74 74-74l2.6 0c17.1 0 33.7 5.7 47 16.1C237.4 37.7 253.9 32 271 32l2.3 0c41.1 0 74.4 33.3 74.4 74.4z',
  ],
};
const faMeat = {
  prefix: 'far',
  iconName: 'meat',
  icon: [
    512,
    512,
    [127830],
    'f814',
    'M443.2 138.7c8.1 13.4 13.9 26.9 17.3 39.8c.5 1.9 .9 3.8 1.3 5.7c2.4 11.6 2.8 22.5 .9 32.1c-1.9 10.1-6.2 18.8-13 25.6l-.2 .2c-29 28.7-92.5 11.9-142-37.6C258 154.8 241.2 91.1 270.2 62.2c1.8-1.8 3.7-3.4 5.8-4.8c.7-.5 1.3-.9 2-1.3c3-1.9 6.3-3.5 9.8-4.7c.6-.2 1.2-.4 1.9-.6c32.7-10.1 82.4 8.5 122.8 48.9c12.4 12.4 22.8 25.7 30.8 39.1zM388.8 302.1C363 323.9 330.1 336 296 336l-88 0c-17.7 0-32-14.3-32-32l0-88c0-34.1 12.1-67 33.9-92.8c.8 5 1.9 9.9 3.1 14.6c9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zM212.6 384l83.4 0c50.9 0 99.8-20.2 135.8-56.2L483.5 276l.3-.3c23.7-23.7 29.9-54.3 27.8-82.5c-.7-9.4-2.3-18.5-4.6-27c-5.8-22-16.4-44.1-30.7-64.8c-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8l0 83.4c0 7.1-2.8 13.9-7.8 18.9c-10.3 10.3-26.9 9.7-40.7 5C73.4 321.1 66.8 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-6.8-1.1-13.4-3.2-19.5c-4.7-13.8-5.3-30.4 5-40.7c5-5 11.8-7.8 18.9-7.8zm175-204.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5z',
  ],
};
const faReply = {
  prefix: 'far',
  iconName: 'reply',
  icon: [
    512,
    512,
    [61714, 'mail-reply'],
    'f3e5',
    'M224 240l96 0c66.2 0 122 44.7 138.8 105.5c3.3-12.4 5.2-26.2 5.2-41.5c0-70.7-57.3-128-128-128l-112 0-24 0c-13.3 0-24-10.7-24-24l0-24 0-28.1L55.9 208 176 316.1l0-28.1 0-24c0-13.3 10.7-24 24-24l24 0zm0 48l0 48 0 16c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2l0 16 0 48 48 0 64 0c97.2 0 176 78.8 176 176c0 78-38.6 126.2-68.7 152.1c-4.1 3.5-8.1 6.6-11.7 9.3c-3.2 2.4-6.2 4.4-8.9 6.2c-4.5 3-8.3 5.1-10.8 6.5c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-6.8 3.6-13.2 8.3-18.1c.5-.5 .9-.9 1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6c1.7-2.3 3.4-5 5-7.9c5.3-9.7 9.5-22.9 9.5-40.2c0-53-43-96-96-96l-48 0-48 0z',
  ],
};
const faMailReply = faReply;
const faStarAndCrescent = {
  prefix: 'far',
  iconName: 'star-and-crescent',
  icon: [
    512,
    512,
    [9770],
    'f699',
    'M40 256c0 95.9 62.5 177.2 149 205.4C123.2 416.8 80 341.4 80 256s43.2-160.8 109-205.4C102.5 78.8 40 160.1 40 256zM256 0c22.2 0 43.7 2.8 64.2 8.1c2.6 .7 5.2 1.4 7.8 2.1c1.4 .4 2.8 .8 4.2 1.3c4.3 1.3 8.5 2.8 12.7 4.3c1.6 .6 3.1 1.2 4.7 1.8c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-1.7-.1-3.4-.2-5-.3c-3.2-.1-6.4-.2-9.6-.2c-.9 0-1.7 0-2.6 0c-3.2 0-6.5 .2-9.7 .3C206.6 54.7 120 145.2 120 256s86.6 201.3 195.7 207.6c3.2 .2 6.4 .3 9.7 .3c.9 0 1.7 0 2.6 0c3.2 0 6.4-.1 9.6-.2c1.7-.1 3.4-.2 5-.3c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4c-1.6 .6-3.1 1.2-4.7 1.8c-4.2 1.6-8.4 3-12.7 4.3c-1.4 .4-2.8 .8-4.2 1.3c-2.6 .8-5.2 1.5-7.8 2.1c-20.5 5.3-42 8.1-64.2 8.1C114.6 512 0 397.4 0 256S114.6 0 256 0zM357.2 174.2l1.7-3.4 10.9-22.2 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 10.9 22.2 1.7 3.4 13.3 27c1.4 2.8 4.1 4.8 7.2 5.3l29.8 4.3 3.7 .5 24.5 3.6 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-17.7 17.3-2.7 2.6-21.6 21c-2.3 2.2-3.3 5.4-2.8 8.5l5.1 29.7 .6 3.7 4.2 24.4 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-21.9-11.5-3.3-1.7-26.6-14c-2.8-1.5-6.1-1.5-8.9 0l-26.6 14-3.3 1.7-21.9 11.5-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 4.2-24.4 .6-3.7 5.1-29.7c.5-3.1-.5-6.3-2.8-8.5l-21.6-21-2.7-2.6-17.7-17.3-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 24.5-3.6 3.7-.5 29.8-4.3c3.1-.5 5.8-2.4 7.2-5.3l13.3-27zm-7.7 78.6a36.3 36.3 0 1 0 69 22.4 36.3 36.3 0 1 0 -69-22.4z',
  ],
};
const faEmptySet = {
  prefix: 'far',
  iconName: 'empty-set',
  icon: [
    512,
    512,
    [8709, 216],
    'f656',
    'M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5L505 41zM362.3 115.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z',
  ],
};
const faHouseFire = {
  prefix: 'far',
  iconName: 'house-fire',
  icon: [
    640,
    512,
    [],
    'e50c',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L447.9 128.2c-12.5-1.1-25.5 2.8-35.4 11.7c-4.1 3.6-8 7.3-12 11L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l77 0c-7.7 15.7-13.8 32-17.4 48L240 320l0 144 84.8 0c13.5 18.8 30.3 35.1 49.6 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faSquareMinus = {
  prefix: 'far',
  iconName: 'square-minus',
  icon: [
    448,
    512,
    [61767, 'minus-square'],
    'f146',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM152 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMinusSquare = faSquareMinus;
const faHelicopter = {
  prefix: 'far',
  iconName: 'helicopter',
  icon: [
    640,
    512,
    [128641],
    'f533',
    'M152 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l184 0 0 80-198.1 0L86.7 76.8C78.5 68.6 67.4 64 55.9 64C28.4 64 7.8 89.2 13.2 116.1l16.1 80.3c3.6 17.8 15.6 32.8 32.2 40.2l124.8 55.5 77.4 77.4c19.5 19.5 46 30.5 73.5 30.5L504 400c39.8 0 72-32.2 72-72l0-48c0-83.9-68.1-152-152-152l-40 0 0-80 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L152 0zM128 176l208 0 0 176c-14.4-.3-28.2-6.2-38.5-16.4L217 255c-2.1-2.1-4.5-3.8-7.2-5L80.9 192.8c-2.4-1.1-4.1-3.2-4.6-5.7L63.1 121 111 169c4.5 4.5 10.6 7 17 7zM504 352l-120 0 0-176 40 0c57.4 0 104 46.6 104 104l0 48c0 13.3-10.7 24-24 24zM631 474.7c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-26.9 21.5c-4.3 3.4-9.5 5.3-15 5.3L248 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l311.2 0c16.3 0 32.2-5.6 45-15.8L631 474.7z',
  ],
};
const faBird = {
  prefix: 'far',
  iconName: 'bird',
  icon: [
    512,
    512,
    [],
    'e469',
    'M48.7 208L192 208c44.2 0 80-35.8 80-80l0-16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80c0 97.2-78.8 176-176 176c-91.8 0-167.2-70.3-175.3-160zM0 188.4L0 192C0 294.3 68.5 380.5 162.1 407.4l48.6 91.9c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4L221 416c1 0 2 0 3 0c12.6 0 25-1 37.1-3.1l45.7 86.3c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4l-40.9-77.2C390.3 366.3 448 285.9 448 192l0-16.5 56.2-33.7c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7l-61.7-37C427.9 32.4 385.7 0 336 0C274.1 0 224 50.1 224 112l0 16c0 17.7-14.3 32-32 32L28.4 160C12.7 160 0 172.7 0 188.4zM336 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faCompass = {
  prefix: 'far',
  iconName: 'compass',
  icon: [
    512,
    512,
    [129517],
    'f14e',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faSquareCaretDown = {
  prefix: 'far',
  iconName: 'square-caret-down',
  icon: [
    448,
    512,
    ['caret-square-down'],
    'f150',
    'M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z',
  ],
};
const faCaretSquareDown = faSquareCaretDown;
const faHeartHalfStroke = {
  prefix: 'far',
  iconName: 'heart-half-stroke',
  icon: [
    512,
    512,
    ['heart-half-alt'],
    'e1ac',
    'M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4l0-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6c0 0 0 0 0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5l0 3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zM256 430.7L256 152c6.4 0 12.4-2.5 16.9-7c.4-.3 .7-.7 1-1.1l17.8-20c0 0 0 0 .1-.1s0 0 .1-.1c23.1-25.9 58-37.7 92-31.2c46.5 8.9 80.1 49.5 80.1 96.9l0 3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7z',
  ],
};
const faHeartHalfAlt = faHeartHalfStroke;
const faFileCircleQuestion = {
  prefix: 'far',
  iconName: 'file-circle-question',
  icon: [
    576,
    512,
    [],
    'e4ef',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z',
  ],
};
const faTruckUtensils = {
  prefix: 'far',
  iconName: 'truck-utensils',
  icon: [
    640,
    512,
    [],
    'e628',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 174.9l9.5-81.4c.7-5.9 5.6-10.3 11.6-10.3c6.2 0 11.3 4.8 11.6 11l4.4 75.5c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.8c.3-6 5.3-10.6 11.3-10.6s10.9 4.7 11.3 10.6l4.4 75.8c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.5c.4-6.2 5.5-11 11.6-11c5.9 0 10.9 4.4 11.6 10.3l9.5 81.4c0 29.4-20.5 54-48 60.3l0 36.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-36.8c-27.5-6.3-48-30.9-48-60.3zM272 304l0-64c-17.7 0-32-14.3-32-32l0-37c0-63.1 41.3-86 50.3-90.2c1.1-.5 2.3-.8 3.6-.8c5.6 0 10.1 4.5 10.1 10.1l0 37.9 0 112 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
  ],
};
const faLaptopCode = {
  prefix: 'far',
  iconName: 'laptop-code',
  icon: [
    640,
    512,
    [],
    'f5fc',
    'M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM281 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM393 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z',
  ],
};
const faJoystick = {
  prefix: 'far',
  iconName: 'joystick',
  icon: [
    448,
    512,
    [128377],
    'f8c5',
    'M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4l0 98.6 48 0 0-98.6zM96 320c-17.7 0-32 14.3-32 32c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-256 0c0-17.7-14.3-32-32-32zm0 80l288 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0z',
  ],
};
const faGrillFire = {
  prefix: 'far',
  iconName: 'grill-fire',
  icon: [
    576,
    512,
    [],
    'e5a4',
    'M48 80l0 16c0 97.2 78.8 176 176 176c7.3 0 14.5-.4 21.6-1.3c-8 16.2-14.3 32.8-18.1 49.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368l73 0c1.5 16.6 5.2 32.7 10.7 48L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-4.3-3.9-9.3-6.9-14.5-8.9C398.8 119.8 400 108 400 96l0-16L48 80zm72 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 96c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C560.5 268 576 320.2 576 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C389 327.1 352 363.6 352 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faRectangleVerticalHistory = {
  prefix: 'far',
  iconName: 'rectangle-vertical-history',
  icon: [
    576,
    512,
    [],
    'e237',
    'M256 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L256 48zM192 64c0-35.3 28.7-64 64-64L512 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-384zM96 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24L96 72zM0 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 120z',
  ],
};
const faSwatchbook = {
  prefix: 'far',
  iconName: 'swatchbook',
  icon: [
    512,
    512,
    [],
    'f5c3',
    'M0 400c0 61.9 50.1 112 112 112l336 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-62.1 0 50.7-50.7c25-25 25-65.5 0-90.5L365.3 75.3c-25-25-65.5-25-90.5 0L224 126.1 224 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 400zm448 64l-238.1 0 128-128L448 336c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16zM402.7 203.3L224 382.1l0-188.1 84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64l0-96 128 0 0 96c0 35.3-28.7 64-64 64zM48 256l0-80 128 0 0 80L48 256zm0-128l0-64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 64L48 128zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faPrescriptionBottle = {
  prefix: 'far',
  iconName: 'prescription-bottle',
  icon: [
    384,
    512,
    [],
    'f485',
    'M48 48l288 0 0 32L48 80l0-32zM40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l304 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-48 0 0 288c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-16-48 0z',
  ],
};
const faBars = {
  prefix: 'far',
  iconName: 'bars',
  icon: [
    448,
    512,
    ['navicon'],
    'f0c9',
    'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z',
  ],
};
const faNavicon = faBars;
const faKeyboardLeft = {
  prefix: 'far',
  iconName: 'keyboard-left',
  icon: [
    640,
    512,
    [],
    'e1c3',
    'M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l352 0zM224 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L224 64zm80 272l0 16c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm48-104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM248 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16-96c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm72 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm72 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM416 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM121 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 63-63z',
  ],
};
const faPeopleGroup = {
  prefix: 'far',
  iconName: 'people-group',
  icon: [
    640,
    512,
    [],
    'e533',
    'M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2L64 416c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-32 0 0-16 0-48 0-128 32 0c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160l-32 0zM64 229.7l0 84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208l32 0 0 128 0 48 0 16-32 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3l0-84.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2l0 58.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-58.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0zm0 224l0-48 0-128 32 0 0 128 0 48 0 32-32 0 0-32zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3l0 84.7zm128 0l0-84.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z',
  ],
};
const faHourglassEnd = {
  prefix: 'far',
  iconName: 'hourglass-end',
  icon: [
    384,
    512,
    [8987, 'hourglass-3'],
    'f253',
    'M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM273.5 140.5C293 121 304 94.6 304 67l0-19L80 48l0 19c0 27.6 11 54 30.5 73.5L192 222.1l81.5-81.5z',
  ],
};
const faHourglass3 = faHourglassEnd;
const faHeartCrack = {
  prefix: 'far',
  iconName: 'heart-crack',
  icon: [
    512,
    512,
    [128148, 'heart-broken'],
    'f7a9',
    'M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4l0-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6c0 0 0 0 0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5l0 3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zm6.6-331.1l-67.6 67.6c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-59.7-97L316 158.9c3.6-2.1 5-6.6 3.2-10.3l-16.6-35.1c22.4-18.5 52.2-26.4 81.3-20.9c46.5 8.9 80.1 49.5 80.1 96.9l0 3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7 80.8 268C59.9 248.6 48 221.3 48 192.8l0-3.3c0-47.3 33.6-88 80.1-96.9c34-6.5 69 5.4 92 31.2c0 0 0 0 0 0l.1 .1 9.6 10.8z',
  ],
};
const faHeartBroken = faHeartCrack;
const faFaceBeamHandOverMouth = {
  prefix: 'far',
  iconName: 'face-beam-hand-over-mouth',
  icon: [
    512,
    512,
    [129325],
    'e47c',
    'M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1l0 10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm-78.3 47.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faDropletPercent = {
  prefix: 'far',
  iconName: 'droplet-percent',
  icon: [
    384,
    512,
    ['humidity'],
    'f750',
    'M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-75.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faHumidity = faDropletPercent;
const faSquareUpRight = {
  prefix: 'far',
  iconName: 'square-up-right',
  icon: [
    448,
    512,
    [8599, 'external-link-square-alt'],
    'f360',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 313.4L320 176c0-8.8-7.2-16-16-16l-137.4 0c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z',
  ],
};
const faExternalLinkSquareAlt = faSquareUpRight;
const faFaceKissBeam = {
  prefix: 'far',
  iconName: 'face-kiss-beam',
  icon: [
    512,
    512,
    [128537, 'kiss-beam'],
    'f597',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faKissBeam = faFaceKissBeam;
const faCorn = {
  prefix: 'far',
  iconName: 'corn',
  icon: [
    512,
    512,
    [127805],
    'f6c7',
    'M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.4 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-19.9 0-37.7 9.1-49.4 23.4l3.6 3.6c11.8 11.8 21.9 25.1 30 39.5c0-.3 0-.7-.1-1c0-.5-.1-.9-.1-1.4c0-8.8 7.2-16 16-16c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c4.6 0 8.7 1.9 11.6 5c5.3 5.5 12.8 8.3 20.4 7.3s14.3-5.4 18-12.1c2.8-5 8-8.2 14-8.2c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.2 14c-6.7 3.7-11.2 10.4-12.1 18s1.8 15.2 7.3 20.4c3.1 2.9 5 7 5 11.6c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7-4.5 12.9-10.7 15.1c7.2 4.8 14.2 10.2 20.7 16.1L435.5 287c12.6-11.7 20.5-28.4 20.5-47c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.4 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.4 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM169 71c-6.1-6.1-15-8.5-23.4-6.2s-14.8 8.9-16.9 17.3l-21.9 87.4c-.4 1.4-1.1 2.7-2.1 3.7L41.9 236.1C15.1 263 0 299.4 0 337.4c0 36 13.6 70.7 38 97.1L66.1 465c27.6 30 66.6 47 107.3 47c38.7 0 75.9-15.4 103.3-42.8l62.9-62.9c.9-.9 1.9-1.5 3.1-1.9l88.8-29.6c8.1-2.7 14.2-9.5 15.9-17.9s-1.1-17-7.4-22.7l-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9 .6-26.8 1.8l0-44.7c0-40.3-16-79-44.5-107.5L169 71zm31 142l0 57.1c-25.9 10.2-49.7 25.7-69.8 45.7L60.9 385.2C52.5 370.8 48 354.3 48 337.4c0-25.3 10-49.5 27.9-67.3l62.8-62.8c7.2-7.2 12.3-16.2 14.7-26L165 134.9l4.5 4.5C189 159 200 185.4 200 213zM101.4 432.5l-9.6-10.3 72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8c37.7 0 74.1 13.6 102.5 38.3l-49.7 16.6c-8.2 2.7-15.7 7.4-21.9 13.5l-62.9 62.9c-18.4 18.4-43.3 28.7-69.3 28.7c-27.4 0-53.5-11.4-72.1-31.5z',
  ],
};
const faRollerCoaster = {
  prefix: 'far',
  iconName: 'roller-coaster',
  icon: [
    640,
    512,
    [],
    'e324',
    'M48 184c0-40.1 22.7-74.9 56-92.3L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-376 5.1 0c15 0 29.6 3.2 42.9 9.3L200 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-323.4 48 69.1L296 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-185.1 14.9 21.5c9.4 13.6 20.6 25.6 33.1 35.8L392 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-99.9c15.3 5.9 31.4 9.7 48 11.2l0 88.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-90.2c20.9-4 40-13 56-25.8L592 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 0-8c0-75.1-60.9-136-136-136l-8.1 0c-30.4 0-60.3 8.3-86.4 23.9L358 150.8l58 83.5 0-62.3 18.1-10.9c14.1-8.4 29.7-13.9 45.9-16L480 264c0 13.3 10.7 24 24 24s24-10.7 24-24l0-116.7c36.9 10.4 64 44.4 64 84.7l0 8c0 44.2-35.8 80-80 80l-8.5 0c-41.9 0-81.2-20.5-105.1-55L281.9 97.3C253.5 56.4 206.9 32 157.1 32L152 32C68.1 32 0 100.1 0 184L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272z',
  ],
};
const faPhotoFilmMusic = {
  prefix: 'far',
  iconName: 'photo-film-music',
  icon: [
    640,
    512,
    [],
    'e228',
    'M576 48L256 48c-8.8 0-16 7.2-16 16l0 192c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 200.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l30.5 46.7L406.3 195c-22.9 7.6-38.3 29-38.3 53.1l0 71.9-112 0c-35.3 0-64-28.7-64-64l0-192c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-6.3 2.1L592 64c0-8.8-7.2-16-16-16zM289.9 448L160 448l-24 0-24 0-48 0c-35.3 0-64-28.7-64-64L0 176c0-35.3 28.7-64 64-64l48 0 24 0 24 0 0 48 0 72 0 88 0 8 0 72 166.3 0c-2.3 1.4-4.6 3-6.7 4.6c-13.8 10.3-25.2 25.2-29.6 43.4zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208l0-48-48 0c-8.8 0-16 7.2-16 16l0 32 64 0zm0 144l-64 0 0 32c0 8.8 7.2 16 16 16l48 0 0-48zm0-48l0-48-64 0 0 48 64 0zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z',
  ],
};
const faRadar = {
  prefix: 'far',
  iconName: 'radar',
  icon: [
    512,
    512,
    [],
    'e024',
    'M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112s112-50.1 112-112l48 0c0 78.2-56.1 143.3-130.3 157.2c-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5c8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2l34.2-34.2C349.7 64.8 304.8 48 256 48C152.7 48 66.9 123.4 50.7 222.1C39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4c7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256l48 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z',
  ],
};
const faSickle = {
  prefix: 'far',
  iconName: 'sickle',
  icon: [
    512,
    512,
    [],
    'f822',
    'M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0c2.3 2.3 4.5 4.7 6.7 7.1c-16.4-6-34-9.3-52.5-9.3c-83.9 0-152 68.1-152 152c0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zM455.8 56.2c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5L207 350.6c9.4 9.4 24.6 9.4 33.9 0l37.1-37.1c7.3-7.3 9.1-18.4 4.6-27.6C275.8 272.1 272 256.5 272 240c0-57.4 46.6-104 104-104c38.7 0 72.5 21.1 90.5 52.6c5.6 9.8 17.3 14.4 28 11s17.7-13.8 16.7-25.1c-3.9-43.2-22.4-85.3-55.4-118.4zM121 311c-9.4-9.4-24.6-9.4-33.9 0L71 327c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l71-71 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z',
  ],
};
const faFilm = {
  prefix: 'far',
  iconName: 'film',
  icon: [
    512,
    512,
    [127902],
    'f008',
    'M352 432l-192 0 0-112 0-40 192 0 0 40 0 112zm0-200l-192 0 0-40 0-112 192 0 0 112 0 40zM64 80l48 0 0 88-64 0 0-72c0-8.8 7.2-16 16-16zM48 216l64 0 0 80-64 0 0-80zm64 216l-48 0c-8.8 0-16-7.2-16-16l0-72 64 0 0 88zM400 168l0-88 48 0c8.8 0 16 7.2 16 16l0 72-64 0zm0 48l64 0 0 80-64 0 0-80zm0 128l64 0 0 72c0 8.8-7.2 16-16 16l-48 0 0-88zM448 32L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64z',
  ],
};
const faCoconut = {
  prefix: 'far',
  iconName: 'coconut',
  icon: [
    512,
    512,
    [],
    'e2f6',
    'M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.9C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512C396 512 512 396 512 253c0-68.7-27.3-134.6-75.9-183.2L395.2 28.9zm27.4 98.5c23.7 32 37.9 70.2 40.9 110.1L457 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4L265 423c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9c12.1-1.5 24.2-4.3 36.3-8c50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3zM256 256c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z',
  ],
};
const faRulerHorizontal = {
  prefix: 'far',
  iconName: 'ruler-horizontal',
  icon: [
    640,
    512,
    [],
    'f547',
    'M48 320c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16 7.2-16 16l0 128zm16 64c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 384z',
  ],
};
const faShieldCross = {
  prefix: 'far',
  iconName: 'shield-cross',
  icon: [
    512,
    512,
    [9960],
    'f712',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48z',
  ],
};
const faCassetteTape = {
  prefix: 'far',
  iconName: 'cassette-tape',
  icon: [
    576,
    512,
    [128429],
    'f8ab',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-40 0-25.6-61.5c-8.7-20.9-29.1-34.5-51.7-34.5l-213.3 0c-22.6 0-43 13.6-51.7 34.5L104 432l-40 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM420 432l-264 0 17.9-43.1c1.2-3 4.2-4.9 7.4-4.9l213.3 0c3.2 0 6.1 1.9 7.4 4.9L420 432zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM176 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16c0-5.5-.7-10.9-2-16l100 0c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16l-100 0c1.3-5.1 2-10.5 2-16zm224 0c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l224 0c35.3 0 64-28.7 64-64zm-80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faSquareTerminal = {
  prefix: 'far',
  iconName: 'square-terminal',
  icon: [
    448,
    512,
    [],
    'e32a',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faPeopleRobbery = {
  prefix: 'far',
  iconName: 'people-robbery',
  icon: [
    576,
    512,
    [],
    'e536',
    'M504.5 53.3C493.1 101.7 449.8 136 400 136s-93.1-34.3-104.5-82.7l-8.2-34.8c-3-12.9-16-20.9-28.9-17.9s-20.9 16-17.9 28.9l8.2 34.8c11.3 48.1 44.3 86.5 87.2 106L336 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-317.8c42.9-19.4 75.9-57.8 87.2-105.9l8.2-34.8c3-12.9-5-25.8-17.9-28.9s-25.8 5-28.9 17.9l-8.2 34.8zM416 183.2L416 304l-32 0 0-120.8c5.3 .5 10.6 .8 16 .8s10.7-.3 16-.8zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM16 204.5L16 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0 0-99.5C64 188.8 76.8 176 92.5 176c9.4 0 18.1 4.6 23.4 12.3l56.3 81.4c4.5 6.5 11.9 10.3 19.7 10.3l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-35.4 0-49.2-71c-14.3-20.6-37.8-33-62.9-33C50.2 128 16 162.2 16 204.5z',
  ],
};
const faLightbulb = {
  prefix: 'far',
  iconName: 'lightbulb',
  icon: [
    384,
    512,
    [128161],
    'f0eb',
    'M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z',
  ],
};
const faCaretLeft = {
  prefix: 'far',
  iconName: 'caret-left',
  icon: [
    256,
    512,
    [],
    'f0d9',
    'M54.6 256L144 166.6l0 178.7L54.6 256zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z',
  ],
};
const faCommentMiddle = {
  prefix: 'far',
  iconName: 'comment-middle',
  icon: [
    512,
    512,
    [],
    'e149',
    'M231.3 387.2L256 436.7l24.7-49.5c6.5-12.9 18.4-22.3 32.5-25.4C407 341 464 274.7 464 208c0-79.5-83.3-160-208-160S48 128.5 48 208c0 66.7 57 133 150.7 153.8c14.1 3.1 26.1 12.5 32.5 25.4zm92.4 21.5l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z',
  ],
};
const faTrashCanList = {
  prefix: 'far',
  iconName: 'trash-can-list',
  icon: [
    640,
    512,
    [],
    'e2ab',
    'M161.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM338.2 80L301.5 24.9C291.1 9.4 273.6 0 254.9 0L161.1 0c-18.7 0-36.2 9.4-46.6 24.9L77.8 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l8 0 0 304c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80l0-304 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-45.8 0zM336 128l0 304c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-304 256 0zM160 176c-8.8 0-16 7.2-16 16l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-8.8-7.2-16-16-16zm216-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zM448 408c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faBlock = {
  prefix: 'far',
  iconName: 'block',
  icon: [
    448,
    512,
    [],
    'e46a',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faCircleExclamation = {
  prefix: 'far',
  iconName: 'circle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-circle'],
    'f06a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faExclamationCircle = faCircleExclamation;
const faSchoolCircleXmark = {
  prefix: 'far',
  iconName: 'school-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e56d',
    'M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z',
  ],
};
const faArrowRightFromBracket = {
  prefix: 'far',
  iconName: 'arrow-right-from-bracket',
  icon: [
    512,
    512,
    ['sign-out'],
    'f08b',
    'M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z',
  ],
};
const faSignOut = faArrowRightFromBracket;
const faFaceFrownSlight = {
  prefix: 'far',
  iconName: 'face-frown-slight',
  icon: [
    512,
    512,
    [],
    'e376',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM334.4 385.9C319.2 369.5 293.2 352 256 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4s91.7 25.5 113.6 49.4c9 9.7 8.4 24.9-1.4 33.9s-24.9 8.4-33.9-1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCircleChevronDown = {
  prefix: 'far',
  iconName: 'circle-chevron-down',
  icon: [
    512,
    512,
    ['chevron-circle-down'],
    'f13a',
    'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241L239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z',
  ],
};
const faChevronCircleDown = faCircleChevronDown;
const faSidebarFlip = {
  prefix: 'far',
  iconName: 'sidebar-flip',
  icon: [
    512,
    512,
    [],
    'e24f',
    'M288 80l0 352L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l224 0zM512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320zm-64 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0zm24 120c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z',
  ],
};
const faUnlockKeyhole = {
  prefix: 'far',
  iconName: 'unlock-keyhole',
  icon: [
    448,
    512,
    ['unlock-alt'],
    'f13e',
    'M224 48c-44.2 0-80 35.8-80 80l0 64 240 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0 0-64C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6c4.1 12.6-2.8 26.1-15.5 30.2s-26.1-2.8-30.2-15.5C289.8 71.2 259.6 48 224 48zM64 240c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240zM256 376l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faUnlockAlt = faUnlockKeyhole;
const faTemperatureList = {
  prefix: 'far',
  iconName: 'temperature-list',
  icon: [
    512,
    512,
    [],
    'e299',
    'M80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 146.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L344 32zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm32 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faCloudShowersHeavy = {
  prefix: 'far',
  iconName: 'cloud-showers-heavy',
  icon: [
    512,
    512,
    [],
    'f740',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm244.6 31.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zM313.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5z',
  ],
};
const faHeadphonesSimple = {
  prefix: 'far',
  iconName: 'headphones-simple',
  icon: [
    512,
    512,
    ['headphones-alt'],
    'f58f',
    'M256 80C141.1 80 48 173.1 48 288l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288C0 146.6 114.6 32 256 32s256 114.6 256 256l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-114.9-93.1-208-208-208zM160 432l0-112c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm0-160l16 0c17.7 0 32 14.3 32 32l0 144c0 17.7-14.3 32-32 32l-16 0c-44.2 0-80-35.8-80-80l0-48c0-44.2 35.8-80 80-80zm192 48l0 112c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32zm80 32l0 48c0 44.2-35.8 80-80 80l-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l16 0c44.2 0 80 35.8 80 80z',
  ],
};
const faHeadphonesAlt = faHeadphonesSimple;
const faSitemap = {
  prefix: 'far',
  iconName: 'sitemap',
  icon: [
    576,
    512,
    [],
    'f0e8',
    'M320 80l0 64-64 0 0-64 64 0zM256 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l8 0 0 40-152 0c-30.9 0-56 25.1-56 56l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-4.4 3.6-8 8-8l152 0 0 40-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-40 152 0c4.4 0 8 3.6 8 8l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-30.9-25.1-56-56-56l-152 0 0-40 8 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0zM48 368l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64z',
  ],
};
const faPipeSection = {
  prefix: 'far',
  iconName: 'pipe-section',
  icon: [
    640,
    512,
    [],
    'e438',
    'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120l0 32L0 360l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 544 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-208 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-272 0L48 128l0-8zm0 56l272 0 272 0 0 160L48 336l0-160z',
  ],
};
const faSpaceStationMoonConstruction = {
  prefix: 'far',
  iconName: 'space-station-moon-construction',
  icon: [
    512,
    512,
    ['space-station-moon-alt'],
    'e034',
    'M208.2 53.5C223.5 49.9 239.5 48 256 48c54.9 0 104.8 21.2 142 56l-30 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l81.5 0c8.8 0 17-4.9 21.1-12.6s3.7-17.2-1.1-24.6C423.7 45.6 345.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c81.4 0 153.9-38 200.7-97.1c8.2-10.4 6.5-25.5-3.9-33.7s-25.5-6.5-33.7 3.9C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3C109.9 362.7 168.9 376 256 376c116.9 0 183.2-23.9 218.9-36.8c0 0 0 0 0 0c4.8-1.7 9-3.2 12.7-4.5c7.5-2.5 13.3-8.6 15.5-16.2l.6-2.1c5.5-19.3 8.3-39.3 8.3-59.3l0-1.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.1c0 12.3-1.3 24.5-4 36.5l-.8 .3C424.3 306.5 364.4 328 256 328s-168.3-21.5-203.2-34.1l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9c.6 52.5 43.3 94.9 96 94.9c53 0 96-43 96-96c0-41.7-26.6-77.2-63.8-90.5zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm248 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z',
  ],
};
const faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
const faCircleDollarToSlot = {
  prefix: 'far',
  iconName: 'circle-dollar-to-slot',
  icon: [
    512,
    512,
    ['donate'],
    'f4b9',
    'M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.6-64-64-64c-13.6 18.2-29.8 34.3-48 48l48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0c-18.2-13.7-34.3-29.8-48-48zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
  ],
};
const faDonate = faCircleDollarToSlot;
const faMemory = {
  prefix: 'far',
  iconName: 'memory',
  icon: [
    576,
    512,
    [],
    'f538',
    'M64 112l448 0c8.8 0 16 7.2 16 16l0 8.4c-19.6 17.5-32 43.1-32 71.6s12.4 54 32 71.6l0 24.4L48 304l0-24.4C67.6 262 80 236.5 80 208s-12.4-54-32-71.6l0-8.4c0-8.8 7.2-16 16-16zM528 352l0 48-56 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-56 0 0-48 480 0zM64 64C28.7 64 0 92.7 0 128l0 23.4c0 6.8 4.4 12.6 10.1 16.3C23.3 176.3 32 191.1 32 208s-8.7 31.7-21.9 40.3C4.4 252 0 257.8 0 264.6L0 416c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-151.4c0-6.8-4.4-12.6-10.1-16.3C552.7 239.7 544 224.9 544 208s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-23.4c0-35.3-28.7-64-64-64L64 64zm104 80c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z',
  ],
};
const faFaceSleeping = {
  prefix: 'far',
  iconName: 'face-sleeping',
  icon: [
    512,
    512,
    [],
    'e38d',
    'M48 256C48 141.1 141.1 48 256 48c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C329.6 8.2 293.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9c-5.5-12.1-19.7-17.4-31.8-11.9s-17.4 19.7-11.9 31.8C457.3 196.1 464 225.3 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm64-296l25.4 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16l25.4 0L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0L432 0c-8.8 0-16 7.2-16 16zM351.6 252c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7z',
  ],
};
const faRoadSpikes = {
  prefix: 'far',
  iconName: 'road-spikes',
  icon: [
    640,
    512,
    [],
    'e568',
    'M192 352l-80 0-48 0 0-48 0-153.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L112 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L240 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L368 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L496 136 606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7L512 352l-16 0-41.7 0-6.3 0-64 0-16 0-41.7 0-6.3 0-64 0-16 0-41.7 0-6.3 0zm-25.7-48L112 222.5l0 81.5 54.3 0zM0 424c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24zM240 222.5l0 81.5 54.3 0L240 222.5zM422.3 304L368 222.5l0 81.5 54.3 0zM496 222.5l0 81.5 54.3 0L496 222.5z',
  ],
};
const faFireBurner = {
  prefix: 'far',
  iconName: 'fire-burner',
  icon: [
    640,
    512,
    [],
    'e4f1',
    'M345.7 48.3L358 34.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2C480 280.8 408.7 352 320 352c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2C273.4 2.3 280.7-.2 288 0c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM384 240.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 280c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 80 480 0 0-80-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 104c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-104zM48 464l116.3 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16L48 432l0 32zm176-16c0 5.8-1.6 11.3-4.3 16l72.6 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16l-72.6 0c2.7 4.7 4.3 10.2 4.3 16zm128 0c0 5.8-1.6 11.3-4.3 16l72.6 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16l-72.6 0c2.7 4.7 4.3 10.2 4.3 16zm240 16l0-32-116.3 0c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16L592 464z',
  ],
};
const faSquirrel = {
  prefix: 'far',
  iconName: 'squirrel',
  icon: [
    512,
    512,
    [],
    'f71a',
    'M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7c22.4 0 40 19.2 38 41.5l-.7 7.7c-1 11-5.9 20.4-12 27.3c-13.1 14.9-21.1 34.4-21.1 55.8c0 39.1 26.6 72 62.8 81.5c-14.3-20-22.8-44.4-22.8-70.9c0-25 7.7-49.3 22-69.8l35-49.9C284.8 219.5 304 158.5 304 96l0-20.8C304 69 309 64 315.2 64c15.2 0 28.7 7.6 36.8 19.2C360.1 71.6 373.6 64 388.8 64C395 64 400 69 400 75.2L400 96l7.6 0c53.4 0 98.2 40.5 103.5 93.7l.8 8c.5 4.5-.4 9.1-2.4 13.1l-4.1 8.2c-14.4 28.8-42 48.1-73.4 52.3l0 54.8c24.3 19 40 48.7 40 82c0 20.6-6 39.8-16.3 56l33.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L368 512l-16 0-38.3 0-77.4 0c-73 0-132.3-59.2-132.3-132.3c0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7C0 66.1 66.1 0 147.7 0C207.3 0 258.6 35.3 282 86c5.5 12 .3 26.3-11.8 31.8s-26.3 .3-31.8-11.8c-15.8-34.3-50.5-58-90.6-58zM352 464l16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5 .9-16.8 2.6c-12.6 4-26.1-3.1-30.1-15.7s3.1-26.1 15.7-30.1c9.9-3.1 20.4-4.8 31.2-4.8c5.4 0 10.8 .4 16 1.2l0-57.2c0-13.3 10.7-24 24-24l11.5 0c18.2 0 34.8-10.3 42.9-26.5l1-2-.1-1.1c-2.9-28.6-27-50.4-55.7-50.4l-7.6 0-48 0-3.3 0c-7.6 55.2-28.2 108.1-60.4 154.2l-35 49.9c-8.7 12.4-13.3 27.1-13.3 42.2c0 40.7 33 73.7 73.7 73.7l38.3 0zm32-288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faArrowUpToLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-line',
  icon: [
    384,
    512,
    ['arrow-to-top'],
    'f341',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM209.5 167.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 244.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z',
  ],
};
const faArrowToTop = faArrowUpToLine;
const faFlag = {
  prefix: 'far',
  iconName: 'flag',
  icon: [
    448,
    512,
    [127988, 61725],
    'f024',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z',
  ],
};
const faFaceCowboyHat = {
  prefix: 'far',
  iconName: 'face-cowboy-hat',
  icon: [
    512,
    512,
    [],
    'e36e',
    'M216 0c-36.8 0-67.4 64.9-82.4 109.8C100 99.3 70 84.6 45.1 66.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7C50.8 163.2 144.5 224 256 224s205.2-60.8 232.2-143.3C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8C442 84.6 412 99.3 378.4 109.8C363.4 64.9 332.8 0 296 0c-9.1 0-17.9 4-26.1 10.7c-7.9 6.5-19.8 6.5-27.7 0C233.9 4 225.1 0 216 0zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-12.8 9.3-26.6 17.5-41.2 24.6c13.4 23.4 21 50.5 21 79.3c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3c-14.6-7.1-28.4-15.4-41.2-24.6zM366.4 367.5c5.7-11.5-6.2-22.2-18.6-18.8c-27.9 7.8-59 12.2-91.6 12.2s-63.7-4.3-91.6-12.2c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 408.1 208 436 256.2 436s90-27.9 110.2-68.6zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faHanukiah = {
  prefix: 'far',
  iconName: 'hanukiah',
  icon: [
    640,
    512,
    [128334],
    'f6e6',
    'M296 56c0-19.4 13.1-43.9 18.2-52.7C315.4 1.2 317.6 0 320 0s4.6 1.2 5.8 3.3C330.9 12.1 344 36.6 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 104C0 84.6 13.1 60.1 18.2 51.3C19.4 49.2 21.6 48 24 48s4.6 1.2 5.8 3.3C34.9 60.1 48 84.6 48 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM106.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C122.9 60.1 136 84.6 136 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM152 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C186.9 60.1 200 84.6 200 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C250.9 60.1 264 84.6 264 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM376 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C410.9 60.1 424 84.6 424 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C474.9 60.1 488 84.6 488 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM504 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C538.9 60.1 552 84.6 552 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM610.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C626.9 60.1 640 84.6 640 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM320 112c13.3 0 24 10.7 24 24l0 200 208 0c22.1 0 40-17.9 40-40l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 48.6-39.4 88-88 88l-208 0 0 80 152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l152 0 0-80L88 384c-48.6 0-88-39.4-88-88L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 22.1 17.9 40 40 40l208 0 0-200c0-13.3 10.7-24 24-24zM112 160c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16z',
  ],
};
const faChartScatter3d = {
  prefix: 'far',
  iconName: 'chart-scatter-3d',
  icon: [
    512,
    512,
    [],
    'e0e8',
    'M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 220.8L40.6 437.6c-10.1 8.5-11.5 23.7-2.9 33.8s23.7 11.5 33.8 2.9L256 319.3l184.6 155c10.2 8.5 25.3 7.2 33.8-2.9s7.2-25.3-2.9-33.8L280 276.8 280 56zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faDisplayChartUp = {
  prefix: 'far',
  iconName: 'display-chart-up',
  icon: [
    576,
    512,
    [],
    'e5e3',
    'M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM376 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0z',
  ],
};
const faSquareCode = {
  prefix: 'far',
  iconName: 'square-code',
  icon: [
    448,
    512,
    [],
    'e267',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM255 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM193 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L95 239c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z',
  ],
};
const faFeather = {
  prefix: 'far',
  iconName: 'feather',
  icon: [
    512,
    512,
    [129718],
    'f52d',
    'M311.9 166.1L112 366.1l0-36c0-55.2 21.9-108.1 60.9-147.1L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3c0 16.8-4 33.3-11.4 48l-114.6 0 7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm-22 89.9l122.2 0-48 48-122.2 0 48-48zm24.9 96c-37.2 30.9-84.2 48-132.9 48l-36 0 48-48 120.9 0zM64 330l0 84L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 84 0c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z',
  ],
};
const faVolumeLow = {
  prefix: 'far',
  iconName: 'volume-low',
  icon: [
    448,
    512,
    [128264, 'volume-down'],
    'f027',
    'M159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM412.6 181.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5z',
  ],
};
const faVolumeDown = faVolumeLow;
const faXmarkToSlot = {
  prefix: 'far',
  iconName: 'xmark-to-slot',
  icon: [
    576,
    512,
    ['times-to-slot', 'vote-nay'],
    'f771',
    'M144 80l0 280 288 0 0-280L144 80zM96 360L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 280c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-288 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288l0 48-16 0 0 96 480 0 0-96-16 0 0-48 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0zM207 135c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faTimesToSlot = faXmarkToSlot;
const faVoteNay = faXmarkToSlot;
const faBoxTaped = {
  prefix: 'far',
  iconName: 'box-taped',
  icon: [
    448,
    512,
    ['box-alt'],
    'f49a',
    'M261.3 80l81.1 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 288 160 261.3 80zm-74.7 0L160 160 59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5l81.1 0zM160 208l0 48c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-48 112 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208 112 0zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70z',
  ],
};
const faBoxAlt = faBoxTaped;
const faCommentSlash = {
  prefix: 'far',
  iconName: 'comment-slash',
  icon: [
    640,
    512,
    [],
    'f4b3',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM184.2 119C219.3 95.2 265.7 80 320 80c124.7 0 208 80.5 208 160c0 38.4-19.4 77-53.5 106.6L184.2 119zM424.1 430.1l-46-36.3c-18.1 4-37.5 6.2-58 6.2c-31.6 0-61.3-5.5-87.8-15.1c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C124.4 302.8 112 272 112 240c0-16.2 3.4-32.4 10-47.9l-39-30.8C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z',
  ],
};
const faSwords = {
  prefix: 'far',
  iconName: 'swords',
  icon: [
    512,
    512,
    [9876],
    'f71d',
    'M347.3 199.4l33.9 33.9L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l33.9 33.9L422.4 54.8l38.2-3.5-3.5 38.2L347.3 199.4zM233.4 381.3l-33.9-33.9-42.7 42.7-34.7-34.7 42.7-42.7-33.9-33.9L88 321.4 75.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62L4.7 460.7c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6L190.6 424l42.7-42.7zM54.8 89.6L51.3 51.3l38.2 3.5L367.4 332.7l33.9-33.9L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L298.7 401.4l33.9-33.9L54.8 89.6zM459.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16z',
  ],
};
const faCloudSunRain = {
  prefix: 'far',
  iconName: 'cloud-sun-rain',
  icon: [
    640,
    512,
    [127782],
    'f743',
    'M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zM320.1 192c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z',
  ],
};
const faAlbum = {
  prefix: 'far',
  iconName: 'album',
  icon: [
    448,
    512,
    [128189],
    'f89f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM80 256a144 144 0 1 1 288 0A144 144 0 1 1 80 256zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCircleN = {
  prefix: 'far',
  iconName: 'circle-n',
  icon: [
    512,
    512,
    [],
    'e118',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3c-6-8.6-16.9-12.4-26.9-9.2s-16.8 12.4-16.8 22.9l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-131.2L308.3 373.7c6 8.6 16.9 12.4 26.9 9.2s16.8-12.4 16.8-22.9l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 131.2L203.7 138.3z',
  ],
};
const faCompress = {
  prefix: 'far',
  iconName: 'compress',
  icon: [
    448,
    512,
    [],
    'f066',
    'M160 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112zM24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L24 320zM336 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-88zM312 320c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faWheatAwn = {
  prefix: 'far',
  iconName: 'wheat-awn',
  icon: [
    512,
    512,
    ['wheat-alt'],
    'e2cd',
    'M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm135.7-22.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm79.2-79.2c25 25 65.5 25 90.5 0C381.2 223 339 219.7 307.9 240.2l10.1 10.1z',
  ],
};
const faWheatAlt = faWheatAwn;
const faAnkh = {
  prefix: 'far',
  iconName: 'ankh',
  icon: [
    320,
    512,
    [9765],
    'f644',
    'M80 128c0 42.3 22.6 78.9 50.5 107.6c10.3 10.6 20.6 19.4 29.5 26.3c8.9-6.9 19.3-15.7 29.5-26.3C217.4 206.9 240 170.3 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM98.9 272C66 238.9 32 189.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 61.8-34 110.9-66.9 144l74.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168L24 320c-13.3 0-24-10.7-24-24s10.7-24 24-24l74.9 0z',
  ],
};
const faHandsHoldingChild = {
  prefix: 'far',
  iconName: 'hands-holding-child',
  icon: [
    640,
    512,
    [],
    'e4fa',
    'M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm44.7 84.3L384.5 181c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-27.9-23.6C368.7 104.8 344.7 96 320 96s-48.7 8.8-67.6 24.7l-27.9 23.6c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l19.8-16.7L264.2 253c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l4.4-35 7.6 0 4.4 35c1.6 13.2 13.6 22.5 26.8 20.8s22.5-13.6 20.8-26.8l-11.1-88.8zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z',
  ],
};
const faAsterisk = {
  prefix: 'far',
  iconName: 'asterisk',
  icon: [
    384,
    512,
    [10033, 61545],
    '2a',
    'M192 32c13.3 0 24 10.7 24 24l0 156.9 131.4-81.3c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L237.6 256l135 83.6c11.3 7 14.7 21.8 7.8 33s-21.8 14.7-33 7.8L216 299.1 216 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-156.9L36.6 380.4c-11.3 7-26.1 3.5-33-7.8s-3.5-26.1 7.8-33l135-83.6-135-83.6c-11.3-7-14.8-21.8-7.8-33s21.8-14.8 33-7.8L168 212.9 168 56c0-13.3 10.7-24 24-24z',
  ],
};
const faKeySkeletonLeftRight = {
  prefix: 'far',
  iconName: 'key-skeleton-left-right',
  icon: [
    640,
    512,
    [],
    'e3b4',
    'M592 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm48 0c0 70.7-57.3 128-128 128c-62.5 0-114.5-44.8-125.8-104L304 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-13.3 10.7-24 24-24l202.2 0C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128zM48 384a80 80 0 1 0 160 0A80 80 0 1 0 48 384zM0 384c0-70.7 57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l82.2 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48 48 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72c0 13.3-10.7 24-24 24l-202.2 0C242.5 467.2 190.5 512 128 512C57.3 512 0 454.7 0 384z',
  ],
};
const faCommentLines = {
  prefix: 'far',
  iconName: 'comment-lines',
  icon: [
    512,
    512,
    [],
    'f4b0',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faLuchadorMask = {
  prefix: 'far',
  iconName: 'luchador-mask',
  icon: [
    448,
    512,
    ['luchador', 'mask-luchador'],
    'f455',
    'M288 464l-128 0C98.1 464 48 413.9 48 352l0-128c0-97.2 78.8-176 176-176s176 78.8 176 176l0 128c0 61.9-50.1 112-112 112zM224 0C100.3 0 0 100.3 0 224L0 352c0 88.4 71.6 160 160 160l128 0c88.4 0 160-71.6 160-160l0-128C448 100.3 347.7 0 224 0zM160 352l35.3 0 57.4 0 35.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7l13.3 0c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48l-32 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-32 0c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80l13.3 0c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3l-11.3 0-6 0-.6 0-21.5 0-.6 0-6 0-11.3 0zM96 208c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16l-32 0c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48l32 0z',
  ],
};
const faLuchador = faLuchadorMask;
const faMaskLuchador = faLuchadorMask;
const faSquareCheck = {
  prefix: 'far',
  iconName: 'square-check',
  icon: [
    448,
    512,
    [9745, 9989, 61510, 'check-square'],
    'f14a',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faCheckSquare = faSquareCheck;
const faShredder = {
  prefix: 'far',
  iconName: 'shredder',
  icon: [
    512,
    512,
    [],
    'f68a',
    'M112 192l0-128c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3L400 192l-288 0zM64 64l0 128c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64l0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64zM448 240c8.8 0 16 7.2 16 16l0 80L48 336l0-80c0-8.8 7.2-16 16-16l384 0zM40 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72z',
  ],
};
const faBookOpenCover = {
  prefix: 'far',
  iconName: 'book-open-cover',
  icon: [
    640,
    512,
    ['book-open-alt'],
    'e0c0',
    'M512 337.2l0-284.8L344 77l0 296 168-35.8zM296 373l0-296L128 52.4l0 284.8L296 373zM523.4 2.2C542.7-.7 560 14.3 560 33.8l0 316.3c0 15.1-10.6 28.1-25.3 31.3l-201.3 43c-8.8 1.9-17.9 1.9-26.7 0l-201.3-43C90.6 378.3 80 365.2 80 350.1L80 33.8C80 14.3 97.3-.7 116.6 2.2L320 32 523.4 2.2zM38.3 23.7l10.2 2c-.3 2.7-.5 5.4-.5 8.1l0 40.7 0 267.6 0 66.7 265.8 54.5c2 .4 4.1 .6 6.2 .6s4.2-.2 6.2-.6L592 408.8l0-66.7 0-267.6 0-40.7c0-2.8-.2-5.5-.5-8.1l10.2-2C621.5 19.7 640 34.8 640 55l0 366.9c0 15.2-10.7 28.3-25.6 31.3L335.8 510.4c-5.2 1.1-10.5 1.6-15.8 1.6s-10.6-.5-15.8-1.6L25.6 453.2C10.7 450.2 0 437.1 0 421.9L0 55C0 34.8 18.5 19.7 38.3 23.7z',
  ],
};
const faBookOpenAlt = faBookOpenCover;
const faSandwich = {
  prefix: 'far',
  iconName: 'sandwich',
  icon: [
    512,
    512,
    [129386],
    'f81f',
    'M48 112l416 0 0 32L48 144l0-32zM32 64C14.3 64 0 78.3 0 96l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 64zM48 368l416 0 0 32L48 400l0-32zM32 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 320zm-8-24c11.8 0 23.1-2.9 33.1-6.3c8.8-3 17.8-6.8 26.1-10.3c0 0 0 0 0 0l3.1-1.3c19.6-8.3 35.3-14.1 49.7-14.1c18.2 0 30.9 5.7 48.7 13.8C202.6 286 224.7 296 256 296s53.4-10 71.3-18.2c17.8-8.1 30.5-13.8 48.7-13.8c14.4 0 30.1 5.9 49.7 14.1l3.1 1.3s0 0 0 0c8.3 3.5 17.3 7.3 26.1 10.3c9.9 3.4 21.3 6.3 33.1 6.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-4.2 0-9.9-1.1-17.7-3.7c-7-2.4-14.3-5.5-22.8-9.1c0 0 0 0 0 0l-3.1-1.3C425.9 226.1 401.6 216 376 216c-28.8 0-49.9 9.6-66.9 17.4l-1.7 .8C290.1 242 276.2 248 256 248s-34.1-6-51.4-13.8l-1.7-.8c-17-7.8-38.1-17.4-66.9-17.4c-25.6 0-49.9 10.1-68.3 17.9l-3.2 1.3s0 0 0 0c-8.5 3.6-15.9 6.7-22.8 9.1C33.9 246.9 28.2 248 24 248c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faPesetaSign = {
  prefix: 'far',
  iconName: 'peseta-sign',
  icon: [
    384,
    512,
    [],
    'e221',
    'M93.9 32C68.6 32 48 52.6 48 77.9L48 176l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 104 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 96 0c77.4 0 142-55 156.8-128l11.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8.8 0C343.2 95.1 275 32 192 32L93.9 32zM302.9 176L96 176l0-96 96 0c56.4 0 103.1 41.7 110.9 96zM96 224l203.4 0c-13.8 46.3-56.6 80-107.4 80l-96 0 0-80z',
  ],
};
const faSquareParkingSlash = {
  prefix: 'far',
  iconName: 'square-parking-slash',
  icon: [
    640,
    512,
    ['parking-slash'],
    'f617',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9l320 0c8.8 0 16 7.2 16 16l0 267.5L408.6 295c19.3-17.6 31.4-42.9 31.4-71c0-53-43-96-96-96l-80 0c-16.5 0-30.2 12.6-31.8 28.7L145.7 88.9zM369.8 264.5L280 194.2l0-18.2 64 0c26.5 0 48 21.5 48 48c0 17-8.9 32-22.2 40.5zM426.5 432L160 432c-8.8 0-16-7.2-16-16l0-206.5L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4L426.5 432zM232 278.8l0 17.2 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-32 0-3.4-48-37.8z',
  ],
};
const faParkingSlash = faSquareParkingSlash;
const faTrainTunnel = {
  prefix: 'far',
  iconName: 'train-tunnel',
  icon: [
    512,
    512,
    [],
    'e454',
    'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232C512 114.6 397.4 0 256 0S0 114.6 0 256L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232zm304-48l0 48-192 0 0-48c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32zM160 368l0-64 192 0 0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32zm32-240c-44.2 0-80 35.8-80 80l0 160c0 27.7 14.1 52.2 35.5 66.5L111 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 108.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-36.5-36.5C385.9 420.2 400 395.7 400 368l0-160c0-44.2-35.8-80-80-80l-128 0zm96 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faHeading = {
  prefix: 'far',
  iconName: 'heading',
  icon: [
    448,
    512,
    ['header'],
    'f1dc',
    'M0 56C0 42.7 10.7 32 24 32l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 144 240 0 0-144-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 168 0 184 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-160-240 0 0 160 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-184L56 80 24 80C10.7 80 0 69.3 0 56z',
  ],
};
const faHeader = faHeading;
const faGhost = {
  prefix: 'far',
  iconName: 'ghost',
  icon: [
    384,
    512,
    [128123],
    'f6e2',
    'M48 192l0 223.5c26.3-4.9 54.6 3.7 73.6 25.5l6.4 7.3 3.8-4.3c31.9-36.4 88.5-36.4 120.4 0l3.8 4.3 6.4-7.3c19.1-21.8 47.3-30.4 73.6-25.5L336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zM256 512c-5.1 0-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L85.5 472.5c-11.6-13.3-32.1-14-44.5-1.5l-2.3 2.3c-4.2 4.2-10 6.6-16 6.6C10.1 480 0 469.9 0 457.4L0 192C0 86 86 0 192 0S384 86 384 192l0 265.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6l-2.3-2.3c-12.5-12.5-32.9-11.8-44.5 1.5L269.3 506c-3.3 3.8-8.2 6-13.3 6zM96 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faFaceAnguished = {
  prefix: 'far',
  iconName: 'face-anguished',
  icon: [
    512,
    512,
    [],
    'e369',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
  ],
};
const faHockeySticks = {
  prefix: 'far',
  iconName: 'hockey-sticks',
  icon: [
    640,
    512,
    [],
    'f454',
    'M173.3 13L302 261.7 288.4 288l-26.9 0L130.7 35C124.6 23.3 129.2 8.8 141 2.7s26.3-1.5 32.3 10.3zM373.1 368l24.8-48L576 320c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-154.8 0c-26.9 0-51.6-15-64-38.9L338 435.9l27-52.2L399.9 451c4.1 8 12.3 13 21.3 13l74.8 0 0-96-122.9 0zM544 368l0 96 32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l240 0c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368l-139 0 0 96 74.8 0c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0 0-96-32 0z',
  ],
};
const faAbacus = {
  prefix: 'far',
  iconName: 'abacus',
  icon: [
    576,
    512,
    [129518],
    'f640',
    'M512 80c8.8 0 16 7.2 16 16l0 112-80 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 64 0zm-96 48l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-128 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 128 0 0 48zm-160 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-96 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 96 0 0 48zm-128 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-80 0L48 96c0-8.8 7.2-16 16-16l64 0 0 48zM48 416l0-176 80 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-64 0c-8.8 0-16-7.2-16-16zm112-32l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 96 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-96 0 0-48zm128-72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 128 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-128 0 0-48 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24zm160 72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 80 0 0 176c0 8.8-7.2 16-16 16l-64 0 0-48zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faFilmSimple = {
  prefix: 'far',
  iconName: 'film-simple',
  icon: [
    512,
    512,
    ['film-alt'],
    'f3a0',
    'M160 432l192 0 0-112 0-128 0-112L160 80l0 112 0 128 0 112zM112 80L64 80c-8.8 0-16 7.2-16 16l0 72 64 0 0-88zm0 136l-64 0 0 80 64 0 0-80zm0 128l-64 0 0 72c0 8.8 7.2 16 16 16l48 0 0-88zM400 80l0 88 64 0 0-72c0-8.8-7.2-16-16-16l-48 0zm64 136l-64 0 0 80 64 0 0-80zm0 128l-64 0 0 88 48 0c8.8 0 16-7.2 16-16l0-72zM64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z',
  ],
};
const faFilmAlt = faFilmSimple;
const faList = {
  prefix: 'far',
  iconName: 'list',
  icon: [
    512,
    512,
    ['list-squares'],
    'f03a',
    'M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
  ],
};
const faListSquares = faList;
const faTreePalm = {
  prefix: 'far',
  iconName: 'tree-palm',
  icon: [
    576,
    512,
    [127796],
    'f82b',
    'M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L236 219.3c2.3 9.3 4.3 20.3 5.6 32.9c4.9 46.6 .5 115.1-26.4 208.3c-7.3 25.3 11.3 51.5 38.5 51.5l84.1 0c20 0 37.6-15 39.6-35.7c9.2-95.5-5.9-202-34.3-284.3l103.5 0c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9l46.7 0c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128l46.7 0c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0zM292 192c28.6 74.1 46 177.9 38.3 272l-66.2 0c25.8-92.9 30.7-164.5 25.2-216.8c-2.2-21.5-6.2-39.9-11.4-55.2l14.1 0z',
  ],
};
const faSquarePhoneFlip = {
  prefix: 'far',
  iconName: 'square-phone-flip',
  icon: [
    448,
    512,
    ['phone-square-alt'],
    'f87b',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM293.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z',
  ],
};
const faPhoneSquareAlt = faSquarePhoneFlip;
const faUserBeardBolt = {
  prefix: 'far',
  iconName: 'user-beard-bolt',
  icon: [
    576,
    512,
    [],
    'e689',
    'M198.9 0L224 0l25.1 0C305.9 0 352 46.1 352 102.9c0 6 1 12 3.1 17.6l25.2 69.3c2.4 6.7 3.7 13.8 3.7 21c0 24.6-14.6 46-35.7 55.7c2.4 6.7 3.7 14 3.7 21.5c0 15.2-5.3 29.3-14.2 40.2C326 342.7 308.1 352 288 352c-6.3 0-12.4-.9-18.2-2.6c-.8-.2-1.6-.5-2.4-.8c-3.4 7.1-8.4 13.2-14.7 17.9c-.7 .5-1.4 1-2.2 1.5c-7.6 5.1-16.7 8-26.5 8s-18.9-2.9-26.5-8c-7.2-4.8-13.1-11.5-16.8-19.4c-6.5 2.2-13.4 3.4-20.6 3.4c-19.9 0-37.6-9.1-49.4-23.3l-.4-.5c-8.9-11-14.2-25-14.2-40.2c0-7.5 1.3-14.8 3.7-21.5c-21.1-9.7-35.7-31-35.7-55.7c0-7.1 1.2-14.3 3.7-21l25.2-69.3c2-5.6 3.1-11.6 3.1-17.6C96 46.1 142.1 0 198.9 0zm98.4 96L280 96c-24.1 0-45.1-13.3-56-33c-10.9 19.7-31.9 33-56 33l-17.3 0c-4.3 9.8-6.7 20.6-6.7 32l0 16c0 12.5 2.9 24.4 8 35c.9-.5 1.8-1.1 2.6-1.8l.6-.6c18.2-18.2 43-28.5 68.8-28.5s50.5 10.2 68.8 28.5l.6 .6c.8 .8 1.6 1.4 2.6 1.8c5.1-10.6 8-22.4 8-35l0-16c0-11.4-2.4-22.2-6.7-32zM269.8 209.6c-1.6-1.3-3.2-2.7-4.7-4.2l-.6-.6C253.7 194 239.2 188 224 188s-29.7 6-40.5 16.8l-.6 .6c-1.5 1.5-3.1 2.9-4.7 4.2c2.6 1.8 5.2 3.4 8 4.9c11.3 6.1 24.2 9.5 37.9 9.5s26.6-3.4 37.9-9.5c2.8-1.5 5.4-3.1 8-4.9zm268.2 18c5.8 4.7 7.6 12.9 4.2 19.6L489.9 352l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L438.1 384 368 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1zM362.3 464l-5.3 10.5c-6 12-6.5 25.5-2.3 37.5l-324 0C13.8 512 0 498.2 0 481.3c0-59.6 32.3-111.7 80.4-139.6c9.9 14.7 23.8 26.5 40.1 33.8c-37.3 14.4-65 47.9-71.2 88.5l313 0z',
  ],
};
const faCartPlus = {
  prefix: 'far',
  iconName: 'cart-plus',
  icon: [
    576,
    512,
    [],
    'f217',
    'M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 48l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faGamepad = {
  prefix: 'far',
  iconName: 'gamepad',
  icon: [
    640,
    512,
    [],
    'f11b',
    'M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144l256 0c79.5 0 144-64.5 144-144s-64.5-144-144-144l-256 0zM0 256C0 150 86 64 192 64l256 0c106 0 192 86 192 192s-86 192-192 192l-256 0C86 448 0 362 0 256zm232-56l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faBorderCenterV = {
  prefix: 'far',
  iconName: 'border-center-v',
  icon: [
    448,
    512,
    [],
    'f89d',
    'M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm40 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400z',
  ],
};
const faCircleDot = {
  prefix: 'far',
  iconName: 'circle-dot',
  icon: [
    512,
    512,
    [128280, 'dot-circle'],
    'f192',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faDotCircle = faCircleDot;
const faClipboardMedical = {
  prefix: 'far',
  iconName: 'clipboard-medical',
  icon: [
    384,
    512,
    [],
    'e133',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 160l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faFaceDizzy = {
  prefix: 'far',
  iconName: 'face-dizzy',
  icon: [
    512,
    512,
    ['dizzy'],
    'f567',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faDizzy = faFaceDizzy;
const faEgg = {
  prefix: 'far',
  iconName: 'egg',
  icon: [
    384,
    512,
    [129370],
    'f7fb',
    'M192 448c-74.7 0-144-75.4-144-160c0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z',
  ],
};
const faUpToLine = {
  prefix: 'far',
  iconName: 'up-to-line',
  icon: [
    384,
    512,
    ['arrow-alt-to-top'],
    'f34d',
    'M82.2 288L192 178 301.8 288 248 288c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM192 128c-11.5 0-22.5 4.6-30.6 12.7L45.6 256.8C36.9 265.5 32 277.3 32 289.6C32 315.2 52.8 336 78.4 336l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM24 80l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80z',
  ],
};
const faArrowAltToTop = faUpToLine;
const faHouseMedicalCircleXmark = {
  prefix: 'far',
  iconName: 'house-medical-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e513',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z',
  ],
};
const faWatchFitness = {
  prefix: 'far',
  iconName: 'watch-fitness',
  icon: [
    384,
    512,
    [],
    'f63e',
    'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM93.7 226.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z',
  ],
};
const faClockNineThirty = {
  prefix: 'far',
  iconName: 'clock-nine-thirty',
  icon: [
    512,
    512,
    [],
    'e34d',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-13.3-10.7-24-24-24l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faCampground = {
  prefix: 'far',
  iconName: 'campground',
  icon: [
    576,
    512,
    [9978],
    'f6bb',
    'M375.4 5.6c10.2 8.5 11.5 23.6 3 33.8l-59.1 70.7L555 392.1c8.4 10.1 13 22.8 13 35.9l0 28c0 30.9-25.1 56-56 56l-224 0L64 512c-30.9 0-56-25.1-56-56l0-28c0-13.1 4.6-25.8 13-35.9L256.7 110.1 197.6 39.4c-8.5-10.2-7.1-25.3 3-33.8s25.3-7.1 33.8 3L288 72.7 341.6 8.6c8.5-10.2 23.6-11.5 33.8-3zM57.9 422.8c-1.2 1.4-1.9 3.3-1.9 5.1l0 28c0 4.4 3.6 8 8 8l62 0L269.1 281.2c4.5-5.8 11.5-9.2 18.9-9.2s14.4 3.4 18.9 9.2L450 464l62 0c4.4 0 8-3.6 8-8l0-28c0-1.9-.7-3.7-1.9-5.1L288 147.5 57.9 422.8zM187 464l101 0 101 0L288 334.9 187 464z',
  ],
};
const faFolderPlus = {
  prefix: 'far',
  iconName: 'folder-plus',
  icon: [
    512,
    512,
    [],
    'f65e',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faJug = {
  prefix: 'far',
  iconName: 'jug',
  icon: [
    448,
    512,
    [],
    'f8c6',
    'M192 77.5c0 17.1-5.5 33.7-15.6 47.5L95.6 234.6C85.5 248.4 80 265 80 282.1l0 5.9 288 0 0-5.9c0-17.1-5.5-33.7-15.6-47.5L271.6 124.9C261.5 111.2 256 94.6 256 77.5L256 48l-64 0 0 29.5zM80 416l0 32c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-32L80 416zM304 48l0 29.5c0 6.8 2.2 13.5 6.2 19l15 20.4C338.3 104 356.2 96 376 96c39.8 0 72 32.2 72 72c0 28.9-17.1 53.9-41.6 65.3c6.3 15.4 9.6 31.9 9.6 48.8L416 448c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-165.9c0-27.3 8.7-53.9 25-75.9L137.8 96.5c4.1-5.5 6.2-12.2 6.2-19L144 48c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 64 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm50.7 108.9l25.6 34.8c11.2-2 19.7-11.8 19.7-23.6c0-13.3-10.7-24-24-24c-9.2 0-17.2 5.2-21.3 12.9z',
  ],
};
const faFutbol = {
  prefix: 'far',
  iconName: 'futbol',
  icon: [
    512,
    512,
    [9917, 'futbol-ball', 'soccer-ball'],
    'f1e3',
    'M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z',
  ],
};
const faFutbolBall = faFutbol;
const faSoccerBall = faFutbol;
const faSnowBlowing = {
  prefix: 'far',
  iconName: 'snow-blowing',
  icon: [
    640,
    512,
    [],
    'f761',
    'M176 64c13.3 0 24 10.7 24 24l0 25.4 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6l0 55.8 48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6l0 55.8 35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6l0 25.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.4-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4l0-55.8-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4l0-55.8-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4 152 88c0-13.3 10.7-24 24-24zM480 424c0-13.3 10.7-24 24-24l48 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-48 0c-13.3 0-24-10.7-24-24zM504 64l48 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faPaintbrush = {
  prefix: 'far',
  iconName: 'paintbrush',
  icon: [
    576,
    512,
    [128396, 'paint-brush'],
    'f1fc',
    'M278 219.5L356.5 298 524.7 73.6c4.8-6.4 4.1-15.3-1.5-20.9s-14.5-6.3-20.9-1.5L278 219.5zM199.1 321.6c-4.9-1-9.9-1.6-15.1-1.6c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9 85.6 0c39.8 0 72-32.2 72-72c0-5.2-.5-10.2-1.6-15.1l-55.4-55.4zM384 341.3c-19.1 25.5-48.6 41.1-80.3 42.6c.2 2.7 .3 5.4 .3 8.1c0 66.3-53.7 120-120 120L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6 0c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c2.7 0 5.4 .1 8.1 .3c1.5-31.7 17-61.1 42.5-80.3L473.5 12.8C499-6.3 534.6-3.8 557.2 18.7s25.1 58.2 6 83.7L384 341.3z',
  ],
};
const faPaintBrush = faPaintbrush;
const faLock = {
  prefix: 'far',
  iconName: 'lock',
  icon: [
    448,
    512,
    [128274],
    'f023',
    'M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z',
  ],
};
const faArrowDownFromLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-line',
  icon: [
    384,
    512,
    [8615, 'arrow-from-top'],
    'f345',
    'M174.5 472.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 395.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 303.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136zM360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0z',
  ],
};
const faArrowFromTop = faArrowDownFromLine;
const faGasPump = {
  prefix: 'far',
  iconName: 'gas-pump',
  icon: [
    512,
    512,
    [9981],
    'f52f',
    'M256 48c8.8 0 16 7.2 16 16l0 128L80 192 80 64c0-8.8 7.2-16 16-16l160 0zm16 192l0 224L80 464l0-224 192 0zM32 64l0 400-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 48 0 192 0 48 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160 8 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-220.1c0-19.1-7.6-37.4-21.1-50.9L417 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33 0 62.1c0 29.8 20.4 54.9 48 62l0 154c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-8 0 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64z',
  ],
};
const faSignalBarsSlash = {
  prefix: 'far',
  iconName: 'signal-bars-slash',
  icon: [
    640,
    512,
    ['signal-alt-slash'],
    'f694',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-22.9-17.9c.1-1 .1-2.1 .1-3.2l0-384c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 286.9-24-18.8L456 192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 39.8L38.8 5.1zM376 269.4l0-77.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 102.5-32-25.1zM528 388.5L528 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 349.6-32-25.1zM544.4 512l-.4 0s0 0 0 0l.4 0zM408 417.5l0 30.5c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.8-48-37.8 0 93.6c0 35.3 28.7 64 64 64c33 0 60.1-25 63.6-57L408 417.5zM211.5 262.7C190.5 273.1 176 294.9 176 320l0 128c0 35.3 28.7 64 64 64s64-28.7 64-64l0-112.5-92.5-72.9zM256 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128zm-144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z',
  ],
};
const faSignalAltSlash = faSignalBarsSlash;
const faMonkey = {
  prefix: 'far',
  iconName: 'monkey',
  icon: [
    576,
    512,
    [128018],
    'f6fb',
    'M160 416c0-91.5 54.8-170.2 133.5-204.9c7.3 15.1 17.2 28.6 29.3 39.9C255.7 275.8 208 340.4 208 416l0 48 192 0 0-24c0-39.8-32.2-72-72-72l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c27 0 51.9 8.9 72 24l0-24 0-32.9c5.2 .6 10.6 .9 16 .9c11 0 21.7-1.3 32-3.8l0 1.8 83.5 83.5C560 398 576 436.7 576 477l0 11c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11c0-27.6-11-54-30.5-73.5L448 353.9l0 86.1 0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-192 0-48 0-8 0C68.1 512 0 443.9 0 360L0 120C0 53.7 53.7 0 120 0l8 0c53 0 96 43 96 96s-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-8 0c-39.8 0-72 32.2-72 72l0 240c0 57.4 46.6 104 104 104l8 0 0-48zM448 251c-10.1 3.3-20.8 5-32 5c-5.4 0-10.8-.4-16-1.2c-13.5-2.1-26.1-6.8-37.4-13.5c-16.4-9.8-29.9-24.1-38.8-41.1c-1.4-2.7-2.7-5.4-3.8-8.2c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-11.6 27.9-35 49.6-64 59zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48l-64 0zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faRectanglePro = {
  prefix: 'far',
  iconName: 'rectangle-pro',
  icon: [
    640,
    512,
    ['pro'],
    'e235',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm104 64l56 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32 32 0zm80-56c0-13.3 10.7-24 24-24l56 0c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7L288 288l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80zm48 56l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32zm200-80c48.6 0 88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16c0-48.6 39.4-88 88-88zm-40 88l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z',
  ],
};
const faPro = faRectanglePro;
const faHouseNight = {
  prefix: 'far',
  iconName: 'house-night',
  icon: [
    640,
    512,
    [],
    'e010',
    'M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm289.9 85.3c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4 224 456c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-161.6 24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3L528 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-200.7L400 151 528 255.3zM352 312l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM248.5 12.3L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3c-2.6-7-12.4-7-15 0zm-145 320c-2.6-7-12.4-7-15 0L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3z',
  ],
};
const faHotTubPerson = {
  prefix: 'far',
  iconName: 'hot-tub-person',
  icon: [
    512,
    512,
    ['hot-tub'],
    'f593',
    'M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336l0 112c0 8.8 7.2 16 16 16l48 0 0-160-64 0 0 16 0 16zM160 464l72 0 0-160-72 0 0 160zm120 0l72 0 0-160-72 0 0 160zm-2.7-208l98.7 0 24 0 48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 336l0-16 0-40 0-24c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256l88 0 40 0-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6c-26.5 0-48 21.5-48 48zm352 48l0 160 48 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-48 0zM272 24l0 5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2l0 13.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2l0-5.2c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2l0 13.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2l0-5.2c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHotTub = faHotTubPerson;
const faGlobePointer = {
  prefix: 'far',
  iconName: 'globe-pointer',
  icon: [
    512,
    512,
    [],
    'e60e',
    'M303.6 415.6C283 456.8 263.4 464 256 464c-3.1 0-8.3-1.3-14.8-5.7l-15.3 52c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3c0-16.5 1.9-32.6 5.6-48l76.7 0c-1.3 13.3-2 27-2.2 41l48.4-14.2c.4-9.1 1.1-18 2-26.7l155 0c1.6 15.3 2.5 31.4 2.5 48s-.9 32.7-2.5 48l-47 0-14.1 48 53.2 0c-5.6 24.4-13.2 45.9-22 63.6zM208.4 96.4C229 55.2 248.6 48 256 48s27 7.2 47.6 48.4c8.8 17.7 16.4 39.2 22 63.6l-139.2 0c5.6-24.4 13.2-45.9 22-63.6zM384 256c0-16.4-.8-32.5-2.2-48l76.7 0c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48l-76.7 0c1.5-15.5 2.2-31.6 2.2-48zm-9.3-96c-7.3-35.9-18.5-67.7-32.6-93.4c42.3 19.3 77 52.3 98.4 93.4l-65.9 0zM71.4 160c21.4-41.1 56.1-74.1 98.4-93.4c-14.1 25.6-25.3 57.5-32.6 93.4l-65.9 0zM374.7 352l65.9 0c-21.4 41.1-56.1 74.1-98.4 93.4c14.1-25.6 25.3-57.5 32.6-93.4zM39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9L39 308.5z',
  ],
};
const faBlanket = {
  prefix: 'far',
  iconName: 'blanket',
  icon: [
    448,
    512,
    [],
    'f498',
    'M48 144l0 132.1C66.1 263.4 88.2 256 112 256l268 0c7 0 13.7 1 20 3l0-115c0-35.3-28.7-64-64-64L112 80c-35.3 0-64 28.7-64 64zM0 368L0 144C0 82.1 50.1 32 112 32l224 0c61.9 0 112 50.1 112 112l0 176-.1 0c.1 1.3 .1 2.7 .1 4c0 37.6-30.4 68-68 68l-260 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l260 0c11 0 20-9 20-20s-9-20-20-20l-268 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l312 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-312 0C50.1 480 0 429.9 0 368z',
  ],
};
const faMapLocation = {
  prefix: 'far',
  iconName: 'map-location',
  icon: [
    576,
    512,
    ['map-marked'],
    'f59f',
    'M403 148.6c3.2-10.3 5-20 5-28.6C408 53.7 354.3 0 288 0C226.4 0 175.6 46.4 168.8 106.2c-.5 4.5-.8 9.1-.8 13.8c0 10.3 2.6 22 7 34.6c.7 2.1 1.5 4.2 2.3 6.3c10.4 27 28.3 57.1 46.7 84.4c18.1 26.9 36.7 51.1 49.2 66.6c7.7 9.6 22 9.6 29.6 0c12.4-15.5 31.1-39.7 49.2-66.6c.1-.2 .3-.4 .4-.6c4.6-6.8 9.1-13.7 13.5-20.8c3.3-5.3 6.5-10.7 9.6-16l.1-.2c11.8-20.4 21.8-40.8 27.4-59.2zm-8.3 89.6c-13.9 22.5-29.1 44.2-42.7 62.4l0 153.1L224 407.2l0-106.6c-13.5-18.2-28.8-39.9-42.7-62.4c-1.8-2.9-3.6-5.8-5.3-8.8l0 177.7L48 453.7l0-252.9 96.9-35.2c-5.2-14.9-8.9-30.5-8.9-45.6c0-.8 0-1.5 0-2.3L15.8 161.4C6.3 164.9 0 173.9 0 184L0 488c0 7.8 3.8 15.2 10.2 19.7s14.6 5.6 22 2.9l167.8-61 167.8 61c5.3 1.9 11.1 1.9 16.4 0l176-64c9.5-3.4 15.8-12.5 15.8-22.6l0-304c0-7.8-3.8-15.2-10.2-19.7s-14.6-5.6-22-2.9l-105 38.2c-2.2 15-7.3 30.2-13.2 44.2c-2 4.6-4.1 9.3-6.3 14L528 154.3l0 252.9L400 453.7l0-224.3c-1.8 3-3.5 5.9-5.3 8.8z',
  ],
};
const faMapMarked = faMapLocation;
const faHouseFloodWater = {
  prefix: 'far',
  iconName: 'house-flood-water',
  icon: [
    576,
    512,
    [],
    'e50e',
    'M301.9 4.4c-8.3-5.9-19.4-5.9-27.7 0l-192 136c-10.8 7.7-13.4 22.6-5.7 33.5s22.6 13.4 33.5 5.7l2.1-1.5 0 80.4c7.3 1.9 14.4 5.1 20.9 9.6c8.4 5.8 17.7 10.6 27.1 14.1l0-138.1L288 53.4l128 90.7 0 138.1c9.5-3.5 18.8-8.3 27.2-14.1c6.5-4.5 13.5-7.8 20.8-9.6l0-80.4 2.1 1.5c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5l-192-136zM80 318.1C62.8 333 41 344.8 18.8 349.8C5.9 352.7-2.3 365.5 .6 378.5s15.7 21.1 28.7 18.2C58 390.2 81.6 376.2 96 366.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm31.9 112c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faCommentsQuestionCheck = {
  prefix: 'far',
  iconName: 'comments-question-check',
  icon: [
    640,
    512,
    [],
    'e14f',
    'M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480zM184.3 86.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4l41.3 0c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9l0 9.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-.3L247.4 168c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7l-41.3 0zM208 266.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3zm331.3 22c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3z',
  ],
};
const faTree = {
  prefix: 'far',
  iconName: 'tree',
  icon: [
    448,
    512,
    [127794],
    'f1bb',
    'M241.8 7.9C237.3 2.9 230.8 0 224 0s-13.3 2.9-17.8 7.9l-144 160c-6.3 7-7.9 17.2-4.1 25.8S70.5 208 80 208l11.8 0-62 72.4c-6.1 7.1-7.5 17.1-3.6 25.6s12.4 14 21.8 14l24 0L4.8 409.6c-5.5 7.3-6.3 17-2.3 25.1S14.9 448 24 448l136 0 40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0 136 0c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1L376 320l24 0c9.4 0 17.9-5.5 21.8-14s2.5-18.5-3.6-25.6l-62-72.4 11.8 0c9.5 0 18.1-5.6 21.9-14.2s2.3-18.8-4.1-25.8l-144-160zM248 400l0-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 184-40 0-88 0 67.2-89.6c5.5-7.3 6.3-17 2.3-25.1s-12.4-13.3-21.5-13.3l-19.8 0 62-72.4c6.1-7.1 7.5-17.1 3.6-25.6s-12.4-14-21.8-14l-10.1 0L224 59.9 314.1 160 304 160c-9.4 0-17.9 5.5-21.8 14s-2.5 18.5 3.6 25.6l62 72.4L328 272c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1L376 400l-88 0-40 0z',
  ],
};
const faArrowsCross = {
  prefix: 'far',
  iconName: 'arrows-cross',
  icon: [
    448,
    512,
    [],
    'e0a2',
    'M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.1 0L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l359-359 0 70.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24L296 32zM41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73L167.4 233.4l33.9-33.9L41 39zM246.6 312.6L366.1 432 296 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.1L280.6 278.6l-33.9 33.9z',
  ],
};
const faBackpack = {
  prefix: 'far',
  iconName: 'backpack',
  icon: [
    448,
    512,
    [127890],
    'f5d4',
    'M192 48l64 0c4.4 0 8 3.6 8 8l0 24-80 0 0-24c0-4.4 3.6-8 8-8zm-56 8l0 24-8 0C57.3 80 0 137.3 0 208L0 448c0 35.3 28.7 64 64 64l40 0 240 0 40 0c35.3 0 64-28.7 64-64l0-240c0-70.7-57.3-128-128-128l-8 0 0-24c0-30.9-25.1-56-56-56L192 0c-30.9 0-56 25.1-56 56zM368 464l0-88 0-64c0-39.8-32.2-72-72-72l-144 0c-39.8 0-72 32.2-72 72l0 64 0 88-16 0c-8.8 0-16-7.2-16-16l0-240c0-44.2 35.8-80 80-80l32 0 128 0 32 0c44.2 0 80 35.8 80 80l0 240c0 8.8-7.2 16-16 16l-16 0zm-240 0l0-64 192 0 0 64-192 0zm16-304c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0zM320 352l-192 0 0-40c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 40z',
  ],
};
const faSquareSmall = {
  prefix: 'far',
  iconName: 'square-small',
  icon: [
    320,
    512,
    [],
    'e27e',
    'M256 144c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l192 0zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 96z',
  ],
};
const faFolderArrowUp = {
  prefix: 'far',
  iconName: 'folder-arrow-up',
  icon: [
    512,
    512,
    ['folder-upload'],
    'e054',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM280 376l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faFolderUpload = faFolderArrowUp;
const faBridgeLock = {
  prefix: 'far',
  iconName: 'bridge-lock',
  icon: [
    640,
    512,
    [],
    'e4cc',
    'M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 193.6 0c20.2-19.8 47.9-32 78.4-32c27.3 0 52.4 9.8 71.8 26.1c5-4.4 8.2-10.9 8.2-18.1c0-13.3-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c24.9 0 45.9 16.2 53.2 38.6c5.5-12.6 14.9-23.2 26.8-30l0-19c-19.1-22.9-47.8-37.5-80-37.5zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faCrosshairsSimple = {
  prefix: 'far',
  iconName: 'crosshairs-simple',
  icon: [
    512,
    512,
    [],
    'e59f',
    'M462.6 232L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.6 0c-11 95.7-86.9 171.6-182.6 182.6l0-70.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.6C136.3 451.6 60.4 375.7 49.4 280l70.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-70.6 0C60.4 136.3 136.3 60.4 232 49.4l0 70.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-70.6c95.7 11 171.6 86.9 182.6 182.6zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z',
  ],
};
const faSackDollar = {
  prefix: 'far',
  iconName: 'sack-dollar',
  icon: [
    512,
    512,
    [128176],
    'f81d',
    'M218.7 152l74.6 0 13.8 8.8C361.1 195.4 464 277 464 416c0 26.5-21.5 48-48 48L96 464c-26.5 0-48-21.5-48-48c0-139 102.9-220.6 156.9-255.2l13.8-8.8zM286 104l-60 0-7.5-10.8L187.4 48l137.2 0L293.5 93.2 286 104zM150.8 139.9C89.4 185.5 0 274.8 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-141.2-89.4-230.5-150.8-276.1c-10.4-7.7-20-14.2-28.2-19.4l27.3-39.5 29.8-43.2C401 21.7 389.6 0 370.3 0L141.7 0C122.4 0 111 21.7 121.9 37.6l29.8 43.2L179 120.4c-8.2 5.3-17.8 11.7-28.2 19.4zM276 216c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
  ],
};
const faPenToSquare = {
  prefix: 'far',
  iconName: 'pen-to-square',
  icon: [
    512,
    512,
    ['edit'],
    'f044',
    'M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z',
  ],
};
const faEdit = faPenToSquare;
const faSquareSliders = {
  prefix: 'far',
  iconName: 'square-sliders',
  icon: [
    448,
    512,
    ['sliders-h-square'],
    'f3f0',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-13.3 10.7-24 24-24l32 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24zm24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l128 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-128 0z',
  ],
};
const faSlidersHSquare = faSquareSliders;
const faCarSide = {
  prefix: 'far',
  iconName: 'car-side',
  icon: [
    640,
    512,
    [128663],
    'f5e4',
    'M171.3 80L224 80l0 16 0 80 0 16L99.4 192l34.7-86.9C140.3 90 155 80 171.3 80zM272 192l0-16 0-80 0-16 81.2 0c12.2 0 23.6 5.5 31.2 15l77.6 97L272 192zm252 .6L422 65c-16.7-20.9-42-33-68.7-33L171.3 32c-36 0-68.3 21.9-81.7 55.3l-42.8 107C19.8 201.8 0 226.6 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-66.7-50.9-121.4-116-127.4zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-138.9 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L48 352l0-96c0-8.8 7.2-16 16-16l448 0c44.2 0 80 35.8 80 80l0 32-21.5 0zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faMessageMiddleTop = {
  prefix: 'far',
  iconName: 'message-middle-top',
  icon: [
    512,
    512,
    ['comment-middle-top-alt'],
    'e1e2',
    'M343.5 144L448 144c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l104.5 0c14.2 0 27.8-6.3 36.9-17.3L256 66l50.6 60.7c9.1 10.9 22.6 17.3 36.9 17.3zm-175-48L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L343.5 96 268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z',
  ],
};
const faCommentMiddleTopAlt = faMessageMiddleTop;
const faLightbulbOn = {
  prefix: 'far',
  iconName: 'lightbulb-on',
  icon: [
    640,
    512,
    [],
    'f672',
    'M69.3 4C58.3-3.3 43.4-.3 36 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L69.3 4zM597.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM400 432l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80z',
  ],
};
const faKnife = {
  prefix: 'far',
  iconName: 'knife',
  icon: [
    512,
    512,
    ['utensil-knife'],
    'f2e4',
    'M451.4 10.8C458.1 3.9 467.2 0 476.8 0C496.2 0 512 15.8 512 35.2l0 48.4c0 65.5-25.9 128.4-72.1 174.9l-70.2 70.6c-31.2 31.4-82 31.5-113.3 .2L233.1 306 41.3 504.7c-9.2 9.5-24.4 9.8-33.9 .6s-9.8-24.4-.6-33.9L215.5 255.1 451.4 10.8zm-185 260.7l23.8 23.8c12.5 12.5 32.8 12.5 45.3-.1l70.2-70.6c37.3-37.5 58.2-88.2 58.2-141l0-16.8L266.4 271.5z',
  ],
};
const faUtensilKnife = faKnife;
const faShareNodes = {
  prefix: 'far',
  iconName: 'share-nodes',
  icon: [
    448,
    512,
    ['share-alt'],
    'f1e0',
    'M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faShareAlt = faShareNodes;
const faDisplayChartUpCircleDollar = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-dollar',
  icon: [
    640,
    512,
    [],
    'e5e6',
    'M64 48l448 0c8.8 0 16 7.2 16 16l0 130.9c17 3.1 33.1 8.7 48 16.3L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 42.8 0c-18.3-12.9-34.1-29.2-46.3-48l-24.8 0L288 464l-35.7 0 8-48 27.7 0 27.7 0 11 0c-4.3-15.3-6.6-31.4-6.6-48l-79.6 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM480 192.7l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z',
  ],
};
const faWaveSine = {
  prefix: 'far',
  iconName: 'wave-sine',
  icon: [
    640,
    512,
    [8767],
    'f899',
    'M47.3 237.8s0 0 0 0s0 0 0 0l.1-.2 .3-1.1c.3-1 .7-2.5 1.3-4.5c1.2-4 3-9.8 5.6-16.8c5.2-14.1 13.1-32.6 24-50.9C101.2 126.6 132.9 96 176 96c33.3 0 55.6 16.4 74.1 46.2c19.5 31.3 32.6 73.9 46.9 120.8l.6 1.9c13.6 44.6 28.3 93.1 51.5 130.3C373.6 434.4 409.3 464 464 464c68.9 0 113.2-49.4 138.6-91.7c13-21.7 22.1-43.1 28-59.1c2.9-8 5.1-14.7 6.5-19.5c.7-2.4 1.3-4.3 1.6-5.6c.2-.7 .3-1.2 .4-1.6l.1-.5 0-.1c0 0 0 0 0-.1c0 0 0 0 0 0L616 280l23.3 5.8c3.2-12.9-4.6-25.9-17.5-29.1s-25.9 4.6-29.1 17.4c0 0 0 0 0 0s0 0 0 0l-.1 .2-.3 1.1c-.3 1-.7 2.5-1.3 4.5c-1.2 4-3 9.8-5.6 16.8c-5.2 14.1-13 32.6-24 50.9C538.8 385.4 507.1 416 464 416c-33.3 0-55.6-16.4-74.1-46.2C370.4 338.5 357.2 295.9 343 249l-.6-1.9C328.8 202.5 314 154 290.9 116.8C266.4 77.6 230.7 48 176 48C107.1 48 62.8 97.4 37.4 139.7c-13 21.7-22.1 43.1-28 59.1c-2.9 8-5.1 14.7-6.5 19.5c-.7 2.4-1.3 4.3-1.6 5.6c-.2 .7-.3 1.2-.4 1.6l-.1 .5 0 .1c0 0 0 0 0 .1c0 0 0 0 0 0L24 232 .7 226.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.4z',
  ],
};
const faHeartCircleMinus = {
  prefix: 'far',
  iconName: 'heart-circle-minus',
  icon: [
    576,
    512,
    [],
    'e4ff',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
  ],
};
const faCircleW = {
  prefix: 'far',
  iconName: 'circle-w',
  icon: [
    512,
    512,
    [],
    'e12c',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7c-4-12.6-17.5-19.6-30.2-15.5s-19.6 17.5-15.5 30.2l64 200c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7L256 254.7l41.1 128.6c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7l64-200c4-12.6-2.9-26.1-15.5-30.2s-26.1 2.9-30.2 15.5L320 297.3 278.9 168.7c-3.2-9.9-12.4-16.7-22.9-16.7s-19.7 6.7-22.9 16.7L192 297.3 150.9 168.7z',
  ],
};
const faCircleCalendar = {
  prefix: 'far',
  iconName: 'circle-calendar',
  icon: [
    512,
    512,
    ['calendar-circle'],
    'e102',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 112c8.8 0 16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c26.5 0 48 21.5 48 48l0 32 0 96c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-96 0-32c0-26.5 21.5-48 48-48l16 0 0-16c0-8.8 7.2-16 16-16zM176 320l160 0 0-96-160 0 0 96z',
  ],
};
const faCalendarCircle = faCircleCalendar;
const faHourglassHalf = {
  prefix: 'far',
  iconName: 'hourglass-half',
  icon: [
    384,
    512,
    ['hourglass-2'],
    'f252',
    'M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z',
  ],
};
const faHourglass2 = faHourglassHalf;
const faMicroscope = {
  prefix: 'far',
  iconName: 'microscope',
  icon: [
    512,
    512,
    [128300],
    'f610',
    'M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32L192 0zM176 272l0-192 64 0 0 192-64 0zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l296 0 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41 0c39.9-35.2 65-86.7 65-144c0-106-86-192-192-192c0 0 0 0 0 0l0 48s0 0 0 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c0 0 0 0 0 0L24 464zm72-56c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faSunset = {
  prefix: 'far',
  iconName: 'sunset',
  icon: [
    576,
    512,
    [127751],
    'f767',
    'M305 217c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80zm88.3 8.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464l58.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l58.1 0L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464l36.7 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l36.7 0 43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48l124 0z',
  ],
};
const faSink = {
  prefix: 'far',
  iconName: 'sink',
  icon: [
    512,
    512,
    [],
    'e06d',
    'M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24c0-48.6-39.4-88-88-88s-88 39.4-88 88l0 200-72 0 0-24c0-30.9-25.1-56-56-56l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 24-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l232 0 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-24c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 24-72 0 0-200zM32 368l0 24c0 66.3 53.7 120 120 120l208 0c66.3 0 120-53.7 120-120l0-24-48 0 0 24c0 39.8-32.2 72-72 72l-208 0c-39.8 0-72-32.2-72-72l0-24-48 0z',
  ],
};
const faCalendarExclamation = {
  prefix: 'far',
  iconName: 'calendar-exclamation',
  icon: [
    448,
    512,
    [],
    'f334',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zM256 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z',
  ],
};
const faTruckContainerEmpty = {
  prefix: 'far',
  iconName: 'truck-container-empty',
  icon: [
    640,
    512,
    [],
    'e2b5',
    'M432 168c0-13.3 10.7-24 24-24l72.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l-16 0-144 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-96 0-88zm103 26.9c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faHandHeart = {
  prefix: 'far',
  iconName: 'hand-heart',
  icon: [
    512,
    512,
    [],
    'f4bc',
    'M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 176c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L112 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9L432 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L352 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L240 232zm-32 96.8c0-22.6 18.3-40.8 40.8-40.8c10.8 0 21.2 4.3 28.9 12l5 5 5-5c7.7-7.7 18-12 28.9-12c22.6 0 40.8 18.3 40.8 40.8c0 10.8-4.3 21.2-12 28.9l-55.2 55.2c-4.2 4.2-10.9 4.2-15.1 0L220 357.7c-7.7-7.7-12-18-12-28.9z',
  ],
};
const faBagShopping = {
  prefix: 'far',
  iconName: 'bag-shopping',
  icon: [
    448,
    512,
    ['shopping-bag'],
    'f290',
    'M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96l-64 0 0 208c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208-64 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-128 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zm0-48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0z',
  ],
};
const faShoppingBag = faBagShopping;
const faArrowDownZA = {
  prefix: 'far',
  iconName: 'arrow-down-z-a',
  icon: [
    576,
    512,
    ['sort-alpha-desc', 'sort-alpha-down-alt'],
    'f881',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM352 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l74.6 0L334.1 184.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 224 352 224l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-74.6 0L497.9 71.9c6.3-7.1 7.8-17.2 4-25.8S489.4 32 480 32L352 32zm64 240c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 440l85.2 0c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160c-4.1-8.1-12.4-13.3-21.5-13.3zM394.8 392L416 349.7 437.2 392l-42.3 0z',
  ],
};
const faSortAlphaDesc = faArrowDownZA;
const faSortAlphaDownAlt = faArrowDownZA;
const faMitten = {
  prefix: 'far',
  iconName: 'mitten',
  icon: [
    448,
    512,
    [],
    'f7b5',
    'M0 142.6C0 63.8 63.8 0 142.6 0c63.7 0 119.6 42.2 137.1 103.4l21.4 75c15.7-11.8 35-18.4 55.2-18.4l4.5 0c48.2 0 87.3 39.1 87.3 87.3c0 21.9-8.3 43.1-23.1 59.2L353.3 384 304 384l0-8c0-6 2.3-11.8 6.4-16.3l79.2-85.8c6.7-7.3 10.4-16.8 10.4-26.6c0-21.7-17.6-39.3-39.3-39.3l-4.5 0c-14.6 0-28.3 7.3-36.4 19.5l-9.5 14.2c-5.2 7.8-14.4 11.8-23.7 10.4s-16.8-8.1-19.4-17.1L233.5 116.6C221.9 76 184.8 48 142.6 48C90.3 48 48 90.3 48 142.6l0 2.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5c.5 1.9 .7 3.9 .7 5.8l-48.7 0L4.3 180.3C1.5 168.8 0 157 0 145.1l0-2.5zM64 416l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
  ],
};
const faReplyClock = {
  prefix: 'far',
  iconName: 'reply-clock',
  icon: [
    640,
    512,
    ['reply-time'],
    'e239',
    'M640 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-11.4 0-22.6-1.1-33.4-3.2c.9 6.2 1.4 12.6 1.4 19.2c0 15.3-1.9 29.1-5.2 41.5C442 316.7 386.2 272 320 272l-96 0-24 0c-13.3 0-24 10.7-24 24l0 24 0 28.1L55.9 240 176 131.9l0 28.1 0 24c0 13.3 10.7 24 24 24l24 0 108 0c-5.9-15.1-9.8-31.2-11.3-48L272 160l-48 0 0-48 0-16c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-16 0-48 48 0 48 0c53 0 96 43 96 96c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C473.4 462.2 512 413.9 512 336z',
  ],
};
const faReplyTime = faReplyClock;
const faPersonRays = {
  prefix: 'far',
  iconName: 'person-rays',
  icon: [
    512,
    512,
    [],
    'e54d',
    'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L272 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM240 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L346.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L107.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L192 223.6 192 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM7 7C-2.3 16.4-2.3 31.6 7 41l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7C31.6-2.3 16.4-2.3 7 7zM505 7c-9.4-9.4-24.6-9.4-33.9 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9zM41 505l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm464 0c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0z',
  ],
};
const faRight = {
  prefix: 'far',
  iconName: 'right',
  icon: [
    448,
    512,
    [11157, 'arrow-alt-right'],
    'f356',
    'M397.6 256L247.7 398.7c-.8 .8-2 1.3-3.2 1.3c-2.5 0-4.6-2-4.6-4.6l0-83.4c0-13.3-10.7-24-24-24L48 288l0-64 168 0c13.3 0 24-10.7 24-24l0-83.4c0-2.5 2-4.6 4.6-4.6c1.2 0 2.3 .5 3.2 1.3L397.6 256zm-153 192c13.5 0 26.5-5.2 36.3-14.5L434.8 286.9c8.5-8.1 13.2-19.2 13.2-30.9s-4.8-22.8-13.2-30.9L280.8 78.5C271.1 69.2 258.1 64 244.6 64c-29 0-52.6 23.5-52.6 52.6l0 59.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l144 0 0 59.4c0 29 23.5 52.6 52.6 52.6z',
  ],
};
const faArrowAltRight = faRight;
const faCircleF = {
  prefix: 'far',
  iconName: 'circle-f',
  icon: [
    512,
    512,
    [],
    'e10e',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-64 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faUsers = {
  prefix: 'far',
  iconName: 'users',
  icon: [
    640,
    512,
    [],
    'f0c0',
    'M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM405.3 320l213.3 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80l117.3 0c39.8 0 73.2 27.2 82.6 64l-282.6 0c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0z',
  ],
};
const faFacePleading = {
  prefix: 'far',
  iconName: 'face-pleading',
  icon: [
    512,
    512,
    [],
    'e386',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM266.5 412.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32c-44.2 0-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80zm240-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48zm-304 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z',
  ],
};
const faEyeSlash = {
  prefix: 'far',
  iconName: 'eye-slash',
  icon: [
    640,
    512,
    [],
    'f070',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z',
  ],
};
const faFlaskVial = {
  prefix: 'far',
  iconName: 'flask-vial',
  icon: [
    640,
    512,
    [],
    'e4f3',
    'M175 389.4l49-79.6L224 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0L176 0 80 0 32 0 24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 304c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1zM80 48l96 0 0 112-96 0L80 48zm0 160l96 0 0 144c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-144zM312 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 169.2L202 408.9c-6.6 10.7-10 22.9-10 35.5c0 37.4 30.3 67.6 67.6 67.6l312.7 0c37.4 0 67.6-30.3 67.6-67.6c0-12.5-3.5-24.8-10-35.5L512 217.2 512 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 0zM464 48l0 176c0 4.4 1.2 8.8 3.6 12.6L518.9 320l-205.8 0 51.3-83.4c2.3-3.8 3.6-8.1 3.6-12.6l0-176 96 0zM242.9 434.1L283.6 368l264.9 0 40.6 66.1c1.9 3.1 2.9 6.7 2.9 10.3c0 10.8-8.8 19.6-19.6 19.6l-312.7 0c-10.9 0-19.6-8.8-19.6-19.6c0-3.6 1-7.2 2.9-10.3z',
  ],
};
const faPoliceBox = {
  prefix: 'far',
  iconName: 'police-box',
  icon: [
    384,
    512,
    [],
    'e021',
    'M192 0c8.8 0 16 7.2 16 16l0 16 80 0c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32l0 368 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0L64 512l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32l80 0 0-16c0-8.8 7.2-16 16-16zM80 464l224 0 0-352L80 112l0 352zm24-320c0-4.4 3.6-8 8-8l24 0 0 32-32 0 0-24zm0 40l32 0 0 32-24 0c-4.4 0-8-3.6-8-8l0-24zm72-48c4.4 0 8 3.6 8 8l0 24-32 0 0-32 24 0zm-24 48l32 0 0 24c0 4.4-3.6 8-8 8l-24 0 0-32zm56-48l24 0 0 32-32 0 0-24c0-4.4 3.6-8 8-8zm24 48l0 32-24 0c-4.4 0-8-3.6-8-8l0-24 32 0zm16-48l24 0c4.4 0 8 3.6 8 8l0 24-32 0 0-32zm32 48l0 24c0 4.4-3.6 8-8 8l-24 0 0-32 32 0zM104 248c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48z',
  ],
};
const faCucumber = {
  prefix: 'far',
  iconName: 'cucumber',
  icon: [
    512,
    512,
    [129362],
    'e401',
    'M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-63 63c-4.4-4.7-10.6-7.6-17.5-7.6c-13.3 0-24 10.7-24 24c0 6.9 2.9 13.1 7.6 17.5l-159 159c-31.2 31.2-81.9 31.2-113.1 0zM37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM352 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM184 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faHeadSideBrain = {
  prefix: 'far',
  iconName: 'head-side-brain',
  icon: [
    512,
    512,
    [],
    'f808',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm264-32c22.1 0 40-17.9 40-40s-17.9-40-40-40c-2 0-3.9 .1-5.8 .4C299.8 102.5 288.7 96 276 96c-6.2 0-12.1 1.6-17.2 4.3C252 88.2 238.9 80 224 80s-28 8.2-34.8 20.3C184.1 97.6 178.2 96 172 96c-18.5 0-33.8 14-35.8 32l-.2 0c-22.1 0-40 17.9-40 40c0 16.5 9.9 30.6 24.1 36.7c-.1 1.1-.1 2.2-.1 3.3c0 22.1 17.9 40 40 40c5.7 0 11.1-1.2 16-3.3l0 51.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48.8c2.6 .5 5.3 .8 8 .8c22.1 0 40-17.9 40-40c0-5.7-1.2-11.1-3.3-16l43.3 0z',
  ],
};
const faHand = {
  prefix: 'far',
  iconName: 'hand',
  icon: [
    512,
    512,
    [129306, 9995, 'hand-paper'],
    'f256',
    'M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64l0 165.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5l0-176c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1l0-.1 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.9 0 .1 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 55.9c0 0 0 .1 0 .1l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-71.9c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 172.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9L192 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-135.9z',
  ],
};
const faHandPaper = faHand;
const faPersonBikingMountain = {
  prefix: 'far',
  iconName: 'person-biking-mountain',
  icon: [
    640,
    512,
    [128693, 'biking-mountain'],
    'f84b',
    'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm.5 103c-2.7-3.4-7.5-4-11-1.4l-74.6 55c-9.6 7.1-8.4 21.8 2.3 27.2l69.6 34.8c8.1 4.1 13.3 12.4 13.3 21.5l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-113.2-56.3-28.1c-42.8-21.4-47.8-80.4-9.3-108.8l74.6-55C337.2 93.1 371.2 97.5 390 121l37.6 47 52.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-7.3 0-14.2-3.3-18.7-9l-44.8-56zM188.4 166.7c-6.9 5.2-16.7 3.9-22.1-2.8l-44-55c-5.6-7.1-4.3-17.4 2.9-22.8l65.2-48.9c27.7-20.7 66.8-15.8 88.4 11.2l14.9 18.7c5.6 7.1 4.3 17.4-2.9 22.8L188.4 166.7zM120 256l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C158.1 503.1 148.1 512 136 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L31.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C8.9 414.1 0 404.1 0 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9C97.9 264.9 107.9 256 120 256zm8 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM480.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C542.1 503.1 532.1 512 520 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C392.9 414.1 384 404.1 384 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM576 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
  ],
};
const faBikingMountain = faPersonBikingMountain;
const faUtensilsSlash = {
  prefix: 'far',
  iconName: 'utensils-slash',
  icon: [
    640,
    512,
    [],
    'e464',
    'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l76.5 59.9 4.9-43.7C121.6 8.2 133.5-1.3 146.7 .1s22.7 13.3 21.2 26.5l-8.1 73.2L200 131.5 200 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 .4 0 .7 0 1.1L291.2 203c3-5.6 4.8-12.1 4.8-19l0-14.7L280.1 26.7c-1.5-13.2 8-25 21.2-26.5s25 8 26.5 21.2l16 144 .1 1.3 0 1.3 0 16c0 18-5.4 34.8-14.7 48.8L384 275.7l0-99.7C384 32 496 0 512 0c17.7 0 32 14.3 32 32l0 216 0 56 0 48 0 49.1 86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM104 184l0-6.1L248 291.4 248 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-216-8 0c-48.6 0-88-39.4-88-88zM519.7 512l.6 0-.3 0-.3 0zM432 176l0 112c0 8.8 7.2 16 16 16l48 0 0-56 0-192.9c-7.1 3.6-14.9 8.5-22.6 15.2C453.7 87.4 432 118.3 432 176z',
  ],
};
const faPrintMagnifyingGlass = {
  prefix: 'far',
  iconName: 'print-magnifying-glass',
  icon: [
    640,
    512,
    ['print-search'],
    'f81a',
    'M176 160l-48 0 0-96c0-35.3 28.7-64 64-64L421.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3l0 69.5-48 0 0-69.5c0-4.2-1.7-8.3-4.7-11.3L432.8 52.7c-3-3-7.1-4.7-11.3-4.7L192 48c-8.8 0-16 7.2-16 16l0 96zm16 208l0 96 186.2 0c21.1 10.2 44.8 16 69.8 16c16.7 0 32.8-2.6 48-7.3l0 7.3c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-80-48 0c-17.7 0-32-14.3-32-32l0-112c0-35.3 28.7-64 64-64l224 0c-17.2 12.9-31.7 29.3-42.6 48L128 240c-8.8 0-16 7.2-16 16l0 96 32 0c0-17.7 14.3-32 32-32l112 0c0 16.7 2.6 32.8 7.3 48L192 368zm256 32.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z',
  ],
};
const faPrintSearch = faPrintMagnifyingGlass;
const faTurnRight = {
  prefix: 'far',
  iconName: 'turn-right',
  icon: [
    512,
    512,
    [],
    'e639',
    'M505.5 240.4c8.7-9.2 8.7-23.7 0-32.9L384.1 78.6c-8.8-9.3-21-14.6-33.7-14.6C324.7 64 304 84.7 304 110.3l0 41.7-144 0C71.6 152 0 223.6 0 312L0 424c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l152 0 0 41.7c0 25.6 20.7 46.3 46.3 46.3c12.8 0 25-5.3 33.7-14.6l121.4-129zM352 333.5l0-61.5c0-13.3-10.7-24-24-24l-176 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-112c0-61.9 50.1-112 112-112l168 0c13.3 0 24-10.7 24-24l0-61.5L455 224 352 333.5z',
  ],
};
const faFolderBookmark = {
  prefix: 'far',
  iconName: 'folder-bookmark',
  icon: [
    512,
    512,
    [],
    'e186',
    'M251.7 127.6s0 0 0 0c1.4 1.4 2.8 2.7 4.3 3.9L256 304c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L336 276l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3l0-160 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z',
  ],
};
const faArrowTurnLeftDown = {
  prefix: 'far',
  iconName: 'arrow-turn-left-down',
  icon: [
    384,
    512,
    [],
    'e633',
    'M337 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L216 88c0-22.1 17.9-40 40-40l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L256 0c-48.6 0-88 39.4-88 88l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505c9.4 9.4 24.6 9.4 33.9 0L337 377z',
  ],
};
const faOm = {
  prefix: 'far',
  iconName: 'om',
  icon: [
    512,
    512,
    [128329],
    'f679',
    'M356.7 4.7c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6l16-16zM144 152c-12.6 0-24.2 4.2-33.6 11.2c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6C99 111.7 120.6 104 144 104c57.4 0 104 46.6 104 104c0 20.6-6 39.8-16.3 56l.3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0c14.8 0 29-5.9 39.5-16.4l20.7-20.7c17.2-17.2 40.6-26.9 65-26.9c50.7 0 91.9 41.1 91.9 91.9l0 96.1c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-4c0-13.3 10.7-24 24-24s24 10.7 24 24l0 4c0 24.3 19.7 44 44 44s44-19.7 44-44l0-96.1c0-24.2-19.6-43.9-43.9-43.9c-11.6 0-22.8 4.6-31 12.9l-20.7 20.7C348.9 301 322.5 312 294.9 312l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.1 0c17.2 20.8 27.6 47 27.6 76c0 70.2-60.9 124-132 124S16 458.2 16 388c0-13.3 10.7-24 24-24s24 10.7 24 24c0 40.3 35.8 76 84 76s84-35.7 84-76s-35.8-76-84-76l-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0c0 0 0 0-.1 0l-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l.3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0c30.9 0 56-25.1 56-56s-25.1-56-56-56zM298.8 65.1C313.1 83.1 338.2 96 368 96s54.9-12.9 69.2-30.9c8.2-10.4 23.3-12.1 33.7-3.9s12.1 23.3 3.9 33.7C450.8 125.2 411.4 144 368 144s-82.8-18.8-106.8-49.1c-8.2-10.4-6.5-25.5 3.9-33.7s25.5-6.5 33.7 3.9z',
  ],
};
const faPi = {
  prefix: 'far',
  iconName: 'pi',
  icon: [
    448,
    512,
    [],
    'f67e',
    'M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l88 0 0 165.4c0 44.9-11.4 89-33.2 128.2L75 412.3c-6.4 11.6-2.3 26.2 9.3 32.6s26.2 2.3 32.6-9.3l3.8-6.8c25.8-46.4 39.3-98.5 39.3-151.5L160 112l144 0 0 262.6c0 40.6 32.9 73.4 73.4 73.4c27.8 0 53.2-15.7 65.7-40.6l2.3-4.7c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.3 4.7c-4.3 8.6-13.1 14.1-22.8 14.1c-14.1 0-25.4-11.4-25.4-25.4L352 112l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 64z',
  ],
};
const faFlaskRoundPotion = {
  prefix: 'far',
  iconName: 'flask-round-potion',
  icon: [
    448,
    512,
    ['flask-potion'],
    'f6e1',
    'M176 48l96 0 0 109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 351.9c-64.4-.9-94.8-12.3-122.5-22.7c-23.8-9-45.7-17.2-85.5-17.2c-55.8 0-92.3 16.1-111.5 27.9c4-53.9 34.8-100.4 79.2-126.3c18.8-11 32.3-31.6 32.3-55.9L176 48zM320 157.7L320 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L304 0 144 0 120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l8 0 0 109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z',
  ],
};
const faFlaskPotion = faFlaskRoundPotion;
const faFaceShush = {
  prefix: 'far',
  iconName: 'face-shush',
  icon: [
    512,
    512,
    [],
    'e38c',
    'M48 256c0 73.6 38.3 138.3 96 175.3l0 .7 0 24c0 11.8 2.3 23.1 6.5 33.3C61.8 449.1 0 359.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 82.2-38.8 155.4-99 202.3c6.4-18.5 2.7-39.4-10.4-54.7C440.5 365.9 464 313.7 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256zm299.3-4.7c-8.7 8.7-20.5 17.7-35.3 24.6l0-27.9c0-2.8-.2-5.6-.6-8.4c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200 248l0 27.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c-.4 2.7-.6 5.5-.6 8.4zM176.4 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM280 248l0 72-48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 408l0 11.5L287.6 464l10 0c7.1 0 13.9-3.2 18.4-8.6l25.6-30.7c8.5-10.2 23.6-11.6 33.8-3.1s11.6 23.6 3.1 33.8l-25.6 30.7c-13.7 16.4-33.9 25.9-55.3 25.9L280 512l-48 0c-30.9 0-56-25.1-56-56l0-24 0-24c0-30.9 25.1-56 56-56l32 0c30.9 0 56 25.1 56 56l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8z',
  ],
};
const faWorm = {
  prefix: 'far',
  iconName: 'worm',
  icon: [
    512,
    512,
    [],
    'e599',
    'M400 192l0 176c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-48c0-53-43-96-96-96s-96 43-96 96l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48c0 53 43 96 96 96s96-43 96-96l0-176 0-72 0-24c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0 48 0 0 48zM176 176c15.9 0 31.2 2.6 45.5 7.3c27.7 9.2 51.7 26.6 69 49.3c5.1 6.7 9.6 13.8 13.5 21.3c10.2 19.8 16 42.2 16 66l0 20.3 0 27.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-27.7 0-20.3 0-76.9 0-3.1 0-48-16 0c-6.3 0-12.5-.6-18.5-1.8c-27.6-5.4-51-22.6-64.7-46.2c-8.2-14.1-12.8-30.5-12.8-48c0-53 43-96 96-96l48 0c53 0 96 43 96 96l0 24 0 72 0 176c0 79.5-64.5 144-144 144c-55.7 0-104.1-31.7-128-78c-10.2-19.8-16-42.2-16-66l0-20.3 0-27.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 27.7 0 20.3 0 76.9 0 3.1c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-79.5 64.5-144 144-144zM376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faHouseCircleXmark = {
  prefix: 'far',
  iconName: 'house-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e50b',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z',
  ],
};
const faPlug = {
  prefix: 'far',
  iconName: 'plug',
  icon: [
    384,
    512,
    [128268],
    'f1e6',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c77-11.6 136-78 136-158.2l0-64 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 64c0 61.9-50.1 112-112 112z',
  ],
};
const faCalendarCircleExclamation = {
  prefix: 'far',
  iconName: 'calendar-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e46e',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faSquareI = {
  prefix: 'far',
  iconName: 'square-i',
  icon: [
    448,
    512,
    [],
    'e272',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faChevronUp = {
  prefix: 'far',
  iconName: 'chevron-up',
  icon: [
    512,
    512,
    [],
    'f077',
    'M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z',
  ],
};
const faFaceSaluting = {
  prefix: 'far',
  iconName: 'face-saluting',
  icon: [
    640,
    512,
    [129761],
    'e484',
    'M266.6 14C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1l-3.3 2.4s0 0 0 0l-9.9 7.2-14.2 10.4L128 185.8l0-39.1L258.1 58.5c14.6-9.9 18.4-29.8 8.5-44.4zm31.8-8.4c7.2 15.7 7.4 33.4 1.6 48.9c16.6-4.3 34-6.5 52-6.5c114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2c-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-18.4 0-36.3 1.9-53.5 5.6zM256 180.5c-.4 13.7-5.1 27.1-13.8 38.2c4.4 12.4 16.2 21.4 30.2 21.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-6 0-11.6 1.6-16.3 4.5zm13.4 152.6c-11-7.4-25.9-4.6-33.3 6.4s-4.6 25.9 6.4 33.3C265 388.1 301.7 403 352 403s87-14.9 109.5-30.2c11-7.4 13.8-22.4 6.4-33.3s-22.4-13.8-33.3-6.4C419.9 343 392.6 355 352 355s-67.9-12-82.5-21.9zM432.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faGaugeSimpleLow = {
  prefix: 'far',
  iconName: 'gauge-simple-low',
  icon: [
    512,
    512,
    ['tachometer-slow'],
    'f62c',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56s-56-25.1-56-56z',
  ],
};
const faTachometerSlow = faGaugeSimpleLow;
const faFacePersevering = {
  prefix: 'far',
  iconName: 'face-persevering',
  icon: [
    512,
    512,
    [],
    'e385',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
  ],
};
const faCircleCamera = {
  prefix: 'far',
  iconName: 'circle-camera',
  icon: [
    512,
    512,
    ['camera-circle'],
    'e103',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm196-96l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6l62.7 0c10 0 19 6.2 22.5 15.6L316 160l36 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l36 0zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faCameraCircle = faCircleCamera;
const faHandSpock = {
  prefix: 'far',
  iconName: 'hand-spock',
  icon: [
    576,
    512,
    [128406],
    'f259',
    'M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512l-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8l33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z',
  ],
};
const faSpiderWeb = {
  prefix: 'far',
  iconName: 'spider-web',
  icon: [
    576,
    512,
    [128376],
    'f719',
    'M137.5 23.6C141.6 12.7 153 6.3 164.4 8.4l69 12.9c36.1 6.8 73 6.8 109.1 0l69-12.9c11.5-2.1 22.8 4.2 26.9 15.2l28.9 77.2c11.7 31.1 28.5 60 49.8 85.6l45.3 54.3c7.4 8.9 7.4 21.8 0 30.7l-45.3 54.3c-21.3 25.5-38.1 54.5-49.8 85.6l-28.9 77.2c-4.1 10.9-15.4 17.3-26.9 15.2l-69-12.9c-36.1-6.8-73-6.8-109.1 0l-69 12.9c-11.5 2.1-22.8-4.2-26.9-15.2l-28.9-77.2c-11.7-31.1-28.5-60-49.8-85.6L13.6 271.4c-7.4-8.9-7.4-21.8 0-30.7l45.3-54.3c21.3-25.5 38.1-54.5 49.8-85.6l28.9-77.2zm27 64.7l-11 29.3c-13.6 36.2-33.1 69.8-57.8 99.4L83.2 232l49.8 0c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L164.5 88.3zm42.1-23.1l24 41.9c37.7 9.5 77.2 9.5 114.9 0l24-41.9-18 3.4c-41.9 7.9-84.9 7.9-126.8 0l-18-3.4zM411.5 88.3l-24.8 43.3 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4l49.8 0-12.5-14.9c-24.7-29.7-44.3-63.3-57.8-99.4l-11-29.3zM492.8 280L443 280c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 24.2 42.4 11-29.3c13.6-36.2 33.1-69.8 57.8-99.4L492.8 280zM369.4 446.8l-22.1-38.7c-37.9-11.7-78.3-12.8-116.7-3.2l-24 41.9 18-3.4c41.9-7.9 84.9-7.9 126.8 0l18 3.4zM164.5 423.7l24.8-43.3-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4l-49.8 0 12.5 14.9c24.7 29.7 44.3 63.3 57.8 99.4l11 29.3zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280l-53.4 0zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7l-53.8 0 27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232l53.4 0zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1l53.4 0-26.9-47.1z',
  ],
};
const faCircleMicrophone = {
  prefix: 'far',
  iconName: 'circle-microphone',
  icon: [
    512,
    512,
    ['microphone-circle'],
    'e116',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112zm-56 88c13.3 0 24 10.7 24 24c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3 10.7-24 24-24s24 10.7 24 24c0 62.5-44.8 114.5-104 125.8l0 10.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.2C172.8 370.5 128 318.5 128 256c0-13.3 10.7-24 24-24z',
  ],
};
const faMicrophoneCircle = faCircleMicrophone;
const faBookArrowUp = {
  prefix: 'far',
  iconName: 'book-arrow-up',
  icon: [
    448,
    512,
    [],
    'e0ba',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l96 0 0-48-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-48-96 0c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8l-88 0 0 48 64 0 0 64-64 0 0 48 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zm55 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L216 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-278.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z',
  ],
};
const faPopsicle = {
  prefix: 'far',
  iconName: 'popsicle',
  icon: [
    320,
    512,
    [],
    'e43e',
    'M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160l0 176 88 0 0-152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 152 88 0 0-176zM136 384l-88 0c-26.5 0-48-21.5-48-48L0 160C0 71.6 71.6 0 160 0s160 71.6 160 160l0 176c0 26.5-21.5 48-48 48l-88 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z',
  ],
};
const faCommand = {
  prefix: 'far',
  iconName: 'command',
  icon: [
    512,
    512,
    [],
    'e142',
    'M0 92C0 41.2 41.2 0 92 0s92 41.2 92 92l0 44 144 0 0-44c0-50.8 41.2-92 92-92s92 41.2 92 92l0 4c0 53-43 96-96 96l-40 0 0 128 40 0c53 0 96 43 96 96l0 4c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-44-144 0 0 44c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-4c0-53 43-96 96-96l40 0 0-128-40 0C43 192 0 149 0 96l0-4zm136 52l0-8 0-44c0-24.3-19.7-44-44-44S48 67.7 48 92l0 4c0 26.5 21.5 48 48 48l40 0zm48 176l0 8 144 0 0-8 0-128 0-8-144 0 0 8 0 128zm-48 48l-40 0c-26.5 0-48 21.5-48 48l0 4c0 24.3 19.7 44 44 44s44-19.7 44-44l0-44 0-8zm240 8l0 44c0 24.3 19.7 44 44 44s44-19.7 44-44l0-4c0-26.5-21.5-48-48-48l-40 0 0 8zm0-232l40 0c26.5 0 48-21.5 48-48l0-4c0-24.3-19.7-44-44-44s-44 19.7-44 44l0 44 0 8z',
  ],
};
const faBlinds = {
  prefix: 'far',
  iconName: 'blinds',
  icon: [
    512,
    512,
    [],
    'f8fb',
    'M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24c0 8.6-4.5 16.2-11.4 20.4l11 57.6c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L224 128l0-48 234.6 0-6.1-32L192 48l0 116.1c28 9.9 48 36.6 48 67.9c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9L144 48 59.5 48 53.4 80 112 80l0 48-90.1 0C9.8 128 0 118.2 0 106.1c0-1.4 .1-2.8 .4-4.1l11-57.6C4.5 40.2 0 32.6 0 24zM66.8 208C65 215.7 64 223.7 64 232s1 16.3 2.8 24l-44.9 0C9.8 256 0 246.2 0 234.1c0-1.4 .1-2.8 .4-4.1l13.3-70 48.9 0-9.1 48 13.3 0zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24l189.3 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9l-220.9 0zM168 336l290.6 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L21.9 384C9.8 384 0 374.2 0 362.1c0-1.4 .1-2.8 .4-4.1l13.3-70 48.9 0-9.1 48L168 336zM13.7 416l48.9 0-9.1 48 405.1 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L21.9 512C9.8 512 0 502.2 0 490.1c0-1.4 .1-2.8 .4-4.1l13.3-70zM168 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faStopwatch = {
  prefix: 'far',
  iconName: 'stopwatch',
  icon: [
    448,
    512,
    [9201],
    'f2f2',
    'M144 24c0-13.3 10.7-24 24-24L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 49.4c43.4 5 82.8 23.3 113.8 50.9L391 119c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31c24 33.9 38.1 75.3 38.1 120c0 114.9-93.1 208-208 208S16 418.9 16 304C16 197.2 96.4 109.3 200 97.4L200 48l-32 0c-13.3 0-24-10.7-24-24zm80 440a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm24-248l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSaxophone = {
  prefix: 'far',
  iconName: 'saxophone',
  icon: [
    640,
    512,
    [127927],
    'f8dc',
    'M514.5 32c-23.3 0-45.7 9.3-62.2 25.8L448 62.1l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L400 110l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L352 158l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-90.6 90.6L265 176c12.8-.5 23-11.1 23-24c0-13.3-10.7-24-24-24l-16 0L56 128l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l2.1 0L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480l9.1 0c51.9 0 101.2-22.7 134.9-62.2l224.5-263c1.5-1.8 3.7-2.8 6.1-2.8l50.6 0c25.8 0 46.6-20.9 46.6-46.6c0-12.4-4.9-24.2-13.7-33L611.7 57.8C595.2 41.3 572.8 32 549.5 32l-35 0zM75.3 176l138.8 0L178.5 276.7c-1.7 4.7-2.5 9.7-2.5 14.8c0 24.5 19.9 44.4 44.4 44.4l2.3 0c12.4 0 24.2-4.9 33-13.6l112.1-112c.4-.4 .9-.8 1.3-1.2s.8-.8 1.2-1.3L416 161.9c.3-.3 .7-.6 1-1s.6-.7 1-1l46.4-46.3c.2-.2 .5-.4 .7-.7s.4-.4 .6-.7l20.6-20.6c7.5-7.5 17.7-11.7 28.3-11.7l35 0c10.6 0 20.8 4.2 28.3 11.7L590.1 104l-47.3 0c-16.4 0-32 7.2-42.6 19.6l-224.5 263c-24.6 28.8-60.5 45.4-98.3 45.4l-9.1 0C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1L75.3 176zM136 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faSquare2 = {
  prefix: 'far',
  iconName: 'square-2',
  icon: [
    448,
    512,
    [],
    'e257',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm190.7 88.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z',
  ],
};
const faFieldHockeyStickBall = {
  prefix: 'far',
  iconName: 'field-hockey-stick-ball',
  icon: [
    512,
    512,
    [127953, 'field-hockey'],
    'f44c',
    'M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM398.1 162.6L213 425.4c-16.9 24-44.4 38.3-73.7 38.4c-50.5 .1-91.1-41.4-90.7-91.6c.1-12.4 2.7-24.8 7.8-36.1l17-38.5c3.6-8.1 13-11.7 21.1-8.2s11.7 13 8.2 21.1l-17 38.5c-3.2 7.3-5 15.4-5 23.5c-.3 32.7 26.2 59.5 58.6 59.4c19-.1 36.7-9.3 47.6-24.8L372.5 143.4l25.6 19.2zM432 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160z',
  ],
};
const faFieldHockey = faFieldHockeyStickBall;
const faArrowUpSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-up-square-triangle',
  icon: [
    576,
    512,
    ['sort-shapes-up-alt'],
    'f88b',
    'M528 454.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9zM368 80l0 96 96 0 0-96-96 0zm94.4 352L416 354.6 369.6 432l92.8 0zM320 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z',
  ],
};
const faSortShapesUpAlt = faArrowUpSquareTriangle;
const faFaceScream = {
  prefix: 'far',
  iconName: 'face-scream',
  icon: [
    640,
    512,
    [],
    'e38b',
    'M528 256c0 15.2-1.6 30-4.7 44.3c14.9-9.7 33-13.9 50.7-11.7c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c17.7-2.2 35.7 2 50.7 11.7C113.6 286 112 271.2 112 256c0-114.9 93.1-208 208-208s208 93.1 208 208zM320 464c-41.6 0-80.4-12.2-112.9-33.3c6.9 20.3 11.7 41.1 14.8 61.8C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c3.1-20.7 7.9-41.5 14.8-61.8C400.5 451.8 361.7 464 320 464zM536.7 330.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3c-16.4-10.6-37.6-8.8-51.8 3.1zM183.3 282.7c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7zM320 304c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48zm46.6-61c22.5 36.9 62.8 54.7 90.1 39.8s31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9z',
  ],
};
const faSquareM = {
  prefix: 'far',
  iconName: 'square-m',
  icon: [
    448,
    512,
    [],
    'e276',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm139.5 41.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2 144 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z',
  ],
};
const faCameraWeb = {
  prefix: 'far',
  iconName: 'camera-web',
  icon: [
    448,
    512,
    ['webcam'],
    'f832',
    'M224 384a168 168 0 1 0 0-336 168 168 0 1 0 0 336zm0 48c-29.1 0-56.9-5.8-82.2-16.2L104.7 464l238.5 0-37.1-48.2C280.9 426.2 253.1 432 224 432zM440 216c0 72.8-36 137.2-91.3 176.4l62.3 81c5.6 7.2 6.5 17 2.5 25.2s-12.4 13.4-21.5 13.4L56 512c-9.1 0-17.5-5.2-21.5-13.4s-3.1-18 2.5-25.2l62.3-81C44 353.2 8 288.8 8 216C8 96.7 104.7 0 224 0S440 96.7 440 216zm-144 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-192 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z',
  ],
};
const faWebcam = faCameraWeb;
const faCommentArrowDown = {
  prefix: 'far',
  iconName: 'comment-arrow-down',
  icon: [
    512,
    512,
    [],
    'e143',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 110.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 152z',
  ],
};
const faLightbulbCfl = {
  prefix: 'far',
  iconName: 'lightbulb-cfl',
  icon: [
    320,
    512,
    [],
    'e5a6',
    'M165.8 47.3l-128 32C25 82.5 11.9 74.7 8.7 61.8S13.3 35.9 26.2 32.7l128-32c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1zM311.3 82.2c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zm0 96c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zM144 384l80 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-40 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-40 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l0-77.8 48-12 0 89.8zM311.3 274.2c3.2 12.9-4.6 25.9-17.5 29.1l-64 16-5.8 1.5 0 63.3-48 0 0-81.4c-.3-11 7.1-21.1 18.2-23.9l8-2s0 0 0 0l16-4 64-16c12.9-3.2 25.9 4.6 29.1 17.5z',
  ],
};
const faWindowFrameOpen = {
  prefix: 'far',
  iconName: 'window-frame-open',
  icon: [
    512,
    512,
    [],
    'e050',
    'M432 240l-152 0 0-192 136 0c8.8 0 16 7.2 16 16l0 176zm-200 0L80 240 80 64c0-8.8 7.2-16 16-16l136 0 0 192zm248 48l0-48 0-176c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 176 0 48 48 0 352 0 48 0zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 400 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-144-48 0 0 144L80 464l0-144-48 0 0 144-8 0z',
  ],
};
const faFaceKiss = {
  prefix: 'far',
  iconName: 'face-kiss',
  icon: [
    512,
    512,
    [128535, 'kiss'],
    'f596',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faKiss = faFaceKiss;
const faBridgeCircleXmark = {
  prefix: 'far',
  iconName: 'bridge-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4cb',
    'M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faPeriod = {
  prefix: 'far',
  iconName: 'period',
  icon: [192, 512, [], '2e', 'M96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'],
};
const faFaceGrinTongue = {
  prefix: 'far',
  iconName: 'face-grin-tongue',
  icon: [
    512,
    512,
    [128539, 'grin-tongue'],
    'f589',
    'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-52.4c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27l0 52.5c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faGrinTongue = faFaceGrinTongue;
const faUpToDottedLine = {
  prefix: 'far',
  iconName: 'up-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e457',
    'M114.2 288L224 178 333.8 288 280 288c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 128c-11.5 0-22.5 4.6-30.6 12.7L77.6 256.8C68.9 265.5 64 277.3 64 289.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM416 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64z',
  ],
};
const faThoughtBubble = {
  prefix: 'far',
  iconName: 'thought-bubble',
  icon: [
    512,
    512,
    [],
    'e32e',
    'M256 0c-48.7 0-91.4 25.6-115.4 64C62.6 65.9 0 129.6 0 208c0 79.5 64.5 144 144 144c9.4 0 18.7-.9 27.6-2.7C193.3 370.7 223.1 384 256 384s62.7-13.3 84.4-34.7c9 1.7 18.2 2.7 27.6 2.7c79.5 0 144-64.5 144-144c0-78.4-62.6-142.1-140.6-144C347.4 25.6 304.7 0 256 0zM176.3 98.7C190.4 68.7 220.8 48 256 48s65.6 20.7 79.7 50.7c4.3 9.1 13.8 14.6 23.8 13.7c2.8-.2 5.6-.4 8.5-.4c53 0 96 43 96 96s-43 96-96 96c-10 0-19.7-1.5-28.7-4.4c-9.6-3-20 .3-26.2 8.3C299.9 325 279.2 336 256 336s-43.9-11-57.1-28.1c-6.1-8-16.6-11.3-26.2-8.3c-9 2.8-18.7 4.4-28.7 4.4c-53 0-96-43-96-96s43-96 96-96c2.9 0 5.7 .1 8.5 .4c10 .9 19.5-4.6 23.8-13.7zM192 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 480A32 32 0 1 0 0 480a32 32 0 1 0 64 0z',
  ],
};
const faSkeletonRibs = {
  prefix: 'far',
  iconName: 'skeleton-ribs',
  icon: [
    640,
    512,
    [],
    'e5cb',
    'M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-42 0c-32.1 0-62.3 17.5-76.7 47.4c-14.1 29.2-34.2 74.3-50.9 124.3C109.8 285.3 96 341.4 96 392l0 11.7c0 42.1 34.2 76.3 76.3 76.3c11.2 0 22.3-2.5 32.5-7.3l70.9-33.4c6.6-3.1 13.4-5.4 20.3-7.1l0 55.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-55.7c6.9 1.6 13.7 4 20.3 7.1l70.9 33.4c10.2 4.8 21.3 7.3 32.5 7.3c42.1 0 76.3-34.2 76.3-76.3l0-11.7c0-50.6-13.8-106.7-30.3-156.3c-16.7-50-36.9-95.1-50.9-124.3C448.3 81.5 418.1 64 386 64l-42 0 0-40zm-48 88l0 60.3L193.6 192.8c9.7-23.7 19.3-44.6 27-60.6c5.9-12.3 18.7-20.2 33.5-20.2l42 0zM173.6 245.8L296 221.3l0 56.7L152.7 319.8c4.9-22.8 11.6-46.1 19.2-68.9c.6-1.7 1.2-3.5 1.8-5.2zM144.8 372.1L296 328l0 55.4c-14 2.2-27.7 6.4-40.7 12.6l-70.9 33.4c-3.8 1.8-7.9 2.7-12.1 2.7c-15.6 0-28.3-12.7-28.3-28.3l0-11.7c0-6.5 .3-13.1 .8-19.9zM344 383.4l0-55.4 151.2 44.1c.5 6.8 .8 13.4 .8 19.9l0 11.7c0 15.6-12.7 28.3-28.3 28.3c-4.2 0-8.3-.9-12.1-2.7l-70.9-33.4c-13.1-6.1-26.8-10.3-40.7-12.6zm143.3-63.6L344 278l0-56.7 122.4 24.5c.6 1.7 1.2 3.5 1.8 5.2c7.6 22.7 14.3 46 19.2 68.9zm-40.9-127L344 172.3l0-60.3 42 0c14.8 0 27.5 7.9 33.5 20.2c7.7 16 17.3 36.9 27 60.6zM0 128L0 232 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256c0-6.5 3.4-12.4 8.9-15.8L94 194c21.1-12.6 34-35.4 34-60l0-6c0-35.3-28.7-64-64-64S0 92.7 0 128zm48 37.6L48 128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 6c0 7.7-4 14.9-10.7 18.8L48 165.6zM576 64c-35.3 0-64 28.7-64 64l0 6c0 24.6 12.9 47.4 34 60l37.1 22.3c5.5 3.3 8.9 9.3 8.9 15.8l0 256c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256 0-104c0-35.3-28.7-64-64-64zm-5.3 88.8c-6.6-4-10.7-11.1-10.7-18.8l0-6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 37.6-21.3-12.8z',
  ],
};
const faRaygun = {
  prefix: 'far',
  iconName: 'raygun',
  icon: [
    576,
    512,
    [],
    'e025',
    'M288 64l-96 0L102.2 4.1C98.2 1.4 93.4 0 88.6 0C75 0 64 11 64 24.6l0 50.2C26.2 92.8 0 131.3 0 176c0 59.3 46.1 107.8 104.4 111.7l-69 137.9c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3l103-206 .2-.3 12.2 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-48 0-128 0-48 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8zM112 112l176 0 0 128-176 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zM392 64c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 60.9 0 77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2l0-96c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144 416 144l0-56c0-13.3-10.7-24-24-24zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM222 288.3L136.8 458.5 85.5 432.8l72.3-144.5 64.2 0z',
  ],
};
const faFlute = {
  prefix: 'far',
  iconName: 'flute',
  icon: [
    640,
    512,
    [],
    'f8b9',
    'M144 304l432 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-432 0 0 96zm-48 0l0-96-32 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0zM64 160l32 0 24 0 24 0 432 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-432 0-24 0-24 0-32 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faAcorn = {
  prefix: 'far',
  iconName: 'acorn',
  icon: [
    448,
    512,
    [],
    'f6ae',
    'M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8L224 16c-10.7 14.3-18 30.7-21.6 48L96 64C43 64 0 107 0 160l0 16c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-16c0-53-43-96-96-96l-99.9 0c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4zM400 160L48 160c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240l-48.1 0c-3.9 65.7-32.7 150.2-127.5 188.9C129.2 390.2 100.3 305.7 96.5 240l-48.1 0z',
  ],
};
const faVideoArrowUpRight = {
  prefix: 'far',
  iconName: 'video-arrow-up-right',
  icon: [
    576,
    512,
    [],
    'e2c9',
    'M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM152 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0L103 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l103-103 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z',
  ],
};
const faGrateDroplet = {
  prefix: 'far',
  iconName: 'grate-droplet',
  icon: [
    576,
    512,
    [],
    'e194',
    'M0 88C0 57.1 25.1 32 56 32l72 0 96 0 96 0 72 0c30.9 0 56 25.1 56 56l0 74.2c-15.1 4.3-28.2 14.6-35.8 28.8L400 214l0-126c0-4.4-3.6-8-8-8l-48 0 0 152 46.4 0L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80L320 480l-96 0-96 0-72 0c-30.9 0-56-25.1-56-56L0 256 0 88zm56-8c-4.4 0-8 3.6-8 8l0 144 56 0 0-152L56 80zM48 424c0 4.4 3.6 8 8 8l48 0 0-152-56 0 0 144zm152 8l0-152-48 0 0 152 48 0zm96 0l0-152-48 0 0 152 48 0zM248 80l0 152 48 0 0-152-48 0zM200 232l0-152-48 0 0 152 48 0zm240.5-25.9c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z',
  ],
};
const faSealExclamation = {
  prefix: 'far',
  iconName: 'seal-exclamation',
  icon: [
    512,
    512,
    [],
    'e242',
    'M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1l64 0 0 64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9l0 64.9-64.9 0c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1L112 400l0-64.9c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9l0-64 64 0zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64l-64 0c-26.5 0-48 21.5-48 48l0 64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1 64 400c0 26.5 21.5 48 48 48l64.9 0 45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448l64.9 0c26.5 0 48-21.5 48-48l0-64.9 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L289.9 17.9zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faChessBishop = {
  prefix: 'far',
  iconName: 'chess-bishop',
  icon: [
    320,
    512,
    [9821],
    'f43a',
    'M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8L48 352l48 0 0-27c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3l0 27 48 0 0-13.3c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24L160 0 104 0zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z',
  ],
};
const faMessageSms = {
  prefix: 'far',
  iconName: 'message-sms',
  icon: [
    512,
    512,
    [],
    'e1e5',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM372.8 144c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9z',
  ],
};
const faCoffeeBeans = {
  prefix: 'far',
  iconName: 'coffee-beans',
  icon: [
    512,
    512,
    [],
    'e13f',
    'M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-46.6-46.7c3.5 4.1 7 9.2 10.4 14.9c-25.8 22.7-83.8 25-133.5-24.7c-28-28-39.5-58.7-40.1-84.8c27.8 29.1 60 40.6 87.3 50.3l1.4 .5c30.2 10.8 54.3 19.8 74.6 43.8zm-10-123c28 28 39.5 58.7 40.1 84.8c-27.8-29.1-60-40.6-87.3-50.3l-1.4-.5c-30.2-10.8-54.3-19.8-74.6-43.8c-3.5-4.1-7-9.2-10.4-14.9c25.8-22.7 83.8-25 133.5 24.7zM128.1 446c-.4 5.4-1.6 11.5-3.1 17.9C90.7 461.7 48 422.3 48 352c0-39.7 13.6-69.5 31.6-88.3c-.9 40.2 13.7 71.1 26.1 97.3l.6 1.3c13.7 29 24.4 52.4 21.8 83.7zM208 352c0 39.7-13.6 69.5-31.6 88.3c.9-40.2-13.7-71.1-26.1-97.3l-.6-1.3c-13.7-29-24.4-52.4-21.8-83.7c.4-5.4 1.6-11.5 3.1-17.9C165.3 242.3 208 281.7 208 352zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z',
  ],
};
const faHatWitch = {
  prefix: 'far',
  iconName: 'hat-witch',
  icon: [
    576,
    512,
    [],
    'f6e7',
    'M148.4 384L96 384l85.9-196.3C198.8 149 228 116.9 265 96.5l170.4-94c3-1.7 6.4-2.5 9.9-2.5c7 0 13.7 2.4 19.1 6.7L564 86.4c7.6 6.1 12 15.3 12 25l0 9.6c0 4.6-1 9.2-2.9 13.4l-39.1 84.7c-3.6 7.9-11.5 12.9-20.1 12.9c-10.4 0-19.4-7.2-21.7-17.4l-8-35.9C481.7 167.8 472 160 460.8 160c-8 0-15.5 4-19.9 10.7l-19.5 29.3c-3.5 5.3-5.4 11.5-5.4 17.8c0 4.1 .8 8.2 2.3 11.9L480 384l-51.7 0L373.7 247.5s0 0 0 0c-3.8-9.5-5.7-19.7-5.7-29.8c0-15.7 4.6-31.2 13.4-44.5L401 144c13.3-20 35.8-32 59.8-32c22.8 0 43.6 10.7 56.9 27.9l9.8-21.2L444.6 52.3 288.2 138.6c-27.7 15.3-49.7 39.3-62.4 68.4L148.4 384zM240 336c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 48-96 0 0-48zm313.4 80c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.7-6.9 15.6C550.1 470.3 493.4 512 416 512l-256 0C82.6 512 25.9 470.3 6.9 454.2C2.4 450.4 0 444.6 0 438.6C0 426.1 10.1 416 22.6 416l530.7 0z',
  ],
};
const faFaceGrinWink = {
  prefix: 'far',
  iconName: 'face-grin-wink',
  icon: [
    512,
    512,
    ['grin-wink'],
    'f58c',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z',
  ],
};
const faGrinWink = faFaceGrinWink;
const faClockThreeThirty = {
  prefix: 'far',
  iconName: 'clock-three-thirty',
  icon: [
    512,
    512,
    [],
    'e357',
    'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-136c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faEarDeaf = {
  prefix: 'far',
  iconName: 'ear-deaf',
  icon: [
    512,
    512,
    ['deaf', 'deafness', 'hard-of-hearing'],
    'f2a4',
    'M505 41l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM185 361L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L151 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm55-249c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40z',
  ],
};
const faDeaf = faEarDeaf;
const faDeafness = faEarDeaf;
const faHardOfHearing = faEarDeaf;
const faAlarmClock = {
  prefix: 'far',
  iconName: 'alarm-clock',
  icon: [
    512,
    512,
    [9200],
    'f34e',
    'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1z',
  ],
};
const faEclipse = {
  prefix: 'far',
  iconName: 'eclipse',
  icon: [
    640,
    512,
    [],
    'f749',
    'M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-15.8-6.6-30.6-15.1-44.2-25.2l-4.5 24.4L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 4.5 24.4C353.2 79.1 368 70.6 383.9 64l-8.2-44.3zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c10.4 0 20.5-1.4 30.1-4.1c-8.4-13.9-15.3-28.9-20.3-44.6c-3.2 .5-6.5 .7-9.8 .7c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.3 0 6.6 .3 9.8 .7c5-15.8 11.9-30.7 20.3-44.6c-9.6-2.7-19.7-4.1-30.1-4.1zm80 112a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z',
  ],
};
const faFaceRelieved = {
  prefix: 'far',
  iconName: 'face-relieved',
  icon: [
    512,
    512,
    [],
    'e389',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm158.7-91c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 285.2 371 292 351.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 285.2 179 292 159.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zm73-135.4c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z',
  ],
};
const faRoadCircleCheck = {
  prefix: 'far',
  iconName: 'road-circle-check',
  icon: [
    640,
    512,
    [],
    'e564',
    'M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faDiceFive = {
  prefix: 'far',
  iconName: 'dice-five',
  icon: [
    448,
    512,
    [9860],
    'f523',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faOctagonMinus = {
  prefix: 'far',
  iconName: 'octagon-minus',
  icon: [
    512,
    512,
    ['minus-octagon'],
    'f308',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMinusOctagon = faOctagonMinus;
const faSquareRss = {
  prefix: 'far',
  iconName: 'square-rss',
  icon: [
    448,
    512,
    ['rss-square'],
    'f143',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 40c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faRssSquare = faSquareRss;
const faFaceZany = {
  prefix: 'far',
  iconName: 'face-zany',
  icon: [
    512,
    512,
    [],
    'e3a4',
    'M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6c-4.1-10.7-6.4-22.4-6.4-34.6l0-7.8c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165l0 24.3c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152zM384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1c-7.8 2.1-16 3.2-24.5 3.2c-1.9 0-3.7-.1-5.6-.2c-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7zM296.4 160c-11.1 0-20.4-7.5-23.2-17.7c-.8 3.1-1.2 6.4-1.2 9.7c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40c-3 0-6 .3-8.8 1c9.9 2.9 17.2 12.1 17.2 23c0 13.3-10.7 24-24 24zM312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 80 224zm48 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM336 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faTricycle = {
  prefix: 'far',
  iconName: 'tricycle',
  icon: [
    512,
    512,
    [],
    'e5c3',
    'M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l73.6 0c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2l-10.9 0c-58.8 0-114 23.9-154.1 64.6L133.6 176l2.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l21.6 0 44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6l12.1 0 11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32L280 32zm62.2 251.8l18.5 74c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-18.5-74c42 2.5 75.2 37.3 75.2 79.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faLandMineOn = {
  prefix: 'far',
  iconName: 'land-mine-on',
  icon: [
    640,
    512,
    [],
    'e51b',
    'M344 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 336c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 16 31.5 0c19.6 0 37.3 11.9 44.6 30.2l34.4 85.9c8.4 21-7.1 43.9-29.7 43.9l-417.5 0c-22.6 0-38.1-22.9-29.7-43.9l34.4-85.9c7.3-18.2 24.9-30.2 44.6-30.2l31.5 0 0-16zM505.1 464l-25.6-64-319 0-25.6 64 370.2 0zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z',
  ],
};
const faSquareArrowUpLeft = {
  prefix: 'far',
  iconName: 'square-arrow-up-left',
  icon: [
    448,
    512,
    [],
    'e263',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm288 48c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135L160 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24l152 0z',
  ],
};
const faICursor = {
  prefix: 'far',
  iconName: 'i-cursor',
  icon: [
    256,
    512,
    [],
    'f246',
    'M.1 22.2c-1 13.2 8.9 24.8 22.1 25.8l15.4 1.2C75 52 104 83.3 104 120.9L104 232l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 111.1c0 37.6-29 68.9-66.5 71.8l-15.4 1.2C8.9 465.1-.9 476.6 .1 489.8s12.6 23.1 25.8 22.1l15.4-1.2c35.7-2.7 66.7-20.9 86.8-47.6c20.1 26.7 51.1 44.9 86.8 47.6l15.4 1.2c13.2 1 24.8-8.9 25.8-22.1s-8.9-24.8-22.1-25.8l-15.4-1.2C181 460 152 428.7 152 391.1L152 280l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-111.1c0-37.6 29-68.9 66.5-71.8l15.4-1.2c13.2-1 23.1-12.6 22.1-25.8S243.4-.9 230.2 .1L214.8 1.3C179.1 4 148.1 22.2 128 48.9C107.9 22.2 76.9 4 41.2 1.3L25.8 .1C12.6-.9 1.1 8.9 .1 22.2z',
  ],
};
const faChartMixedUpCircleDollar = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [
    576,
    512,
    [],
    'e5d9',
    'M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.5 0L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7l0 55.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L408 0zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
  ],
};
const faSaltShaker = {
  prefix: 'far',
  iconName: 'salt-shaker',
  icon: [
    384,
    512,
    [129474],
    'e446',
    'M325.2 464L58.8 464c-6 0-10.8-4.8-10.8-10.8c0-.6 .1-1.3 .2-1.9L94.5 192l195.1 0 46.3 259.3c.1 .6 .2 1.3 .2 1.9c0 6-4.8 10.8-10.8 10.8zM58.8 512l266.4 0c32.5 0 58.8-26.3 58.8-58.8c0-3.5-.3-6.9-.9-10.3L323.7 110.3C312.3 46.5 256.8 0 192 0S71.7 46.5 60.3 110.3L.9 442.9c-.6 3.4-.9 6.9-.9 10.3C0 485.7 26.3 512 58.8 512zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faStamp = {
  prefix: 'far',
  iconName: 'stamp',
  icon: [
    512,
    512,
    [],
    'f5bf',
    'M299.3 116.7c3-6.2 4.7-13.2 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 7.5 1.7 14.5 4.7 20.7l.3 .6c7 14.6 19 39.6 19 68.7c0 65.2-52.8 118-118 118l-18 0c-26.5 0-48 21.5-48 48l0 8c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-8c0-26.5-21.5-48-48-48l-18 0c-65.2 0-118-52.8-118-118c0-29 12-54.1 19-68.6c0 0 0 0 0 0l.3-.6zm43.3 20.8C335.2 152.9 328 168.9 328 186c0 38.7 31.4 70 70 70l18 0c53 0 96 43 96 96l0 8c0 30.9-25.1 56-56 56L56 416c-30.9 0-56-25.1-56-56l0-8c0-53 43-96 96-96l18 0c38.7 0 70-31.3 70-70c0-17.1-7.2-33.1-14.6-48.5c-6-12.6-9.4-26.6-9.4-41.5c0-53 43-96 96-96s96 43 96 96c0 14.9-3.4 28.9-9.4 41.5zM32 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32z',
  ],
};
const faFilePlus = {
  prefix: 'far',
  iconName: 'file-plus',
  icon: [
    384,
    512,
    [],
    'f319',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM192 208c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z',
  ],
};
const faDrawSquare = {
  prefix: 'far',
  iconName: 'draw-square',
  icon: [
    448,
    512,
    [],
    'f5ef',
    'M64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 43.3l0 201.3c16 6.5 28.9 19.3 35.3 35.3l201.3 0c6.5-16 19.3-28.9 35.3-35.3l0-201.3c-16-6.5-28.9-19.3-35.3-35.3l-201.3 0c-6.5 16-19.3 28.9-35.3 35.3zM123.3 440c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-201.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40l201.3 0c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64c0 26.9-16.5 49.9-40 59.3l0 201.3c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40l-201.3 0zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm320 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faToiletPaperUnderSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-under-slash',
  icon: [
    640,
    512,
    ['toilet-paper-reverse-slash'],
    'e2a1',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 192c0-49.5-10.5-95.4-28.5-129.9C530 28.7 501.7 0 464 0L176 0c-33.8 0-60 23-77.6 51.8L38.8 5.1zm97.7 76.6c14-25.4 29-33.7 39.5-33.7l212.7 0c-3 4.5-5.7 9.3-8.2 14.1C362.5 96.6 352 142.5 352 192c0 22 2.1 43.3 6 63.3L136.5 81.7zM460.6 335.7l-30.2-23.7c-2.5-3.6-5-7.7-7.4-12.4c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C437.4 56.9 453.1 48 464 48s26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3c-1.1 0-2.2-.1-3.4-.3zm45.1 35.3c8.2-5.4 15.6-12.2 22.3-20l0 37.5-22.3-17.5zm21.7 140.5L467.1 464 280 464c-4.4 0-8-3.6-8-8l0-40-48 0 0 40c0 30.9 25.1 56 56 56l240 0c2.5 0 5-.2 7.4-.5zM304.6 336L176 336c-10.9 0-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7c0-2.6 0-5.1 .1-7.7L66.8 148.6c-1.8 14-2.8 28.6-2.8 43.4c0 49.5 10.5 95.4 28.5 129.9C110 355.3 138.3 384 176 384l189.5 0-60.9-48zM488 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z',
  ],
};
const faToiletPaperReverseSlash = faToiletPaperUnderSlash;
const faStairs = {
  prefix: 'far',
  iconName: 'stairs',
  icon: [
    576,
    512,
    [],
    'e289',
    'M384 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L432 80l0 120c0 13.3-10.7 24-24 24l-104 0 0 104c0 13.3-10.7 24-24 24l-104 0 0 104c0 13.3-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0 0-104c0-13.3 10.7-24 24-24l104 0 0-104c0-13.3 10.7-24 24-24l104 0 0-120z',
  ],
};
const faDroneFront = {
  prefix: 'far',
  iconName: 'drone-front',
  icon: [
    640,
    512,
    ['drone-alt'],
    'f860',
    'M136 96c10.4 0 19.3 6.7 22.6 16L264 112c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 160c-13.3 0-24-10.7-24-24s10.7-24 24-24l89.4 0c3.3-9.3 12.2-16 22.6-16zm345.4 16c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16l89.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l105.4 0zM112 256l0-64 48 0 0 49.6 10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7 0-49.6 48 0 0 64c0 8.9-4.9 17.1-12.8 21.2l-51.6 27.3 4.5 5.4c18 21.6 27.8 48.8 27.8 76.8l0 5.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-5.2c0-16.8-5.9-33.2-16.7-46.1l-11-13.2-41.1 21.7c-3.5 1.8-7.3 2.8-11.2 2.8l-96 0c-3.9 0-7.8-1-11.2-2.8l-41.1-21.7-11 13.2c-10.8 12.9-16.7 29.3-16.7 46.1l0 5.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-5.2c0-28.1 9.8-55.3 27.8-76.8l4.5-5.4-51.6-27.3c-7.9-4.2-12.8-12.3-12.8-21.2zm307.3 17.7l-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304l84.1 0 57.2-30.3z',
  ],
};
const faDroneAlt = faDroneFront;
const faGlassEmpty = {
  prefix: 'far',
  iconName: 'glass-empty',
  icon: [
    384,
    512,
    [],
    'e191',
    'M6.3 7.8C10.9 2.8 17.3 0 24 0L360 0c6.7 0 13.1 2.8 17.7 7.8s6.8 11.6 6.2 18.3L347.7 446.2C344.5 483.4 313.3 512 276 512L108 512c-37.4 0-68.5-28.6-71.7-65.8L.1 26.1C-.5 19.4 1.8 12.7 6.3 7.8zM50.2 48l34 394.1C85.2 454.5 95.6 464 108 464L276 464c12.5 0 22.8-9.5 23.9-21.9L333.8 48 50.2 48z',
  ],
};
const faDialHigh = {
  prefix: 'far',
  iconName: 'dial-high',
  icon: [
    576,
    512,
    [],
    'e15c',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 248l109.4 0c-11 50.3-55.8 88-109.4 88c-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88L288 264c-13.3 0-24 10.7-24 24s10.7 24 24 24zm160-24a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faUserHelmetSafety = {
  prefix: 'far',
  iconName: 'user-helmet-safety',
  icon: [
    448,
    512,
    [128119, 'user-construction', 'user-hard-hat'],
    'f82c',
    'M216 0l16 0c13.3 0 24 10.7 24 24l0 56 28.4-56.9c38 20.4 64.5 59.4 67.3 104.9l.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L96 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l.2 0C99 82.6 125.6 43.5 163.6 23.1L192 80l0-56c0-13.3 10.7-24 24-24zM162 304c-34.9-19.4-59.8-54.6-65-96l48.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l48.6 0c-5.2 41.4-30.1 76.6-65 96c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48l73.4 0 73.4 0 16.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0zM397.1 464c-9.9-36.9-43.5-64-83.5-64l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0z',
  ],
};
const faUserConstruction = faUserHelmetSafety;
const faUserHardHat = faUserHelmetSafety;
const faI = {
  prefix: 'far',
  iconName: 'i',
  icon: [
    320,
    512,
    [105],
    '49',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l112 0 0 352L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-352 112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L160 32 24 32z',
  ],
};
const faHryvniaSign = {
  prefix: 'far',
  iconName: 'hryvnia-sign',
  icon: [
    384,
    512,
    [8372, 'hryvnia'],
    'f6f2',
    'M105.7 104.6C125.6 88.7 150.3 80 175.8 80L227 80c33.7 0 61 27.3 61 61c0 20.7-10.5 39.8-27.5 51L24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l147 0-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l29.8 0C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109l51.2 0c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6L157 432c-33.7 0-61-27.3-61-61c0-12.8 4-24.9 11-35l253 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-177 0 90-48 87 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-36.7 0c8.2-15.4 12.7-32.9 12.7-51c0-60.2-48.8-109-109-109l-51.2 0c-36.4 0-71.7 12.4-100.1 35.1L73 69.3C62.7 77.5 61 92.6 69.3 103s23.4 12 33.7 3.7l2.7-2.2z',
  ],
};
const faHryvnia = faHryvniaSign;
const faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'far',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [
    512,
    512,
    [],
    'e092',
    'M489 57c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L320 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0L489 57zM23 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L72 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L23 455z',
  ],
};
const faPills = {
  prefix: 'far',
  iconName: 'pills',
  icon: [
    576,
    512,
    [],
    'f484',
    'M112 80c35.3 0 64 28.7 64 64l0 112L48 256l0-112c0-35.3 28.7-64 64-64zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 432c-61.9 0-112-50.1-112-112c0-22.2 6.5-43 17.7-60.4L476.4 414.3C459 425.5 438.2 432 416 432zM355.6 225.7C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112c0 22.2-6.5 43-17.7 60.4L355.6 225.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z',
  ],
};
const faFaceGrinWide = {
  prefix: 'far',
  iconName: 'face-grin-wide',
  icon: [
    512,
    512,
    [128515, 'grin-alt'],
    'f581',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z',
  ],
};
const faGrinAlt = faFaceGrinWide;
const faTooth = {
  prefix: 'far',
  iconName: 'tooth',
  icon: [
    448,
    512,
    [129463],
    'f5c9',
    'M64 143.3c0 12.5 2.9 24.9 8.5 36.1l17.1 34.2c8.8 17.7 15.2 36.4 18.9 55.8L139.6 431c.1 .6 .6 1 1.2 1c.5 0 1-.4 1.2-.9l28.4-102.4C177.1 304.6 199 288 224 288s46.9 16.6 53.5 40.7L306 431.1c.1 .5 .6 .9 1.2 .9c.6 0 1.1-.4 1.2-1l31.1-161.6c3.7-19.4 10.1-38.2 18.9-55.8l15.1-30.2c6.9-13.9 10.6-29.2 10.6-44.8c0-32.4-26.3-58.7-58.7-58.7l-10.7 0C298 80 282 85.9 269.4 96.7l-7 6 8.1 6c10.6 8 12.8 23 4.8 33.6s-23 12.8-33.6 4.8l-32-24-32-24-8-6C158.2 84.6 144.3 80 130 80l-2.7 0C92.3 80 64 108.3 64 143.3zm159-70l15.1-13C259.4 42 286.5 32 314.6 32l10.7 0C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2l-15.1 30.2c-6.9 13.7-11.8 28.3-14.7 43.4L355.5 440.1C351 463.3 330.8 480 307.2 480c-22.1 0-41.5-14.7-47.4-36L231.3 341.5c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.3-7.3 5.5L188.3 444c-5.9 21.3-25.3 36-47.4 36c-23.6 0-43.9-16.7-48.3-39.9L61.4 278.5c-2.9-15.1-7.8-29.7-14.7-43.4L29.6 200.8C20.7 183 16 163.3 16 143.3C16 81.8 65.8 32 127.3 32l2.7 0c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z',
  ],
};
const faBasketballHoop = {
  prefix: 'far',
  iconName: 'basketball-hoop',
  icon: [
    640,
    512,
    [],
    'f435',
    'M49.2 209.4C64.9 179.7 144.6 48 320 48s255.1 131.7 270.8 161.4c.7 1.4 1.2 3.1 1.2 5.5l0 116.3c0 6.3-3.7 12.1-9.5 14.6l-60.3 26.8-8 56.1 87.8-39c23.1-10.3 38-33.2 38-58.5l0-116.3c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9L0 331.2c0 25.3 14.9 48.2 38 58.5l87.8 39-8-56.1L57.5 345.8c-5.8-2.6-9.5-8.3-9.5-14.6l0-116.3c0-2.4 .5-4.2 1.2-5.5zM142.1 288l7.3 50.8s0 0 0 0l0 .1 22.9 152c1.1 7.5 6.4 13.8 13.7 16.1s15.2 .3 20.5-5.2l48.7-50.6 50.7 50.9c3.8 3.8 8.8 5.9 14.2 5.9s10.4-2.1 14.2-5.9l50.7-50.9 48.7 50.6c5.3 5.5 13.2 7.5 20.5 5.2s12.6-8.6 13.7-16.1l22.9-152s0 0 0 0l0-.1 7.3-50.8 6.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0-48 0-224 0-48 0-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l6.1 0zm315.4 0l-4.1 28.9L418.6 288l37.4 0 1.5 0zM356 288l.5 .4L320 326.2l-36.4-37.8 .5-.4 71.9 0zm-134.5 0l-34.8 28.9L182.5 288l1.5 0 37.4 0zm61.5 134.4L320 383.9l37.1 38.5L320 459.7l-37.1-37.2zm9.3-67.4l-37.6 39-44.5-44.7L252.7 314l39.5 41.1zM198.1 394l28.8 28.9-21.2 22L198.1 394zm149.7-38.9L387.3 314l42.6 35.4-44.5 44.7-37.6-39zM441.9 394l-7.7 50.9-21.2-22L441.9 394zM208 176l224 0 0 32 48 0 0-40c0-22.1-17.9-40-40-40l-240 0c-22.1 0-40 17.9-40 40l0 40 48 0 0-32z',
  ],
};
const faObjectsAlignBottom = {
  prefix: 'far',
  iconName: 'objects-align-bottom',
  icon: [
    512,
    512,
    [],
    'e3bb',
    'M24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512zM176 336l0-288-64 0 0 288 64 0zm-64 48c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0zm288-48l0-160-64 0 0 160 64 0zm-64 48c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0z',
  ],
};
const faV = {
  prefix: 'far',
  iconName: 'v',
  icon: [
    384,
    512,
    [118],
    '56',
    'M14.7 33.9c12.2-5.1 26.3 .6 31.4 12.8L192 394 337.9 46.7c5.1-12.2 19.2-18 31.4-12.8s18 19.2 12.8 31.4l-168 400c-3.7 8.9-12.5 14.7-22.1 14.7s-18.4-5.8-22.1-14.7L1.9 65.3C-3.3 53.1 2.5 39 14.7 33.9z',
  ],
};
const faSparkles = {
  prefix: 'far',
  iconName: 'sparkles',
  icon: [
    512,
    512,
    [10024],
    'f890',
    'M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z',
  ],
};
const faSquid = {
  prefix: 'far',
  iconName: 'squid',
  icon: [
    512,
    512,
    [129425],
    'e450',
    'M261.5 4.8C265.3 .9 270.7-.8 276 .3L392.2 23.5C422.3 14.4 455.9 6.5 493.4 .2c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9c-6.2 37.1-14 70.4-23 100.3l22.9 118c1 5.3-.7 10.8-4.6 14.5s-9.4 5.3-14.6 4.1l-58.6-13.1c-46 71.9-101.3 103.4-147.8 110.6l16 16 .1 .1 22.5 22.5c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2c19-19 49.8-18.7 68.5 .6l35.5 36.7c6 6.2 6 16.2-.1 22.3l-2.3 2.4c-33.7 34.2-87.4 33.7-120.7 2.4L370 414.4c-18.7 18.7-49.1 18.7-67.9 0L273.7 386c-9.4-9.2-24.4-9.2-33.7 0l-.1 .1-.1 .1c-9.2 9.4-9.2 24.4 0 33.8l.1 .1 5.7 5.7 9.9 9.9c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6l2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-9.9-9.8-.1-.1-22.4-22.4-.1-.1c-10.2-10.1-27-9-35.8 2.3l-15.6 20c-2.7 3.5-4.2 7.7-4.2 12.1c0 10.9 8.8 19.7 19.7 19.7l12.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-12.3 0c-28.6 0-51.7-23.2-51.7-51.7c0-11.5 3.8-22.7 10.9-31.8l21.9-28.2c7.3-9.4 6.5-22.8-1.9-31.2s-21.8-9.3-31.2-1.9L84.4 389.1C75.3 396.2 64.1 400 52.6 400C24.1 400 .9 376.8 .9 348.3L.9 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 12.3c0 10.9 8.8 19.7 19.7 19.7c4.4 0 8.7-1.5 12.1-4.2l20-15.6c11.3-8.8 12.4-25.5 2.4-35.8L64.6 289.9l-.2-.2L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3L27.6 283c-6.1 6.4-16.2 6.7-22.6 .6s-6.7-16.2-.6-22.6l3.3-3.5c18.6-19.6 49.7-20 68.7-.9L93 273.1c9.4 9.2 24.4 9.1 33.8-.2c9.4-9.4 9.4-24.5 0-33.9c0 0 0 0 0 0l-5.7-5.7c0 0 0 0 0 0L98.5 210.7c-18.7-18.7-18.7-49.1 0-67.9l14.3-14.3C81.4 95.2 80.5 41.4 114.3 7.1l2.3-2.4c6.2-6.2 16.2-6.4 22.5-.3l37.6 36.4c19.3 18.6 19.6 49.5 .6 68.5l-56.2 56.2c-6.2 6.2-6.2 16.4 0 22.6l22.6 22.6 2 2 13.9 13.9c7.1-46.7 38.5-102.5 110.6-148.7l-13-58.5c-1.2-5.3 .4-10.8 4.2-14.7zM184.9 296a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM432.3 62C266.7 103.7 228.1 174.4 222.4 215.4c-1.9 13.9 6 30.8 25.1 49.9s36 27 49.9 25.1c41-5.6 111.8-44.3 153.5-209.8c2.8-11.3-7.3-21.5-18.6-18.6z',
  ],
};
const faLeafyGreen = {
  prefix: 'far',
  iconName: 'leafy-green',
  icon: [
    576,
    512,
    [129388],
    'e41d',
    'M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1l0 35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6l0-45.7c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6l0-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5zM526 128c-9.1 35.4-9.7 73.9-6.3 106.9c.2 1.7 .3 3.4 .3 5.1c0 21-13.5 38.9-32.4 45.4c-14.5 5-38.5 13.6-57.7 32.8l-29.1 29.1c-3 3-7.1 4.7-11.3 4.7l-43 0c-29.7 0-58.2 11.8-79.2 32.8l-10.5 10.5c-3 3-7.1 4.7-11.3 4.7l-35.5 0L313 297l41-41 86.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 71-71c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L327 215l-7 7 0-38.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-96 96 0-35.5c0-4.2 1.7-8.3 4.7-11.3l10.5-10.5c21-21 32.8-49.5 32.8-79.2l0-43c0-4.2 1.7-8.3 4.7-11.3l29.1-29.1c19.2-19.2 27.8-43.2 32.8-57.7C297.1 69.5 315 56 336 56c1.7 0 3.5 .1 5.1 .3c33 3.5 71.4 2.8 106.9-6.3c5.1-1.3 10.4-2 16-2c35.3 0 64 28.7 64 64c0 5.6-.7 10.9-2 16zM105 505l38.2-38.2c12-12 28.3-18.7 45.3-18.7l57 0c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7l43 0c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3l0 43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3l0 57c0 17-6.7 33.3-18.7 45.3L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z',
  ],
};
const faCircleArrowUpRight = {
  prefix: 'far',
  iconName: 'circle-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e0fc',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM192 144l152 0c13.3 0 24 10.7 24 24l0 160c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L192 192c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCalendars = {
  prefix: 'far',
  iconName: 'calendars',
  icon: [
    512,
    512,
    [],
    'e0d7',
    'M224 0c13.3 0 24 10.7 24 24l0 40 112 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 48 0 16 0 160c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-160 0-16 0-48c0-35.3 28.7-64 64-64l40 0 0-40c0-13.3 10.7-24 24-24zM144 192l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160-320 0zm-96-8l0 208c0 39.8 32.2 72 72 72l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0C53.7 512 0 458.3 0 392L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faBangladeshiTakaSign = {
  prefix: 'far',
  iconName: 'bangladeshi-taka-sign',
  icon: [
    384,
    512,
    [],
    'e2e6',
    'M26.4 32.1C13.2 30.8 1.4 40.4 .1 53.6s8.3 25 21.5 26.3L44 82.1c20.4 2 36 19.3 36 39.8L80 176l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 168c0 48.6 39.4 88 88 88l32 0c101.6 0 184-82.4 184-184l0-32c0-48.6-39.4-88-88-88l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c22.1 0 40 17.9 40 40l0 32c0 75.1-60.9 136-136 136l-32 0c-22.1 0-40-17.9-40-40l0-168 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-54.1c0-45.2-34.3-83.1-79.2-87.6L26.4 32.1z',
  ],
};
const faBicycle = {
  prefix: 'far',
  iconName: 'bicycle',
  icon: [
    640,
    512,
    [128690],
    'f206',
    'M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.7 0 34.6 64-149.4 0-27.4-38C191 99.7 183.7 96 176 96l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.7 0 22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l49 0c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32L312 32zM454.6 296.3l36.3 67.1c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zM136.9 272.5l-28.1 56.1c-9 18.1 4.1 39.4 24.3 39.4l73.2 0c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9 .5zM166.8 320l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z',
  ],
};
const faHammerWar = {
  prefix: 'far',
  iconName: 'hammer-war',
  icon: [
    384,
    512,
    [],
    'f6e4',
    'M216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 28L36.7 32.4C17.7 29.5 0 44.7 0 64L0 256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6l0-192c0-19.3-17.7-34.5-36.7-31.6L216 52l0-28zm0 276.3l-24-3.6-24 3.6L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-187.7zm-35.9-82.7L48 237.4 48 82.6l132.1 19.8c7.9 1.2 15.9 1.2 23.7 0L336 82.6l0 154.8L203.9 217.6c-7.9-1.2-15.9-1.2-23.7 0z',
  ],
};
const faCircleD = {
  prefix: 'far',
  iconName: 'circle-d',
  icon: [
    512,
    512,
    [],
    'e104',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l72 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-72 0zm72 208l-48 0 0-160 48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
  ],
};
const faSpiderBlackWidow = {
  prefix: 'far',
  iconName: 'spider-black-widow',
  icon: [
    512,
    512,
    [],
    'f718',
    'M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L160 158.1c.6-32.8 17.8-61.6 43.3-78.4c5.8-3.8 13.1-4.9 19.8-3s12.3 6.7 15.2 13L256 128.1l17.7-38.3c2.9-6.3 8.5-11.1 15.2-13s13.9-.8 19.8 3c25.6 16.8 42.7 45.5 43.3 78.4l32.3-32.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-68.8-22.9c.8 3.2 1.5 6.4 2 9.7l43.8 43.8c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5l-12.1-12.1C358.8 425.8 311.9 464 256 464s-102.8-38.2-116.2-89.9l-12.1 12.1c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l43.8-43.8c.5-3.3 1.2-6.5 2-9.7L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm66 142.7c-1.7 4.9-2.6 10.2-2.6 15.7l0 88c0 3.4 .4 6.7 1 9.9c1.6 7.6-.6 15.5-5.9 21.2C191.2 292 184 309.1 184 328l0 16c0 39.8 32.2 72 72 72s72-32.2 72-72l0-16c0-18.9-7.2-36-19.1-48.9c-5.3-5.7-7.5-13.6-5.9-21.2c.7-3.2 1-6.5 1-9.9l0-88c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8c-3.9 8.5-12.4 13.9-21.8 13.9l-16 0c-9.4 0-17.9-5.4-21.8-13.9l-15.6-33.8zm7.8 162.9c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12l56 0c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12l-56 0c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z',
  ],
};
const faStaffSnake = {
  prefix: 'far',
  iconName: 'staff-snake',
  icon: [
    384,
    512,
    ['rod-asclepius', 'rod-snake', 'staff-aesculapius'],
    'e579',
    'M222.6 43.2l-.1 4.8L296 48c48.6 0 88 39.4 88 88s-39.4 88-88 88l-48 0 0-48 48 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-75 0-6 192 25 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l0-48c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.5 0-3.6 115.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1.4-43.5L174 448l-54 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.5 0-2-64L144 336c-44.2 0-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6l0 48.6c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32l25 0L163 96l-35.6 0c.4 2.6 .6 5.3 .6 8c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56S25.1 48 56 48l8 0 8 0 89.5 0-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faRodAsclepius = faStaffSnake;
const faRodSnake = faStaffSnake;
const faStaffAesculapius = faStaffSnake;
const faPear = {
  prefix: 'far',
  iconName: 'pear',
  icon: [
    512,
    512,
    [],
    'e20c',
    'M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM367 111l22-22c-11.1-5.8-23.7-9.1-37-9.1c-19.2 0-36.8 6.7-50.6 18C264 128.6 212 166 155.6 180.6c-23.9 6.2-46.6 18.7-65.5 37.5c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0c18.9-18.9 31.3-41.5 37.5-65.5C346 300 383.4 248 414 210.6c11.3-13.8 18-31.3 18-50.6c0-13.4-3.3-25.9-9.1-37l-22 22c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM288 320c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faHeadSideCoughSlash = {
  prefix: 'far',
  iconName: 'head-side-cough-slash',
  icon: [
    640,
    512,
    [],
    'e062',
    'M129 75.8C156.4 58.2 189 48 224 48l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-6.3 0-12 2.4-16.2 6.3L129 75.8zM459.7 335c29.7-5.3 52.3-31.3 52.3-62.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C173.5 0 127 16.7 89.5 44.8L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459.7 335zM27 117.3C9.8 149 0 185.4 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224c0-27.4 6.3-53.3 17.4-76.4L27 117.3zM339.2 363.2l-1.3 .3c-10.5 2.6-17.8 12-17.8 22.8c0 12.2 9.4 22.4 21.6 23.4l58.4 4.9 0 9.3 0 8c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24c10.4 0 19.3-6.7 22.6-16l65.4 0c30 0 55.2-20.6 62.1-48.5l-107-84.3zM640 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faFileMov = {
  prefix: 'far',
  iconName: 'file-mov',
  icon: [
    512,
    512,
    [],
    'e647',
    'M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm93.7-104.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM448 368l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z',
  ],
};
const faTriangle = {
  prefix: 'far',
  iconName: 'triangle',
  icon: [
    512,
    512,
    [9650],
    'f2ec',
    'M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3z',
  ],
};
const faApartment = {
  prefix: 'far',
  iconName: 'apartment',
  icon: [
    576,
    512,
    [],
    'e468',
    'M176 96l0-32c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16l0 128c0 26.5 21.5 48 48 48l64 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-128 0-32 0-32 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48zm16 416l64 0 64 0 32 0 32 0 128 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0-48 0 0-48 0-80c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 32L80 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l128 0zM352 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm144 80l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM128 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16 80l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM368 96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM256 80l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM368 224l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM480 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM144 224l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0z',
  ],
};
const faTruckMedical = {
  prefix: 'far',
  iconName: 'truck-medical',
  icon: [
    640,
    512,
    [128657, 'ambulance'],
    'f0f9',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faAmbulance = faTruckMedical;
const faPepper = {
  prefix: 'far',
  iconName: 'pepper',
  icon: [
    512,
    512,
    [129745],
    'e432',
    'M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37l0 10.9c-17.1-6.1-36.2-7.4-55.1-2.7l-.2 0c-10.5 2.6-20.1 6.9-28.7 12.4C126.5 97.5 99.5 92.2 72.7 98.9C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c10.5-2.6 20.1-6.9 28.7-12.4c5.7 3.6 11.8 6.7 18.3 9.2c10.6 4 22 6.1 33.7 6.1c0 0 0 0 0 0l0-24 0 24s0 0 0 0c11.7 0 23.1-2.1 33.7-6.1c6.5-2.4 12.6-5.5 18.3-9.2c8.6 5.5 18.3 9.8 28.7 12.4c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.9-116.4c-26.8-6.7-53.8-1.4-75.3 12.4c-8.6-5.6-18.3-9.8-28.7-12.4c-19-4.8-38.1-3.5-55.3 2.6l0-10.9c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4c-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1L153.4 203.6c-6.2-25 8.3-50.3 32.7-57.6c.7-.2 1.5-.4 2.2-.6c18.7-4.7 37.6 2.3 49 16.4c4.6 5.6 11.4 8.9 18.7 8.9s14.1-3.3 18.7-8.9c11.4-14.1 30.3-21.1 49-16.4c9.2 2.3 17 7 23 13.3c4.5 4.7 10.8 7.4 17.3 7.4s12.8-2.7 17.3-7.4c11.6-12.1 29-17.7 46.3-13.4c25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9c-9.2-2.3-17-7-23-13.3c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-.2 .2-.5 .5-.7 .7c0 0 0 0 0 0c-4.7 4.7-10.5 8.5-17.1 11c0 0 0 0 0 0c-5.3 2-11 3.1-16.8 3.1c0 0 0 0 0 0c-5.8 0-11.5-1.1-16.8-3.1c0 0 0 0 0 0c-6.6-2.5-12.3-6.2-17-10.9c0 0 0 0 0 0c-.2-.2-.5-.5-.7-.8c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-6 6.3-13.9 11-23 13.3c-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z',
  ],
};
const faPiano = {
  prefix: 'far',
  iconName: 'piano',
  icon: [
    512,
    512,
    [],
    'f8d4',
    'M432 384l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-96 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64-32 0zM48 336l416 0 0-8.4c0-6.1-3.4-11.6-8.8-14.3L396.8 284c-37.2-18.6-60.8-56.7-60.8-98.3C336 109.7 274.3 48 198.3 48L192 48C112.5 48 48 112.5 48 192l0 144zm464-8.4l0 8.4 0 24 0 24 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64 0-24 0-24L0 192C0 86 86 0 192 0l6.3 0C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z',
  ],
};
const faGunSquirt = {
  prefix: 'far',
  iconName: 'gun-squirt',
  icon: [
    576,
    512,
    [],
    'e19d',
    'M104 32c13.3 0 24 10.7 24 24l0 8 320 0c41.8 0 77.4 26.7 90.5 64l13.5 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-13.5 0c-13.2 37.3-48.7 64-90.5 64l-199 0-18 72 41 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-53 0L199 455.8C195.5 470 182.7 480 168 480L64 480c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7L80 56c0-13.3 10.7-24 24-24zm24.5 224l-44 176 71 0 44-176-71 0zM448 208c26.5 0 48-21.5 48-48s-21.5-48-48-48l-344 0-8 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l115.5 0 49.5 0 187 0zM96 144l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faWheatAwnCircleExclamation = {
  prefix: 'far',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e598',
    'M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63.7 63.7c-21.6 7.1-41.4 18.2-58.4 32.5c-24.3-10.1-52.5-7.8-75 7l10.1 10.1c9.4 9.4 21 15.3 33.1 17.6c-11.9 17.2-20.9 36.7-26.1 57.7c-27.3-23.7-66.9-25.8-96.4-6.2l10.1 10.1c23 23 59.1 24.8 84.2 5.5c-2 10.7-3.1 21.7-3.1 32.9c0 7.4 .5 14.8 1.4 21.9c-5.8 2-11.8 3.6-17.8 4.7c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faSnowman = {
  prefix: 'far',
  iconName: 'snowman',
  icon: [
    512,
    512,
    [9731, 9924],
    'f7d0',
    'M256 0C189.7 0 136 53.7 136 120c0 19 4.4 37 12.3 53c-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2l0-40.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 19.6-22.5-9.7c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l56 24 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7c0 12.5 1.7 24.7 4.9 36.3C106.7 318.2 96 349.9 96 384c0 39.2 14.1 75.1 37.5 102.9c15.6 18.6 38.4 25.1 58.3 25.1l128.5 0c19.8 0 42.7-6.5 58.3-25.1C401.9 459.1 416 423.2 416 384c0-34.1-10.7-65.8-28.9-91.7c3.2-11.6 4.9-23.7 4.9-36.3c0-1.6 0-3.1-.1-4.7l49.5-21.2 56-24c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L456 171.6l0-19.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40.2-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6c7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0zM184 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8c-6.9 9.6-5.7 22.9 2.8 31.1c16.4 16 26.6 38.3 26.6 63c0 11.3-2.1 22.1-6 32c-3.2 8.2-1.7 17.4 3.9 24.1C358.2 331.6 368 356.6 368 384c0 27.5-9.8 52.5-26.2 72c-3.8 4.6-11.1 8-21.5 8l-128.5 0c-10.4 0-17.7-3.4-21.5-8c-16.4-19.5-26.2-44.6-26.2-72c0-27.4 9.8-52.4 26.1-71.8c5.6-6.7 7.1-16 3.9-24.1c-3.9-9.9-6-20.7-6-32c0-24.7 10.2-47 26.6-63c8.5-8.3 9.7-21.5 2.8-31.1C189 150 184 135.6 184 120zm56-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24l0 3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9l0-3.2c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faUserAlien = {
  prefix: 'far',
  iconName: 'user-alien',
  icon: [
    448,
    512,
    [],
    'e04a',
    'M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 33.9-18.3 69.4-46.1 102.4c-23.3 27.7-49.6 49.4-65.9 61.6c-16.3-12.2-42.6-34-65.9-61.6C130.3 236.4 112 201 112 167zM224 0C135.6 0 64 74.8 64 167c0 101 106.6 185 139.2 208.3c6.1 4.3 13.4 6.5 20.8 6.5s14.7-2.1 20.8-6.5C277.4 352 384 268.1 384 167C384 74.8 312.4 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-71.4-55.7-129.8-126.1-134.1c-22.6 22.1-44 38.6-56.7 47.7l48.3 0c40 0 73.6 27.1 83.5 64L50.9 464c9.9-36.9 43.5-64 83.5-64l48.3 0c-12.7-9.2-34-25.6-56.7-47.7C55.7 356.6 0 415 0 486.4zM208 222.9c0-30.3-24.6-54.9-54.9-54.9l-16 0c-5 0-9.1 4.1-9.1 9.1c0 30.3 24.6 54.9 54.9 54.9l16 0c5 0 9.1-4.1 9.1-9.1zM294.9 168c-30.3 0-54.9 24.6-54.9 54.9c0 5 4.1 9.1 9.1 9.1l16 0c30.3 0 54.9-24.6 54.9-54.9c0-5-4.1-9.1-9.1-9.1l-16 0z',
  ],
};
const faShieldCheck = {
  prefix: 'far',
  iconName: 'shield-check',
  icon: [
    512,
    512,
    [],
    'f2f7',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z',
  ],
};
const faMortarPestle = {
  prefix: 'far',
  iconName: 'mortar-pestle',
  icon: [
    512,
    512,
    [],
    'f5a7',
    'M504.3 11.1c10.9 12.7 10.2 31.7-1.6 43.5L397.3 160l-144.9 0L461 6.2c13.5-9.9 32.3-7.8 43.2 4.9zM80 240l0 16c0 62.9 31.3 109.5 91.9 131c14.6 5.2 25.8 17.1 30.1 32.1s1 31-8.6 43.1c-.5 .6-1 1.2-1.4 1.8l128 0c-.5-.6-.9-1.2-1.4-1.8c-9.7-12.1-12.9-28.2-8.6-43.1s15.5-26.9 30.1-32.1c60.7-21.6 91.9-68.1 91.9-131l0-16L80 240zm432-24c0 13.3-10.7 24-24 24l-8 0 0 16c0 66-27.8 120.8-80 154.8c-13.1 8.5-27.7 15.7-43.9 21.5c10 12.6 17.7 27.1 22.5 42.9c.5 1.7 1 3.5 1.4 5.2c4.4 17.1-10.4 31.7-28.1 31.7l-192 0c-17.7 0-32.4-14.6-28.1-31.7c.4-1.8 .9-3.5 1.4-5.2c4.7-15.8 12.5-30.3 22.5-42.9c-16.1-5.7-30.8-12.9-43.9-21.5C59.8 376.8 32 322 32 256l0-16-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 448 0 8 0c13.3 0 24 10.7 24 24z',
  ],
};
const faRoadBarrier = {
  prefix: 'far',
  iconName: 'road-barrier',
  icon: [
    640,
    512,
    [],
    'e562',
    'M24 32c13.3 0 24 10.7 24 24l0 24 544 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 0 48 0 128 0 48 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152L48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32zM592 256l0-128-21.2 0-64 128 85.2 0zM48 256l21.2 0 64-128L48 128l0 128zM389.2 128l-74.3 0-64 128 74.3 0 64-128zM378.8 256l74.3 0 64-128-74.3 0-64 128zm-192-128l-64 128 74.3 0 64-128-74.3 0z',
  ],
};
const faChartCandlestick = {
  prefix: 'far',
  iconName: 'chart-candlestick',
  icon: [
    512,
    512,
    [],
    'e0e2',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zm272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l0-48zm64 176l0 64c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48z',
  ],
};
const faBriefcaseBlank = {
  prefix: 'far',
  iconName: 'briefcase-blank',
  icon: [
    512,
    512,
    [],
    'e0c8',
    'M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm232 48l-208 0-88 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-88 0z',
  ],
};
const faSchool = {
  prefix: 'far',
  iconName: 'school',
  icon: [
    640,
    512,
    [127979],
    'f549',
    'M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92L568 96c39.8 0 72 32.2 72 72l0 272c0 39.8-32.2 72-72 72l-184 0-128 0L72 512c-39.8 0-72-32.2-72-72L0 168c0-39.8 32.2-72 72-72l96.7 0 138-92zM568 464c13.3 0 24-10.7 24-24l0-272c0-13.3-10.7-24-24-24l-104 0c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4L72 144c-13.3 0-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l184 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 184 0zM112 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM112 320l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-8.8-7.2-16-16-16z',
  ],
};
const faIgloo = {
  prefix: 'far',
  iconName: 'igloo',
  icon: [
    576,
    512,
    [],
    'f7ae',
    'M512 432l-112 0 0-64 128 0 0 48c0 8.8-7.2 16-16 16zM395.4 320c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80L144 320l0-128 288 0 0 128-36.6 0zm95.7-128c23.4 37 36.9 80.9 36.9 128l-48 0 0-128 11.1 0zM96 192l0 128-48 0c0-47.1 13.5-91 36.9-128L96 192zM288 80c5.4 0 10.7 .2 16 .5l0 63.5-179.2 0C167.7 104.3 225 80 288 80zm64 64l0-55.4c37.6 10.4 71.4 29.6 99.2 55.4L352 144zM176 368l0 64L64 432c-8.8 0-16-7.2-16-16l0-48 128 0zM64 480l112 0 224 0 112 0c35.3 0 64-28.7 64-64l0-96C576 160.9 447.1 32 288 32S0 160.9 0 320l0 96c0 35.3 28.7 64 64 64zM288 288c35.3 0 64 28.7 64 64l0 80-128 0 0-80c0-35.3 28.7-64 64-64z',
  ],
};
const faBracketRound = {
  prefix: 'far',
  iconName: 'bracket-round',
  icon: [
    192,
    512,
    ['parenthesis'],
    '28',
    'M156.6 43.7c6.8 11.4 3 26.1-8.3 32.9C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4c11.4 6.8 15.1 21.5 8.3 32.9s-21.5 15.1-32.9 8.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4c11.4-6.8 26.1-3 32.9 8.3z',
  ],
};
const faParenthesis = faBracketRound;
const faJoint = {
  prefix: 'far',
  iconName: 'joint',
  icon: [
    640,
    512,
    [],
    'f595',
    'M464 24l0 19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24zM592 264l0-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24zM120.2 436.8C171.7 450.7 235.2 464 288 464l27.4 0-52.6-63.1c-47 3.2-99.1 14.6-142.6 26.3c-5.8 1.6-11.7 3.2-17.5 4.8c5.8 1.7 11.6 3.3 17.5 4.8zM324.6 400l53.3 64 97.5 0-53.3-64-97.5 0zm160 0l53.3 64 54.1 0 0-64-107.4 0zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352l312 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-312 0c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z',
  ],
};
const faHorseSaddle = {
  prefix: 'far',
  iconName: 'horse-saddle',
  icon: [
    576,
    512,
    [],
    'f8c3',
    'M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 32 0 .5 0c2.5 0 5 .1 7.5 .3l0-.3 56 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c5.4 9.4 9.1 20 10.7 31.3l9.9 69.2c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1l22.6 0 33.1 0 61.3 0C309.8 51.5 362.6 6.1 426.8 .6zM416 239l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-32 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-.2 1.4-.4 2.7-.8 3.9c0 .4 0 .7 0 1.1l0 32c0 40.3-27.1 74.2-64 84.7l0 49.1 38.7 11.3c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM288 160l-56 0-24 0 0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16zm-128 2.1c-27.6 7.2-48 32.3-48 62.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l1.3 .4 0-35.1c-36.9-10.4-64-44.4-64-84.7l0-13.9zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faMugMarshmallows = {
  prefix: 'far',
  iconName: 'mug-marshmallows',
  icon: [
    512,
    512,
    [],
    'f7b7',
    'M197.7 125.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128l-144 0-2.3-2.3zM32 64c0-17.7 14.3-32 32-32l128 0c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16L32 128l0-64zM48 384c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-176-184 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0 0 176zM0 192c0-17.7 14.3-32 32-32l320 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 192zM384 336l16 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-16 0 0 128z',
  ],
};
const faFilters = {
  prefix: 'far',
  iconName: 'filters',
  icon: [
    640,
    512,
    [],
    'e17e',
    'M233.8 32C210.7 32 192 50.7 192 73.8c0 9.3 3.1 18.4 8.9 25.8L336 272.3l0 63.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-143.3L631.1 99.6c5.8-7.4 8.9-16.4 8.9-25.8C640 50.7 621.3 32 598.2 32L233.8 32zM378.9 249.2L246.5 80l339 0L453.1 249.2c-3.3 4.2-5.1 9.4-5.1 14.8l0 118.6-64-50.3 0-68.3c0-5.4-1.8-10.6-5.1-14.8zM163.4 96L41.8 96C18.7 96 0 114.7 0 137.8c0 9.3 3.1 18.4 8.9 25.8L144 336.3l0 31.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-111.3c0 0 0 0 0-.1l0-52.9-9.7-12.5-33.2 42.4c-3.3 4.2-5.1 9.4-5.1 14.8l0 86.6-64-50.3 0-36.3c0-5.4-1.8-10.6-5.1-14.8L54.5 144 195 144l-19.3-24.6c-5.5-7-9.6-15-12.3-23.4z',
  ],
};
const faBellOn = {
  prefix: 'far',
  iconName: 'bell-on',
  icon: [
    640,
    512,
    [128365],
    'f8fa',
    'M320 0c-17.7 0-32 14.3-32 32l0 17.9C215.5 61.4 160 124.2 160 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6l-303.4 0c25.8-40 39.7-86.7 39.7-134.6l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM0 200c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z',
  ],
};
const faAngleRight = {
  prefix: 'far',
  iconName: 'angle-right',
  icon: [
    320,
    512,
    [8250],
    'f105',
    'M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z',
  ],
};
const faDialMed = {
  prefix: 'far',
  iconName: 'dial-med',
  icon: [
    576,
    512,
    [],
    'e15f',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 288c0-53.6 37.7-98.4 88-109.4L264 288c0 13.3 10.7 24 24 24s24-10.7 24-24l0-109.4c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faHorse = {
  prefix: 'far',
  iconName: 'horse',
  icon: [
    576,
    512,
    [128014],
    'f6f0',
    'M432 0c-1.8 0-3.5 .2-5.2 .6c-64.2 5.5-117 51-133.5 111.4L232 112l-33.1 0-22.6 0c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2l49.8 0c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5l0 99.5c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-136.2c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7 0-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24L480 0l0 .3c-2.5-.2-5-.3-7.5-.3L472 0 440 0l-8 0zM416 240.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2L384 464l-48 0 0-117.8c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464l-49.8 0-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-35.5 28.8-64.2 64.2-64.2l22.6 0 33.1 0 81 0c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2l4.6 0 32 0 .5 0c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6l0 55c0 .5 0 1 0 1.5zM480 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faQ = {
  prefix: 'far',
  iconName: 'q',
  icon: [
    448,
    512,
    [113],
    '51',
    'M48 256c0 97.2 78.8 176 176 176c35.7 0 69-10.6 96.7-28.9l-91-107.6c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l90.5 107C383.7 340.6 400 300.2 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zM351.9 439.9C315.6 465.2 271.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 58.9-22.7 112.5-59.9 152.4l54.2 64.1c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-53.8-63.6z',
  ],
};
const faMonitorWaveform = {
  prefix: 'far',
  iconName: 'monitor-waveform',
  icon: [
    576,
    512,
    ['monitor-heart-rate'],
    'f611',
    'M64 80c-8.8 0-16 7.2-16 16l0 144 128 0c8.4 0 16.2 4.4 20.6 11.7l25.5 42.5 60.4-120.9c3.9-7.8 11.8-12.9 20.5-13.2s17 4.1 21.5 11.6l41 68.3 58.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-8.4 0-16.2-4.4-20.6-11.7l-25.5-42.5L245.5 354.7c-3.9 7.8-11.8 12.9-20.5 13.2s-17-4.1-21.5-11.6l-41-68.3L48 288l0 128c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faMonitorHeartRate = faMonitorWaveform;
const faLinkSimple = {
  prefix: 'far',
  iconName: 'link-simple',
  icon: [
    576,
    512,
    [],
    'e1cd',
    'M0 256C0 167.6 71.6 96 160 96l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C98.1 144 48 194.1 48 256s50.1 112 112 112l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c88.4 0 160 71.6 160 160zM184 232l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faWhistle = {
  prefix: 'far',
  iconName: 'whistle',
  icon: [
    640,
    512,
    [],
    'f460',
    'M119 95.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6l2 0c9 0 17.6-3.8 23.7-10.5l63.3-69.6c4.6-5.1 7.2-11.7 7.2-18.5c0-8.4-3.9-16.4-10.5-21.6L352.5 108.7C315.9 79.7 270.6 64 224 64c-38.8 0-74.8 11.5-105 31.2zM68.5 143.4c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c-4 4.6-7.9 9.4-11.5 14.3zM402.9 324.4c-21.3-11.1-47.5-4.8-61.4 14.8C315.4 376.1 272.5 400 224 400c-79.5 0-144-64.5-144-144s64.5-144 144-144c35.8 0 70.6 12.1 98.7 34.3l70 55.4-11.9 15.9c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l11.2-14.9L582.6 351.8l-40.9 45L402.9 324.4zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faG = {
  prefix: 'far',
  iconName: 'g',
  icon: [
    448,
    512,
    [103],
    '47',
    'M224 80C126.8 80 48 158.8 48 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152l-149 0c-13.3 0-24-10.7-24-24s10.7-24 24-24L408 232c21.6 0 41.2 17.9 39.3 41.9C438.2 389.3 341.7 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C310.2 96.9 269.1 80 224 80z',
  ],
};
const faWineGlassCrack = {
  prefix: 'far',
  iconName: 'wine-glass-crack',
  icon: [
    320,
    512,
    ['fragile'],
    'f4bb',
    'M184 464l0-114c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0L264 0 194.9 0l-29 0L56 0 48.2 0c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350l0 114-64 0c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0 88 0 88 0c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0-64 0zM163.3 48c-.4 3.4-2 6.7-4.6 9.3l-52.3 52.3c-5.9 5.9-6.3 15.3-.9 21.6l76 89.8c1.6 1.9 3.9 3 6.4 3c5.8 0 9.9-5.9 7.8-11.3l-30.9-80.4c-2.8-7.2 0-15.3 6.5-19.3l43.4-27.1c5.6-3.5 8.5-10.2 7.2-16.7L217.6 48l24.2 0L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L78.2 48l85.1 0z',
  ],
};
const faFragile = faWineGlassCrack;
const faSlotMachine = {
  prefix: 'far',
  iconName: 'slot-machine',
  icon: [
    640,
    512,
    [],
    'e3ce',
    'M400 416l-288 0 0 32c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-32zm48 32c0 5.5-.7 10.9-2 16l82 0c22.1 0 40-17.9 40-40l0-206.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6L616 424c0 48.6-39.4 88-88 88l-144 0-256 0c-35.3 0-64-28.7-64-64l0-32c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l0-32C64 28.7 92.7 0 128 0L384 0c35.3 0 64 28.7 64 64l0 32c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l0 32zM400 96l0-32c0-8.8-7.2-16-16-16L128 48c-8.8 0-16 7.2-16 16l0 32 288 0zm48 48L64 144c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM112 176l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L133.9 224 112 224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96 24c0-13.3 10.7-24 24-24l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L253.9 224 232 224c-13.3 0-24-10.7-24-24zm144-24l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L373.9 224 352 224c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faNotesMedical = {
  prefix: 'far',
  iconName: 'notes-medical',
  icon: [
    512,
    512,
    [],
    'f481',
    'M144 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 197.5c0 4.2-1.7 8.3-4.7 11.3l-58.5 58.5c-3 3-7.1 4.7-11.3 4.7L160 368c-8.8 0-16-7.2-16-16l0-256zM96 96l0 256c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm176 32c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0zm24 336l-160 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 376c0 75.1 60.9 136 136 136l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
  ],
};
const faCarWash = {
  prefix: 'far',
  iconName: 'car-wash',
  icon: [
    448,
    512,
    [],
    'f5e6',
    'M224 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zm-70.2 80l140.3 0c10.1 0 19.2 6.4 22.6 15.9L333.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM57.4 287.9c-.2 .5-.3 .9-.5 1.4C32.2 306.7 16 335.5 16 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.6c-.1-.5-.3-.9-.5-1.4L362 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L57.4 287.9zM384 368l0 32L64 400l0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48zM128 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 80c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48s48-16 48-48zm272 48c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48z',
  ],
};
const faEscalator = {
  prefix: 'far',
  iconName: 'escalator',
  icon: [
    640,
    512,
    [],
    'e171',
    'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm182.1 85.8c16-14 36.6-21.8 57.9-21.8l104 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-70.9 0L249.9 490.2c-16 14-36.6 21.8-57.9 21.8L88 512c-48.6 0-88-39.4-88-88s39.4-88 88-88l70.9 0L390.1 133.8zM448 160c-9.7 0-19 3.5-26.3 9.9L183.8 378.1c-4.4 3.8-10 5.9-15.8 5.9l-80 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l104 0c9.7 0 19-3.5 26.3-9.9L456.2 245.9c4.4-3.8 10-5.9 15.8-5.9l80 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-104 0zM256 128c23.7 0 44.4 12.9 55.5 32L192 264.5l0-72.5c0-35.3 28.7-64 64-64z',
  ],
};
const faCommentImage = {
  prefix: 'far',
  iconName: 'comment-image',
  icon: [
    512,
    512,
    [],
    'e148',
    'M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9l-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5zM296 160c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-128 0-48 0-48 0c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faTemperatureHalf = {
  prefix: 'far',
  iconName: 'temperature-half',
  icon: [
    320,
    512,
    [127777, 'temperature-2', 'thermometer-2', 'thermometer-half'],
    'f2c9',
    'M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 200c0-8.8 7.2-16 16-16s16 7.2 16 16l0 122.7c18.6 6.6 32 24.4 32 45.3z',
  ],
};
const faTemperature2 = faTemperatureHalf;
const faThermometer2 = faTemperatureHalf;
const faThermometerHalf = faTemperatureHalf;
const faDongSign = {
  prefix: 'far',
  iconName: 'dong-sign',
  icon: [
    384,
    512,
    [],
    'e169',
    'M296 32c-13.3 0-24 10.7-24 24l0 8-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 76.1c-21.9-17.6-49.7-28.1-80-28.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1l0 4.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-176 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24zM112 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM24 448c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 448z',
  ],
};
const faDonut = {
  prefix: 'far',
  iconName: 'donut',
  icon: [
    512,
    512,
    [127849, 'doughnut'],
    'e406',
    'M48 289.9c7.7 5 14.4 11.5 19.5 19.2c9.4 13 22 23.4 36.5 30.2c14.7 6.8 30.8 9.7 46.9 8.4l.6 0 .6 0c17.7-.2 35.3 3.3 51.7 10.1l.1 0c16.4 7 34.1 10.5 51.9 10.3l.3 0s0 0 0 0c17.8 .2 35.5-3.3 51.9-10.3l.1 0s0 0 0 0c16.4-6.8 34-10.2 51.7-10.1l.6 0 .6 0c16.1 1.3 32.2-1.5 46.9-8.3c14.6-6.7 27.1-17.1 36.5-30.1c5.1-7.8 11.8-14.3 19.5-19.3l0 14c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304l0-14.1zM256 48C114.6 48 0 119.6 0 208l0 96c0 88.4 114.6 160 256 160s256-71.6 256-160l0-96c0-88.4-114.6-160-256-160zm64 144c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32zM283.3 84.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zm-112 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm224 9.4l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 192l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm331.3 36.7l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-240 16l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm176 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faDoughnut = faDonut;
const faCapsules = {
  prefix: 'far',
  iconName: 'capsules',
  icon: [
    576,
    512,
    [],
    'f46b',
    'M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64l0 112L48 256l0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93c28.5-20.4 68-13.7 88.5 16.2l66.9 97.5L348.5 312.2l-65.1-94.9z',
  ],
};
const faPooStorm = {
  prefix: 'far',
  iconName: 'poo-storm',
  icon: [
    448,
    512,
    ['poo-bolt'],
    'f75a',
    'M175.3 10.1C179.8 3.8 187 0 194.8 0c58.8 0 132.5 41.8 140.5 121.2C364.2 135.7 384 165.5 384 200c0 2.2-.1 4.4-.2 6.6C421.3 221 448 257.4 448 300c0 55.2-44.8 100-100 100l-8.2 0c11.5-12.9 15.4-31.2 9.5-47.9l0-.1c28.1-.7 50.7-23.7 50.7-52c0-27-20.7-49.3-47-51.8c-7.6-.7-14.4-5-18.3-11.5s-4.5-14.5-1.7-21.5c1.9-4.7 3-9.8 3-15.2c0-18.6-12.7-34.3-30-38.7c-10.9-2.8-18.4-12.8-18-24.1c0-.5 0-1 0-1.5c0-40.2-26.7-68.8-58.4-81c1.3 5.6 2.4 11.6 2.4 16.8c0 38-19.6 61-39 73.6c-9.3 6-18.5 9.6-25.2 11.7c-3.4 1.1-6.3 1.8-8.4 2.2l-.4 .1c-2.2 .7-4.5 1-6.9 1l-.1 0c-22.1 0-40 17.9-40 40c0 5.4 1.1 10.5 3 15.2c2.9 7 2.3 15-1.7 21.5s-10.7 10.8-18.3 11.5C68.7 250.7 48 273 48 300c0 18 9.1 33.8 22.9 43.1c-7.3 12-9.1 27-4.2 40.8c1.6 4.6 3.8 8.8 6.6 12.5C31 384.7 0 346 0 300c0-42.6 26.7-79 64.2-93.4c-.2-2.2-.2-4.4-.2-6.6c0-47.6 37.8-86.3 84.9-87.9l.5-.1c.9-.2 2.4-.6 4.3-1.1c3.8-1.2 8.6-3.1 13.3-6.1c8.6-5.5 17-14.7 17-33.3l0 0c0-.3-.2-1.5-.7-4c-.6-2.8-1.5-6.1-2.6-9.9c-2.2-7.5-5-15.3-7.1-21.3c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1c-.5-1.6-1.1-3.1-1.5-4.3c-2.5-7.3-1.3-15.4 3.2-21.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384 112 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z',
  ],
};
const faPooBolt = faPooStorm;
const faTally1 = {
  prefix: 'far',
  iconName: 'tally-1',
  icon: [
    640,
    512,
    [],
    'e294',
    'M128 40c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24z',
  ],
};
const faFileVector = {
  prefix: 'far',
  iconName: 'file-vector',
  icon: [
    384,
    512,
    [],
    'e64c',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM240 224l-96 0c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l0 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l96 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l0-96c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 368l0-96 96 0 0 96-96 0z',
  ],
};
const faFaceFrownOpen = {
  prefix: 'far',
  iconName: 'face-frown-open',
  icon: [
    512,
    512,
    [128550, 'frown-open'],
    'f57a',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faFrownOpen = faFaceFrownOpen;
const faSquareDashed = {
  prefix: 'far',
  iconName: 'square-dashed',
  icon: [
    448,
    512,
    [],
    'e269',
    'M88 32l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 80c-22.1 0-40 17.9-40 40l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16C0 71.4 39.4 32 88 32zM24 192c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm400 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm0-32c-13.3 0-24-10.7-24-24l0-16c0-22.1-17.9-40-40-40l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c48.6 0 88 39.4 88 88l0 16c0 13.3-10.7 24-24 24zm24 216l0 16c0 48.6-39.4 88-88 88l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c22.1 0 40-17.9 40-40l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 376l0 16c0 22.1 17.9 40 40 40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-48.6 0-88-39.4-88-88l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zM184 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0zM160 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faBagShoppingPlus = {
  prefix: 'far',
  iconName: 'bag-shopping-plus',
  icon: [
    448,
    512,
    [],
    'e651',
    'M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0zM48 416c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208L48 208l0 208zm72-80c0-13.3 10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faSquareJ = {
  prefix: 'far',
  iconName: 'square-j',
  icon: [
    448,
    512,
    [],
    'e273',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm304 56l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHandPointUp = {
  prefix: 'far',
  iconName: 'hand-point-up',
  icon: [
    384,
    512,
    [9757],
    'f0a6',
    'M64 64l0 177.6c5.2-1 10.5-1.6 16-1.6l16 0 0-32L96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0l0 24c0 66.3 53.7 120 120 120l48 0c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-40 0zM0 320s0 0 0 0c0-18 6-34.6 16-48L16 64C16 28.7 44.7 0 80 0s64 28.7 64 64l0 82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64l0 64 0 24c0 92.8-75.2 168-168 168l-48 0C75.2 512 0 436.8 0 344l0-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM160 240c5.5 0 10.9 .7 16 2l0-2 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 16 0zm64 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24z',
  ],
};
const faMoneyBill = {
  prefix: 'far',
  iconName: 'money-bill',
  icon: [
    576,
    512,
    [],
    'f0d6',
    'M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faArrowUpBigSmall = {
  prefix: 'far',
  iconName: 'arrow-up-big-small',
  icon: [
    576,
    512,
    ['sort-size-up'],
    'f88e',
    'M368 208l0-128 128 0 0 128-128 0zm-48 0c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48l0 128zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 368l64 0 0 64-64 0 0-64zm-48 0l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faSortSizeUp = faArrowUpBigSmall;
const faBarcodeRead = {
  prefix: 'far',
  iconName: 'barcode-read',
  icon: [
    576,
    512,
    [],
    'f464',
    'M56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48zm64 80c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm272 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm-208 8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm152-24c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zM528 56c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM56 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8zm472-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8z',
  ],
};
const faBaguette = {
  prefix: 'far',
  iconName: 'baguette',
  icon: [
    640,
    512,
    [129366],
    'e3d8',
    'M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2l-69.7 46.5L433 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-41.9-41.9-74.5 49.6L321 223c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.1-45.1-74.5 49.6L209 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48.3-48.3L83.6 317.4c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z',
  ],
};
const faBowlSoftServe = {
  prefix: 'far',
  iconName: 'bowl-soft-serve',
  icon: [
    512,
    512,
    [],
    'e46b',
    'M256 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L172 64c-42 0-76 34-76 76c0 4.7 .4 9.3 1.2 13.8C51 162.5 16 203.2 16 252c0 29 12.3 55.1 32 73.3L48 344c0 57.4 46.6 104 104 104l30.1 0-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2c0 2.9 .8 5.8 2.4 8.4c2.9 4.7 8.1 7.6 13.6 7.6l160 0c5.5 0 10.7-2.9 13.6-7.6c1.6-2.6 2.4-5.5 2.4-8.4c0-2.4-.6-4.9-1.7-7.2L329.9 448l30.1 0c57.4 0 104-46.6 104-104l0-18.7c19.7-18.3 32-44.4 32-73.3c0-49.1-35.3-89.9-82-98.4c1.3-5.7 2-11.6 2-17.6C416 60.9 355.1 0 280 0L256 0zM396 304l-280 0c-28.7 0-52-23.3-52-52s23.3-52 52-52l12 0 6.5 0 33.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-21.3 0c-1.7-3.6-2.7-7.7-2.7-12c0-15.5 12.5-28 28-28l69.3 0c30.2 0 54.7-24.5 54.7-54.7c0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16L280 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l95.2 0 8.8 0 12 0c28.7 0 52 23.3 52 52s-23.3 52-52 52z',
  ],
};
const faFaceHoldingBackTears = {
  prefix: 'far',
  iconName: 'face-holding-back-tears',
  icon: [
    512,
    512,
    [129401],
    'e482',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 32l0 16 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7l0 6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6l0 32zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48zM310.4 362.5c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9C328.3 413.8 298.3 434 256 434s-72.3-20.2-89.6-38.9c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4C212.1 373.9 230.1 386 256 386s43.9-12.1 54.4-23.5zM128 240c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z',
  ],
};
const faSquareUp = {
  prefix: 'far',
  iconName: 'square-up',
  icon: [
    448,
    512,
    [11014, 'arrow-alt-square-up'],
    'f353',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM119.2 217.4l91-84c3.8-3.5 8.7-5.4 13.9-5.4s10.1 1.9 13.9 5.4l91 84c4.6 4.2 7.2 10.1 7.2 16.4c0 12.3-10 22.3-22.3 22.3L272 256l0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-41.7 0C122 256 112 246 112 233.7c0-6.2 2.6-12.1 7.2-16.4z',
  ],
};
const faArrowAltSquareUp = faSquareUp;
const faTrainSubwayTunnel = {
  prefix: 'far',
  iconName: 'train-subway-tunnel',
  icon: [
    512,
    512,
    ['subway-tunnel'],
    'e2a3',
    'M256 48C141.1 48 48 141.1 48 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-114.9-93.1-208-208-208zm24 128l0 80 72 0 0-48c0-17.7-14.3-32-32-32l-40 0zm-48 0l-40 0c-17.7 0-32 14.3-32 32l0 48 72 0 0-80zM160 304l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64-192 0zm-48-96c0-44.2 35.8-80 80-80l128 0c44.2 0 80 35.8 80 80l0 160c0 27.7-14.1 52.2-35.5 66.5L401 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-57-57-108.1 0-57 57c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l36.5-36.5C126.1 420.2 112 395.7 112 368l0-160zm64 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faSubwayTunnel = faTrainSubwayTunnel;
const faSquareExclamation = {
  prefix: 'far',
  iconName: 'square-exclamation',
  icon: [
    448,
    512,
    ['exclamation-square'],
    'f321',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faExclamationSquare = faSquareExclamation;
const faSemicolon = {
  prefix: 'far',
  iconName: 'semicolon',
  icon: [
    192,
    512,
    [],
    '3b',
    'M72 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 24 128a72 72 0 1 0 144 0zM84.4 347c1.4-6.4 7.1-11 13.6-11c7.3 0 13.9 6.2 13.9 14.3c0 2.7-.8 5.4-2.1 7.6L67.1 428l17.3-81zm-.7 145.8L150.8 383c6-9.8 9.2-21.2 9.2-32.7c0-34.2-27.7-62.3-61.9-62.3c-29.2 0-54.4 20.4-60.6 49L10.4 463.6C5 488.5 24 512 49.5 512c14 0 26.9-7.3 34.2-19.2z',
  ],
};
const faBookmark = {
  prefix: 'far',
  iconName: 'bookmark',
  icon: [
    384,
    512,
    [128278, 61591],
    'f02e',
    'M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z',
  ],
};
const faFanTable = {
  prefix: 'far',
  iconName: 'fan-table',
  icon: [
    448,
    512,
    [],
    'e004',
    'M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352zM448 224c0 115.6-87.6 210.8-200 222.7l0 17.3 112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-136 0L88 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-17.3C87.6 434.8 0 339.6 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM118.4 197.6c-16.6-41 3.2-87.6 44.2-104.1c12.3-5 26.3 1 31.2 13.3l29.2 72.2c16.7-23.7 45.8-37.5 76.6-33.2c43.8 6.1 74.2 46.6 68.1 90.4c-1.8 13.1-14 22.3-27.1 20.4l-77.1-10.8c12.2 26.4 9.6 58.4-9.6 82.9c-27.2 34.8-77.5 41-112.3 13.8c-10.4-8.2-12.3-23.2-4.1-33.7l47.9-61.4c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faAlignJustify = {
  prefix: 'far',
  iconName: 'align-justify',
  icon: [
    448,
    512,
    [],
    'f039',
    'M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z',
  ],
};
const faBatteryLow = {
  prefix: 'far',
  iconName: 'battery-low',
  icon: [
    576,
    512,
    ['battery-1'],
    'e0b1',
    'M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm80 96l-64 0 0 128 64 0 0-128z',
  ],
};
const faBattery1 = faBatteryLow;
const faCreditCardFront = {
  prefix: 'far',
  iconName: 'credit-card-front',
  icon: [
    576,
    512,
    [],
    'f38a',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM96 280c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24zM376 128l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
  ],
};
const faBrainArrowCurvedRight = {
  prefix: 'far',
  iconName: 'brain-arrow-curved-right',
  icon: [
    640,
    512,
    ['mind-share'],
    'f677',
    'M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44l0-332c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c1.3 1.5 2.6 3.1 3.8 4.8c-5.7 8-9 17.7-9 28l0 16-20.6 0c-3.8-9.4-9.8-17.8-17.4-24.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40l0 332c0 19.8 13.1 36.5 31 42.1c6.5 20.5 16.6 36.8 26.4 49c-4.4 .6-8.8 1-13.4 1c-26.9 0-51.2-11.6-68-30zM539.3 244.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-48-48 0c-35.3 0-64 28.7-64 64l0 35.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.7-2.2c-10.5-8.2-45-39.5-45-93.8c0-61.9 50.1-112 112-112l64 0 0-48c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5z',
  ],
};
const faMindShare = faBrainArrowCurvedRight;
const faUmbrellaBeach = {
  prefix: 'far',
  iconName: 'umbrella-beach',
  icon: [
    576,
    512,
    [127958],
    'f5ca',
    'M399.7 18.8c0 0 0 0 0 0c1.3 .5 2.6 .9 4 1.4c4.1 1.5 8.1 3 12 4.7c0 0 0 0 0 0C519.4 68.6 580.3 173.8 571.4 281.8c-1.6 19.2-21.5 30-39.6 23.4L349.7 239l-45.1-16.4L122.5 156.3c-18.1-6.6-26.4-27.7-15.3-43.4c64.2-90.8 182.8-132 292.6-94zM288.8 54.6c-48 6.4-92.7 29.5-125.8 65.4l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM413.3 211.1c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9c-3-1.2-6-2.4-9-3.5c-1-.4-2-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84l136.3 49.6zm45.2 16.4L524 251.3c-2.2-47-20.3-91.9-51-127.2c.4 35-4.5 69.8-14.5 103.3zM552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l192.7 0 76.9-211.4L338.7 269l-71 195L552 464z',
  ],
};
const faHelmetUn = {
  prefix: 'far',
  iconName: 'helmet-un',
  icon: [
    512,
    512,
    [],
    'e503',
    'M240 48c106 0 192 86 192 192l-176 0c-9.4 0-18 5.5-21.8 14.1L196.9 336 82.4 336c-19 0-34.4-15.4-34.4-34.4L48 240C48 134 134 48 240 48zm80 372.7l-77.7-68.6L271.5 288l48.5 0 0 132.7zm48 42.4L368 288l120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0C480 107.5 372.5 0 240 0S0 107.5 0 240l0 61.6C0 347.1 36.9 384 82.4 384l123.4 0 2.3 2 136 120c4.4 3.9 10 6 15.9 6l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.9 0-1.1-.9zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z',
  ],
};
const faLocationSmile = {
  prefix: 'far',
  iconName: 'location-smile',
  icon: [
    384,
    512,
    ['map-marker-smile'],
    'f60d',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM136 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-79.4 76.9c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C262.9 265.7 234.5 292 192 292s-70.9-26.3-80.6-40.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z',
  ],
};
const faMapMarkerSmile = faLocationSmile;
const faArrowLeftToLine = {
  prefix: 'far',
  iconName: 'arrow-left-to-line',
  icon: [
    448,
    512,
    [8676, 'arrow-to-left'],
    'f33e',
    'M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z',
  ],
};
const faArrowToLeft = faArrowLeftToLine;
const faBullseye = {
  prefix: 'far',
  iconName: 'bullseye',
  icon: [
    512,
    512,
    [],
    'f140',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faSushi = {
  prefix: 'far',
  iconName: 'sushi',
  icon: [
    576,
    512,
    [127843, 'nigiri'],
    'e48a',
    'M524.5 302.9c23.1 7.7 46-12.3 41.5-36.3l-8.6-46c-7.1-37.7-24.8-71-49.8-97.2L421.7 268.8l102.8 34.1zM393.7 65.6L296.5 230.2c9 1 17.9 2.9 26.6 5.8l67.5 22.4 92.5-156.6C457.4 82.7 426.7 70 393.7 65.6zM357.5 64L246.6 64 119.9 278.4l120.9-41.9c5.7-2 11.6-3.6 17.5-4.7L357.5 64zM207.3 64C115 64 35.7 129.8 18.6 220.6l-8.5 45.2C5.6 290 28.9 310 52.1 302l21.1-7.3L209.5 64l-2.1 0zM32 336.7L32 352c0 53 43 96 96 96c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c53 0 96-43 96-96l0-14.6c-8.5 .8-17.4-.1-26.2-3.1L496 327.1l0 24.9c0 26.5-21.5 48-48 48c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-9.5 0-18.2-2.7-25.6-7.4c-18.6-11.7-42.3-11.7-60.8 0c-7.4 4.7-16.1 7.4-25.6 7.4c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-26.5 0-48-21.5-48-48l0-25.9-20.9 7.2c-9.1 3.2-18.3 4.2-27.1 3.3z',
  ],
};
const faNigiri = faSushi;
const faMessageCaptions = {
  prefix: 'far',
  iconName: 'message-captions',
  icon: [
    512,
    512,
    ['comment-alt-captions'],
    'e1de',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faCommentAltCaptions = faMessageCaptions;
const faTrashList = {
  prefix: 'far',
  iconName: 'trash-list',
  icon: [
    640,
    512,
    [],
    'e2b1',
    'M170.5 51.6L151.5 80l113 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-61.7 0c-2.7 0-5.2 1.3-6.7 3.6zm115-26.6L322.2 80l13.7 0L384 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L356.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-169.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l61.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l169.1 0c8.4 0 15.3-6.5 16-14.8L332.3 128 83.7 128zM472 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM448 408c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faBacon = {
  prefix: 'far',
  iconName: 'bacon',
  icon: [
    576,
    512,
    [129363],
    'f7e5',
    'M441.7 216c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2zM262.9 196.4s0 0 0 0c-41.7 60.7-89.2 129.6-204.1 191.7l24.3 24.3C197.6 352.8 242.8 287 284.5 226.3l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L443.4 50.1c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 53-69.9 85.1c0 0 0 0 0 0l-2.3 3.4zM106.8 436.1l24.3 24.3c114.5-59.7 159.8-125.5 201.3-186l.2-.3s0 0 0 0l2.2-3.2s0 0 0 0c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L491.4 98c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3C269.3 304.9 221.9 374 106.8 436.1z',
  ],
};
const faOption = {
  prefix: 'far',
  iconName: 'option',
  icon: [
    640,
    512,
    [],
    'e318',
    'M172.1 120.4c-4.6-5.3-11.2-8.4-18.2-8.4L24 112C10.7 112 0 101.3 0 88S10.7 64 24 64l129.9 0c21 0 41 9.2 54.7 25.1L467.9 391.6c4.6 5.3 11.2 8.4 18.2 8.4L616 400c13.3 0 24 10.7 24 24s-10.7 24-24 24l-129.9 0c-21 0-41-9.2-54.7-25.1L172.1 120.4zM616 64c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0z',
  ],
};
const faRaccoon = {
  prefix: 'far',
  iconName: 'raccoon',
  icon: [
    512,
    512,
    [],
    'e613',
    'M336 93.1c12.7-16.1 33.6-24.3 54.1-20.6C376.5 57 356.8 48 336 48s-40.5 9-54.1 24.5c20.5-3.6 41.4 4.5 54.1 20.6zm0 69.5c-2.6 3.4-5.7 6.5-9.1 9.2l-35.8 28.6c3.4 1.9 6.8 4 10.1 6.2l10.9 7.3c1.1-12.3 11.4-21.9 23.9-21.9s22.8 9.6 23.9 21.9l10.9-7.3c3.3-2.2 6.7-4.2 10.1-6.2l-35.8-28.6c-3.4-2.7-6.5-5.8-9.1-9.2zm78.8 23.9l31.9-9.6c5.6-1.7 9.4-6.8 9.4-12.6c0-2.8-.9-5.6-2.6-7.9l-17.8-23.7-42.9-25.7c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l49.6 39.7zM306.9 146.8c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-42.9 25.7-17.7 23.7c-1.7 2.3-2.6 5-2.6 7.9c0 5.8 3.8 10.9 9.4 12.6l31.9 9.6 49.6-39.7zM206.2 93.1L194.2 57.3c-1.5-4.4-2.2-9.1-2.2-13.8C192 19.5 211.5 0 235.5 0l1.3 0c3.3 0 6.5 .4 9.7 1.1l41 9.1C302.7 3.6 319.1 0 336 0s33.3 3.6 48.4 10.2l41-9.1c3.2-.7 6.5-1.1 9.7-1.1l1.3 0c24 0 43.5 19.5 43.5 43.5c0 4.7-.8 9.3-2.2 13.8L465.8 93.1l25.9 34.6c7.9 10.6 12.2 23.5 12.2 36.7c0 27-17.7 50.8-43.6 58.5l-35.3 10.6c-9.8 2.9-19.2 7.3-27.7 13l-18.8 12.6C366 267.5 351.2 272 336 272s-30-4.5-42.6-12.9l-18.8-12.6c-8.5-5.7-17.9-10.1-27.7-13l-35.3-10.6c-25.9-7.8-43.6-31.6-43.6-58.5c0-13.2 4.3-26.1 12.2-36.7l25.9-34.6zM144 241.9c4.7-4.5 9.6-8.8 14.6-12.8c11.3 10.9 25.2 19.2 40.9 24l6 1.8C159.1 282.9 128 333.8 128 392c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-10.9 .8-21.6 2.4-32L48 360l0 32c0 39.8 32.2 72 72 72l184 0 0-8c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c39.8 0 72 32.2 72 72l0 8 80 0 0-8c0-13.3-10.7-24-24-24s-24-10.7-24-24s10.7-24 24-24c39.8 0 72 32.2 72 72l0 32c0 13.3-10.7 24-24 24l-336 0C53.7 512 0 458.3 0 392L0 224 0 104C0 64.2 32.2 32 72 32s72 32.2 72 72l0 137.9zm-48 70L96 264l-48 0 0 48 47.9 0 .1-.1zM96 216l0-48-48 0 0 48 48 0zM307.3 364.4l-64-40c-11.2-7-14.7-21.8-7.6-33.1s21.8-14.7 33.1-7.6l64 40c11.2 7 14.7 21.8 7.6 33.1s-21.8 14.7-33.1 7.6zm56.4-7.6c-7-11.2-3.6-26 7.6-33.1l64-40c11.2-7 26-3.6 33.1 7.6s3.6 26-7.6 33.1l-64 40c-11.2 7-26 3.6-33.1-7.6zM48 120l48 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16zm240-8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faHandPointDown = {
  prefix: 'far',
  iconName: 'hand-point-down',
  icon: [
    384,
    512,
    [],
    'f0a7',
    'M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z',
  ],
};
const faArrowUpFromBracket = {
  prefix: 'far',
  iconName: 'arrow-up-from-bracket',
  icon: [
    448,
    512,
    [],
    'e09a',
    'M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z',
  ],
};
const faHeadSideGear = {
  prefix: 'far',
  iconName: 'head-side-gear',
  icon: [
    512,
    512,
    [],
    'e611',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288.6-28.1c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z',
  ],
};
const faTrashPlus = {
  prefix: 'far',
  iconName: 'trash-plus',
  icon: [
    448,
    512,
    [],
    'e2b2',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zM204 376l0-68-68 0c-11 0-20-9-20-20s9-20 20-20l68 0 0-68c0-11 9-20 20-20s20 9 20 20l0 68 68 0c11 0 20 9 20 20s-9 20-20 20l-68 0 0 68c0 11-9 20-20 20s-20-9-20-20z',
  ],
};
const faFileCad = {
  prefix: 'far',
  iconName: 'file-cad',
  icon: [
    512,
    512,
    [],
    'e672',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm232 0l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 32l0 96 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0zm-160 8c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 56 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-56zm32 0l0 40 32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z',
  ],
};
const faObjectsAlignTop = {
  prefix: 'far',
  iconName: 'objects-align-top',
  icon: [
    512,
    512,
    [],
    'e3c0',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM176 176l0 288-64 0 0-288 64 0zm-64-48c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-64 0zm288 48l0 160-64 0 0-160 64 0zm-64-48c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0z',
  ],
};
const faFolder = {
  prefix: 'far',
  iconName: 'folder',
  icon: [
    512,
    512,
    [128193, 128447, 61716, 'folder-blank'],
    'f07b',
    'M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z',
  ],
};
const faFolderBlank = faFolder;
const faFaceAnxiousSweat = {
  prefix: 'far',
  iconName: 'face-anxious-sweat',
  icon: [
    576,
    512,
    [],
    'e36a',
    'M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM48 416c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47zM335.6 272a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM288 320c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80z',
  ],
};
const faCreditCardBlank = {
  prefix: 'far',
  iconName: 'credit-card-blank',
  icon: [
    576,
    512,
    [],
    'f389',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faFileWaveform = {
  prefix: 'far',
  iconName: 'file-waveform',
  icon: [
    448,
    512,
    ['file-medical-alt'],
    'f478',
    'M384 464l-256 0c-8.8 0-16-7.2-16-16l0-96-48 0 0 96c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L338.7 18.7C326.7 6.7 310.5 0 293.5 0L128 0C92.7 0 64 28.7 64 64l0 176 48 0 0-176c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM276.8 228.1c-4.4-7.7-12.7-12.3-21.5-12.1s-16.8 5.3-20.8 13.3l-45.5 91L164 282.7C159.5 276 152 272 144 272L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l107.2 0L172 381.3c4.7 7.1 12.9 11.2 21.5 10.6s16.1-5.6 20-13.2l43.9-87.9 9.8 17.1c4.3 7.5 12.2 12.1 20.8 12.1l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-26.1 0-25.1-43.9z',
  ],
};
const faFileMedicalAlt = faFileWaveform;
const faMicrochipAi = {
  prefix: 'far',
  iconName: 'microchip-ai',
  icon: [
    512,
    512,
    [],
    'e1ec',
    'M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-8 0c-35.3 0-64 28.7-64 64l0 8-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 8c0 35.3 28.7 64 64 64l8 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c35.3 0 64-28.7 64-64l0-8 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-8c0-35.3-28.7-64-64-64l-8 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40zM112 128c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256zm224 44c-11 0-20 9-20 20l0 128c0 11 9 20 20 20s20-9 20-20l0-128c0-11-9-20-20-20zM234.3 184c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1 .2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12 64.8 0 5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9L230.9 276l-29.8 0L216 241.9z',
  ],
};
const faMug = {
  prefix: 'far',
  iconName: 'mug',
  icon: [
    576,
    512,
    [],
    'f874',
    'M80 352c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-240L80 112l0 240zM32 96c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96zM416 272l32 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-32 0 0 160z',
  ],
};
const faPlaneUpSlash = {
  prefix: 'far',
  iconName: 'plane-up-slash',
  icon: [
    640,
    512,
    [],
    'e22e',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L38.8 5.1zM576 338.1l0-40.6c0-19.1-9.7-36.9-25.8-47.2L400 154.2l0-26.2c0-20.6-5.8-49.8-16.5-74.4c-5.4-12.4-12.7-25-22.4-34.9C351.2 8.6 337.4 0 320 0c-17.4 0-31.1 8.8-40.7 18.7c-9.6 9.9-16.9 22.4-22.4 34.8C250 69.2 245 86.8 242.3 102.9L288 139l0-11c0-13.4 4.4-36.1 12.8-55.1c4.2-9.4 8.7-16.4 12.9-20.7c4.1-4.2 6.1-4.2 6.3-4.2c0 0 0 0 0 0c.6 0 2.8 .1 6.8 4.2c4.2 4.3 8.6 11.2 12.7 20.6C347.8 91.7 352 114.4 352 128l0 39.4c0 8.2 4.2 15.8 11.1 20.2L524.3 290.8c2.3 1.5 3.7 4 3.7 6.7l0 29.6-2.9-.9 43.8 34.6c4.4-6.4 7.1-14.2 7.1-22.7zM148.8 212.6l-59 37.8 12.9 20.2L89.8 250.3C73.7 260.6 64 278.4 64 297.5l0 40.6c0 27.1 26.4 46.4 52.2 38.1L240 336.6l0 27.4-48 36c-10.1 7.6-16 19.4-16 32l0 42.1c0 20.9 17 37.9 37.9 37.9c2.3 0 4.6-.3 6.9-1l-6.9-23 6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 0 .6-.2 2.4-.7 8.9-2.7c7.5-2.2 17.8-5.4 29.2-8.8c19.5-5.9 42-12.6 57.8-17.5l95 29.2c24 7.4 49.1-10.7 49.1-36.2l0-12.7-48-37.9 0 12.5 0 12 0 12.4-88.9-27.4c-4.6-1.4-9.5-1.4-14.1 0c-15.5 4.8-42 12.8-64.6 19.6c-9.1 2.7-17.5 5.3-24.3 7.3l0-23.9 54.4-40.8c6-4.5 9.6-11.6 9.6-19.2l0-53.5-46.6-36.8L112 327.1l0-29.6c0-2.7 1.4-5.3 3.7-6.7l73-46.7-39.9-31.5z',
  ],
};
const faRadiation = {
  prefix: 'far',
  iconName: 'radiation',
  icon: [
    512,
    512,
    [],
    'f7b9',
    'M113.2 104.7l41.9 72.5c-7.3 9.3-13.3 19.6-17.8 30.8l-83.8 0c9.5-40.1 30.6-75.8 59.7-103.3zm83.1 350.6l41.9-72.6c5.8 .8 11.8 1.2 17.8 1.2s11.9-.4 17.8-1.2l41.9 72.6C296.8 461 276.8 464 256 464s-40.8-3-59.7-8.7zM398.8 104.7c29.1 27.5 50.2 63.1 59.7 103.3l-83.8 0c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faPenCircle = {
  prefix: 'far',
  iconName: 'pen-circle',
  icon: [
    512,
    512,
    [],
    'e20e',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faBagSeedling = {
  prefix: 'far',
  iconName: 'bag-seedling',
  icon: [
    512,
    512,
    [],
    'e5f2',
    'M91.9 150.1C84 181.9 80 214.4 80 247.2l0 17.7c0 32.7 4 65.3 11.9 97L97.5 384l317 0 5.5-22.1c7.9-31.7 11.9-64.3 11.9-97l0-17.7c0-32.7-4-65.3-11.9-97L414.5 128l-317 0-5.5 22.1zM427.5 48L84.5 48 98.7 80l314.5 0 14.2-32zM83.7 464l344.6 0-12.8-32-319 0L83.7 464zM55 99.8L35.4 55.7C33.2 50.6 32 45.1 32 39.6C32 17.7 49.7 0 71.6 0L440.4 0C462.3 0 480 17.7 480 39.6c0 5.5-1.2 11-3.4 16.1L457 99.8l9.7 38.7c8.9 35.5 13.4 72 13.4 108.7l0 17.7c0 36.6-4.5 73.1-13.4 108.7l-8.8 35.1 19.3 48.2c1.9 4.8 2.9 9.8 2.9 14.9c0 22.2-18 40.2-40.2 40.2L72.2 512C50 512 32 494 32 471.8c0-5.1 1-10.2 2.9-14.9l19.3-48.2-8.8-35.1C36.5 338 32 301.5 32 264.8l0-17.7c0-36.6 4.5-73.1 13.4-108.7L55 99.8zM144 160l2 0c47.3 0 88.4 26 110 64.5C277.6 186 318.7 160 366 160l2 0c8.8 0 16 7.2 16 16c0 59.2-45.9 107.6-104 111.7l0 40.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.3c-58.1-4.1-104-52.6-104-111.7c0-8.8 7.2-16 16-16z',
  ],
};
const faChartSimple = {
  prefix: 'far',
  iconName: 'chart-simple',
  icon: [
    448,
    512,
    [],
    'e473',
    'M240 80l0 352-32 0 0-352 32 0zM208 32c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0zM80 272l0 160-32 0 0-160 32 0zM48 224c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0zm320-80l32 0 0 288-32 0 0-288zm-48 0l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faCrutches = {
  prefix: 'far',
  iconName: 'crutches',
  icon: [
    640,
    512,
    [],
    'f7f8',
    'M183 7L7 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15L201.9 347.8c1.9 1.9 3.8 3.6 5.8 5.3l3.5-3.5c1.1-1.1 1.8-2.4 2.2-3.9l9.9-44.4L89.9 168 168 89.9l95.7 95.7c1.9-2.2 3.9-4.3 5.9-6.4l27.8-27.8L201.9 56l15-15c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM402 402.7l-27.2 6L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.2-77.2c-8.2 3.9-16.8 6.9-25.8 8.9zM423 7c-9.4 9.4-9.4 24.6 0 33.9L599 217c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L457 7c-9.4-9.4-24.6-9.4-33.9 0zm-7.6 71.6L292.2 201.9c-11.8 11.8-20 26.8-23.7 43.1L244.6 352.6c-1.7 7.4-5.4 14.2-10.8 19.6L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l98.8-98.8c5.4-5.4 12.2-9.1 19.6-10.8L395 371.5c16.3-3.6 31.3-11.8 43.1-23.7L561.4 224.6l-33.9-33.9L456 262.1 377.9 184l71.4-71.4L415.4 78.6zM326.2 235.8L344 217.9 422.1 296l-17.8 17.9c-5.4 5.4-12.2 9.1-19.6 10.8l-89 19.8 19.8-89c1.7-7.4 5.4-14.2 10.8-19.6z',
  ],
};
const faCircleParking = {
  prefix: 'far',
  iconName: 'circle-parking',
  icon: [
    512,
    512,
    ['parking-circle'],
    'f615',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216 16l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-64 0 0 96zm64 48l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-136c0-17.7 14.3-32 32-32l80 0c53 0 96 43 96 96s-43 96-96 96z',
  ],
};
const faParkingCircle = faCircleParking;
const faMarsStroke = {
  prefix: 'far',
  iconName: 'mars-stroke',
  icon: [
    512,
    512,
    [9894],
    'f229',
    'M352 24c0-13.3 10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L409.9 136l31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L342.1 136l-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L430.1 48 376 48c-13.3 0-24-10.7-24-24zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256z',
  ],
};
const faLeafOak = {
  prefix: 'far',
  iconName: 'leaf-oak',
  icon: [
    512,
    512,
    [],
    'f6f7',
    'M302 0c-33.4 0-62.4 22.7-70.5 55.1l-1.9 7.5c-25.2-23.7-64.8-23.2-89.4 1.4c-14.3 14.3-21 34.5-18.2 54.6l5.4 37.6c-20.5-2-41.6 5-57 20.4l-3.2 3.2c-23.2 23.2-29 58.7-14.3 88.1l12.4 24.7c7.2 14.4 11 30.4 11 46.5l0 62.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72.4-72.4 56.3 0c16.1 0 32.1 3.8 46.5 11l24.7 12.4c29.4 14.7 64.9 8.9 88.1-14.3l3.2-3.2c15.4-15.4 22.4-36.5 20.4-57l37.6 5.4c20 2.9 40.2-3.9 54.6-18.2c24.6-24.6 25.1-64.2 1.4-89.4l7.5-1.9c32.4-8.1 55.1-37.2 55.1-70.5c0-24.3-12.2-47-32.4-60.5l-7-4.6 2.8-11.3c6.6-26.4-1.1-54.3-20.3-73.5s-47.1-26.9-73.5-20.4l-11.3 2.8-4.6-7C349 12.1 326.3 0 302 0zM161.3 384.6L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L124.1 353.9l0-14.8c0-23.6-5.5-46.9-16-68L95.7 246.4c-5.4-10.9-3.3-24.1 5.3-32.7l3.2-3.2c7.7-7.7 19.7-8.8 28.7-2.8c21.5 14.3 49.7-3.5 46.1-29l-9.5-66.8c-.7-5.1 1-10.2 4.6-13.8c6.4-6.4 16.7-6.4 23 0l18.5 18.5c17.6 17.6 47.6 9.3 53.7-14.9L278 66.7c2.7-11 12.6-18.7 24-18.7c8.3 0 16 4.1 20.6 11l7.8 11.7c9.4 14.1 26.6 20.7 43 16.6L390 83.1c10-2.5 20.6 .4 27.9 7.7s10.2 17.9 7.7 27.9l-4.2 16.7c-4.1 16.4 2.6 33.6 16.6 43l11.7 7.8c6.9 4.6 11 12.3 11 20.6c0 11.3-7.7 21.2-18.7 24l-34.9 8.7c-24.1 6-32.5 36.1-14.9 53.7l18.5 18.5c6.4 6.4 6.4 16.7 0 23c-3.6 3.6-8.7 5.3-13.8 4.6l-66.8-9.5c-25.5-3.6-43.4 24.6-29 46.1c6 9 4.8 21-2.8 28.7l-3.2 3.2c-8.6 8.6-21.8 10.7-32.7 5.3l-24.7-12.4c-21.1-10.6-44.4-16-68-16l-8.3 0z',
  ],
};
const faSquareBolt = {
  prefix: 'far',
  iconName: 'square-bolt',
  icon: [
    448,
    512,
    [],
    'e265',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm298.1 19.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272 128 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z',
  ],
};
const faVial = {
  prefix: 'far',
  iconName: 'vial',
  icon: [
    512,
    512,
    [129514],
    'f492',
    'M329 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L30.2 335.8C10.9 355.2 0 381.4 0 408.8C0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-32-32L361 39 329 7zm-151 249L344 89.9 422.1 168l-88 88-156.1 0z',
  ],
};
const faGauge = {
  prefix: 'far',
  iconName: 'gauge',
  icon: [
    512,
    512,
    ['dashboard', 'gauge-med', 'tachometer-alt-average'],
    'f624',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 181.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faDashboard = faGauge;
const faGaugeMed = faGauge;
const faTachometerAltAverage = faGauge;
const faWandMagicSparkles = {
  prefix: 'far',
  iconName: 'wand-magic-sparkles',
  icon: [
    576,
    512,
    ['magic-wand-sparkles'],
    'e2ca',
    'M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM461.4 48L496 82.6 386.2 192.3l-34.6-34.6L461.4 48zM80 429.4L317.7 191.7l34.6 34.6L114.6 464 80 429.4zM427.4 14.1L46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z',
  ],
};
const faMagicWandSparkles = faWandMagicSparkles;
const faLambda = {
  prefix: 'far',
  iconName: 'lambda',
  icon: [
    448,
    512,
    [],
    'f66e',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l108.6 0c3 0 5.7 1.7 7.1 4.3l10.2 19.6L2 446.5c-5.3 12.2 .4 26.3 12.5 31.5s26.3-.3 31.5-12.5L178.4 158.9l151.3 291c9.6 18.5 28.8 30.2 49.7 30.2l44.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-44.6 0c-3 0-5.7-1.7-7.1-4.3L182.3 62.2C172.6 43.6 153.5 32 132.6 32L24 32z',
  ],
};
const faE = {
  prefix: 'far',
  iconName: 'e',
  icon: [
    320,
    512,
    [101],
    '45',
    'M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 432c-4.4 0-8-3.6-8-8l0-152 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 224 48 88c0-4.4 3.6-8 8-8l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32z',
  ],
};
const faPizza = {
  prefix: 'far',
  iconName: 'pizza',
  icon: [
    576,
    512,
    [127829],
    'f817',
    'M254.2 322.1c-8.4 3.8-14.2 12.2-14.2 21.9c0 13.3 10.7 24 24 24c9.8 0 18.2-5.8 21.9-14.2L318.1 386c-18.8 9-39.8 14-62.1 14c-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-84.7 84.7c-25 25-25 65.5 0 90.5l20.8 20.8zm87.6 87.6l23.4 23.4C333.5 452.7 296.1 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zM425.4 448c6.6-5.8 6.6-16 .3-22.3L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L425.7 86.3C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64zm71.7-82.8l-23.4-23.4C487.9 316.4 496 287.1 496 256s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256 450 193.9c9 18.8 14 39.8 14 62.1zm48 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L489.7 425.7c6.2 6.2 16.4 6.3 22.3-.3zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faBowlChopsticksNoodles = {
  prefix: 'far',
  iconName: 'bowl-chopsticks-noodles',
  icon: [
    512,
    512,
    [],
    'e2ea',
    'M13.1 93.6L128 72l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7 0 37.5 0 38 0 37.5 0 48s0 0 0 0l32 0s0 0 0 0l0-48 0-38.5 0-42L208 57l0-17c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 40 0 48 0 40 0 48s0 0 0 0l32 0s0 0 0 0l176 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272c0-26.5 21.5-48 48-48l80 0 0-48L16.2 176C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140l0-32L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176L288 176l0-41 199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83l0-41L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5z',
  ],
};
const faH3 = {
  prefix: 'far',
  iconName: 'h3',
  icon: [
    640,
    512,
    [],
    'f315',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l142.1 0L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l88 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-72.6 0c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8l72.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-30.1 0L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64L400 64z',
  ],
};
const faPenClip = {
  prefix: 'far',
  iconName: 'pen-clip',
  icon: [
    512,
    512,
    ['pen-alt'],
    'f305',
    'M320 62.1l42.7-42.7c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L286.1 96 273 82.9c-9.4-9.4-24.6-9.4-33.9 0L137 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L205.1 49c28.1-28.1 73.7-28.1 101.8 0L320 62.1zm0 67.9L133.5 316.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L382.1 192 320 129.9z',
  ],
};
const faPenAlt = faPenClip;
const faBridgeCircleExclamation = {
  prefix: 'far',
  iconName: 'bridge-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4ca',
    'M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faBadgePercent = {
  prefix: 'far',
  iconName: 'badge-percent',
  icon: [
    512,
    512,
    [],
    'f646',
    'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z',
  ],
};
const faRotateReverse = {
  prefix: 'far',
  iconName: 'rotate-reverse',
  icon: [
    512,
    512,
    [],
    'e631',
    'M418 187.1C391.2 124.1 328.7 80 256 80c-39.7 0-77.8 15.8-105.9 43.9l-4.1 4.1 35.7 35.7c6.6 6.6 10.3 15.6 10.3 25c0 19.5-15.8 35.3-35.3 35.3L40 224c-13.3 0-24-10.7-24-24L16 83.3C16 63.8 31.8 48 51.3 48c9.4 0 18.3 3.7 25 10.3L112 94.1l4.1-4.1C153.2 52.8 203.5 32 256 32c92.6 0 172.1 56.2 206.2 136.3c5.2 12.2-.5 26.3-12.7 31.5s-26.3-.5-31.5-12.7zM50 344.1c-5.2-12.2 .4-26.3 12.6-31.5s26.3 .4 31.5 12.6C121 388.1 183.4 432 256 432c39.7 0 77.8-15.8 105.9-43.9l4.1-4.1-35.7-35.7c-6.6-6.6-10.3-15.6-10.3-25c0-19.5 15.8-35.3 35.3-35.3L472 288c13.3 0 24 10.7 24 24l0 116.7c0 19.5-15.8 35.3-35.3 35.3c-9.4 0-18.3-3.7-25-10.3L400 417.9l-4.1 4.1C358.8 459.2 308.5 480 256 480c-92.5 0-171.8-56-206-135.9zM64 176l62.1 0L64 113.9 64 176zM448 336l-62.1 0L448 398.1l0-62.1z',
  ],
};
const faUser = {
  prefix: 'far',
  iconName: 'user',
  icon: [
    448,
    512,
    [128100, 62144],
    'f007',
    'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z',
  ],
};
const faSensor = {
  prefix: 'far',
  iconName: 'sensor',
  icon: [
    448,
    512,
    [],
    'e028',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 56l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faComma = {
  prefix: 'far',
  iconName: 'comma',
  icon: [
    192,
    512,
    [],
    '2c',
    'M120 353.4c0-9.6-7.8-17.4-17.4-17.4c-8.4 0-15.6 6-17.1 14.3L66.7 453.6l50.4-85.7c1.9-3.3 2.9-7 2.9-10.7l0-3.8zm48 0l0 3.8c0 12.3-3.3 24.4-9.5 35.1l-57.2 97.2C93.1 503.4 78 512 61.8 512L60 512c-24.3 0-44-19.7-44-44c0-2.6 .2-5.3 .7-7.9L38.2 341.7C43.9 310.6 71 288 102.6 288c36.1 0 65.4 29.3 65.4 65.4z',
  ],
};
const faSchoolCircleCheck = {
  prefix: 'far',
  iconName: 'school-circle-check',
  icon: [
    640,
    512,
    [],
    'e56b',
    'M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z',
  ],
};
const faToiletPaperUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-under',
  icon: [
    512,
    512,
    ['toilet-paper-reverse'],
    'e2a0',
    'M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3l212.7 0c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1L112 48c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456l0-104.9c-16.6 19.3-38.1 32.9-64 32.9l-288 0c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0L400 0c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192l0 264c0 30.9-25.1 56-56 56l-240 0c-30.9 0-56-25.1-56-56l0-40 48 0 0 40c0 4.4 3.6 8 8 8l240 0c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM112 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faToiletPaperReverse = faToiletPaperUnder;
const faLightEmergency = {
  prefix: 'far',
  iconName: 'light-emergency',
  icon: [
    448,
    512,
    [],
    'e41f',
    'M352 304l0-96c0-70.7-57.3-128-128-128S96 137.3 96 208l0 96-48 0 0-96c0-97.2 78.8-176 176-176s176 78.8 176 176l0 96-48 0zM48 384l0 48 352 0 0-48L48 384zm0-48l352 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48zM160 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z',
  ],
};
const faArrowDownToArc = {
  prefix: 'far',
  iconName: 'arrow-down-to-arc',
  icon: [
    512,
    512,
    [],
    'e4ae',
    'M256 464c114.9 0 208-93.1 208-208c0-13.3 10.7-24 24-24s24 10.7 24 24c0 141.4-114.6 256-256 256S0 397.4 0 256c0-13.3 10.7-24 24-24s24 10.7 24 24c0 114.9 93.1 208 208 208zM377.6 232.3l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 266.9 232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9z',
  ],
};
const faDumpster = {
  prefix: 'far',
  iconName: 'dumpster',
  icon: [
    576,
    512,
    [],
    'f793',
    'M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0l94 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0 25.6 128zM86.4 240l403.3 0-20 160-363.3 0-20-160zM112 448l352 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 22-176 18 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0 4-32-48.4 0L80.4 192 32 192l4 32-12 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l18 0L64 448l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8z',
  ],
};
const faVanShuttle = {
  prefix: 'far',
  iconName: 'van-shuttle',
  icon: [
    640,
    512,
    [128656, 'shuttle-van'],
    'f5b6',
    'M48 96l0 96 128 0 0-112L64 80c-8.8 0-16 7.2-16 16zm0 144l0 80c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l153.7 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l12.8 0c8.8 0 16-7.2 16-16l0-80-232 0-160 0L48 240zm176-48l112 0 0-112L224 80l0 112zm160 0l180.1 0L471.3 82.8c-1.5-1.8-3.7-2.8-6.1-2.8L384 80l0 112zM640 320c0 35.3-28.7 64-64 64c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l136 0 160 0 105.2 0c16.4 0 32 7.2 42.7 19.7L626.7 191.5c8.6 10.1 13.3 23 13.3 36.3l0 92.2zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faShuttleVan = faVanShuttle;
const faBuildingUser = {
  prefix: 'far',
  iconName: 'building-user',
  icon: [
    640,
    512,
    [],
    'e4da',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 351.7c11.3-20 27.9-36.7 48-47.9l0-95.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm344 56a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z',
  ],
};
const faLightSwitch = {
  prefix: 'far',
  iconName: 'light-switch',
  icon: [
    384,
    512,
    [],
    'e017',
    'M192 64c-10.4 0-19.3-6.7-22.6-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l105.4 0c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16L320 464c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L214.6 48c-3.3 9.3-12.2 16-22.6 16zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM144 368l96 0 0-88-96 0 0 88zm0-224l0 88 96 0 0-88-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224z',
  ],
};
const faSquareCaretLeft = {
  prefix: 'far',
  iconName: 'square-caret-left',
  icon: [
    448,
    512,
    ['caret-square-left'],
    'f191',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z',
  ],
};
const faCaretSquareLeft = faSquareCaretLeft;
const faHighlighter = {
  prefix: 'far',
  iconName: 'highlighter',
  icon: [
    576,
    512,
    [],
    'f591',
    'M184 296.6l0-48 22.5-16.2 113 113L303.4 368l-48 0c-12.7 0-24.9 5.1-33.9 14.1l-38.1 38.1-51.5-51.5 38.1-38.1c9-9 14.1-21.2 14.1-33.9zM502.8 90.2L347.9 306 246 204.1 461.8 49.2c1.1-.8 2.4-1.2 3.7-1.2c1.7 0 3.3 .7 4.5 1.9L502.1 82c1.2 1.2 1.9 2.8 1.9 4.5c0 1.3-.4 2.6-1.2 3.7zM255.4 416l48 0c15.5 0 30-7.4 39-20L541.8 118.2C548.4 109 552 97.9 552 86.5c0-14.4-5.7-28.2-15.9-38.4L503.9 15.9C493.7 5.7 479.9 0 465.5 0C454.1 0 443 3.6 433.8 10.2L156 209.6c-12.6 9-20 23.5-20 39l0 48L92.3 340.3c-10.7 10.7-14.1 26-10.1 39.5L9.4 452.7c-6 6-9.4 14.1-9.4 22.6L0 480c0 17.7 14.3 32 32 32l84.7 0c8.5 0 16.6-3.4 22.6-9.4l32.8-32.8c13.6 4 28.8 .6 39.5-10.1L255.4 416zM134.7 439.3L110.1 464l-44.1 0 46.7-46.7 22.1 22.1z',
  ],
};
const faWavePulse = {
  prefix: 'far',
  iconName: 'wave-pulse',
  icon: [
    640,
    512,
    ['heart-rate'],
    'f5f8',
    'M319.4 0c11.1-.3 21 7.1 23.8 17.9l79.3 303.9 27.1-57.7c9.2-19.6 29-32.2 50.7-32.2L616 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-115.7 0c-3.1 0-5.9 1.8-7.2 4.6L437.7 402.2c-4.3 9.1-13.9 14.6-23.9 13.7s-18.5-8.1-21-17.8L322.7 129.4 247.5 492.9c-2.2 10.9-11.6 18.8-22.7 19.1s-21-6.9-23.9-17.6L143.3 285.9c-1-3.5-4.1-5.9-7.7-5.9L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l111.6 0c25.2 0 47.3 16.8 54 41.1l31 112.6L296.5 19.1C298.8 8.2 308.2 .3 319.4 0z',
  ],
};
const faHeartRate = faWavePulse;
const faKey = {
  prefix: 'far',
  iconName: 'key',
  icon: [
    512,
    512,
    [128273],
    'f084',
    'M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6c-8.1-2-16.7 .4-22.6 6.4L254.1 336 200 336c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24l0 40-64 0 0-78.1L205.2 228.7c5.9-5.9 8.3-14.5 6.4-22.6c-2.3-9.6-3.6-19.7-3.6-30.1zM336 0C238.8 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faArrowLeftToBracket = {
  prefix: 'far',
  iconName: 'arrow-left-to-bracket',
  icon: [
    512,
    512,
    [],
    'e669',
    'M295 401L167 273c-9.4-9.4-9.4-24.6 0-33.9L295 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-246.1 0 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zM168 80L88 80c-22.1 0-40 17.9-40 40l0 272c0 22.1 17.9 40 40 40l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-48.6 0-88-39.4-88-88L0 120C0 71.4 39.4 32 88 32l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faHatSanta = {
  prefix: 'far',
  iconName: 'hat-santa',
  icon: [
    640,
    512,
    [],
    'f7a7',
    'M64 352l51.7 0 78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6l19 22.5c-4-.7-8-1.1-12-1.1l-1.2 0c-37.3 0-67.6 30.3-67.6 67.6c0 10 2.2 19.8 6.4 28.8L395 352l53 0L385.9 220c-1.2-2.6-1.9-5.5-1.9-8.4c0-10.8 8.8-19.6 19.6-19.6l1.2 0c2.1 0 4.2 .3 6.3 1l47.1 14.9c1.9-2.7 4-5.1 6.3-7.4c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L64 352zM583.9 182.2C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 384c-26.5 0-48 21.5-48 48z',
  ],
};
const faTamale = {
  prefix: 'far',
  iconName: 'tamale',
  icon: [
    320,
    512,
    [129748],
    'e451',
    'M319.6 69.3L296.4 208l-.4 0-48.2 0L270.7 70.3c-6.4-4.6-14.9-8.8-25.4-12.1L229.2 208l-32.2 0L213.8 51.3c-12.5-1.8-25.3-2.7-37.8-3L176 208l-16 0-16 0 0-159.8c-12.5 .4-25.4 1.3-37.8 3L122.9 208l-32.2 0L74.7 58.2c-10.6 3.4-19 7.5-25.4 12.1L72.2 208 24 208l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM296 304l.4 0 23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0 42.7 0c-3.7 10.5-3.6 22 .1 32.3L49.3 441.7c6.4 4.6 14.9 8.8 25.4 12.1l10.1-94.3c9.5 6.5 20.6 9.2 31.3 8.3l-10 92.9c12.5 1.8 25.3 2.6 37.8 3l0-108c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8c1.9 2.6 4.1 4.9 6.4 7l0 108c12.5-.4 25.4-1.3 37.8-3l-10-92.9c10.7 .9 21.8-1.7 31.3-8.3l10.1 94.3c10.6-3.4 19-7.5 25.4-12.1L253.2 336.3c3.7-10.3 3.8-21.7 .1-32.3l42.7 0zM24 240l136 0 136 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-104 0 28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272 24 272c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faBoxCheck = {
  prefix: 'far',
  iconName: 'box-check',
  icon: [
    448,
    512,
    [],
    'f467',
    'M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zM48 208l352 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm152-48L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z',
  ],
};
const faBullhorn = {
  prefix: 'far',
  iconName: 'bullhorn',
  icon: [
    512,
    512,
    [128226, 128363],
    'f0a1',
    'M432 73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9c0 0 0 .1 0 .1l0 128s0 0 0 0c0 0 0 .1 0 .1c80.1 1.9 156.5 34.5 213.3 91.3L432 406.1l0-332.1zM160 128l40.7 0c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3l0 144.3c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4l0 144.3c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2L208 456c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-104c-35.3 0-64-28.7-64-64l0-96c0-35.3 28.7-64 64-64l96 0zM112 352l0 104c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-104-48 0zM64 176c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16c0 0 0 0 0 0l48 0 48 0 0-128-96 0z',
  ],
};
const faSteak = {
  prefix: 'far',
  iconName: 'steak',
  icon: [
    576,
    512,
    [129385],
    'f824',
    'M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6c-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3c-26.6 26.6-56.8 42.7-81.6 55.3c-2.8 1.4-5.5 2.8-8.1 4.1c0 0 0 0 0 0c-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360c0 50 42.8 75.3 77.6 87.3C162.2 459.8 206.1 464 240 464c70.2 0 140.7-26.7 194-66.3c52.5-39.1 94-95.4 94-157.7c0-48.1-19-95-47-130c-27.6-34.5-67.9-62-113-62c-27.4 0-49.4 8.6-66.5 24.6zM268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faLocationCrosshairsSlash = {
  prefix: 'far',
  iconName: 'location-crosshairs-slash',
  icon: [
    640,
    512,
    ['location-slash'],
    'f603',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c13.4-22.3 22.4-47.6 25.8-74.6l41.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.5 0C499.7 145.2 430.8 76.3 344 65.5L344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 41.5c-43.1 5.4-81.8 25-111.1 54.1L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-22 0-42.2 7.4-58.4 19.8l-38.6-30.2zM367.5 262.8l-65.5-51.3c5.5-2.2 11.6-3.5 17.9-3.5c26.5 0 48 21.5 48 48c0 2.3-.2 4.6-.5 6.8zm47.4 160.2l-41.9-33c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3L88 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l41.5 0c10.8 86.8 79.7 155.7 166.5 166.5l0 41.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-41.5c25.5-3.2 49.5-11.4 70.9-23.6z',
  ],
};
const faLocationSlash = faLocationCrosshairsSlash;
const faPersonDolly = {
  prefix: 'far',
  iconName: 'person-dolly',
  icon: [
    512,
    512,
    [],
    'f4d0',
    'M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM0 340.3L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-109.9L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zM48 187.2C48 181 53 176 59.2 176c4.5 0 8.9 1.1 12.8 3l0 116.2L51.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3l0-85.3zm72 145.7l0-86.7 15.1 23.5c7.4 11.4 20 18.4 33.6 18.4l54.5 0 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1L211.3 240l-38.2 0-49.3-76.7c-14.1-22-38.5-35.3-64.6-35.3C26.5 128 0 154.5 0 187.2l0 85.3c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L160.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L120 332.9zM288 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm69.4-55.8L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3z',
  ],
};
const faGlobe = {
  prefix: 'far',
  iconName: 'globe',
  icon: [
    512,
    512,
    [127760],
    'f0ac',
    'M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6l-139.2 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304l155 0c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4l-65.9 0c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z',
  ],
};
const faSynagogue = {
  prefix: 'far',
  iconName: 'synagogue',
  icon: [
    640,
    512,
    [128333],
    'f69b',
    'M305.1 5.2c8.7-6.9 21-6.9 29.7 0L462.5 105.9C483.7 122.6 496 148.1 496 175l0 63 31-31c9.4-9.4 24.6-9.4 33.9 0l62.6 62.6c10.5 10.5 16.4 24.7 16.4 39.6L640 440c0 39.8-32.2 72-72 72l-96 0-88 0-128 0-88 0-96 0c-39.8 0-72-32.2-72-72L0 309.3c0-14.9 5.9-29.1 16.4-39.6L79 207c9.4-9.4 24.6-9.4 33.9 0l31 31 0-63c0-26.9 12.3-52.4 33.5-69.1L305.1 5.2zM496 464l72 0c13.3 0 24-10.7 24-24l0-130.7c0-2.1-.8-4.2-2.3-5.7L544 257.9l-45.7 45.7c-1.5 1.5-2.3 3.5-2.3 5.7L496 464zM448 175c0-12.2-5.6-23.8-15.2-31.4L320 54.6l-112.8 89c-9.6 7.6-15.2 19.2-15.2 31.4l0 134.2L192 464l64 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 64 0 0-154.7L448 175zM144 309.3c0-2.1-.8-4.2-2.3-5.7L96 257.9 50.3 303.6c-1.5 1.5-2.3 3.5-2.3 5.7L48 440c0 13.3 10.7 24 24 24l72 0 0-154.7zM327 124.3l15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3L327 259.7c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3 .3c-6.2 .1-10.1-6.7-7-12.1L274.3 192l-16.4-27.8c-3.2-5.4 .7-12.1 7-12.1l32.3 .3L313 124.3c3.1-5.4 10.9-5.4 13.9 0z',
  ],
};
const faFileChartColumn = {
  prefix: 'far',
  iconName: 'file-chart-column',
  icon: [
    384,
    512,
    ['file-chart-line'],
    'f659',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96zM128 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z',
  ],
};
const faFileChartLine = faFileChartColumn;
const faPersonHalfDress = {
  prefix: 'far',
  iconName: 'person-half-dress',
  icon: [
    320,
    512,
    [],
    'e548',
    'M154 .4A48 48 0 1 1 166 95.6 48 48 0 1 1 154 .4zM176 352l0-48s0 0 0 0l0-127.9s0 0 0 0l0-48c30.8 .8 59.1 17.7 74.3 44.6l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136s0 0 0 0zM62.9 184.6c17.1-30.3 47.2-50.6 81.1-55.5l0 108.6L113.3 336l30.7 0 0 48s0 0 0 0l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.2 0c-10.8 0-18.5-10.5-15.3-20.8l46.3-148L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5z',
  ],
};
const faFolderImage = {
  prefix: 'far',
  iconName: 'folder-image',
  icon: [
    512,
    512,
    [],
    'e18a',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM160 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm155.2 9.6c-4.5-6-11.6-9.6-19.2-9.6s-14.7 3.6-19.2 9.6l-54.2 72.2L202.7 265c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1l-96-128z',
  ],
};
const faCalendarPen = {
  prefix: 'far',
  iconName: 'calendar-pen',
  icon: [
    448,
    512,
    ['calendar-edit'],
    'f333',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-91.2 51c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L240.6 258 255.5 243c14.7-14.7 38.6-14.7 53.3 0zM146.1 352.5L218 280.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.6c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faCalendarEdit = faCalendarPen;
const faRoadBridge = {
  prefix: 'far',
  iconName: 'road-bridge',
  icon: [
    640,
    512,
    [],
    'e563',
    'M576 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-72 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-72 0c-8.8 0-16-7.2-16-16l0-384c0-8.8 7.2-16 16-16l72 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 72 0zm0-48L384 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM480 192c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 64 0 0-48-40 0 0-64 40 0 0-48L24 96zM272 304c-57.4 0-104 46.6-104 104l0 56-48 0 0-64c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 72c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-64c0-30.9 25.1-56 56-56l16 0 0-48-16 0zM200 144l0 64-80 0 0-64 80 0z',
  ],
};
const faFaceSmileTear = {
  prefix: 'far',
  iconName: 'face-smile-tear',
  icon: [
    512,
    512,
    [],
    'e393',
    'M338.7 446.9c4.3 .7 8.8 1.1 13.3 1.1c43.4 0 80-34.6 80-79c0-.7 0-1.4 0-2c20.3-32.1 32-70.2 32-111c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm136.3 61.9c10-8.7 25.2-7.6 33.9 2.4C187 339.8 215.5 360 256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58 0-98.8-29.4-122.1-56.3c-8.7-10-7.6-25.2 2.4-33.9zM352 416c-26.5 0-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369c0 26-21.5 47-48 47zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faMessagePlus = {
  prefix: 'far',
  iconName: 'message-plus',
  icon: [
    512,
    512,
    ['comment-alt-plus'],
    'f4a8',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faCommentAltPlus = faMessagePlus;
const faLocationArrow = {
  prefix: 'far',
  iconName: 'location-arrow',
  icon: [
    448,
    512,
    [],
    'f124',
    'M224 208l-94.6 0 241.4-98.7L272 350.6l0-94.6c0-26.5-21.5-48-48-48zm-48 48l48 0 0 48 0 128c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l128 0z',
  ],
};
const faC = {
  prefix: 'far',
  iconName: 'c',
  icon: [
    384,
    512,
    [99],
    '43',
    'M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7s177.5 68.7 245.2 0c9.3-9.4 24.4-9.4 33.7 0s9.3 24.7 0 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317S290.9 10 377.2 97.5c9.3 9.4 9.3 24.7 0 34.2s-24.4 9.4-33.7 0z',
  ],
};
const faTabletButton = {
  prefix: 'far',
  iconName: 'tablet-button',
  icon: [
    448,
    512,
    [],
    'f10a',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPersonDressFairy = {
  prefix: 'far',
  iconName: 'person-dress-fairy',
  icon: [
    640,
    512,
    [],
    'e607',
    'M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm48.3 144c-7.1 0-13.4 4.7-15.4 11.6L255.6 336l128.7 0L351.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.5 0zm0-48l31.5 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L384 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-14.1 8-26.1 19.5-34.7 33.5C181.6 120.7 119 85.2 48 80.5L48 112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c32.1-.2 61.9-9.7 87-26.2c7.2 4.6 15.4 7.9 24.3 9.3l0 32.1C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM417.6 173.9c-8.6-14-20.6-25.5-34.7-33.5C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-32.1c8.9-1.4 17.1-4.7 24.3-9.3c25 16.4 54.9 26 87 26.2c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112l0-31.5c-71 4.7-133.6 40.2-174.4 93.3z',
  ],
};
const faRectangleHistoryCircleUser = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-user',
  icon: [
    640,
    512,
    [],
    'e4a4',
    'M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faBuildingLock = {
  prefix: 'far',
  iconName: 'building-lock',
  icon: [
    576,
    512,
    [],
    'e4d6',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 245.7c4.6-5.2 10-9.6 16-13.1l0-24.6c0-30.5 12.2-58.2 32-78.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5l0-16-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm232 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faChartLineUp = {
  prefix: 'far',
  iconName: 'chart-line-up',
  icon: [
    512,
    512,
    [],
    'e0e5',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zm272 96c0 13.3 10.7 24 24 24l54.1 0L304 270.1l-79-79c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 79 79c9.4 9.4 24.6 9.4 33.9 0l111-111 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faMailbox = {
  prefix: 'far',
  iconName: 'mailbox',
  icon: [
    576,
    512,
    [128234],
    'f813',
    'M48 208c0-53 43-96 96-96s96 43 96 96l0 192L64 400c-8.8 0-16-7.2-16-16l0-176zM240 448l48 0 224 0c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144L144 64C64.5 64 0 128.5 0 208L0 384c0 35.3 28.7 64 64 64l176 0zm48-240c0-36.9-13.9-70.5-36.7-96L432 112c53 0 96 43 96 96l0 176c0 8.8-7.2 16-16 16l-224 0 0-192zM104 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm256 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 24c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-16 0-80 0z',
  ],
};
const faSignPosts = {
  prefix: 'far',
  iconName: 'sign-posts',
  icon: [
    576,
    512,
    [],
    'e625',
    'M64 24l0 8L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l16 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 352 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 16 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L112 32l0-8c0-13.3-10.7-24-24-24S64 10.7 64 24zM528 80l0 288L48 368 48 80l480 0z',
  ],
};
const faTruckBolt = {
  prefix: 'far',
  iconName: 'truck-bolt',
  icon: [
    640,
    512,
    [],
    'e3d0',
    'M352 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-32 0-76.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l288 0zm32 368c0 53 43 96 96 96s96-43 96-96l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-122.7c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l64 0 32 0 24 0 8 0zM557.7 239.6c.1 .1 .3 .3 .4 .4l-142 0 0-96 42.7 0c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.2 84.6c-5.3-5.2-13.4-6.1-19.7-2.2l-128 80c-6.1 3.8-8.9 11.1-6.9 18s8.2 11.6 15.4 11.6l51.7 0-33.5 55.8c-3.8 6.3-2.8 14.5 2.5 19.6s13.4 6.1 19.7 2.2l128-80c6.1-3.8 8.9-11.1 6.9-18s-8.2-11.6-15.4-11.6l-51.7 0 33.5-55.8c3.8-6.3 2.8-14.5-2.5-19.6z',
  ],
};
const faPizzaSlice = {
  prefix: 'far',
  iconName: 'pizza-slice',
  icon: [
    512,
    512,
    [],
    'f818',
    'M122.2 35.6L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L476.4 389.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9c-22.8-1.6-41.9 14-47.5 34.7zM144.6 138C264.3 152.7 359.3 247.7 374 367.4L61.2 450.8 144.6 138zm12.5-46.8l11.3-42.3C325.6 60.7 451.3 186.4 463.1 343.7l-42.3 11.3c-19.7-136.2-127.5-244-263.7-263.7zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faMoneyBillWave = {
  prefix: 'far',
  iconName: 'money-bill-wave',
  icon: [
    576,
    512,
    [],
    'f53a',
    'M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7l0-176c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192l0 176c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z',
  ],
};
const faChartArea = {
  prefix: 'far',
  iconName: 'chart-area',
  icon: [
    512,
    512,
    ['area-chart'],
    'f1fe',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM286.1 225.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1l27.3-27.3L432 257.8l0 78.2-288 0 0-92.1 80-80 62.1 62.1zM320 192l-33.9-33.9-39.4-39.4c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9L96 352c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-5.6 5.6L320 192z',
  ],
};
const faAreaChart = faChartArea;
const faHouseFlag = {
  prefix: 'far',
  iconName: 'house-flag',
  icon: [
    640,
    512,
    [],
    'e50d',
    'M472 0c-13.3 0-24 10.7-24 24l0 8 0 160 0 320 48 0 0-320 128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L496 32l0-8c0-13.3-10.7-24-24-24zM416 133L286.3 36.7c-8.5-6.3-20.1-6.3-28.6 0l-248 184c-10.6 7.9-12.9 22.9-5 33.6s22.9 12.9 33.6 5L64 240.2 64 432c0 44.2 35.8 80 80 80l256 0c5.5 0 10.8-.6 16-1.6l0-50.7c-4.7 2.7-10.2 4.3-16 4.3l-48 0 0-120c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 120-48 0c-17.7 0-32-14.3-32-32l0-227.4L272 85.9 416 192.7l0-59.8zM304 352l0 112-64 0 0-112 64 0z',
  ],
};
const faCircleThreeQuartersStroke = {
  prefix: 'far',
  iconName: 'circle-three-quarters-stroke',
  icon: [
    512,
    512,
    [],
    'e5d4',
    'M256 48l0 176c0 17.7 14.3 32 32 32l176 0c0-114.9-93.1-208-208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faPersonCircleMinus = {
  prefix: 'far',
  iconName: 'person-circle-minus',
  icon: [
    576,
    512,
    [],
    'e540',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
  ],
};
const faScalpel = {
  prefix: 'far',
  iconName: 'scalpel',
  icon: [
    512,
    512,
    [],
    'f61d',
    'M421.4 59.2c5.1-6.1 13-9.2 20.9-8.5C454.6 52 464 62.4 464 74.7c0 5.9-2.2 11.6-6.1 16L325.1 240l-56.3 0L421.4 59.2zM227.7 288l.7 0 96.8 0c13.7 0 26.8-5.9 35.9-16.1L493.8 122.6C505.5 109.4 512 92.3 512 74.7c0-37-28.1-68-64.9-71.7c-23.7-2.4-47 7.1-62.4 25.3L206.1 240l-.4 .5-5.6 6.7-12.2 14.5c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l19 0 8.8 0zm-63 36.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7z',
  ],
};
const faBan = {
  prefix: 'far',
  iconName: 'ban',
  icon: [
    512,
    512,
    [128683, 'cancel'],
    'f05e',
    'M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faCancel = faBan;
const faBellExclamation = {
  prefix: 'far',
  iconName: 'bell-exclamation',
  icon: [
    448,
    512,
    [],
    'f848',
    'M224 0c-17.7 0-32 14.3-32 32l0 17.9C119.5 61.4 64 124.2 64 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L256 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM256 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80z',
  ],
};
const faCircleBookmark = {
  prefix: 'far',
  iconName: 'circle-bookmark',
  icon: [
    512,
    512,
    ['bookmark-circle'],
    'e100',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176l0 192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4l0-192c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faBookmarkCircle = faCircleBookmark;
const faEggFried = {
  prefix: 'far',
  iconName: 'egg-fried',
  icon: [
    512,
    512,
    [],
    'f7fc',
    'M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 14-22.6 32-24.3 50.6C107.7 173.6 92.7 244.5 63 296c-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7c23.3-14.3 50.6-25.3 77.1-29c12.7-1.8 25.3-6.7 36.4-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112-32c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16c0-22.1 17.9-40 40-40z',
  ],
};
const faFaceWeary = {
  prefix: 'far',
  iconName: 'face-weary',
  icon: [
    512,
    512,
    [],
    'e3a1',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm34.8-155.6c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z',
  ],
};
const faUniformMartialArts = {
  prefix: 'far',
  iconName: 'uniform-martial-arts',
  icon: [
    640,
    512,
    [],
    'e3d1',
    'M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V248.4c0-13.6 4.5-27.2 9.7-39c5.4-12.1 12.5-24.4 19.7-35.8c12.1-19.2 26.5-37.4 37.5-57.3c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V288H160V209.2c-6.7 11.3-16 25.7-16 39.2V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2C104.3 23.8 144.6 0 188.4 0H240c9 0 17.2 5 21.3 13L320 127.1 378.7 13C382.8 5 391 0 400 0h51.6c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V248.4c0-13.5-9.3-27.9-16-39.2V288H432V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7c11 19.9 25.4 38.1 37.5 57.3c7.2 11.4 14.4 23.7 19.7 35.8c5.2 11.8 9.7 25.4 9.7 39V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48h-37L291.2 288h-54L293 179.6 225.4 48h-37zM160 384h48v64c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384zm0-64v32H290.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H480V320H160z',
  ],
};
const faCameraRotate = {
  prefix: 'far',
  iconName: 'camera-rotate',
  icon: [
    640,
    512,
    [],
    'e0d8',
    'M263.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L201.4 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C422.4 47.4 401 32 376.9 32L263.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-384 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM362.4 237.6l-15 15c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l60.7 0c8.8 0 16-7.2 16-16l0-60.7c0-6.2-5.1-11.3-11.3-11.3c-3 0-5.9 1.2-8 3.3l-16.1 16.1C375.1 185.8 348 176 320 176c-32 0-62.6 12.7-85.3 35.3L231 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l3.7-3.7C282.3 231.6 300.8 224 320 224c15.3 0 30.1 4.8 42.4 13.6zM208 380.7c0 6.2 5.1 11.3 11.3 11.3c3 0 5.9-1.2 8-3.3l16.1-16.1C264.9 390.2 292 400 320 400c32 0 62.6-12.7 85.3-35.3L409 361c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-3.7 3.7C357.7 344.4 339.2 352 320 352c-15.3 0-30.1-4.8-42.4-13.6l15-15c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3L224 304c-8.8 0-16 7.2-16 16l0 60.7z',
  ],
};
const faSunDust = {
  prefix: 'far',
  iconName: 'sun-dust',
  icon: [
    512,
    512,
    [],
    'f764',
    'M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1s0 0 0 0l37.6-37.6c-3.4-3.4-7.7-5.7-12.6-6.6L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c.9 4.9 3.3 9.3 6.6 12.6l37.6-37.6s0 0 0 0L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112c0 30.9 12.5 58.9 32.8 79.2l33.9-33.9C199.2 289.7 192 273.7 192 256c0-35.3 28.7-64 64-64c17.7 0 33.7 7.2 45.3 18.7l33.9-33.9C314.9 156.5 286.9 144 256 144zm256 16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCommentText = {
  prefix: 'far',
  iconName: 'comment-text',
  icon: [
    512,
    512,
    [],
    'e14d',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-72 0z',
  ],
};
const faSprayCanSparkles = {
  prefix: 'far',
  iconName: 'spray-can-sparkles',
  icon: [
    512,
    512,
    ['air-freshener'],
    'f5d0',
    'M381.8 51.6C383 51 384 49.4 384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4zM448 64l12.4 29.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64zm32 160l-12.4-29.8c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224zm-34.2-76.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4zM128 0C110.3 0 96 14.3 96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0zm96 208c26.5 0 48 21.5 48 48l0 184c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-184c0-26.5 21.5-48 48-48l128 0zM96 160c-53 0-96 43-96 96L0 440c0 39.8 32.2 72 72 72l176 0c39.8 0 72-32.2 72-72l0-184c0-53-43-96-96-96L96 160zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0z',
  ],
};
const faAirFreshener = faSprayCanSparkles;
const faSignalBars = {
  prefix: 'far',
  iconName: 'signal-bars',
  icon: [
    640,
    512,
    ['signal-alt', 'signal-alt-4', 'signal-bars-strong'],
    'f690',
    'M576 448l0-384c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16zM496 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 384c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-384zM416 448l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16zM336 192c0-35.3 28.7-64 64-64s64 28.7 64 64l0 256c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-256zM240 464c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16zm0-208c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64zM80 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 16 448a64 64 0 1 1 128 0z',
  ],
};
const faSignalAlt = faSignalBars;
const faSignalAlt4 = faSignalBars;
const faSignalBarsStrong = faSignalBars;
const faDiamondExclamation = {
  prefix: 'far',
  iconName: 'diamond-exclamation',
  icon: [
    512,
    512,
    [],
    'e405',
    'M51.3 256L256 51.3 460.7 256 256 460.7 51.3 256zm233-244.3c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faStar = {
  prefix: 'far',
  iconName: 'star',
  icon: [
    576,
    512,
    [11088, 61446],
    'f005',
    'M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z',
  ],
};
const faDialMin = {
  prefix: 'far',
  iconName: 'dial-min',
  icon: [
    576,
    512,
    [],
    'e161',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 271l-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faRepeat = {
  prefix: 'far',
  iconName: 'repeat',
  icon: [
    512,
    512,
    [128257],
    'f363',
    'M22.8 280C9.6 279.3-.6 268 0 254.8l.4-8C5.3 148.9 86.2 72 184.2 72L304 72l0-36.4C304 15.9 319.9 0 339.6 0c8.8 0 17.3 3.3 23.8 9.1l76.7 69c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-76.7 69c-6.5 5.9-15 9.1-23.8 9.1c-19.6 0-35.6-15.9-35.6-35.6l0-36.4-119.8 0C111.7 120 52 176.8 48.4 249.2l-.4 8C47.3 270.4 36 280.6 22.8 280zM352 128.5L388.1 96 352 63.5l0 65zM489.2 232c13.2 .7 23.4 11.9 22.8 25.2l-.4 8C506.7 363.1 425.8 440 327.8 440L208 440l0 36.4c0 19.6-15.9 35.6-35.6 35.6c-8.8 0-17.3-3.3-23.8-9.1l-76.7-69c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l76.7-69c6.5-5.9 15-9.1 23.8-9.1c19.6 0 35.6 15.9 35.6 35.6l0 36.4 119.8 0c72.5 0 132.2-56.8 135.8-129.2l.4-8c.7-13.2 11.9-23.4 25.2-22.8zM160 383.5L123.9 416 160 448.5l0-65z',
  ],
};
const faCross = {
  prefix: 'far',
  iconName: 'cross',
  icon: [
    384,
    512,
    [128327, 10013],
    'f654',
    'M112 48c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64 64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0 0 192c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-192-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l64 0 0-64zm112 0l-64 0 0 88c0 13.3-10.7 24-24 24l-88 0 0 64 88 0c13.3 0 24 10.7 24 24l0 216 64 0 0-216c0-13.3 10.7-24 24-24l88 0 0-64-88 0c-13.3 0-24-10.7-24-24l0-88z',
  ],
};
const faPageCaretDown = {
  prefix: 'far',
  iconName: 'page-caret-down',
  icon: [
    384,
    512,
    ['file-caret-down'],
    'e429',
    'M48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384zm272 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z',
  ],
};
const faFileCaretDown = faPageCaretDown;
const faBox = {
  prefix: 'far',
  iconName: 'box',
  icon: [
    448,
    512,
    [128230],
    'f466',
    'M342.4 80L248 80l0 80 140.4 0L357 89.5c-2.6-5.8-8.3-9.5-14.6-9.5zM400 208L48 208l0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208zM59.6 160L200 160l0-80-94.4 0c-6.3 0-12.1 3.7-14.6 9.5L59.6 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38l236.8 0z',
  ],
};
const faVenusMars = {
  prefix: 'far',
  iconName: 'venus-mars',
  icon: [
    640,
    512,
    [9892],
    'f228',
    'M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM352 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6C66.2 338.7 0 265.1 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1 .9-25.2 2.5c-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48 504 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L616 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z',
  ],
};
const faClockSevenThirty = {
  prefix: 'far',
  iconName: 'clock-seven-thirty',
  icon: [
    512,
    512,
    [],
    'e351',
    'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-56.7-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faArrowPointer = {
  prefix: 'far',
  iconName: 'arrow-pointer',
  icon: [
    320,
    512,
    ['mouse-pointer'],
    'f245',
    'M144 272l85.8 0L48 110.4l0 246.4 59.9-68.4C117 278 130.2 272 144 272zM0 426L0 55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1l-127.4 0 59.1 126.8c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L126.7 339.7 38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z',
  ],
};
const faMousePointer = faArrowPointer;
const faClockFourThirty = {
  prefix: 'far',
  iconName: 'clock-four-thirty',
  icon: [
    512,
    512,
    [],
    'e34b',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-91.2L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faSignalBarsGood = {
  prefix: 'far',
  iconName: 'signal-bars-good',
  icon: [
    640,
    512,
    ['signal-alt-3'],
    'f693',
    'M416 192l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16-64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64s64-28.7 64-64l0-256c0-35.3-28.7-64-64-64zM240 464c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16zm0-208c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64s64-28.7 64-64l0-128c0-35.3-28.7-64-64-64zM80 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM16 448a64 64 0 1 0 128 0A64 64 0 1 0 16 448z',
  ],
};
const faSignalAlt3 = faSignalBarsGood;
const faCactus = {
  prefix: 'far',
  iconName: 'cactus',
  icon: [
    512,
    512,
    [127797],
    'f8a7',
    'M304 448c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-352c0-26.5 21.5-48 48-48s48 21.5 48 48l0 352zM256 0c-53 0-96 43-96 96l0 128-48 0c-8.8 0-16-7.2-16-16l0-64c0-26.5-21.5-48-48-48S0 117.5 0 144l0 64c0 61.9 50.1 112 112 112l48 0 0 128c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l48 0c61.9 0 112-50.1 112-112l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64c0 8.8-7.2 16-16 16l-48 0 0-256c0-53-43-96-96-96zm0 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faLightbulbGear = {
  prefix: 'far',
  iconName: 'lightbulb-gear',
  icon: [
    576,
    512,
    [],
    'e5fd',
    'M314.4 213.6c3.6-11.9 5.6-24.5 5.6-37.6c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3l0 .9c-7.7-4.3-16.7-6.4-25.6-5.9zM245.6 416c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80l0-16 133.6 0zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm228 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-17.4c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9l0-17.4zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z',
  ],
};
const faMaximize = {
  prefix: 'far',
  iconName: 'maximize',
  icon: [
    512,
    512,
    ['expand-arrows-alt'],
    'f31e',
    'M156.1 80L80 80l0 76.1L156.1 80zM32 192L32 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 2.7c0 8.5-3.4 16.6-9.4 22.6L169 135l87 87 87-87L297.4 89.4c-6-6-9.4-14.1-9.4-22.6l0-2.7c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-2.7 0c-8.5 0-16.6-3.4-22.6-9.4L377 169l-87 87 87 87 45.7-45.7c6-6 14.1-9.4 22.6-9.4l2.7 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-2.7c0-8.5 3.4-16.6 9.4-22.6L343 377l-87-87-87 87 45.7 45.7c6 6 9.4 14.1 9.4 22.6l0 2.7c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l2.7 0c8.5 0 16.6 3.4 22.6 9.4L135 343l87-87-87-87L89.4 214.6c-6 6-14.1 9.4-22.6 9.4L64 224c-17.7 0-32-14.3-32-32zM355.9 432l76.1 0 0-76.1L355.9 432zM80 355.9L80 432l76.1 0L80 355.9zM355.9 80L432 156.1 432 80l-76.1 0z',
  ],
};
const faExpandArrowsAlt = faMaximize;
const faChargingStation = {
  prefix: 'far',
  iconName: 'charging-station',
  icon: [
    576,
    512,
    [],
    'f5e7',
    'M96 48c-8.8 0-16 7.2-16 16l0 400 192 0 0-400c0-8.8-7.2-16-16-16L96 48zM32 464L32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 28c0 15.5 12.5 28 28 28s28-12.5 28-28l0-103.7c-32.5-10.2-56-40.5-56-76.3l0-40c0-13.3 10.7-24 24-24l8 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 8 0c13.3 0 24 10.7 24 24l0 40c0 35.8-23.5 66.1-56 76.3L520 372c0 42-34 76-76 76s-76-34-76-76l0-28c0-22.1-17.9-40-40-40l-8 0 0 160 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zM464 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16-64 0 0 16zM222.9 117.9L199.6 176l40.4 0c6.7 0 12.8 4.2 15 10.6s.4 13.4-4.8 17.7l-96 80c-5.6 4.7-13.7 5-19.6 .7s-8.2-12.1-5.5-18.9L152.4 208 112 208c-6.7 0-12.8-4.2-15-10.6s-.4-13.4 4.8-17.7l96-80c5.6-4.7 13.7-5 19.6-.7s8.2 12.1 5.5 18.9z',
  ],
};
const faShapes = {
  prefix: 'far',
  iconName: 'shapes',
  icon: [
    512,
    512,
    ['triangle-circle-square'],
    'f61f',
    'M288 63.1L220.3 176l135.5 0L288 63.1zM411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM464 320l-128 0 0 128 128 0 0-128zM328 272l144 0c22.1 0 40 17.9 40 40l0 144c0 22.1-17.9 40-40 40l-144 0c-22.1 0-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zM208 384A80 80 0 1 0 48 384a80 80 0 1 0 160 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z',
  ],
};
const faTriangleCircleSquare = faShapes;
const faPlaneTail = {
  prefix: 'far',
  iconName: 'plane-tail',
  icon: [
    512,
    512,
    [],
    'e22c',
    'M.8 39L61.5 308.8l-15.5 4.3C18.8 320.5 0 345.2 0 373.4c0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7L488 512c13.3 0 24-10.7 24-24s-10.7-24-24-24l-220.3 0c-4.8 0-9.7-.9-14.2-2.6L57.4 387c-5.7-2.1-9.4-7.6-9.4-13.6c0-6.6 4.4-12.3 10.7-14.1L254 305.4c3.5-1 7-1.4 10.6-1.4L488 304c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0L154.9 19.5C142.8 7 126.2 0 108.9 0L32 0C11.5 0-3.7 19 .8 39zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faGaugeSimpleMax = {
  prefix: 'far',
  iconName: 'gauge-simple-max',
  icon: [
    512,
    512,
    ['tachometer-fastest'],
    'f62b',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-30.9 25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56s-56-25.1-56-56z',
  ],
};
const faTachometerFastest = faGaugeSimpleMax;
const faCircleU = {
  prefix: 'far',
  iconName: 'circle-u',
  icon: [
    512,
    512,
    [],
    'e127',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120c0 61.9 50.1 112 112 112s112-50.1 112-112l0-120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-120z',
  ],
};
const faShieldSlash = {
  prefix: 'far',
  iconName: 'shield-slash',
  icon: [
    640,
    512,
    [],
    'e24b',
    'M174.2 111.2L320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8c-.3 52.8-13 127.8-52.2 195.3L174.2 111.2zM497.9 365c47.4-78.8 61.8-166.3 62.1-225c.1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.9 365zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7c16.7 8 36.1 8 52.8 0c35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3c-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201L80.6 159.5z',
  ],
};
const faSquarePhoneHangup = {
  prefix: 'far',
  iconName: 'square-phone-hangup',
  icon: [
    448,
    512,
    ['phone-square-down'],
    'e27a',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM345.9 303.3c-4.8 7.6-15.1 10.7-24 7.4l-41.6-15.4c-7.9-2.9-12.7-10.1-11.8-17.7l2.6-23.3c-30.4-9.5-63.7-9.5-94.1 0l2.6 23.3c.8 7.6-4 14.8-11.8 17.7l-41.6 15.4c-8.9 3.3-19.2 .1-24-7.4L82.5 272.4c-4.3-6.8-3-15.3 3.1-20.8c76.4-68.8 200.3-68.8 276.7 0c6.1 5.5 7.4 14.1 3.1 20.8l-19.6 30.8z',
  ],
};
const faPhoneSquareDown = faSquarePhoneHangup;
const faArrowUpLeft = {
  prefix: 'far',
  iconName: 'arrow-up-left',
  icon: [
    384,
    512,
    [],
    'e09d',
    'M56 96c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-231-231L296 144c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 96z',
  ],
};
const faTransporter1 = {
  prefix: 'far',
  iconName: 'transporter-1',
  icon: [
    512,
    512,
    [],
    'e043',
    'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 288l48 0 0-112 32 0 0 112 48 0 0-79.2 52.9 69.7c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-65.7-86.7c-16.6-21.9-42.6-34.8-70.1-34.8l-38.6 0c-27.5 0-53.5 12.9-70.1 34.8l-65.7 86.7c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6L192 208.8l0 79.2zM480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352 6.6 359.3C2.7 360.4 0 363.9 0 368s2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352zm56 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm56-144c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
  ],
};
const faPeanuts = {
  prefix: 'far',
  iconName: 'peanuts',
  icon: [
    640,
    512,
    [129372],
    'e431',
    'M123 504.9c-16.8-19.6-27-45-27-72.9c0-5.2-.1-10.6-.1-16.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-.6-55.4-1.3-125.1 52.8-179.2c26.5-26.5 59-43.2 94.7-49.8c22.9-4.6 39.5-10.9 50-21.5s16.9-27.1 21.5-50c1.6-8.9 3.9-17.5 6.7-26L299.2 38.9C284.4 5.8 245.7-9 212.6 5.7L161.7 28.3c-15 6.7-28 16.1-38.7 27.3c-10.6 11.2-19.3 24.6-25.2 39.9l-.2 .5c-5.8 15.3-8.3 31-7.9 46.4c.2 8.5 1.3 17 3.4 25.4c4.5 19.9 6.9 41-.4 60s-23.1 33.1-39.8 44.9c-7.2 4.9-13.7 10.5-19.5 16.6C22.7 300.5 14 314 8.1 329.4C2.2 344.7-.4 360.6 0 376c.4 15.5 3.8 31.1 10.5 46.2l22.7 50.9c14.7 33.1 53.5 48 86.6 33.2l3.2-1.4zM563 218.4l-.6 .6s0 0 0 0c-9.6 9.5-20.5 16.6-32.2 21.4c0 0 0 0 0 0c-6.4 2.7-13.2 4.7-20.2 5.9l-.4 .1-.4 .1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1 .4-.1 .4c-1.3 7-3.3 13.8-5.9 20.2c0 0 0 0 0 0c-4.8 11.5-11.8 22.3-21.1 31.9c0 0 0 0 0 0c-.2 .2-.5 .5-.7 .7c-.1 .1-.3 .3-.4 .4l32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464l-68 0c-17.7 0-32-14.3-32-32l0-68c0-13.6 2.7-26.5 7.6-38.3c0 0 0 0 0 0c4.9-11.7 12.1-22.8 21.7-32.4c9.7-9.7 20.7-16.9 32.5-21.7c0 0 0 0 0 0c6.4-2.7 13.2-4.7 20.2-5.9l.4-.1 .4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4 .1-.4c1.3-7 3.3-13.8 5.9-20.2c0 0 0 0 0 0c4.8-11.7 12-22.6 21.5-32.2c0 0 0 0 0 0l.3-.3c9.6-9.6 20.6-16.8 32.3-21.6c0 0 0 0 0 0C465.5 50.7 478.4 48 492 48l68 0c17.7 0 32 14.3 32 32l0 68c0 27.5-11 52.3-29 70.4c0 0 0 0 0 0zm34.1 33.8C623.6 225.4 640 188.6 640 148l0-68c0-44.2-35.8-80-80-80L492 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364l0 68c0 44.2 35.8 80 80 80l68 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zm-77.1-97a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 392a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 328a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z',
  ],
};
const faShuffle = {
  prefix: 'far',
  iconName: 'shuffle',
  icon: [
    512,
    512,
    [128256, 'random'],
    'f074',
    'M425 31l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L352 152c-12.6 0-24.4 5.9-32 16l-46 61.3-30-40 37.6-50.1C298.2 117 324.3 104 352 104l78.1 0L391 65c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM204 322.7l-37.6 50.1C149.8 395 123.7 408 96 408l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c12.6 0 24.4-5.9 32-16l46-61.3 30 40zM391 287c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L352 408c-27.7 0-53.8-13-70.4-35.2L128 168c-7.6-10.1-19.4-16-32-16l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c27.7 0 53.8 13 70.4 35.2L320 344c7.6 10.1 19.4 16 32 16l78.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faRandom = faShuffle;
const faPersonRunning = {
  prefix: 'far',
  iconName: 'person-running',
  icon: [
    448,
    512,
    [127939, 'running'],
    'f70c',
    'M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-85.3 60.6c14-3.5 28.7-3.5 42.7 0l95 23.7c19 4.8 34.2 19.1 39.9 37.9L336 234.4c1 3.4 4.1 5.6 7.6 5.6l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0c-24.6 0-46.3-16-53.5-39.5l-5.6-18.2-28.1 84.4 32.1 18c16.5 9.3 24.2 28.8 18.6 46.8L270.9 495.2c-4 12.7-17.4 19.7-30.1 15.8s-19.7-17.4-15.7-30.1l34.2-109.5-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l32.7-98-8.6-2.1c-6.4-1.6-13-1.6-19.4 0l-1.8 .5c-6 1.5-11.6 4.4-16.3 8.4L87.6 202.2c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l44.5-38.2c10.4-8.9 22.7-15.2 35.9-18.6l1.8-.5zm75.1 182.1l38.3-115L225 169 191.1 270.5c-1.2 3.6 .3 7.6 3.7 9.5l19 10.7zM103.4 368l19.1-50.9c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-14.1 37.6c-5.9 15.6-20.8 25.9-37.4 25.9L24 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l79.4 0z',
  ],
};
const faRunning = faPersonRunning;
const faMobileRetro = {
  prefix: 'far',
  iconName: 'mobile-retro',
  icon: [
    320,
    512,
    [],
    'e527',
    'M256 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l192 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 160l0 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM96 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z',
  ],
};
const faGripLinesVertical = {
  prefix: 'far',
  iconName: 'grip-lines-vertical',
  icon: [
    192,
    512,
    [],
    'f7a5',
    'M32 32C18.7 32 8 42.7 8 56L8 456c0 13.3 10.7 24 24 24s24-10.7 24-24L56 56c0-13.3-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24z',
  ],
};
const faBinBottlesRecycle = {
  prefix: 'far',
  iconName: 'bin-bottles-recycle',
  icon: [
    640,
    512,
    [],
    'e5f6',
    'M152 0l80 0c13.3 0 24 10.7 24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192l32 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7l0-42.1c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 42.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5l32.9 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7l-369.7 0c-40.6 0-74.7-30.4-79.5-70.7L32 240l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm48.3 48l23 195.7c1.9 16.1 15.6 28.3 31.8 28.3l369.7 0c16.2 0 29.9-12.1 31.8-28.3l23-195.7L80.3 240zm228.1 70.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6l25.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-25.2 0c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 400l20.9 0c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6l-20.9 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faArrowUpFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-from-square',
  icon: [
    512,
    512,
    [],
    'e09c',
    'M273 7c-9.4-9.4-24.6-9.4-33.9 0L127 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71L232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 71 71c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-336c0-39.8-32.2-72-72-72l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0z',
  ],
};
const faFileDashedLine = {
  prefix: 'far',
  iconName: 'file-dashed-line',
  icon: [
    640,
    512,
    ['page-break'],
    'f877',
    'M448 464l-256 0c-8.8 0-16-7.2-16-16l0-80-48 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-48 0 0 80c0 8.8-7.2 16-16 16zm16-304l0 96 48 0 0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 192 48 0 0-192c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0zM56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 288zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faPageBreak = faFileDashedLine;
const faBracketCurlyRight = {
  prefix: 'far',
  iconName: 'bracket-curly-right',
  icon: [
    256,
    512,
    [],
    '7d',
    'M192 120c0-48.6-39.4-88-88-88L56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0c22.1 0 40 17.9 40 40l0 45.5c0 23.3 9.3 45.7 25.8 62.2L198.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2l0 45.5c0 22.1-17.9 40-40 40l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c48.6 0 88-39.4 88-88l0-45.5c0-10.6 4.2-20.8 11.7-28.3L249 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3l0-45.5z',
  ],
};
const faSpider = {
  prefix: 'far',
  iconName: 'spider',
  icon: [
    512,
    512,
    [128375],
    'f717',
    'M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l68.8-22.9c-.8 3.2-1.5 6.4-2 9.7L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l12.1-12.1C153.2 425.8 200.1 464 256 464s102.8-38.2 116.2-89.9l12.1 12.1c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-43.8-43.8c-.5-3.3-1.2-6.5-2-9.7l68.8 22.9c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L352 158.1c-.6-32.8-17.8-61.6-43.3-78.4c-5.8-3.8-13.1-4.9-19.8-3s-12.3 6.7-15.2 13L256 128.1 238.3 89.7c-2.9-6.3-8.5-11.1-15.2-13s-13.9-.8-19.8 3c-25.6 16.8-42.7 45.5-43.3 78.4l-32.3-32.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6zM208 160c0-5.5 .9-10.8 2.6-15.7l15.6 33.8c3.9 8.5 12.4 13.9 21.8 13.9l16 0c9.4 0 17.9-5.4 21.8-13.9l15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7l0 88c0 3.4-.4 6.7-1 9.9c-1.6 7.6 .6 15.5 5.9 21.2C320.8 292 328 309.1 328 328l0 16c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-16c0-18.9 7.2-36 19.1-48.9c5.3-5.7 7.5-13.6 5.9-21.2c-.7-3.2-1-6.5-1-9.9l0-88z',
  ],
};
const faClockThree = {
  prefix: 'far',
  iconName: 'clock-three',
  icon: [
    512,
    512,
    [],
    'e356',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faHandsBound = {
  prefix: 'far',
  iconName: 'hands-bound',
  icon: [
    640,
    512,
    [],
    'e4f9',
    'M16 72l0 134.6c0 22.2 7.4 43.7 21.1 61.2l69.2 88.6C100 360.7 96 367.9 96 376c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24c0-8.1-4-15.3-10.2-19.7l69.2-88.6c13.7-17.5 21.1-39 21.1-61.2L624 72c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 66.3c-.5-.5-1-.9-1.6-1.4c-29.8-25.2-74.3-22-100.2 7.2l-46.7 52.5c-4.2 4.7-8 9.7-11.5 14.8c-3.5-5.2-7.3-10.1-11.5-14.8l-46.7-52.5c-25.9-29.2-70.4-32.4-100.2-7.2c-.5 .5-1.1 .9-1.6 1.4L160 72c0-39.8-32.2-72-72-72S16 32.2 16 72zM163.8 352L74.9 238.2C67.8 229.2 64 218 64 206.6L64 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 107.4 71.5 95.3c.1 .2 .3 .4 .4 .6c7.5 9.4 20.9 11.6 31 5c11.4-7.4 14.1-22.9 6-33.7c-.1-.2-.3-.4-.4-.6L189.3 207c-2.7-3.3-4.3-7.2-5-11.2c-1.3-8.1 1.6-16.6 8.2-22.2c9.9-8.4 24.8-7.3 33.4 2.4l46.7 52.5c15.1 16.9 23.4 38.8 23.4 61.5l0 61.9-132.2 0zM344 352l0-61.9c0-22.7 8.3-44.6 23.4-61.5l46.7-52.5c8.6-9.7 23.5-10.8 33.4-2.4c6.7 5.6 9.5 14.1 8.2 22.2c-.6 4-2.3 7.8-5 11.2l-31.3 39.1c-.2 .2-.3 .4-.4 .6c-8.1 10.8-5.4 26.3 6 33.7c10.1 6.6 23.5 4.3 31-5c.2-.2 .3-.4 .4-.6L528 179.4 528 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 134.6c0 11.5-3.8 22.6-10.9 31.7L476.2 352 344 352zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 120 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 120 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0z',
  ],
};
const faScalpelLineDashed = {
  prefix: 'far',
  iconName: 'scalpel-line-dashed',
  icon: [
    576,
    512,
    ['scalpel-path'],
    'f61e',
    'M493.8 122.6C505.5 109.4 512 92.3 512 74.7c0-37-28.1-68-64.9-71.7c-23.7-2.4-47 7.1-62.4 25.3L206.1 240l-.4 .5-5.6 6.7-12.2 14.5c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l19 0 8.8 0 .7 0 96.8 0c13.7 0 26.8-5.9 35.9-16.1L493.8 122.6zM268.9 240L421.4 59.2c5.1-6.1 13-9.2 20.9-8.5C454.6 52 464 62.4 464 74.7c0 5.9-2.2 11.6-6.1 16L325.1 240l-56.3 0zm-99.5 80l-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0zM248 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z',
  ],
};
const faScalpelPath = faScalpelLineDashed;
const faFileInvoiceDollar = {
  prefix: 'far',
  iconName: 'file-invoice-dollar',
  icon: [
    384,
    512,
    [],
    'f571',
    'M336 448l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 215.6c11 0 20 9 20 20l0 10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8l0 10.1c0 11-9 20-20 20s-20-9-20-20l0-10.8c-10-1.9-19.3-4.8-27.5-7.3c0 0 0 0 0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2c0 0 0 0 0 0s0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3l0-10.3c0-11 9-20 20-20zM96 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faPipeSmoking = {
  prefix: 'far',
  iconName: 'pipe-smoking',
  icon: [
    640,
    512,
    [],
    'e3c4',
    'M586.8 48c-36.4 0-70.1 19-89 50.2L412.1 239.8c13 16 14.6 39.3 2.4 57.2L318.7 438.3c-31.3 46.1-83.3 73.7-139 73.7L168 512C75.2 512 0 436.8 0 344L0 232c0-30.9 25.1-56 56-56l160 0c30.9 0 56 25.1 56 56l0 9.4 23-29.9c12.3-16 32.9-22.2 51.4-16.9l111.2-138C486.4 20.8 529.9 0 575.9 0l10.9 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-29.2 0zM56 224c-4.4 0-8 3.6-8 8l0 112c0 66.3 53.7 120 120 120l11.7 0c39.8 0 77-19.7 99.3-52.6l95.9-141.3L333 240.8l-66 85.8c-6.3 8.1-17 11.4-26.8 8.1s-16.3-12.4-16.3-22.7l0-80c0-4.4-3.6-8-8-8L56 224z',
  ],
};
const faFaceAstonished = {
  prefix: 'far',
  iconName: 'face-astonished',
  icon: [
    512,
    512,
    [],
    'e36b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 48c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
  ],
};
const faWindow = {
  prefix: 'far',
  iconName: 'window',
  icon: [
    512,
    512,
    [],
    'f40e',
    'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64 0 48 0 16 0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224l0-16 0-48L0 96zM464 224L48 224l0 192c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-192zM96 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faPlaneCircleExclamation = {
  prefix: 'far',
  iconName: 'plane-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e556',
    'M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faEar = {
  prefix: 'far',
  iconName: 'ear',
  icon: [
    384,
    512,
    [128066],
    'f5f0',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192l0 176c0 53 43 96 96 96s96-43 96-96c0-21.7 10.9-42.6 29.8-54.8C309.7 287.5 336 242.8 336 192zm48 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368L0 192C0 86 86 0 192 0S384 86 384 192zm-256 0l0 20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8L126 278.4c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1L80 192c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64z',
  ],
};
const faFileLock = {
  prefix: 'far',
  iconName: 'file-lock',
  icon: [
    576,
    512,
    [],
    'e3a6',
    'M320 464L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 149.7c4.6-5.2 10-9.6 16-13.1l0-24.6c0-30.5 12.2-58.2 32-78.4l0-39.1c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5l0-16zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faDiagramVenn = {
  prefix: 'far',
  iconName: 'diagram-venn',
  icon: [
    640,
    512,
    [],
    'e15a',
    'M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1C126.8 80 48 158.8 48 256s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1zM252 320l136 0c5.9-15.1 9.8-31.2 11.3-48l-158.6 0c1.5 16.8 5.4 32.9 11.3 48zm16.5 32c13.4 20.6 31 38.1 51.5 51.5c20.6-13.4 38.1-31 51.5-51.5l-103.1 0zM252 192c-5.9 15.1-9.8 31.2-11.3 48l158.6 0c-1.5-16.8-5.4-32.9-11.3-48l-136 0zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5c-20.6 13.4-38.1 31-51.5 51.5l103.1 0zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6z',
  ],
};
const faArrowDownFromBracket = {
  prefix: 'far',
  iconName: 'arrow-down-from-bracket',
  icon: [
    448,
    512,
    [],
    'e667',
    'M241 505c-9.4 9.4-24.6 9.4-33.9 0L79 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L200 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 246.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 505zM48 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L360 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88l0 80z',
  ],
};
const faXRay = {
  prefix: 'far',
  iconName: 'x-ray',
  icon: [
    512,
    512,
    [],
    'f497',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 352-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 400 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-352 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 32 24 32zM80 432L80 80l352 0 0 352L80 432zM256 96c-8.8 0-16 7.2-16 16l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 32-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 54.6L189.1 275c-5.2-2-10.6-3-16.2-3l-2.1 0c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6l120.8 0c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8l-2.2 0c-5.5 0-11 1-16.2 3L272 294.6l0-54.6 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-32 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-8.8-7.2-16-16-16zM208 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faGoalNet = {
  prefix: 'far',
  iconName: 'goal-net',
  icon: [
    640,
    512,
    [],
    'e3ab',
    'M48 120c0-22.1 17.9-40 40-40l464 0c22.1 0 40 17.9 40 40l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-48.6-39.4-88-88-88L88 32C39.4 32 0 71.4 0 120L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zm128 8c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16zm80 256l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64z',
  ],
};
const faCoffinCross = {
  prefix: 'far',
  iconName: 'coffin-cross',
  icon: [
    384,
    512,
    [],
    'e051',
    'M140.1 464l103.8 0 91.9-318.2L250.2 48 133.8 48 48.2 145.8 140.1 464zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0l131 0c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1l-127.9 0c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM216 120l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faOctopus = {
  prefix: 'far',
  iconName: 'octopus',
  icon: [
    640,
    512,
    [],
    'e688',
    'M208 160l0 3.4c0 6.9 .6 13.8 1.9 20.6c0 0 0 0 0 0L229 289.6l9 49.7c1.3 7 1.9 14.2 1.9 21.4l0 2.5c0 10.1-1.3 19.9-3.7 29.3l12.2-6.5c22-11.7 46.6-17.9 71.5-17.9s49.5 6.1 71.5 17.9l12.2 6.5c-2.4-9.4-3.7-19.2-3.7-29.3l0-2.5c0-7.2 .6-14.3 1.9-21.4l9-49.6c0 0 0 0 0-.1l19.2-105.5c0 0 0 0 0-.1s0 0 0 0c1.2-6.8 1.8-13.7 1.8-20.6l0-3.4c0-61.9-50.1-112-112-112s-112 50.1-112 112zM448.1 367.2c2.1 36.2 32.1 64.8 68.8 64.8c32.5 0 60.6-22.7 67.4-54.5l8.3-38.6c2.8-13 15.5-21.2 28.5-18.4s21.2 15.5 18.4 28.5l-8.3 38.6C619.7 441.5 572 480 516.9 480l-.2 0c-33.4 0-66.2-8.3-95.6-24l-52.1-27.8c-15.1-8-31.9-12.2-48.9-12.2s-33.9 4.2-48.9 12.2L218.9 456c-29.5 15.7-62.4 24-95.8 24C68 480 20.3 441.5 8.8 387.6L.5 349c-2.8-13 5.5-25.7 18.4-28.5s25.7 5.5 28.5 18.4l8.3 38.6c6.8 31.8 34.9 54.5 67.4 54.5c36.7 0 66.7-28.7 68.8-64.8c-10.3 5.6-22.2 8.8-35 8.8c-32.5 0-61.2-21.4-70.3-52.6L72.8 276.5C66.4 254.9 46.6 240 24 240c-13.3 0-24-10.7-24-24s10.7-24 24-24c43.8 0 82.5 28.9 94.8 71l13.8 46.9c3.2 10.8 13.1 18.2 24.3 18.2c15.8 0 27.7-14.3 24.9-29.8c0 0 0 0 0 0L162.6 192.7s0 0 0 0s0 0 0 0c-1.7-9.6-2.6-19.4-2.6-29.1c0 0 0 0 0-.1l0-3.4C160 71.6 231.6 0 320 0s160 71.6 160 160l0 3.4c0 0 0 0 0 .1c0 9.8-.9 19.5-2.6 29.1c0 0 0 0 0 0s0 0 0 0L458.2 298.2s0 0 0 0c-2.8 15.5 9.1 29.8 24.9 29.8c11.2 0 21.1-7.4 24.3-18.2L521.2 263c12.4-42.1 51-71 94.8-71c13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.6 0-42.4 14.9-48.8 36.5l-13.8 46.9c-9.2 31.2-37.8 52.6-70.3 52.6c-12.8 0-24.6-3.2-35-8.8zM256 268a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm108-20a20 20 0 1 1 0 40 20 20 0 1 1 0-40z',
  ],
};
const faSpellCheck = {
  prefix: 'far',
  iconName: 'spell-check',
  icon: [
    576,
    512,
    [],
    'f891',
    'M134.1 14.6C130.3 5.8 121.6 0 112 0s-18.3 5.8-22.1 14.6l-88 208c-5.2 12.2 .5 26.3 12.8 31.5s26.3-.5 31.5-12.8L56.8 216l110.3 0 10.7 25.4c5.2 12.2 19.2 17.9 31.5 12.8s17.9-19.2 12.8-31.5l-88-208zM146.9 168l-69.7 0L112 85.6 146.9 168zM256 24l0 104 0 104c0 13.3 10.7 24 24 24l92 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3C426.9 107.3 432 92.2 432 76c0-42-34-76-76-76L280 0c-13.3 0-24 10.7-24 24zm100 80l-52 0 0-56 52 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-52 48l52 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-68 0 0-56zM568.6 313.3c9.6-9.2 9.9-24.4 .7-33.9s-24.4-9.9-33.9-.7l-183 175.7L265 367c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L335 505c9.2 9.2 24.2 9.4 33.6 .3l200-192z',
  ],
};
const faLocationXmark = {
  prefix: 'far',
  iconName: 'location-xmark',
  icon: [
    384,
    512,
    ['map-marker-times', 'map-marker-xmark'],
    'f60e',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faMapMarkerTimes = faLocationXmark;
const faMapMarkerXmark = faLocationXmark;
const faCircleQuarterStroke = {
  prefix: 'far',
  iconName: 'circle-quarter-stroke',
  icon: [
    512,
    512,
    [],
    'e5d3',
    'M464 256c0-114.9-93.1-208-208-208c-1.4 0-2.9 0-4.3 0c2.7 4.6 4.3 10.1 4.3 16l0 160c0 17.7-14.3 32-32 32L64 256c-5.8 0-11.3-1.6-16-4.3c0 1.4 0 2.9 0 4.3c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faLasso = {
  prefix: 'far',
  iconName: 'lasso',
  icon: [
    576,
    512,
    [],
    'f8c8',
    'M576 176c0 97.2-128.9 176-288 176c-14.9 0-29.6-.7-43.9-2c7.7 15.3 11.9 32.4 11.9 50.2C256 461.9 205.9 512 144.2 512L56 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l88.2 0c35.2 0 63.8-28.6 63.8-63.8c0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 304c132.5 0 240-57.3 240-128s-107.5-128-240-128S48 105.3 48 176s107.5 128 240 128z',
  ],
};
const faSlash = {
  prefix: 'far',
  iconName: 'slash',
  icon: [
    640,
    512,
    [],
    'f715',
    'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
  ],
};
const faPersonToPortal = {
  prefix: 'far',
  iconName: 'person-to-portal',
  icon: [
    512,
    512,
    ['portal-enter'],
    'e022',
    'M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5l8.4 0 16.5 0 23.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-23.9 0c1.2-82.9 11.4-134.5 24.1-164c12.4-28.7 22.4-28.1 23.7-28l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28c-10.1-23.4-18.6-60.5-22.2-116l-18 0-30.1 0c8.8 140.7 47.6 192 94.1 192c53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189.1l-5.8-18.9c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6z',
  ],
};
const faPortalEnter = faPersonToPortal;
const faCalendarStar = {
  prefix: 'far',
  iconName: 'calendar-star',
  icon: [
    448,
    512,
    [],
    'f736',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM233.3 242.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L224 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z',
  ],
};
const faComputerMouse = {
  prefix: 'far',
  iconName: 'computer-mouse',
  icon: [
    384,
    512,
    [128433, 'mouse'],
    'f8cc',
    'M192 224L48 224l0 128c0 61.9 50.1 112 112 112l64 0c61.9 0 112-50.1 112-112l0-128-144 0zm192-48l0 24 0 24 0 128c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 224l0-24 0-24 0-16C0 71.6 71.6 0 160 0l8 0 24 0 24 0 8 0c88.4 0 160 71.6 160 160l0 16zM216 48l0 128 120 0 0-16c0-61.9-50.1-112-112-112l-8 0zm-48 0l-8 0C98.1 48 48 98.1 48 160l0 16 120 0 0-128z',
  ],
};
const faMouse = faComputerMouse;
const faArrowRightToBracket = {
  prefix: 'far',
  iconName: 'arrow-right-to-bracket',
  icon: [
    512,
    512,
    ['sign-in'],
    'f090',
    'M217 401L345 273c9.4-9.4 9.4-24.6 0-33.9L217 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM344 80l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faSignIn = faArrowRightToBracket;
const faPegasus = {
  prefix: 'far',
  iconName: 'pegasus',
  icon: [
    576,
    512,
    [],
    'f703',
    'M432 0c-1.8 0-3.5 .2-5.2 .6C366.3 5.8 316 46.3 296.6 101.5L162.7 34.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 47.7 128 56c0 81 33.4 133.2 67.7 164.8c16.9 15.6 33.8 26 46.6 32.5c6.4 3.3 11.8 5.6 15.7 7.2c2 .8 3.6 1.4 4.7 1.8c.5 .2 1 .3 1.3 .5c2.5 .9 5.1 1.3 7.9 1.3c13.3 0 24-10.7 24-24c0-10.8-7.2-20-17-23l-.4-.1c-.6-.2-1.6-.6-2.9-1.1c-2.6-1-6.6-2.8-11.5-5.2c-9.8-5-22.9-13.1-35.9-25.1c-19.9-18.3-40.3-46.4-48.5-88.8l121.5 60.8c3.6 1.8 7.4 2.6 11.2 2.5l.5 0c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2l4.6 0 24 0 8 0 .5 0c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6l0 55c0 .5 0 1 0 1.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2L384 464l-48 0 0-117.8c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464l-49.8 0-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-15.5 5.5-29.7 14.6-40.8c-7.7-14.2-14.5-30.1-19.6-47.6c-8.8 6.9-16.5 15-22.9 24.2C37.3 162.1 0 200.7 0 248l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2l49.8 0c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5l0 99.5c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-136.2c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7 0-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24L472.5 0 472 0l-8 0L440 0l-8 0zm48 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faFilesMedical = {
  prefix: 'far',
  iconName: 'files-medical',
  icon: [
    448,
    512,
    [],
    'f7fd',
    'M384 368l-224 0c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l160 0 0 48c0 17.7 14.3 32 32 32l48 0 0 224c0 8.8-7.2 16-16 16zM160 416l224 0c35.3 0 64-28.7 64-64l0-229.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256zm197.3 72l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faCannon = {
  prefix: 'far',
  iconName: 'cannon',
  icon: [
    640,
    512,
    [],
    'e642',
    'M261.2 406.7c-11.5 6.9-20.5 12.2-26.6 15.3c-47.4 23.5-104.9 4.3-128.5-43s-4.6-104.9 42.7-128.7c22.2-10.7 90.8-36.6 170.7-65.6C398.3 156.1 484.4 125.8 538 107c7.3-2.6 15.6 .6 19.2 8l30.7 61.4c3.7 7.3 1.3 15.8-5.2 20.2c-24.3 16.3-56.1 37.5-90.8 60.6c12.4 10.3 23.1 22.8 31.5 36.7c32.9-21.9 62.9-41.9 86-57.4c26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8C414.8 99.3 177.1 183.2 127.6 207.2c-56.1 28-85.9 87.7-78.5 146.6L26.5 365.1C2.8 376.9-6.8 405.8 5.1 429.5s40.7 33.3 64.4 21.5L92 439.7c42.7 41.2 108.3 53.2 164.4 25.1c6.1-3.2 14.8-8.1 25.4-14.5c-9.2-13.1-16.2-27.8-20.6-43.6zM400 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 176a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
  ],
};
const faNfcLock = {
  prefix: 'far',
  iconName: 'nfc-lock',
  icon: [
    576,
    512,
    [],
    'e1f8',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 65.1c-17.7 2.5-34 9.2-48 18.9L400 96c0-8.8-7.2-16-16-16zm-16 72l0 62.3c-10.2 16.9-16 36.6-16 57.7l0 24.6c-19.1 11.1-32 31.7-32 55.4l0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM128 352l192 0 0 48-200 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faPersonSkiLift = {
  prefix: 'far',
  iconName: 'person-ski-lift',
  icon: [
    512,
    512,
    ['ski-lift'],
    'f7c8',
    'M240 0c8.8 0 16 7.2 16 16l0 191.9-32 7.5L224 16c0-8.8 7.2-16 16-16zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM13.6 178.3c12-5.7 26.3-.7 32 11.3l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32zM488 288c13.3 0 24 10.7 24 24l0 1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L272 406.2l0-119.9-94.2 22.2c-18 4.2-36.6-4.5-44.9-21L90.3 202.3C78.8 179.2 95.5 152 121.4 152c13.2 0 25.2 7.4 31.1 19.2l42 84L280.7 235c20.1-4.7 39.3 10.5 39.3 31.1l0 122.4L443.1 343c12.6-4.6 20.9-16.6 20.9-30l0-1c0-13.3 10.7-24 24-24z',
  ],
};
const faSkiLift = faPersonSkiLift;
const faSquare6 = {
  prefix: 'far',
  iconName: 'square-6',
  icon: [
    448,
    512,
    [],
    'e25b',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z',
  ],
};
const faShopSlash = {
  prefix: 'far',
  iconName: 'shop-slash',
  icon: [
    640,
    512,
    ['store-alt-slash'],
    'e070',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 224l25.8 0c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0l-391 0C106.9 0 90.8 9.6 82.4 25L76.9 35 38.8 5.1zM115.2 65l9.3-17 391 0 69.8 128-328.5 0L115.2 65zM318.1 224L528 224l0 164.5L318.1 224zM0 185.8C0 206.9 17.1 224 38.2 224L64 224l0 248c0 22.1 17.9 40 40 40l240 0c22.1 0 40-17.9 40-40l0-73.5L284.3 320 112 320l0-96 50.5 0-60.9-48-46.9 0 14.1-25.8L30.5 120 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM112 464l0-96 224 0 0 96-224 0z',
  ],
};
const faStoreAltSlash = faShopSlash;
const faWindTurbine = {
  prefix: 'far',
  iconName: 'wind-turbine',
  icon: [
    512,
    512,
    [],
    'f89b',
    'M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.9 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM232 339.8L232 464l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-46.2-48-78zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faSlidersSimple = {
  prefix: 'far',
  iconName: 'sliders-simple',
  icon: [
    512,
    512,
    [],
    'e253',
    'M80 336a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm76.3 8L488 344c13.3 0 24 10.7 24 24s-10.7 24-24 24l-331.7 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM400 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-44.3-24c10.2-32.5 40.5-56 76.3-56c44.2 0 80 35.8 80 80s-35.8 80-80 80c-35.8 0-66.1-23.5-76.3-56L24 168c-13.3 0-24-10.7-24-24s10.7-24 24-24l331.7 0z',
  ],
};
const faGridRound = {
  prefix: 'far',
  iconName: 'grid-round',
  icon: [
    448,
    512,
    [],
    'e5da',
    'M88 96A24 24 0 1 1 40 96a24 24 0 1 1 48 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM88 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
  ],
};
const faBadgeSheriff = {
  prefix: 'far',
  iconName: 'badge-sheriff',
  icon: [
    448,
    512,
    [],
    'f8a2',
    'M256.1 63.9c5-6.7 7.9-14.9 7.9-23.9c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 9 2.9 17.2 7.9 23.9c-.9 1.2-1.7 2.4-2.5 3.8l-37.3 64-74 .3c-1.2 0-2.3 .1-3.5 .2c-6.9-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c1.2 0 2.4-.1 3.6-.2L80.4 256 43.6 320.2c-1.2-.1-2.4-.2-3.6-.2c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.8-8.1 34.7-20c1.1 .1 2.3 .2 3.5 .2l74 .3 37.3 64c.8 1.3 1.6 2.6 2.5 3.8c-5 6.7-7.9 14.9-7.9 23.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.9c.9-1.2 1.7-2.4 2.5-3.8l37.3-64 74-.3c1.2 0 2.3-.1 3.5-.2c6.9 12 19.9 20 34.7 20c22.1 0 40-17.9 40-40s-17.9-40-40-40c-1.2 0-2.4 .1-3.6 .2L367.6 256l36.7-64.2c1.2 .1 2.4 .2 3.6 .2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-14.8 0-27.8 8.1-34.7 20c-1.1-.1-2.3-.2-3.5-.2l-74-.3-37.3-64c-.8-1.3-1.6-2.6-2.5-3.8zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-80.7-96.3l32.7-56 32.7 56c7.1 12.2 20.2 19.8 34.4 19.9l64.9 .3-32.2 56.3c-7 12.3-7 27.4 0 39.7l32.2 56.3-64.9 .3c-14.2 .1-27.3 7.6-34.4 19.9l-32.7 56-32.7-56c-7.1-12.2-20.2-19.8-34.4-19.9l-64.9-.3 32.2-56.3c7-12.3 7-27.4 0-39.7L92.1 179.8l64.9-.3c14.2-.1 27.3-7.6 34.4-19.9z',
  ],
};
const faServer = {
  prefix: 'far',
  iconName: 'server',
  icon: [
    512,
    512,
    [],
    'f233',
    'M64 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96zM64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 336zM0 352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64zm392 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM328 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faVirusCovidSlash = {
  prefix: 'far',
  iconName: 'virus-covid-slash',
  icon: [
    640,
    512,
    [],
    'e4a9',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6L344 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7L235.8 159.5zM145.6 232L112 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5z',
  ],
};
const faIntersection = {
  prefix: 'far',
  iconName: 'intersection',
  icon: [
    384,
    512,
    [8898],
    'f668',
    'M24 480c13.3 0 24-10.7 24-24l0-232c0-79.5 64.5-144 144-144s144 64.5 144 144l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232c0-106-86-192-192-192S0 118 0 224L0 456c0 13.3 10.7 24 24 24z',
  ],
};
const faShopLock = {
  prefix: 'far',
  iconName: 'shop-lock',
  icon: [
    640,
    512,
    [],
    'e4a5',
    'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-9.6-16.7-23.4-30.6-39.9-40.4L515.5 48l-391 0L54.7 176l415.6 0c-18.8 11.3-34 28-43.5 48L384 224l0 248c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-248-25.8 0C17.1 224 0 206.9 0 185.8zM112 224l0 96 224 0 0-96-224 0zm0 240l224 0 0-96-224 0 0 96zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faFamily = {
  prefix: 'far',
  iconName: 'family',
  icon: [
    512,
    512,
    [],
    'e300',
    'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM105.6 208l22.4 0 22.4 0 32.3 0c-4.3-9.8-6.7-20.6-6.7-32c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0-16c0-11.1 1.6-21.9 4.6-32L88 304l-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3C75.1 220.8 89 208 105.6 208zM336 176c0 11.4-2.4 22.2-6.7 32l38.9 0 15.7 0 15.7 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336 368 336l0 16c0 11.2-1.9 22-5.5 32l37.5 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112l0 16c0 8.8-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z',
  ],
};
const faHourglassStart = {
  prefix: 'far',
  iconName: 'hourglass-start',
  icon: [
    384,
    512,
    ['hourglass-1'],
    'f251',
    'M0 488c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24zM84.1 96C81.4 86.7 80 76.9 80 67l0-19 224 0 0 19c0 9.9-1.4 19.7-4.1 29L84.1 96zM273.5 371.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9l81.5 81.5z',
  ],
};
const faHourglass1 = faHourglassStart;
const faUserHairBuns = {
  prefix: 'far',
  iconName: 'user-hair-buns',
  icon: [
    448,
    512,
    [],
    'e3d3',
    'M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l14.4 0c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32l14.4 0c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44l0 40c0 24.3 19.7 44 44 44zM49.3 464c8.3-54.4 55.3-96 112-96l125.4 0c56.7 0 103.7 41.6 112 96L49.3 464zM0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0C72.2 320 0 392.2 0 481.3z',
  ],
};
const faBlenderPhone = {
  prefix: 'far',
  iconName: 'blender-phone',
  icon: [
    576,
    512,
    [],
    'f6b6',
    'M158.1 64.1c4.7-12.4 .2-26.7-10.6-33.4l-44-27.2c-9.7-6-21.9-4.2-29.8 4.3C-24.6 114-24.6 286 73.7 392.2c7.9 8.5 20.1 10.3 29.8 4.3l44-27.2c10.8-6.7 15.3-21 10.6-33.4l-22-57.8c-4.2-10.9-14.5-17.6-25.3-16.4l-33.3 3.6c-13.6-42.2-13.6-88.4 0-130.7l33.3 3.6c10.9 1.2 21.2-5.5 25.3-16.4l22-57.8zM268.2 336l174.4 0 28-112L368 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l110.5 0 16-64L368 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l134.5 0 12-48L244.2 48l24 288zM566.1 39.8L489.6 345.5C521.8 361 544 393.9 544 432l0 16c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-16c0-40.5 25.1-75.1 60.6-89.2L196.3 52C194 24 216.1 0 244.2 0L535 0c20.8 0 36.1 19.6 31 39.8zM208 432l0 16c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-16c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48zm144-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faHourglassClock = {
  prefix: 'far',
  iconName: 'hourglass-clock',
  icon: [
    576,
    512,
    [],
    'e41b',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l306.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9l64.5 64.5c1.5-19.3 6-37.7 13.2-54.7L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 222.1l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
  ],
};
const faPersonSeatReclined = {
  prefix: 'far',
  iconName: 'person-seat-reclined',
  icon: [
    512,
    512,
    [],
    'e21f',
    'M176 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16.9 189.6l16.9 76.2c.8 3.7 4.1 6.3 7.8 6.3l16.4 0-19.4-87.3c-1.1-5.1-5.7-8.7-10.9-8.7c-7.1 0-12.4 6.6-10.9 13.6zm68.6-15.2l.4 1.7 66.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-55.4 0 10.7 48 35.5 0c30 0 56.9 18.6 67.4 46.7l28.5 76.1 34.7-9.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-56 16c-12 3.4-24.7-2.9-29.1-14.6l-36.3-96.9c-3.5-9.4-12.5-15.6-22.5-15.6l-54.3 0c-.3 0-.7 0-1 0l-45.8 0c-26.2 0-49-18.2-54.7-43.9L146.1 232c-8.2-36.9 19.9-72 57.7-72c27.7 0 51.7 19.3 57.7 46.3zM79.6 147.8l34 192.7c6.1 34.4 36 59.5 70.9 59.5l95.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-95.5 0c-58.2 0-108.1-41.8-118.2-99.1l-34-192.7c-2.3-13.1 6.4-25.5 19.5-27.8s25.5 6.4 27.8 19.5z',
  ],
};
const faPaperPlaneTop = {
  prefix: 'far',
  iconName: 'paper-plane-top',
  icon: [
    512,
    512,
    ['paper-plane-alt', 'send'],
    'e20a',
    'M133.9 232L65.8 95.9 383.4 232l-249.5 0zm0 48l249.5 0L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z',
  ],
};
const faPaperPlaneAlt = faPaperPlaneTop;
const faSend = faPaperPlaneTop;
const faMessageArrowUp = {
  prefix: 'far',
  iconName: 'message-arrow-up',
  icon: [
    512,
    512,
    ['comment-alt-arrow-up'],
    'e1dc',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 296l0-118.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 296c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faCommentAltArrowUp = faMessageArrowUp;
const faLightbulbExclamation = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation',
  icon: [
    384,
    512,
    [],
    'f671',
    'M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zm0-400c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faLayerMinus = {
  prefix: 'far',
  iconName: 'layer-minus',
  icon: [
    576,
    512,
    ['layer-group-minus'],
    'f5fe',
    'M408 60l112 0c11 0 20 9 20 20s-9 20-20 20l-112 0c-11 0-20-9-20-20s9-20 20-20zM263.2 133.1c7.8-3.4 16.3-5.1 24.8-5.1s17 1.7 24.8 5.1l209.3 89.7c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 378.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 289.2C40.6 283.5 32 270.5 32 256s8.6-27.5 21.9-33.2l209.3-89.7zM288 176c-2 0-4 .4-5.9 1.2L98.3 256l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 256 293.9 177.2c-1.9-.8-3.9-1.2-5.9-1.2zM53.9 350.8l31.2-13.4L146 363.5 98.3 384l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 384 430 363.5l60.9-26.1 31.2 13.4c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 506.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 417.2C40.6 411.5 32 398.5 32 384s8.6-27.5 21.9-33.2z',
  ],
};
const faLayerGroupMinus = faLayerMinus;
const faChartPieSimpleCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [
    640,
    512,
    [],
    'e604',
    'M496 192c-46.8 0-89.3 18.2-120.8 48L272 240l0-223.4c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288l67.2 0c-7.6 14.9-13.2 31-16.3 48L224 336c-26.5 0-48-21.5-48-48l0-197.1C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 240l0 48 48 0zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z',
  ],
};
const faCircleE = {
  prefix: 'far',
  iconName: 'circle-e',
  icon: [
    512,
    512,
    [],
    'e109',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 104 0 104c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-56 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-56 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faBuildingWheat = {
  prefix: 'far',
  iconName: 'building-wheat',
  icon: [
    640,
    512,
    [],
    'e4db',
    'M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm40 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM104 216c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm424-40l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zm0 128l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zm0 112l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zM512 496c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zm0-128c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zM528 32c-13.3 0-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-13.3-10.7-24-24-24zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zM456 72c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24z',
  ],
};
const faGaugeMax = {
  prefix: 'far',
  iconName: 'gauge-max',
  icon: [
    512,
    512,
    ['tachometer-alt-fastest'],
    'f626',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM112 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
  ],
};
const faTachometerAltFastest = faGaugeMax;
const faPersonBreastfeeding = {
  prefix: 'far',
  iconName: 'person-breastfeeding',
  icon: [
    448,
    512,
    [],
    'e53a',
    'M192 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM116.9 282.2c19.6-26.5 50.6-42.2 83.6-42.2l58.3 0c27.6 0 54.1 11 73.7 30.6l55.2 55.3c12 12 12.5 31.3 1.2 43.9L326.1 440c-8.8 9.9-8 25.1 1.9 33.9s25.1 8 33.9-1.9l62.8-70.2c28.3-31.6 27-79.8-3-109.8l-55.2-55.3C338 208.1 299.3 192 258.9 192l-58.3 0c-48.2 0-93.6 22.9-122.2 61.7l-56 75.7C-8.1 370.6 7.5 429.5 54.5 450.2L190.3 510c12.1 5.3 26.3-.2 31.6-12.3s-.2-26.3-12.3-31.6L73.8 406.2c-18.8-8.3-25-31.8-12.8-48.3l56-75.7zM192 328c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 43.4c0 7.5 2.1 14.8 6.1 21.2C177.8 437 226.5 464 278.9 464l1.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.1 0c-35.1 0-67.7-17.7-86.9-46.9l0-41.1zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faApostrophe = {
  prefix: 'far',
  iconName: 'apostrophe',
  icon: [
    192,
    512,
    [],
    '27',
    'M128 176c8.8 0 16-7.2 16-16l0-32 0-32c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0zm16 46c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10z',
  ],
};
const faFilePng = {
  prefix: 'far',
  iconName: 'file-png',
  icon: [
    512,
    512,
    [],
    'e666',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM318.3 360.8L352 428.2l0-60.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 7.4-5.1 13.9-12.3 15.6s-14.7-1.8-18-8.4L320 435.8l0 60.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.4 5.1-13.9 12.3-15.6s14.7 1.8 18 8.4zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z',
  ],
};
const faFireHydrant = {
  prefix: 'far',
  iconName: 'fire-hydrant',
  icon: [
    384,
    512,
    [],
    'e17f',
    'M192 0c-17.7 0-32 14.3-32 32l0 4c-45 11.6-80.4 47-92 92l-12 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0c-11.6-45-47-80.4-92-92l0-4c0-17.7-14.3-32-32-32zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-80 16 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0 0-48-48 0 0 256-160 0 0-256-48 0 0 48-16 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l16 0 0 80-8 0zM248 320a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z',
  ],
};
const faRightToBracket = {
  prefix: 'far',
  iconName: 'right-to-bracket',
  icon: [
    512,
    512,
    ['sign-in-alt'],
    'f2f6',
    'M192 365.8L302 256 192 146.2l0 53.8c0 13.3-10.7 24-24 24L48 224l0 64 120 0c13.3 0 24 10.7 24 24l0 53.8zM352 256c0 11.5-4.6 22.5-12.7 30.6L223.2 402.4c-8.7 8.7-20.5 13.6-32.8 13.6c-25.6 0-46.4-20.8-46.4-46.4l0-33.6-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l96 0 0-33.6c0-25.6 20.8-46.4 46.4-46.4c12.3 0 24.1 4.9 32.8 13.6L339.3 225.4c8.1 8.1 12.7 19.1 12.7 30.6zm-8 176l80 0c22.1 0 40-17.9 40-40l0-272c0-22.1-17.9-40-40-40l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faSignInAlt = faRightToBracket;
const faVideoPlus = {
  prefix: 'far',
  iconName: 'video-plus',
  icon: [
    576,
    512,
    [],
    'f4e1',
    'M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM216 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48z',
  ],
};
const faSquareRight = {
  prefix: 'far',
  iconName: 'square-right',
  icon: [
    448,
    512,
    [10145, 'arrow-alt-square-right'],
    'f352',
    'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM262.6 151.2l84 91c3.5 3.8 5.4 8.7 5.4 13.9s-1.9 10.1-5.4 13.9l-84 91c-4.2 4.6-10.1 7.2-16.4 7.2C234 368 224 358 224 345.7l0-41.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-41.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.4 7.2z',
  ],
};
const faArrowAltSquareRight = faSquareRight;
const faCommentSmile = {
  prefix: 'far',
  iconName: 'comment-smile',
  icon: [
    512,
    512,
    [],
    'f4b4',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 270.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z',
  ],
};
const faVenus = {
  prefix: 'far',
  iconName: 'venus',
  icon: [
    384,
    512,
    [9792],
    'f221',
    'M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4l0 49.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-49.6z',
  ],
};
const faPassport = {
  prefix: 'far',
  iconName: 'passport',
  icon: [
    448,
    512,
    [],
    'f5ab',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 400c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm33.3-176l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 304l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0zm0-32l-39.1 0c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 112l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z',
  ],
};
const faThumbtackSlash = {
  prefix: 'far',
  iconName: 'thumbtack-slash',
  icon: [
    640,
    512,
    ['thumb-tack-slash'],
    'e68f',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352c9.4-.4 18.1-4.9 23.9-12.3c6.1-7.8 8.2-17.9 5.8-27.5l-6.2-25c-10.3-41.3-35.4-75.7-68.7-98.3L428.9 96l-3.7-48L456 48c4.4 0 8.6-1.2 12.2-3.3C475.2 40.5 480 32.8 480 24c0-13.3-10.7-24-24-24L425.2 0 214.8 0 184 0c-13.3 0-24 10.7-24 24c0 8.8 4.8 16.5 11.8 20.7c3.6 2.1 7.7 3.3 12.2 3.3l30.8 0-3.7 48-3.2 41.6L38.8 5.1zM253.3 173.2l9.3-121.5c.1-1.2 .1-2.5 .1-3.7l114.5 0c0 1.2 0 2.5 .1 3.7l10.8 140.9c1.1 14.6 8.8 27.8 20.9 36c23.9 16.2 41.7 40.8 49.1 70.2l1.3 5.1-39.4 0L344 244.3l0-28.3c0-13.3-10.7-24-24-24c-10.4 0-19.2 6.6-22.6 15.8l-44.2-34.6zM344 367l-80-63-83.5 0 1.3-5.1c4-16.1 11.2-30.7 20.7-43.3l-37.7-29.7c-13.7 17.8-23.9 38.6-29.6 61.4l-6.2 25c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3l136 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-121z',
  ],
};
const faThumbTackSlash = faThumbtackSlash;
const faInboxIn = {
  prefix: 'far',
  iconName: 'inbox-in',
  icon: [
    512,
    512,
    [128229, 'inbox-arrow-down'],
    'f310',
    'M280 24l0 206.1 63-63c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 305c-9.4 9.4-24.6 9.4-33.9 0L135 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l63 63L232 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM149.1 405.5L130.3 368 48 368l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 421.7 338.2 432 320 432l-128 0c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l82.3 0c18.2 0 34.8 10.3 42.9 26.5z',
  ],
};
const faInboxArrowDown = faInboxIn;
const faHeartPulse = {
  prefix: 'far',
  iconName: 'heart-pulse',
  icon: [
    512,
    512,
    ['heartbeat'],
    'f21e',
    'M256 163.9L222.1 130l-12-12c-21.7-21.7-52.5-31.6-82.7-26.5C81.6 99.1 48 138.7 48 185.1l0 5.8c0 23.9 8.4 46.9 23.5 65.1l51.1 0c6.5 0 12.3-3.9 14.8-9.8l31.8-76.3c2.5-5.9 8.2-9.8 14.5-9.8s12.2 3.6 14.8 9.4l58.2 129.3 48.9-97.9c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8l68.7 0c15.1-18.2 23.5-41.2 23.5-65.1l0-5.8c0-46.4-33.6-86-79.3-93.6c-30.2-5-61.1 4.8-82.7 26.5l-12 12L256 163.9zM456 288l-48.6 0-35.6 0c-18.2 0-34.8-10.3-42.9-26.5L320 243.8l-49.7 99.4c-2.8 5.5-8.5 9-14.6 8.8s-11.7-3.8-14.3-9.4L184.6 216.2 167 258.5C159.5 276.3 142 288 122.7 288l-18 0L56 288l-20.3 0C12.8 261.1 0 226.7 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84c0 0 0 0 0 0l12 12 12-12s0 0 0 0c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 35.8-12.8 70.1-35.7 97.1L456 288zM68.6 320l70.3 0L256 429.3 373.1 320l70.3 0L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L68.6 320z',
  ],
};
const faHeartbeat = faHeartPulse;
const faCircle8 = {
  prefix: 'far',
  iconName: 'circle-8',
  icon: [
    512,
    512,
    [],
    'e0f5',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72l16 0zm-16 96s0 0 0 0l16 0s0 0 0 0c13.2 0 24-10.8 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm16 48l-16 0-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0z',
  ],
};
const faCloudsMoon = {
  prefix: 'far',
  iconName: 'clouds-moon',
  icon: [
    640,
    512,
    [],
    'f745',
    'M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM335.8 272c26.5 0 48 21.5 48 48c0 .8 0 1.7 .1 2.5l2 23.8c1.1 13.2 12.7 23 25.9 21.9c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.3 0-1.9 0c-.3 0-.6 0-.9 0l-266.9 0c-.3 0-.6 0-1 0c-.4 0-.9 0-1.3 0c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.6 0 3.1 .1 4.6 .3c6.9 1 13.9-1.1 19.1-5.6s8.3-11.2 8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c.1-.6 .2-1.1 .3-1.7c2.5-19.6 19.3-34.8 39.7-34.8c12.6 0 23.8 5.8 31.1 14.9c5.8 7.1 15.1 10.4 24.1 8.3s15.9-9.1 18-18c4.9-21.3 24-37.2 46.8-37.2zm96 46.8c-.6-52.5-43.4-94.8-96-94.8c-33 0-62 16.6-79.3 41.9c-12.2-6.3-26-9.9-40.6-9.9c-43 0-78.8 30.9-86.5 71.7c-1 2.6-1.5 5.4-1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0l266 0c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.5-34.5-86.9-79.8-94.6l-.2-2.5zM320 192.1s0 0 0 0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c0 0 0 0 0 0l34.8 0c9.4-19.9 24.6-36.6 43.4-48l-76.4 0c-.6 0-1.2 0-1.7 0c-13.2 0-24-10.7-24-24s10.7-24 24-24c1.1 0 2.2 .1 3.2 .2c25.1 3.3 48.5-13.5 53.4-38.4c2.9-14.7 15.9-25.8 31.4-25.8c13.6 0 25.3 8.5 29.9 20.6c9.2 24.3 36.2 36.9 60.8 28.2c1.6-.6 3.4-.9 5.3-.9c8.8 0 16 7.2 16 16l0 .9c-.1 6.6-1.6 12.9-4.1 18.6c15.5-9.7 33.2-16.3 52.1-18.7l0-.9z',
  ],
};
const faClockTenThirty = {
  prefix: 'far',
  iconName: 'clock-ten-thirty',
  icon: [
    512,
    512,
    [],
    'e355',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8 232 392c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faPeopleCarryBox = {
  prefix: 'far',
  iconName: 'people-carry-box',
  icon: [
    640,
    512,
    ['people-carry'],
    'f4ce',
    'M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM53 344.3L1.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L92.6 375.4 53 344.3zM96 187.5c0-6.4 5.2-11.5 11.5-11.5c4.4 0 8.6 1 12.5 2.8l0 116.4L99.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3l0-84.9zm72 145.4l0-89.6 26 39.1c3.3 4.9 7.6 9.1 12.7 12.1l26.1 15.7c5.6 5.9 13.5 9.6 22.3 9.9c.4 0 .9 0 1.3 0l127.2 0c.4 0 .9 0 1.3 0c8.7-.2 16.6-4 22.2-9.9l26.1-15.7c5.1-3 9.4-7.2 12.7-12.1l26-39.1 0 89.6-25.8 20.3c-8.1 6.4-13.4 15.6-14.9 25.8L416.2 484.6c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l14.6-102.5 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44l0-84.9c0-32.9-26.6-59.5-59.5-59.5c-25.8 0-50 12.9-64.3 34.4L416 240.7l0-80.7c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 80.7-52.2-78.3c-14.3-21.5-38.5-34.4-64.3-34.4C74.6 128 48 154.6 48 187.5l0 84.9c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L208.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L168 332.9zM272 176l96 0 0 96-96 0 0-96zM512 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM638.4 479.5L587 344.3l-39.5 31.1 46.2 121.2c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31zM532.5 176c6.4 0 11.5 5.2 11.5 11.5l0 84.9c0 2.5-1.1 4.8-3.1 6.3L520 295.2l0-116.4c3.9-1.8 8.1-2.8 12.5-2.8z',
  ],
};
const faPeopleCarry = faPeopleCarryBox;
const faFolderUser = {
  prefix: 'far',
  iconName: 'folder-user',
  icon: [
    512,
    512,
    [],
    'e18e',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-80 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-80 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
  ],
};
const faTrashCanXmark = {
  prefix: 'far',
  iconName: 'trash-can-xmark',
  icon: [
    448,
    512,
    [],
    'e2ae',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm63 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faTemperatureHigh = {
  prefix: 'far',
  iconName: 'temperature-high',
  icon: [
    512,
    512,
    [],
    'f769',
    'M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z',
  ],
};
const faMicrochip = {
  prefix: 'far',
  iconName: 'microchip',
  icon: [
    512,
    512,
    [],
    'f2db',
    'M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-8 0c-35.3 0-64 28.7-64 64l0 8-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 8c0 35.3 28.7 64 64 64l8 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c35.3 0 64-28.7 64-64l0-8 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-8c0-35.3-28.7-64-64-64l-8 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40zM400 128l0 256c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM192 160c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-128 0zm16 48l96 0 0 96-96 0 0-96z',
  ],
};
const faLeftLongToLine = {
  prefix: 'far',
  iconName: 'left-long-to-line',
  icon: [
    640,
    512,
    [],
    'e41e',
    'M0 88C0 74.7 10.7 64 24 64s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88zM134.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6l-121.4-129zM288 200l0-53.5L185 256 288 365.5l0-53.5c0-6.4 2.5-12.5 7-17s10.6-7 17-7l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faCrown = {
  prefix: 'far',
  iconName: 'crown',
  icon: [
    576,
    512,
    [128081],
    'f521',
    'M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7l-72-57.6L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6l41.4-227.5 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-72 57.6c-15.9 12.7-39.5 7.5-48.6-10.7L314.8 117.7 309 106zM133.7 418.9L102.2 245.6l28.9 23.1c39.8 31.8 98.8 18.9 121.5-26.7L288 171.3l35.4 70.7c22.8 45.6 81.8 58.5 121.5 26.7l28.9-23.1L442.3 418.9c-1.4 7.6-8 13.1-15.7 13.1l-277.2 0c-7.7 0-14.4-5.5-15.7-13.1z',
  ],
};
const faWeightHanging = {
  prefix: 'far',
  iconName: 'weight-hanging',
  icon: [
    512,
    512,
    [],
    'f5cd',
    'M216 88a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm118.4 40c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-57.6 0zM256 176l136 0 72 288L48 464l72-288 136 0z',
  ],
};
const faXmarksLines = {
  prefix: 'far',
  iconName: 'xmarks-lines',
  icon: [
    640,
    512,
    [],
    'e59a',
    'M24 32l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56S10.7 32 24 32zm0 400l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24zM41 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55L7 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm224 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM455 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faFilePrescription = {
  prefix: 'far',
  iconName: 'file-prescription',
  icon: [
    384,
    512,
    [],
    'f572',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm40 192c-13.3 0-24 10.7-24 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 22.1 0c.3 .3 .6 .7 .9 1l55 55-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23-31.1-31.1C227.5 299.7 240 279.3 240 256c0-35.3-28.7-64-64-64l-72 0zm72 80l-48 0 0-32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
  ],
};
const faTableCellsLock = {
  prefix: 'far',
  iconName: 'table-cells-lock',
  icon: [
    640,
    512,
    [],
    'e679',
    'M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l24 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 56 0 0 .6c-16.9 9.8-29 27.1-31.5 47.4L360 344l0 88zM200 296l112 0 0-80-112 0 0 80zm328-56c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faCalendarRange = {
  prefix: 'far',
  iconName: 'calendar-range',
  icon: [
    448,
    512,
    [],
    'e0d6',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm48 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm224 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 288c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zm40 72l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
  ],
};
const faFlowerDaffodil = {
  prefix: 'far',
  iconName: 'flower-daffodil',
  icon: [
    512,
    512,
    [9880],
    'f800',
    'M112 88c0-48.6 39.4-88 88-88c21.3 0 40.8 7.6 56 20.1C271.2 7.6 290.7 0 312 0c48.6 0 88 39.4 88 88c0 21.3-7.6 40.8-20.1 56c12.6 15.2 20.1 34.7 20.1 56c0 48.6-39.4 88-88 88c-11.3 0-22.1-2.1-32-6l0 91.4c41-52 104.6-85.4 176-85.4l28 0c15.5 0 28 12.5 28 28c0 108.2-87.8 196-196 196l-36 0-48 0-36 0C87.8 512 0 424.2 0 316c0-15.5 12.5-28 28-28l28 0c71.4 0 135 33.4 176 85.4l0-91.4c-9.9 3.9-20.7 6-32 6c-48.6 0-88-39.4-88-88c0-21.3 7.6-40.8 20.1-56C119.6 128.8 112 109.3 112 88zm88-40c-22.1 0-40 17.9-40 40c0 15 8.3 28.2 20.6 35c7.6 4.2 12.4 12.3 12.4 21s-4.7 16.8-12.4 21c-12.4 6.9-20.6 20-20.6 35c0 22.1 17.9 40 40 40c15 0 28.2-8.3 35-20.6c4.2-7.6 12.3-12.4 21-12.4s16.8 4.7 21 12.4c6.9 12.4 20 20.6 35 20.6c22.1 0 40-17.9 40-40c0-15-8.3-28.2-20.6-35c-7.6-4.2-12.4-12.3-12.4-21s4.7-16.8 12.4-21c12.4-6.9 20.6-20 20.6-35c0-22.1-17.9-40-40-40c-15 0-28.2 8.3-35 20.6C272.8 76.3 264.7 81 256 81s-16.8-4.7-21-12.4C228.2 56.3 215 48 200 48zM49.3 336C59.1 408.3 121 464 196 464l29.4 0C204.5 390.1 136.6 336 56 336l-6.7 0zm413.3 0l-6.7 0c-80.6 0-148.5 54.1-169.4 128l29.4 0c75 0 136.9-55.7 146.7-128zM256 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faHandBackPointUp = {
  prefix: 'far',
  iconName: 'hand-back-point-up',
  icon: [
    448,
    512,
    [],
    'e1a2',
    'M144 0C108.7 0 80 28.7 80 64l0 188.8c-5.2 3.6-10.2 7.6-14.9 11.9L44.8 283.2C26.5 299.9 16 323.5 16 348.3l0 10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7L296 512c66.3 0 120-53.7 120-120l0-8 0-96c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5L208 64c0-35.3-28.7-64-64-64zM128 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 96 0 8c0 39.8-32.2 72-72 72l-125.4 0c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C83.6 429.7 64 395.5 64 358.5l0-10.2c0-11.3 4.8-22 13.1-29.6L96 301.5 96 344c0 8.8 7.2 16 16 16s16-7.2 16-16l0-78 0-2 0-200z',
  ],
};
const faWeightScale = {
  prefix: 'far',
  iconName: 'weight-scale',
  icon: [
    512,
    512,
    ['weight'],
    'f496',
    'M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0c0-22.6-4.3-44.2-12-64l28 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l28 0c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z',
  ],
};
const faWeight = faWeightScale;
const faArrowUpToArc = {
  prefix: 'far',
  iconName: 'arrow-up-to-arc',
  icon: [
    512,
    512,
    [],
    'e617',
    'M256 48c114.9 0 208 93.1 208 208c0 13.3 10.7 24 24 24s24-10.7 24-24C512 114.6 397.4 0 256 0S0 114.6 0 256c0 13.3 10.7 24 24 24s24-10.7 24-24C48 141.1 141.1 48 256 48zM377.6 279.7l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 245.1 232 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9z',
  ],
};
const faStarExclamation = {
  prefix: 'far',
  iconName: 'star-exclamation',
  icon: [
    576,
    512,
    [],
    'f2f3',
    'M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM235.4 187.2L287.9 79l52.6 108.2c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-7.1-3.8-15.6-3.8-22.6 0L171.4 443.7l20.2-119.6c1.3-7.7-1.2-15.5-6.8-21L99 217.9l118.3-17.5c7.8-1.2 14.6-6.1 18.1-13.3zM288 168c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zm32 168a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faBooks = {
  prefix: 'far',
  iconName: 'books',
  icon: [
    512,
    512,
    [128218],
    'f5db',
    'M48 416l0 48 64 0 0-48-64 0zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4l-64 0c-26.5 0-48-21.5-48-48l0-48 0-24 0-24L0 144l0-24L0 96 0 48C0 21.5 21.5 0 48 0l64 0c8.7 0 16.9 2.3 24 6.4C143.1 2.3 151.3 0 160 0l64 0c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L349.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L275.6 145.9 272 132.2l0 11.8 0 224 0 24 0 24 0 48c0 26.5-21.5 48-48 48l-64 0c-8.7 0-16.9-2.3-24-6.4zM160 464l64 0 0-48-64 0 0 48zM112 48L48 48l0 48 64 0 0-48zm0 96l-64 0 0 224 64 0 0-224zm48-48l64 0 0-48-64 0 0 48zm64 272l0-224-64 0 0 224 64 0zm216.1-12.3l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L464 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L360.4 48.5 304 64.1c0 .1 0 .2 0 .4l11.7 45.2z',
  ],
};
const faUserGroup = {
  prefix: 'far',
  iconName: 'user-group',
  icon: [
    640,
    512,
    [128101, 'user-friends'],
    'f500',
    'M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6C95.3 319.4 135 304 178.3 304l45.7 0 45.7 0c43.3 0 83 15.4 113.9 41.1c33.6 28 56.8 68.1 62.8 113.6c1 7.7 1.5 15.6 1.5 23.6c0 16.4-13.3 29.7-29.7 29.7l-19.6 0L49.3 512l-19.6 0C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm208 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64c-8.6 14.4-14.4 30.7-16.8 48L98 464 350 464l48.8 0c-.4-2.7-.8-5.3-1.4-8c-2.9-14.3-8.2-27.8-15.5-40c-22.7-38.3-64.4-64-112.2-64l-91.4 0zm431 160l-136.9 0c4.9-8.8 7.6-18.9 7.6-29.7c0-65-29.5-123.2-75.9-161.8c4.3-.4 8.7-.5 13.2-.5l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z',
  ],
};
const faUserFriends = faUserGroup;
const faArrowUpAZ = {
  prefix: 'far',
  iconName: 'arrow-up-a-z',
  icon: [
    576,
    512,
    ['sort-alpha-up'],
    'f15e',
    'M416 32c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5l-85.2 0-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160C398.6 37.1 406.9 32 416 32zM394.8 152l42.3 0L416 109.7 394.8 152zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM352 288l128 0c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 432l74.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 336 352 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faSortAlphaUp = faArrowUpAZ;
const faLayerPlus = {
  prefix: 'far',
  iconName: 'layer-plus',
  icon: [
    576,
    512,
    ['layer-group-plus'],
    'f5ff',
    'M464 4c-11 0-20 9-20 20l0 36-36 0c-11 0-20 9-20 20s9 20 20 20l36 0 0 36c0 11 9 20 20 20s20-9 20-20l0-36 36 0c11 0 20-9 20-20s-9-20-20-20l-36 0 0-36c0-11-9-20-20-20zM288 128c-8.5 0-17 1.7-24.8 5.1L53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 133.1c-7.8-3.4-16.3-5.1-24.8-5.1zm-5.9 49.2c1.9-.8 3.9-1.2 5.9-1.2s4 .4 5.9 1.2L477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256l183.8-78.8zM85.1 337.4L53.9 350.8C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4z',
  ],
};
const faLayerGroupPlus = faLayerPlus;
const faPlayPause = {
  prefix: 'far',
  iconName: 'play-pause',
  icon: [
    640,
    512,
    [],
    'e22f',
    'M432 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zm144 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM112 381.8l0-251.7L263 256 112 381.8zm4.5-310.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96l0 320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z',
  ],
};
const faBlockQuestion = {
  prefix: 'far',
  iconName: 'block-question',
  icon: [
    448,
    512,
    [],
    'e3dd',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm137.8 77.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM360 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faSnooze = {
  prefix: 'far',
  iconName: 'snooze',
  icon: [
    448,
    512,
    [128164, 'zzz'],
    'f880',
    'M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l59.1 0-77.2 88.2c-6.2 7.1-7.7 17.1-3.8 25.7S174.6 176 184 176l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.1 0 77.2-88.2c6.2-7.1 7.7-17.1 3.8-25.7S305.4 0 296 0L184 0zM312 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.9 0L293.1 377.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-62.9 0 81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5l-112 0zM24 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l128.6 0L4.6 473.8c-5.3 7.3-6.1 17-2.1 25S15 512 24 512l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L71.4 464l148-201.8c5.3-7.3 6.1-17 2.1-25S209 224 200 224L24 224z',
  ],
};
const faZzz = faSnooze;
const faScannerImage = {
  prefix: 'far',
  iconName: 'scanner-image',
  icon: [
    576,
    512,
    [],
    'f8f3',
    'M66.7 34.5c-11.9-5.9-26.3-1.1-32.2 10.7s-1.1 26.3 10.7 32.2L466.3 288 64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-32 0-32 0-8.4c0-33.3-18.8-63.8-48.6-78.7L66.7 34.5zM528 352l0 32 0 32c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16zM120 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faTvRetro = {
  prefix: 'far',
  iconName: 'tv-retro',
  icon: [
    512,
    512,
    [128250],
    'f401',
    'M135 7c9.4-9.4 24.6-9.4 33.9 0l87 87L343 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55L432 96c44.2 0 80 35.8 80 80l0 256c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l110.1 0L135 41c-9.4-9.4-9.4-24.6 0-33.9zM80 144c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L80 144zm336 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 192l160 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z',
  ],
};
const faSquareT = {
  prefix: 'far',
  iconName: 'square-t',
  icon: [
    448,
    512,
    [],
    'e280',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm120 48l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faFarm = {
  prefix: 'far',
  iconName: 'farm',
  icon: [
    576,
    512,
    ['barn-silo'],
    'f864',
    'M48 464l0-288 115.3 0 23.4-50.2c7.2-15.5 19.8-27.9 35.3-35C212.1 39.1 166.6 0 112 0C50.1 0 0 50.1 0 112L0 464c0 26.5 21.5 48 48 48l100.1 0c-11-13.3-18.1-29.8-19.8-48L48 464zM176 128L48 128l0-16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 16zm81.9 34.4L368 114.2l110.1 48.2 49.9 107L528 456c0 4.4-3.6 8-8 8l-88 0 0-56c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 56-88 0c-4.4 0-8-3.6-8-8l0-186.7 49.9-107zM384 68.8c-10.2-4.5-21.8-4.5-32.1 0L235.9 119.6c-8.9 3.9-16.1 10.9-20.2 19.7L163.8 250.6c-2.5 5.3-3.8 11.1-3.8 16.9L160 456c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56l0-188.5c0-5.8-1.3-11.6-3.8-16.9L520.3 139.3c-4.1-8.8-11.3-15.8-20.2-19.7L384 68.8zM320 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faBarnSilo = faFarm;
const faChessKnight = {
  prefix: 'far',
  iconName: 'chess-knight',
  icon: [
    448,
    512,
    [9822],
    'f441',
    'M226.6 48L117.3 48l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1l-50.7 0c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0L226.6 0C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352l-48.8 0 24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464l310.7 0-16.6-32L85.2 432zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L56.8 512C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384l297 0c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z',
  ],
};
const faBarsSort = {
  prefix: 'far',
  iconName: 'bars-sort',
  icon: [
    448,
    512,
    [],
    'e0ae',
    'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM192 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24z',
  ],
};
const faPalletBoxes = {
  prefix: 'far',
  iconName: 'pallet-boxes',
  icon: [
    640,
    512,
    [57863, 'palette-boxes', 'pallet-alt'],
    'f483',
    'M272 48L112 48l0 160 160 0 0-160zM112 0L272 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0zM528 112l-96 0 0 96 96 0 0-96zM432 64l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z',
  ],
};
const faPaletteBoxes = faPalletBoxes;
const faPalletAlt = faPalletBoxes;
const faFaceLaughSquint = {
  prefix: 'far',
  iconName: 'face-laugh-squint',
  icon: [
    512,
    512,
    ['laugh-squint'],
    'f59b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
  ],
};
const faLaughSquint = faFaceLaughSquint;
const faCodeSimple = {
  prefix: 'far',
  iconName: 'code-simple',
  icon: [
    576,
    512,
    [],
    'e13d',
    'M216.6 105.4c9.6-9.2 9.9-24.3 .8-33.9s-24.3-9.9-33.9-.8l-176 168C2.7 243.2 0 249.4 0 256s2.7 12.8 7.4 17.4l176 168c9.6 9.2 24.8 8.8 33.9-.8s8.8-24.8-.8-33.9L58.8 256 216.6 105.4zm142.9 0L517.2 256 359.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z',
  ],
};
const faBoltSlash = {
  prefix: 'far',
  iconName: 'bolt-slash',
  icon: [
    640,
    512,
    [],
    'e0b8',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.2 327.6l49.5-42c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9l-85.2 0L445.4 36.6C450.6 18.3 436.8 0 417.7 0c-6.8 0-13.5 2.4-18.7 6.9L227.9 153.3 38.8 5.1zM266.4 183.5L381.6 85 337.5 239.3l-71.1-55.7zM379.3 272l62.2 0-29.8 25.3L379.3 272zm-4.4 119.4l-38.5-30.3-78.2 66.4L288.1 323l-40.7-32.1L194.6 475.4c-5.2 18.4 8.5 36.6 27.6 36.6c6.8 0 13.4-2.4 18.6-6.8L374.9 391.4zM153.5 216.9l-13.7 11.7c-7.5 6.4-11.8 15.8-11.8 25.6c0 18.6 15.1 33.7 33.7 33.7l82 0-90.2-71.1z',
  ],
};
const faPanelFire = {
  prefix: 'far',
  iconName: 'panel-fire',
  icon: [
    640,
    512,
    [],
    'e42f',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l242.1 0c8.1 17.5 18.8 33.7 31.5 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-4.2 3.8-8.4 7.6-12.5 11.5L400 96c0-8.8-7.2-16-16-16zM293.8 311.3c-1.8 .5-3.8 .7-5.8 .7c-13.3 0-24-10.7-24-24s10.7-24 24-24c8.2 0 15.5 4.1 19.8 10.4c-5.8 12.1-10.6 24.5-14 36.9zM96 160c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-32zm32 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm321.7-79.9L518 194.3c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.1 640 322 640 352c0 88.7-71.3 159.8-160 159.8c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327 416 363.5 416 400c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faBinaryCircleCheck = {
  prefix: 'far',
  iconName: 'binary-circle-check',
  icon: [
    640,
    512,
    [],
    'e33c',
    'M318 4.5C324.3 9 328 16.3 328 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5zM94 292.5c6.3 4.5 10 11.8 10 19.5l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3zM72 0l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72L0 72C0 32.2 32.2 0 72 0zM48 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L72 48C58.7 48 48 58.7 48 72zM192 360c0-39.8 32.2-72 72-72l48 0c8.8 0 17.2 1.6 25 4.5c-6.8 14.4-11.8 29.8-14.5 45.9c-3.2-1.5-6.7-2.4-10.5-2.4l-48 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l48 0c0 0 .1 0 .1 0l36.4 0c5.4 8.2 11.4 15.9 18 23.1C353.2 502.4 333.7 512 312 512l-48 0c-39.8 0-72-32.2-72-72l0-80zm160 8a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faCommentMinus = {
  prefix: 'far',
  iconName: 'comment-minus',
  icon: [
    512,
    512,
    [],
    'f4b1',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 216c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faBurrito = {
  prefix: 'far',
  iconName: 'burrito',
  icon: [
    512,
    512,
    [127791],
    'f7ed',
    'M67.9 304c-4.4 4.4-8.1 9.4-11.2 14.7c17.3 6 35.9 9.3 55.3 9.3c75.6 0 139.5-49.9 160.6-118.6c4.8-15.6 7.4-32.2 7.4-49.4c0-20.3-3.6-39.8-10.2-57.9L67.9 304zm-53.8-7.4s0 0 0 0c5.3-9.7 11.9-18.6 19.8-26.5L242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c2.7 6.1 4.6 12.7 5.7 19.6c6.6 41.7-20.4 81-61 90.4L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L112 444.1c12.7 12.7 30 19.9 48 19.9s35.3-7.2 48-19.9L409.9 242.2c-18-6.6-37.5-10.2-57.9-10.2c-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-21.7 0-42.6-3.2-62.4-9.1c2.8 12.5 9.1 24 18.2 33.1L112 444.1 78.1 478.1 33.9 433.9C12.2 412.2 0 382.7 0 352c0-2.4 .1-4.8 .2-7.1c0 0 0 0 0 0c1-17 5.8-33.5 13.9-48.3z',
  ],
};
const faViolin = {
  prefix: 'far',
  iconName: 'violin',
  icon: [
    640,
    512,
    [127931],
    'f8ed',
    'M496 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM345 41L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM198.4 403.2c6.4-4.8 15.3-4.1 20.9 1.5l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-5.3 7.1c16.6 9.7 35.9 15.3 56.5 15.3c25.2 0 48.3-8.2 67-22.2c-2-8.3-3-17-3-25.8c0-60 47.3-109.1 106.6-111.9c8.2-19.7 8.4-46.6-12.7-76.1L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L412 194.1c-29.5-21-56.4-20.8-76.1-12.7C333.1 240.8 284 288 224 288c-8.8 0-17.5-1-25.8-3c-14 18.7-22.2 41.8-22.2 67c0 20.6 5.6 39.9 15.3 56.5l7.1-5.3zm-45.7 34.3c-15.7-24.7-24.7-54-24.7-85.5c0-41.2 15.5-78.7 41.1-107c9.7-10.7 25.8-10.1 39.8-6.7c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64c0-11.6 2.6-24 12.4-30.1c39.3-24.7 94.3-26.4 145.8 14L599 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L480.2 193.8c40.3 51.5 38.6 106.5 14 145.8C488 349.4 475.6 352 464 352c-35.3 0-64 28.7-64 64c0 5.2 .6 10.2 1.8 15.1c3.4 14.1 4 30.2-6.7 39.8C366.7 496.5 329.2 512 288 512c-31.4 0-60.7-9.1-85.5-24.7l-13.7 18.3c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l18.3-13.7zM448 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faObjectsColumn = {
  prefix: 'far',
  iconName: 'objects-column',
  icon: [
    448,
    512,
    [],
    'e3c1',
    'M48 80l0 160 96 0 0-160L48 80zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM304 272l0 160 96 0 0-160-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM144 368l-96 0 0 64 96 0 0-64zM48 320l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM304 80l0 64 96 0 0-64-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64z',
  ],
};
const faSquareChevronDown = {
  prefix: 'far',
  iconName: 'square-chevron-down',
  icon: [
    448,
    512,
    ['chevron-square-down'],
    'f329',
    'M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z',
  ],
};
const faChevronSquareDown = faSquareChevronDown;
const faCommentPlus = {
  prefix: 'far',
  iconName: 'comment-plus',
  icon: [
    512,
    512,
    [],
    'f4b2',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faTriangleInstrument = {
  prefix: 'far',
  iconName: 'triangle-instrument',
  icon: [
    576,
    512,
    ['triangle-music'],
    'f8e2',
    'M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 43.3c-21.3 5.9-40 19.5-52.1 38.7L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94L450 512c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-34.8 34.8 75.5 119.5c4.6 7.4 7.1 15.9 7.1 24.6c0 25.4-20.6 46-46 46L126 464c-25.4 0-46-20.6-46-46c0-8.7 2.5-17.2 7.1-24.6L252.4 131.6c7.7-12.2 21.1-19.6 35.6-19.6s27.9 7.4 35.6 19.6l46 72.9-62.8 62.8c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l55.1-55.1 34.8-34.8L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C352 86.8 333.3 73.2 312 67.3L312 24z',
  ],
};
const faTriangleMusic = faTriangleInstrument;
const faWheelchair = {
  prefix: 'far',
  iconName: 'wheelchair',
  icon: [
    512,
    512,
    [],
    'f193',
    'M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.5 247.2C78.1 263.2 48 304.1 48 352c0 61.9 50.1 112 112 112c42.8 0 80-24 98.9-59.3c6.2-11.7 20.8-16.1 32.5-9.9s16.1 20.8 9.9 32.5C274.3 477.7 221.2 512 160 512C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9zm67.2-118.8c13-2.4 25.5 6.3 27.9 19.3l5.1 28.3L344 176c13.3 0 24 10.7 24 24s-10.7 24-24 24l-114.5 0 13.4 73.4c.7 3.8 4 6.6 7.9 6.6l122.8 0c15.9 0 30.3 9.4 36.6 24l43 98.3 27.2-9.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-48 16c-11.8 3.9-24.6-1.8-29.6-13.1L368.3 352l-117.6 0c-27.1 0-50.3-19.4-55.1-46L168.4 156.3c-2.4-13 6.3-25.5 19.3-27.9z',
  ],
};
const faUserPilotTie = {
  prefix: 'far',
  iconName: 'user-pilot-tie',
  icon: [
    448,
    512,
    [],
    'e2c1',
    'M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9c0 0 0 0 0 0l-.5-.9s0 0 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L168 512s0 0 0 0l1 0 21.2 0 1.7 0s0 0 0 0l64 0s0 0 0 0l1.7 0 21.2 0 1 0s0 0 0 0l142.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464s0 0 0 0l-.5 .9c0 0 0 0 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464l-88.3 0c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0l-88.3 0 35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z',
  ],
};
const faPianoKeyboard = {
  prefix: 'far',
  iconName: 'piano-keyboard',
  icon: [
    576,
    512,
    [127929],
    'f8d5',
    'M528 224l0 160c0 8.8-7.2 16-16 16l-80 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 80 0zM400 400l-96 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zm-128 0l-96 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zm-128 0l-80 0c-8.8 0-16-7.2-16-16l0-160 80 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zM528 176l-112 0-128 0-128 0L48 176l0-48c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 48zm48 0l0-48c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128l0 48 0 24 0 24L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-160 0-24 0-24z',
  ],
};
const faBedEmpty = {
  prefix: 'far',
  iconName: 'bed-empty',
  icon: [
    640,
    512,
    [128719],
    'f8f9',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 184 0 360l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 544 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-80c0-66.3-53.7-120-120-120L48 160 48 56zM592 336L48 336l0-128 472 0c39.8 0 72 32.2 72 72l0 56z',
  ],
};
const faCircleArrowUp = {
  prefix: 'far',
  iconName: 'circle-arrow-up',
  icon: [
    512,
    512,
    ['arrow-circle-up'],
    'f0aa',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 207l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z',
  ],
};
const faArrowCircleUp = faCircleArrowUp;
const faToggleOn = {
  prefix: 'far',
  iconName: 'toggle-on',
  icon: [
    576,
    512,
    [],
    'f205',
    'M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144l192 0c79.5 0 144-64.5 144-144s-64.5-144-144-144l-192 0zM0 256C0 150 86 64 192 64l192 0c106 0 192 86 192 192s-86 192-192 192l-192 0C86 448 0 362 0 256zm384-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faRectangleVertical = {
  prefix: 'far',
  iconName: 'rectangle-vertical',
  icon: [
    384,
    512,
    ['rectangle-portrait'],
    'f2fb',
    'M336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z',
  ],
};
const faRectanglePortrait = faRectangleVertical;
const faPersonWalking = {
  prefix: 'far',
  iconName: 'person-walking',
  icon: [
    320,
    512,
    [128694, 'walking'],
    'f554',
    'M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm11.7 128.8l-29.9 89.8c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1zm57.6 53.1l-28.5 91.3 50.1 40.7c6.9 5.6 11.7 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L114 312.6C96 297.9 88.9 273.5 96.2 251.4L119 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7L19.5 217c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L313 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L250 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7zM75.5 402.5l24.1-60.4 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5z',
  ],
};
const faWalking = faPersonWalking;
const faL = {
  prefix: 'far',
  iconName: 'l',
  icon: [
    320,
    512,
    [108],
    '4c',
    'M56 32c13.3 0 24 10.7 24 24l0 376 216 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24L32 56c0-13.3 10.7-24 24-24z',
  ],
};
const faSignalStream = {
  prefix: 'far',
  iconName: 'signal-stream',
  icon: [
    576,
    512,
    [],
    'f8dd',
    'M99.8 69.4c10.2 8.4 11.6 23.6 3.2 33.8C68.6 144.7 48 197.9 48 256s20.6 111.3 55 152.8c8.4 10.2 7 25.3-3.2 33.8s-25.3 7-33.8-3.2C24.8 389.6 0 325.7 0 256S24.8 122.4 66 72.6c8.4-10.2 23.6-11.6 33.8-3.2zm376.5 0c10.2-8.4 25.3-7 33.8 3.2c41.2 49.8 66 113.8 66 183.4s-24.8 133.6-66 183.4c-8.4 10.2-23.6 11.6-33.8 3.2s-11.6-23.6-3.2-33.8c34.3-41.5 55-94.7 55-152.8s-20.6-111.3-55-152.8c-8.4-10.2-7-25.3 3.2-33.8zM248 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-61.1-78.5C170 199.2 160 226.4 160 256s10 56.8 26.9 78.5c8.1 10.5 6.3 25.5-4.2 33.7s-25.5 6.3-33.7-4.2c-23.2-29.8-37-67.3-37-108s13.8-78.2 37-108c8.1-10.5 23.2-12.3 33.7-4.2s12.3 23.2 4.2 33.7zM427 148c23.2 29.8 37 67.3 37 108s-13.8 78.2-37 108c-8.1 10.5-23.2 12.3-33.7 4.2s-12.3-23.2-4.2-33.7C406 312.8 416 285.6 416 256s-10-56.8-26.9-78.5c-8.1-10.5-6.3-25.5 4.2-33.7s25.5-6.3 33.7 4.2z',
  ],
};
const faDownToBracket = {
  prefix: 'far',
  iconName: 'down-to-bracket',
  icon: [
    448,
    512,
    [],
    'e4e7',
    'M114.2 192L224 302 333.8 192 280 192c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 352c-11.5 0-22.5-4.6-30.6-12.7L77.6 223.2C68.9 214.5 64 202.7 64 190.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 339.3c-8.1 8.1-19.1 12.7-30.6 12.7zM48 344l0 80c0 22.1 17.9 40 40 40l272 0c22.1 0 40-17.9 40-40l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faCircleZ = {
  prefix: 'far',
  iconName: 'circle-z',
  icon: [
    512,
    512,
    [],
    'e130',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l98.2 0L164.3 346.3c-5.1 7.3-5.7 16.9-1.5 24.8S175.1 384 184 384l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-98.2 0L347.7 165.7c5.1-7.3 5.7-16.9 1.5-24.8S336.9 128 328 128l-144 0z',
  ],
};
const faStars = {
  prefix: 'far',
  iconName: 'stars',
  icon: [
    512,
    512,
    [],
    'f762',
    'M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z',
  ],
};
const faFire = {
  prefix: 'far',
  iconName: 'fire',
  icon: [
    448,
    512,
    [128293],
    'f06d',
    'M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7c3.8 4.8 7.4 9.5 10.9 13.9c4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4c2.6-3.8 5.3-7.6 7.8-11.2c5.6-7.9 10.5-14.5 14.4-19.1c20 20.8 41 53 57.4 88.4c17.7 38.2 28.6 77 28.6 106.3c0 103-78.8 181.4-176 181.4c-98.3 0-176-78.4-176-181.4c0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6C183.3-3.8 158-3.9 141.8 11.5c-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6C0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4c0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1c-7.9 7.6-17 20-24.3 30.3l-1.1 1.6C240.6 57 218.4 29.5 199.5 11.6zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z',
  ],
};
const faBedPulse = {
  prefix: 'far',
  iconName: 'bed-pulse',
  icon: [
    640,
    512,
    ['procedures'],
    'f487',
    'M483.2 9.6L524 64l92 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112 216 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM288 216c0-27.3 19.5-50 45.4-55l20 30.1c4.7 7 10.8 12.7 17.8 16.9L344 208c-4.4 0-8 3.6-8 8l0 152 256 0 0-88c0-39.8-32.2-72-72-72l-91.2 0c9.3-5.6 17-13.9 21.8-24.2L461.9 160l58.1 0c66.3 0 120 53.7 120 120l0 112 0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-280 0L48 416l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96L0 88C0 74.7 10.7 64 24 64s24 10.7 24 24l0 280 240 0 0-152zm-80 32a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM80 248a88 88 0 1 1 176 0A88 88 0 1 1 80 248z',
  ],
};
const faProcedures = faBedPulse;
const faHouseDay = {
  prefix: 'far',
  iconName: 'house-day',
  icon: [
    640,
    512,
    [],
    'e00e',
    'M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.8c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.4c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 6.2 11.5 24-19.6 14.5-11.8c-1 0-2.1 .1-3.1 .1c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 6.6-.8 13-2.3 19.2l54.6-44.5-31.7-17.1 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM208 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm207.2-58.6c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4 224 456c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-161.6 24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3L528 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-200.7L400 151 528 255.3zM352 312l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faShuttleSpace = {
  prefix: 'far',
  iconName: 'shuttle-space',
  icon: [
    640,
    512,
    ['space-shuttle'],
    'f197',
    'M32 384l-8 0c-13.3 0-24-10.7-24-24l0-32L0 184l0-32c0-13.3 10.7-24 24-24l8 0 0-48c0-26.5 21.5-48 48-48l50 0c40.6 0 80.4 11 115.2 31.9L405.3 160l50.7 0c69.3 0 135 22.7 179.2 81.6c6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352l-50.7 0L245.2 448.1C210.4 469 170.6 480 130 480l-50 0c-26.5 0-48-21.5-48-48l0-48zm280-32l-144 0c-9.9 13.2-23.9 23.3-40 28.3l0 51.7 2 0c31.9 0 63.2-8.7 90.6-25.1L312 352zm0-192l-91.5-54.9C193.2 88.7 161.9 80 130 80l-2 0 0 51.7c16.1 5.1 30.1 15.1 40 28.3l144 0zM48 184l0 144 0 8 56 0c12.7 0 23.8-7.4 28.9-18.3c4-8.4 12.4-13.7 21.7-13.7L456 304c32.6 0 62.4-5.8 88-18.5l0-59.1c-25.6-12.6-55.4-18.5-88-18.5l-301.4 0c-9.3 0-17.7-5.3-21.7-13.7C127.8 183.4 116.7 176 104 176l-56 0 0 8zm416 40c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
  ],
};
const faSpaceShuttle = faShuttleSpace;
const faShirtLongSleeve = {
  prefix: 'far',
  iconName: 'shirt-long-sleeve',
  icon: [
    640,
    512,
    [],
    'e3c7',
    'M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4L48 400l48 0 0-151.6c0-13.6 4.5-27.2 9.7-39c5.4-12.1 12.5-24.4 19.7-35.8c6.1-9.6 12.6-19.2 18.4-27.8c1.1-1.6 2.2-3.2 3.2-4.7c6.9-10.2 12.3-18.4 15.9-24.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2l0 320c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-320c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7c3.5 6.4 9 14.7 15.9 24.8c1 1.5 2.1 3.1 3.2 4.7c5.9 8.6 12.3 18.2 18.4 27.8c7.2 11.4 14.4 23.7 19.7 35.8c5.2 11.8 9.7 25.4 9.7 39L544 400l48 0 0-151.6c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48L444 48c-.4 0-.9 0-1.3 0c-1 .1-2 0-3 0l-18.5 0c-10.8 45.9-52 80-101.2 80s-90.4-34.1-101.2-80l-18.5 0c-1 .1-2 .1-3 0c-.4 0-.9 0-1.3 0l-7.6 0zM83.2 62.2C104.3 23.8 144.6 0 188.4 0L196 0c.8 0 1.5 0 2.3 0c.6 0 1.1 0 1.7 0l24 0c23 0 37.7 18.2 41.1 35.2C270.3 60.7 292.9 80 320 80s49.7-19.3 54.9-44.8C378.3 18.2 393 0 416 0l24 0c.6 0 1.1 0 1.7 0c.8 0 1.5 0 2.3 0l7.6 0c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5L640 424c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-175.6c0-3.7-1.4-10.1-5.6-19.4c-2.7-6.2-6.3-12.8-10.4-19.8L480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-238.8c-4.1 7-7.7 13.6-10.4 19.8c-4.2 9.4-5.6 15.7-5.6 19.4L144 424c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24L0 248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2z',
  ],
};
const faChartPieSimple = {
  prefix: 'far',
  iconName: 'chart-pie-simple',
  icon: [
    512,
    512,
    ['chart-pie-alt'],
    'f64e',
    'M495.4 240c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6L272 240l223.4 0zM176 288c0 26.5 21.5 48 48 48l197.1 0C394.7 410.6 323.6 464 240 464C134 464 48 378 48 272c0-83.6 53.4-154.7 128-181.1L176 288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8L272 288l-48 0 0-48 0-173.3z',
  ],
};
const faChartPieAlt = faChartPieSimple;
const faFaceLaugh = {
  prefix: 'far',
  iconName: 'face-laugh',
  icon: [
    512,
    512,
    ['laugh'],
    'f599',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faLaugh = faFaceLaugh;
const faFolderOpen = {
  prefix: 'far',
  iconName: 'folder-open',
  icon: [
    576,
    512,
    [128194, 128449, 61717],
    'f07c',
    'M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z',
  ],
};
const faAlbumCollectionCircleUser = {
  prefix: 'far',
  iconName: 'album-collection-circle-user',
  icon: [
    640,
    512,
    [],
    'e48f',
    'M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16l-353 0c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l249.4 0c12.3 18.8 28 35.1 46.3 48L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zm96 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faCandy = {
  prefix: 'far',
  iconName: 'candy',
  icon: [
    640,
    512,
    [127852],
    'e3e7',
    'M309 399.6L198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6zM233.3 141L360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4zM331 112.4L441.5 333.3C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6zM320 64c88 0 162.1 59.1 184.8 139.8l91.9-49c10.5-5.6 23.5-2.7 30.6 6.9s6.1 22.9-2.3 31.3l-29.6 29.6 29.1 10.9C633.8 237 640 246 640 256s-6.2 19-15.6 22.5l-29.1 10.9L625 319c8.4 8.4 9.4 21.7 2.3 31.3s-20.1 12.5-30.6 6.9l-91.9-49C482.1 388.9 408 448 320 448s-162.1-59.1-184.8-139.8l-91.9 49c-10.5 5.6-23.5 2.7-30.6-6.9S6.6 327.4 15 319l29.6-29.6L15.6 278.5C6.2 275 0 266 0 256s6.2-19 15.6-22.5l29.1-10.9L15 193c-8.4-8.4-9.4-21.7-2.3-31.3s20.1-12.5 30.6-6.9l91.9 49C157.9 123.1 232 64 320 64z',
  ],
};
const faBowlHot = {
  prefix: 'far',
  iconName: 'bowl-hot',
  icon: [
    512,
    512,
    ['soup'],
    'f823',
    'M152 0c13.3 0 24 10.7 24 24l0 8c0 17.6 8.3 34.2 22.4 44.8C224.6 96.4 240 127.3 240 160l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-17.6-8.3-34.2-22.4-44.8C143.4 95.6 128 64.7 128 32l0-8c0-13.3 10.7-24 24-24zm-.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272zM304 24l0 8c0 17.6 8.3 34.2 22.4 44.8C352.6 96.4 368 127.3 368 160l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-17.6-8.3-34.2-22.4-44.8C271.4 95.6 256 64.7 256 32l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSoup = faBowlHot;
const faFlatbread = {
  prefix: 'far',
  iconName: 'flatbread',
  icon: [
    512,
    512,
    [129747],
    'e40b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm361-71L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM241 111c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0zM401 305l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faHeartCirclePlus = {
  prefix: 'far',
  iconName: 'heart-circle-plus',
  icon: [
    576,
    512,
    [],
    'e500',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faCodeFork = {
  prefix: 'far',
  iconName: 'code-fork',
  icon: [
    448,
    512,
    [],
    'e13b',
    'M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 35.7c0 22.1 17.9 40 40 40l160 0c22.1 0 40-17.9 40-40l0-35.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 35.7c0 48.6-39.4 88-88 88l-56 0 0 75.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-75.7-56 0c-48.6 0-88-39.4-88-88l0-35.7C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCity = {
  prefix: 'far',
  iconName: 'city',
  icon: [
    640,
    512,
    [127961],
    'f64f',
    'M104 0C90.7 0 80 10.7 80 24l0 40-8 0C32.2 64 0 96.2 0 136L0 440c0 39.8 32.2 72 72 72l168 0c-10-13.4-16-30-16-48L72 464c-13.3 0-24-10.7-24-24l0-304c0-13.3 10.7-24 24-24l8 0 48 0 48 0 48 0 0-48 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24zM464 160c0 26.5 21.5 48 48 48l64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-128 0-128 0c-8.8 0-16-7.2-16-16l0-224 0-160c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 96zm48-48l0-48c0-35.3-28.7-64-64-64L320 0c-35.3 0-64 28.7-64 64l0 160 0 224c0 35.3 28.7 64 64 64l128 0 128 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-16 0-48 0 0-48zM352 336c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM368 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 240c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM496 416l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16zM480 304c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM112 320l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16zM96 400c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zm16-176l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16z',
  ],
};
const faSignalBarsWeak = {
  prefix: 'far',
  iconName: 'signal-bars-weak',
  icon: [
    640,
    512,
    ['signal-alt-1'],
    'f691',
    'M96 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM80 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z',
  ],
};
const faSignalAlt1 = faSignalBarsWeak;
const faMicrophoneLines = {
  prefix: 'far',
  iconName: 'microphone-lines',
  icon: [
    384,
    512,
    [127897, 'microphone-alt'],
    'f3c9',
    'M240 128l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z',
  ],
};
const faMicrophoneAlt = faMicrophoneLines;
const faClockTwelve = {
  prefix: 'far',
  iconName: 'clock-twelve',
  icon: [
    512,
    512,
    [],
    'e358',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faPepperHot = {
  prefix: 'far',
  iconName: 'pepper-hot',
  icon: [
    512,
    512,
    [127798],
    'f816',
    'M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3L360 256c-13.3 0-24-10.7-24-24l0-80c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm-256 302.7L261.7 160l42.3 0 0 22.8-90.7 148c-24.9 40.7-65.3 69.5-111.9 79.8L66 418.5c-10.5 2.3-18 11.7-18 22.5c0 12.7 10.3 23 23 23l32.1 0c133.7 0 254.1-68.7 323.6-176l1.4 0 23.9 47.8C372.3 443.9 244.3 512 103.2 512L71 512c-39.2 0-71-31.8-71-71c0-33.3 23.1-62.1 55.6-69.3L91 363.8c33.9-7.5 63.2-28.5 81.4-58.1z',
  ],
};
const faCitrusSlice = {
  prefix: 'far',
  iconName: 'citrus-slice',
  icon: [
    512,
    512,
    [],
    'e2f5',
    'M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L7 391zm384.3 .3c-91.1 91.1-235.2 96.2-332.6 15.8l22.4-22.4C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6zm-40.8-276c13.3 17.8 23.2 38.3 28.7 60.6l-89.3 0 60.6-60.6zM272 208l111.8 0c.1 2.7 .2 5.3 .2 8c0 40.6-14.4 77.9-38.4 106.9l-82.4-82.4c5.9-10 8.9-21.3 8.9-32.5zm-31.5 55.1l82.4 82.4C293.9 369.6 256.6 384 216 384c-2.7 0-5.3-.1-8-.2L208 272c11.3 0 22.5-3 32.5-8.9zM115.4 350.6L176 289.9l0 89.3c-22.3-5.4-42.8-15.3-60.6-28.7z',
  ],
};
const faSheep = {
  prefix: 'far',
  iconName: 'sheep',
  icon: [
    640,
    512,
    [128017],
    'f711',
    'M384 135.8l0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-203.1-1l-.4-.9c-6.9-16.1-5.7-33.5 1.8-47.9c-7.4-11.8-18.5-21-31.7-26C271.6 65.5 264 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L464 320c-11.8 0-23.2-1.8-33.8-5.2c.2 3.1 .6 6.2 1.4 9.3c.3 1.2 .5 2.5 .5 3.9c0 8.8-7.2 16-16 16c-.9 0-1.7-.1-2.5-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.8 0 10.9 3 13.7 7.8c8 13.3 22 21.9 37.4 23.1c.6 0 1.2 .1 1.7 .1z',
  ],
};
const faUnlock = {
  prefix: 'far',
  iconName: 'unlock',
  icon: [
    448,
    512,
    [128275],
    'f09c',
    'M144 128c0-44.2 35.8-80 80-80c35.6 0 65.8 23.2 76.1 55.4c4.1 12.6 17.6 19.5 30.2 15.5s19.5-17.6 15.5-30.2C329.2 37.2 281 0 224 0C153.3 0 96 57.3 96 128l0 64-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-240 0 0-64zM48 256c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192z',
  ],
};
const faColonSign = {
  prefix: 'far',
  iconName: 'colon-sign',
  icon: [
    384,
    512,
    [],
    'e140',
    'M255.3 29.6c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7l-13.5 56C103.6 88.3 32 163.2 32 256c0 63 33 117.8 82.9 150.8L96.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L159 428.7c9.3 3.2 18.9 5.8 28.8 7.7l-11.1 46c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l13-53.9c39.3-2 75.7-15.1 105.5-36.1c10.8-7.7 13.4-22.6 5.7-33.5s-22.6-13.4-33.5-5.7c-18.8 13.3-41.3 22.5-65.9 26l59.6-247c2.1 1.3 4.2 2.7 6.3 4.2c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5c-7.1-5-14.5-9.5-22.3-13.6l15.7-65.2c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7L274.3 77.8c-9.6-2.3-19.4-4-29.4-4.9l10.4-43.2zm-72.7 96.4l-55.5 230C98 331 80 295.1 80 256c0-60.1 42.5-112.6 102.7-129.9zM170.3 381.8l63.2-261.6c10.2 .5 20.1 1.9 29.6 4.2L199 389.7c-10-1.7-19.6-4.4-28.7-7.9z',
  ],
};
const faHeadset = {
  prefix: 'far',
  iconName: 'headset',
  icon: [
    512,
    512,
    [],
    'f590',
    'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208l0 144.1c0 22.1-17.9 40-40 40L313.6 440c-8.3-14.4-23.8-24-41.6-24l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l32 0c17.8 0 33.3-9.7 41.6-24l110.4 .1c48.6 0 88.1-39.4 88.1-88L512 256C512 114.6 397.4 0 256 0S0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm112-32l0 112c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zM80 256l0 48c0 44.2 35.8 80 80 80l16 0c17.7 0 32-14.3 32-32l0-144c0-17.7-14.3-32-32-32l-16 0c-44.2 0-80 35.8-80 80zm272-32c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32l0-112zm80 32c0-44.2-35.8-80-80-80l-16 0c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0c44.2 0 80-35.8 80-80l0-48z',
  ],
};
const faBadgerHoney = {
  prefix: 'far',
  iconName: 'badger-honey',
  icon: [
    640,
    512,
    [129441],
    'f6b4',
    'M465 112c16.9 0 33.6 3.7 49 10.9L559.2 144l-72.3 0c-49.3 0-97.7 13.4-139.9 38.8l-69.4 41.7c-17 10.2-36.4 15.6-56.2 15.6c-55.4 0-101.1-41.2-108.3-94.6c4.9-.9 9.9-1.4 15-1.4l204.2 0c27.3 0 54.1-6.3 78.5-18.5l2.5-1.2c16.1-8 33.8-12.2 51.8-12.2zm126.8 64c-.6 4.7-2.8 9-6.1 12.4L583 191l16.4 16.4L583 191c-5.5 5.5-13.8 9.2-23.9 10.1c-67.9 6.4-128.1 37.5-169.4 67.9c-7.8 5.7-11.4 15.6-9.1 25c0 .2 .1 .4 .1 .6c0 0 0 0 0 0l21.3 128c.8 4.9-2.9 9.3-7.9 9.3l-31.1 0c-3.9 0-7.2-2.8-7.9-6.7L338.3 324.1c-1.9-11.6-11.9-20.1-23.7-20.1l-110.1 0c-9.6 0-18.3 5.7-22.1 14.5l-16 37.3c-5.2 12.1-5.9 25.6-2.2 38.2l8.3 27.7c1.5 5.1-2.3 10.3-7.7 10.3l-29.2 0c-3.5 0-6.6-2.3-7.7-5.7L115 382.6c-1.3-4.4-1.3-9.1-.1-13.5l10.7-37.6c1.8-6.2 1-13-2.3-18.6s-8.6-9.7-14.9-11.3C73.7 292.9 48 261.4 48 224c0-27.3 13.7-51.5 34.7-65.9C95.4 223 152.6 272 221.3 272c25.6 0 50.7-7 72.7-20.1l69.4-41.7c33.2-19.9 70.6-31.5 109.1-33.8c2 8.9 10 15.6 19.5 15.6c9.7 0 17.7-6.9 19.6-16l80.2 0zM48 323.9c7.8 6.2 16.3 11.6 25.4 15.9l-4.6 16.1c-3.8 13.2-3.7 27.3 .3 40.5l13.1 43.7c7.1 23.7 28.9 39.9 53.6 39.9l29.2 0c37.5 0 64.4-36.2 53.6-72.1l-8.3-27.7c-.5-1.8-.4-3.7 .3-5.4l9.8-22.8 73.9 0 13.5 81.2c4.5 27 27.9 46.8 55.2 46.8l31.1 0c34.6 0 60.9-31.1 55.2-65.2L430.2 299.3c28.6-19.1 64.3-36.8 103.4-45.6l19.6 31.4c3.1 5 10.4 5 13.6 0l27.8-44.5c8.1-3.8 15.7-9 22.4-15.7l2.6-2.6c13.1-13.1 20.4-30.8 20.4-49.3c0-27.1-15.7-51.7-40.2-63.1L534.2 79.4C512.6 69.2 488.9 64 465 64c-25.4 0-50.5 5.9-73.2 17.3l-2.5 1.2C371.6 91.4 352 96 332.2 96L128 96C57.3 96 0 153.3 0 224L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-4.1z',
  ],
};
const faH4 = {
  prefix: 'far',
  iconName: 'h4',
  icon: [
    640,
    512,
    [],
    'f86a',
    'M455.5 92.9L421.5 256 592 256l0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-200 0c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24l0 136 224 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152L48 272l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 248 0 88C0 74.7 10.7 64 24 64z',
  ],
};
const faStoreSlash = {
  prefix: 'far',
  iconName: 'store-slash',
  icon: [
    640,
    512,
    [],
    'e071',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68 0-17.1 0-48 0-83.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6l0 81.6-35 0L301.2 210.7c1.9-1.2 3.7-2.4 5.5-3.7c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0L141.6 0c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm94.1 73.7L152.4 48l335.2 0 51.5 81.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-6.9 7.6-16.5 12.5-27.5 13.1L132.9 78.9zm-84 55.7c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5zM365.5 384l-60.9-48L144 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 336l0 48 0 64c0 35.3 28.7 64 64 64l320 0c12.9 0 24.8-3.8 34.9-10.3L467.1 464 160 464c-8.8 0-16-7.2-16-16l0-64 221.5 0z',
  ],
};
const faRoadCircleXmark = {
  prefix: 'far',
  iconName: 'road-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e566',
    'M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z',
  ],
};
const faSignalSlash = {
  prefix: 'far',
  iconName: 'signal-slash',
  icon: [
    640,
    512,
    [],
    'f695',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445l0-421c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 383.3-80-62.7L472 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 187-80-62.7 0-28.3c0-13.3-10.7-24-24-24c-10.4 0-19.2 6.6-22.6 15.8L38.8 5.1zM576 512l-.2 0 .5 0-.2 0zM472 488l0-20.1-48-37.8 0 57.9c0 13.3 10.7 24 24 24s24-10.7 24-24zM344 367l-48-37.8L296 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-121zM192 288c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24zM64 384c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z',
  ],
};
const faUserMinus = {
  prefix: 'far',
  iconName: 'user-minus',
  icon: [
    640,
    512,
    [],
    'f503',
    'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM472 200c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faMarsStrokeUp = {
  prefix: 'far',
  iconName: 'mars-stroke-up',
  icon: [
    320,
    512,
    [9896, 'mars-stroke-v'],
    'f22a',
    'M175.6 5.8c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.4-14 0 51.8-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2l0-17.8 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-51.8 16.4 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224z',
  ],
};
const faMarsStrokeV = faMarsStrokeUp;
const faChampagneGlasses = {
  prefix: 'far',
  iconName: 'champagne-glasses',
  icon: [
    640,
    512,
    [129346, 'glass-cheers'],
    'f79f',
    'M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6zM119.8 186.4c-22.4 41.5-2.8 93.3 41.6 109.4c41.3 15 86.5-9.4 96.5-52.3l8.1-34.7L133.7 160.7l-13.9 25.7zM448.4 53.6L346.5 90.7l16.5 71L483.2 118 448.4 53.6zm71.7 132.7l-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3c44.3-16.1 64-67.9 41.6-109.4z',
  ],
};
const faGlassCheers = faChampagneGlasses;
const faTaco = {
  prefix: 'far',
  iconName: 'taco',
  icon: [
    512,
    512,
    [127790],
    'f826',
    'M274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7l17.1 47.7C70.9 209.2 157.7 160 256 160s185.1 49.2 237.1 124.4l17.1-47.7c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4zM256 240c109.5 0 199.2 84.6 207.4 192L48.6 432C56.8 324.6 146.5 240 256 240zM32 480l448 0c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zM168 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faHexagonPlus = {
  prefix: 'far',
  iconName: 'hexagon-plus',
  icon: [
    512,
    512,
    ['plus-hexagon'],
    'f300',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faPlusHexagon = faHexagonPlus;
const faClipboard = {
  prefix: 'far',
  iconName: 'clipboard',
  icon: [
    384,
    512,
    [128203],
    'f328',
    'M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faHouseCircleExclamation = {
  prefix: 'far',
  iconName: 'house-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e50a',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faFileArrowUp = {
  prefix: 'far',
  iconName: 'file-arrow-up',
  icon: [
    384,
    512,
    ['file-upload'],
    'f574',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 408l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L168 408c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faFileUpload = faFileArrowUp;
const faWifi = {
  prefix: 'far',
  iconName: 'wifi',
  icon: [
    640,
    512,
    ['wifi-3', 'wifi-strong'],
    'f1eb',
    'M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z',
  ],
};
const faWifi3 = faWifi;
const faWifiStrong = faWifi;
const faMessages = {
  prefix: 'far',
  iconName: 'messages',
  icon: [
    640,
    512,
    ['comments-alt'],
    'f4b6',
    'M48 72c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24l-128 0c-4.7 0-9.4 1.4-13.3 4L144 315.2l0-19.2c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24-10.7-24-24L48 72zM72 0C32.2 0 0 32.2 0 72L0 248c0 39.8 32.2 72 72 72l24 0 0 40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60L344 320c39.8 0 72-32.2 72-72l0-176c0-39.8-32.2-72-72-72L72 0zM256 376c0 39.8 32.2 72 72 72l88.7 0 90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488l0-40 24 0c39.8 0 72-32.2 72-72l0-176c0-39.8-32.2-72-72-72l-120 0 0 48 120 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24 10.7-24 24l0 19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4l-96 0c-13.3 0-24-10.7-24-24l0-24-48 0 0 24z',
  ],
};
const faCommentsAlt = faMessages;
const faBath = {
  prefix: 'far',
  iconName: 'bath',
  icon: [
    512,
    512,
    [128705, 'bathtub'],
    'f2cd',
    'M101.3 48C89.5 48 80 57.5 80 69.3L80 256l352 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 304l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1c23.9 0 45.4 10.5 60.1 27.2c9.2-5.3 21.1-4 28.9 3.9c9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0c-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336l48 0 0 32c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-32 48 0 0 32c0 28.4-12.4 54-32 71.6l0 48.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.3c-5.2 .9-10.5 1.3-16 1.3l-256 0c-5.5 0-10.8-.5-16-1.3l0 25.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48.4C44.4 422 32 396.4 32 368l0-32zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z',
  ],
};
const faBathtub = faBath;
const faUmbrellaSimple = {
  prefix: 'far',
  iconName: 'umbrella-simple',
  icon: [
    512,
    512,
    ['umbrella-alt'],
    'e2bc',
    'M256 0c13.3 0 24 10.7 24 24l0 9.1c119.6 11.1 215.3 104.5 230 223c2.2 17.5-12.4 31.9-30 31.9L32 288C14.3 288-.2 273.6 2 256.1C16.7 137.6 112.4 44.2 232 33.1l0-9.1c0-13.3 10.7-24 24-24zM458.4 240C436.8 148.3 354.3 80 256 80S75.2 148.3 53.6 240l404.9 0zM280 438.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4L232 320l48 0 0 118.6z',
  ],
};
const faUmbrellaAlt = faUmbrellaSimple;
const faRectangleHistoryCirclePlus = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-plus',
  icon: [
    640,
    512,
    [],
    'e4a3',
    'M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faUnderline = {
  prefix: 'far',
  iconName: 'underline',
  icon: [
    448,
    512,
    [],
    'f0cd',
    'M16 56c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 144c0 61.9 50.1 112 112 112s112-50.1 112-112l0-144-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 144c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 80 40 80C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24z',
  ],
};
const faPrescriptionBottlePill = {
  prefix: 'far',
  iconName: 'prescription-bottle-pill',
  icon: [
    576,
    512,
    [],
    'e5c0',
    'M48 48l288 0 0 32L48 80l0-32zM40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l304 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c11.6 0 22.4-3.1 31.8-8.4c-13.7-11.3-25.6-24.7-35.3-39.6L96 464c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-16-48 0zm320 0l-48 0 0 87.2c13.8-14.6 30-26.8 48-36l0-51.2zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM383 319c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faUserPen = {
  prefix: 'far',
  iconName: 'user-pen',
  icon: [
    640,
    512,
    ['user-edit'],
    'f4ff',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l277.2 0-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c48.1 0 91.8 19.1 123.9 50.1L359.6 388c-23.4-22.3-55.1-36-89.9-36l-91.4 0c-65.7 0-120.1 48.7-129 112zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faUserEdit = faUserPen;
const faBinarySlash = {
  prefix: 'far',
  iconName: 'binary-slash',
  icon: [
    640,
    512,
    [],
    'e33e',
    'M456 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C379 67 365.4 60.2 361.2 47.6S363.8 21.4 376.4 17.2l48-16C431.7-1.2 439.8 0 446 4.5S456 16.3 456 24zM232 312l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM128 72c0-39.8 32.2-72 72-72l48 0c39.8 0 72 32.2 72 72l0 80c0 21.6-9.5 41-24.6 54.2L399.7 288l40.3 0c39.8 0 72 32.2 72 72l0 16 118.8 93.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L128 75l0-3zm48 40.6l79.4 62.2C265 171.7 272 162.7 272 152l0-80c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 40.6zM320 360c0-3.8 .3-7.5 .9-11.2L368 385.9l0 54.1c0 13.3 10.7 24 24 24l48 0c6.9 0 13.1-2.9 17.5-7.6l37.8 29.7C482 502 462.2 512 440 512l-48 0c-39.8 0-72-32.2-72-72l0-80z',
  ],
};
const faSquareO = {
  prefix: 'far',
  iconName: 'square-o',
  icon: [
    448,
    512,
    [],
    'e278',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z',
  ],
};
const faCaduceus = {
  prefix: 'far',
  iconName: 'caduceus',
  icon: [
    512,
    512,
    [],
    'e681',
    'M280 89.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 12.6L183.4 73.9c-11.1-6.5-23.7-9.9-36.5-9.9c-18.2 0-35.7 6.9-49.1 19.2L11.3 163.1C4.1 169.7 0 179.1 0 188.9C0 208.3 15.7 224 35.1 224l111 0c30 0 59.5-7.3 85.9-21.3l0 127.7-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 40.8 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-40.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4l0-127.7c26.4 13.9 55.9 21.3 85.9 21.3l111 0c19.4 0 35.1-15.7 35.1-35.1c0-9.8-4.1-19.2-11.3-25.8L414.2 83.2C400.8 70.9 383.3 64 365.1 64c-12.8 0-25.4 3.4-36.5 9.9L280 102.2l0-12.6zM130.4 118.5c4.5-4.2 10.4-6.5 16.5-6.5c4.3 0 8.6 1.1 12.3 3.3l63.6 37.1-4.6 2.9c-21.6 13.5-46.6 20.7-72.1 20.7l-78.1 0 62.3-57.5zM365.1 112c6.1 0 12 2.3 16.5 6.5L443.9 176l-78.1 0c-25.5 0-50.5-7.2-72.1-20.7l-4.6-2.9 63.6-37.1c3.7-2.2 8-3.3 12.3-3.3z',
  ],
};
const faSignature = {
  prefix: 'far',
  iconName: 'signature',
  icon: [
    640,
    512,
    [],
    'f5b7',
    'M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm-3.8 169l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42zm216.8 48L616 416c13.3 0 24-10.7 24-24s-10.7-24-24-24l-311.9 0c-7 16.3-14.8 32.4-23.3 48z',
  ],
};
const faStroopwafel = {
  prefix: 'far',
  iconName: 'stroopwafel',
  icon: [
    512,
    512,
    [],
    'f551',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm97.6-45.3l22.6 22.6 45.3-45.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm90.5 0L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zM256 233.4l45.3-45.3L256 142.9l-45.3 45.3L256 233.4zM278.6 256l45.3 45.3L369.1 256l-45.3-45.3L278.6 256zM256 278.6l-45.3 45.3L256 369.1l45.3-45.3L256 278.6z',
  ],
};
const faBold = {
  prefix: 'far',
  iconName: 'bold',
  icon: [
    384,
    512,
    [],
    'f032',
    'M0 56C0 42.7 10.7 32 24 32l48 0 16 0 124 0c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124L88 480l-16 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-176L48 80 24 80C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76L96 80l0 152 116 0zM96 280l0 152 148 0c42 0 76-34 76-76s-34-76-76-76l-32 0L96 280z',
  ],
};
const faAnchorLock = {
  prefix: 'far',
  iconName: 'anchor-lock',
  icon: [
    640,
    512,
    [],
    'e4ad',
    'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c18.3 0 36.1-2.7 52.8-7.7c-3.1-7.5-4.8-15.7-4.8-24.3l0-24.7c-14.9 5.6-31.1 8.7-48 8.7l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faBuildingNgo = {
  prefix: 'far',
  iconName: 'building-ngo',
  icon: [
    384,
    512,
    [],
    'e4d7',
    'M320 48L64 48 2 48C9.1 20.4 34.2 0 64 0L320 0c29.8 0 54.9 20.4 62 48l-62 0zm16 192l48 0 0 208c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 240l48 0 0 208c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-208zM168 80l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-88c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM61.3 87.1l34.7 52L96 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8 64 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM88 264c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z',
  ],
};
const faTransporter3 = {
  prefix: 'far',
  iconName: 'transporter-3',
  icon: [
    512,
    512,
    [],
    'e045',
    'M480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zm56 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
  ],
};
const faEngineWarning = {
  prefix: 'far',
  iconName: 'engine-warning',
  icon: [
    640,
    512,
    ['engine-exclamation'],
    'f5f2',
    'M424 88c0 13.3-10.7 24-24 24l-72 0 0 32 68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-35.3 0-64-28.7-64-64l0-40-32 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 32 0 0-24c0-35.3 28.7-64 64-64l16 0 32 0 88 0 0-32-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c13.3 0 24 10.7 24 24zM210.3 354l32 40c3 3.8 7.6 6 12.5 6L448 400c8.8 0 16-7.2 16-16l0-141.7c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7L192 192l-32 0-16 0c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l28.8 0c14.6 0 28.4 6.6 37.5 18zM544 224c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192zM304 212c11 0 20 9 20 20l0 56c0 11-9 20-20 20s-20-9-20-20l0-56c0-11 9-20 20-20zM280 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faEngineExclamation = faEngineWarning;
const faCircleDownRight = {
  prefix: 'far',
  iconName: 'circle-down-right',
  icon: [
    512,
    512,
    [],
    'e108',
    'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3C210 146 205.1 144 200 144s-10 2-13.7 5.7l-36.7 36.7C146 190 144 194.9 144 200s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6L336 352c8.8 0 16-7.2 16-16l0-137.4z',
  ],
};
const faSquareK = {
  prefix: 'far',
  iconName: 'square-k',
  icon: [
    448,
    512,
    [],
    'e274',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm313.1 72.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L128 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z',
  ],
};
const faManatSign = {
  prefix: 'far',
  iconName: 'manat-sign',
  icon: [
    384,
    512,
    [],
    'e1d5',
    'M192 32c-13.3 0-24 10.7-24 24l0 41.5C73.3 109.3 0 190.1 0 288L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-71.4 51.9-130.6 120-142l0 310c0 13.3 10.7 24 24 24s24-10.7 24-24l0-310c68.1 11.4 120 70.7 120 142l0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-97.9-73.3-178.7-168-190.5L216 56c0-13.3-10.7-24-24-24z',
  ],
};
const faMoneyCheckPen = {
  prefix: 'far',
  iconName: 'money-check-pen',
  icon: [
    640,
    512,
    ['money-check-edit'],
    'f872',
    'M64 112l448 0c8.8 0 16 7.2 16 16l0 91.6 6.6-6.6c11.6-11.6 26.3-18.5 41.4-20.5l0-64.6c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l266.5 0 6-23.9c2.2-8.8 6.2-17 11.8-24.1L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16zm56 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zM96 200c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm517.8 35.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z',
  ],
};
const faMoneyCheckEdit = faMoneyCheckPen;
const faNotEqual = {
  prefix: 'far',
  iconName: 'not-equal',
  icon: [
    448,
    512,
    [],
    'f53e',
    'M373.5 36.2c11 7.5 13.8 22.4 6.3 33.3L329.2 144l78.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-111.5 0-87 128L408 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-231.1 0-69 101.5c-7.5 11-22.4 13.8-33.3 6.3s-13.8-22.4-6.4-33.3L118.8 368 40 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l111.5 0 87-128L40 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l231.1 0 69-101.5c7.5-11 22.4-13.8 33.3-6.4z',
  ],
};
const faBorderTopLeft = {
  prefix: 'far',
  iconName: 'border-top-left',
  icon: [
    448,
    512,
    ['border-style'],
    'f853',
    'M0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-352c0-13.3 10.7-24 24-24l352 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32C32.2 32 0 64.2 0 104L0 456zm128-40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faBorderStyle = faBorderTopLeft;
const faMapLocationDot = {
  prefix: 'far',
  iconName: 'map-location-dot',
  icon: [
    576,
    512,
    ['map-marked-alt'],
    'f5a0',
    'M408 120c0 8.6-1.8 18.3-5 28.6c-5.7 18.4-15.6 38.8-27.4 59.2l-.1 .2c-3.1 5.4-6.3 10.7-9.6 16c-4.4 7-8.9 14-13.5 20.8l-.4 .6c-18.1 26.9-36.7 51.1-49.2 66.6c-7.7 9.6-22 9.6-29.6 0c-12.4-15.5-31.1-39.7-49.2-66.6c-18.4-27.3-36.3-57.5-46.7-84.4c-.8-2.1-1.6-4.2-2.3-6.3c-4.4-12.6-7-24.4-7-34.6c0-4.7 .3-9.3 .8-13.8C175.6 46.4 226.4 0 288 0c66.3 0 120 53.7 120 120zM352 300.6c13.5-18.2 28.8-39.9 42.7-62.4c1.8-2.9 3.6-5.8 5.3-8.8l0 224.3 128-46.5 0-252.9L419.3 193.8c2.2-4.7 4.4-9.3 6.3-14c5.9-14 11-29.2 13.2-44.2l105-38.2c7.4-2.7 15.6-1.6 22 2.9s10.2 11.8 10.2 19.7l0 304c0 10.1-6.3 19.1-15.8 22.6l-176 64c-5.3 1.9-11.1 1.9-16.4 0L200 449.5l-167.8 61c-7.4 2.7-15.6 1.6-22-2.9S0 495.8 0 488L0 184c0-10.1 6.3-19.1 15.8-22.6L136 117.7c0 .8 0 1.5 0 2.3c0 15.1 3.7 30.7 8.9 45.6L48 200.8l0 252.9 128-46.5 0-177.7c1.8 3 3.5 5.9 5.3 8.8c13.9 22.5 29.1 44.2 42.7 62.4l0 106.6 128 46.5 0-153.1zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
  ],
};
const faMapMarkedAlt = faMapLocationDot;
const faTilde = {
  prefix: 'far',
  iconName: 'tilde',
  icon: [
    448,
    512,
    [63135],
    '7e',
    'M100.5 176c-29 0-52.5 23.5-52.5 52.5L48 320c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-91.5C0 173 45 128 100.5 128c29.6 0 57.6 13 76.7 35.6L307.4 317.4c10 11.8 24.6 18.6 40.1 18.6c29 0 52.5-23.5 52.5-52.5l0-91.5c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.5C448 339 403 384 347.5 384c-29.6 0-57.6-13-76.7-35.6L140.6 194.6c-10-11.8-24.6-18.6-40.1-18.6z',
  ],
};
const faJedi = {
  prefix: 'far',
  iconName: 'jedi',
  icon: [
    576,
    512,
    [],
    'f669',
    'M224.8 267.9L246 299.7c1.3 1.9 .2 4.5-2 4.9l-37.6 7.5c-3.7 .7-6.4 4-6.4 7.8s2.7 7.1 6.4 7.8l37.6 7.5c2.2 .4 3.3 3 2 4.9l-21.2 31.9c-2.1 3.2-1.7 7.4 1 10.1s6.9 3.1 10.1 1l26.9-17.9c2.2-1.4 5.1 .2 5 2.8l-2.1 61.7C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5c4.5-4.8 6.8-11.2 6.4-17.7s-3.3-12.6-8.3-16.9C177.2 185.4 160 150.7 160 112c0-26.9 8.3-51.9 22.5-72.5c6.4-9.3 5.5-21.7-2.2-30s-20-10-29.7-4.4C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272C560 139.9 505.9 52.4 425.4 5.2c-9.7-5.7-22.1-3.9-29.7 4.4s-8.6 20.7-2.2 30C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9c-4.9 4.3-7.9 10.4-8.3 16.9s2 12.9 6.4 17.7c18.8 20 30.2 46.9 30.2 76.5c0 54.2-38.5 99.4-89.7 109.8l-2.1-61.7c-.1-2.6 2.8-4.2 5-2.8l26.9 17.9c3.2 2.1 7.4 1.7 10.1-1s3.1-6.9 1-10.1L330 340.3c-1.3-1.9-.2-4.5 2-4.9l37.5-7.5c3.7-.7 6.4-4 6.4-7.8s-2.7-7.1-6.4-7.8L332 304.6c-2.2-.4-3.3-3-2-4.9l21.2-31.9c2.1-3.2 1.7-7.4-1-10.1s-6.9-3.1-10.1-1l-30 20c-2.1 1.4-4.9 0-5-2.6L296.3 8c-.1-4.5-3.8-8-8.3-8s-8.1 3.5-8.3 8l-8.9 266.2c-.1 2.5-2.9 3.9-5 2.6l-30-20c-3.2-2.1-7.4-1.7-10.1 1s-3.1 6.9-1 10.1zM64.1 233.5c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L76.5 165.9c8.3-23.7 20.5-45.6 35.8-64.9c-.2 3.6-.3 7.3-.3 11c0 44.9 16.8 85.8 44.4 116.9C138.5 254.8 128 286.2 128 320c0 44.5 18.1 84.7 47.4 113.7c-54.9-32-94.9-86.6-107.4-151l16.6 16.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L64.1 233.5zm447.8 0l-43.2 43.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151c29.3-29 47.4-69.2 47.4-113.7c0-33.8-10.5-65.2-28.4-91.1c27.6-31.1 44.4-72 44.4-116.9c0-3.7-.1-7.4-.3-11c15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z',
  ],
};
const faSquarePollVertical = {
  prefix: 'far',
  iconName: 'square-poll-vertical',
  icon: [
    448,
    512,
    ['poll'],
    'f681',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 224c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zm72-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zM320 288c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
  ],
};
const faPoll = faSquarePollVertical;
const faArrowDownSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-down-square-triangle',
  icon: [
    576,
    512,
    ['sort-shapes-down-alt'],
    'f889',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm481 78c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1zM368 80l96 0 0 96-96 0 0-96zm94.4 352l-92.8 0L416 354.6 462.4 432zM320 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faSortShapesDownAlt = faArrowDownSquareTriangle;
const faMugHot = {
  prefix: 'far',
  iconName: 'mug-hot',
  icon: [
    512,
    512,
    [9749],
    'f7b6',
    'M88 0c13.3 0 24 10.7 24 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24C64 10.7 74.7 0 88 0zM48 416c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-176L48 240l0 176zM0 224c0-17.7 14.3-32 32-32l320 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 224zM384 368l16 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-16 0 0 128zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faDogLeashed = {
  prefix: 'far',
  iconName: 'dog-leashed',
  icon: [
    576,
    512,
    [129454],
    'f6d4',
    'M69.6 8.6C78.2-1.6 93.3-2.9 103.4 5.6L292.6 164.5 313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32l76.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 32c0 53-43 96-96 96l-45.3 0L432 256l0 192c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-19.4 0-48.9c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2l0 48.9 0 19.4c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-224c0-1.3 .1-2.6 .2-3.8c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5c0 0 0 0 0 0l3.9 15.5C55.6 163.5 71.6 176 90 176l54 0 87.6 0L72.6 42.4C62.4 33.9 61.1 18.7 69.6 8.6zM318 342.2c11.4 9.1 18 22.9 18 37.4l0 68.4c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-173.2-96-48 0 104.8c10.8 0 21.4 3.7 30 10.6zm-78-6.4L240 224l-96 0-31.9 0-.1 .8L112 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c7 1.5 14.2 2.6 21.6 3zm94.2-139.5l55.3 27.6c6.7-18.8 24.6-31.9 45.2-31.9l45.3 0c26.5 0 48-21.5 48-48l0-32-32 0c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.7 4.4-2 8.5-3.8 12.4zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faCarBattery = {
  prefix: 'far',
  iconName: 'car-battery',
  icon: [
    512,
    512,
    ['battery-car'],
    'f5df',
    'M80 96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l16 0zM64 144c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L64 144zm304 32c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zM96 224l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faBatteryCar = faCarBattery;
const faFaceDowncastSweat = {
  prefix: 'far',
  iconName: 'face-downcast-sweat',
  icon: [
    512,
    512,
    [],
    'e371',
    'M35.2 126.3C14.9 120.8 0 102.7 0 81C0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0c9.5 12.6 27.1 37.2 36 57.5c.3 .7 .6 1.4 .9 2.1C94.2 69.7 96 76 96 81c0 26-21.5 47-48 47c-4.4 0-8.7-.6-12.8-1.7zm81.4-85.1C156.7 15.2 204.6 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8c8.6 3.1 17.8 4.8 27.4 4.8c8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208s-93.1-208-208-208c-48.7 0-93.4 16.7-128.9 44.7c.6-3.8 .9-7.7 .9-11.7c0-11.4-3.8-22.4-7.1-30.5c-1.3-3.1-2.7-6.2-4.3-9.3zM96 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm208-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM183.6 409.5c-9.7-9-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2z',
  ],
};
const faMailboxFlagUp = {
  prefix: 'far',
  iconName: 'mailbox-flag-up',
  icon: [
    576,
    512,
    [],
    'e5bb',
    'M376 224c-13.3 0-24-10.7-24-24l0-112 0-32c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-40 0 0 88c0 13.3-10.7 24-24 24zM144 112c-53 0-96 43-96 96l0 176c0 8.8 7.2 16 16 16l176 0 0-192c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96l0 192 224 0c8.8 0 16-7.2 16-16l0-176c0-34.9-18.7-65.5-46.6-82.3c9.1-9.9 14.6-23.2 14.6-37.7l0-9c47.4 23.6 80 72.5 80 129l0 176c0 35.3-28.7 64-64 64l-224 0-48 0L64 448c-35.3 0-64-28.7-64-64L0 208C0 128.5 64.5 64 144 64l176 0 0 24 0 24-68.7 0zM104 192l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMemoCircleInfo = {
  prefix: 'far',
  iconName: 'memo-circle-info',
  icon: [
    576,
    512,
    [],
    'e49a',
    'M320 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6c-17.2 4.9-33.4 12.3-48 21.8L336 64c0-8.8-7.2-16-16-16zM96 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm312-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faGift = {
  prefix: 'far',
  iconName: 'gift',
  icon: [
    512,
    512,
    [127873],
    'f06b',
    'M231.9 44.4C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40L48 128c-26.5 0-48 21.5-48 48l0 64c0 20.9 13.4 38.7 32 45.3l0 2.7 0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160 0-2.7c18.6-6.6 32-24.4 32-45.3l0-64c0-26.5-21.5-48-48-48l-25.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176l0 64-32 0-144 0 0-64 72 0 104 0zm-240 0l0 64L80 240l-32 0 0-64 104 0 72 0zm0 112l0 176L96 464c-8.8 0-16-7.2-16-16l0-160 144 0zm64 176l0-176 144 0 0 160c0 8.8-7.2 16-16 16l-128 0zm72-336l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0l-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8L225.3 128l-1.3 0z',
  ],
};
const faDiceTwo = {
  prefix: 'far',
  iconName: 'dice-two',
  icon: [
    448,
    512,
    [9857],
    'f528',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faVolume = {
  prefix: 'far',
  iconName: 'volume',
  icon: [
    576,
    512,
    [128265, 'volume-medium'],
    'f6a8',
    'M191.9 201.9L304 102.3l0 307.3L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160 88 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C352 45.3 338.7 32 322.2 32zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C466.1 312.9 480 286.1 480 256s-13.9-56.9-35.4-74.5z',
  ],
};
const faVolumeMedium = faVolume;
const faTransporter5 = {
  prefix: 'far',
  iconName: 'transporter-5',
  icon: [
    512,
    512,
    [],
    'e2a6',
    'M224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm-56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160 6.6 167.3C2.7 168.4 0 171.9 0 176s2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160zM472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6z',
  ],
};
const faGaugeCircleBolt = {
  prefix: 'far',
  iconName: 'gauge-circle-bolt',
  icon: [
    640,
    512,
    [],
    'e496',
    'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z',
  ],
};
const faCoinFront = {
  prefix: 'far',
  iconName: 'coin-front',
  icon: [
    512,
    512,
    [],
    'e3fc',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm24-248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z',
  ],
};
const faFileSlash = {
  prefix: 'far',
  iconName: 'file-slash',
  icon: [
    640,
    512,
    [],
    'e3a7',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-221.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM176 112.6L176 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 178.4L176 112.6zM448 464l-256 0c-8.8 0-16-7.2-16-16l0-213.3-48-37.8L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8l-37.7-29.7c-2.9 3.4-7.3 5.5-12.1 5.5z',
  ],
};
const faMessageArrowUpRight = {
  prefix: 'far',
  iconName: 'message-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e1dd',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM216 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z',
  ],
};
const faTreasureChest = {
  prefix: 'far',
  iconName: 'treasure-chest',
  icon: [
    576,
    512,
    [],
    'f723',
    'M160 80l256 0 0 160-64 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16-64 0 0-160zM48 160c0-38.7 27.5-71 64-78.4L112 240l-64 0 0-80zm0 272l0-144 64 0 0 144-64 0zM416 288l0 144-256 0 0-144 64 0 0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32 64 0zM528 432l-64 0 0-144 64 0 0 144zm0-272l0 80-64 0 0-158.4c36.5 7.4 64 39.7 64 78.4zM128 32C57.3 32 0 89.3 0 160L0 432c0 26.5 21.5 48 48 48l480 0c26.5 0 48-21.5 48-48l0-272c0-70.7-57.3-128-128-128L128 32zM304 256l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faChessQueen = {
  prefix: 'far',
  iconName: 'chess-queen',
  icon: [
    512,
    512,
    [9819],
    'f445',
    'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352l55.4 0-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352l55.4 0 93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432l245.6 0 16.6 32-278.7 0 16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z',
  ],
};
const faPaintbrushFine = {
  prefix: 'far',
  iconName: 'paintbrush-fine',
  icon: [
    576,
    512,
    ['paint-brush-alt', 'paint-brush-fine', 'paintbrush-alt'],
    'f5a9',
    'M489 57L306.2 239.7l30.1 30.1L519 87c8.3-8.3 8.3-21.8 0-30.1s-21.8-8.3-30.1 0zM210.5 325c-8.2-3.3-17.2-5-26.5-5c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9 85.6 0c39.8 0 72-32.2 72-72c0-9.4-1.8-18.3-5-26.5L210.5 325zm-6.2-51.3L455 23c27-27 70.9-27 97.9 0s27 70.9 0 97.9L302.3 371.7c1.1 6.6 1.7 13.4 1.7 20.3c0 66.3-53.7 120-120 120L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6 0c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c6.9 0 13.7 .6 20.3 1.7z',
  ],
};
const faPaintBrushAlt = faPaintbrushFine;
const faPaintBrushFine = faPaintbrushFine;
const faPaintbrushAlt = faPaintbrushFine;
const faGlasses = {
  prefix: 'far',
  iconName: 'glasses',
  icon: [
    576,
    512,
    [],
    'f530',
    'M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2c0 .5 0 1 0 1.5l0 41.3c0 .2 0 .4 0 .6l0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 35.3 28.7 64 64 64l44.3 0c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z',
  ],
};
const faHoodCloak = {
  prefix: 'far',
  iconName: 'hood-cloak',
  icon: [
    576,
    512,
    [],
    'f6ef',
    'M454.4 15.3c3 7.7 1.8 16.2-2.9 22.7c-1 1.3-2.1 2.6-3.3 3.7l-32 29c11.4 10.2 22.6 21.8 33.1 34.8C484.5 149.1 512 208.6 512 288c0 58.5 14.6 101.6 28.6 129.7c7 14.1 14 24.5 19 31.1c2.5 3.3 4.5 5.7 5.7 7.1c.6 .7 1.1 1.2 1.3 1.4l.1 .1s0 0 0 0s0 0 0 0s0 0 0 0c9 9.2 11.7 22.8 6.8 34.7c-5 12-16.6 19.8-29.6 19.8L32 512c-12.9 0-24.6-7.8-29.6-19.8c-4.9-11.9-2.2-25.6 6.8-34.7l.2-.2c.2-.2 .7-.7 1.3-1.4c1.3-1.4 3.2-3.8 5.7-7.1c5-6.6 11.9-17 19-31.1C49.4 389.6 64 346.5 64 288C64 151.8 111.4 76.9 167.7 37.7C222 0 278.2 0 288 0c0 0 0 0 0 0L432 0c9.9 0 18.8 6.1 22.4 15.3zm43.3 423.8c-17-34-33.7-84.4-33.7-151.2c0-86.7-38.5-144.2-79.9-181.5c-10.1-9.1-15.9-22-15.9-35.6c0-8.1 2-16 5.8-22.9l-86 0s0 0 0 0c-7.2 0-51 0-92.8 29.1C154.3 105.5 112 164 112 288c0 66.8-16.7 117.2-33.7 151.2c-4.8 9.6-9.6 17.9-14.1 24.8l95.8 0 0-128c0-70.7 57.3-128 128-128s128 57.3 128 128l0 128 95.8 0c-4.5-7-9.3-15.2-14.1-24.8zM208 464l160 0 0-128c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 128z',
  ],
};
const faSquareQuote = {
  prefix: 'far',
  iconName: 'square-quote',
  icon: [
    448,
    512,
    [],
    'e329',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 240l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3zm144 39.3l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71z',
  ],
};
const faUpLeft = {
  prefix: 'far',
  iconName: 'up-left',
  icon: [
    384,
    512,
    [],
    'e2bd',
    'M64 128l0 193.4c0 1.7 .8 3.2 2.1 4.2c2.1 1.6 5 1.4 6.9-.5L127 271c9.4-9.4 24.6-9.4 33.9 0L285.7 395.7c2.7 2.7 6.5 4.3 10.3 4.3s7.6-1.5 10.3-4.3l25.4-25.4c2.7-2.7 4.3-6.5 4.3-10.3s-1.5-7.6-4.3-10.3L207 225c-9.4-9.4-9.4-24.6 0-33.9L261.1 137c1.8-1.8 2.1-4.8 .5-6.9c-1-1.3-2.5-2.1-4.2-2.1L64 128zm-48-8c0-22.1 17.9-40 40-40l201.4 0c16.8 0 32.5 7.9 42.6 21.3c15.9 21.2 13.8 50.9-4.9 69.6L257.9 208 365.7 315.7C377.4 327.5 384 343.4 384 360s-6.6 32.5-18.3 44.3l-25.4 25.4C328.5 441.4 312.6 448 296 448s-32.5-6.6-44.3-18.3L144 321.9 106.9 359c-18.7 18.7-48.4 20.8-69.6 5C23.9 353.9 16 338.1 16 321.4L16 120z',
  ],
};
const faBringFront = {
  prefix: 'far',
  iconName: 'bring-front',
  icon: [
    640,
    512,
    [],
    'f857',
    'M64 48l128 0c8.8 0 16 7.2 16 16l48 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l64 0 0-48-64 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM448 512l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l-48 0c0 35.3 28.7 64 64 64zM224 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L224 96z',
  ],
};
const faChessBoard = {
  prefix: 'far',
  iconName: 'chess-board',
  icon: [
    448,
    512,
    [],
    'f43c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 0l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z',
  ],
};
const faBurgerCheese = {
  prefix: 'far',
  iconName: 'burger-cheese',
  icon: [
    512,
    512,
    [127828, 'cheeseburger'],
    'f7f1',
    'M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zM253.5 262.8l52.2 26.1c9 4.5 19.6 4.5 28.6 0l52.2-26.1c8.9-4.4 18.7-6.8 28.6-6.8l16.9 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 16.9 0c9.9 0 19.7 2.3 28.6 6.8z',
  ],
};
const faCheeseburger = faBurgerCheese;
const faBuildingCircleCheck = {
  prefix: 'far',
  iconName: 'building-circle-check',
  icon: [
    640,
    512,
    [],
    'e4d2',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faRepeat1 = {
  prefix: 'far',
  iconName: 'repeat-1',
  icon: [
    512,
    512,
    [128258],
    'f365',
    'M0 254.8C-.6 268 9.6 279.3 22.8 280s24.5-9.5 25.2-22.8l.4-8C52 176.8 111.7 120 184.2 120L304 120l0 36.4c0 19.6 15.9 35.6 35.6 35.6c8.8 0 17.3-3.3 23.8-9.1l76.7-69c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-76.7-69c-6.5-5.9-15-9.1-23.8-9.1C319.9 0 304 15.9 304 35.6L304 72 184.2 72C86.2 72 5.3 148.9 .4 246.8l-.4 8zM388.1 96L352 128.5l0-65L388.1 96zM512 257.2c.7-13.2-9.5-24.5-22.8-25.2s-24.5 9.5-25.2 22.8l-.4 8C460 335.2 400.3 392 327.8 392L208 392l0-36.4c0-19.6-15.9-35.6-35.6-35.6c-8.8 0-17.3 3.3-23.8 9.1l-76.7 69c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l76.7 69c6.5 5.9 15 9.1 23.8 9.1c19.6 0 35.6-15.9 35.6-35.6l0-36.4 119.8 0c98 0 178.9-76.9 183.8-174.8l.4-8zM123.9 416L160 383.5l0 65L123.9 416zM288 208c0-9.1-5.1-17.4-13.3-21.5s-17.9-3.2-25.1 2.3l-32 24c-10.6 8-12.8 23-4.8 33.6c6.5 8.6 17.6 11.6 27.2 8.2l0 49.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z',
  ],
};
const faArrowDownToLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-line',
  icon: [
    384,
    512,
    ['arrow-to-bottom'],
    'f33d',
    'M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 267.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 175.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z',
  ],
};
const faArrowToBottom = faArrowDownToLine;
const faGrid5 = {
  prefix: 'far',
  iconName: 'grid-5',
  icon: [
    448,
    512,
    [],
    'e199',
    'M0 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80L0 48zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
  ],
};
const faSwapArrows = {
  prefix: 'far',
  iconName: 'swap-arrows',
  icon: [
    640,
    512,
    [],
    'e60a',
    'M111 7c9.4-9.4 24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47L152 360c0 39.8 32.2 72 72 72s72-32.2 72-72l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 278.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L488 152c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-278.1L57 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L111 7z',
  ],
};
const faRightLongToLine = {
  prefix: 'far',
  iconName: 'right-long-to-line',
  icon: [
    640,
    512,
    [],
    'e444',
    'M640 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM505.5 272.4c8.7-9.2 8.7-23.7 0-32.9l-121.4-129c-8.8-9.3-21-14.6-33.7-14.6c-25.6 0-46.3 20.7-46.3 46.3l0 33.7L56 176c-30.9 0-56 25.1-56 56l0 48c0 30.9 25.1 56 56 56l248 0 0 33.7c0 25.6 20.7 46.3 46.3 46.3c12.8 0 25-5.3 33.7-14.6l121.4-129zM352 200l0-53.5L455 256 352 365.5l0-53.5c0-6.4-2.5-12.5-7-17s-10.6-7-17-7L56 288c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l272 0c13.3 0 24-10.7 24-24z',
  ],
};
const faPersonChalkboard = {
  prefix: 'far',
  iconName: 'person-chalkboard',
  icon: [
    640,
    512,
    [],
    'e53d',
    'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l29.8 0 0 128-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-312 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-80 224 0 0 224-224 0 0-48-48 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80-76.9 0-64.8 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 488c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faMarsStrokeRight = {
  prefix: 'far',
  iconName: 'mars-stroke-right',
  icon: [
    640,
    512,
    [9897, 'mars-stroke-h'],
    'f22b',
    'M80 256a128 128 0 1 1 256 0A128 128 0 1 1 80 256zm302.4-24C370.7 146.2 297.1 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152l33.6 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 78.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L464 232l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-33.6 0z',
  ],
};
const faMarsStrokeH = faMarsStrokeRight;
const faHandBackFist = {
  prefix: 'far',
  iconName: 'hand-back-fist',
  icon: [
    448,
    512,
    ['hand-rock'],
    'f255',
    'M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 104c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.8c38-20.1 64-60.1 64-106.2l0-104c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64l0 64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6l0 12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3L128 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128.1c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4l0-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6l0 32.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-65.7 0-14.3 0-64z',
  ],
};
const faHandRock = faHandBackFist;
const faGridRound5 = {
  prefix: 'far',
  iconName: 'grid-round-5',
  icon: [
    448,
    512,
    [],
    'e5de',
    'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
  ],
};
const faTally = {
  prefix: 'far',
  iconName: 'tally',
  icon: [
    640,
    512,
    ['tally-5'],
    'f69c',
    'M128 40c13.3 0 24 10.7 24 24l0 222.7L232 260l0-196c0-13.3 10.7-24 24-24s24 10.7 24 24l0 180 80-26.7L360 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 137.4 80-26.7L488 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 94.7 64.4-21.5c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4L536 209.3 536 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-222.7L408 252l0 196c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-180-80 26.7L280 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.4-80 26.7L152 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.7L39.6 374.8C27 379 13.4 372.2 9.2 359.6S11.8 333.4 24.4 329.2L104 302.7 104 64c0-13.3 10.7-24 24-24z',
  ],
};
const faTally5 = faTally;
const faSquareCaretUp = {
  prefix: 'far',
  iconName: 'square-caret-up',
  icon: [
    448,
    512,
    ['caret-square-up'],
    'f151',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z',
  ],
};
const faCaretSquareUp = faSquareCaretUp;
const faCloudShowersWater = {
  prefix: 'far',
  iconName: 'cloud-showers-water',
  icon: [
    576,
    512,
    [],
    'e4e4',
    'M184.1 107.8C186.3 74.4 214.1 48 248 48c23.4 0 43.9 12.6 55.1 31.5c3.4 5.7 9 9.8 15.5 11.2s13.3 .1 18.8-3.7c6.4-4.4 14.2-7 22.6-7c19.1 0 35.2 13.4 39.1 31.4c2.4 11 12.2 18.9 23.4 18.9l10.6 0c17 0 30.9 13.8 30.9 30.9s-13.8 30.9-30.9 30.9l-290.3 0c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9l17.3 0c12.7 0 23.1-9.8 24-22.5zM248 0c-51.6 0-95 34.9-108 82.3c-42.2 1.5-76 36.2-76 78.8c0 43.6 35.3 78.9 78.9 78.9l290.3 0c43.6 0 78.9-35.3 78.9-78.9c0-41.4-31.8-75.3-72.4-78.6C425.6 52.7 395.2 32 360 32c-10.1 0-19.9 1.7-28.9 4.9C310.6 14.3 281 0 248 0zM132.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm327.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM244.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm103.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faChartBar = {
  prefix: 'far',
  iconName: 'chart-bar',
  icon: [
    512,
    512,
    ['bar-chart'],
    'f080',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faBarChart = faChartBar;
const faHandsBubbles = {
  prefix: 'far',
  iconName: 'hands-bubbles',
  icon: [
    576,
    512,
    ['hands-wash'],
    'e05e',
    'M416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM528 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM48 143.8l0 84.6c0 39.8 16 77.3 43.4 104.7c-14.4 7.6-26.9 18.3-36.6 31.2C20.1 328.3 0 279.8 0 228.4l0-84.6c0-35.3 28.7-64 64-64c22.6 0 42.5 11.7 53.9 29.4L164.7 28C180.2 1.2 214.4-8 241.2 7.5c3.8 2.2 7.2 4.8 10.3 7.6c17.4-12.7 41.3-14.8 61.1-3.3s30 33.2 27.7 54.6c4 1.2 8 2.9 11.7 5.1c12.4 7.2 21.1 18.4 25.2 31c-21.4-8.7-46.2-9.1-69 1l-53 23.5 20.2-35c0 0 0 0 0-.1l16-27.7c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9l-8 13.8c0 0 0 0 0 .1l-8 13.9-31.5 54.5c-19.1 9.6-36.4 21.8-51.5 36.1c-9.8-7.1-12.9-20.7-6.7-31.4l48-83.1c0 0 0 0 0-.1c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9L124.8 193.2c-5.4 9.4-16.5 14-27 11.2S80 192.1 80 181.2l0-37.4c0-8.8-7.2-16-16-16s-16 7.2-16 16zM326.1 512c-31.3 0-60.7-7.9-86.4-21.8c8.4-13.8 13.9-29.5 15.7-46.4c20.5 12.8 44.7 20.1 70.7 20.1L456 464c4.4 0 8-3.6 8-8c0-4.4-3.5-7.9-7.9-8L392 448c-13.3 0-24-10.7-24-24s10.7-24 24-24l63.9 0 .2 0 31.9 0c4.4 0 8-3.6 8-8c0-4.4-3.5-8-7.9-8L392 384c-13.3 0-24-10.7-24-24s10.7-24 24-24l95.8 0 .2 0 32 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-15.8 0-.2 0-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l95.8 0 .2 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-152.1 0c-11.2 0-21-7.8-23.4-18.8s3-22.2 13.2-27l25.1-11.8c8-3.8 11.4-13.3 7.7-21.3s-13.3-11.4-21.3-7.7l-56.4 26.5c-27.6 13-50.1 33.5-65.5 58.4c-.2 .2-.3 .5-.5 .7c-14.6 21.7-22.8 47.6-22.8 74.8l0 .9c-14.5-6.9-30.7-10.7-47.7-10.8c1.8-33.2 12.6-64.6 30.4-91.3c20.2-32.4 49.6-59.2 85.7-76.1l56.4-26.5c32-15.1 70.1-1.3 85.2 30.7c7.9 16.8 7.9 35.3 1.4 51.3l84.7 0c30.9 0 56 25.1 56 56c0 4.4-.5 8.6-1.5 12.7c19.7 8.7 33.5 28.4 33.5 51.3s-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 22.9-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 30.9-25.1 56-56 56l-129.9 0z',
  ],
};
const faHandsWash = faHandsBubbles;
const faLessThanEqual = {
  prefix: 'far',
  iconName: 'less-than-equal',
  icon: [
    448,
    512,
    [],
    'f537',
    'M401 78.2c12.3-5 18.2-19 13.2-31.3s-19-18.2-31.3-13.2L47 169.8c-9.1 3.7-15 12.5-15 22.2s5.9 18.6 15 22.2l336 136c12.3 5 26.3-1 31.3-13.2s-1-26.3-13.2-31.3L120 192 401 78.2zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faTrain = {
  prefix: 'far',
  iconName: 'train',
  icon: [
    448,
    512,
    [128646],
    'f238',
    'M352 48c26.5 0 48 21.5 48 48l0 96L48 192l0-96c0-26.5 21.5-48 48-48l256 0zM48 352l0-112 352 0 0 112c0 26.5-21.5 48-48 48L96 400c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96L0 352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 188.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352l0-256c0-53-43-96-96-96L96 0zM224 360a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
  ],
};
const faUpFromDottedLine = {
  prefix: 'far',
  iconName: 'up-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e456',
    'M114.2 192L224 82 333.8 192 280 192c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 32c-11.5 0-22.5 4.6-30.6 12.7L77.6 160.8C68.9 169.5 64 181.3 64 193.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 44.7C246.5 36.6 235.5 32 224 32zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faEyeLowVision = {
  prefix: 'far',
  iconName: 'eye-low-vision',
  icon: [
    640,
    512,
    ['low-vision'],
    'f2a8',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2l-74-58c-36.7-11.8-68.5-32.9-95-57.5c-18.3-17-34-35.6-46.8-53.6L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z',
  ],
};
const faLowVision = faEyeLowVision;
const faTrafficLightGo = {
  prefix: 'far',
  iconName: 'traffic-light-go',
  icon: [
    320,
    512,
    [],
    'f638',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
  ],
};
const faFaceExhaling = {
  prefix: 'far',
  iconName: 'face-exhaling',
  icon: [
    576,
    512,
    [],
    'e480',
    'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 7-.3 13.9-1 20.7c11.6-8 25.6-12.7 40.8-12.7c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39C141.1 464 48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm95.6-172c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7zm409.2 96.2c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-20.7 0-37.7 15.8-39.7 35.9l-72.3 18.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9L416.1 412c-.1 1.3-.2 2.6-.2 4c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z',
  ],
};
const faSensorFire = {
  prefix: 'far',
  iconName: 'sensor-fire',
  icon: [
    640,
    512,
    [],
    'e02a',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 55.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l273.6 0c-12.7-14.3-23.4-30.5-31.5-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm265.7 56.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z',
  ],
};
const faUserUnlock = {
  prefix: 'far',
  iconName: 'user-unlock',
  icon: [
    640,
    512,
    [],
    'e058',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464L384 464l0 16c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 67.7C361.9 379.3 319 352 269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112zM496 272l0 48 16 0 48 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
  ],
};
const faHexagonDivide = {
  prefix: 'far',
  iconName: 'hexagon-divide',
  icon: [
    512,
    512,
    [],
    'e1ad',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const fa00 = {
  prefix: 'far',
  iconName: '00',
  icon: [
    640,
    512,
    [],
    'e467',
    'M144 32C64.5 32 0 96.5 0 176L0 336c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM48 176c0-53 43-96 96-96s96 43 96 96l0 160c0 53-43 96-96 96s-96-43-96-96l0-160zM496 32c-79.5 0-144 64.5-144 144l0 160c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM400 176c0-53 43-96 96-96s96 43 96 96l0 160c0 53-43 96-96 96s-96-43-96-96l0-160z',
  ],
};
const faCrow = {
  prefix: 'far',
  iconName: 'crow',
  icon: [
    640,
    512,
    [],
    'f520',
    'M39.2 442.6l72-58.6 148.1 0 46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384l40.9 0c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192l0-64 0-8 96-24c-9.4-37.6-43.2-64-82-64l-43 0C496.1 12.3 469.5 0 440 0C382.6 0 336 46.6 336 104l0 35.1L94.1 336 80.9 346.8l-72 58.6s0 0 0 0s0 0 0 0C-1.4 413.8-3 428.9 5.4 439.2s23.5 11.8 33.8 3.5c0 0 0 0 0 0zM195.4 315.4L333.1 203.4c-10.9 51.4-51 93.1-104 104.7l-33.7 7.4zM384 161.9s0 0 0 0l0-22.8 0-35.1c0-30.9 25.1-56 56-56s56 25.1 56 56l0 24 0 64c0 79.5-64.5 144-144 144l-62.5 0c57.1-31.8 94.5-92.7 94.5-160.8l0-13.3zM464 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCassetteBetamax = {
  prefix: 'far',
  iconName: 'cassette-betamax',
  icon: [
    576,
    512,
    ['betamax'],
    'f8a4',
    'M48 416l0-256 480 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM368 256l80 0 0 80-80 0 0-80zm-48-16l0 112c0 17.7 14.3 32 32 32l112 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32 14.3-32 32zm-136 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faBetamax = faCassetteBetamax;
const faSailboat = {
  prefix: 'far',
  iconName: 'sailboat',
  icon: [
    576,
    512,
    [],
    'e445',
    'M284.6 6.2c-4.2-5.4-11.4-7.5-17.8-5.3S256 9.2 256 16l0 288c0 8.8 7.2 16 16 16l224 0c6.1 0 11.7-3.5 14.4-9s2-12-1.7-16.9l-224-288zm-72 90.5c-6.7-2-14 .6-17.9 6.4l-128 192c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l128 0c8.8 0 16-7.2 16-16l0-192c0-7.1-4.6-13.3-11.4-15.3zM60 400l456 0-.4 1.6c-8.2 36.5-40.6 62.4-78 62.4l-299.2 0c-37.4 0-69.8-25.9-78-62.4L60 400zM20 352c-10.3 0-17.9 9.5-15.6 19.5l9.1 40.6c13.1 58.4 65 99.9 124.9 99.9l299.2 0c59.9 0 111.7-41.5 124.9-99.9l9.1-40.6c2.2-10-5.4-19.5-15.6-19.5L20 352z',
  ],
};
const faWindowRestore = {
  prefix: 'far',
  iconName: 'window-restore',
  icon: [
    512,
    512,
    [],
    'f2d2',
    'M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z',
  ],
};
const faNfcMagnifyingGlass = {
  prefix: 'far',
  iconName: 'nfc-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e1f9',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l269.7 0c20.2 20.6 46 35.8 74.8 43.1c-7.6 3.2-15.9 4.9-24.6 4.9L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 64c-16.7 0-32.8 2.6-48 7.3L400 96c0-8.8-7.2-16-16-16zm-16 72l0 29.4c-18.7 10.8-35.1 25.4-48 42.6l0-64-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM309.4 400L120 400c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 163.2 0c3.5 17.2 9.7 33.3 18.2 48zm138.6 .2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z',
  ],
};
const faFileBinary = {
  prefix: 'far',
  iconName: 'file-binary',
  icon: [
    384,
    512,
    [],
    'e175',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm64 240c-30.9 0-56 25.1-56 56l0 64c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56l0-64c0-30.9-25.1-56-56-56l-16 0zm-8 56c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 64c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-64zm120-56c-13.3 0-24 10.7-24 24s10.7 24 24 24l0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l0-104c0-13.3-10.7-24-24-24l-24 0z',
  ],
};
const faCircleV = {
  prefix: 'far',
  iconName: 'circle-v',
  icon: [
    512,
    512,
    [],
    'e12a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l104 208c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l104-208c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L256 322.3 173.5 157.3z',
  ],
};
const faSquarePlus = {
  prefix: 'far',
  iconName: 'square-plus',
  icon: [
    448,
    512,
    [61846, 'plus-square'],
    'f0fe',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faPlusSquare = faSquarePlus;
const faBowlScoops = {
  prefix: 'far',
  iconName: 'bowl-scoops',
  icon: [
    448,
    512,
    [127813],
    'e3df',
    'M224 208c0 5.4 .4 10.8 1.1 16l221.7 0c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16l191.7 0c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM173.8 368l-2.2 0L145 368c-41.4 0-77.2-26.3-90.5-64l339.1 0c-13.3 37.7-49.1 64-90.5 64l-26.7 0-2.2 0-100.3 0zm36.9 78.7L224 430.8l13.3 15.9L251.7 464l-55.4 0 14.4-17.3zm92.3 3.9L274.2 416l28.8 0c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3l28.8 0L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2l19.2 0 8.5 0 .6 0 135.4 0 .6 0 8.5 0 19.2 0c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z',
  ],
};
const faMistletoe = {
  prefix: 'far',
  iconName: 'mistletoe',
  icon: [
    576,
    512,
    [],
    'f7b4',
    'M288 0c13.3 0 24 10.7 24 24l0 62.1 98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7L312 153.9 312 288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8 0-134.1L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98L264 24c0-13.3 10.7-24 24-24zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27c30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1l9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27c0-30.9-22-57.5-52.4-63.4l-47.1-9.1zM249.6 387.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336l-38.4 51.2zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCustard = {
  prefix: 'far',
  iconName: 'custard',
  icon: [
    576,
    512,
    [127854],
    'e403',
    'M116.1 112.8L53.7 368l49.4 0 33.6-137.6c14.1-3.8 27.9-6.4 39.3-6.4c16.7 0 28.8 5.6 45.6 13.6l1 .5C238.9 246 259.8 256 288 256s49.1-10 65.4-17.9l1-.5c16.8-8.1 28.9-13.6 45.6-13.6c11.4 0 25.2 2.6 39.3 6.4L472.9 368l49.4 0L459.9 112.8c-7-28.6-32.7-48.8-62.2-48.8L178.2 64c-29.5 0-55.2 20.2-62.2 48.8zm310.5 65.6c-9-1.5-18-2.4-26.6-2.4c-28.2 0-49.1 10-65.4 17.9l-1 .5C316.8 202.4 304.7 208 288 208s-28.8-5.6-45.6-13.6l-1-.5C225.1 186 204.2 176 176 176c-8.6 0-17.6 .9-26.6 2.4l13.3-54.2c1.8-7.2 8.2-12.2 15.5-12.2l219.5 0c7.4 0 13.8 5 15.5 12.2l13.3 54.2zM0 424c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400c-13.3 0-24 10.7-24 24z',
  ],
};
const faLacrosseStick = {
  prefix: 'far',
  iconName: 'lacrosse-stick',
  icon: [
    512,
    512,
    [],
    'e3b5',
    'M261.5 107.5l-6.6 19.7c-6.3 18.9-16 36.5-28.6 51.9l-34.4 42c-10.3 12.6-15.9 28.3-15.9 44.5c0 38.8 31.5 70.3 70.3 70.3c16.2 0 32-5.6 44.5-15.9l42-34.4c15.4-12.6 33-22.3 51.9-28.6l19.7-6.6C440 238.7 464 205.4 464 168c0 0 0 0 0 0l0-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48l-.3 0s0 0 0 0c-37.4 0-70.7 24-82.5 59.5zM344 0s0 0 0 0l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3s0 0 0 0c0 58.1-37.2 109.7-92.3 128.1L400 302.6c-13.4 4.5-25.8 11.3-36.7 20.2l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-24 0-46.3-7.1-65-19.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L147.4 330.6c-12.3-18.6-19.4-41-19.4-65c0-27.3 9.5-53.8 26.7-74.9l34.4-42c8.9-10.9 15.8-23.3 20.2-36.7l6.6-19.7C234.3 37.2 285.9 0 344 0z',
  ],
};
const faHockeyMask = {
  prefix: 'far',
  iconName: 'hockey-mask',
  icon: [
    448,
    512,
    [],
    'f6ee',
    'M48 240c0-57.4 14.3-105.3 41.1-137.9C114.7 70.9 156.1 48 224 48s109.3 22.9 134.9 54.1C385.7 134.7 400 182.6 400 240c0 95.1-12.6 148.4-36 178.6C343.4 445.3 306 464 224 464s-119.4-18.7-140-45.4C60.6 388.4 48 335.1 48 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM200 208c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64zm112 64c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faSunrise = {
  prefix: 'far',
  iconName: 'sunrise',
  icon: [
    576,
    512,
    [127749],
    'f766',
    'M271 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L312 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L271 7zM393.3 225.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464l58.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l58.1 0L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464l36.7 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l36.7 0 43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48l124 0z',
  ],
};
const faSubtitles = {
  prefix: 'far',
  iconName: 'subtitles',
  icon: [
    576,
    512,
    [],
    'e60f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM120 240l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 336l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faPanelEws = {
  prefix: 'far',
  iconName: 'panel-ews',
  icon: [
    512,
    512,
    [],
    'e42e',
    'M64 48c-8.8 0-16 7.2-16 16l0 230.7C76.3 307 96 335.2 96 368l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-14.2-6.2-27-16-35.8L48 448c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 160l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z',
  ],
};
const faToriiGate = {
  prefix: 'far',
  iconName: 'torii-gate',
  icon: [
    512,
    512,
    [9961],
    'f6a1',
    'M48 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-47.5-1.6 .6C437.9 75 411.6 80 385.2 80L126.8 80c-26.5 0-52.7-5-77.2-14.9L48 64.5 48 112zM0 112L0 13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32l258.4 0c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4l0 98.6c0 35.3-28.7 64-64 64l0 64 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-200-144 0-144 0 0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-200-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-64c-35.3 0-64-28.7-64-64zM112 240l120 0 0-64-120 0 0 64zm168-64l0 64 120 0 0-64-120 0z',
  ],
};
const faCloudExclamation = {
  prefix: 'far',
  iconName: 'cloud-exclamation',
  icon: [
    640,
    512,
    [],
    'e491',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM320 144c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faMessageLines = {
  prefix: 'far',
  iconName: 'message-lines',
  icon: [
    512,
    512,
    ['comment-alt-lines'],
    'f4a6',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faCommentAltLines = faMessageLines;
const faFrog = {
  prefix: 'far',
  iconName: 'frog',
  icon: [
    576,
    512,
    [],
    'f52e',
    'M322.4 113c-5.9 17.8-21.6 30.6-40.2 32.7C150.4 160.5 48 272.3 48 408l0 16c0 4.4 3.6 8 8 8l182.1 0c.3-.3 .6-.7 .9-1l56.8-56.8c10.4-10.3 16.2-24.4 16.2-39c0-30.5-24.7-55.2-55.2-55.2c-14.6 0-28.7 5.8-39 16.2L169 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48.8-48.8c19.4-19.4 45.6-30.2 73-30.2c50.2 0 92 35.8 101.3 83.2c3-6.3 7.4-11.9 12.9-16.4c4.6-3.8 9.5-7.3 14.5-10.5l135.9-86.5c4.1-2.6 6.5-7.1 6.5-11.9c0-6.2-4-11.7-10-13.5l-70-21.5c-16.8-5.2-29.5-19.1-32.9-36.4C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33zM434.1 371.3l54 58.1c1.5 1.6 3.6 2.6 5.9 2.6l58 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-58 0c-15.6 0-30.4-6.5-41-17.9l-23.5-25.3-28.7-31-16.4-17.6-16.4-17.6L355.4 384l-20.3 21.8L310.9 432l48.6 0 .5 0c4.7 0 9.2 1.4 12.9 3.7C379.6 440 384 447.5 384 456c0 .8 0 1.5-.1 2.3C382.7 470.5 372.5 480 360 480l-49.1 0L56 480c-30.9 0-56-25.1-56-56l0-16C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66c46.5 0 85.3 33.1 94.1 77l70 21.5c26.1 8 43.9 32.1 43.9 59.4c0 21.2-10.9 41-28.8 52.4L442 309.3l-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.7 1.9c0 0 0 0 0 0l31 33.4zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faBucket = {
  prefix: 'far',
  iconName: 'bucket',
  icon: [
    448,
    512,
    [],
    'e4cf',
    'M96 152l0 8-48 0 0-8C48 68.1 116.1 0 200 0l48 0c83.9 0 152 68.1 152 152l0 8-48 0 0-8c0-57.4-46.6-104-104-104l-48 0C142.6 48 96 94.6 96 152zM0 216c0-13.3 10.7-24 24-24l48.4 0 303.3 0 48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-6 0L389.3 470c-3 24-23.4 42-47.6 42l-235.3 0c-24.2 0-44.6-18-47.6-42L30 240l-6 0c-13.3 0-24-10.7-24-24zm78.4 24l28 224 235.3 0 28-224L78.4 240z',
  ],
};
const faFloppyDiskPen = {
  prefix: 'far',
  iconName: 'floppy-disk-pen',
  icon: [
    576,
    512,
    [],
    'e182',
    'M48 96l0 320c0 8.8 7.2 16 16 16l206.5 0-12 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 65.1-48 48 0-113.1c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM128 80l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm389.8-84.2l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1L441.1 287.9l71 71L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faImage = {
  prefix: 'far',
  iconName: 'image',
  icon: [
    512,
    512,
    [],
    'f03e',
    'M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faWindowFrame = {
  prefix: 'far',
  iconName: 'window-frame',
  icon: [
    512,
    512,
    [129695],
    'e04f',
    'M80 464l152 0 0-192L80 272l0 192zm-48 0L32 64C32 28.7 60.7 0 96 0L416 0c35.3 0 64 28.7 64 64l0 400 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm400 0l0-192-152 0 0 192 152 0zM80 224l152 0 0-176L96 48c-8.8 0-16 7.2-16 16l0 160zm200 0l152 0 0-160c0-8.8-7.2-16-16-16L280 48l0 176z',
  ],
};
const faMicrophone = {
  prefix: 'far',
  iconName: 'microphone',
  icon: [
    384,
    512,
    [],
    'f130',
    'M240 96l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z',
  ],
};
const faCow = {
  prefix: 'far',
  iconName: 'cow',
  icon: [
    640,
    512,
    [128004],
    'f6c8',
    'M72 184c0-23 10.7-43.4 27.5-56.6C97.2 135.2 96 143.5 96 152l0 248c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-21.4c2.5 .6 5.2 1.2 8 1.7l0 11.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.1c2.6 .1 5.3 .1 8 .1s5.4 0 8-.1l0 8.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-11.6c2.8-.5 5.5-1.1 8-1.7l0 21.4c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-128.9 16 18 0 46.9c0 4.6 1.3 9 3.8 12.9l42.3 66.5C523 435.7 545.4 448 569.5 448c38.9 0 70.5-31.6 70.5-70.5l0-102.6c0-12.4-4.1-24.4-11.7-34.2l-4.3-5.6 0-67.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5-48.2-62.4C505.1 81.2 470 64 432.9 64L256 64l-72 0-40 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4C211.8 179.8 241.3 192 272 192s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6l50.5 0c22.3 0 43.3 10.3 57 28L590.3 270c1.1 1.4 1.7 3.1 1.7 4.9l0 102.6c0 12.4-10.1 22.5-22.5 22.5c-7.7 0-14.8-3.9-19-10.4L512 329l0-49c0-5.9-2.2-11.6-6.1-15.9l-64-72c-6.6-7.4-17.2-10-26.5-6.5S400 198 400 208l0 192-32 0 0-48 0-8 0-8c0-53-43-96-96-96s-96 43-96 96l0 8 0 8 0 48-32 0 0-248c0-14.5 7.7-27.1 19.2-34.1zm62.4 211.4l-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1 .4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faFileZip = {
  prefix: 'far',
  iconName: 'file-zip',
  icon: [
    512,
    512,
    [],
    'e5ee',
    'M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z',
  ],
};
const faSquareRing = {
  prefix: 'far',
  iconName: 'square-ring',
  icon: [
    448,
    512,
    [],
    'e44f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM304 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 256a128 128 0 1 1 256 0A128 128 0 1 1 96 256z',
  ],
};
const faDownFromLine = {
  prefix: 'far',
  iconName: 'down-from-line',
  icon: [
    384,
    512,
    ['arrow-alt-from-top'],
    'f349',
    'M82.2 320L192 430 301.8 320 248 320c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM192 480c-11.5 0-22.5-4.6-30.6-12.7L45.6 351.2C36.9 342.5 32 330.7 32 318.4C32 292.8 52.8 272 78.4 272l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 80C10.7 80 0 69.3 0 56S10.7 32 24 32l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80z',
  ],
};
const faArrowAltFromTop = faDownFromLine;
const faCaretUp = {
  prefix: 'far',
  iconName: 'caret-up',
  icon: [
    320,
    512,
    [],
    'f0d8',
    'M160 182.6L70.6 272l178.7 0L160 182.6zm-22.6-45.3c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 320c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z',
  ],
};
const faShieldXmark = {
  prefix: 'far',
  iconName: 'shield-xmark',
  icon: [
    512,
    512,
    ['shield-times'],
    'e24c',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faShieldTimes = faShieldXmark;
const faScrewdriver = {
  prefix: 'far',
  iconName: 'screwdriver',
  icon: [
    512,
    512,
    [129691],
    'f54a',
    'M445.9 55.9l10.2 10.2L396.2 144 368 144l0-28.2 77.9-59.9zM507 78.6c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 54.1-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192l54.1 0c7.5 0 14.5-3.5 19-9.4l80-104zM155.3 315.3c11.4-11.4 29.9-11.4 41.4 0s11.4 29.9 0 41.4L96 457.4 54.6 416 155.3 315.3zm75.3-33.9c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z',
  ],
};
const faCircleSortDown = {
  prefix: 'far',
  iconName: 'circle-sort-down',
  icon: [
    512,
    512,
    ['sort-circle-down'],
    'e031',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zm0-310.6c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM313.4 192l-114.7 0L256 134.6 313.4 192z',
  ],
};
const faSortCircleDown = faCircleSortDown;
const faFolderClosed = {
  prefix: 'far',
  iconName: 'folder-closed',
  icon: [
    512,
    512,
    [],
    'e185',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 32L48 192l0-96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240l416 0 0 176c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-176zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z',
  ],
};
const faHouseTsunami = {
  prefix: 'far',
  iconName: 'house-tsunami',
  icon: [
    576,
    512,
    [],
    'e515',
    'M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5c12.6 4.2 26.2-2.7 30.3-15.3s-2.7-26.2-15.3-30.3C256.4 3.8 233.4 0 209.4 0C95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8c12.7 3.4 26 5.2 39.7 5.2c.6 0 1.2 0 1.8-.1c1.8 0 3.6 .1 5.4 .1c.1 0 .3 0 .4 0c0 0 0 0 0 0c34.6 0 67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9c0 0 0 0 0 0c-.1 0-.3 0-.4 0c-12.9 0-25.2-1.4-36.7-4.2c-43.4-12.7-75-52.6-75-99.8c0-57.4 46.7-104 104.4-104c15.9 0 30.9 3.5 44.3 9.8c12 5.6 26.3 .4 31.9-11.6s.4-26.3-11.6-31.9C229.4 101.1 207.5 96 184.4 96C126.3 96 75.6 128.5 50 176.4zM368 286.8L368 152l79.9-60L527.5 152l.3 124.4c9.4 6.4 20.2 11.3 30.8 13.7c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.7 1 3.3 2 4.8 3.1c13.4 9.3 28.4 15.9 43.2 18.7zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faSquareNfi = {
  prefix: 'far',
  iconName: 'square-nfi',
  icon: [
    448,
    512,
    [],
    'e576',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 32 48 0 0-32c0-8.8 7.2-16 16-16zM48 384L0 384l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-32zm1-223c-10.1 3.1-17 12.4-17 23l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64.7 52 78c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64.7-52-78C70.1 161.9 59.2 158 49 161zm167 23l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24zm200 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z',
  ],
};
const faForklift = {
  prefix: 'far',
  iconName: 'forklift',
  icon: [
    640,
    512,
    [],
    'f47a',
    'M80 160l16 0L96 40c0-22.1 17.9-40 40-40L293 0c16.6 0 31.5 10.3 37.4 25.8l83 218.9c1.7 4.5 2.6 9.3 2.6 14.2l0 13.1 0 72.4c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96l-64 0c0 53-43 96-96 96s-96-43-96-96l0-48L0 240c0-44.2 35.8-80 80-80zm160 80l120.3 0L287.4 48 144 48l0 123.4L240 240zm0 48c-10 0-19.8-3.1-27.9-8.9L112.6 208 80 208c-17.7 0-32 14.3-32 32l0 92.8C62.1 324.7 78.5 320 96 320c35.5 0 66.6 19.3 83.2 48l89.7 0c16.6-28.7 47.6-48 83.2-48c5.5 0 10.8 .5 16 1.3l0-33.3-128 0zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 24l0 376 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faArrowUpFromGroundWater = {
  prefix: 'far',
  iconName: 'arrow-up-from-ground-water',
  icon: [
    576,
    512,
    [],
    'e4b5',
    'M288 352c13.3 0 24-10.7 24-24l0-246.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L305 7c-9.4-9.4-24.6-9.4-33.9 0L191 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L264 328c0 13.3 10.7 24 24 24zM80 430.1C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM192 192L64 192c-35.3 0-64 28.7-64 64L0 425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5L48 256c0-8.8 7.2-16 16-16l128 0 0-48zm384 64c0-35.3-28.7-64-64-64l-128 0 0 48 128 0c8.8 0 16 7.2 16 16l0 148.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9l0-169z',
  ],
};
const faBracketSquareRight = {
  prefix: 'far',
  iconName: 'bracket-square-right',
  icon: [
    192,
    512,
    [],
    '5d',
    'M192 88c0-30.9-25.1-56-56-56L72 32C58.7 32 48 42.7 48 56s10.7 24 24 24l64 0c4.4 0 8 3.6 8 8l0 336c0 4.4-3.6 8-8 8l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c30.9 0 56-25.1 56-56l0-336z',
  ],
};
const faMartiniGlass = {
  prefix: 'far',
  iconName: 'martini-glass',
  icon: [
    512,
    512,
    [127864, 'glass-martini-alt'],
    'f57b',
    'M35.3 0C15.8 0 0 15.8 0 35.3c0 9.4 3.7 18.3 10.3 25L232 281.9 232 464l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-182.1L501.7 60.3c6.6-6.6 10.3-15.6 10.3-25C512 15.8 496.2 0 476.7 0L35.3 0zM318.1 176L256 238.1 193.9 176l124.1 0zm48-48l-220.1 0-80-80 380.1 0-80 80z',
  ],
};
const faGlassMartiniAlt = faMartiniGlass;
const faSquareBinary = {
  prefix: 'far',
  iconName: 'square-binary',
  icon: [
    448,
    512,
    [],
    'e69b',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 76c-24.3 0-44 19.7-44 44l0 40c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44l-32 0zm-4 44c0-2.2 1.8-4 4-4l32 0c2.2 0 4 1.8 4 4l0 40c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-40zm140-44c-11 0-20 9-20 20c0 9.7 6.9 17.7 16 19.6l0 68.4c0 11 9 20 20 20s20-9 20-20l0-88c0-11-9-20-20-20l-16 0zM132 296c0 9.7 6.9 17.7 16 19.6l0 68.4c0 11 9 20 20 20s20-9 20-20l0-88c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zm96 24l0 40c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44l-32 0c-24.3 0-44 19.7-44 44zm44-4l32 0c2.2 0 4 1.8 4 4l0 40c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-40c0-2.2 1.8-4 4-4z',
  ],
};
const faRotateLeft = {
  prefix: 'far',
  iconName: 'rotate-left',
  icon: [
    512,
    512,
    ['rotate-back', 'rotate-backward', 'undo-alt'],
    'f2ea',
    'M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48C31.8 48 16 63.8 16 83.3L16 200c0 13.3 10.7 24 24 24l116.7 0c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L126.1 176 64 176l0-62.1z',
  ],
};
const faRotateBack = faRotateLeft;
const faRotateBackward = faRotateLeft;
const faUndoAlt = faRotateLeft;
const faTableColumns = {
  prefix: 'far',
  iconName: 'table-columns',
  icon: [
    512,
    512,
    ['columns'],
    'f0db',
    'M48 416l0-256 184 0 0 272L64 432c-8.8 0-16-7.2-16-16zm232 16l0-272 184 0 0 256c0 8.8-7.2 16-16 16l-168 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faColumns = faTableColumns;
const faSquareA = {
  prefix: 'far',
  iconName: 'square-a',
  icon: [
    448,
    512,
    [],
    'e25f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336l-130.3 0-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288l82.3 0L224 205.7z',
  ],
};
const faTick = {
  prefix: 'far',
  iconName: 'tick',
  icon: [
    192,
    512,
    [],
    'e32f',
    'M72 104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 1.9c0 1.4-.1 2.8-.4 4.3c0 0 0 0 0 0L96 252 72.4 110.1c-.2-1.4-.4-2.8-.4-4.3l0-1.9zm95 14c.7-4 1-8.1 1-12.1l0-1.9c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 1.9c0 4.1 .3 8.1 1 12.1L49.4 264.5C53.2 287.3 72.9 304 96 304s42.8-16.7 46.6-39.5L167 118z',
  ],
};
const faLemon = {
  prefix: 'far',
  iconName: 'lemon',
  icon: [
    448,
    512,
    [127819],
    'f094',
    'M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z',
  ],
};
const faHeadSideMask = {
  prefix: 'far',
  iconName: 'head-side-mask',
  icon: [
    576,
    512,
    [],
    'e063',
    'M80 224c0-8 .5-15.8 1.5-23.4L256 316.8l0 3.2 0 160c0 17.7 14.3 32 32 32l143.7 0c28.6 0 53.7-18.9 61.5-46.4L534.9 320l4.7-16.6c1.5-5.1 2.6-10.4 3.3-15.6c.7-3.1 1.1-6.2 1.1-9.5c0-.8 0-1.6-.1-2.3c0-1.3 .1-2.6 .1-3.9l-.5 0c-1.1-7.2-4.1-14.1-8.7-19.9l-18-22.5c-11.5-14.4-20.1-31.5-28-50.9c-3.7-8.9-7.1-18-10.6-27.5l-1-2.6c-3.9-10.3-7.9-21-12.4-31.6C435.6 48.3 367.5 0 288 0L256 0C132.3 0 32 100.3 32 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L96 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C94.8 304.8 80 266.2 80 224zm195.3 48L95.3 152C122.8 90.7 184.4 48 256 48l32 0c59.5 0 110.7 36.2 132.6 87.8c4 9.5 7.8 19.3 11.6 29.7l1 2.6s0 0 0 0c3.5 9.4 7.2 19.2 11.1 28.8c8.6 21.1 19.3 43.1 35 62.7l9.9 12.4L456 272l-.6 0L304 272l-28.7 0zM368 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm63.7 240L304 464l0-144 180.9 0-6.9 24L368 344c-8.8 0-16 7.2-16 16s7.2 16 16 16l100.9 0-9.1 32L368 408c-8.8 0-16 7.2-16 16s7.2 16 16 16l82.6 0-3.5 12.4c-2 6.9-8.2 11.6-15.4 11.6z',
  ],
};
const faHandshake = {
  prefix: 'far',
  iconName: 'handshake',
  icon: [
    640,
    512,
    [],
    'f2b5',
    'M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faGem = {
  prefix: 'far',
  iconName: 'gem',
  icon: [
    512,
    512,
    [128142],
    'f3a5',
    'M168.5 72L256 165l87.5-93-175 0zM383.9 99.1L311.5 176l129 0L383.9 99.1zm50 124.9L256 224 78.1 224 256 420.3 433.9 224zM71.5 176l129 0L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z',
  ],
};
const faDolly = {
  prefix: 'far',
  iconName: 'dolly',
  icon: [
    576,
    512,
    ['dolly-box'],
    'f472',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l80.8 0c3.5 0 6.5 2.2 7.6 5.5l91.9 281.6C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6c12.5-4.4 19.1-18.1 14.7-30.6s-18.1-19.1-30.6-14.7L335.8 362.5C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L158 38.6C150.5 15.6 129 0 104.8 0L24 0zM256 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM457.4 117.3c-10.6-28.7-42.2-43.7-71.1-33.5L224.9 140.5l14.9 45.6 57.5-20.2 24.1 66.3c4.5 12.5 18.3 18.9 30.8 14.4s18.9-18.3 14.4-30.8L342.6 150l59.6-20.9c4.1-1.4 8.7 .7 10.2 4.8L467 282.5l45.3-15.9L457.4 117.3z',
  ],
};
const faDollyBox = faDolly;
const faSmoking = {
  prefix: 'far',
  iconName: 'smoking',
  icon: [
    640,
    512,
    [128684],
    'f48d',
    'M440 0c13.3 0 24 10.7 24 24l0 19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43l0-19c0-13.3 10.7-24 24-24zM616 288c-13.3 0-24-10.7-24-24l0-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8l0 19c0 13.3-10.7 24-24 24zm-56 88l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 464l208 0 0-64-208 0 0 64zM0 416c0-35.3 28.7-64 64-64l384 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L64 512c-35.3 0-64-28.7-64-64l0-32z',
  ],
};
const faMinimize = {
  prefix: 'far',
  iconName: 'minimize',
  icon: [
    512,
    512,
    ['compress-arrows-alt'],
    'f78c',
    'M7 7C-2.3 16.4-2.3 31.6 7 41l80 80L41.4 166.6c-6 6-9.4 14.1-9.4 22.6l0 2.7c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-2.7 0c-8.5 0-16.6 3.4-22.6 9.4L121 87 41 7C31.6-2.3 16.4-2.3 7 7zM505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L391 87 345.4 41.4c-6-6-14.1-9.4-22.6-9.4L320 32c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-2.7c0-8.5-3.4-16.6-9.4-22.6L425 121l80-80zM505 471l-80-80 45.7-45.7c6-6 9.4-14.1 9.4-22.6l0-2.7c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l2.7 0c8.5 0 16.6-3.4 22.6-9.4L391 425l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80 45.7 45.7c6 6 14.1 9.4 22.6 9.4l2.7 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L64 288c-17.7 0-32 14.3-32 32l0 2.7c0 8.5 3.4 16.6 9.4 22.6L87 391 7 471zM412.1 176L336 176l0-76.1L412.1 176zM336 412.1l0-76.1 76.1 0L336 412.1zM99.9 176L176 99.9l0 76.1-76.1 0zM176 412.1L99.9 336l76.1 0 0 76.1z',
  ],
};
const faCompressArrowsAlt = faMinimize;
const faRefrigerator = {
  prefix: 'far',
  iconName: 'refrigerator',
  icon: [
    384,
    512,
    [],
    'e026',
    'M288 48c26.5 0 48 21.5 48 48l0 64-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L48 160l0-64c0-26.5 21.5-48 48-48l192 0zM240 208l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 48 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-240 192 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0z',
  ],
};
const faMonument = {
  prefix: 'far',
  iconName: 'monument',
  icon: [
    384,
    512,
    [],
    'f5a6',
    'M175 7c9.4-9.4 24.6-9.4 33.9 0l80 80c3.8 3.8 6.2 8.7 6.8 14l41.4 331-48.4 0L249.2 115.1 192 57.9l-57.2 57.2L95.2 432l-48.4 0L88.2 101c.7-5.3 3.1-10.2 6.8-14L175 7zM42.8 464l48.4 0 201.6 0 48.4 0 18.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0L64 512l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l18.8 0zM144 312c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faOctagonXmark = {
  prefix: 'far',
  iconName: 'octagon-xmark',
  icon: [
    512,
    512,
    ['times-octagon', 'xmark-octagon'],
    'f2f0',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faTimesOctagon = faOctagonXmark;
const faXmarkOctagon = faOctagonXmark;
const faAlignSlash = {
  prefix: 'far',
  iconName: 'align-slash',
  icon: [
    640,
    512,
    [],
    'f846',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344l48.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-110.1 0L307.9 216 520 216c13.3 0 24-10.7 24-24s-10.7-24-24-24l-273.4 0L144.6 88 520 88c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 40c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24l32.3 0zM314.8 344l-60.9-48L120 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l194.8 0zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l357.2 0-60.9-48L120 424z',
  ],
};
const faSnowplow = {
  prefix: 'far',
  iconName: 'snowplow',
  icon: [
    640,
    512,
    [],
    'f7d2',
    'M298.8 48c3.2 0 6.1 1.9 7.4 4.9L371.8 208l-152.3 0-56.8-71-2.7-3.4L160 48l138.8 0zM429 220.3c-.4-1.2-.9-2.4-1.4-3.6L350.4 34.2C341.6 13.5 321.3 0 298.8 0L152 0c-22.1 0-40 17.9-40 40l0 88-16 0c-26.5 0-48 21.5-48 48l0 132.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-20.4-5.5-39.5-15-56l47 0 0 56c0 6 2.2 11.7 6.2 16.1l80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 390.7l0-141.4 73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1l0 56-80 0 0-57.5 0-6.5c0-4.2-1.1-8.2-3-11.7zm-45 68.8c-5.2-.7-10.6-1.1-16-1.1l-256 0c-5.4 0-10.8 .4-16 1.1L96 176l36.5 0 56.8 71c4.6 5.7 11.4 9 18.7 9l176 0 0 33.1zM112 336l256 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faAnglesRight = {
  prefix: 'far',
  iconName: 'angles-right',
  icon: [
    512,
    512,
    [187, 'angle-double-right'],
    'f101',
    'M113 433L273 273c9.4-9.4 9.4-24.6 0-33.9L113 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L79 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm192 0L465 273c9.4-9.4 9.4-24.6 0-33.9L305 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L271 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z',
  ],
};
const faAngleDoubleRight = faAnglesRight;
const faTruckRampCouch = {
  prefix: 'far',
  iconName: 'truck-ramp-couch',
  icon: [
    640,
    512,
    ['truck-couch'],
    'f4dd',
    'M352 88c0-48.6 39.4-88 88-88L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 48c-22.1 0-40 17.9-40 40l0 272.7 25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8 352 88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2l0 125.5-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z',
  ],
};
const faTruckCouch = faTruckRampCouch;
const faCannabis = {
  prefix: 'far',
  iconName: 'cannabis',
  icon: [
    512,
    512,
    [],
    'f55f',
    'M275.9 10.6C271.5 4 264 0 256 0s-15.5 4-19.9 10.6c-16.1 24.1-36.5 67.2-49.2 115.1c-6.8 25.8-11.7 54.2-12 82.5c-15-10.3-30.7-19-45.9-26.4c-34.5-16.7-68.6-27-92.3-31.7c-7.9-1.6-16 .9-21.7 6.6s-8.1 13.8-6.5 21.7c6.9 34.4 26.5 93.6 62.3 143.2c-21.3 8.1-39.3 17.5-50.5 23.7C12.7 349.5 8 357.6 8 366.3s4.7 16.8 12.4 21c14.6 8.1 40.5 21.5 70.1 30.4c17.6 5.3 37.8 9.5 58.5 9.3l-5.8 23.2c-2.3 9.1 .9 18.7 8.2 24.5s17.3 7 25.7 2.8L232 450.2l0 37.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-37.8 54.9 27.3c8.4 4.2 18.4 3.1 25.7-2.8s10.5-15.5 8.2-24.5L363.1 427c20.6 .2 40.8-4 58.5-9.3c29.6-8.9 55.6-22.3 70.1-30.4c7.6-4.2 12.4-12.3 12.4-21s-4.7-16.8-12.4-21c-11.1-6.2-29.1-15.6-50.5-23.7C477 272.2 496.6 213 503.5 178.4c1.6-7.9-.9-16-6.5-21.7s-13.8-8.2-21.7-6.6c-23.7 4.7-57.7 15-92.3 31.7c-15.3 7.4-30.9 16.1-45.9 26.4c-.3-28.3-5.2-56.7-12-82.5c-12.6-47.9-33-91.1-49.2-115.1zM280 396.6l0-52.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 52.6-29.6 14.7 2-7.8c2.2-8.6-.6-17.6-7.1-23.6s-15.8-7.8-24.1-4.9c-19 6.7-43.3 4.3-68.7-3.3c-5.5-1.6-10.8-3.5-16-5.4c9.3-3.5 19.2-6.7 29.3-9c8.5-1.9 15.2-8.3 17.7-16.6s.3-17.3-5.8-23.5c-30.1-31-50.9-73.8-63.1-109.2c13.1 4.5 27.3 10.1 41.7 17.1C139 240 168.8 260 189.6 285c7.4 9 20.2 11.3 30.3 5.5s14.7-17.9 10.8-28.9c-12.4-34.8-8.9-79.8 2.6-123.7c6.2-23.5 14.4-45.4 22.7-63.6c8.3 18.2 16.5 40.2 22.7 63.6c11.6 43.8 15 88.8 2.6 123.7c-3.9 11 .6 23.1 10.8 28.9s22.9 3.4 30.3-5.5c20.8-25.1 50.6-45 81.5-59.9c14.3-6.9 28.6-12.6 41.7-17.1c-11.1 32-29.2 70.2-55 100.3c-2.6 3.1-5.3 6-8.1 8.9c-6 6.2-8.2 15.2-5.8 23.5s9.2 14.6 17.7 16.6c10.1 2.3 20 5.5 29.3 9c-5.2 2-10.5 3.8-16 5.4c-25.4 7.7-49.7 10-68.7 3.3c-8.3-2.9-17.6-1.1-24.1 4.9s-9.3 15-7.1 23.6l2 7.8L280 396.6z',
  ],
};
const faCirclePlay = {
  prefix: 'far',
  iconName: 'circle-play',
  icon: [
    512,
    512,
    [61469, 'play-circle'],
    'f144',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z',
  ],
};
const faPlayCircle = faCirclePlay;
const faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [
    512,
    512,
    [],
    'e0a0',
    'M295 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L344 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L295 183zM217 329c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 430.1 48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 488c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0L217 329z',
  ],
};
const faLocationArrowUp = {
  prefix: 'far',
  iconName: 'location-arrow-up',
  icon: [
    448,
    512,
    [],
    'e63a',
    'M224 98.5L87.2 420l122.1-95c8.7-6.7 20.8-6.7 29.5 0l122.1 95L224 98.5zM190.8 54c5.7-13.3 18.7-22 33.2-22s27.5 8.6 33.2 22L412.5 418.9c2.3 5.4 3.5 11.3 3.5 17.2l0 2.1c0 23.1-18.7 41.9-41.9 41.9c-9.3 0-18.4-3.1-25.7-8.8L224 374.4 99.6 471.2c-7.3 5.7-16.4 8.8-25.7 8.8C50.7 480 32 461.3 32 438.1l0-2.1c0-5.9 1.2-11.8 3.5-17.2L190.8 54z',
  ],
};
const faTablets = {
  prefix: 'far',
  iconName: 'tablets',
  icon: [
    640,
    512,
    [],
    'f490',
    'M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1L574.3 220.4c27.8-43.4 22.8-101.7-15.1-139.6zM540.4 254.3L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136zM160 240c-53.6 0-98.4 37.7-109.4 88l218.8 0c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88L50.6 376c11 50.3 55.8 88 109.4 88z',
  ],
};
const fa360Degrees = {
  prefix: 'far',
  iconName: '360-degrees',
  icon: [
    640,
    512,
    [],
    'e2dc',
    'M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l83.2 0L36 218.7c-4.9 7.4-5.4 16.8-1.2 24.6S47.1 256 56 256l32 0c30.9 0 56 25.1 56 56l0 40c0 26.5-21.5 48-48 48l-1.5 0c-16 0-31-8-39.9-21.4L44 362.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l10.6 15.9C32.5 432 62.4 448 94.5 448l1.5 0c53 0 96-43 96-96l0-40c0-53.3-40-97.2-91.6-103.3L172 101.3c4.9-7.4 5.4-16.8 1.2-24.6S160.9 64 152 64L24 64zm440 80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224zM576 368l0-224c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 160c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96l0 128 0 .2 0 79.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80c-11.4 0-22.2 2.4-32 6.7l0-38.7zm32 80c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z',
  ],
};
const faEthernet = {
  prefix: 'far',
  iconName: 'ethernet',
  icon: [
    512,
    512,
    [],
    'f796',
    'M128 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-80 0-96 0-96 0-96 0-80 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32l32 0 0-32zm48 16l0 40c0 13.3-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24l-40 0 0 160 40 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 40 0 0-160-40 0c-13.3 0-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24l0-40-160 0z',
  ],
};
const faEuroSign = {
  prefix: 'far',
  iconName: 'euro-sign',
  icon: [
    320,
    512,
    [8364, 'eur', 'euro'],
    'f153',
    'M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7 .6 16L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l33.3 0C84.8 412.5 170.5 480 272 480l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0c-74.6 0-138.4-46.4-164-112l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96.7 272c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16L264 240c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c25.6-65.6 89.4-112 164-112l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0C170.5 32 84.8 99.5 57.3 192L24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.6 0z',
  ],
};
const faEur = faEuroSign;
const faEuro = faEuroSign;
const faChair = {
  prefix: 'far',
  iconName: 'chair',
  icon: [
    448,
    512,
    [129681],
    'f6c0',
    'M248 48l-48 0 0 176-48 0 0-165.3c-23.9 13.8-40 39.7-40 69.3l0 96-48 0 0-96C64 57.3 121.3 0 192 0l64 0c70.7 0 128 57.3 128 128l0 96-48 0 0-96c0-29.6-16.1-55.5-40-69.3L296 224l-48 0 0-176zM67.1 304l-18 48 349.8 0-18-48L67.1 304zM22.1 287.1c7-18.7 24.9-31.1 44.9-31.1l313.8 0c20 0 37.9 12.4 44.9 31.1l19.2 51.3c1.9 5.1 2.9 10.5 2.9 16c0 20.4-13.5 37.7-32 43.5l0 90c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88L80 400l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-90c-18.5-5.8-32-23.1-32-43.5c0-5.5 1-10.9 2.9-16l19.2-51.3z',
  ],
};
const faCircleCheck = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    [61533, 'check-circle'],
    'f058',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z',
  ],
};
const faCheckCircle = faCircleCheck;
const faSquareDashedCirclePlus = {
  prefix: 'far',
  iconName: 'square-dashed-circle-plus',
  icon: [
    576,
    512,
    [],
    'e5c2',
    'M104 32L88 32C39.4 32 0 71.4 0 120l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1 17.9-40 40-40l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80zm24 56c-13.3 0-24 10.7-24 24l0 16c0 48.6 39.4 88 88 88l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-22.1 0-40-17.9-40-40l0-16c0-13.3-10.7-24-24-24zM424 192c13.3 0 24-10.7 24-24l0-48c0-48.6-39.4-88-88-88l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c22.1 0 40 17.9 40 40l0 48c0 13.3 10.7 24 24 24zM256 456c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24zm8-376c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faHandHoldingCircleDollar = {
  prefix: 'far',
  iconName: 'hand-holding-circle-dollar',
  icon: [
    576,
    512,
    [],
    'e621',
    'M128 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faMoneySimpleFromBracket = {
  prefix: 'far',
  iconName: 'money-simple-from-bracket',
  icon: [
    640,
    512,
    [],
    'e313',
    'M48 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L552 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88zm416 8l48 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352 48 0 0 352c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-352zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z',
  ],
};
const faBat = {
  prefix: 'far',
  iconName: 'bat',
  icon: [
    576,
    512,
    [],
    'f6b5',
    'M356.3 187.3c-13.3-6.8-22.7-19.3-25.4-33.9l-6.5-34.9c-11.1 6.2-23.6 9.5-36.4 9.5s-25.3-3.3-36.4-9.5l-6.5 34.9c-2.7 14.6-12.1 27.2-25.4 33.9s-28.9 7-42.4 .6l-68.7-32.7C70.1 202.4 48.7 261.3 48 322.3l13.3-6.6c29.9-15 66.3-4.4 83.5 24.3l8.7 14.6 7.6-7.6c27.3-27.3 72.4-24.4 96 6.2L288 393.3l30.8-40.1c23.6-30.6 68.7-33.6 96-6.2l7.6 7.6 8.7-14.6c17.2-28.7 53.6-39.3 83.5-24.3l13.3 6.6c-.6-61-22-120-60.6-167.2l-68.7 32.7c-13.5 6.4-29.1 6.2-42.4-.6zM576 346.3s0 0 0 0l0 2 0 28.5c0 10.6-11.2 17.5-20.6 12.8l-25.5-12.8L528 376s0 0 0 0l-34.7-17.4c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L48 376s0 0 0 0l-1.8 .9L20.7 389.7C11.2 394.4 0 387.5 0 376.9l0-28.5 0-2s0 0 0 0l0-21.1C0 249.6 27.1 176.4 76.3 119c11.6-13.6 30.9-17.7 47.1-10l29.7 14.1 44.8 21.3 9.2-48.8 6.8-36.2c1.3-6.7 7.1-11.5 13.9-11.5c2.8 0 5.5 .8 7.8 2.4l37.8 25.2c4.3 2.9 9.4 4.4 14.7 4.4s10.3-1.5 14.7-4.4l37.8-25.2c2.3-1.5 5-2.4 7.8-2.4c6.8 0 12.6 4.8 13.9 11.5l6.8 36.2 9.2 48.8 44.8-21.3L452.6 109c16.2-7.7 35.5-3.6 47.1 10C548.9 176.4 576 249.6 576 325.2l0 21.1z',
  ],
};
const faCircleStop = {
  prefix: 'far',
  iconName: 'circle-stop',
  icon: [
    512,
    512,
    [62094, 'stop-circle'],
    'f28d',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
  ],
};
const faStopCircle = faCircleStop;
const faHeadSideHeadphones = {
  prefix: 'far',
  iconName: 'head-side-headphones',
  icon: [
    512,
    512,
    [],
    'f8c2',
    'M184 52.6C106.1 70.7 48 140.5 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4l0 89.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0l24 0c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6l-.4 0 0 48c0 35.3-28.7 64-64 64l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24l88 0c8.8 0 16-7.2 16-16l0-72c0-13.3 10.7-24 24-24l24.4 0c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48l-16 0 0 50.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-53.6 37.7-98.4 88-109.4l0-46zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faPhoneRotary = {
  prefix: 'far',
  iconName: 'phone-rotary',
  icon: [
    512,
    512,
    [9742],
    'f8d3',
    'M0 176l0-34.7c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1l0 34.7c0 17.7-14.3 32-32 32l-42.3 0c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208L32 208c-17.7 0-32-14.3-32-32zM80 401l0 31 352 0 0-31c0-2.8-.7-5.5-2.1-7.9l-101.1-177c-2.8-5-8.2-8.1-13.9-8.1l-117.7 0c-5.7 0-11 3.1-13.9 8.1L82.1 393.1c-1.4 2.4-2.1 5.2-2.1 7.9zm61.6-208.7C153 172.3 174.2 160 197.1 160l117.7 0c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8l0 31c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177zM256 256a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faArrowUpToBracket = {
  prefix: 'far',
  iconName: 'arrow-up-to-bracket',
  icon: [
    448,
    512,
    [],
    'e66a',
    'M369 295L241 167c-9.4-9.4-24.6-9.4-33.9 0L79 295c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM48 168l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faCompassDrafting = {
  prefix: 'far',
  iconName: 'compass-drafting',
  icon: [
    512,
    512,
    ['drafting-compass'],
    'f568',
    'M304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L158.1 306.4C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L44.7 500.1c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9L92.6 323.4C60.4 300.2 33.4 270.4 13.5 236c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zM508.7 475.9c6.7 11.4 2.9 26.1-8.6 32.8s-26.1 2.9-32.8-8.6L394.4 375.7c14.4-7.1 28.2-15.4 41.2-24.6l73 124.8z',
  ],
};
const faDraftingCompass = faCompassDrafting;
const faPlateWheat = {
  prefix: 'far',
  iconName: 'plate-wheat',
  icon: [
    512,
    512,
    [],
    'e55a',
    'M176 32c-8.8 0-16 7.2-16 16l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80zM56 64C42.7 64 32 74.7 32 88s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 64zM24 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 136zm8 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM272 48l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 32c-8.8 0-16 7.2-16 16l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80zm80 160c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16zM352 176c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16zM130 423.7c-7.3-13.2-20.4-22.2-35.3-24.3C76 396.8 60.3 384.6 52.8 368l406.4 0c-7.5 16.6-23.2 28.8-41.9 31.5c-14.9 2.1-28 11.1-35.3 24.3c-2.8 5-8.1 8.3-14 8.3l-224 0c-6 0-11.2-3.2-14-8.3zM25.6 320C11.5 320 0 331.5 0 345.6C0 397.3 38.3 440 88 447c10.9 19.7 31.9 33 56 33l224 0c24.1 0 45.1-13.3 56-33c49.7-7 88-49.7 88-101.4c0-14.1-11.5-25.6-25.6-25.6L25.6 320z',
  ],
};
const faCalendarCircleMinus = {
  prefix: 'far',
  iconName: 'calendar-circle-minus',
  icon: [
    576,
    512,
    [],
    'e46f',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
  ],
};
const faChopsticks = {
  prefix: 'far',
  iconName: 'chopsticks',
  icon: [
    640,
    512,
    [],
    'e3f7',
    'M144.9 332.9L332.9 54.7c3.5-4.3 8.4-6.7 13.6-6.7c9.2 0 18.1 8 18.1 19.5c0 4.6-1.4 8.7-3.8 11.9L144.9 332.9zM346.5 0c-21.4 0-40.3 10.4-52.2 26.1l-.4 .5-.4 .6L7.4 450.7c-12 16.4-9.2 39.8 6.8 52.8C30.8 517 54.7 514 67.7 497.6L397.9 109.9l.4-.5 .4-.5c8.7-11.5 13.9-25.9 13.9-41.4C412.6 31 383.7 0 346.5 0zm-37 356.7L561.1 116.2c3.2-2.6 7.3-4.2 11.9-4.2c10.4 0 18.9 8.4 18.9 18.9c0 5.5-2.4 10.5-6.2 14L309.5 356.7zM573 64c-16.6 0-31.8 6.1-43.5 16.1l-.5 .4-.5 .4-381 364.2c-15.5 13.8-17.1 37.6-3.5 53.5s37.3 17.9 53.4 4.7L615.5 182.4l.5-.4 .5-.4c14.3-12.2 23.3-30.4 23.3-50.8C639.9 93.9 609.9 64 573 64z',
  ],
};
const faCarWrench = {
  prefix: 'far',
  iconName: 'car-wrench',
  icon: [
    512,
    512,
    ['car-mechanic'],
    'f5e3',
    'M468.9 104L456 104l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0 12.9 0 17.6 0c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3L163.8 48c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56l17.6 0L56 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0-12.9 0-17.6 0C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3l184.4 0c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6l-17.6 0zM185.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L365.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM368 320c26.5 0 48 21.5 48 48l0 32L96 400l0-32c0-26.5 21.5-48 48-48l224 0zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCarMechanic = faCarWrench;
const faIcicles = {
  prefix: 'far',
  iconName: 'icicles',
  icon: [
    512,
    512,
    [],
    'f7ad',
    'M5.2 9.1C9.7 3.4 16.7 0 24 0L488 0c6.9 0 13.5 3 18.1 8.2s6.6 12.2 5.7 19L448.9 483c-2.3 16.6-16.5 29-33.2 29c-15.8 0-29.4-11-32.8-26.4L332.6 256.5l-11.2 38.2c-4.4 15-18.1 25.2-33.7 25.2c-14.5 0-27.6-9-32.8-22.5l-9.4-24.6-20.2 84.9C221.5 373.1 207.8 384 192 384s-29.5-10.9-33.2-26.2l-20.2-84.9-9.5 24.8C123.9 311.1 111 320 96.6 320c-16.2 0-30.2-11.1-33.9-26.8L.6 29.5C-1 22.4 .6 14.8 5.2 9.1zM54.3 48L99.6 240.6l22-57.2c3.8-9.8 13.5-16 24-15.3s19.3 8.2 21.7 18.4L192 290l24.7-103.5c2.4-10.2 11.3-17.7 21.7-18.4s20.2 5.5 24 15.3L286 244.8 313 153.2c3.1-10.5 12.9-17.6 23.9-17.2s20.3 8.1 22.6 18.8l53 241.4L460.5 48 54.3 48z',
  ],
};
const faPersonShelter = {
  prefix: 'far',
  iconName: 'person-shelter',
  icon: [
    512,
    512,
    [],
    'e54f',
    'M268.1 3.3c-7.5-4.4-16.8-4.4-24.3 0l-232 136C4.5 143.6 0 151.5 0 160L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-314.2L256 51.8 464 173.8 464 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-328c0-8.5-4.5-16.4-11.9-20.7l-232-136zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 64.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 95.5-32 0 0-95.5zM240 416l32 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-159.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35L192 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72z',
  ],
};
const faNeuter = {
  prefix: 'far',
  iconName: 'neuter',
  icon: [
    384,
    512,
    [9906],
    'f22c',
    'M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-137.6z',
  ],
};
const faIdBadge = {
  prefix: 'far',
  iconName: 'id-badge',
  icon: [
    384,
    512,
    [],
    'f2c1',
    'M256 48l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16l-64 0zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faKazoo = {
  prefix: 'far',
  iconName: 'kazoo',
  icon: [
    640,
    512,
    [],
    'f8c7',
    'M560 256c0 29.6-8.9 57.1-24.2 80l40.2 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-40.2 0c15.3 22.9 24.2 50.4 24.2 80zm16 128l-94 0c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16l-108.2 0c-11.8 0-23.4-1.6-34.7-4.8c-39.3-11.1-136.7-38.7-184-52.5C9.4 322.7 0 310.2 0 296l0-80c0-14.2 9.4-26.7 23-30.7c47.3-13.8 144.7-41.4 184-52.5c11.3-3.2 23-4.8 34.7-4.8L350 128c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16l94 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64zM241.7 336l54.5 0c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80l-54.5 0c-7.4 0-14.6 1-21.7 3C183.7 189.3 97.9 213.6 48 228l0 56c49.9 14.5 135.7 38.7 172.1 49c7 2 14.3 3 21.7 3zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM398.1 209.9L416 227.7l17.9-17.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L444.3 256l17.9 17.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L416 284.3l-17.9 17.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L387.7 256l-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z',
  ],
};
const faMarker = {
  prefix: 'far',
  iconName: 'marker',
  icon: [
    512,
    512,
    [],
    'f5a1',
    'M336 113.9L225.9 224 288 286.1 447 127c17.1-17.1 17.1-44.9 0-62.1s-44.9-17.1-62.1 0l-15 15L336 113.9zm-144 144l-58.5 58.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L254.1 320 192 257.9zM232.4 23.7c27.9-18.4 65.9-15.4 90.5 9.2c0 0 0 0 0 0L336 46.1l15-15s0 0 0 0C386.9-4.8 445.1-4.8 481 31c35.9 35.9 35.9 94.1 0 129.9L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8l80-80L199 183l69.1-69.1 6.2-6.2L285.1 97l17-17L289 66.9s0 0 0 0c-9.4-9.4-24.6-9.3-33.9 0L169 153c-4.1 4.1-9.3 6.4-14.7 6.9c-6.9 .7-14-1.7-19.3-6.9c-9.4-9.4-9.4-24.6 0-33.9L221.1 33c3.5-3.5 7.3-6.6 11.3-9.2z',
  ],
};
const faBinBottles = {
  prefix: 'far',
  iconName: 'bin-bottles',
  icon: [
    640,
    512,
    [],
    'e5f5',
    'M152 0l80 0c13.3 0 24 10.7 24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192l32 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7l0-42.1c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 42.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5l32.9 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7l-369.7 0c-40.6 0-74.7-30.4-79.5-70.7L32 240l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm71.4 243.7c1.9 16.1 15.6 28.3 31.8 28.3l369.7 0c16.2 0 29.9-12.1 31.8-28.3l23-195.7L80.3 240l23 195.7z',
  ],
};
const faFaceLaughBeam = {
  prefix: 'far',
  iconName: 'face-laugh-beam',
  icon: [
    512,
    512,
    [128513, 'laugh-beam'],
    'f59a',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faLaughBeam = faFaceLaughBeam;
const faSquareArrowDownLeft = {
  prefix: 'far',
  iconName: 'square-arrow-down-left',
  icon: [
    448,
    512,
    [],
    'e261',
    'M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24l152 0z',
  ],
};
const faBatteryBolt = {
  prefix: 'far',
  iconName: 'battery-bolt',
  icon: [
    576,
    512,
    [],
    'f376',
    'M80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l92.2 0c-11.6-13-15.3-31.5-9.5-48L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l159.2 0 60-48L80 96zM464 368l-159.2 0-60 48L464 416c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80l-92.2 0c11.6 13 15.3 31.5 9.5 48l82.7 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z',
  ],
};
const faTreeLarge = {
  prefix: 'far',
  iconName: 'tree-large',
  icon: [
    448,
    512,
    [],
    'f7dd',
    'M224 0c7.4 0 14.4 3.4 18.9 9.3L381.2 186.9c5.6 7.2 6.6 17 2.6 25.3s-12.4 13.5-21.6 13.5l-16.5 0 67.2 100.6c4.9 7.4 5.4 16.8 1.2 24.6s-12.3 12.7-21.2 12.7l-24 0 74.9 111.1c5 7.4 5.5 16.9 1.3 24.7S432.9 512 424 512L24 512c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.3-24.7L79 363.5l-24 0c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.2-24.6l67.2-100.6-16.5 0c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L205.1 9.3C209.6 3.4 216.6 0 224 0zM134.9 177.6l12.3 0c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.2 24.6L99.9 315.5l24.2 0c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.3 24.7L69.1 464l309.7 0L303.9 352.9c-5-7.4-5.5-16.9-1.3-24.7s12.3-12.7 21.2-12.7l24.2 0L280.8 214.9c-4.9-7.4-5.4-16.8-1.2-24.6s12.3-12.7 21.2-12.7l12.3 0L224 63.1 134.9 177.6z',
  ],
};
const faHelicopterSymbol = {
  prefix: 'far',
  iconName: 'helicopter-symbol',
  icon: [
    512,
    512,
    [],
    'e502',
    'M461.6 224l48.5 0C495.6 108.2 403.8 16.4 288 2l0 48.5C377.3 64.2 447.8 134.7 461.6 224zM510 288l-48.5 0C447.8 377.3 377.3 447.8 288 461.6l0 48.5c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-48.5C134.7 447.8 64.2 377.3 50.4 288L2 288zm0-64l48.5 0C64.2 134.7 134.7 64.2 224 50.4L224 2C108.2 16.4 16.4 108.2 2 224zm190-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 128 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-128 0 0-72z',
  ],
};
const faAperture = {
  prefix: 'far',
  iconName: 'aperture',
  icon: [
    512,
    512,
    [],
    'e2df',
    'M256 464l67-116 13.8-23.8c0-.1 .1-.1 .1-.2l11.5-20 56.3 97.5C366.9 440.1 314.2 464 256 464zM163.6 208l-56.3-97.5C145.1 71.9 197.8 48 256 48L189 164l-13.9 24-11.5 20zm87.8-56l56.3-97.5c54.8 14 100.9 49.8 128.5 97.5l-134 0-27.5 0-.3 0-23.1 0zm104.1 68.3c-.1-.1-.1-.2-.2-.3l-11.5-20 112.6 0c5 17.8 7.6 36.6 7.6 56c0 37.9-10.1 73.4-27.8 104l-67-116-13.7-23.7zM48 256c0-37.9 10.1-73.4 27.8-104l67 116 25.4 44L55.6 312c-5-17.8-7.6-36.6-7.6-56zM204.3 457.5c-54.8-14-100.9-49.8-128.5-97.5l134 0 50.8 0-56.3 97.5zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216.7 212c4.3-7.4 12.1-11.9 20.6-12l37.3 0c8.5 .1 16.3 4.6 20.5 11.8l18.7 32.3c4.2 7.4 4.2 16.4 0 23.8l-.1 .1-18.5 32 0 .1c-4.3 7.4-12.2 11.9-20.7 11.9l-36.9 0c-8.6 0-16.5-4.6-20.8-12l-18.5-32c-4.3-7.4-4.3-16.6 0-24l18.5-32z',
  ],
};
const faUniversalAccess = {
  prefix: 'far',
  iconName: 'universal-access',
  icon: [
    512,
    512,
    [],
    'f29a',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1l11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3l0 50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6l0-50.1c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
  ],
};
const faGearComplex = {
  prefix: 'far',
  iconName: 'gear-complex',
  icon: [
    512,
    512,
    [],
    'e5e9',
    'M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm48 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM234.9 0c-22.2 0-41.5 15.2-46.7 36.7L180 71l-1.1 .4L148.9 53c-18.9-11.6-43.3-8.7-59 7L60.1 89.9c-15.7 15.7-18.6 40.1-7 59l18.4 30L71 180l-34.2 8.3C15.2 193.4 0 212.7 0 234.9l0 42.2c0 22.2 15.2 41.5 36.7 46.7L71 332l.4 1.1L53 363.1c-11.6 18.9-8.7 43.3 7 59l29.8 29.8c15.7 15.7 40.1 18.6 59 7l30-18.4 1.1 .4 8.3 34.2c5.2 21.6 24.5 36.7 46.7 36.7l42.2 0c22.2 0 41.5-15.2 46.7-36.7L332 441l1.1-.4 30 18.4c18.9 11.6 43.3 8.7 59-7l29.8-29.8c15.7-15.7 18.6-40.1 7-59l-18.4-30 .4-1.1 34.2-8.3c21.6-5.2 36.7-24.5 36.7-46.7l0-42.2c0-22.2-15.2-41.5-36.7-46.7L441 180l-.4-1.1 18.4-30c11.6-18.9 8.7-43.3-7-59L422.1 60.1c-15.7-15.7-40.1-18.6-59-7l-30 18.4L332 71l-8.3-34.2C318.6 15.2 299.3 0 277.1 0L234.9 0zm0 48l42.2 0 11.3 46.6c1.9 8 7.9 14.5 15.7 17.1c6.8 2.3 13.5 5 19.9 8.2c7.4 3.7 16.2 3.3 23.3-1l40.9-25L418 123.8l-25 40.9c-4.3 7.1-4.7 15.9-1 23.3c3.2 6.4 6 13 8.2 19.9c2.6 7.9 9.1 13.8 17.1 15.7L464 234.9l0 42.2-46.6 11.3c-8 1.9-14.5 7.9-17.1 15.7c-2.3 6.8-5 13.5-8.2 19.9c-3.7 7.4-3.3 16.2 1 23.3l25 40.9L388.2 418l-40.9-25c-7.1-4.3-15.9-4.7-23.3-1c-6.4 3.2-13 6-19.9 8.2c-7.9 2.6-13.8 9.1-15.7 17.1L277.1 464l-42.2 0-11.3-46.6c-1.9-8-7.9-14.5-15.7-17.1c-6.8-2.3-13.5-5-19.9-8.2c-7.4-3.7-16.2-3.3-23.3 1l-40.9 25L94 388.2l25-40.9c4.3-7.1 4.7-15.9 1-23.3c-3.2-6.4-6-13-8.2-19.9c-2.6-7.9-9.1-13.8-17.1-15.7L48 277.1l0-42.2 46.6-11.3c8-1.9 14.5-7.9 17.1-15.7c2.3-6.8 5-13.5 8.2-19.9c3.7-7.4 3.3-16.2-1-23.3L94 123.8 123.8 94l40.9 25c7.1 4.3 15.9 4.7 23.3 1c6.4-3.2 13-6 19.9-8.2c7.9-2.6 13.8-9.1 15.7-17.1L234.9 48z',
  ],
};
const faFileMagnifyingGlass = {
  prefix: 'far',
  iconName: 'file-magnifying-glass',
  icon: [
    384,
    512,
    ['file-search'],
    'f865',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM272 304c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faFileSearch = faFileMagnifyingGlass;
const faUpRight = {
  prefix: 'far',
  iconName: 'up-right',
  icon: [
    384,
    512,
    [],
    'e2be',
    'M320 128l0 193.4c0 1.7-.8 3.2-2.1 4.2c-2.1 1.6-5 1.4-6.9-.5L257 271c-9.4-9.4-24.6-9.4-33.9 0L98.3 395.7c-2.7 2.7-6.5 4.3-10.3 4.3s-7.6-1.5-10.3-4.3L52.3 370.3c-2.7-2.7-4.3-6.5-4.3-10.3s1.5-7.6 4.3-10.3L177 225c9.4-9.4 9.4-24.6 0-33.9L122.9 137c-1.8-1.8-2.1-4.8-.5-6.9c1-1.3 2.5-2.1 4.2-2.1L320 128zm48-8c0-22.1-17.9-40-40-40L126.6 80c-16.8 0-32.5 7.9-42.6 21.3c-15.9 21.2-13.8 50.9 4.9 69.6L126.1 208 18.3 315.7C6.6 327.5 0 343.4 0 360s6.6 32.5 18.3 44.3l25.4 25.4C55.5 441.4 71.4 448 88 448s32.5-6.6 44.3-18.3L240 321.9 277.1 359c18.7 18.7 48.4 20.8 69.6 5c13.4-10.1 21.3-25.8 21.3-42.6L368 120z',
  ],
};
const faCircleChevronUp = {
  prefix: 'far',
  iconName: 'circle-chevron-up',
  icon: [
    512,
    512,
    ['chevron-circle-up'],
    'f139',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271L273 167c-9.4-9.4-24.6-9.4-33.9 0L135 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z',
  ],
};
const faChevronCircleUp = faCircleChevronUp;
const faUserPolice = {
  prefix: 'far',
  iconName: 'user-police',
  icon: [
    448,
    512,
    [],
    'e333',
    'M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm20.6 209.8l65.2 57.1c2.1 1.9 4.3 3.6 6.6 5.1L50.9 464c8.4-31.2 33.8-55.5 65.7-62.2zM358.4 464l4.7-3.4c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5L315 446.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l4.7 3.4-38.1 0c2.3-1.5 4.5-3.2 6.6-5.1l65.2-57.1c31.9 6.7 57.3 30.9 65.7 62.2l-38.6 0zM137.2 356.1c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7z',
  ],
};
const faLariSign = {
  prefix: 'far',
  iconName: 'lari-sign',
  icon: [
    384,
    512,
    [],
    'e1c8',
    'M144 32c13.3 0 24 10.7 24 24l0 41.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5L216 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54c58.9 23.8 103.2 76 116.2 139.7c2.6 13-5.8 25.7-18.7 28.3s-25.7-5.8-28.3-18.7c-8.3-41-34-75.6-69.1-95.9L264 264c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118c-7.8-1.3-15.8-2-24-2s-16.2 .7-24 2l0 118c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-100.7C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144l168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-168 0L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l41 0C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178l0-54c0-13.3 10.7-24 24-24z',
  ],
};
const faVolcano = {
  prefix: 'far',
  iconName: 'volcano',
  icon: [
    512,
    512,
    [127755],
    'f770',
    'M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM48 459.8c0 2.3 1.9 4.2 4.2 4.2l407.7 0c2.3 0 4.2-1.9 4.2-4.2c0-1-.4-2-1.1-2.8L361.3 342.7l-15 15c-6.6 6.6-15.5 10.3-24.8 10.3c-11 0-21.4-5.2-28-14l-18-24c-12.3-16.4-31.5-26-52-26c-15.2 0-29.9 5.3-41.6 15.1l-39.4 32.8L49.1 457.1c-.7 .8-1.1 1.7-1.1 2.8zM163.4 256.2c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z',
  ],
};
const faTeddyBear = {
  prefix: 'far',
  iconName: 'teddy-bear',
  icon: [
    576,
    512,
    [],
    'e3cf',
    'M144 80c0-17.7 14.3-32 32-32c14 0 25.9 9 30.3 21.5c4 11.5 15.9 18.2 27.8 15.6c16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1c11.9 2.6 23.8-4.1 27.8-15.6C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32c0 11.5-6.1 21.7-15.4 27.3c-9 5.5-13.3 16.2-10.8 26.4c1.3 5.3 2.1 11.3 2.1 18.3c0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9 .8-13 2.1-18.3c2.6-10.2-1.8-20.9-10.8-26.4C150.1 101.7 144 91.5 144 80zM176 0C131.8 0 96 35.8 96 80c0 22.8 9.5 43.3 24.7 57.9c-.4 3.4-.6 6.8-.7 10.3c-25.2-16.9-59.5-16.5-84.6 3.3c-31.2 24.6-36.6 69.9-12 101.1l25.8 32.7c5.5 6.9 11.2 13.6 17.1 19.9C28.6 311.7 0 344.5 0 384c0 3.9 .3 7.7 .8 11.4c.1 .8 .3 1.5 .4 2.3l13 53.3c8 33 35.8 56.9 68.9 60.6c1.6 .3 3.2 .5 4.8 .5l4 0 28 0 336 0 28 0 4 0c1.6 0 3.3-.2 4.8-.5c33.1-3.6 60.9-27.6 68.9-60.6l13-53.3c.2-.8 .3-1.5 .4-2.3c.5-3.7 .8-7.5 .8-11.4c0-39.5-28.6-72.3-66.3-78.8c5.9-6.3 11.6-13 17.1-19.9l25.8-32.7c24.6-31.2 19.2-76.5-12-101.1c-25.1-19.8-59.4-20.2-84.6-3.3c-.1-3.5-.3-6.9-.7-10.3C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80c-27.5 0-51.8 13.9-66.1 35c-14.7-2.1-30.2-3-45.9-3s-31.1 .9-45.9 3C227.8 13.9 203.5 0 176 0zM92 464l-1.4 0c-.3 0-.6-.1-.9-.1c-13.8-1-25.5-10.7-28.8-24.3l-12.7-52c-.1-1.2-.2-2.4-.2-3.6c0-17.7 14.3-32 32-32c16.1 0 29.5 11.9 31.7 27.4c1.7 11.8 11.8 20.6 23.8 20.6l.6 0c13.3 0 24-10.7 24-24l0-43.5c0-8.1-4.1-15.7-11-20.1c-22.9-14.8-44-33.7-62.1-56.8L61.1 222.9c-8.2-10.4-6.4-25.5 4-33.7s25.5-6.4 33.7 4l25.8 32.7c83.3 105.7 243.5 105.7 326.8 0l25.8-32.7c8.2-10.4 23.3-12.2 33.7-4s12.2 23.3 4 33.7l-25.8 32.7c-18.1 23-39.2 41.9-62.1 56.8c-6.8 4.4-11 12-11 20.1l0 43.5c0 13.3 10.7 24 24 24l.6 0c11.9 0 22.1-8.8 23.8-20.6c2.2-15.5 15.6-27.4 31.7-27.4c17.7 0 32 14.3 32 32c0 1.2-.1 2.4-.2 3.6l-12.7 52c-3.3 13.6-15 23.4-28.8 24.3c-.3 0-.6 0-.9 .1l-1.4 0-28 0-80 0 0-48c0-44.2-35.8-80-80-80l-16 0c-44.2 0-80 35.8-80 80l0 48-80 0-28 0zm156 0l0-48c0-17.7 14.3-32 32-32l16 0c17.7 0 32 14.3 32 32l0 48-80 0zm8-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24s32-10.7 32-24z',
  ],
};
const faStocking = {
  prefix: 'far',
  iconName: 'stocking',
  icon: [
    384,
    512,
    [],
    'f7d5',
    'M96 0C78.3 0 64 14.3 64 32l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 0zm48 238.9L144 128l-48 0 0 110.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5L352 128l-48 0 0 187.5c0 26.7-13.4 51.7-35.6 66.6L164.3 451.4C152 459.6 137.6 464 122.8 464C81.5 464 48 430.5 48 389.2l0-2.2c0-25.8 12.9-49.8 34.3-64.1l26.1-17.4c22.3-14.8 35.6-39.8 35.6-66.6z',
  ],
};
const faPersonWalkingDashedLineArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [
    640,
    512,
    [],
    'e553',
    'M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80zM392 128c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-13.3-10.7-24-24-24zm24 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16zm-24 72c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24z',
  ],
};
const faImageSlash = {
  prefix: 'far',
  iconName: 'image-slash',
  icon: [
    640,
    512,
    [],
    'e1b7',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM134.4 80L512 80c8.8 0 16 7.2 16 16l0 292.5-53.4-41.9L387 233.3c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3l-7.2 9.3L256 175.3c-.4-26.2-21.7-47.3-48-47.3c-3.7 0-7.4 .4-10.8 1.2L134.4 80zm353 400L282.9 318.9 266 340.7l-30.5-42.7C231 291.7 223.8 288 216 288s-15 3.7-19.5 10.1l-80 112-4.5 6.3 0-.3 0-231.8L64 146.4 64 416c0 35.3 28.7 64 64 64l359.4 0z',
  ],
};
const faMaskSnorkel = {
  prefix: 'far',
  iconName: 'mask-snorkel',
  icon: [
    576,
    512,
    [],
    'e3b7',
    'M552 32c13.3 0 24 10.7 24 24l0 104-48 0 0-104c0-13.3 10.7-24 24-24zM528 376.6L528 192l48 0 0 184.6C576 451.4 515.4 512 440.6 512c-67.4 0-124.5-49.5-134-116.2l-2.3-16.4c-1.9-13.1 7.2-25.3 20.4-27.2s25.3 7.2 27.2 20.4l2.3 16.4c6.2 43.1 43 75 86.5 75c48.3 0 87.4-39.1 87.4-87.4zM64 112c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l79.7 0c7.1 0 13.4-4.7 15.4-11.6l3.4-11.7c17.7-61.9 105.4-61.9 123.1 0l3.4 11.7c2 6.9 8.2 11.6 15.4 11.6l79.7 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 112zM304.3 288c-22.3 0-42.4-11.5-54-29.6c-.7-1-1.3-2.1-1.9-3.2c-.3-.5-.6-1-.8-1.5c-2-3.8-3.6-7.8-4.8-12.1l-.6-2.2-2.7-9.6c-4.4-15.5-26.3-15.5-30.8 0l-2.7 9.6-.6 2.2c-1.2 4.2-2.8 8.3-4.8 12.1c-.3 .5-.5 1-.8 1.5c-.6 1.1-1.2 2.2-1.9 3.2c-11.5 18.1-31.7 29.6-54 29.6L64 288c-35.3 0-64-28.7-64-64l0-96C0 92.7 28.7 64 64 64l320 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-79.7 0z',
  ],
};
const faSmoke = {
  prefix: 'far',
  iconName: 'smoke',
  icon: [
    640,
    512,
    [],
    'f760',
    'M80 128c0-44.2 35.8-80 80-80c31.1 0 58 17.7 71.3 43.7c3.3 6.5 9.5 11.2 16.7 12.6s14.7-.5 20.2-5.3c14-11.9 32-19 51.8-19c24.3 0 46.1 10.8 60.7 27.9c4.9 2 9.7 4.3 14.4 6.8c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0C89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6c16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128zm512 96c0 27.5-13.8 51.7-34.9 66.1c12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.6 0-87.3 24.8-109.7 62c-22.2-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4c10.7 3.9 20.9 8.7 30.5 14.5c7.9-5 16.2-9.4 25-13C273.9 186.8 295.7 176 320 176c24.3 0 46.1 10.8 60.7 27.9c13.7 5.6 26.5 13.1 38 22.2c7.5-3 13.1-9.6 14.7-17.7c7.2-36.7 39.7-64.4 78.5-64.4c44.2 0 80 35.8 80 80zM48 368c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64l-320 0c-53 0-96-43-96-96zm96-144C64.5 224 0 288.5 0 368s64.5 144 144 144l320 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3C210.2 236.1 178.5 224 144 224z',
  ],
};
const faSterlingSign = {
  prefix: 'far',
  iconName: 'sterling-sign',
  icon: [
    320,
    512,
    [163, 'gbp', 'pound-sign'],
    'f154',
    'M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2L48 224l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 63.4c0 17.4-4.4 34.5-12.7 49.8L2.9 444.5c-4.1 7.4-3.9 16.5 .4 23.7S15.5 480 24 480l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64.4 432l13-23.9C89.6 385.8 96 360.8 96 335.4L96 272l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 224l0-64.8z',
  ],
};
const faGbp = faSterlingSign;
const faPoundSign = faSterlingSign;
const faBatteryExclamation = {
  prefix: 'far',
  iconName: 'battery-exclamation',
  icon: [
    576,
    512,
    [],
    'e0b0',
    'M208 96l0 48L80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l113.6 0c-1 5.2-1.6 10.5-1.6 16c0 11.4 2.4 22.2 6.7 32L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l128 0zM464 416l-118.7 0c4.3-9.8 6.7-20.6 6.7-32c0-5.5-.6-10.8-1.6-16L464 368c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-128 0 0-48 128 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faViruses = {
  prefix: 'far',
  iconName: 'viruses',
  icon: [
    640,
    512,
    [],
    'e076',
    'M327.8 293.8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 34 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3c0 0 0 0 0 0l9.5 9.5zM285.8 192c-17.9-17.2-28-41.6-27.5-66.4c-11.1 .2-22.1-1.7-32.4-5.5c-12.7-4.7-24.4-12.2-33.9-22c-17.2 17.9-41.6 28-66.4 27.5c.5 24.8-9.6 49.2-27.5 66.4c17.9 17.2 28 41.6 27.5 66.4c24.8-.5 49.2 9.6 66.4 27.5c17.2-17.9 41.6-28 66.4-27.5c-.5-24.8 9.6-49.2 27.5-66.4zM512 240c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM152 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm72 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faSquarePersonConfined = {
  prefix: 'far',
  iconName: 'square-person-confined',
  icon: [
    448,
    512,
    [],
    'e577',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM292 200c33.1 0 60 26.9 60 60l0 88c0 31.8-24.7 57.8-56 59.9l0 .1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L232 309l0-49c0-33.1 26.9-60 60-60zm-4.2 159.2c1.8 .3 3.7 .6 5.6 .7c6-.7 10.6-5.8 10.6-11.9l0-88c0-6.6-5.4-12-12-12s-12 5.4-12 12l0 88c0 5.2 3.2 9.5 7.8 11.2zM208 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faUserTie = {
  prefix: 'far',
  iconName: 'user-tie',
  icon: [
    448,
    512,
    [],
    'f508',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2 43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2zm-90.6 17.1C82.3 391.1 55.4 424.2 49.3 464l113 0-43.8-87.7zM285.7 464l113 0c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z',
  ],
};
const faUpToBracket = {
  prefix: 'far',
  iconName: 'up-to-bracket',
  icon: [
    448,
    512,
    [],
    'e66e',
    'M114.2 320L224 210 333.8 320 280 320c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 160c-11.5 0-22.5 4.6-30.6 12.7L77.6 288.8C68.9 297.5 64 309.3 64 321.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 172.7c-8.1-8.1-19.1-12.7-30.6-12.7zM48 168l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faArrowDownLong = {
  prefix: 'far',
  iconName: 'arrow-down-long',
  icon: [
    384,
    512,
    ['long-arrow-down'],
    'f175',
    'M175 505c9.4 9.4 24.6 9.4 33.9 0L345 369c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 406.1L73 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505z',
  ],
};
const faLongArrowDown = faArrowDownLong;
const faTentArrowDownToLine = {
  prefix: 'far',
  iconName: 'tent-arrow-down-to-line',
  icon: [
    640,
    512,
    [],
    'e57e',
    'M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zM369.3 133c8.6-6.7 20.7-6.7 29.4 0L565.2 261.7c10.7 8.3 18 20.1 20.7 33.3l33.9 169.3C631.2 466.1 640 476 640 488c0 13.3-10.7 24-24 24l-16 0-432 0L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l124.3 0 33.8-169c2.6-13.2 10-25.1 20.7-33.3L369.3 133zm-172 331L360 464l0-263.1L232.1 299.7c-1.5 1.2-2.6 2.9-3 4.8L197.3 464zM472 464l98.7 0L538.8 304.4c-.4-1.9-1.4-3.6-3-4.8L408 200.9 408 336l64 128z',
  ],
};
const faCertificate = {
  prefix: 'far',
  iconName: 'certificate',
  icon: [
    512,
    512,
    [],
    'f0a3',
    'M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zM222.5 19.1L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-4 15.9L154.7 80.6 108.5 67.5 92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2L34.1 166.5l-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256 19.1 289.5 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8L67.5 403.5l-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L222.5 493 256 458.5 289.5 493 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256 493 222.5 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5L357.3 80.6 345.5 34.1l-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L289.5 19.1 256 53.5 222.5 19.1z',
  ],
};
const faCrystalBall = {
  prefix: 'far',
  iconName: 'crystal-ball',
  icon: [
    448,
    512,
    [],
    'e362',
    'M400 224c0 71-42 132.2-102.6 160l83.3 0c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160l83.3 0C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zM167.5 100.3c-2.6-7-12.4-7-15 0l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4zm113 48l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8c-2.6-7-12.4-7-15 0zM20.3 474.2c-5.1 7.3-5.8 16.9-1.6 24.8S31.1 512 40 512l368 0c8.9 0 17.2-5 21.3-12.9s3.5-17.5-1.6-24.8L386.9 416 61.1 416 20.3 474.2z',
  ],
};
const faReplyAll = {
  prefix: 'far',
  iconName: 'reply-all',
  icon: [
    576,
    512,
    ['mail-reply-all'],
    'f122',
    'M208.5 73.4c9.6-9.1 10-24.3 .9-33.9s-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4zM352 240c0 0 0 0 0 0l-24 0c-13.3 0-24 10.7-24 24l0 24 0 28.1L183.9 208 304 99.9l0 28.1 0 24c0 13.3 10.7 24 24 24l24 0 48 0c70.7 0 128 57.3 128 128c0 15.3-1.9 29.1-5.2 41.5C506 284.7 450.2 240 384 240l-32 0zm0 96l0-48 32 0c5.5 0 10.8 .5 16 1.3c45.4 7.6 80 47.1 80 94.7c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C537.4 430.2 576 382 576 304c0-97.2-78.8-176-176-176l-48 0 0-48 0-16c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-16z',
  ],
};
const faMailReplyAll = faReplyAll;
const faSuitcase = {
  prefix: 'far',
  iconName: 'suitcase',
  icon: [
    512,
    512,
    [129523],
    'f0f2',
    'M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm232 48l-208 0-8 0 0 288 224 0 0-288-8 0zM64 144c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l32 0 0-288-32 0zM448 432c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-32 0 0 288 32 0z',
  ],
};
const faPersonSkating = {
  prefix: 'far',
  iconName: 'person-skating',
  icon: [
    448,
    512,
    ['skating'],
    'f7c5',
    'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 120c0-13.3 10.7-24 24-24l169.4 0c35.6 0 53.5 43.1 28.3 68.3L268.9 245l69.3 60c8.8 7.6 13.8 18.6 13.8 30.2l0 88.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-85-85.3-74c-24.8-21.5-26-59.7-1.9-82.5c11.9-11.2 26.8-25.1 41.6-38.5L152 144c-13.3 0-24-10.7-24-24zM79 367L179.4 266.6c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm324.9 81.4c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L272 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z',
  ],
};
const faSkating = faPersonSkating;
const faStarShooting = {
  prefix: 'far',
  iconName: 'star-shooting',
  icon: [
    512,
    512,
    [127776],
    'e036',
    'M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM129.5 388.7L120 444l49.5-26.1c14-7.4 30.7-7.4 44.7 0L263.8 444l-9.5-55.4c-2.7-15.6 2.5-31.4 13.8-42.4L308.3 307l-55.5-8.1c-15.6-2.3-29.2-12.1-36.1-26.3l-24.8-50.3-24.8 50.3c-7 14.2-20.5 24-36.1 26.3L75.5 307l40.2 39.2c11.3 11 16.4 26.9 13.8 42.4zm-5.4-137.3l46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faBinaryLock = {
  prefix: 'far',
  iconName: 'binary-lock',
  icon: [
    640,
    512,
    [],
    'e33d',
    'M318 4.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C235.8 21.4 229 35 233.2 47.6S251 67 263.6 62.8L280 57.3 280 176l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-152c0-7.7-3.7-15-10-19.5zM94 292.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C11.8 309.4 5 323 9.2 335.6S27 355 39.6 350.8L56 345.3 56 464l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-152c0-7.7-3.7-15-10-19.5zM72 0C32.2 0 0 32.2 0 72l0 80c0 39.8 32.2 72 72 72l48 0c39.8 0 72-32.2 72-72l0-80c0-39.8-32.2-72-72-72L72 0zM48 72c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-80zM192 360l0 80c0 39.8 32.2 72 72 72l48 0c39.8 0 72-32.2 72-72l0-80c0-39.8-32.2-72-72-72l-48 0c-39.8 0-72 32.2-72 72zm72-24l48 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm264-96c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faFilterCircleDollar = {
  prefix: 'far',
  iconName: 'filter-circle-dollar',
  icon: [
    576,
    512,
    ['funnel-dollar'],
    'f662',
    'M0 41.7C0 18.7 18.7 0 41.7 0L469.9 0C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48 55 48 218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 68C3.3 60.6 0 51.3 0 41.7zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z',
  ],
};
const faFunnelDollar = faFilterCircleDollar;
const faCameraRetro = {
  prefix: 'far',
  iconName: 'camera-retro',
  icon: [
    512,
    512,
    [128247],
    'f083',
    'M192 112L64 112c-8.8 0-16 7.2-16 16l0 64 108.1 0c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48L464 192l0-96c0-8.8-7.2-16-16-16L271.1 80c-2.5 0-4.9 .6-7.2 1.7l-50.5 25.2c-6.7 3.3-14 5.1-21.5 5.1zM48 240l0 176c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-176-84 0c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32l-84 0zM0 416L0 128C0 92.7 28.7 64 64 64l0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16 32 0 50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8L448 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM336 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faCircleArrowDown = {
  prefix: 'far',
  iconName: 'circle-arrow-down',
  icon: [
    512,
    512,
    ['arrow-circle-down'],
    'f0ab',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faArrowCircleDown = faCircleArrowDown;
const faCommentPen = {
  prefix: 'far',
  iconName: 'comment-pen',
  icon: [
    512,
    512,
    ['comment-edit'],
    'f4ae',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM340.8 155c-14.7-14.7-38.6-14.7-53.3 0L272.6 170l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 264.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 316c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 192.6l-71.9 71.9z',
  ],
};
const faCommentEdit = faCommentPen;
const faFileImport = {
  prefix: 'far',
  iconName: 'file-import',
  icon: [
    512,
    512,
    ['arrow-right-to-file'],
    'f56f',
    'M448 464l-256 0c-8.8 0-16-7.2-16-16l0-80-48 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 192 48 0 0-192c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
  ],
};
const faArrowRightToFile = faFileImport;
const faBanjo = {
  prefix: 'far',
  iconName: 'banjo',
  icon: [
    512,
    512,
    [129685],
    'f8a3',
    'M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-22.2 59.1-61.5 61.5-1.2 1.2c-22-16.5-48.2-27.7-76.6-31.7l0-1.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l1.7 0c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7l0 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6l1.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.7 0c-4.1-28.5-15.3-54.6-31.7-76.6l1.2-1.2s0 0 0 0l61.5-61.5 59.1-22.2c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM153 311c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48z',
  ],
};
const faSquareArrowUpRight = {
  prefix: 'far',
  iconName: 'square-arrow-up-right',
  icon: [
    448,
    512,
    ['external-link-square'],
    'f14c',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.1 0L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135L288 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24l-152 0z',
  ],
};
const faExternalLinkSquare = faSquareArrowUpRight;
const faLightEmergencyOn = {
  prefix: 'far',
  iconName: 'light-emergency-on',
  icon: [
    640,
    512,
    [],
    'e420',
    'M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm544 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM448 208l0 96 48 0 0-96c0-97.2-78.8-176-176-176s-176 78.8-176 176l0 96 48 0 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128zM144 432l0-48 352 0 0 48-352 0zM96 384l0 48c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-352 0c-26.5 0-48 21.5-48 48zM320 144c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z',
  ],
};
const faKerning = {
  prefix: 'far',
  iconName: 'kerning',
  icon: [
    640,
    512,
    [],
    'f86f',
    'M453.8 34.1c5.6-12 .4-26.3-11.6-31.9s-26.3-.4-31.9 11.6l-216 464c-5.6 12-.4 26.3 11.6 31.9s26.3 .4 31.9-11.6l216-464zM45.5 109.3C39.5 97.4 25.1 92.6 13.3 98.5S-3.4 118.9 2.5 130.7l136 272c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l136-272c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L160 338.3 45.5 109.3zm328.3 293L397.4 352l165.3 0 23.6 50.2c5.6 12 19.9 17.1 31.9 11.5s17.1-19.9 11.5-31.9l-128-272c-4-8.4-12.4-13.8-21.7-13.8s-17.8 5.4-21.7 13.8l-128 272c-5.6 12-.5 26.3 11.5 31.9s26.3 .5 31.9-11.5zM480 176.4L540.1 304l-120.1 0L480 176.4z',
  ],
};
const faBoxOpen = {
  prefix: 'far',
  iconName: 'box-open',
  icon: [
    640,
    512,
    [],
    'f49e',
    'M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64l2.2 0s0 0 0 0l-2.2 0s0 0 0 0zM528 225.3l0 153.2-184 46L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240.5-184-46 0-153.2L64 211.6l0 167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-167-48 13.7z',
  ],
};
const faSquareF = {
  prefix: 'far',
  iconName: 'square-f',
  icon: [
    448,
    512,
    [],
    'e270',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24z',
  ],
};
const faScroll = {
  prefix: 'far',
  iconName: 'scroll',
  icon: [
    576,
    512,
    [128220],
    'f70e',
    'M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 288c0 44.2 35.8 80 80 80l304 0c44.2 0 80-35.8 80-80l0-48c0-26.5-21.5-48-48-48l-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0c-26.5 0-48 21.5-48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-288c0-11.4-2.4-22.2-6.7-32L400 80c17.7 0 32 14.3 32 32l0 160 48 0 0-160c0-44.2-35.8-80-80-80L80 32C35.8 32 0 67.8 0 112l0 48c0 26.5 21.5 48 48 48l32 0 0-48-32 0 0-48zM496 432l-230.7 0c4.3-9.8 6.7-20.6 6.7-32l0-48s0 0 0 0l.6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0s0 0 0 0l0 48c0 17.7-14.3 32-32 32z',
  ],
};
const faSpa = {
  prefix: 'far',
  iconName: 'spa',
  icon: [
    576,
    512,
    [],
    'f5bb',
    'M288 92.1c21.2 24.9 52.1 69.7 68.6 134.5c13.3-10.3 27.4-19.5 42.2-27.6c-27.3-91.6-79.3-145.6-96.8-161.8c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.5 16.2-69.5 70.1-96.8 161.8c14.8 8.1 28.9 17.3 42.2 27.6c16.5-64.8 47.3-109.7 68.6-134.5zm-96 377c22.9 6.7 47 10.5 72 10.9l48 0c25-.4 49.1-4.1 72-10.9c111-32.7 192-135.4 192-257c0-11.1-9-20.1-20.1-20.1c-61.7 0-121.7 17.9-171.9 54.1c-41.8 30-75.1 71-96 118.7c-20.9-47.7-54.2-88.6-96-118.7C141.8 209.9 81.8 192 20.1 192C9 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-50.5C116.8 390.9 60.8 323.2 49.9 241.4c55.1 5.9 104.6 30.5 142.1 67.2c33.5 32.9 57.4 75.5 67.2 123.2c-23.5-.9-46.1-5.5-67.2-13.3zm192 0c-21.1 7.7-43.6 12.4-67.2 13.3c9.7-47.8 33.7-90.4 67.2-123.2c37.5-36.8 87-61.3 142.1-67.2C515.2 323.2 459.2 390.9 384 418.5z',
  ],
};
const faArrowLeftFromLine = {
  prefix: 'far',
  iconName: 'arrow-left-from-line',
  icon: [
    448,
    512,
    [8612, 'arrow-from-right'],
    'f344',
    'M7.6 238.5C2.7 243.1 0 249.4 0 256s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L84.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128zM400 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336z',
  ],
};
const faArrowFromRight = faArrowLeftFromLine;
const faStrawberry = {
  prefix: 'far',
  iconName: 'strawberry',
  icon: [
    512,
    512,
    [],
    'e32b',
    'M494.1 33.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C439.7 38.4 420.3 61.8 402 80c-.7 .7-1.4 1.4-2 2c0-.7 0-1.4 0-2.1c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-10.8-8.6-35.4-24.9-68.2-26.6c19.4-19.7 42.9-47.5 56.3-78.7zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6c0 59.2-62.9 144-224 144c-60 0-87.8-11.7-102.1-25.9S48 396 48 336c0-161 84.9-224 144.2-224zm0-48C96.2 64 0 160 0 336C0 464 48 512 176 512c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zm-2.8 90.5c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm47.3 98.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm96.7-66.3c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm24-80c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm55.3 90.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-192-80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-23.3 53.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3z',
  ],
};
const faLocationPinLock = {
  prefix: 'far',
  iconName: 'location-pin-lock',
  icon: [
    512,
    512,
    [],
    'e51f',
    'M192 451.7c18.5-23.7 41.6-54.7 64-88.1l0 83.2c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48C112.5 48 48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm288 48c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faPause = {
  prefix: 'far',
  iconName: 'pause',
  icon: [
    320,
    512,
    [9208],
    'f04c',
    'M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z',
  ],
};
const faClockEightThirty = {
  prefix: 'far',
  iconName: 'clock-eight-thirty',
  icon: [
    512,
    512,
    [],
    'e346',
    'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faPlaneEngines = {
  prefix: 'far',
  iconName: 'plane-engines',
  icon: [
    576,
    512,
    [9992, 'plane-alt'],
    'f3de',
    'M576 256c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C498 182.1 468.7 176 448 176l-66.2 0-32.5-50.9C360.3 120.1 368 109 368 96c0-17.7-14.3-32-32-32l-25.9 0L285.7 25.8C275.4 9.7 257.6 0 238.5 0L197.9 0c-27.1 0-46.4 26.4-38.1 52.2L199.4 176 148 176l-36-48c-7.6-10.1-19.4-16-32-16l-42.1 0C17 112 0 129 0 149.9c0 3.8 .6 7.5 1.7 11.1c0 0 0 0 0 0l19.9 64.7C9 230.1 0 242 0 256s9 25.9 21.6 30.3L1.7 350.9s0 0 0 0C.6 354.6 0 358.3 0 362.1C0 383 17 400 37.9 400L80 400c12.6 0 24.4-5.9 32-16L92.8 369.6 112 384l36-48 51.4 0L159.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8L310.1 448l25.9 0c17.7 0 32-14.3 32-32c0-13-7.7-24.1-18.8-29.1L381.8 336l66.2 0c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1zM448 224c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3c0 0 0 0 0 0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C484.3 283.8 461.6 288 448 288l-79.4 0c-8.2 0-15.8 4.2-20.2 11.1L245.2 460.3c-1.5 2.3-4 3.7-6.7 3.7l-29.6 0 46.3-144.7c2.3-7.3 1-15.3-3.5-21.5s-11.7-9.8-19.4-9.8L136 288c-7.6 0-14.7 3.6-19.2 9.6L76 352l-24.4 0 27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L51.6 160 76 160l40.8 54.4c4.5 6 11.6 9.6 19.2 9.6l96.3 0c7.7 0 14.9-3.7 19.4-9.8s5.8-14.2 3.5-21.5L208.9 48l29.6 0c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L245.2 51.7 348.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0z',
  ],
};
const faPlaneAlt = faPlaneEngines;
const faHillAvalanche = {
  prefix: 'far',
  iconName: 'hill-avalanche',
  icon: [
    576,
    512,
    [],
    'e507',
    'M551.1 391.1c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM48 440l0-294.1L366.1 464 72 464c-13.3 0-24-10.7-24-24zM68.3 98.3C43.1 73.1 0 91 0 126.6L0 440c0 39.8 32.2 72 72 72l313.4 0c35.6 0 53.5-43.1 28.3-68.3L68.3 98.3z',
  ],
};
const faTemperatureEmpty = {
  prefix: 'far',
  iconName: 'temperature-empty',
  icon: [
    320,
    512,
    ['temperature-0', 'thermometer-0', 'thermometer-empty'],
    'f2cb',
    'M96 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C90.3 301 96 288.4 96 273.9L96 112zM160 0C98.1 0 48 50.2 48 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C26.7 305.7 16 335.7 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L272 112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faTemperature0 = faTemperatureEmpty;
const faThermometer0 = faTemperatureEmpty;
const faThermometerEmpty = faTemperatureEmpty;
const faBomb = {
  prefix: 'far',
  iconName: 'bomb',
  icon: [
    512,
    512,
    [128163],
    'f1e2',
    'M459.1 52.4l45.7 16.8c4.3 1.6 7.3 5.9 7.2 10.4c0 4.5-3 8.7-7.2 10.2l-45.7 16.8-16.5 45.8c-1.5 4.4-5.8 7.5-10.4 7.5s-8.9-3.1-10.4-7.5l-16.8-45.8L359.2 89.8c-4.2-1.5-7.2-5.7-7.2-10.2c0-4.6 3-8.9 7.2-10.4l46-16.8L421.7 6.5c1.9-3.9 6.1-6.5 10.4-6.5s8.5 2.6 10.4 6.5l16.5 45.8zM302.9 149.6c-12.1 7.2-27.1 8.8-40.7 3.8c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2c-4.9-13.7-3.3-28.6 3.8-40.7l-59.5-59.5zm-24.4-41.3l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 224c-39.8 0-72 32.2-72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3 53.7-120 120-120c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faGaugeLow = {
  prefix: 'far',
  iconName: 'gauge-low',
  icon: [
    512,
    512,
    ['tachometer-alt-slow'],
    'f627',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
  ],
};
const faTachometerAltSlow = faGaugeLow;
const faRegistered = {
  prefix: 'far',
  iconName: 'registered',
  icon: [
    512,
    512,
    [174],
    'f25d',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0c-13.3 0-24 10.7-24 24zm48 88l0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z',
  ],
};
const faTrashCanPlus = {
  prefix: 'far',
  iconName: 'trash-can-plus',
  icon: [
    448,
    512,
    [],
    'e2ac',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zM200 376l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faAddressCard = {
  prefix: 'far',
  iconName: 'address-card',
  icon: [
    576,
    512,
    [62140, 'contact-card', 'vcard'],
    'f2bb',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z',
  ],
};
const faContactCard = faAddressCard;
const faVcard = faAddressCard;
const faChartFft = {
  prefix: 'far',
  iconName: 'chart-fft',
  icon: [
    512,
    512,
    [],
    'e69e',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM277.7 85.8c-4.2-8.8-13.3-14.3-23-13.7s-18.2 6.9-21.4 16.1L158.9 304 120 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c10.2 0 19.4-6.5 22.7-16.2l60.7-176.2 38.9 82.6c4 8.4 12.4 13.8 21.7 13.8l66.2 0 49.1 84.1c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-56-96c-4.3-7.4-12.2-11.9-20.7-11.9l-64.8 0L277.7 85.8z',
  ],
};
const faScaleUnbalancedFlip = {
  prefix: 'far',
  iconName: 'scale-unbalanced-flip',
  icon: [
    640,
    512,
    ['balance-scale-right'],
    'f516',
    'M97.1 16.7c-4 12.6 2.9 26.1 15.5 30.2L240.4 87.7c3.1 32.4 25.5 59.2 55.6 68.6L296 464l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0c13.3 0 24-10.7 24-24l0-331.7c14.2-4.5 26.8-12.8 36.4-23.8l132.3 42.3c12.6 4 26.1-2.9 30.2-15.5s-2.9-26.1-15.5-30.2L399.6 88.3c.3-2.7 .4-5.5 .4-8.3c0-44.2-35.8-80-80-80c-29.8 0-55.8 16.3-69.6 40.5L127.3 1.1c-12.6-4-26.1 2.9-30.2 15.5zM128 163.8L200.4 288 55.6 288 128 163.8zM254 305.1c2.6-11-1-22.3-6.7-32.1L152.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 273.1C3 282.8-.6 294.1 2 305.1C12.8 350 65.1 384 128 384s115.2-34 126-78.9zM583.3 416l-144.9 0 72.4-124.2L583.3 416zm-72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 401.1c-5.7 9.8-9.3 21.1-6.7 32.1C395.7 478 448 512 510.8 512zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faBalanceScaleRight = faScaleUnbalancedFlip;
const faGlobeSnow = {
  prefix: 'far',
  iconName: 'globe-snow',
  icon: [
    448,
    512,
    [],
    'f7a3',
    'M297.4 384C358 356.2 400 295 400 224c0-97.2-78.8-176-176-176S48 126.8 48 224c0 71 42 132.2 102.6 160l-83.3 0C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 62.7-25.7 119.3-67.2 160l-83.3 0zM232 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.3 84.7l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-16.5 0 44.8 53.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2l-56 0 0 48-48 0 0-48-56 0c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L176.5 256 160 256c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64c6.2-6.2 16.4-6.2 22.6 0zM328 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM80 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM20.3 474.2L61.1 416l325.8 0 40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512L40 512c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z',
  ],
};
const faSubscript = {
  prefix: 'far',
  iconName: 'subscript',
  icon: [
    512,
    512,
    [],
    'f12c',
    'M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l27.2 0 96 144-96 144L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-27.2 0-96-144 96-144 27.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64L24 64zM472 312c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8L424 464l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-152z',
  ],
};
const faDiamondTurnRight = {
  prefix: 'far',
  iconName: 'diamond-turn-right',
  icon: [
    512,
    512,
    ['directions'],
    'f5eb',
    'M50.9 249L249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zM315.3 148.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 40-48 0c-35.3 0-64 28.7-64 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-8.8 7.2-16 16-16l48 0 0 40c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z',
  ],
};
const faDirections = faDiamondTurnRight;
const faIntegral = {
  prefix: 'far',
  iconName: 'integral',
  icon: [
    320,
    512,
    [],
    'f667',
    'M216 48c-17.7 0-32 14.3-32 32l0 352c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-17.7-14.3-32-32-32z',
  ],
};
const faBurst = {
  prefix: 'far',
  iconName: 'burst',
  icon: [
    512,
    512,
    [],
    'e4dc',
    'M161.7 216.4c4.9-14.3 2.7-30.1-5.9-42.6l-39.2-57.1 57.1 39.2c12.5 8.6 28.3 10.7 42.6 5.9s25.5-16.2 30.2-30.6l9.4-29.1 11.7 36c4 12.4 12.9 22.6 24.6 28.3s25.2 6.4 37.5 2l22-8-8 22.1c-4.5 12.2-3.8 25.8 2 37.5s15.9 20.6 28.3 24.6l36 11.7-32.6 10.6c-13.5 4.4-24.3 14.5-29.7 27.6s-4.6 27.9 2 40.4l17 32.2-32.2-17c-12.5-6.6-27.3-7.3-40.4-2s-23.2 16.2-27.6 29.7L256 410.1l-10.6-32.6c-4.4-13.5-14.5-24.3-27.6-29.7s-27.9-4.6-40.4 2l-32.2 17 16.9-32.2c6.6-12.5 7.3-27.3 2-40.4s-16.2-23.2-29.7-27.6L101.9 256l29.1-9.4c14.4-4.7 25.8-15.9 30.6-30.2zm-2-128.5L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l83.7 122 28.3 41.3L68.6 216.3l-52 16.8C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l56.7 18.4 46.3 15L97 355.3 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L156.7 415l43.1-22.7 15 46.3 18.4 56.7c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l18.4-56.7 15-46.3L355.3 415l57.5 30.2c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L415 355.3l-22.7-43.1 46.3-15 56.7-18.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-60.8-19.7-45.7-14.8 16.4-45.1 9.2-25.3c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-25.3 9.2-45.1 16.4L298.5 77.4 278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-16.8 52-15.4 47.6L159.6 87.9z',
  ],
};
const faHouseLaptop = {
  prefix: 'far',
  iconName: 'house-laptop',
  icon: [
    640,
    512,
    ['laptop-house'],
    'e066',
    'M224.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L416 198.4l0 41.6-48 0 0-80.7L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l152 0 0 48-152 0c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM288 216l0 45.7c-6 6.8-10.6 14.9-13.3 23.8c-3.2 1.6-6.9 2.5-10.7 2.5l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24zm64 104l0 144 192 0 0-144-192 0zm-48-16c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160 36 0c6.6 0 12 5.4 12 12c0 19.9-16.1 36-36 36l-12 0-48 0-192 0-48 0-12 0c-19.9 0-36-16.1-36-36c0-6.6 5.4-12 12-12l36 0 0-160z',
  ],
};
const faLaptopHouse = faHouseLaptop;
const faFaceTired = {
  prefix: 'far',
  iconName: 'face-tired',
  icon: [
    512,
    512,
    [128555, 'tired'],
    'f5c8',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
  ],
};
const faTired = faFaceTired;
const faMoneyBills = {
  prefix: 'far',
  iconName: 'money-bills',
  icon: [
    640,
    512,
    [],
    'e1f3',
    'M528 80c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z',
  ],
};
const faBlindsRaised = {
  prefix: 'far',
  iconName: 'blinds-raised',
  icon: [
    512,
    512,
    [],
    'f8fd',
    'M24 0C10.7 0 0 10.7 0 24C0 34.6 6.9 43.6 16.4 46.8l-15 45C.5 94.6 0 97.5 0 100.5C0 115.7 12.3 128 27.5 128l84.5 0 0-48L55.9 80 66.6 48 112 48l32 0 0 32 0 48 0 80 0 48 0 116.1C116 382 96 408.6 96 440c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9L192 256l0-48 0-80 0-48 0-32 32 0 221.4 0 10.7 32L224 80l0 48 260.5 0c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.4-8.7l-15-45C505.1 43.6 512 34.6 512 24c0-13.3-10.7-24-24-24l-8 0L192 0 144 0 32 0 24 0zM144 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 208l-56.5 0 15.4-48-50.4 0L1.3 219.9c-.9 2.7-1.3 5.6-1.3 8.4C0 243.6 12.4 256 27.7 256l84.3 0 0-48zm112 48l260.3 0c15.3 0 27.7-12.4 27.7-27.7c0-2.9-.4-5.7-1.3-8.4L491.5 160l-50.4 0 15.4 48L224 208l0 48z',
  ],
};
const faSmog = {
  prefix: 'far',
  iconName: 'smog',
  icon: [
    640,
    512,
    [],
    'f75f',
    'M80 144c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64l-37 0c-6.5 0-12.8 2.7-17.3 7.4c-14.6 15.2-35 24.6-57.7 24.6s-43.1-9.4-57.7-24.6c-4.5-4.7-10.8-7.4-17.3-7.4l-133 0c-53 0-96-43-96-96zM176 0C96.5 0 32 64.5 32 144s64.5 144 144 144l123.3 0c22.5 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM552 464l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm280-72c0-13.3-10.7-24-24-24l-336 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24zM200 368L96 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
  ],
};
const faUfoBeam = {
  prefix: 'far',
  iconName: 'ufo-beam',
  icon: [
    576,
    512,
    [],
    'e048',
    'M152.5 163.3l-16.9 17c-4-4-6.5-9.2-7-14.9c-.6-7-.8-14-.5-20.7c-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2c10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7c10.4-9.2 12.6-16 12.6-20.2c0-5.7-4.5-16.7-26.2-30.1c-13.7-8.4-31.9-16.3-53.9-23c.3 6.8 .1 13.7-.5 20.7c-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1s0 0 0 0c0 0 0 0 0 0l-.1 .1-.3 .3c-.2 .2-.4 .4-.7 .7c-.6 .5-1.3 1.1-2.1 1.9c-1.8 1.5-4.2 3.3-7.3 5.5c-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9c-3.1-2.2-5.6-4-7.3-5.5c-.9-.7-1.6-1.4-2.1-1.9c-.3-.3-.5-.5-.7-.7l-.3-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0l16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2c26.1 16.1 49 39.7 49 70.9c0 23-12.6 41.9-28.9 56.2c-16.3 14.4-38.6 26.2-64.1 35.7C432 308.7 363 320 288 320s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6c18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6zM117.2 363.2l-72 136c-6.2 11.7-20.7 16.2-32.4 10S-3.4 488.5 2.8 476.8l72-136c6.2-11.7 20.7-16.2 32.4-10s16.2 20.7 10 32.4zm384-22.5l72 136c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-72-136c-6.2-11.7-1.7-26.2 10-32.4s26.2-1.7 32.4 10z',
  ],
};
const faHydra = {
  prefix: 'far',
  iconName: 'hydra',
  icon: [
    640,
    512,
    [],
    'e686',
    'M450.1 48c8.9 0 17.6 2.6 25 7.4l17.6 11.5c2 1.3 3.2 3.6 3.2 6c0 3.9-3.2 7.1-7.1 7.1l-15.3 0c-27.9 0-49.7 24-47 51.7l7.7 80.1c2.7 28-1.7 56.3-12.7 82.2l-3.6 8.5c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7l3.6-8.5c14.2-33.3 19.8-69.6 16.3-105.6L474.4 128l14.5 0c30.4 0 55.1-24.7 55.1-55.1c0-18.6-9.4-36-25.1-46.2L501.3 15.2C486.1 5.3 468.3 0 450.1 0l-1 0C395.5 0 352 43.5 352 97.1l0 66c0 24.8-20.1 44.8-44.8 44.8l-8.6 0c-49.7 0-95.9 25.3-122.8 67L156.6 305c-6 9.4-16.4 15-27.5 15c-25 0-40.8-27-28.5-48.8l24.2-43c.5-.8 .9-1.7 1.3-2.6c1.4-3.2 2-6.6 2-9.9s-.8-6.7-2.3-9.9c-1.2-2.6-2.9-4.9-4.9-7c-2.1-2.1-4.6-3.7-7.2-4.9c-3.2-1.4-6.6-2-9.9-2s-6.7 .8-9.8 2.3c-.9 .4-1.7 .9-2.6 1.4l-30 18C23.3 236.5 0 277.5 0 321.8C0 391.5 56.5 448 126.2 448l17.8 0 0 24c0 22.1 17.9 40 40 40l49.9 0c20.2 0 37.2-15 39.7-35l3.6-29 53.6 0 3.6 29c2.5 20 19.5 35 39.7 35l49.9 0c22.1 0 40-17.9 40-40l0-26.1c54.7-10.4 96-58.5 96-116.2l0-25.7 24.3 0c30.8 0 55.7-24.9 55.7-55.7c0-18-8.7-34.9-23.3-45.3l-24.1-17.2C576.4 174.2 557 168 537.1 168c-8.5 0-17 1.1-25.1 3.4l0 51.8c7.5-4.7 16.2-7.2 25.1-7.2c9.9 0 19.6 3.1 27.6 8.8l24.1 17.2c2 1.4 3.2 3.8 3.2 6.3c0 4.2-3.4 7.7-7.7 7.7L552 256c-22.1 0-40 17.9-40 40l0 33.7c0 38.8-31.5 70.3-70.3 70.3c-14.2 0-25.7 11.5-25.7 25.7l0 38.3-34.8 0-5.4-43c-1.5-12-11.7-21-23.8-21l-96 0c-12.1 0-22.3 9-23.8 21l-5.4 43L192 464l0-40c0-13.3-10.7-24-24-24l-41.8 0C83 400 48 365 48 321.8c0-6 .7-11.9 2-17.6c7.7 35 38.4 63.8 79 63.8c27.5 0 53.1-14 67.9-37.1L216.2 301c18-28 49.1-45 82.4-45l8.6 0c51.3 0 92.8-41.6 92.8-92.8l0-66C400 70 422 48 449.1 48l1 0zM250.4 176l48.2 0 1.4 0-1-6.3c-3.7-24-24.3-41.7-48.6-41.7l-19.3 0c-3.9 0-7.1-3.2-7.1-7.1c0-2.4 1.2-4.7 3.2-6l17.6-11.5c7.5-4.9 16.2-7.4 25-7.4l8.4 0c15.2 0 29.7 4.7 41.7 12.9l0-11.7c0-13.7 2.1-27 6.1-39.4c-14.8-6.3-31.1-9.8-47.8-9.8l-8.4 0c-18.2 0-36 5.3-51.2 15.2L201.1 74.7C185.4 84.8 176 102.2 176 120.9c0 30.4 24.7 55.1 55.1 55.1l19.3 0z',
  ],
};
const faCircleCaretUp = {
  prefix: 'far',
  iconName: 'circle-caret-up',
  icon: [
    512,
    512,
    ['caret-circle-up'],
    'f331',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c-6.7 0-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4l208 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7z',
  ],
};
const faCaretCircleUp = faCircleCaretUp;
const faUserVneckHairLong = {
  prefix: 'far',
  iconName: 'user-vneck-hair-long',
  icon: [
    448,
    512,
    [],
    'e463',
    'M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM48.3 461.9l351.5 0c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9c-41.4 16.9-71.3 56.4-74.4 103.1zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 322.2 448 389.5 448 469.9l0 8c0 17.7-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.2z',
  ],
};
const faSquareALock = {
  prefix: 'far',
  iconName: 'square-a-lock',
  icon: [
    576,
    512,
    [],
    'e44d',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 84.1c14-9.8 30.3-16.4 48-18.9L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l256 0 0-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm181.8 61.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3 .3 31.8-11.7l12-26.1 124.4 0 12 26.1c4 8.8 12.7 13.9 21.8 13.9l0-32c0-11.4 3-22.1 8.2-31.4L245.8 141.9zM224 209.3L264 296l-80 0 40-86.7zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faCrutch = {
  prefix: 'far',
  iconName: 'crutch',
  icon: [
    512,
    512,
    [],
    'f7f7',
    'M329 7L505 183c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L295 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM164.2 201.9L287.4 78.6l33.9 33.9L249.9 184 328 262.1l71.4-71.4 33.9 33.9L310.1 347.8c-11.8 11.8-26.8 20-43.1 23.7L159.4 395.4c-7.4 1.7-14.2 5.4-19.6 10.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l98.8-98.8c5.4-5.4 9.1-12.2 10.8-19.6L140.5 245c3.6-16.3 11.8-31.3 23.7-43.1zM216 217.9l-17.9 17.9c-5.4 5.4-9.1 12.2-10.8 19.6l-19.8 89 89-19.8c7.4-1.7 14.2-5.4 19.6-10.8L294.1 296 216 217.9z',
  ],
};
const faGasPumpSlash = {
  prefix: 'far',
  iconName: 'gas-pump-slash',
  icon: [
    640,
    512,
    [],
    'f5f4',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-67.2-52.7C571.4 404.9 576 391 576 376l0-220.1c0-19.1-7.6-37.4-21.1-50.9L481 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33 0 62.1c0 29.8 20.4 54.9 48 62l0 154c0 3.8-.9 7.4-2.5 10.6L384 275.7 384 64c0-35.3-28.7-64-64-64L160 0c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM144 87.6L144 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 174L144 87.6zM144 464l0-254.5L96 171.6 96 464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 48 0 192 0 48 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-65.5-48-37.8L336 464l-192 0z',
  ],
};
const faFontAwesome = {
  prefix: 'far',
  iconName: 'font-awesome',
  icon: [
    512,
    512,
    [62501, 62694, 'font-awesome-flag', 'font-awesome-logo-full'],
    'f2b4',
    'M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 389.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96zM80 400l0-256 356.4 0L388.1 252.5c-5.5 12.4-5.5 26.6 0 39L436.4 400 80 400z',
  ],
};
const faFontAwesomeFlag = faFontAwesome;
const faFontAwesomeLogoFull = faFontAwesome;
const faCloudArrowUp = {
  prefix: 'far',
  iconName: 'cloud-arrow-up',
  icon: [
    640,
    512,
    [62338, 'cloud-upload', 'cloud-upload-alt'],
    'f0ee',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z',
  ],
};
const faCloudUpload = faCloudArrowUp;
const faCloudUploadAlt = faCloudArrowUp;
const faPalette = {
  prefix: 'far',
  iconName: 'palette',
  icon: [
    512,
    512,
    [127912],
    'f53f',
    'M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8L344 272c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6c0 0 0 0 0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faTransporter4 = {
  prefix: 'far',
  iconName: 'transporter-4',
  icon: [
    512,
    512,
    [],
    'e2a5',
    'M224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM472.7 134.6L480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 224L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faChartMixedUpCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [
    576,
    512,
    [],
    'e5d8',
    'M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.5 0L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7l0 55.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L408 0zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z',
  ],
};
const faObjectsAlignRight = {
  prefix: 'far',
  iconName: 'objects-align-right',
  icon: [
    512,
    512,
    [],
    'e3bf',
    'M512 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464zM336 176L48 176l0-64 288 0 0 64zm48-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM336 400l-160 0 0-64 160 0 0 64zm48-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z',
  ],
};
const faArrowsTurnRight = {
  prefix: 'far',
  iconName: 'arrows-turn-right',
  icon: [
    448,
    512,
    [],
    'e4c0',
    'M294.4 7.7c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L362.9 152 120 152c-39.8 0-72 32.2-72 72l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-66.3 53.7-120 120-120l242.9 0L295.7 41.6c-9.7-9-10.3-24.2-1.3-33.9zm-96 256c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 408 88 408c-22.1 0-40 17.9-40 40l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-48.6 39.4-88 88-88l178.9 0-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9z',
  ],
};
const faVest = {
  prefix: 'far',
  iconName: 'vest',
  icon: [
    448,
    512,
    [],
    'e085',
    'M104 0l8.3 0 5 0c19.4 0 35.2 10 45.5 19.2C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8C295.5 10 311.3 0 330.7 0l5 0L344 0c1.9 0 3.8 .1 5.7 .3C378 3.2 400 27 400 56l0 72 0 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37L448 456c0 30.9-25.1 56-56 56l-128 0c-30.9 0-56-25.1-56-56l0-160.9c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5l28.8 95-25.1 82.8L119.9 53.7c-1-3.4-4.1-5.7-7.7-5.7L104 48c-4.4 0-8 3.6-8 8l0 72 0 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3l0 104.8 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L51.4 462.5c1.3 .9 2.9 1.5 4.6 1.5l120.4 0c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1L56 512c-30.9 0-56-25.1-56-56L0 293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3L48 128l0-72C48 25.1 73.1 0 104 0zM352 56c0-4.4-3.6-8-8-8c0 0 0 0 0 0l-8.3 0c-3.5 0-6.6 2.3-7.7 5.7L257 288.2c-.7 2.3-1 4.6-1 7L256 456c0 4.4 3.6 8 8 8l128 0c1.7 0 3.3-.5 4.6-1.5L311 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55 0-104.8c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37l0-58.7 0-72z',
  ],
};
const faPig = {
  prefix: 'far',
  iconName: 'pig',
  icon: [
    640,
    512,
    [128022],
    'f706',
    'M475 32c-4 0-7.9 .5-11.8 1.5L417.1 45c-21.1 5.3-38.6 18-50.2 35L240 80C162.6 80 98 135 83.2 208l-35.8 0c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240L80 240l0 16c0 55.8 31.8 104.2 78.1 128.1l22.3 68.3c5.4 16.5 20.7 27.6 38 27.6l45.5 0c22.1 0 40-17.9 40-40l0-24 16 0 32 0 0 24c0 22.1 17.9 40 40 40l45.5 0c17.3 0 32.7-11.1 38-27.6l13.7-42.1c26.1-7.5 49.6-22.2 67.8-42.4l34.9 0c26.5 0 48-21.5 48-48l0-80c0-26.5-21.5-48-48-48l-8.7 0c-6.7-4.7-12.5-10.5-17.2-17.3c0 0 0 0 0 0c21-14.9 33.9-39.3 33.9-65.6C600 93 587 80 570.9 80L552 80l0 29.1c0 12.2-6.9 23.4-17.8 28.9c-4.1-3.8-8.4-7.4-12.7-10.8c4.2-10.3 6.5-21.5 6.5-33.2l0-11.7C528 54.5 505.5 32 477.7 32L475 32zm-.1 48c0 0 .1 0 .1 0c0 0 0 0 0 0l2.6 0c1.3 0 2.3 1 2.3 2.3L480 94c0 9.4-3.3 18.2-8.9 25.1c-4.3 5.3-6.1 12.2-5 19s5.1 12.7 10.9 16.4c19.3 12.2 36.3 28.2 49.7 47.6c8.8 12.8 20.1 23.6 33.1 31.9c6.7 4.3 14.1 6 20.9 6l11.3 0 0 80-38.2 0c-12.8 0-23.8 6.1-31.1 14.5c-14.5 16.7-34.3 28.1-56.3 32c-8.7 1.6-15.8 7.8-18.6 16.2L431.7 432 400 432l0-40c0-13.3-10.7-24-24-24l-56 0-40 0c-13.3 0-24 10.7-24 24l0 40-31.7 0-23.7-72.7c-2.2-6.6-7.1-12-13.6-14.7c-34.7-14.5-59-48.8-59-88.6l0-16c0-61.9 50.1-112 112-112l141 0c9.6 0 18.3-5.7 22.1-14.5c4.6-10.7 13.9-19 25.7-21.9L474.9 80zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z',
  ],
};
const faInboxFull = {
  prefix: 'far',
  iconName: 'inbox-full',
  icon: [
    512,
    512,
    [],
    'e1ba',
    'M48 416c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80-81.2 0-20.9 41.9c-6.8 13.6-20.6 22.1-35.8 22.1l-140.2 0c-15.2 0-29-8.6-35.8-22.1L129.2 336 48 336l0 80zM405.6 92.1C403.8 85 397.4 80 390 80L122 80c-7.3 0-13.7 5-15.5 12.1L57.5 288l76.6 0c15.2 0 29 8.6 35.8 22.1L190.8 352l130.3 0 20.9-41.9c6.8-13.6 20.6-22.1 35.8-22.1l76.6 0-49-195.9zM0 416l0-88.1c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32L390 32c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5l0 88.1c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM184 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCircleEnvelope = {
  prefix: 'far',
  iconName: 'circle-envelope',
  icon: [
    512,
    512,
    ['envelope-circle'],
    'e10c',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-7.3-256.4c2.2 1.2 4.7 1.9 7.3 1.9s5.1-.6 7.3-1.9l120.6-66.4C382.5 172.9 368.7 160 352 160l-192 0c-16.7 0-30.5 12.9-31.9 29.3l120.6 66.4zm30 28c-7 3.8-14.8 5.8-22.7 5.8s-15.8-2-22.7-5.8L128 225.7l0 94.3c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.3L278.7 283.6z',
  ],
};
const faEnvelopeCircle = faCircleEnvelope;
const faTrianglePersonDigging = {
  prefix: 'far',
  iconName: 'triangle-person-digging',
  icon: [
    640,
    512,
    ['construction'],
    'f85d',
    'M70.3 464L320 55.3 570.2 464 70.3 464zM285.9 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512l528.5 0c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm36.5 100.1l-19.7-49.2c-8.4-21.1-28.9-34.9-51.6-34.9c-18.6 0-35.9 9.3-46.3 24.8l-4.2 6.4c-2.5 3.7-3.3 8.2-2.3 12.5s3.8 8 7.6 10.2l153.5 88.6-15.2 25.4c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1l96 0c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8L402 355l-53.5-30.9zm-131.6-3.4l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9l0 23.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8z',
  ],
};
const faConstruction = faTrianglePersonDigging;
const faFerry = {
  prefix: 'far',
  iconName: 'ferry',
  icon: [
    576,
    512,
    [],
    'e4ea',
    'M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l68 0c17.1 0 28.7 17.4 22.2 33.2L468 80l4 0c30.9 0 56 25.1 56 56l0 157.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L463.5 320 424 320l-272 0-39.5 0 35.2 50.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L58.1 326C51.5 316.6 48 305.4 48 293.9L48 136c0-30.9 25.1-56 56-56l4 0-6.2-14.8C95.3 49.4 106.9 32 124 32l68 0zM480 272l0-136c0-4.4-3.6-8-8-8l-24 0-320 0-24 0c-4.4 0-8 3.6-8 8l0 136 32 0 0-88c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24l0 88 32 0zM176 208l0 64 224 0 0-64-224 0zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faBullseyeArrow = {
  prefix: 'far',
  iconName: 'bullseye-arrow',
  icon: [
    512,
    512,
    [127919],
    'f648',
    'M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zm-93.9-29.4l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z',
  ],
};
const faArrowsDownToPeople = {
  prefix: 'far',
  iconName: 'arrows-down-to-people',
  icon: [
    640,
    512,
    [],
    'e4b9',
    'M120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0L63 153c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L120 24zm295 95c9.4-9.4 24.6-9.4 33.9 0l23 23L472 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm81 137a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5zm98.9 27.4l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35 0 39.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-39.7-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5l0 79.5 32 0 0-79.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5z',
  ],
};
const faSeedling = {
  prefix: 'far',
  iconName: 'seedling',
  icon: [
    512,
    512,
    [127793, 'sprout'],
    'f4d8',
    'M307.3 207c82.9-9.1 148.4-75.6 156-159L456 48c-76.7 0-142 49.1-166.1 117.5c-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0l24 0c17.7 0 32 14.3 32 32c0 113.6-84.6 207.4-194.2 222c-2.1-16.2-5.6-31.9-10.5-47.1zM48 112l0 16c0 97.2 78.8 176 176 176l8 0 0-16c0 0 0 0 0 0c0-97.2-78.8-176-176-176l-8 0zM280 288l0 16 0 48 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-8 0C100.3 352 0 251.7 0 128L0 96C0 78.3 14.3 64 32 64l24 0c123.7 0 224 100.3 224 224z',
  ],
};
const faSprout = faSeedling;
const faClockSeven = {
  prefix: 'far',
  iconName: 'clock-seven',
  icon: [
    512,
    512,
    [],
    'e350',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 128.7-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faLeftRight = {
  prefix: 'far',
  iconName: 'left-right',
  icon: [
    512,
    512,
    [8596, 'arrows-alt-h'],
    'f337',
    'M505.6 239.7c8.5 9.2 8.5 23.4 0 32.6l-89.4 96.8c-8.8 9.5-21.1 14.9-34 14.9c-25.5 0-46.3-20.7-46.3-46.3l0-9.7-160 0 0 9.7c0 25.5-20.7 46.3-46.3 46.3c-12.9 0-25.2-5.4-34-14.9L6.4 272.3c-8.5-9.2-8.5-23.4 0-32.6l89.4-96.8c8.8-9.5 21.1-14.9 34-14.9c25.5 0 46.3 20.7 46.3 46.3l0 9.7 160 0 0-9.7c0-25.5 20.7-46.3 46.3-46.3c12.9 0 25.2 5.4 34 14.9l89.4 96.8zM384 178.7l0 29.3c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-29.3L56.7 256 128 333.3l0-29.3c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24l0 29.3L455.3 256 384 178.7zm-253-3.3s0 0 0 0l-1.3-1.2 1.3 1.2s0 0 0 0z',
  ],
};
const faArrowsAltH = faLeftRight;
const faBoxesPacking = {
  prefix: 'far',
  iconName: 'boxes-packing',
  icon: [
    640,
    512,
    [],
    'e4c7',
    'M592 48L304 48l0 80-48 0 0-80c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-32 208 0 0-416zM561 311c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 70.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64zM48 208l0 48 32 0 224 0 32 0 0-48L48 208zM0 272l0-80c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32l0 176c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-176c-17.7 0-32-14.3-32-32zm80 32l0 160 224 0 0-160L80 304zm72 32l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCircleArrowLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-left',
  icon: [
    512,
    512,
    ['arrow-circle-left'],
    'f0a8',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM207 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L376 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-182.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z',
  ],
};
const faArrowCircleLeft = faCircleArrowLeft;
const faFlashlight = {
  prefix: 'far',
  iconName: 'flashlight',
  icon: [
    640,
    512,
    [128294],
    'f8b8',
    'M384 304L48 304l0-96 336 0c11.6 0 22.9-4.2 31.7-11.9l.1-.1c.2-.2 .7-.6 1.4-1.2c1.5-1.2 3.9-3.1 7.4-5.4c6.9-4.8 17.5-11.4 31.4-18.2c15-7.3 33.9-14.6 56.1-19.8l0 209.3c-22.2-5.2-41-12.5-56.1-19.8c-14-6.8-24.5-13.4-31.4-18.2c-3.4-2.4-5.9-4.3-7.4-5.4c-.7-.6-1.2-1-1.4-1.2l-.1-.1c-8.8-7.7-20-11.9-31.6-11.9zm192 64c-5.5 0-10.8-.2-16-.4l0-223.1c5.2-.3 10.5-.4 16-.4l16 0 0 224-16 0zM384 160L48 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l336 0s72 64 192 64l32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0c-120 0-192 64-192 64zM248 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z',
  ],
};
const faFileJpg = {
  prefix: 'far',
  iconName: 'file-jpg',
  icon: [
    512,
    512,
    [],
    'e646',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm144 48c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 26.5-21.5 48-48 48zm96-160l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm80-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z',
  ],
};
const faGroupArrowsRotate = {
  prefix: 'far',
  iconName: 'group-arrows-rotate',
  icon: [
    512,
    512,
    [],
    'e4f6',
    'M215 34.4c3.8 12.7-3.5 26.1-16.2 29.8c-14.2 4.2-27.8 10-40.5 17.1C159.4 86.1 160 91 160 96c0 35.3-28.7 64-64 64c-5 0-9.9-.6-14.6-1.7c-7.1 12.7-12.9 26.3-17.1 40.5c-3.8 12.7-17.1 19.9-29.8 16.2s-19.9-17.1-16.2-29.8c5.7-19.3 13.8-37.7 23.8-54.7C35.7 120.5 32 108.7 32 96c0-35.3 28.7-64 64-64c12.7 0 24.5 3.7 34.5 10.1c17-10 35.4-18 54.7-23.8c12.7-3.8 26.1 3.5 29.8 16.2zm82 0c3.8-12.7 17.1-19.9 29.8-16.2c19.3 5.7 37.7 13.8 54.7 23.8C391.5 35.7 403.3 32 416 32c35.3 0 64 28.7 64 64c0 12.7-3.7 24.5-10.1 34.5c10 17 18 35.4 23.8 54.7c3.8 12.7-3.5 26.1-16.2 29.8s-26.1-3.5-29.8-16.2c-4.2-14.2-10-27.8-17.1-40.5c-4.7 1.1-9.6 1.7-14.6 1.7c-35.3 0-64-28.7-64-64c0-5 .6-9.9 1.7-14.6c-12.7-7.1-26.3-12.9-40.5-17.1c-12.7-3.8-19.9-17.1-16.2-29.8zM34.4 297c12.7-3.8 26.1 3.5 29.8 16.2c4.2 14.2 10 27.8 17.1 40.5C86.1 352.6 91 352 96 352c35.3 0 64 28.7 64 64c0 5-.6 9.9-1.7 14.6c12.7 7.1 26.3 12.9 40.5 17.1c12.7 3.8 19.9 17.1 16.2 29.8s-17.1 19.9-29.8 16.2c-19.3-5.8-37.7-13.8-54.7-23.8c-10 6.4-21.8 10.1-34.5 10.1c-35.3 0-64-28.7-64-64c0-12.7 3.7-24.5 10.1-34.5c-10-17-18-35.4-23.8-54.7c-3.8-12.7 3.5-26.1 16.2-29.8zm443.1 0c12.7 3.8 19.9 17.1 16.2 29.8c-5.8 19.3-13.8 37.7-23.8 54.7c6.4 10 10.1 21.8 10.1 34.5c0 35.3-28.7 64-64 64c-12.7 0-24.5-3.7-34.5-10.1c-17 10-35.4 18-54.7 23.8c-12.7 3.8-26.1-3.5-29.8-16.2s3.5-26.1 16.2-29.8c14.2-4.2 27.8-10 40.5-17.1c-1.1-4.7-1.7-9.6-1.7-14.6c0-35.3 28.7-64 64-64c5 0 9.9 .6 14.6 1.7c7.1-12.7 12.9-26.3 17.1-40.5c3.8-12.7 17.1-19.9 29.8-16.2zM112 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zM96 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192.8 256.8c0 24.8 14.1 46.4 34.9 57c11.8 6 16.5 20.5 10.4 32.3s-20.5 16.5-32.3 10.4c-36.2-18.5-61.1-56.2-61.1-99.8c0-28.9 11-55.2 28.9-75.1l-11.2-11.2c-6.6-6.6-1.9-17.8 7.4-17.8l60.5 0c5.7 0 10.4 4.7 10.4 10.4l0 60.5c0 9.3-11.2 13.9-17.8 7.4l-15.3-15.3c-9.3 11.1-14.9 25.4-14.9 41.1zm93.1-58.6c-11.8-6-16.5-20.5-10.4-32.3s20.5-16.5 32.3-10.4c36.2 18.5 61.1 56.2 61.1 99.8c0 28.9-11 55.2-28.9 75.1L351 341.5c6.6 6.6 1.9 17.8-7.4 17.8l-60.5 0c-5.7 0-10.4-4.7-10.4-10.4l0-60.5c0-9.3 11.2-13.9 17.8-7.4l15.3 15.3c9.3-11.1 14.9-25.4 14.9-41.1c0-24.8-14.1-46.4-34.9-57z',
  ],
};
const faBowlFood = {
  prefix: 'far',
  iconName: 'bowl-food',
  icon: [
    512,
    512,
    [],
    'e4c6',
    'M0 192c0 11.7 3.1 22.6 8.6 32l494.9 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64c-.5 0-1.1 0-1.6 0C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64zM144.7 420.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304l412.4 0c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4l-192 0c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256z',
  ],
};
const faSquare9 = {
  prefix: 'far',
  iconName: 'square-9',
  icon: [
    448,
    512,
    [],
    'e25e',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z',
  ],
};
const faCandyCane = {
  prefix: 'far',
  iconName: 'candy-cane',
  icon: [
    512,
    512,
    [],
    'f786',
    'M343 82.3c5.8-1.5 11.9-2.3 18-2.3c13.8 0 26.7 3.9 37.6 10.8l23-23C404.6 55.3 383.6 48 361 48c-9.6 0-19 1.3-28.1 3.9L343 82.3zm78.3 31.1c6.8 10.9 10.8 23.8 10.8 37.6l0 5.6c0 3.5-.2 6.9-.7 10.3l30.7 10.2c1.3-6.7 1.9-13.6 1.9-20.5l0-5.6c0-22.7-7.3-43.6-19.7-60.7l-23 23zm30.2 93.9L420.5 197c-6.1 9.8-14.4 18.3-24.5 24.6l-51.2 32L375 272.5l37.9-23.7c16.5-10.3 29.7-24.7 38.5-41.4zm-106.6 84l-30.2-18.9-77 48.1 30.2 18.9 77-48.1zm-107.2 67l-30.2-18.9-73 45.6L164.6 404l73-45.6zM134.4 422.9L104.2 404 55.5 434.4c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l61.9-38.7zM303.6 65.4l-24.1 15c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l17.5-11L303.6 65.4zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151l0 5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3l0-5.6c0-12.7-10.3-23-23-23z',
  ],
};
const faArrowDownWideShort = {
  prefix: 'far',
  iconName: 'arrow-down-wide-short',
  icon: [
    576,
    512,
    ['sort-amount-asc', 'sort-amount-down'],
    'f160',
    'M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 480l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faSortAmountAsc = faArrowDownWideShort;
const faSortAmountDown = faArrowDownWideShort;
const faSquareDollar = {
  prefix: 'far',
  iconName: 'square-dollar',
  icon: [
    448,
    512,
    ['dollar-square', 'usd-square'],
    'f2e9',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm244.8 37.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z',
  ],
};
const faDollarSquare = faSquareDollar;
const faUsdSquare = faSquareDollar;
const faPhoneArrowRight = {
  prefix: 'far',
  iconName: 'phone-arrow-right',
  icon: [
    512,
    512,
    [],
    'e5be',
    'M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L312 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l118.1 0L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faHandHoldingSeedling = {
  prefix: 'far',
  iconName: 'hand-holding-seedling',
  icon: [
    576,
    512,
    [],
    'f4bf',
    'M115.6 0C96 0 80 16 80 35.6C80 113.2 142.8 176 220.4 176l43.6 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104C312 68.1 243.9 0 160 0L115.6 0zM160 48c49.2 0 90.4 34.1 101.2 80l-40.9 0c-46.8 0-85.5-34.8-91.5-80L160 48zm5.2 310.7c6.6-4.4 14.3-6.7 22.2-6.7L344 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 24 0 48 0c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9l7.4 0c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l363.7 0c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3l-7.4 0c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64l-156.6 0c-17.4 0-34.4 5.1-48.8 14.8L64.7 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.7 0 9.4-1.4 13.3-4l79.9-53.3zM355.6 176C433.2 176 496 113.2 496 35.6C496 16 480 0 460.4 0L416 0c-41.7 0-79.5 16.8-107 44c10 13.8 18.1 29 24 45.2C352 64.2 382.1 48 416 48l31.2 0c-6 45.2-44.7 80-91.5 80l-13.2 0c1 7.9 1.6 15.9 1.6 24l0 24 11.6 0z',
  ],
};
const faMessageCheck = {
  prefix: 'far',
  iconName: 'message-check',
  icon: [
    512,
    512,
    ['comment-alt-check'],
    'f4a2',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM369 153c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z',
  ],
};
const faCommentAltCheck = faMessageCheck;
const faCloudBolt = {
  prefix: 'far',
  iconName: 'cloud-bolt',
  icon: [
    512,
    512,
    [127785, 'thunderstorm'],
    'f76c',
    'M184 48c-39.8 0-72 32.2-72 72c0 2.6 .1 5.2 .4 7.7c1.3 12-6.6 23.1-18.3 25.9C67.6 159.9 48 183.7 48 212c0 32.2 25.3 58.4 57.1 59.9c.3 0 .7 0 1 .1l1.9 0 95.2 0-60 48L108 320l-4 0c-1.2 0-2.4-.1-3.5-.3C44.3 315.9 0 269.1 0 212c0-44.1 26.4-81.9 64.2-98.7C67.7 50.1 120 0 184 0c33.9 0 64.5 14.1 86.3 36.6C285.1 28.6 302 24 320 24c46.9 0 86.5 31 99.5 73.7C472.1 106.9 512 152.8 512 208c0 61.9-50.1 112-112 112l-48 0-18.3 0 24-48 42.3 0c35.3 0 64-28.7 64-64s-28.6-64-64-64c0 0 0 0 0 0l-.3 0c-12.4 0-22.7-9.3-23.9-21.6C372.9 94.1 349 72 320 72c-14.7 0-28.1 5.7-38.1 15c-5.3 4.9-12.4 7.2-19.5 6.2s-13.4-5-17.2-11.1C232.5 61.6 209.8 48 184 48zM330.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L281.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 384 160 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z',
  ],
};
const faThunderstorm = faCloudBolt;
const faChartLineUpDown = {
  prefix: 'far',
  iconName: 'chart-line-up-down',
  icon: [
    512,
    512,
    [],
    'e5d7',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zm352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-22.1L305 273c-9.4 9.4-24.6 9.4-33.9 0l-63-63-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 112 376 112zm0 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.1 0-47-47L385 255l47 47 0-22.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 6.4-2.5 12.5-7 17s-10.6 7-17 7l-80 0z',
  ],
};
const faTextSlash = {
  prefix: 'far',
  iconName: 'text-slash',
  icon: [
    640,
    512,
    ['remove-format'],
    'f87d',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80l124.8 0-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1C576.6 56.5 557.5 32 531.5 32l-335 0c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zM191.5 124.8L202.7 80l143.8 0L308.1 216.2 191.5 124.8zm57.4 300.7l-1.8 6.5L192 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.1 0 23.6-83.5-40.8-32.1L248.9 425.5z',
  ],
};
const faRemoveFormat = faTextSlash;
const faWatch = {
  prefix: 'far',
  iconName: 'watch',
  icon: [
    384,
    512,
    [8986],
    'f2e1',
    'M112 0C85.5 0 64 21.5 64 48l0 64 1 0C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144l-1 0 0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64-1 0c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144l1 0 0-64c0-26.5-21.5-48-48-48L112 0zM48 256a144 144 0 1 1 288 0A144 144 0 1 1 48 256zm168-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2l0-67.2z',
  ],
};
const faCircleDownLeft = {
  prefix: 'far',
  iconName: 'circle-down-left',
  icon: [
    512,
    512,
    [],
    'e107',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L176 352c-8.8 0-16-7.2-16-16l0-137.4z',
  ],
};
const faText = {
  prefix: 'far',
  iconName: 'text',
  icon: [
    448,
    512,
    [],
    'f893',
    'M48 80l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48L248 80l0 352 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-352L48 80z',
  ],
};
const faProjector = {
  prefix: 'far',
  iconName: 'projector',
  icon: [
    640,
    512,
    [],
    'f8d6',
    'M424 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM265 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L265 39zM569 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L479 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm272 0c0-29.1-7.8-56.5-21.4-80l37.4 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-37.4 0c13.6-23.5 21.4-50.9 21.4-80zM400 480c36 0 69.3-11.9 96-32l16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-80 0c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32L64 192c-35.3 0-64 28.7-64 64L0 384c0 35.3 28.7 64 64 64l16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 176 0c26.7 20.1 60 32 96 32zM240 320c0 29.1 7.8 56.5 21.4 80L64 400c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l197.4 0c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faFaceSmileWink = {
  prefix: 'far',
  iconName: 'face-smile-wink',
  icon: [
    512,
    512,
    [128521, 'smile-wink'],
    'f4da',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z',
  ],
};
const faSmileWink = faFaceSmileWink;
const faTombstoneBlank = {
  prefix: 'far',
  iconName: 'tombstone-blank',
  icon: [
    448,
    512,
    [129702, 'tombstone-alt'],
    'f721',
    'M368 192l0 240 48 0 0-240C416 86 330 0 224 0S32 86 32 192l0 240 48 0 0-240c0-79.5 64.5-144 144-144s144 64.5 144 144zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z',
  ],
};
const faTombstoneAlt = faTombstoneBlank;
const faChessKingPiece = {
  prefix: 'far',
  iconName: 'chess-king-piece',
  icon: [
    256,
    512,
    ['chess-king-alt'],
    'f440',
    'M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L66.9 96C43.2 96 24 115.2 24 138.9c0 4.7 .8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352l48 0 2.1-96 57.6 0 2.1 96 48 0-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5c0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8c0-23.7-19.2-42.9-42.9-42.9L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm16.2 192l-64.4 0L74 144l108 0-21.8 64zm-91 224l117.6 0 16.6 32L52.7 464l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l174.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3l-137 0z',
  ],
};
const faChessKingAlt = faChessKingPiece;
const faCircle6 = {
  prefix: 'far',
  iconName: 'circle-6',
  icon: [
    512,
    512,
    [],
    'e0f3',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-96-48c0-32.4 14.2-63.2 38.8-84.3l81.6-70c10.1-8.6 25.2-7.5 33.8 2.6s7.5 25.2-2.6 33.8L282 195.6c40.4 11.4 70 48.4 70 92.4c0 53-43 96-96 96s-96-43-96-96z',
  ],
};
const faWavesSine = {
  prefix: 'far',
  iconName: 'waves-sine',
  icon: [
    640,
    512,
    [],
    'e65d',
    'M95.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C112.4 446.8 77.2 480 24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24c29 0 51.3-16.8 71.9-50.9zM248.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C231.6 65.2 266.8 32 320 32s88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7c0 0 0 0 0 0s0 0 0 0l.6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C564.7 415.2 587 432 616 432c13.3 0 24 10.7 24 24s-10.7 24-24 24c-53.2 0-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C371.3 96.8 349 80 320 80s-51.3 16.8-71.9 50.9zM391.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C408.4 446.8 373.2 480 320 480s-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C75.3 96.8 53 80 24 80C10.7 80 0 69.3 0 56S10.7 32 24 32c53.2 0 88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7l.6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C268.7 415.2 291 432 320 432s51.3-16.8 71.9-50.9zM544.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C527.6 65.2 562.8 32 616 32c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29 0-51.3 16.8-71.9 50.9z',
  ],
};
const faLeft = {
  prefix: 'far',
  iconName: 'left',
  icon: [
    448,
    512,
    ['arrow-alt-left'],
    'f355',
    'M50.4 256L200.3 113.3c.8-.8 2-1.3 3.2-1.3c2.5 0 4.6 2 4.6 4.6l0 83.4c0 13.3 10.7 24 24 24l168 0 0 64-168 0c-13.3 0-24 10.7-24 24l0 83.4c0 2.5-2 4.6-4.6 4.6c-1.2 0-2.3-.5-3.2-1.3L50.4 256zm153-192c-13.5 0-26.5 5.2-36.3 14.5L13.2 225.1C4.8 233.2 0 244.3 0 256s4.8 22.8 13.2 30.9L167.2 433.5c9.8 9.3 22.8 14.5 36.3 14.5c29 0 52.6-23.5 52.6-52.6l0-59.4 144 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-144 0 0-59.4c0-29-23.5-52.6-52.6-52.6z',
  ],
};
const faArrowAltLeft = faLeft;
const faFileWord = {
  prefix: 'far',
  iconName: 'file-word',
  icon: [
    384,
    512,
    [],
    'f1c2',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z',
  ],
};
const faFilePowerpoint = {
  prefix: 'far',
  iconName: 'file-powerpoint',
  icon: [
    384,
    512,
    [],
    'f1c4',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z',
  ],
};
const faSquareDown = {
  prefix: 'far',
  iconName: 'square-down',
  icon: [
    448,
    512,
    [11015, 'arrow-alt-square-down'],
    'f350',
    'M400 416l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM328.8 294.6l-91 84c-3.8 3.5-8.7 5.4-13.9 5.4s-10.1-1.9-13.9-5.4l-91-84c-4.6-4.2-7.2-10.1-7.2-16.4c0-12.3 10-22.3 22.3-22.3l41.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 41.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.2 16.4z',
  ],
};
const faArrowAltSquareDown = faSquareDown;
const faObjectsAlignCenterVertical = {
  prefix: 'far',
  iconName: 'objects-align-center-vertical',
  icon: [
    512,
    512,
    [],
    'e3bd',
    'M112 80l0 352 64 0 0-352-64 0zM64 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 152 64 0 0-88c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 88 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 88c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-88-64 0 0 152c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-152-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L64 80zm272 64l0 224 64 0 0-224-64 0z',
  ],
};
const faArrowsLeftRight = {
  prefix: 'far',
  iconName: 'arrows-left-right',
  icon: [
    512,
    512,
    ['arrows-h'],
    'f07e',
    'M505 273c9.4-9.4 9.4-24.6 0-33.9l-96-96c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L81.9 232l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 348.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z',
  ],
};
const faArrowsH = faArrowsLeftRight;
const faHouseLock = {
  prefix: 'far',
  iconName: 'house-lock',
  icon: [
    640,
    512,
    [],
    'e510',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L492.2 165.8c-16.3 5.5-31 14.7-43 26.5L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 152s0 0 0 0l0 16c0 11.7 3.1 22.6 8.6 32L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM240 464l96 0 0-144-96 0 0 144zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faCloudArrowDown = {
  prefix: 'far',
  iconName: 'cloud-arrow-down',
  icon: [
    640,
    512,
    [62337, 'cloud-download', 'cloud-download-alt'],
    'f0ed',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 313l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z',
  ],
};
const faCloudDownload = faCloudArrowDown;
const faCloudDownloadAlt = faCloudArrowDown;
const faWreath = {
  prefix: 'far',
  iconName: 'wreath',
  icon: [
    448,
    512,
    [],
    'f7e2',
    'M339.4 88.7c-24.5 7.3-50.4-5.9-58.9-30c-2.2-6.3-8.2-10.7-15.1-10.7c-4 0-7.5 1.4-10.3 3.8c-17.9 15.2-44.2 15.2-62.1 0c-2.8-2.4-6.3-3.8-10.3-3.8c-6.9 0-12.9 4.4-15.1 10.7c-8.5 24.1-34.4 37.3-58.9 30c-1.4-.4-2.9-.7-4.6-.7c-8.8 0-16 7.2-16 16c0 1.7 .2 3.2 .7 4.6c7.3 24.5-5.9 50.4-30 58.9c-6.3 2.2-10.7 8.2-10.7 15.1c0 4 1.4 7.5 3.8 10.3c15.2 17.9 15.2 44.2 0 62.2c-2.4 2.8-3.8 6.3-3.8 10.3c0 6.9 4.4 12.9 10.7 15.1c24.1 8.5 37.3 34.4 30 58.9c-.4 1.4-.7 2.9-.7 4.6c0 8.8 7.2 16 16 16c1.7 0 3.2-.2 4.6-.7c5.4-1.6 10.8-2.2 16.1-1.9c-17 8.5-28.7 26.1-28.7 46.4l0 3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5l0-3.7c0-20.3-11.7-37.9-28.7-46.4c5.3-.3 10.8 .3 16.1 1.9c1.4 .4 2.9 .7 4.6 .7c8.8 0 16-7.2 16-16c0-1.7-.2-3.2-.7-4.6c-7.3-24.5 5.9-50.4 30-58.9c6.3-2.2 10.7-8.2 10.7-15.1c0-4-1.4-7.5-3.8-10.3c-15.2-17.9-15.2-44.2 0-62.2c2.4-2.8 3.8-6.3 3.8-10.3c0-6.9-4.4-12.9-10.7-15.1c-24.1-8.5-37.3-34.4-30-58.9c.4-1.4 .7-2.9 .7-4.6c0-8.8-7.2-16-16-16c-1.7 0-3.2 .2-4.6 .7zM128 492.2l0-88.4c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8l0 88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8zm69.9-294.3c-2 9.3-5.6 18.2-10.8 26.1c5.2 8 8.9 16.8 10.8 26.1c9.3 2 18.2 5.6 26.1 10.8c8-5.2 16.8-8.9 26.1-10.8c2-9.3 5.6-18.2 10.8-26.1c-5.2-8-8.9-16.8-10.8-26.1c-4.7-1-9.3-2.4-13.7-4.2c-4.3-1.8-8.5-4-12.4-6.6c-8 5.2-16.8 8.9-26.1 10.8zm5.2-55.5c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z',
  ],
};
const faChildren = {
  prefix: 'far',
  iconName: 'children',
  icon: [
    640,
    512,
    [],
    'e4e1',
    'M160 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 160 0a72 72 0 1 0 0 144zm0 16c-34.6 0-67.3 16.2-88.2 43.8L12.9 281.5c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6l45.3-59.8L57.2 368.4c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 32 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 16 0c7.7 0 15-3.7 19.5-10s5.7-14.3 3.3-21.6L223.5 250.7l45.3 59.8c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-58.9-77.7C227.3 176.2 194.7 160 160 160zM113.3 352L160 211.9 206.7 352l-93.4 0zM456 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 408 72a72 72 0 1 0 144 0zM480 208c5.5 0 10.9 .9 16 2.6L496 336l-32 0 0-125.4c5.1-1.7 10.5-2.6 16-2.6zM464 488l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-223.2 27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C545.8 177.5 514.1 160 480 160s-65.8 17.5-83.9 46.3l-48.4 76.9c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44L416 488c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faMeterDroplet = {
  prefix: 'far',
  iconName: 'meter-droplet',
  icon: [
    640,
    512,
    [],
    'e1ea',
    'M256 464c48.8 0 93.8-16.8 129.2-45c2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-15.4 28.8C443.8 122.2 358.6 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zM192 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm136.5 54.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z',
  ],
};
const faChalkboard = {
  prefix: 'far',
  iconName: 'chalkboard',
  icon: [
    576,
    512,
    ['blackboard'],
    'f51b',
    'M80 88c0-4.4 3.6-8 8-8l400 0c4.4 0 8 3.6 8 8l0 312 48 0 0-312c0-30.9-25.1-56-56-56L88 32C57.1 32 32 57.1 32 88l0 312 48 0L80 88zM224 408l0 24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0 24 0 144 0 24 0 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0 0-24c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56zm144 0l0 24-96 0 0-24c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8z',
  ],
};
const faBlackboard = faChalkboard;
const faUserLargeSlash = {
  prefix: 'far',
  iconName: 'user-large-slash',
  icon: [
    640,
    512,
    ['user-alt-slash'],
    'f4fa',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM224.2 150.4c-.1-2.1-.2-4.3-.2-6.4c0-53 43-96 96-96s96 43 96 96c0 47.3-34.3 86.7-79.3 94.6L224.2 150.4zM545.5 512L528 512l-60.9-48-353.8 0c8.3-54.4 55.3-96 112-96l119.9 0-60.9-48-59 0C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0 .3 0z',
  ],
};
const faUserAltSlash = faUserLargeSlash;
const faSignalStrong = {
  prefix: 'far',
  iconName: 'signal-strong',
  icon: [
    640,
    512,
    ['signal-4'],
    'f68f',
    'M448 96c13.3 0 24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faSignal4 = faSignalStrong;
const faLollipop = {
  prefix: 'far',
  iconName: 'lollipop',
  icon: [
    512,
    512,
    [127853, 'lollypop'],
    'e424',
    'M210.8 334.8C265.3 314.2 304 261.6 304 200l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 53-43 96-96 96l-8 0C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c44.4 0 85.2-15 117.7-40.3L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L343.7 309.7C369 277.2 384 236.4 384 192C384 86 298 0 192 0S0 86 0 192z',
  ],
};
const faLollypop = faLollipop;
const faListTree = {
  prefix: 'far',
  iconName: 'list-tree',
  icon: [
    512,
    512,
    [],
    'e1d2',
    'M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48zM160 96c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72c-13.3 0-24 10.7-24 24zM288 256c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faEnvelopeOpen = {
  prefix: 'far',
  iconName: 'envelope-open',
  icon: [
    512,
    512,
    [62135],
    'f2b6',
    'M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z',
  ],
};
const faDrawCircle = {
  prefix: 'far',
  iconName: 'draw-circle',
  icon: [
    512,
    512,
    [],
    'f5ed',
    'M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1C115.6 212.4 128 232.8 128 256s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1C212.4 396.4 232.8 384 256 384s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1C396.4 299.6 384 279.2 384 256s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6c-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1C124.5 442.1 69.9 387.5 49.1 318.3C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3C69.9 124.5 124.5 69.9 193.7 49.1C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faCatSpace = {
  prefix: 'far',
  iconName: 'cat-space',
  icon: [
    640,
    512,
    [],
    'e001',
    'M464 304c70.7 0 128-57.3 128-128c0-32.5-12.1-62.1-32-84.7l0 84.7c0 53-43 96-96 96s-96-43-96-96l0-84.7c-19.9 22.6-32 52.2-32 84.7c0 70.7 57.3 128 128 128zM397.8 66.4l29.4 39.2c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l29.4-39.2C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4zM464 352l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-98.9c-10.4 1.9-21.1 2.9-32 2.9zM640 176c0 68.4-39 127.7-96 156.8L544 448c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-54L336 441l0 23 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-48.6 0-88-39.4-88-88c0 0 0-.1 0-.1l0-239.4c0-20.2-15-37.2-35-39.7l-7.9-1c-13.2-1.6-22.5-13.6-20.8-26.8S45.8 94.5 59 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3l0 94.5c34.5-46.4 85.2-80.1 144.3-92.7c-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176zM144 423.9c0 0 0 .1 0 .1c0 22.1 17.9 40 40 40l104 0 0-64c0-17.7-14.3-32-32-32l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c39.4 0 72.2 28.5 78.8 66l73.3-43.1c-51.7-17.3-92.7-58-110.5-109.5C209 252.6 144 331.2 144 423.9zM231.5 12.3l10.7 28.8c.8 2.2 2.5 3.9 4.7 4.7l28.8 10.7c7 2.6 7 12.4 0 15L246.9 82.2c-2.2 .8-3.9 2.5-4.7 4.7l-10.7 28.8c-2.6 7-12.4 7-15 0L205.8 86.9c-.8-2.2-2.5-3.9-4.7-4.7L172.3 71.5c-7-2.6-7-12.4 0-15l28.8-10.7c2.2-.8 3.9-2.5 4.7-4.7l10.7-28.8c2.6-7 12.4-7 15 0zM432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faHandshakeSimpleSlash = {
  prefix: 'far',
  iconName: 'handshake-simple-slash',
  icon: [
    640,
    512,
    ['handshake-alt-slash'],
    'e05f',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368l82.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-15.4 0-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5 44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-78.9 0L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM388.9 402.4l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4L56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l37.7 0c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5zM101.5 176L44.4 131C37 135.1 32 143 32 152c0 13.3 10.7 24 24 24l45.5 0z',
  ],
};
const faHandshakeAltSlash = faHandshakeSimpleSlash;
const faRabbitRunning = {
  prefix: 'far',
  iconName: 'rabbit-running',
  icon: [
    576,
    512,
    ['rabbit-fast'],
    'f709',
    'M501.8 167.8c-8.6-5.9-17.8-10.8-27.4-14.6C457.7 98.3 413.9 55 358 39.7l-2-.6c-13-3.6-26.9-1.8-38.5 5c-20.2 11.7-29.8 35.7-23.1 58.1l7.8 26.3c1.2 4 2.5 8 4 11.9l-57.1-20.8c-13.8-5-28.4-7.6-43.1-7.6l-12.3 0c-30.1 0-57.5 11.7-77.9 30.9C103.7 133.5 88.5 128 72 128c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2c6 14.1 14.8 27 26.1 37.8l37.7 36.1-28.3 18.9c-29.4 19.6-37.4 59.3-17.8 88.8s59.3 37.4 88.8 17.8l52.1-34.7 5.3 5.1C269.2 455.3 291 464 313.7 464L416 464c35.3 0 64-28.7 64-64c0-19.1-8.4-36.3-21.7-48l33.4 0c46.5 0 84.3-37.7 84.3-84.3c0-25.3-11.4-49.3-31-65.3l-18.9-15.4c13.8-52.7-1.7-108.8-40.6-147l-1.4-1.4c-5.7-5.6-13.8-8-21.6-6.5l-1.6 .3c-8.8 1.7-16 8.3-18.4 16.9c-.8 2.8-1.5 5.5-2.1 8.3c28.7 25.3 49.7 59 59.4 97.4c1.1 4.2 1.7 8.5 2 12.7zM88.5 182.5c-5.1 12.4-8.1 25.9-8.4 40.1c-2.5 .9-5.2 1.4-8 1.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.4 0 12.2 2.5 16.5 6.5zm62.7 220.1l37.2-24.8L212 400.5l-43.2 28.8c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2zm190.3-317c.6-.3 1.2-.4 1.9-.2l2 .6c41.5 11.4 74 44.6 84.6 86.5c.3 10.6 7.6 19.7 17.8 22.4c11.7 3.1 22.8 8.7 32.3 16.5l34.6 28.2c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3L392 304c-6.4 0-12.5 2.5-17 7l-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8c-12.9-3.2-25.9 4.6-29.1 17.5s4.6 25.9 17.5 29.1l23.3 5.8c32.1 8 54.5 36.8 54.5 69.8l0 13c0 13.3 10.7 24 24 24l40 0 .1 0 31.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-102.3 0c-10.3 0-20.2-4-27.6-11.1L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5c0-36.3 29.4-65.7 65.7-65.7l12.3 0c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1c11 4 23.3-.5 29.1-10.7s3.4-23.1-5.7-30.5c-17.6-14.3-30.7-33.7-37.3-55.8l-7.8-26.3c-.3-1.1 .1-2.2 1.1-2.8zM480 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faRabbitFast = faRabbitRunning;
const faMemoPad = {
  prefix: 'far',
  iconName: 'memo-pad',
  icon: [
    448,
    512,
    [],
    'e1da',
    'M400 128l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320 352 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 200c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faMattressPillow = {
  prefix: 'far',
  iconName: 'mattress-pillow',
  icon: [
    640,
    512,
    [],
    'e525',
    'M240 112l0 288L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l176 0zm48 0l288 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-288 0 0-288zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM80 176l0 160c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
  ],
};
const faAlarmPlus = {
  prefix: 'far',
  iconName: 'alarm-plus',
  icon: [
    512,
    512,
    [],
    'f844',
    'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM256 176c-13.3 0-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24z',
  ],
};
const faAlicorn = {
  prefix: 'far',
  iconName: 'alicorn',
  icon: [
    640,
    512,
    [],
    'f6b0',
    'M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 24 0 8 0 .5 0L536 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c3.5 6.1 6.3 12.7 8.3 19.7l73.5 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c6.4-9.1 14.1-17.3 22.9-24.2c5.1 17.5 11.8 33.3 19.6 47.6c-9.1 11.1-14.6 25.3-14.6 40.8c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-8 0-24 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-1.5 12-11.7 21-23.8 21l-.5 0c-3.8 .1-7.6-.7-11.2-2.5L179.7 96.7c8.2 42.4 28.6 70.5 48.5 88.8c13.1 12 26.2 20.1 35.9 25.1c4.9 2.5 8.8 4.2 11.5 5.2c1.3 .5 2.3 .9 2.9 1.1l.4 .1c9.9 3 17 12.1 17 23c0 13.3-10.7 24-24 24c-2.8 0-5.4-.5-7.9-1.3c-.4-.1-.8-.3-1.3-.5c-1.2-.4-2.8-1-4.7-1.8c-3.9-1.6-9.3-3.9-15.7-7.2c-12.7-6.5-29.6-16.9-46.6-32.5C161.4 189.2 128 137 128 56c0-8.3 4.3-16 11.4-20.4s15.9-4.8 23.4-1.1l133.9 66.9C316 46.3 366.3 5.8 426.8 .6zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faCommentQuestion = {
  prefix: 'far',
  iconName: 'comment-question',
  icon: [
    512,
    512,
    [],
    'e14b',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM169.8 149.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faGingerbreadMan = {
  prefix: 'far',
  iconName: 'gingerbread-man',
  icon: [
    448,
    512,
    [],
    'f79d',
    'M152 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 9.5-1.8 18.4-5.1 26.6c-7.6 19 4.4 45.4 30.1 45.4l39 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-7 0c-39.2 0-60.7 45.6-35.8 75.9l41.7 50.7c14 17.1 11.6 42.3-5.5 56.3s-42.3 11.6-56.3-5.5l-37.3-45.3c-18.6-22.6-53.1-22.6-71.7 0l-37.3 45.3c-14 17.1-39.2 19.5-56.3 5.5s-19.5-39.2-5.5-56.3l41.7-50.7C155.7 317.6 134.2 272 95 272l-7 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l39 0c25.7 0 37.7-26.4 30.1-45.4c-3.3-8.2-5.1-17.2-5.1-26.6zM224 0C157.7 0 104 53.7 104 120c0 8.2 .8 16.2 2.4 24L88 144c-48.6 0-88 39.4-88 88s39.4 88 88 88l3.6 0L52 368.1c-30.9 37.5-25.5 93 12 123.9l14.5-17.6L64.1 492c37.5 30.9 93 25.5 123.9-12l36-43.8 36 43.8c30.9 37.5 86.3 42.9 123.9 12s42.9-86.3 12-123.9L356.4 320l3.6 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-18.4 0c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0zm0 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM208 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faGuaraniSign = {
  prefix: 'far',
  iconName: 'guarani-sign',
  icon: [
    384,
    512,
    [],
    'e19a',
    'M192 0c-13.3 0-24 10.7-24 24l0 41.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5l0 41.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-41.5c94.7-11.8 168-92.6 168-190.5c0-13.3-10.7-24-24-24l-144 0 0-118c29.7 5 56.2 19 76.8 39.2c9.5 9.3 24.7 9.1 33.9-.3s9.1-24.7-.3-33.9C297.2 90.2 258.8 70.8 216 65.5L216 24c0-13.3-10.7-24-24-24zM168 114l0 284C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142zm48 284l0-118 118 0c-10.1 60.3-57.7 107.9-118 118z',
  ],
};
const faBurgerFries = {
  prefix: 'far',
  iconName: 'burger-fries',
  icon: [
    640,
    512,
    [],
    'e0cd',
    'M167.6 2.4C162.9 5.3 160 10.5 160 16l0 190.7s0 0 0 0l0 63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16c-5-2.5-10.8-2.2-15.6 .7zM128 261l0-246.3-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6zM58.2 193L40.3 85.6 19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1zm312-17.5l13.5-76.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.5-.4 5.1-.7 7.9-.8c10.4-6.1 22.1-11.7 35.1-16.4zM286.6 230c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6c2.1-1.5 4-3 5.7-4.5c3.2-4.9 7-10 11.4-15.4c.7-1.6 1.3-3.1 1.7-4.5zM192 304c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224l-26.6 0C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512l204.9 0c-14-13.1-24.9-29.5-31.3-48l-161 0L66.1 316.8c1.4 1.1 2.8 2.1 4.3 3.1C99.3 340.1 139.1 352 192 352c26.8 0 50.3-3.1 70.6-8.7c-4.3-11.8-6.6-24.6-6.6-37.8c0-3.2 .1-6.7 .5-10.5c-16.7 5.5-37.8 9-64.5 9zm257.9-63.8c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.4 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z',
  ],
};
const faMugTea = {
  prefix: 'far',
  iconName: 'mug-tea',
  icon: [
    576,
    512,
    [],
    'f875',
    'M80 112l72 0 0 10.7c0 8.5-3.4 16.6-9.4 22.6l-21.3 21.3c-6 6-9.4 14.1-9.4 22.6l0 66.7c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-21.3-21.3c-6-6-9.4-14.1-9.4-22.6l0-10.7 184 0 0 240c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-240zM64 64C46.3 64 32 78.3 32 96l0 256c0 53 43 96 96 96l192 0c53 0 96-43 96-96l0-32 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L64 64zM448 272l-32 0 0-160 32 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
  ],
};
const faBorderTop = {
  prefix: 'far',
  iconName: 'border-top',
  icon: [
    448,
    512,
    [],
    'f855',
    'M0 56C0 42.7 10.7 32 24 32l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faArrowsRotate = {
  prefix: 'far',
  iconName: 'arrows-rotate',
  icon: [
    512,
    512,
    [128472, 'refresh', 'sync'],
    'f021',
    'M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176 360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336l54.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-54.1 52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9z',
  ],
};
const faRefresh = faArrowsRotate;
const faSync = faArrowsRotate;
const faCircleBookOpen = {
  prefix: 'far',
  iconName: 'circle-book-open',
  icon: [
    512,
    512,
    ['book-circle'],
    'e0ff',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9l0-160.7c0-5.8-3.1-11.1-8.3-13.5C221.2 167.1 202.5 160 184 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5l0 160.7c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C143 347.1 160.9 336 184 336zm144 0c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9l0-160.7c0-5.8-3.1-11.1-8.3-13.5C365.2 167.1 346.5 160 328 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5l0 160.7c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C287 347.1 304.9 336 328 336z',
  ],
};
const faBookCircle = faCircleBookOpen;
const faArrowsToDottedLine = {
  prefix: 'far',
  iconName: 'arrows-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a6',
    'M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM313 399l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z',
  ],
};
const faFireExtinguisher = {
  prefix: 'far',
  iconName: 'fire-extinguisher',
  icon: [
    512,
    512,
    [129519],
    'f134',
    'M500.3 7.3C507.7 13.3 512 22.4 512 32l0 96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104l-89 0 0 26.6c50.3 11 88 55.8 88 109.4l0 208c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64l0-208c0-53.6 37.7-98.4 88-109.4l0-25.6c-46.9 5.5-86.5 34.8-106.3 75.6c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C30.1 102.8 86.1 62.4 152 56.7L152 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 89 0c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM112 416l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32-128 0zm0-48l128 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128z',
  ],
};
const faMagnifyingGlassArrowsRotate = {
  prefix: 'far',
  iconName: 'magnifying-glass-arrows-rotate',
  icon: [
    512,
    512,
    [],
    'e65e',
    'M208 48c39.6 0 75.9 14.4 103.8 38.2L279 119c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l96 0c13.3 0 24-10.7 24-24l0-96c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L345.8 52.2C309.1 19.7 260.9 0 208 0C108.6 0 25.6 69.7 4.9 162.8c-2.9 12.9 5.3 25.8 18.2 28.6c1.4 .3 2.7 .5 4.1 .5l2.3 0c10.5-.5 19.9-8 22.2-18.8C67.7 101.6 131.6 48 208 48zM386 224c-10.4 .7-19.4 8.1-21.8 18.8C348.4 314.4 284.4 368 208 368c-39.6 0-75.9-14.4-103.8-38.2L137 297c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8l-96 0c-13.3 0-24 10.7-24 24l0 96c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l29.2-29.2c36.7 32.5 85 52.2 137.8 52.2c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1c19.2-24.2 33.1-52.8 40-84c2.9-12.9-5.3-25.8-18.2-28.6c-1.2-.3-2.4-.4-3.6-.5l-3.2 0z',
  ],
};
const faGarageOpen = {
  prefix: 'far',
  iconName: 'garage-open',
  icon: [
    640,
    512,
    [],
    'e00b',
    'M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 320l0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-352 0zm0-48l352 0 0-32-352 0 0 32zm88 144l0 16 176 0 0-16c0-8.8-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16zm0 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-35.3 28.7-64 64-64l144 0c35.3 0 64 28.7 64 64l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-176 0z',
  ],
};
const faShelvesEmpty = {
  prefix: 'far',
  iconName: 'shelves-empty',
  icon: [
    640,
    512,
    [],
    'e246',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 184 0 440l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 544 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 0-256 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 160 48 24zm0 184l544 0 0 208L48 416l0-208z',
  ],
};
const faCruzeiroSign = {
  prefix: 'far',
  iconName: 'cruzeiro-sign',
  icon: [
    448,
    512,
    [],
    'e152',
    'M80 256c0-97 79.3-176 177.6-176c45.6 0 87 17 118.5 44.9c9.9 8.8 25.1 7.9 33.9-2s7.9-25.1-2-33.9C368 53.5 315.3 32 257.6 32C133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2C344.6 415 303.2 432 257.6 432c-6.3 0-12.5-.3-18.6-1c.7-2.2 1-4.6 1-7l0-104 0-1.8c0-21.1 17.1-38.2 38.2-38.2c10.1 0 19.9 4 27 11.2L311 297c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3c-14.1 0-27.4 3.4-39.2 9.4C236.2 231.3 227 224 216 224c-13.3 0-24 10.7-24 24l0 70.2 0 1.8 0 99.6C126.3 393.7 80 330.1 80 256z',
  ],
};
const faWatchApple = {
  prefix: 'far',
  iconName: 'watch-apple',
  icon: [
    384,
    512,
    [],
    'e2cb',
    'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faWatchCalculator = {
  prefix: 'far',
  iconName: 'watch-calculator',
  icon: [
    384,
    512,
    [],
    'f8f0',
    'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM104 160c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-176 0zM88 272a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM112 312a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z',
  ],
};
const faListDropdown = {
  prefix: 'far',
  iconName: 'list-dropdown',
  icon: [
    512,
    512,
    [],
    'e1cf',
    'M48 192l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224L48 192zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm436.7 0l-73.4 0c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7zM128 232l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCabinetFiling = {
  prefix: 'far',
  iconName: 'cabinet-filing',
  icon: [
    448,
    512,
    [128452],
    'f64b',
    'M400 232L48 232 48 64c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 168zM0 256l0 24L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-168 0-24 0-24 0-168c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 232l0 24zM400 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-168 352 0 0 168zM160 152l0-8 128 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1-17.9-40-40-40L152 96c-22.1 0-40 17.9-40 40l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24zm-8 184c-22.1 0-40 17.9-40 40l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 128 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1-17.9-40-40-40l-144 0z',
  ],
};
const faBurgerSoda = {
  prefix: 'far',
  iconName: 'burger-soda',
  icon: [
    640,
    512,
    [],
    'f858',
    'M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8-94.7 0L32 128l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12 0 48.2 0 89.9 0 35.8 0 89.9 0 48.2 0 12 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.2 0-79.6 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0zM60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c5.4 0 10.7-.9 15.5-2.6c-12.7-12.7-22.6-28.1-28.7-45.4l-154.5 0L86.8 208l-48.2 0L60.3 468zM449.9 240.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z',
  ],
};
const faSquareArrowUp = {
  prefix: 'far',
  iconName: 'square-arrow-up',
  icon: [
    448,
    512,
    ['arrow-square-up'],
    'f33c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm241 23l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47L248 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l88-88c9.4-9.4 24.6-9.4 33.9 0z',
  ],
};
const faArrowSquareUp = faSquareArrowUp;
const faGreaterThanEqual = {
  prefix: 'far',
  iconName: 'greater-than-equal',
  icon: [
    448,
    512,
    [],
    'f532',
    'M47 78.2c-12.3-5-18.2-19-13.2-31.3s19-18.2 31.3-13.2l336 136c9.1 3.7 15 12.5 15 22.2s-5.9 18.6-15 22.2L65 350.2c-12.3 5-26.3-1-31.3-13.2s1-26.3 13.2-31.3L328 192 47 78.2zM424 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0z',
  ],
};
const faPalletBox = {
  prefix: 'far',
  iconName: 'pallet-box',
  icon: [
    640,
    512,
    [],
    'e208',
    'M384 48l0 80c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 115.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-80-80 0 0 192 288 0 0-192-80 0zM128 48c0-26.5 21.5-48 48-48L464 0c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-192zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z',
  ],
};
const faFaceConfounded = {
  prefix: 'far',
  iconName: 'face-confounded',
  icon: [
    512,
    512,
    [],
    'e36c',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm231 77.3l25 20 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 343c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.8 7-21.2 7-30 0l-26.3-21L181.3 404c-9.5 6.3-22.2 5.1-30.3-3l-24-24c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l10.1 10.1L202.7 332c8.7-5.8 20.1-5.3 28.3 1.2zM133.5 178.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 189.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
  ],
};
const faShieldHalved = {
  prefix: 'far',
  iconName: 'shield-halved',
  icon: [
    512,
    512,
    ['shield-alt'],
    'f3ed',
    'M232 59.6l0 390.7C99.2 375.7 64.4 227.3 64 139.7c0-5 3.1-10.2 9-12.8L232 59.6zm48 390.8l0-390.8L439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 87.5-35.2 236-168 310.6zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2z',
  ],
};
const faShieldAlt = faShieldHalved;
const faTruckPlow = {
  prefix: 'far',
  iconName: 'truck-plow',
  icon: [
    640,
    512,
    [],
    'f7de',
    'M184 80l86.1 0c2.8 0 5.4 1.5 6.8 3.8L343 192l-167 0 0-104c0-4.4 3.6-8 8-8zM398.6 192c-.6-1.5-1.3-3.1-2.2-4.5L317.8 58.8C307.7 42.2 289.6 32 270.1 32L184 32c-30.9 0-56 25.1-56 56l0 104-72 0c-30.9 0-56 25.1-56 56l0 96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96l48 0c0 53 43 96 96 96s96-43 96-96l54.1 0 .1 .1 80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 358.7l0-141.4 73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1l0 128-32 0 0-88c0-30.9-25.1-56-56-56l-25.4 0zM432 312.4c-17-15.2-39.4-24.4-64-24.4c-35.5 0-66.6 19.3-83.2 48l-73.7 0c-16.6-28.7-47.6-48-83.2-48c-33.4 0-62.8 17-80 42.9L48 248c0-4.4 3.6-8 8-8l368 0c4.4 0 8 3.6 8 8l0 64.4zM80 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm288-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faBookAtlas = {
  prefix: 'far',
  iconName: 'book-atlas',
  icon: [
    448,
    512,
    ['atlas'],
    'f558',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM176.5 216l-31 0c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8l31 0zM112 200a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16l-31 0c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8l31 0c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216l-46.9 0c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32l46.9 0c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z',
  ],
};
const faAtlas = faBookAtlas;
const faVirus = {
  prefix: 'far',
  iconName: 'virus',
  icon: [
    512,
    512,
    [],
    'e074',
    'M75 75c12.5-12.5 32.8-12.5 45.3 0l8.2 8.2C163.7 118.4 224 93.4 224 43.5L224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 11.5c0 49.9 60.3 74.9 95.6 39.6l8.2-8.2c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-8.2 8.2c-35.3 35.3-10.3 95.6 39.6 95.6l11.5 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-11.5 0c-49.9 0-74.9 60.3-39.6 95.6l8.2 8.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-8.2-8.2c-35.3-35.3-95.6-10.3-95.6 39.6l0 11.5c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-11.5c0-49.9-60.3-74.9-95.6-39.6l-8.2 8.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l8.2-8.2C118.4 348.3 93.4 288 43.5 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l11.5 0c49.9 0 74.9-60.3 39.6-95.6L75 120.2C62.5 107.7 62.5 87.5 75 75zM256 99.6c-23.3 36.4-68.4 55.1-110.6 45.8c9.3 42.2-9.4 87.3-45.8 110.6c36.4 23.3 55.1 68.4 45.8 110.6c42.2-9.3 87.3 9.4 110.6 45.8c23.3-36.4 68.4-55.1 110.6-45.8c-9.3-42.2 9.4-87.3 45.8-110.6c-36.4-23.3-55.1-68.4-45.8-110.6c-21.2 4.7-43.1 2.3-62.6-5.8c-19.4-8.1-36.4-21.8-48-40zM192 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faGridRound2 = {
  prefix: 'far',
  iconName: 'grid-round-2',
  icon: [
    512,
    512,
    [],
    'e5db',
    'M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM336 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
  ],
};
const faCommentMiddleTop = {
  prefix: 'far',
  iconName: 'comment-middle-top',
  icon: [
    512,
    512,
    [],
    'e14a',
    'M231.3 124.8L256 75.3l24.7 49.5c6.5 12.9 18.4 22.3 32.5 25.4C407 171 464 237.3 464 304c0 79.5-83.3 160-208 160S48 383.5 48 304c0-66.7 57-133 150.7-153.8c14.1-3.1 26.1-12.5 32.5-25.4zm92.4-21.5l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z',
  ],
};
const faWave = {
  prefix: 'far',
  iconName: 'wave',
  icon: [
    576,
    512,
    [],
    'e65b',
    'M304 80c-83.9 0-152 68.1-152 152c0 66.3-53.7 120-120 120c-13.3 0-24-10.7-24-24s10.7-24 24-24c39.8 0 72-32.2 72-72c0-110.5 89.5-200 200-200c67.7 0 127.5 33.6 163.6 85c6.3 8.9 5.8 20.9-1.3 29.3s-18.8 10.9-28.6 6.2C426.3 147 413.5 144 400 144c-48.6 0-88 39.4-88 88c0 39.8 32.2 72 72 72c28.8 0 58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8c-66.3 0-120-53.7-120-120c0-66.9 48.3-122.6 112-133.9C354.6 86.6 330.1 80 304 80zM80 398.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z',
  ],
};
const faEnvelopeCircleCheck = {
  prefix: 'far',
  iconName: 'envelope-circle-check',
  icon: [
    640,
    512,
    [],
    'e4e8',
    'M64 112l384 0c8.8 0 16 7.2 16 16l0 22.1-22.6 18.5C458.6 163 477 160 496 160c5.4 0 10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l296.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 400c-8.8 0-16-7.2-16-16l0-171.8L190 328.8c37.7 31 91.8 31.5 130.1 1.5c.9-29.2 8.9-56.5 22.4-80.4l-50.9 41.8c-20.7 17-50.4 17-71.1 0L48 150.1 48 128c0-8.8 7.2-16 16-16zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faLayerGroup = {
  prefix: 'far',
  iconName: 'layer-group',
  icon: [
    576,
    512,
    [],
    'f5fd',
    'M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z',
  ],
};
const faRestroomSimple = {
  prefix: 'far',
  iconName: 'restroom-simple',
  icon: [
    640,
    512,
    [],
    'e23a',
    'M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208l44.8 0c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3l-2.4 0-80 0-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352l32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136zM320 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM576 64A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM496.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L576.4 336l-128.7 0 33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z',
  ],
};
const faArrowsToDot = {
  prefix: 'far',
  iconName: 'arrows-to-dot',
  icon: [
    512,
    512,
    [],
    'e4be',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L201 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 24zM433 345c9.4-9.4 9.4-24.6 0-33.9l-31-31 86.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0 31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM113 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L79 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zM167 433c9.4 9.4 24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9z',
  ],
};
const faBorderOuter = {
  prefix: 'far',
  iconName: 'border-outer',
  icon: [
    448,
    512,
    [],
    'f851',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
  ],
};
const faHashtagLock = {
  prefix: 'far',
  iconName: 'hashtag-lock',
  icon: [
    576,
    512,
    [],
    'e415',
    'M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136l111 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136l71.5 0c13.3 0 24 10.7 24 24c0 .4 0 .8 0 1.1c-19.9 2.9-38.2 11-53.3 22.9l-51.8 0L287.5 460.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144L56 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l87.5 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144-111 0zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faClockTwoThirty = {
  prefix: 'far',
  iconName: 'clock-two-thirty',
  icon: [
    512,
    512,
    [],
    'e35b',
    'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-136c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8 280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faArchway = {
  prefix: 'far',
  iconName: 'archway',
  icon: [
    512,
    512,
    [],
    'f557',
    'M0 56C0 42.7 10.7 32 24 32l32 0 400 0 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 352 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-32 0-64 0c-13.3 0-24-10.7-24-24l0-120c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 120c0 13.3-10.7 24-24 24l-64 0-32 0-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 32 352 0 0-32L80 80zm0 80l0 272 8 0 40 0 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96 40 0 8 0 0-272L80 160z',
  ],
};
const faHeartCircleCheck = {
  prefix: 'far',
  iconName: 'heart-circle-check',
  icon: [
    576,
    512,
    [],
    'e4fd',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faHouseChimneyCrack = {
  prefix: 'far',
  iconName: 'house-chimney-crack',
  icon: [
    576,
    512,
    ['house-damage'],
    'f6f1',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l85.9 0-30.3-48.1c-4.4-6.9-2.8-16 3.6-21.1L288 327.6l-58.1-76.1c-11.3-14.8 7.4-33.6 22.3-22.5l115.2 86.2c8.4 6.3 8.6 18.8 .4 25.3L288 403.8 325.9 464 432 464c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8z',
  ],
};
const faHouseDamage = faHouseChimneyCrack;
const faFileZipper = {
  prefix: 'far',
  iconName: 'file-zipper',
  icon: [
    384,
    512,
    ['file-archive'],
    'f1c6',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l48 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l48 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm48 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM128 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faFileArchive = faFileZipper;
const faTicketPerforated = {
  prefix: 'far',
  iconName: 'ticket-perforated',
  icon: [
    640,
    512,
    [],
    'e63e',
    'M48 128c0-8.8 7.2-16 16-16l512 0c8.8 0 16 7.2 16 16l0 35c-41.4 10.7-72 48.2-72 93s30.6 82.3 72 93l0 35c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-61.3c0-11.2-12.8-18.7-24-18.7c-26.5 0-48-21.5-48-48s21.5-48 48-48c11.2 0 24-7.5 24-18.7l0-61.3c0-35.3-28.7-64-64-64L64 64zm384 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faHeartHalf = {
  prefix: 'far',
  iconName: 'heart-half',
  icon: [
    512,
    512,
    [],
    'e1ab',
    'M236.7 476.9c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5l0-12.3 0-22.4 0-4.6L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L208 450.1l3.3 3.1 16.4 15.3 9 8.4zM208 384.5L80.3 265.3C59.7 246.1 48 219.1 48 190.9l0-5.8c0-46.4 33.6-86 79.3-93.6c29.3-4.9 59.1 4.2 80.7 24.5l0 268.5z',
  ],
};
const faCommentCheck = {
  prefix: 'far',
  iconName: 'comment-check',
  icon: [
    512,
    512,
    [],
    'f4ac',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM369 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 193z',
  ],
};
const faSquare = {
  prefix: 'far',
  iconName: 'square',
  icon: [
    448,
    512,
    [9632, 9723, 9724, 61590],
    'f0c8',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faMemo = {
  prefix: 'far',
  iconName: 'memo',
  icon: [
    384,
    512,
    [],
    'e1d8',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm120 64l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMartiniGlassEmpty = {
  prefix: 'far',
  iconName: 'martini-glass-empty',
  icon: [
    512,
    512,
    ['glass-martini'],
    'f000',
    'M0 35.3C0 15.8 15.8 0 35.3 0L476.7 0C496.2 0 512 15.8 512 35.3c0 9.4-3.7 18.3-10.3 25L280 281.9 280 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-182.1L10.3 60.3C3.7 53.7 0 44.7 0 35.3zM256 238.1L446.1 48 65.9 48 256 238.1z',
  ],
};
const faGlassMartini = faMartiniGlassEmpty;
const faCouch = {
  prefix: 'far',
  iconName: 'couch',
  icon: [
    640,
    512,
    [],
    'f4b8',
    'M448 80L192 80c-44.2 0-80 35.8-80 80l0 40c-12.3-5.1-25.8-8-40-8c-2.7 0-5.4 .1-8 .3L64 160C64 89.3 121.3 32 192 32l256 0c70.7 0 128 57.3 128 128l0 32.3c-2.6-.2-5.3-.3-8-.3c-14.2 0-27.7 2.8-40 8l0-40c0-44.2-35.8-80-80-80zM568 224c2.7 0 5.4 .1 8 .4c36 4 64 34.5 64 71.6l0 136c0 26.5-21.5 48-48 48l-48 0c-20.9 0-38.7-13.4-45.3-32l-357.5 0c-6.6 18.6-24.4 32-45.3 32l-48 0c-26.5 0-48-21.5-48-48L0 296c0-37.1 28-67.6 64-71.6c2.6-.3 5.3-.4 8-.4c15.2 0 29.4 4.7 41 12.8c16.7 11.6 28.2 30 30.5 51.2l352.9 0c2.3-21.2 13.9-39.6 30.5-51.2c11.6-8.1 25.8-12.8 41-12.8zm-24 72l0 40 0 64 0 32 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM496 400l0-64-352 0 0 64 352 0zM96 400l0-64 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136 48 0 0-32z',
  ],
};
const faCediSign = {
  prefix: 'far',
  iconName: 'cedi-sign',
  icon: [
    384,
    512,
    [],
    'e0df',
    'M216 0c13.3 0 24 10.7 24 24l0 48.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7c-20.9-14.8-46.3-24.5-74.1-27l0 270.8c27.8-2.5 53.2-12.2 74.1-27c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5l0 48.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-50.8C102 422 32 347.7 32 256s70-166 160-181.2L192 24c0-13.3 10.7-24 24-24zM80 256c0 63.2 47 117.9 112 132.3l0-264.6C127 138.1 80 192.8 80 256z',
  ],
};
const faItalic = {
  prefix: 'far',
  iconName: 'italic',
  icon: [
    384,
    512,
    [],
    'f033',
    'M128 56c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-68.7 0L144.7 432l87.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l68.7 0L239.3 80 152 80c-13.3 0-24-10.7-24-24z',
  ],
};
const faGlassCitrus = {
  prefix: 'far',
  iconName: 'glass-citrus',
  icon: [
    512,
    512,
    [],
    'f869',
    'M464 144c0-53-43-96-96-96c-35.5 0-66.6 19.3-83.2 48l-52.6 0C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.7 142.2-140.7 144l4.6-48.3c49.3-4 88.1-45.3 88.1-95.7zM6.2 135.9c4.5-5 11-7.9 17.8-7.9l304 0c6.8 0 13.2 2.9 17.8 7.9s6.8 11.7 6.1 18.4l-29.2 307c-2.7 28.7-26.9 50.7-55.7 50.7L85.1 512c-28.9 0-53-21.9-55.7-50.7L.1 154.3c-.6-6.7 1.6-13.4 6.1-18.4zM62.6 304L77.1 456.8c.4 4.1 3.8 7.2 8 7.2l181.8 0c4.1 0 7.6-3.1 8-7.2L289.4 304 62.6 304zM58 256l236 0 7.6-80L50.4 176 58 256z',
  ],
};
const faCalendarLinesPen = {
  prefix: 'far',
  iconName: 'calendar-lines-pen',
  icon: [
    576,
    512,
    [],
    'e472',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-48 0-16 0L48 192l0 256c0 8.8 7.2 16 16 16l198.5 0-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zm-8 256l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 376c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faTableCellsColumnLock = {
  prefix: 'far',
  iconName: 'table-cells-column-lock',
  icon: [
    640,
    512,
    [],
    'e678',
    'M448 80c8.8 0 16 7.2 16 16l0 72-104 0 0-88 88 0zM200 80l112 0 0 88-112 0 0-88zM312 432l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 296l0-80 112 0 0 80-112 0zm328-56c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faChurch = {
  prefix: 'far',
  iconName: 'church',
  icon: [
    640,
    512,
    [9962],
    'f51d',
    'M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 26.9L192.9 189.7c-20.5 13.3-32.9 36-32.9 60.4L160 464l-88 0c-13.3 0-24-10.7-24-24l0-69.9c0-8.1 4.1-15.7 11-20.2l69-44.7 0-57.2L32.9 309.7C12.4 322.9 0 345.7 0 370.1L0 440c0 39.8 32.2 72 72 72l120 0s0 0 0 0l256 0 8 0 112 0c39.8 0 72-32.2 72-72l0-69.9c0-24.4-12.4-47.2-32.9-60.4L512 248.1l0 57.2L581 350c6.8 4.4 11 12 11 20.1l0 69.9c0 13.3-10.7 24-24 24l-88 0 0-213.9c0-24.4-12.4-47.2-32.9-60.4L344 122.9 344 96l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM320 164.6L421 230c6.8 4.4 11 12 11 20.1L432 464l-64 0 0-96c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96-64 0 0-213.9c0-8.1 4.1-15.7 11-20.1l101-65.4z',
  ],
};
const faPersonSnowmobiling = {
  prefix: 'far',
  iconName: 'person-snowmobiling',
  icon: [
    640,
    512,
    ['snowmobile'],
    'f7d1',
    'M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm99.7 75.4c11.4-6.8 26.1-3.1 32.9 8.2l46.8 78.1 138.9 69.4c10.8 5.4 17.7 16.5 17.7 28.6l0 59.1c0 10.7-5.3 20.7-14.2 26.6L492 392l54 72 20.1 0 33-33c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-40 40c-4.5 4.5-10.6 7-17 7l-136 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l46 0-48-64-124.7 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l8-16 31.2-62.3C76.6 278.8 87.7 272 99.8 272L288 272l24-32-32 0c-7.6 0-14.7-3.6-19.2-9.6l-33.4-44.5c-4.7-6.2-12-9.9-19.8-9.9c-9.8 0-18.6 5.7-22.6 14.7l-19.1 43.1c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l19.1-43.1c11.7-26.3 37.7-43.2 66.4-43.2c22.9 0 44.4 10.8 58.2 29.1L292 192l56 0 18.7-24.9-35.3-58.8c-6.8-11.4-3.1-26.1 8.2-32.9zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 400zm160-48l225.5 0L528 310.3l0-40.6L398.4 204.8l-72 96L312 320l-24 0-178.3 0-16 32L240 352z',
  ],
};
const faSnowmobile = faPersonSnowmobiling;
const faFaceHushed = {
  prefix: 'far',
  iconName: 'face-hushed',
  icon: [
    512,
    512,
    [],
    'e37b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faCommentsDollar = {
  prefix: 'far',
  iconName: 'comments-dollar',
  icon: [
    640,
    512,
    [],
    'f653',
    'M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM224 83.6l0 13.8c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.2 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2s0 0 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8l0 13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-14.3c-9.7-1.9-18.8-5-26.7-7.7c0 0 0 0 0 0s0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2c0 0 0 0 0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4s0 0 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6l0-13.9c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faTicketsSimple = {
  prefix: 'far',
  iconName: 'tickets-simple',
  icon: [
    640,
    512,
    [],
    'e659',
    'M144 96c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16l0 38.2c-24 15.7-40 42.8-40 73.8s16 58.1 40 73.8l0 38.2c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-38.2c24-15.7 40-42.8 40-73.8s-16-58.1-40-73.8L144 96zM96 96l0 56c0 8.8 7.4 15.7 15.6 19.1c14.4 6.1 24.4 20.3 24.4 36.9s-10.1 30.8-24.4 36.9C103.4 248.3 96 255.2 96 264l0 56c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z',
  ],
};
const faPickaxe = {
  prefix: 'far',
  iconName: 'pickaxe',
  icon: [
    512,
    512,
    [],
    'e5bf',
    'M460.3 112.6c47.6 66.4 63.4 152.5 42 231.5c-.3 .9-.5 1.9-.8 2.8c-1.3 4.4-2.6 8.9-4.1 13.2l-.2 .6c-1.5 4.5-3.2 8.9-5 13.3c-5.4 13.3-24.9 13-29.8-.5c-1.8-4.6-3.6-9.3-5.6-13.9c-1.6-3.7-3.2-7.4-4.9-11.1l-.8-1.7c-28.4-62.2-70.9-119.9-118.5-167.6C285.3 131.9 227.5 88.9 165.3 60.8l-1.7-.8c-3.7-1.7-7.5-3.3-11.3-4.9c-4.6-1.9-9.2-3.7-13.8-5.5c-13.4-5-13.7-24.5-.5-29.8c4.4-1.8 8.8-3.4 13.3-5l.2-.1c4.5-1.5 9-2.9 13.5-4.2c1-.3 2-.5 2.9-.8c78.9-21.3 165-5.5 231.3 42.1l9.5-9.9c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.9 9.5zm-62.2 .7C357 72.3 301 49.8 244.2 48.4c45.4 27.7 86.9 61.4 122.4 97c35.9 35.9 69.4 77.5 97 122.8c-1.3-57.2-24.1-113.6-65.5-154.8zM8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4S-3.1 470.4 8.9 457.8z',
  ],
};
const faLinkSimpleSlash = {
  prefix: 'far',
  iconName: 'link-simple-slash',
  icon: [
    640,
    512,
    [],
    'e1ce',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0c61.9 0 112 50.1 112 112c0 46.6-28.5 86.6-69.1 103.5L389.5 280l34.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-95.7 0L216 144l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zm69.6 176.3L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-61.9 0-112-50.1-112-112c0-28.6 10.7-54.8 28.4-74.6z',
  ],
};
const faDemocrat = {
  prefix: 'far',
  iconName: 'democrat',
  icon: [
    640,
    512,
    [],
    'f747',
    'M102.2 4.7C99.8 11.1 96 23.1 96 32c0 12.7 5 22.8 11.1 30.5c-5.3 3.6-10.2 7.9-14.7 12.6l-70.6 76C7.8 166.2 0 186.1 0 206.6C0 251.4 36.2 288 81.2 288c13.8 0 27.4-3.5 39.4-10.2L157 257.5l35 75.7L192 456c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-24 96 0 0 24c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-128 0-112c0-1.4 0-2.8-.1-4.2c5.5 5.7 9.9 11.1 13.2 15.4c2.2 2.9 3.9 5.4 5 7c.5 .8 .9 1.4 1.1 1.8l.2 .3s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c6.8 11.3 21.5 15.1 32.9 8.3c11.4-6.8 15.1-21.5 8.4-32.9L616 224c20.6-12.3 20.6-12.3 20.6-12.3s0 0 0 0s0 0 0 0l-.1-.1-.2-.3-.5-.8c-.4-.7-1-1.6-1.8-2.8c-1.5-2.3-3.8-5.5-6.6-9.3c-5.7-7.6-14.2-17.7-25.1-27.9c-21.5-20-55.1-42.4-98.3-42.4c-1.9 0-3.7 .2-5.5 .6c-3.5-.4-7-.6-10.5-.6l-196.9 0c-1.8 0-3.5-.6-5-1.7L209.9 66.1c7.3-8 14.1-19.3 14.1-34.1c0-8.9-3.8-20.9-6.2-27.3C216.8 1.8 214 0 211 0c-1.9 0-3.8 .7-5.2 2.1L160 45.7 114.2 2.1C112.8 .7 110.9 0 109 0c-3 0-5.8 1.8-6.8 4.7zM240 352l288 0 0 104c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-48c0-13.3-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24l0 48c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-104zm288-48l-296.6 0-41.6-90.1c-2.8-6.1-8-10.7-14.3-12.8s-13.3-1.4-19.1 1.8l-59 32.8c-4.9 2.7-10.5 4.2-16.1 4.2C63 240 48 225.1 48 206.6c0-8.5 3.2-16.7 8.9-22.8l70.6-76c7.1-7.7 17.1-12.2 27.5-12.4c9.1-.2 17.9 2.7 25 8.3L256.4 164c9.9 7.8 22.1 12 34.7 12L488 176c22.1 0 40 17.9 40 40l0 88zM379.3 210.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4zM279.5 208c-1.6 0-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4c-.7-1.4-2.2-2.3-3.8-2.3zm195.8 2.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4z',
  ],
};
const faFaceConfused = {
  prefix: 'far',
  iconName: 'face-confused',
  icon: [
    512,
    512,
    [],
    'e36d',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.2 385.6l-12.8 9.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l12.8-9.6c37.4-28 82.9-43.2 129.6-43.2l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faPinball = {
  prefix: 'far',
  iconName: 'pinball',
  icon: [
    448,
    512,
    [],
    'e229',
    'M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM312 408L126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8c0 0 0 0 .1 0L312 408zM66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faZ = {
  prefix: 'far',
  iconName: 'z',
  icon: [
    384,
    512,
    [122],
    '5a',
    'M0 56C0 42.7 10.7 32 24 32l336 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.4-3.4 25.6L75.5 432 360 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L308.5 80 24 80C10.7 80 0 69.3 0 56z',
  ],
};
const faPersonSkiing = {
  prefix: 'far',
  iconName: 'person-skiing',
  icon: [
    512,
    512,
    [9975, 'skiing'],
    'f7c9',
    'M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L239.8 365l49.6-74.5-82.7-87.9c-9.5-10.1-14.4-22.4-15.1-34.9l87.7 42 49.4 52.5c12.8 13.6 14.5 34.1 4.2 49.6l-50.2 75.4 135.8 70.5c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 55.5 26.6c1.7-.9 3.5-1.7 5.4-2.5l80.9-32.4c32.4-13 68.6 6.5 75.6 40.7l12.3 59.7 62.9 30.1c12 5.7 17 20 11.3 32s-20 17-32 11.3l-54.2-25.9c-1-.3-1.9-.6-2.8-1l-229.1-110-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5zm217.3 64.7c-1-4.9-6.2-7.7-10.8-5.8l-45.7 18.3 65.5 31.5-9-43.9z',
  ],
};
const faSkiing = faPersonSkiing;
const faDeer = {
  prefix: 'far',
  iconName: 'deer',
  icon: [
    512,
    512,
    [129420],
    'f78e',
    'M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 24 0-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18l28.2 0L295 168l-191 0c-36.5 0-68.3 20.4-84.5 50.4c-9.2 13.7-15.1 30-16.2 47.6L0 319c-.6 8.8 6.2 16.4 15 17c8.5 .5 15.9-5.7 16.9-14.1l1.1 1.1c4.5 4.5 7 10.6 7 17l0 4.3c0 2.6-.4 5.1-1.2 7.6l-8.2 24.7c-5.1 15.4-4.9 32.1 .6 47.4l22.5 61.8C59.4 501.5 74.4 512 91.2 512l46 0c27.8 0 47.1-27.6 37.6-53.7L157 409.5l6.5-4.3c15.2-10.1 25.6-25.4 29.9-42.4c20 8.7 41.7 13.3 63.8 13.3l6.8 0 0 96c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-160.2c0-2.6 .4-5.1 1.2-7.6L409.3 256l42.3 0c37.8 0 68.4-30.6 68.4-68.4c0-19.3-8.1-37.6-22.4-50.6L444.1 88.4C460.8 78.7 472 60.7 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-29.9 0-39.5 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zm130.1 96c8.1 0 15.9 3 21.9 8.5l57.3 52.1c4.2 3.9 6.7 9.3 6.7 15.1c0 11.3-9.1 20.4-20.4 20.4L392 208c-10.3 0-19.5 6.6-22.8 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8L344 464l-32 0 0-112c0-13.3-10.7-24-24-24l-30.8 0c-22.1 0-43.7-6.5-62.1-18.8L181.3 300c-8-5.3-18.3-5.4-26.3-.2s-12.2 14.7-10.6 24.1l2.9 17.4c1.6 9.3-2.5 18.7-10.4 23.9L114.7 380c-9.2 6.1-13 17.8-9.2 28.2L125.7 464l-28.9 0L76.3 407.5c-1.9-5.1-1.9-10.7-.2-15.8L84.3 367c2.4-7.3 3.7-15 3.7-22.8l0-4.3c0-19.1-7.6-37.4-21.1-50.9L63 285.1c-4.5-4.5-7-10.6-7-17l0-4.1c0-26.5 21.5-48 48-48l208.9 0c10.6 0 20-7 23-17.1l19-63.6c4.1-13.8 16.8-23.2 31.2-23.2zM416 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faInputPipe = {
  prefix: 'far',
  iconName: 'input-pipe',
  icon: [
    640,
    512,
    [],
    'e1be',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm144 56l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faRoadLock = {
  prefix: 'far',
  iconName: 'road-lock',
  icon: [
    640,
    512,
    [],
    'e567',
    'M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480L384 480l0-48-40 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l28.3 78.5c13.8-7.8 29.4-12.7 46-14L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM344 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm184 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faA = {
  prefix: 'far',
  iconName: 'a',
  icon: [
    384,
    512,
    [97],
    '41',
    'M214.1 46.7C210.4 37.8 201.7 32 192 32s-18.4 5.8-22.1 14.7l-168 400c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L80.3 384l223.5 0 34.1 81.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4l-168-400zM283.6 336l-183.1 0L192 118l91.6 218z',
  ],
};
const faBookmarkSlash = {
  prefix: 'far',
  iconName: 'bookmark-slash',
  icon: [
    640,
    512,
    [],
    'e0c2',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-328c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48l0 27L38.8 5.1zM176 112.6L176 48l288 0 0 290.4L176 112.6zM509.9 497.8L315.3 344.5c-3.3 .6-6.5 2-9.3 4L176 441.4l0-206.7-48-37.8L128 488c0 9 5 17.2 13 21.3s17.6 3.4 24.9-1.8L320 397.5l154.1 110c7.3 5.2 16.9 5.9 24.9 1.8c4.9-2.5 8.8-6.7 10.9-11.6z',
  ],
};
const faTemperatureArrowDown = {
  prefix: 'far',
  iconName: 'temperature-arrow-down',
  icon: [
    576,
    512,
    ['temperature-down'],
    'e03f',
    'M176 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L240 112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L64 112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3zM448 480c-6.8 0-13.3-2.9-17.8-7.9l-72-80c-8.9-9.9-8.1-25 1.8-33.9s25-8.1 33.9 1.8L424 393.5 424 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 337.5 30.2-33.5c8.9-9.9 24-10.7 33.9-1.8s10.7 24 1.8 33.9l-72 80c-4.6 5.1-11 7.9-17.8 7.9z',
  ],
};
const faTemperatureDown = faTemperatureArrowDown;
const faMace = {
  prefix: 'far',
  iconName: 'mace',
  icon: [
    512,
    512,
    [],
    'f6f8',
    'M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-12.4-4.1-24-10-34.5-17.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L176.4 301.7c-7.3-10.5-13.2-22.1-17.4-34.5l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 312a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm-32-88a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faFeatherPointed = {
  prefix: 'far',
  iconName: 'feather-pointed',
  icon: [
    512,
    512,
    ['feather-alt'],
    'f56b',
    'M117.7 343.9c-11.2-41.4-11.7-113 53.7-178.3c38.1-38.1 93.7-66.3 152.8-85.7c50.6-16.7 100.7-26 138.3-30.3c-4.3 37.6-13.6 87.7-30.3 138.3c-2.2 6.8-4.6 13.5-7 20.1l-87.2 0 7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L122.8 355.2c-2.6-4.1-4.2-7.9-5.1-11.3zm4.6 79.7c10 7.6 21 13.7 33.3 17c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c3.3 12.2 9.4 23.2 17 33.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l81.3-81.3zm34.5-34.5L193.9 352l140.4 0c-61.9 53.9-127.3 52.9-166.2 42.3c-3.5-.9-7.2-2.6-11.3-5.2zm220-85.2l-134.8 0 48-48 114.7 0c-8.4 17-17.7 33.2-27.9 48z',
  ],
};
const faFeatherAlt = faFeatherPointed;
const faSausage = {
  prefix: 'far',
  iconName: 'sausage',
  icon: [
    512,
    512,
    [],
    'f820',
    'M447.5 69.3l15.2-41.9c.8-2.2 1.2-4.6 1.2-7C464 9.1 454.9 0 443.6 0L388.4 0C377.1 0 368 9.1 368 20.4c0 2.4 .4 4.7 1.2 7l15.2 41.9C346.9 82.3 320 118 320 160c0 88.4-71.6 160-160 160c-42 0-77.7 26.9-90.7 64.5L27.4 369.2c-2.2-.8-4.6-1.2-7-1.2C9.1 368 0 377.1 0 388.4l0 55.2C0 454.9 9.1 464 20.4 464c2.4 0 4.7-.4 7-1.2l41.9-15.2C82.3 485.1 118 512 160 512c194.4 0 352-157.6 352-352c0-42-26.9-77.7-64.5-90.7zM112 416c0-26.5 21.5-48 48-48c114.9 0 208-93.1 208-208c0-26.5 21.5-48 48-48s48 21.5 48 48c0 167.9-136.1 304-304 304c-26.5 0-48-21.5-48-48z',
  ],
};
const faTrashCanClock = {
  prefix: 'far',
  iconName: 'trash-can-clock',
  icon: [
    576,
    512,
    [],
    'e2aa',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 64.7c-16.8 1.5-32.9 5.4-48 11.3l0-76L80 128l0 304c0 17.7 14.3 32 32 32l172.5 0c12.3 18.8 28 35.1 46.3 48L112 512c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM320 192l0 40.2c-12.1 10-22.9 21.7-32 34.6l0-74.8c0-8.8 7.2-16 16-16s16 7.2 16 16zm-160 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm48 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
  ],
};
const faP = {
  prefix: 'far',
  iconName: 'p',
  icon: [
    320,
    512,
    [112],
    '50',
    'M56 80l112 0c57.4 0 104 46.6 104 104s-46.6 104-104 104L48 288 48 88c0-4.4 3.6-8 8-8zM48 336l120 0c83.9 0 152-68.1 152-152s-68.1-152-152-152L56 32C25.1 32 0 57.1 0 88L0 312 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120z',
  ],
};
const faBroomWide = {
  prefix: 'far',
  iconName: 'broom-wide',
  icon: [
    512,
    512,
    [],
    'e5d1',
    'M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 143l-12.9-12.9c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3L369 177 505 41zM323.6 291.6l-90 162.1L137 357.1l18-53.9c2.1-6.3-3.9-12.2-10.1-10.1L90.9 311 58.4 278.5l162.1-90L323.6 291.6z',
  ],
};
const faSnowflake = {
  prefix: 'far',
  iconName: 'snowflake',
  icon: [
    448,
    512,
    [10052, 10054],
    'f2dc',
    'M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z',
  ],
};
const faStomach = {
  prefix: 'far',
  iconName: 'stomach',
  icon: [
    512,
    512,
    [],
    'f623',
    'M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72c0 66.3 53.7 120 120 120l.2 0c-.2 2.6-.2 5.3-.2 8l0 64c0 39.8-32.2 72-72 72l-64 0C53.7 360 0 413.7 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3 28.7-64 64-64c9.6 0 19 3.5 30.6 11.1c8.8 5.7 17.1 12.6 26.9 20.7c4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192l0-96c0-70.7-57.3-128-128-128c-50.6 0-94.4 29.4-115.1 72L256 168c-39.8 0-72-32.2-72-72l0-72zm18 388.3c-2-1.6-4-3.3-6-4.9c46.2-4.6 84.6-35.4 100.4-77.3c12.2-6.9 22.6-8 32.7-6.6c12.4 1.7 24.9 7.1 41.1 14.4l1.2 .6c14.8 6.6 33.1 14.8 53 17.6c11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7c-3.5-2.8-7.2-5.8-10.9-8.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0zM464 301.6c-12.4 7.1-22.9 8.2-33.1 6.8c-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6c-10.3-1.4-20.8-1.4-31.6 .7l0-52.7c0-44.2 35.8-80 80-80s80 35.8 80 80l0 77.6z',
  ],
};
const faNewspaper = {
  prefix: 'far',
  iconName: 'newspaper',
  icon: [
    512,
    512,
    [128240],
    'f1ea',
    'M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faRectangleAd = {
  prefix: 'far',
  iconName: 'rectangle-ad',
  icon: [
    576,
    512,
    ['ad'],
    'f641',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm229.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328l-90.3 0-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280l42.3 0L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z',
  ],
};
const faAd = faRectangleAd;
const faGuitarElectric = {
  prefix: 'far',
  iconName: 'guitar-electric',
  icon: [
    512,
    512,
    [127928],
    'f8be',
    'M352 126.1l0-44.9c0-10.7 5.3-20.7 14.2-26.6L435.6 8.3C443.7 2.9 453.2 0 462.9 0L464 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-14.1 0L314.4 231.6c9.1 8.1 13.8 8.4 14.9 8.4c2.6 .1 4.3-.6 10.9-3.5l3.7-1.6c13.2-5.6 36-8.3 52.3 8.2c15.8 15.9 15.8 41.7 0 57.6l-21.6 21.8c-12.2 12.3-28.2 18.8-38.7 23l-2.1 .8c-5.5 2.2-12.7 6.3-20.3 14c-17.3 17.5-23.7 39.4-30.6 63.5c-.9 3-1.7 6-2.6 9.1c-5.2 17.5-14.1 35-28.1 49.2c-39.4 39.9-103.5 39.9-142.9 0L29.5 401.3c-39.3-39.7-39.3-104 0-143.7c14.1-14.2 31.4-23.3 48.8-28.5c2.9-.9 5.7-1.7 8.6-2.6c0 0 0 0 0 0c23.9-7.1 45.6-13.5 63-31.1c6.3-6.3 10.1-12.4 12.5-17.5c.8-1.8 1.8-3.8 2.8-6c5.4-11.9 13.1-29.1 25.6-41.7l29.9-30.2c15.9-16.1 41.8-16.1 57.7 0c16.1 16.3 14.2 39.7 5.2 54.6c-1.1 1.8-2.1 3.4-3 4.9c0 0 0 0 0 0c-4.9 8-7.8 12.7-8.8 18.2c-.6 3.2-1 9.2 8.7 19.8L352 126.1zM167 263c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zM242.4 129.8s0 0 0 0s0 0 0 0c0 0 0 0 0-.1zm-18 39.8c.4-2.3 .9-4.5 1.5-6.7l-1.2 1.2c-5.9 5.9-9.4 13.5-14.7 25.1c0 0 0 0 0 0c-1.3 2.9-2.8 6-4.4 9.4c-4.6 9.6-11.5 20.2-21.7 30.6c-26.7 27-60.7 36.8-83.8 43.5c0 0 0 0 0 0c-2.8 .8-5.5 1.6-7.9 2.3c-11.5 3.5-21.3 9-28.6 16.4c-20.8 21-20.8 55.2 0 76.2l79.9 80.8c20.6 20.9 54 20.9 74.6 0c7.3-7.4 12.8-17.4 16.3-29.1c.8-2.6 1.5-5.3 2.4-8.2c6.6-23.3 16.2-57.6 42.8-84.4c12.5-12.6 25.3-20.2 36.2-24.7c12.9-5.2 20-8.4 24.7-13.2l2.3-2.4c-4.6 1.1-9.7 1.7-15 1.6c-18-.5-35-9.6-52.1-26.9c0 0 0 0 0 0L248 233.2c0 0 0 0-.1-.1c-20.4-20.6-27.2-42.3-23.5-63.5z',
  ],
};
const faArrowTurnDownRight = {
  prefix: 'far',
  iconName: 'arrow-turn-down-right',
  icon: [
    512,
    512,
    [],
    'e3d6',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 224c0 48.6 39.4 88 88 88l342.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9L377 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L88 264c-22.1 0-40-17.9-40-40L48 56z',
  ],
};
const faMoonCloud = {
  prefix: 'far',
  iconName: 'moon-cloud',
  icon: [
    640,
    512,
    [],
    'f754',
    'M635.2 416.6c-2.6 2.5-5.2 5-7.9 7.3c-4.5 4-9.1 7.8-13.9 11.4c-1.8 1.4-3.7 2.7-5.5 4C571.5 465 527.2 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c11.6-12 20.3-26.9 25-43.4C380.2 409 427.2 432 479.5 432c13.3 0 26.2-1.5 38.6-4.3C430.5 397.4 367.6 314 367.6 216c0-43 12.1-83.2 33.1-117.3C343.4 127.6 304 187.1 304 256l0 .3c-13.9-8.9-30.1-14.6-47.5-16c7.6-110.9 95.8-199.6 206.3-207.7c2.3-.2 4.6-.3 6.9-.4c3.2-.1 6.5-.2 9.8-.2c2.7 0 5.5 0 8.2 .1c3.6 .1 7.2 .3 10.7 .6c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-3.2 1.8-6.4 3.8-9.6 5.8c-4.3 2.8-8.5 5.8-12.5 9c-1.1 .8-2.1 1.7-3.2 2.6c-39.2 32.3-64.1 81.2-64.1 136c0 97.1 78.5 175.8 175.2 176l.3 0c1.2 0 2.5 0 3.7 0c5.2-.1 10.3-.4 15.3-1c3.7-.4 7.4-.9 11.1-1.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7zM64 416c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72L64 416z',
  ],
};
const faBreadSliceButter = {
  prefix: 'far',
  iconName: 'bread-slice-butter',
  icon: [
    512,
    512,
    [],
    'e3e1',
    'M112 256l0 176 288 0 0-176c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16c0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16c26.5 0 48 21.5 48 48zm336 0l0 48 0 128c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-128 0-48c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zm-265.4 9.4l50.7-50.7c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3z',
  ],
};
const faCircleArrowRight = {
  prefix: 'far',
  iconName: 'circle-arrow-right',
  icon: [
    512,
    512,
    ['arrow-circle-right'],
    'f0a9',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM305 361l88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L136 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l182.1 0-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z',
  ],
};
const faArrowCircleRight = faCircleArrowRight;
const faUserGroupCrown = {
  prefix: 'far',
  iconName: 'user-group-crown',
  icon: [
    640,
    512,
    ['users-crown'],
    'f6a5',
    'M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zm-.1-124.9l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5L336 0c8.8 0 16 7.2 16 16l0 23 0 3.2c0 0 0 .1 0 .1L352 144c0 70.7-57.3 128-128 128s-128-57.3-128-128L96 42.3c0 0 0-.1 0-.1L96 39l0-23c0-8.8 7.2-16 16-16l2.4 0c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6zM48.3 464l351.5 0c-4.1-62.5-56.2-112-119.7-112l-112 0c-63.6 0-115.6 49.5-119.7 112zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8zM432 256c-27.7 0-53-10.1-72.6-26.7c.5-.8 1-1.5 1.4-2.3c12.1-19.9 20-42.6 22.4-67c.5-5.3 .8-10.6 .8-16l0-101.2C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z',
  ],
};
const faUsersCrown = faUserGroupCrown;
const faCircleI = {
  prefix: 'far',
  iconName: 'circle-i',
  icon: [
    512,
    512,
    [],
    'e111',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 160-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-160 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-72 0z',
  ],
};
const faToiletPaperCheck = {
  prefix: 'far',
  iconName: 'toilet-paper-check',
  icon: [
    640,
    512,
    [],
    'e5b2',
    'M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7c0 0 0 0 0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0L492.2 0c0 0 0 .1 0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464l260.1 0c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48L160 48zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-204.7-4.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L232 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faFilterCircleXmark = {
  prefix: 'far',
  iconName: 'filter-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e17b',
    'M0 41.7C0 18.7 18.7 0 41.7 0L469.9 0C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48 55 48 218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 68C3.3 60.6 0 51.3 0 41.7zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z',
  ],
};
const faLocust = {
  prefix: 'far',
  iconName: 'locust',
  icon: [
    576,
    512,
    [],
    'e520',
    'M304 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0c94.6 0 173.9 65.7 194.7 154c-12.9-6.4-27.4-10-42.7-10l-45.4 0-45.5-83.5c-3.9-7.2-11.3-11.9-19.4-12.5s-16.1 3.1-21 9.7l-35 47.5-29.4-46.2c-4.2-6.6-11.3-10.7-19-11.1s-15.2 3-20.1 9.1L176.6 224l-74.4 0C63.4 224 32 255.4 32 294.1c0 26.9 15.4 51.3 39.4 63.1L5.2 441.1c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l73.5-93.1 41.5 19-33.2 45c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l42.5-57.6c11.8 2.3 23.9 3.4 36 3.4l33.4 0-16.1 28.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L330.5 416l110.7 0 25.4 50.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-15.2-30.3c46.2-6.9 81.6-46.7 81.7-94.7l0-.2 0-40C576 143 465 32 328 32l-24 0zm61 164.6l15 27.4-35.2 0L365 196.6zm-103.1-3.2L281.4 224l-43.6 0 24.2-30.6zM102.1 272l36.5 0L102 318.4l-9.1-4.2C85.1 310.7 80 302.8 80 294.1c0-12.2 9.9-22.1 22.1-22.1zm97.7 0L480 272c26.5 0 48 21.5 48 48s-21.5 48-48 48l-23.5 0c-.2 0-.3 0-.5 0s-.3 0-.5 0l-213.7 0c-20.7 0-41.1-4.4-59.9-13l-35-16 52.9-67zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faSort = {
  prefix: 'far',
  iconName: 'sort',
  icon: [
    320,
    512,
    ['unsorted'],
    'f0dc',
    'M70.6 176l178.7 0L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336 70.6 336zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z',
  ],
};
const faUnsorted = faSort;
const faListOl = {
  prefix: 'far',
  iconName: 'list-ol',
  icon: [
    512,
    512,
    ['list-1-2', 'list-numeric'],
    'f0cb',
    'M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM216 72l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faList12 = faListOl;
const faListNumeric = faListOl;
const faChartWaterfall = {
  prefix: 'far',
  iconName: 'chart-waterfall',
  icon: [
    512,
    512,
    [],
    'e0eb',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm120-72l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM480 88l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSparkle = {
  prefix: 'far',
  iconName: 'sparkle',
  icon: [
    448,
    512,
    [],
    'e5d6',
    'M224 32c9.4 0 17.9 5.4 21.8 13.9l59.5 128.8 128.8 59.5c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8L305.3 337.3 245.8 466.1c-3.9 8.5-12.4 13.9-21.8 13.9s-17.9-5.4-21.8-13.9L142.7 337.3 13.9 277.8C5.4 273.9 0 265.4 0 256s5.4-17.9 13.9-21.8l128.8-59.5L202.2 45.9C206.1 37.4 214.6 32 224 32zm0 81.2l-41.4 89.6c-2.4 5.2-6.5 9.3-11.7 11.7L81.2 256l89.6 41.4c5.2 2.4 9.3 6.5 11.7 11.7L224 398.8l41.4-89.6c2.4-5.2 6.5-9.3 11.7-11.7L366.8 256l-89.6-41.4c-5.2-2.4-9.3-6.5-11.7-11.7L224 113.2z',
  ],
};
const faFaceParty = {
  prefix: 'far',
  iconName: 'face-party',
  icon: [
    640,
    512,
    [],
    'e383',
    'M320 464c59 0 112.2-24.6 150.1-64l61.6 0C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176l-3.3 0c-15.9 0-30.7 4.6-43.2 12.6C488.9 106.8 411.3 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3c-.5 .6-1 1.1-1.5 1.7L592 336c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-184.8 0c.5 .6 1 1.1 1.5 1.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z',
  ],
};
const faKidneys = {
  prefix: 'far',
  iconName: 'kidneys',
  icon: [
    640,
    512,
    [],
    'f5fb',
    'M165.8 0c-24 0-52.6 6.6-76.2 27.3C58.2 54.8 0 119.5 0 221.2c0 23 3.2 49.4 6.4 70.3c8.9 57.7 59.1 95.9 113.3 95.9c69.6 0 123.8-60.3 116.4-129.5l-.5-5.1 15.9 7.9c2.7 1.4 4.4 4.1 4.4 7.2L256 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-21.2-12-40.6-31-50.1l-31-15.5 16.4-17.4c18.7-19.8 29.1-46 29.1-73.3c0-36.7-18.9-70.9-50-90.4L232.5 18 219.8 38.2 232.5 18C213.8 6.2 192.1 0 170 0l-4.2 0zM121.2 63.4C133.8 52.4 150 48 165.8 48l4.2 0c13.1 0 25.9 3.7 37 10.6l5.2 3.2c17.1 10.7 27.5 29.5 27.5 49.7c0 15-5.7 29.4-16 40.3l-16.9 17.8c-16.1 17-23.9 40.2-21.4 63.4l3.2 29.8c4.3 40.8-27.7 76.4-68.7 76.4c-32.4 0-60.9-22.6-65.9-55.1c-3.1-20.2-5.9-43.7-5.9-63c0-82 46.8-134.6 73.2-157.8zm310.7-4.8C443 51.7 455.8 48 468.9 48l4.2 0c15.8 0 32 4.4 44.6 15.4c26.4 23.2 73.2 75.8 73.2 157.8c0 19.3-2.8 42.7-5.9 63c-5 32.5-33.5 55.1-65.9 55.1c-41.1 0-73.1-35.6-68.7-76.4l3.2-29.8c2.5-23.3-5.4-46.4-21.4-63.4l-16.9-17.8c-10.3-10.9-16-25.3-16-40.3c0-20.2 10.4-39 27.5-49.7l5.2-3.2zM468.9 0c-22.1 0-43.8 6.2-62.5 18l-5.2 3.2c-31.1 19.5-50 53.6-50 90.4c0 27.2 10.4 53.5 29.1 73.3l16.8 17.7L367 217.7c-19 9.5-31 28.9-31 50.1L336 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-3 1.7-5.8 4.4-7.2l14.8-7.4-.5 4.6c-7.4 69.2 46.9 129.5 116.4 129.5c54.3 0 104.5-38.1 113.3-95.9c3.2-20.9 6.4-47.3 6.4-70.3c0-101.7-58.2-166.3-89.6-193.9C525.8 6.6 497.2 0 473.2 0l-4.2 0z',
  ],
};
const faWifiExclamation = {
  prefix: 'far',
  iconName: 'wifi-exclamation',
  icon: [
    640,
    512,
    [],
    'e2cf',
    'M344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 256c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256zM8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c61.5-54.2 138.8-90.8 224.1-102L264 56c0-7.5 1.5-14.6 4.1-21.2C169 45.7 79.1 87.2 8.2 149.6zM119.9 285.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c31-28.4 69.2-49.1 111.6-58.9l0-49.1c-54.9 10.5-104.5 36.2-144.1 72.6zM376 213.3l0 49.1c42.4 9.8 80.6 30.4 111.6 58.9c9.8 9 25 8.3 33.9-1.5s8.3-24.9-1.5-33.9c-39.6-36.3-89.1-62-144.1-72.6zM264 424a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM376 56l0 27.7c85.3 11.2 162.6 47.8 224.1 102c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C560.9 87.2 471 45.7 371.9 34.8c2.7 6.5 4.1 13.7 4.1 21.2z',
  ],
};
const faChartNetwork = {
  prefix: 'far',
  iconName: 'chart-network',
  icon: [
    640,
    512,
    [],
    'f78a',
    'M288 64c0 16.9-6.5 32.2-17.2 43.6l26.9 57.5c12.2-3.4 25-5.2 38.3-5.2c39 0 74.4 15.5 100.3 40.7l77.6-56.9c-1.3-5-1.9-10.3-1.9-15.7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-12.3 0-23.9-3.5-33.7-9.6l-77.6 56.9c9.8 19.4 15.3 41.4 15.3 64.6c0 18.5-3.5 36.2-9.9 52.5l67.3 40.4c10.7-8.1 24.1-12.9 38.5-12.9c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.4 .3-6.7 .8-9.9l-67.4-40.4C419 428.5 379.8 448 336 448c-71.4 0-130.6-51.9-142-120l-70.6 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l70.6 0c6.6-39.1 28.9-72.9 60.2-94.5l-26.9-57.6c-1.1 .1-2.2 .1-3.3 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm48 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z',
  ],
};
const faPersonDressBurst = {
  prefix: 'far',
  iconName: 'person-dress-burst',
  icon: [
    640,
    512,
    [],
    'e544',
    'M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8L544 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.2 0c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336L480 186.5 433.3 336l93.4 0zM176 8c8.9 0 17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9L332.2 193l-31.7 56.1-32 8.6-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38-51.7 38c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8zm0 75.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2z',
  ],
};
const faDiceD4 = {
  prefix: 'far',
  iconName: 'dice-d4',
  icon: [
    512,
    512,
    [],
    'f6d0',
    'M256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0zM58.2 307.8L232 439.7l0-347.6L58.2 307.8zM280 92.1l0 347.6L453.8 307.8 280 92.1z',
  ],
};
const faMoneyCheckDollar = {
  prefix: 'far',
  iconName: 'money-check-dollar',
  icon: [
    576,
    512,
    ['money-check-alt'],
    'f53d',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM280 272l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm-76-48l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z',
  ],
};
const faMoneyCheckAlt = faMoneyCheckDollar;
const faVectorSquare = {
  prefix: 'far',
  iconName: 'vector-square',
  icon: [
    448,
    512,
    [],
    'f5cb',
    'M360 72l48 0 0 48-48 0 0-48zm-8-40c-17.7 0-32 14.3-32 32l0 8L128 72l0-8c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-192 8 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM88 352l0-192 8 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 8-192 0 0-8c0-17.7-14.3-32-32-32l-8 0zM40 440l0-48 48 0 0 48-48 0zm320 0l0-48 48 0 0 48-48 0zM40 120l0-48 48 0 0 48-48 0z',
  ],
};
const faBreadSlice = {
  prefix: 'far',
  iconName: 'bread-slice',
  icon: [
    512,
    512,
    [],
    'f7ec',
    'M64 208c-8.8 0-16-7.2-16-16c0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1C439.4 129.7 464 157.5 464 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 176-288 0 0-176c0-26.5-21.5-48-48-48zm384 96l0-48c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64l0 48 0 128c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-128z',
  ],
};
const faLanguage = {
  prefix: 'far',
  iconName: 'language',
  icon: [
    640,
    512,
    [],
    'f1ab',
    'M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l208 0 32 0 16 0 256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L320 64l-16 0-32 0L64 64zm512 48c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-256 0 0-288 256 0zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316l-73.6 0-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276l38 0zM456 164c-11 0-20 9-20 20l0 4-52 0c-11 0-20 9-20 20s9 20 20 20l72 0 35.1 0c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228l2 0c11 0 20-9 20-20s-9-20-20-20l-16 0-44 0 0-4c0-11-9-20-20-20z',
  ],
};
const faWheatAwnSlash = {
  prefix: 'far',
  iconName: 'wheat-awn-slash',
  icon: [
    640,
    512,
    [],
    'e338',
    'M568.7 7.2c9.4 9.4 9.4 24.6 0 33.9L430.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L535 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c2.8 3.9 4.4 8.4 4.6 13L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L216.6 144.4l12.8-12.8c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L534.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM148.2 212.8L376.5 392.6c-3 .8-6 1.4-9 2c6.9 9.4 6 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L105 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0l-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l15-15zM325.5 103.3c-25 25-25 65.5 0 90.5L335.7 204c20.5-31 17.2-73.3-10.2-100.6zM223.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM382.1 250.4c25 25 65.5 25 90.5 0C445.2 223 403 219.7 371.9 240.2l10.1 10.1z',
  ],
};
const faFaceKissWinkHeart = {
  prefix: 'far',
  iconName: 'face-kiss-wink-heart',
  icon: [
    512,
    512,
    [128536, 'kiss-wink-heart'],
    'f598',
    'M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z',
  ],
};
const faKissWinkHeart = faFaceKissWinkHeart;
const faDagger = {
  prefix: 'far',
  iconName: 'dagger',
  icon: [
    384,
    512,
    [],
    'f6cb',
    'M192 0c13.3 0 24 10.7 24 24l0 104 32 0 24 0 64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l-16 0-48 0-32 0-32 0-48 0-16 0c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48l64 0 24 0 32 0 0-104c0-13.3 10.7-24 24-24zm32 397.9L224 208l48 0 0 189.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-4.5 6.4-11.8 10.2-19.7 10.2s-15.2-3.8-19.7-10.2L122.1 430c-6.6-9.4-10.1-20.6-10.1-32.1L112 208l48 0 0 189.9c0 1.6 .5 3.2 1.4 4.6L192 446.2l30.6-43.7c.9-1.3 1.4-2.9 1.4-4.6z',
  ],
};
const faPodium = {
  prefix: 'far',
  iconName: 'podium',
  icon: [
    448,
    512,
    [],
    'f680',
    'M168 72c-22.1 0-40 17.9-40 40l0 32 296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-32c0-48.6 39.4-88 88-88l14.4 0C190.7 9.7 206.2 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24L168 72zM73.5 455.2L47.3 224l48.3 0 25.7 225.8c.9 8.1 7.8 14.2 15.9 14.2l173.7 0c8.1 0 15-6.1 15.9-14.2L352.4 224l48.3 0L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8l-173.7 0c-32.6 0-59.9-24.4-63.6-56.8z',
  ],
};
const faDiamonds4 = {
  prefix: 'far',
  iconName: 'diamonds-4',
  icon: [
    512,
    512,
    [],
    'e68b',
    'M367.5 104.9c-.8-7-3.8-13.7-9.2-19.1L284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0L153.7 85.8c-5.3 5.3-8.4 12.1-9.2 19.1c-1 9.3 2 19 9.2 26.2l79.7 79.7c5.3 5.3 12.1 8.4 19.1 9.2c2.4 .3 4.7 .3 7.1 0c7-.8 13.7-3.8 19.1-9.2L358.3 131c7.2-7.2 10.2-16.8 9.2-26.2zM219.9 252.5c-.8-7-3.8-13.7-9.2-19.1L131 153.7c-7.2-7.2-16.8-10.2-26.2-9.2c-7 .8-13.7 3.8-19.1 9.2L11.7 227.7c-15.6 15.6-15.6 40.9 0 56.6l74.1 74.1c5.3 5.3 12.1 8.4 19.1 9.2c9.3 1 19-2 26.2-9.2l79.7-79.7c5.3-5.3 8.4-12.1 9.2-19.1c.3-2.4 .3-4.7 0-7.1zm32.5 39.6c-7 .8-13.7 3.8-19.1 9.2L153.7 381c-7.2 7.2-10.2 16.8-9.2 26.2c.8 7 3.8 13.7 9.2 19.1l74.1 74.1c15.6 15.6 40.9 15.6 56.6 0l74.1-74.1c5.3-5.3 8.4-12.1 9.2-19.1c1-9.3-2-19-9.2-26.2l-79.7-79.7c-5.3-5.3-12.1-8.4-19.1-9.2c-2.4-.3-4.7-.3-7.1 0zm39.6-32.5c.8 7 3.8 13.7 9.2 19.1L381 358.3c7.2 7.2 16.8 10.2 26.2 9.2c7-.8 13.7-3.8 19.1-9.2l74.1-74.1c15.6-15.6 15.6-40.9 0-56.6l-74.1-74.1c-5.3-5.3-12.1-8.4-19.1-9.2c-9.3-1-19 2-26.2 9.2l-79.7 79.7c-5.3 5.3-8.4 12.1-9.2 19.1c-.3 2.4-.3 4.7 0 7.1zM256 51.3l57.1 57.1L256 165.5l-57.1-57.1L256 51.3zM51.3 256l57.1-57.1L165.5 256l-57.1 57.1L51.3 256zM256 460.7l-57.1-57.1L256 346.5l57.1 57.1L256 460.7zM460.7 256l-57.1 57.1L346.5 256l57.1-57.1L460.7 256z',
  ],
};
const faMemoCircleCheck = {
  prefix: 'far',
  iconName: 'memo-circle-check',
  icon: [
    576,
    512,
    [],
    'e1d9',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 156.5c14.6-9.5 30.8-17 48-21.8L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.3 0 6.6-.3 9.7-.7c-17.9-12.8-33.3-28.8-45.3-47.3L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm456 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faRouteHighway = {
  prefix: 'far',
  iconName: 'route-highway',
  icon: [
    448,
    512,
    [],
    'f61a',
    'M236.3 3.4c-7.6-4.6-17.1-4.6-24.7 0L202.3 9c-37.5 22.5-83.6 25.1-123.3 7C60.3 7.6 38.2 14.7 28.1 32.5L7.4 68.7c-6.6 11.6-7 25.8-1 37.7l8.5 16.9C26.1 145.9 32 170.8 32 196.1c0 20.7-3.9 41.2-11.6 60.4L8.7 285.7C2.9 300 0 315.3 0 330.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5c6.6 3.2 14.2 3.2 20.8 0l144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4c0-15.4-2.9-30.7-8.7-45.1l-11.7-29.2c-7.7-19.2-11.6-39.7-11.6-60.4c0-25.2 5.9-50.1 17.2-72.7l8.5-16.9c6-12 5.6-26.1-1-37.7L419.9 32.5c-10.2-17.8-32.2-24.9-50.9-16.4c-39.8 18.1-85.9 15.4-123.3-7l-9.4-5.6zM80 192L368 192c0 1.4 0 2.7 0 4.1c0 26.8 5.1 53.3 15.1 78.2l11.7 29.2c3.5 8.7 5.2 17.9 5.2 27.2c0 28.2-16.2 53.9-41.6 66.1L224 461.4 89.6 396.9C64.2 384.7 48 359 48 330.7c0-9.3 1.8-18.6 5.2-27.2l11.7-29.2c10-24.9 15.1-51.4 15.1-78.2c0-1.4 0-2.7 0-4.1z',
  ],
};
const faDownToLine = {
  prefix: 'far',
  iconName: 'down-to-line',
  icon: [
    384,
    512,
    ['arrow-alt-to-bottom'],
    'f34a',
    'M82.2 224L192 334 301.8 224 248 224c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM192 384c-11.5 0-22.5-4.6-30.6-12.7L45.6 255.2C36.9 246.5 32 234.7 32 222.4C32 196.8 52.8 176 78.4 176l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 432l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faArrowAltToBottom = faDownToLine;
const faFilter = {
  prefix: 'far',
  iconName: 'filter',
  icon: [
    512,
    512,
    [],
    'f0b0',
    'M0 73.7C0 50.7 18.7 32 41.7 32l428.6 0c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5l0 143.2c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4 64 50.8L288 296c0-5.5 1.9-10.9 5.4-15.2L457 80 55 80z',
  ],
};
const faSquareG = {
  prefix: 'far',
  iconName: 'square-g',
  icon: [
    448,
    512,
    [],
    'e271',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z',
  ],
};
const faCirclePhone = {
  prefix: 'far',
  iconName: 'circle-phone',
  icon: [
    512,
    512,
    ['phone-circle'],
    'e11b',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7l-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48c-3.9-9.3-14-14.2-23.7-11.6z',
  ],
};
const faPhoneCircle = faCirclePhone;
const faClipboardPrescription = {
  prefix: 'far',
  iconName: 'clipboard-prescription',
  icon: [
    384,
    512,
    [],
    'f5e8',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 204c-11 0-20 9-20 20l0 80 0 64c0 11 9 20 20 20s20-9 20-20l0-44 35.7 0 52 52-25.9 25.9c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L240 404.3l25.9 25.9c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L268.3 376l25.9-25.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L240 347.7l-32.6-32.6C224.6 304.6 236 285.6 236 264c0-33.1-26.9-60-60-60l-72 0zm72 80l-8 0-44 0 0-40 52 0c11 0 20 9 20 20s-9 20-20 20z',
  ],
};
const faUserNurseHair = {
  prefix: 'far',
  iconName: 'user-nurse-hair',
  icon: [
    448,
    512,
    [],
    'e45d',
    'M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0 0-57.8zM304 160l-8 0c-20.5 0-38.7-9.6-50.4-24.5C231.9 159.7 205.8 176 176 176l-32 0c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM49.3 461.9l349.4 0c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7l-386.6 0c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4zM208 48l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z',
  ],
};
const faQuestion = {
  prefix: 'far',
  iconName: 'question',
  icon: [
    320,
    512,
    [10067, 10068, 61736],
    '3f',
    'M64 160c0-44.2 35.8-80 80-80l32 0c44.2 0 80 35.8 80 80l0 4.6c0 24.1-12 46.6-32.1 59.9l-52.3 34.9C149.4 274.2 136 299.2 136 326l0 2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2c0-10.7 5.3-20.7 14.2-26.6l52.3-34.9c33.4-22.3 53.4-59.7 53.4-99.8l0-4.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faFileSignature = {
  prefix: 'far',
  iconName: 'file-signature',
  icon: [
    576,
    512,
    [],
    'f573',
    'M64 464l256 0c8.8 0 16-7.2 16-16l0-6.7 39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7l0 19.3c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 49.1-48 48 0-91.6-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-115l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L96 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 25.6 0 12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1 .3-2.1 .4-3.2 .5c-.8 .1-1.5 .2-2.3 .2L256 416c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zM549.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z',
  ],
};
const faToggleLargeOn = {
  prefix: 'far',
  iconName: 'toggle-large-on',
  icon: [
    576,
    512,
    [],
    'e5b1',
    'M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64zm192 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288z',
  ],
};
const faUpDownLeftRight = {
  prefix: 'far',
  iconName: 'up-down-left-right',
  icon: [
    512,
    512,
    ['arrows-alt'],
    'f0b2',
    'M256 55.8L289.5 96l-67 0L256 55.8zM229.8 12.3L168.2 86.2c-5.3 6.3-8.2 14.3-8.2 22.6c0 19.5 15.8 35.2 35.2 35.2l36.8 0 0 88-88 0 0-36.8c0-19.5-15.8-35.2-35.2-35.2c-8.2 0-16.2 2.9-22.6 8.2L12.3 229.8C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2c19.5 0 35.2-15.8 35.2-35.2l0-36.8 88 0 0 88-36.8 0c-19.5 0-35.2 15.8-35.2 35.2c0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6c0-19.5-15.8-35.2-35.2-35.2L280 368l0-88 88 0 0 36.8c0 19.5 15.8 35.2 35.2 35.2c8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2c-19.5 0-35.2 15.8-35.2 35.2l0 36.8-88 0 0-88 36.8 0c19.5 0 35.2-15.8 35.2-35.2c0-8.2-2.9-16.2-8.2-22.6L282.2 12.3C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2L222.5 416l67 0L256 456.2zM456.2 256L416 289.5l0-67L456.2 256zM96 289.5L55.8 256 96 222.5l0 67z',
  ],
};
const faArrowsAlt = faUpDownLeftRight;
const faDryerHeat = {
  prefix: 'far',
  iconName: 'dryer-heat',
  icon: [
    448,
    512,
    ['dryer-alt'],
    'f862',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM80 288a144 144 0 1 1 288 0A144 144 0 1 1 80 288zm107.3-83.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L177.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7zm80 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7z',
  ],
};
const faDryerAlt = faDryerHeat;
const faHouseChimneyUser = {
  prefix: 'far',
  iconName: 'house-chimney-user',
  icon: [
    576,
    512,
    [],
    'e065',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6 512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 85.9L303.5 5.7zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 400c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80z',
  ],
};
const faHandHoldingHeart = {
  prefix: 'far',
  iconName: 'hand-holding-heart',
  icon: [
    576,
    512,
    [],
    'f4be',
    'M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faArrowUpSmallBig = {
  prefix: 'far',
  iconName: 'arrow-up-small-big',
  icon: [
    576,
    512,
    ['sort-size-up-alt'],
    'f88f',
    'M368 144l0-64 64 0 0 64-64 0zm-48 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 64zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 304l128 0 0 128-128 0 0-128zm-48 0l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faSortSizeUpAlt = faArrowUpSmallBig;
const faTrainTrack = {
  prefix: 'far',
  iconName: 'train-track',
  icon: [
    576,
    512,
    [],
    'e453',
    'M222.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5L160.1 96 112 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l30.8 0L114 224l-42 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.7 0L67.9 352 32 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l18.7 0L33.4 447.9c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5L101.7 400l372.7 0 23.1 64.1c4.5 12.5 18.2 18.9 30.7 14.5s18.9-18.2 14.5-30.7L525.3 400l18.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-35.9 0-28.8-80 24.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-42 0-28.8-80 30.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.1 0L398.6 47.9c-4.5-12.5-18.2-18.9-30.7-14.5s-18.9 18.2-14.5 30.7L364.9 96 211.1 96l11.5-31.9zM193.8 144l188.3 0L411 224 165 224l28.8-80zM457.1 352l-338.1 0 28.8-80 280.5 0 28.8 80z',
  ],
};
const faPuzzlePiece = {
  prefix: 'far',
  iconName: 'puzzle-piece',
  icon: [
    512,
    512,
    [129513],
    'f12e',
    'M201.1 57.3C194.1 62.5 192 68 192 72c0 4.2 2.4 10.1 10.4 15.6c7.8 5.3 13.6 14.6 13.6 25.6c0 17-13.8 30.7-30.7 30.7L56 144c-4.4 0-8 3.6-8 8l0 52.5c7.4-2.9 15.5-4.5 24-4.5c43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5L48 456c0 4.4 3.6 8 8 8l100.5 0c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24l52.5 0c4.4 0 8-3.6 8-8l0-129.3c0-17 13.8-30.7 30.7-30.7c11.1 0 20.3 5.8 25.6 13.6c5.5 8 11.4 10.4 15.6 10.4c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-4.2 0-10.1 2.4-15.6 10.4c-5.3 7.8-14.6 13.6-25.6 13.6c-17 0-30.7-13.8-30.7-30.7l0-81.3c0-4.4-3.6-8-8-8l-81.3 0c-17 0-30.7-13.8-30.7-30.7c0-11.1 5.8-20.3 13.6-25.6c8-5.5 10.4-11.4 10.4-15.6c0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3zM172.3 18.9C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24L360 96c30.9 0 56 25.1 56 56l0 44.9c7.3-3.1 15.4-4.9 24-4.9c22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9l0 92.9c0 30.9-25.1 56-56 56l-78.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9L56 512c-30.9 0-56-25.1-56-56L0 329.9C0 311.2 15.2 296 33.9 296c10.1 0 18.5 4.5 24.2 9.9c4.3 4.2 9.2 6.1 13.9 6.1c9.9 0 24-10.7 24-32s-14.1-32-24-32c-4.7 0-9.5 1.9-13.9 6.1C52.4 259.5 44 264 33.9 264C15.2 264 0 248.8 0 230.1L0 152c0-30.9 25.1-56 56-56l92.9 0c-3.1-7.3-4.9-15.4-4.9-24c0-22.5 12.2-41 28.3-53.1z',
  ],
};
const faMoneyCheck = {
  prefix: 'far',
  iconName: 'money-check',
  icon: [
    576,
    512,
    [],
    'f53c',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm120 80l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 328c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24zM376 160l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
  ],
};
const faStarHalfStroke = {
  prefix: 'far',
  iconName: 'star-half-stroke',
  icon: [
    576,
    512,
    ['star-half-alt'],
    'f5c0',
    'M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z',
  ],
};
const faStarHalfAlt = faStarHalfStroke;
const faFileExclamation = {
  prefix: 'far',
  iconName: 'file-exclamation',
  icon: [
    384,
    512,
    [],
    'f31a',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM192 176c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCode = {
  prefix: 'far',
  iconName: 'code',
  icon: [
    640,
    512,
    [],
    'f121',
    'M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z',
  ],
};
const faWhiskeyGlass = {
  prefix: 'far',
  iconName: 'whiskey-glass',
  icon: [
    512,
    512,
    [129347, 'glass-whiskey'],
    'f7a0',
    'M80.8 288l350.3 0L461.5 80l-411 0L80.8 288zm7 48l10 68.6c2.3 15.7 15.8 27.4 31.7 27.4l253 0c15.9 0 29.4-11.7 31.7-27.4l10-68.6L87.8 336zM7.8 43.1C13.9 36 22.7 32 32 32l448 0c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5l-253 0c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z',
  ],
};
const faGlassWhiskey = faWhiskeyGlass;
const faMoonStars = {
  prefix: 'far',
  iconName: 'moon-stars',
  icon: [
    512,
    512,
    [],
    'f755',
    'M295.8 137.8c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11 11 38.6zM403.8 310.8c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM48 320c0-70 50-128.3 116.2-141.3C141.6 206.3 128 241.5 128 280c0 83.2 63.5 151.6 144.7 159.3c-23 15.6-50.8 24.7-80.7 24.7c-79.5 0-144-64.5-144-144zM192 128C86 128 0 214 0 320S86 512 192 512c69.4 0 130.2-36.9 163.9-92c5.3-8.7 4.6-19.9-2-27.8s-17.3-10.8-26.9-7.2c-12.1 4.5-25.3 7-39.1 7c-61.9 0-112-50.1-112-112c0-45 26.6-83.9 65-101.7c9.3-4.3 14.8-14 13.8-24.2s-8.4-18.6-18.3-20.9c-14.3-3.4-29.2-5.2-44.4-5.2z',
  ],
};
const faBuildingCircleExclamation = {
  prefix: 'far',
  iconName: 'building-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4d3',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faClothesHanger = {
  prefix: 'far',
  iconName: 'clothes-hanger',
  icon: [
    640,
    512,
    [],
    'e136',
    'M211.4 91.3C221 38.4 267 0 320.8 0C382.2 0 432 49.8 432 111.2l0 2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9L611 391.7c18.1 12.2 29 32.7 29 54.5c0 36.3-29.5 65.8-65.8 65.8L65.8 512C29.5 512 0 482.5 0 446.2c0-21.9 10.9-42.3 29-54.5L306.2 204.3l50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5l0-2.9C384 76.3 355.7 48 320.8 48c-30.6 0-56.7 21.8-62.2 51.9l-3 16.4c-2.4 13-14.9 21.7-27.9 19.3s-21.7-14.9-19.3-27.9l3-16.4zM320 253L55.8 431.5c-4.9 3.3-7.8 8.8-7.8 14.7C48 456 56 464 65.8 464l508.4 0c9.8 0 17.8-8 17.8-17.8c0-5.9-2.9-11.4-7.8-14.7L320 253z',
  ],
};
const faMobileNotch = {
  prefix: 'far',
  iconName: 'mobile-notch',
  icon: [
    384,
    512,
    ['mobile-iphone'],
    'e1ee',
    'M256 48l0 16c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-16L96 48C78.3 48 64 62.3 64 80l0 352c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32l-32 0zM16 80C16 35.8 51.8 0 96 0L288 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80L96 512c-44.2 0-80-35.8-80-80L16 80z',
  ],
};
const faMobileIphone = faMobileNotch;
const faMagnifyingGlassChart = {
  prefix: 'far',
  iconName: 'magnifying-glass-chart',
  icon: [
    512,
    512,
    [],
    'e522',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faArrowUpRightFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-right-from-square',
  icon: [
    512,
    512,
    ['external-link'],
    'f08e',
    'M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z',
  ],
};
const faExternalLink = faArrowUpRightFromSquare;
const faCubesStacked = {
  prefix: 'far',
  iconName: 'cubes-stacked',
  icon: [
    448,
    512,
    [],
    'e4e6',
    'M240 80l0 32 32 0 0-32-32 0zM224 32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM136.5 268.2l27.7-16-16-27.7-27.7 16 16 27.7zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM304 272l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM368 432l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM208 400l0 32 32 0 0-32-32 0zm-16-48l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM48 432l32 0 0-32-32 0 0 32zM0 384c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z',
  ],
};
const faImagesUser = {
  prefix: 'far',
  iconName: 'images-user',
  icon: [
    576,
    512,
    [],
    'e1b9',
    'M512 80L160 80c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l64 0c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64l64 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zM160 32l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0C60.9 480 0 419.1 0 344L0 120c0-13.3 10.7-24 24-24zm248 80a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faWonSign = {
  prefix: 'far',
  iconName: 'won-sign',
  icon: [
    512,
    512,
    [8361, 'krw', 'won'],
    'f159',
    'M71.1 49.5C67.5 36.8 54.3 29.3 41.5 32.9S21.3 49.7 24.9 62.5L79.1 256 24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l68.5 0 44.4 158.5c2.9 10.5 12.6 17.7 23.6 17.5s20.3-7.8 22.9-18.4L221.2 304l69.7 0 37.8 157.6c2.6 10.6 12 18.2 22.9 18.4s20.6-7 23.6-17.5L419.5 304l68.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.1 0L487.1 62.5c3.6-12.8-3.9-26-16.6-29.6s-26 3.9-29.6 16.6L383.1 256l-54.4 0L279.3 50.4C276.7 39.6 267.1 32 256 32s-20.7 7.6-23.3 18.4L183.3 256l-54.4 0L71.1 49.5zM142.4 304l29.4 0-13.6 56.6L142.4 304zm90.3-48L256 158.8 279.3 256l-46.6 0zm107.5 48l29.4 0-15.9 56.6L340.2 304z',
  ],
};
const faKrw = faWonSign;
const faWon = faWonSign;
const faImagePolaroidUser = {
  prefix: 'far',
  iconName: 'image-polaroid-user',
  icon: [
    448,
    512,
    [],
    'e1b6',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48L48 368l0 48zm286-96l66 0 0-224c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 224 66 0c7.1-27.6 32.2-48 62-48l96 0c29.8 0 54.9 20.4 62 48zM448 96l0 224 0 24 0 24 0 48c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-48 0-24 0-24L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64zM160 176a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faVirusCovid = {
  prefix: 'far',
  iconName: 'virus-covid',
  icon: [
    512,
    512,
    [],
    'e4a8',
    'M216 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L92 125.9l23.8 23.8C97.9 173.2 85.8 201.3 81.6 232L48 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1 80.6 374.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L125.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c30.7-4.2 58.8-16.3 82.3-34.1L386.1 420l-11.3 11.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L420 386.1l-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L420 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L386.1 92l-23.8 23.8C338.8 97.9 310.7 85.8 280 81.6L280 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 0zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faSquareEllipsis = {
  prefix: 'far',
  iconName: 'square-ellipsis',
  icon: [
    448,
    512,
    [],
    'e26e',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faPie = {
  prefix: 'far',
  iconName: 'pie',
  icon: [
    576,
    512,
    [129383],
    'f705',
    'M525.8 225.1c3.1 7.8 8.8 14.4 16.3 18.2l16.2 8.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-29.6-14.8c-14.7-7.4-31.7-8.8-47.4-3.9l-41.6 12.8c-23.3 7.2-48.3 6.5-71.2-1.8l-30-10.9c-14.1-5.1-29.6-5.1-43.7 0l-30 10.9c-22.9 8.3-47.9 9-71.2 1.8l-41.6-12.8c-15.7-4.8-32.7-3.4-47.4 3.9L46.3 308.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l16.2-8.1c7.5-3.8 13.2-10.4 16.3-18.2C87.9 130.7 180.1 64 288 64s200.1 66.7 237.8 161.1zM199.2 129.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5c2.2 1.1 4.5 1.6 6.8 1.7l.7 0c5.7-.1 11.2-3.3 14-8.8l16-32c4-7.9 .7-17.5-7.2-21.5zm177.7 0c-7.9 4-11.1 13.6-7.2 21.5l16 32c2.7 5.5 8.2 8.7 14 8.8l.7 0c2.3 0 4.6-.6 6.8-1.7c7.9-4 11.1-13.6 7.2-21.5l-16-32c-4-7.9-13.6-11.1-21.5-7.2zM288 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM90.2 322.4c4.2-2.1 8.8-3.2 13.4-3.4l23.3 70c2.2 6.5 8.3 10.9 15.2 10.9l291.7 0c6.9 0 13-4.4 15.2-10.9l23.3-70c4.6 .1 9.2 1.3 13.4 3.4l29.6 14.8c.4 .2 .9 .4 1.3 .6l-22.1 66.4c-8.7 26.1-33.2 43.8-60.7 43.8l-291.7 0c-27.5 0-52-17.6-60.7-43.8L59.3 337.9c.4-.2 .9-.4 1.3-.6l29.6-14.8z',
  ],
};
const faChessKnightPiece = {
  prefix: 'far',
  iconName: 'chess-knight-piece',
  icon: [
    320,
    512,
    ['chess-knight-alt'],
    'f442',
    'M68.9 112l79.8 0C216.8 112 272 167.2 272 235.3c0 11.3-1.6 22.5-4.6 33.4L243.9 352l49.9 0 19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64L40.8 64C18.5 64 .4 82.1 .4 104.5c0 11.6 5 22.5 13.3 30C5 148.3 .3 164.4 .3 181L.1 232C0 253.2 8 273.7 22.4 289.2l1.9 2c6.5 7 14 12.6 22 16.8c-8.3 13-13.1 28.2-13.8 43.9l48.1 0c1.1-11.5 7-22 16.2-29l25.1-15.4c2.7-1.4 5.3-3 7.8-4.8l42.9-26.3c11.3-6.9 14.8-21.7 7.9-33s-21.7-14.8-33-7.9l-42.7 26.2-.1-.2c-.5 .4-1 .8-1.5 1.2l-4.9 3c-12.8 6.4-28.7 3.8-38.8-7.1l-1.9-2c-6.2-6.6-9.6-15.4-9.5-24.4l.2-51c0-10.6 4.2-20.7 11.7-28.1l8-8c5.5-5.5 8-13.2 6.7-20.8c-.7-4.6-2.8-8.8-5.8-12.2zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z',
  ],
};
const faChessKnightAlt = faChessKnightPiece;
const faAustralSign = {
  prefix: 'far',
  iconName: 'austral-sign',
  icon: [
    448,
    512,
    [],
    'e0a9',
    'M246.1 46.7C242.4 37.8 233.7 32 224 32s-18.4 5.8-22.1 14.7L127.4 224 24 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l83.2 0L87.1 320 24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l42.9 0L33.9 446.7c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L119 368l210 0 40.9 97.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4L381.1 368l42.9 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-63.1 0-20.2-48 83.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-103.4 0L246.1 46.7zM268.5 224l-89.1 0L224 118l44.5 106zM159.3 272l129.4 0 20.2 48-169.7 0 20.2-48z',
  ],
};
const faCloudPlus = {
  prefix: 'far',
  iconName: 'cloud-plus',
  icon: [
    640,
    512,
    [],
    'e35e',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faF = {
  prefix: 'far',
  iconName: 'f',
  icon: [
    320,
    512,
    [102],
    '46',
    'M56 32C25.1 32 0 57.1 0 88L0 248 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 224 48 88c0-4.4 3.6-8 8-8l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32z',
  ],
};
const faLeaf = {
  prefix: 'far',
  iconName: 'leaf',
  icon: [
    512,
    512,
    [],
    'f06c',
    'M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400c0 0 0 0 .1 0l.8 0c0 0 0 0 .1 0C370.2 399.5 464 299.7 464 156.6c0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144l-104 0c-57.6 0-106.3 38.1-122.4 90.4zM96.4 260.1C102.5 168.5 178.8 96 272 96l104 0c28.7 0 54.8-10.8 74.6-28.5c.7-.6 1.4-1.3 2.1-1.9c6.6-6.2 12.5-13.2 17.4-20.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6c2.9 8.9 5.5 17.9 7.8 27.2c.5 1.9 .9 3.8 1.3 5.6c5.4 24.3 8.3 49.8 8.3 76.2C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-75.1 38.3-141.2 96.4-179.9z',
  ],
};
const faBedBunk = {
  prefix: 'far',
  iconName: 'bed-bunk',
  icon: [
    576,
    512,
    [],
    'f8f8',
    'M24 0C37.3 0 48 10.7 48 24l0 136 208 0 0-120c0-22.1 17.9-40 40-40L456 0c66.3 0 120 53.7 120 120l0 64 0 96 0 159.7 0 48.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24.3-248 0-232 0L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48.3L0 184 0 24C0 10.7 10.7 0 24 0zM256 415.7L256 296c0-22.1 17.9-40 40-40l232 0 0-48-248 0L48 208l0 207.7 208 0zM528 160l0-40c0-39.8-32.2-72-72-72L304 48l0 112 224 0zm0 144l-224 0 0 111.7 224 0L528 304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
  ],
};
const faRoad = {
  prefix: 'far',
  iconName: 'road',
  icon: [
    576,
    512,
    [128739],
    'f018',
    'M185.7 32c-30.4 0-57.5 19-67.7 47.6L8.6 383.6C-8.3 430.5 26.4 480 76.3 480l423.4 0c49.9 0 84.6-49.5 67.7-96.4L458 79.6C447.7 51 420.6 32 390.3 32L185.7 32zM163.2 95.9c3.4-9.5 12.5-15.9 22.6-15.9L264 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l109.4 304c5.6 15.6-6 32.1-22.6 32.1L312 432l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L76.3 432c-16.6 0-28.2-16.5-22.6-32.1l109.4-304zM312 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80z',
  ],
};
const faTaxi = {
  prefix: 'far',
  iconName: 'taxi',
  icon: [
    512,
    512,
    [128662, 'cab'],
    'f1ba',
    'M192 0c-17.7 0-32 14.3-32 32l0 32 0 .2c-35.2 2.2-65.9 25.2-77.7 58.8L48.1 220.8C19.3 237.4 0 268.4 0 304l0 80 0 48 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 416 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 0-48 0-80c0-35.6-19.4-66.6-48.1-83.2l-34.3-97.9C417.9 89.3 387.2 66.3 352 64.2l0-.2 0-32c0-17.7-14.3-32-32-32L192 0zM165.4 112l181.2 0c17 0 32.1 10.7 37.8 26.8L408.6 208l-305.1 0 24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM96 256l320 0c26.5 0 48 21.5 48 48l0 80L48 384l0-80c0-26.5 21.5-48 48-48zm48 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCab = faTaxi;
const faPersonCirclePlus = {
  prefix: 'far',
  iconName: 'person-circle-plus',
  icon: [
    576,
    512,
    [],
    'e541',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faChartPie = {
  prefix: 'far',
  iconName: 'chart-pie',
  icon: [
    576,
    512,
    ['pie-chart'],
    'f200',
    'M493.1 192L352 192l0-141.1C423.5 64 480 120.5 493.1 192zM352 240l175.4 0c9 0 16.6-7 16.6-16C544 100.3 443.7 0 320 0c-9 0-16 7.6-16 16.6L304 192l0 48 48 0zM222.1 321.9L348.4 448.2C325 458.4 299.2 464 272 464C166 464 80 378 80 272c0-83.6 53.4-154.7 128-181.1L208 288c0 12.7 5.1 24.9 14.1 33.9zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288l0-238.4c0-9.2-7.8-16.6-17-15.4zM558.4 288L320 288 478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3c1.3-9.2-6.1-17-15.4-17z',
  ],
};
const faPieChart = faChartPie;
const faBoltLightning = {
  prefix: 'far',
  iconName: 'bolt-lightning',
  icon: [
    384,
    512,
    [],
    'e0b7',
    'M77 48L51.4 240 208 240c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192 176 192c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48 77 48zM30.4 34.7C33 14.8 50 0 70 0L208.6 0c28.1 0 47.5 28.3 37.3 54.5L211.1 144l126.8 0c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288l-135 0C18.1 288-.6 266.7 2.6 242.7l27.7-208z',
  ],
};
const faClockEight = {
  prefix: 'far',
  iconName: 'clock-eight',
  icon: [
    512,
    512,
    [],
    'e345',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2 232 120c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSackXmark = {
  prefix: 'far',
  iconName: 'sack-xmark',
  icon: [
    512,
    512,
    [],
    'e56a',
    'M293.3 152l-74.6 0-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48 187.4 48l31.1 45.2L226 104l60 0 7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96zM209 239l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faFileXls = {
  prefix: 'far',
  iconName: 'file-xls',
  icon: [
    512,
    512,
    [],
    'e64d',
    'M64 464l80 0 0 48-80 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm160-96c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 128l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zm88-98.3c0-25.2 20.4-45.7 45.7-45.7l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L432 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l26.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z',
  ],
};
const faFileExcel = {
  prefix: 'far',
  iconName: 'file-excel',
  icon: [
    384,
    512,
    [],
    'f1c3',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z',
  ],
};
const faFileContract = {
  prefix: 'far',
  iconName: 'file-contract',
  icon: [
    384,
    512,
    [],
    'f56c',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0zm54.2 221.8L160 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l10.6-21.3c.6-1.2 1.8-1.9 3.1-1.9s2.5 .7 3.1 1.9l10.6 21.3c2.7 5.4 8.3 8.8 14.3 8.8l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-30.1 0-6.2-12.4c-6-12-18.3-19.6-31.7-19.6c-8.6 0-16.8 3.1-23.1 8.6l-11.3-37.5C182.2 311.7 171.8 304 160 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L96 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2z',
  ],
};
const faFishFins = {
  prefix: 'far',
  iconName: 'fish-fins',
  icon: [
    576,
    512,
    [],
    'e4f2',
    'M247.3 166c-13.1 6.7-25.4 14.5-36.5 22.8c-10.2 7.6-19.5 15.8-27.9 24c-14.2 13.9-35.5 17.6-53.6 9.3L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l58.7-26.9c18.1-8.3 39.4-4.6 53.6 9.3c8.4 8.3 17.8 16.4 27.9 24c11.2 8.4 23.5 16.3 36.8 23c16.7 8.4 27 25.8 26.3 44.4l-.8 23.6 46.2-36.3c7.7-6.1 17.2-9.6 27-10.2c44.7-2.5 83.7-21 114.9-44.5c29.4-22.1 51.3-48 64-67.2c-12.7-19.2-34.6-45.1-64-67.2c-31.3-23.5-70.2-42-114.9-44.5c-9.8-.5-19.2-4.1-27-10.2L272.9 97.6l.6 24.3c.5 18.5-9.7 35.7-26.3 44.1zM8.4 373.6C-1 363.3-2.7 348.2 4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l103.9 47.6c9.8-9.6 20.8-19.2 32.7-28.1c13.1-9.8 27.7-19.2 43.6-27.2L224 64.9c-.3-12.4 6.5-23.9 17.6-29.4s24.4-4.2 34.1 3.4L349 96.4c56.6 3.2 104.5 26.6 141.1 54c39.2 29.4 67.2 64.7 81.6 89.5c5.8 9.9 5.8 22.2 0 32.1c-14.4 24.8-42.5 60.1-81.6 89.5c-36.6 27.5-84.5 50.9-141.1 54l-73.2 57.5c-9.8 7.7-23.1 9-34.2 3.4s-17.9-17.2-17.5-29.6l1.9-57.9c-16.1-8.1-30.8-17.5-44-27.4c-12-9-22.9-18.5-32.7-28.1L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCircleQ = {
  prefix: 'far',
  iconName: 'circle-q',
  icon: [
    512,
    512,
    [],
    'e11e',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80zm208 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1c14-20.5 22.1-45.3 22.1-71.9z',
  ],
};
const faBuildingFlag = {
  prefix: 'far',
  iconName: 'building-flag',
  icon: [
    640,
    512,
    [],
    'e4d5',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM448 0c17.7 0 32 14.3 32 32l144 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-144 0 0 320-64 0 0-480c0-17.7 14.3-32 32-32z',
  ],
};
const faFaceGrinBeam = {
  prefix: 'far',
  iconName: 'face-grin-beam',
  icon: [
    512,
    512,
    [128516, 'grin-beam'],
    'f582',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faGrinBeam = faFaceGrinBeam;
const faObjectUngroup = {
  prefix: 'far',
  iconName: 'object-ungroup',
  icon: [
    640,
    512,
    [],
    'f248',
    'M48.2 66.8c-.1-.8-.2-1.7-.2-2.5l0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3l0 105.3C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L123.3 40C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-105.3c16-6.5 28.9-19.3 35.3-35.3l201.3 0zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40l45.4 0c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-36.7-48 0 0 36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L448 200l0 16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm307-18.5a16 16 0 1 1 -5.5 31.5 16 16 0 1 1 5.5-31.5z',
  ],
};
const faFaceDisguise = {
  prefix: 'far',
  iconName: 'face-disguise',
  icon: [
    512,
    512,
    [],
    'e370',
    'M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48L72 208c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8l0 25.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-25.2c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6l18.4 0c3.6 15.4 5.6 31.5 5.6 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zM280 208c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3zm219.4-31.6C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM63.9 176c6.4-15.3 14.5-29.7 24.2-42.9c-.6 4.5 .2 9.3 2.4 13.6l1.4 2.7c-6.1 8-11 16.9-14.4 26.5l-13.5 0zm384.1 0l-13.5 0c-3.4-9.6-8.3-18.6-14.4-26.5l1.4-2.7c2.2-4.4 2.9-9.1 2.4-13.6c9.7 13.2 17.8 27.6 24.2 42.9zM104.9 113.1C142.8 73 196.5 48 256 48s113.2 25 151.1 65.1c-9-2.8-18.7 0-24.9 6.8c-2-.9-4.1-1.7-6.2-2.4l0-5.5c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.3c-1.5 .2-2.9 .5-4.4 .8c-6.7-9.6-19.6-13-30.3-7.6s-15.7 17.8-12.1 28.9c-10.7 9.3-19.4 21-25.2 34.2c-5.8-13.2-14.4-24.9-25.2-34.2c3.6-11.1-1.3-23.5-12.1-28.9s-23.6-1.9-30.4 7.6c-1.4-.3-2.9-.6-4.4-.8l0-1.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5.5c-2.1 .7-4.2 1.6-6.2 2.4c-6.2-6.9-16-9.6-24.9-6.8zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faCircleArrowDownRight = {
  prefix: 'far',
  iconName: 'circle-arrow-down-right',
  icon: [
    512,
    512,
    [],
    'e0fa',
    'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368l152 0c13.3 0 24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1L185 151c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l135 135L192 320c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faAlien8bit = {
  prefix: 'far',
  iconName: 'alien-8bit',
  icon: [
    576,
    512,
    [128126, 'alien-monster'],
    'f8f6',
    'M120 32c13.3 0 24 10.7 24 24l24 0c13.3 0 24 10.7 24 24l0 48 192 0 0-48c0-13.3 10.7-24 24-24l24 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c0 13.3-10.7 24-24 24l-24 0 0 48 0 8 24 0c13.3 0 24 10.7 24 24l0 56 8 0 40 0 0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-40 0 0 72c0 13.3-10.7 24-24 24l-40 0 0 72c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-48-224 0 0 48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-72-40 0c-13.3 0-24-10.7-24-24l0-72-40 0c-13.3 0-24-10.7-24-24L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 40 0 8 0 0-56c0-13.3 10.7-24 24-24l24 0 0-8 0-48-24 0c-13.3 0-24-10.7-24-24l0-24c0-13.3 10.7-24 24-24zm72 144l0 8c0 13.3-10.7 24-24 24l-24 0 0 56c0 13.3-10.7 24-24 24l-8 0 0 48 40 0 272 0 40 0 0-48-8 0c-13.3 0-24-10.7-24-24l0-56-24 0c-13.3 0-24-10.7-24-24l0-8-192 0zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48zm144-16l32 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z',
  ],
};
const faAlienMonster = faAlien8bit;
const faHandPointRibbon = {
  prefix: 'far',
  iconName: 'hand-point-ribbon',
  icon: [
    448,
    512,
    [],
    'e1a6',
    'M112 48c8.8 0 16 7.2 16 16l0 16L96 80l0-16c0-8.8 7.2-16 16-16zm64 32l0-16c0-35.3-28.7-64-64-64S48 28.7 48 64l0 16L11.8 80C5.3 80 0 85.3 0 91.8c0 3.9 1.9 7.5 5.1 9.7L43.6 128 5.1 154.5c-3.2 2.2-5.1 5.8-5.1 9.7C0 170.7 5.3 176 11.8 176L48 176l0 96c-10 13.4-16 30-16 48c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-24 0-64c0-35.3-28.7-64-64-64c-11 0-21.3 2.8-30.3 7.6C309.9 185.2 292 176 272 176c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36l0-48c0-8.8-7.2-16-16-16zm-48 96l0 32 0 32-16 0c-5.5 0-10.8 .6-16 1.6L96 176l32 0zm24 112l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c11 0 21.3-2.8 30.3-7.6C314.1 374.8 332 384 352 384c3.2 0 6.3-.2 9.4-.7C345.1 430.3 300.5 464 248 464l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l40 0zm200-48c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16 0-48c0-8.8 7.2-16 16-16zm-144 2c-5.1-1.3-10.5-2-16-2l-16 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 2zm48-2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-24z',
  ],
};
const faPoop = {
  prefix: 'far',
  iconName: 'poop',
  icon: [
    512,
    512,
    [],
    'f619',
    'M201.8 14.8C205.5 5.8 214.3 0 224 0l8 0c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 1.1 0 2.2-.1 3.3c33 14 56.1 46.6 56.1 84.7c0 14.3-3.3 27.8-9.1 39.9c20.3 19 33.1 46 33.1 76.1c0 57.4-46.6 104-104 104l-304 0C46.6 512 0 465.4 0 408c0-30.1 12.8-57.1 33.1-76.1C27.3 319.8 24 306.3 24 292c0-38.1 23.1-70.7 56.1-84.7c0-1.1-.1-2.2-.1-3.3c0-48.1 33.9-88.2 79.1-97.8c5.7-1.4 11.7-2.2 17.8-2.2l3.1 0 14.7 0c16.2 0 29.3-13.1 29.3-29.3l0-3.2c0-8.6-3.4-16.9-9.5-23L207 41c-6.9-6.9-8.9-17.2-5.2-26.2zm68.5 40.5c1.1 5.3 1.6 10.7 1.6 16.1l0 3.2c0 42.7-34.6 77.3-77.3 77.3L180 152l-3.1 0c-2.2 0-4.3 .3-6.3 .8c-.4 .1-.8 .2-1.2 .3C145.8 158 128 178.9 128 204c0 4.9 .7 9.7 1.9 14.1c1.9 6.7 .8 13.9-3 19.7s-10 9.7-16.9 10.6c-21.5 2.9-38 21.3-38 43.6c0 11.4 4.3 21.8 11.4 29.6c5 5.4 7.1 12.9 5.9 20.1s-5.7 13.6-12.2 17.1C59.7 368.3 48 386.8 48 408c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56c0-21.2-11.8-39.7-29.2-49.2c-6.5-3.5-10.9-9.8-12.2-17.1s1-14.7 5.9-20.1c7.1-7.8 11.4-18.2 11.4-29.6c0-22.3-16.6-40.7-38-43.6c-6.9-.9-13-4.8-16.9-10.6s-4.9-13-3-19.7c1.3-4.5 1.9-9.2 1.9-14.1c0-22.3-14-41.4-33.8-48.7c-8.2-3-14-10.3-15.3-18.9c-5.6-37-30.7-67.6-64.5-81z',
  ],
};
const faObjectExclude = {
  prefix: 'far',
  iconName: 'object-exclude',
  icon: [
    512,
    512,
    [],
    'e49c',
    'M64 48l224 0c8.8 0 16 7.2 16 16l0 64 48 0 0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-48-64 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm96 336l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64-48 0zm128-32c35.3 0 64-28.7 64-64l-48 0c0 8.8-7.2 16-16 16l-32 0 0 48 32 0zm64-144l0-48-48 0-16 0 0 48 16 0 0 48 48 0 0-48zM224 352l0-48-16 0 0-48-48 0 0 48 0 48 48 0 16 0zM160 224l48 0c0-8.8 7.2-16 16-16l32 0 0-48-32 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faTelescope = {
  prefix: 'far',
  iconName: 'telescope',
  icon: [
    576,
    512,
    [128301],
    'e03e',
    'M459.7 231.7l61.5-35.5-80-138.6L379.7 93.1l80 138.6zM328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c.6 4 .9 8.1 .9 12.3c0 20.1-7.4 38.5-19.7 52.5l49.9 122.4c5 12.3-.9 26.3-13.2 31.3s-26.3-.9-31.3-13.2l-47-115.3c-6 1.5-12.3 2.2-18.8 2.2s-12.8-.8-18.8-2.2l-47 115.3c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l44.3-108.8L149.5 418c-15.2 8.2-34.3 2.9-42.9-12.1l-.7-1.3L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6zm73.3 127.5l-49.5-85.7L101.3 300.7l39.1 67.7L226 322.1c-1.3-5.8-2-11.9-2-18.1c0-44.2 35.8-80 80-80c22.7 0 43.2 9.5 57.8 24.7l39.9-21.6zM304 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faLocationPin = {
  prefix: 'far',
  iconName: 'location-pin',
  icon: [
    384,
    512,
    ['map-marker'],
    'f041',
    'M320.7 249.2c-10.5 24.8-25.4 52.2-42.5 79.9C249.8 375.3 216.8 420 192 451.7c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9C52.5 223.6 48 204.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2zm-105 250C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z',
  ],
};
const faMapMarker = faLocationPin;
const faSquareList = {
  prefix: 'far',
  iconName: 'square-list',
  icon: [
    448,
    512,
    [],
    'e489',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faKaaba = {
  prefix: 'far',
  iconName: 'kaaba',
  icon: [
    576,
    512,
    [128331],
    'f66b',
    'M288 48.8L490.4 112 288 175.2 85.6 112 288 48.8zm9.5 173.8l230.5-72 0 45.7L292.8 269.7c-3.1 1-6.4 1-9.5 0L48 196.2l0-45.7 230.5 72c6.2 1.9 12.9 1.9 19.1 0zM48 229.8l225.7 70.5c9.3 2.9 19.3 2.9 28.6 0L528 229.8l0 30.5-4.8 1.5c-8.4 2.6-13.1 11.6-10.5 20c2.1 6.8 8.5 11.2 15.3 11.2l0 95.2-240 75-240-75L48 293c6.8 0 13.1-4.4 15.3-11.2c2.6-8.4-2.1-17.4-10.5-20L48 260.2l0-30.5zM22.5 81.5C9.1 85.6 0 98 0 112L0 400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400l0-288c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zm94.3 200.3c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z',
  ],
};
const faToiletPaper = {
  prefix: 'far',
  iconName: 'toilet-paper',
  icon: [
    640,
    512,
    [129531],
    'f71e',
    'M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7c0 0 0 0 0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0L492.2 0c0 0 0 .1 0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464l260.1 0c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48L160 48zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faHelmetSafety = {
  prefix: 'far',
  iconName: 'helmet-safety',
  icon: [
    576,
    512,
    ['hard-hat', 'hat-hard'],
    'f807',
    'M264 80l48 0c4.4 0 8 3.6 8 8l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-30.9-25.1-56-56-56l-48 0c-30.9 0-56 25.1-56 56l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-4.4 3.6-8 8-8zM559.4 384L16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6zM32 288l0 64 48 0 0-64c0-68.4 39-127.7 96-156.8l0-52.5C91.8 110.9 32 192.5 32 288zm464-2.2l0 66.2 48 0 0-64 0-2.4c-1-94.5-60.5-174.9-144-206.9l0 52.5c56.4 28.8 95.2 87.2 96 154.6z',
  ],
};
const faHardHat = faHelmetSafety;
const faHatHard = faHelmetSafety;
const faCommentCode = {
  prefix: 'far',
  iconName: 'comment-code',
  icon: [
    512,
    512,
    [],
    'e147',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM217 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z',
  ],
};
const faSimCards = {
  prefix: 'far',
  iconName: 'sim-cards',
  icon: [
    448,
    512,
    [],
    'e251',
    'M144 352c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-213.5c0-4.2-1.7-8.3-4.7-11.3L320.8 52.7c-3-3-7.1-4.7-11.3-4.7L160 48c-8.8 0-16 7.2-16 16l0 288zM429.3 93.3c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L309.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm184 80l64 0 0 64-16 0-80 0 0-32c0-17.7 14.3-32 32-32zM176 304l0-32 64 0 0 64-32 0c-17.7 0-32-14.3-32-32zm192 0c0 17.7-14.3 32-32 32l-64 0 0-64 16 0 80 0 0 32zm0-96l0 32-64 0 0-64 32 0c17.7 0 32 14.3 32 32z',
  ],
};
const faStarship = {
  prefix: 'far',
  iconName: 'starship',
  icon: [
    640,
    512,
    [],
    'e039',
    'M0 96C0 60.7 28.7 32 64 32l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-27.2 0 37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4L164.8 352l27.2 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64s28.7-64 64-64l16.5 0 50.1-34.7-13.7-1.6C86.7 312 64 286.4 64 256s22.7-56 52.9-59.6l13.7-1.6L80.5 160 64 160C28.7 160 0 131.3 0 96zM64 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 80zm58.6 164c-6.1 .7-10.6 5.9-10.6 12s4.6 11.3 10.6 12l135.4 16.3c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2L122.6 244zM48 416c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 400c-8.8 0-16 7.2-16 16zm400-16a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
};
const faEject = {
  prefix: 'far',
  iconName: 'eject',
  icon: [
    448,
    512,
    [9167],
    'f052',
    'M4.1 323.3c-7.7-17.4-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64s26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352L48 352c-19 0-36.3-11.2-43.9-28.7zM48 304l352 0L224 112 48 304zM24 400l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCircleRight = {
  prefix: 'far',
  iconName: 'circle-right',
  icon: [
    512,
    512,
    [61838, 'arrow-alt-circle-right'],
    'f35a',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 151.2c-4.2-4.6-10.1-7.2-16.4-7.2C266 144 256 154 256 166.3l0 41.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 41.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.4-7.2l84-91c3.5-3.8 5.4-8.7 5.4-13.9s-1.9-10.1-5.4-13.9l-84-91z',
  ],
};
const faArrowAltCircleRight = faCircleRight;
const faPlaneCircleCheck = {
  prefix: 'far',
  iconName: 'plane-circle-check',
  icon: [
    640,
    512,
    [],
    'e555',
    'M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faSeal = {
  prefix: 'far',
  iconName: 'seal',
  icon: [
    512,
    512,
    [],
    'e241',
    'M210.4 97.9c-9 9-21.2 14.1-33.9 14.1L112 112l0 64.5c0 12.7-5.1 24.9-14.1 33.9L52.4 256l45.6 45.6c9 9 14.1 21.2 14.1 33.9l0 64.5 64.5 0c12.7 0 24.9 5.1 33.9 14.1L256 459.6l45.6-45.6c9-9 21.2-14.1 33.9-14.1l64.5 0 0-64.5c0-12.7 5.1-24.9 14.1-33.9L459.6 256l-45.6-45.6c-9-9-14.1-21.2-14.1-33.9l0-64.5-64.5 0c-12.7 0-24.9-5.1-33.9-14.1L256 52.4 210.4 97.9zm11.6-79.5c18.7-18.7 49.1-18.7 67.9 0L335.5 64 400 64c26.5 0 48 21.5 48 48l0 64.5 45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5l0 64.5c0 26.5-21.5 48-48 48l-64.5 0-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448 112 448c-26.5 0-48-21.5-48-48l0-64.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5 64 112c0-26.5 21.5-48 48-48l64.5 0 45.6-45.6z',
  ],
};
const faUserCowboy = {
  prefix: 'far',
  iconName: 'user-cowboy',
  icon: [
    448,
    512,
    [],
    'f8ea',
    'M208.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.6 0 58.8 59.3 72.4 112c7.1-2.2 13.7-4.5 19.8-6.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.4 5.4-15.4 10.6-23.8 15.5c.8 5.8 1.2 11.6 1.2 17.6c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-6 .4-11.9 1.2-17.6c-8.4-4.8-16.4-10-23.8-15.5C35.8 147.5 10.1 113 .8 85.1c-2.5-7.4 .8-15.6 7.8-19.2s15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7c6.1 2.4 12.7 4.7 19.8 6.9C117.2 59.3 140.4 0 176 0c18 0 25.9 5.4 32.5 9.9zM224 224c-29 0-55.8-4.8-79.9-12.7c1.7 42.7 36.8 76.7 79.9 76.7s78.2-34.1 79.9-76.7C279.8 219.2 253 224 224 224zM54.2 458.7l-.6 5.3 340.7 0-.6-5.3c-2.7-24.3-23.2-42.7-47.7-42.7l-244.2 0c-24.5 0-45 18.4-47.7 42.7zM6.5 453.4C11.9 404.8 53 368 101.9 368l244.2 0c48.9 0 90 36.8 95.4 85.4l2.6 23.1c2.1 19-12.7 35.5-31.8 35.5L35.8 512c-19.1 0-33.9-16.6-31.8-35.5l2.6-23.1z',
  ],
};
const faHexagonVerticalNft = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft',
  icon: [
    448,
    512,
    [],
    'e505',
    'M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9L0 168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.6c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4l0 176.6c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm-48-41.6c7.4 4.3 16.6 4.3 24 0l152.9-88.3c7.4-4.3 12-12.2 12-20.8l0-176.6c0-8.6-4.6-16.5-12-20.8L236.9 59.2c-7.4-4.3-16.6-4.3-24 0L60 147.5c-7.4 4.3-12 12.2-12 20.8l0 176.6c0 8.6 4.6 16.5 12 20.8l152.9 88.3zM95.8 170.6l33.1 82.9 0-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L96.9 259.7l0 76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-80zm112-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faFaceRollingEyes = {
  prefix: 'far',
  iconName: 'face-rolling-eyes',
  icon: [
    512,
    512,
    [128580, 'meh-rolling-eyes'],
    'f5a5',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z',
  ],
};
const faMehRollingEyes = faFaceRollingEyes;
const faBreadLoaf = {
  prefix: 'far',
  iconName: 'bread-loaf',
  icon: [
    640,
    512,
    [127838],
    'f7eb',
    'M64 208c-8.8 0-16-7.2-16-16c0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6C408.4 128.1 432 155.3 432 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 176-48 0-208 0 0-176c0-26.5-21.5-48-48-48zm352 48l112 0 0 176-112 0 0-128 0-48zm155.3-47.8c-1.1-.1-2.2-.2-3.3-.2l-90 0c1.3-5.1 2-10.5 2-16c0-51.1-28-86.9-65.8-111.5c28.7 2 72.2 9.7 109.7 27C568.4 128.1 592 155.3 592 192c0 8.8-7.2 16-16 16c-1.6 0-3.1 .1-4.7 .2zM112 480l208 0 48 0 160 0c26.5 0 48-21.5 48-48l0-128 0-48c35.3 0 64-28.7 64-64C640 64 464 32 400 32L288 32l-48 0C176 32 0 64 0 192c0 35.3 28.7 64 64 64l0 48 0 128c0 26.5 21.5 48 48 48z',
  ],
};
const faRingsWedding = {
  prefix: 'far',
  iconName: 'rings-wedding',
  icon: [
    512,
    512,
    [],
    'f81b',
    'M119.9 105.1C50.2 128.6 0 194.4 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128c-32.8 0-62.7-12.3-85.3-32.6c0 0 0 0 0 0c-12.3-11-22.5-24.4-29.8-39.5c0 0 0 0 0 0C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105c7 14.8 17.7 27.5 30.8 37c43.7-32 72-83.7 72-142c0-77.6-50.2-143.4-119.9-166.9l22.5-50.6c1.9-4.4 1.8-9.4-.3-13.7l-16-32C235.6 3.4 230.1 0 224 0L128 0c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.1 4.3-2.3 9.3-.3 13.7l22.5 50.6zM147.8 48l56.4 0 .4 .8L187.2 88l-22.4 0L147.4 48.8l.4-.8zM160 336c0 22.6 4.2 44.1 12 63.9C103.1 397.8 48 341.3 48 272c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6C201.5 204.7 160 265.5 160 336z',
  ],
};
const faObjectGroup = {
  prefix: 'far',
  iconName: 'object-group',
  icon: [
    576,
    512,
    [],
    'f247',
    'M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z',
  ],
};
const faFrenchFries = {
  prefix: 'far',
  iconName: 'french-fries',
  icon: [
    384,
    512,
    [127839],
    'f803',
    'M167.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l32 16c5.4 2.7 8.8 8.1 8.8 14.1l0 238c-9.2 1.4-19.8 2.2-32 2.2s-22.8-.8-32-2.2l0-63.2s0 0 0 0L160 16c0-5.5 2.9-10.7 7.6-13.6zM128 261c-4.8-2.1-8.7-4.4-11.8-6.6c-12-8.4-16.7-18-18.7-24.3c-.4-1.1-.8-2.3-1.2-3.4l-32-192c-1.2-6.9 2.3-13.8 8.6-16.9l32-16c4.5-2.3 9.9-2.3 14.4 .1s7.7 6.6 8.5 11.6l.2 1.3L128 261zM58.2 193c-3.2-.7-6.6-1-10.2-1l-26.6 0c-1.6 0-3.2 .1-4.7 .2L.2 98.8C-.7 93.4 1.1 88 5.1 84.3s9.5-5.1 14.8-3.8l20.4 5.1L58.2 193zm309.1-.8c-1.6-.1-3.1-.2-4.7-.2L336 192c-3.1 0-6 .3-8.8 .8L346.2 85l17.9-4.5c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5l-16.5 93.4zM289.4 223c-1.1 2.4-2.1 4.7-2.8 7c-2 6.3-6.7 15.9-18.7 24.3c-3.2 2.2-7.1 4.5-11.8 6.6l0-206.4 .2-1.4C257.3 47 262 42 268.1 40.5l32-8c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5L289.4 223zM48 224c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7l26.6 0c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5L89.2 512c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224L48 224zm269.9 92.8c-1.4 1.1-2.8 2.1-4.3 3.1C284.7 340.1 244.9 352 192 352s-92.7-11.9-121.6-32.1c-1.5-1-2.9-2.1-4.3-3.1L101.8 464l180.5 0 35.7-147.2z',
  ],
};
const faChartLine = {
  prefix: 'far',
  iconName: 'chart-line',
  icon: [
    512,
    512,
    ['line-chart'],
    'f201',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM473 169c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z',
  ],
};
const faLineChart = faChartLine;
const faCalendarArrowDown = {
  prefix: 'far',
  iconName: 'calendar-arrow-down',
  icon: [
    448,
    512,
    ['calendar-download'],
    'e0d0',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM248 248l0 102.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L200 248c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faCalendarDownload = faCalendarArrowDown;
const faSendBack = {
  prefix: 'far',
  iconName: 'send-back',
  icon: [
    640,
    512,
    [],
    'f87e',
    'M192 48c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16L64 208c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l128 0zM64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L64 0zM576 304c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l128 0zM448 256c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-128 0zM160 288l0 64c0 35.3 28.7 64 64 64l128 0 0-96c0-53 43-96 96-96l32 0 0-64c0-35.3-28.7-64-64-64L288 96l0 96c0 53-43 96-96 96l-32 0z',
  ],
};
const faMaskVentilator = {
  prefix: 'far',
  iconName: 'mask-ventilator',
  icon: [
    640,
    512,
    [],
    'e524',
    'M176 300.8c0 26.7 8.9 52.3 24.7 73.6c-.5-4.3-.7-8.7-.7-13.1c0-31.9 12.4-72.4 31.4-104.9c9.6-16.5 21.7-32.1 36-43.8C281.7 200.9 299.5 192 320 192c20.4 0 38.2 8.9 52.4 20.7s26.3 27.3 36 43.8c19.1 32.5 31.6 73 31.6 104.9c0 4.3-.2 8.5-.6 12.7C455 352.8 464 327.4 464 300.8c0-38.2-17.9-96.6-49.1-145.7C382.2 103.7 346.7 80 320 80c-27.3 0-62.7 23.8-95.2 75C193.7 204.1 176 262.5 176 300.8zm72 60.5c0 21.8 9.2 41.2 24 54.5l0 58.6c-45.3-10.8-84-36.5-109.8-71.1L90.9 385.5C37.5 372.1 0 324.1 0 269l0-85c0-30.9 25.1-56 56-56l129.1 0C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96L584 128c30.9 0 56 25.1 56 56l0 85c0 55.1-37.5 103.1-90.9 116.4l-71.6 17.9c-26 34.6-64.7 60.2-109.5 71l0-58.7c14.7-13.3 24-32.6 24-54.3c0-21.6-9.2-53.7-25-80.6c-7.8-13.2-16.4-23.9-25.1-31.1s-16-9.7-21.9-9.7c-6 0-13.5 2.6-22.1 9.7c-8.7 7.1-17.3 17.8-25.1 31c-15.7 26.8-24.8 59-24.8 80.6zm257.6-14.5l31.8-8c32.1-8 54.5-36.8 54.5-69.9l0-85c0-4.4-3.6-8-8-8l-103.3 0c19.8 43.2 31.3 88.7 31.3 124.8c0 16-2.2 31.4-6.4 46.1zM159.1 176L56 176c-4.4 0-8 3.6-8 8l0 85c0 33 22.5 61.8 54.5 69.9l31.8 7.9c-4.1-14.7-6.3-30.1-6.3-46c0-36.1 11.4-81.6 31.1-124.8zM296 328c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184-48 0 0-184z',
  ],
};
const faTickets = {
  prefix: 'far',
  iconName: 'tickets',
  icon: [
    640,
    512,
    [],
    'e658',
    'M160 80c-8.8 0-16 7.2-16 16l0 38.2c24 15.7 40 42.8 40 73.8s-16 58.1-40 73.8l0 38.2c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-38.2c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8L592 96c0-8.8-7.2-16-16-16L160 80zm0-48l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64l0-56c0-8.8 7.4-15.7 15.6-19.1c14.4-6.1 24.4-20.3 24.4-36.9s-10.1-30.8-24.4-36.9C103.4 167.7 96 160.8 96 152l0-56c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 240c0 39.8 32.2 72 72 72l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0C53.7 480 0 426.3 0 360L0 120c0-13.3 10.7-24 24-24zM464 240l0-64-192 0 0 64 192 0zM224 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-96z',
  ],
};
const faSignatureLock = {
  prefix: 'far',
  iconName: 'signature-lock',
  icon: [
    640,
    512,
    [],
    'e3ca',
    'M80 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L62 251.1C25.1 262.5 0 296.6 0 335.2L0 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l72.6 0c5.6-9.7 13.7-17.8 23.4-23.4l0-24.6-61.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zM208.1 368c-7 16.3-14.8 32.4-23.3 48L384 416l0-48-175.9 0zM76.2 297l80.9-25c-11.7 43.2-29.4 84.5-52.4 123L88.8 421.3C84.8 428 77.7 432 70 432c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faArrowRight = {
  prefix: 'far',
  iconName: 'arrow-right',
  icon: [
    448,
    512,
    [8594],
    'f061',
    'M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z',
  ],
};
const faSignsPost = {
  prefix: 'far',
  iconName: 'signs-post',
  icon: [
    512,
    512,
    ['map-signs'],
    'f277',
    'M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 160.3 0c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6L280 192l0 32 168 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-168 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104L71.7 384c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6L232 224l0-32L64 192c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l168 0 0-8zM80 80l0 64 344.9 0 25.6-32L424.9 80 80 80zM432 336l0-64L87.1 272 61.5 304l25.6 32L432 336z',
  ],
};
const faMapSigns = faSignsPost;
const faOctagonPlus = {
  prefix: 'far',
  iconName: 'octagon-plus',
  icon: [
    512,
    512,
    ['plus-octagon'],
    'f301',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faPlusOctagon = faOctagonPlus;
const faCashRegister = {
  prefix: 'far',
  iconName: 'cash-register',
  icon: [
    512,
    512,
    [],
    'f788',
    'M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-56.5 0c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-59.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9L208 160l0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM48 448l0-16 416 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM440.3 221.7L463.5 384l-415 0L71.7 221.7c1.1-7.9 7.9-13.7 15.8-13.7l337 0c8 0 14.7 5.9 15.8 13.7zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z',
  ],
};
const faPersonCircleQuestion = {
  prefix: 'far',
  iconName: 'person-circle-question',
  icon: [
    576,
    512,
    [],
    'e542',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z',
  ],
};
const faMelonSlice = {
  prefix: 'far',
  iconName: 'melon-slice',
  icon: [
    512,
    512,
    [],
    'e311',
    'M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L319 79c-6.2 6.2-8.5 15.3-6.1 23.7c0 0 0 0 0 0l.1 .4c.1 .5 .3 1.3 .6 2.4c.5 2.3 1.2 5.8 1.8 10.4c1.2 9.2 2.1 22.3 .6 37.9c-2.9 30.9-15.1 71.3-53 109.2c-42.3 42.3-82.7 54-111.6 55.9c-14.7 1-26.8-.5-35-2.2c-4.1-.8-7.2-1.7-9.2-2.3c-1-.3-1.7-.5-2-.7l-.3-.1C96 310.2 85.8 312.2 79 319L7 391zM313 102.7s0 0 0 0c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1zm51.8 35.2C377.1 161.3 384 187.8 384 216c0 92.8-75.2 168-168 168c-26.2 0-51-6-73.1-16.7c3.8 0 7.7-.2 11.8-.4c39.9-2.7 91.4-19 142.2-69.9c47.2-47.2 63-98.7 66.8-138.6c.7-7.2 1-14.1 1-20.4zM81.2 384.8C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6s-235.2 96.2-332.6 15.8l22.4-22.4z',
  ],
};
const faSpaceStationMoon = {
  prefix: 'far',
  iconName: 'space-station-moon',
  icon: [
    512,
    512,
    [],
    'e033',
    'M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96c-52.7 0-95.4-42.4-96-94.9C59.7 177.2 48 215.2 48 256c0 12.8 1.1 25.2 3.3 37.4c.5 .2 1 .3 1.5 .5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1c0 0 0 0 0 0c.5-.2 1-.4 1.5-.5c2.2-12.1 3.3-24.6 3.3-37.4c0-114.9-93.1-208-208-208zM441.3 350.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM176 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faMessageSmile = {
  prefix: 'far',
  iconName: 'message-smile',
  icon: [
    512,
    512,
    ['comment-alt-smile'],
    'f4aa',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z',
  ],
};
const faCommentAltSmile = faMessageSmile;
const faCupStraw = {
  prefix: 'far',
  iconName: 'cup-straw',
  icon: [
    384,
    512,
    [129380],
    'e363',
    'M194.8 43.2l-20 84.8-94.7 0L32 128l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12 0 48.2 0 89.9 0 35.8 0 89.9 0 48.2 0 12 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.2 0-79.6 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0c-26 0-48.6 17.9-54.5 43.2zM38.7 208L60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44l21.7-260-48.2 0L275.8 464l-167.7 0L86.8 208l-48.2 0z',
  ],
};
const faLeftFromLine = {
  prefix: 'far',
  iconName: 'left-from-line',
  icon: [
    448,
    512,
    ['arrow-alt-from-right'],
    'f348',
    'M160 146.2L50 256 160 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM0 256c0-11.5 4.6-22.5 12.7-30.6L128.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L12.7 286.6C4.6 278.5 0 267.5 0 256zM400 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336z',
  ],
};
const faArrowAltFromRight = faLeftFromLine;
const faH = {
  prefix: 'far',
  iconName: 'h',
  icon: [
    384,
    512,
    [104],
    '48',
    'M336 256l0 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232 0-168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152L48 208 48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-200 288 0z',
  ],
};
const faBasketShoppingSimple = {
  prefix: 'far',
  iconName: 'basket-shopping-simple',
  icon: [
    576,
    512,
    ['shopping-basket-alt'],
    'e0af',
    'M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240l-389 0 53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faShoppingBasketAlt = faBasketShoppingSimple;
const faHandsHoldingHeart = {
  prefix: 'far',
  iconName: 'hands-holding-heart',
  icon: [
    640,
    512,
    ['hands-heart'],
    'f4c3',
    'M195.9 136.9L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z',
  ],
};
const faHandsHeart = faHandsHoldingHeart;
const faClockNine = {
  prefix: 'far',
  iconName: 'clock-nine',
  icon: [
    512,
    512,
    [],
    'e34c',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 13.3-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHammerBrush = {
  prefix: 'far',
  iconName: 'hammer-brush',
  icon: [
    640,
    512,
    [],
    'e620',
    'M152 0C68.1 0 0 68.1 0 152l0 16c0 8.3 4.3 16 11.4 20.4s15.9 4.8 23.4 1.1l45.7-22.9c10.2 10.7 23.2 18.5 37.5 22.5L100.4 448.1C98 482.7 125.4 512 160 512s62-29.3 59.6-63.9L202.2 191.8c23.4-1.7 44.9-13.4 59-31.8l42.8 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-31.8 0-.2 0-80 0-.2L352 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-42.8 0C245.8 12.1 221.9 0 196.2 0L152 0zM304 112l-56 0c-9.1 0-17.4 5.1-21.5 13.3c-5.7 11.5-17.5 18.7-30.3 18.7l-56.4 0c-12.8 0-24.6-7.3-30.3-18.7c-5.9-11.9-20.3-16.7-32.2-10.7L50.8 127.7C61.8 82 102.9 48 152 48l44.2 0c12.8 0 24.6 7.3 30.3 18.7C230.6 74.9 238.9 80 248 80l56 0 0 32zM592 464l-112 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0 0-144 192 0 0 144zM380.5 237c-17.8 11.9-28.5 31.9-28.5 53.3L352 464c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-173.7c0-21.4-10.7-41.4-28.5-53.3L544 192l0-144c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 144-67.5 45zM480 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faTarp = {
  prefix: 'far',
  iconName: 'tarp',
  icon: [
    576,
    512,
    [],
    'e57b',
    'M48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 160-80 0c-17.7 0-32 14.3-32 32l0 80L64 400c-8.8 0-16-7.2-16-16l0-256zm528 0c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l364.1 0c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9L576 128zM112 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faFaceSleepy = {
  prefix: 'far',
  iconName: 'face-sleepy',
  icon: [
    512,
    512,
    [],
    'e38e',
    'M256 464c47 0 90.4-15.6 125.2-41.9c2.7 14.8 2.8 29.6 2.8 41.9c0 4.5 .4 8.9 1.1 13.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7c-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208zm-80-74.5C191.1 364.8 221.3 348 256 348s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4c-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zM326.2 250.3c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 293.2 371 300 351.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM159.6 260c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 293.2 179 300 159.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z',
  ],
};
const faHandHorns = {
  prefix: 'far',
  iconName: 'hand-horns',
  icon: [
    384,
    512,
    [],
    'e1a9',
    'M80 48c8.8 0 16 7.2 16 16l0 144 0 32-16 0c-5.5 0-10.8 .6-16 1.6L64 64c0-8.8 7.2-16 16-16zM16 64l0 208C6 285.4 0 302 0 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-56 0-32 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 50c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2l0-82c0-35.3-28.7-64-64-64S16 28.7 16 64zM336 256l0 32 0 56c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l40 0 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64l0-48 0-16 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128zM160 240l-16 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 2c-5.1-1.3-10.5-2-16-2zm96 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16z',
  ],
};
const faScrewdriverWrench = {
  prefix: 'far',
  iconName: 'screwdriver-wrench',
  icon: [
    512,
    512,
    ['tools'],
    'f7d9',
    'M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l54.1 0 109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109 0-54.1c0-7.5-3.5-14.5-9.4-19L78.6 5zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-8.9-17.6-12.8-37.1-11.6-56.3L101.3 454.9c-5.9 5.8-13.8 9.1-22.1 9.1C62 464 48 450 48 432.8c0-8.3 3.3-16.2 9.1-22.1L194.3 273.5l-33.9-33.9L23.2 376.8zM463.9 164c-1.4 38.9-22.6 72.8-53.8 91.8c1.1 1 2.1 2 3.1 3l31.6 31.6c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7L368 160c-8.8 0-16-7.2-16-16l0-25.4c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C294.7 0 244.4 30.1 216.2 75.4C221.2 84 224 93.8 224 104l0 40.8 16 16 0-.8c0-60.5 48-109.9 108-111.9L322.7 73.4s0 0 0 0c-12 12-18.7 28.3-18.7 45.3l0 25.4c0 35.3 28.7 64 64 64l25.4 0c17 0 33.3-6.7 45.3-18.7L463.9 164z',
  ],
};
const faTools = faScrewdriverWrench;
const faArrowsToEye = {
  prefix: 'far',
  iconName: 'arrows-to-eye',
  icon: [
    640,
    512,
    [],
    'e4bf',
    'M49 15C39.6 5.7 24.4 5.7 15 15S5.7 39.6 15 49l63 63L40 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 38.1L49 15zM320 352c-64.5 0-113.8-52.1-138.5-96c24.7-43.9 74-96 138.5-96s113.8 52.1 138.5 96c-24.7 43.9-74 96-138.5 96zm0-240c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM625 15c-9.4-9.4-24.6-9.4-33.9 0l-63 63L528 40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 63-63c9.4-9.4 9.4-24.6 0-33.9zM49 497l63-63 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0L15 463c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm576 0c9.4-9.4 9.4-24.6 0-33.9l-63-63 38.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-38.1 63 63c9.4 9.4 24.6 9.4 33.9 0zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faCircleThreeQuarters = {
  prefix: 'far',
  iconName: 'circle-three-quarters',
  icon: [
    512,
    512,
    [],
    'e125',
    'M256 304c-26.5 0-48-21.5-48-48l0-202.4C116.3 75.2 48 157.7 48 256c0 114.9 93.1 208 208 208c98.3 0 180.8-68.3 202.4-160L256 304zM224.1 2C241.6-.2 256 14.3 256 32l0 176 0 48 48 0 176 0c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z',
  ],
};
const faTrophyStar = {
  prefix: 'far',
  iconName: 'trophy-star',
  icon: [
    576,
    512,
    ['trophy-alt'],
    'f2eb',
    'M176.9 48c6.4 160.7 44.3 231.4 71.8 261.7c13.7 15.1 25.9 21.4 33.1 24.1c2.6 1 4.7 1.5 6.1 1.9c1.4-.3 3.5-.9 6.1-1.9c7.2-2.7 19.4-9 33.1-24.1c27.5-30.3 65.5-101 71.8-261.7L176.9 48zM176 0L400 0c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8L552 64c13.3 0 24 10.7 24 24c0 108.5-45.9 177.7-101.4 220.6c-53.9 41.7-115.7 57.6-149.5 63.7c-4.7 2.5-9.1 4.5-13.1 6.1l0 85.6 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-85.6c-4-1.6-8.4-3.6-13.1-6.1c-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88C0 74.7 10.7 64 24 64l105.6 0c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM390.8 302.6c18.1-8 36.8-18.4 54.4-32c40.6-31.3 75.9-80.2 81.9-158.6l-84.4 0c-9.1 90.1-29.2 150.3-51.9 190.6zm-260-32c17.5 13.6 36.3 24 54.4 32c-22.7-40.3-42.8-100.5-51.9-190.6l-84.4 0c6 78.4 41.3 127.3 81.9 158.6zM295.2 102.5l14.5 29.3c1.2 2.4 3.4 4 6 4.4l32.4 4.7c6.6 1 9.2 9 4.4 13.6l-23.4 22.8c-1.9 1.8-2.7 4.5-2.3 7.1l5.5 32.2c1.1 6.5-5.7 11.5-11.6 8.4l-29-15.2c-2.3-1.2-5.1-1.2-7.4 0l-29 15.2c-5.9 3.1-12.7-1.9-11.6-8.4l5.5-32.2c.4-2.6-.4-5.2-2.3-7.1l-23.4-22.8c-4.7-4.6-2.1-12.7 4.4-13.6l32.4-4.7c2.6-.4 4.9-2 6-4.4l14.5-29.3c2.9-5.9 11.4-5.9 14.3 0z',
  ],
};
const faTrophyAlt = faTrophyStar;
const faPlugCircleBolt = {
  prefix: 'far',
  iconName: 'plug-circle-bolt',
  icon: [
    576,
    512,
    [],
    'e55b',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z',
  ],
};
const faFaceThermometer = {
  prefix: 'far',
  iconName: 'face-thermometer',
  icon: [
    576,
    512,
    [],
    'e39a',
    'M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5c1.5-1.3 3-2.6 4.4-4L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48zM546.8 180.1c19.8 19.8 19.4 52.1-.9 71.4L415.1 376.1c-1.2 4.2-3.4 8.1-6.8 11.2c-9.7 9-24.9 8.4-33.9-1.4C359.2 369.5 333.2 352 296 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4c16.2 0 31.1 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8 .7zM401.3 345l28-26.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L372.5 323.9c11.2 6.3 20.8 13.7 28.9 21.1zm-193-169a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faGridRound4 = {
  prefix: 'far',
  iconName: 'grid-round-4',
  icon: [
    448,
    512,
    [],
    'e5dd',
    'M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zM44.8 183.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM57.6 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM177.1 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM296.5 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z',
  ],
};
const faSignPostsWrench = {
  prefix: 'far',
  iconName: 'sign-posts-wrench',
  icon: [
    640,
    512,
    [],
    'e626',
    'M64 24l0 8L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l16 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 272 0c-10.8-14.3-19.2-30.5-24.7-48L48 368 48 80l480 0 0 80.8c16.9 1.7 33.1 6 48 12.5L576 80c0-26.5-21.5-48-48-48l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L112 32l0-8c0-13.3-10.7-24-24-24S64 10.7 64 24zM640 320c0-47.4-25.7-88.8-64-110.9c-7.4-4.3-16 1.5-16 10l0 84.9c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-84.9c0-8.5-8.6-14.3-16-10c-38.3 22.1-64 63.5-64 110.9c0 40.4 18.7 76.5 48 99.9l0 56.1c0 19.9 16.1 36 36 36l88 0c19.9 0 36-16.1 36-36l0-56.1c29.3-23.5 48-59.5 48-99.9zM512.3 192l-.3 0-.3 0 .7 0z',
  ],
};
const faShirtRunning = {
  prefix: 'far',
  iconName: 'shirt-running',
  icon: [
    384,
    512,
    [],
    'e3c8',
    'M88 0c13.3 0 24 10.7 24 24l0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24c0 127.9 26.8 181 41.5 200.5c9.6 12.8 22.5 32.8 22.5 56.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 280.7c0-23.5 12.9-43.5 22.5-56.3C37.2 205 64 151.9 64 24C64 10.7 74.7 0 88 0zM60.8 253.4C52.2 264.8 48 273.9 48 280.7l0 110.1L299.3 209.3c-5.4-13.6-10.4-29.8-14.6-49.1C261.4 184.7 228.5 200 192 200s-69.4-15.3-92.7-39.8C89 206.9 74.1 235.7 60.8 253.4zM48.1 450c1 7.9 7.7 14 15.9 14l256 0c8.8 0 16-7.2 16-16l0-167.3c0-6.8-4.2-15.9-12.8-27.3c-.3-.4-.7-.9-1-1.4L48.1 450z',
  ],
};
const faBookCircleArrowUp = {
  prefix: 'far',
  iconName: 'book-circle-arrow-up',
  icon: [
    640,
    512,
    [],
    'e0bd',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l314.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l242.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 164.5c14.6-9.5 30.8-17 48-21.8L448 56c0-30.9-25.1-56-56-56L88 0zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z',
  ],
};
const faFaceNauseated = {
  prefix: 'far',
  iconName: 'face-nauseated',
  icon: [
    512,
    512,
    [],
    'e381',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM172 267.2C189 277 202 293 208 312l96.2 0c6.1-18.8 19-34.5 35.8-44.2c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8c-17.1-9.9-30.2-26-36.2-45.3L208 360c-6 19-19.1 35-36 44.8c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8z',
  ],
};
const faHeart = {
  prefix: 'far',
  iconName: 'heart',
  icon: [
    512,
    512,
    [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578],
    'f004',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z',
  ],
};
const faFileChartPie = {
  prefix: 'far',
  iconName: 'file-chart-pie',
  icon: [
    384,
    512,
    [],
    'f65a',
    'M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 240.1c8.7-1.5 16 5.8 16 14.7l0 65.3c0 8.8 7.2 16 16 16l64 0c8.9 0 16.3 7.4 14.6 16.1c-.5 2.5-1 5-1.7 7.4c-13.7 51.2-66.4 81.6-117.6 67.9s-81.6-66.4-67.9-117.6c10-37.4 40.8-63.7 76.5-69.8zm63.9-30.8c40.3 6.7 72 38.5 78.8 78.8c1.5 8.7-5.8 15.9-14.7 15.9l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16.1 15.9-14.7z',
  ],
};
const faMarsAndVenus = {
  prefix: 'far',
  iconName: 'mars-and-venus',
  icon: [
    512,
    512,
    [9893],
    'f224',
    'M352 24c0 13.3 10.7 24 24 24l38.1 0L371.2 90.9C340.3 64.2 300 48 256 48C158.8 48 80 126.8 80 224c0 89.1 66.2 162.7 152 174.4l0 17.6-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-17.6c85.8-11.7 152-85.3 152-174.4c0-35.8-10.7-69.2-29.1-97L448 81.9l0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24L376 0c-13.3 0-24 10.7-24 24zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z',
  ],
};
const faHouseUser = {
  prefix: 'far',
  iconName: 'house-user',
  icon: [
    576,
    512,
    ['home-user'],
    'e1b0',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM224 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 96l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z',
  ],
};
const faHomeUser = faHouseUser;
const faCircleArrowDownLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-down-left',
  icon: [
    512,
    512,
    [],
    'e0f9',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144l-152 0c-13.3 0-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-135 135 94.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faDumpsterFire = {
  prefix: 'far',
  iconName: 'dumpster-fire',
  icon: [
    640,
    512,
    [],
    'f794',
    'M49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32zM272 160l-124.5 0L173.1 32 272 32l0 128zm32 0l0-128 98.9 0 14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1l-58 0zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.2 .7 .4 1.4 .5 2.1c-17.8-15-44.3-14.6-61.7 1.2zM80.4 192l257.1 0c-4.4 6.2-8.5 12.5-12.3 18.7c-5.8 9.5-11.3 19.3-16.2 29.3L86.4 240l20 160 199.7 0c8.1 17.5 18.8 33.7 31.5 48L112 448l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L42 272l-18 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l12 0-4-32 48.4 0zm425.3-15.7L518 162.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 259.2 640 290.2 640 320.2C640 408.8 568.7 480 480 480c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 368.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 295.1 416 331.6 416 368.2c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faHexagonMinus = {
  prefix: 'far',
  iconName: 'hexagon-minus',
  icon: [
    512,
    512,
    ['minus-hexagon'],
    'f307',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMinusHexagon = faHexagonMinus;
const faLeftToLine = {
  prefix: 'far',
  iconName: 'left-to-line',
  icon: [
    448,
    512,
    ['arrow-alt-to-left'],
    'f34b',
    'M256 146.2L146 256 256 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM96 256c0-11.5 4.6-22.5 12.7-30.6L224.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L108.7 286.6C100.6 278.5 96 267.5 96 256zM48 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64s24 10.7 24 24z',
  ],
};
const faArrowAltToLeft = faLeftToLine;
const faHouseCrack = {
  prefix: 'far',
  iconName: 'house-crack',
  icon: [
    576,
    512,
    [],
    'e3b1',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-106.1 0L288 403.8l79.7-63.3c8.2-6.5 8-19.1-.4-25.3L252.2 229c-14.9-11.1-33.6 7.8-22.3 22.5L288 327.6l-84.8 67.3c-6.4 5.1-7.9 14.2-3.6 21.1L229.9 464 144 464c-17.7 0-32-14.3-32-32z',
  ],
};
const faPawSimple = {
  prefix: 'far',
  iconName: 'paw-simple',
  icon: [
    448,
    512,
    ['paw-alt'],
    'f701',
    'M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zm-.7 146.1c7.1-11.3 19.4-18.1 32.7-18.1s25.7 6.9 32.7 18.1l49.2 78.6c8.7 14 20.9 22.8 32.2 28.1c17.8 8.4 30 26.4 30 47.1c0 28.7-23.3 52-52 52c-11.1 0-21.2-3.4-29.6-9.2c-19.6-13.6-43.8-17.6-62.4-17.6s-42.8 4-62.4 17.6c-8.4 5.8-18.5 9.2-29.6 9.2c-28.7 0-52-23.3-52-52c0-20.8 12.2-38.8 30-47.1c11.2-5.3 23.4-14.1 32.2-28.1l49.2-78.6zm-89.9 53.2c-2.8 4.5-7.1 7.8-11.8 10.1C55.6 305.4 32 339.9 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-40.1-23.6-74.6-57.6-90.6c-4.8-2.2-9-5.6-11.8-10.1l-49.1-78.6C281.6 175.4 253.9 160 224 160s-57.6 15.4-73.4 40.7l-49.2 78.6zM304 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faPawAlt = faPawSimple;
const faArrowLeftLongToLine = {
  prefix: 'far',
  iconName: 'arrow-left-long-to-line',
  icon: [
    640,
    512,
    [],
    'e3d4',
    'M0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88zM135 239c-9.4 9.4-9.4 24.6 0 33.9L271 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L616 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-406.1 0 95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L135 239z',
  ],
};
const faBracketsRound = {
  prefix: 'far',
  iconName: 'brackets-round',
  icon: [
    512,
    512,
    ['parentheses'],
    'e0c5',
    'M148.3 76.6c11.4-6.8 15.1-21.5 8.3-32.9s-21.5-15.1-32.9-8.3C82 60.2 0 137.9 0 256S82 451.8 123.7 476.6c11.4 6.8 26.1 3 32.9-8.3s3-26.1-8.3-32.9C115.3 415.7 48 351.3 48 256s67.3-159.7 100.3-179.4zm215.4 0C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C430 451.8 512 374.1 512 256s-82-195.8-123.7-220.6c-11.4-6.8-26.1-3-32.9 8.3s-3 26.1 8.3 32.9z',
  ],
};
const faParentheses = faBracketsRound;
const faMartiniGlassCitrus = {
  prefix: 'far',
  iconName: 'martini-glass-citrus',
  icon: [
    576,
    512,
    ['cocktail'],
    'f561',
    'M432 240c-14.3 0-27.9-3.1-40.1-8.7l-35.4 35.4C378.5 280.2 404.3 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96l52.6 0c16.6-28.7 47.6-48 83.2-48c53 0 96 43 96 96s-43 96-96 96zM24 128c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l177 177L184 464l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-118.1L409 169c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8L24 128zm310.1 48L208 302.1 81.9 176l252.1 0z',
  ],
};
const faCocktail = faMartiniGlassCitrus;
const faUserShakespeare = {
  prefix: 'far',
  iconName: 'user-shakespeare',
  icon: [
    448,
    512,
    [],
    'e2c2',
    'M224 48c-44.2 0-80 35.8-80 80l0 32c0 40.1 29.5 73.3 68 79.1l0-15.1c0-6.6 5.4-12 12-12s12 5.4 12 12l0 15.1c38.5-5.8 68-39 68-79.1l0-32c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4L286 272c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16l-50.6 0C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30L96 128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM240 416.7c-.3 8.5-7.4 15.3-16 15.3s-15.6-6.8-16-15.3c-23.1 1.9-42.4 7.7-56.5 13.5c-8.6 3.5-15.2 7-19.6 9.6c-2.2 1.3-3.8 2.3-4.8 2.9c-.5 .3-.8 .6-1 .7l-.1 .1c-7.3 5.3-16.9 6-24.9 1.9C93.1 441.3 88 433 88 424l0-29.1C67.7 412.1 53.5 436.4 49.3 464L208 464c0-8.8 7.2-16 16-16s16 7.2 16 16l158.7 0c-4.2-27.6-18.4-51.9-38.7-69.1l0 29.1c0 9-5.1 17.3-13.1 21.4c-8 4.1-17.6 3.3-24.9-1.9l-.1-.1c-.2-.1-.5-.3-1-.7c-1-.6-2.6-1.7-4.8-2.9c-4.4-2.5-11-6-19.6-9.6c-14.1-5.8-33.3-11.6-56.5-13.5zM117.9 325.9C133.4 312.3 153.7 304 176 304l96 0c22.3 0 42.6 8.3 58.1 21.9c68 18.9 117.9 81.3 117.9 155.4c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-74 49.9-136.4 117.9-155.4zM224 368c35.9 0 65.8 8 87.3 16.4C307.7 366 291.5 352 272 352l-96 0c-19.5 0-35.7 14-39.3 32.4C158.2 376 188.1 368 224 368z',
  ],
};
const faArrowRightToArc = {
  prefix: 'far',
  iconName: 'arrow-right-to-arc',
  icon: [
    512,
    512,
    [],
    'e4b2',
    'M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM232.3 134.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l242.9 0-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9s24.2-10.3 33.9-1.3z',
  ],
};
const faFaceSurprise = {
  prefix: 'far',
  iconName: 'face-surprise',
  icon: [
    512,
    512,
    [128558, 'surprise'],
    'f5c2',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faSurprise = faFaceSurprise;
const faBottleWater = {
  prefix: 'far',
  iconName: 'bottle-water',
  icon: [
    320,
    512,
    [],
    'e4c5',
    'M120 0C106.7 0 96 10.7 96 24l0 59.4c-7.6 2.1-14.9 5-21.8 8.9L68 95.7c-27.1 15.1-44 43.7-44 74.8c0 15.9 4.3 30.8 11.9 43.5C28.4 226.2 24 240.6 24 256c0 18 6 34.6 16 48c-10 13.4-16 30-16 48c0 14.6 3.9 28.2 10.7 40C27.9 403.8 24 417.4 24 432c0 44.2 35.8 80 80 80l112 0c44.2 0 80-35.8 80-80c0-14.6-3.9-28.2-10.7-40c6.8-11.8 10.7-25.4 10.7-40c0-18-6-34.6-16-48c10-13.4 16-30 16-48c0-15.4-4.4-29.8-11.9-42c7.6-12.8 11.9-27.6 11.9-43.5c0-31.1-16.8-59.7-44-74.8l-6.2-3.4c-6.9-3.8-14.3-6.8-21.8-8.9L224 24c0-13.3-10.7-24-24-24L120 0zM76.7 239.2c9.4-15.2 9.6-34.3 .5-49.7c-3.3-5.5-5.2-12-5.2-19.1c0-13.6 7.4-26.2 19.3-32.8l6.2-3.4c7.4-4.1 15.6-6.2 24.1-6.2l76.9 0c8.4 0 16.7 2.1 24.1 6.2l6.2 3.4c11.9 6.6 19.3 19.2 19.3 32.8c0 7.1-1.9 13.5-5.2 19.1c-9.1 15.4-8.9 34.5 .5 49.7c3 4.8 4.7 10.5 4.7 16.8c0 7.3-2.4 13.8-6.4 19.2c-12.8 17.1-12.8 40.6 0 57.7c4 5.3 6.4 11.9 6.4 19.2c0 5.9-1.6 11.3-4.3 16c-8.6 14.9-8.6 33.2 0 48.1c2.7 4.7 4.3 10.1 4.3 16c0 17.7-14.3 32-32 32l-112 0c-17.7 0-32-14.3-32-32c0-5.9 1.6-11.3 4.3-16c8.6-14.9 8.6-33.2 0-48.1c-2.7-4.7-4.3-10.1-4.3-16c0-7.3 2.4-13.8 6.4-19.2c12.8-17.1 12.8-40.6 0-57.7c-4-5.3-6.4-11.9-6.4-19.2c0-6.2 1.7-11.9 4.7-16.8zM136 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM112 360c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faCirclePause = {
  prefix: 'far',
  iconName: 'circle-pause',
  icon: [
    512,
    512,
    [62092, 'pause-circle'],
    'f28b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faPauseCircle = faCirclePause;
const faGaugeCirclePlus = {
  prefix: 'far',
  iconName: 'gauge-circle-plus',
  icon: [
    640,
    512,
    [],
    'e498',
    'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faFolders = {
  prefix: 'far',
  iconName: 'folders',
  icon: [
    576,
    512,
    [],
    'f660',
    'M512 336l-352 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L512 144c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16zM160 384l352 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L394.5 96c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7L160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z',
  ],
};
const faAngel = {
  prefix: 'far',
  iconName: 'angel',
  icon: [
    576,
    512,
    [],
    'f779',
    'M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zM256 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM87.6 388.2c5.6-11.1 8.4-23.4 8.4-35.8l0-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464l-70.3 0 37.9-75.8zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3L96 512l53.7 0 276.7 0 53.7 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3l0-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm109.6 26.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8l0 .9c0 12.4 2.9 24.7 8.4 35.8L526.3 464 456 464 380.6 313.2c-4.6-9.2-10.4-17.5-17.3-24.7zm-25.7 46.2L402.3 464l-228.7 0 64.6-129.3C247.7 315.9 267 304 288 304s40.3 11.9 49.7 30.7z',
  ],
};
const faValueAbsolute = {
  prefix: 'far',
  iconName: 'value-absolute',
  icon: [
    512,
    512,
    [],
    'f6a6',
    'M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24L48 56c0-13.3-10.7-24-24-24zM177 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l79 79-79 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79-79 79-79c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-79 79-79-79zM512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400z',
  ],
};
const faRabbit = {
  prefix: 'far',
  iconName: 'rabbit',
  icon: [
    512,
    512,
    [128007],
    'f708',
    'M245.7 0c-24.4 0-45.1 17.9-48.5 42.1l-.7 4.9c-7.8 54.3 8.4 108.9 43.5 150.1l0 20.6c-66.8 20.7-119.8 73-141.4 139.4C90.3 353.8 81.4 352 72 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c14.7 0 28.3-4.4 39.7-11.9C127.8 501.3 150.6 512 176 512l32 0 96 0c23.9 0 44.7-13.1 55.7-32.4l5.1 6.8c21.2 28.3 61.3 34 89.6 12.8s34-61.3 12.8-89.6L388 304c46.4-.1 84-37.8 84-84.3c0-25.3-11.4-49.3-31-65.3L404 124.3c-5.6-4.5-11.5-8.6-17.6-12c10.1-24.8 13.6-52.1 9.8-79.4l-.9-6C393.1 11.4 379.9 0 364.3 0c-8.2 0-16.2 3.3-22 9.1l-2 2c-5.8 5.7-11 11.9-15.7 18.3c14.7 21.5 25.1 45.4 30.7 70.4c-8.4-2.1-17-3.4-25.7-3.7c-8.2-29.3-23.8-56.6-46.2-78.8l-3.1-3.1L263.4 31.1l16.8-16.9C271 5.1 258.6 0 245.7 0zM88.7 406.7c-.4 5.7-.7 11.4-.7 17.3c0 5.6 .5 11.1 1.5 16.4C85.1 445.1 78.9 448 72 448c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7zm156-357.9c.1-.5 .5-.9 1-.9c.3 0 .5 .1 .7 .3l3.1 3.1 16.8-16.9L249.5 51.4c20.4 20.2 33.2 46.2 37.2 73.7c1 6.7 4.7 12.6 10.3 16.4s12.5 5 19 3.5c2.7-.6 5.5-1 8.5-1c17.9 0 35.3 6.2 49.3 17.5l36.9 30.1c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3L352 256c-13.3 0-24 10.7-24 24l0 16c0 5.2 1.7 10.2 4.8 14.4l96 128c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-68.6-91.4c-4.2-5.6-10.6-9-17.5-9.5s-13.8 2.1-18.7 7L271 391c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0-32 0c-22.1 0-40-17.9-40-40c0-80.8 57-148.2 133-164.3c11.1-2.4 19-12.1 19-23.5l0-48.3c0-6.1-2.4-12.1-6.6-16.5C251.8 140.1 237.8 96.8 244 53.8l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faToiletPaperSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-slash',
  icon: [
    640,
    512,
    [],
    'e072',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L518.1 380.8c14.4-4.3 26.5-12.4 35.9-21.3c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1c0 0 0-.1 0-.1L160 0c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM134 79.8c.3-.7 .7-1.4 1-2.1c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0l259 0c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 29.8-1 57-2.7 81.6L134 79.8zM426.5 309c3.4-33.8 5.5-72.6 5.5-117c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144l-35 0-34.5-27zM20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512l285.9 0c22.3 0 45.4-12.1 55.4-36.1c5.4-12.9 12.2-32.1 18.8-58.4l-41.7-32.8c-7.5 35.6-15.8 59.2-21.5 72.8c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2L73.8 464c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-2.6 0-5.1 .1-7.7L66.5 148.4C64.9 162.4 64 177 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6c0 0 0 0 0 .1zM496 240c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z',
  ],
};
const faCircleEuro = {
  prefix: 'far',
  iconName: 'circle-euro',
  icon: [
    512,
    512,
    [],
    'e5ce',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16l16 0c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L128 240c-8.8 0-16-7.2-16-16s7.2-16 16-16l24.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-26.3 0-49.6 12.6-64.4 32l80.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-95.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2l95.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-81.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-54.4 0-101-33.8-119.8-81.5L128 304c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faAppleWhole = {
  prefix: 'far',
  iconName: 'apple-whole',
  icon: [
    448,
    512,
    [127822, 127823, 'apple-alt'],
    'f5d1',
    'M224 112l16 0c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L288 0c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16zM48 288c0-31.7 7.6-62.5 20.4-83.7C80.5 184.3 94.7 176 112 176c17.8 0 43.2 7.4 65.3 16c30 11.7 63.5 11.7 93.5 0c22.1-8.6 47.5-16 65.3-16c17.3 0 31.5 8.3 43.6 28.3C392.4 225.5 400 256.3 400 288c0 54.2-17 100-40.4 131.2c-24 32-51.2 44.8-71.6 44.8c-4.6 0-13.6-1.7-24.9-5.1c-25.4-7.6-52.7-7.6-78.1 0c-11.3 3.4-20.3 5.1-24.9 5.1c-20.4 0-47.6-12.8-71.6-44.8C65 388 48 342.2 48 288zm64-160C35.7 128 0 211.7 0 288C0 416 80 512 160 512c11.9 0 26.5-3.4 38.8-7.1c16.4-4.9 34.1-4.9 50.5 0c12.2 3.7 26.8 7.1 38.8 7.1c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z',
  ],
};
const faAppleAlt = faAppleWhole;
const faKitchenSet = {
  prefix: 'far',
  iconName: 'kitchen-set',
  icon: [
    576,
    512,
    [],
    'e51a',
    'M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120l66.7 0c3.8-22.7 23.6-40 47.3-40l96 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-96 0c-23.8 0-43.5-17.3-47.3-40L286 168zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 264c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 144c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-144-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 40 0 0-8zm-40 56l0 144 128 0 0-144-128 0zM32 336c0-8.8 7.2-16 16-16l80 0 16 0 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80zm128 48l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32zM0 488c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM400 128l0 32 96 0 0-32-96 0z',
  ],
};
const faDiamondHalf = {
  prefix: 'far',
  iconName: 'diamond-half',
  icon: [
    512,
    512,
    [],
    'e5b7',
    'M227.7 11.7C235.5 3.9 245.8 0 256 0l0 48 0 3.3 0 409.4 0 3.3 0 48c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM208 412.7l0-313.4L51.3 256 208 412.7z',
  ],
};
const faLockKeyhole = {
  prefix: 'far',
  iconName: 'lock-keyhole',
  icon: [
    448,
    512,
    ['lock-alt'],
    'f30d',
    'M224 48c44.2 0 80 35.8 80 80l0 64-160 0 0-64c0-44.2 35.8-80 80-80zM96 128l0 64-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z',
  ],
};
const faLockAlt = faLockKeyhole;
const faR = {
  prefix: 'far',
  iconName: 'r',
  icon: [
    320,
    512,
    [114],
    '52',
    'M56 32C25.1 32 0 57.1 0 88L0 280 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 109.9 0L276.5 469.9c7.7 10.8 22.7 13.3 33.5 5.6s13.3-22.7 5.6-33.5L214.5 300.6C274.9 286.7 320 232.6 320 168c0-75.1-60.9-136-136-136L56 32zM176 256L48 256 48 88c0-4.4 3.6-8 8-8l128 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-8 0z',
  ],
};
const faTemperatureQuarter = {
  prefix: 'far',
  iconName: 'temperature-quarter',
  icon: [
    320,
    512,
    ['temperature-1', 'thermometer-1', 'thermometer-quarter'],
    'f2ca',
    'M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z',
  ],
};
const faTemperature1 = faTemperatureQuarter;
const faThermometer1 = faTemperatureQuarter;
const faThermometerQuarter = faTemperatureQuarter;
const faSquareInfo = {
  prefix: 'far',
  iconName: 'square-info',
  icon: [
    448,
    512,
    [8505, 'info-square'],
    'f30f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM184 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faInfoSquare = faSquareInfo;
const faWifiSlash = {
  prefix: 'far',
  iconName: 'wifi-slash',
  icon: [
    640,
    512,
    [],
    'f6ac',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3 .3-21.4 .8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zM76.9 156.6L37.7 125.7c-10.2 7.6-20 15.6-29.5 23.9c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zM226.3 274.3L184 241c-23.4 12.1-44.9 27.2-64.1 44.8c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z',
  ],
};
const faToiletPaperXmark = {
  prefix: 'far',
  iconName: 'toilet-paper-xmark',
  icon: [
    512,
    512,
    [],
    'e5b3',
    'M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3l212.7 0c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1L112 48c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456l0-104.9c-16.6 19.3-38.1 32.9-64 32.9l-288 0c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0L400 0c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192l0 264c0 30.9-25.1 56-56 56l-240 0c-30.9 0-56-25.1-56-56l0-40 48 0 0 40c0 4.4 3.6 8 8 8l240 0c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM235.3 132.7c6.2 6.2 6.2 16.4 0 22.6L198.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L153.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faHandsHoldingDollar = {
  prefix: 'far',
  iconName: 'hands-holding-dollar',
  icon: [
    640,
    512,
    ['hands-usd'],
    'f4c5',
    'M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 10.9c-6.9 1.8-13.8 4.5-20.2 8.2c-14.9 8.8-27.9 24.5-27.7 47.4c.1 22.1 13.1 36 26.6 44.1c11.4 6.9 25.6 11.2 36.4 14.4l1.9 .6c12.7 3.8 21.3 6.7 27.1 10.3c4 2.5 4 3.6 4 4.6l0 .2c0 2.3-.5 3.5-.8 4.1c-.4 .7-1.3 1.8-3.2 2.9c-4.1 2.6-11.2 4.4-19.2 4.1c-10.5-.3-20.2-3.6-33.9-8.3c-2.3-.8-4.8-1.6-7.3-2.5c-12.6-4.2-26.2 2.6-30.4 15.2s2.6 26.2 15.2 30.4c1.9 .6 3.9 1.3 6 2c7.4 2.6 16.2 5.6 25.6 7.8l0 11.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-10.6c7.4-1.8 14.6-4.7 21.3-8.8c15.3-9.5 27-25.9 26.7-48.5c-.3-22-12.8-36.3-26.4-44.9c-12-7.5-26.8-12-37.9-15.3c0 0 0 0 0 0l-.9-.3c-12.9-3.9-21.6-6.6-27.4-10.1c-2.4-1.5-3.2-2.4-3.3-2.6c0-.1 0-.3 0-.6c0-1.6 .4-2.3 .7-2.8c.4-.6 1.4-1.8 3.5-3c4.7-2.8 12-4.5 19.4-4.4c9.1 .1 19.3 2.1 30.2 5c12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4c-5.6-1.5-11.7-3-18.2-4.2L344 24zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z',
  ],
};
const faHandsUsd = faHandsHoldingDollar;
const faCube = {
  prefix: 'far',
  iconName: 'cube',
  icon: [
    512,
    512,
    [],
    'f1b2',
    'M258.8 50.7c-1.8-.7-3.8-.7-5.7 0L63.6 122.6 256 198.2l192.4-75.6L258.8 50.7zM48 377.9c0 3.3 2.1 6.3 5.2 7.5L232 453.2l0-212.9L48 168.1l0 209.8zm232 75.3l178.8-67.8c3.1-1.2 5.2-4.2 5.2-7.5l0-209.8L280 240.4l0 212.9zM236.1 5.9c12.8-4.9 26.9-4.9 39.7 0l200 75.9C497.6 90 512 110.8 512 134.1l0 243.8c0 23.3-14.4 44.1-36.1 52.4l-200 75.9c-12.8 4.9-26.9 4.9-39.7 0l-200-75.9C14.4 422 0 401.2 0 377.9L0 134.1C0 110.8 14.4 90 36.1 81.7l200-75.9z',
  ],
};
const faArrowDownTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-down-triangle-square',
  icon: [
    576,
    512,
    ['sort-shapes-down'],
    'f888',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM416 32c-9.9 0-19.1 5.2-24.2 13.7L307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32zM368 432l0-96 96 0 0 96-96 0zM416 98.6L462.4 176l-92.8 0L416 98.6zM320 432c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96z',
  ],
};
const faSortShapesDown = faArrowDownTriangleSquare;
const faBitcoinSign = {
  prefix: 'far',
  iconName: 'bitcoin-sign',
  icon: [
    320,
    512,
    [],
    'e0b4',
    'M64 24C64 10.7 74.7 0 88 0s24 10.7 24 24l0 40 32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40.7c54 6 96 51.8 96 107.3c0 27.5-10.3 52.6-27.2 71.6C295.9 261.5 320 297.9 320 340c0 59.6-48.4 108-108 108l-20 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-22.3 0C18.7 448 0 429.3 0 406.3L0 280l0-6.3L0 232 0 101.6C0 80.8 16.8 64 37.6 64L64 64l0-40zM48 232l132 0c33.1 0 60-26.9 60-60s-26.9-60-60-60L48 112l0 120zm132 48L48 280l0 120 164 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0z',
  ],
};
const faShutters = {
  prefix: 'far',
  iconName: 'shutters',
  icon: [
    512,
    512,
    [],
    'e449',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM13.7 128L.4 198c-.3 1.4-.4 2.7-.4 4.1C0 214.2 9.8 224 21.9 224l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 176l9.1-48-48.9 0zM.4 326c-.3 1.4-.4 2.7-.4 4.1C0 342.2 9.8 352 21.9 352l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 304l9.1-48-48.9 0L.4 326zm0 128c-.3 1.4-.4 2.7-.4 4.1C0 470.2 9.8 480 21.9 480l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 432l9.1-48-48.9 0L.4 454z',
  ],
};
const faShieldDog = {
  prefix: 'far',
  iconName: 'shield-dog',
  icon: [
    512,
    512,
    [],
    'e573',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160.9 270.2l-15 30c-1.2 2.5-1.9 5.2-1.9 8c0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7 .7 3.4 1.1 5.2 1.1c7.3 0 13.3-5.9 13.3-13.3l0-50.7 48 0c44.2 0 80-35.8 80-80l0-32c0-8.8-7.2-16-16-16l-64 0-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7L240 144l0 64c0 35.3-28.7 64-64 64c-5.2 0-10.3-.6-15.1-1.8zM160 144c-8.8 0-16 7.2-16 16l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-32-8 0-40 0zm96 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faSolarPanel = {
  prefix: 'far',
  iconName: 'solar-panel',
  icon: [
    640,
    512,
    [],
    'f5ba',
    'M114.5 48c-3.8 0-7.1 2.7-7.9 6.5L86.5 160l116.6 0L214.3 48l-99.8 0zm83.8 160L77.4 208 54.8 326.5c-.9 4.9 2.8 9.5 7.9 9.5l122.8 0 12.8-128zm48.2 0L233.7 336l172.6 0L393.5 208l-147 0zm142.2-48L377.5 48l-115 0L251.3 160l137.4 0zm53 48l12.8 128 122.8 0c5 0 8.8-4.6 7.9-9.5L562.6 208l-120.9 0zm111.8-48L533.4 54.5c-.7-3.8-4-6.5-7.9-6.5l-99.8 0 11.2 112 116.6 0zM59.5 45.5C64.5 19.1 87.6 0 114.5 0l411 0c26.9 0 50 19.1 55 45.5l51.8 272c6.6 34.5-19.9 66.5-55 66.5L344 384l0 80 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-80L62.7 384c-35.1 0-61.6-32-55-66.5l51.8-272z',
  ],
};
const faLockOpen = {
  prefix: 'far',
  iconName: 'lock-open',
  icon: [
    576,
    512,
    [],
    'f3c1',
    'M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72C560 57.3 502.7 0 432 0S304 57.3 304 128l0 64L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16z',
  ],
};
const faTableTree = {
  prefix: 'far',
  iconName: 'table-tree',
  icon: [
    512,
    512,
    [],
    'e293',
    'M48 160l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256-336 0 0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-5.6 0-11-1-16-2.7l0 50.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48l0-96 0-64-48 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 240c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32zm80 80l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
  ],
};
const faHouseChimneyHeart = {
  prefix: 'far',
  iconName: 'house-chimney-heart',
  icon: [
    576,
    512,
    [],
    'e1b2',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM237.3 208c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z',
  ],
};
const faTally3 = {
  prefix: 'far',
  iconName: 'tally-3',
  icon: [
    640,
    512,
    [],
    'e296',
    'M128 40c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24zm128 0c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24zM408 64l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faElevator = {
  prefix: 'far',
  iconName: 'elevator',
  icon: [
    512,
    512,
    [],
    'e16d',
    'M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9L80 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9L432 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM64 176c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 176zM0 192c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zM272 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM128 352l64 0c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32c0-26.5 21.5-48 48-48zm176-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faMoneyBillTransfer = {
  prefix: 'far',
  iconName: 'money-bill-transfer',
  icon: [
    640,
    512,
    [],
    'e528',
    'M558.1 64L535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-64.6 0s0 0 0 0L160 112l0 16c0 35.3-28.7 64-64 64l-16 0 0 93.5L50.7 314.7 32 333.5 32 128c0-35.3 28.7-64 64-64l287.6 0 .4 0 174.1 0zM560 320l0-93.5 29.3-29.3L608 178.5 608 384c0 35.3-28.7 64-64 64l-397.5 0s0 0 0 0l-64.6 0 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23L256 400c.1 0 .3 0 .4 0L480 400l0-16c0-35.3 28.7-64 64-64l16 0zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faMoneyBillTrendUp = {
  prefix: 'far',
  iconName: 'money-bill-trend-up',
  icon: [
    512,
    512,
    [],
    'e529',
    'M320 24c0 13.3 10.7 24 24 24l54.1 0L286.7 159.3 191.6 77.8c-9-7.7-22.4-7.7-31.3 .1l-120 104c-10 8.7-11.1 23.8-2.4 33.9s23.8 11.1 33.9 2.4l104.4-90.5 96.3 82.5c9.5 8.2 23.7 7.6 32.6-1.3l127-127 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L344 0c-13.3 0-24 10.7-24 24zM103.5 304l305 0c3.6 29 26.6 51.9 55.5 55.5l0 49c-29 3.6-51.9 26.6-55.5 55.5l-305 0c-3.6-29-26.6-51.9-55.5-55.5l0-49c28.9-3.6 51.9-26.6 55.5-55.5zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faHouseFloodWaterCircleArrowRight = {
  prefix: 'far',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e50f',
    'M316.1 107.1c-3.5-16.5-9.4-32.2-17.2-46.7L378.1 4.4c8.3-5.9 19.4-5.9 27.7 0l192 136c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7l-2.1-1.5 0 103.3c-5.3-2.9-10.3-6.2-14.8-9.9c-9.7-8.2-21.3-13.1-33.2-14.6l0-112.9L392 53.4l-75.9 53.7zM143.9 318.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM112 430.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zM0 144a144 144 0 1 1 288 0A144 144 0 1 1 0 144zM140.7 76.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 128 80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z',
  ],
};
const faSquarePollHorizontal = {
  prefix: 'far',
  iconName: 'square-poll-horizontal',
  icon: [
    448,
    512,
    ['poll-h'],
    'f682',
    'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24zm72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0zM192 352c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z',
  ],
};
const faPollH = faSquarePollHorizontal;
const faCircle = {
  prefix: 'far',
  iconName: 'circle',
  icon: [
    512,
    512,
    [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915],
    'f111',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faLeftToBracket = {
  prefix: 'far',
  iconName: 'left-to-bracket',
  icon: [
    512,
    512,
    [],
    'e66d',
    'M320 365.8L210 256 320 146.2l0 53.8c0 13.3 10.7 24 24 24l120 0 0 64-120 0c-13.3 0-24 10.7-24 24l0 53.8zM160 256c0 11.5 4.6 22.5 12.7 30.6L288.8 402.4c8.7 8.7 20.5 13.6 32.8 13.6c25.6 0 46.4-20.8 46.4-46.4l0-33.6 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-33.6c0-25.6-20.8-46.4-46.4-46.4c-12.3 0-24.1 4.9-32.8 13.6L172.7 225.4c-8.1 8.1-12.7 19.1-12.7 30.6zm8 176l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
  ],
};
const faCartCircleExclamation = {
  prefix: 'far',
  iconName: 'cart-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e3f2',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faSword = {
  prefix: 'far',
  iconName: 'sword',
  icon: [
    512,
    512,
    [128481],
    'f71c',
    'M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l33.9 33.9L408.1 69.1c4.7-4.7 10.8-7.8 17.4-8.9l31.6-5.3-5.3 31.6c-1.1 6.6-4.2 12.7-8.9 17.4L235.3 311.4l33.9 33.9L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z',
  ],
};
const faBackwardFast = {
  prefix: 'far',
  iconName: 'backward-fast',
  icon: [
    512,
    512,
    [9198, 'fast-backward'],
    'f049',
    'M16 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136.1L238.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8l0-130.3L462.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8l0-324.4C512 77.3 498.7 64 482.2 64c-7.2 0-14.2 2.6-19.6 7.4L288 224.1l0-130.3C288 77.3 274.7 64 258.2 64c-7.2 0-14.2 2.6-19.6 7.4L64 224.1 64 88c0-13.3-10.7-24-24-24S16 74.7 16 88l0 336zM464 133.9l0 244.2L324.4 256 464 133.9zM240 378.1L100.4 256 240 133.9l0 244.2z',
  ],
};
const faFastBackward = faBackwardFast;
const faRecycle = {
  prefix: 'far',
  iconName: 'recycle',
  icon: [
    512,
    512,
    [9842, 9850, 9851],
    'f1b8',
    'M181.5 40.9C197.7 15.3 226 0 256 0s58.3 15.3 74.5 40.9L392.8 139l6.6-31.8c2.7-13 15.4-21.3 28.3-18.7s21.3 15.4 18.7 28.3l-19.4 94.4c-1.4 6.7-5.6 12.5-11.5 15.9s-13.1 4.2-19.6 2l-91.4-30.4c-12.6-4.2-19.4-17.8-15.2-30.3s17.8-19.4 30.3-15.2l32.2 10.7L290 66.6C282.7 55.1 269.8 48 256 48s-26.7 7.1-34 18.6l-21.5 33.9c-7 11-21.4 14.4-32.6 7.7c-11.6-6.9-15.1-22-7.9-33.4l21.5-33.9zM439 255.5c11.2-6.7 25.6-3.3 32.6 7.7l26.8 42.2c8.8 13.9 13.5 30 13.6 46.4c.3 48.6-39 88.2-87.6 88.2l-137.2 0 24.8 22c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2s7.9 25.1-2 33.9L287.1 392l137.3 0c22 0 39.8-17.9 39.6-39.9c0-7.4-2.2-14.7-6.2-21l-26.8-42.2c-7.2-11.4-3.7-26.5 7.9-33.4zm-311.6 3.7l-6.7-32.8L54.2 331.1c-4 6.3-6.1 13.6-6.2 21c-.1 22 17.7 39.9 39.6 39.9l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0C39 440-.3 400.5 0 351.9c.1-16.4 4.8-32.5 13.6-46.4L78.8 202.8 47.6 213.1c-12.6 4.2-26.2-2.6-30.3-15.2s2.6-26.2 15.2-30.3l91.4-30.4c6.5-2.2 13.6-1.4 19.6 2s10.1 9.2 11.5 15.9l19.4 94.4c2.7 13-5.7 25.7-18.7 28.3s-25.7-5.7-28.3-18.7z',
  ],
};
const faUserAstronaut = {
  prefix: 'far',
  iconName: 'user-astronaut',
  icon: [
    448,
    512,
    [],
    'f4fb',
    'M224 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm181.2 80.4C379 53.6 307.8 0 224 0S69 53.6 42.8 128.4C27.6 130.9 16 144.1 16 160l0 64c0 15.9 11.6 29.1 26.8 31.6c9.7 27.6 25.5 52.4 45.8 72.6C35.6 359.1 0 416.5 0 482.3C0 498.7 13.3 512 29.7 512L160 512l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 226.3 0c16.4 0 29.7-13.3 29.7-29.7c0-65.8-35.6-123.2-88.6-154.1c20.3-20.2 36.2-45 45.8-72.6c15.2-2.5 26.8-15.7 26.8-31.6l0-64c0-15.9-11.6-29.1-26.8-31.6zM319.7 358.5c44.5 18 77.1 59.3 82.6 108.7l-66.4 0 0-19.2c0-17.7-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32l0 19.2-66.4 0c5.6-49.5 38.1-90.7 82.6-108.7C156.5 374.7 189.1 384 224 384s67.5-9.3 95.7-25.5zM160 128c-26.5 0-48 21.5-48 48l0 16c0 53 43 96 96 96l32 0c53 0 96-43 96-96l0-16c0-26.5-21.5-48-48-48l-128 0zm39.3 45.5l6 21.2 21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5zM256 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faInterrobang = {
  prefix: 'far',
  iconName: 'interrobang',
  icon: [
    320,
    512,
    [8253],
    'e5ba',
    'M144 80c-44.2 0-80 35.8-80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 4.6c0 40.1-20.1 77.6-53.4 99.8l-52.3 34.9c-8.9 5.9-14.2 15.9-14.2 26.6l0 2 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16 0-2 0-158c0-13.3 10.7-24 24-24s24 10.7 24 24l0 83.2 39.9-26.6c20-13.4 32.1-35.8 32.1-59.9l0-4.6c0-44.2-35.8-80-80-80l-32 0zM128 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faPlaneSlash = {
  prefix: 'far',
  iconName: 'plane-slash',
  icon: [
    640,
    512,
    [],
    'e069',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L461 336l19 0c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C530 182.1 500.7 176 480 176l-66.2 0L317.7 25.8C307.4 9.7 289.6 0 270.5 0L229.9 0c-27.1 0-46.4 26.4-38.1 52.2l31.1 97.2L38.8 5.1zM288.3 200.7c.1-2.7-.3-5.4-1.1-8L240.9 48l29.6 0c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L277.2 51.7 380.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3c0 0 0 0 0 0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C516.3 283.8 493.6 288 480 288l-79.4 0c-.3 0-.6 0-.9 0L288.3 200.7zm88.9 192.5l-37.9-29.8-62.1 97c-1.5 2.3-4 3.7-6.7 3.7l-29.6 0 45.5-142.3L243.7 288 168 288c-7.6 0-14.7 3.6-19.2 9.6L108 352l-24.4 0 27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L84.3 162.4 39.6 127.2c-4.8 6.3-7.6 14.2-7.6 22.7c0 3.8 .6 7.5 1.7 11.1c0 0 0 0 0 0L62.9 256 33.7 350.9s0 0 0 0c-1.1 3.6-1.7 7.4-1.7 11.1C32 383 49 400 69.9 400l42.1 0c12.6 0 24.4-5.9 32-16l-19.2-14.4L144 384l36-48 51.4 0L191.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8l59.5-93z',
  ],
};
const faCircleDashed = {
  prefix: 'far',
  iconName: 'circle-dashed',
  icon: [
    512,
    512,
    [],
    'e105',
    'M27.7 232c12.3 0 22.5-9.3 25.2-21.3c5.3-23.9 14.7-46.2 27.4-66.2c6.6-10.4 6-24.2-2.8-32.9c-10.1-10.1-26.8-9.4-34.7 2.5c-18.2 27.3-31.3 58.3-37.9 91.6c-2.8 14 8.5 26.3 22.8 26.3zM144.5 80.4c20-12.7 42.3-22.1 66.2-27.4c12-2.7 21.3-12.9 21.3-25.2c0-14.3-12.3-25.6-26.3-22.8c-33.3 6.6-64.3 19.7-91.6 37.9c-11.9 7.9-12.6 24.6-2.5 34.7c8.7 8.7 22.5 9.4 32.9 2.8zM280 484.3c0 14.3 12.3 25.6 26.3 22.8c33.3-6.6 64.3-19.7 91.6-37.9c11.9-7.9 12.6-24.6 2.5-34.7c-8.7-8.7-22.5-9.4-32.9-2.8c-20 12.7-42.3 22.1-66.2 27.4c-12 2.7-21.3 12.9-21.3 25.2zM431.6 367.5c-6.6 10.4-6 24.2 2.8 32.9c10.1 10.1 26.8 9.4 34.7-2.5c18.2-27.3 31.3-58.3 37.9-91.6c2.8-14-8.5-26.3-22.8-26.3c-12.3 0-22.5 9.3-25.2 21.3c-5.3 23.9-14.7 46.2-27.4 66.2zm-320 66.8c-10.1 10.1-9.4 26.8 2.5 34.7c27.3 18.2 58.3 31.3 91.6 37.9c14 2.8 26.3-8.5 26.3-22.8c0-12.3-9.3-22.5-21.3-25.2c-23.9-5.3-46.2-14.7-66.2-27.4c-10.4-6.6-24.2-6-32.9 2.8zM42.9 397.9c7.9 11.9 24.6 12.6 34.7 2.5c8.7-8.7 9.4-22.5 2.8-32.9c-12.7-20-22.1-42.3-27.4-66.2c-2.7-12-12.9-21.3-25.2-21.3c-14.3 0-25.6 12.3-22.8 26.3c6.6 33.3 19.7 64.3 37.9 91.6zM400.4 77.6c10.1-10.1 9.4-26.8-2.5-34.7c-27.3-18.2-58.3-31.3-91.6-37.9c-14-2.8-26.3 8.5-26.3 22.8c0 12.3 9.3 22.5 21.3 25.2c23.9 5.3 46.2 14.7 66.2 27.4c10.4 6.6 24.2 6 32.9-2.8zm31.2 66.8c12.7 20 22.1 42.3 27.4 66.2c2.7 12 12.9 21.3 25.2 21.3c14.3 0 25.6-12.3 22.8-26.3c-6.6-33.3-19.7-64.3-37.9-91.6c-7.9-11.9-24.6-12.6-34.7-2.5c-8.7 8.7-9.4 22.5-2.8 32.9z',
  ],
};
const faTrademark = {
  prefix: 'far',
  iconName: 'trademark',
  icon: [
    640,
    512,
    [8482],
    'f25c',
    'M331.4 105.8c-6.1-8.4-17-11.9-26.8-8.7s-16.6 12.4-16.6 22.8l0 272c0 13.3 10.7 24 24 24s24-10.7 24-24l0-198.5L444.6 342.2c4.5 6.2 11.7 9.8 19.4 9.8s14.9-3.7 19.4-9.8L592 193.5 592 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.7L464 287.3 331.4 105.8zM0 120c0 13.3 10.7 24 24 24l80 0 0 248c0 13.3 10.7 24 24 24s24-10.7 24-24l0-248 80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 96C10.7 96 0 106.7 0 120z',
  ],
};
const faBasketball = {
  prefix: 'far',
  iconName: 'basketball',
  icon: [
    512,
    512,
    [127936, 'basketball-ball'],
    'f434',
    'M304 458.4c0-.8 0-1.6 0-2.4c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zM256.2 464l-.2 0c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7 .1 5.3 .2 8zm76.4-165.4L289.9 256 419.1 126.9C447.2 162.3 464 207.2 464 256l0 .2c-2.7-.1-5.3-.2-8-.2c-46.6 0-89.4 15.9-123.4 42.6zM458.4 304c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9c.8 0 1.6 0 2.4 0zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8l.2 0c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9L126.9 92.9c23.5-18.6 51-32.2 81.1-39.4c0 .8 0 1.6 0 2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208c-.8 0-1.6 0-2.4 0c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7 .1 5.3 .2 8 .2c46.6 0 89.4-15.9 123.4-42.6L222.1 256 92.9 385.1C64.8 349.7 48 304.8 48 256l0-.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
  ],
};
const faBasketballBall = faBasketball;
const faForkKnife = {
  prefix: 'far',
  iconName: 'fork-knife',
  icon: [
    576,
    512,
    ['utensils-alt'],
    'f2e6',
    'M467.2 9.6c8 10.6 5.8 25.6-4.8 33.6l-122.7 92c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188s6.6 32.7 18.4 44.5l6.5 6.5c0 0 0 0 0 0s0 0 0 0l6.5 6.5C355.3 257.4 371.3 264 388 264s32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4l92-122.7c8-10.6 23-12.8 33.6-4.8s12.8 23 4.8 33.6l-92 122.7c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5c-24.5 0-48.1-8.1-67.3-22.8L105 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L286.8 255.3C272.1 236.1 264 212.4 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9l122.7-92c10.6-8 25.6-5.8 33.6 4.8zM521 55c9.4 9.4 9.4 24.6 0 33.9L405 205c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L487 55c9.4-9.4 24.6-9.4 33.9 0zM382.2 343.9l123 127.4c9.2 9.5 8.9 24.7-.6 33.9s-24.7 8.9-33.9-.6L313.4 341.8l12.1-12.1c17.6 8.5 36.8 13.4 56.7 14.2zM235.6 261.2L48 66.8l0 16.8c0 52.8 20.9 103.5 58.2 141l70.2 70.6c4.6 4.7 10.3 7.6 16.3 8.8l-36.3 36.3c-5-3.2-9.7-6.9-14-11.3L72.1 258.5C25.9 212 0 149.1 0 83.6L0 35.2C0 15.8 15.8 0 35.2 0c9.6 0 18.7 3.9 25.3 10.8L232 188.3c0 21.7 5 42.9 14.4 62.1l-10.7 10.7z',
  ],
};
const faUtensilsAlt = faForkKnife;
const faSatelliteDish = {
  prefix: 'far',
  iconName: 'satellite-dish',
  icon: [
    512,
    512,
    [128225],
    'f7c0',
    'M192 24c0 13.3 10.7 24 24 24c137 0 248 111 248 248c0 13.3 10.7 24 24 24s24-10.7 24-24C512 132.5 379.5 0 216 0c-13.3 0-24 10.7-24 24zm24 80c-13.3 0-24 10.7-24 24s10.7 24 24 24c79.5 0 144 64.5 144 144c0 13.3 10.7 24 24 24s24-10.7 24-24c0-106-86-192-192-192zm-7 233l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-40 40L71 199c-13.5-13.5-35.9-12.3-45.1 4.4C9.4 233.2 0 267.5 0 304C0 418.9 93.1 512 208 512c36.5 0 70.8-9.4 100.6-25.9c16.7-9.2 17.8-31.6 4.4-45.1L209 337zM48 304c0-18.1 3-35.5 8.5-51.6L259.6 455.5C243.5 461 226.1 464 208 464c-88.4 0-160-71.6-160-160z',
  ],
};
const faBadgeCheck = {
  prefix: 'far',
  iconName: 'badge-check',
  icon: [
    512,
    512,
    [],
    'f336',
    'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z',
  ],
};
const faCircleUp = {
  prefix: 'far',
  iconName: 'circle-up',
  icon: [
    512,
    512,
    [61467, 'arrow-alt-circle-up'],
    'f35b',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM151.2 217.4c-4.6 4.2-7.2 10.1-7.2 16.4c0 12.3 10 22.3 22.3 22.3l41.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 41.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.2-16.4l-91-84c-3.8-3.5-8.7-5.4-13.9-5.4s-10.1 1.9-13.9 5.4l-91 84z',
  ],
};
const faArrowAltCircleUp = faCircleUp;
const faSlider = {
  prefix: 'far',
  iconName: 'slider',
  icon: [
    512,
    512,
    [],
    'e252',
    'M352 144c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l32 0zM320 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-72 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-72c0-35.3-28.7-64-64-64l-32 0zM0 256c0 13.3 10.7 24 24 24l200 0 0-48L24 232c-13.3 0-24 10.7-24 24z',
  ],
};
const faMobileScreenButton = {
  prefix: 'far',
  iconName: 'mobile-screen-button',
  icon: [
    384,
    512,
    ['mobile-alt'],
    'f3cd',
    'M64 448c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L64 368l0 80zm0-128l256 0 0-256c0-8.8-7.2-16-16-16L80 48c-8.8 0-16 7.2-16 16l0 256zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faMobileAlt = faMobileScreenButton;
const faClockOneThirty = {
  prefix: 'far',
  iconName: 'clock-one-thirty',
  icon: [
    512,
    512,
    [],
    'e34f',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-128.7 60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faInboxOut = {
  prefix: 'far',
  iconName: 'inbox-out',
  icon: [
    512,
    512,
    [128228, 'inbox-arrow-up'],
    'f311',
    'M280 288c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-206.1-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L377 111c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-63-63L280 288zM149.1 405.5L130.3 368 48 368l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 421.7 338.2 432 320 432l-128 0c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l82.3 0c18.2 0 34.8 10.3 42.9 26.5z',
  ],
};
const faInboxArrowUp = faInboxOut;
const faCloudSlash = {
  prefix: 'far',
  iconName: 'cloud-slash',
  icon: [
    640,
    512,
    [],
    'e137',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-33.4-26.2C623.6 418.1 640 383 640 344c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-48.5 0-92.1 20.5-122.8 53.4L38.8 5.1zm140.4 110C200.9 93.4 230.9 80 264 80c36.3 0 68.8 16.1 90.9 41.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 27.8-12.9 52.6-33.1 68.8L179.2 115.1zM426.5 432L144 432c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c16.4-5.8 28.2-19.9 31.2-36.6L98.1 173.3C96.7 182 96 190.9 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 23.4 0-60.9-48z',
  ],
};
const faVolumeHigh = {
  prefix: 'far',
  iconName: 'volume-high',
  icon: [
    640,
    512,
    [128266, 'volume-up'],
    'f028',
    'M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256s-41.5-170.8-106.4-223.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.9 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32z',
  ],
};
const faVolumeUp = faVolumeHigh;
const faUsersRays = {
  prefix: 'far',
  iconName: 'users-rays',
  icon: [
    640,
    512,
    [],
    'e593',
    'M7 7C16.4-2.3 31.6-2.3 41 7l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L599 7c9.4-9.4 24.6-9.4 33.9 0zM41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505zm592 0c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2l32 0 32 0c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32l-64 0c-20.9 0-38.7 13.4-45.3 32l154.5 0zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3l69.3 0c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8l-46.6 0C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2l69.3 0c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7l-46.6 0zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faWallet = {
  prefix: 'far',
  iconName: 'wallet',
  icon: [
    512,
    512,
    [],
    'f555',
    'M88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88l0-176c0-48.6-39.4-88-88-88l-304 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c22.1 0 40 17.9 40 40l0 176c0 22.1-17.9 40-40 40L88 432c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faOctagonCheck = {
  prefix: 'far',
  iconName: 'octagon-check',
  icon: [
    512,
    512,
    [],
    'e426',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faFlatbreadStuffed = {
  prefix: 'far',
  iconName: 'flatbread-stuffed',
  icon: [
    576,
    512,
    [129369],
    'e40c',
    'M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM275 243l-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86zM395 191l43-43 23-23c21.8 34 35 72.7 35 115c0 123.7-100.3 224-224 224c-42.4 0-81-13.2-115-35l66-66 86-86 86-86zM296 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faClipboardCheck = {
  prefix: 'far',
  iconName: 'clipboard-check',
  icon: [
    384,
    512,
    [],
    'f46c',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z',
  ],
};
const faCartCirclePlus = {
  prefix: 'far',
  iconName: 'cart-circle-plus',
  icon: [
    640,
    512,
    [],
    'e3f3',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
  ],
};
const faTruckClock = {
  prefix: 'far',
  iconName: 'truck-clock',
  icon: [
    640,
    512,
    ['shipping-timed'],
    'f48c',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 192a112 112 0 1 1 224 0A112 112 0 1 1 96 192zm112-64c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32c0-8.8-7.2-16-16-16z',
  ],
};
const faShippingTimed = faTruckClock;
const faPool8Ball = {
  prefix: 'far',
  iconName: 'pool-8-ball',
  icon: [
    512,
    512,
    [],
    'e3c5',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm120-56a136 136 0 1 1 272 0 136 136 0 1 1 -272 0zm173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faFileAudio = {
  prefix: 'far',
  iconName: 'file-audio',
  icon: [
    384,
    512,
    [],
    'f1c7',
    'M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 272l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376 112 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l17.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z',
  ],
};
const faTurnDownLeft = {
  prefix: 'far',
  iconName: 'turn-down-left',
  icon: [
    512,
    512,
    [],
    'e331',
    'M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6c25.6 0 46.3-20.7 46.3-46.3l0-41.7 144 0c88.4 0 160-71.6 160-160l0-112c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-152 0 0-41.7c0-25.6-20.7-46.3-46.3-46.3c-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93l0 61.5c0 13.3 10.7 24 24 24l176 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 112c0 61.9-50.1 112-112 112l-168 0c-13.3 0-24 10.7-24 24l0 61.5L57 288 160 178.5z',
  ],
};
const faLockHashtag = {
  prefix: 'far',
  iconName: 'lock-hashtag',
  icon: [
    448,
    512,
    [],
    'e423',
    'M144 128l0 32 160 0 0-32c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 160l0-32C96 57.3 153.3 0 224 0s128 57.3 128 128l0 32 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l32 0zm0 48l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-32 0-48 0-160 0-48 0zm88 16c13.3 0 24 10.7 24 24l0 24 32 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-32 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-24c0-13.3 10.7-24 24-24zm24 128l32 0 0-32-32 0 0 32z',
  ],
};
const faChartRadar = {
  prefix: 'far',
  iconName: 'chart-radar',
  icon: [
    512,
    512,
    [],
    'e0e7',
    'M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12l-176.6 0c-8.6 0-16.5-4.6-20.8-12L58.6 268zm231.5-87.2c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zM202 271.9l47.5-63.4 31.7 79.2L202 271.9z',
  ],
};
const faStaff = {
  prefix: 'far',
  iconName: 'staff',
  icon: [
    512,
    512,
    [],
    'f71b',
    'M238.8 57.5C256.4 22.3 292.4 0 331.8 0L408 0c57.4 0 104 46.6 104 104l0 103.9c0 42.8-26.1 80.8-65.1 96.5l-17.3 30.7c-4.3 7.7-14.1 10.4-21.8 6.1l-29.4-16.6L253.7 360.1 122.9 490.9C94.8 519 49.2 519 21.1 490.9l16.8-16.8L21.1 490.9C-7 462.8-7 417.2 21.1 389.1L96 314.2 96 288c0-8.8 7.2-16 16-16l26.2 0 21-21c12.5-12.5 28-21.6 45-26.5L368 177.7l0-33.7-12.1 0c-19.8 29.8-59.2 40.8-92.1 24.4c-35.6-17.8-50-61-32.2-96.6l7.2-14.3zm93-9.5c-21.2 0-40.6 12-50.1 31l-7.2 14.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l2.7-5.5c4.1-8.1 12.4-13.3 21.5-13.3L392 96c13.3 0 24 10.7 24 24l0 75.8c0 10.7-7.1 20.1-17.4 23.1L217.4 270.6c-9.2 2.6-17.5 7.5-24.2 14.2L55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L224.2 321.8c2.9-2.9 6.5-5 10.4-6.1l188.8-54c24-6.9 40.6-28.8 40.6-53.8L464 104c0-30.9-25.1-56-56-56l-76.2 0z',
  ],
};
const faBurger = {
  prefix: 'far',
  iconName: 'burger',
  icon: [
    512,
    512,
    ['hamburger'],
    'f805',
    'M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zM16 288c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 320c-17.7 0-32-14.3-32-32z',
  ],
};
const faHamburger = faBurger;
const faUtilityPole = {
  prefix: 'far',
  iconName: 'utility-pole',
  icon: [
    512,
    512,
    [],
    'e2c3',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56L128 80l0-24c0-13.3-10.7-24-24-24S80 42.7 80 56l0 24L64.2 80c-.2 0-.3 0-.5 0L48 80l0-24c0-13.3-10.7-24-24-24S0 42.7 0 56L0 88c0 22.1 17.9 40 40 40l43.2 0L232 227.2l0 68.8 0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192 0-68.8L428.8 128l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 80l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L280 80l0-56zm91.2 104L280 188.8l0-60.8 91.2 0zM232 188.8L140.8 128l91.2 0 0 60.8z',
  ],
};
const faTransporter6 = {
  prefix: 'far',
  iconName: 'transporter-6',
  icon: [
    512,
    512,
    [],
    'e2a7',
    'M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zm416 352L480 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24zM224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faArrowTurnLeft = {
  prefix: 'far',
  iconName: 'arrow-turn-left',
  icon: [
    512,
    512,
    [],
    'e632',
    'M135 369c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87L424 248c22.1 0 40 17.9 40 40l0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-48.6-39.4-88-88-88L81.9 200l87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 207c-9.4 9.4-9.4 24.6 0 33.9L135 369z',
  ],
};
const faWrench = {
  prefix: 'far',
  iconName: 'wrench',
  icon: [
    512,
    512,
    [128295],
    'f0ad',
    'M322.3 268c9.4 2.6 19.3 4 29.7 4c60.5 0 109.8-48 111.9-108l-25.3 25.3c-12 12-28.3 18.7-45.3 18.7L368 208c-35.3 0-64-28.7-64-64l0-25.4c0-17 6.7-33.3 18.7-45.3c0 0 0 0 0 0L348 48.1C288 50.1 240 99.5 240 160c0 10.3 1.4 20.3 4 29.7c4.6 16.6-.2 34.4-12.4 46.6L57.1 410.7c-5.9 5.8-9.1 13.8-9.1 22.1C48 450 62 464 79.2 464c8.3 0 16.2-3.3 22.1-9.1L275.7 280.4c12.2-12.2 30-16.9 46.6-12.4zM424.6 39.4l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3l0 25.4c0 8.8 7.2 16 16 16l25.4 0c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3c0 88.4-71.6 160-160 160c-14.7 0-28.9-2-42.3-5.7L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L197.7 202.3C194 188.9 192 174.7 192 160C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faBugs = {
  prefix: 'far',
  iconName: 'bugs',
  icon: [
    576,
    512,
    [],
    'e4d0',
    'M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6l-17 0-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184l32 0 0 23.3-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3l0-23.3 32 0c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136l-17 0c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2zM144 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zm307.9 97.8l-32 55.4c-4.4 7.7-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9l32-55.4c4.4-7.7 14.2-10.3 21.9-5.9s10.3 14.2 5.9 21.9z',
  ],
};
const faVectorPolygon = {
  prefix: 'far',
  iconName: 'vector-polygon',
  icon: [
    448,
    512,
    [],
    'e2c7',
    'M360 72l48 0 0 48-48 0 0-48zm-8-40c-17.7 0-32 14.3-32 32l0 8L128 72l0-8c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-42.4 0-27.4-45.6c3.7-5.2 5.8-11.5 5.8-18.4l0-64c0-6.8-2.1-13.2-5.8-18.4L373.6 160l42.4 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM298.4 320l27.4 45.6c-3.7 5.2-5.8 11.5-5.8 18.4l0 8-192 0 0-8c0-17.7-14.3-32-32-32l-8 0 0-192 8 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 6.8 2.1 13.2 5.8 18.4L298.4 192 256 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l42.4 0zM40 440l0-48 48 0 0 48-48 0zm320 0l0-48 48 0 0 48-48 0zM40 120l0-48 48 0 0 48-48 0zM264 232l48 0 0 48-48 0 0-48z',
  ],
};
const faDiagramNested = {
  prefix: 'far',
  iconName: 'diagram-nested',
  icon: [
    448,
    512,
    [],
    'e157',
    'M144 80l0 96-96 0 0-96 96 0zM48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l24 0 0 96c0 48.6 39.4 88 88 88l96 0 0 24c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 24-96 0c-22.1 0-40-17.9-40-40l0-96 24 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32zM400 336l0 96-96 0 0-96 96 0z',
  ],
};
const faRupeeSign = {
  prefix: 'far',
  iconName: 'rupee-sign',
  icon: [
    448,
    512,
    [8360, 'rupee'],
    'f156',
    'M0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8 .3c17.4 6.2 40 14.2 56.7 28.5c9 7.7 16.8 17.6 21.5 30.4c4.7 12.7 5.7 26.7 3.5 41.9c-3.9 26.6-19.1 46.5-41 57.6c-21 10.6-46.4 12.3-71.6 7.6l-.2 0s0 0 0 0c-9-1.7-20.2-5.7-29.5-9.2c-6.3-2.4-13-5.1-18.5-7.3c0 0 0 0 0 0s0 0 0 0c-2.7-1.1-5-2-6.9-2.8c-12.3-4.8-18.4-18.8-13.6-31.1s18.8-18.4 31.1-13.6c2.6 1 5.3 2.1 8.2 3.3c0 0 0 0 0 0s0 0 0 0c5.1 2.1 10.7 4.3 16.7 6.6c9.4 3.5 17 6 21.5 6.9c18.1 3.3 32.1 1.2 41.2-3.3c8.1-4.1 13.5-10.7 15.1-21.7c1.3-8.8 .4-14.5-1-18.3c-1.4-3.8-3.8-7.1-7.7-10.5c-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2c-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2c7.1 1.3 28.4 6.1 36.5 8.7c12.6 4 19.7 17.4 15.7 30.1s-17.4 19.7-30.1 15.7c-5.5-1.7-24.7-6.1-30.8-7.3c-36.3-6.7-54.2 10.2-56.4 25z',
  ],
};
const faRupee = faRupeeSign;
const faFileImage = {
  prefix: 'far',
  iconName: 'file-image',
  icon: [
    384,
    512,
    [128443],
    'f1c5',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z',
  ],
};
const faCircleQuestion = {
  prefix: 'far',
  iconName: 'circle-question',
  icon: [
    512,
    512,
    [62108, 'question-circle'],
    'f059',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faQuestionCircle = faCircleQuestion;
const faTicketsPerforated = {
  prefix: 'far',
  iconName: 'tickets-perforated',
  icon: [
    640,
    512,
    [],
    'e63f',
    'M160 80l416 0c8.8 0 16 7.2 16 16l0 38.2c-24 15.7-40 42.8-40 73.8s16 58.1 40 73.8l0 38.2c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm400 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z',
  ],
};
const faImageUser = {
  prefix: 'far',
  iconName: 'image-user',
  icon: [
    512,
    512,
    [],
    'e1b8',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm192 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-15.1 0-27.4-12.3-27.4-27.4z',
  ],
};
const faBuoy = {
  prefix: 'far',
  iconName: 'buoy',
  icon: [
    576,
    512,
    [],
    'e5b5',
    'M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12.1 0L142.2 304 96 304c-17.7 0-32 14.3-32 32l0 16c0 13.3 1.8 26.1 5.2 38.3c15.8-7.3 33.9-7.9 50.2-1.5c-4.7-11.3-7.3-23.8-7.3-36.8l352 0c0 13.1-2.6 25.5-7.3 36.9c16.2-6.4 34.4-5.8 50.2 1.5c3.4-12.2 5.2-25.1 5.2-38.3l0-16c0-17.7-14.3-32-32-32l-46.2 0L379.9 48 392 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 0zM330.8 48l11.9 56.6L288 168.5l-54.8-63.9L245.2 48l85.7 0zM220.8 163.8l35.6 41.5-58.8 68.6 23.2-110.1zM288 242.2L341 304 235 304l53-61.8zm90.4 31.7l-58.8-68.6 35.6-41.5 23.2 110.1zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faPlaneDeparture = {
  prefix: 'far',
  iconName: 'plane-departure',
  icon: [
    640,
    512,
    [128747],
    'f5b0',
    'M154.5 87.6c9.2-3.8 19.4-4.1 28.8-.8L369 152.8c6.3 2.2 13.2 1.7 19.2-1.4l83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9l50.8 0c11.2 0 18.6 11.6 13.9 21.8c-17.2 36.8-46 67-81.9 85.8L251.8 335.1c-1.1 .6-2.4 .9-3.7 .9l-121.4 0c-2.3 0-4.6-1-6.1-2.8L54.2 255.7l23-11.5c2.1-1.1 4.6-1.1 6.8-.2l58.2 25.9c6.7 3 14.4 2.7 20.9-.7l88.1-46.2c7.6-4 12.5-11.7 12.8-20.3s-3.9-16.7-11.2-21.3L124 100.4l30.5-12.7zm44.8-46c-20.6-7.3-43.1-6.7-63.3 1.7L91.3 62c-29.9 12.5-33.4 53.5-5.9 70.8L192 199.9l-40.9 21.4-47.6-21.2c-15.3-6.8-32.8-6.4-47.8 1.1L66.1 222 55.8 201.3 23.6 217.4C.3 229-5.8 259.4 11.1 279.2l73.1 85.3 17.6-15.1L84.2 364.4c10.6 12.4 26.2 19.6 42.5 19.6l121.4 0c9.1 0 18-2.2 26-6.4L524.5 246.1c45.3-23.8 81.5-61.7 103.1-108c19.6-42-11-90.1-57.4-90.1l-50.8 0c-24.6 0-48.8 6-70.5 17.4L375.1 104 199.3 41.6zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z',
  ],
};
const faHandshakeSlash = {
  prefix: 'far',
  iconName: 'handshake-slash',
  icon: [
    640,
    512,
    [],
    'e060',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368l46.5 0c5.5 9.6 15.9 16 27.7 16l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-40 0-40 0-38.9 0L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM263.9 181.5l44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l48 0 0 144-88 0-15.4 0-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5zM96 171.6L40.6 128 16 128c-8.8 0-16 7.2-16 16L0 352c0 17.7 14.3 32 32 32l32 0c17.6 0 32-14.3 32-31.9c7.7 .5 14.9 3.8 20.4 9.3L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6C135.8 313 116.4 304.6 96 304l0-80 0-48 0-4.4zM32 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faBookBookmark = {
  prefix: 'far',
  iconName: 'book-bookmark',
  icon: [
    448,
    512,
    [],
    'e0bb',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8l-40 0 0 158.7c0 13.4-15.5 20.9-26 12.5L272 176l-54 43.2c-10.5 8.4-26 .9-26-12.5L192 48 88 48C65.9 48 48 65.9 48 88l0 270.7z',
  ],
};
const faBorderCenterH = {
  prefix: 'far',
  iconName: 'border-center-h',
  icon: [
    448,
    512,
    [],
    'f89c',
    'M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z',
  ],
};
const faCanFood = {
  prefix: 'far',
  iconName: 'can-food',
  icon: [
    384,
    512,
    [129387],
    'e3e6',
    'M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2l0-144.8c14.2 6.1 31 11.3 49.7 15.1c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5c18.7-3.8 35.5-8.9 49.7-15.1l0 144.8zm48 5.7l0-200 0-168c0-39.8-78.8-72-176-72S16 32.2 16 72l0 168 0 200c0 39.8 78.8 72 176 72s176-32.2 176-72zM304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faTypewriter = {
  prefix: 'far',
  iconName: 'typewriter',
  icon: [
    512,
    512,
    [],
    'f8e7',
    'M128 64c0-8.8 7.2-16 16-16l191.4 0c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3l0 63.4 48 0 0-63.4c0-17-6.7-33.3-18.7-45.3L380.7 18.7C368.7 6.7 352.4 0 335.4 0L144 0C108.7 0 80 28.7 80 64l0 96 48 0 0-96zM0 224l0 32c0 17.7 14.3 32 32 32l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-114.7 0c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4l-101.5 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L32 192c-17.7 0-32 14.3-32 32zm80 64l352 0 0 160c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-160zm48 112l0 16c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm40-60a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm92-20a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40z',
  ],
};
const faArrowRightFromArc = {
  prefix: 'far',
  iconName: 'arrow-right-from-arc',
  icon: [
    512,
    512,
    [],
    'e4b1',
    'M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM392.3 134.4c-9.7-9-24.9-8.5-33.9 1.3s-8.5 24.9 1.3 33.9L426.9 232 184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l242.9 0-67.2 62.4c-9.7 9-10.3 24.2-1.3 33.9s24.2 10.3 33.9 1.3l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104z',
  ],
};
const faCircleK = {
  prefix: 'far',
  iconName: 'circle-k',
  icon: [
    512,
    512,
    [],
    'e113',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2c9.3-9.5 9.2-24.6-.3-33.9s-24.6-9.2-33.9 .3L208 239.8l0-87.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 146.5 0 61.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.7 30-30.5 70.7 96.4c7.8 10.7 22.9 13 33.5 5.2s13-22.9 5.2-33.5L272.1 243.1l73.1-74.3z',
  ],
};
const faFaceHandOverMouth = {
  prefix: 'far',
  iconName: 'face-hand-over-mouth',
  icon: [
    512,
    512,
    [129762],
    'e378',
    'M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1l0 10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM299.3 276.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faPopcorn = {
  prefix: 'far',
  iconName: 'popcorn',
  icon: [
    448,
    512,
    [127871],
    'f819',
    'M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4l-87.6 0-208.4 0-87.6 0c-.1-1.3-.2-2.7-.2-4zm22.3 84l62.2 224 215 0 62.2-224-47 0L303.6 419.7c-2.1 8.6-10.7 13.9-19.3 11.8s-13.9-10.7-11.8-19.3L313.8 240 240 240l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176-73.8 0 41.3 172.3c2.1 8.6-3.2 17.2-11.8 19.3s-17.2-3.2-19.3-11.8L101.3 240l-47 0zM224 192l195.8 0c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512l-215 0c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192L224 192z',
  ],
};
const faHouseWater = {
  prefix: 'far',
  iconName: 'house-water',
  icon: [
    576,
    512,
    ['house-flood'],
    'f74f',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 393c14.6-8.5 31.9-10.7 48-6.6l0-181.7L288 55.5 464 204.8l0 181.7c16.1-4.2 33.4-1.9 48 6.5l0-147.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM256 224l64 0 0 64-64 0 0-64zm-8-48c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-80 0zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faHouseFlood = faHouseWater;
const faObjectSubtract = {
  prefix: 'far',
  iconName: 'object-subtract',
  icon: [
    512,
    512,
    [],
    'e49e',
    'M64 48l32 0L96 0 64 0C28.7 0 0 28.7 0 64L0 96l48 0 0-32c0-8.8 7.2-16 16-16zm160 0l0-48L128 0l0 48 96 0zM48 128L0 128l0 96 48 0 0-96zm0 128L0 256l0 32c0 35.3 28.7 64 64 64l32 0 0-48-32 0c-8.8 0-16-7.2-16-16l0-32zm80 96l32 0 48 0 16 0 0-48-96 0 0 48zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64-48 0zM352 208l0-48 0-32-48 0 0 96 48 0 0-16zm0-144c0-35.3-28.7-64-64-64L256 0l0 48 32 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32zM256 304l0 48 32 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16l-32 0z',
  ],
};
const faCodeBranch = {
  prefix: 'far',
  iconName: 'code-branch',
  icon: [
    448,
    512,
    [],
    'f126',
    'M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 99.7c20.1-15.1 45-24 72-24l96 0c39.8 0 72-32.2 72-72l0-3.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 3.7c0 66.3-53.7 120-120 120l-96 0c-39.8 0-72 32.2-72 72l0 3.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-3.7 0-195.7C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm240 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faWarehouseFull = {
  prefix: 'far',
  iconName: 'warehouse-full',
  icon: [
    640,
    512,
    ['warehouse-alt'],
    'f495',
    'M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240l0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-352 0zM376 416l64 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM176 312c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-48zm24 104l96 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
  ],
};
const faWarehouseAlt = faWarehouseFull;
const faHatCowboy = {
  prefix: 'far',
  iconName: 'hat-cowboy',
  icon: [
    640,
    512,
    [],
    'f8c0',
    'M254.2 82.7c-2 2.8-4.4 6.7-7.1 11.8C236.8 114 226.9 142 218.2 173c-8.5 30.4-15.3 61-19.9 84.3c-.9 4.7-1.8 9.1-2.5 13.1c-16.8-5-32-10.6-45.7-16.6C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64s22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.4 0 84.4 152.2 97.9 221.9c-13.7 5.9-28.9 11.6-45.7 16.6c-.8-4-1.6-8.4-2.5-13.2c-4.6-23.3-11.3-54-19.9-84.3c-8.7-30.9-18.6-59-28.9-78.5c-2.7-5.1-5.1-9-7.1-11.8c-.5 .4-1 .9-1.6 1.4c-.5 .5-1.1 1-1.8 1.6c0 0 0 0 0 0s0 0 0 0C374 93.3 353.4 112 320 112s-54-18.7-62.3-26.2c0 0 0 0 0 0s0 0 0 0c-.7-.6-1.3-1.2-1.8-1.6c-.6-.5-1.2-1-1.6-1.4zM380.9 77c0 0 0 0-.1 0c0 0 0 0 0 0c0 0 0 0 .1 0zM259.1 77l.1 0c0 0 0 0-.1 0zm-148 193.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z',
  ],
};
const faBridge = {
  prefix: 'far',
  iconName: 'bridge',
  icon: [
    576,
    512,
    [],
    'e4c8',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM456 80l0 64-80 0 0-64 80 0zM328 80l0 64-80 0 0-64 80 0zM200 80l0 64-80 0 0-64 80 0zM24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c30.9 0 56 25.1 56 56l0 96c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-104c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96l0 96-48 0 0-88c0-57.4-46.6-104-104-104l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96z',
  ],
};
const faPhoneFlip = {
  prefix: 'far',
  iconName: 'phone-flip',
  icon: [
    512,
    512,
    [128381, 'phone-alt'],
    'f879',
    'M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64c0 0 0 0 0 0c0 231.2-175.2 421.5-400.1 445.5c-9.8 1-19.7 1.8-29.6 2.2c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4c0 0 0 0 0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM70.5 464C286.3 460.5 460.5 286.2 464 70.5L364.8 49.2l-43 100.4L357.6 179c18.2 14.9 22.9 40.8 11.1 61.2c-30.9 53.3-75.3 97.7-128.6 128.6c-20.4 11.8-46.3 7.1-61.2-11.1l-29.4-35.9-100.4 43L70.5 464zM464 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faPhoneAlt = faPhoneFlip;
const faArrowDownFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e090',
    'M241.5 472.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 395.5l0-83.5 0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128 0 83.5 86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
  ],
};
const faFileDoc = {
  prefix: 'far',
  iconName: 'file-doc',
  icon: [
    512,
    512,
    [],
    'e5ed',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 128l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z',
  ],
};
const faSquareQuarters = {
  prefix: 'far',
  iconName: 'square-quarters',
  icon: [
    448,
    512,
    [],
    'e44e',
    'M52.7 84.7L224 256 395.3 84.7c-2.9-2.9-6.9-4.7-11.3-4.7L64 80c-4.4 0-8.4 1.8-11.3 4.7zm0 342.6c2.9 2.9 6.9 4.7 11.3 4.7l320 0c4.4 0 8.4-1.8 11.3-4.7L224 256 52.7 427.3zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faTruckFront = {
  prefix: 'far',
  iconName: 'truck-front',
  icon: [
    512,
    512,
    [],
    'e2b7',
    'M80 48C62.3 48 48 62.3 48 80l0 152c4.2-3.2 8.7-6.1 13.3-8.7l40-85.8C113.2 112.2 138.6 96 166.6 96l178.9 0c28 0 53.4 16.2 65.2 41.6l40 85.8c4.6 2.6 9.1 5.5 13.3 8.7l0-152c0-17.7-14.3-32-32-32L80 48zM48 328l0 40c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-40c0-39.8-32.2-72-72-72l-272 0c-39.8 0-72 32.2-72 72zM0 328L0 80C0 35.8 35.8 0 80 0L432 0c44.2 0 80 35.8 80 80l0 248 0 40c0 26.2-12.6 49.4-32 64l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40L80 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56C12.6 417.4 0 394.2 0 368l0-40zM121.4 208l269.2 0-23.4-50.1c-3.9-8.4-12.4-13.9-21.7-13.9l-178.9 0c-9.3 0-17.8 5.4-21.7 13.9L121.4 208zM96 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCat = {
  prefix: 'far',
  iconName: 'cat',
  icon: [
    576,
    512,
    [128008],
    'f6be',
    'M361 0c10.9 0 21.3 4.3 29 12l36 36 44.1 0 36-36c7.7-7.7 18.1-12 29-12c22.6 0 41 18.3 41 41l0 119c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-119c0-22.6 18.3-41 41-41zm7 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-102.1L501.7 84.3C494.2 91.8 484 96 473.4 96l-50.7 0c-10.6 0-20.8-4.2-28.3-11.7L368 57.9 368 160zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM285 182l4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9c0 0 0 .1 0 .1c0 22.1 17.9 40 40 40l104 0 0-64c0-17.7-14.3-32-32-32l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c39.4 0 72.2 28.5 78.8 66l93-54.7c7.4-4.4 16.6-4.4 24.1-.1s12.1 12.2 12.1 20.8l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128.8c16.9-1.7 33.1-6 48-12.5L512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-54L304 441l0 23 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-48.6 0-88-39.4-88-88c0 0 0-.1 0-.1l0-239.4c0-20.2-15-37.2-35-39.7l-7.9-1C7.9 142.2-1.5 130.2 .2 117S13.8 94.5 27 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3l0 94.5c40-53.7 101.7-90.5 173-97z',
  ],
};
const faTrashXmark = {
  prefix: 'far',
  iconName: 'trash-xmark',
  icon: [
    448,
    512,
    [],
    'e2b4',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zm62.2 81.9c7.8-7.8 20.5-7.8 28.3 0L224 259.7l49.9-49.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L252.3 288l49.9 49.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L224 316.3l-49.9 49.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L195.7 288l-49.9-49.9c-7.8-7.8-7.8-20.5 0-28.3z',
  ],
};
const faCircleCaretLeft = {
  prefix: 'far',
  iconName: 'circle-caret-left',
  icon: [
    512,
    512,
    ['caret-circle-left'],
    'f32e',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0 6.7 2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6z',
  ],
};
const faCaretCircleLeft = faCircleCaretLeft;
const faFiles = {
  prefix: 'far',
  iconName: 'files',
  icon: [
    448,
    512,
    [],
    'e178',
    'M160 368l224 0c8.8 0 16-7.2 16-16l0-224-48 0c-17.7 0-32-14.3-32-32l0-48L160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm224 48l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L325.5 0c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24z',
  ],
};
const faAnchorCircleExclamation = {
  prefix: 'far',
  iconName: 'anchor-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4ab',
    'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faFaceClouds = {
  prefix: 'far',
  iconName: 'face-clouds',
  icon: [
    640,
    512,
    [],
    'e47d',
    'M128 0c27.9 0 51.7 17.9 60.4 42.8C198.6 36 210.8 32 224 32c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 160C28.7 160 0 131.3 0 96S28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0zM72.1 192l50 0c-6.5 20.2-10 41.7-10 64c0 80.2 45.4 149.9 112 184.6c.1 22.3 7.2 42.9 19.3 59.7C139.4 467.7 64 370.6 64 256c0-22.1 2.8-43.5 8.1-64zM307.4 48.4C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7C461.4 0 576 114.6 576 256c0 14.8-1.3 29.3-3.7 43.5c-12.5-10.8-28.3-17.8-45.7-19.2c.9-8 1.4-16.1 1.4-24.3c0-114.9-93.1-208-208-208c-4.2 0-8.4 .1-12.6 .4zM208.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368c0-44.2 35.8-80 80-80c29.3 0 54.9 15.8 68.9 39.3c8.8-9.4 21.3-15.3 35.1-15.3c26.5 0 48 21.5 48 48c0 2.7-.2 5.4-.7 8l.7 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-240 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l8 0z',
  ],
};
const faUserCrown = {
  prefix: 'far',
  iconName: 'user-crown',
  icon: [
    448,
    512,
    [],
    'f6a4',
    'M144 128l160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16zm0-108.8l-.1-.1c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0L112 0c-8.8 0-16 7.2-16 16l0 23 0 3.2c0 0 0 .1 0 .1L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-101.7c0 0 0-.1 0-.1l0-3.2 0-23c0-8.8-7.2-16-16-16l-2.4 0c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2zM168 352l112 0c63.6 0 115.6 49.5 119.7 112L48.3 464c4.1-62.5 56.2-112 119.7-112zm0-48C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0z',
  ],
};
const faBasketShoppingPlus = {
  prefix: 'far',
  iconName: 'basket-shopping-plus',
  icon: [
    576,
    512,
    [],
    'e653',
    'M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240l-389 0 53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9zM200 352c0-13.3 10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faTruckField = {
  prefix: 'far',
  iconName: 'truck-field',
  icon: [
    640,
    512,
    [],
    'e58d',
    'M336 80c8.8 0 16 7.2 16 16l0 8 0 120 0 96 0 16-108.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 336l0-48 0-160 0-32c0-8.8 7.2-16 16-16l256 0zM16 283.7L16 336l0 1.4C6.7 340.7 0 349.5 0 360s6.7 19.3 16 22.6l0 1.4 8 0 40 0c0 53 43 96 96 96s96-43 96-96l96 0 32 0c0 53 43 96 96 96s96-43 96-96l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48c0-35.3-28.7-64-64-64l-5 0-.3-.7L486.4 112.2c-9.2-19.6-29-32.2-50.7-32.2L398 80c-7.1-27.6-32.2-48-62-48L80 32C44.7 32 16 60.7 16 96l0 36.3C6.4 137.8 0 148.2 0 160l0 96c0 11.8 6.4 22.2 16 27.7zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM485.9 224L400 224l0-96 35.7 0c3.1 0 5.9 1.8 7.2 4.6l43 91.4zM528 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
  ],
};
const faRoute = {
  prefix: 'far',
  iconName: 'route',
  icon: [
    512,
    512,
    [],
    'f4d7',
    'M438.6 155.7c-7.2 11.5-15 22.6-22.6 32.7c-7.5-10.1-15.4-21.2-22.6-32.7C375.7 127.3 368 106.3 368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.3-7.7 31.3-25.4 59.7zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 33.3 25.9 77.3 50.8 112L328 208c-48.6 0-88 39.4-88 88s39.4 88 88 88l96 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-246.2 0c-2.7 3.8-5.5 7.6-8.2 11.2c-10.7 14.2-21.3 26.9-30 36.8L424 512c48.6 0 88-39.4 88-88s-39.4-88-88-88l-96 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l84.9 0c5.1 1.1 10.7-.6 14.5-5zM118.9 408.4c-7.3 11-15.3 21.7-22.9 31.2c-7.6-9.5-15.6-20.2-22.9-31.2C55.4 381.7 48 361.9 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-7.4 29.7-25.1 56.4zm19 55.6c25.9-33.1 54.1-77.3 54.1-112c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c.1-.1 .2-.2 .3-.3c.3-.3 .6-.7 .9-1c2.8-3.1 6-6.7 9.5-10.7c.1-.1 .1-.1 .2-.2c6.1-7 13-15.2 20-24.2z',
  ],
};
const faCartCircleCheck = {
  prefix: 'far',
  iconName: 'cart-circle-check',
  icon: [
    640,
    512,
    [],
    'e3f1',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z',
  ],
};
const faClipboardQuestion = {
  prefix: 'far',
  iconName: 'clipboard-question',
  icon: [
    384,
    512,
    [],
    'e4e3',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM105.8 229.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM224 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faPanorama = {
  prefix: 'far',
  iconName: 'panorama',
  icon: [
    640,
    512,
    [],
    'e209',
    'M48 80.9C72.3 88.8 177.5 120 320 120s247.7-31.2 272-39.1l0 350.2c-9.8-3.2-32.9-10.2-66.3-17.4c-.5-1-1-1.9-1.6-2.8l-136-208c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9L264.8 330l-29.5-40.2c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8l-88 120c-1.3 1.8-2.4 3.8-3.1 5.8c-28.7 6.5-48.6 12.6-57.5 15.5L48 80.9zM579.6 34.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCommentMedical = {
  prefix: 'far',
  iconName: 'comment-medical',
  icon: [
    512,
    512,
    [],
    'f7f5',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM224 160l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faTeethOpen = {
  prefix: 'far',
  iconName: 'teeth-open',
  icon: [
    576,
    512,
    [],
    'f62f',
    'M480 48L96 48C69.5 48 48 69.5 48 96l0 29.4C63.9 102.8 90.2 88 120 88c15.2 0 29.5 3.9 42 10.7C178.1 77.6 203.5 64 232 64c21.3 0 40.8 7.5 56 20.1C303.2 71.5 322.7 64 344 64c28.5 0 53.9 13.6 70 34.7C426.5 91.9 440.8 88 456 88c29.8 0 56.1 14.8 72 37.4L528 96c0-26.5-21.5-48-48-48zm0 208l-48 0-64 0-48 0-64 0-48 0-64 0-48 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 43 43 0 96 0L480 0c53 0 96 43 96 96l0 96c0 35.3-28.7 64-64 64l-32 0zm0-48c8.8 0 16-7.2 16-16l0-16c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24l0 16c0 8.2 6.1 14.9 14 15.9c.6 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-16 0-24c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28l0 40c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-40c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19l0 24 0 16c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-16c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40l0 16c0 8.8 7.2 16 16 16l48 0zM480 464c26.5 0 48-21.5 48-48l0-5.4c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4l0 5.4c0 26.5 21.5 48 48 48l384 0zm0-128l-48 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40l0-8c0-8.8-7.2-16-16-16zm-112 0l-48 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.6-.1-1.3-.1-2-.1zm112-48l32 0c35.3 0 64 28.7 64 64l0 64c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-64c0-35.3 28.7-64 64-64l32 0 48 0 64 0 48 0 64 0 48 0 64 0 48 0zM96 336c-8.8 0-16 7.2-16 16l0 8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1l-48 0zm112 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1l-48 0z',
  ],
};
const faUserTieHairLong = {
  prefix: 'far',
  iconName: 'user-tie-hair-long',
  icon: [
    448,
    512,
    [],
    'e460',
    'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272L224 272l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-11C352 57.3 294.7 0 224 0zM168.2 511.1l-.2 .9 112 0-.2-.9 137.5 0c17 0 30.7-13.8 30.7-30.7c0-79.6-57.6-145.7-133.5-158.9c-6.6-1.1-12.9 2.4-15.9 8.4l-44 87.9-15.8-58.6 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-15.8 58.6-44-87.9c-3-6-9.4-9.5-15.9-8.4C57.6 334.7 0 400.8 0 480.4c0 17 13.8 30.7 30.7 30.7l137.5 0zM118.5 375.5l43.8 87.7-113 0c6.1-39.8 33-72.9 69.2-87.7zm167.2 87.7l43.8-87.7c36.2 14.8 63.1 47.8 69.2 87.7l-113 0z',
  ],
};
const faFileCircleMinus = {
  prefix: 'far',
  iconName: 'file-circle-minus',
  icon: [
    576,
    512,
    [],
    'e4ed',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
  ],
};
const faHeadSideMedical = {
  prefix: 'far',
  iconName: 'head-side-medical',
  icon: [
    512,
    512,
    [],
    'f809',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM192 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faArrowTurnRight = {
  prefix: 'far',
  iconName: 'arrow-turn-right',
  icon: [
    512,
    512,
    [],
    'e635',
    'M377 369c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87L88 248c-22.1 0-40 17.9-40 40l0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288c0-48.6 39.4-88 88-88l342.1 0-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 207c9.4 9.4 9.4 24.6 0 33.9L377 369z',
  ],
};
const faTags = {
  prefix: 'far',
  iconName: 'tags',
  icon: [
    512,
    512,
    [],
    'f02c',
    'M345 39.1c-9.3-9.4-24.5-9.5-33.9-.2s-9.5 24.5-.2 33.9L438.6 202.1c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6 .2 33.9s24.6 9.2 33.9-.2L472.8 359.6c52.4-53 52.4-138.2 0-191.2L345 39.1zM242.7 50.7c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168zM48 80l149.5 0c4.2 0 8.3 1.7 11.3 4.7l168 168c6.2 6.2 6.2 16.4 0 22.6L243.3 408.8c-6.2 6.2-16.4 6.2-22.6 0l-168-168c-3-3-4.7-7.1-4.7-11.3L48 80zm96 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faWineGlass = {
  prefix: 'far',
  iconName: 'wine-glass',
  icon: [
    320,
    512,
    [127863],
    'f4e3',
    'M184 464l0-114c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0L264 0 56 0 48.2 0c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350l0 114-64 0c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0 88 0 88 0c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0-64 0zM78.2 48l163.6 0 6.3 80L71.9 128l6.3-80zM68.1 176l183.9 0 2.1 26.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L68.1 176z',
  ],
};
const faForwardFast = {
  prefix: 'far',
  iconName: 'forward-fast',
  icon: [
    512,
    512,
    [9197, 'fast-forward'],
    'f050',
    'M496 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1L273.4 440.6c-5.4 4.8-12.4 7.4-19.6 7.4c-16.5 0-29.8-13.3-29.8-29.8l0-130.3L49.4 440.6C44 445.4 37 448 29.8 448C13.3 448 0 434.7 0 418.2L0 93.8C0 77.3 13.3 64 29.8 64C37 64 44 66.6 49.4 71.4L224 224.1l0-130.3C224 77.3 237.3 64 253.8 64c7.2 0 14.2 2.6 19.6 7.4L448 224.1 448 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336zM48 133.9l0 244.2L187.6 256 48 133.9zM272 378.1L411.6 256 272 133.9l0 244.2z',
  ],
};
const faFastForward = faForwardFast;
const faFaceMehBlank = {
  prefix: 'far',
  iconName: 'face-meh-blank',
  icon: [
    512,
    512,
    [128566, 'meh-blank'],
    'f5a4',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faMehBlank = faFaceMehBlank;
const faUserRobot = {
  prefix: 'far',
  iconName: 'user-robot',
  icon: [
    448,
    512,
    [],
    'e04b',
    'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zm96 128l0 96c0 17.7-14.3 32-32 32l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32zm64 304l0 16-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-16c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM160 512l64 0 64 0 112 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l112 0zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM208 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faSquareParking = {
  prefix: 'far',
  iconName: 'square-parking',
  icon: [
    448,
    512,
    [127359, 'parking'],
    'f540',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM184 272l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-64 0 0 96zm64 48l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-136c0-17.7 14.3-32 32-32l80 0c53 0 96 43 96 96s-43 96-96 96z',
  ],
};
const faParking = faSquareParking;
const faCardDiamond = {
  prefix: 'far',
  iconName: 'card-diamond',
  icon: [
    384,
    512,
    [],
    'e3ea',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96z',
  ],
};
const faFaceZipper = {
  prefix: 'far',
  iconName: 'face-zipper',
  icon: [
    512,
    512,
    [],
    'e3a5',
    'M389.2 394.3l29.1 58.1c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c42.5 0 82-12.7 114.9-34.6l18.7 37.3c1 2 2 3.9 3.1 5.7C353.2 497.5 306.3 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 34.9-7 68.1-19.6 98.4l-43.1-21.5c9.5-23.8 14.7-49.7 14.7-76.9c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 320c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 336l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faFaceRaisedEyebrow = {
  prefix: 'far',
  iconName: 'face-raised-eyebrow',
  icon: [
    512,
    512,
    [],
    'e388',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 352c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM328.8 141.8l-29.5 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faHouseSignal = {
  prefix: 'far',
  iconName: 'house-signal',
  icon: [
    576,
    512,
    [],
    'e012',
    'M320.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L512 198.4 512 360c0 30.9-25.1 56-56 56l-177.9 0c-4.7-16.7-11.1-32.8-18.8-48L456 368c4.4 0 8-3.6 8-8l0-200.7L336 55 208 159.3l0 139.4c-14.5-14.1-30.6-26.5-48-37l0-63.3-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM312 192l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM24 256c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 376c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z',
  ],
};
const faSquareChevronUp = {
  prefix: 'far',
  iconName: 'square-chevron-up',
  icon: [
    448,
    512,
    ['chevron-square-up'],
    'f32c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm241 71L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z',
  ],
};
const faChevronSquareUp = faSquareChevronUp;
const faNfcSymbol = {
  prefix: 'far',
  iconName: 'nfc-symbol',
  icon: [
    512,
    512,
    [],
    'e531',
    'M357.4 473.6c7.7 7.2 19.2 8.5 28.3 3.2C461.4 433 512 349.3 512 256s-50.6-177-126.3-220.8c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8C422.7 112.1 464 180.1 464 256c0 69.6-34.7 132.6-87.6 169.8L200.3 262.4c-9.7-9-24.9-8.4-33.9 1.3s-8.4 24.9 1.3 33.9l189.7 176zM154.6 38.4c-7.7-7.2-19.2-8.5-28.3-3.2C50.6 79 0 162.7 0 256s50.6 177 126.3 220.8c11.5 6.6 26.2 2.7 32.8-8.8s2.7-26.2-8.8-32.8C89.3 399.9 48 331.9 48 256c0-69.6 34.7-132.6 87.6-169.8L311.7 249.6c9.7 9 24.9 8.4 33.9-1.3s8.4-24.9-1.3-33.9L154.6 38.4z',
  ],
};
const faBarsProgress = {
  prefix: 'far',
  iconName: 'bars-progress',
  icon: [
    512,
    512,
    ['tasks-alt'],
    'f828',
    'M464 112l0 64-144 0 0-64 144 0zM48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM464 336l0 64-272 0 0-64 272 0zM48 288c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z',
  ],
};
const faTasksAlt = faBarsProgress;
const faFaucetDrip = {
  prefix: 'far',
  iconName: 'faucet-drip',
  icon: [
    512,
    512,
    [128688],
    'e006',
    'M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21L96 32C78.3 32 64 46.3 64 64s14.3 32 32 32L200 83l0 45-18.7 0c-14.9 0-29.1 5.9-39.6 16.4L126.1 160 24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c6.4 0 12.5-2.5 17-7l22.6-22.6c1.5-1.5 3.5-2.3 5.7-2.3l93.5 0c2.1 0 4.2 .8 5.7 2.3L303 201c4.5 4.5 10.6 7 17 7l40 0c57.4 0 104 46.6 104 104l0 16c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56l-32.3 0c-8.2 0-15.8 4.2-20.2 11.1C277.2 305.3 252.3 320 224 320s-53.2-14.7-67.4-36.9c-4.4-6.9-12-11.1-20.2-11.1L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l100.1 0c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48l20.1 0c4.4 0 8 3.6 8 8c0 30.9 25.1 56 56 56l48 0c30.9 0 56-25.1 56-56l0-16c0-83.9-68.1-152-152-152l-30.1 0-15.6-15.6c-10.5-10.5-24.7-16.4-39.6-16.4L248 128l0-45L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L248 45l0-21zM420.8 423.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4z',
  ],
};
const faArrowsToLine = {
  prefix: 'far',
  iconName: 'arrows-to-line',
  icon: [
    448,
    512,
    [],
    'e0a7',
    'M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z',
  ],
};
const faDolphin = {
  prefix: 'far',
  iconName: 'dolphin',
  icon: [
    512,
    512,
    [],
    'e168',
    'M80 160c0 13.3 2.3 26 6.5 37.8c3.9 10.8-.4 22.8-10.2 28.7L56.8 238.2 44.7 217.9l12.1 20.2c-5.5 3.3-8.8 9.2-8.8 15.6c0 10.1 8.2 18.2 18.2 18.2L192 272l24 0 32.9 0c6.3 0 12.3 2.5 16.8 6.8L304 316.3l0-20.3c0-13.3 10.7-24 24-24l16 0c48.6 0 88 39.4 88 88l0 8c0 .9 0 1.8 0 2.6c19.9-21.2 32-49.6 32-81c0-60.8-22.4-116.2-59.4-158.7c-7.2-8.2-7.9-20.3-1.7-29.3c10.4-15.3 23.4-35.5 31.4-51.9c-27.3 4-58.4 14.3-84.2 24.6c-6.4 2.5-13.5 2.2-19.6-.8C297.9 57.2 261.2 48 222.3 48L192 48C130.1 48 80 98.1 80 160zM277.7 408l66.3 0c22.1 0 40-17.9 40-40l0-8c0-19.4-13.7-35.5-32-39.2l0 1.9c0 25-20.3 45.3-45.3 45.3c-11.8 0-23.2-4.6-31.7-12.9L239.1 320 216 320l-24 0L66.2 320C29.6 320 0 290.4 0 253.8C0 230.5 12.2 209 32.1 197l3.7-2.2C33.3 183.6 32 171.9 32 160C32 71.6 103.6 0 192 0l30.3 0C265 0 305.6 9.3 342.2 25.9C374.9 13.5 418.7 0 456 0c7.8 0 17.9 2.4 25.2 11.3c6.7 8.1 7.5 17.4 7.3 23.2c-.4 11.3-5.2 23.4-9.7 33.1c-7 15-17.1 31.8-26.4 46.2C489.8 162.5 512 223.5 512 289.7C512 381.5 437.5 456 345.7 456l-1.7 0-66.3 0c-19.9 34.5-56.8 56-97 56l-4.7 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L190.1 432l-28.4-56.8c-2.5-5-2.2-10.9 .7-15.6s8.1-7.6 13.6-7.6l4.7 0c40.2 0 77.1 21.5 97 56zM136 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faArrowUpRight = {
  prefix: 'far',
  iconName: 'arrow-up-right',
  icon: [
    384,
    512,
    [],
    'e09f',
    'M328 96c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1L73 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l231-231L88 144c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0z',
  ],
};
const faCircleR = {
  prefix: 'far',
  iconName: 'circle-r',
  icon: [
    512,
    512,
    [],
    'e120',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 44 0 64.8 86.4c8 10.6 23 12.8 33.6 4.8s12.8-23 4.8-33.6L309.8 285c33.6-9.5 58.2-40.4 58.2-77c0-44.2-35.8-80-80-80l-104 0zm80 112l-56 0 0-64 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0z',
  ],
};
const faCartFlatbed = {
  prefix: 'far',
  iconName: 'cart-flatbed',
  icon: [
    640,
    512,
    ['dolly-flatbed'],
    'f474',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l48 0c4.4 0 8 3.6 8 8l0 352c0 30.9 25.1 56 56 56l24 0c0 26.5 21.5 48 48 48s48-21.5 48-48l192 0c0 26.5 21.5 48 48 48s48-21.5 48-48l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0-288 0-72 0c-4.4 0-8-3.6-8-8l0-352c0-30.9-25.1-56-56-56L24 0zM240 80l96 0 0 96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-96 96 0 0 224-320 0 0-224zm-48 0l0 224c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L240 32c-26.5 0-48 21.5-48 48z',
  ],
};
const faDollyFlatbed = faCartFlatbed;
const faBanSmoking = {
  prefix: 'far',
  iconName: 'ban-smoking',
  icon: [
    512,
    512,
    [128685, 'smoking-ban'],
    'f54d',
    'M92.9 126.9L385.1 419.1C349.7 447.2 304.8 464 256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1zm165 97.1L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L353.9 320l46.1 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-142.1 0zm32 32l94.1 0 0 32-62.1 0-32-32zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l128.8 0-96-96L112 224z',
  ],
};
const faSmokingBan = faBanSmoking;
const faCircleSortUp = {
  prefix: 'far',
  iconName: 'circle-sort-up',
  icon: [
    512,
    512,
    ['sort-circle-up'],
    'e032',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm0 310.6c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zM313.4 320l-114.7 0L256 377.4 313.4 320z',
  ],
};
const faSortCircleUp = faCircleSortUp;
const faTerminal = {
  prefix: 'far',
  iconName: 'terminal',
  icon: [
    576,
    512,
    [],
    'f120',
    'M6.3 72.2c-9-9.8-8.3-24.9 1.4-33.9s24.9-8.3 33.9 1.4l184 200c8.5 9.2 8.5 23.3 0 32.5l-184 200c-9 9.8-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9L175.4 256 6.3 72.2zM248 432l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMobileButton = {
  prefix: 'far',
  iconName: 'mobile-button',
  icon: [
    384,
    512,
    [],
    'f10b',
    'M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faHouseMedicalFlag = {
  prefix: 'far',
  iconName: 'house-medical-flag',
  icon: [
    640,
    512,
    [],
    'e514',
    'M496 24l0 8 128 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0 0 320-48 0 0-320 0-160 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24zM286.3 36.7L416 133l0 59.8L272 85.9 112 204.6 112 432c0 17.7 14.3 32 32 32l256 0c5.8 0 11.3-1.6 16-4.3l0 50.7c-5.2 1-10.5 1.6-16 1.6l-256 0c-44.2 0-80-35.8-80-80l0-191.8L38.3 259.3c-10.6 7.9-25.7 5.7-33.6-5s-5.7-25.7 5-33.6l248-184c8.5-6.3 20.1-6.3 28.6 0zM240 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faBasketShopping = {
  prefix: 'far',
  iconName: 'basket-shopping',
  icon: [
    576,
    512,
    ['shopping-basket'],
    'f291',
    'M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM93.5 240l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9-389 0zM224 312l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm64-24c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm112 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faShoppingBasket = faBasketShopping;
const faTape = {
  prefix: 'far',
  iconName: 'tape',
  icon: [
    576,
    512,
    [],
    'f4db',
    'M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zM362.6 432c52-41 85.4-104.6 85.4-176C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-189.4 0zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z',
  ],
};
const faChestnut = {
  prefix: 'far',
  iconName: 'chestnut',
  icon: [
    448,
    512,
    [127792],
    'e3f6',
    'M154 90.5c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128l-192 0C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2zM393.3 384L54.7 384C67 412.3 95.2 432 128 432l192 0c32.8 0 61-19.7 73.3-48zm-76-209.4c-13.6-13.6-28.6-26.3-45.2-39.9c-2.7-2.2-5.5-4.5-8.2-6.8c0 0 0 0 0 0c-12.8-10.5-26.6-21.7-39.9-33.6c-13.3 11.9-27.1 23.1-39.9 33.6c0 0 0 0 0 0c-2.8 2.3-5.6 4.5-8.2 6.8c-16.6 13.6-31.6 26.3-45.2 39.9C88.9 216.4 53.4 268 48.6 336l350.9 0c-4.8-68-40.3-119.6-82.1-161.4z',
  ],
};
const faBusSimple = {
  prefix: 'far',
  iconName: 'bus-simple',
  icon: [
    448,
    512,
    ['bus-alt'],
    'f55e',
    'M51.5 96l345.7 0C381.4 78.9 335.2 48 224 48C121.8 48 69.8 78.3 51.5 96zM400 144L48 144l0 80 352 0 0-80zm0 128L48 272l0 104c0 13.3 10.7 24 24 24l228.2 0 75.8 0c13.3 0 24-10.7 24-24l0-104zM10.2 70C35.9 38.7 103.8 0 224 0C352.6 0 414 38.6 438.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9L448 376c0 25-12.7 47-32 59.9l0 52.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-67.8 0L80 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-52.1C12.7 423 0 401 0 376L0 100.4C0 91.6 2 80 10.2 70zM112 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faBusAlt = faBusSimple;
const faEye = {
  prefix: 'far',
  iconName: 'eye',
  icon: [
    576,
    512,
    [128065],
    'f06e',
    'M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z',
  ],
};
const faFaceSadCry = {
  prefix: 'far',
  iconName: 'face-sad-cry',
  icon: [
    512,
    512,
    [128557, 'sad-cry'],
    'f5b3',
    'M400 406.1L400 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4L160 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
  ],
};
const faSadCry = faFaceSadCry;
const faHeat = {
  prefix: 'far',
  iconName: 'heat',
  icon: [
    448,
    512,
    [],
    'e00c',
    'M176 32c13.3 0 24 10.7 24 24l0 88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144l0-88c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24l0 37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8l0 37.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-37.9c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9L0 120c0-13.3 10.7-24 24-24zm328 24l0 37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8l0 37.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-37.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9l0-37.9c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faTicketAirline = {
  prefix: 'far',
  iconName: 'ticket-airline',
  icon: [
    640,
    512,
    ['ticket-perforated-plane', 'ticket-plane'],
    'e29a',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-35c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93l0-35c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 61.3c0 11.2-12.8 18.7-24 18.7c-26.5 0-48 21.5-48 48s21.5 48 48 48c11.2 0 24 7.5 24 18.7l0 61.3c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm432 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.7 224l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5l31.1 0c8.5 0 16.4 4.5 20.7 11.9L262.7 224l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.4-7.6-10.5L186.7 288 144 288l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4l-13.8 0c-5.2 0-9-4.9-7.8-9.9L103 259.9c.6-2.5 .6-5.2 0-7.8L90.5 201.9c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L144 224l42.7 0z',
  ],
};
const faTicketPerforatedPlane = faTicketAirline;
const faTicketPlane = faTicketAirline;
const faBootHeeled = {
  prefix: 'far',
  iconName: 'boot-heeled',
  icon: [
    512,
    512,
    [],
    'e33f',
    'M31.3 0C14 0 0 14 0 31.3c0 1.8 .1 3.9 .6 6.2C2.6 47.1 24 154.3 24 232c0 33.2-12.8 93.5-19.7 123.2C1.6 367 0 379.3 0 391.8L0 440l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-22.7 121.6 40.5c12.2 4.1 25 6.2 37.9 6.2L456 512l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-33.3c0-28.1-16.3-53.6-41.8-65.4L313.8 307.9c-25.5-11.8-41.8-37.3-41.8-65.4L272 24c0-13.3-10.7-24-24-24L31.3 0zM432 430.7l0 33.3-144.4 0c-7.7 0-15.4-1.2-22.8-3.7L135.6 417.2c-2.4-.8-5-1.2-7.6-1.2l-24 0-56 0 0-24.2c0-8.5 1.1-17.2 3.1-25.8C57.6 337.7 72 271.8 72 232C72 167.4 58.5 85.7 51.5 48L96 48l0 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184 80 0 0 194.6c0 46.8 27.2 89.3 69.7 109l124.3 57.4c8.5 3.9 13.9 12.4 13.9 21.8z',
  ],
};
const faArrowsMinimize = {
  prefix: 'far',
  iconName: 'arrows-minimize',
  icon: [
    512,
    512,
    ['compress-arrows'],
    'e0a5',
    'M23 23c9.4-9.4 24.6-9.4 33.9 0l119 119L176 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24L56 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l86.1 0L23 57c-9.4-9.4-9.4-24.6 0-33.9zM489 23c9.4 9.4 9.4 24.6 0 33.9l-119 119 86.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24l0 86.1L455 23c9.4-9.4 24.6-9.4 33.9 0zM56 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-86.1L57 489c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119L56 336zm232-24c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-86.1 0L489 455c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119 0 86.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z',
  ],
};
const faCompressArrows = faArrowsMinimize;
const faAudioDescription = {
  prefix: 'far',
  iconName: 'audio-description',
  icon: [
    576,
    512,
    [],
    'f29e',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm213.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2 42.2 0zM304 184c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
  ],
};
const faPersonMilitaryToPerson = {
  prefix: 'far',
  iconName: 'person-military-to-person',
  icon: [
    512,
    512,
    [],
    'e54c',
    'M71 12.5L182.2 .1C191.7-1 200 6.5 200 16l0 14.1c0 8.8-7.2 16-16 16l-111.1 0C63.6 46.1 56 38.6 56 29.2c0-8.6 6.5-15.8 15-16.8zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM336 256l0 16 96 0 0-16c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-48 0c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32zM66 80l124 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16zM224 432c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9L136.1 456 24 456c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.1 0-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1zm72.2 18.1c-5.2-4.6-8.2-11.1-8.2-18.1s3-13.5 8.2-18.1l64-56c10-8.7 25.1-7.7 33.9 2.3s7.7 25.1-2.3 33.9L375.9 408 488 408c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112.1 0 15.9 13.9c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-64-56zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7 .3-3.4 .4-5.2 .4L64 320c-17.7 0-32-14.3-32-32l0-32zm192 32c0 3.7-.6 7.2-1.8 10.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9l64 0c35.3 0 64 28.7 64 64l0 32z',
  ],
};
const faFileShield = {
  prefix: 'far',
  iconName: 'file-shield',
  icon: [
    576,
    512,
    [],
    'e4f0',
    'M64 464l246.7 0c11 14.4 24.1 28.1 39.5 40.4c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 52.5-48 19.2 0-66.2-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z',
  ],
};
const faHexagon = {
  prefix: 'far',
  iconName: 'hexagon',
  icon: [
    512,
    512,
    [11043],
    'f312',
    'M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12l-176.6 0c-8.6 0-16.5-4.6-20.8-12L58.6 268z',
  ],
};
const faManhole = {
  prefix: 'far',
  iconName: 'manhole',
  icon: [
    512,
    512,
    [],
    'e1d6',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z',
  ],
};
const faUserSlash = {
  prefix: 'far',
  iconName: 'user-slash',
  icon: [
    640,
    512,
    [],
    'f506',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM290.5 202.4l-35.6-27.9C245.5 161.4 240 145.3 240 128c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80c-10.4 0-20.4-2-29.5-5.6zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1L467.1 464l-321.8 0c8.9-63.3 63.3-112 129-112l50.6 0-60.6-47.7z',
  ],
};
const faPen = {
  prefix: 'far',
  iconName: 'pen',
  icon: [
    512,
    512,
    [128394],
    'f304',
    'M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z',
  ],
};
const faTowerObservation = {
  prefix: 'far',
  iconName: 'tower-observation',
  icon: [
    512,
    512,
    [],
    'e586',
    'M245.7 2.3c6.5-3.1 14.1-3.1 20.6 0l168 80c12 5.7 17 20 11.3 32c-5.3 11.2-18.2 16.4-29.7 12.3l0 73.4c0 27.2-19.4 49.9-45.2 55l34.8 209 82.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l82.3 0 34.8-209c-25.7-5-45.2-27.7-45.2-55l0-73.4c-11.4 4.1-24.3-1.1-29.7-12.3c-5.7-12-.6-26.3 11.4-32l168-80zM256 50.6L144 103.9l0 24.1 224 0 0-24.1L256 50.6zM144 176l0 24c0 4.4 3.6 8 8 8l208 0c4.4 0 8-3.6 8-8l0-24-224 0zM330.8 464L256 400.7 181.2 464l149.7 0zM189.7 256l-3.7 22.5L256 337.8l70.1-59.3L322.3 256l-132.7 0zm-12.9 77.6l-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6l55.9 47.3-13.8-83-42.1 35.6z',
  ],
};
const faFloppyDisks = {
  prefix: 'far',
  iconName: 'floppy-disks',
  icon: [
    512,
    512,
    [],
    'e183',
    'M144 352c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-213.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9-33.9 33.9L384.8 52.7c-.3-.3-.5-.5-.8-.8l0 68.1c0 13.3-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24l0-72-16 0c-8.8 0-16 7.2-16 16l0 288zM224 0L373.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L512 352c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64l16 0 48 0zm0 48l0 48 112 0 0-48L224 48zM48 120l0 256c0 48.6 39.4 88 88 88l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24zM240 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faToiletPaperBlankUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-blank-under',
  icon: [
    512,
    512,
    ['toilet-paper-reverse-alt'],
    'e29f',
    'M71 84.3C85.4 56.9 101.1 48 112 48l212.7 0c-3 4.5-5.7 9.3-8.2 14.1C298.5 96.6 288 142.5 288 192s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1L112 336c-10.9 0-26.6-8.9-41-36.3C57.2 273.3 48 235.3 48 192s9.2-81.3 23-107.7zM400 48c10.9 0 26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48zm64 303.1L464 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-40-48 0 0 40c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-264c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0L112 0C74.3 0 46 28.7 28.5 62.1C10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384l288 0c25.9 0 47.4-13.6 64-32.9zM424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z',
  ],
};
const faToiletPaperReverseAlt = faToiletPaperBlankUnder;
const faFileCode = {
  prefix: 'far',
  iconName: 'file-code',
  icon: [
    384,
    512,
    [],
    'f1c9',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z',
  ],
};
const faSignal = {
  prefix: 'far',
  iconName: 'signal',
  icon: [
    640,
    512,
    [128246, 'signal-5', 'signal-perfect'],
    'f012',
    'M576 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM448 96c13.3 0 24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faSignal5 = faSignal;
const faSignalPerfect = faSignal;
const faPump = {
  prefix: 'far',
  iconName: 'pump',
  icon: [
    640,
    512,
    [],
    'e442',
    'M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24l8 0 0 160-48 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32L0 376l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 272 0 0-48L48 352l0-96 72 0c13.3 0 24-10.7 24-24l0-184 96 0 0 184c0 13.3 10.7 24 24 24l56 0 0-48-32 0 0-160 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L264 0 120 0 88 0zM458.5 146.7c2.6-1.8 5.7-2.7 8.9-2.7L576 144c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-108.6 0c-3.2 0-6.2-.9-8.9-2.7l-51.4-34.2c-4.4-3-7.1-8-7.1-13.3l0-219.5c0-5.3 2.7-10.3 7.1-13.3l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7L576 512c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L467.4 96c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3l0 219.5c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faBus = {
  prefix: 'far',
  iconName: 'bus',
  icon: [
    576,
    512,
    [128653],
    'f207',
    'M363.7 96l97.5 0C445.4 78.9 399.2 48 288 48C185.8 48 133.8 78.3 115.5 96l96.8 0c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16zM464 144l-152 0 0 80 152 0 0-80zm-352 0l0 80 152 0 0-80-152 0zm0 128l0 104c0 13.3 10.7 24 24 24l228.2 0 75.8 0c13.3 0 24-10.7 24-24l0-104-352 0zM74.2 70C99.9 38.7 167.8 0 288 0C416.6 0 478 38.6 502.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9l0 27.6c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 120c0 25-12.7 47-32 59.9l0 52.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-67.8 0L144 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-52.1C76.7 423 64 401 64 376l0-120c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-27.6C64 91.6 66 80 74.2 70zM176 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faHeartCircleXmark = {
  prefix: 'far',
  iconName: 'heart-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e501',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z',
  ],
};
const faArrowUpLeftFromCircle = {
  prefix: 'far',
  iconName: 'arrow-up-left-from-circle',
  icon: [
    512,
    512,
    [],
    'e09e',
    'M184 0L24 0C10.7 0 0 10.7 0 24L0 184c0 13.3 10.7 24 24 24s24-10.7 24-24L48 81.9 295 329c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L81.9 48 184 48c13.3 0 24-10.7 24-24s-10.7-24-24-24zM288 64c-13.3 0-24 10.7-24 24s10.7 24 24 24c97.2 0 176 78.8 176 176s-78.8 176-176 176s-176-78.8-176-176c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z',
  ],
};
const faHouseChimney = {
  prefix: 'far',
  iconName: 'house-chimney',
  icon: [
    576,
    512,
    [63499, 'home-lg'],
    'e3af',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 152 48 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM336 320l-96 0 0 144 96 0 0-144z',
  ],
};
const faHomeLg = faHouseChimney;
const faWindowMaximize = {
  prefix: 'far',
  iconName: 'window-maximize',
  icon: [
    512,
    512,
    [128470],
    'f2d0',
    'M.3 89.5C.1 91.6 0 93.8 0 96L0 224 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-128c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z',
  ],
};
const faDryer = {
  prefix: 'far',
  iconName: 'dryer',
  icon: [
    448,
    512,
    [],
    'f861',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 256c-44.7 0-82.3-30.6-93-72l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-53 0c10.7-41.4 48.2-72 93-72c53 0 96 43 96 96s-43 96-96 96zm0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288z',
  ],
};
const faFaceFrown = {
  prefix: 'far',
  iconName: 'face-frown',
  icon: [
    512,
    512,
    [9785, 'frown'],
    'f119',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faFrown = faFaceFrown;
const faChessBishopPiece = {
  prefix: 'far',
  iconName: 'chess-bishop-piece',
  icon: [
    256,
    512,
    ['chess-bishop-alt'],
    'f43b',
    'M64 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 12.2-9.2 22.3-21 23.8c6.2 6.4 13.2 14.4 20.2 23.8C210.8 129.8 232 168.8 232 216c0 20-5.9 35.9-13.9 48.2c3.7 4.2 5.9 9.7 5.9 15.8c0 11.3-7.8 20.8-18.3 23.3l4.9 48.7-48.2 0-4.8-48-59 0-4.8 48-48.2 0 4.9-48.7C39.8 300.8 32 291.3 32 280c0-6 2.2-11.6 5.9-15.8C29.9 251.9 24 236 24 216c0-47.2 21.2-86.2 40.8-112.4c7-9.4 14.1-17.4 20.2-23.8C73.2 78.3 64 68.2 64 56zm93.3 200l7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9c0-13.8-2.6-26.9-6.9-39.2L161 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l26.1-26.1-.4-.5c-8.1-10.8-16.2-19.3-22.2-25.1c-.9-.9-1.8-1.7-2.6-2.5c-.8 .8-1.7 1.6-2.6 2.5c-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1 58.7 0zM69.2 432L52.7 464l150.7 0-16.6-32L69.2 432zm-9.7-48l137 0c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384z',
  ],
};
const faChessBishopAlt = faChessBishopPiece;
const faShirtTankTop = {
  prefix: 'far',
  iconName: 'shirt-tank-top',
  icon: [
    384,
    512,
    [],
    'e3c9',
    'M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24c0 127.9-26.8 181-41.5 200.5C12.9 237.2 0 257.2 0 280.7L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-167.3c0-23.5-12.9-43.5-22.5-56.3C346.8 205 320 151.9 320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48zM99.3 160.2C122.6 184.7 155.5 200 192 200s69.4-15.3 92.7-39.8c10.3 46.7 25.2 75.5 38.5 93.1c8.6 11.4 12.8 20.5 12.8 27.3L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-167.3c0-6.8 4.2-15.9 12.8-27.3c13.3-17.6 28.2-46.5 38.5-93.1z',
  ],
};
const faDiploma = {
  prefix: 'far',
  iconName: 'diploma',
  icon: [
    640,
    512,
    ['scroll-ribbon'],
    'f5ea',
    'M320 80.3L302 59.7C286.6 42.1 264.4 32 241 32l-1 0c-44.2 0-80 35.8-80 80c0 11.4 2.4 22.2 6.7 32L96 144c-65.1 .3-96 71.5-96 128c0 56.9 24.1 119.2 81 140.7c10.5 4 22.5 4.2 33.4 1.8L256 383l0 81c0 6.2 3.6 11.9 9.2 14.5s12.3 1.8 17-2.2L320 444.8l37.8 31.5c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5l0-81 141.6 31.5c10.9 2.4 22.9 2.2 33.4-1.8c56.9-21.5 81-83.8 81-140.7c0-56.5-30.9-127.7-96-128l-70.7 0c4.3-9.8 6.7-20.6 6.7-32c0-44.2-35.8-80-80-80l-1 0c-23.4 0-45.6 10.1-61 27.7L320 80.3zM400 144l-8 0-46.4 0c-6.9 0-10.5-8.1-6-13.3l34.5-39.5c5.5-6.3 13.1-10.2 21.3-11.1c1.2-.1 2.3-.2 3.5-.2l1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zm-105.6 0L240 144c-17.7 0-32-14.3-32-32s14.3-32 32-32l1 0c9.5 0 18.6 4.1 24.8 11.3l34.5 39.5c4.5 5.2 .9 13.3-6 13.3zM240 192l16 0 0 141.8L104 367.6c-1.5 .3-3.1 .5-4.3 .4c-1.1 0-1.6-.2-1.7-.2c0 0 0 0 0 0C68.1 356.5 48 319.7 48 272c0-20.6 5.9-43.3 16.1-59.3C73.6 197.8 84 192.1 96.1 192L240 192zm144 0l16 0 143.9 0c12.1 .1 22.6 5.8 32.1 20.7c10.2 16 16.1 38.7 16.1 59.3c0 47.7-20.1 84.5-50 95.8c0 0 0 0 0 0c-.1 0-.6 .2-1.7 .2c-1.3 .1-2.8-.1-4.3-.4L384 333.8 384 192z',
  ],
};
const faScrollRibbon = faDiploma;
const faScreencast = {
  prefix: 'far',
  iconName: 'screencast',
  icon: [
    576,
    512,
    [],
    'e23e',
    'M512 80L64 80c-8.8 0-16 7.2-16 16l0 97.1c-7.9-.7-15.9-1.1-24-1.1L0 192 0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-224 0 0-24c0-8.1-.4-16.1-1.1-24L512 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z',
  ],
};
const faWalker = {
  prefix: 'far',
  iconName: 'walker',
  icon: [
    448,
    512,
    [],
    'f831',
    'M186.4 48L320 48c22.1 0 40 17.9 40 40l0 88-236 0 23.5-97.4c4.3-18 20.4-30.6 38.9-30.6zM360 224l0 164.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L408 88c0-48.6-39.4-88-88-88L186.4 0c-40.6 0-76 27.8-85.5 67.4L.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L112.4 224 360 224zm24 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faPrescription = {
  prefix: 'far',
  iconName: 'prescription',
  icon: [
    448,
    512,
    [],
    'f5b1',
    'M24 0C10.7 0 0 10.7 0 24L0 200l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 78.1 0 128 128L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L407 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L441 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-95.3-95.3C246.6 214.7 288 168.2 288 112C288 50.1 237.9 0 176 0L24 0zM176 176L48 176 48 48l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64z',
  ],
};
const faShop = {
  prefix: 'far',
  iconName: 'shop',
  icon: [
    640,
    512,
    ['store-alt'],
    'f54f',
    'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2L576 224l0 264c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264-144 0 0 248c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-248-25.8 0C17.1 224 0 206.9 0 185.8zM112 224l0 96 224 0 0-96-224 0zM515.5 48l-391 0L54.7 176l530.6 0L515.5 48zM112 464l224 0 0-96-224 0 0 96z',
  ],
};
const faStoreAlt = faShop;
const faFloppyDisk = {
  prefix: 'far',
  iconName: 'floppy-disk',
  icon: [
    448,
    512,
    [128190, 128426, 'save'],
    'f0c7',
    'M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faSave = faFloppyDisk;
const faVihara = {
  prefix: 'far',
  iconName: 'vihara',
  icon: [
    640,
    512,
    [],
    'f6a7',
    'M308.5 61.4c-31 21.7-64.8 39-100.5 51.3l0 47.3 112 0 112 0 0-47.3c-35.7-12.3-69.5-29.6-100.5-51.3L320 53.3l-11.5 8.1zm173.2 65.8l-1.7-.5 0 39.7 1.7 1.9 2.5 2.9c27.3 31.5 62.5 55.1 102.1 68.3l4.8 1.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 7s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-7 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4L544 288l0 36.6 4.3 7.4 1.9 3.3c17.2 29.6 43.4 52.9 74.8 66.5c8.8 3.6 15 12.2 15 22.3c0 13.3-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-184 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-184 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24c0-10.1 6.2-18.7 15-22.3c31.4-13.6 57.6-36.9 74.8-66.5l1.9-3.3 4.3-7.4L96 288l-39.4 0c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l4.8-1.6c39.5-13.2 74.8-36.8 102.1-68.3l2.5-2.9 1.7-1.9 0-39.7-1.7 .5c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5l23.6-6.4C209.2 63.5 247 45.8 281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23.6 6.4c12.8 3.5 20.3 16.7 16.8 29.5s-16.7 20.3-29.5 16.8zM496 320l0-32-176 0-176 0 0 32 176 0 176 0zM152.8 240L320 240l167.2 0c-12.3-9.6-23.9-20.3-34.5-32L320 208l-132.7 0c-10.6 11.7-22.2 22.4-34.5 32zM100.5 400L320 400l219.5 0c-9.5-9.8-18.1-20.5-25.5-32l-194 0-194 0c-7.5 11.5-16 22.2-25.5 32z',
  ],
};
const faFaceKissClosedEyes = {
  prefix: 'far',
  iconName: 'face-kiss-closed-eyes',
  icon: [
    512,
    512,
    [],
    'e37d',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM175.6 220c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z',
  ],
};
const faScaleUnbalanced = {
  prefix: 'far',
  iconName: 'scale-unbalanced',
  icon: [
    640,
    512,
    ['balance-scale-left'],
    'f515',
    'M542.9 16.7c4 12.6-2.9 26.1-15.5 30.2L399.6 87.7c-3.1 32.4-25.5 59.2-55.6 68.6L344 464l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-200 0c-13.3 0-24-10.7-24-24l0-331.7c-14.2-4.5-26.8-12.8-36.4-23.8L127.3 174.9c-12.6 4-26.1-2.9-30.2-15.5s2.9-26.1 15.5-30.2L240.4 88.3c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c29.8 0 55.8 16.3 69.6 40.5L512.7 1.1c12.6-4 26.1 2.9 30.2 15.5zM512 163.8L439.6 288l144.9 0L512 163.8zM386 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 350 574.9 384 512 384s-115.2-34-126-78.9zM56.7 416l144.9 0L129.2 291.8 56.7 416zm72.4 96C66.3 512 14 478 3.2 433.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C244.3 478 192 512 129.2 512zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faBalanceScaleLeft = faScaleUnbalanced;
const faFileUser = {
  prefix: 'far',
  iconName: 'file-user',
  icon: [
    384,
    512,
    [],
    'f65c',
    'M304 464c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-16 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16l-16 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM256 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
  ],
};
const faUserPoliceTie = {
  prefix: 'far',
  iconName: 'user-police-tie',
  icon: [
    448,
    512,
    [],
    'e334',
    'M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM221 48.6c1.9-.8 4-.8 5.9 0l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9c0 0 0 0 0 0l-.5-.9s0 0 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L168 512s0 0 0 0l1 0 21.2 0 1.7 0s0 0 0 0l64 0s0 0 0 0l1.7 0 21.2 0 1 0s0 0 0 0l142.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464s0 0 0 0l-.5 .9c0 0 0 0 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464l-88.3 0c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0l-88.3 0 35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z',
  ],
};
const faFaceTongueMoney = {
  prefix: 'far',
  iconName: 'face-tongue-money',
  icon: [
    512,
    512,
    [],
    'e39d',
    'M348.3 442.4c2.2-7.7 3.5-15.9 3.7-24.3c30.5-21.1 53.2-52.1 63.3-88.1c3.8-13.7-7.4-26.1-21.6-26.1L352 304l-32 0-128 0-32 0-41.6 0c-14.2 0-25.5 12.4-21.6 26.1c10.1 36 32.8 66.9 63.3 88.1c.2 8.4 1.5 16.5 3.7 24.3C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zm-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.5-6.2-9.8-13.5-12.6-21.6c-2.3-6.5-3.5-13.6-3.5-20.9l0-80 128 0 0 80c0 7.3-1.2 14.4-3.5 20.9c-2.8 8-7.1 15.3-12.6 21.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 120c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8zm144-16c-8.8 0-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8c0-8.8-7.2-16-16-16zM267.2 355.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6l0 6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8c0 0 0 0 0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4l0 7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6l0-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2l0-7.2z',
  ],
};
const faTennisBall = {
  prefix: 'far',
  iconName: 'tennis-ball',
  icon: [
    512,
    512,
    [127934],
    'f45e',
    'M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264C52.3 372.5 139.5 459.7 248 463.8zm48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2S297 418.4 296 460.2zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faSquareL = {
  prefix: 'far',
  iconName: 'square-l',
  icon: [
    448,
    512,
    [],
    'e275',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 56l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSortUp = {
  prefix: 'far',
  iconName: 'sort-up',
  icon: [
    320,
    512,
    ['sort-asc'],
    'f0de',
    'M160 86.6L70.6 176l178.7 0L160 86.6zM137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z',
  ],
};
const faSortAsc = faSortUp;
const faCalendarArrowUp = {
  prefix: 'far',
  iconName: 'calendar-arrow-up',
  icon: [
    448,
    512,
    ['calendar-upload'],
    'e0d1',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM200 408l0-102.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L248 408c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faCalendarUpload = faCalendarArrowUp;
const faCommentDots = {
  prefix: 'far',
  iconName: 'comment-dots',
  icon: [
    512,
    512,
    [128172, 62075, 'commenting'],
    'f4ad',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCommenting = faCommentDots;
const faPlantWilt = {
  prefix: 'far',
  iconName: 'plant-wilt',
  icon: [
    512,
    512,
    [],
    'e5aa',
    'M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 18.7c-33.9 8-56 33.6-56 72.4c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4l0-18.7C456 50.1 405.9 0 344 0S232 50.1 232 112l0 36.1c-18.1-12.7-40.2-20.1-64-20.1c-61.9 0-112 50.1-112 112l0 18.7c-33.9 8-56 33.6-56 72.4C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4l0-18.7c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32 0 216c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 0-32 0-128zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2c1 .1 2 .2 3.1 .2s2.1-.1 3.1-.2c12.3 .5 19.1 4.3 22.3 7.2c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3c0 0 0 0 0 0c0-11.9 3.8-17.1 6.7-19.8zM400 203.1c0-11.9 3.8-17.1 6.7-19.8c3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3c0 0 0 0 0 0z',
  ],
};
const faScarf = {
  prefix: 'far',
  iconName: 'scarf',
  icon: [
    512,
    512,
    [129507],
    'f7c1',
    'M306.7 256s0 0 0 0l33.9 33.9L362.7 312 312 362.7 162.4 213.1c-11.7-11.7-18.4-27.7-18.4-44.3c0-10.8 2.8-21.3 8-30.7l41.5-73.8C199.2 54.2 209.9 48 221.4 48l69.1 0c11.6 0 22.2 6.2 27.9 16.3L360 138.1c5.3 9.4 8 20 8 30.7c0 16.6-6.6 32.6-18.3 44.3l-9 9-50.7-50.7 8-8c3.9-3.9 6.1-9.1 6.1-14.6c0-11.4-9.3-20.7-20.7-20.7l-54.6 0c-11.4 0-20.7 9.3-20.7 20.7c0 5.5 2.2 10.7 6.1 14.6L306.7 256s0 0 0 0zm101.8 33.9l-11.9-11.9L374.6 256l9-9c20.8-20.8 32.4-48.9 32.4-78.2c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0L221.4 0c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L278.1 396.7l30.6 30.6s0 0 0 0l3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408l11.3-11.3L360 382.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360l14.1-14.1L408 334.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3s0 0 0 0l-18.7-18.7zM116.7 276.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6z',
  ],
};
const faAlbumCirclePlus = {
  prefix: 'far',
  iconName: 'album-circle-plus',
  icon: [
    576,
    512,
    [],
    'e48c',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faUserNurseHairLong = {
  prefix: 'far',
  iconName: 'user-nurse-hair-long',
  icon: [
    448,
    512,
    [],
    'e45e',
    'M96 70.2L96 128l.3 0c-.2 2.6-.3 5.3-.3 8l0 24 0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304L224 304l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-11 0-24c0-2.7-.1-5.4-.3-8l.3 0 0-57.8c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160l8 0zM50 461.9c7.8-38.7 38-69.3 76.4-77.7l52.3 52.3c25 25 65.5 25 90.5 0l52.3-52.3c38.5 8.4 68.6 39 76.4 77.7L50 461.9zm80.4-127C56.9 343.6 0 406 0 481.8c0 15.6 12.6 28.2 28.2 28.2l391.7 0c15.6 0 28.2-12.6 28.2-28.2C448 406 391.1 343.6 317.6 335c-8.7-1-17.2 2.5-23.4 8.7l-58.9 58.9c-6.2 6.2-16.4 6.2-22.6 0l-58.9-58.9c-6.2-6.2-14.7-9.8-23.4-8.7zM208 48c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16z',
  ],
};
const faDiamond = {
  prefix: 'far',
  iconName: 'diamond',
  icon: [
    512,
    512,
    [9830],
    'f219',
    'M249 50.9L50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L249 461.1c1.9 1.9 4.4 2.9 7 2.9s5.2-1 7-2.9L461.1 263c1.9-1.9 2.9-4.4 2.9-7s-1-5.2-2.9-7L263 50.9c-1.9-1.9-4.4-2.9-7-2.9s-5.2 1-7 2.9zM17 215L215 17C225.9 6.1 240.6 0 256 0s30.1 6.1 41 17L495 215c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L297 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41z',
  ],
};
const faSquareLeft = {
  prefix: 'far',
  iconName: 'square-left',
  icon: [
    448,
    512,
    [11013, 'arrow-alt-square-left'],
    'f351',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM185.4 360.8l-84-91c-3.5-3.8-5.4-8.7-5.4-13.9s1.9-10.1 5.4-13.9l84-91c4.2-4.6 10.1-7.2 16.4-7.2c12.3 0 22.3 10 22.3 22.3l0 41.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 41.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.4-7.2z',
  ],
};
const faArrowAltSquareLeft = faSquareLeft;
const faFaceGrinSquint = {
  prefix: 'far',
  iconName: 'face-grin-squint',
  icon: [
    512,
    512,
    [128518, 'grin-squint'],
    'f585',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
  ],
};
const faGrinSquint = faFaceGrinSquint;
const faCircleEllipsisVertical = {
  prefix: 'far',
  iconName: 'circle-ellipsis-vertical',
  icon: [
    512,
    512,
    [],
    'e10b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faHandHoldingDollar = {
  prefix: 'far',
  iconName: 'hand-holding-dollar',
  icon: [
    576,
    512,
    ['hand-holding-usd'],
    'f4c0',
    'M312 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faHandHoldingUsd = faHandHoldingDollar;
const faGridDividers = {
  prefix: 'far',
  iconName: 'grid-dividers',
  icon: [
    512,
    512,
    [],
    'e3ad',
    'M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM80 176l32 0 0-32-32 0 0 32zM32 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM80 464l32 0 0-32-32 0 0 32zM32 416c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM240 144l0 32 32 0 0-32-32 0zM224 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM400 144l0 32 32 0 0-32-32 0zM384 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM24 288l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faChartDiagram = {
  prefix: 'far',
  iconName: 'chart-diagram',
  icon: [
    512,
    512,
    [],
    'e695',
    'M416 80c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 112c-8.8 0-16-7.2-16-16s7.2-16 16-16l320 0zM96 32C60.7 32 32 60.7 32 96s28.7 64 64 64l136 0 0 16-9.9 9.9-28.1 28.1L184 224l-56 0c-48.6 0-88 39.4-88 88l0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40c0-22.1 17.9-40 40-40l56 0 9.9 9.9 28.1 28.1L232 320l0 32-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-32 9.9-9.9 28.1-28.1L328 272l56 0c22.1 0 40 17.9 40 40l0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40c0-48.6-39.4-88-88-88l-56 0-9.9-9.9-28.1-28.1L280 176l0-16 136 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L96 32zM48 432l0-32 32 0 0 32-32 0zm192 0l0-32 32 0 0 32-32 0zm192 0l0-32 32 0 0 32-32 0zM227.9 248L256 219.9 284.1 248 256 276.1 227.9 248z',
  ],
};
const faBacterium = {
  prefix: 'far',
  iconName: 'bacterium',
  icon: [
    512,
    512,
    [],
    'e05a',
    'M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.4 4.5c-4.8 16.8-8.2 34-10 51c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3c.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM207.9 372.9c-.1 .7-.2 1.4-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8c-35.1-3.2-61-34.2-58-69.2c4.4-41 20.4-84 42.9-121.4c38-63.4 107.9-131.1 230.5-159.4c34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8C297 226.1 254.9 270.3 232.9 306.9c-10.8 18-21.1 40.8-25 66zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faHandPointer = {
  prefix: 'far',
  iconName: 'hand-pointer',
  icon: [
    448,
    512,
    [],
    'f25a',
    'M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z',
  ],
};
const faDrumSteelpan = {
  prefix: 'far',
  iconName: 'drum-steelpan',
  icon: [
    576,
    512,
    [],
    'f56a',
    'M528 160c0-9.9-8-29.9-55-49.8c-20-8.5-44.3-15.4-71.9-20.6c-1.2 4.1-2.4 8.8-3.6 13.8c-4.5 18.9-7.6 39.2-5.7 53.3c2.2 16.3 10.4 35.1 19.3 51.1c4 7.3 7.9 13.5 10.9 18c19.1-4.5 36.2-9.9 51-16.2c47.1-19.9 55-39.9 55-49.8zM369.1 231.2c-6.9-12.5-14.9-28.8-20.1-46.3c-15.4 8-36 15.1-61 15.1s-45.6-7.1-61-15.1c-5.2 17.5-13.2 33.8-20.1 46.3c-.7 1.3-1.4 2.5-2.1 3.8c25.7 3.3 53.7 5 83.2 5s57.5-1.8 83.2-5c-.7-1.2-1.4-2.5-2.1-3.8zM350.8 92.3c.8-3.2 1.6-6.3 2.3-9.3c-20.6-2-42.4-3-65.1-3s-44.5 1-65.1 3c.8 2.9 1.6 6 2.3 9.3c2.6 11 5.4 24.5 6.7 38.4l.3 .2c2.6 2.3 6.6 5.4 11.8 8.6c10.5 6.4 25.4 12.5 44 12.5s33.5-6.2 44-12.5c5.2-3.2 9.2-6.3 11.8-8.6c.1-.1 .2-.2 .3-.2c1.3-13.9 4.1-27.4 6.7-38.4zM103 209.8c14.8 6.3 31.9 11.7 51 16.2c3-4.5 6.9-10.8 10.9-18c8.9-16 17.1-34.9 19.3-51.1c1.9-14.2-1.1-34.5-5.7-53.3c-1.2-5-2.5-9.7-3.6-13.8c-27.6 5.1-51.9 12.1-71.9 20.6C56 130.1 48 150.1 48 160s8 29.9 55 49.8zM576 160l0 192c0 24.3-11.3 44.9-28.1 61c-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352L0 160C0 80 128.9 32 288 32s288 48 288 128zm-48 74.9C476.4 269 388.2 288 288 288s-188.4-19-240-53.1L48 352c0 8.2 3.5 16.9 13.3 26.3c10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6c9.9-9.4 13.3-18.2 13.3-26.3l0-117.1z',
  ],
};
const faHandScissors = {
  prefix: 'far',
  iconName: 'hand-scissors',
  icon: [
    512,
    512,
    [],
    'f257',
    'M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z',
  ],
};
const faHandsPraying = {
  prefix: 'far',
  iconName: 'hands-praying',
  icon: [
    640,
    512,
    ['praying-hands'],
    'f684',
    'M277.8 48c-5.9 0-11.4 2.9-14.8 7.7l-99.8 141c-12.4 17.6-19.1 38.6-19.1 60.1l0 40.2c0 24.1-15.4 45.5-38.3 53.1L31.6 374.8C19 379 5.4 372.2 1.2 359.6S3.8 333.4 16.4 329.2l74.1-24.7c3.3-1.1 5.5-4.1 5.5-7.6l0-40.2c0-31.5 9.8-62.2 28-87.9l99.8-141C236.2 10.4 256.4 0 277.8 0c16.1 0 30.8 5.8 42.2 15.3C331.4 5.8 346.1 0 362.2 0c21.5 0 41.6 10.4 54 27.9l99.8 141c18.2 25.7 28 56.4 28 87.9l0 40.2c0 3.4 2.2 6.5 5.5 7.6l74.1 24.7c12.6 4.2 19.4 17.8 15.2 30.4s-17.8 19.4-30.4 15.2l-74.1-24.7c-22.9-7.6-38.3-29-38.3-53.1l0-40.2c0-21.5-6.7-42.5-19.1-60.1L377 55.7c-3.4-4.8-8.9-7.7-14.8-7.7c-9.6 0-18 8-18.2 18.2l0 .4 0 .4c.1 3.7 1.3 7.4 3.3 10.3L416.5 178c10.1 14.7 15.5 32.1 15.5 49.9l0 8.1 0 60c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-60c0-11-9-20-20-20c-10.9 0-19.8 8.7-20 19.6l0 .4 0 74c0 .3 0 .6 0 .9c.4 46.6 31.8 87.3 76.9 99.5l201.4 54.4c12.8 3.5 20.4 16.6 16.9 29.4s-16.6 20.4-29.4 16.9L408.3 456.7C370.9 446.6 339.9 423 320 392c-19.9 31-50.9 54.6-88.3 64.8L30.3 511.2c-12.8 3.5-26-4.1-29.4-16.9s4.1-26 16.9-29.4l201.4-54.4c45.1-12.2 76.5-52.9 76.9-99.5c0-.3 0-.6 0-.9l0-74 0-.4c-.2-10.8-9.1-19.6-20-19.6c-11 0-20 9-20 20l0 60c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-60 0-8.1c0-17.8 5.4-35.2 15.5-49.9L292.7 77.3c2-2.9 3.2-6.6 3.3-10.3l0-.4 0-.4C295.8 56 287.4 48 277.8 48zM320 122.4L287.9 169c12.1 2.1 23.1 7.5 32.1 15.1c9-7.6 20-13 32.1-15.1L320 122.4z',
  ],
};
const faPrayingHands = faHandsPraying;
const faFacePensive = {
  prefix: 'far',
  iconName: 'face-pensive',
  icon: [
    512,
    512,
    [],
    'e384',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 368l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm143.6-84c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 317.2 371 324 351.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 317.2 179 324 159.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z',
  ],
};
const faUserMusic = {
  prefix: 'far',
  iconName: 'user-music',
  icon: [
    640,
    512,
    [],
    'f8eb',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464L288 464s0 0 0 0c0 19.1 7.7 35.4 18.9 48L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c36.3 0 70.1 10.9 98.3 29.5l0 51.6c-3.2 .4-6.5 1-9.6 1.7C335.1 365.2 304 352 269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z',
  ],
};
const faArrowRotateRight = {
  prefix: 'far',
  iconName: 'arrow-rotate-right',
  icon: [
    512,
    512,
    [8635, 'arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
    'f01e',
    'M472 224c13.3 0 24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80.1-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2s0 0 0 0L418.9 176 328 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0z',
  ],
};
const faArrowRightRotate = faArrowRotateRight;
const faArrowRotateForward = faArrowRotateRight;
const faRedo = faArrowRotateRight;
const faMessagesDollar = {
  prefix: 'far',
  iconName: 'messages-dollar',
  icon: [
    640,
    512,
    ['comments-alt-dollar'],
    'f652',
    'M72 48C58.7 48 48 58.7 48 72l0 176c0 13.3 10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 19.2L202.7 276c3.9-2.6 8.6-4 13.3-4l128 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24L72 48zM0 72C0 32.2 32.2 0 72 0L344 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-120.7 0-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360l0-40-24 0c-39.8 0-72-32.2-72-72L0 72zM256 352l48 0 0 24c0 13.3 10.7 24 24 24l96 0c4.7 0 9.4 1.4 13.3 4L496 443.2l0-19.2c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-120 0 0-48 120 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-24 0 0 40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60L328 448c-39.8 0-72-32.2-72-72l0-24zM224 79.1l0 10.4c5.9 .9 11.6 2.3 16.8 3.6c8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-8.8-2.3-17.3-3.9-25-4c-6.4-.1-13 1.4-17.4 3.9c-3.9 2.2-4.8 4.3-4.8 6.8l0 .1c0 1 0 2.2 4.1 4.6c5.1 3 12.5 5.2 22.7 8.2l.5 .2c9 2.6 20.4 6 29.6 11.6c10.2 6.3 19.6 16.6 19.8 32.8c.2 16.7-8.6 28.6-20 35.5c-5.7 3.4-12 5.7-18.4 7l0 10.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.9c-8.2-1.7-15.8-4.3-22.5-6.5c0 0 0 0 0 0c-1.7-.6-3.3-1.1-4.9-1.6c-8.4-2.7-13-11.7-10.3-20.2s11.7-13 20.2-10.3c2 .7 3.9 1.3 5.8 1.9c0 0 0 0 0 0s0 0 0 0c10.9 3.6 19.2 6.4 28.2 6.6c6.9 .2 13.3-1.3 17.3-3.7c3.3-2 4.6-4.2 4.6-7.7c0-1.8-.4-3.4-4.5-5.9c-5-3.1-12.4-5.4-22.5-8.4l-1.4-.4c-8.7-2.5-19.7-5.8-28.4-10.9c-10.1-5.9-19.8-16-19.9-32.2c-.1-16.8 9.7-28.3 20.8-34.7c5.5-3.2 11.5-5.3 17.6-6.6l0-10.5c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faCommentsAltDollar = faMessagesDollar;
const faSensorOn = {
  prefix: 'far',
  iconName: 'sensor-on',
  icon: [
    640,
    512,
    [],
    'e02b',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 96c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm381.3-20c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM536 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm13.3 140c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z',
  ],
};
const faBalloon = {
  prefix: 'far',
  iconName: 'balloon',
  icon: [
    384,
    512,
    [],
    'e2e3',
    'M48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 35.8-18.4 74.2-46.5 110.7c-27.5 35.7-60.2 64.2-79 79.3c-7.6 6.1-13.8 13.5-18.4 21.8c-4.6-8.3-10.9-15.8-18.4-21.8c-18.9-15.1-51.5-43.6-79-79.3C66.4 266.2 48 227.8 48 192zM150.7 450.5L144 464l-.1 .1-3 6-11.6 23.2c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l25.9 0 6.7 0 .1 0 36.7 0 .1 0 6.7 0 25.9 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8l-11.6-23.2-3-6-.1-.1-6.7-13.5c-5.3-10.6-2.1-23.6 7.1-31C281.2 386.9 384 294.6 384 192C384 86 298 0 192 0S0 86 0 192C0 294.6 102.8 386.9 143.6 419.5c9.3 7.4 12.5 20.4 7.1 31zM128 184c0-30.9 25.1-56 56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24C126.6 80 80 126.6 80 184c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faWebAwesome = {
  prefix: 'far',
  iconName: 'web-awesome',
  icon: [
    640,
    512,
    [],
    'e682',
    'M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l102.2-20.4 2.2-.4c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48l-9.8 21.8L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L56.2 213.8 46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1l2.2 .4L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52zm44.2 176.1L320 143.8l-96.4 84.3c-11.2 9.8-26.4 13.9-41 10.9L114 225.4l88.7 197.2c2.6 5.7 8.3 9.4 14.6 9.4l205.2 0c6.3 0 12-3.7 14.6-9.4L526 225.4l-68.5 13.7c-14.6 2.9-29.8-1.1-41-10.9z',
  ],
};
const faBiohazard = {
  prefix: 'far',
  iconName: 'biohazard',
  icon: [
    576,
    512,
    [9763],
    'f780',
    'M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c3.3-6.2 5.9-12.8 7.3-19.8c-29.9-23.5-51.1-57.5-58.3-96.4c-7.1-2.2-14.4-3.4-21.7-3.8c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c3.8 6.9 8.5 13.3 14.3 18.8c18-7 37.5-10.8 57.9-10.8s40 3.8 57.9 10.8c5.8-5.5 10.5-11.9 14.3-18.8c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM445.3 301.3c-7.2 38.9-28.5 72.9-58.3 96.4c1.5 7 4 13.7 7.3 19.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-7.3 .3-14.6 1.5-21.7 3.8z',
  ],
};
const faChessQueenPiece = {
  prefix: 'far',
  iconName: 'chess-queen-piece',
  icon: [
    256,
    512,
    ['chess-queen-alt'],
    'f446',
    'M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM16 232c0-13.3 10.7-24 24-24l5.1 0L3.6 140.6c-6.4-10.4-4-24 5.7-31.5l2.5-1.9c6.1-4.7 14.1-6.3 21.5-4.1c2.1 .6 4.4 1 6.8 1c11.7 0 21.4-8.3 23.6-19.4c1.9-9.7 9.5-17.3 19.2-19s19.5 2.6 24.7 11C111.8 83.5 119.4 88 128 88s16.2-4.5 20.5-11.4c5.2-8.4 15-12.8 24.7-11s17.4 9.3 19.2 19c2.1 11 11.9 19.4 23.6 19.4c2.4 0 4.7-.3 6.8-1c7.4-2.2 15.4-.6 21.5 4.1l2.5 1.9c9.7 7.5 12.1 21.1 5.7 31.5L211 208l5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-15.2 0 4.4 96-48 0-4.4-96-49.4 0-4.4 96-48 0 4.4-96L40 256c-13.3 0-24-10.7-24-24zm138.6-24l37.1-60.2c-11.6-4.2-21.8-11.2-29.7-20.3c-10.1 5.4-21.6 8.5-33.9 8.5s-23.8-3.1-33.9-8.5c-8 9.1-18.2 16.1-29.7 20.3L101.4 208l53.2 0zM52.7 464l150.7 0-16.6-32L69.2 432 52.7 464zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l137 0z',
  ],
};
const faChessQueenAlt = faChessQueenPiece;
const faLocationCrosshairs = {
  prefix: 'far',
  iconName: 'location-crosshairs',
  icon: [
    512,
    512,
    ['location'],
    'f601',
    'M256 0c13.3 0 24 10.7 24 24l0 41.5C366.8 76.3 435.7 145.2 446.5 232l41.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.5 0C435.7 366.8 366.8 435.7 280 446.5l0 41.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-41.5C145.2 435.7 76.3 366.8 65.5 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l41.5 0C76.3 145.2 145.2 76.3 232 65.5L232 24c0-13.3 10.7-24 24-24zM112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z',
  ],
};
const faLocation = faLocationCrosshairs;
const faMarsDouble = {
  prefix: 'far',
  iconName: 'mars-double',
  icon: [
    640,
    512,
    [9891],
    'f227',
    'M288 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80 312 80c-13.3 0-24-10.7-24-24zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM480 158.1L558.1 80 504 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12c14.3-11.2 27.1-24.2 38-38.6c8.4 1.7 17.1 2.6 26 2.6c70.7 0 128-57.3 128-128c0-35.7-14.7-68.1-38.3-91.3C471.3 202.5 480 186.3 480 168l0-9.9z',
  ],
};
const faLeftFromBracket = {
  prefix: 'far',
  iconName: 'left-from-bracket',
  icon: [
    512,
    512,
    [],
    'e66c',
    'M160 365.8L50 256 160 146.2l0 53.8c0 13.3 10.7 24 24 24l120 0 0 64-120 0c-13.3 0-24 10.7-24 24l0 53.8zM0 256c0 11.5 4.6 22.5 12.7 30.6L128.8 402.4c8.7 8.7 20.5 13.6 32.8 13.6c25.6 0 46.4-20.8 46.4-46.4l0-33.6 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-33.6c0-25.6-20.8-46.4-46.4-46.4c-12.3 0-24.1 4.9-32.8 13.6L12.7 225.4C4.6 233.5 0 244.5 0 256zM344 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0z',
  ],
};
const faHousePersonLeave = {
  prefix: 'far',
  iconName: 'house-person-leave',
  icon: [
    640,
    512,
    ['house-leave', 'house-person-depart'],
    'e00f',
    'M528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM461.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm59 54.6l50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L439 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l9.5-21.3c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L633 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L570 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3zm-101.1 21l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L361 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4zM255.2 5.4L391.9 116.8c-14.8 7.8-28.4 17.5-40.5 28.9L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l200 0 40 0 14.9 0-6.6 16.5L336.8 416 120 416c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0zM160 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z',
  ],
};
const faHouseLeave = faHousePersonLeave;
const faHousePersonDepart = faHousePersonLeave;
const faRulerTriangle = {
  prefix: 'far',
  iconName: 'ruler-triangle',
  icon: [
    512,
    512,
    [128208],
    'f61c',
    'M48 448L48 67.9l66.7 66.7-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1L444.1 464 64 464c-8.8 0-16-7.2-16-16zm454.6 6.6L57.4 9.4C51.4 3.4 43.2 0 34.7 0L32 0C14.3 0 0 14.3 0 32L0 448c0 35.3 28.7 64 64 64l416 0c17.7 0 32-14.3 32-32l0-2.7c0-8.5-3.4-16.6-9.4-22.6zM128 256l0 128 128 0L128 256z',
  ],
};
const faCardClub = {
  prefix: 'far',
  iconName: 'card-club',
  icon: [
    384,
    512,
    [],
    'e3e9',
    'M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm66.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z',
  ],
};
const faChildDress = {
  prefix: 'far',
  iconName: 'child-dress',
  icon: [
    320,
    512,
    [],
    'e59c',
    'M184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 72a72 72 0 1 1 144 0A72 72 0 1 1 88 72zm-17 129.8c21.3-25.7 52.7-40.9 86-41.8c.7 0 1.4 0 2.2 0l.9 0 .9 0c.7 0 1.4 0 2.2 0c33.3 .9 64.6 16.1 86 41.8l65.4 78.8c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1l-43.1-52 36.3 109c2.4 7.3 1.2 15.4-3.3 21.6s-11.8 10-19.5 10l-24 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-32 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-24 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l36.3-109-43.1 52c-8.5 10.2-23.6 11.6-33.8 3.1S-2.9 290.9 5.5 280.7l65.4-78.8zM160 208c-.5 0-1 0-1.4 0c-3.2 .2-6.1 2.3-7.1 5.5L105.3 352l109.4 0L168.5 213.5c-1-3.1-3.9-5.3-7.1-5.5c-.5 0-1 0-1.4 0z',
  ],
};
const faUsersBetweenLines = {
  prefix: 'far',
  iconName: 'users-between-lines',
  icon: [
    640,
    512,
    [],
    'e591',
    'M24 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24S10.7 0 24 0zm0 464l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zM321.6 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-60.5 80.8c4.1-.5 8.3-.8 12.5-.8l48 0 48 0c4.2 0 8.4 .3 12.5 .8c47.1 6.1 83.5 46.4 83.5 95.2c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c0 0 0 0 0 0c10.5-29.7 35.3-52.8 66.1-60.9c0 0 0 0 0 0c3.9-1 7.9-1.8 11.9-2.3zM273.6 240c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80s80 35.8 80 80c0 26.2-12.6 49.4-32 64c0 0 0 0 0 0c-13.4 10-30 16-48 16s-34.6-6-48-16c0 0 0 0 0 0zM392.7 341.9c-6.8-3.8-14.7-5.9-23.1-5.9l-96 0c-20.9 0-38.7 13.4-45.3 32l186.5 0c-2.6-7.3-6.9-13.8-12.4-19c-3.7-1.7-7-4.2-9.8-7.1zM147.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96 256l96 0c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6L64 352c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64zm480 96l-82.4 0c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32zM499.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faLungsVirus = {
  prefix: 'far',
  iconName: 'lungs-virus',
  icon: [
    640,
    512,
    [],
    'e067',
    'M344 24l0 126.4c-7.1-4.1-15.3-6.4-24-6.4s-16.9 2.3-24 6.4L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 165.3l0 24.1c-14.4-9.6-32.8-10.5-48-2.9l0-21.2c0-11.8-9.6-21.3-21.3-21.3c-6.8 0-12.8 3.2-16.4 8.3c-14.7 21.1-42.3 62.6-67.8 111.6C77 312.8 54.3 367.9 48 417l0 6c0 22.6 18.3 41 41 41c3.4 0 6.7-.4 9.9-1.2l72.7-18.2c6.4-1.6 12.3-4.5 17.3-8.3c1.8 2.9 4 5.6 6.6 8.2c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3zm273.4 344l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c2.5-2.5 4.7-5.3 6.6-8.2c5 3.8 10.9 6.7 17.3 8.3l72.7 18.2c3.3 .8 6.6 1.2 9.9 1.2c22.6 0 41-18.3 41-41l0-6c-6.3-49.1-29-104.2-54.4-153.1c-25.5-49-53.1-90.5-67.8-111.6c-3.6-5.1-9.6-8.3-16.4-8.3c-11.8 0-21.3 9.6-21.3 21.3l0 21.2c-15.2-7.6-33.6-6.6-48 2.9l0-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7zM320 176c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faSpinnerThird = {
  prefix: 'far',
  iconName: 'spinner-third',
  icon: [
    512,
    512,
    [],
    'f3f4',
    'M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256C512 122.7 410.1 13.2 280 1.1C266.8-.1 256 10.7 256 24s10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6c-5.3 12.2-1.5 26.8 10 33.5z',
  ],
};
const faFaceGrinTears = {
  prefix: 'far',
  iconName: 'face-grin-tears',
  icon: [
    640,
    512,
    [128514, 'grin-tears'],
    'f588',
    'M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z',
  ],
};
const faGrinTears = faFaceGrinTears;
const faPhone = {
  prefix: 'far',
  iconName: 'phone',
  icon: [
    512,
    512,
    [128222, 128379],
    'f095',
    'M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faComputerMouseScrollwheel = {
  prefix: 'far',
  iconName: 'computer-mouse-scrollwheel',
  icon: [
    384,
    512,
    ['mouse-alt'],
    'f8cd',
    'M336 352l0-192c0-61.9-50.1-112-112-112l-64 0C98.1 48 48 98.1 48 160l0 192c0 61.9 50.1 112 112 112l64 0c61.9 0 112-50.1 112-112zM0 160C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 192c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 160zM192 96c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
  ],
};
const faMouseAlt = faComputerMouseScrollwheel;
const faCalendarXmark = {
  prefix: 'far',
  iconName: 'calendar-xmark',
  icon: [
    448,
    512,
    ['calendar-times'],
    'f273',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faCalendarTimes = faCalendarXmark;
const faChildReaching = {
  prefix: 'far',
  iconName: 'child-reaching',
  icon: [
    384,
    512,
    [],
    'e59d',
    'M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 192 0a72 72 0 1 0 0 144zm-.2 32c-41.6 0-80-22.4-100.6-58.5L76.9 92.2c-6.5-11.5-21.2-15.6-32.7-9s-15.6 21.2-9 32.7l14.4 25.3c15 26.5 36.8 47.7 62.5 62.1L112 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 64 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-285c25-14 46.2-34.6 61.1-60.2l15.6-26.7c6.7-11.4 2.8-26.1-8.6-32.8s-26.1-2.8-32.8 8.6l-15.6 26.7C271 154.2 232.9 176 191.8 176zM224 336l-64 0 0-115.1c10.4 2.1 21 3.1 31.8 3.1c10.9 0 21.7-1.1 32.2-3.2L224 336z',
  ],
};
const faTableLayout = {
  prefix: 'far',
  iconName: 'table-layout',
  icon: [
    512,
    512,
    [],
    'e290',
    'M448 80c8.8 0 16 7.2 16 16l0 64L48 160l0-64c0-8.8 7.2-16 16-16l384 0zM48 416l0-208 96 0 0 224-80 0c-8.8 0-16-7.2-16-16zm144 16l0-224 272 0 0 208c0 8.8-7.2 16-16 16l-256 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faNarwhal = {
  prefix: 'far',
  iconName: 'narwhal',
  icon: [
    640,
    512,
    [],
    'f6fe',
    'M639.4 20.5c2.3-7.7-1.6-16-9-19.2s-16-.4-20.1 6.5L516 167.3c-15.7-4.7-32.3-7.3-49.6-7.3c-53.1 0-104.4 19.5-144.1 54.8L177.9 343.2c-6.4 5.7-14.6 8.8-23.1 8.8c-19.2 0-34.8-15.6-34.8-34.8l0-13.2 0-45.3 37.9-26.5c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L72 258.7 72 304l0 13.2L72 352c0 88.4 71.6 160 160 160l232 0c97.2 0 176-80 176-177.2c0-50.1-21.2-95.5-55.1-127.5L639.4 20.5zM232 464c-46.3 0-86-28.1-103.1-68.1c8.1 2.7 16.8 4.1 25.9 4.1c20.3 0 39.8-7.4 55-20.9L354.2 250.7c30.9-27.5 70.9-42.7 112.2-42.7C535.4 208 592 265 592 334.8C592 405.9 534.3 464 464 464l-232 0zM496 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faRampLoading = {
  prefix: 'far',
  iconName: 'ramp-loading',
  icon: [
    448,
    512,
    [],
    'f4d4',
    'M96 48l256 0c8.8 0 16 7.2 16 16l0 248.4 48 88L416 64c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 336.4 48-88L80 64c0-8.8 7.2-16 16-16zm67 240c-20.5 0-39.3 11.2-49.2 29.2l-74 135.7C25.3 479.5 44.6 512 75 512L373 512c30.4 0 49.7-32.5 35.1-59.2l-74-135.7c-9.8-18-28.7-29.2-49.2-29.2l-122 0zm-7 52.2c1.4-2.6 4.1-4.2 7-4.2l122 0c2.9 0 5.6 1.6 7 4.2L359.6 464 88.4 464 156 340.2z',
  ],
};
const faCalendarCirclePlus = {
  prefix: 'far',
  iconName: 'calendar-circle-plus',
  icon: [
    576,
    512,
    [],
    'e470',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faToothbrush = {
  prefix: 'far',
  iconName: 'toothbrush',
  icon: [
    576,
    512,
    [129701],
    'f635',
    'M64 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0c29.4 0 55.1-11.9 71-36.1c4.3-6.5 7.4-13.2 9.7-19.9c6.4 2.7 12 6 16.6 9.7c9.5 7.7 14.6 17 14.6 30.3c0 26.5-21.5 48-48 48L64 176zM0 160c0 35.3 28.7 64 64 64l288 0c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48L64 96C28.7 96 0 124.7 0 160zM80 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 80 0 80 0 80 0 80 0 176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-152 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152z',
  ],
};
const faBorderInner = {
  prefix: 'far',
  iconName: 'border-inner',
  icon: [
    448,
    512,
    [],
    'f84e',
    'M416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c-13.3 0-24-10.7-24-24l0-176L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0 0-176c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176 176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0 0 176c0 13.3-10.7 24-24 24z',
  ],
};
const faPawClaws = {
  prefix: 'far',
  iconName: 'paw-claws',
  icon: [
    512,
    512,
    [],
    'f702',
    'M178.1 15.3L138.9 58.4C121.6 77.4 112 102.3 112 128c0 0 0 0 0 0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2l0-50.5c0-7.3-9-10.8-13.9-5.4zm132 206.3c32.3 10.6 70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0 0 0 0 0 0c0-25.7-9.6-50.6-26.9-69.6L333.9 15.3C329 9.9 320 13.4 320 20.7l0 50.5c-18.3 9.8-34.3 28.9-42.5 53.6c-14.3 42.9 .3 86.2 32.6 96.8zm-209.7 8.9C91.1 214.7 77.9 203 64 196.8l0-44.2c0-7.7-9.9-11-14.5-4.7L12.2 199.2C4.3 210.1 0 223.3 0 236.8L0 240s0 0 0 0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1zM256 304c20.6 0 96.1 15.4 141.7 137.7c1.4 3.7 2.3 8.5 2.3 14.2c0 4.5-3.6 8.1-8.1 8.1l-3.4 0c-2.2 0-4.3-.4-6.3-1.2l-72.7-29.1c-34.3-13.7-72.6-13.7-107 0l-72.7 29.1c-2 .8-4.2 1.2-6.3 1.2l-3.4 0c-4.5 0-8.1-3.6-8.1-8.1c0-5.7 .9-10.4 2.3-14.2C159.9 319.4 235.4 304 256 304zm0-48c-41.2 0-134.3 28.4-186.7 169c-3.7 9.9-5.3 20.4-5.3 31c0 31 25.1 56.1 56.1 56.1l3.4 0c8.3 0 16.5-1.6 24.2-4.7l72.7-29.1c22.9-9.2 48.4-9.2 71.3 0l72.7 29.1c7.7 3.1 15.9 4.7 24.2 4.7l3.4 0c31 0 56.1-25.1 56.1-56.1c0-10.5-1.6-21.1-5.3-31C390.3 284.4 297.2 256 256 256zm165.8 58.7c24.5 14 59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4c0 0 0 0 0 0l0-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7l0 44.2c-13.9 6.1-27.1 17.8-36.4 33.7c-18.9 32.4-14.3 70.1 10.2 84.1z',
  ],
};
const faKiwiFruit = {
  prefix: 'far',
  iconName: 'kiwi-fruit',
  icon: [
    448,
    512,
    [],
    'e30c',
    'M399.8 265.3C358.7 298.6 295.3 320 224 320s-134.7-21.4-175.8-54.7C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7zM448 176l0 80c0 123.7-100.3 224-224 224S0 379.7 0 256l0-80C0 96.5 100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24z',
  ],
};
const faTrafficLightSlow = {
  prefix: 'far',
  iconName: 'traffic-light-slow',
  icon: [
    320,
    512,
    [],
    'f639',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-120a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
  ],
};
const faRectangleCode = {
  prefix: 'far',
  iconName: 'rectangle-code',
  icon: [
    512,
    512,
    [],
    'e322',
    'M448 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM287 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM225 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z',
  ],
};
const faHeadSideVirus = {
  prefix: 'far',
  iconName: 'head-side-virus',
  icon: [
    512,
    512,
    [],
    'e064',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM224 72c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 160.1 129 200 96 200c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 294.5 208 311 208 344c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 271.9 319 232 352 232c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 137.5 240 121 240 88c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faKeyboardBrightness = {
  prefix: 'far',
  iconName: 'keyboard-brightness',
  icon: [
    640,
    512,
    [],
    'e1c0',
    'M129 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80zm167 33c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112zm135 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80zM0 392c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm216-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm320 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z',
  ],
};
const faBooksMedical = {
  prefix: 'far',
  iconName: 'books-medical',
  icon: [
    576,
    512,
    [],
    'f7e8',
    'M112 416l0 48 64 0 0-48-64 0zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4l-64 0c-26.5 0-48-21.5-48-48l0-48 0-24 0-8 112 0 0-16 0-48 48 0 0 48 64 0 0-224-64 0 0 48-48 0 0-48 0-16L64 128l0-8 0-24 0-48C64 21.5 85.5 0 112 0l64 0c8.7 0 16.9 2.3 24 6.4C207.1 2.3 215.3 0 224 0l64 0c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L413.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L339.6 145.9 336 132.2l0 11.8 0 224 0 24 0 24 0 48c0 26.5-21.5 48-48 48l-64 0c-8.7 0-16.9-2.3-24-6.4zM224 464l64 0 0-48-64 0 0 48zM176 48l-64 0 0 48 64 0 0-48zm48 48l64 0 0-48-64 0 0 48zM504.1 355.7l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L528 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L424.4 48.5 368 64.1c0 .1 0 .2 0 .4l11.7 45.2zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faLightbulbSlash = {
  prefix: 'far',
  iconName: 'lightbulb-slash',
  icon: [
    640,
    512,
    [],
    'f673',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM200 131.4C218.1 82.7 265 48 320 48c70.7 0 128 57.3 128 128c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-4.6 6.3-9.5 13-14.4 20L268.9 185.5c1.9-2.6 3.1-5.9 3.1-9.5c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-40 0-73.1 29.3-79 67.6l-41-32.1zM400 424.9L388.7 416 240 416l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-7.1zM152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-2-3.7-4.2-7.5-6.5-11.2L152.4 229.8z',
  ],
};
const faHouseBlank = {
  prefix: 'far',
  iconName: 'house-blank',
  icon: [
    576,
    512,
    ['home-blank'],
    'e487',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8L464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 464 204.8z',
  ],
};
const faHomeBlank = faHouseBlank;
const faSquare5 = {
  prefix: 'far',
  iconName: 'square-5',
  icon: [
    448,
    512,
    [],
    'e25a',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 32l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z',
  ],
};
const faSquareHeart = {
  prefix: 'far',
  iconName: 'square-heart',
  icon: [
    448,
    512,
    [128159, 'heart-square'],
    'f4c8',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM335.7 265.6l-91.5 92.9c-5.6 5.7-13 8.5-20.3 8.5c-7.3 0-14.6-2.9-20.1-8.5l-91.5-92.9c-26.4-26.8-26.4-70.4 0-97.2s69.3-26.8 95.8 0l16 16.2 16-16.2c26.4-26.8 69.3-26.8 95.8 0s26.4 70.4 0 97.2z',
  ],
};
const faHeartSquare = faSquareHeart;
const faPuzzle = {
  prefix: 'far',
  iconName: 'puzzle',
  icon: [
    512,
    512,
    [],
    'e443',
    'M448 0c35.3 0 64 28.7 64 64l0 128c0 8.8-7.2 16-16 16l-52 0c-6.6 0-12 5.4-12 12l0 4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16L448 0zM0 240L0 128C0 92.7 28.7 64 64 64l144 0c8.8 0 16 7.2 16 16l0 52c0 6.6 5.4 12 12 12l4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-4 0c-6.6 0-12 5.4-12 12l0 52c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16l-32 0 0 152c0 13.3 10.7 24 24 24l152 0 0-36c0-6.6-5.4-12-12-12l-4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0c6.6 0 12-5.4 12-12l0-36c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 144c0 35.3-28.7 64-64 64l-128 0-16 0L72 512c-39.8 0-72-32.2-72-72L0 272l0-32z',
  ],
};
const faUserGear = {
  prefix: 'far',
  iconName: 'user-gear',
  icon: [
    640,
    512,
    ['user-cog'],
    'f4fe',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l287.3 0c3.3 4.2 6.7 8.2 10.3 12c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-3.6 2.3-7 5.1-9.9 8.4c-14.4-5.5-30.1-8.5-46.5-8.5l-91.4 0c-65.7 0-120.1 48.7-129 112zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z',
  ],
};
const faUserCog = faUserGear;
const faPipeCircleCheck = {
  prefix: 'far',
  iconName: 'pipe-circle-check',
  icon: [
    640,
    512,
    [],
    'e436',
    'M24 96c13.3 0 24 10.7 24 24l0 8 272 0 144 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 40.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-18.9-144 0L48 176l0 160 274.9 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L48 384l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32L0 152l0-32c0-13.3 10.7-24 24-24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z',
  ],
};
const faArrowUp19 = {
  prefix: 'far',
  iconName: 'arrow-up-1-9',
  icon: [
    576,
    512,
    ['sort-numeric-up'],
    'f163',
    'M456 56l0 120 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-86.7-16.4 5.5C379 99 365.4 92.2 361.2 79.6S363.8 53.4 376.4 49.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM424 304a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM406.1 430.2c-40-8.3-70.1-43.7-70.1-86.2c0-48.6 39.4-88 88-88s88 39.4 88 88c0 21.1-7.3 41.5-20.6 57.8l-56.8 69.4c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l8.7-10.6z',
  ],
};
const faSortNumericUp = faArrowUp19;
const faOctagonExclamation = {
  prefix: 'far',
  iconName: 'octagon-exclamation',
  icon: [
    512,
    512,
    [],
    'e204',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faDialLow = {
  prefix: 'far',
  iconName: 'dial-low',
  icon: [
    576,
    512,
    [],
    'e15d',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 336c-53.6 0-98.4-37.7-109.4-88L288 312c13.3 0 24-10.7 24-24s-10.7-24-24-24l-109.4 0c11-50.3 55.8-88 109.4-88c61.9 0 112 50.1 112 112s-50.1 112-112 112zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm448 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faDoorClosed = {
  prefix: 'far',
  iconName: 'door-closed',
  icon: [
    576,
    512,
    [128682],
    'f52a',
    'M416 48c8.8 0 16 7.2 16 16l0 400-288 0 0-400c0-8.8 7.2-16 16-16l256 0zm64 416l0-400c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 400-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 48 0 288 0 48 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
  ],
};
const faLaptopMobile = {
  prefix: 'far',
  iconName: 'laptop-mobile',
  icon: [
    640,
    512,
    ['phone-laptop'],
    'f87a',
    'M128 48l320 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 256-48 0c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l304 0 0-64-240 0 0-256c0-8.8 7.2-16 16-16zM384 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 288zm208 0l-160 0 0-288 160 0 0 288z',
  ],
};
const faPhoneLaptop = faLaptopMobile;
const faConveyorBeltBoxes = {
  prefix: 'far',
  iconName: 'conveyor-belt-boxes',
  icon: [
    640,
    512,
    ['conveyor-belt-alt'],
    'f46f',
    'M304 48l0 160-160 0 0-160 160 0zM144 0C117.5 0 96 21.5 96 48l0 160c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L144 0zM528 112l0 96-96 0 0-96 96 0zM432 64c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l416 0zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l416 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-416 0zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faConveyorBeltAlt = faConveyorBeltBoxes;
const faShieldVirus = {
  prefix: 'far',
  iconName: 'shield-virus',
  icon: [
    512,
    512,
    [],
    'e06c',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 96c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faStarfighterTwinIonEngineAdvanced = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [
    640,
    512,
    ['starfighter-alt-advanced'],
    'e28e',
    'M118.5 7.6c9-9.7 24.2-10.2 33.9-1.2s10.2 24.2 1.2 33.9L50.2 151.2c-1.4 1.5-2.2 3.4-2.2 5.5L48 195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195l0-38.4c0-2-.8-4-2.2-5.5L486.5 40.4c-9-9.7-8.5-24.9 1.2-33.9s24.9-8.5 33.9 1.2L624.9 118.4c9.7 10.4 15.1 24 15.1 38.2l0 47.5 0 19.9 0 64 0 19.9 0 47.5c0 14.2-5.4 27.8-15.1 38.2L521.5 504.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9L589.8 360.8c1.4-1.5 2.2-3.4 2.2-5.5l0-38.4L454.1 343.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317l0 38.4c0 2 .8 4 2.2 5.5L153.5 471.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2L15.1 393.6C5.4 383.2 0 369.6 0 355.4l0-47.5L0 288l0-64 0-19.9 0-47.5c0-14.2 5.4-27.8 15.1-38.2L118.5 7.6zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9l0 24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22 0-24.3-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2l0-32.5zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1l-32.5 0c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1l32.5 0zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7l0-32.5c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7l0 32.5zM430.9 272l-32.5 0c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1zm-32.5-32l32.5 0c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1zM336 145.1l0 32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2zM352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2l-.5 0c-8.7 .1-16.5 3.6-22.2 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32s32-14.3 32-32z',
  ],
};
const faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
const faDiceSix = {
  prefix: 'far',
  iconName: 'dice-six',
  icon: [
    448,
    512,
    [9861],
    'f526',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faStarfighterTwinIonEngine = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine',
  icon: [
    576,
    512,
    ['starfighter-alt'],
    'e038',
    'M24 32c13.3 0 24 10.7 24 24l0 137.7 105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7 528 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 149 0 19 0 64 0 19 0 149c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.7L422.2 343.2C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 307l0-19 0-64 0-19L0 56C0 42.7 10.7 32 24 32zM444.7 288.6L528 269l0-26-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6zM48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243l0 26zm224 97.9l0-32.5c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-73.7-43.8l23-23c-5.6-8.4-9.6-17.9-11.7-28.1l-32.5 0c2.7 19 10.2 36.4 21.2 51.1zM177.1 240l32.5 0c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm43.8-73.7l23 23c8.4-5.6 17.9-9.6 28.1-11.7l0-32.5c-19 2.7-36.4 10.2-51.1 21.2zM355.1 345.7l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7l0 32.5c19-2.7 36.4-10.2 51.1-21.2zm22.6-22.6c11-14.7 18.4-32.1 21.2-51.1l-32.5 0c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1l32.5 0c-2.7-19-10.2-36.4-21.2-51.1l-23 23zm.3-45.6c-14.7-11-32.1-18.4-51.1-21.2l0 32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23zM310.6 278.6c5.8-5.8 9.4-13.8 9.4-22.6c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2l-.5 0c-8.7 .1-16.5 3.6-22.3 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4z',
  ],
};
const faStarfighterAlt = faStarfighterTwinIonEngine;
const faRocketLaunch = {
  prefix: 'far',
  iconName: 'rocket-launch',
  icon: [
    512,
    512,
    [128640],
    'e027',
    'M197.9 253.9c12.9 6.4 24.7 14.8 35 25.2s18.8 22.2 25.2 35c105.8-30 156.7-79.5 181.5-126c25-46.8 27.3-97.6 22-137.7c-40.1-5.3-90.9-3-137.7 22c-46.5 24.8-96 75.8-126 181.5zM384 312.1l0 82.2c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.2 0C281.7-3.8 408.8-8.5 483.9 5.3c11.6 2.1 20.7 11.2 22.8 22.8c13.8 75.1 9.1 202.2-122.7 284zM28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5C132.3 504.3 66 511 28.3 511.9zm50.2-64.5c12.8-.7 31.2-3.7 41.3-13.7c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9zM328 144a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z',
  ],
};
const faMosquitoNet = {
  prefix: 'far',
  iconName: 'mosquito-net',
  icon: [
    640,
    512,
    [],
    'e52c',
    'M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4l0-23.1L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5l0-22.6c0-14.9 10.1-27.3 23.8-31l0-43.3c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2l0 43.3c13.7 3.6 23.8 16.1 23.8 31l0 22.6 45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-13.3 0-25.3 5.4-34 14.1l-11.7-1.7 7.5 6.5c-3.4 4.5-6.1 9.6-7.8 15.2c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35 0 23.1 32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6l0 50c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM105.2 310c.8-.8 1.6-1.5 2.4-2.3l82-71.4L78.5 252.9c-.4 .1-.8 .1-1.1 .2C60.6 255.2 48 269.5 48 286.3c0 29.8 36.1 44.8 57.2 23.7zM512 256c8.8 0 16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16zm16 112l48 0 0-48-48 0 0 48zm0 80l48 0 0-48-48 0 0 48zM448 320l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0z',
  ],
};
const faFileFragment = {
  prefix: 'far',
  iconName: 'file-fragment',
  icon: [
    384,
    512,
    [],
    'e697',
    'M320 464l-96 0 0 48 96 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 288l48 0L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM48 464l0-96 96 0 0 96-96 0zM0 352L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L32 320c-17.7 0-32 14.3-32 32z',
  ],
};
const faVentDamper = {
  prefix: 'far',
  iconName: 'vent-damper',
  icon: [
    640,
    512,
    [],
    'e465',
    'M512 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-384 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM128 64c-35.3 0-64 28.7-64 64l0 32-32 0c-17.7 0-32 14.3-32 32L0 320c0 17.7 14.3 32 32 32l32 0 0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0 0-32c0-35.3-28.7-64-64-64L128 64zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z',
  ],
};
const faBridgeWater = {
  prefix: 'far',
  iconName: 'bridge-water',
  icon: [
    576,
    512,
    [],
    'e4ce',
    'M48 112l0 50.8c45.9 10.9 80 52.2 80 101.5l0 96.7c-14.8-8.5-32-10.6-48-6.5l0-90.2C80 233.2 54.8 208 23.7 208C10.6 208 0 197.4 0 184.3L0 96C0 78.3 14.3 64 32 64l512 0c17.7 0 32 14.3 32 32l0 88.3c0 13.1-10.6 23.7-23.7 23.7c-31.1 0-56.3 25.2-56.3 56.3l0 90.2c-16-4.1-33.2-2-48 6.6l0-96.7c0-49.2 34.1-90.5 80-101.5l0-50.8L48 112zM192 384.5c-5.2 0-10.5-.6-16-1.7L176 272c0-61.9 50.1-112 112-112s112 50.1 112 112l0 110.8c-5.5 1.1-10.8 1.7-16 1.7c-10.4 0-21.3-2.2-32-6.1L352 272c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 106.4c-10.3 3.8-21.1 6.1-32 6.1zm-80.1 13.6c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faBanBug = {
  prefix: 'far',
  iconName: 'ban-bug',
  icon: [
    512,
    512,
    ['debug'],
    'f7f9',
    'M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm78.9-163c.2-1.1 .3-2.1 .5-3.2l29.5 5.9c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7 0-18.6 35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-21.6 0-41.2 8.6-55.6 22.5L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L334.9 301zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z',
  ],
};
const faDebug = faBanBug;
const faPersonBooth = {
  prefix: 'far',
  iconName: 'person-booth',
  icon: [
    576,
    512,
    [],
    'f756',
    'M299.2 48l75.1 191.2c2.7 6.8 2.1 14.4-1.5 20.7L316.8 358c-3.1 5.5-4.8 11.7-4.8 18c0 13.3 10.7 24 24 24c8.3 0 15.7-4.2 20-10.7c4.4-6.7 11.9-10.7 20-10.7s15.5 4 20 10.7c4.3 6.5 11.7 10.7 20 10.7c8.6 0 16.2-4.5 20.5-11.5c4.3-6.9 11.8-11.2 19.9-11.4s15.8 3.8 20.4 10.5c5.1 7.5 13.6 12.3 23.2 12.3c13.2 0 24.3-9.2 27.3-21.5c.2-.9 .5-1.7 .7-2.5l0-3.9 0-316c0-4.4-3.6-8-8-8L299.2 48zM528 442.7c-8.7 3.4-18.1 5.3-28 5.3c-15.8 0-30.5-4.8-42.6-13.1c-11.7 8.2-26 13.1-41.4 13.1c-14.8 0-28.6-4.5-40-12.1c-11.4 7.7-25.2 12.1-40 12.1c-39.8 0-72-32.2-72-72c0-14.7 3.8-29.1 11.1-41.8l50.4-88.1L247.6 48c-4.3 .2-7.6 3.7-7.6 8l0 152-48 0 0-152c0-30.9 25.1-56 56-56l16 0L520 0c30.9 0 56 25.1 56 56l0 316 0 12 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-45.3zM192 320l48 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168zM64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM61.2 208c-7.3 0-13.2 5.9-13.2 13.2l0 42.2 0 .6 0 13c.1 1.7 .7 3.4 1.8 4.7L72 309l0-99.1c-3.4-1.2-7.1-1.9-10.8-1.9zM0 276.6l0-55.4C0 187.4 27.4 160 61.2 160c24.2 0 47.2 11 62.3 29.9l40 50.1 52.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56.3 0c-12.2 0-23.6-5.5-31.2-15L120 262.4l0 105.7 23 28.4c5.8 7.1 9 16 9 25.2l0 66.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-63.5L48 355.6 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 277.5l0-.9z',
  ],
};
const faTextWidth = {
  prefix: 'far',
  iconName: 'text-width',
  icon: [
    448,
    512,
    [],
    'f035',
    'M48 112l0-32 152 0 0 160-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-160 152 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24zM441 401c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L81.9 360l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 284.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64z',
  ],
};
const faGarageCar = {
  prefix: 'far',
  iconName: 'garage-car',
  icon: [
    640,
    512,
    [],
    'e00a',
    'M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240l0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-352 0zm127.9 85.9l-7 26.1L375 352l-7.5-26.2c-1-3.4-4.1-5.8-7.7-5.8l-80.2 0c-3.6 0-6.8 2.4-7.7 5.9zm-59.7 37l4.6-17.2 8.7-32.3c6.6-24.4 28.8-41.4 54.1-41.4l80.2 0c25 0 47 16.6 53.8 40.6l9.4 32.8 5.1 17.8C445 374.7 456 394.1 456 416l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-176 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-22.1 11.2-41.5 28.2-53zM408 416c0-8.8-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16l0 16 176 0 0-16z',
  ],
};
const faSquareKanban = {
  prefix: 'far',
  iconName: 'square-kanban',
  icon: [
    448,
    512,
    [],
    'e488',
    'M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 288c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176zm-72-72c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24z',
  ],
};
const faHatWizard = {
  prefix: 'far',
  iconName: 'hat-wizard',
  icon: [
    512,
    512,
    [],
    'f6e8',
    'M327.7 227.6c-5.1-11.5-7.7-23.9-7.7-36.5c0-10.1 1.7-20.1 5-29.7l27.7-79.1-98.3 56.2c-26.6 15.2-47.7 38.5-60.1 66.5L100.5 416 48 416 150.4 185.5c16.6-37.4 44.7-68.4 80.2-88.7L376.9 13.2c0 0 .1 0 .1 0l2.1-1.2 16.6-9.5C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19l0 1.5c0 2.3-.4 4.6-1.2 6.8l-5 14.2-1.5 4.2-.1 .3-46 131.3c-1.6 4.4-2.4 9.1-2.4 13.8c0 5.9 1.2 11.7 3.6 17l-43.9 19.5zm43.9-19.5L464 416l-52.5 0L327.7 227.6l43.9-19.5zM246.2 416l-44.4 0-6.5-19.4-40.4-13.5C148.4 381 144 374.9 144 368s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5L246.2 416zM0 480c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM264 168c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z',
  ],
};
const faChartKanban = {
  prefix: 'far',
  iconName: 'chart-kanban',
  icon: [
    448,
    512,
    [],
    'e64f',
    'M368 432l0-352 32 0 0 352-32 0zm-48 0c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 352zM80 368l-32 0L48 80l32 0 0 288zM48 416l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48zM240 240l-32 0 0-160 32 0 0 160zm-32 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48z',
  ],
};
const faPenFancy = {
  prefix: 'far',
  iconName: 'pen-fancy',
  icon: [
    512,
    512,
    [128395, 10002],
    'f5ac',
    'M399.4 59.9c7.1-7.6 17-11.9 27.3-11.9C447.3 48 464 64.7 464 85.3c0 10.4-4.3 20.2-11.9 27.3l-195.5 182-39.2-39.2 182-195.5zM426.7 0C403 0 380.4 9.8 364.2 27.2L170.8 234.9 97.2 257.6c-22.8 7-40.6 24.9-47.6 47.6L1.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l22.6-73.6L484.8 147.8C502.2 131.6 512 109 512 85.3C512 38.2 473.8 0 426.7 0zM228.8 334.8l-20.3 65.9c-2.3 7.6-8.3 13.5-15.9 15.9L85 449.7 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L62.3 427 95.5 319.3c2.3-7.6 8.3-13.5 15.9-15.9l65.9-20.3 51.6 51.6z',
  ],
};
const faCoffeePot = {
  prefix: 'far',
  iconName: 'coffee-pot',
  icon: [
    512,
    512,
    [],
    'e002',
    'M88 80c-22.1 0-40 17.9-40 40l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80C0 71.4 39.4 32 88 32l34.4 0L192 32l261.6 0C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9l0 8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480L158 480c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344l0-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80 88 80zm296.8 80l35.6-80L192 80l-36.4 0 35.6 80 193.6 0zm1.2 48L190 208c-41.8 21.6-71.7 63.1-77.1 112l350.2 0c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224l-260.5 0 .2 0L418 432l.2 0z',
  ],
};
const faMouseField = {
  prefix: 'far',
  iconName: 'mouse-field',
  icon: [
    512,
    512,
    [],
    'e5a8',
    'M393.4 50.8C397.9 49 402.8 48 408 48c22.1 0 40 17.9 40 40c0 8.1-2.4 15.6-6.5 21.9c-10.4-5.3-21.7-9.1-33.6-11.4c-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88c-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0C246.6 0 200 46.6 200 104l0 3.2c0 21.2 6.4 41.3 17.7 58.1C143.2 184.4 88 252 88 332.6c0 12.7 2.8 24.7 7.9 35.4L72 368c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l99.4 0L344 416l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-47.8 0 32-80 79.8 0c30.9 0 56-25.1 56-56l0-7.7c0-32.6-12.2-62.4-32.4-85.1zM292.6 368l-121.1 0c-19.6 0-35.4-15.9-35.4-35.4C136 263.8 191.8 208 260.6 208l19.4 0c11.4 0 21.2-8 23.5-19.2s-3.6-22.4-14.1-26.9l-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5l0-3.2c0-30.9 25.1-56 56-56s56 25.1 56 56l0 16c0 12.5 9.7 23 22.2 23.9l8 .6c41.7 3.2 73.9 38 73.9 79.8l0 7.7c0 4.4-3.6 8-8 8l-96 0c-9.8 0-18.6 6-22.3 15.1L292.6 368zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z',
  ],
};
const faPersonDigging = {
  prefix: 'far',
  iconName: 'person-digging',
  icon: [
    576,
    512,
    ['digging'],
    'f85e',
    'M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440.8 288c8.2 .3 15.7 4.7 19.8 11.8l104 176c4.4 7.4 4.5 16.6 .2 24.1s-12.2 12.1-20.8 12.1l-256 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l16-48c3.3-9.8 12.4-16.4 22.8-16.4l35.4 0 20.3-29.5L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4s19.1-18 31.4-12.9L61 210.1l19.8-36.2C96.2 145.6 125.8 128 158 128l3.8 0c52.3 0 98.5 33.8 114.4 83.6l32.3 101.6 79 32.9 32.8-47.7c4.6-6.8 12.4-10.7 20.6-10.4zm-190.4 1l-20-62.8c-9.5-29.9-37.3-50.2-68.6-50.2l-3.8 0c-14.6 0-28.1 8-35.1 20.8l-17.3 31.8L250.4 289zm188.1 67.6l-66.7 97L364.6 464l137.3 0L438.5 356.6zM81.4 301.1l128 54.4c8.9 3.8 14.6 12.5 14.6 22.1L224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.5L87.5 355.9 47 494.7c-3.7 12.7-17 20-29.8 16.3S-2.7 494 1 481.3L49 316.5l7.6-25.9 24.9 10.6z',
  ],
};
const faDigging = faPersonDigging;
const faShowerDown = {
  prefix: 'far',
  iconName: 'shower-down',
  icon: [
    384,
    512,
    ['shower-alt'],
    'e24d',
    'M192 0c13.3 0 24 10.7 24 24l0 9.8c77 11.6 136 78 136 158.2l0 16 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 256l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-16C32 111.8 91 45.4 168 33.8l0-9.8c0-13.3 10.7-24 24-24zM80 208l224 0 0-16c0-61.9-50.1-112-112-112S80 130.1 80 192l0 16zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm109.8 42.4l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zm64 128l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zm82.2-170.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1z',
  ],
};
const faShowerAlt = faShowerDown;
const faBoxCircleCheck = {
  prefix: 'far',
  iconName: 'box-circle-check',
  icon: [
    576,
    512,
    [],
    'e0c4',
    'M342.4 80c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80 94.4 0zM48 208l310.6 0c22.3-10.3 47.2-16 73.4-16c5.4 0 10.7 .2 16 .7l0-3.1c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16l0-208zm11.6-48L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80L59.6 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faBrightness = {
  prefix: 'far',
  iconName: 'brightness',
  icon: [
    512,
    512,
    [],
    'e0c9',
    'M232 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM0 256c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24zm424-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM256 512c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24zM75 75c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM391.8 357.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3zM75 437c9.4 9.4 24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9zM357.8 120.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3z',
  ],
};
const faCarSideBolt = {
  prefix: 'far',
  iconName: 'car-side-bolt',
  icon: [
    640,
    512,
    [],
    'e344',
    'M134.2 105.1L99.4 192l28.6 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 96 21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l21.5 0 0-32c0-44.2-35.8-80-80-80l-96 0 0-48 46.1 0L384.5 95c-7.6-9.5-19.1-15-31.2-15L171.3 80c-16.4 0-31.1 10-37.1 25.1zM46.8 194.3l42.8-107C103 53.9 135.3 32 171.3 32l181.9 0c26.7 0 52 12.2 68.7 33L524 192.6c65.1 6 116 60.8 116 127.4l0 48c0 17.7-14.3 32-32 32l-33.3 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-130.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80L32 400c-17.7 0-32-14.3-32-32L0 256c0-29.4 19.8-54.2 46.8-61.7zM434.7 400a48 48 0 1 0 90.5-32 48 48 0 1 0 -90.5 32zM208 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208 192 208c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z',
  ],
};
const faFileXml = {
  prefix: 'far',
  iconName: 'file-xml',
  icon: [
    512,
    512,
    [],
    'e654',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm128-96c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 496l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM299.7 352.6c6.9-1.9 14.3 1 18 7.2L352 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-2.9-13.7-7.8L320 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4z',
  ],
};
const faOrnament = {
  prefix: 'far',
  iconName: 'ornament',
  icon: [
    384,
    512,
    [],
    'f7b8',
    'M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32L128 96c-17.7 0-32 14.3-32 32l0 25.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-25.7c0-17.7-14.3-32-32-32l-8.6 0zM192 176c42.6 0 81 18.5 107.3 48L84.7 224c26.4-29.5 64.7-48 107.3-48zM56.2 272l271.6 0c5.3 15 8.2 31.2 8.2 48s-2.9 33-8.2 48L56.2 368c-5.3-15-8.2-31.2-8.2-48s2.9-33 8.2-48zM84.7 416l214.7 0C273 445.5 234.6 464 192 464s-81-18.5-107.3-48z',
  ],
};
const faPhoneArrowDownLeft = {
  prefix: 'far',
  iconName: 'phone-arrow-down-left',
  icon: [
    512,
    512,
    ['phone-arrow-down', 'phone-incoming'],
    'e223',
    'M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM505 41l-135 135 54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faPhoneArrowDown = faPhoneArrowDownLeft;
const faPhoneIncoming = faPhoneArrowDownLeft;
const faCloudWord = {
  prefix: 'far',
  iconName: 'cloud-word',
  icon: [
    640,
    512,
    [],
    'e138',
    'M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8zM512 368c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0zM128 304c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm272-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faHandFingersCrossed = {
  prefix: 'far',
  iconName: 'hand-fingers-crossed',
  icon: [
    384,
    512,
    [],
    'e1a3',
    'M169.8 57.6c3.7-8 13.3-11.5 21.3-7.7s11.5 13.3 7.7 21.3L120 240l-35.3 0 55.7-119.5c1-1.7 1.9-3.5 2.5-5.3l26.8-57.6zM126.3 37.3l-6.5 14C102.9 24.1 68 13.1 38.3 27C6.3 41.9-7.6 80 7.3 112l42.1 90.2L22 261c-.9 2-1.5 4-1.9 6C7.6 281.1 0 299.7 0 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.4 0-10.7 .7-15.7 1.9l18-38.5c14.9-32 1.1-70.1-31-85.1s-70.1-1.1-85.1 31zM50.8 91.7c-3.7-8-.3-17.5 7.7-21.3s17.5-.3 21.3 7.7l13.7 29.3L75.9 145.4l-25-53.7zM240 176c8.8 0 16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm0 128c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2zm96-48l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32z',
  ],
};
const faTrash = {
  prefix: 'far',
  iconName: 'trash',
  icon: [
    448,
    512,
    [],
    'f1f8',
    'M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z',
  ],
};
const faGaugeSimple = {
  prefix: 'far',
  iconName: 'gauge-simple',
  icon: [
    512,
    512,
    ['gauge-simple-med', 'tachometer-average'],
    'f629',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 181.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56z',
  ],
};
const faGaugeSimpleMed = faGaugeSimple;
const faTachometerAverage = faGaugeSimple;
const faArrowDownSmallBig = {
  prefix: 'far',
  iconName: 'arrow-down-small-big',
  icon: [
    576,
    512,
    ['sort-size-down-alt'],
    'f88d',
    'M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L136 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 342.1 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 144l64 0 0-64-64 0 0 64zm-48 0l0-64c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48zm48 160l0 128 128 0 0-128-128 0zm-48 0c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128z',
  ],
};
const faSortSizeDownAlt = faArrowDownSmallBig;
const faBookMedical = {
  prefix: 'far',
  iconName: 'book-medical',
  icon: [
    448,
    512,
    [],
    'f7e6',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM208 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faFaceMelting = {
  prefix: 'far',
  iconName: 'face-melting',
  icon: [
    640,
    512,
    [129760],
    'e483',
    'M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93c16.7 33.4 12.5 72.2-.1 100.7c-2.1 4.7-4.6 9.5-7.6 14.4l193.7 0c0 0 .1 0 .1 0c0 0 0 0 0 0s0 0 0 0c0 0 .1 0 .1 0l164 0c-2.7-7.5-4.1-15.6-4.1-24c0-32.6 21.6-60.1 51.3-69c-10.9-20.5-14.2-44.9-9.1-66.1c3.8-15.6 5.8-32 5.8-48.9zm40.9 60.1c-6 24.8 11.1 51.9 36.6 51.9c0 0 0 0 0 0l10.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-10.5 0s0 0 0 0L552 416c-13.3 0-24 10.7-24 24s10.7 24 24 24s24 10.7 24 24s-10.7 24-24 24l-231.9 0-.1 0-.1 0L46.6 512 24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.6 0c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 20.7-2.5 40.8-7.1 60.1zm-305.1-158a32 32 0 1 1 -16.6 61.8 32 32 0 1 1 16.6-61.8zm115.4 64A32 32 0 1 1 441 238.7a32 32 0 1 1 -61.8-16.6zM220.4 279.9c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1c11-7.4 25.9-4.6 33.3 6.4s4.6 25.9-6.4 33.3c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86c-5.8-11.9-.8-26.3 11.1-32.1s26.3-.8 32.1 11.1z',
  ],
};
const faPoo = {
  prefix: 'far',
  iconName: 'poo',
  icon: [
    512,
    512,
    [128169],
    'f2fe',
    'M224 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l7.4 7.4c6.1 6.1 9.5 14.4 9.5 23l0 3.2c0 16.2-13.1 29.3-29.3 29.3L180 104l-3.1 0c-6.1 0-12.1 .8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 1.1 0 2.2 .1 3.3C47.1 221.3 24 253.9 24 292c0 14.3 3.3 27.8 9.1 39.9C12.8 350.9 0 377.9 0 408c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104c0-30.1-12.8-57.1-33.1-76.1c5.8-12.1 9.1-25.6 9.1-39.9c0-38.1-23.1-70.7-56.1-84.7c0-1.1 .1-2.2 .1-3.3c0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0l-8 0zm48 71.4c0-5.5-.6-10.9-1.6-16.1c33.8 13.4 58.9 44 64.5 81c1.3 8.6 7.2 15.9 15.3 18.9C370 162.6 384 181.7 384 204c0 4.9-.7 9.7-1.9 14.1c-1.9 6.7-.8 13.9 3 19.7s10 9.7 16.9 10.6c21.5 2.9 38 21.3 38 43.6c0 11.4-4.3 21.8-11.4 29.6c-5 5.4-7.1 12.9-5.9 20.1s5.7 13.6 12.2 17.1c17.4 9.5 29.2 28 29.2 49.2c0 30.9-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56c0-21.2 11.7-39.7 29.2-49.2c6.5-3.5 10.9-9.8 12.2-17.1s-1-14.7-5.9-20.1C76.3 313.8 72 303.4 72 292c0-22.3 16.6-40.7 38-43.6c6.9-.9 13-4.8 16.9-10.6s4.9-13 3-19.7c-1.3-4.5-1.9-9.2-1.9-14.1c0-25.1 17.8-46 41.4-50.9c.4-.1 .8-.2 1.2-.3c2-.5 4.1-.8 6.3-.8l3.1 0 14.7 0c42.7 0 77.3-34.6 77.3-77.3l0-3.2zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM172.3 352c-6.8 0-12.3 5.5-12.3 12.3c0 2.4 .7 4.8 2.2 6.7c8.2 10.5 39.5 45 93.8 45s85.6-34.6 93.8-45c1.5-1.9 2.2-4.3 2.2-6.7c0-6.8-5.5-12.3-12.3-12.3l-167.4 0z',
  ],
};
const faPenClipSlash = {
  prefix: 'far',
  iconName: 'pen-clip-slash',
  icon: [
    640,
    512,
    ['pen-alt-slash'],
    'e20f',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L384 62.1 370.9 49c-28.1-28.1-73.7-28.1-101.8 0l-76.6 76.6L38.8 5.1zM230.5 155.4L303 82.9c9.4-9.4 24.6-9.4 33.9 0L350.1 96l-85.8 85.8-33.7-26.4zm71.8 56.2L384 129.9 446.1 192l-74.2 74.2-69.6-54.5zM197.5 316.5l36.3-36.3-38-29.9-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-38-29.9-43.6 43.6c-38.8 38.8-87.5 66-140.7 78.6c12.7-53.2 39.9-101.9 78.6-140.7z',
  ],
};
const faPenAltSlash = faPenClipSlash;
const faQuoteRight = {
  prefix: 'far',
  iconName: 'quote-right',
  icon: [
    448,
    512,
    [8221, 'quote-right-alt'],
    'f10e',
    'M448 296c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-48-72l0-32 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16zM64 240l64 0c8.8 0 16-7.2 16-16l0-32 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16zm128-48l0 32 0 72c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32z',
  ],
};
const faQuoteRightAlt = faQuoteRight;
const faScrollOld = {
  prefix: 'far',
  iconName: 'scroll-old',
  icon: [
    576,
    512,
    [],
    'f70f',
    'M80 80c-17.7 0-32 14.3-32 32l0 48 32 0 0 48-32 0c-26.5 0-48-21.5-48-48l0-48C0 67.8 35.8 32 80 32l320 0c44.2 0 80 35.8 80 80l0 160-32 0-16 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-80-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-16c0-17.7-14.3-32-32-32L153.3 80c4.3 9.8 6.7 20.6 6.7 32l0 112 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5 21.5-48 48-48l.6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0c26.5 0 48 21.5 48 48l0 48c0 44.2-35.8 80-80 80l-304 0c-44.2 0-80-35.8-80-80l0-288c0-17.7-14.3-32-32-32zM265.3 432L496 432c17.7 0 32-14.3 32-32l0-48s0 0 0 0l-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0s0 0 0 0l0 48c0 11.4-2.4 22.2-6.7 32z',
  ],
};
const faGuitars = {
  prefix: 'far',
  iconName: 'guitars',
  icon: [
    512,
    512,
    [],
    'f8bf',
    'M152 178l0-44.4 19.8-39.6c2.8-5.6 4.2-11.7 4.2-17.9L176 24c0-13.3-10.7-24-24-24L104 0C90.7 0 80 10.7 80 24l0 52.2c0 6.2 1.4 12.3 4.2 17.9L104 133.7l0 44.4c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-8.4-14.7-13.4-31.7-13.8-49.7c-13.1 12.9-34.3 23.2-64 23.2c-54 0-80-33.9-80-56c0-9.7 3.7-19.8 12.4-29.3c26.2-29 26.4-71.9 7.8-101.2c-3-4.8-4.2-9.2-4.2-13.5c0-9.6 11.2-29.7 40-37.1l0 85.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-85.1c28.8 7.4 40 27.5 40 37.1c0 4.2-1.2 8.7-4.2 13.5c-18.6 29.4-18.4 72.2 7.8 101.2c2.5 2.7 4.6 5.5 6.3 8.4c4.1-11.5 8.8-22.1 12.9-31.2c0 0 0 0 0 0l1-2.3c3.3-7.4 6.1-13.9 8.5-19.7c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.3l-.4-1.3c-3.5-10-8.5-24.7-9.2-40.9c-.1-1.3-.1-2.5-.1-3.8l0-12.9 0-10.1c-15.8-15.7-38.2-27.1-64-31.5zm170.6-53.9L344 148.6l0 91.4c-23.7 0-38.6-8.8-48-19.8c-2.5-2.9-4.6-6-6.3-9.1c-3.7-6.6-6-13.3-7.4-19.1l0-.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16l0 8 0 19.6 0 12.9c0 .8 0 1.7 .1 2.5c.5 11.5 4.2 22.3 7.9 33.1c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8l140.4 0c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8c0 0 0 0 0 0c3.3-8.9 6.6-17.8 7.6-27.2c.2-1.9 .3-3.8 .3-5.7l0-1.6 0-13.6 0-14c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5l-.2 .5c-1.9 4.5-4.7 9.4-9.1 14c-1 1.1-2.1 2.1-3.2 3.1c-9.4 8.3-24.3 14.9-48 14.9l0-165.9c9.6-6.4 16-17.3 16-29.7l0-4.6C408 17.8 390.2 0 368.2 0c-18.8 0-35 13.1-38.9 31.5L315.4 96.3c-2.1 9.9 .6 20.2 7.2 27.8zM344 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm81.9-99.7c-1.1 6.1-1.9 12.8-1.9 19.7c0 30.7 13.5 60.6 22.2 80c0 0 0 0 0 0c.7 1.5 1.4 3 2 4.4c10.7 24 15.8 38 15.8 49.8c0 14.2-11.6 25.8-25.8 25.8l-140.4 0c-14.2 0-25.8-11.6-25.8-25.8c0-11.9 5.2-25.8 15.8-49.8c.6-1.4 1.3-2.9 2-4.4c0 0 0 0 0 0c8.7-19.4 22.2-49.2 22.2-80c0-7.2-.8-14.1-1.9-20.5c10.4 2.9 21.7 4.5 33.9 4.5l48 0c12.1 0 23.4-1.3 33.9-3.7z',
  ],
};
const faPhoneXmark = {
  prefix: 'far',
  iconName: 'phone-xmark',
  icon: [
    576,
    512,
    [],
    'e227',
    'M361 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C207.2 485.6 32 295.2 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zm133.8 78.1l-100.4-43L365 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L80.1 70.5C83.5 286.2 257.8 460.5 473.5 464l21.3-99.2zM375 7c9.4-9.4 24.6-9.4 33.9 0l47 47L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L375 41c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faHose = {
  prefix: 'far',
  iconName: 'hose',
  icon: [
    448,
    512,
    [],
    'e419',
    'M312 128c13.3 0 24-10.7 24-24l0-2.3 80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3l0-2.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24zM8 488c0 13.3 10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464c-13.3 0-24 10.7-24 24zM32 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 384zM8 328c0 13.3 10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 304c-13.3 0-24 10.7-24 24zM56 156c0-37.6 30.4-68 68-68l132 0 0-48L124 40C59.9 40 8 91.9 8 156s51.9 116 116 116l292 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-292 0c-37.6 0-68-30.4-68-68z',
  ],
};
const faClockSix = {
  prefix: 'far',
  iconName: 'clock-six',
  icon: [
    512,
    512,
    [],
    'e352',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faShirt = {
  prefix: 'far',
  iconName: 'shirt',
  icon: [
    640,
    512,
    [128085, 't-shirt', 'tshirt'],
    'f553',
    'M146.3 27.8C167.9 9.8 195.1 0 223.2 0c18.2 0 31.1 13.6 34 28.5C263 57.8 288.9 80 320 80s57-22.2 62.8-51.5C385.7 13.6 398.7 0 416.8 0c28.1 0 55.3 9.8 76.8 27.8L478.3 46.3l15.4-18.4L619.8 133c11.6 9.7 18.8 23.6 20 38.6s-3.7 29.9-13.7 41.3l-56 64c-20 22.9-54.6 25.6-78 6.1L480 272.9 480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-175.1L147.9 283c-23.4 19.5-58 16.7-78-6.1l-56-64C3.9 201.5-1 186.6 .2 171.6s8.4-29 20-38.6L146.3 27.8zm66.5 20.9c-13.1 1.9-25.5 7.4-35.8 15.9L50.9 169.9c-1.7 1.4-2.7 3.4-2.9 5.5s.5 4.3 2 5.9L31.9 197.1 50 181.3l56 64c2.9 3.3 7.8 3.7 11.1 .9l51.5-42.9c7.2-6 17.1-7.2 25.5-3.3s13.8 12.4 13.8 21.7L208 448c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-226.3c0-9.3 5.4-17.8 13.8-21.7s18.4-2.7 25.5 3.3l51.5 42.9c3.3 2.8 8.3 2.4 11.1-.9l56-64c1.4-1.6 2.1-3.7 2-5.9s-1.2-4.1-2.9-5.5L462.9 64.7c-10.3-8.6-22.7-14.1-35.8-15.9C413.1 94.6 370.5 128 320 128s-93.1-33.4-107.1-79.3z',
  ],
};
const faTShirt = faShirt;
const faTshirt = faShirt;
const faBillboard = {
  prefix: 'far',
  iconName: 'billboard',
  icon: [
    640,
    512,
    [],
    'e5cd',
    'M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L248 32l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L80 32C53.5 32 32 53.5 32 80l0 272-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 216 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 216 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-272c0-26.5-21.5-48-48-48L440 32l0-8zM320 352L80 352 80 80l120 0 0 48-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 144 0 0 48-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 120 0 0 272-240 0z',
  ],
};
const faSquareR = {
  prefix: 'far',
  iconName: 'square-r',
  icon: [
    448,
    512,
    [],
    'e27c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24zm80 112l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64 56 0z',
  ],
};
const faCubes = {
  prefix: 'far',
  iconName: 'cubes',
  icon: [
    576,
    512,
    [],
    'f1b3',
    'M290.7 48.3c-1.7-.6-3.6-.6-5.4 0l-81.2 29L288 109.5l83.9-32.1-81.2-29zM176 207.2l88 31.4 0-86.9-88-33.7 0 89.3zm136 31.4l88-31.4 0-89.3-88 33.7 0 86.9zM448 93l0 114.6 91.9 34.8c21.8 8.2 36.1 29.1 36.1 52.4l0 119.1c0 22.2-13.1 42.3-33.5 51.3l-96.4 42.4c-14 6.1-29.8 6.3-43.9 .5L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5L33.5 465.1C13.1 456.2 0 436.1 0 413.9L0 294.7c0-23.3 14.4-44.1 36.1-52.4L128 207.5 128 93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1C433.1 48.2 448 69.3 448 93zM264 320.2l-88 33.7 0 101.3 88-36.4 0-98.6zM52.8 421.2L128 454.3l0-100.4L48 323.2l0 90.7c0 3.2 1.9 6 4.8 7.3zM400 455.1l0-101.3-88-33.7 0 98.6 88 36.4zm48-.9l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3l0-90.7-80 30.7 0 100.4zM155 250.7c-1.8-.6-3.7-.6-5.5 .1L70.8 280.6 152 311.7l83.9-32.1L155 250.7zm266 0l-80.9 28.9L424 311.7l81.2-31.1-78.7-29.8c-1.8-.7-3.7-.7-5.5-.1z',
  ],
};
const faEnvelopeOpenDollar = {
  prefix: 'far',
  iconName: 'envelope-open-dollar',
  icon: [
    512,
    512,
    [],
    'f657',
    'M120 48c-4.4 0-8 3.6-8 8l0 169.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2 400 56c0-4.4-3.6-8-8-8L120 48zM48 276.2L48 456c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-179.8L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9L512 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 237.9zM276 88l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z',
  ],
};
const faDivide = {
  prefix: 'far',
  iconName: 'divide',
  icon: [
    448,
    512,
    [10135, 247],
    'f529',
    'M264 96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm0 320a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM408 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0z',
  ],
};
const faSunCloud = {
  prefix: 'far',
  iconName: 'sun-cloud',
  icon: [
    640,
    512,
    [127780],
    'f763',
    'M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-16.9 0-32.8-4.4-46.6-12.1l-2.1 11.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-13.3 19.3c9.6-2.7 19.7-4.1 30.1-4.1c9.8 0 19.4 1.3 28.5 3.7l15.3-22.1c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c11.4 0 22.3-1.7 32.6-4.8c-.4-3.7-.6-7.4-.6-11.2c0-21.4 7-41.2 18.8-57.1C295.1 310.1 276.7 320 256 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 14.2-4.6 27.3-12.4 37.9c13.2-17.3 32.1-30 54-35.3c1.8-4 3.8-8 6.1-11.7C363 189.3 314.8 144 256 144zM384 416l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z',
  ],
};
const faLampFloor = {
  prefix: 'far',
  iconName: 'lamp-floor',
  icon: [
    384,
    512,
    [],
    'e015',
    'M55.6 176l272.7 0L277.2 48 106.8 48 55.6 176zM66.3 20.1C71.1 8 82.9 0 96 0L288 0c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1L32 224c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM88 464l80 0 0-208 48 0 0 208 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0L88 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faSquare7 = {
  prefix: 'far',
  iconName: 'square-7',
  icon: [
    448,
    512,
    [],
    'e25c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faTengeSign = {
  prefix: 'far',
  iconName: 'tenge-sign',
  icon: [
    384,
    512,
    [8376, 'tenge'],
    'f7d7',
    'M0 56C0 42.7 10.7 32 24 32l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM0 184c0-13.3 10.7-24 24-24l168 0 168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0 0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248L24 208c-13.3 0-24-10.7-24-24z',
  ],
};
const faTenge = faTengeSign;
const faHeadphones = {
  prefix: 'far',
  iconName: 'headphones',
  icon: [
    512,
    512,
    [127911],
    'f025',
    'M49.6 262C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c-9.4-3.9-19.6-6-30.4-6c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80l0-32 0-32 0-48C512 146.6 397.4 32 256 32S0 146.6 0 288l0 48 0 32 0 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48c-10.8 0-21 2.1-30.4 6zM48 336c0-17.7 14.3-32 32-32l0 128c-17.7 0-32-14.3-32-32l0-32 0-32zm416 0l0 32 0 32c0 17.7-14.3 32-32 32l0-128c17.7 0 32 14.3 32 32z',
  ],
};
const faHandsHolding = {
  prefix: 'far',
  iconName: 'hands-holding',
  icon: [
    640,
    512,
    [],
    'f4c2',
    'M72 64c39.8 0 72 32.2 72 72l0 128.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8L496 136c0-39.8 32.2-72 72-72s72 32.2 72 72l0 216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9L592 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9c0 0 0 0 0 0L473 393c0 0 0 0 0 0l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16c0 0 0 0 0 0l26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8l0 51.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359s0 0 0 0l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16c0 0 0 0 0 0l-26.7-26.7s0 0 0 0l-15.9-15.9C106.2 332.1 96 307.5 96 281.9L96 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2L0 136C0 96.2 32.2 64 72 64z',
  ],
};
const faCampfire = {
  prefix: 'far',
  iconName: 'campfire',
  icon: [
    512,
    512,
    [],
    'f6ba',
    'M279.1 43.9L262.1 25.8c-1.8-1.9-3.6-4-5.4-6.1c0 0 0 0 0 0C248.6 10.4 239.9 .3 227.2 0c-6.5-.2-13.1 2.1-18.3 6.8c-21.1 19.2-45 44.4-63.8 72.9c-18.7 28.3-33.1 61-33.1 95C112 255.2 175.4 320 256 320c79.8 0 144-64.7 144-145.3c0-27.3-9.9-55.4-23.6-80.1C362.7 69.7 344.7 47 326.9 30.4c-5-4.7-11.5-7.1-17.9-7.1c-6.8 0-14 2.5-18.8 8.1l-11 12.5zm36.5 174.4c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-33.2 33.7-66.4 49.8-80.4c4.9-4.2 11.9-4.2 16.8 0c16.1 14 49.8 47.2 49.8 80.4zM32.5 289.6c-12.4-4.7-26.3 1.5-31 13.9s1.5 26.2 13.9 31L188.3 400 15.5 465.6c-12.4 4.7-18.6 18.6-13.9 31s18.6 18.6 31 13.9L256 425.7l223.5 84.8c12.4 4.7 26.3-1.5 31-13.9s-1.5-26.2-13.9-31L323.7 400l172.8-65.6c12.4-4.7 18.6-18.6 13.9-31s-18.6-18.6-31-13.9L256 374.3 32.5 289.6z',
  ],
};
const faCircleAmpersand = {
  prefix: 'far',
  iconName: 'circle-ampersand',
  icon: [
    512,
    512,
    [],
    'e0f8',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0-8.6 7-15.6 15.6-15.6l19.2 0c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11zm71 46.9c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2l-19.2 0c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5l32.2 0c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7L287 238.5zm-87.5 64.1l30.7-22.5 40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8l-32.2 0c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9z',
  ],
};
const faSnowflakes = {
  prefix: 'far',
  iconName: 'snowflakes',
  icon: [
    640,
    512,
    [],
    'f7cf',
    'M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faHandsClapping = {
  prefix: 'far',
  iconName: 'hands-clapping',
  icon: [
    512,
    512,
    [],
    'e1a8',
    'M328 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM223.1 18.7c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2zM412 152c9.5-5.1 20.4-8 32-8c37.6 0 68 30.4 68 68l0 117.6c0 100.5-81.3 182-181.7 182.4c27.3-16.9 50.5-39.8 67.8-66.8c39.4-23.4 65.8-66.4 65.8-115.6L464 212c0-11-9-20-20-20c-5 0-9.6 1.9-13.1 4.9c-2.5-16.7-9.2-32-18.9-44.9zM410.7 23.1c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48zM320 208l0 40c0 3.3-.6 6.4-1.8 9.2s-2.9 5.5-5.2 7.8s-5 4-7.8 5.2s-5.9 1.8-9.2 1.8s-6.4-.6-9.2-1.8s-5.5-2.9-7.8-5.2L169 154.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7L233 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L121 202.9l-32-32c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l24 24L185 295c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L65 242.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l48 48s0 0 0 0L137 343c1.2 1.2 2.2 2.4 3.1 3.8c6.2 9.3 5.1 22-3.1 30.2c-9.4 9.4-24.6 9.4-33.9 0L65 338.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l22 22s0 0 0 0l16 16s0 0 0 0l33.6 33.6c25.2 25.2 59.4 39.4 95 39.4C291.8 464 352 403.8 352 329.6L352 208c0-8.8-7.2-16-16-16s-16 7.2-16 16zM113.9 129.6c10.4-15.4 28.1-25.6 48.1-25.6c15.4 0 30.1 6.1 41 17L274 192.1c7.1-27.6 32.2-48.1 62-48.1c35.3 0 64 28.7 64 64l0 121.6C400 430.3 318.3 512 217.6 512c-48.4 0-94.8-19.2-129-53.4L55 425s0 0 0 0L39 409s0 0 0 0l-22-22C6.1 376 0 361.3 0 345.9c0-19.6 9.7-36.9 24.6-47.4L17 290.9C6.1 280 0 265.3 0 249.9c0-21.2 11.4-39.8 28.4-49.9c-2.9-7-4.4-14.5-4.4-22.1c0-32 25.9-57.9 57.9-57.9c11.4 0 22.5 3.4 31.9 9.6z',
  ],
};
const faRepublican = {
  prefix: 'far',
  iconName: 'republican',
  icon: [
    640,
    512,
    [],
    'f75e',
    'M152 32C68.1 32 0 100.1 0 184l0 80L0 424c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-40 160 0 0 40c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-40 48 0 0 24c0 39.8 32.2 72 72 72s72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48 0-96 0-80c0-83.9-68.1-152-152-152L152 32zM496 288l0 48-72 0c-13.3 0-24 10.7-24 24l0 64c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-64c0-13.3-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24l0 64c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-136 448 0zm0-48L48 240l0-56C48 126.6 94.6 80 152 80l240 0c57.4 0 104 46.6 104 104l0 56zM405.7 115.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L450 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM271.9 112c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-122.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L194 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6z',
  ],
};
const faLeafMaple = {
  prefix: 'far',
  iconName: 'leaf-maple',
  icon: [
    512,
    512,
    [127809],
    'f6f6',
    'M344.8 13.3c-3.7-7.4-11-12.4-19.3-13.2s-16.4 2.8-21.4 9.5L249.9 82l-2.1-16.1c-.9-7-4.8-13.2-10.7-17.1s-13.2-4.9-19.9-2.9L181.8 56.4 147 15.9c-4.6-5.3-11.2-8.4-18.2-8.4s-13.7 3.1-18.2 8.4L74 58.5 27 52.6c-7.9-1-15.8 2-21 8S-1.2 74.7 .8 82.4L41.4 238 10.7 258.5c-7 4.6-11 12.6-10.7 20.9s5 15.9 12.3 20l106.9 59.4L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L153.2 392.8l59.4 106.9c4.1 7.3 11.6 12 20 12.3s16.3-3.7 20.9-10.7L274 470.6l155.6 40.6c7.7 2 15.9 .1 21.9-5.2s9-13.1 8-21l-5.4-42.8c-.3-2.7 .7-5.3 2.7-7.1l39.3-33.7c5.3-4.6 8.4-11.2 8.4-18.2s-3.1-13.7-8.4-18.2l-40.6-34.8 10.5-35.4c2-6.8 .9-14-2.9-19.9s-10.1-9.8-17.1-10.7L430 262.1l72.4-54.3c6.7-5 10.2-13.1 9.5-21.4s-5.7-15.6-13.2-19.3l-36.1-18.1c-3.4-1.7-5.2-5.7-4.1-9.4l22.6-79.2c2.4-8.4 .1-17.4-6.1-23.6s-15.2-8.5-23.6-6.1L372.2 53.5c-3.7 1.1-7.6-.7-9.4-4.1L344.8 13.3zM188.5 357.5L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L154.5 323.5 70.1 276.6l2.7-1.8c14.2-9.5 20.8-26.9 16.5-43.4L56.2 104.6l24.7 3.1c8 1 16-2.1 21.2-8.2l26.7-31.1 26.7 31.1c6.2 7.2 16 10.1 25.1 7.4l23.2-6.9 6 46.8c1.2 9.7 8.2 17.7 17.7 20.2s19.5-1 25.3-8.8l66.5-88.7 .7 1.4C332 95 359.5 107.1 385.4 99.7l37.7-10.8-10.8 37.7c-7.4 25.9 4.7 53.4 28.8 65.5l1.4 .7-88.7 66.5c-7.8 5.9-11.3 15.9-8.8 25.3s10.5 16.4 20.2 17.7l46.8 6-6.9 23.2c-2.7 9.1 .2 18.9 7.4 25.1l31.1 26.7-18.1 15.5c-14.3 12.2-21.5 30.8-19.1 49.5l1 7.7L280.6 422.8c-16.5-4.3-33.9 2.3-43.4 16.5l-1.8 2.7-46.9-84.5z',
  ],
};
const faArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-left',
  icon: [
    448,
    512,
    [8592],
    'f060',
    'M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z',
  ],
};
const faPersonCircleXmark = {
  prefix: 'far',
  iconName: 'person-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e543',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z',
  ],
};
const faRuler = {
  prefix: 'far',
  iconName: 'ruler',
  icon: [
    512,
    512,
    [128207],
    'f545',
    'M63.2 379.3c-6.2-6.2-6.2-16.4 0-22.6l39.4-39.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 39.4-39.4c6.2-6.2 16.4-6.2 22.6 0l69.5 69.5c6.2 6.2 6.2 16.4 0 22.6L155.3 448.8c-6.2 6.2-16.4 6.2-22.6 0L63.2 379.3zM98.7 482.7c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z',
  ],
};
const faArrowLeftFromBracket = {
  prefix: 'far',
  iconName: 'arrow-left-from-bracket',
  icon: [
    512,
    512,
    [],
    'e668',
    'M7 273c-9.4-9.4-9.4-24.6 0-33.9L135 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L328 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 280l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 273zM344 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c22.1 0 40-17.9 40-40l0-272c0-22.1-17.9-40-40-40l-80 0z',
  ],
};
const faCupStrawSwoosh = {
  prefix: 'far',
  iconName: 'cup-straw-swoosh',
  icon: [
    384,
    512,
    [],
    'e364',
    'M249.3 0L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.7 0c-3.7 0-6.9 2.6-7.8 6.2L224.2 128l79.6 0 48.2 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-12 0-48.2 0-89.9 0-35.8 0-89.9 0L36 176l-12 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 48.2 0 94.7 0 20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L38.7 208l48.2 0L99.7 362.4c15.7-3.1 27.5-7.3 36.9-11.9c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7c16-8.6 35.4-15.1 59.8-18.9l3-36 48.2 0L323.7 468c-2.1 24.9-22.9 44-47.8 44l-167.7 0c-25 0-45.8-19.1-47.8-44zM290 293.5c-14.1 3.1-24.6 7.1-32.9 11.6c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5 167.7 0L290 293.5z',
  ],
};
const faTemperatureSun = {
  prefix: 'far',
  iconName: 'temperature-sun',
  icon: [
    640,
    512,
    ['temperature-hot'],
    'f76a',
    'M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-35-8.3-53.7c0-37.7 11.8-72.6 32-101.2L320 112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6L400 112zM464 0C402.1 0 352 50.2 352 112l0 161.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L576 112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L480 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z',
  ],
};
const faTemperatureHot = faTemperatureSun;
const faAlignLeft = {
  prefix: 'far',
  iconName: 'align-left',
  icon: [
    448,
    512,
    [],
    'f036',
    'M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z',
  ],
};
const faDiceD6 = {
  prefix: 'far',
  iconName: 'dice-d6',
  icon: [
    448,
    512,
    [],
    'f6d1',
    'M243.9 7.7c-12.4-7-27.6-6.9-39.9 .3L19.8 115.6C7.5 122.8 0 135.9 0 150.1L0 366.6c0 14.5 7.8 27.8 20.5 34.9l184 103c12.1 6.8 26.9 6.8 39.1 0l184-103c12.6-7.1 20.5-20.4 20.5-34.9l0-219.9c0-14.4-7.7-27.7-20.3-34.8L243.9 7.7zM71.8 140.8L224.2 51.7l152 86.2L223.8 228.2l-152-87.4zM48 182.4l152 87.4 0 177.2L48 361.9l0-179.5zM248 447.1l0-177.4 152-90.1 0 182.4L248 447.1z',
  ],
};
const faRestroom = {
  prefix: 'far',
  iconName: 'restroom',
  icon: [
    640,
    512,
    [],
    'f7bd',
    'M128 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-7.3 80l14.6 0c3 0 5.9 .3 8.7 1l0 127-32 0 0-127c2.8-.6 5.7-1 8.7-1zM112 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236.6 17.6 45.3c4.8 12.4 18.7 18.5 31.1 13.7s18.5-18.7 13.7-31.1l-37-95.2c-13.2-33.8-45.7-56.1-82-56.1l-14.6 0c-36.3 0-68.9 22.3-82 56.1L1.6 279.3c-4.8 12.4 1.3 26.3 13.7 31.1s26.3-1.3 31.1-13.7L64 251.4 64 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM320 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM560 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 80c-40.7 0-77.2 25-92 62.9l-34.4 88.4c-4.8 12.4 1.3 26.3 13.7 31.1c7.6 3 15.8 1.8 22.1-2.5l-15.7 55.8c-2.9 10.2 4.8 20.3 15.4 20.3l26.9 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.9 0c10.6 0 18.3-10.1 15.4-20.3l-15.7-55.8c6.3 4.2 14.5 5.4 22.1 2.5c12.4-4.8 18.5-18.7 13.7-31.1L604 190.9C589.2 153 552.7 128 512 128zm0 48c2.2 0 4 1.4 4.6 3.5l44 156.5-97.3 0 44-156.5c.6-2.1 2.5-3.5 4.6-3.5z',
  ],
};
const faHighDefinition = {
  prefix: 'far',
  iconName: 'high-definition',
  icon: [
    576,
    512,
    ['rectangle-hd'],
    'e1ae',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 184l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96 32 0zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 64 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-64 0 0-48z',
  ],
};
const faRectangleHd = faHighDefinition;
const faJ = {
  prefix: 'far',
  iconName: 'j',
  icon: [
    320,
    512,
    [106],
    '4a',
    'M296 32c13.3 0 24 10.7 24 24l0 264c0 88.4-71.6 160-160 160S0 408.4 0 320l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 61.9 50.1 112 112 112s112-50.1 112-112l0-264c0-13.3 10.7-24 24-24z',
  ],
};
const faGalaxy = {
  prefix: 'far',
  iconName: 'galaxy',
  icon: [
    512,
    512,
    [],
    'e008',
    'M160 184c0-68.3 50.4-124.9 116.1-134.5c-31.2 28.4-51.6 66.6-58 108.1c-1.4 9.3 2.7 18.6 10.6 23.7s18.1 5.2 26 .1C275.9 167.8 301 160 328 160c68.3 0 124.9 50.4 134.6 116.1c-28.4-31.2-66.6-51.6-108.1-58c-9.3-1.4-18.6 2.7-23.7 10.6s-5.2 18.1-.1 26C344.2 275.9 352 301 352 328c0 68.3-50.4 124.9-116.1 134.5c31.2-28.4 51.6-66.6 58-108.1c1.4-9.3-2.7-18.6-10.6-23.7s-18.1-5.2-26-.1C236.1 344.2 211 352 184 352c-68.3 0-124.9-50.4-134.5-116.1c28.4 31.2 66.6 51.6 108.1 58c9.3 1.4 18.6-2.7 23.7-10.6s5.2-18.1 .1-26C167.8 236.1 160 211 160 184zM296 0C194.4 0 112 82.4 112 184c0 15.9 2 31.3 5.8 46c-16.4-9.4-30.8-22.2-42.2-37.9l-13-17.9c-6.5-9-16.9-14.2-28-14.2C15.5 160 0 175.5 0 194.6L0 216C0 317.6 82.4 400 184 400c15.9 0 31.3-2 46-5.8c-9.4 16.4-22.2 30.8-37.9 42.2l-17.9 13c-9 6.5-14.2 16.9-14.2 28c0 19.1 15.5 34.6 34.6 34.6l21.4 0c101.6 0 184-82.4 184-184c0-15.9-2-31.3-5.8-46c16.4 9.4 30.8 22.2 42.2 37.9l13 17.9c6.5 9 16.9 14.2 28 14.2c19.1 0 34.6-15.5 34.6-34.6l0-21.4c0-101.6-82.4-184-184-184c-15.9 0-31.3 2-46 5.8c9.4-16.4 22.2-30.8 37.9-42.2l17.9-13-14-19.3 14 19.3c9-6.5 14.2-16.9 14.2-28C352 15.5 336.5 0 317.4 0L296 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faUsersViewfinder = {
  prefix: 'far',
  iconName: 'users-viewfinder',
  icon: [
    640,
    512,
    [],
    'e595',
    'M48 48l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 32C0 14.3 14.3 0 32 0L136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L48 48zm544 0l-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24L608 0c17.7 0 32 14.3 32 32l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88zM136 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 512c-17.7 0-32-14.3-32-32L0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0zm456 0l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 17.7-14.3 32-32 32l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2l32 0 32 0c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32l-64 0c-20.9 0-38.7 13.4-45.3 32l154.5 0zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3l69.3 0c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8l-46.6 0C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2l69.3 0c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7l-46.6 0zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faFileVideo = {
  prefix: 'far',
  iconName: 'file-video',
  icon: [
    384,
    512,
    [],
    'f1c8',
    'M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 16 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z',
  ],
};
const faCherries = {
  prefix: 'far',
  iconName: 'cherries',
  icon: [
    640,
    512,
    [],
    'e0ec',
    'M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7c16.3 14.8 30.1 35.3 37.4 63c1.8 1 3.3 2 4.6 2.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-12.3 0-36.6-3.4-61.7-13.4c-9.2 14.8-20.2 27.5-32.3 38.2C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 24zM162.4 293.8c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5c6.1-3.6 12.7-5.6 18-6.6c2.6-.5 4.6-.7 5.7-.8c.3 0 .6 0 .7-.1c18.7 .1 35.4 5.5 48 11.4c6.2 2.9 11.1 5.8 14.2 7.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3z',
  ],
};
const faUpRightFromSquare = {
  prefix: 'far',
  iconName: 'up-right-from-square',
  icon: [
    512,
    512,
    ['external-link-alt'],
    'f35d',
    'M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41l0-127c0-22.1-17.9-40-40-40L345 0c-22.6 0-41 18.3-41 41zm57.9 7L464 48l0 102.1L361.9 48zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z',
  ],
};
const faExternalLinkAlt = faUpRightFromSquare;
const faCircleSort = {
  prefix: 'far',
  iconName: 'circle-sort',
  icon: [
    512,
    512,
    ['sort-circle'],
    'e030',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM244.7 411.3l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z',
  ],
};
const faSortCircle = faCircleSort;
const faTableCells = {
  prefix: 'far',
  iconName: 'table-cells',
  icon: [
    512,
    512,
    ['th'],
    'f00a',
    'M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l88 0c8.8 0 16-7.2 16-16l0-72-104 0 0 88zM464 296l0-80-104 0 0 80 104 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 296l112 0 0-80-112 0 0 80z',
  ],
};
const faTh = faTableCells;
const faBagShoppingMinus = {
  prefix: 'far',
  iconName: 'bag-shopping-minus',
  icon: [
    448,
    512,
    [],
    'e650',
    'M224 48c35.3 0 64 28.7 64 64l0 48-128 0 0-48c0-35.3 28.7-64 64-64zM112 112l0 48-64 0c-26.5 0-48 21.5-48 48L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112zM48 208l352 0 0 208c0 26.5-21.5 48-48 48L96 464c-26.5 0-48-21.5-48-48l0-208zm96 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0z',
  ],
};
const faFilePdf = {
  prefix: 'far',
  iconName: 'file-pdf',
  icon: [
    512,
    512,
    [],
    'f1c1',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z',
  ],
};
const faSiren = {
  prefix: 'far',
  iconName: 'siren',
  icon: [
    448,
    512,
    [],
    'e02d',
    'M345.6 304l48.4 0L375 152.1C371 120 343.8 96 311.5 96l-175 0C104.2 96 77 120 73 152.1L54 304l48.4 0 18.2-146c1-8 7.8-14 15.9-14l175 0c8.1 0 14.9 6 15.9 14l18.2 146zm-165.5 0l11.8-94c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-12.2 98 32.2 0zM48 384l352 0 0 48L48 432l0-48zM0 384l0 48c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48L48 336c-26.5 0-48 21.5-48 48z',
  ],
};
const faArrowUpToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a1',
    'M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM241.5 151.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 228.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z',
  ],
};
const faImageLandscape = {
  prefix: 'far',
  iconName: 'image-landscape',
  icon: [
    576,
    512,
    ['landscape'],
    'e1b5',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l19.8 0 80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L232.8 330l83.1-127.1c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L485 400l27 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM96 448l-32 0c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-40 0-200 0-72 0L96 448zm64-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faLandscape = faImageLandscape;
const faTankWater = {
  prefix: 'far',
  iconName: 'tank-water',
  icon: [
    448,
    512,
    [],
    'e452',
    'M277.2 80L263.9 55.7 251 32l133 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l133 0L184.1 55.7 170.8 80 64 80c-8.8 0-16 7.2-16 16l0 206.4c14.1-2.7 27.8-8.7 39.3-15.3c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c11.6 6.6 25.2 12.5 39.4 15.3L400 96c0-8.8-7.2-16-16-16L277.2 80zM48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-65c-25-3.1-47.1-13-63.1-22.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-16 9.1-38.1 19-63 22.1l0 65zM212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5l0 1.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-1.4c0-9.6 2.4-19 7-27.5L212.2 71z',
  ],
};
const faCurlingStone = {
  prefix: 'far',
  iconName: 'curling-stone',
  icon: [
    576,
    512,
    [129356, 'curling'],
    'f44a',
    'M264 80c-22.1 0-40 17.9-40 40l0 24 192 0c35.3 0 64 28.7 64 64l0 1.1c54.3 7.8 96 54.4 96 110.9l0 48c0 61.9-50.1 112-112 112l-352 0C50.1 480 0 429.9 0 368l0-48c0-56.4 41.7-103.1 96-110.9l0-1.1c0-35.3 28.7-64 64-64l16 0 0-24c0-48.6 39.4-88 88-88l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L264 80zM112 432l352 0c35.3 0 64-28.7 64-64L48 368c0 35.3 28.7 64 64 64zM48 320l480 0c0-35.3-28.7-64-64-64l-352 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faCurling = faCurlingStone;
const faGamepadModern = {
  prefix: 'far',
  iconName: 'gamepad-modern',
  icon: [
    640,
    512,
    [127918, 63676, 'gamepad-alt'],
    'e5a2',
    'M216 336l208 0c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3c33 0 59.8-26.8 59.8-59.8l0-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9C109.4 107.6 87.8 132 81.6 168L48.9 358.8c-.6 3.5-.9 7-.9 10.6l0 2.8c0 33 26.8 59.8 59.8 59.8c27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384l-208 0-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2l0-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7l0 2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faGamepadAlt = faGamepadModern;
const faMessagesQuestion = {
  prefix: 'far',
  iconName: 'messages-question',
  icon: [
    640,
    512,
    [],
    'e1e7',
    'M72 48C58.7 48 48 58.7 48 72l0 176c0 13.3 10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 19.2L202.7 276c3.9-2.6 8.6-4 13.3-4l128 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24L72 48zM0 72C0 32.2 32.2 0 72 0L344 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-120.7 0-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360l0-40-24 0c-39.8 0-72-32.2-72-72L0 72zM256 352l48 0 0 24c0 13.3 10.7 24 24 24l96 0c4.7 0 9.4 1.4 13.3 4L496 443.2l0-19.2c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-120 0 0-48 120 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-24 0 0 40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60L328 448c-39.8 0-72-32.2-72-72l0-24zM147.9 96.1c5.5-15.4 20.1-25.7 36.4-25.7l41.3 0c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 165.4l0 .3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7l-41.3 0c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 228a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z',
  ],
};
const faBookBible = {
  prefix: 'far',
  iconName: 'book-bible',
  icon: [
    448,
    512,
    ['bible'],
    'f647',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM208 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faBible = faBookBible;
const faO = {
  prefix: 'far',
  iconName: 'o',
  icon: [
    448,
    512,
    [111],
    '4f',
    'M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z',
  ],
};
const faSuitcaseMedical = {
  prefix: 'far',
  iconName: 'suitcase-medical',
  icon: [
    512,
    512,
    ['medkit'],
    'f0fa',
    'M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm240 88l0 288-224 0 0-288 8 0 208 0 8 0zM96 144l0 288-32 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0zM416 432l0-288 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-32 0zM229.3 224l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faMedkit = faSuitcaseMedical;
const faBriefcaseArrowRight = {
  prefix: 'far',
  iconName: 'briefcase-arrow-right',
  icon: [
    512,
    512,
    [],
    'e2f2',
    'M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm24 88l208 0 88 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l88 0zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L152 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l150.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
  ],
};
const faExpandWide = {
  prefix: 'far',
  iconName: 'expand-wide',
  icon: [
    512,
    512,
    [],
    'f320',
    'M136 64c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64l112 0zM0 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24L0 312zM488 64c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zM464 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0 0-88z',
  ],
};
const faClockElevenThirty = {
  prefix: 'far',
  iconName: 'clock-eleven-thirty',
  icon: [
    512,
    512,
    [],
    'e348',
    'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-128.7-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
  ],
};
const faRv = {
  prefix: 'far',
  iconName: 'rv',
  icon: [
    640,
    512,
    [],
    'f7be',
    'M224 24c0-13.3 10.7-24 24-24L360 0c13.3 0 24 10.7 24 24l0 8 136 0c48.6 0 88 39.4 88 88l0 40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5l0 96.2c0 22.1-17.9 40-40 40l-25.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16l-9.6 0-153.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1c-1.3-.8-2.4-1.8-3.5-2.9L21.1 335C7.6 321.5 0 303.2 0 284.1L0 104C0 64.2 32.2 32 72 32l152 0 0-8zM72 80c-13.3 0-24 10.7-24 24l0 180.1c0 6.4 2.5 12.5 7 17L121.9 368l6.1 0c13.4-10 30-16 48-16s34.6 6 48 16l160 0 0-112 0-72c0-13.3 10.7-24 24-24l16 0 80 0 56 0 0-40c0-22.1-17.9-40-40-40L72 80zM556.8 256l-61.1-48L432 208l0 48 124.8 0zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM120 128l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faUserSecret = {
  prefix: 'far',
  iconName: 'user-secret',
  icon: [
    448,
    512,
    [128373],
    'f21b',
    'M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 13.4 22.1 25.6 57.7 34.3C88.6 169.4 88 176.6 88 184c0 13.9 2.1 27.4 6 40l-48.6 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512L168 512l112 0 138.3 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4L354 224c3.9-12.6 6-26.1 6-40c0-7.4-.6-14.6-1.7-21.7c35.6-8.7 57.7-20.9 57.7-34.3c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44 448l-24.8-99.1c-2.1-8.2-.8-16.9 3.6-24.2l15.7-26.2c25.7-7.6 48.3-22.6 65.2-42.5l23.8 0-19.8 49.5c-8.1 20.2-1.6 43.3 15.9 56.3c27.3 20.4 46.2 51 51.2 86.2L268 464zM185.5 314.5l15.7 26.2c4.4 7.3 5.7 16 3.6 24.2L180 464 49.3 464c4.9-35.2 23.9-65.8 51.2-86.2c17.4-13 23.9-36.1 15.9-56.3L96.5 272l23.8 0c16.9 19.9 39.5 34.9 65.2 42.5zM224 272c-38.2 0-70.7-24.4-82.9-58.4c7.1 6.5 16.5 10.4 26.9 10.4l12.4 0c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2l12.4 0c10.4 0 19.8-3.9 26.9-10.4c-12.2 34-44.7 58.4-82.9 58.4z',
  ],
};
const faOtter = {
  prefix: 'far',
  iconName: 'otter',
  icon: [
    640,
    512,
    [129446],
    'f700',
    'M135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185zM160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-5.1 0-10.1-.4-14.9-1.2c9.5 28.6 36.5 49.2 68.3 49.2l64 0c13.3 0 24 10.7 24 24c0 2.8-.5 5.5-1.4 8L352 336c0-11.4 2.4-22.2 6.7-32L328 304c-36.7 0-68.1-22.4-81.3-54.3c-10.3 4.1-21.5 6.3-33.3 6.3c-14.1 0-27.9-3.3-40.5-9.6L160 240zm250.8 16c10.8-45.9 52-80 101.2-80c13.3 0 24 10.7 24 24l0-5.7c0-38.8-24.9-73.3-61.7-85.6l-17.9-6c-12.1-4-18.9-16.8-15.6-29s15.7-19.8 28.1-17.2l16.2 3.4C575.4 78.9 640 158.5 640 250.8c0 120.3-92.6 218.9-210.4 228.5c-4.5 .5-9 .8-13.6 .8l-5.2 0L384 480l-126.4 0C133 480 32 379 32 254.4l0-37.6c-10.1-14.6-16-32.3-16-51.4L16 144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 8-1 15.7-3 23.1c12.4-7.9 27.2-12.5 43-12.5l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-16.6 0-30.2 12.6-31.8 28.7c4.9 2.1 10.2 3.3 15.8 3.3l82.8 0zM99.7 335.8l.1 .2 .3 0-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5c35.6-4.4 63.1-34.7 63.1-71.5l0-56 0-48 0-26.6c-18.9 9-32 28.3-32 50.6c0 13.3-10.7 24-24 24c-17.7 0-32 14.3-32 32l0 24c0 13.3-10.7 24-24 24l-239.8 0c31.8 29.8 74.5 48 121.4 48L384 432l26.8 0zM536 360c0 8.2-.8 16.3-2.4 24c35.9-33.1 58.4-80.6 58.4-133.3c0-16.7-2.8-32.8-8-47.9l0 5.1c0 35.5-19.3 66.6-48 83.2l0 68.8zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faDreidel = {
  prefix: 'far',
  iconName: 'dreidel',
  icon: [
    448,
    512,
    [],
    'f792',
    'M441 39c9.4 9.4 9.4 24.6 0 33.9L327.6 186.3l67.7 67.7c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7L64 480c-35.3 0-64-28.7-64-64L0 269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l67.7 67.7L407 39c9.4-9.4 24.6-9.4 33.9 0zM106.3 204.3L52.7 257.9c-3 3-4.7 7.1-4.7 11.3L48 416c0 8.8 7.2 16 16 16l146.7 0c4.2 0 8.3-1.7 11.3-4.7l53.7-53.7L106.3 204.3zm33.9-33.9L309.7 339.7 361.4 288 192 118.6l-51.7 51.7z',
  ],
};
const faPersonDress = {
  prefix: 'far',
  iconName: 'person-dress',
  icon: [
    320,
    512,
    ['female'],
    'f182',
    'M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm21.7 185.7l37.4 66.1c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l37.4-66.1L53.7 363.7C50.8 373.9 58.5 384 69.1 384L96 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.9 0c10.6 0 18.3-10.1 15.4-20.3L229.7 233.7zM160 176c2.2 0 4 1.4 4.6 3.5l44 156.5-97.3 0 44-156.5c.6-2.1 2.5-3.5 4.6-3.5z',
  ],
};
const faFemale = faPersonDress;
const faCommentDollar = {
  prefix: 'far',
  iconName: 'comment-dollar',
  icon: [
    512,
    512,
    [],
    'f651',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM276 136c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
  ],
};
const faBusinessTime = {
  prefix: 'far',
  iconName: 'business-time',
  icon: [
    640,
    512,
    ['briefcase-clock'],
    'f64a',
    'M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 32.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-34.9c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0 160 0 8.2 0c-21.9 26.6-36.2 59.7-39.5 96l-.7 0-96 0c-17.7 0-32-14.3-32-32l0-16L48 304l0 112c0 8.8 7.2 16 16 16l268 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
  ],
};
const faBriefcaseClock = faBusinessTime;
const faFlowerTulip = {
  prefix: 'far',
  iconName: 'flower-tulip',
  icon: [
    512,
    512,
    [127799],
    'f801',
    'M273.9 8.1C269.4 2.9 262.9 0 256 0s-13.4 2.9-17.9 8.1L189 63.3 134.7 21.1c-7.2-5.6-17-6.6-25.3-2.6S96 30.8 96 40l0 112c0 75.1 60.9 136 136 136l0 85.4C191 321.4 127.4 288 56 288l-28 0c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512l36 0 48 0 36 0c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28l-28 0c-71.4 0-135 33.4-176 85.4l0-85.4c75.1 0 136-60.9 136-136l0-112c0-9.2-5.2-17.5-13.5-21.6s-18-3-25.3 2.6L323 63.3 273.9 8.1zM280 240l-48 0c-48.6 0-88-39.4-88-88l0-62.9 33.3 25.9c10 7.8 24.3 6.5 32.7-3L256 60.1l46.1 51.8c8.4 9.5 22.7 10.8 32.7 3L368 89.1l0 62.9c0 48.6-39.4 88-88 88zM196 464c-75 0-136.9-55.7-146.7-128l6.7 0c80.6 0 148.5 54.1 169.4 128L196 464zm120 0l-29.4 0c20.9-73.9 88.8-128 169.4-128l6.7 0C452.9 408.3 391 464 316 464z',
  ],
};
const faPeoplePantsSimple = {
  prefix: 'far',
  iconName: 'people-pants-simple',
  icon: [
    512,
    512,
    [],
    'e21a',
    'M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L192 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM329.7 237.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L448 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3z',
  ],
};
const faCloudDrizzle = {
  prefix: 'far',
  iconName: 'cloud-drizzle',
  icon: [
    512,
    512,
    [],
    'f738',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM88 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm168-24c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm-72-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm168-24c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24z',
  ],
};
const faTableCellsLarge = {
  prefix: 'far',
  iconName: 'table-cells-large',
  icon: [
    512,
    512,
    ['th-large'],
    'f009',
    'M280 80l0 152 184 0 0-136c0-8.8-7.2-16-16-16L280 80zm-48 0L64 80c-8.8 0-16 7.2-16 16l0 136 184 0 0-152zM48 280l0 136c0 8.8 7.2 16 16 16l168 0 0-152L48 280zM280 432l168 0c8.8 0 16-7.2 16-16l0-136-184 0 0 152zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faThLarge = faTableCellsLarge;
const faBookTanakh = {
  prefix: 'far',
  iconName: 'book-tanakh',
  icon: [
    448,
    512,
    ['tanakh'],
    'f827',
    'M448 88c0-48.6-39.4-88-88-88L56 0C25.1 0 0 25.1 0 56L0 344c0 22.3 13.1 41.6 32 50.6L32 464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l344 0c44.2 0 80-35.8 80-80c0-2.7-.1-5.4-.4-8l.4 0 0-336zM368 400c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 464l0-64 288 0zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7L56 352c-4.4 0-8-3.6-8-8L48 56c0-4.4 3.6-8 8-8l304 0c22.1 0 40 17.9 40 40l0 270.7zM216 104l13.9 24-27.7 0L216 104zM202.1 80l-27.7 48L119 128c-12.3 0-20 13.3-13.9 24l27.7 48-27.7 48c-6.2 10.7 1.5 24 13.9 24l55.4 0 27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48 55.4 0c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24l-55.4 0L229.9 80c-6.2-10.7-21.6-10.7-27.7 0zm-69.3 72l27.7 0-13.9 24-13.9-24zm55.4 0l55.4 0 27.7 48-27.7 48-55.4 0-27.7-48 27.7-48zm-55.4 96l13.9-24 13.9 24-27.7 0zM216 296l-13.9-24 27.7 0L216 296zm83.1-48l-27.7 0 13.9-24 13.9 24zm0-96l-13.9 24-13.9-24 27.7 0z',
  ],
};
const faTanakh = faBookTanakh;
const faSolarSystem = {
  prefix: 'far',
  iconName: 'solar-system',
  icon: [
    512,
    512,
    [],
    'e02f',
    'M464 256c0 42.1-12.5 81.3-34 114.1c-4.4-1.3-9.1-2.1-14-2.1c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464C141.1 464 48 370.9 48 256c0-42.1 12.5-81.3 34-114.1c4.4 1.3 9.1 2.1 14 2.1c26.5 0 48-21.5 48-48s-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-14.1-9.1-25.1-22.4-31.3-38.2c-26.1 11.8-55 18.3-85.5 18.3zM390.8 169.8c.8-3.1 1.2-6.4 1.2-9.8c0-22.1-17.9-40-40-40c-3.4 0-6.6 .4-9.8 1.2C317.3 105.2 287.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-31.8-9.3-61.3-25.2-86.2zM312 159c0 .3 0 .7 0 1c0 22.1 17.9 40 40 40c.3 0 .7 0 1 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c20.4 0 39.5 5.5 56 15zm-56 81a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faSealQuestion = {
  prefix: 'far',
  iconName: 'seal-question',
  icon: [
    512,
    512,
    [],
    'e243',
    'M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1l64 0 0 64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9l0 64.9-64.9 0c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1L112 400l0-64.9c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9l0-64 64 0zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64l-64 0c-26.5 0-48 21.5-48 48l0 64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1 64 400c0 26.5 21.5 48 48 48l64.9 0 45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448l64.9 0c26.5 0 48-21.5 48-48l0-64.9 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L289.9 17.9zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faPhoneVolume = {
  prefix: 'far',
  iconName: 'phone-volume',
  icon: [
    512,
    512,
    ['volume-control-phone'],
    'f2a0',
    'M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zm73 166.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z',
  ],
};
const faVolumeControlPhone = faPhoneVolume;
const faDiscDrive = {
  prefix: 'far',
  iconName: 'disc-drive',
  icon: [
    512,
    512,
    [],
    'f8b5',
    'M80 96l0 336 352 0 0-336c0-8.8-7.2-16-16-16L96 80c-8.8 0-16 7.2-16 16zm400 0l0 336 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 480l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faHatCowboySide = {
  prefix: 'far',
  iconName: 'hat-cowboy-side',
  icon: [
    640,
    512,
    [],
    'f8c1',
    'M444.8 256l-133.5 0-31.5-25.6c-25-20.3-55-33-86.6-37.1l4.9-63.4c.3-3.6 2.9-6.5 6.4-7.2L412.3 81.2 444.8 256zM560 400l-40 0c0-1.4-.1-2.9-.4-4.4l-26-139.6c10.2 5.4 21.6 12 32.8 19.8C563.6 301.2 592 332.9 592 368c0 17.7-14.3 32-32 32zM498 204.6c-5.9-2.8-11.1-5.1-15.3-6.9l-24.6-132C454.6 46.2 437.6 32 417.7 32c-2.7 0-5.4 .3-8.1 .8L195.1 75.7c-24.6 4.9-42.9 25.6-44.9 50.6L145 194C62.9 206.8 0 277.9 0 363.6l0 18.8C0 418.6 29.4 448 65.6 448L464 448l16 0 80 0c44.2 0 80-35.8 80-80c0-60.9-47.6-105.2-86.4-131.8c-20.3-13.9-40.5-24.5-55.5-31.6zM48 363.6C48 295.3 103.3 240 171.6 240c28.4 0 55.9 9.8 77.9 27.7L412.4 400 65.6 400c-9.7 0-17.6-7.9-17.6-17.6l0-18.8z',
  ],
};
const faTableRows = {
  prefix: 'far',
  iconName: 'table-rows',
  icon: [
    512,
    512,
    ['rows'],
    'e292',
    'M448 432l-320 0 0-152 336 0 0 136c0 8.8-7.2 16-16 16zm16-200l-336 0 0-152 320 0c8.8 0 16 7.2 16 16l0 136zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z',
  ],
};
const faRows = faTableRows;
const faLocationExclamation = {
  prefix: 'far',
  iconName: 'location-exclamation',
  icon: [
    384,
    512,
    ['map-marker-exclamation'],
    'f608',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faMapMarkerExclamation = faLocationExclamation;
const faFaceFearful = {
  prefix: 'far',
  iconName: 'face-fearful',
  icon: [
    512,
    512,
    [],
    'e375',
    'M464 256c0-43.5-13.3-83.9-36.2-117.2l-.1 .2c-6 6.5-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8l-.1-.2C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z',
  ],
};
const faClipboardUser = {
  prefix: 'far',
  iconName: 'clipboard-user',
  icon: [
    384,
    512,
    [],
    'f7f3',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-16 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-16 0c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
  ],
};
const faBusSchool = {
  prefix: 'far',
  iconName: 'bus-school',
  icon: [
    512,
    512,
    [],
    'f5dd',
    'M96 95l0 1 84.3 0c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16L416 96l0-1c0-.4 0-.8-.1-1c0 0 0 0 0-.1C404.2 79.4 363.5 48 256 48C156.9 48 109.6 79.1 96 94.3c0 .2 0 .4 0 .7zm0 49l0 82.8c7.7-1.8 15.7-2.8 24-2.8l112 0 0-80L96 144zm320 82.8l0-82.8-136 0 0 80 112 0c8.3 0 16.3 1 24 2.8zM464 95l0 33 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-13 0c17.9 18.7 29 44.1 29 72l0 56c0 29.8-20.4 54.9-48 62l0 42c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-288 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-42c-27.6-7.1-48-32.2-48-62l0-56c0-27.9 11-53.3 29-72l-13 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-33c0-8.8 2-20.6 10.4-30.6C82.9 35.2 145.9 0 256 0C373.7 0 430.9 35.1 454.3 65c7.7 9.8 9.7 21.1 9.7 30zM112 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM120 272c-30.9 0-56 25.1-56 56l0 56c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-56c0-30.9-25.1-56-56-56l-272 0z',
  ],
};
const faFilmSlash = {
  prefix: 'far',
  iconName: 'film-slash',
  icon: [
    640,
    512,
    [],
    'e179',
    'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L89.5 44.9C100.2 36.8 113.6 32 128 32l384 0c35.3 0 64 28.7 64 64l0 320c0 3.3-.2 6.5-.7 9.6l55.5 43.5c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM176 112.6L176 80l-41.6 0L176 112.6zM328.3 232l87.7 0 0-40 0-112L224 80l0 70.3L328.3 232zM528 388.5l0-44.5-56.8 0L528 388.5zM416 423.8L487.4 480 128 480c-35.3 0-64-28.7-64-64l0-269.6L152.3 216 112 216l0 80 64 0 0-61.3L233.5 280l-9.5 0 0 40 0 112 192 0 0-8.2zM176 344l-64 0 0 72c0 8.8 7.2 16 16 16l48 0 0-88zM464 80l0 88 64 0 0-72c0-8.8-7.2-16-16-16l-48 0zm64 136l-64 0 0 80 64 0 0-80z',
  ],
};
const faSquareArrowDownRight = {
  prefix: 'far',
  iconName: 'square-arrow-down-right',
  icon: [
    448,
    512,
    [],
    'e262',
    'M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L288 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0z',
  ],
};
const faBookSparkles = {
  prefix: 'far',
  iconName: 'book-sparkles',
  icon: [
    448,
    512,
    ['book-spells'],
    'f6b8',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM160 112l8.8-17.7c2.9-5.9 11.4-5.9 14.3 0L192 112l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 144l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 144l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 112zM264 216l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 216l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 264l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 264l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 216z',
  ],
};
const faBookSpells = faBookSparkles;
const faWashingMachine = {
  prefix: 'far',
  iconName: 'washing-machine',
  icon: [
    448,
    512,
    ['washer'],
    'f898',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM314.6 319.7c-3.5 .2-7 .3-10.6 .3c-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1 .2-10.7 .4C146.4 218.9 182 192 224 192c53 0 96 43 96 96c0 11.1-1.9 21.8-5.4 31.7zM368 288A144 144 0 1 0 80 288a144 144 0 1 0 288 0z',
  ],
};
const faWasher = faWashingMachine;
const faChild = {
  prefix: 'far',
  iconName: 'child',
  icon: [
    320,
    512,
    [],
    'f1ae',
    'M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM128 214l0 122 64 0 0-121.6c-10.2-4.2-21.2-6.4-32.4-6.4c-11 0-21.6 2.1-31.6 6zm0 170l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-230.1L43.7 309.8c-7.6 10.9-22.6 13.5-33.4 5.9S-3.3 293.1 4.3 282.2L50.1 217c25-35.7 65.9-57 109.5-57c43.2 0 83.7 20.8 108.8 56L315.5 282c7.7 10.8 5.2 25.8-5.6 33.5s-25.8 5.2-33.5-5.6L240 258.9 240 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-64 0z',
  ],
};
const faLiraSign = {
  prefix: 'far',
  iconName: 'lira-sign',
  icon: [
    320,
    512,
    [8356],
    'f195',
    'M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2L48 192l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 4.5c0 18.8-5.1 37.3-14.8 53.5L3.4 443.7c-4.4 7.4-4.6 16.6-.3 24.2S15.4 480 24 480l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L66.4 432l8-13.3C88.5 395.1 96 368.1 96 340.5l0-4.5 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 288l0-48 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 192l0-32.8z',
  ],
};
const faUserVisor = {
  prefix: 'far',
  iconName: 'user-visor',
  icon: [
    448,
    512,
    [],
    'e04c',
    'M224 208c26.2 0 49.4-12.6 64-32l-128 0c14.6 19.4 37.8 32 64 32zm0 48c-54 0-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2l0-64c0-17.7 14.3-32 32-32l12.1 0C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L336 48c17.7 0 32 14.3 32 32l0 64c0 15.3-10.7 28-25 31.2C324.2 222.5 278 256 224 256zM128 112c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 96c-8.8 0-16 7.2-16 16zM269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112l349.5 0c-8.9-63.3-63.3-112-129-112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM313.5 429c-7.9 0-18.8 9.5-26.5 16.3c-2.1 1.9-4 3.5-5.5 4.7c-2.3 1.7-5.7 0-5.4-2.9c3.2-30.5 13.2-55.5 29.8-74.7c1.3-1.5 4.1-1.6 5.1 .1c15.8 20.6 24.2 45.9 25.1 75.3c0 3.2-4.1 4.7-6.1 2.1c-10.2-14.4-14.7-19.2-16.6-20.9z',
  ],
};
const faFilePlusMinus = {
  prefix: 'far',
  iconName: 'file-plus-minus',
  icon: [
    384,
    512,
    [],
    'e177',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40zM128 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z',
  ],
};
const faChessClockFlip = {
  prefix: 'far',
  iconName: 'chess-clock-flip',
  icon: [
    640,
    512,
    ['chess-clock-alt'],
    'f43e',
    'M384 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32 88 0c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 176c0-35.3 28.7-64 64-64l32 0 0-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 16 184 0 0-32-32 0c-13.3 0-24-10.7-24-24zM64 160c-8.8 0-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-240c0-8.8-7.2-16-16-16L64 160zm376 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM126.5 222.5A104 104 0 1 1 273.5 369.5 104 104 0 1 1 126.5 222.5zm124.5 22.6c-6.2-6.2-16.4-6.2-22.6 0L194.3 279c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faChessClockAlt = faChessClockFlip;
const faSatellite = {
  prefix: 'far',
  iconName: 'satellite',
  icon: [
    512,
    512,
    [128752],
    'f7bf',
    'M241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l58.1 58.1c-50.9-9.8-105.5 3.2-147.2 39.7c-3.8 3.3-5.9 8-5.9 13l0 .5c0 4.9 1.9 9.6 5.4 13L103 375 55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48 97.6 97.6c3.5 3.5 8.1 5.4 13 5.4l.5 0c5 0 9.8-2.2 13-5.9c36.5-41.7 49.6-96.3 39.7-147.2L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75 241 7zm34.6 289.5c-6.4-9.7-13.8-18.8-22.3-27.3l-10.6-10.6c-8.5-8.5-17.6-15.9-27.3-22.3L369 82.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L429.1 129c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L275.6 296.6zM275 109L197 187l-51-51L224 57.9l51 51zM376 366.1l-51-51L403 237l51 51L376 366.1zM219.4 303.2c38.8 38.8 47.1 97 23.8 144.1L64.7 268.8c47.1-23.2 105.3-14.9 144.1 23.8l10.6 10.6z',
  ],
};
const faTruckFire = {
  prefix: 'far',
  iconName: 'truck-fire',
  icon: [
    640,
    512,
    [],
    'e65a',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 50.7C13.4 105.3 0 123.1 0 144L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l16 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-96 0 0-48 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM336 48l0 48-56 0 0-48 56 0zm0 96l48 0 0 80L48 224l0-80 288 0zM48 368l0-96 352 0c17.7 0 32-14.3 32-32l0-96 160 0 0 224-28.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48l-153.7 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L48 368zM232 48l0 48-48 0 0-48 48 0zm-96 0l0 48L80 96l0-48 56 0zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8-192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
  ],
};
const faPlaneLock = {
  prefix: 'far',
  iconName: 'plane-lock',
  icon: [
    640,
    512,
    [],
    'e558',
    'M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 95.3 61c-8.3 14.1-13.5 30.2-14.9 47.4L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6c9 2.7 17.5 5.3 24.3 7.3l0-23.9-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5l82.5 26.4c-11 11.5-17.8 27.1-17.8 44.3l0 .4-48-15.4 0 27.4 48 36 0 79.3c0 7.9 1.4 15.4 4 22.4c-6.8 6.4-15.9 10.3-26 10.3c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faSteeringWheel = {
  prefix: 'far',
  iconName: 'steering-wheel',
  icon: [
    512,
    512,
    [],
    'f622',
    'M232 369l0 93.6C133.7 451.3 56.2 371.4 48.6 272l107.8 0 74.3 95.5c.4 .5 .8 1 1.3 1.5zm48 0c.4-.5 .9-1 1.3-1.5L355.6 272l107.8 0c-7.6 99.4-85 179.3-183.4 190.6l0-93.6zm72-145l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-120.4 0c-12.1 0-23.2 6.8-28.6 17.7L160 224 50.4 224C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176L352 224zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
  ],
};
const faTag = {
  prefix: 'far',
  iconName: 'tag',
  icon: [
    448,
    512,
    [127991],
    'f02b',
    'M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0L384.8 283.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7L48 80l0 149.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faStretcher = {
  prefix: 'far',
  iconName: 'stretcher',
  icon: [
    640,
    512,
    [],
    'f825',
    'M41.4 71.5c-9.1-9.6-24.3-10-33.9-.9s-10 24.3-.9 33.9L139.7 244.6c16.6 17.5 39.7 27.4 63.8 27.4L616 272c13.3 0 24-10.7 24-24s-10.7-24-24-24l-412.5 0c-11 0-21.4-4.5-29-12.4L41.4 71.5zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 86-62.5-81.6 0L368 336.9 322.8 304l-81.6 0zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faBookSection = {
  prefix: 'far',
  iconName: 'book-section',
  icon: [
    448,
    512,
    ['book-law'],
    'e0c1',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM224.7 246.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c0 0 0 0 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 177.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z',
  ],
};
const faBookLaw = faBookSection;
const faInboxes = {
  prefix: 'far',
  iconName: 'inboxes',
  icon: [
    512,
    512,
    [],
    'e1bb',
    'M62.5 96l67.9 0c18.2 0 34.8 10.3 42.9 26.5L192 160l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l67.8 0-40-48-307 0-40 48zM48 144l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 197.7 338.2 208 320 208l-128 0c-18.2 0-34.8-10.3-42.9-26.5L130.3 144 48 144zM0 144l0-30.6c0-11.2 3.9-22.1 11.1-30.7L65.6 17.3C74.7 6.3 88.2 0 102.5 0l307 0c14.2 0 27.8 6.3 36.9 17.3l54.5 65.4c7.2 8.6 11.1 19.5 11.1 30.7l0 30.6 0 96c0 26.5-21.5 48-48 48L48 288c-26.5 0-48-21.5-48-48l0-96zM310.1 432l-108.2 0c-24.2 0-46.4-13.7-57.2-35.4L130.3 368 48 368l0 96 416 0 0-96-82.3 0-14.3 28.6-42.6-21.3 42.6 21.3c-10.8 21.7-33 35.4-57.2 35.4zM48 320l82.3 0c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8l108.2 0c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z',
  ],
};
const faCoffeeBean = {
  prefix: 'far',
  iconName: 'coffee-bean',
  icon: [
    448,
    512,
    [],
    'e13e',
    'M385.9 133.1c-13.3 27.7-29.9 56.7-48.9 75.8c-34.5 34.8-69.6 52.3-101.5 68.2l-.8 .4c-32.1 16-61 30.6-89.7 59.4c-16.6 16.7-34.4 47-49.8 77.5c23.2 14.8 54.2 20.9 90.3 15.8c45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c4.7-33.2-.1-61.9-12.3-84.4zM350.1 95.9c-22.9-13.6-52.9-19.1-87.7-14.2c-45.5 6.5-96.1 30.9-138.9 73.8S56.3 249 49.8 294.5c-4.6 32-.3 59.9 11.1 82.1c14.5-27.1 31.8-55 50.1-73.4c34.5-34.8 69.6-52.3 101.5-68.2l.8-.4c32.1-16 61-30.6 89.7-59.4c16.6-16.8 33.4-47.8 47.2-79.1zm53-19.1c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8S-9.4 220.6 89.6 121.6s239.4-119 313.6-44.8z',
  ],
};
const faCircleYen = {
  prefix: 'far',
  iconName: 'circle-yen',
  icon: [
    512,
    512,
    [],
    'e5d0',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256l31.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 32 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 25c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l40 0 0-32-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l31.6 0-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z',
  ],
};
const faBracketsCurly = {
  prefix: 'far',
  iconName: 'brackets-curly',
  icon: [
    576,
    512,
    [],
    'f7ea',
    'M152 32c-48.6 0-88 39.4-88 88l0 45.5c0 10.6-4.2 20.8-11.7 28.3L7 239c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c7.5 7.5 11.7 17.7 11.7 28.3L64 392c0 48.6 39.4 88 88 88l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-22.1 0-40-17.9-40-40l0-45.5c0-23.3-9.3-45.7-25.8-62.2L57.9 256l28.3-28.3c16.5-16.5 25.8-38.9 25.8-62.2l0-45.5c0-22.1 17.9-40 40-40l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm272 0l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c22.1 0 40 17.9 40 40l0 45.5c0 23.3 9.3 45.7 25.8 62.2L518.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2l0 45.5c0 22.1-17.9 40-40 40l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c48.6 0 88-39.4 88-88l0-45.5c0-10.6 4.2-20.8 11.7-28.3L569 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3l0-45.5c0-48.6-39.4-88-88-88z',
  ],
};
const faEllipsisStrokeVertical = {
  prefix: 'far',
  iconName: 'ellipsis-stroke-vertical',
  icon: [
    192,
    512,
    ['ellipsis-v-alt'],
    'f39c',
    'M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 88A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm24 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z',
  ],
};
const faEllipsisVAlt = faEllipsisStrokeVertical;
const faComment = {
  prefix: 'far',
  iconName: 'comment',
  icon: [
    512,
    512,
    [128489, 61669],
    'f075',
    'M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z',
  ],
};
const faSquare1 = {
  prefix: 'far',
  iconName: 'square-1',
  icon: [
    448,
    512,
    [],
    'e256',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm172 99.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4 200 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184c0-8.6-4.6-16.5-12-20.8z',
  ],
};
const faCakeCandles = {
  prefix: 'far',
  iconName: 'cake-candles',
  icon: [
    448,
    512,
    [127874, 'birthday-cake', 'cake'],
    'f1fd',
    'M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2L56 72c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM120 168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-8 0c-35.3 0-64 28.7-64 64L0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-192c0-35.3-28.7-64-64-64l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-80 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-80 0 0-56zM64 272l320 0c8.8 0 16 7.2 16 16l0 60.8c-5.5-2.1-10.9-5.1-15.8-8.5c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C310.2 347 299 352 288 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C182.2 347 171 352 160 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7C112.4 326.3 105.7 320 96 320c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5c-4.9 3.4-10.3 6.4-15.8 8.5L48 288c0-8.8 7.2-16 16-16zM400 398.5l0 65.5L48 464l0-65.5c17.5-3.3 33.9-11.6 48-22.3c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c14.1 10.7 30.5 19 48 22.3z',
  ],
};
const faBirthdayCake = faCakeCandles;
const faCake = faCakeCandles;
const faHeadSide = {
  prefix: 'far',
  iconName: 'head-side',
  icon: [
    512,
    512,
    [],
    'f6e9',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faTruckLadder = {
  prefix: 'far',
  iconName: 'truck-ladder',
  icon: [
    640,
    512,
    [],
    'e657',
    'M0 24C0 37.3 10.7 48 24 48l8 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM272 144l-32 0 0-96 32 0 0 96zM160 48l32 0 0 96-32 0 0-96zm-48 96l-32 0 0-96 32 0 0 96zM408 96c-13.3 0-24 10.7-24 24l0 104L56 224c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l8 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l8 0c30.9 0 56-25.1 56-56l0-108.8c0-12.7-4.3-25.1-12.3-35L548.3 117c-10.6-13.3-26.7-21-43.7-21L408 96zM76.8 368L56 368c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l328 0 48 0 160 0 0 88c0 4.4-3.6 8-8 8l-20.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48l-153.7 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48zM432 224l0-80 72.6 0c2.4 0 4.7 1.1 6.2 3l61.6 77L432 224zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faEnvelope = {
  prefix: 'far',
  iconName: 'envelope',
  icon: [
    512,
    512,
    [128386, 9993, 61443],
    'f0e0',
    'M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z',
  ],
};
const faDollyEmpty = {
  prefix: 'far',
  iconName: 'dolly-empty',
  icon: [
    576,
    512,
    [],
    'f473',
    'M0 24C0 10.7 10.7 0 24 0l80.8 0C129 0 150.5 15.6 158 38.6L250 320.2c2-.1 4-.2 6-.2c33.2 0 62.5 16.9 79.8 42.5L544 289.4c12.5-4.4 26.2 2.2 30.6 14.7s-2.2 26.2-14.7 30.6L351.7 407.8c.2 2.7 .3 5.4 .3 8.2c0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L112.4 53.5c-1.1-3.3-4.1-5.5-7.6-5.5L24 48C10.7 48 0 37.3 0 24zM304 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faFaceTissue = {
  prefix: 'far',
  iconName: 'face-tissue',
  icon: [
    512,
    512,
    [],
    'e39c',
    'M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 8.7 .5 17.3 1.6 25.7L8.1 288.7c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l6.9-41.5c8.4 1 17 1.6 25.7 1.6zm-13.3-76l9-54.1 4.3 3.4 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.2 6.6-19.7 7-28.3 1.2zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-159.2 162c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z',
  ],
};
const faAnglesUp = {
  prefix: 'far',
  iconName: 'angles-up',
  icon: [
    448,
    512,
    ['angle-double-up'],
    'f102',
    'M241 47c-9.4-9.4-24.6-9.4-33.9 0L47 207c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 241c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 47zM401 399L241 239c-9.4-9.4-24.6-9.4-33.9 0L47 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z',
  ],
};
const faAngleDoubleUp = faAnglesUp;
const faBinRecycle = {
  prefix: 'far',
  iconName: 'bin-recycle',
  icon: [
    576,
    512,
    [],
    'e5f7',
    'M0 56C0 42.7 10.7 32 24 32l8 0 48.1 0 415.8 0L544 32l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.4 0L516.2 420.6C513.9 454.1 486 480 452.4 480l-328.8 0c-33.6 0-61.4-25.9-63.8-59.4L35.4 80 24 80C10.7 80 0 69.3 0 56zM83.6 80l24.1 337.1c.6 8.4 7.6 14.9 16 14.9l328.8 0c8.4 0 15.4-6.5 16-14.9L492.4 80 83.6 80zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-20.7 29.6c-7.3 10.5-21.6 13.4-32.4 6.6c-11.7-7.3-14.8-22.9-6.9-34.1l20.7-29.6c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l20.7 29.6c7.9 11.3 4.7 26.8-6.9 34.1c-10.8 6.8-25.1 3.9-32.4-6.6l-20.7-29.6c-1.3-1.8-3.3-2.9-5.5-2.9zm-88.3 77.1c11.7 7.3 14.8 22.9 6.9 34.1l-21.5 30.7c-.8 1.1-1.2 2.4-1.2 3.7c0 3.5 2.9 6.4 6.4 6.4l49.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-49.6 0c-30.1 0-54.4-24.4-54.4-54.4c0-11.2 3.4-22.1 9.8-31.2l21.5-30.7c7.3-10.5 21.6-13.4 32.4-6.6zM312 352c0-13.3 10.7-24 24-24l49.6 0c3.5 0 6.4-2.9 6.4-6.4c0-1.3-.4-2.6-1.2-3.7l-21.5-30.7c-7.9-11.3-4.7-26.8 6.9-34.1c10.8-6.8 25.1-3.9 32.4 6.6l21.5 30.7c6.4 9.1 9.8 20 9.8 31.2c0 30.1-24.4 54.4-54.4 54.4L336 376c-13.3 0-24-10.7-24-24z',
  ],
};
const faPaperclip = {
  prefix: 'far',
  iconName: 'paperclip',
  icon: [
    448,
    512,
    [128206],
    'f0c6',
    'M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z',
  ],
};
const faChartLineDown = {
  prefix: 'far',
  iconName: 'chart-line-down',
  icon: [
    512,
    512,
    [128201],
    'f64d',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM320 296c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L321 127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l79-79L398.1 272 344 272c-13.3 0-24 10.7-24 24z',
  ],
};
const faArrowRightToCity = {
  prefix: 'far',
  iconName: 'arrow-right-to-city',
  icon: [
    640,
    512,
    [],
    'e4b3',
    'M336 56c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 160c0 13.3 10.7 24 24 24l80 0 16 0c4.4 0 8 3.6 8 8l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-28.2-20.9-51.6-48-55.4l0-72.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-32 0 0-136c0-30.9-25.1-56-56-56L344 0c-30.9 0-56 25.1-56 56l0 432c0 13.3 10.7 24 24 24s24-10.7 24-24l0-432zm32 40l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM368 288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM496 384l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160.1 158.2c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9L169.9 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l145.9 0-42.1 38.2c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6l88-80c5-4.5 7.9-11 7.9-17.8s-2.9-13.2-7.9-17.8l-88-80z',
  ],
};
const faLockA = {
  prefix: 'far',
  iconName: 'lock-a',
  icon: [
    448,
    512,
    [],
    'e422',
    'M224 48c44.2 0 80 35.8 80 80l0 32-160 0 0-32c0-44.2 35.8-80 80-80zM96 128l0 32-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-32 0 0-32C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208l32 0 48 0 160 0 48 0 32 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm58.5 197.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L178.8 400l90.3 0 13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2L245.6 245.5c-1.2-2.4-2.7-4.6-4.6-6.5c-2.2-2.2-4.7-3.9-7.4-5c-3.1-1.3-6.3-2-9.5-2s-6.4 .6-9.5 2c-2.7 1.2-5.3 2.9-7.4 5c-1.9 1.9-3.4 4.1-4.6 6.5L122.5 405.3zM202.8 352L224 309.7 245.2 352l-42.3 0z',
  ],
};
const faRibbon = {
  prefix: 'far',
  iconName: 'ribbon',
  icon: [
    448,
    512,
    [127895],
    'f4d6',
    'M6.5 415.6l96.6-103.4L136 347.4 60.5 428.2l40.3 28.2 68.5-73.3 32.8 35.1-80.5 86.2c-8.2 8.7-21.5 10.1-31.3 3.3l-80-56c-5.7-4-9.4-10.2-10.1-17.2s1.6-13.8 6.3-18.9zM245.9 159.4l7-7.5c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.1-42.5l-9.3-12.5c-7.3-.4-15.5-.6-24.4-.6l0-48c14.8 0 27.9 .6 39 1.5c9.1 .7 17 1.7 23.5 2.6c21.2 3.1 38.2 15.4 49.5 30.6l40.2 53.6c15.4 20.6 23.7 45.6 23.7 71.3c0 30.1-11.4 59.1-32 81.2l-23 24.6-32.8-35.2L332.9 208c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.2-42.5L319.5 92.6c.3 3.6 .5 7.3 .5 11c0 30.1-11.4 59.1-32 81.2l-9.2 9.8-32.8-35.2zM224 48c-8.9 0-17.1 .2-24.4 .6l-9.3 12.5c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L441.5 415.6c4.7 5.1 7.1 12 6.3 18.9s-4.4 13.2-10.1 17.2l-80 56c-9.8 6.9-23.1 5.5-31.3-3.3L80.1 240.7c-20.6-22-32-51-32-81.2c0-25.7 8.3-50.7 23.7-71.3L112 34.7c11.4-15.2 28.4-27.5 49.5-30.6c6.6-1 14.4-1.9 23.5-2.6C196.1 .6 209.2 0 224 0l0 48zM110.2 117.1c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L347.3 456.4l40.3-28.2L160.1 184.7c-20.6-22-32-51-32-81.2c0-3.7 .2-7.4 .5-11l-18.4 24.5z',
  ],
};
const faLungs = {
  prefix: 'far',
  iconName: 'lungs',
  icon: [
    640,
    512,
    [129729],
    'f604',
    'M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 142.8c0 18.1-8.7 35.1-23.5 45.6L256 224.2l0-39.5 0-8.7 0-10.7C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398l0-75.5-48 34.3 0 41.2c0 22-15 41.2-36.4 46.6L98.9 462.8c-3.3 .8-6.6 1.2-9.9 1.2c-22.6 0-41-18.3-41-41l0-6c6.3-49.1 29-104.2 54.4-153.1c25.5-49 53.1-90.5 67.8-111.6c3.6-5.1 9.6-8.3 16.4-8.3c11.8 0 21.3 9.6 21.3 21.3l0 10.7 0 43.2 0 39.3-69.9 50c-10.8 7.7-13.3 22.7-5.6 33.5s22.7 13.3 33.5 5.6l42.1-30 48-34.3 44.4-31.7c7.4-5.3 13.9-11.4 19.6-18.2c5.6 6.8 12.2 12.9 19.6 18.2L384 283.2l48 34.3 42.1 30c10.8 7.7 25.8 5.2 33.5-5.6s5.2-25.8-5.6-33.5l-69.9-50 0-39.3 0-43.2 0-10.7c0-11.8 9.6-21.3 21.3-21.3c6.8 0 12.8 3.2 16.4 8.3c14.7 21.1 42.3 62.6 67.8 111.6C563 312.8 585.7 367.9 592 417l0 6c0 22.6-18.3 41-41 41c-3.4 0-6.7-.4-9.9-1.2l-72.7-18.2C447 439.3 432 420.1 432 398l0-41.2-48-34.3 0 75.5c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3l0 10.7 0 8.7 0 39.5-16.6-11.8c-14.7-10.5-23.4-27.5-23.4-45.6L344 24z',
  ],
};
const faPersonPinball = {
  prefix: 'far',
  iconName: 'person-pinball',
  icon: [
    640,
    512,
    [],
    'e21d',
    'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM48 186.2c0-5.6 4.6-10.2 10.2-10.2c4.9 0 9.7 1.3 13.8 3.7l0 120.1L50.6 279.9c-1.6-1.5-2.6-3.6-2.6-5.9l0-87.8zm72 158.2l0-88 6.5 11.5c7.1 12.5 20.4 20.2 34.7 20.2l30.7 0 0 88 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 352 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112 0-168 0-184c0-13.3-10.7-24-24-24L504 0c-13.3 0-24 10.7-24 24l0 42c0 6.9 1.3 13.8 3.8 20.3l44 113.2L251 249.3c-4.4-5.7-11.3-9.3-19-9.3l-66.1 0-42.3-74c-13.4-23.5-38.4-38-65.4-38C26.1 128 0 154.1 0 186.2L0 274c0 15.6 6.5 30.4 17.9 41L112 402.5l0 85.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89c0-11.1-4.6-21.7-12.8-29.3L120 344.4zM592 352l-352 0 0-51.9 32.1-5.8c0 .6-.1 1.1-.1 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7 592 352zM48 386.7L0 342.1 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-101.3zM528 66l0-18 64 0 0 139.2-16.5 2.4L528.5 68.9c-.4-.9-.5-1.9-.5-2.9z',
  ],
};
const faArrowUp91 = {
  prefix: 'far',
  iconName: 'arrow-up-9-1',
  icon: [
    576,
    512,
    ['sort-numeric-up-alt'],
    'f887',
    'M424 80a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm88 40c0 .8 0 1.6 0 2.5c-.6 20.2-7.9 39.7-20.9 55.3l-64.6 77.6c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L405.1 206c-39.5-8.6-69.1-43.8-69.1-86c0-48.6 39.4-88 88-88s88 39.4 88 88zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM456 312l0 120 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-86.7-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z',
  ],
};
const faSortNumericUpAlt = faArrowUp91;
const faAppleCore = {
  prefix: 'far',
  iconName: 'apple-core',
  icon: [
    384,
    512,
    [],
    'e08f',
    'M192 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM128 464c4.6 0 13.6-1.7 24.9-5.1c25.4-7.6 52.7-7.6 78.1 0c11.3 3.4 20.3 5.1 24.9 5.1c11.4 0 24.9-3.9 38.9-13.1C260.7 411.6 240 360.2 240 304c0-46 13.9-88.8 37.7-124.4c-12.7 3-26.4 7.5-39 12.4c-30 11.7-63.5 11.7-93.5 0c-12.6-4.9-26.2-9.4-39-12.4C130.1 215.2 144 258 144 304c0 56.2-20.7 107.6-54.9 146.9c14 9.2 27.4 13.1 38.9 13.1zM304 128c6.7 0 13 .6 19.1 1.9c0 0 0 0 0 0l.5 .1c11.3 2.3 21.5 6.7 30.6 12.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-11.9 0-26.5-3.4-38.8-7.1c-16.4-4.9-34.1-4.9-50.5 0c-12.2 3.7-26.8 7.1-38.8 7.1c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3c9.2-6 19.4-10.3 30.6-12.7l.5-.1s0 0 0 0C67 128.6 73.3 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3z',
  ],
};
const faCircleY = {
  prefix: 'far',
  iconName: 'circle-y',
  icon: [
    512,
    512,
    [],
    'e12f',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3c-8.7-10-23.8-11.1-33.9-2.4s-11.1 23.8-2.4 33.9L232 297l0 79c0 13.3 10.7 24 24 24s24-10.7 24-24l0-79 98.1-113.2c8.7-10 7.6-25.2-2.4-33.9s-25.2-7.6-33.9 2.4L256 251.4l-85.9-99.1z',
  ],
};
const faH6 = {
  prefix: 'far',
  iconName: 'h6',
  icon: [
    640,
    512,
    [],
    'e413',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM519 69.3c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296l.2 0c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L522.7 103c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faLitecoinSign = {
  prefix: 'far',
  iconName: 'litecoin-sign',
  icon: [
    384,
    512,
    [],
    'e1d3',
    'M112 56c0-13.3-10.7-24-24-24S64 42.7 64 56l0 164.5L17.8 232.8C5 236.2-2.6 249.4 .8 262.2s16.6 20.4 29.4 17l33.8-9L64 456c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-248 0 0-174.6 158.2-42.2c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17L112 207.7 112 56z',
  ],
};
const faBottleBaby = {
  prefix: 'far',
  iconName: 'bottle-baby',
  icon: [
    512,
    512,
    [],
    'e673',
    'M220.6 49.7L224 48l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 3.4 1.7C308.9 58.5 320 76.4 320 96c17.7 0 32 14.3 32 32l0 16 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-180.4c0-38.2 15.2-74.8 42.2-101.8L160 144l0-16c0-17.7 14.3-32 32-32c0-19.6 11.1-37.5 28.6-46.3zM368 448l0-180.4c0-25.5-10.1-49.9-28.1-67.9l-7.8-7.8-152.2 0-7.8 7.8c-18 18-28.1 42.4-28.1 67.9l0 4.4 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 48 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 32c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16z',
  ],
};
const faCircleSmall = {
  prefix: 'far',
  iconName: 'circle-small',
  icon: [
    320,
    512,
    [],
    'e122',
    'M272 256A112 112 0 1 0 48 256a112 112 0 1 0 224 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z',
  ],
};
const faBorderNone = {
  prefix: 'far',
  iconName: 'border-none',
  icon: [
    448,
    512,
    [],
    'f850',
    'M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
  ],
};
const faArrowTurnDownLeft = {
  prefix: 'far',
  iconName: 'arrow-turn-down-left',
  icon: [
    512,
    512,
    [],
    'e2e1',
    'M464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168c0 48.6-39.4 88-88 88L81.9 312l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-9.4-9.4-9.4-24.6 0-33.9L135 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L424 264c22.1 0 40-17.9 40-40l0-168z',
  ],
};
const faCircleWifiCircleWifi = {
  prefix: 'far',
  iconName: 'circle-wifi-circle-wifi',
  icon: [
    640,
    512,
    ['circle-wifi-group'],
    'e67e',
    'M256 48c94.3 0 173.9 62.7 199.4 148.7c13-3.1 26.6-4.7 40.6-4.7c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-11-12-20.4-25.5-27.7-40.1c-25.3 11-53.3 17.1-82.6 17.1C141.1 464 48 370.9 48 256S141.1 48 256 48zM416.6 205.6C374.1 167.3 317.7 144 256 144s-118.1 23.3-160.6 61.6c-9.8 8.9-10.6 24-1.8 33.9s24 10.6 33.9 1.8c34-30.7 79-49.3 128.5-49.3c46.8 0 89.7 16.7 123 44.5c12.2-10.9 26-20.1 40.9-27.3c-1-1.3-2-2.5-3.3-3.6zM256 240c-35.1 0-67.1 13.3-91.2 35.1c-9.8 8.9-10.6 24.1-1.7 33.9s24.1 10.6 33.9 1.7c15.6-14.1 36.3-22.7 59-22.7s43.4 8.6 59 22.7c3.7 3.3 8.1 5.3 12.6 5.9c4.5-14.9 11-29 19.1-42C322.7 253.1 290.9 240 256 240zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm384-32a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320c-27.2 0-51.9 10.2-70.6 27.1c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c24.4-21.9 56.6-35.3 92-35.3s67.7 13.4 92 35.3c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C547.9 330.2 523.2 320 496 320zM476 432a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm-11.5-35.9c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c14-12.7 32.6-20.4 53-20.4s39 7.7 53 20.4c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-8.3-7.5-19.4-12.1-31.5-12.1s-23.2 4.6-31.5 12.1z',
  ],
};
const faCircleWifiGroup = faCircleWifiCircleWifi;
const faCircleNodes = {
  prefix: 'far',
  iconName: 'circle-nodes',
  icon: [
    512,
    512,
    [],
    'e4e2',
    'M368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1L153.3 240.2c4.3-9.9 6.7-20.7 6.7-32.2c0-2-.1-4.1-.2-6.1l178.3-71.3zM410 159.4c39.5-4.9 70-38.6 70-79.4c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1 .2 6.1L141.9 157.4C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7L262.7 399.8c-4.3 9.9-6.7 20.7-6.7 32.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8L410 159.4zM304 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faParachuteBox = {
  prefix: 'far',
  iconName: 'parachute-box',
  icon: [
    512,
    512,
    [],
    'f4cd',
    'M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16L232 192l0 128-24 0c-3.3 0-6.5 .3-9.6 1L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192L38 192 162.4 353c-1.6 4.7-2.4 9.8-2.4 15l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-5.3-.8-10.3-2.4-15L474 192l19.1 0c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L313.6 321c-3.1-.6-6.3-1-9.6-1l-24 0 0-128 103.5 0zM208 368l96 0 0 96-96 0 0-96z',
  ],
};
const faReflectHorizontal = {
  prefix: 'far',
  iconName: 'reflect-horizontal',
  icon: [
    512,
    512,
    [],
    'e664',
    'M256 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM48 166.6l0 178.7L137.4 256 48 166.6zM0 128c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S0 396.9 0 384L0 128zM374.6 256L464 345.4l0-178.7L374.6 256zM492.2 98.4c12 5 19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9z',
  ],
};
const faMessageMedical = {
  prefix: 'far',
  iconName: 'message-medical',
  icon: [
    512,
    512,
    ['comment-alt-medical'],
    'f7f4',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM224 128l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faCommentAltMedical = faMessageMedical;
const faRugbyBall = {
  prefix: 'far',
  iconName: 'rugby-ball',
  icon: [
    512,
    512,
    [],
    'e3c6',
    'M336 16l32 0c70.7 0 128 57.3 128 128l0 32c0 176.7-143.3 320-320 320l-32 0C73.3 496 16 438.7 16 368l0-32C16 159.3 159.3 16 336 16zM308.5 65.4C252.1 71 200.9 93.9 160 128.6c-11.5 9.8-22.2 20.5-32 32.1c-34.8 41.3-57.6 93.1-62.8 150C88.5 266 125.5 216.6 172 170c45.1-45.1 92.9-81.2 136.4-104.6zm-108 381.5c57.2-5.1 109.3-27.9 150.8-62.9c11.6-9.8 22.3-20.5 32.1-32c34.9-41.1 57.8-92.6 63.3-149.3c-23.4 43.7-59.7 91.7-105 137c-46.8 46.8-96.4 83.9-141.3 107.2zM90.4 421.4c2.7 2.7 8.8 5.9 22.3 5c13.4-.9 31.2-5.8 52.5-15.6c42.3-19.4 93.5-55.8 142.7-105s85.6-100.4 105-142.7c9.8-21.2 14.7-39 15.6-52.5c.9-13.5-2.3-19.6-5-22.3s-8.8-5.9-22.3-5c-13.4 .9-31.2 5.8-52.5 15.6c-42.3 19.5-93.5 55.8-142.7 105s-85.6 100.4-105 142.7c-9.8 21.2-14.7 39-15.6 52.5c-.9 13.5 2.3 19.6 5 22.3z',
  ],
};
const faCommentMusic = {
  prefix: 'far',
  iconName: 'comment-music',
  icon: [
    512,
    512,
    [],
    'f8b0',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM352 128c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faIndent = {
  prefix: 'far',
  iconName: 'indent',
  icon: [
    448,
    512,
    [],
    'f03c',
    'M0 64C0 77.3 10.7 88 24 88l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40C10.7 40 0 50.7 0 64zM192 192c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zM0 448c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424c-13.3 0-24 10.7-24 24zM121 268.4c7.8-6.4 7.8-18.3 0-24.7L26.2 165.6C15.7 157 0 164.4 0 177.9L0 334.1c0 13.5 15.7 20.9 26.2 12.4L121 268.4z',
  ],
};
const faTreeDeciduous = {
  prefix: 'far',
  iconName: 'tree-deciduous',
  icon: [
    512,
    512,
    [127795, 'tree-alt'],
    'f400',
    'M185.9 103.6c-1.4 6.2-5.3 11.6-10.7 15s-12 4.4-18.2 3c-4.1-1-8.5-1.5-13-1.5c-30.9 0-56 25.1-56 56c0 6.4 1.1 12.5 3 18.2c3.8 11.1-1 23.4-11.3 28.9C60.8 233.2 48 253.2 48 276c0 33.1 26.9 60 60 60l124 0 0-16 0-64 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 0 64 0 16 124 0c33.1 0 60-26.9 60-60c0-22.8-12.8-42.8-31.7-52.9c-10.4-5.6-15.2-17.8-11.3-28.9c1.9-5.7 3-11.8 3-18.2c0-30.9-25.1-56-56-56c-4.5 0-8.8 .5-13 1.5c-6.2 1.5-12.7 .4-18.2-3s-9.3-8.7-10.7-15C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6zM232 384l-124 0C48.4 384 0 335.6 0 276c0-34.4 16.1-65 41.1-84.8c-.7-5-1.1-10.1-1.1-15.2C40 118.6 86.6 72 144 72c.7 0 1.3 0 2 0C164.5 29.6 206.8 0 256 0s91.5 29.6 110 72c.7 0 1.3 0 2 0c57.4 0 104 46.6 104 104c0 5.2-.4 10.2-1.1 15.2C495.9 211 512 241.6 512 276c0 59.6-48.4 108-108 108l-124 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z',
  ],
};
const faTreeAlt = faTreeDeciduous;
const faPuzzlePieceSimple = {
  prefix: 'far',
  iconName: 'puzzle-piece-simple',
  icon: [
    640,
    512,
    ['puzzle-piece-alt'],
    'e231',
    'M168 112c-4.4 0-8 3.6-8 8l0 79.1c0 22.6-18.3 40.9-40.9 40.9c-15 0-26.5-8.1-33.5-16.3c-4.9-5.9-9.8-7.7-13.6-7.7c-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9s10.7 9.1 14.7 9.1c3.7 0 8.6-1.8 13.6-7.7c7-8.3 18.5-16.3 33.5-16.3c22.6 0 40.9 18.3 40.9 40.9l0 79.1c0 4.4 3.6 8 8 8l76.5 0c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24l76.5 0c4.4 0 8-3.6 8-8l0-79.1c0-22.6 18.3-40.9 40.9-40.9c15 0 26.5 8.1 33.5 16.3c4.9 5.9 9.8 7.7 13.6 7.7c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-3.7 0-8.6 1.8-13.6 7.7c-7 8.3-18.5 16.3-33.5 16.3c-22.6 0-40.9-18.3-40.9-40.9l0-79.1c0-4.4-3.6-8-8-8l-76.5 0c2.9 7.4 4.5 15.5 4.5 24c0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24L168 112zm-56 8c0-30.9 25.1-56 56-56l102.1 0C288.8 64 304 79.2 304 97.9c0 10.1-4.5 18.5-9.9 24.2c-4.2 4.3-6.1 9.2-6.1 13.9c0 9.9 10.7 24 32 24s32-14.1 32-24c0-4.7-1.9-9.5-6.1-13.9c-5.5-5.7-9.9-14.1-9.9-24.2C336 79.2 351.2 64 369.9 64L472 64c30.9 0 56 25.1 56 56l0 62.6c10.9-8.8 24.6-14.6 40-14.6c22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.4 0-29.1-5.8-40-14.6l0 62.6c0 30.9-25.1 56-56 56l-102.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9L168 448c-30.9 0-56-25.1-56-56l0-62.6C101.1 338.2 87.4 344 72 344c-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.4 0 29.1 5.8 40 14.6l0-62.6z',
  ],
};
const faPuzzlePieceAlt = faPuzzlePieceSimple;
const faTruckFieldUn = {
  prefix: 'far',
  iconName: 'truck-field-un',
  icon: [
    640,
    512,
    [],
    'e58e',
    'M80 80c-8.8 0-16 7.2-16 16l0 32 0 160 0 48 12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L352 336l0-16 0-96 0-120 0-8c0-8.8-7.2-16-16-16L80 80zM16 336l0-52.3C6.4 278.2 0 267.8 0 256l0-96c0-11.8 6.4-22.2 16-27.7L16 96c0-35.3 28.7-64 64-64l256 0c29.8 0 54.9 20.4 62 48l37.7 0c21.7 0 41.4 12.5 50.7 32.2l52.3 111.2 .3 .7 5 0c35.3 0 64 28.7 64 64l0 48 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0-96 0c0 53-43 96-96 96s-96-43-96-96l-40 0-8 0 0-1.4C6.7 379.3 0 370.5 0 360s6.7-19.3 16-22.6l0-1.4zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM400 224l85.9 0-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6L400 128l0 96zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM253.3 135.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faNfcTrash = {
  prefix: 'far',
  iconName: 'nfc-trash',
  icon: [
    640,
    512,
    [],
    'e1fd',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l314.2 0 3.4 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5L400 192l0-96c0-8.8-7.2-16-16-16zM352 240c0 13.7 5.8 26.1 15 34.8l1 14.3 0 70.9c0 22.1-17.9 40-40 40l-208 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 192 0 0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40l0 52.2c-9.8 8.8-16 21.6-16 35.8zm97.7-39.2c2.7-5.4 8.2-8.8 14.3-8.8l96 0c6.1 0 11.6 3.4 14.3 8.8L585.9 224l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-128 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l38.1 0 11.6-23.2zM413.9 482.3L400 288l224 0L610.1 482.3C608.9 499 595 512 578.2 512l-132.4 0c-16.8 0-30.7-13-31.9-29.7z',
  ],
};
const faHourglass = {
  prefix: 'far',
  iconName: 'hourglass',
  icon: [
    384,
    512,
    [9203, 62032, 'hourglass-empty'],
    'f254',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z',
  ],
};
const faHourglassEmpty = faHourglass;
const faMountain = {
  prefix: 'far',
  iconName: 'mountain',
  icon: [
    512,
    512,
    [127956],
    'f6fc',
    'M464 424.1c0 4.4-3.5 7.9-7.9 7.9L55.9 432c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L149.6 260l39.5 50.8c4.6 5.9 11.7 9.3 19.2 9.3s14.5-3.6 19-9.6L268 256l92 0L462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zM329.8 208L256 208c-7.6 0-14.7 3.6-19.2 9.6l-29.1 38.9-30.9-39.8L256 90.3 329.8 208zM55.9 480l400.2 0c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z',
  ],
};
const faFileXmark = {
  prefix: 'far',
  iconName: 'file-xmark',
  icon: [
    384,
    512,
    ['file-times'],
    'f317',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm47 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faFileTimes = faFileXmark;
const faHouseHeart = {
  prefix: 'far',
  iconName: 'house-heart',
  icon: [
    576,
    512,
    ['home-heart'],
    'f4c9',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm64-162.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
  ],
};
const faHomeHeart = faHouseHeart;
const faHouseChimneyBlank = {
  prefix: 'far',
  iconName: 'house-chimney-blank',
  icon: [
    576,
    512,
    [],
    'e3b0',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6 512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 85.9L303.5 5.7zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z',
  ],
};
const faMeterBolt = {
  prefix: 'far',
  iconName: 'meter-bolt',
  icon: [
    640,
    512,
    [],
    'e1e9',
    'M464 256c0 8.9-.6 17.6-1.6 26.2l49.3-39.4C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c73.7 0 140.1-31.1 186.8-81l7.5-15L432 416c-11.5 0-22.3-4.1-30.7-11.1C363.8 441.5 312.5 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208zM192 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm234.1 75.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z',
  ],
};
const faUserDoctor = {
  prefix: 'far',
  iconName: 'user-doctor',
  icon: [
    448,
    512,
    ['user-md'],
    'f0f0',
    'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm64 225c5.2-.7 10.6-1 16-1l96 0c5.4 0 10.8 .3 16 1l0 49c-27.6 7.1-48 32.2-48 62l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-32c0-29.8-20.4-54.9-48-62l0-40.7c46.9 19 80 65 80 118.7l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-97.2-78.8-176-176-176l-96 0C78.8 304 0 382.8 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-53.7 33.1-99.7 80-118.7l0 41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-49.3zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faUserMd = faUserDoctor;
const faSlashBack = {
  prefix: 'far',
  iconName: 'slash-back',
  icon: [
    320,
    512,
    [],
    '5c',
    'M11.9 3.3C.4 10-3.4 24.7 3.3 36.1l272 464c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-272-464C38 .4 23.3-3.4 11.9 3.3z',
  ],
};
const faCircleInfo = {
  prefix: 'far',
  iconName: 'circle-info',
  icon: [
    512,
    512,
    ['info-circle'],
    'f05a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faInfoCircle = faCircleInfo;
const faFishingRod = {
  prefix: 'far',
  iconName: 'fishing-rod',
  icon: [
    448,
    512,
    [],
    'e3a8',
    'M280.4 48c-3.2 0-6.3 .5-9.3 1.4L206.6 69.2C136.1 90.9 88 156.1 88 229.8l0 42.9c22.7 3.8 40 23.6 40 47.3l0 144c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 320c0-23.8 17.3-43.5 40-47.3l0-42.9C40 135 101.8 51.2 192.5 23.4L256.9 3.5C264.5 1.2 272.4 0 280.4 0c44 0 79.6 35.7 79.6 79.6l0 56.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56.4C312 62.2 297.8 48 280.4 48zM48 320l0 144 32 0 0-144-32 0zm208 24c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3l0 1.4c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faHammerCrash = {
  prefix: 'far',
  iconName: 'hammer-crash',
  icon: [
    640,
    512,
    [],
    'e414',
    'M289.9 328.5l1.5 .7c15 7.5 31.5 8.6 46.4 4.2l-.3 1.8 54.1-23.5c9.6-4.2 20.9-1.6 27.7 6.3l38.6 44.6 15.4-56.9c2.7-10.1 11.7-17.3 22.2-17.7l58.9-2.3-34.9-47.5c-6.2-8.5-6.2-20 0-28.4l34.9-47.5L495.4 160c-10.5-.4-19.5-7.6-22.2-17.7L457.8 85.3l-20.3 23.6c-6-9.1-14.4-16.9-24.9-22.1L399 80l52-60.3c5.8-6.7 14.8-9.7 23.5-7.7s15.5 8.6 17.8 17.1l22.6 83.5 86.5 3.4c8.9 .3 16.8 5.6 20.7 13.6s3 17.5-2.3 24.6L568.6 224l51.3 69.7c5.3 7.2 6.1 16.6 2.3 24.6s-11.8 13.2-20.7 13.6l-86.5 3.4-22.6 83.5c-2.3 8.6-9.2 15.2-17.8 17.1s-17.7-1-23.5-7.7l-56.6-65.5-79.4 34.5c-8.1 3.5-17.6 2.3-24.5-3.3s-10.3-14.5-8.6-23.2l7.9-42.3zM81.9 64L53.5 120.8 312.8 250.5l49.7-99.4L188.2 64 81.9 64zM43.4 33.7C48.8 22.8 59.9 16 72 16l120 0c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3L186.4 241 69.5 474.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2L143.4 219.5 17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80z',
  ],
};
const faMessageHeart = {
  prefix: 'far',
  iconName: 'message-heart',
  icon: [
    512,
    512,
    [],
    'e5c9',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
  ],
};
const faCloudMeatball = {
  prefix: 'far',
  iconName: 'cloud-meatball',
  icon: [
    512,
    512,
    [],
    'f73b',
    'M184 49.2c-38.7 0-72 33.3-72 76.8c0 2.8 .1 5.6 .4 8.4c1.2 11.9-6.5 22.8-18.1 25.7C68.5 166.5 48 191.5 48 222.6c0 35.5 26.4 62.6 57.2 64.1c.3 0 .7 0 1 .1l1.8 0 63.3 0c-18.3 9.2-31.6 27-34.6 48l-28.7 0-4 0c-1.2 0-2.4-.1-3.6-.3C43.3 330.4 0 280.9 0 222.6C0 177.4 25.9 137.7 64.1 120C67.1 54.9 118.6 1.2 184 1.2c34.2 0 64.8 14.8 86.4 38.2c14.7-8.3 31.6-13 49.6-13c47.9 0 87.2 33.2 99.7 77.4C472.9 113.5 512 162 512 218.4c0 63.2-49.1 116.4-112 116.4l-24.7 0c-3-21-16.3-38.8-34.6-48l59.3 0c34.3 0 64-29.5 64-68.4s-29.7-68.4-64-68.4c0 0 0 0 0 0l-.3 0c-12.4 0-22.8-9.4-23.9-21.7c-3-31.2-27.7-53.9-55.7-53.9c-14.4 0-27.6 5.8-37.7 15.6c-5.3 5.1-12.6 7.6-19.9 6.6s-13.7-5.2-17.5-11.6c-13-21.9-35.7-35.9-60.9-35.9zM288 320c0 1-.1 2.1-.1 3.1c.7-.8 1.3-1.6 2.1-2.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-.7 .7-1.5 1.4-2.3 2.1c1-.1 2.1-.1 3.1-.1c17.7 0 32 14.3 32 32s-14.3 32-32 32c-1 0-2.1-.1-3.1-.2c.8 .7 1.6 1.4 2.3 2.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0c-.7-.7-1.4-1.5-2.1-2.3c.1 1 .1 2.1 .1 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1 .1-2.1 .1-3.1c-.7 .8-1.3 1.6-2.1 2.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3c.7-.7 1.5-1.4 2.3-2.1c-1 .1-2.1 .2-3.1 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1 0 2.1 0 3.1 .1c-.8-.7-1.6-1.3-2.3-2.1c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c.7 .7 1.4 1.5 2.1 2.3c-.1-1-.1-2.1-.1-3.1c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm416 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faCameraPolaroid = {
  prefix: 'far',
  iconName: 'camera-polaroid',
  icon: [
    576,
    512,
    [],
    'f8aa',
    'M512 432L64 432c-8.8 0-16-7.2-16-16l0-32 480 0 0 32c0 8.8-7.2 16-16 16zM68.4 336l32.9-49.3c7-10.5 10.7-22.9 10.7-35.5L112 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 155.2c0 12.6 3.7 25 10.7 35.5L507.6 336 68.4 336zM64 480l448 0c35.3 0 64-28.7 64-64l0-44.6c0-12.6-3.7-25-10.7-35.5L514.7 260c-1.8-2.6-2.7-5.7-2.7-8.9L512 96c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 155.2c0 3.2-.9 6.2-2.7 8.9L10.7 335.9C3.7 346.4 0 358.7 0 371.4L0 416c0 35.3 28.7 64 64 64zM408 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM288 288a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-32-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faCamera = {
  prefix: 'far',
  iconName: 'camera',
  icon: [
    512,
    512,
    [62258, 'camera-alt'],
    'f030',
    'M199.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L137.4 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C358.4 47.4 337 32 312.9 32L199.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faCameraAlt = faCamera;
const faSquareVirus = {
  prefix: 'far',
  iconName: 'square-virus',
  icon: [
    448,
    512,
    [],
    'e578',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 13.6c13.3 0 24 10.7 24 24c0 23.8 28.8 35.7 45.6 18.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.8 16.8-4.9 45.6 18.9 45.6c13.3 0 24 10.7 24 24s-10.7 24-24 24c-23.8 0-35.7 28.8-18.9 45.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.8-16.8-45.6-4.9-45.6 18.9c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-23.8-28.8-35.7-45.6-18.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.8-16.8 4.9-45.6-18.9-45.6c-13.3 0-24-10.7-24-24s10.7-24 24-24c23.8 0 35.7-28.8 18.9-45.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.8 16.8 45.6 4.9 45.6-18.9c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCartArrowUp = {
  prefix: 'far',
  iconName: 'cart-arrow-up',
  icon: [
    576,
    512,
    [],
    'e3ee',
    'M296 184l0-102.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23L344 184c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faMeteor = {
  prefix: 'far',
  iconName: 'meteor',
  icon: [
    512,
    512,
    [9732],
    'f753',
    'M474.8 0c-5.2 0-10.3 1.1-15 3.2L324 62.9l1.4-18.2c2.5-34.2-36.2-55.5-63.7-35.1L82.7 142.5C30.6 181.2 0 242.7 0 307.5C0 419.8 91 512 203.6 512c65.7 0 127.4-31.8 165.7-85.3L495.6 249.8c19.7-27.6-1.8-65.7-35.6-63.1l-10.7 .8L508.8 52.2c2.1-4.7 3.2-9.8 3.2-15C512 16.7 495.3 0 474.8 0zm-168 122.9l147-64.7L389.2 204.9c-3.4 7.7-2.5 16.7 2.4 23.5s13 10.7 21.4 10.1l33.5-2.6-116.4 163C301 439.7 253.8 464 203.6 464C117.8 464 48 393.6 48 307.5c0-49.7 23.6-96.9 63.4-126.5L276.2 58.6l-3 40.6c-.6 8.4 3.2 16.5 10.1 21.4s15.8 5.8 23.5 2.4zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faCarOn = {
  prefix: 'far',
  iconName: 'car-on',
  icon: [
    512,
    512,
    [],
    'e4dd',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM185.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L365.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM416 368l0 32L96 400l0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z',
  ],
};
const faSleigh = {
  prefix: 'far',
  iconName: 'sleigh',
  icon: [
    640,
    512,
    [],
    'f7cc',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 176c0 62.5 44.8 114.5 104 125.8l0 50.2-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l504 0c44.2 0 80-35.8 80-80l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 17.7-14.3 32-32 32l-120 0 0-48.2C507 379.6 560 324 560 256l0-112 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0-24 0-24 0-56 0c-22.1 0-40 17.9-40 40l0 45.7c0 23.3-18.9 42.3-42.3 42.3c-58.3 0-112.5-30-143.4-79.5l-18.9-30.2C182.5 67.9 133.7 38.1 80 32.8c-5.1-.5-10.2-.8-15.4-.8L64 32l-1 0L32 32l-8 0zM392 432l-208 0 0-48 208 0 0 48zm40-96l-40 0-208 0-24 0c-44.2 0-80-35.8-80-80L80 81.1c37.2 5 70.5 26.3 90.7 58.6L189.6 170c39.7 63.5 109.2 102 184.1 102c49.9 0 90.3-40.4 90.3-90.3l0-37.7 48 0 0 112c0 44.2-35.8 80-80 80z',
  ],
};
const faArrowDown19 = {
  prefix: 'far',
  iconName: 'arrow-down-1-9',
  icon: [
    576,
    512,
    ['sort-numeric-asc', 'sort-numeric-down'],
    'f162',
    'M456 56c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 53.4 357 67 361.2 79.6S379 99 391.6 94.8L408 89.3l0 38.7 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-48 0-72zM143 473c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm281-89a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-17.9 46.2l-8.7 10.6c-8.4 10.3-6.9 25.4 3.4 33.8s25.4 6.9 33.8-3.4l56.8-69.4C504.7 385.5 512 365.1 512 344c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.5 30.1 77.9 70.1 86.2z',
  ],
};
const faSortNumericAsc = faArrowDown19;
const faSortNumericDown = faArrowDown19;
const faBuoyMooring = {
  prefix: 'far',
  iconName: 'buoy-mooring',
  icon: [
    576,
    512,
    [],
    'e5b6',
    'M264 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 42.6c42.6 9.4 76.7 43.2 85.3 87.5l47.1 241.2c-.4 .3-.8 .6-1.2 .9c-13.3 9.2-28.9 15.9-43.8 18.8L383.9 336l-191.9 0-15.4 78.9c-14.9-2.9-30.5-9.6-43.8-18.8c-.4-.3-.8-.6-1.3-.9l47.1-241.2c8.6-44.3 42.8-78.1 85.3-87.5L264 24zm24 88c-30.3 0-56.4 21.5-62.2 51.3L201.4 288l173.1 0L350.2 163.3C344.4 133.5 318.3 112 288 112zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faSquare4 = {
  prefix: 'far',
  iconName: 'square-4',
  icon: [
    448,
    512,
    [],
    'e259',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm127.6 97.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z',
  ],
};
const faHandHoldingDroplet = {
  prefix: 'far',
  iconName: 'hand-holding-droplet',
  icon: [
    576,
    512,
    ['hand-holding-water'],
    'f4c1',
    'M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3l0 1.7c0 53-43 96-96 96s-96-43-96-96l0-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faHandHoldingWater = faHandHoldingDroplet;
const faFileEps = {
  prefix: 'far',
  iconName: 'file-eps',
  icon: [
    512,
    512,
    [],
    'e644',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64 0-64zm144-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm117.7-80l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L424 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z',
  ],
};
const faTricycleAdult = {
  prefix: 'far',
  iconName: 'tricycle-adult',
  icon: [
    640,
    512,
    [],
    'e5c4',
    'M288 88c0-13.3 10.7-24 24-24l38.9 0c18.7 0 36.2 9.4 46.6 24.9L512.4 261.3c9.9-3.4 20.5-5.3 31.6-5.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-24.6 9.3-47 24.5-64l-13.4-20.1-39.8 53.1c-14.7 19.5-37.7 31.1-62.1 31.1c-5 0-10-.5-14.9-1.4l-55.1-10.7c.5 4 .8 8.1 .8 12.2c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c.6-.4 1.3-.8 1.9-1.1c-14.5 8.9-31.6 14-49.9 14c-53 0-96-43-96-96c0-24.4 9.1-46.6 24-63.5l-4.6-.9c-13-2.5-21.5-15.1-19-28.2s15.1-21.5 28.2-19l322.9 63c1.9 .4 3.8 .5 5.7 .5c9.3 0 18.1-4.4 23.7-11.9l50-66.6-73.3-110c-1.5-2.2-4-3.6-6.7-3.6L312 112c-13.3 0-24-10.7-24-24zM186.6 320.2c3.5 10 5.4 20.7 5.4 31.8c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l-47.8-9.3zM48.7 97.1c12.6-4 26.1 2.9 30.2 15.5l15.3 47.9c2.7 8.3 9.7 14.6 18.3 16.2l84.1 16.4c13 2.5 21.5 15.1 19 28.2s-15.1 21.5-28.2 19l-84.1-16.4c-25.8-5-46.8-23.7-54.8-48.7L33.1 127.3c-4-12.6 2.9-26.1 15.5-30.2zM144 352a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm448 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faWaveform = {
  prefix: 'far',
  iconName: 'waveform',
  icon: [
    640,
    512,
    [],
    'f8f1',
    'M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264l22.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.3 0 26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z',
  ],
};
const faWater = {
  prefix: 'far',
  iconName: 'water',
  icon: [
    576,
    512,
    [],
    'f773',
    'M80 78.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7C41 104.8 62.8 93 80 78.1zm0 288c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm31.9-144c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faStarSharpHalfStroke = {
  prefix: 'far',
  iconName: 'star-sharp-half-stroke',
  icon: [
    576,
    512,
    ['star-sharp-half-alt'],
    'e28d',
    'M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176 56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-158.4 0L310.9 16.7zM288 103.2s0 0 0 0l33.1 104.1c3.2 10 12.4 16.7 22.9 16.7l106.1 0-88.8 69.1c-7.9 6.2-11.2 16.6-8.1 26.2l32.5 102.3-82.9-64.5c-4.3-3.4-9.5-5.1-14.7-5.1l0-248.8z',
  ],
};
const faStarSharpHalfAlt = faStarSharpHalfStroke;
const faNfcSignal = {
  prefix: 'far',
  iconName: 'nfc-signal',
  icon: [
    512,
    512,
    [],
    'e1fb',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l166 0c-3.4 15.5-5.3 31.6-5.8 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 131c-16.6 2.5-32.6 6.6-48 12l0-143c0-8.8-7.2-16-16-16zm-16 72l0 100.8c-17.2 8.8-33.3 19.4-48 31.6L320 160l-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM239 400l-119 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 133.7 0c-9.1 15.1-16.7 31.1-22.7 48zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z',
  ],
};
const faPlaneProp = {
  prefix: 'far',
  iconName: 'plane-prop',
  icon: [
    576,
    512,
    [],
    'e22b',
    'M267.3 176l49.5 0L299.1 48l-14.2 0L267.3 176zM344.7 27.6l5 36.4c.7-.1 1.5-.1 2.2-.1l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-9.4 0 6.6 48 93.1 0c21 0 48.1 6.2 70.4 17.4C549.4 203.8 576 223.9 576 256c0 32.5-26.4 52.6-47.4 63c-22.5 11.1-49.5 17-70.3 17l-93.1 0-6.6 48 9.4 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-.8 0-1.5 0-2.2-.1l-5 36.4C342.5 500.2 329 512 313 512L271 512c-16 0-29.5-11.8-31.7-27.6l-5-36.4L224 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l1.4 0-7.2-52.4-75.7-9.1-5.8 34.3C134.3 372.4 120.8 384 105 384l-34 0c-15.9 0-29.4-11.7-31.7-27.4L28.7 287.8C12.6 286.2 0 272.5 0 256s12.6-30.2 28.7-31.8l10.7-68.7C41.6 139.7 55.1 128 71 128l34 0c15.8 0 29.3 11.6 31.6 27.2l5.8 34.3 75.7-9.1 7.2-52.4-1.4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l10.3 0 5-36.4C241.5 11.8 255 0 271 0L313 0c16 0 29.5 11.8 31.7 27.6zM267.3 336l17.7 128 14.2 0 17.7-128-49.5 0zm191.1-48c13.4 0 33.1-4.1 49-12c17.4-8.6 20.7-16.5 20.7-20c0-2.9-3.2-10.8-20.8-19.7c-15.9-8-35.7-12.3-48.9-12.3l-200.9 0L125.5 239.8c-12.7 1.5-24.4-7.2-26.5-19.8l-7.5-44-6.8 0L72.3 256l12.4 80 6.8 0L99 292c2.2-12.6 13.8-21.3 26.5-19.8L257.4 288l200.9 0z',
  ],
};
const faCalendarCheck = {
  prefix: 'far',
  iconName: 'calendar-check',
  icon: [
    448,
    512,
    [],
    'f274',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faClockDesk = {
  prefix: 'far',
  iconName: 'clock-desk',
  icon: [
    448,
    512,
    [],
    'e134',
    'M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM224 0C347.7 0 448 100.3 448 224l0 240c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 224C0 100.3 100.3 0 224 0zm0 96c13.3 0 24 10.7 24 24l0 94.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17l0-104c0-13.3 10.7-24 24-24z',
  ],
};
const faCalendarClock = {
  prefix: 'far',
  iconName: 'calendar-clock',
  icon: [
    576,
    512,
    ['calendar-time'],
    'e0d2',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-112 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
  ],
};
const faCalendarTime = faCalendarClock;
const faBraille = {
  prefix: 'far',
  iconName: 'braille',
  icon: [
    640,
    512,
    [],
    'f2a1',
    'M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faPrescriptionBottleMedical = {
  prefix: 'far',
  iconName: 'prescription-bottle-medical',
  icon: [
    384,
    512,
    ['prescription-bottle-alt'],
    'f486',
    'M48 48l288 0 0 32L48 80l0-32zM32 0C14.3 0 0 14.3 0 32L0 96c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0zm0 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-48 0 0 288c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-288-48 0zm133.3 80l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faPrescriptionBottleAlt = faPrescriptionBottleMedical;
const faPlateUtensils = {
  prefix: 'far',
  iconName: 'plate-utensils',
  icon: [
    640,
    512,
    [58713],
    'e43b',
    'M24 16c13.3 0 24 10.7 24 24l0 128c0 4.4 3.6 8 8 8l8 0L64 40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 8 0c4.4 0 8-3.6 8-8l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128c0 30.9-25.1 56-56 56l-8 0 0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-8 0c-30.9 0-56-25.1-56-56L0 40C0 26.7 10.7 16 24 16zM560 160l0 112 32 0 0-56 0-130.8c-16.6 15.3-32 39.1-32 74.8zm32 160l-48 0c-17.7 0-32-14.3-32-32l0-128C512 59.2 596.2 23.2 613.1 17c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9L640 216l0 56 0 48 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152zM336 480c-81.5 0-152.8-43.5-192-108.6l0-118.8c5.7-1.6 11.1-3.8 16.3-6.4c-.2 3.2-.3 6.5-.3 9.7c0 97.2 78.8 176 176 176c70.8 0 131.8-41.8 159.7-102c10.6 12.2 25.8 20.3 42.8 21.8C502.6 427.6 425.4 480 336 480zM208 72.2C244.3 46.8 288.4 32 336 32c60.3 0 115 23.8 155.3 62.5c-6.5 17.5-10.6 37.5-11.2 60.3C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2l0-63.1zM416 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z',
  ],
};
const faFamilyPants = {
  prefix: 'far',
  iconName: 'family-pants',
  icon: [
    512,
    512,
    [],
    'e302',
    'M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 60.6 0c-3 10.1-4.6 20.9-4.6 32l0 16-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 11.4 2.4 22.2 6.7 32l-32.3 0L128 208l-22.4 0zM336 176c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0-16c0-11.1-1.6-21.9-4.6-32l60.6 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208L384 208l-22.4 0-32.3 0c4.3-9.8 6.7-20.6 6.7-32zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16l0-16zm48 16c0 24-13.2 44.9-32.7 55.8c.5 2.7 .7 5.4 .7 8.2l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-2.8 .2-5.5 .7-8.2C189.2 396.9 176 376 176 352l0-16c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16z',
  ],
};
const faHoseReel = {
  prefix: 'far',
  iconName: 'hose-reel',
  icon: [
    640,
    512,
    [],
    'e41a',
    'M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5C428 494 376.1 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256l0 96 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.3 0-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L514.3 400l-2.3 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96c0-114.9-93.1-208-208-208zM208 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM320 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faHouseWindow = {
  prefix: 'far',
  iconName: 'house-window',
  icon: [
    576,
    512,
    [],
    'e3b3',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM256 288l0-64 64 0 0 64-64 0zm-48-72l0 80c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40z',
  ],
};
const faLandmark = {
  prefix: 'far',
  iconName: 'landmark',
  icon: [
    512,
    512,
    [127963],
    'f66f',
    'M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM256 51.4L423.8 144 88.2 144 256 51.4zM112 224l-48 0 0 160-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z',
  ],
};
const faTruck = {
  prefix: 'far',
  iconName: 'truck',
  icon: [
    640,
    512,
    [128666, 9951],
    'f0d1',
    'M352 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-32 0-76.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l288 0zm32 368c0 53 43 96 96 96s96-43 96-96l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-122.7c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l64 0 32 0 24 0 8 0zM557.7 239.6c.1 .1 .3 .3 .4 .4l-142 0 0-96 42.7 0c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faMusicMagnifyingGlass = {
  prefix: 'far',
  iconName: 'music-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e662',
    'M352 367.2c80.9-8 144-76.2 144-159.2c0-88.4-71.6-160-160-160c-72.7 0-134 48.5-153.5 114.8l-52.6 17.5C143.3 78.6 230.5 0 336 0C450.9 0 544 93.1 544 208c0 48.8-16.8 93.7-44.9 129.1L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L465.1 371.1c-32 25.4-71.6 41.5-114.9 44.4c1.1-4.9 1.8-10.1 1.8-15.5c0-1.4 0-2.8-.1-4.2c.1-1.3 .1-2.5 .1-3.8l0-24.8zM320 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64C86.6 228.5 80 237.7 80 248l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48z',
  ],
};
const faCrosshairs = {
  prefix: 'far',
  iconName: 'crosshairs',
  icon: [
    512,
    512,
    [],
    'f05b',
    'M256 0c13.3 0 24 10.7 24 24l0 17.3C380.1 52.4 459.6 131.9 470.7 232l17.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-17.3 0C459.6 380.1 380.1 459.6 280 470.7l0 17.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.3C131.9 459.6 52.4 380.1 41.3 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l17.3 0C52.4 131.9 131.9 52.4 232 41.3L232 24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3l0-30.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.3c73.6-10.5 131.8-68.7 142.3-142.3L392 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.3 0C411.8 158.4 353.6 100.2 280 89.7l0 30.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-30.3C158.4 100.2 100.2 158.4 89.7 232l30.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.3 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCloudRainbow = {
  prefix: 'far',
  iconName: 'cloud-rainbow',
  icon: [
    576,
    512,
    [],
    'f73e',
    'M291.5 195.2C344.7 107 441.5 48 552 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C420.9 0 306.5 71.7 245.9 178.1c10.8 6 20.8 13.4 29.6 21.9c5.2-1.9 10.5-3.5 16-4.8zM394.6 216c38.1-44.1 94.5-72 157.4-72c13.3 0 24-10.7 24-24s-10.7-24-24-24c-82.4 0-155.7 38.9-202.5 99.4c16.5 3.9 31.8 11 45.2 20.6zm42.9 53.3c9.8 2.8 19.2 6.7 28 11.6C486.1 255.9 517.2 240 552 240c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.1 0-94.8 23-124.1 59.1c3.7 5.8 6.9 11.8 9.7 18.2zM112 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 462.4 48 436.2 48 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C26.4 322.1 0 359.9 0 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 247 366.9 216 320 216c-18 0-34.9 4.6-49.7 12.6C248.5 206.1 217.9 192 184 192z',
  ],
};
const faPersonCane = {
  prefix: 'far',
  iconName: 'person-cane',
  icon: [
    448,
    512,
    [],
    'e53c',
    'M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 209.5L76.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L93.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l35 0c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L256 214.2 256 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1L176 176l0 128 32 0 0-127.9zM352 376l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-30.9 25.1-56 56-56s56 25.1 56 56l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-4.4-3.6-8-8-8s-8 3.6-8 8z',
  ],
};
const faAlien = {
  prefix: 'far',
  iconName: 'alien',
  icon: [
    448,
    512,
    [128125],
    'f8f5',
    'M194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2zM224 48c97.2 0 176 78.8 176 176c0 50.4-28.2 101.3-68.2 146.9c-39.2 44.7-84.2 78.1-105.6 92.7c0 0 0 0 0 0s0 0 0 0c0 0 0 0-.1 0l-.1 0c0 0-.1 0-.1 0l-.1 0c-.3 .1-.9 .2-1.8 .2s-1.4-.1-1.8-.2c-.1 0-.2-.1-.2-.1l-.1 0c0 0 0 0-.1 0c0 0 0 0 0 0s0 0 0 0c-21.4-14.6-66.4-48-105.6-92.7C76.2 325.3 48 274.4 48 224c0-97.2 78.8-176 176-176zm16 258.3c0 7.6 6.1 13.7 13.7 13.7l32 0c45.4 0 82.3-36.8 82.3-82.3c0-7.6-6.1-13.7-13.7-13.7l-32 0c-45.4 0-82.3 36.8-82.3 82.3zM125.7 224l-32 0c-7.6 0-13.7 6.1-13.7 13.7c0 45.4 36.8 82.3 82.3 82.3l32 0c7.6 0 13.7-6.1 13.7-13.7c0-45.4-36.8-82.3-82.3-82.3z',
  ],
};
const faTent = {
  prefix: 'far',
  iconName: 'tent',
  icon: [
    576,
    512,
    [],
    'e57d',
    'M274.4 4.2c8.2-5.7 19-5.7 27.3 0L521.5 155.9c13.5 9.3 22.2 24 23.9 40.2l26.7 254c3.5 33.1-22.4 61.9-55.7 61.9L440 512l-176 0L59.5 512C26.3 512 .4 483.2 3.9 450.1l26.7-254c1.7-16.3 10.4-31 23.9-40.2L274.4 4.2zM516.5 464c4.7 0 8.5-4.1 8-8.8l-26.7-254c-.2-2.3-1.5-4.4-3.4-5.7L312 69.7l0 209.6L413.6 464l102.9 0zM264 69.7L81.7 195.4c-1.9 1.3-3.2 3.4-3.4 5.7l-26.7 254c-.5 4.7 3.2 8.8 8 8.8L264 464l0-136 0-136 0-122.3z',
  ],
};
const faLaptopBinary = {
  prefix: 'far',
  iconName: 'laptop-binary',
  icon: [
    640,
    512,
    [],
    'e5e7',
    'M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM200 128c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0zm80 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 16 32 0 0-32c0-8.8-7.2-16-16-16l-16 0zm240 0l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 16 32 0 0-32c0-8.8-7.2-16-16-16zm-64 40c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40l0 8 32 0 0-8c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 32 0 0-8z',
  ],
};
const faVestPatches = {
  prefix: 'far',
  iconName: 'vest-patches',
  icon: [
    448,
    512,
    [],
    'e086',
    'M178.5 81.5l28.8 95-25.1 82.8-64-211.2c-.3 0-.6-.1-.9-.1L104 48c-4.4 0-8 3.6-8 8l0 72 0 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3L48 456c0 4.4 3.6 8 8 8l120.4 0c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1L56 512c-30.9 0-56-25.1-56-56L0 293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3L48 128l0-72C48 25.1 73.1 0 104 0l13.3 0 6.8 0c10.1 0 19.5 3.8 26.7 10.2c4.6 2.8 8.6 6 12 9C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8c3.4-3.1 7.5-6.2 12-9C304.4 3.8 313.8 0 323.9 0l6.8 0L344 0c30.9 0 56 25.1 56 56l0 72 0 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37L448 456c0 30.9-25.1 56-56 56l-128 0c-30.9 0-56-25.1-56-56l0-160.9c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5zM329.8 48.1L257 288.2c-.7 2.3-1 4.6-1 7L256 456c0 4.4 3.6 8 8 8l128 0c4.4 0 8-3.6 8-8l0-162.7c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37l0-58.7 0-72c0-3.9-2.7-7.1-6.4-7.8c-.5-.1-1.1-.2-1.6-.2l-13.3 0c-.3 0-.6 0-.9 .1zM288 288l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-32 0c-8.8 0-16-7.2-16-16l0-32zM84.7 260.7c6.2-6.2 16.4-6.2 22.6 0L120 273.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 296l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 318.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 296 84.7 283.3c-6.2-6.2-6.2-16.4 0-22.6zM112 360a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
  ],
};
const faPeopleDressSimple = {
  prefix: 'far',
  iconName: 'people-dress-simple',
  icon: [
    512,
    512,
    [],
    'e218',
    'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM112.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L192.4 336 63.6 336 96.9 219.6c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM368.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336l-128.7 0 33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z',
  ],
};
const faCheckDouble = {
  prefix: 'far',
  iconName: 'check-double',
  icon: [
    448,
    512,
    [],
    'f560',
    'M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z',
  ],
};
const faArrowDownAZ = {
  prefix: 'far',
  iconName: 'arrow-down-a-z',
  icon: [
    576,
    512,
    ['sort-alpha-asc', 'sort-alpha-down'],
    'f15d',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm305-89c-13.3 0-24 10.7-24 24s10.7 24 24 24l74.6 0L334.1 440.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 480 352 480l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-74.6 0 92.5-104.1c6.3-7.1 7.8-17.2 4-25.8S489.4 288 480 288l-128 0zM416 32c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 200l85.2 0c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160C433.4 37.1 425.1 32 416 32zM394.8 152L416 109.7 437.2 152l-42.3 0z',
  ],
};
const faSortAlphaAsc = faArrowDownAZ;
const faSortAlphaDown = faArrowDownAZ;
const faBowlingBallPin = {
  prefix: 'far',
  iconName: 'bowling-ball-pin',
  icon: [
    576,
    512,
    [],
    'e0c3',
    'M464 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM438.3 230.2l-1 2.7c-8.5-27.4-21.8-52.7-38.8-74.9c-.4-2.5-1-5-1.6-7.4l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7l0-4.4c0-44.2 35.8-80 80-80s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L563 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L536 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.6 0-23.9-7.3-29.1-18.8l-10.6-23.3c12.6-13.1 23.7-27.7 33-43.4l17 37.5 65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM168 196a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm28 60a28 28 0 1 1 0 56 28 28 0 1 1 0-56zM96 244a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm272 60A160 160 0 1 0 48 304a160 160 0 1 0 320 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304z',
  ],
};
const faBellSchoolSlash = {
  prefix: 'far',
  iconName: 'bell-school-slash',
  icon: [
    640,
    512,
    [],
    'f5d6',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM156.5 97.3C185.6 66.9 226.6 48 272 48c88.4 0 160 71.6 160 160c0 31.6-9.1 61-24.9 85.8L356.3 254c7.5-13.7 11.7-29.3 11.7-46c0-53-43-96-96-96c-25 0-47.7 9.5-64.8 25.1L156.5 97.3zm161 126.2l-71.3-55.9c7.5-4.8 16.4-7.6 25.9-7.6c26.5 0 48 21.5 48 48c0 5.4-.9 10.6-2.6 15.5zM467.1 464L414 464c1.3-5.1 2-10.5 2-16l0-24.2-85-67C312.7 364 292.8 368 272 368c-88.4 0-160-71.6-160-160c0-7.6 .5-15.2 1.6-22.5l-42-33.1C66.6 170.1 64 188.7 64 208c0 59 24.6 112.2 64 150.1l0 89.9c0 35.3 28.7 64 64 64l144 0 16 0 128 0c13.1 0 25.3-3.5 35.9-9.6L467.1 464zM336 464l-144 0c-8.8 0-16-7.2-16-16l0-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4l0 55.4c0 8.8-7.2 16-16 16l-16 0z',
  ],
};
const faPlusLarge = {
  prefix: 'far',
  iconName: 'plus-large',
  icon: [
    512,
    512,
    [],
    'e59e',
    'M488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208 208 0z',
  ],
};
const faMoneyBillWheat = {
  prefix: 'far',
  iconName: 'money-bill-wheat',
  icon: [
    512,
    512,
    [],
    'e52a',
    'M176 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zM56 16C42.7 16 32 26.7 32 40s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 16zM24 88C10.7 88 0 98.7 0 112s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 88zm8 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM272 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zm80 144c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM352 128c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5l305 0c3.6 29 26.6 51.9 55.5 55.5l0 49c-29 3.6-51.9 26.6-55.5 55.5l-305 0c-3.6-29-26.6-51.9-55.5-55.5l0-49zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faCameraViewfinder = {
  prefix: 'far',
  iconName: 'camera-viewfinder',
  icon: [
    512,
    512,
    ['screenshot'],
    'e0da',
    'M56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0zM376 0l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM173.8 120.2c6.3-14.7 20.8-24.2 36.8-24.2l90.9 0c16 0 30.5 9.5 36.8 24.2l3.3 7.8 10.5 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l10.5 0 3.3-7.8zm42 23.8l-7.5 17.5c-3.8 8.8-12.5 14.5-22.1 14.5L160 176c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-26.3 0c-9.6 0-18.3-5.7-22.1-14.5L296.2 144l-80.3 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z',
  ],
};
const faScreenshot = faCameraViewfinder;
const faMessageMusic = {
  prefix: 'far',
  iconName: 'message-music',
  icon: [
    512,
    512,
    ['comment-alt-music'],
    'f8af',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faCommentAltMusic = faMessageMusic;
const faCarBuilding = {
  prefix: 'far',
  iconName: 'car-building',
  icon: [
    640,
    512,
    [],
    'f859',
    'M288 48L64 48c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l128 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 64.5c-17.5 1.7-33.9 7.7-48 17.1L304 64c0-8.8-7.2-16-16-16zM256 219.1l-13.1 36.6c-.9 .2-1.9 .3-2.9 .3l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 11.1zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm265.8-96c-10.1 0-19.2 6.4-22.6 15.9L322.1 272l219.9 0-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9l-140.3 0zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8l140.3 0c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368l0 32 0 16 0 32 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-320 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40 0-32 0-16 0-32c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320l-224 0c-26.5 0-48 21.5-48 48l0 32 320 0 0-32c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faBorderBottomRight = {
  prefix: 'far',
  iconName: 'border-bottom-right',
  icon: [
    448,
    512,
    ['border-style-alt'],
    'f854',
    'M448 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 352c0 13.3-10.7 24-24 24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l352 0c39.8 0 72-32.2 72-72l0-352zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
  ],
};
const faBorderStyleAlt = faBorderBottomRight;
const faOctagon = {
  prefix: 'far',
  iconName: 'octagon',
  icon: [
    512,
    512,
    [128721],
    'f306',
    'M170.5 57.4c6-6 14.1-9.4 22.6-9.4l125.7 0c8.5 0 16.6 3.4 22.6 9.4L454.6 170.5c6 6 9.4 14.1 9.4 22.6l0 125.7c0 8.5-3.4 16.6-9.4 22.6L341.5 454.6c-6 6-14.1 9.4-22.6 9.4l-125.7 0c-8.5 0-16.6-3.4-22.6-9.4L57.4 341.5c-6-6-9.4-14.1-9.4-22.6l0-125.7c0-8.5 3.4-16.6 9.4-22.6L170.5 57.4zM136.6 23.4L23.4 136.6C8.4 151.6 0 171.9 0 193.1L0 318.9c0 21.2 8.4 41.6 23.4 56.6L136.6 488.6c15 15 35.4 23.4 56.6 23.4l125.7 0c21.2 0 41.6-8.4 56.6-23.4L488.6 375.4c15-15 23.4-35.4 23.4-56.6l0-125.7c0-21.2-8.4-41.6-23.4-56.6L375.4 23.4C360.4 8.4 340.1 0 318.9 0L193.1 0c-21.2 0-41.6 8.4-56.6 23.4z',
  ],
};
const faCommentArrowUpRight = {
  prefix: 'far',
  iconName: 'comment-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e145',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM200 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z',
  ],
};
const faOctagonDivide = {
  prefix: 'far',
  iconName: 'octagon-divide',
  icon: [
    512,
    512,
    [],
    'e203',
    'M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faCookie = {
  prefix: 'far',
  iconName: 'cookie',
  icon: [
    512,
    512,
    [127850],
    'f563',
    'M240.5 64.6c-12-1.7-24.3 .5-35.1 6.2l-74 39.5C120.7 116 112 125 106.6 136L69.9 211.6c-5.4 11-7.1 23.5-5 35.6L79.4 330c2.1 12.1 8 23.2 16.8 31.7l60.3 58.4c8.8 8.5 20 14 32 15.7l83 11.7c12 1.7 24.3-.5 35.1-6.2l74-39.5C391.3 396 400 387 405.4 376l36.7-75.5c5.4-11 7.1-23.5 5-35.6L432.6 182c-2.1-12.1-8-23.2-16.8-31.7L355.5 91.9c-8.8-8.5-20-14-32-15.7l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM288 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faArrowRotateLeft = {
  prefix: 'far',
  iconName: 'arrow-rotate-left',
  icon: [
    512,
    512,
    [8634, 'arrow-left-rotate', 'arrow-rotate-back', 'arrow-rotate-backward', 'undo'],
    'f0e2',
    'M40 224c-13.3 0-24-10.7-24-24L16 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80.1 20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-50.4 0-97-16.7-134.4-44.8c-10.6-8-12.7-23-4.8-33.6s23-12.7 33.6-4.8C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176s-78.8-176-176-176c-54.3 0-102.9 24.6-135.2 63.4l-.1 .2s0 0 0 0L93.1 176l90.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 224z',
  ],
};
const faArrowLeftRotate = faArrowRotateLeft;
const faArrowRotateBack = faArrowRotateLeft;
const faArrowRotateBackward = faArrowRotateLeft;
const faUndo = faArrowRotateLeft;
const faTvMusic = {
  prefix: 'far',
  iconName: 'tv-music',
  icon: [
    640,
    512,
    [],
    'f8e6',
    'M576 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l512 0zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM96 488c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-13.3 0-24 10.7-24 24zM416 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faHardDrive = {
  prefix: 'far',
  iconName: 'hard-drive',
  icon: [
    512,
    512,
    [128436, 'hdd'],
    'f0a0',
    'M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faHdd = faHardDrive;
const faReel = {
  prefix: 'far',
  iconName: 'reel',
  icon: [
    448,
    512,
    [],
    'e238',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l40 0 0 40c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L384 0 344 0 104 0 64 0 24 0zm80 72l0-24 240 0 0 24L104 72zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0 240 0 40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24L88 400c-13.3 0-24 10.7-24 24l0 40-40 0zm320 0l-240 0 0-24 240 0 0 24zM80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 144zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 272zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 336z',
  ],
};
const faFaceGrinSquintTears = {
  prefix: 'far',
  iconName: 'face-grin-squint-tears',
  icon: [
    512,
    512,
    [129315, 'grin-squint-tears'],
    'f586',
    'M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z',
  ],
};
const faGrinSquintTears = faFaceGrinSquintTears;
const faDumbbell = {
  prefix: 'far',
  iconName: 'dumbbell',
  icon: [
    640,
    512,
    [],
    'f44b',
    'M128 88c0-30.9 25.1-56 56-56l16 0c30.9 0 56 25.1 56 56l0 144 128 0 0-144c0-30.9 25.1-56 56-56l16 0c30.9 0 56 25.1 56 56l0 16 24 0c30.9 0 56 25.1 56 56l0 72 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 30.9-25.1 56-56 56l-24 0 0 16c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-144-128 0 0 144c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-16-24 0c-30.9 0-56-25.1-56-56l0-72-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-72c0-30.9 25.1-56 56-56l24 0 0-16zm48 16l0 24 0 256 0 24 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-336c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 16zm-48 48l-24 0c-4.4 0-8 3.6-8 8l0 192c0 4.4 3.6 8 8 8l24 0 0-208zM464 384l0-256 0-24 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 0-24zm72-24c4.4 0 8-3.6 8-8l0-192c0-4.4-3.6-8-8-8l-24 0 0 208 24 0z',
  ],
};
const faRectangleList = {
  prefix: 'far',
  iconName: 'rectangle-list',
  icon: [
    576,
    512,
    ['list-alt'],
    'f022',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faListAlt = faRectangleList;
const faTarpDroplet = {
  prefix: 'far',
  iconName: 'tarp-droplet',
  icon: [
    576,
    512,
    [],
    'e57c',
    'M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128l133.5 0c7 19.8 20.3 36.6 37.5 48L64 176c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l352 0 0-80c0-17.7 14.3-32 32-32l80 0 0-160c0-8.8-7.2-16-16-16l-170.9 0c17.2-11.4 30.5-28.2 37.5-48L512 128c35.3 0 64 28.7 64 64l0 172.1c0 12.7-5.1 24.9-14.1 33.9l-99.9 99.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faAlarmExclamation = {
  prefix: 'far',
  iconName: 'alarm-exclamation',
  icon: [
    512,
    512,
    [],
    'f843',
    'M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM432 288A176 176 0 1 0 80 288a176 176 0 1 0 352 0zM396.5 462.5C358.1 493.4 309.2 512 256 512s-102.1-18.6-140.5-49.5L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l42.5-42.5C50.6 390.1 32 341.2 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 53.2-18.6 102.1-49.5 140.5L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42.5-42.5zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24-168l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHouseMedicalCircleCheck = {
  prefix: 'far',
  iconName: 'house-medical-circle-check',
  icon: [
    640,
    512,
    [],
    'e511',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm32 112a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faTrafficCone = {
  prefix: 'far',
  iconName: 'traffic-cone',
  icon: [
    512,
    512,
    [],
    'f636',
    'M217.8 15c3.7-9 12.5-15 22.2-15l32 0c9.8 0 18.6 5.9 22.2 15L476.9 464l11.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l11.1 0L217.8 15zM386 368l-260 0L86.9 464l338.1 0-39-96zm-19.5-48L320.9 208l-129.9 0L145.5 320l221 0zM210.6 160l90.8 0L256 48.4 210.6 160z',
  ],
};
const faGrate = {
  prefix: 'far',
  iconName: 'grate',
  icon: [
    448,
    512,
    [],
    'e193',
    'M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l72 0 96 0 96 0 72 0c30.9 0 56-25.1 56-56l0-168 0-168c0-30.9-25.1-56-56-56l-72 0-96 0-96 0L56 32zm48 48l0 152-56 0L48 88c0-4.4 3.6-8 8-8l48 0zM48 280l56 0 0 152-48 0c-4.4 0-8-3.6-8-8l0-144zM152 432l0-152 48 0 0 152-48 0zm96 0l0-152 48 0 0 152-48 0zm96 0l0-152 56 0 0 144c0 4.4-3.6 8-8 8l-48 0zm56-200l-56 0 0-152 48 0c4.4 0 8 3.6 8 8l0 144zM296 80l0 152-48 0 0-152 48 0zm-96 0l0 152-48 0 0-152 48 0z',
  ],
};
const faArrowDownRight = {
  prefix: 'far',
  iconName: 'arrow-down-right',
  icon: [
    384,
    512,
    [],
    'e093',
    'M328 416c13.3 0 24-10.7 24-24l0-240c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l231 231L88 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0z',
  ],
};
const faPersonSkiingNordic = {
  prefix: 'far',
  iconName: 'person-skiing-nordic',
  icon: [
    576,
    512,
    ['skiing-nordic'],
    'f7ca',
    'M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8c1.2 1.5 2.6 2.7 4.1 3.8L67 464l-43 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l287.5 0c.4 0 .7 0 1.1 0L504 512c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-69.4 0 27.2-176.7c10.4-2.6 18.2-12 18.2-23.3c0-13.3-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zM429.4 288L402.3 464l-57.6 0L371 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C361.3 272 383 288 407.6 288l21.7 0zM99.7 464l55.8-265.1 40.6-34.8c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L294.4 464l-103.7 0 36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464l-40.3 0zM316.1 175.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L289 169l27.1 6.8z',
  ],
};
const faSkiingNordic = faPersonSkiingNordic;
const faCalendarPlus = {
  prefix: 'far',
  iconName: 'calendar-plus',
  icon: [
    448,
    512,
    [],
    'f271',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z',
  ],
};
const faPersonFromPortal = {
  prefix: 'far',
  iconName: 'person-from-portal',
  icon: [
    512,
    512,
    ['portal-exit'],
    'e023',
    'M72.2 436C58.7 404.6 48 348.4 48 256s10.7-148.6 24.2-180C84.6 47.3 94.6 47.9 95.9 48l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180c0 45.7-2.6 82.6-6.9 112L120 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l7 0s0 0 0 0l49.7 0s0 0 0 0l28.2 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368l-13.8 0c4.2-31.3 6.4-68.4 6.4-112c0-21.4-.5-41.2-1.6-59.6l37.7-32.4c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L184.7 138C170.3 38 136 0 96 0C43 0 0 66.6 0 256S43 512 96 512c28 0 53.2-18.6 70.7-64l-52.9 0c-9.5 16.5-16.7 16.1-17.8 16l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-19.9 79.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8z',
  ],
};
const faPortalExit = faPersonFromPortal;
const faPlaneArrival = {
  prefix: 'far',
  iconName: 'plane-arrival',
  icon: [
    640,
    512,
    [128748],
    'f5af',
    'M552.2 333.2c4.3 4 2.8 11.1-2.8 12.9c-26.5 8.8-54.9 9.7-81.9 2.6L141.9 264c-1.2-.3-2.3-.9-3.2-1.7l-87.7-75c-1.8-1.5-2.8-3.7-2.8-6.1l-.2-86.6 18.2 4.6c2.5 .6 4.5 2.4 5.5 4.8l25.9 64.8c2.8 7 8.8 12.3 16.1 14.3l113.9 30.4c8.4 2.2 17.4-.2 23.4-6.5s8.3-15.3 5.8-23.6L216.3 48 242 48 349.1 238.4c3.2 5.6 8.5 9.8 14.7 11.4l113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.6 29.2zm12.3 58.5c40.3-13.3 51.5-65 20.3-93.8l-31.6-29.2c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 281.5 20.4C274.4 7.8 261.1 0 246.6 0L205.5 0c-26.8 0-46 25.8-38.3 51.5l31.4 104.6-60.8-16.2L116.4 86.3c-6.7-16.7-21-29.2-38.4-33.5L49.7 45.7C24.5 39.4 0 58.5 0 84.6l.2 96.8s0 0 0 0c0 16.3 7.2 31.8 19.6 42.4l87.7 75c6.4 5.5 14.1 9.5 22.3 11.6l325.5 84.7c35.9 9.4 73.8 8.1 109.1-3.5zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464zm168-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCowbellCirclePlus = {
  prefix: 'far',
  iconName: 'cowbell-circle-plus',
  icon: [
    576,
    512,
    ['cowbell-more'],
    'f8b4',
    'M176 48l96 0 0 48-96 0 0-48zm-48-8l0 56-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l214.6 0c-4.3-15.3-6.6-31.4-6.6-48L48 368l64-224 224 0 18.8 65.8c14.2-7 29.6-12.1 45.6-15l-18.3-64C376.3 110.2 357.4 96 336 96l-16 0 0-56c0-22.1-17.9-40-40-40L168 0c-22.1 0-40 17.9-40 40zm32 408c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6L160 448zm272 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faCowbellMore = faCowbellCirclePlus;
const faCircleLeft = {
  prefix: 'far',
  iconName: 'circle-left',
  icon: [
    512,
    512,
    [61840, 'arrow-alt-circle-left'],
    'f359',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z',
  ],
};
const faArrowAltCircleLeft = faCircleLeft;
const faDistributeSpacingVertical = {
  prefix: 'far',
  iconName: 'distribute-spacing-vertical',
  icon: [
    512,
    512,
    [],
    'e366',
    'M0 56C0 69.3 10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56zM368 208l0 96-224 0 0-96 224 0zM144 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faSignalBarsFair = {
  prefix: 'far',
  iconName: 'signal-bars-fair',
  icon: [
    640,
    512,
    ['signal-alt-2'],
    'f692',
    'M240 304c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm-64 16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 128c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128zM80 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 16 448a64 64 0 1 1 128 0z',
  ],
};
const faSignalAlt2 = faSignalBarsFair;
const faSportsball = {
  prefix: 'far',
  iconName: 'sportsball',
  icon: [
    512,
    512,
    [],
    'e44b',
    'M447 99c3.8 33.4 4.4 70.2-.1 107c-25.6-8.1-49.2-20.8-69.7-37.2L447 99zm-9 154.5c-7.2 28-17.9 55.2-33 79.8c-4.7 7.7-9.9 15.1-15.5 22.3L289.9 256l53.1-53.1c27.5 22.9 59.7 40.3 94.9 50.6zM356.1 390.1c-19.4 16.1-42.4 29.6-69.7 39.8c-10.2 3.8-21 7.1-32.4 9.9c-10.2-35.9-27.8-68.7-51.1-96.7L256 289.9 356.1 390.1zM206.3 447.8c-31.5 3.2-67 3-106.9-1.3l69.3-69.3c16.6 20.8 29.5 44.6 37.5 70.6zM22.9 455.2s0 0 0 0c.5 2.7 1 5.3 1.6 7.9c1.6 7.5 5.7 14 11.4 18.6c4.2 3.3 9.2 5.6 14.6 6.5c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-1.5-7.1-5.2-13.3-10.5-17.8c-.7-.6-1.5-1.3-2.3-1.8c-3.9-2.8-8.4-4.7-13.3-5.5c-2.1-.3-4.2-.7-6.2-1c0 0 0 0 0 0C395.7 13.3 343 11.7 296.6 16.9c0 0 0 0 0 0c-16.6 1.9-32.4 4.6-47.5 8.1c0 0 0 0 0 0c-14.1 3.3-27.5 7.4-40.3 12.1c-34.1 12.7-63 30-87.1 50.7c0 0 0 0 0 0C109.4 98.5 98.3 110 88.3 122.2c0 0 0 0 0 0c-8.2 10-15.6 20.5-22.2 31.4c-18.4 29.9-31 62.5-39.2 95.7c0 0 0 0 0 0c-3.9 15.7-6.8 31.6-8.8 47.4c0 0 0 0 0 0c-7.4 56.9-3.6 113 4.9 158.4zM65 413c-3.8-33.4-4.4-70.2 .1-107c25.6 8.1 49.2 20.8 69.7 37.2L65 413zm9-154.5c7.2-28 17.9-55.2 33-79.8c4.7-7.7 9.9-15.1 15.5-22.3L222.1 256l-53.1 53.1c-27.5-22.9-59.7-40.3-94.9-50.6zm81.9-136.6c19.4-16.1 42.4-29.6 69.7-39.8c10.2-3.8 21-7.1 32.4-9.9c10.2 35.9 27.8 68.7 51.1 96.7L256 222.1 155.9 121.9zM305.7 64.2c31.5-3.2 67-3 106.9 1.3l-69.3 69.3c-16.6-20.8-29.5-44.6-37.5-70.6z',
  ],
};
const faGameConsoleHandheldCrank = {
  prefix: 'far',
  iconName: 'game-console-handheld-crank',
  icon: [
    576,
    512,
    [],
    'e5b9',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 176 32 0 0-72 0-32c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24l-56 0 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 160c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zm120 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faTrainSubway = {
  prefix: 'far',
  iconName: 'train-subway',
  icon: [
    448,
    512,
    ['subway'],
    'f239',
    'M200 48l0 160L48 208 48 96c0-26.5 21.5-48 48-48l104 0zm48 0l104 0c26.5 0 48 21.5 48 48l0 112-152 0 0-160zM48 352l0-96 352 0 0 96c0 26.5-21.5 48-48 48L96 400c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96L0 352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 188.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352l0-256c0-53-43-96-96-96L96 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faSubway = faTrainSubway;
const faChartGantt = {
  prefix: 'far',
  iconName: 'chart-gantt',
  icon: [
    512,
    512,
    [],
    'e0e4',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm88 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faFaceSmileUpsideDown = {
  prefix: 'far',
  iconName: 'face-smile-upside-down',
  icon: [
    512,
    512,
    [],
    'e395',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM177.6 193.9C192.8 177.5 218.8 160 256 160s63.2 17.5 78.4 33.9c9 9.7 24.2 10.4 33.9 1.4s10.4-24.2 1.4-33.9c-22-23.8-60-49.4-113.6-49.4s-91.7 25.5-113.6 49.4c-9 9.7-8.4 24.9 1.4 33.9s24.9 8.4 33.9-1.4zM208.4 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
  ],
};
const faBallPile = {
  prefix: 'far',
  iconName: 'ball-pile',
  icon: [
    576,
    512,
    [],
    'f77e',
    'M336 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 0c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96zm-96 96c-9.9 0-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zm0 64c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256zM144 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faBadgeDollar = {
  prefix: 'far',
  iconName: 'badge-dollar',
  icon: [
    512,
    512,
    [],
    'f645',
    'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20l0 17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6l0 18c0 11 9 20 20 20s20-9 20-20l0-17.1c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4l0-17.3z',
  ],
};
const faMoneyBillsSimple = {
  prefix: 'far',
  iconName: 'money-bills-simple',
  icon: [
    640,
    512,
    ['money-bills-alt'],
    'e1f4',
    'M576 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z',
  ],
};
const faMoneyBillsAlt = faMoneyBillsSimple;
const faListTimeline = {
  prefix: 'far',
  iconName: 'list-timeline',
  icon: [
    512,
    512,
    [],
    'e1d1',
    'M219.9 112L400 112l0-32L219.9 80l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L416 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm187.9 16L400 432l0-32-180.1 0-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L416 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM203.9 256l16 16L464 272l0-32-244.1 0-16 16zm-13.3 54.6l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L480 192c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-266.7 0c-8.5 0-16.6-3.4-22.6-9.4z',
  ],
};
const faIndianRupeeSign = {
  prefix: 'far',
  iconName: 'indian-rupee-sign',
  icon: [
    320,
    512,
    ['indian-rupee', 'inr'],
    'e1bc',
    'M0 56C0 42.7 10.7 32 24 32l80 0 192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84.7 0c17.7 19.8 30.1 44.6 34.7 72l50 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-50 0c-11.4 68.1-70.7 120-142 120l-5.1 0L262 436.5c10.8 7.7 13.3 22.7 5.6 33.5s-22.7 13.3-33.5 5.6l-224-160C1.6 309.5-2 298.6 1.1 288.7S13.6 272 24 272l80 0c44.7 0 82.3-30.6 93-72L24 200c-13.3 0-24-10.7-24-24s10.7-24 24-24l173 0c-10.7-41.4-48.2-72-93-72L24 80C10.7 80 0 69.3 0 56z',
  ],
};
const faIndianRupee = faIndianRupeeSign;
const faInr = faIndianRupeeSign;
const faCropSimple = {
  prefix: 'far',
  iconName: 'crop-simple',
  icon: [
    512,
    512,
    ['crop-alt'],
    'f565',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 56L24 80C10.7 80 0 90.7 0 104s10.7 24 24 24l56 0 0 248c0 30.9 25.1 56 56 56l216 0 0-48-216 0c-4.4 0-8-3.6-8-8l0-352zM384 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-248c0-30.9-25.1-56-56-56L160 80l0 48 216 0c4.4 0 8 3.6 8 8l0 352z',
  ],
};
const faCropAlt = faCropSimple;
const faMoneyBill1 = {
  prefix: 'far',
  iconName: 'money-bill-1',
  icon: [
    576,
    512,
    ['money-bill-alt'],
    'f3d1',
    'M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faMoneyBillAlt = faMoneyBill1;
const faLeftLong = {
  prefix: 'far',
  iconName: 'left-long',
  icon: [
    512,
    512,
    ['long-arrow-alt-left'],
    'f30a',
    'M6.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6L6.5 272.4zm153.5 93l0-53.5c0-13.3 10.7-24 24-24l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-6.4 0-12.5-2.5-17-7s-7-10.6-7-17l0-53.5L57 256 160 365.5z',
  ],
};
const faLongArrowAltLeft = faLeftLong;
const faKeyboardDown = {
  prefix: 'far',
  iconName: 'keyboard-down',
  icon: [
    576,
    512,
    [],
    'e1c2',
    'M64 48c-8.8 0-16 7.2-16 16l0 176c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-176c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 176c0 35.3-28.7 64-64 64L64 304c-35.3 0-64-28.7-64-64L0 64zM159 359c9.4-9.4 24.6-9.4 33.9 0l95 95 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L305 505c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L159 393c-9.4-9.4-9.4-24.6 0-33.9zm1-167c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16zM120 88l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm96-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm96-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z',
  ],
};
const faCircleUpRight = {
  prefix: 'far',
  iconName: 'circle-up-right',
  icon: [
    512,
    512,
    [],
    'e129',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L336 160c8.8 0 16 7.2 16 16l0 137.4z',
  ],
};
const faCloudBoltMoon = {
  prefix: 'far',
  iconName: 'cloud-bolt-moon',
  icon: [
    576,
    512,
    ['thunderstorm-moon'],
    'f76d',
    'M361.4 79.9c31.2 18.7 52.5 52.2 54.3 90.8c33.3 15.8 57.6 47.5 63 85.3c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9zM128.1 160c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0l-72.1 0-8 16.1 18.3 0c20.3 0 38.4 12.8 45.2 31.9l16.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3C374.9 126.9 339.1 96 296.1 96c-14.7 0-28.5 3.6-40.6 9.9C238.1 80.6 209.1 64 176.1 64c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 169 .1 208.5 .1 256c0 43.4 28.8 80 68.3 91.9c3.1-6.6 7.6-12.6 13.6-17.4l33.3-26.6-16.4 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm154 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z',
  ],
};
const faThunderstormMoon = faCloudBoltMoon;
const faTurnLeftUp = {
  prefix: 'far',
  iconName: 'turn-left-up',
  icon: [
    384,
    512,
    [],
    'e638',
    'M208.4 6.5c-9.2-8.7-23.7-8.7-32.9 0L46.6 127.9c-9.3 8.8-14.6 21-14.6 33.7C32 187.3 52.7 208 78.3 208l41.7 0 0 144c0 88.4 71.6 160 160 160l48 0c30.9 0 56-25.1 56-56l0-32c0-30.9-25.1-56-56-56l-56 0c-4.4 0-8-3.6-8-8l0-152 41.7 0c25.6 0 46.3-20.7 46.3-46.3c0-12.8-5.3-25-14.6-33.7L208.4 6.5zm93 153.5L240 160c-13.3 0-24 10.7-24 24l0 176c0 30.9 25.1 56 56 56l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-48 0c-61.9 0-112-50.1-112-112l0-168c0-13.3-10.7-24-24-24l-61.5 0L192 57 301.5 160z',
  ],
};
const faDna = {
  prefix: 'far',
  iconName: 'dna',
  icon: [
    448,
    512,
    [129516],
    'f471',
    'M416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 2.7-.1 5.4-.2 8L80.2 32c-.2-2.6-.2-5.3-.2-8C80 10.7 69.3 0 56 0S32 10.7 32 24c0 55.6 24.5 101.9 58.1 141.9c27.2 32.4 61.5 62 95.8 90.1c-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.7 .1-5.4 .2-8l287.5 0c.2 2.6 .2 5.3 .2 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-55.6-24.5-101.9-58.1-141.9c-20.6-24.5-45.2-47.3-70.8-69.2c-8.7 7.1-17.3 14.1-25.7 20.9c0 0 0 0 0 0l-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1c11.2 9.4 22.1 18.8 32.3 28.3l-115 0c22-20.4 46.7-40.4 72.2-61c.3-.2 .5-.4 .8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384l205.8 0c12.4 15.7 22.4 31.6 29.4 48L91.7 432c7-16.4 17-32.3 29.4-48zM91.7 80l264.5 0c-7 16.4-17 32.3-29.4 48l-205.8 0c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1c-20.3-16.5-39.7-32.7-57.5-49.1l115 0z',
  ],
};
const faVirusSlash = {
  prefix: 'far',
  iconName: 'virus-slash',
  icon: [
    640,
    512,
    [],
    'e075',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zM220 147.1c39 4.3 78.6-14.2 100-47.6c23.3 36.4 68.4 55.1 110.6 45.8c-9.3 42.2 9.4 87.3 45.8 110.6c-21.2 13.6-36.4 34.5-43.6 58L220 147.1zM402 412.7l-44.6-35.1c-14.9 8.2-27.9 20.1-37.4 34.8c-23.3-36.4-68.4-55.1-110.6-45.8c9.3-42.2-9.4-87.3-45.8-110.6c7.1-4.5 13.6-9.9 19.2-16l-38.1-30c-9.5 8.5-22.2 14-37.2 14L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-31.2 23.6-52.7 50-55.7z',
  ],
};
const faBracketRoundRight = {
  prefix: 'far',
  iconName: 'bracket-round-right',
  icon: [
    192,
    512,
    [],
    '29',
    'M35.4 43.7c-6.8 11.4-3 26.1 8.3 32.9C76.7 96.3 144 160.7 144 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4c-11.4-6.8-26.1-3-32.9 8.3z',
  ],
};
const faCircleSterling = {
  prefix: 'far',
  iconName: 'circle-sterling',
  icon: [
    512,
    512,
    [],
    'e5cf',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5 40.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40.3 0 .1 9.7c.1 18.6-3.1 37-9.6 54.3L328 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1-7.7 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l7.5 0-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z',
  ],
};
const faCircle5 = {
  prefix: 'far',
  iconName: 'circle-5',
  icon: [
    512,
    512,
    [],
    'e0f2',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5 .4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1c0 17.3-14 31.3-31.3 31.3l-36 0c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6l36 0c43.8 0 79.3-35.5 79.3-79.3c0-40.3-30.3-74.3-70.4-78.8L220.2 219l7.8-43 84 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0z',
  ],
};
const faMinus = {
  prefix: 'far',
  iconName: 'minus',
  icon: [
    448,
    512,
    [8211, 8722, 10134, 'subtract'],
    'f068',
    'M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z',
  ],
};
const faSubtract = faMinus;
const faFireFlame = {
  prefix: 'far',
  iconName: 'fire-flame',
  icon: [
    384,
    512,
    ['flame'],
    'f6df',
    'M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zM189.3 163.8c1.7-2.4 4.4-3.8 7.4-3.8c5 0 9.1 4.1 9.1 9.1l0 10.8c0 7.8 3.1 15.3 8.5 20.8l44.1 45.1c19 19.4 29.6 45.5 29.6 72.6l0 1.6c0 53-43 96-96 96s-96-43-96-96l0-11.4c0-18.4 6.6-36.3 18.6-50.3l6-7c1.8-2.1 4.4-3.3 7.1-3.3c5.2 0 9.4 4.2 9.4 9.4l0 40.9c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7l0-1.5c0-10.2-3.9-19.9-11-27.3l-11-11.4c-12.3-12.8-19.2-29.8-19.2-47.5c0-14.4 4.5-28.4 13-40.1l4.9-6.7z',
  ],
};
const faFlame = faFireFlame;
const faRightToLine = {
  prefix: 'far',
  iconName: 'right-to-line',
  icon: [
    448,
    512,
    ['arrow-alt-to-right'],
    'f34c',
    'M192 146.2L302 256 192 365.8l0-53.8c0-13.3-10.7-24-24-24L48 288l0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM352 256c0-11.5-4.6-22.5-12.7-30.6L223.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L339.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM400 88l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faArrowAltToRight = faRightToLine;
const faGif = {
  prefix: 'far',
  iconName: 'gif',
  icon: [
    576,
    512,
    [],
    'e190',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM296 160c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm56 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3l0-51.9c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z',
  ],
};
const faChess = {
  prefix: 'far',
  iconName: 'chess',
  icon: [
    512,
    512,
    [],
    'f439',
    'M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L66.9 96C43.2 96 24 115.2 24 138.9c0 4.7 .8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352l48 0 2.1-96 57.6 0 2.1 96 48 0-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5c0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8c0-23.7-19.2-42.9-42.9-42.9L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm16.2 192l-64.4 0L74 144l108 0-21.8 64zm-91 224l117.6 0 16.6 32L52.7 464l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512L192 512l23.2 0 80.5 0 24.2 0 152.2 0c22 0 39.8-17.8 39.8-39.8c0-6.8-1.7-13.4-5-19.3l-31.4-56.6c-4.2-7.6-12.3-12.3-21-12.3l-141.2 0c-8.7 0-16.7 4.7-21 12.3L261 452.9c-3.2 5.8-5 12.4-5 19.1c0 0 0 0 0 0c0-.2 0-.5 0-.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3l-137 0zM256 184l0 72c0 5 1.6 9.9 4.5 13.9L296 319.7l0 32.3 48 0 0-40c0-5-1.6-9.9-4.5-13.9L304 248.3l0-40.3 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 40.3-35.5 49.7c-2.9 4.1-4.5 8.9-4.5 13.9l0 40 48 0 0-32.3 35.5-49.7c2.9-4.1 4.5-8.9 4.5-13.9l0-72c0-13.3-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm53.8 280l17.8-32 112.9 0 17.8 32-148.5 0z',
  ],
};
const faTrashSlash = {
  prefix: 'far',
  iconName: 'trash-slash',
  icon: [
    640,
    512,
    [],
    'e2b3',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.3 359.8 508.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0L413.5 24.9C403.1 9.4 385.6 0 366.9 0L273.1 0c-18.7 0-36.2 9.4-46.6 24.9L189.8 80l-13.7 0-41.8 0L38.8 5.1zM195.6 128l264.7 0L445.8 324.1 195.6 128zM479.2 473.6l-42.1-33.1-.6 8.7c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L188.3 244.4l-51.1-40.3 18.4 248.6c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c26.1 0 48.8-15.7 58.7-38.4zM273.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6z',
  ],
};
const faArrowLeftLong = {
  prefix: 'far',
  iconName: 'arrow-left-long',
  icon: [
    512,
    512,
    ['long-arrow-left'],
    'f177',
    'M7 239c-9.4 9.4-9.4 24.6 0 33.9L143 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 232l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z',
  ],
};
const faLongArrowLeft = faArrowLeftLong;
const faPlugCircleCheck = {
  prefix: 'far',
  iconName: 'plug-circle-check',
  icon: [
    576,
    512,
    [],
    'e55c',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faFontCase = {
  prefix: 'far',
  iconName: 'font-case',
  icon: [
    640,
    512,
    [],
    'f866',
    'M198.4 47.5C194.9 38.2 186 32 176 32s-18.9 6.2-22.4 15.5l-152 400c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L83.1 368l185.8 0 36.7 96.5c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31l-152-400zM250.7 320l-149.3 0L176 123.6 250.7 320zM616 160c-13.3 0-24 10.7-24 24l0 8.8c-22.1-20.4-51.6-32.8-84-32.8c-68.5 0-124 55.5-124 124l0 72c0 68.5 55.5 124 124 124c32.4 0 61.9-12.4 84-32.8l0 8.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-13.3-10.7-24-24-24zM432 284c0-42 34-76 76-76s76 34 76 76l0 72c0 42-34 76-76 76s-76-34-76-76l0-72z',
  ],
};
const faStreetView = {
  prefix: 'far',
  iconName: 'street-view',
  icon: [
    512,
    512,
    [],
    'f21d',
    'M256 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 256 0a72 72 0 1 0 0 144zM192 280s0 0 0 0l0-40c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 40s0 0 0 0c-19.4 4.9-33.8 21.3-36 41.2l-6.2 55.6c-.5 4.1-3.9 7.1-8 7.1l-27.8 0c-4.1 0-7.5-3.1-8-7.1L228 321.3c-2.2-19.9-16.6-36.3-36-41.2zm-5.6 102.2c3.2 28.4 27.1 49.8 55.7 49.8l27.8 0c28.5 0 52.5-21.5 55.7-49.8l6.2-55.6c20.8-5.2 36.3-24.1 36.3-46.6l0-40c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l0 40c0 22.5 15.4 41.3 36.3 46.6l6.2 55.6zm-54.1 12c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z',
  ],
};
const faArrowDownLeft = {
  prefix: 'far',
  iconName: 'arrow-down-left',
  icon: [
    384,
    512,
    [],
    'e091',
    'M56 416c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1L311 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-231 231L296 368c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 416z',
  ],
};
const faFrancSign = {
  prefix: 'far',
  iconName: 'franc-sign',
  icon: [
    320,
    512,
    [],
    'e18f',
    'M72 32C58.7 32 48 42.7 48 56l0 160 0 104-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 320l0-80 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 192 96 80l200 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z',
  ],
};
const faFlaskRoundPoison = {
  prefix: 'far',
  iconName: 'flask-round-poison',
  icon: [
    448,
    512,
    ['flask-poison'],
    'f6e0',
    'M176 48l96 0 0 109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 352c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7l-219.6 0c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352c0-59 31.9-110.6 79.7-138.4c18.8-11 32.3-31.6 32.3-55.9L176 48zM320 157.7L320 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L304 0 144 0 120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l8 0 0 109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM286.8 378.4c15.6-13 25.2-30.8 25.2-50.4c0-39.8-39.4-72-88-72s-88 32.2-88 72c0 19.6 9.6 37.4 25.2 50.4c4.1 3.4 6.8 8.3 6.8 13.6l0 8c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16l0-8c0-5.3 2.7-10.2 6.8-13.6zM192 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faFlaskPoison = faFlaskRoundPoison;
const faVolumeOff = {
  prefix: 'far',
  iconName: 'volume-off',
  icon: [
    320,
    512,
    [],
    'f026',
    'M272 102.3L159.9 201.9c-4.4 3.9-10.1 6.1-15.9 6.1l-88 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l88 0c5.9 0 11.6 2.2 15.9 6.1L272 409.7l0-307.3zm-1.6-62.8c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8l0 388.4c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5L134.9 352 56 352c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l78.9 0L270.4 39.5z',
  ],
};
const faBookCircleArrowRight = {
  prefix: 'far',
  iconName: 'book-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e0bc',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l314.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l242.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 164.5c14.6-9.5 30.8-17 48-21.8L448 56c0-30.9-25.1-56-56-56L88 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
  ],
};
const faChartUser = {
  prefix: 'far',
  iconName: 'chart-user',
  icon: [
    640,
    512,
    ['user-chart'],
    'f6a3',
    'M576 48L224 48c-8.8 0-16 7.2-16 16l0 41.3c-14.8-6-31-9.3-48-9.3l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-8.3-18-19.8-34.2-33.7-48L576 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM412.7 139.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM160 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 400c-39.8 0-73.2 27.2-82.6 64l218.6 0c-9.5-36.8-42.9-64-82.6-64l-53.3 0zm0-48l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z',
  ],
};
const faUserChart = faChartUser;
const faHandsAslInterpreting = {
  prefix: 'far',
  iconName: 'hands-asl-interpreting',
  icon: [
    640,
    512,
    ['american-sign-language-interpreting', 'asl-interpreting', 'hands-american-sign-language-interpreting'],
    'f2a3',
    'M186.3 55.8l-51.8 86.3c-5.8 9.6-17.4 14-28.1 10.5S89 138.6 90 127.5l5.9-61.9c.8-8.8-5.6-16.6-14.4-17.4s-16.6 5.6-17.4 14.4l-16 168-.1 .8 0 .8 0 32c0 61.9 50.1 112 112 112l48 0c31.6 0 60.5-14.5 76.2-41.6c4.4-7.7 1.8-17.4-5.8-21.9c-2.5-1.4-5.1-2.1-7.7-2.2l-.3 0-.3 0c-5.5 .1-10.7 3-13.6 8C247.4 334.1 230 344 208 344c-30.9 0-56-25.1-56-56s25.1-56 56-56c11.6 0 21.7 1.8 30.1 5.8c8.9 4.2 14.8 10.3 18.4 16.6c2.9 5 8.1 7.9 13.6 8l.3 0 .3 0c2.6 0 5.2-.7 7.7-2.2c7.6-4.4 10.3-14.2 5.8-21.9c-6-10.3-13.5-18-21.9-23.6c-7.1-4.8-11.1-12.9-10.5-21.5s5.6-16.1 13.2-19.9l46.2-23.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-87.4 43.7c-9.5 4.8-21.1 2.7-28.3-5.2s-8.5-19.5-3-28.7l35.6-59.4c4.5-7.6 2.1-17.4-5.5-22s-17.4-2.1-22 5.5zm92.8 349.5C257.5 417.8 232.7 424 208 424l-48 0C71.6 424 0 352.4 0 264l0-32 0-1.9c0-.8 0-1.5 .1-2.3l.2-1.9 16-168C19.6 22.8 50.9-3.1 86.1 .3c24.7 2.4 44.9 18.5 53.4 40.1l5.6-9.3c18.2-30.3 57.5-40.1 87.8-22c26.9 16.2 37.7 49 27 77.4l15.4-7.7c31.4-15.7 69.5-3.2 85.5 28C382.5 94.2 407.3 88 432 88l48 0c88.4 0 160 71.6 160 160l0 32 0 1.9c0 .8 0 1.5-.1 2.3l-.2 1.9-16 168c-3.4 35.2-34.6 61-69.8 57.6c-24.7-2.4-44.9-18.5-53.4-40.1l-5.6 9.3c-18.2 30.3-57.5 40.1-87.8 22c-26.9-16.2-37.7-49-27-77.4l-15.4 7.7c-31.4 15.7-69.5 3.2-85.5-28zm174.6 51l51.8-86.3c5.8-9.6 17.4-14 28.1-10.5s17.5 13.9 16.4 25.1l-5.9 61.9c-.8 8.8 5.6 16.6 14.4 17.4s16.6-5.6 17.4-14.4l16-168 .1-.8 0-.8 0-32c0-61.9-50.1-112-112-112l-48 0c-31.6 0-60.5 14.5-76.2 41.6c-4.4 7.6-1.8 17.4 5.8 21.9c2.5 1.4 5.1 2.1 7.7 2.2l.3 0 .3 0c5.5-.1 10.7-3 13.6-8C392.6 177.9 410 168 432 168c30.9 0 56 25.1 56 56s-25.1 56-56 56c-11.6 0-21.7-1.8-30.1-5.8c-8.9-4.2-14.8-10.3-18.4-16.6c-2.9-5-8.1-7.9-13.6-8l-.3 0-.3 0c-2.6 0-5.2 .7-7.7 2.2c-7.7 4.4-10.3 14.2-5.8 21.9c6 10.3 13.5 18 21.9 23.6c7.1 4.8 11.1 12.9 10.6 21.5s-5.6 16.1-13.2 19.9l-46.2 23.1c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l87.4-43.7c9.5-4.8 21.1-2.7 28.3 5.2s8.5 19.5 3 28.7l-35.6 59.4c-4.5 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5zM224 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm208-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faAslInterpreting = faHandsAslInterpreting;
const faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faPresentationScreen = {
  prefix: 'far',
  iconName: 'presentation-screen',
  icon: [
    576,
    512,
    ['presentation'],
    'f685',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm8 80l0 216c0 30.9 25.1 56 56 56l176 0 0 46.1-73 73c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73-73 0-46.1 176 0c30.9 0 56-25.1 56-56l0-216-48 0 0 216c0 4.4-3.6 8-8 8l-200 0L88 304c-4.4 0-8-3.6-8-8L80 80 32 80z',
  ],
};
const faPresentation = faPresentationScreen;
const faCircleBolt = {
  prefix: 'far',
  iconName: 'circle-bolt',
  icon: [
    512,
    512,
    [],
    'e0fe',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM330.1 115.6c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272 160 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z',
  ],
};
const faFaceSmileHalo = {
  prefix: 'far',
  iconName: 'face-smile-halo',
  icon: [
    512,
    512,
    [],
    'e38f',
    'M512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zm-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32s192 14.3 192 32zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-14 5.8-29.6 11.1-46.4 15.6c17.8 29.1 28 63.3 28 99.9c0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9c-16.9-4.6-32.4-9.8-46.4-15.6zm172 128.3s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 244.4 120 262.1 120 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm-73.9 47.9c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm233.9-47.9s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 244.4 280 262.1 280 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
  ],
};
const faCartCircleArrowDown = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-down',
  icon: [
    640,
    512,
    [],
    'e3ef',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4l0-89.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4 28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faHousePersonReturn = {
  prefix: 'far',
  iconName: 'house-person-return',
  icon: [
    640,
    512,
    ['house-person-arrive', 'house-return'],
    'e011',
    'M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm66.2 266.6l-29.9-89.8c-7.7 1.2-15 3.6-21.7 7.1c.1 .3 .2 .7 .3 1l32.4 103.8 16.3-13.3c2.6-2.1 3.6-5.6 2.5-8.7zm-59 54.6l-28.5-91.3-10.5 36.7c-1.9 6.5-5.4 12.5-10.2 17.3L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l27.6-27.6 10.9-38.1c14.4-50.5 60.6-85.4 113.2-85.4l4.9 0c16.1 0 32.1 2.6 47.4 7.7c39.9 13.3 72.4 42.8 89.5 81.3l9.5 21.3c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-9.5-21.3c-10.9-24.4-30.9-43.5-55.6-53.3l22.8 68.3c7.4 22.1 .3 46.5-17.8 61.2L421.5 397.4l-22.1 96c-3 12.9-15.9 21-28.8 18s-21-15.9-18-28.8L375.4 384c2-8.7 6.8-16.4 13.8-22.1l50.1-40.7zm101.1 21l24.1 60.4L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-69.7-69.7c-3.8-3.8-6.8-8.4-8.9-13.4l-19.2-48 39-31.7zm-146.7-224l2.9 2.4c-13.5 8.9-25.6 20-35.7 32.8L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l226.8 0c-1.1 2.9-1.9 5.8-2.6 8.8L335.1 416 120 416c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0L371.1 99.8c6.3 7.4 14 13.7 22.6 18.4zM160 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z',
  ],
};
const faHousePersonArrive = faHousePersonReturn;
const faHouseReturn = faHousePersonReturn;
const faMessageXmark = {
  prefix: 'far',
  iconName: 'message-xmark',
  icon: [
    512,
    512,
    ['comment-alt-times', 'message-times'],
    'f4ab',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM175 127c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faCommentAltTimes = faMessageXmark;
const faMessageTimes = faMessageXmark;
const faFileCertificate = {
  prefix: 'far',
  iconName: 'file-certificate',
  icon: [
    512,
    512,
    ['file-award'],
    'f5f3',
    'M448 464l-224 0 0 32c0 5.5-1 10.9-2.7 16L448 512c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 71.1 .1-.1c1.5-.7 4-2 6.6-3c13.6-5.5 28.3-5.4 41.3-.5L176 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM109.2 161.6c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6L64 390.2 64 496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-105.8 15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z',
  ],
};
const faFileAward = faFileCertificate;
const faUserDoctorHairLong = {
  prefix: 'far',
  iconName: 'user-doctor-hair-long',
  icon: [
    448,
    512,
    [],
    'e459',
    'M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zm80 224c-5.4 0-10.8 .3-16 1l0 49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-41c-46.9 19-80 65-80 118.7l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-97.2 78.8-176 176-176l96 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-53.7-33.1-99.7-80-118.7l0 40.7c27.6 7.1 48 32.2 48 62l0 32c0 8.8-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-29.8 20.4-54.9 48-62l0-49c-5.2-.7-10.6-1-16-1l-96 0zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCameraSecurity = {
  prefix: 'far',
  iconName: 'camera-security',
  icon: [
    448,
    512,
    ['camera-home'],
    'f8fe',
    'M384 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l40.1 0L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3l272 0c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416l40.1 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM287.5 416l29.5 48-186.1 0 29.5-48 127 0zM336 208a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM224 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faCameraHome = faCameraSecurity;
const faGear = {
  prefix: 'far',
  iconName: 'gear',
  icon: [
    512,
    512,
    [9881, 'cog'],
    'f013',
    'M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z',
  ],
};
const faCog = faGear;
const faDropletSlash = {
  prefix: 'far',
  iconName: 'droplet-slash',
  icon: [
    640,
    512,
    ['tint-slash'],
    'f5c7',
    'M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192c0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8c-11.9 27.6-17 48.2-17 61.1c0 79.5 64.5 144 144 144zm185.2-93.3l125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L205.8 136c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.6-2.4 34.5-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6c0-13-5.1-33.5-17-61.1c-11.5-26.6-27.6-55.8-45.5-84.7c-29-46.8-61-90.2-81.5-117c-19.3 25.1-48.7 65-76.3 108.5L462.9 337.5zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6 .1 1.2 .1 1.7c0 30.9 25.1 56 56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z',
  ],
};
const faTintSlash = faDropletSlash;
const faBookHeart = {
  prefix: 'far',
  iconName: 'book-heart',
  icon: [
    448,
    512,
    [],
    'f499',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zm80-185.4c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
  ],
};
const faMosque = {
  prefix: 'far',
  iconName: 'mosque',
  icon: [
    640,
    512,
    [128332],
    'f678',
    'M400 0c7.6 0 14.7 3.6 19.2 9.6c18 24 40.1 42.1 66.5 59.5c15.7 10.3 31.3 19.5 48.2 29.3c13.1 7.6 26.9 15.7 42.2 25.2c31 19.2 48 53.2 48 88.3c0 25.6-8.9 49.2-23.8 67.7C623.8 291.4 640 315.8 640 344l0 96c0 39.8-32.2 72-72 72l-120 0-96 0-112 0-8 0L72 512c-39.8 0-72-32.2-72-72L0 176l0-35.3C0 96.3 20.5 54.3 55.6 27l25.7-20c8.7-6.7 20.8-6.7 29.5 0l25.7 20c26.9 20.9 45.2 50.4 52.3 83.1c-24.1 21.6-38.9 51-43.3 81.9l-1.4 0-96 0 0 248c0 13.3 10.7 24 24 24l92.1 0c-2.7-7.5-4.1-15.6-4.1-24l0-96c0-28.2 16.2-52.6 39.8-64.4C184.9 261 176 237.5 176 211.8c0-35.1 17-69.1 48-88.3c15.2-9.4 29.1-17.5 42.2-25.2c0 0 0 0 0 0c16.9-9.9 32.5-19 48.2-29.3c26.4-17.4 48.5-35.5 66.4-59.5C385.3 3.6 392.4 0 400 0zM232 464l8 0 16 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-50c0-19 8.4-37 23-49.2L400 344l25 20.8C439.6 377 448 395 448 414l0 50 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 24 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-52.2 0L400 320l-115.8 0L232 320c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24zM48 144l96 0 0-3.3c0-29.6-13.7-57.6-37.1-75.8L96 56.4 85.1 64.9C61.7 83.1 48 111.1 48 140.7l0 3.3zm528 67.8c0-19.9-9.6-37.7-25.3-47.5c-12.6-7.8-25.9-15.6-39-23.3c-18.3-10.8-36.5-21.4-52.4-31.9C438.2 95.3 418.1 80 400 61c-18.1 18.9-38.2 34.2-59.3 48.1c-16 10.5-34.1 21.1-52.4 31.9c-13.1 7.7-26.4 15.5-39 23.3C233.6 174.1 224 192 224 211.8c0 33.2 26.9 60.2 60.2 60.2L400 272l115.8 0c33.2 0 60.2-26.9 60.2-60.2z',
  ],
};
const faDuck = {
  prefix: 'far',
  iconName: 'duck',
  icon: [
    512,
    512,
    [129414],
    'f6d8',
    'M69.1 324.1c11.2 4.8 23.7 5.2 35.2 1l146.5-52.7c14.6-5.3 25.8-17.3 30-32.2s.9-31-8.8-43.1c-10-12.4-15.9-28-15.9-45.1c0-39.8 32.2-72 72-72s72 32.2 72 72c0 20.1-8.2 38.2-21.5 51.4l7.5 7.6-7.5-7.6c-7.1 7-13.6 15.5-18.4 25.5c-8.7 18.2-5.1 39.9 9 54.4c14.3 14.5 22.9 34.3 22.9 56l0 12.8c0 44.2-35.8 80-80 80l-116 0c-69.8 0-128.7-49.4-144.1-115.2l17.2 7.4zM446.8 135C438.5 76.8 388.5 32 328 32c-66.3 0-120 53.7-120 120c0 11.2 1.5 22 4.4 32.2c4.4 15.9 12.1 30.5 22.1 43l-47 16.9L88 280 37 258.1c-3.3-1.4-6.9-2.1-10.5-2.1C11.9 256 0 268.1 0 282.7C0 391 87.8 480 196 480l116 0c70.7 0 128-57.3 128-128l0-12.8c0-34.7-13.9-66.4-36.6-89.6c2.1-4.4 5.1-8.5 8.7-12c1.8-1.8 3.6-3.7 5.3-5.6l3.5 0c50.3 0 91.1-40.8 91.1-91.1c0-6.8-6-12.1-12.8-11.3L463.9 134c-5.7 .7-11.4 1-17.1 1zM344 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM299.2 289.1c-13.1-1.8-25.2 7.5-27 20.6c-2.7 20-18 38.3-40.8 44c-18.6 4.6-36.8-.5-49.3-11.6c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9c24.2 21.5 58.7 30.8 92.8 22.3c41.6-10.4 71.4-44.4 76.7-84.2c1.8-13.1-7.5-25.2-20.6-27z',
  ],
};
const faMosquito = {
  prefix: 'far',
  iconName: 'mosquito',
  icon: [
    640,
    512,
    [],
    'e52b',
    'M177.5 506.9c-10.3-8.2-12.2-23.5-4.3-34.1l43.1-57.3 0-55.6c0-5.8 2-11.4 5.7-15.8l62.3-74.6L154.6 387.8C97.6 447.6 0 405.2 0 320.6c0-47.9 34-88.3 79.3-94.2l153-23.9-40.8-40.9c-7.8-7.8-9.4-20.1-3.9-29.8l23.9-41.7L173.3 39.2c-8-10.6-6.1-25.9 4.3-34.1s25.2-6.3 33.2 4.4l48 63.9c5.9 7.9 6.6 18.6 1.7 27.2L237.8 140 288 190.3l0-38.1c0-14.9 10.2-27.4 24-31l0-57.2c0-4.4 3.6-8 8-8s8 3.6 8 8l0 57.2c13.8 3.6 24 16.1 24 31l0 38.2L402.2 140l-22.6-39.5c-4.9-8.6-4.2-19.3 1.7-27.2l48-63.9c8-10.6 22.8-12.6 33.2-4.4s12.2 23.5 4.3 34.1L428.5 90.1l23.9 41.7c5.5 9.7 3.9 22-3.9 29.8l-40.8 40.9 153 23.9c45.3 5.9 79.4 46.3 79.4 94.2c0 84.6-97.6 127-154.6 67.1L355.7 269.4 418 344c3.7 4.4 5.7 10 5.7 15.8l0 62.7 42.1 49c8.6 10.1 7.7 25.5-2.1 34.3s-24.7 7.9-33.4-2.1l-48-55.9c-3.8-4.4-5.9-10.2-5.9-16.1l0-62.9L352 339.7l0 68.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-68.1-24.3 29.2 0 54.9c0 5.4-1.7 10.6-4.9 14.9l-48 63.9c-8 10.6-22.8 12.6-33.2 4.4zM119.9 354.6c.8-.8 1.6-1.6 2.4-2.3L233.4 250.9l-146.6 23c-.4 .1-.8 .1-1.2 .2C65.8 276.6 48 295.1 48 320.6c0 22.3 12.2 37.3 27 43.7c14.5 6.3 31.3 4.5 44.9-9.7zM406.6 250.9L517.7 352.3c.8 .7 1.6 1.5 2.4 2.3c13.6 14.2 30.4 16 44.9 9.7c14.8-6.4 27-21.4 27-43.7c0-25.5-17.8-44-37.6-46.6c-.4-.1-.8-.1-1.2-.2L406.6 250.9z',
  ],
};
const faStarOfDavid = {
  prefix: 'far',
  iconName: 'star-of-david',
  icon: [
    512,
    512,
    [10017],
    'f69a',
    'M408.9 301.9L378.2 352l61.5 0-30.8-50.1zM380.8 256l-58.9-96-131.7 0-58.9 96 58.9 96 131.7 0 58.9-96zm56.3 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400 53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112l109.8 0 56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112l109.8 0c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-58.9-96l30.7 50.1L439.7 160l-61.5 0zm-85.8-48L256 52.7 219.6 112l72.8 0zM133.8 160l-61.5 0 30.8 50.1L133.8 160zM103.1 301.9L72.3 352l61.5 0-30.8-50.1zM219.6 400L256 459.3 292.4 400l-72.8 0z',
  ],
};
const faFlagSwallowtail = {
  prefix: 'far',
  iconName: 'flag-swallowtail',
  icon: [
    448,
    512,
    ['flag-alt'],
    'f74c',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24l0 8L0 80 0 304l0 48L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 376 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24L48 32l0-8zm0 56l328 0-62.4 83.2c-12.8 17.1-12.8 40.5 0 57.6L376 304 48 304 48 80z',
  ],
};
const faFlagAlt = faFlagSwallowtail;
const faPersonMilitaryRifle = {
  prefix: 'far',
  iconName: 'person-military-rifle',
  icon: [
    512,
    512,
    [],
    'e54b',
    'M160 39c0 13.8 11.2 25 25 25l151 0c8.8 0 16-7.2 16-16l0-30.6C352 8 344 .7 334.7 1.4L182.9 14.1C170 15.2 160 26 160 39zm277.9 1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9L327.2 231.6c-10.1-3.8-20.8-6.2-31.7-7.1c-2.5-.3-5-.4-7.6-.4l-2.7 0-58.5 0-2.7 0c-2.6 0-5.1 .1-7.5 .4c-35.7 3.1-68.5 22-88.9 52L36.2 410.5c-7.5 11-4.6 25.9 6.3 33.4s25.9 4.6 33.3-6.3L160 314.1 160 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-165.9 84.2 123.5c7.5 11 22.4 13.8 33.4 6.3s13.8-22.4 6.3-33.3l-85.2-125 38.6-66.9c8.8-15.3 3.6-34.9-11.7-43.7l-1.6-.9 55.5-96.1c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8-13.9-8zM304 403.6L228.8 272l56.5 0c1.7 0 3.5 .1 5.2 .2c7.7 1.2 13.5 7.8 13.5 15.8l0 115.6zm-96-71.3L283.2 464 208 464l0-131.6zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l-50.7 0c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16l-50.7 0c-1 5.2-1.6 10.5-1.6 16z',
  ],
};
const faCarGarage = {
  prefix: 'far',
  iconName: 'car-garage',
  icon: [
    640,
    512,
    [],
    'f5e2',
    'M331.4 2.9c-7.1-3.8-15.7-3.8-22.8 0l-296 160c-11.7 6.3-16 20.9-9.7 32.5s20.9 16 32.5 9.7L320 51.3 604.6 205.1c11.7 6.3 26.2 2 32.5-9.7s2-26.2-9.7-32.5l-296-160zM249.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L429.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C128.2 306.7 112 335.5 112 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L458 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM432 320c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48l224 0zM224 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCartShopping = {
  prefix: 'far',
  iconName: 'cart-shopping',
  icon: [
    576,
    512,
    [128722, 'shopping-cart'],
    'f07a',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM131.1 80l389.6 0L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8l-297.6 0L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faShoppingCart = faCartShopping;
const faBookFont = {
  prefix: 'far',
  iconName: 'book-font',
  icon: [
    448,
    512,
    [],
    'e0bf',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM261.5 93.3l88 176c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 256c-.4 0-.8 0-1.2 0l-96 0c-.4 0-.8 0-1.2 0l-17.4 34.8c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l88-176C222.6 85.1 230.9 80 240 80s17.4 5.1 21.5 13.3zM265.2 208L240 157.7 214.8 208l50.3 0z',
  ],
};
const faShieldPlus = {
  prefix: 'far',
  iconName: 'shield-plus',
  icon: [
    512,
    512,
    [],
    'e24a',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faVials = {
  prefix: 'far',
  iconName: 'vials',
  icon: [
    512,
    512,
    [],
    'f493',
    'M0 56C0 42.7 10.7 32 24 32l32 0 112 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 320c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 176 64 0 0-176L80 80zM288 56c0-13.3 10.7-24 24-24l32 0 112 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 320c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-320-8 0c-13.3 0-24-10.7-24-24zm80 24l0 176 64 0 0-176-64 0z',
  ],
};
const faEyeDropperFull = {
  prefix: 'far',
  iconName: 'eye-dropper-full',
  icon: [
    512,
    512,
    [],
    'e172',
    'M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c0 0 0 0 0 0l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9l0 52.9-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28 52.9 0c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6 183.4 198.6 53.1 329z',
  ],
};
const faDistributeSpacingHorizontal = {
  prefix: 'far',
  iconName: 'distribute-spacing-horizontal',
  icon: [
    512,
    512,
    [],
    'e365',
    'M456 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM304 368l-96 0 0-224 96 0 0 224zm48-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM80 24C80 10.7 69.3 0 56 0S32 10.7 32 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24L80 24z',
  ],
};
const faTabletRugged = {
  prefix: 'far',
  iconName: 'tablet-rugged',
  icon: [
    448,
    512,
    [],
    'f48f',
    'M352 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l256 0zM96 0C66.6 0 41.8 19.8 34.3 46.8L8.8 59.6C3.4 62.3 0 67.8 0 73.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 176l0 16L8.8 203.6C3.4 206.3 0 211.8 0 217.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 320l0 16L8.8 347.6C3.4 350.3 0 355.8 0 361.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3l25.5 12.7C41.8 492.2 66.6 512 96 512l256 0c29.4 0 54.2-19.8 61.7-46.8l25.5-12.7c5.4-2.7 8.8-8.2 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L413.7 46.8C406.2 19.8 381.4 0 352 0L96 0z',
  ],
};
const faTemperatureSnow = {
  prefix: 'far',
  iconName: 'temperature-snow',
  icon: [
    576,
    512,
    ['temperature-frigid'],
    'f768',
    'M368 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6L368 112zM432 0C370.1 0 320 50.1 320 112l0 161.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L544 112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8 0-55.8 35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4 200 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 25.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6l0 55.8-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6l0 55.8-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6l0 25.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.4 12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4l0-55.8 67.7 39.1c5.2-13.5 12-26.2 20.3-37.9l0-5.8-64-37 64-37 0-55.4z',
  ],
};
const faTemperatureFrigid = faTemperatureSnow;
const faMoped = {
  prefix: 'far',
  iconName: 'moped',
  icon: [
    640,
    512,
    [],
    'e3b9',
    'M328 56c0-13.3 10.7-24 24-24l41.3 0c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4l8.4 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-8.4 0c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8l-42.1 0c-.9 0-1.7 0-2.6-.1L288 384l-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32l0-32c0-70.7 57.3-128 128-128l96 0c17.7 0 32 14.3 32 32l0 80c0 17.7 14.3 32 32 32l40 0 31.3 0c14.5-46 49.1-83.1 93.6-100.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4L352 80c-13.3 0-24-10.7-24-24zM120 112l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 128l-80 0c-44.2 0-80 35.8-80 80l0 16 166.7 0c-4.3-9.8-6.7-20.6-6.7-32l0-64zM160 432c26.5 0 48-21.5 48-48l-96 0c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faFaceSmilePlus = {
  prefix: 'far',
  iconName: 'face-smile-plus',
  icon: [
    640,
    512,
    ['smile-plus'],
    'f5b9',
    'M544 0c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24zM400 288A176 176 0 1 0 48 288a176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM146 332.8c19.1 21.6 46.9 35.2 78 35.2s58.9-13.6 78-35.2c8.8-9.9 23.9-10.9 33.9-2.1s10.9 23.9 2.1 33.9C310.2 396.1 269.4 416 224 416s-86.2-19.9-114-51.5c-8.8-9.9-7.8-25.1 2.1-33.9s25.1-7.8 33.9 2.1z',
  ],
};
const faSmilePlus = faFaceSmilePlus;
const faRadioTuner = {
  prefix: 'far',
  iconName: 'radio-tuner',
  icon: [
    512,
    512,
    ['radio-alt'],
    'f8d8',
    'M511.1 17.6c3.5 12.8-4 26-16.8 29.5L201.2 128 448 128c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 304 0 192l0-3.4c0-32.4 21.6-60.8 52.9-69.4L481.6 .9c12.8-3.5 26 4 29.5 16.8zM48 272l0 32 0 144c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-176L48 272zm256 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM96 320l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faRadioAlt = faRadioTuner;
const faFaceSwear = {
  prefix: 'far',
  iconName: 'face-swear',
  icon: [
    640,
    512,
    [],
    'e399',
    'M320 48c114.9 0 208 93.1 208 208l48 0C576 114.6 461.4 0 320 0S64 114.6 64 256l48 0c0-114.9 93.1-208 208-208zM240.4 224c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32zM48 288c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 288zm352 96l-16 0 0 32 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0l0 32 32 0 0-32-32 0zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336l0 1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-2.3 1.7-2.2 4.5-.1 5.9c6.9 4.7 14.9 6.9 22.9 9.2c0 0 0 0 0 0c8.6 2.4 17.2 4.8 24.6 10.2c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4l0 .8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c3-1.8 2.9-6.7 .4-8.5c-6.8-5-15.2-7.3-23.6-9.7c-8.1-2.3-16.2-4.5-23.1-9.2c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7l0-1.5c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faWaterArrowDown = {
  prefix: 'far',
  iconName: 'water-arrow-down',
  icon: [
    576,
    512,
    ['water-lower'],
    'f774',
    'M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 137.7-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L312 161.7 312 24zM80 302.1C62.8 317 41 328.8 18.8 333.8C5.9 336.7-2.3 349.5 .6 362.5s15.7 21.1 28.7 18.2C58 374.2 81.6 360.2 96 350.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm0 128C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0z',
  ],
};
const faWaterLower = faWaterArrowDown;
const faScannerTouchscreen = {
  prefix: 'far',
  iconName: 'scanner-touchscreen',
  icon: [
    512,
    512,
    [],
    'f48a',
    'M128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zM384 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-13.3-10.7-24-24-24zM64 144l224 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 80c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-144 0z',
  ],
};
const faCircle7 = {
  prefix: 'far',
  iconName: 'circle-7',
  icon: [
    512,
    512,
    [],
    'e0f4',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l103.8 0-93 172.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l112-208c4-7.4 3.8-16.4-.5-23.7s-12.2-11.7-20.6-11.7l-144 0z',
  ],
};
const faPlugCirclePlus = {
  prefix: 'far',
  iconName: 'plug-circle-plus',
  icon: [
    576,
    512,
    [],
    'e55f',
    'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM104 0c13.3 0 24 10.7 24 24l0 88-48 0 0-88C80 10.7 90.7 0 104 0zM280 0c13.3 0 24 10.7 24 24l0 88-48 0 0-88c0-13.3 10.7-24 24-24zM0 168c0-13.3 10.7-24 24-24l8 0 48 0 224 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19.2c-18 9.2-34.2 21.4-48 36l0-55.2L80 192l0 64c0 61.9 50.1 112 112 112c24.3 0 46.9-7.8 65.2-20.9c-.8 6.9-1.2 13.9-1.2 20.9c0 11.4 1.1 22.5 3.1 33.3c-13.5 6.2-28 10.7-43.1 12.9l0 73.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-73.8C91 402.6 32 336.2 32 256l0-64-8 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faPersonSkiJumping = {
  prefix: 'far',
  iconName: 'person-ski-jumping',
  icon: [
    512,
    512,
    ['ski-jump'],
    'f7c7',
    'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 120c0-13.3 10.7-24 24-24l165.2 0c37 0 54.2 45.9 26.3 70.2L202.4 275 171 385 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7l0-7.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l113.2-58.6c-5.4-5.9-7.6-14.4-5.3-22.7l37.2-130.1c.1-.2 .1-.5 .2-.7l8.3-29c2.7-9.4 7.8-18 14.9-24.9c11.1-10.7 36.2-34.6 60.8-56.8L136 144c-13.3 0-24-10.7-24-24z',
  ],
};
const faSkiJump = faPersonSkiJumping;
const faPlaceOfWorship = {
  prefix: 'far',
  iconName: 'place-of-worship',
  icon: [
    640,
    512,
    [],
    'f67f',
    'M320 0c6.8 0 13.3 2.9 17.8 7.9l67.9 75.4c6.6 7.3 10.3 16.9 10.3 26.8l0 75.4 38.4 24.9c15.9 10.3 25.6 28 25.6 47L480 464l88 0c13.3 0 24-10.7 24-24l0-69.9c0-8.1-4.1-15.7-11-20.2l-69-44.7 0-57.2 95.1 61.5c20.5 13.3 32.9 36 32.9 60.4l0 69.9c0 39.8-32.2 72-72 72l-184 0s0 0 0 0l-160 0s0 0 0 0L72 512c-39.8 0-72-32.2-72-72l0-69.9c0-24.4 12.4-47.2 32.9-60.5L128 248.1l0 57.2L59 350c-6.8 4.4-11 12-11 20.2L48 440c0 13.3 10.7 24 24 24l88 0 0-206.6c0-19 9.6-36.7 25.6-47L224 185.5l0-75.4c0-9.9 3.7-19.4 10.3-26.8L302.2 7.9C306.7 2.9 313.2 0 320 0zM272 113.2l0 85.4c0 8.1-4.1 15.7-11 20.1l-49.4 32c-2.3 1.5-3.7 4-3.7 6.7L208 464l64 0 0-96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 96 64 0 0-206.6c0-2.7-1.4-5.2-3.7-6.7l-49.4-32c-6.8-4.4-11-12-11-20.1l0-85.4L320 59.9l-48 53.3z',
  ],
};
const faWaterArrowUp = {
  prefix: 'far',
  iconName: 'water-arrow-up',
  icon: [
    576,
    512,
    ['water-rise'],
    'f775',
    'M312 216c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.7-47.9 43.5c-9.8 8.9-25 8.2-33.9-1.6s-8.2-25 1.6-33.9l88-80c9.2-8.3 23.1-8.3 32.3 0l88 80c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6L312 78.3 312 216zM80 302.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm0 128c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z',
  ],
};
const faWaterRise = faWaterArrowUp;
const faWaveformLines = {
  prefix: 'far',
  iconName: 'waveform-lines',
  icon: [
    640,
    512,
    ['waveform-path'],
    'f8f2',
    'M320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM520 64c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24zM216 96c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zm208 32c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zM120 192c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM24 224c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm592 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24z',
  ],
};
const faWaveformPath = faWaveformLines;
const faSplit = {
  prefix: 'far',
  iconName: 'split',
  icon: [
    512,
    512,
    [],
    'e254',
    'M391 31c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-10.6 0-20.8 4.2-28.3 11.7L225.9 256l92.3 92.3c7.5 7.5 17.7 11.7 28.3 11.7l83.5 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-23.3 0-45.7-9.3-62.2-25.8L182.1 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l158.1 0L284.3 129.8c16.5-16.5 38.9-25.8 62.2-25.8l83.5 0L391 65c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faFilmCanister = {
  prefix: 'far',
  iconName: 'film-canister',
  icon: [
    576,
    512,
    ['film-cannister'],
    'f8b7',
    'M96 32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l40 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 384 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 512l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 80l-8 0C10.7 80 0 69.3 0 56S10.7 32 24 32l32 0 40 0zM80 80l0 384 192 0 0-384L80 80zm464 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32l-128 0 0-288 192 0zM392 184l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM392 344l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faFilmCannister = faFilmCanister;
const faFolderXmark = {
  prefix: 'far',
  iconName: 'folder-xmark',
  icon: [
    512,
    512,
    ['folder-times'],
    'f65f',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faFolderTimes = faFolderXmark;
const faToiletPaperBlank = {
  prefix: 'far',
  iconName: 'toilet-paper-blank',
  icon: [
    640,
    512,
    ['toilet-paper-alt'],
    'f71f',
    'M20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512l285.9 0c22.3 0 45.4-12.1 55.4-36.1c9.6-23.2 23.9-66.4 33.3-134.5l.1-.8c5.5-40.5 9.3-89.7 9.3-148.6c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144c-13.9 0-26.9-10-37.4-27.1c-2.2 22.3-4.9 42.5-7.9 60.8C463 378 478.2 384 496 384c24.5 0 44.1-11.4 58-24.5c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1c0 0 0-.1 0-.1L160 0C107 0 64 86 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6c0 0 0 0 0 .1zM419 48c-4.6 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 153.2-26.3 235-39 265.5c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2L73.8 464c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-47.2 9.7-87.5 23.1-114.3c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0l259 0zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z',
  ],
};
const faToiletPaperAlt = faToiletPaperBlank;
const faTabletScreen = {
  prefix: 'far',
  iconName: 'tablet-screen',
  icon: [
    448,
    512,
    ['tablet-android-alt'],
    'f3fc',
    'M48 448c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-80L48 368l0 80zm0-128l352 0 0-256c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 256zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faTabletAndroidAlt = faTabletScreen;
const faHexagonVerticalNftSlanted = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [
    448,
    512,
    [],
    'e506',
    'M188.9 495.5c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4l0-176.6c0-25.7-13.7-49.5-36-62.4L260.9 17.6c-22.3-12.9-49.7-12.9-72 0L36 105.9C13.7 118.8 0 142.6 0 168.3L0 344.9c0 25.7 13.7 49.5 36 62.4l152.9 88.3zm48-41.6c-7.4 4.3-16.6 4.3-24 0L60 365.7c-7.4-4.3-12-12.2-12-20.8l0-176.6c0-8.6 4.6-16.5 12-20.8L212.9 59.2c7.4-4.3 16.6-4.3 24 0l152.9 88.3c7.4 4.3 12 12.2 12 20.8l0 176.6c0 8.6-4.6 16.5-12 20.8L236.9 453.9zm27-344.3c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9l-24.2-13.8 0 117 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144 0-160.2c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3 0 155.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-174.2-23.8-13.6zM159.8 144.6l0 224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2l0 61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270l0-125.4c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faFolderMusic = {
  prefix: 'far',
  iconName: 'folder-music',
  icon: [
    512,
    512,
    [],
    'e18d',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faDisplayMedical = {
  prefix: 'far',
  iconName: 'display-medical',
  icon: [
    576,
    512,
    ['desktop-medical'],
    'e166',
    'M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM256 128l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faDesktopMedical = faDisplayMedical;
const faShareAll = {
  prefix: 'far',
  iconName: 'share-all',
  icon: [
    576,
    512,
    [],
    'f367',
    'M367.5 73.4c-9.6-9.1-10-24.3-.9-33.9s24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4zM224 240c0 0 0 0 0 0l24 0c13.3 0 24 10.7 24 24l0 24 0 28.1L392.1 208 272 99.9l0 28.1 0 24c0 13.3-10.7 24-24 24l-24 0-48 0c-70.7 0-128 57.3-128 128c0 15.3 1.9 29.1 5.2 41.5C70 284.7 125.8 240 192 240l32 0zm0 96l0-48-32 0c-5.5 0-10.8 .5-16 1.3c-45.4 7.6-80 47.1-80 94.7c0 17.3 4.2 30.5 9.5 40.2c1.6 2.9 3.3 5.5 5 7.9c2.6 3.5 5.3 6.4 7.7 8.6c.5 .5 1 .9 1.4 1.4c4.8 4.9 8.3 11.3 8.3 18.1c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9c-2.6-1.4-6.3-3.5-10.8-6.5c-2.7-1.8-5.7-3.8-8.9-6.2c-3.7-2.7-7.6-5.8-11.7-9.3C38.6 430.2 0 382 0 304c0-97.2 78.8-176 176-176l48 0 0-48 0-16c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2l0-16z',
  ],
};
const faPeapod = {
  prefix: 'far',
  iconName: 'peapod',
  icon: [
    512,
    512,
    [],
    'e31c',
    'M416 48C212.8 48 48 212.8 48 416l0 48 48 0c203.2 0 368-164.8 368-368l0-48-48 0zm0-48l48 0c26.5 0 48 21.5 48 48l0 48c0 229.8-186.2 416-416 416l-48 0c-26.5 0-48-21.5-48-48l0-48C0 186.2 186.2 0 416 0zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
  ],
};
const faChessClock = {
  prefix: 'far',
  iconName: 'chess-clock',
  icon: [
    640,
    512,
    [],
    'f43d',
    'M256 56c0-13.3-10.7-24-24-24L120 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32-88 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-240c0-35.3-28.7-64-64-64l-32 0 0-16c0-8.8-7.2-16-16-16L400 80c-8.8 0-16 7.2-16 16l0 16-184 0 0-32 32 0c13.3 0 24-10.7 24-24zM576 160c8.8 0 16 7.2 16 16l0 240c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-240c0-8.8 7.2-16 16-16l512 0zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM184 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zM513.5 369.5A104 104 0 1 0 366.5 222.5 104 104 0 1 0 513.5 369.5zM490.9 245.1c6.2 6.2 6.2 16.4 0 22.6L457 301.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faAxe = {
  prefix: 'far',
  iconName: 'axe',
  icon: [
    640,
    512,
    [129683],
    'f6b2',
    'M486.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3l0 82.7c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32l-82.7 0-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16zM305.4 267.9l-61.3-61.3L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9zm185.9-73.9c9 9 21.2 14.1 33.9 14.1l66 0c-7.6 84.4-74.8 151.7-159.3 159.3l0-66c0-12.7-5.1-24.9-14.1-33.9L278.6 128 352 54.6 491.3 193.9z',
  ],
};
const faSquareD = {
  prefix: 'far',
  iconName: 'square-d',
  icon: [
    448,
    512,
    [],
    'e268',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm24 208l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z',
  ],
};
const faGripVertical = {
  prefix: 'far',
  iconName: 'grip-vertical',
  icon: [
    320,
    512,
    [],
    'f58e',
    'M40 440l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm192-40l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 232l48 0 0 48-48 0 0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 72l48 0 0 48-48 0 0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z',
  ],
};
const faMobileSignalOut = {
  prefix: 'far',
  iconName: 'mobile-signal-out',
  icon: [
    512,
    512,
    [],
    'e1f0',
    'M64 48l160 0 0-48L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-160-48 0 0 160c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z',
  ],
};
const faHexagonNodes = {
  prefix: 'far',
  iconName: 'hexagon-nodes',
  icon: [
    448,
    512,
    [],
    'e699',
    'M224 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-24c0 26.9-16.5 49.9-40 59.3l0 73.3c23.5 9.5 40 32.5 40 59.3c0 3.4-.3 6.7-.8 10l58.2 34.9c4.5-3.4 9.4-6.1 14.5-8.2l0-73.3c-5.2-2.1-10-4.8-14.5-8.2l-29.4 17.6c-4.7-15.8-13.3-29.9-24.7-41.1l29.4-17.6c-4-25.4 7.7-51.7 31.2-65.4c30.6-17.7 69.8-7.2 87.4 23.4s7.2 69.8-23.4 87.4c-2.6 1.5-5.3 2.8-8 3.9l0 73.3c2.7 1.1 5.4 2.4 8 3.9c30.6 17.7 41.1 56.8 23.4 87.4s-56.8 41.1-87.4 23.4c-23.6-13.6-35.2-40-31.2-65.4l-58.2-34.9c-4.4 3.3-9.3 6.1-14.5 8.2l0 73.3c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-3.4 .3-6.7 .8-10l-58.2-34.9c-4.5 3.4-9.4 6.1-14.6 8.2l0 73.3c5.1 2.1 10 4.8 14.5 8.2l29.4-17.6c4.7 15.8 13.3 29.9 24.7 41.1L127.2 342c4 25.4-7.6 51.8-31.2 65.4C65.4 425.1 26.3 414.6 8.6 384S1.4 314.3 32 296.6c2.6-1.5 5.3-2.8 8-3.9l0-73.3c-2.7-1.1-5.4-2.4-8-3.9C1.4 197.8-9.1 158.6 8.6 128S65.4 86.9 96 104.6c23.6 13.6 35.2 40 31.2 65.4l58.2 34.9c4.4-3.3 9.3-6.1 14.5-8.2l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-35.3 28.7-64 64-64s64 28.7 64 64zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm172-99.2a24 24 0 1 0 -24-41.6 24 24 0 1 0 24 41.6zM84.8 172A24 24 0 1 0 43.2 148a24 24 0 1 0 41.6 24zM248 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM43.2 364a24 24 0 1 0 41.6-24A24 24 0 1 0 43.2 364zM396 331.2a24 24 0 1 0 -24 41.6 24 24 0 1 0 24-41.6z',
  ],
};
const faArrowTurnUp = {
  prefix: 'far',
  iconName: 'arrow-turn-up',
  icon: [
    384,
    512,
    ['level-up'],
    'f148',
    'M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z',
  ],
};
const faLevelUp = faArrowTurnUp;
const faU = {
  prefix: 'far',
  iconName: 'u',
  icon: [
    384,
    512,
    [117],
    '55',
    'M24 32c13.3 0 24 10.7 24 24l0 232c0 79.5 64.5 144 144 144s144-64.5 144-144l0-232c0-13.3 10.7-24 24-24s24 10.7 24 24l0 232c0 106-86 192-192 192S0 394 0 288L0 56C0 42.7 10.7 32 24 32z',
  ],
};
const faArrowUpFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e09b',
    'M241.5 39.6C236.9 34.7 230.6 32 224 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 116.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faSquareRootVariable = {
  prefix: 'far',
  iconName: 'square-root-variable',
  icon: [
    576,
    512,
    ['square-root-alt'],
    'f698',
    'M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.9 0c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L344.3 80zM399 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faSquareRootAlt = faSquareRootVariable;
const faLightSwitchOn = {
  prefix: 'far',
  iconName: 'light-switch-on',
  icon: [
    384,
    512,
    [],
    'e019',
    'M169.4 48c3.3 9.3 12.2 16 22.6 16s19.3-6.7 22.6-16L320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-105.4 0c-3.3-9.3-12.2-16-22.6-16s-19.3 6.7-22.6 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l105.4 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm80 256l96 0 0 112-96 0 0-112zm0-160c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-96 0z',
  ],
};
const faArrowDownArrowUp = {
  prefix: 'far',
  iconName: 'arrow-down-arrow-up',
  icon: [
    576,
    512,
    ['sort-alt'],
    'f883',
    'M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM399 39l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L392 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 39c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faSortAlt = faArrowDownArrowUp;
const faRaindrops = {
  prefix: 'far',
  iconName: 'raindrops',
  icon: [
    448,
    512,
    [],
    'f75c',
    'M105.9 106.6l41.9-67.8C150.4 34.6 155 32 160 32s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9l0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-2.5c0-12.3 3.4-24.4 9.9-34.9zm-96 192l41.9-67.8C54.4 226.6 59 224 64 224s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9l0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-2.5c0-12.3 3.4-24.4 9.9-34.9zm242.6 11.5c-8.2 12.7-12.5 27.6-12.5 42.7c0 43.4 35.9 79.2 80 79.2s80-35.8 80-79.2c0-15.1-4.3-30-12.5-42.7L320 204.6 252.5 310.1zm-40.4-25.9l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z',
  ],
};
const faDash = {
  prefix: 'far',
  iconName: 'dash',
  icon: [
    512,
    512,
    ['minus-large'],
    'e404',
    'M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
  ],
};
const faMinusLarge = faDash;
const faClock = {
  prefix: 'far',
  iconName: 'clock',
  icon: [
    512,
    512,
    [128339, 'clock-four'],
    'f017',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faClockFour = faClock;
const faInputNumeric = {
  prefix: 'far',
  iconName: 'input-numeric',
  icon: [
    640,
    512,
    [],
    'e1bd',
    'M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm40 120c0 13.3 10.7 24 24 24l8 0 0 96-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-120c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.2 0 34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z',
  ],
};
const faTruckTow = {
  prefix: 'far',
  iconName: 'truck-tow',
  icon: [
    640,
    512,
    [],
    'e2b8',
    'M96 64l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16L64 32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0l21.7 0 28 0c9.1 0 17.8 3.9 23.9 10.7L373.3 240l10.7 0 0-88c0-30.9 25.1-56 56-56l50.1 0c20.9 0 40.7 9.1 54.4 24.8l81.8 94.4c8.8 10.2 13.7 23.2 13.7 36.7L640 360c0 30.9-25.1 56-56 56l-8 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-8 0c-30.9 0-56-25.1-56-56l0-64c0-30.9 25.1-56 56-56l128 0L96 64zM243.2 368l153.7 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l20.8 0c4.4 0 8-3.6 8-8l0-72-160 0-16 0-32 0-32.2 0L208 288 56 288c-4.4 0-8 3.6-8 8l0 64c0 4.4 3.6 8 8 8l20.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48zM145.8 56.3L237.7 240l71.4 0L145.8 56.3zM584.2 240l-76-87.7c-4.6-5.3-11.2-8.3-18.1-8.3L440 144c-4.4 0-8 3.6-8 8l0 88 152.2 0zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faBackwardStep = {
  prefix: 'far',
  iconName: 'backward-step',
  icon: [
    320,
    512,
    ['step-backward'],
    'f048',
    'M80 88c0-13.3-10.7-24-24-24S32 74.7 32 88l0 138.7 0 58.6L32 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-105.1L256.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1l0-323.8C304 77.5 290.5 64 273.9 64c-6.2 0-12.2 1.9-17.3 5.4L80 193.1 80 88zm0 172.3l0-8.6L256 128.5l0 255L80 260.3z',
  ],
};
const faStepBackward = faBackwardStep;
const faPallet = {
  prefix: 'far',
  iconName: 'pallet',
  icon: [
    640,
    512,
    [],
    'f482',
    'M24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 96-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 232 0 232 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-96 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0-232 0L88 320l-64 0zm88 48l184 0 0 96-184 0 0-96zm232 0l184 0 0 96-184 0 0-96z',
  ],
};
const faCarBolt = {
  prefix: 'far',
  iconName: 'car-bolt',
  icon: [
    512,
    512,
    [],
    'e341',
    'M127.7 106.8L103.4 176l24.6 0 0 48-32 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-32 0 0-48 24.6 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM315.2 116.6c5.3 5.2 6.3 13.3 2.5 19.6L284.3 192l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L227.7 224 176 224c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z',
  ],
};
const faArrowsMaximize = {
  prefix: 'far',
  iconName: 'arrows-maximize',
  icon: [
    512,
    512,
    ['expand-arrows'],
    'f31d',
    'M328 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.1 0L256 222.1 113.9 80 184 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32C42.7 32 32 42.7 32 56l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-70.1L222.1 256 80 398.1 80 328c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-70.1 0L256 289.9 398.1 432 328 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.1L289.9 256 432 113.9l0 70.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24L328 32z',
  ],
};
const faExpandArrows = faArrowsMaximize;
const faFaucet = {
  prefix: 'far',
  iconName: 'faucet',
  icon: [
    512,
    512,
    [],
    'e005',
    'M224 64c13.3 0 24 10.7 24 24l0 21L352 96c17.7 0 32 14.3 32 32s-14.3 32-32 32L248 147l0 45 26.7 0c14.9 0 29.1 5.9 39.6 16.4L329.9 224l30.1 0c83.9 0 152 68.1 152 152l0 16c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56c0-4.4-3.6-8-8-8l-20.1 0c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48L24 384c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.3 0c8.2 0 15.8 4.2 20.2 11.1C170.8 369.3 195.7 384 224 384s53.2-14.7 67.4-36.9c4.4-6.9 12-11.1 20.2-11.1l32.3 0c30.9 0 56 25.1 56 56c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-16c0-57.4-46.6-104-104-104l-40 0c-6.4 0-12.5-2.5-17-7l-22.6-22.6c-1.5-1.5-3.5-2.3-5.7-2.3l-93.5 0c-2.1 0-4.2 .8-5.7 2.3L153 265c-4.5 4.5-10.6 7-17 7L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l102.1 0 15.6-15.6c10.5-10.5 24.7-16.4 39.6-16.4l18.7 0 0-45L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l104 13 0-21c0-13.3 10.7-24 24-24z',
  ],
};
const faCloudSleet = {
  prefix: 'far',
  iconName: 'cloud-sleet',
  icon: [
    512,
    512,
    [],
    'f741',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm272 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM216 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16zm256 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16z',
  ],
};
const faLampStreet = {
  prefix: 'far',
  iconName: 'lamp-street',
  icon: [
    512,
    512,
    [],
    'e1c5',
    'M48 172c0-68.5 55.5-124 124-124c65 0 118.3 50 123.6 113.5c-84 10.7-151.1 75.6-164.9 158.6C127.7 337.6 142.3 352 160 352l320 0c17.7 0 32.3-14.4 29.4-31.9C495.5 236.9 428 171.8 343.7 161.4C338.2 71.4 263.4 0 172 0C77 0 0 77 0 172L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-316zM455.8 304l-271.6 0c19.8-55.9 73.1-96 135.8-96s116.1 40.1 135.8 96zM320 448c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z',
  ],
};
const faListRadio = {
  prefix: 'far',
  iconName: 'list-radio',
  icon: [
    512,
    512,
    [],
    'e1d0',
    'M64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z',
  ],
};
const faPenNibSlash = {
  prefix: 'far',
  iconName: 'pen-nib-slash',
  icon: [
    640,
    512,
    [],
    'e4a1',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L448.6 326.3 476.2 225l10.4-10.4 71-71c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0l-71 71L351 99.8 209 138.5 38.8 5.1zM256.1 175.4l104.8-28.6 68.3 68.3-21.6 79.1L256.1 175.4zM272 352c13.5 0 25.7-5.6 34.4-14.6l-75-59.1c-4.7 7.4-7.4 16.2-7.4 25.7c0 7.4 1.7 14.4 4.7 20.7L126.5 426.9l63.6-181.1-39.8-31.4L71 440c-6.5 18.5-1.8 39.1 12 52.9s34.4 18.5 52.9 12l264.1-92.8 .8-.3-44.7-35.2L149.1 449.5 251.3 347.3c6.3 3 13.3 4.7 20.7 4.7z',
  ],
};
const faBaseballBatBall = {
  prefix: 'far',
  iconName: 'baseball-bat-ball',
  icon: [
    512,
    512,
    [],
    'f432',
    'M372 17.5C383.8 6.3 399.5 0 415.7 0c16.8 0 32.9 6.7 44.7 18.5l33 33c11.9 11.9 18.5 28 18.5 44.7c0 16.3-6.3 31.9-17.5 43.7L356.3 284.7c-14.1 14.8-30.3 27.5-48 37.8L201.8 384.2c-12.6 7.3-24.3 16.3-34.6 26.6l-38.6 38.6c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l38.6-38.6c10.3-10.3 19.3-22 26.6-34.6l61.6-106.5c10.3-17.7 23-33.9 37.8-48L372 17.5zM171.9 329.9l10.2 10.2L284.2 281c13.8-8 26.4-17.9 37.3-29.4L459.8 106.8c2.7-2.8 4.2-6.6 4.2-10.5c0-4-1.6-7.9-4.5-10.8l-33-33c-2.9-2.9-6.7-4.5-10.8-4.5c-3.9 0-7.7 1.5-10.5 4.2L260.4 190.4c-11.5 11-21.4 23.6-29.4 37.3L171.9 329.9zM464 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM15 399c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L15 433c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faSquareUpLeft = {
  prefix: 'far',
  iconName: 'square-up-left',
  icon: [
    448,
    512,
    [],
    'e282',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 313.4L128 176c0-8.8 7.2-16 16-16l137.4 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z',
  ],
};
const faOverline = {
  prefix: 'far',
  iconName: 'overline',
  icon: [
    448,
    512,
    [],
    'f876',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zm200 80c-97.2 0-176 78.8-176 176l0 16c0 97.2 78.8 176 176 176s176-78.8 176-176l0-16c0-97.2-78.8-176-176-176zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16z',
  ],
};
const faS = {
  prefix: 'far',
  iconName: 's',
  icon: [
    320,
    512,
    [115],
    '53',
    'M91.2 90.6c-24 10.1-37.9 26.2-41.8 48c-2.8 16.1-1 27.4 2.8 35.7c3.8 8.5 10.6 16.1 21.1 23.3c22.1 15.1 54.9 24.6 93.2 35.3c.8 .2 1.6 .4 2.4 .7c35.3 9.9 75.6 21.2 104.9 41.2c15.6 10.6 29.3 24.5 37.7 43.1c8.5 18.7 10.6 40 6.4 63.9c-7.2 40.8-34.4 68.8-70.5 83.9c-35.3 14.8-79.6 17.8-125.7 10.7l-.1 0c-24.5-3.9-64.3-17.2-90.9-26.2c-5.3-1.8-10-3.4-14-4.7C4 441.4-2.9 427.8 1.2 415.2s17.7-19.5 30.3-15.4c4.9 1.6 10.5 3.5 16.3 5.4c26.9 9 61.2 20.4 81.3 23.6c40.4 6.2 75.1 2.9 99.8-7.5c24-10.1 37.9-26.2 41.8-48c2.8-16.1 1-27.4-2.8-35.7c-3.8-8.5-10.6-16.1-21.1-23.3c-22.1-15.1-54.9-24.6-93.2-35.3l-2.4-.7c-35.3-9.9-75.6-21.2-104.9-41.2c-15.6-10.6-29.3-24.5-37.7-43.1c-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2L2.1 130.3C9.3 89.5 36.5 61.5 72.6 46.4c35.3-14.8 79.6-17.8 125.7-10.7c13.7 2.1 55.1 9.9 69.7 13.8c12.8 3.3 20.5 16.5 17.2 29.3s-16.5 20.5-29.3 17.2c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7L191 83.1c-40.4-6.2-75.2-2.9-99.9 7.5z',
  ],
};
const faTimeline = {
  prefix: 'far',
  iconName: 'timeline',
  icon: [
    640,
    512,
    [],
    'e29c',
    'M128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24 108.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 35.8 23.5 66.1 56 76.3l0 59.7-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0 0 59.7c-32.5 10.2-56 40.5-56 76.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-59.7 272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-59.7c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 35.8 23.5 66.1 56 76.3l0 59.7-336 0 0-59.7zM320 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faKeyboard = {
  prefix: 'far',
  iconName: 'keyboard',
  icon: [
    576,
    512,
    [9000],
    'f11c',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 320l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z',
  ],
};
const faArrowsFromDottedLine = {
  prefix: 'far',
  iconName: 'arrows-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a3',
    'M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-86.1zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faUsbDrive = {
  prefix: 'far',
  iconName: 'usb-drive',
  icon: [
    640,
    512,
    [],
    'f8e9',
    'M64 144c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l336 0 0-224L64 144zM0 160c0-35.3 28.7-64 64-64l352 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-35.3 0-64-28.7-64-64L0 160zm608-32c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-128 0 0-256 128 0zm-48 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM536 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
  ],
};
const faBallot = {
  prefix: 'far',
  iconName: 'ballot',
  icon: [
    448,
    512,
    [],
    'f732',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L96 96c-8.8 0-16 7.2-16 16zM96 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM80 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM200 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faCaretDown = {
  prefix: 'far',
  iconName: 'caret-down',
  icon: [
    320,
    512,
    [],
    'f0d7',
    'M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z',
  ],
};
const faLocationDotSlash = {
  prefix: 'far',
  iconName: 'location-dot-slash',
  icon: [
    640,
    512,
    ['map-marker-alt-slash'],
    'f605',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4l-57.7-45.2C385.3 245.1 400 220.3 400 192c0-44.2-35.8-80-80-80c-35.1 0-65 22.7-75.7 54.1l-52-40.7zM318 223.9l-28.5-22.4c-.9-3-1.5-6.2-1.5-9.6c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-.7 0-1.3 0-2-.1zM191.3 249.2c-.5-1.2-1-2.5-1.5-3.7l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9z',
  ],
};
const faMapMarkerAltSlash = faLocationDotSlash;
const faCards = {
  prefix: 'far',
  iconName: 'cards',
  icon: [
    640,
    512,
    [],
    'e3ed',
    'M244.7 49c3.7-2.1 8.4-.9 10.5 2.8l167 289.3c2.1 3.7 .9 8.4-2.8 10.5L226.5 463c-3.7 2.1-8.4 .9-10.5-2.8L49 170.9c-2.1-3.7-.9-8.4 2.8-10.5L244.7 49zM27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM324.1 499c9.7 8.1 22.2 13 35.9 13l224 0c30.9 0 56-25.1 56-56l0-336c0-30.9-25.1-56-56-56L360 64c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8L324.1 499zM582 187.6l-48.2 49.9c-3.2 3.2-8.5 3.2-11.5 0l-48.4-49.9c-14-14.5-13.2-38.5 2.5-51.9c13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2c15.5 13.5 16.2 37.5 2.2 51.9zM171.4 174.3l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6c-11.1-3-22.6 3.6-25.6 14.8z',
  ],
};
const faHouseChimneyMedical = {
  prefix: 'far',
  iconName: 'house-chimney-medical',
  icon: [
    576,
    512,
    ['clinic-medical'],
    'f7f2',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM272 192l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16z',
  ],
};
const faClinicMedical = faHouseChimneyMedical;
const faBoxingGlove = {
  prefix: 'far',
  iconName: 'boxing-glove',
  icon: [
    448,
    512,
    [129354, 'glove-boxing'],
    'f438',
    'M48 120c0-39.8 32.2-72 72-72l152 0c39.8 0 72 32.2 72 72l0 8-32 0c-40.3 0-74.2 27.1-84.7 64l-59.8 0c-19.9 0-36.8-14.6-39.6-34.3l-.2-1.1c-1.9-13.1-14-22.2-27.2-20.4s-22.2 14-20.4 27.2l.2 1.1c6.2 43.4 43.3 75.6 87.1 75.6l59.8 0c10.4 36.9 44.4 64 84.7 64c13.3 0 24-10.7 24-24s-10.7-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40l51.1 0c.6 .1 1.2 .2 1.9 .3c19.7 2.5 35 19.3 35 39.7l0 38.9c0 14.9-5.9 29.1-16.4 39.6l-60.9 60.9c-12 12-18.7 28.3-18.7 45.3l0 47.4c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-88.4c0-6.8-2.9-13.3-8-17.9C57.2 328.5 48 309.3 48 288l0-168zM120 0C53.7 0 0 53.7 0 120L0 288c0 31.5 12.2 60.2 32 81.6L32 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-47.4c0-4.2 1.7-8.3 4.7-11.3l60.9-60.9c19.5-19.5 30.5-46 30.5-73.5l0-38.9c0-37.3-23.2-69.2-56-82l0-14C392 53.7 338.3 0 272 0L120 0zm32.9 346.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 411.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 372.8l-39.1-26.1z',
  ],
};
const faGloveBoxing = faBoxingGlove;
const faTemperatureThreeQuarters = {
  prefix: 'far',
  iconName: 'temperature-three-quarters',
  icon: [
    320,
    512,
    ['temperature-3', 'thermometer-3', 'thermometer-three-quarters'],
    'f2c8',
    'M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 152c0-8.8 7.2-16 16-16s16 7.2 16 16l0 170.7c18.6 6.6 32 24.4 32 45.3z',
  ],
};
const faTemperature3 = faTemperatureThreeQuarters;
const faThermometer3 = faTemperatureThreeQuarters;
const faThermometerThreeQuarters = faTemperatureThreeQuarters;
const faBellSchool = {
  prefix: 'far',
  iconName: 'bell-school',
  icon: [
    512,
    512,
    [],
    'f5d5',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM352 358.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1L64 448c0 35.3 28.7 64 64 64l144 0 16 0 128 0c39.2 0 71.1-31.4 72-70.4c14.4-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.7 9.6 33.2 24 41.5c-.8 12.5-11.2 22.5-24 22.5l-66 0c1.3-5.1 2-10.5 2-16l0-89.9zM288 464l-16 0-144 0c-8.8 0-16-7.2-16-16l0-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4l0 55.4c0 8.8-7.2 16-16 16zM208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z',
  ],
};
const faMobileScreen = {
  prefix: 'far',
  iconName: 'mobile-screen',
  icon: [
    384,
    512,
    ['mobile-android-alt'],
    'f3cf',
    'M64 448c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L64 368l0 80zm0-128l256 0 0-256c0-8.8-7.2-16-16-16L80 48c-8.8 0-16 7.2-16 16l0 256zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faMobileAndroidAlt = faMobileScreen;
const faPlaneUp = {
  prefix: 'far',
  iconName: 'plane-up',
  icon: [
    512,
    512,
    [],
    'e22d',
    'M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 150.2 96.1c16.1 10.3 25.8 28.1 25.8 47.2l0 40.6c0 27.1-26.4 46.4-52.2 38.1L336 336.6l0 27.4 48 36c10.1 7.6 16 19.4 16 32l0 42.1c0 20.9-17 37.9-37.9 37.9c-3.8 0-7.5-.6-11.1-1.7L256 481.1l-94.9 29.2c-3.6 1.1-7.4 1.7-11.1 1.7C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm21.5 54.2c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 24.4 88.9-27.4c4.6-1.4 9.5-1.4 14.1 0L352 460.4l0-24.4-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5L464 327.1l0-29.6c0-2.7-1.4-5.3-3.7-6.7L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7zM146.9 464.4s0 0 0 0c0 0 0 0 0 0z',
  ],
};
const faFolderHeart = {
  prefix: 'far',
  iconName: 'folder-heart',
  icon: [
    512,
    512,
    [],
    'e189',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
  ],
};
const faCircleLocationArrow = {
  prefix: 'far',
  iconName: 'circle-location-arrow',
  icon: [
    512,
    512,
    ['location-circle'],
    'f602',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.2-73.3l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370l0-90-90 0c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z',
  ],
};
const faLocationCircle = faCircleLocationArrow;
const faFaceHeadBandage = {
  prefix: 'far',
  iconName: 'face-head-bandage',
  icon: [
    576,
    512,
    [],
    'e37a',
    'M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208c0-13.2-1.2-26.2-3.6-38.7c11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4c0 141.4-114.6 256-256 256c-99.5 0-185.8-56.8-228.2-139.8c2.5-3.8 4.8-7.5 6.7-10.7c1.9-3.1 3.5-5.7 4.7-7.5zM218.5 209.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4zM368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1c-13.9 3.4-27.2 8.2-39.8 14.2c-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9c-12.6 4-26.1-3-30.1-15.7s3-26.1 15.7-30.1c14.2-4.5 30-7.1 47.2-7.1c46.5 0 81.4 19.3 104.2 39.9c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c20.8 12.6 39.7 28 56.1 45.7C419.3 71.1 360.6 64.9 300.6 64.1zM406 103.4c34 4.3 67.3 10.5 100.1 18.3c14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1 .5-51 1.5c-47.8 2.8-94.6 9.4-140 19.7c-19.6 4.4-39 9.5-58.1 15.3c6.4-26.8 17-51.9 31-74.7c48.4-11.6 98.2-19.5 149.3-23.2C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-51.6 37.5-96.5 83.8-132.2 136.7C36.5 310.9 32 284 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5z',
  ],
};
const faSushiRoll = {
  prefix: 'far',
  iconName: 'sushi-roll',
  icon: [
    448,
    512,
    ['maki-roll', 'makizushi'],
    'e48b',
    'M400 207.7c-13.2 11.2-29 19.7-45 26.1C319 248.2 272.7 256 224 256s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1L48 368c0 3 3.6 18.5 39.1 36.3C119.6 420.5 168 432 224 432s104.4-11.5 136.9-27.7C396.4 386.5 400 371 400 368l0-160.3zM64 144c0 10.4 6.2 20.1 17.1 28.8c20.4-23.3 45.9-40.4 70.3-52.7c20.1-10.1 40.2-17.3 57.5-21.9c-1.7-5.8-3-11.7-3.8-17.7C125.7 84.2 64 111.2 64 144zm54 47.9c28.2 10 65.4 16.1 106 16.1c30.9 0 59.8-3.5 84.2-9.6c-35.3-13.5-63.8-36.1-82-63.4c-16 3.8-36.4 10.5-56.9 20.8c-18.6 9.3-36.6 21.3-51.4 36.1zM384 144c0-32.4-60.1-59.2-138.2-63.4c9.3 42.5 53.3 85.3 122.8 90.8c9.8-8.3 15.4-17.6 15.4-27.4zM224 32c123.7 0 224 50.1 224 112l0 224c0 61.9-100.3 112-224 112S0 429.9 0 368L0 144C0 82.1 100.3 32 224 32z',
  ],
};
const faMakiRoll = faSushiRoll;
const faMakizushi = faSushiRoll;
const faCarBump = {
  prefix: 'far',
  iconName: 'car-bump',
  icon: [
    640,
    512,
    [],
    'f5e0',
    'M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1s0 0 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35l147.9 0z',
  ],
};
const faPiggyBank = {
  prefix: 'far',
  iconName: 'piggy-bank',
  icon: [
    576,
    512,
    [],
    'f4d3',
    'M277.1 48c23 0 42.5 14.7 49.8 35.2c4.4 12.5 18.1 19 30.6 14.6s19-18.1 14.6-30.6C358.3 28.1 321 0 277.1 0S195.8 28.1 182 67.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6C234.5 62.7 254.1 48 277.1 48zM66.7 197.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-4.7 2.3C15.7 169.3 0 194.7 0 222.6c0 37.4 28 68.3 64.2 72.9C66.4 344.7 91 388.2 128 416l0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-16 48 0 0 16c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-37.4c18.7-10.8 35.1-25.4 48-42.6l32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-13.3 0c-8.2-18.8-19.9-35.7-34.2-49.8l11.3-36.8-22.9-7 22.9 7c6.3-20.6-9.1-41.4-30.6-41.4L456 96c-31.5 0-60.2 12.2-81.6 32L224 128c-74.4 0-137 50.8-154.9 119.6c-12-2-21.1-12.5-21.1-25.1c0-9.6 5.4-18.4 14.1-22.8l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM402.3 168c13.1-14.7 32.1-23.9 53.2-24L446 174.8c-2.9 9.4 .2 19.6 7.9 25.8c17.4 13.9 30.4 32.8 37.1 54.5c3.1 10.1 12.4 17 22.9 17l14 0 0 64-28.6 0c-8.3 0-16 4.3-20.3 11.3c-11.7 18.7-28.7 33.7-48.9 42.8C421.5 394 416 402.5 416 412l0 52-48 0 0-40c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 40-48 0 0-60.6c0-8.3-4.3-16-11.3-20.3c-31.7-19.8-52.7-55-52.7-95c0-61.9 50.1-112 112-112l160 0s0 0 0 0l.4 0c6.8 0 13.4-2.9 17.9-8z',
  ],
};
const faRacquet = {
  prefix: 'far',
  iconName: 'racquet',
  icon: [
    512,
    512,
    [],
    'f45a',
    'M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1c-64 64-154.5 68.7-202.7 20.5C186.9 282.1 176 252.8 176 221c0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48zm0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 17.2 2.4 34.3 7.3 50.6c8.2 27.4 7.6 58.9-9.9 80.6c-12.6-11.3-31.9-10.9-44 1.2l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.1-12.1 12.5-31.4 1.2-44c21.7-17.5 53.2-18 80.5-9.7c67.7 20.4 148.5-3.6 204.8-59.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM54.6 448L104 398.6l9.4 9.4L64 457.4 54.6 448z',
  ],
};
const faCarMirrors = {
  prefix: 'far',
  iconName: 'car-mirrors',
  icon: [
    576,
    512,
    [],
    'e343',
    'M197.4 80c-17 0-32.1 10.7-37.8 26.8L135.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L197.4 80zM44.8 224L40 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l44.6 0 29.8-85.1C126.7 55.6 160 32 197.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9L491.4 176l44.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4.8 0c8.2 14.1 12.8 30.5 12.8 48l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L80 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-17.5 4.7-33.9 12.8-48zm83.2 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-320 0zm-16 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faIndustryWindows = {
  prefix: 'far',
  iconName: 'industry-windows',
  icon: [
    576,
    512,
    [127981, 'industry-alt'],
    'f3b3',
    'M80 88c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 126.7c0 8.6 4.6 16.5 12 20.8s16.6 4.2 24-.1L320 153.8l0 70.9c0 8.8 4.8 16.8 12.5 21.1s17.1 3.9 24.5-.8l139.1-89L496 304l0 16 0 88c0 13.3-10.7 24-24 24l-368 0c-13.3 0-24-10.7-24-24l0-56 0-48L80 88zm8-56C57.1 32 32 57.1 32 88l0 216 0 48 0 56c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-88 0-16 0-148.1c0-37.9-41.9-60.9-73.9-40.4L368 180.8l0-27c0-37-40.2-60.1-72.2-41.5L192 172.9 192 88c0-30.9-25.1-56-56-56L88 32zm56 264c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm104 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm136-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0z',
  ],
};
const faIndustryAlt = faIndustryWindows;
const faBoltAuto = {
  prefix: 'far',
  iconName: 'bolt-auto',
  icon: [
    576,
    512,
    [],
    'e0b6',
    'M317.4 36.6C322.6 18.3 308.8 0 289.7 0c-6.8 0-13.5 2.4-18.7 6.9L11.8 228.6C4.3 235 0 244.4 0 254.3C0 272.9 15.1 288 33.7 288l86.4 0L66.6 475.4C61.4 493.7 75.2 512 94.3 512c6.8 0 13.4-2.4 18.6-6.8L371.7 285.6c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9l-85.2 0L317.4 36.6zM72.4 240L253.6 85 208.9 241.4c-2.1 7.2-.6 15 3.9 21s11.6 9.5 19.2 9.5l81.5 0L130.3 427.5l44.8-156.9c2.1-7.2 .6-15-3.9-21s-11.6-9.5-19.2-9.5l-79.6 0zM464 288c-9.1 0-17.4 5.1-21.5 13.3l-88 176c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L410.8 472l106.3 0 13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-88-176c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L493.2 424l-58.3 0L464 365.7z',
  ],
};
const faBatteryHalf = {
  prefix: 'far',
  iconName: 'battery-half',
  icon: [
    576,
    512,
    ['battery-3'],
    'f242',
    'M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm208 96L96 192l0 128 192 0 0-128z',
  ],
};
const faBattery3 = faBatteryHalf;
const faFluxCapacitor = {
  prefix: 'far',
  iconName: 'flux-capacitor',
  icon: [
    448,
    512,
    [],
    'f8ba',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM283.3 253.3c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0L224 199.4l51.7-51.7c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zM180.4 268.9c-21.9 14.3-36.4 39-36.4 67.1c0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6 0 63.4c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-63.4-3.6-3.6zM155.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z',
  ],
};
const faMountainCity = {
  prefix: 'far',
  iconName: 'mountain-city',
  icon: [
    640,
    512,
    [],
    'e52e',
    'M344 48c-4.4 0-8 3.6-8 8l0 163.7-48-79.6L288 56c0-30.9 25.1-56 56-56L456 0c30.9 0 56 25.1 56 56l0 136 32 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72.6c27.1 3.9 48 27.2 48 55.4l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-4.4-3.6-8-8-8l-16 0-80 0c-13.3 0-24-10.7-24-24l0-160c0-4.4-3.6-8-8-8L344 48zm27.3 230.2c2.9-3.8 7.5-6.2 12.7-6.2l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-9.8 0-34.9-57.8zM384 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM368 192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm128 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 188.9L154.5 304.1l21.3 30.8 28-37.3c4.5-6 11.6-9.6 19.2-9.6l60.8 0L224 188.9zM58 464L390 464 312.8 336 235 336l-40.8 54.4c-4.6 6.2-11.9 9.7-19.7 9.6s-14.9-4-19.3-10.4l-28-40.5L58 464zM253.4 144.7L442.9 458.9c6.5 10.8 6.7 24.3 .7 35.3s-17.6 17.8-30.1 17.8L34.5 512c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5 .7-35.3L194.6 144.7C200.9 134.3 212 128 224 128s23.1 6.3 29.4 16.7z',
  ],
};
const faCoins = {
  prefix: 'far',
  iconName: 'coins',
  icon: [
    512,
    512,
    [],
    'f51e',
    'M176 88c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c.4 .3 .8 .7 1.2 1c-18.7 .4-36.9 1.7-54.4 4.1L128 88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-13.7 5.2-29.4 9.6-46.3 12.9c-5.1-7.5-11-13.9-16.8-19.1c-10.1-9.1-21.8-16.5-34-22.6c31.7-2.3 59.3-8.2 80-16.1c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM48 216c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7c-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM0 216c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424L0 320 0 216zM336 320l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2L48 320c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0c0 0 0 0 0 0zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2L48 424s0 0 0 0c0 0 0 .5 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z',
  ],
};
const faHoneyPot = {
  prefix: 'far',
  iconName: 'honey-pot',
  icon: [
    448,
    512,
    [127855],
    'e418',
    'M78.6 352c21.5 40.9 49 67 64.6 79.6c0 0 .1 0 .1 0c.4 .1 1.4 .4 3.1 .4l155.3 0c1.6 0 2.6-.2 3.1-.4c0 0 .1 0 .1 0c15.5-12.6 43.1-38.7 64.6-79.6L78.6 352zM48 224l352 0c0-79.5-64.5-144-144-144l-64 0c-5.4 0-10.7 .3-16 .9l0 55.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-41c-47.4 23.6-80 72.5-80 129zM56 32l96 0 40 0 64 0 136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-9 0c39.9 35.2 65 86.7 65 144c0 138.8-79.6 217.9-113.3 245.1c-9.3 7.5-21.1 10.9-33.1 10.9l-155.3 0c-12 0-23.7-3.3-33.1-10.9C79.6 441.9 0 362.8 0 224C0 166.7 25.1 115.2 65 80l-9 0C42.7 80 32 69.3 32 56s10.7-24 24-24z',
  ],
};
const faOlive = {
  prefix: 'far',
  iconName: 'olive',
  icon: [
    448,
    512,
    [],
    'e316',
    'M160 432C98.1 432 48 381.9 48 320c0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9c8.5 5.7 15.7 11.4 20.8 15.8c2.5 2.1 4.4 3.9 5.6 5c.6 .6 1 1 1.2 1.2l.1 .1 .1 .1c.2 .2 .6 .6 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6c4.3 5 10.1 12.2 15.8 20.8C392.5 168.2 400 186.4 400 200c0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM271.1 208.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z',
  ],
};
const faKhanda = {
  prefix: 'far',
  iconName: 'khanda',
  icon: [
    512,
    512,
    [9772],
    'f66d',
    'M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1s0 0 0 0s0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5l0 19.8 35.6-24.5c0 0 0 0 .1 0c0 0 0 0 0 0l41.1-28.2c72.1-49.6 86.2-151.1 39.1-221.7c-4-6-3.5-14 1.3-19.5s12.8-6.9 19.3-3.6c58.5 30 104.7 91.3 104.7 158.2c0 53.1-26.4 100.5-51.2 133.6c-14.8 19.7-31.7 38.7-50.6 54.7c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.1-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6c-19-15.9-35.8-35-50.6-54.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c15.4-15.4 32.7-29.2 52.2-39c6.5-3.2 14.3-1.7 19.2 3.7c6.9 7.8 3.4 16.3-1.5 23.7C76.1 162.6 95 262.9 164.4 310.6l41.1 28.2c0 0 0 0 .1 0L240 362.6l0-19.1-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1s0 0 0 0s0 0 0 0s0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1zM57.3 163C47 180.1 40 200.4 40 224c0 40.4 20.4 79.2 43.2 109.6c10 13.4 20.7 25.9 32 37l36-20.5-9.5-6.5C81.5 302.2 51.5 231.7 57.3 163zM429.9 333.6c22.8-30.4 43.2-69.2 43.2-109.6c0-24.3-7.4-45.1-18.2-62.5c6.7 68.5-20.8 138.9-83.6 182l-9.5 6.5 35.9 20.4c11.4-11.1 22.1-23.6 32.1-36.9z',
  ],
};
const faFilterList = {
  prefix: 'far',
  iconName: 'filter-list',
  icon: [
    512,
    512,
    [],
    'e17c',
    'M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1 0 126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4c18 0 32.6-14.6 32.6-32.6l0-182 93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64L41.2 64zM145.6 207.7L56.8 112l238.5 0-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3l0 162.8-48-31.7L152 224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM320 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zM408 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z',
  ],
};
const faOutlet = {
  prefix: 'far',
  iconName: 'outlet',
  icon: [
    448,
    512,
    [],
    'e01c',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM80 256c0-52.3 26.5-85.2 43.6-100.9c8.6-8 20.2-11.1 31.9-11.1l137 0c11.7 0 23.3 3.1 31.9 11.1c17 15.8 43.6 48.7 43.6 100.9s-26.5 85.2-43.6 100.9c-8.6 8-20.2 11.1-31.9 11.1l-137 0c-11.7 0-23.3-3.1-31.9-11.1C106.5 341.2 80 308.3 80 256zm96-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM200 296l0 16c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faSliders = {
  prefix: 'far',
  iconName: 'sliders',
  icon: [
    512,
    512,
    ['sliders-h'],
    'f1de',
    'M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z',
  ],
};
const faSlidersH = faSliders;
const faCauldron = {
  prefix: 'far',
  iconName: 'cauldron',
  icon: [
    448,
    512,
    [],
    'f6bf',
    'M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5L224 208l121.2 0c8.5 11.4 19 26.9 28.6 44.5c15.9 29.2 26.2 58.5 26.2 81.9c0 39.2-18.3 70-49.4 92.5C318.3 450.2 272.6 464 224 464s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5L32 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 15c0 13.3 10.7 24 24 24s24-10.7 24-24l0-58.1c20.1-26.1 32-58.1 32-95.5c0-43.6-22.5-91-44.6-126.4l20.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0-144 0L80 160l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l20.6 0z',
  ],
};
const faPeople = {
  prefix: 'far',
  iconName: 'people',
  icon: [
    640,
    512,
    [],
    'e216',
    'M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L176 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM144 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6 96 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM587.1 299.8c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6l-51.8 91.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l47.9-84.6-46.3 148c-3.2 10.3 4.5 20.8 15.3 20.8l26.2 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.2 0c10.8 0 18.5-10.5 15.3-20.8l-46.3-148 47.9 84.6zM526.7 336l-93.4 0L480 186.5 526.7 336z',
  ],
};
const faFolderTree = {
  prefix: 'far',
  iconName: 'folder-tree',
  icon: [
    576,
    512,
    [],
    'f802',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 136 0 392c0 30.9 25.1 56 56 56l200 0 0-48L56 400c-4.4 0-8-3.6-8-8l0-232 208 0 0-48L48 112l0-88zM336 176l0-128 44.1 0 17 17c9.6 9.6 22.6 15 36.2 15L528 80l0 96-192 0zM288 32l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L433.3 32c-.8 0-1.7-.3-2.3-.9L409.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32zm48 432l0-128 44.1 0 17 17c9.6 9.6 22.6 15 36.2 15l94.7 0 0 96-192 0zM288 320l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-110.7 0c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32z',
  ],
};
const faNetworkWired = {
  prefix: 'far',
  iconName: 'network-wired',
  icon: [
    640,
    512,
    [],
    'f6ff',
    'M400 48l0 96-160 0 0-96 160 0zM240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l56 0 0 40L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0 0 40-56 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-56 0 0-40 272 0 0 40-56 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-56 0 0-40 112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0 0-40 56 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0zM80 368l160 0 0 96L80 464l0-96zm480 0l0 96-160 0 0-96 160 0z',
  ],
};
const faCroissant = {
  prefix: 'far',
  iconName: 'croissant',
  icon: [
    512,
    512,
    [129360],
    'f7f6',
    'M323.7 242.1c2 18.9-4.5 38.1-18.4 51.9L294 305.3c-13.9 13.9-33 20.4-51.9 18.4L208 350.2l0 33.8 15.6 93.6c.3 1.6 .4 3.2 .4 4.9c0 16.3-13.2 29.6-29.6 29.6l-5.4 0c-4.2 0-8.3-.7-12.2-2.3c-35.8-14.3-67.5-36.5-93.2-64.3c-16.4 7.1-36 2.5-45.3-13.7C14 389.4 0 340.3 0 288c0-22.4 2.6-44.2 7.4-65.1C2.7 215.6 0 207 0 197.9c0-5 .8-10 2.5-14.6C33.2 99.6 99.6 33.2 183.3 2.5C188 .8 193 0 197.9 0c9.1 0 17.7 2.7 24.9 7.4C243.8 2.6 265.6 0 288 0c52.3 0 101.4 14 143.7 38.4c16.2 9.3 20.8 28.9 13.7 45.3c27.9 25.7 50 57.4 64.3 93.2c1.5 3.9 2.3 8 2.3 12.2l0 5.4c0 16.3-13.2 29.6-29.6 29.6c-1.6 0-3.3-.1-4.9-.4L384 208l-33.8 0-26.5 34.1zm-74.3-191l55.3 137.3L394.5 72.9C362.5 57 326.3 48 288 48c-13.1 0-26 1.1-38.6 3.1zM51.1 249.4C49.1 262 48 274.9 48 288c0 38.3 9 74.5 24.9 106.5l115.5-89.8L51.1 249.4zM388 160l3.9 .7 62 10.3c-10-17.9-22.6-34.3-37.2-48.4L387.6 160l.4 0zM171 453.9l-10.3-62L160 388l0-.4-37.4 29.1c14.2 14.6 30.5 27.2 48.4 37.2zm71.8-179c6 2.4 12.8 1 17.3-3.5l11.3-11.3c4.5-4.5 5.9-11.3 3.5-17.3l-78.2-194c-67.9 25.9-122 80-147.9 147.9l194 78.2z',
  ],
};
const faMapPin = {
  prefix: 'far',
  iconName: 'map-pin',
  icon: [
    320,
    512,
    [128205],
    'f276',
    'M64 144a96 96 0 1 1 192 0A96 96 0 1 1 64 144zM184 286c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142l0 202c0 13.3 10.7 24 24 24s24-10.7 24-24l0-202z',
  ],
};
const faHamsa = {
  prefix: 'far',
  iconName: 'hamsa',
  icon: [
    512,
    512,
    [],
    'f665',
    'M184 104l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176c0 13.3 10.7 24 24 24l48.4 0c8.6 0 15.6 7 15.6 15.6c0 4.1-1.6 8.1-4.6 11l-83.8 83.8C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5L52.6 330.6c-2.9-2.9-4.6-6.9-4.6-11C48 311 55 304 63.6 304l48.4 0c13.3 0 24-10.7 24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm7.8-64.6C182.2 34.7 171.4 32 160 32c-39.8 0-72 32.2-72 72l0 152-24.4 0C28.5 256 0 284.5 0 319.6c0 16.9 6.7 33 18.6 45l83.8 83.8c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6l83.8-83.8c11.9-11.9 18.6-28.1 18.6-45c0-35.1-28.5-63.6-63.6-63.6L424 256l0-152c0-39.8-32.2-72-72-72c-11.4 0-22.2 2.7-31.8 7.4C308.3 16 284 0 256 0s-52.3 16-64.2 39.4zM165.4 338.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288s-76.8 35.8-90.6 50.2zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCentSign = {
  prefix: 'far',
  iconName: 'cent-sign',
  icon: [
    384,
    512,
    [],
    'e3f5',
    'M216 0c13.3 0 24 10.7 24 24l0 48.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7C289.7 130.3 259.2 120 226 120c-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5l0 48.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-50.8C102 422 32 347.7 32 256s70-166 160-181.2L192 24c0-13.3 10.7-24 24-24z',
  ],
};
const faSwordsLaser = {
  prefix: 'far',
  iconName: 'swords-laser',
  icon: [
    640,
    512,
    [],
    'e03d',
    'M204.6 250.7l42.9-39.3 50.7 55.5-37 40.5L281 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-.7-.7-59 59L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l82.3-82.3c0 0 0 0 0 0s0 0 0 0l59-59-.7-.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l19.7 19.7zM505.7 40.2l-115.3 126-46.7-42.7L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7s9.4 23.7 .7 33.2zM177.1 361.6l-26.7-26.7-12.4 12.4 26.7 26.7 12.4-12.4zm-61.8 8.3L53.3 432 80 458.7l62.1-62.1-26.7-26.7zM173 312.3L199.7 339l12.7-12.7-26.7-26.7L173 312.3zM135 7c9.1-9.1 23.7-9.4 33.2-.7L360 181.8l0 105.1L134.3 40.2c-8.7-9.5-8.3-24.1 .7-33.2zM626.8 459.8l-39 39c-8.4 8.4-19.9 13.2-31.8 13.2s-23.4-4.7-31.8-13.2L398.1 372.7c-9-9-14.1-21.2-14.1-33.9l0-127.4c0-21.4 25.9-32.1 41-17L626.8 396.2c8.4 8.4 13.2 19.9 13.2 31.8s-4.7 23.4-13.2 31.8zM590.7 428l-66.1-66.1-34.7 34.7L556 462.7 590.7 428zm-88.7-88.7L432 269.3l0 69.5 35.3 35.3 34.7-34.7z',
  ],
};
const faFlask = {
  prefix: 'far',
  iconName: 'flask',
  icon: [
    448,
    512,
    [],
    'f0c3',
    'M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320l208.6 0-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7L272 48l-96 0 0 148.8zM320 48l0 148.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 48l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L288 0l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z',
  ],
};
const faPersonPregnant = {
  prefix: 'far',
  iconName: 'person-pregnant',
  icon: [
    384,
    512,
    [],
    'e31e',
    'M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 352c0 17.7 14.3 32 32 32l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 16 0 16 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0 16 0c17.7 0 32-14.3 32-32l0-32c0-46.8-33.4-85.7-77.7-94.3l-6.1-32.5c-6.8-36.1-37.1-62.7-73.3-65.1c-1-.1-1.9-.2-2.9-.2l-2.4 0L176 128l-4.7 0c-32.5 0-62.3 17.9-77.6 46.5L34.8 284.7c-6.2 11.7-1.8 26.2 9.9 32.5s26.2 1.8 32.5-9.9L96 272.1 96 352zm80-176l13.6 0c15.4 0 28.6 11 31.5 26.1l6.1 32.5c3.6 19.4 18.7 34.5 38.1 38.3c22.1 4.3 38.8 23.8 38.8 47.1l0 16-112 0-48 0 0-128c0-17.7 14.3-32 32-32z',
  ],
};
const faSquareU = {
  prefix: 'far',
  iconName: 'square-u',
  icon: [
    448,
    512,
    [],
    'e281',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faWandSparkles = {
  prefix: 'far',
  iconName: 'wand-sparkles',
  icon: [
    512,
    512,
    [],
    'f72b',
    'M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3c2.7 0 4.9 2.2 4.9 4.9c0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4c-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4c0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0C446 0 433.4 4.9 423.6 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1L112 256c-8.8 0-16 7.2-16 16l0 31.3c0 4.5-1.9 8.8-5.3 11.9L20.2 379.1C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18c17.3 0 33.8-7.3 45.4-20.2L399.7 197.3c3-3.3 7.3-5.3 11.9-5.3l20.4 0c8.8 0 16-7.2 16-16l0-25.9c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9C512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0z',
  ],
};
const faRouter = {
  prefix: 'far',
  iconName: 'router',
  icon: [
    576,
    512,
    [],
    'f8da',
    'M198.6 105.9c-9.9 8.8-25.1 7.8-33.9-2.1s-7.8-25.1 2.1-33.9C216.2 26.4 281.1 0 352 0s135.8 26.4 185.1 69.9c9.9 8.8 10.9 23.9 2.1 33.9s-23.9 10.9-33.9 2.1C464.5 69.8 410.8 48 352 48s-112.5 21.8-153.4 57.9zM64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16L64 352zM0 368c0-35.3 28.7-64 64-64l264 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 160c-28.6 0-54.9 10-75.5 26.7c-10.3 8.3-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C275.2 126 312 112 352 112s76.8 14 105.7 37.4c10.3 8.3 11.9 23.5 3.5 33.8s-23.5 11.9-33.8 3.5C406.9 170 380.6 160 352 160z',
  ],
};
const faEllipsisVertical = {
  prefix: 'far',
  iconName: 'ellipsis-vertical',
  icon: [
    128,
    512,
    ['ellipsis-v'],
    'f142',
    'M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z',
  ],
};
const faEllipsisV = faEllipsisVertical;
const faSwordLaserAlt = {
  prefix: 'far',
  iconName: 'sword-laser-alt',
  icon: [
    512,
    512,
    [],
    'e03c',
    'M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232l105.1 0L505.7 40.2zM13.2 459.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L310.6 304l1.1-1.1 8.3-8.3 11.3-11.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-16 0-11.7 0-1.5 0-117.5 0c-12.7 0-24.9 5.1-33.9 14.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8zM242.7 304l-70.1 70.1-34.7-34.7L173.3 304l69.5 0zm-92.7 92.7L84 462.7 49.3 428l66.1-66.1 34.7 34.7z',
  ],
};
const faTicket = {
  prefix: 'far',
  iconName: 'ticket',
  icon: [
    576,
    512,
    [127903],
    'f145',
    'M64 64C28.7 64 0 92.7 0 128l0 60.1c0 10.2 6.4 19.2 16 22.6c18.7 6.6 32 24.4 32 45.3s-13.3 38.7-32 45.3c-9.6 3.4-16 12.5-16 22.6L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-60.1c0-10.2-6.4-19.2-16-22.6c-18.7-6.6-32-24.4-32-45.3s13.3-38.7 32-45.3c9.6-3.4 16-12.5 16-22.6l0-60.1c0-35.3-28.7-64-64-64L64 64zM48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 44.9c-28.7 16.6-48 47.6-48 83.1s19.3 66.6 48 83.1l0 44.9c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-44.9c28.7-16.6 48-47.6 48-83.1s-19.3-66.6-48-83.1L48 128zM400 304l-224 0 0-96 224 0 0 96zM128 192l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z',
  ],
};
const faPowerOff = {
  prefix: 'far',
  iconName: 'power-off',
  icon: [
    512,
    512,
    [9211],
    'f011',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240zM134.2 107.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3c-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z',
  ],
};
const faCoin = {
  prefix: 'far',
  iconName: 'coin',
  icon: [
    512,
    512,
    [129689],
    'f85c',
    'M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60C375.6 289.3 320 304 256 304s-119.6-14.7-157.5-36zM256 64C114.6 64 0 128.5 0 208l0 48 0 64c0 70.7 114.6 128 256 128s256-57.3 256-128l0-64 0-48c0-79.5-114.6-144-256-144zM216 350.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7l0 48c-12.9 1.1-26.3 1.7-40 1.7s-27.1-.6-40-1.7l0-48zm-32-4l0 48.1c-23.7-3.9-45.3-9.6-64-16.6l0-47.7c19.7 7 41.2 12.5 64 16.2zM48 292c11.6 9.1 25 17.4 40 24.7l0 46.5C54.2 344.2 48 326.8 48 320l0-28zM328 394.3l0-48.1c22.8-3.8 44.3-9.2 64-16.2l0 47.7c-18.7 7-40.3 12.7-64 16.6zm96-31.2l0-46.5c15-7.3 28.4-15.6 40-24.7l0 28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9c11.8 3.7 19.9 7.7 24.7 11.1c-4.8 3.4-12.9 7.3-24.7 11.1c-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1c4.8-3.4 12.9-7.3 24.7-11.1c24.6-7.8 60-12.9 100.3-12.9zm128.8 27.4s0-.1-.1-.2c.1 .1 .1 .2 .1 .2zm-.1-6.6c.1-.1 .1-.2 .1-.2s-.1 .1-.1 .2zm-257.4-.2s0 .1 .1 .2c-.1-.1-.1-.2-.1-.2zm.1 6.6c-.1 .1-.1 .2-.1 .2s.1-.1 .1-.2zM432 208c0-17.7-11.3-30.3-21.6-37.9c-10.7-8-24.6-14.2-39.7-18.9c-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9c30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9c10.3-7.7 21.6-20.2 21.6-37.9z',
  ],
};
const faLaptopSlash = {
  prefix: 'far',
  iconName: 'laptop-slash',
  icon: [
    640,
    512,
    [],
    'e1c7',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-20.3-15.9c18.2-17.5 29.5-42 29.5-69.2c0-17.7-14.3-32-32-32l-126.6 0L134.4 80 512 80c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM542.6 400l46.6 0c-3.3 9.3-9.4 17.3-17.3 23l-29.4-23zM426.3 432L96 432c-20.9 0-38.7-13.4-45.3-32l334.9 0-60.9-48L32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l391.2 0-60.9-48zM112 184.4L64 146.6 64 320l48 0 0-135.6z',
  ],
};
const faRightLong = {
  prefix: 'far',
  iconName: 'right-long',
  icon: [
    512,
    512,
    ['long-arrow-alt-right'],
    'f30b',
    'M505.5 239.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-33.7L56 336c-30.9 0-56-25.1-56-56l0-48c0-30.9 25.1-56 56-56l248 0 0-33.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 146.5l0 53.5c0 13.3-10.7 24-24 24L56 224c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l272 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 53.5L455 256 352 146.5z',
  ],
};
const faLongArrowAltRight = faRightLong;
const faCircleB = {
  prefix: 'far',
  iconName: 'circle-b',
  icon: [
    512,
    512,
    [],
    'e0fd',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 104 0 104c0 13.3 10.7 24 24 24l108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0c-13.3 0-24 10.7-24 24zm144 52c0 15.5-12.5 28-28 28l-68 0 0-56 68 0c15.5 0 28 12.5 28 28zM208 336l0-56 68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0z',
  ],
};
const faPersonDressSimple = {
  prefix: 'far',
  iconName: 'person-dress-simple',
  icon: [
    256,
    512,
    [],
    'e21c',
    'M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM96.9 219.6L63.6 336l128.7 0L159.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.4 0c-7.1 0-13.4 4.7-15.4 11.6zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L192 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z',
  ],
};
const faPipeCollar = {
  prefix: 'far',
  iconName: 'pipe-collar',
  icon: [
    512,
    512,
    [],
    'e437',
    'M109.3 18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L35.4 126C12.9 164.1 0 208.5 0 256s12.9 91.9 35.4 130L18.7 402.7c-25 25-25 65.5 0 90.5s65.5 25 90.5 0L126 476.6c38.1 22.5 82.6 35.4 130 35.4s91.9-12.9 130-35.4l16.7 16.7c25 25 65.5 25 90.5 0s25-65.5 0-90.5L476.6 386c22.5-38.1 35.4-82.6 35.4-130s-12.9-91.9-35.4-130l16.7-16.7c25-25 25-65.5 0-90.5s-65.5-25-90.5 0L386 35.4C347.9 12.9 303.5 0 256 0s-91.9 12.9-130 35.4L109.3 18.7zM48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM48 64a16 16 0 1 1 32 0A16 16 0 1 1 48 64zm0 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm400-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faLightsHoliday = {
  prefix: 'far',
  iconName: 'lights-holiday',
  icon: [
    640,
    512,
    [],
    'f7b2',
    'M35.3 66.8s0 0 0 0l.1 0 .6 .3c.6 .3 1.7 .8 3.1 1.5c2.8 1.4 7.3 3.4 13.2 5.8c11.9 4.9 30 11.6 54.1 18.3C154.5 106.3 226.4 120 320 120s165.5-13.7 213.5-27.1c24-6.7 42.1-13.4 54.1-18.3c6-2.5 10.4-4.5 13.2-5.8c1.4-.7 2.5-1.2 3.1-1.5l.6-.3c0 0 0 0 0 0c0 0 0 0 0 0c11.7-6.3 26.2-1.9 32.5 9.8s1.9 26.2-9.8 32.5L616 88c11.4 21.1 11.4 21.1 11.4 21.1s0 0 0 0s0 0 0 0l-.1 .1-.4 .2-1.2 .6c-1 .5-2.4 1.2-4.2 2c-3.6 1.7-8.8 4.1-15.6 6.9c-13.6 5.6-33.5 12.9-59.4 20.2C494.5 153.7 418.4 168 320 168s-174.5-14.3-226.5-28.9c-26-7.3-45.9-14.6-59.4-20.2c-6.8-2.8-12-5.2-15.6-6.9c-1.8-.9-3.2-1.5-4.2-2l-1.2-.6-.4-.2-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L24 88 12.6 109.1C1 102.8-3.4 88.3 2.9 76.6c6.3-11.7 20.8-16 32.5-9.8zm80 155.3L130 181c14.8 3.1 30.7 6.1 47.9 8.7l-17.3 48.6c27.2 20.5 39.2 56.9 27.2 90.7c-16.1 45.2-95.7 101.8-118.3 93.8s-48.6-102.2-32.5-147.4c12-33.7 44.4-54.4 78.3-53.1zM296 259.7l0-59.9c7.9 .2 15.9 .3 24 .3s16.1-.1 24-.3l0 59.9c32.5 10.2 56 40.5 56 76.3c0 48-56 128-80 128s-80-80-80-128c0-35.8 23.5-66.1 56-76.3zm183.4-21.4l-17.3-48.6c17.1-2.6 33.1-5.5 47.9-8.7l14.7 41.2c34-1.3 66.3 19.4 78.3 53.1c16.1 45.2-9.8 139.4-32.5 147.4s-102.2-48.6-118.3-93.8c-12-33.7 0-70.2 27.2-90.7zM82.2 291.4c-1.2 3.4-2.6 11-2.1 23.3c.4 11.6 2.3 24.6 5.3 37c1.3 5.3 2.7 10.2 4.2 14.6c3.9-2.5 8.1-5.4 12.5-8.7c10.2-7.7 19.9-16.6 27.5-25.4c8-9.2 11.8-16 13-19.4c5.9-16.7-2.8-35-19.4-40.9s-35 2.8-40.9 19.4zM288 336c0 3.6 1.3 11.3 5.8 22.6c4.3 10.8 10.4 22.4 17.4 33.1c3 4.6 6 8.7 8.8 12.4c2.8-3.7 5.8-7.8 8.8-12.4c7-10.7 13.1-22.3 17.4-33.1c4.5-11.4 5.8-19 5.8-22.6c0-17.7-14.3-32-32-32s-32 14.3-32 32zm228.9-64c-16.7 5.9-25.3 24.2-19.4 40.9c1.2 3.4 5 10.2 13 19.4c7.6 8.8 17.3 17.6 27.5 25.4c4.4 3.3 8.6 6.2 12.5 8.7c1.5-4.4 2.9-9.3 4.2-14.6c3-12.4 4.9-25.4 5.3-37c.4-12.2-.9-19.9-2.1-23.3c-5.9-16.7-24.2-25.3-40.9-19.4z',
  ],
};
const faCitrus = {
  prefix: 'far',
  iconName: 'citrus',
  icon: [
    512,
    512,
    [],
    'e2f4',
    'M304 128l80 0c53 0 96-43 96-96l0-16c0-8.8-7.2-16-16-16L384 0c-31 0-58.7 14.7-76.2 37.6c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7c-13.5 9.1-28.8 15.7-45.3 19.1c23.9 32 38 71.7 38 114.6c0 106-86 192-192 192S64 378 64 272S150 80 256 80c11.2 0 22.2 1 32.9 2.8c-.6 4.3-.9 8.7-.9 13.2l0 16c0 8.8 7.2 16 16 16z',
  ],
};
const faFlagUsa = {
  prefix: 'far',
  iconName: 'flag-usa',
  icon: [
    448,
    512,
    [],
    'f74d',
    'M24 0C37.3 0 48 10.7 48 24l0 28 85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 66.2 0 51.3 0 52.7 0 51.3 0 74.2c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 404l0 84c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-49.5 0-53.3L0 264l0-46.7L0 168 0 64 0 24C0 10.7 10.7 0 24 0zM400 93c-56.4 22.9-120.2 20.6-175-6.8c-15.3-7.7-32.1-11.8-49-12.3l0 60.7c18.8 .6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4L400 93zM48 252.9l68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7 0-52.8c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2l0 46.7zm0 49.3l0 52.4 68.6-17.2c52.2-13.1 107.4-7 155.6 17.1c32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1 0-45.4c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2zM96 104a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 152a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faLaptopFile = {
  prefix: 'far',
  iconName: 'laptop-file',
  icon: [
    640,
    512,
    [],
    'e51d',
    'M448 48L128 48c-8.8 0-16 7.2-16 16l0 256 208 0 0 64L48 384c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l48 0L64 64C64 28.7 92.7 0 128 0L448 0c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16zM400 464l192 0 0-208-48 0c-17.7 0-32-14.3-32-32l0-48-112 0 0 288zm192 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l124.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L640 464c0 26.5-21.5 48-48 48z',
  ],
};
const faTty = {
  prefix: 'far',
  iconName: 'tty',
  icon: [
    512,
    512,
    ['teletype'],
    'f1e4',
    'M368 188.8l0 25.8 78.6 17.1 15.8-53.6c3.3-11.2-.3-17.4-2.5-19.4C421 123.4 349.4 80 256 80s-165 43.4-203.9 78.6c-2.2 2-5.8 8.2-2.5 19.4l15.8 53.6L144 214.5l0-25.8c0-19.3 11.6-36.8 29.5-44.3c52.8-22.1 112.3-22.1 165.1 0c17.8 7.5 29.5 24.9 29.5 44.3zm-48 25.8l0-25.8c-40.9-17.2-87.1-17.2-128 0l0 25.8c0 22.6-15.7 42.1-37.8 46.9L75.6 278.5c-24.6 5.3-49.1-9.2-56.2-33.3L3.5 191.7c-7.2-24.5-2.6-51.4 16.3-68.6C64.9 82.2 147.6 32 256 32s191.1 50.2 236.2 91.1c18.9 17.2 23.5 44.1 16.3 68.6l-15.8 53.6c-7.1 24.1-31.7 38.6-56.2 33.3l-78.6-17.1c-22.1-4.8-37.8-24.3-37.8-46.9zM32 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM144 320l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32z',
  ],
};
const faTeletype = faTty;
const faChartTreeMap = {
  prefix: 'far',
  iconName: 'chart-tree-map',
  icon: [
    512,
    512,
    [],
    'e0ea',
    'M176 80l0 112L48 192 48 80l128 0zM48 32C21.5 32 0 53.5 0 80L0 192c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 32zM176 320l0 112L48 432l0-112 128 0zM48 272c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 272zM304 80l160 0 0 32-160 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L304 32c-26.5 0-48 21.5-48 48zM464 240l0 32-160 0 0-32 160 0zM304 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0zm0 208l160 0 0 32-160 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faDiagramNext = {
  prefix: 'far',
  iconName: 'diagram-next',
  icon: [
    512,
    512,
    [],
    'e476',
    'M448 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l168 0 0 86.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-86.1 168 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-74.3 0c4.8 16 2.2 33.8-7.7 48l82 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0-224 0-80 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l82 0c-9.9-14.2-12.5-32-7.7-48L64 288z',
  ],
};
const faPersonRifle = {
  prefix: 'far',
  iconName: 'person-rifle',
  icon: [
    576,
    512,
    [],
    'e54e',
    'M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79l0-2c-.5-43.7-36.1-79-80-79zm20.7 192l-41.3 0c-45.5 0-87 25.7-107.3 66.3L34.5 413.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L152 285.7 152 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-245.4c6.2-1.7 12.7-2.6 19.3-2.6l41.3 0c3.8 0 7.6 .3 11.3 .9L272 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216.8 0-63.5c-17.8-10.1-38.1-15.7-59.3-15.7zM208 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l32 0 0 48 0 64c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16L432 0 416 0zm16 336l-16 0-16 0 0-96 32 0 0 96z',
  ],
};
const faClockFiveThirty = {
  prefix: 'far',
  iconName: 'clock-five-thirty',
  icon: [
    512,
    512,
    [],
    'e34a',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-56.7 20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faPipeValve = {
  prefix: 'far',
  iconName: 'pipe-valve',
  icon: [
    512,
    512,
    [],
    'e439',
    'M280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l104-13 0 77L48 192l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32L0 424l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 416 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-208 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-184 0 0-77 104 13c17.7 0 32-14.3 32-32s-14.3-32-32-32L280 77l0-21zM48 400l0-160 208 0 208 0 0 160L48 400z',
  ],
};
const faLightbulbMessage = {
  prefix: 'far',
  iconName: 'lightbulb-message',
  icon: [
    576,
    512,
    [],
    'e687',
    'M310.4 224.7c6.2-15 9.6-31.4 9.6-48.7c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 16.6-2.3 32.7-6.6 48L320 224c-3.3 0-6.5 .2-9.6 .7zM192 416l64 0c0 14.4 4.8 27.7 12.8 38.4C259.1 487.7 228.4 512 192 512c-44.2 0-80-35.8-80-80l0-16 80 0zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm400 78c17.7 0 32 14.3 32 32l0 130c0 17.7-14.3 32-32 32l-64 0 0 48c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L393.4 448 320 448c-17.7 0-32-14.3-32-32l0-130c0-17.7 14.3-32 32-32l224 0z',
  ],
};
const faArrowUpFromArc = {
  prefix: 'far',
  iconName: 'arrow-up-from-arc',
  icon: [
    512,
    512,
    [],
    'e4b4',
    'M256 464C141.1 464 48 370.9 48 256c0-13.3-10.7-24-24-24s-24 10.7-24 24C0 397.4 114.6 512 256 512s256-114.6 256-256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 114.9-93.1 208-208 208zM134.4 119.7c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 85.1 232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9l-104-112C269 2.8 262.7 0 256 0s-13 2.8-17.6 7.7l-104 112z',
  ],
};
const faFaceSpiralEyes = {
  prefix: 'far',
  iconName: 'face-spiral-eyes',
  icon: [
    512,
    512,
    [],
    'e485',
    'M464 256c0-114.9-93.1-208-208-208c-71 0-133.6 35.5-171.1 89.8c18.5-21.6 45.8-36.5 76.6-37.7c6.6-.3 12.2 4.9 12.5 11.5s-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm338.1 48.5c-.3-6.6 4.9-12.2 11.5-12.5c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5zm-35.9 46.6l6.7-4.5c22.2-14.8 51.8-11.9 70.7 7L385 359c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-5.4-5.4c-2.7-2.7-6.9-3.1-10.1-1l-6.7 4.5c-20.3 13.5-47 12.4-66-2.9l-1.7-1.4c-2.9-2.3-7.1-2.3-10 0l-1.7 1.4c-19 15.2-45.8 16.4-66 2.9l-6.7-4.5c-3.2-2.1-7.4-1.7-10.1 1L161 393c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l5.4-5.4c18.9-18.9 48.5-21.8 70.7-7l6.7 4.5c2.9 1.9 6.7 1.8 9.4-.4l1.7-1.4c20.5-16.4 49.5-16.4 70 0l1.7 1.4c2.7 2.2 6.5 2.3 9.4 .4z',
  ],
};
const faCompressWide = {
  prefix: 'far',
  iconName: 'compress-wide',
  icon: [
    512,
    512,
    [],
    'f326',
    'M160 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112zM24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L24 288zM400 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-88zM376 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faCirclePhoneHangup = {
  prefix: 'far',
  iconName: 'circle-phone-hangup',
  icon: [
    512,
    512,
    ['phone-circle-down'],
    'e11d',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 294l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L120.6 294c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L203.7 238c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6c9.9 3.8 21.4 .2 26.7-8.5z',
  ],
};
const faPhoneCircleDown = faCirclePhoneHangup;
const faGearComplexCode = {
  prefix: 'far',
  iconName: 'gear-complex-code',
  icon: [
    512,
    512,
    [],
    'e5eb',
    'M188.2 36.7C193.4 15.2 212.7 0 234.9 0l42.2 0c22.2 0 41.5 15.2 46.7 36.7L332 71l1.1 .4 30-18.4c18.9-11.6 43.3-8.7 59 7l29.8 29.8c15.7 15.7 18.6 40.1 7 59l-18.4 30 .4 1.1 34.2 8.3c21.6 5.2 36.7 24.5 36.7 46.7l0 42.2c0 22.2-15.2 41.5-36.7 46.7L441 332l-.4 1.1 18.4 30c11.6 18.9 8.7 43.3-7 59l-29.8 29.8c-15.7 15.7-40.1 18.6-59 7l-30-18.4L332 441l-8.3 34.2c-5.2 21.6-24.5 36.7-46.7 36.7l-42.2 0c-22.2 0-41.5-15.2-46.7-36.7L180 441l-1.1-.4-30 18.4c-18.9 11.6-43.3 8.7-59-7L60.1 422.1c-15.7-15.7-18.6-40.1-7-59l18.4-30L71 332l-34.2-8.3C15.2 318.6 0 299.3 0 277.1l0-42.2c0-22.2 15.2-41.5 36.7-46.7L71 180l.4-1.1L53 148.9c-11.6-18.9-8.7-43.3 7-59L89.9 60.1c15.7-15.7 40.1-18.6 59-7l30 18.4L180 71l8.3-34.2zM277.1 48l-42.2 0L223.6 94.6c-1.9 8-7.9 14.5-15.7 17.1c-6.8 2.3-13.5 5-19.9 8.2c-7.4 3.7-16.2 3.3-23.3-1L123.8 94 94 123.8l25 40.9c4.3 7.1 4.7 15.9 1 23.3c-3.2 6.4-6 13-8.2 19.9c-2.6 7.9-9.1 13.8-17.1 15.7L48 234.9l0 42.2 46.6 11.3c8 1.9 14.5 7.9 17.1 15.7c2.3 6.8 5 13.5 8.2 19.9c3.7 7.4 3.3 16.2-1 23.3L94 388.2 123.8 418l40.9-25c7.1-4.3 15.9-4.7 23.3-1c6.4 3.2 13 6 19.9 8.2c7.9 2.6 13.8 9.1 15.7 17.1L234.9 464l42.2 0 11.3-46.6c1.9-8 7.9-14.5 15.7-17.1c6.8-2.3 13.5-5 19.9-8.2c7.4-3.7 16.2-3.3 23.3 1l40.9 25L418 388.2l-25-40.9c-4.3-7.1-4.7-15.9-1-23.3c3.2-6.4 6-13 8.2-19.9c2.6-7.9 9.1-13.8 17.1-15.7L464 277.1l0-42.2-46.6-11.3c-8-1.9-14.5-7.9-17.1-15.7c-2.3-6.8-5-13.5-8.2-19.9c-3.7-7.4-3.3-16.2 1-23.3l25-40.9L388.2 94l-40.9 25c-7.1 4.3-15.9 4.7-23.3 1c-6.4-3.2-13-6-19.9-8.2c-7.9-2.6-13.8-9.1-15.7-17.1L277.1 48zm14.6 115.3l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z',
  ],
};
const faHouseMedicalCircleExclamation = {
  prefix: 'far',
  iconName: 'house-medical-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e512',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faBadminton = {
  prefix: 'far',
  iconName: 'badminton',
  icon: [
    576,
    512,
    [],
    'e33a',
    'M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6c48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9zM194.9 66.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-56.3 56.3-137 80.2-204.8 59.8c-27.3-8.2-58.7-7.8-80.5 9.7c11.3 12.6 10.9 31.9-1.2 44l-72 72c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l72-72c12.1-12.1 31.4-12.5 44-1.2c17.5-21.8 18.1-53.3 9.9-80.6c-4.9-16.3-7.3-33.4-7.3-50.6c0-54.2 23.4-110.5 66.9-154zM104 398.6L54.6 448l9.4 9.4L113.4 408l-9.4-9.4zM512 352c26.5 0 48 21.5 48 48l0 32-96 0 0-32c0-26.5 21.5-48 48-48zm-50.3 96l33.4 0-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9l13-43.4zm34.3 0l32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm32.9 0l33.4 0 13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7L528.9 448z',
  ],
};
const faClosedCaptioning = {
  prefix: 'far',
  iconName: 'closed-captioning',
  icon: [
    576,
    512,
    [],
    'f20a',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z',
  ],
};
const faPersonHiking = {
  prefix: 'far',
  iconName: 'person-hiking',
  icon: [
    384,
    512,
    ['hiking'],
    'f6ec',
    'M288 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136.5 125.8c3.8-15.1-7.7-29.8-23.3-29.8l-4.2 0C73 96 41.4 120.1 31.9 155L7 246.4c-3.7 13.7 5.2 27.7 19.2 30l47.9 8c12.3 2.1 24.2-5.7 27.2-17.9l35.2-140.7zM384 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-27.2 0-28.7-43.1c-11.2-16.9-28.6-28.7-48.5-32.9c-32-6.9-63.6 13.3-70.9 45.2l-19.8 86.5c-4.7 20.4 2.4 41.7 18.4 55.2L240 387.1 240 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104.6c0-11.8-5.2-22.9-14.2-30.5l-27.5-23.2 22.4-95.2 2.5 3.7c7.4 11.1 19.9 17.8 33.3 17.8l31.4 0 0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304zm-162.4-5.1c3.6 .8 7 2.2 10 4.1L205.3 294.9l-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l19.8-86.5c1.4-6.3 7.7-10.3 14.1-9zM80.9 481.5c-3.6 12.8 3.8 26 16.6 29.6s26-3.8 29.6-16.6l36.7-130-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8L80.9 481.5z',
  ],
};
const faHiking = faPersonHiking;
const faRightFromLine = {
  prefix: 'far',
  iconName: 'right-from-line',
  icon: [
    448,
    512,
    ['arrow-alt-from-left'],
    'f347',
    'M288 146.2L398 256 288 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM448 256c0-11.5-4.6-22.5-12.7-30.6L319.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L435.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88z',
  ],
};
const faArrowAltFromLeft = faRightFromLine;
const faVenusDouble = {
  prefix: 'far',
  iconName: 'venus-double',
  icon: [
    640,
    512,
    [9890],
    'f226',
    'M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM368 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6C82.2 338.7 16 265.1 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c10.9-11.7 20.5-24.6 28.5-38.6C393.7 294.9 419.8 304 448 304c70.7 0 128-57.3 128-128s-57.3-128-128-128c-28.2 0-54.3 9.1-75.5 24.6c-8-14-17.6-26.9-28.5-38.6C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6c-29.7-4-57-15.5-80-32.4z',
  ],
};
const faImages = {
  prefix: 'far',
  iconName: 'images',
  icon: [
    576,
    512,
    [],
    'f302',
    'M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCalculator = {
  prefix: 'far',
  iconName: 'calculator',
  icon: [
    384,
    512,
    [128425],
    'f1ec',
    'M336 176l0 272c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-272 288 0zm0-48L48 128l0-64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 64zm48 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 24 0 24L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-272 0-24 0-24zM80 232a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM80 408c0 13.3 10.7 24 24 24l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM192 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM168 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM280 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM256 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z',
  ],
};
const faShuttlecock = {
  prefix: 'far',
  iconName: 'shuttlecock',
  icon: [
    512,
    512,
    [],
    'f45b',
    'M247 48l-43.3 89.2L280 97.4 280 48l-33 0zM168.5 209.6l-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zM328 40l0 40 72 0c17.7 0 32 14.3 32 32l0 72 40 0c22.1 0 40 17.9 40 40l0 46c0 15.3-8.7 29.3-22.5 36l-242 117.5c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8L206 22.5C212.7 8.7 226.7 0 242 0l46 0c22.1 0 40 17.9 40 40zM222.3 382.3l80-38.9 48-92.1-81.5 25.7L193 353l29.4 29.4zm70.4-163.1L384 190.4l0-62.4-62.4 0-28.8 91.2zM188.1 416L96 323.9 73.3 346.6l92.1 92.1L188.1 416zm-48.4 42.3l-86-86C50 380.6 48 389.6 48 398.9c0 36 29.2 65.1 65.1 65.1c9.2 0 18.3-2 26.6-5.7zm235.1-150L464 265l0-33-49.4 0-39.7 76.3z',
  ],
};
const faUserHair = {
  prefix: 'far',
  iconName: 'user-hair',
  icon: [
    448,
    512,
    [],
    'e45a',
    'M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM49.6 464l348.7 0c-9.3-54.5-56.8-96-113.9-96l-120.9 0c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z',
  ],
};
const faEyeEvil = {
  prefix: 'far',
  iconName: 'eye-evil',
  icon: [
    640,
    512,
    [],
    'f6db',
    'M288.4 115.5L320 65l31.6 50.6c6.3 10 16 17.4 27.4 20.7c10.6 3.1 20.6 6.9 30 11.4c11 5.3 23.5 6.2 35.2 2.6l27.7-8.6-2.3 3.6c-10.6 16.2-10.5 37.1 .3 53.2c4.2 6.2 7.6 12.5 10.3 19c5.2 12.4 15.4 22 28.1 26.5L542.1 256l-33.9 12.1c-12.7 4.5-22.8 14.1-28.1 26.5c-2.7 6.5-6.2 12.8-10.3 19c-10.8 16.1-10.9 37-.3 53.2l2.3 3.6-27.7-8.6c-11.6-3.6-24.2-2.7-35.2 2.6c-9.4 4.5-19.4 8.4-30 11.4c-11.4 3.3-21.1 10.6-27.4 20.7L320 447l-31.6-50.6c-6.3-10-16-17.4-27.4-20.7c-10.6-3.1-20.6-6.9-30-11.4c-11-5.3-23.5-6.2-35.2-2.6l-27.7 8.6 2.3-3.6c10.6-16.2 10.5-37.1-.3-53.2c-4.2-6.2-7.6-12.5-10.3-19c-5.2-12.4-15.4-22-28.1-26.5L97.9 256l33.9-12.1c12.7-4.5 22.8-14.1 28.1-26.5c2.7-6.5 6.2-12.8 10.3-19c10.8-16.1 10.9-37 .3-53.2l-2.3-3.6 27.7 8.6c11.6 3.6 24.2 2.7 35.2-2.6c9.4-4.5 19.4-8.4 30-11.4c11.4-3.3 21.1-10.6 27.4-20.7zM392.3 90.1L344.5 13.6C339.2 5.1 330 0 320 0s-19.2 5.1-24.5 13.6L247.7 90.1c-13.1 3.8-25.7 8.6-37.5 14.3L114.9 74.7c-9.2-2.9-19.1 .3-24.9 8s-6.1 18.1-.8 26.1l41.3 62.7c-5.8 8.6-10.7 17.7-14.7 27.1L15.1 234.6C6 237.8 0 246.4 0 256s6 18.2 15.1 21.4l100.6 35.9c4 9.4 8.9 18.5 14.7 27.1L89.2 403.2c-5.3 8-4.9 18.5 .8 26.1s15.7 10.9 24.9 8l95.3-29.8c11.8 5.7 24.4 10.5 37.5 14.3l47.8 76.5C300.8 506.9 310 512 320 512s19.2-5.1 24.5-13.6l47.8-76.5c13.1-3.8 25.7-8.6 37.5-14.3l95.3 29.8c9.2 2.9 19.1-.3 24.9-8s6.1-18.1 .8-26.1l-41.3-62.7c5.8-8.6 10.7-17.7 14.7-27.1l100.6-35.9c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L524.3 198.7c-4-9.4-8.9-18.5-14.7-27.1l41.3-62.7c5.3-8 4.9-18.5-.8-26.1s-15.7-10.9-24.9-8l-95.3 29.8c-11.8-5.7-24.4-10.5-37.5-14.3zM256 245.5c12 4 24.5 7 37.3 8.7c.1 .4 .2 .7 .4 1.1c5.5 14.4 13.5 24.4 18.1 29.3c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c4.5-4.9 12.6-14.9 18.1-29.3c.1-.4 .3-.7 .4-1.1c12.9-1.7 25.3-4.6 37.3-8.7c0 .8 0 1.6 0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-.8 0-1.6 0-2.5zM246 242s0 0 0 0c0 0 .1 0 .1 0l-.1 0c0 0 0 0 0 0zm148 0s0 0-.1 0c.1 0 .1 0 .1 0zM220.1 219c-2.7 9.2-4.1 18.9-4.1 29c0 57.4 46.6 104 104 104s104-46.6 104-104c0-10-1.4-19.8-4.1-29c-4.9-16.8-25-20.6-41.3-14.1C360.5 212.1 340.7 216 320 216s-40.5-3.9-58.6-11.1c-16.3-6.4-36.4-2.7-41.3 14.1z',
  ],
};
const faPeoplePulling = {
  prefix: 'far',
  iconName: 'people-pulling',
  icon: [
    576,
    512,
    [],
    'e535',
    'M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM48 271.9L48 328c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 184c0-30.9 25.1-56 56-56l58.4 0c15.1 0 29.9 3.9 43 11.2l122.5 68.7c17.9-34 48.4-60 85.1-72.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L569 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L506 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3 50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L375 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2c-6.8-3-11.5-8.8-13.3-15.4L160.5 196l63 286.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L145.6 352l-30.9 0 28.7 130.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L48 271.9zM106.9 176l-30.9 0 28.1 128 30.9 0L106.9 176zM464 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM397.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm-42.1 75.6l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L297 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4z',
  ],
};
const faN = {
  prefix: 'far',
  iconName: 'n',
  icon: [
    384,
    512,
    [110],
    '4e',
    'M15.8 33.5c9.5-3.5 20.1-.6 26.6 7.1L336 390.1 336 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 10.1-6.3 19.1-15.8 22.6s-20.1 .6-26.6-7.1L48 121.9 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 45.9 6.3 36.9 15.8 33.5z',
  ],
};
const faSwap = {
  prefix: 'far',
  iconName: 'swap',
  icon: [
    640,
    512,
    [],
    'e609',
    'M240 119c0 22.6-18.3 41-41 41l-47 0 0 200c0 39.8 32.2 72 72 72s72-32.2 72-72l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 200 47 0c22.6 0 41 18.3 41 41c0 10.9-4.3 21.3-12 29l-83 83c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-83-83c-7.7-7.7-12-18.1-12-29c0-22.6 18.3-41 41-41l47 0 0-200c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-200-47 0c-22.6 0-41-18.3-41-41c0-10.9 4.3-21.3 12-29L111 7c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l83 83c7.7 7.7 12 18.1 12 29zM73.9 112l108.1 0L128 57.9 73.9 112zm384 288L512 454.1 566.1 400l-108.1 0z',
  ],
};
const faGarage = {
  prefix: 'far',
  iconName: 'garage',
  icon: [
    640,
    512,
    [],
    'e009',
    'M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 368l0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-352 0zm0-48l352 0 0-80-352 0 0 80zm136 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faCableCar = {
  prefix: 'far',
  iconName: 'cable-car',
  icon: [
    512,
    512,
    [128673, 57551, 'tram'],
    'f7da',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 288l0 64-80 0 0-80 64 0c8.8 0 16 7.2 16 16zm0 112l0 48c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-48 104 0 144 0 104 0zM80 352l0-64c0-8.8 7.2-16 16-16l64 0 0 80-80 0zm128-80l96 0 0 80-96 0 0-80zM96 224c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-136 0 0-76.5 212.9-44c13-2.7 21.3-15.4 18.6-28.4s-15.4-21.3-28.4-18.6l-232 48-232 48c-13 2.7-21.3 15.4-18.6 28.4s15.4 21.3 28.4 18.6l203.1-42 0 66.5L96 224z',
  ],
};
const faTram = faCableCar;
const faShovelSnow = {
  prefix: 'far',
  iconName: 'shovel-snow',
  icon: [
    512,
    512,
    [],
    'f7c3',
    'M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2L297.9 248l35.3 35.3c19.8 19.8 21.9 51.2 4.9 73.5L236.7 489.9c-10.6 13.9-27.1 22.1-44.5 22.1l-2.9 0c-14.9 0-29.1-5.9-39.6-16.4L16.4 362.3C5.9 351.8 0 337.6 0 322.7l0-2.9c0-17.5 8.2-34 22.1-44.5L155.2 173.9c22.3-17 53.7-14.9 73.5 4.9L264 214.1l81.2-81.2c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM184.3 212L51.2 313.5c-2 1.5-3.2 3.9-3.2 6.4l0 2.9c0 2.1 .8 4.2 2.3 5.7L183.6 461.7c1.5 1.5 3.5 2.3 5.7 2.3l2.9 0c2.5 0 4.9-1.2 6.4-3.2L300 327.7c2.4-3.2 2.1-7.7-.7-10.5L194.8 212.7c-2.8-2.8-7.3-3.1-10.5-.7zm5.8 90.1l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm48 48l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z',
  ],
};
const faCloudRain = {
  prefix: 'far',
  iconName: 'cloud-rain',
  icon: [
    512,
    512,
    [127783, 9926],
    'f73d',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM89.2 372L54.2 436.6C50.1 444.1 48 452.5 48 461l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm160 0l-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm124.9 64.6c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6z',
  ],
};
const faFaceLying = {
  prefix: 'far',
  iconName: 'face-lying',
  icon: [
    512,
    512,
    [],
    'e37e',
    'M431.3 368L352 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l152 0c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96zm67.4-30.3C464.6 439 368.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 8.8-.4 17.6-1.3 26.2c.9 4.5 1.3 9.1 1.3 13.8c0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM195.2 390.4c-8 10.6-23 12.7-33.6 4.8s-12.7-23-4.8-33.6C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7c12.1 5.3 17.7 19.5 12.4 31.6s-19.5 17.7-31.6 12.4c-6.8-3-14.4-4.6-22.4-4.6c-18.3 0-34.6 8.8-44.8 22.4z',
  ],
};
const faSprinkler = {
  prefix: 'far',
  iconName: 'sprinkler',
  icon: [
    512,
    512,
    [],
    'e035',
    'M0 24a24 24 0 1 1 48 0A24 24 0 1 1 0 24zm24 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM512 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM424 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM97.8 270.8c3.7-9 12.5-14.8 22.2-14.8l112 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168 112 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89 0 86.1c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-86.1-89-89c-6.9-6.9-8.9-17.2-5.2-26.2zM256 304l-78.1 0 55 55c4.5 4.5 7 10.6 7 17l0 88 32 0 0-88c0-6.4 2.5-12.5 7-17l55-55L256 304z',
  ],
};
const faBuildingCircleXmark = {
  prefix: 'far',
  iconName: 'building-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4d4',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faPersonSledding = {
  prefix: 'far',
  iconName: 'person-sledding',
  icon: [
    512,
    512,
    ['sledding'],
    'f7cb',
    'M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 152c0-13.3 10.7-24 24-24l169.4 0c35.6 0 53.5 43.1 28.3 68.3L281.9 264l62.1 0c22.1 0 40 17.9 40 40l0 80c0 7.7-3.7 14.6-9.4 19l43.9 22.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 269.3C1.2 263.2-3.4 248.7 2.7 236.9s20.6-16.3 32.4-10.2l124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80L152 176c-13.3 0-24-10.7-24-24zM336 312l-136.7 0L336 383l0-71z',
  ],
};
const faSledding = faPersonSledding;
const faGameConsoleHandheld = {
  prefix: 'far',
  iconName: 'game-console-handheld',
  icon: [
    384,
    512,
    [],
    'f8bb',
    'M64 48c-8.8 0-16 7.2-16 16l0 352c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-352c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 352c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 64zM232 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 288c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM112 96l160 0c8.8 0 16 7.2 16 16l0 112c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-112c0-8.8 7.2-16 16-16z',
  ],
};
const faShip = {
  prefix: 'far',
  iconName: 'ship',
  icon: [
    576,
    512,
    [128674],
    'f21a',
    'M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l0 32 40 0c30.9 0 56 25.1 56 56l0 118.4 25.9 9.7c38.1 14.3 48.7 63.2 19.9 92L457 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.9-68.9c4.1-4.1 2.6-11.1-2.8-13.1L290.8 218.7c-1.8-.7-3.8-.7-5.6 0L87 293c-5.4 2-7 9-2.8 13.1L153 375c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L50.2 340.1c-28.8-28.8-18.2-77.7 19.9-92L96 238.4 96 120c0-30.9 25.1-56 56-56l40 0 0-32zm-48 88l0 100.4 124.3-46.6c12.7-4.8 26.6-4.8 39.3 0L432 220.4 432 120c0-4.4-3.6-8-8-8l-272 0c-4.4 0-8 3.6-8 8zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faClockSixThirty = {
  prefix: 'far',
  iconName: 'clock-six-thirty',
  icon: [
    512,
    512,
    [],
    'e353',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faBatterySlash = {
  prefix: 'far',
  iconName: 'battery-slash',
  icon: [
    640,
    512,
    [],
    'f377',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L154.8 96 38.8 5.1zM216 144l280 0c17.7 0 32 14.3 32 32l0 160c0 15.9-11.6 29.1-26.7 31.6L216 144zM406.2 416l-60.9-48L112 368c-17.7 0-32-14.3-32-32l0-160c0-5.1 1.2-10 3.4-14.3l-38-30C36.9 144.4 32 159.6 32 176l0 160c0 44.2 35.8 80 80 80l294.2 0z',
  ],
};
const faTugrikSign = {
  prefix: 'far',
  iconName: 'tugrik-sign',
  icon: [
    384,
    512,
    [],
    'e2ba',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l144 0 0 125.3L58.2 232.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 254.7l0 46.5L58.2 328.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 350.7 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.3 109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 289.3l0-46.5 109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 193.3 216 80l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L192 32 24 32z',
  ],
};
const faArrowsDownToLine = {
  prefix: 'far',
  iconName: 'arrows-down-to-line',
  icon: [
    576,
    512,
    [],
    'e4b8',
    'M552 432L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm17-159c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63L472 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L431 377c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L569 273zM249 239c-9.4-9.4-24.6-9.4-33.9 0l-63 63L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L111 377c9.4 9.4 24.6 9.4 33.9 0L249 273c9.4-9.4 9.4-24.6 0-33.9z',
  ],
};
const faDownload = {
  prefix: 'far',
  iconName: 'download',
  icon: [
    512,
    512,
    [],
    'f019',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faAnglesUpDown = {
  prefix: 'far',
  iconName: 'angles-up-down',
  icon: [
    448,
    512,
    [],
    'e60d',
    'M239 498.7c-8.8 7-21.2 7-30 0L49 370.7c-10.4-8.3-12-23.4-3.7-33.7s23.4-12 33.7-3.8l145 116 145-116c10.3-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.7 33.7l-160 128zM399 141.3c10.4 8.3 12 23.4 3.8 33.7s-23.4 12-33.7 3.7L224 62.7 79 178.7c-10.4 8.3-25.5 6.6-33.7-3.7s-6.6-25.5 3.7-33.7l160-128c8.8-7 21.2-7 30 0l160 128z',
  ],
};
const faShelves = {
  prefix: 'far',
  iconName: 'shelves',
  icon: [
    640,
    512,
    ['inventory'],
    'f480',
    'M24 0C37.3 0 48 10.7 48 24l0 136 544 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 256 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L48 464l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48L0 184 0 24C0 10.7 10.7 0 24 0zM48 416l544 0 0-208L48 208l0 208zM352 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM128 256l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm160 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
  ],
};
const faInventory = faShelves;
const faCloudSnow = {
  prefix: 'far',
  iconName: 'cloud-snow',
  icon: [
    512,
    512,
    [127784],
    'f742',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM64 352c-13.3 0-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24zm192 32c-13.3 0-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24zm216-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16z',
  ],
};
const faFaceGrin = {
  prefix: 'far',
  iconName: 'face-grin',
  icon: [
    512,
    512,
    [128512, 'grin'],
    'f580',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faGrin = faFaceGrin;
const faDeleteLeft = {
  prefix: 'far',
  iconName: 'delete-left',
  icon: [
    576,
    512,
    [9003, 'backspace'],
    'f55a',
    'M205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L205.3 64zM528 128l0 256c0 8.8-7.2 16-16 16l-306.7 0c-4.2 0-8.3-1.7-11.3-4.7L54.6 256 193.9 116.7c3-3 7.1-4.7 11.3-4.7L512 112c8.8 0 16 7.2 16 16zm-95 47c-9.4-9.4-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9z',
  ],
};
const faBackspace = faDeleteLeft;
const faOven = {
  prefix: 'far',
  iconName: 'oven',
  icon: [
    448,
    512,
    [],
    'e01d',
    'M352 48c26.5 0 48 21.5 48 48l0 64L48 160l0-64c0-26.5 21.5-48 48-48l256 0zm48 160l0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-240 352 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0zm32 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-224 0zm32 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faCloudBinary = {
  prefix: 'far',
  iconName: 'cloud-binary',
  icon: [
    640,
    512,
    [],
    'e601',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM176 216l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm72-16c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm120-16c-22.1 0-40 17.9-40 40l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16zM192 320c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm80 24l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm88-32c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0z',
  ],
};
const faEyeDropper = {
  prefix: 'far',
  iconName: 'eye-dropper',
  icon: [
    512,
    512,
    ['eye-dropper-empty', 'eyedropper'],
    'f1fb',
    'M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c0 0 0 0 0 0l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9l0 52.9-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28 52.9 0c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6l-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7L80 432l0-52.1c0-6.4 2.5-12.5 7-17L217.4 232.6l-33.9-33.9L53.1 329z',
  ],
};
const faEyeDropperEmpty = faEyeDropper;
const faEyedropper = faEyeDropper;
const faCommentCaptions = {
  prefix: 'far',
  iconName: 'comment-captions',
  icon: [
    512,
    512,
    [],
    'e146',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM136 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0zm112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z',
  ],
};
const faCommentsQuestion = {
  prefix: 'far',
  iconName: 'comments-question',
  icon: [
    640,
    512,
    [],
    'e14e',
    'M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM147.9 112.1c5.5-15.4 20.1-25.7 36.4-25.7l41.3 0c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 181.4l0 .3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7l-41.3 0c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 244a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z',
  ],
};
const faScribble = {
  prefix: 'far',
  iconName: 'scribble',
  icon: [
    512,
    512,
    [],
    'e23f',
    'M183.3 21.4C198.3 7.7 218 0 238.4 0l1 0C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L374.5 151.6c15.1-15.1 35.6-23.6 57-23.6c44.5 0 80.6 36.1 80.6 80.6c0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39c0 30.5 24.7 55.2 55.2 55.2l4.4 0c5.6 0 11.2-.9 16.6-2.7l36.2-12.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2l-4.4 0c-57 0-103.2-46.2-103.2-103.2c0-27.4 10.9-53.6 30.2-73L454.5 231.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6c-8.6 0-16.9 3.4-23 9.5L169.5 424.4c-15.1 15.1-35.6 23.6-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57L262.5 103.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6l-1 0c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L183.3 21.4z',
  ],
};
const faRotateExclamation = {
  prefix: 'far',
  iconName: 'rotate-exclamation',
  icon: [
    512,
    512,
    [],
    'e23c',
    'M256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1 448 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l54.1 0-52.1-52.1C333.8 95.8 295.7 80 256 80zM449.4 312.6c12.2 5.2 17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9 64 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-54.1 0 52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faFileCircleCheck = {
  prefix: 'far',
  iconName: 'file-circle-check',
  icon: [
    576,
    512,
    [],
    'e5a0',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faGlass = {
  prefix: 'far',
  iconName: 'glass',
  icon: [
    384,
    512,
    [129371],
    'f804',
    'M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM57.1 128L50.2 48l283.7 0-6.9 80L57.1 128zm4.1 48l261.6 0L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L61.2 176z',
  ],
};
const faLoader = {
  prefix: 'far',
  iconName: 'loader',
  icon: [
    512,
    512,
    [],
    'e1d4',
    'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm0 384c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM0 256c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm408-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM437 75c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9zM165.5 380.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6zM75 75c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM380.5 346.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.6-56.6z',
  ],
};
const faForward = {
  prefix: 'far',
  iconName: 'forward',
  icon: [
    512,
    512,
    [9193],
    'f04e',
    'M224 94c0-16.6 13.5-30 30-30c6.3 0 12.5 2 17.6 5.7L502.1 236.6c6.2 4.5 9.9 11.7 9.9 19.4s-3.7 14.9-9.9 19.4L271.7 442.3c-5.1 3.7-11.3 5.7-17.6 5.7c-16.6 0-30-13.4-30-30l0-99.1L47.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C13.5 448 0 434.5 0 417.9L0 94.1C0 77.5 13.5 64 30.1 64c6.2 0 12.2 1.9 17.3 5.4L224 193.1 224 94zm0 157.7L48 128.5l0 255L224 260.3l0-8.6zM447.1 256L272 129.2l0 253.6L447.1 256z',
  ],
};
const faUserPilot = {
  prefix: 'far',
  iconName: 'user-pilot',
  icon: [
    448,
    512,
    [],
    'e2c0',
    'M217.9 .8c4-1.1 8.2-1.1 12.2 0l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5l0 8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9l0-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7zM98.1 168.8c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM50.9 464l137.6 0c-2.3-1.5-4.5-3.2-6.6-5.1l-65.2-57.1c-31.9 6.7-57.3 30.9-65.7 62.2zm346.1 0c-8.4-31.2-33.8-55.5-65.7-62.2l-65.2 57.1c-2.1 1.9-4.3 3.6-6.6 5.1l137.6 0zM126.5 352.2c3.9-.2 7.8 1.2 10.7 3.8l76.3 66.7c6 5.3 15 5.3 21.1 0l76.3-66.7c3-2.6 6.8-4.1 10.7-3.8C392.1 356.3 448 414.8 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4c0-71.6 55.9-130.1 126.5-134.2z',
  ],
};
const faMobile = {
  prefix: 'far',
  iconName: 'mobile',
  icon: [
    384,
    512,
    [128241, 'mobile-android', 'mobile-phone'],
    'f3ce',
    'M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faMobileAndroid = faMobile;
const faMobilePhone = faMobile;
const faCodePullRequestClosed = {
  prefix: 'far',
  iconName: 'code-pull-request-closed',
  icon: [
    512,
    512,
    [],
    'e3f9',
    'M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3l0 199.3c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-199.3C55.5 146.1 32 115.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 48c-44.2 0-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L376 224c0-13.3 10.7-24 24-24s24 10.7 24 24l0 131.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80zM327 7c9.4-9.4 24.6-9.4 33.9 0l39 39L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L327 41c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faFaceMeh = {
  prefix: 'far',
  iconName: 'face-meh',
  icon: [
    512,
    512,
    [128528, 'meh'],
    'f11a',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faMeh = faFaceMeh;
const faAlignCenter = {
  prefix: 'far',
  iconName: 'align-center',
  icon: [
    448,
    512,
    [],
    'f037',
    'M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 40zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM96 320c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z',
  ],
};
const faBookSkull = {
  prefix: 'far',
  iconName: 'book-skull',
  icon: [
    448,
    512,
    ['book-dead'],
    'f6b7',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM288 195.2l0 12.8c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-12.8c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM224 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128.8 234.9c2.8-8.4 11.9-12.9 20.2-10.1L240 255.1l90.9-30.3c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L290.6 272l50.5 16.8c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1L240 288.9l-90.9 30.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L189.4 272l-50.5-16.8c-8.4-2.8-12.9-11.9-10.1-20.2z',
  ],
};
const faBookDead = faBookSkull;
const faIdCard = {
  prefix: 'far',
  iconName: 'id-card',
  icon: [
    576,
    512,
    [62147, 'drivers-license'],
    'f2c2',
    'M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z',
  ],
};
const faDriversLicense = faIdCard;
const faFaceDotted = {
  prefix: 'far',
  iconName: 'face-dotted',
  icon: [
    512,
    512,
    [129765],
    'e47f',
    'M256 0c-13.6 0-27 1.1-40 3.1c-13.1 2.1-22 14.3-20 27.4s14.3 22 27.4 20C234 48.9 244.9 48 256 48s22 .9 32.6 2.5c13.1 2.1 25.4-6.9 27.4-20s-6.9-25.4-20-27.4C283 1.1 269.6 0 256 0zM133.7 87.7c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3C83.8 64.7 64.7 83.8 48.9 105.5c-7.8 10.7-5.4 25.7 5.3 33.5s25.7 5.4 33.5-5.3c12.8-17.6 28.4-33.2 46.1-46.1zM406.5 48.9c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5c17.6 12.8 33.2 28.4 46 46.1c7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5c-15.8-21.7-34.9-40.8-56.6-56.6zM50.5 223.4c2.1-13.1-6.9-25.4-20-27.4s-25.4 6.9-27.4 20C1.1 229 0 242.4 0 256s1.1 27 3.1 40c2.1 13.1 14.3 22 27.4 20s22-14.3 20-27.4C48.9 278 48 267.1 48 256s.9-22 2.5-32.6zM508.9 216c-2.1-13.1-14.3-22-27.4-20s-22 14.3-20 27.4c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3c-7.8-10.7-22.8-13.1-33.5-5.3s-13.1 22.8-5.3 33.5c15.8 21.7 34.9 40.8 56.6 56.6c10.7 7.8 25.7 5.4 33.5-5.3s5.4-25.7-5.3-33.5c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2c7.8-10.7 5.4-25.7-5.3-33.5s-25.7-5.4-33.5 5.3c-12.8 17.6-28.4 33.2-46 46c-10.7 7.8-13.1 22.8-5.3 33.5s22.8 13.1 33.5 5.3c21.7-15.8 40.8-34.9 56.6-56.6zm-239.7 55c-13.1-2.1-25.4 6.9-27.4 20s6.9 25.4 20 27.4c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1c13.1-2.1 22-14.3 20-27.4s-14.3-22-27.4-20C278 463.1 267.1 464 256 464s-22-.9-32.6-2.5zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faFaceWorried = {
  prefix: 'far',
  iconName: 'face-worried',
  icon: [
    512,
    512,
    [],
    'e3a3',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 414.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
  ],
};
const faOutdent = {
  prefix: 'far',
  iconName: 'outdent',
  icon: [
    448,
    512,
    ['dedent'],
    'f03b',
    'M0 64C0 50.7 10.7 40 24 40l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 88C10.7 88 0 77.3 0 64zM192 192c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 104l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 448c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 472c-13.3 0-24-10.7-24-24zM7 268.4C-.8 262-.8 250 7 243.6l94.8-78.1c10.4-8.6 26.2-1.2 26.2 12.4l0 156.2c0 13.5-15.7 20.9-26.2 12.4L7 268.4z',
  ],
};
const faDedent = faOutdent;
const faCourtSport = {
  prefix: 'far',
  iconName: 'court-sport',
  icon: [
    640,
    512,
    [],
    'e643',
    'M64 80c-8.8 0-16 7.2-16 16l0 32 16 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-16 0 0 32c0 8.8 7.2 16 16 16l232 0 0-66.6c-50.3-11-88-55.8-88-109.4s37.7-98.4 88-109.4L296 80 64 80zM344 365.4l0 66.6 232 0c8.8 0 16-7.2 16-16l0-32-16 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l16 0 0-32c0-8.8-7.2-16-16-16L344 80l0 66.6c50.3 11 88 55.8 88 109.4s-37.7 98.4-88 109.4zm0-168.8l0 118.7c23.5-9.5 40-32.5 40-59.3s-16.5-49.9-40-59.3zm-48 0c-23.5 9.5-40 32.5-40 59.3s16.5 49.9 40 59.3l0-118.7zM48 176l0 160 16 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-16 0zM576 336l16 0 0-160-16 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faHeartCircleExclamation = {
  prefix: 'far',
  iconName: 'heart-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e4fe',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faHouse = {
  prefix: 'far',
  iconName: 'house',
  icon: [
    576,
    512,
    [127968, 63498, 63500, 'home', 'home-alt', 'home-lg-alt'],
    'f015',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-48 0 0-152c0-22.1-17.9-40-40-40l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32zm128 32l0-144 96 0 0 144-96 0z',
  ],
};
const faHome = faHouse;
const faHomeAlt = faHouse;
const faHomeLgAlt = faHouse;
const faVectorCircle = {
  prefix: 'far',
  iconName: 'vector-circle',
  icon: [
    512,
    512,
    [],
    'e2c6',
    'M232 88l48 0 0-48-48 0 0 48zM192 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 17.6c67.8 21 121.4 74.5 142.4 142.4l17.6 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-17.6 0c-21 67.8-74.5 121.4-142.4 142.4l0 17.6c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-17.6C124.2 441.4 70.6 387.8 49.6 320L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l17.6 0C70.6 124.2 124.2 70.6 192 49.6L192 32zM100.5 192.3C116 194.5 128 207.9 128 224l0 64c0 16.1-12 29.5-27.5 31.7c17 41.6 50.3 74.8 91.8 91.8C194.5 396 207.9 384 224 384l64 0c16.1 0 29.5 12 31.7 27.5c41.6-17 74.8-50.3 91.8-91.8C396 317.5 384 304.1 384 288l0-64c0-16.1 12-29.5 27.5-31.7c-17-41.6-50.3-74.8-91.8-91.8C317.5 116 304.1 128 288 128l-64 0c-16.1 0-29.5-12-31.7-27.5c-41.6 17-74.8 50.3-91.8 91.8zM424 232l0 48 48 0 0-48-48 0zM232 424l0 48 48 0 0-48-48 0zM40 232l0 48 48 0 0-48-48 0z',
  ],
};
const faCarCircleBolt = {
  prefix: 'far',
  iconName: 'car-circle-bolt',
  icon: [
    640,
    512,
    [],
    'e342',
    'M127.7 106.8L103.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c2.6 1.5 5.2 3.2 7.6 4.9c-28.3 3.9-54.4 14.6-76.8 30.3L96 224c-26.5 0-48 21.5-48 48l0 80 272.7 0c-.5 5.3-.7 10.6-.7 16c0 10.9 1 21.6 2.9 32L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z',
  ],
};
const faCalendarWeek = {
  prefix: 'far',
  iconName: 'calendar-week',
  icon: [
    448,
    512,
    [],
    'f784',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l224 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
  ],
};
const faFlyingDisc = {
  prefix: 'far',
  iconName: 'flying-disc',
  icon: [
    448,
    512,
    [],
    'e3a9',
    'M390.4 89.6c7.9 7.9 16.9 31.4 .6 80.4c-15.3 45.9-49.5 101-100.7 152.2S183.9 407.6 138 422.9c-49 16.3-72.5 7.3-80.4-.6c-5.6-5.6-11.8-19.2-9-44.3c19.9 19.2 45.3 20.8 62.5 18.9c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c1.9-17.2 .3-42.6-18.9-62.5c25.1-2.8 38.7 3.3 44.3 9zM105.2 175.4C8.3 281.9-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.2 356.2S479.6 111 424.3 55.7C372.2 3.6 249.9 40.3 143.5 137.1c-6.6 6-13.2 12.2-19.7 18.7c-6.5 6.5-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8c5.9-5.9 11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1c21.4 21.4-12.7 90.1-76.1 153.4s-132.1 97.4-153.4 76.1c-19.4-19.4 6.8-77.7 59.1-135.6z',
  ],
};
const faLaptopMedical = {
  prefix: 'far',
  iconName: 'laptop-medical',
  icon: [
    640,
    512,
    [],
    'f812',
    'M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM288 144l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faSquareDownRight = {
  prefix: 'far',
  iconName: 'square-down-right',
  icon: [
    448,
    512,
    [],
    'e26c',
    'M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM320 198.6L320 336c0 8.8-7.2 16-16 16l-137.4 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z',
  ],
};
const faB = {
  prefix: 'far',
  iconName: 'b',
  icon: [
    320,
    512,
    [98],
    '42',
    'M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l140 0c68.5 0 124-55.5 124-124c0-48.9-28.3-91.1-69.3-111.3c23-22.5 37.3-53.9 37.3-88.7c0-68.5-55.5-124-124-124L56 32zM164 232L48 232 48 88c0-4.4 3.6-8 8-8l108 0c42 0 76 34 76 76s-34 76-76 76zM48 280l116 0 28 0 4 0c42 0 76 34 76 76s-34 76-76 76L56 432c-4.4 0-8-3.6-8-8l0-144z',
  ],
};
const faSeatAirline = {
  prefix: 'far',
  iconName: 'seat-airline',
  icon: [
    448,
    512,
    [],
    'e244',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 142.9c0 14.7 3.1 29.2 9.1 42.5L89.1 364c14.2 31.6 45.6 52 80.3 52l46.6 0 0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48 88 0c29.1 0 55.3-17.5 66.5-44.3l27.7-66.5c3.1-7.4 2.3-15.9-2.2-22.5S432 272 424 272l-323.5 0L86.2 240 328 240c13.3 0 24-10.7 24-24s-10.7-24-24-24L64.6 192 52.9 165.8c-3.2-7.2-4.9-15-4.9-22.9L48 24zm84.9 320.4L122 320l266 0-13.8 33.2c-3.7 8.9-12.5 14.8-22.2 14.8l-182.6 0c-15.8 0-30.1-9.3-36.5-23.6z',
  ],
};
const faMoonOverSun = {
  prefix: 'far',
  iconName: 'moon-over-sun',
  icon: [
    512,
    512,
    ['eclipse-alt'],
    'f74a',
    'M361.3 1.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L450.9 256l56.9 82.5c4.6 6.7 5.5 15.3 2.4 22.8s-9.8 13-17.8 14.4l-98.5 18.1-18.1 98.5c-1.5 8-6.9 14.7-14.4 17.8s-16.1 2.2-22.8-2.4L256 450.9l-82.5 56.9c-6.7 4.6-15.3 5.5-22.8 2.4s-12.9-9.8-14.4-17.8l-18.1-98.5L19.7 375.7c-8-1.5-14.7-6.9-17.8-14.4s-2.2-16.1 2.4-22.8L61.1 256 4.2 173.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-12.9 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L256 61.1 338.5 4.2c6.7-4.6 15.3-5.5 22.8-2.4zm-26.1 63L269.6 110c-8.2 5.7-19 5.7-27.2 0L176.8 64.8l-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L64.8 176.8 110 242.4c5.7 8.2 5.7 19 0 27.2L64.8 335.2l78.3 14.4c9.8 1.8 17.5 9.5 19.3 19.3l14.4 78.3L242.4 402c8.2-5.7 19-5.7 27.2 0l65.6 45.2 14.4-78.3c1.8-9.8 9.5-17.5 19.3-19.3l78.3-14.4L402 269.6c-5.7-8.2-5.7-19 0-27.2l45.2-65.6-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3L335.2 64.8zM144 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm151.7 50.2C310.5 294.5 320 276.4 320 256c0-35.3-28.7-64-64-64c-.2 0-.4 0-.5 0c-12.3 12.2-19.9 29-19.9 47.5c0 34.4 26.2 62.9 60.1 66.7z',
  ],
};
const faEclipseAlt = faMoonOverSun;
const faPipe = {
  prefix: 'far',
  iconName: 'pipe',
  icon: [
    64,
    512,
    [],
    '7c',
    'M32 0C45.3 0 56 10.7 56 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L8 24C8 10.7 18.7 0 32 0z',
  ],
};
const faFileMedical = {
  prefix: 'far',
  iconName: 'file-medical',
  icon: [
    384,
    512,
    [],
    'f477',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faPotato = {
  prefix: 'far',
  iconName: 'potato',
  icon: [
    512,
    512,
    [129364],
    'e440',
    'M464 144c0-53-43-96-96-96c-26.6 0-50.5 10.7-68 28.2C269.3 107 232 134.9 194 155.7c-16.1 8.8-29.4 22.1-38.2 38.2C134.9 232 107 269.3 76.2 300C58.7 317.5 48 341.4 48 368c0 53 43 96 96 96c20.2 0 38.9-6.2 54.3-16.8c31.8-21.9 67.9-39.9 104.3-52.2c29.5-10 53.5-34 62.1-66.1c11.5-42.8 36.5-84.4 68.8-114.7C452.4 196.6 464 171.7 464 144zm48 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM352 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faDiceOne = {
  prefix: 'far',
  iconName: 'dice-one',
  icon: [
    448,
    512,
    [9856],
    'f525',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCircleA = {
  prefix: 'far',
  iconName: 'circle-a',
  icon: [
    512,
    512,
    [],
    'e0f7',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.1 0-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L190.8 320l130.3 0 17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L297.2 272l-82.3 0L256 189.7z',
  ],
};
const faHelmetBattle = {
  prefix: 'far',
  iconName: 'helmet-battle',
  icon: [
    576,
    512,
    [],
    'f6eb',
    'M80 17.1L65.1 225.7c-1.2 17-15.4 30.2-32.5 30.2l-2.2 0C13.6 256 0 242.4 0 225.6c0-2.3 .3-4.6 .8-6.8L48.4 12.4c1.9-8.1 9.7-13.5 18-12.2s14.2 8.6 13.6 17zM75.5 420.5c-9.2-5.6-13.5-16.7-10.6-27.1C81.9 333.6 96 270.2 96 208c0-85 89.1-149.2 153.1-189c1.9-1.2 4-2.6 6.3-4.1C264.8 8.4 277.3 0 288 0s23.2 8.4 32.7 14.9c2.3 1.5 4.4 3 6.3 4.1C390.9 58.8 480 123 480 208c0 62.2 14.1 125.6 31.1 185.4c3 10.4-1.4 21.4-10.6 27.1L316.8 506c-8.5 3.9-17.7 6-27 6l-3.7 0c-9.3 0-18.6-2-27-6L75.5 420.5zM312 455.3l147.4-68.7C444.4 330.7 432 269.5 432 208c0-25-13.1-50.9-39.2-78.3c-26-27.1-60-50.6-91.2-70c-2.7-1.7-5.9-3.9-8.3-5.4l-1.5-1c-1.4-1-2.7-1.8-3.9-2.5c-1.2 .7-2.4 1.6-3.9 2.5l-1.5 1c-2.3 1.6-5.5 3.7-8.3 5.4c-31.2 19.4-65.2 42.9-91.2 70C157.1 157.1 144 183 144 208c0 61.5-12.4 122.7-27.4 178.7L264 455.3l0-156.1c0-6.7-4.2-12.7-10.5-15l-65.1-23.7c-7.4-2.7-12.4-9.8-12.4-17.7c0-10.4 8.4-18.8 18.8-18.8l186.4 0c10.4 0 18.8 8.4 18.8 18.8c0 7.9-5 15-12.4 17.7l-65.1 23.7c-6.3 2.3-10.5 8.3-10.5 15l0 156.1zM509.6 .2c8.3-1.2 16.1 4.1 18 12.2l47.6 206.4c.5 2.2 .8 4.5 .8 6.8c0 16.8-13.6 30.4-30.4 30.4l-2.2 0c-17.1 0-31.3-13.2-32.5-30.2L496 17.1c-.6-8.3 5.3-15.7 13.6-17z',
  ],
};
const faButter = {
  prefix: 'far',
  iconName: 'butter',
  icon: [
    640,
    512,
    [129480],
    'e3e4',
    'M464 112l0 176-48 0 0-176-288 0c-8.8 0-16 7.2-16 16l0 160-48 0 0-160c0-35.3 28.7-64 64-64l288 0 24 0 24 0 48 0c35.3 0 64 28.7 64 64l0 160-48 0 0-160c0-8.8-7.2-16-16-16l-48 0zM0 344c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 48c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-48-8 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faBlanketFire = {
  prefix: 'far',
  iconName: 'blanket-fire',
  icon: [
    640,
    512,
    [],
    'e3da',
    'M48 112c0-35.3 28.7-64 64-64l224 0c35.3 0 64 28.7 64 64l0 39.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7l0-16.2C448 50.1 397.9 0 336 0L112 0C50.1 0 0 50.1 0 112L0 336c0 61.9 50.1 112 112 112l202.4 0c-8.7-14.9-15.4-31-19.9-48L112 400c-35.3 0-64-28.7-64-64s28.7-64 64-64l197 0c4.9-10 10.3-19.8 16.2-29.3c3.8-6.2 7.9-12.5 12.3-18.7L112 224c-23.8 0-45.9 7.4-64 20.1L48 112zM288 350.1c0-12.4 2-25.2 5.6-38.1L120 312c-13.3 0-24 10.7-24 24s10.7 24 24 24l168.3 0c-.2-3.3-.3-6.6-.3-9.9zM505.7 208.3l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2C320 440.7 390.4 512 480 512c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327.1 544 363.6 544 400.2z',
  ],
};
const faKiwiBird = {
  prefix: 'far',
  iconName: 'kiwi-bird',
  icon: [
    576,
    512,
    [],
    'f535',
    'M266.4 347.3c31.2-18.9 74.9-43.3 125.9-43.3l55.7 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-55.7 0c-51 0-94.7-24.4-125.9-43.3C244.7 87.6 219.3 80 192 80C112.5 80 48 144.5 48 224s64.5 144 144 144c27.3 0 52.7-7.6 74.4-20.7zM392.3 352c-36.4 0-69.9 17.6-101.1 36.4c-11.1 6.7-22.9 12.3-35.2 16.7l0 50.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.7c-5.3 .4-10.6 .7-16 .7c-16.6 0-32.7-2.1-48-6l0 46c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-65.7C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c36.3 0 70.3 10.1 99.2 27.6C322.4 78.4 355.9 96 392.3 96L448 96c70.7 0 128 57.3 128 128l0 240c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7L477.6 348.6c-9.5 2.2-19.4 3.4-29.6 3.4l-55.7 0zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faCastle = {
  prefix: 'far',
  iconName: 'castle',
  icon: [
    640,
    512,
    [],
    'e0de',
    'M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 200-80 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 440c0 39.8 32.2 72 72 72l496 0c39.8 0 72-32.2 72-72l0-256c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-80 0 0-200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40zm0 88l288 0 0 112-288 0 0-112zM48 272l544 0 0 168c0 13.3-10.7 24-24 24l-184 0 0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-168z',
  ],
};
const faGolfClub = {
  prefix: 'far',
  iconName: 'golf-club',
  icon: [
    512,
    512,
    [],
    'f451',
    'M498.7 2.5c11.9 5.9 16.7 20.3 10.7 32.2L290.7 472.2c-12.2 24.4-37.1 39.8-64.4 39.8L56 512c-30.9 0-56-25.1-56-56L0 347.1c0-37.6 36.3-64.5 72.2-53.6L293 360.4 466.5 13.3c5.9-11.9 20.3-16.7 32.2-10.7zM271.2 404L58.3 339.5c-5.1-1.6-10.3 2.3-10.3 7.7L48 368l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 16 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 8c0 4.4 3.6 8 8 8l170.3 0c9.1 0 17.4-5.1 21.5-13.3L271.2 404z',
  ],
};
const faArrowRightArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-right-arrow-left',
  icon: [
    448,
    512,
    [8644, 'exchange'],
    'f0ec',
    'M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 360l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zM441 145c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l342.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z',
  ],
};
const faExchange = faArrowRightArrowLeft;
const faRotateRight = {
  prefix: 'far',
  iconName: 'rotate-right',
  icon: [
    512,
    512,
    ['redo-alt', 'rotate-forward'],
    'f2f9',
    'M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3L496 200c0 13.3-10.7 24-24 24l-116.7 0c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176l62.1 0 0-62.1z',
  ],
};
const faRedoAlt = faRotateRight;
const faRotateForward = faRotateRight;
const faUtensils = {
  prefix: 'far',
  iconName: 'utensils',
  icon: [
    448,
    512,
    [127860, 61685, 'cutlery'],
    'f2e7',
    'M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144L8 166.7 8 168l0 16c0 48.6 39.4 88 88 88l8 0 0 216c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 8 0c48.6 0 88-39.4 88-88l0-16 0-1.3-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3 .1s-22.7 13.3-21.2 26.5L200 169.3l0 14.7c0 22.1-17.9 40-40 40l-32 0-32 0c-22.1 0-40-17.9-40-40l0-14.7L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zM336 176c0-57.7 21.7-88.6 41.4-105.7c7.7-6.6 15.5-11.6 22.6-15.2L400 248l0 56-48 0c-8.8 0-16-7.2-16-16l0-112zm64 176l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 0-48 0-56 0-216c0-17.7-14.3-32-32-32C400 0 288 32 288 176l0 112c0 35.3 28.7 64 64 64l48 0z',
  ],
};
const faCutlery = faUtensils;
const faArrowUpWideShort = {
  prefix: 'far',
  iconName: 'arrow-up-wide-short',
  icon: [
    576,
    512,
    ['sort-amount-up'],
    'f161',
    'M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L152 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM312 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L312 96z',
  ],
};
const faSortAmountUp = faArrowUpWideShort;
const faChartPieSimpleCircleDollar = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [
    640,
    512,
    [],
    'e605',
    'M496 192c-46.8 0-89.3 18.2-120.8 48L272 240l0-223.4c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288l67.2 0c-7.6 14.9-13.2 31-16.3 48L224 336c-26.5 0-48-21.5-48-48l0-197.1C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 240l0 48 48 0zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z',
  ],
};
const faBalloons = {
  prefix: 'far',
  iconName: 'balloons',
  icon: [
    640,
    512,
    [],
    'e2e4',
    'M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6zM112 400l10-20.1c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160C0 71.6 71.6 0 160 0s160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L208 400l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-25.9 0-6.7 0-.1 0-36.7 0-.1 0-6.7 0s0 0 0 0l-25.9 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1zm48-264c-13.3 0-24 10.7-24 24s-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM437.7 423.7c-26.2-22.1-94.5-85.6-113-161.8C340.5 231.8 352 197.2 352 160c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L528 464l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-25.9 0-6.7 0-.1 0-36.7 0-.1 0-6.7 0-25.9 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1 10-20.1c3.5-6.9 1.6-15.3-4.4-20.3zM480 112c-61.9 0-112 50.1-112 112c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6c0-61.9-50.1-112-112-112zM456 224c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24 10.7-24 24z',
  ],
};
const faMillSign = {
  prefix: 'far',
  iconName: 'mill-sign',
  icon: [
    384,
    512,
    [],
    'e1ed',
    'M302.4 32.5c4.7-12.4-1.5-26.3-13.9-31s-26.3 1.5-31 13.9l-36.1 95.3c-11.3 6.6-21.2 15.2-29.4 25.3C172.2 111.6 141.9 96 108 96c-22.5 0-43.3 6.9-60.6 18.6C44.9 103.9 35.4 96 24 96C10.7 96 0 106.7 0 120l0 80c0 0 0 0 .1 0c0 1.3-.1 2.7-.1 4L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220c0-33.1 26.9-60 60-60s60 26.9 60 60l0 47.6L81.6 479.5c-4.7 12.4 1.5 26.2 13.9 31s26.3-1.5 31-13.9L168 386.9l0 29.1 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-155.6 43.3-114c5.3-1.5 10.9-2.4 16.7-2.4c33.1 0 60 26.9 60 60l0 220c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220c0-58.9-47.1-106.7-105.7-108l24.1-63.5z',
  ],
};
const faBowlRice = {
  prefix: 'far',
  iconName: 'bowl-rice',
  icon: [
    512,
    512,
    [],
    'e2eb',
    'M176 56c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm24 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zM56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm88.7 244.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304l412.4 0c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4l-192 0c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256zM224 200c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-96 0c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm216 96c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm120 96c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zM296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0z',
  ],
};
const faTimelineArrow = {
  prefix: 'far',
  iconName: 'timeline-arrow',
  icon: [
    640,
    512,
    [],
    'e29d',
    'M160 96A32 32 0 1 0 96 96a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3l0 59.7 176 0 0-59.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 59.7 178.6 0-58.9-54.4c-9.7-9-10.3-24.2-1.4-33.9s24.2-10.3 33.9-1.4l103.9 95.9c.1 .1 .3 .3 .4 .4c.3 .3 .6 .6 .9 .9c4 4.3 6.5 10.1 6.5 16.4s-2.5 12.1-6.5 16.4c-.3 .3-.6 .6-.9 .9c-.1 .1-.3 .3-.4 .4L528.3 369.6c-9.7 9-24.9 8.4-33.9-1.4s-8.4-24.9 1.4-33.9L554.6 280 248 280l0 59.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-59.7L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-59.7C71.5 162.1 48 131.8 48 96c0-44.2 35.8-80 80-80s80 35.8 80 80zM192 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faSkull = {
  prefix: 'far',
  iconName: 'skull',
  icon: [
    512,
    512,
    [128128],
    'f54c',
    'M368 400c-.4-16 7.3-31.2 20.4-40.4C436.1 326.2 464 276.9 464 224c0-91.4-86.9-176-208-176S48 132.6 48 224c0 52.9 27.9 102.2 75.6 135.6c13.1 9.2 20.8 24.4 20.4 40.4c0 0 0 0 0 0l0 64 48 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 32 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 48 0 0-64s0 0 0 0zm48-1.1c0 .4 0 .7 0 1.1l0 64c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-64c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM112 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm232-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
  ],
};
const faGameBoardSimple = {
  prefix: 'far',
  iconName: 'game-board-simple',
  icon: [
    448,
    512,
    ['game-board-alt'],
    'f868',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm16 80l0 144 144 0 0-144L80 112zM224 256l0 144 144 0 0-144-144 0z',
  ],
};
const faGameBoardAlt = faGameBoardSimple;
const faCircleVideo = {
  prefix: 'far',
  iconName: 'circle-video',
  icon: [
    512,
    512,
    ['video-circle'],
    'e12b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-56c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-112zM364.9 317.9L320 288l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z',
  ],
};
const faVideoCircle = faCircleVideo;
const faChartScatterBubble = {
  prefix: 'far',
  iconName: 'chart-scatter-bubble',
  icon: [
    512,
    512,
    [],
    'e0e9',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM176 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm200 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM240 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm168 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faHouseTurret = {
  prefix: 'far',
  iconName: 'house-turret',
  icon: [
    640,
    512,
    [],
    'e1b4',
    'M56 48c-4.4 0-8 3.6-8 8l0 147.8c0 2 .7 3.9 2 5.3l55.9 62.9c3.9 4.4 6.1 10.1 6.1 15.9l0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-190.9L14.1 241C5 230.8 0 217.5 0 203.8L0 56C0 25.1 25.1 0 56 0L296 0c30.9 0 56 25.1 56 56l0 68.6-48 44L304 56c0-4.4-3.6-8-8-8l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40L56 48zm120 96c22.1 0 40 17.9 40 40l0 40c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-40c0-22.1 17.9-40 40-40zm100.8 93l128-117.3c24.5-22.4 62-22.4 86.5 0L619.2 237c13.2 12.1 20.8 29.2 20.8 47.2L640 448c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-163.8c0-17.9 7.5-35.1 20.8-47.2zM304 284.2L304 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-163.8c0-4.5-1.9-8.8-5.2-11.8L458.8 155c-6.1-5.6-15.5-5.6-21.6 0l-128 117.3c-3.3 3-5.2 7.3-5.2 11.8zM400 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z',
  ],
};
const faBanana = {
  prefix: 'far',
  iconName: 'banana',
  icon: [
    576,
    512,
    [],
    'e2e5',
    'M352 144c0 46.7-10.5 90.9-29.3 130.4l-25.3-20.2c-4.4-3.5-9.1-6.8-13.9-9.8C296.7 213.6 304 179.7 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 10.9-.6 21.6-1.8 32.1c-10.9 .4-21.7 2.1-32.3 4.9l-17.6 4.7c2.4-13.5 3.6-27.5 3.6-41.7c0-59.5-21.7-114-57.6-156c6.2 24.3 9.6 49.7 9.6 76zM208.8 304c-15.5 0-30.4 5.5-42.2 15.6l-31.1 26.6c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l31.1-26.6c20.4-17.5 46.5-27.2 73.4-27.2c21.4 0 42.2 6.1 60.1 17.4l.1-.2c2.9 1.9 5.6 3.9 8.3 6l1.7 1.3 .2 .2 46.2 37s0 0 0 0l96.7-25.8s0 0 0 0c6.1-1.6 12.3-2.7 18.5-3.4c0 0 0 0 0 0c3.7-.4 7.5-.6 11.3-.6c40.7 0 78.4 21.3 99.3 56.2l21.3 35.4c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-21.3-35.4C497.9 348.5 475.8 336 452 336c-5.9 0-11.8 .8-17.5 2.3l-11.5 3.1C378.2 441.9 277.3 512 160 512L48 512c-26.5 0-48-21.5-48-48l0-16c0-26.5 21.5-48 48-48c76.9 0 145.9-33.9 192.8-87.6c-9.7-5.5-20.7-8.4-31.9-8.4z',
  ],
};
const faHandHoldingSkull = {
  prefix: 'far',
  iconName: 'hand-holding-skull',
  icon: [
    576,
    512,
    [],
    'e1a4',
    'M192 128c0 29.9 20.4 58.1 53.8 71.8c9.9 4.1 15.9 14.2 14.7 24.9L258.8 240l58.4 0-1.7-15.3c-1.2-10.6 4.8-20.8 14.7-24.9C363.6 186.1 384 157.9 384 128c0-41.1-39.6-80-96-80s-96 38.9-96 80zM288 0c76.2 0 144 54.2 144 128c0 46.7-27.7 86.1-66.9 108.2l2.8 25.2c.8 6.8-1.4 13.6-6 18.7s-11.1 8-17.9 8l-112 0c-6.8 0-13.3-2.9-17.9-8s-6.7-11.9-6-18.7l2.8-25.2C171.7 214.1 144 174.7 144 128C144 54.2 211.8 0 288 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0zM224 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM328 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPeopleDress = {
  prefix: 'far',
  iconName: 'people-dress',
  icon: [
    640,
    512,
    [],
    'e217',
    'M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.1 299.8l-37.4-66.1 36.5 129.9c2.9 10.2-4.8 20.3-15.4 20.3L224 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.9 0c-10.6 0-18.3-10.1-15.4-20.3L90.3 233.7 52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM155.4 179.5L111.4 336l97.3 0-44-156.5c-.6-2.1-2.5-3.5-4.6-3.5s-4 1.4-4.6 3.5zM480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-37.4-66.1 36.5 129.9c2.9 10.2-4.8 20.3-15.4 20.3L544 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.9 0c-10.6 0-18.3-10.1-15.4-20.3l36.5-129.9-37.4 66.1c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM475.4 179.5L431.4 336l97.3 0-44-156.5c-.6-2.1-2.5-3.5-4.6-3.5s-4 1.4-4.6 3.5z',
  ],
};
const faLoveseat = {
  prefix: 'far',
  iconName: 'loveseat',
  icon: [
    512,
    512,
    ['couch-small'],
    'f4cc',
    'M176 80l160 0c44.2 0 80 35.8 80 80l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8l0-34.8c0-70.7-57.3-128-128-128L176 32C105.3 32 48 89.3 48 160l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8L96 160c0-44.2 35.8-80 80-80zM462.5 227.6c-7.1-2.3-14.6-3.6-22.5-3.6c-9.5 0-18.5 1.8-26.8 5.2c-24.1 9.7-41.8 32-44.7 58.8l-224.9 0c-3-26.8-20.6-49.1-44.7-58.8C90.5 225.8 81.5 224 72 224c-7.9 0-15.4 1.3-22.5 3.6C20.7 237 0 264.1 0 296L0 432c0 26.5 21.5 48 48 48l48 0c20.9 0 38.7-13.4 45.3-32l229.5 0c6.6 18.6 24.4 32 45.3 32l48 0c26.5 0 48-21.5 48-48l0-136c0-31.9-20.7-59-49.5-68.4zM368 400l-224 0 0-64 32 0 160 0 32 0 0 64zM96 400l0 32-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 0 64zM464 296l0 136-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faCouchSmall = faLoveseat;
const faTowerBroadcast = {
  prefix: 'far',
  iconName: 'tower-broadcast',
  icon: [
    576,
    512,
    ['broadcast-tower'],
    'f519',
    'M54.8 1.9C42.6-3.4 28.5 2.3 23.3 14.4C8.3 49.3 0 87.7 0 128s8.3 78.7 23.3 113.6c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5C54.9 193.6 48 161.6 48 128s6.9-65.6 19.4-94.6C72.6 21.2 67 7.1 54.8 1.9zm466.4 0C509 7.1 503.4 21.2 508.6 33.4c12.5 29 19.4 61 19.4 94.6s-6.9 65.6-19.4 94.6c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6c15-34.9 23.3-73.3 23.3-113.6s-8.3-78.7-23.3-113.6C547.5 2.3 533.4-3.4 521.2 1.9zM312 187.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 26.9 16.5 49.9 40 59.3L264 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-300.7zM166.5 87.6c4.2-12.6-2.6-26.2-15.2-30.3S125.1 59.8 121 72.4c-5.8 17.5-9 36.2-9 55.6s3.1 38.1 9 55.6c4.2 12.6 17.8 19.4 30.3 15.2s19.4-17.8 15.2-30.3c-4.2-12.7-6.5-26.3-6.5-40.4s2.3-27.7 6.5-40.4zM455 72.4c-4.2-12.6-17.8-19.4-30.3-15.2s-19.4 17.8-15.2 30.3c4.2 12.7 6.5 26.3 6.5 40.4s-2.3 27.7-6.5 40.4c-4.2 12.6 2.6 26.2 15.2 30.3s26.2-2.6 30.3-15.2c5.8-17.5 9-36.2 9-55.6s-3.1-38.1-9-55.6z',
  ],
};
const faBroadcastTower = faTowerBroadcast;
const faTruckPickup = {
  prefix: 'far',
  iconName: 'truck-pickup',
  icon: [
    640,
    512,
    [128763],
    'f63c',
    'M272 88l0 88 174.9 0L374.7 83.1c-1.5-1.9-3.8-3.1-6.3-3.1L280 80c-4.4 0-8 3.6-8 8zM412.6 53.6L507.7 176l44.3 0c30.9 0 56 25.1 56 56l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-1.3 0c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16l-98.7 0c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16L80 368l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-88c0-30.9 25.1-56 56-56l136 0 0-88c0-30.9 25.1-56 56-56l88.3 0c17.3 0 33.6 8 44.2 21.6zM96 320l8.4 0c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32l8.4 0 128 0 8.4 0c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32l8.4 0 16 0 0-88c0-4.4-3.6-8-8-8l-55.8 0-.5 0L248 224 88 224c-4.4 0-8 3.6-8 8l0 88 16 0zm128 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faBlockQuote = {
  prefix: 'far',
  iconName: 'block-quote',
  icon: [
    448,
    512,
    [],
    'e0b5',
    'M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 72zM152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM128 416c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 424z',
  ],
};
const faUpLong = {
  prefix: 'far',
  iconName: 'up-long',
  icon: [
    320,
    512,
    ['long-arrow-alt-up'],
    'f30c',
    'M143.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3L240 208l0 248c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56l0-248-33.7 0C20.7 208 0 187.3 0 161.7c0-12.8 5.3-25 14.6-33.7L143.6 6.5zM50.5 160l53.5 0c13.3 0 24 10.7 24 24l0 272c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-272c0-13.3 10.7-24 24-24l53.5 0L160 57 50.5 160z',
  ],
};
const faLongArrowAltUp = faUpLong;
const faStop = {
  prefix: 'far',
  iconName: 'stop',
  icon: [
    384,
    512,
    [9209],
    'f04d',
    'M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z',
  ],
};
const faCodeMerge = {
  prefix: 'far',
  iconName: 'code-merge',
  icon: [
    448,
    512,
    [],
    'f387',
    'M80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24.7 108.1C136.8 145.7 160 115.6 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3l0 199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-100.8c27.2 25.5 63.8 41.1 104 41.1l83.7 0c10.2 32.5 40.5 56 76.3 56c44.2 0 80-35.8 80-80s-35.8-80-80-80c-35.8 0-66.1 23.5-76.3 56L208 248c-53.3 0-97.3-40.2-103.3-91.9zM80 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faMoneyCheckDollarPen = {
  prefix: 'far',
  iconName: 'money-check-dollar-pen',
  icon: [
    640,
    512,
    ['money-check-edit-alt'],
    'f873',
    'M512 112L64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l284.3 0c-5.6 7.1-9.6 15.3-11.8 24.1l-6 23.9L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64.6c-15.2 2-29.8 8.8-41.4 20.5l-6.6 6.6 0-91.6c0-8.8-7.2-16-16-16zM256 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24-120l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM160 132c11 0 20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faMoneyCheckEditAlt = faMoneyCheckDollarPen;
const faUpFromLine = {
  prefix: 'far',
  iconName: 'up-from-line',
  icon: [
    384,
    512,
    ['arrow-alt-from-bottom'],
    'f346',
    'M82.2 192L192 82 301.8 192 248 192c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM192 32c-11.5 0-22.5 4.6-30.6 12.7L45.6 160.8C36.9 169.5 32 181.3 32 193.6C32 219.2 52.8 240 78.4 240l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 44.7C214.5 36.6 203.5 32 192 32zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faArrowAltFromBottom = faUpFromLine;
const faUpload = {
  prefix: 'far',
  iconName: 'upload',
  icon: [
    512,
    512,
    [],
    'f093',
    'M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95L280 360zm32-8l0-48 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80c0-35.3 28.7-64 64-64l136 0 0 48L64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-136 0zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faHurricane = {
  prefix: 'far',
  iconName: 'hurricane',
  icon: [
    384,
    512,
    [],
    'f751',
    'M48 208C48 133.5 99 70.8 168 53l0 52.4c0 21.2 16 37.1 34.6 40.2C278.3 158.3 336 224.1 336 303.4c0 74.5-51 137.2-120 155l0-52.4c0-21.2-16-37.1-34.6-40.2C105.7 353.1 48 287.3 48 208zM216 42.1c0-22.7-20.1-43.4-45.6-38.7C73.5 21.1 0 105.9 0 208C0 309.2 72.3 393.5 168 412.2l0 57.1c0 22.7 20.1 43.4 45.6 38.7C310.5 490.3 384 405.5 384 303.4c0-101.2-72.3-185.5-168-204.2l0-57.1zM176 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
  ],
};
const faGridRound2Plus = {
  prefix: 'far',
  iconName: 'grid-round-2-plus',
  icon: [
    512,
    512,
    [],
    'e5dc',
    'M80 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM80 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z',
  ],
};
const faPeoplePants = {
  prefix: 'far',
  iconName: 'people-pants',
  icon: [
    640,
    512,
    [],
    'e219',
    'M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L176 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM144 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6 96 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L496 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM464 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6 416 488c0 13.3 10.7 24 24 24s24-10.7 24-24z',
  ],
};
const faMound = {
  prefix: 'far',
  iconName: 'mound',
  icon: [
    576,
    512,
    [],
    'e52d',
    'M485 368L91 368l94.8-164.9c21-36.6 60-59.1 102.2-59.1s81.2 22.6 102.2 59.1L485 368zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48l449.4 0c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z',
  ],
};
const faWindsock = {
  prefix: 'far',
  iconName: 'windsock',
  icon: [
    512,
    512,
    [],
    'f777',
    'M24 0C37.3 0 48 10.7 48 24l0 72 80 0 0-8.6c0-20.3 18.7-35.5 38.5-31.3l320 66.7c14.8 3.1 25.5 16.2 25.5 31.3l0 108c0 15.2-10.6 28.2-25.5 31.3L166.5 360c-19.9 4.1-38.5-11-38.5-31.3l0-8.6-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 296 0 120 0 24C0 10.7 10.7 0 24 0zM48 144l0 128 80 0 0-128-80 0zM416 259l48-10 0-81.9-48-10L416 259zm-48 10L368 147l-80-16.7 0 155.3L368 269zM240 295.6l0-175.3L176 107 176 309l64-13.3z',
  ],
};
const faCircleHalf = {
  prefix: 'far',
  iconName: 'circle-half',
  icon: [
    512,
    512,
    [],
    'e110',
    'M208 53.6C116.3 75.2 48 157.7 48 256s68.3 180.8 160 202.4l0-404.9zM224.1 2C241.6-.2 256 14.3 256 32l0 448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z',
  ],
};
const faBrakeWarning = {
  prefix: 'far',
  iconName: 'brake-warning',
  icon: [
    640,
    512,
    [],
    'e0c7',
    'M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM83.9 75.8c-11.1-7.2-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147c7.2-11.1 4-26-7.2-33.2zm472.2 0c-11.1 7.2-14.4 22-7.2 33.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173c-7.2-11.1-22-14.4-33.2-7.2zM320 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faToiletPortable = {
  prefix: 'far',
  iconName: 'toilet-portable',
  icon: [
    320,
    512,
    [],
    'e583',
    'M48 72l0 24 224 0 0-24c0-13.3-10.7-24-24-24L72 48C58.7 48 48 58.7 48 72zm0 72l0 288 224 0 0-112-24 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l24 0 0-80L48 144zm0 336l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 72C0 32.2 32.2 0 72 0L248 0c39.8 0 72 32.2 72 72l0 416c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 480z',
  ],
};
const faCompactDisc = {
  prefix: 'far',
  iconName: 'compact-disc',
  icon: [
    512,
    512,
    [128191, 128192, 128440],
    'f51f',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z',
  ],
};
const faFileArrowDown = {
  prefix: 'far',
  iconName: 'file-arrow-down',
  icon: [
    384,
    512,
    ['file-download'],
    'f56d',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232z',
  ],
};
const faFileDownload = faFileArrowDown;
const faSaxophoneFire = {
  prefix: 'far',
  iconName: 'saxophone-fire',
  icon: [
    640,
    512,
    ['sax-hot'],
    'f8db',
    'M256 153.6c0 7.6-.7 15.1-2 22.4l-77.6 0c-7.7-23.3-29.5-44.6-41-54.6c-4.3-3.7-10.5-3.7-14.8 0c-11.6 10-33.4 31.3-41 54.6L2 176c-1.3-7.3-2-14.8-2-22.4C0 92.3 50 37.9 85.8 10.1c4-3.1 8.7-4.6 13.4-4.7c6.4-.1 12.8 2.5 17.6 7.4l36.8 36.8 9.1-9.1c9.4-9.4 24.4-10.1 33.8-.8C243.6 86.4 256 128.1 256 153.6zM452.3 89.8C468.8 73.3 491.2 64 514.5 64l35 0c23.3 0 45.7 9.3 62.2 25.8l14.6 14.6c8.7 8.7 13.7 20.6 13.7 33c0 25.8-20.9 46.6-46.6 46.6l-50.6 0c-2.3 0-4.6 1-6.1 2.8l-224.5 263c-33.7 39.5-83 62.2-134.9 62.2l-5.5 0C76.9 512 0 435.1 0 340.2c0-9.5 .8-18.9 2.3-28.2l9.8-59.1C4.9 248.8 0 241 0 232c0-13.3 10.7-24 24-24l16 0 192 0 16 0c13.3 0 24 10.7 24 24c0 13-10.3 23.6-23.2 24l-21.2 58.3L318 224l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L366 176l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L414 128l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7 4.3-4.3zM255.6 354.2c-8.7 8.7-20.6 13.6-33 13.6l-2.4 0c-24.4 0-44.3-19.8-44.3-44.3c0-5.2 .9-10.3 2.7-15.1L197.7 256 60.3 256 49.7 319.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464l5.5 0c37.8 0 73.8-16.6 98.3-45.4l224.5-263c10.6-12.5 26.2-19.6 42.6-19.6l47.3 0-12.3-12.3c-7.5-7.5-17.7-11.7-28.3-11.7l-35 0c-10.6 0-20.8 4.2-28.3 11.7l-20.6 20.6c-.2 .2-.4 .5-.6 .7s-.5 .4-.7 .7L417.9 192c-.3 .3-.6 .7-1 1s-.7 .7-1 1l-45.8 45.8c-.4 .4-.8 .9-1.2 1.3s-.8 .8-1.3 1.2l-112.1 112zM120 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faSaxHot = faSaxophoneFire;
const faCameraWebSlash = {
  prefix: 'far',
  iconName: 'camera-web-slash',
  icon: [
    640,
    512,
    ['webcam-slash'],
    'f833',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L485.3 355.1C516.9 317.5 536 269 536 216C536 96.7 439.3 0 320 0C248.3 0 184.8 34.9 145.5 88.7L38.8 5.1zM183.3 118.3C213.8 75.8 263.6 48 320 48c92.8 0 168 75.2 168 168c0 41.8-15.3 80-40.5 109.4l-37.8-29.7C428.5 274.6 440 246.6 440 216c0-66.3-53.7-120-120-120c-41 0-77.2 20.6-98.9 52l-37.8-29.7zM371.7 266.1L259 177.7c12.7-20.3 35.3-33.7 61-33.7c39.8 0 72 32.2 72 72c0 19.5-7.7 37.1-20.3 50.1zM359.6 379.3c-12.7 3.1-25.9 4.7-39.6 4.7c-92.8 0-168-75.2-168-168l0-.2-45.1-35.5C105 191.9 104 203.8 104 216c0 72.8 36 137.2 91.3 176.4l-62.3 81c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4l376 0-60.9-48-266.3 0 37.1-48.2C263.1 426.2 290.9 432 320 432c30 0 58.6-6.1 84.6-17.2l-45-35.5z',
  ],
};
const faWebcamSlash = faCameraWebSlash;
const faFolderMedical = {
  prefix: 'far',
  iconName: 'folder-medical',
  icon: [
    512,
    512,
    [],
    'e18c',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM224 256l-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48z',
  ],
};
const faFolderGear = {
  prefix: 'far',
  iconName: 'folder-gear',
  icon: [
    512,
    512,
    ['folder-cog'],
    'e187',
    'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L289.9 96 247 53.1C233.5 39.6 215.2 32 196.1 32L64 32zM48 96c0-8.8 7.2-16 16-16l132.1 0c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM353.2 264.2c6.3-3.6 9.5-11.2 6.8-17.9c-1.7-4.3-3.7-8.4-5.9-12.4l-2-3.5c-2.4-4-5.1-7.9-7.9-11.5c-4.5-5.7-12.6-6.8-18.9-3.1l-1.2 .7c-8 4.6-17.9 3.5-25.9-1.2s-14.1-12.7-14.1-21.9l0-1.4c0-7.3-4.9-13.8-12.2-14.8c-5.2-.7-10.5-1.1-15.8-1.1s-10.7 .4-15.8 1.1c-7.2 1-12.2 7.5-12.2 14.8l0 1.4c0 9.3-6.1 17.3-14.1 21.9s-17.9 5.8-25.9 1.2l-1.2-.7c-6.3-3.6-14.4-2.6-18.9 3.1c-2.9 3.7-5.5 7.5-8 11.5l-2 3.4c-2.2 4-4.2 8.2-5.9 12.5c-2.7 6.8 .4 14.3 6.8 17.9l1.2 .7c8 4.6 12 13.8 12 23.1s-4 18.4-12 23.1l-1.2 .7c-6.3 3.6-9.5 11.2-6.8 17.9c1.7 4.3 3.7 8.4 5.9 12.4l2.1 3.6c2.4 4 5 7.8 7.9 11.5c4.5 5.7 12.6 6.8 18.9 3.1l1.2-.7c8-4.6 17.9-3.5 25.9 1.2s14.1 12.7 14.1 21.9l0 1.4c0 7.3 4.9 13.8 12.2 14.8c5.2 .7 10.5 1.1 15.8 1.1s10.7-.4 15.8-1.1c7.2-1 12.2-7.5 12.2-14.8l0-1.4c0-9.3 6.1-17.3 14.1-21.9s17.9-5.8 25.9-1.2l1.2 .7c6.3 3.6 14.4 2.6 18.9-3.1c2.9-3.6 5.5-7.5 7.9-11.4l2.1-3.6c2.2-4 4.2-8.1 5.9-12.4c2.7-6.8-.4-14.3-6.8-17.9l-1.2-.7c-8-4.6-12-13.8-12-23.1s4-18.5 12-23.1l1.2-.7zM221 288a35 35 0 1 1 70 0 35 35 0 1 1 -70 0z',
  ],
};
const faFolderCog = faFolderGear;
const faHandWave = {
  prefix: 'far',
  iconName: 'hand-wave',
  icon: [
    512,
    512,
    [],
    'e1a7',
    'M336.2 82.3L335 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S281.5-1.1 290.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM80 68.7c17.9-17.9 43.8-23 66.2-15.2c3.1-6.8 7.4-13.1 13-18.7c25-25 65.5-25 90.5 0L368 153l0-5.2c0-35.3 28.7-64 64-64s64 28.7 64 64l0 157.7c0 1.6 0 3.1-.1 4.7c0 .6 .1 1.1 .1 1.7c0 109.9-88.7 199.2-198.5 200l-.5 0-1 0s0 0 0 0l-6.6 0c-53 0-103.9-21.1-141.4-58.6L34.7 340.2c-25-25-25-65.5 0-90.5c3.9-3.9 8.2-7.2 12.7-9.9l-1.4-1.4c-25-25-25-65.5 0-90.5c5.6-5.6 11.9-9.9 18.7-13C57 112.5 62.1 86.6 80 68.7zm79.3 56.7l-.1-.1-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l22.5 22.5 .1 .1L232.7 244c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1c0 0 0 0-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L119.5 244l.1 .1 56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L91.4 283.7l-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L181.9 419.5C210.4 448 249.1 464 289.4 464l6.6 0s0 0 0 0l.6 0 .2 0c82.8-.5 149.9-67.1 151.1-149.8c-.1-1-.1-2.1-.1-3.1c.1-1.8 .1-3.6 .1-5.5l0-157.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 63.1c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L215.8 68.7c-6.2-6.2-16.4-6.2-22.6 0c-6.2 6.2-6.2 16.3-.1 22.6l96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1zM13.7 368.2c8.7-1.3 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.2 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 386.3c-1.2-8.7 4.8-16.9 13.6-18.1z',
  ],
};
const faArrowUpArrowDown = {
  prefix: 'far',
  iconName: 'arrow-up-arrow-down',
  icon: [
    576,
    512,
    ['sort-up-down'],
    'e099',
    'M529 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L440 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1-55-55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39z',
  ],
};
const faSortUpDown = faArrowUpArrowDown;
const faCaravan = {
  prefix: 'far',
  iconName: 'caravan',
  icon: [
    640,
    512,
    [],
    'f8ff',
    'M416 80c61.9 0 112 50.1 112 112l0 176-48 0 0-200c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 200-44.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L80 368c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l336 0zM80 416l16 0c0 53 43 96 96 96s96-43 96-96l64 0 96 0 80 0 48 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-176c0-88.4-71.6-160-160-160L80 32C35.8 32 0 67.8 0 112L0 336c0 44.2 35.8 80 80 80zM432 224l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 96-64 0 0-192 64 0 0 48zM128 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0zm64 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faShieldCat = {
  prefix: 'far',
  iconName: 'shield-cat',
  icon: [
    512,
    512,
    [],
    'e572',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160 154.4L160 272c0 53 43 96 96 96s96-43 96-96l0-117.6c0-5.8-4.7-10.4-10.4-10.4l-.2 0c-3.4 0-6.5 1.6-8.5 4.3l-40 53.3c-3 4-7.8 6.4-12.8 6.4l-48 0c-5 0-9.8-2.4-12.8-6.4l-40-53.3c-2-2.7-5.2-4.3-8.5-4.3l-.2 0c-5.8 0-10.4 4.7-10.4 10.4zM216 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faMessageSlash = {
  prefix: 'far',
  iconName: 'message-slash',
  icon: [
    640,
    512,
    ['comment-alt-slash'],
    'f4a9',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352l0-288c0-35.3-28.7-64-64-64L128 0C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-10.2 0L112.1 62.5zM406.2 416l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432l0-16c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16l0-167.8L64 146.4 64 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76 32.8 0z',
  ],
};
const faCommentAltSlash = faMessageSlash;
const faBolt = {
  prefix: 'far',
  iconName: 'bolt',
  icon: [
    448,
    512,
    [9889, 'zap'],
    'f0e7',
    'M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224l85.2 0c19.3 0 34.9 15.6 34.9 34.9c0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8c-19.1 0-32.9-18.3-27.6-36.6L152.2 288l-86.4 0C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9C308.3 2.4 314.9 0 321.7 0zM285.6 85L104.4 240l79.6 0c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21L162.3 427.5 345.5 272 264 272c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z',
  ],
};
const faZap = faBolt;
const faTrashCanCheck = {
  prefix: 'far',
  iconName: 'trash-can-check',
  icon: [
    448,
    512,
    [],
    'e2a9',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zM337 241L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faGlassWater = {
  prefix: 'far',
  iconName: 'glass-water',
  icon: [
    384,
    512,
    [],
    'e4f4',
    'M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM57.6 134.3L50.2 48l283.7 0-7.4 86.3-25.2 14c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 155.6 99 157.3 82.8 148.3l-25.2-14zm5 57.6c32.7 16.6 72.1 12.6 100.9-10.4c16.7-13.3 40.4-13.3 57 0c28.8 23 68.3 27 100.9 10.4L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L62.6 191.9z',
  ],
};
const faOilWell = {
  prefix: 'far',
  iconName: 'oil-well',
  icon: [
    576,
    512,
    [],
    'e532',
    'M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L431.3 193.6 96 280.5 96 464l44.1 0L198 294.3l55.6-14.4L229.1 352l85.9 0-27.6-80.8 46.6-12.1 70 204.9L552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.9 135.7-35.2 17.6-51.5c3.3-9.7 12.4-16.2 22.7-16.2s19.4 6.5 22.7 16.2l11 32.3 113.1-29.3L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM353.2 464l-21.9-64-118.6 0-21.9 64 162.4 0z',
  ],
};
const faTableCellsColumnUnlock = {
  prefix: 'far',
  iconName: 'table-cells-column-unlock',
  icon: [
    640,
    512,
    [],
    'e690',
    'M448 80c8.8 0 16 7.2 16 16l0 72-104 0 0-88 88 0zM200 80l112 0 0 88-112 0 0-88zM312 432l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 296l0-80 112 0 0 80-112 0zm296-24c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0-32 0-32 0 0-48z',
  ],
};
const faPersonSimple = {
  prefix: 'far',
  iconName: 'person-simple',
  icon: [
    256,
    512,
    [],
    'e220',
    'M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208l44.8 0c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3l-2.4 0-80 0-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352l32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136z',
  ],
};
const faArrowTurnLeftUp = {
  prefix: 'far',
  iconName: 'arrow-turn-left-up',
  icon: [
    384,
    512,
    [],
    'e634',
    'M337 135c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87L216 424c0 22.1 17.9 40 40 40l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-48.6 0-88-39.4-88-88l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 7c9.4-9.4 24.6-9.4 33.9 0L337 135z',
  ],
};
const faVault = {
  prefix: 'far',
  iconName: 'vault',
  icon: [
    576,
    512,
    [],
    'e2c5',
    'M64 48c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-352 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64L0 64zM320 240a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM80 240a144 144 0 1 1 288 0A144 144 0 1 1 80 240zm144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272-16c0 17.8-9.7 33.3-24 41.6L472 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-110.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48z',
  ],
};
const faMars = {
  prefix: 'far',
  iconName: 'mars',
  icon: [
    448,
    512,
    [9794],
    'f222',
    'M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-83.7 83.7C252.8 141.3 215.9 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3L400 113.9l0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L312 32zM48 304a128 128 0 1 1 256 0A128 128 0 1 1 48 304z',
  ],
};
const faToilet = {
  prefix: 'far',
  iconName: 'toilet',
  icon: [
    448,
    512,
    [128701],
    'f7d8',
    'M0 24C0 37.3 10.7 48 24 48l32 0 336 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L392 0 56 0 24 0C10.7 0 0 10.7 0 24zM81.6 182.9l-1.6 .5L80 80 32 80l0 127.1-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c1.7 1.1 3.5 2.1 5.2 3.2L69.3 448.2c-3.5 6.3-5.3 13.5-5.3 20.7c0 23.8 19.3 43.1 43.1 43.1l233.8 0c23.8 0 43.1-19.3 43.1-43.1c0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4L416 80l-48 0 0 103.4-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zM373.8 326.8c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12zM312.3 426.8L332.6 464l-217.3 0 20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0z',
  ],
};
const faPlaneCircleXmark = {
  prefix: 'far',
  iconName: 'plane-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e557',
    'M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z',
  ],
};
const faYenSign = {
  prefix: 'far',
  iconName: 'yen-sign',
  icon: [
    320,
    512,
    [165, 'cny', 'jpy', 'rmb', 'yen'],
    'f157',
    'M43.8 42.5c-7.5-11-22.4-13.8-33.3-6.4S-3.3 58.5 4.2 69.5L109.2 224 40 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-69.2 0L315.8 69.5c7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4L160 213.3 43.8 42.5z',
  ],
};
const faCny = faYenSign;
const faJpy = faYenSign;
const faRmb = faYenSign;
const faYen = faYenSign;
const faGearCode = {
  prefix: 'far',
  iconName: 'gear-code',
  icon: [
    512,
    512,
    [],
    'e5e8',
    'M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zm73.7 111.8l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z',
  ],
};
const faNotes = {
  prefix: 'far',
  iconName: 'notes',
  icon: [
    512,
    512,
    [],
    'e202',
    'M144 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 192-48 0c-17.7 0-32 14.3-32 32l0 48-192 0c-8.8 0-16-7.2-16-16l0-256zM96 96l0 256c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM320 488c0-13.3-10.7-24-24-24l-160 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 376c0 75.1 60.9 136 136 136l160 0c13.3 0 24-10.7 24-24z',
  ],
};
const faRubleSign = {
  prefix: 'far',
  iconName: 'ruble-sign',
  icon: [
    384,
    512,
    [8381, 'rouble', 'rub', 'ruble'],
    'f158',
    'M111.3 32C85.2 32 64 53.2 64 79.3L64 272l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-184 0 0-48 128 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L111.3 32zM240 272l-128 0 0-192 128 0c53 0 96 43 96 96s-43 96-96 96z',
  ],
};
const faRouble = faRubleSign;
const faRub = faRubleSign;
const faRuble = faRubleSign;
const faTrashUndo = {
  prefix: 'far',
  iconName: 'trash-undo',
  icon: [
    448,
    512,
    ['trash-arrow-turn-left'],
    'f895',
    'M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0zM222.9 194.7c-7.3-8.3-20-9-28.2-1.7l-72 64c-4.3 3.8-6.7 9.2-6.7 14.9s2.4 11.2 6.7 14.9l72 64c8.3 7.3 20.9 6.6 28.2-1.7s6.6-20.9-1.7-28.2L188.6 292l51.4 0c24.3 0 44 19.7 44 44l0 24c0 11 9 20 20 20s20-9 20-20l0-24c0-46.4-37.6-84-84-84l-51.4 0 32.7-29.1c8.3-7.3 9-20 1.7-28.2z',
  ],
};
const faTrashArrowTurnLeft = faTrashUndo;
const faChampagneGlass = {
  prefix: 'far',
  iconName: 'champagne-glass',
  icon: [
    320,
    512,
    ['glass-champagne'],
    'f79e',
    'M80 0C68.1 0 58 8.7 56.3 20.5L29.7 201C19.1 272.5 67.8 337.3 136 349.8L136 464l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-114.2c64.4-12.2 110.8-72.8 102.6-140.6l-22.8-188C262.4 9.1 252.1 0 240 0L80 0zm8.9 128l11.8-80 118 0 9.7 80L88.9 128zm-7.1 48l152.4 0 4.7 38.9c5.7 47.4-31.2 89.1-78.9 89.1c-51.1 0-90.3-45.4-82.9-96l4.7-32z',
  ],
};
const faGlassChampagne = faChampagneGlass;
const faObjectsAlignCenterHorizontal = {
  prefix: 'far',
  iconName: 'objects-align-center-horizontal',
  icon: [
    512,
    512,
    [],
    'e3bc',
    'M432 176L80 176l0-64 352 0 0 64zm48-64c0-26.5-21.5-48-48-48L280 64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l152 0 0 64-88 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l88 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0 0-64 152 0c26.5 0 48-21.5 48-48l0-64zM368 400l-224 0 0-64 224 0 0 64z',
  ],
};
const faSun = {
  prefix: 'far',
  iconName: 'sun',
  icon: [
    512,
    512,
    [9728],
    'f185',
    'M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
  ],
};
const faTrashCanSlash = {
  prefix: 'far',
  iconName: 'trash-can-slash',
  icon: [
    640,
    512,
    ['trash-alt-slash'],
    'e2ad',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-248 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0-13.8 0L413.5 24.9C403.1 9.4 385.6 0 366.9 0L273.1 0c-18.7 0-36.2 9.4-46.6 24.9L189.8 80 176 80l-41.6 0L38.8 5.1zM195.6 128L464 128l0 210.4-48-37.6L416 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 83.7L336 238l0-46c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 21L195.6 128zM454.9 454.4c-5.8 5.9-13.9 9.6-22.9 9.6l-224 0c-17.7 0-32-14.3-32-32l0-197.3-48-37.8L128 432c0 44.2 35.8 80 80 80l224 0c24.3 0 46-10.8 60.7-27.8l-37.8-29.8zM336 360.7l-32-25.2 0 64.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-39.3zM224 272.5L224 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.3-32-25.2zM273.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6z',
  ],
};
const faTrashAltSlash = faTrashCanSlash;
const faScreenUsers = {
  prefix: 'far',
  iconName: 'screen-users',
  icon: [
    640,
    512,
    ['users-class'],
    'f63d',
    'M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm256-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm320-96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM448 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM544 48L96 48c-8.8 0-16 7.2-16 16l0 161.3c-18.3 3.1-34.8 11.3-48 23.1L32 64C32 28.7 60.7 0 96 0L544 0c35.3 0 64 28.7 64 64l0 184.4c-13.2-11.8-29.7-20.1-48-23.1L560 64c0-8.8-7.2-16-16-16z',
  ],
};
const faUsersClass = faScreenUsers;
const faGuitar = {
  prefix: 'far',
  iconName: 'guitar',
  icon: [
    512,
    512,
    [],
    'f7a6',
    'M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-59.1 22.2-35.8 35.8c38.2 50.8 41.4 115.2 4.6 152c-12 12-26.8 19.7-43.2 23.4c-18.1 4.1-33.5 20.8-34.5 39.4c-1.4 27.9-11.7 53.8-31.2 73.4C200.3 529.4 112 520.3 51.8 460.2S-17.4 311.7 31.4 262.8C51 243.2 76.9 233 104.8 231.5c18.5-.9 35.3-16.4 39.4-34.5c3.7-16.4 11.4-31.2 23.4-43.2c36.8-36.8 101.2-33.6 152 4.6l35.8-35.8 22.2-59.1c1.2-3.2 3.1-6.1 5.5-8.5L431 7zM254.4 291.6c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6l64.8-64.8c-36-24.5-70.6-18.1-83.8-5c-5 5-8.6 11.5-10.5 19.8c-8.3 37-41.6 69.7-83.8 71.9c-17.6 .9-31.7 7.1-41.9 17.3c-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9c2.1-42.2 34.9-75.4 71.9-83.8c8.3-1.9 14.8-5.5 19.8-10.5c13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8z',
  ],
};
const faSquareArrowLeft = {
  prefix: 'far',
  iconName: 'square-arrow-left',
  icon: [
    448,
    512,
    ['arrow-square-left'],
    'f33a',
    'M48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM87 273l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L344 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-182.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L87 239c-9.4 9.4-9.4 24.6 0 33.9z',
  ],
};
const faArrowSquareLeft = faSquareArrowLeft;
const faSquare8 = {
  prefix: 'far',
  iconName: 'square-8',
  icon: [
    448,
    512,
    [],
    'e25d',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm168 96l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm0 48c0 0 0 0 0 0l16 0c0 0 0 0 0 0l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0z',
  ],
};
const faFaceSmileHearts = {
  prefix: 'far',
  iconName: 'face-smile-hearts',
  icon: [
    640,
    512,
    [],
    'e390',
    'M553.5 361.1C568 329 576 293.4 576 256c0-24.5-3.4-48.2-9.9-70.6c-3.6-12.7-16.9-20.1-29.7-16.5s-20.1 16.9-16.5 29.7c5.2 18.2 8 37.4 8 57.4c0 35.3-8.8 68.5-24.3 97.6c16.7-3.7 34.5-1.2 49.8 7.4zM448.1 419.9C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7c-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1C202.4 490.4 258.7 512 320 512c53.3 0 102.8-16.3 143.8-44.2c-11.2-13.9-16.5-31-15.7-47.9zm-326-99.8C115.5 299.9 112 278.4 112 256c0-114.9 93.1-208 208-208c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C393.6 8.2 357.7 0 320 0C178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c12.5-9 27.3-13.4 42-13.2zm85.7-3.3c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 334.5 357.2 352 320 352s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm6.5-87.1c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C279.7 186.8 259 180 239.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM399.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C439.7 186.8 419 180 399.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM573.7 11.5L560 25.3 546.3 11.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zm54.9 384c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3 66.3 363.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z',
  ],
};
const faBracketsSquare = {
  prefix: 'far',
  iconName: 'brackets-square',
  icon: [
    448,
    512,
    ['brackets'],
    'f7e9',
    'M56 32C25.1 32 0 57.1 0 88L0 424c0 30.9 25.1 56 56 56l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-4.4 0-8-3.6-8-8L48 88c0-4.4 3.6-8 8-8l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zm336 0l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c4.4 0 8 3.6 8 8l0 336c0 4.4-3.6 8-8 8l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c30.9 0 56-25.1 56-56l0-336c0-30.9-25.1-56-56-56z',
  ],
};
const faBrackets = faBracketsSquare;
const faLaptopArrowDown = {
  prefix: 'far',
  iconName: 'laptop-arrow-down',
  icon: [
    640,
    512,
    [],
    'e1c6',
    'M256 32l0 48L128 80c-8.8 0-16 7.2-16 16l0 224-48 0L64 96c0-35.3 28.7-64 64-64l128 0zM384 80l0-48 128 0c35.3 0 64 28.7 64 64l0 224-48 0 0-224c0-8.8-7.2-16-16-16L384 80zM320 32c13.3 0 24 10.7 24 24l0 182.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L296 56c0-13.3 10.7-24 24-24zM96 432l448 0c20.9 0 38.7-13.4 45.3-32L50.7 400c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96L96 480c-53 0-96-43-96-96z',
  ],
};
const faHockeyStickPuck = {
  prefix: 'far',
  iconName: 'hockey-stick-puck',
  icon: [
    640,
    512,
    [],
    'e3ae',
    'M499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l240 0c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368l-139 0 0 96 74.8 0c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0 0-96-32 0zm368 64l0 32 160 0 0-32-160 0zm-48 0c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32z',
  ],
};
const faHouseTree = {
  prefix: 'far',
  iconName: 'house-tree',
  icon: [
    640,
    512,
    [],
    'e1b3',
    'M417.4 7.5C412.9 2.7 406.6 0 400 0s-12.9 2.7-17.4 7.5l-103.5 109 35.4 32.4 85.5-90L496.1 160 448 160c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26L528.3 304 480 304c-9.4 0-17.9 5.4-21.8 13.9s-2.6 18.5 3.5 25.6L564.1 464 416 464c0 18-6 34.6-16 48l216 0c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L531.9 352l52.1 0c9.6 0 18.2-5.7 22-14.5s2-19-4.6-26L503.7 208l48.3 0c9.6 0 18.3-5.7 22.1-14.5s2-19-4.7-26l-152-160zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faSignalFair = {
  prefix: 'far',
  iconName: 'signal-fair',
  icon: [
    640,
    512,
    ['signal-2'],
    'f68d',
    'M192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faSignal2 = faSignalFair;
const faFaceLaughWink = {
  prefix: 'far',
  iconName: 'face-laugh-wink',
  icon: [
    512,
    512,
    ['laugh-wink'],
    'f59c',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z',
  ],
};
const faLaughWink = faFaceLaughWink;
const faCircleDollar = {
  prefix: 'far',
  iconName: 'circle-dollar',
  icon: [
    512,
    512,
    ['dollar-circle', 'usd-circle'],
    'f2e8',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM276.8 133.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z',
  ],
};
const faDollarCircle = faCircleDollar;
const faUsdCircle = faCircleDollar;
const faHorseHead = {
  prefix: 'far',
  iconName: 'horse-head',
  icon: [
    640,
    512,
    [],
    'f7ab',
    'M405.1 48.7c9.2-3.3 18.9 3.6 18.9 13.4c0 4.2-1.9 8.2-5.1 10.9l-34.3 28.5c-7.3 6.1-10.4 16-7.7 25.2s10.6 15.9 20.1 17.1l1.5 .2c31.3 3.9 58.7 23 73.3 51L520 287.8c11 21.3 7 47.2-9.9 64.2c-10.3 10.3-24.3 16.1-38.8 16.1l-7.4 0c-18.5 0-36-8-48.2-21.9l-26.2-30c-10.3-11.8-28-13.5-40.4-3.9c-27.6 21.5-67.3 17.2-89.7-9.7l-25-30c-8.5-10.2-23.6-11.6-33.8-3.1s-11.6 23.6-3.1 33.8l25 30c25 30 62.3 43.8 98.6 40l43.4 68.2c2.3 3.5 3.5 7.7 3.5 11.9c0 5.8-4.7 10.6-10.6 10.6L136 464c-13.3 0-24-10.7-24-24l0-123.3c0-98.2 61.8-185.7 154.3-218.6L405.1 48.7zm0 367l-21.5-33.8c21 21.7 50 34.1 80.4 34.1l7.4 0c27.3 0 53.5-10.8 72.8-30.1c31.7-31.7 39.2-80.4 18.5-120.2l-48.3-92.8c-14.4-27.8-37.3-49.6-64.7-63C463.8 98 472 80.5 472 62.1c0-43-42.5-73-83-58.6L250.2 52.9C138.6 92.5 64 198.2 64 316.7L64 440c0 39.8 32.2 72 72 72l221.4 0c32.4 0 58.6-26.2 58.6-58.6c0-13.3-3.8-26.4-11-37.6zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faArrowsRepeat = {
  prefix: 'far',
  iconName: 'arrows-repeat',
  icon: [
    512,
    512,
    ['repeat-alt'],
    'f364',
    'M0 254.5c-.8 13.2 9.2 24.6 22.5 25.5s24.6-9.2 25.5-22.5l.5-8C51.9 194.7 97.3 152 152.2 152l213.8 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-213.8 0C72 104 5.6 166.4 .5 246.5l-.5 8zm511.9 3c.8-13.2-9.2-24.6-22.5-25.5s-24.6 9.2-25.4 22.5l-.5 8c-3.4 54.8-48.9 97.5-103.8 97.5l-213.8 0 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 367c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 213.8 0c80.3 0 146.7-62.4 151.7-142.5l.5-8z',
  ],
};
const faRepeatAlt = faArrowsRepeat;
const faBoreHole = {
  prefix: 'far',
  iconName: 'bore-hole',
  icon: [
    512,
    512,
    [],
    'e4c3',
    'M256 0c13.3 0 24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 24c0-13.3 10.7-24 24-24zm0 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM112 176l-32 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-32 0 0 112c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-112zm16-48c17.7 0 32 14.3 32 32l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-17.7 14.3-32 32-32l48 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 208c0-44.2 35.8-80 80-80l48 0z',
  ],
};
const faIndustry = {
  prefix: 'far',
  iconName: 'industry',
  icon: [
    576,
    512,
    [],
    'f275',
    'M88 80c-4.4 0-8 3.6-8 8l0 216 0 48 0 56c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24l0-88 0-16 0-148.1-139.1 89c-7.4 4.7-16.8 5-24.5 .8s-12.5-12.3-12.5-21.1l0-70.9L180.1 235.4c-7.4 4.3-16.6 4.4-24 .1s-12-12.2-12-20.8L144 88c0-4.4-3.6-8-8-8L88 80zM32 88c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 84.9 103.8-60.6c32-18.7 72.2 4.4 72.2 41.5l0 27 102.1-65.4C502.1 95 544 117.9 544 155.9L544 304l0 16 0 88c0 39.8-32.2 72-72 72l-368 0c-39.8 0-72-32.2-72-72l0-56 0-48L32 88z',
  ],
};
const faImagePolaroid = {
  prefix: 'far',
  iconName: 'image-polaroid',
  icon: [
    448,
    512,
    [],
    'f8c4',
    'M400 368l0 48c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-48 352 0zM75.3 320L48 320 48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 224-23.6 0L284.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-56 85.6-16.6-22.6c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L75.3 320zM448 320l0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320l0 24 0 24 0 48c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-48 0-24 0-24zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faWaveTriangle = {
  prefix: 'far',
  iconName: 'wave-triangle',
  icon: [
    640,
    512,
    [],
    'f89a',
    'M176.1 32c7.7 0 14.9 3.7 19.4 10L464.1 415.1 596.6 233.8c7.8-10.7 22.8-13 33.5-5.2s13 22.8 5.2 33.5l-152 208c-4.5 6.2-11.8 9.9-19.5 9.8s-14.9-3.7-19.4-10L175.9 96.9 43.4 278.2c-7.8 10.7-22.8 13-33.5 5.2s-13-22.8-5.2-33.5l152-208c4.5-6.2 11.8-9.9 19.5-9.8z',
  ],
};
const faTurnLeftDown = {
  prefix: 'far',
  iconName: 'turn-left-down',
  icon: [
    384,
    512,
    [],
    'e637',
    'M208.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L46.6 384.1c-9.3-8.8-14.6-21-14.6-33.7C32 324.7 52.7 304 78.3 304l41.7 0 0-144C120 71.6 191.6 0 280 0l48 0c30.9 0 56 25.1 56 56l0 32c0 30.9-25.1 56-56 56l-56 0c-4.4 0-8 3.6-8 8l0 152 41.7 0c25.6 0 46.3 20.7 46.3 46.3c0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5L240 352c-13.3 0-24-10.7-24-24l0-176c0-30.9 25.1-56 56-56l56 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-48 0c-61.9 0-112 50.1-112 112l0 168c0 13.3-10.7 24-24 24l-61.5 0L192 455 301.5 352z',
  ],
};
const faPersonRunningFast = {
  prefix: 'far',
  iconName: 'person-running-fast',
  icon: [
    512,
    512,
    [],
    'e5ff',
    'M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8zM218.5 317.1L199.4 368 120 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm-16 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z',
  ],
};
const faCircleDown = {
  prefix: 'far',
  iconName: 'circle-down',
  icon: [
    512,
    512,
    [61466, 'arrow-alt-circle-down'],
    'f358',
    'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z',
  ],
};
const faArrowAltCircleDown = faCircleDown;
const faGrill = {
  prefix: 'far',
  iconName: 'grill',
  icon: [
    448,
    512,
    [],
    'e5a3',
    'M48 80l352 0 0 16c0 97.2-78.8 176-176 176S48 193.2 48 96l0-16zM40 32C17.9 32 0 49.9 0 72L0 96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64l156.7 0 21.2 49.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L318.8 299C395.1 263.3 448 185.8 448 96l0-24c0-22.1-17.9-40-40-40L40 32zM151.8 368l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4L296.2 368l-144.3 0zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faArrowsTurnToDots = {
  prefix: 'far',
  iconName: 'arrows-turn-to-dots',
  icon: [
    512,
    512,
    [],
    'e4c1',
    'M255 31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39L424 104c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-174.1 0 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9l80-80zM257 287l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L88 408c-22.1 0-40 17.9-40 40l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-48.6 39.4-88 88-88l174.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm127 97a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z',
  ],
};
const faChartMixed = {
  prefix: 'far',
  iconName: 'chart-mixed',
  icon: [
    512,
    512,
    ['analytics'],
    'f643',
    'M503.6 74.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6L320.2 168.3 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2l168-144zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zm264 16l0 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8zm-56 0l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm184 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48z',
  ],
};
const faAnalytics = faChartMixed;
const faFlorinSign = {
  prefix: 'far',
  iconName: 'florin-sign',
  icon: [
    384,
    512,
    [],
    'e184',
    'M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224 56 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l103.8 0L105.8 406.9C99.7 422 85 432 68.7 432L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l44.7 0c36 0 68.3-21.9 81.7-55.3L211.4 272 328 272c13.3 0 24-10.7 24-24s-10.7-24-24-24l-97.4 0 47.5-118.9C284.3 90 299 80 315.3 80L360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-44.7 0z',
  ],
};
const faArrowDownShortWide = {
  prefix: 'far',
  iconName: 'arrow-down-short-wide',
  icon: [
    576,
    512,
    ['sort-amount-desc', 'sort-amount-down-alt'],
    'f884',
    'M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0z',
  ],
};
const faSortAmountDesc = faArrowDownShortWide;
const faSortAmountDownAlt = faArrowDownShortWide;
const faLessThan = {
  prefix: 'far',
  iconName: 'less-than',
  icon: [
    384,
    512,
    [62774],
    '3c',
    'M381.5 77.3c5.9 11.9 1.1 26.3-10.7 32.2L77.7 256 370.7 402.5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-336-168C5.1 273.4 0 265.1 0 256s5.1-17.4 13.3-21.5l336-168c11.9-5.9 26.3-1.1 32.2 10.7z',
  ],
};
const faDisplayCode = {
  prefix: 'far',
  iconName: 'display-code',
  icon: [
    576,
    512,
    ['desktop-code'],
    'e165',
    'M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM361 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z',
  ],
};
const faDesktopCode = faDisplayCode;
const faFaceDrooling = {
  prefix: 'far',
  iconName: 'face-drooling',
  icon: [
    512,
    512,
    [],
    'e372',
    'M48 256c0 114.9 93.1 208 208 208l0 48C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9l0-66.9c30-36 48-82.4 48-132.9c0-114.9-93.1-208-208-208S48 141.1 48 256zm110.8-32.4c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4c3.8-11.3 12.2-26.8 25.8-39.8C153.2 155.2 173.5 144 200 144c13.3 0 24 10.7 24 24s-10.7 24-24 24c-11.9 0-20.9 4.8-27.9 11.4c-7.4 7-11.8 15.5-13.4 20.2zM129 309.3c10.4-8.3 25.5-6.6 33.7 3.7c18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47c8.3-10.4 23.4-12 33.7-3.7s12 23.4 3.8 33.7c-.9 1.1-1.8 2.2-2.7 3.3L384 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-119.6c-9.5 7-20.2 13.3-32 18.5l0 69.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-59.1c-10 2-20.7 3.1-32 3.1c-62.6 0-106.2-34.3-130.7-65c-8.3-10.3-6.6-25.5 3.7-33.7zM339.9 203.4c-7-6.6-16-11.4-27.9-11.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.5 0 46.8 11.2 60.9 24.6c13.7 13 22.1 28.5 25.8 39.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2c-1.6-4.7-6-13.2-13.4-20.2z',
  ],
};
const faOilTemperature = {
  prefix: 'far',
  iconName: 'oil-temperature',
  icon: [
    576,
    512,
    ['oil-temp'],
    'f614',
    'M264 24c0-13.3 10.7-24 24-24l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 83.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L264 120l0-96zm24 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM111.9 286.1c17.8 15.4 41.2 28.5 65 32.6c2.4 18.1 9.1 34.9 19.1 49.3c-1.3 0-2.7 .1-4.1 .1c-34.6 0-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM384 368c-1.3 0-2.7 0-4-.1c10-14.3 16.7-31.1 19.1-49.3c23.8-4.1 47.2-17.2 65-32.6c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8zm-272 62.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faOilTemp = faOilTemperature;
const faSquareQuestion = {
  prefix: 'far',
  iconName: 'square-question',
  icon: [
    448,
    512,
    ['question-square'],
    'f2fd',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm137.8 69.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faQuestionSquare = faSquareQuestion;
const faAirConditioner = {
  prefix: 'far',
  iconName: 'air-conditioner',
  icon: [
    576,
    512,
    [],
    'f8f4',
    'M64 48c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 256c-35.3 0-64-28.7-64-64L0 64zm120 64l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM368 288l0 104c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7c-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-104 48 0zM208 424l0-136 48 0 0 136c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2c11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z',
  ],
};
const faAngleDown = {
  prefix: 'far',
  iconName: 'angle-down',
  icon: [
    448,
    512,
    [8964],
    'f107',
    'M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z',
  ],
};
const faMountains = {
  prefix: 'far',
  iconName: 'mountains',
  icon: [
    640,
    512,
    [9968],
    'f6fd',
    'M464 424.1c0 4.4-3.5 7.9-7.9 7.9L55.9 432c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L256 90.3 462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zm-464 0C0 455 25 480 55.9 480l400.2 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1z',
  ],
};
const faOmega = {
  prefix: 'far',
  iconName: 'omega',
  icon: [
    448,
    512,
    [],
    'f67a',
    'M224 80C126.8 80 48 158.8 48 256c0 63.7 33.8 119.5 84.6 150.4c11.4 7 19.4 19.6 19.4 34.2c0 21.8-17.6 39.4-39.4 39.4L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l61.4 0C33.4 391 0 327.4 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176l61.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88.6 0c-21.8 0-39.4-17.6-39.4-39.4c0-14.6 8-27.2 19.4-34.2C366.2 375.5 400 319.7 400 256c0-97.2-78.8-176-176-176z',
  ],
};
const faCarTunnel = {
  prefix: 'far',
  iconName: 'car-tunnel',
  icon: [
    512,
    512,
    [],
    'e4de',
    'M256 48C141.1 48 48 141.1 48 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-114.9-93.1-208-208-208zM190.8 277.5L177 320l158 0-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5l-115.2 0c-3.5 0-6.5 2.2-7.6 5.5zM122.7 332l22.5-69.3c7.5-23.1 29-38.7 53.3-38.7l115.2 0c24.3 0 45.8 15.6 53.3 38.7L389.3 332c16.1 11.6 26.7 30.6 26.7 52l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-224 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-21.4 10.5-40.4 26.7-52zM144 432l224 0 0-48c0-8.8-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16l0 48zm16-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPersonDollyEmpty = {
  prefix: 'far',
  iconName: 'person-dolly-empty',
  icon: [
    512,
    512,
    [],
    'f4d1',
    'M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM60.6 176c-6.9 0-12.6 5.6-12.6 12.6l0 83.9c0 2.5 1.1 4.8 3.1 6.3L72 295.2l0-117c-3.6-1.4-7.5-2.2-11.4-2.2zM120 234.7l0 98.2 25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4l0-83.9C0 155.1 27.1 128 60.6 128c24.8 0 48.2 11.7 63.1 31.5L172 224l35.3 0-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L219.3 272 168 272c-12.6 0-24.4-5.9-32-16l-16-21.3zM304 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faPanFood = {
  prefix: 'far',
  iconName: 'pan-food',
  icon: [
    640,
    512,
    [129368],
    'e42b',
    'M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM48 184l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zM243.4 142.8C250.7 106.3 282.8 80 320 80s69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14l-131.4 0c-7.4 0-12.9-6.8-11.5-14l.6-3.2zm-13.3 43.1c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7l26.7 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-26.7c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm132.9-4.9l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C446 315.2 432.4 320 418.4 320l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z',
  ],
};
const faHeadSideCough = {
  prefix: 'far',
  iconName: 'head-side-cough',
  icon: [
    640,
    512,
    [],
    'e061',
    'M224 48C126.8 48 48 126.8 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4l0 89.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0l24 0c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6l-.4 0s0 0 0 0l0 24 0 64 0 8c0 35.3-28.7 64-64 64l-65.4 0c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l88 0c8.8 0 16-7.2 16-16l0-8 0-9.3-58.4-4.9c-12.2-1-21.6-11.2-21.6-23.4c0-10.8 7.3-20.2 17.8-22.8L400 348l0-12 0-8 0-16c0-13.3 10.7-24 24-24l24.4 0c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48l-24 0zm80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM488 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faGripLines = {
  prefix: 'far',
  iconName: 'grip-lines',
  icon: [
    448,
    512,
    [],
    'f7a4',
    'M448 192c0-13.3-10.7-24-24-24L24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24zm0 128c0-13.3-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24z',
  ],
};
const faThumbsDown = {
  prefix: 'far',
  iconName: 'thumbs-down',
  icon: [
    512,
    512,
    [128078, 61576],
    'f165',
    'M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z',
  ],
};
const faUserLock = {
  prefix: 'far',
  iconName: 'user-lock',
  icon: [
    640,
    512,
    [],
    'f502',
    'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM49.3 464c8.9-63.3 63.3-112 129-112l91.4 0c49.3 0 92.1 27.3 114.3 67.7l0-67.7c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-16L49.3 464zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faArrowRightLong = {
  prefix: 'far',
  iconName: 'arrow-right-long',
  icon: [
    512,
    512,
    ['long-arrow-right'],
    'f178',
    'M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z',
  ],
};
const faLongArrowRight = faArrowRightLong;
const faTicketsAirline = {
  prefix: 'far',
  iconName: 'tickets-airline',
  icon: [
    640,
    512,
    ['tickets-perforated-plane', 'tickets-plane'],
    'e29b',
    'M144 96l0 224c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-38.2c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8L592 96c0-8.8-7.2-16-16-16L160 80c-8.8 0-16 7.2-16 16zm16-64l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM24 96c13.3 0 24 10.7 24 24l0 240c0 39.8 32.2 72 72 72l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0C53.7 480 0 426.3 0 360L0 120c0-13.3 10.7-24 24-24zm264.4 80l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5L304 96c8.5 0 16.4 4.5 20.7 11.9L364.4 176l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.3-7.6-10.5L288.4 240l-42.7 0-19.2 25.6c-3 4-7.8 6.4-12.8 6.4L200 272c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L245.8 176l42.7 0z',
  ],
};
const faTicketsPerforatedPlane = faTicketsAirline;
const faTicketsPlane = faTicketsAirline;
const faTentDoublePeak = {
  prefix: 'far',
  iconName: 'tent-double-peak',
  icon: [
    576,
    512,
    [],
    'e627',
    'M131.3 93.4l30-37.5 6.1 6.1C199.4 94 242.8 112 288 112s88.6-18 120.6-49.9l6.1-6.1 30 37.5c16 20 34.5 37.9 55 53.3L528 168l0 24-216 0-48 0L48 192l0-24 28.4-21.3c20.5-15.4 39-33.3 55-53.3zM264 240l0 224L48 464l0-224 216 0zm48 0l216 0 0 224-112 0L312 240zM393.4 9.4L374.6 28.1C351.7 51.1 320.5 64 288 64s-63.7-12.9-86.6-35.9L182.6 9.4C176.2 2.9 167.3-.5 158.2 0s-17.5 4.9-23.2 12L93.9 63.5c-13.5 16.9-29 31.9-46.3 44.9L12.8 134.4C4.7 140.4 0 149.9 0 160L0 480c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-320c0-10.1-4.7-19.6-12.8-25.6l-34.7-26.1c-17.3-12.9-32.8-28-46.3-44.9L441 12C435.3 4.9 426.9 .6 417.8 0s-18 2.9-24.4 9.3z',
  ],
};
const faAnchorCircleXmark = {
  prefix: 'far',
  iconName: 'anchor-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4ac',
    'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faEllipsis = {
  prefix: 'far',
  iconName: 'ellipsis',
  icon: [
    448,
    512,
    ['ellipsis-h'],
    'f141',
    'M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
  ],
};
const faEllipsisH = faEllipsis;
const faNfcSlash = {
  prefix: 'far',
  iconName: 'nfc-slash',
  icon: [
    640,
    512,
    [],
    'e1fc',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9l320 0c8.8 0 16 7.2 16 16l0 267.5-32-25.1L464 152c0-22.1-17.9-40-40-40l-88 0c-22.1 0-40 17.9-40 40l0 54.7-60-47c11.4-1.9 20-11.8 20-23.7c0-13.3-10.7-24-24-24l-16 0c-10.5 0-20.1 4-27.2 10.7L145.7 88.9zM416 300.8l-48.5-38c.3-2.2 .5-4.5 .5-6.8c0-17.8-9.7-33.3-24-41.6l0-54.4 72 0 0 140.8zm70.9 178.9L426.5 432 160 432c-8.8 0-16-7.2-16-16l0-206.5L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4zM385.8 400l-60.9-48L224 352l0-79.5-48-37.8L176 360c0 22.1 17.9 40 40 40l169.8 0z',
  ],
};
const faChessPawn = {
  prefix: 'far',
  iconName: 'chess-pawn',
  icon: [
    320,
    512,
    [9823],
    'f443',
    'M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120l-12.6 0 10.7 80-48.4 0L195 272l-35 0-35 0-10.7 80-48.4 0 10.7-80L64 272c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z',
  ],
};
const faKitMedical = {
  prefix: 'far',
  iconName: 'kit-medical',
  icon: [
    576,
    512,
    ['first-aid'],
    'f479',
    'M144 432l288 0 0-352L144 80l0 352zm-48 0L96 80 64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l32 0zM64 32l32 0 24 0 24 0 288 0 24 0 24 0 32 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-32 0-24 0-24 0-288 0-24 0-24 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM480 432l32 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-32 0 0 352zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faFirstAid = faKitMedical;
const faGrid2Plus = {
  prefix: 'far',
  iconName: 'grid-2-plus',
  icon: [
    512,
    512,
    [],
    'e197',
    'M176 80L80 80l0 96 96 0 0-96zM80 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm96 304l-96 0 0 96 96 0 0-96zM80 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM336 80l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm96 192c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z',
  ],
};
const faBells = {
  prefix: 'far',
  iconName: 'bells',
  icon: [
    640,
    512,
    [],
    'f77f',
    'M230.8 245.5C203.2 170.3 232.4 88.2 296.5 46c-4.5-2.2-9.1-4.2-13.9-6C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c9.4-32.5 8.1-67.2-3.5-99.1l-18.7-51.2zm128.5-142c46.5-16.9 97.9 7 114.9 53.4l18.8 51.2c15.8 43.1 43.6 80.8 80.1 108.5L333.7 403.7c9.9-44.6 6.9-91.2-9-134.4L306 218.2c-17-46.4 6.9-97.8 53.3-114.7zM283.9 404.6l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9zM480.8 480c35.6 0 64.5-28.8 64.5-64.3c0-1.3 0-2.6-.1-3.9L429.1 454.1c11.8 15.7 30.6 25.9 51.7 25.9zM94.3 376.2c-.3 2.5-.4 5-.4 7.5c0 35.5 28.9 64.3 64.5 64.3c22.3 0 41.9-11.3 53.5-28.4L94.3 376.2z',
  ],
};
const faPersonThroughWindow = {
  prefix: 'far',
  iconName: 'person-through-window',
  icon: [
    640,
    512,
    [],
    'e5a9',
    'M304 48l0 18.4c0 46.1-28.9 87.3-72.2 103.1C169.5 192.1 128 251.3 128 317.6l0 82.4-80 0L48 48l256 0zm48 0l240 0 0 352-81.7 0L499 385.4l-75.2-97.8c-7.6-9.8-19.3-15.6-31.7-15.6L333 272l-49.4-75.7c42.1-28.9 68.4-77.2 68.4-130L352 48zm97.7 352l-83.8 0 32 48L592 448c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 400c0 26.5 21.5 48 48 48l255.9 0 36.2 53.5c7.4 11 22.4 13.8 33.3 6.4s13.8-22.4 6.4-33.3L297.2 352.5 343.6 320l44.6 0 61.5 80zm-178.3 0L176 400l0-82.4c0-15.7 3.3-30.8 9.4-44.5l86 126.9zm-1.1-87.3l-54.1-79.9c7.3-6 15.4-11 24.2-15l51.9 79.6-22 15.4zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faToolbox = {
  prefix: 'far',
  iconName: 'toolbox',
  icon: [
    512,
    512,
    [129520],
    'f552',
    'M184 80l144 0c4.4 0 8 3.6 8 8l0 40-160 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-28.1 0c-12.7 0-24.9 5.1-33.9 14.1L14.1 193.9c-9 9-14.1 21.2-14.1 33.9L0 328l0 88c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88 0-100.1c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1L384 128l0-40c0-30.9-25.1-56-56-56L184 32c-30.9 0-56 25.1-56 56zM464 304l-96 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-128 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-96 0 0-76.1L99.9 176l312.2 0L464 227.9l0 76.1zM48 352l96 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 128 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 96 0 0 64c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64z',
  ],
};
const faGlobeWifi = {
  prefix: 'far',
  iconName: 'globe-wifi',
  icon: [
    640,
    512,
    [],
    'e685',
    'M256 464c7.4 0 27-7.2 47.6-48.4c6.2-12.4 11.8-26.7 16.5-42.5c1.2 43.9 18.6 83.8 46.3 114C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-26.2 0-51.1 5.7-73.4 16l-40.8 0c.8 8.1 1.3 16.3 1.7 24.7c-21.4 17.8-38.4 40.5-49.5 66.4c1.3-13.8 2-28.2 2-43.1c0-16.6-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48L332 304c-5.9 15.1-9.8 31.2-11.3 48l-134.3 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM186.4 160l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm254.2 0c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM169.9 445.4c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-48c27.2 0 51.9 10.2 70.6 27.1c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6c-24.4-21.9-56.6-35.3-92-35.3s-67.7 13.4-92 35.3c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2C444.1 330.2 468.9 320 496 320zm20 112a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm-51.5-35.9c8.3-7.5 19.4-12.1 31.5-12.1s23.2 4.6 31.5 12.1c6.6 5.9 16.7 5.4 22.6-1.1s5.4-16.7-1.1-22.6c-14-12.7-32.6-20.4-53-20.4s-39 7.7-53 20.4c-6.6 5.9-7.1 16-1.1 22.6s16 7.1 22.6 1.1z',
  ],
};
const faEnvelopeDot = {
  prefix: 'far',
  iconName: 'envelope-dot',
  icon: [
    576,
    512,
    ['envelope-badge'],
    'e16f',
    'M496 160A80 80 0 1 0 496 0a80 80 0 1 0 0 160zm16 224l0-193.1c-5.2 .7-10.6 1.1-16 1.1c-22.5 0-43.5-6.6-61-18.1L291.5 291.7c-20.7 17-50.4 17-71.1 0L48 150.1 48 128c0-8.8 7.2-16 16-16l324.6 0c-3-10.1-4.6-20.9-4.6-32c0-5.4 .4-10.8 1.1-16L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM48 212.2L190 328.8c38.4 31.5 93.7 31.5 132 0L464 212.2 464 384c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-171.8z',
  ],
};
const faEnvelopeBadge = faEnvelopeDot;
const faMagnifyingGlassWaveform = {
  prefix: 'far',
  iconName: 'magnifying-glass-waveform',
  icon: [
    512,
    512,
    [],
    'e661',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm24-280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zm-80 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm160 16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z',
  ],
};
const faHandsHoldingCircle = {
  prefix: 'far',
  iconName: 'hands-holding-circle',
  icon: [
    640,
    512,
    [],
    'e4fb',
    'M320 256A128 128 0 1 0 320 0a128 128 0 1 0 0 256zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z',
  ],
};
const faBug = {
  prefix: 'far',
  iconName: 'bug',
  icon: [
    512,
    512,
    [],
    'f188',
    'M256 0c53 0 96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4C161.3 165.7 180 160 200 160l112 0c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C410.3 225.3 416 244 416 264l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0 0 8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-70.9-70.9C339.3 462.5 299.7 480 256 480s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320l0-8-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zM144 264l0 56c0 53.6 37.7 98.4 88 109.4L232 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 149.4c50.3-11 88-55.8 88-109.4l0-56c0-30.9-25.1-56-56-56l-112 0c-30.9 0-56 25.1-56 56z',
  ],
};
const faBowlChopsticks = {
  prefix: 'far',
  iconName: 'bowl-chopsticks',
  icon: [
    512,
    512,
    [],
    'e2e9',
    'M18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23l-473.8 74zM0 159.7c0-8.8 7-16 15.7-16.2l471.9-14.7C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6L16.2 176C7.3 176 0 168.7 0 159.7zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272z',
  ],
};
const faCreditCard = {
  prefix: 'far',
  iconName: 'credit-card',
  icon: [
    576,
    512,
    [128179, 62083, 'credit-card-alt'],
    'f09d',
    'M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faCreditCardAlt = faCreditCard;
const faCircleS = {
  prefix: 'far',
  iconName: 'circle-s',
  icon: [
    512,
    512,
    [],
    'e121',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c1.1-6.2 5-11.8 15.4-15.8c11-4.3 27.6-6 47.8-2.9c6 .9 20.6 4 27.3 5.7c12.8 3.3 25.9-4.5 29.2-17.3s-4.5-25.9-17.3-29.2c-7.7-2-23.9-5.5-32-6.7c-25.6-3.9-51.3-2.6-72.6 5.7c-21.9 8.6-40.3 25.7-45 52c-2.6 14.4-1.3 28 4.4 40.3c5.6 12.1 14.7 20.8 24.1 27.2c17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4c4.5 3 6.5 5.6 7.4 7.7c.9 1.9 1.8 5.2 .6 11.6c-1.1 6.2-5 11.8-15.4 15.8c-11 4.3-27.5 6-47.7 2.9c-12.2-1.9-36.1-8.9-50-13.4c-12.6-4-26.1 2.9-30.2 15.5s2.9 26.1 15.5 30.2c13.6 4.4 40.9 12.5 57.3 15.1c0 0 0 0 0 0l.1 0c25.6 3.9 51.3 2.6 72.6-5.7c21.9-8.6 40.3-25.7 45-52c2.6-14.4 1.4-28-4.4-40.3c-5.6-12.1-14.7-20.8-24.1-27.2c-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4c-4.5-3-6.5-5.6-7.4-7.7c-.9-1.9-1.8-5.2-.6-11.6z',
  ],
};
const faBoxBallot = {
  prefix: 'far',
  iconName: 'box-ballot',
  icon: [
    576,
    512,
    [128499],
    'f735',
    'M176 208l224 0 0-160L176 48l0 160zM128 32c0-17.7 14.3-32 32-32L416 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-192zM48 160l48 0 0 48-48 0 0 112 480 0 0-112-48 0 0-48 48 0c26.5 0 48 21.5 48 48l0 112 0 24 0 24 0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96 0-24 0-24L0 208c0-26.5 21.5-48 48-48zM528 368L48 368l0 96 480 0 0-96z',
  ],
};
const faCar = {
  prefix: 'far',
  iconName: 'car',
  icon: [
    512,
    512,
    [128664, 'automobile'],
    'f1b9',
    'M127.7 106.8L103.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM416 224L96 224c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faAutomobile = faCar;
const faHandHoldingHand = {
  prefix: 'far',
  iconName: 'hand-holding-hand',
  icon: [
    576,
    512,
    [],
    'e4f7',
    'M388.6 192c7.9 0 15.6-2.3 22.2-6.7L490.7 132c3.9-2.6 8.6-4 13.3-4l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40.7 0-73.8 49.2C423 234.9 406 240 388.6 240L232 240c-35.3 0-64-28.7-64-64c0-.7 0-1.3 0-2l-64.9 40c-10.7 6.6-22.9 10-35.5 10l-7.4 0C27 224 0 197 0 163.7c0-20.4 10.4-39.5 27.5-50.6l95.6-61.9C142.6 38.7 165.2 32 188.4 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L188.4 80c-13.9 0-27.5 4-39.1 11.6L53.6 153.4c-3.5 2.3-5.6 6.1-5.6 10.3c0 6.8 5.5 12.3 12.3 12.3l7.4 0c3.6 0 7.2-1 10.3-2.9l93.5-57.5c3.8-2.3 8.1-3.6 12.6-3.6l48 0 24 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l156.6 0zM187.4 320c-7.9 0-15.6 2.3-22.2 6.7L85.3 380c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 277.1 170 272 187.4 272L344 272c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faUserTieHair = {
  prefix: 'far',
  iconName: 'user-tie-hair',
  icon: [
    448,
    512,
    [],
    'e45f',
    'M304 144l0-16c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16C96 57.3 153.3 0 224 0zm30.8 418.4l43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2zM118.5 376.3C82.3 391.1 55.4 424.2 49.3 464l113 0-43.8-87.7zM285.7 464l113 0c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z',
  ],
};
const faPodiumStar = {
  prefix: 'far',
  iconName: 'podium-star',
  icon: [
    448,
    512,
    [],
    'f758',
    'M182.4 72c8.3 14.3 23.8 24 41.6 24l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L224 0c-17.8 0-33.3 9.7-41.6 24L168 24c-48.6 0-88 39.4-88 88l0 32-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-296 0 0-32c0-22.1 17.9-40 40-40l14.4 0zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8l173.7 0c32.6 0 59.9-24.4 63.6-56.8L400.7 224l-48.3 0L326.8 449.8c-.9 8.1-7.8 14.2-15.9 14.2l-173.7 0c-8.1 0-15-6.1-15.9-14.2L95.6 224l-48.3 0zm201.5 77.7l-18.2-41.3c-2.6-5.8-10.5-5.8-13.1 0l-18.2 41.3c-1.1 2.4-3.2 4-5.7 4.3l-43.2 5.4c-6.1 .8-8.6 8.7-4 13l31.9 30.9c1.8 1.8 2.7 4.4 2.2 7L171.9 407c-1.2 6.3 5.2 11.2 10.6 8.1l37.9-22.2c2.2-1.3 4.9-1.3 7 0L265.5 415c5.4 3.1 11.8-1.7 10.6-8.1l-8.5-44.6c-.5-2.6 .3-5.2 2.2-7l31.9-30.9c4.5-4.4 2.1-12.3-4-13L254.5 306c-2.5-.3-4.6-2-5.7-4.3z',
  ],
};
const faUserHairMullet = {
  prefix: 'far',
  iconName: 'user-hair-mullet',
  icon: [
    448,
    512,
    ['business-front', 'party-back', 'trian-balbot'],
    'e45c',
    'M304 128c0-5.7-.6-11.3-1.7-16.6c-30.6-3.1-58.5-17.9-78.3-40.6c-19.8 22.7-47.6 37.5-78.3 40.6c-1.1 5.4-1.7 10.9-1.7 16.6l0 16c0 18 6 34.6 16 48c0 0 0 0 0 0s0 0 0 0c14.6 19.4 37.8 32 64 32s49.4-12.6 64-32c0 0 0 0 0 0s0 0 0 0c10-13.4 16-30 16-48l0-16zM237.4 271.3c-4.4 .5-8.9 .7-13.4 .7s-9-.2-13.4-.7L193 289c-5.5 5.5-13.2 8-20.8 6.7s-14.2-6.1-17.6-13l-6.1-12.2-19.5 7.8c-9.3 3.7-19.8 1.3-26.6-6s-8.3-18.1-3.8-27c8.5-17 11-22.3 12.2-27.1c.7-2.9 1.1-5.9 1.2-12.3C101.8 187.5 96 166.4 96 144l0-16c0-7.1 .6-14 1.7-20.7C91.8 102.9 88 95.9 88 88c0-13.3 10.7-24 24-24l1.1 0C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64l1.1 0c13.3 0 24 10.7 24 24c0 7.9-3.8 14.9-9.7 19.3c1.1 6.8 1.7 13.7 1.7 20.7l0 16c0 22.4-5.8 43.5-15.9 61.8c.1 6.4 .5 9.4 1.2 12.3c1.2 4.8 3.7 10.1 12.2 27.1c4.5 8.9 2.9 19.7-3.8 27s-17.3 9.7-26.6 6l-19.5-7.8-6.1 12.2c-3.4 6.9-10 11.7-17.6 13s-15.4-1.3-20.8-6.7l-17.7-17.7zM49.6 464l348.7 0c-9.3-54.5-56.8-96-113.9-96l-120.9 0c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z',
  ],
};
const faBusinessFront = faUserHairMullet;
const faPartyBack = faUserHairMullet;
const faTrianBalbot = faUserHairMullet;
const faMicrophoneStand = {
  prefix: 'far',
  iconName: 'microphone-stand',
  icon: [
    512,
    512,
    [127908],
    'f8cb',
    'M476.9 204.9l1-1c45.9-46.9 45.6-122.2-1-168.7s-121.8-46.9-168.7-1l-1 .9s0 0 0 0l-16 16-16 16s0 0 0 0l-.9 1C251.8 91 240.4 120.7 240 150.5L17.2 388.2C6.1 400 0 415.5 0 431.6c0 16.8 6.7 33 18.6 44.9l16.8 16.8C47.4 505.3 63.5 512 80.4 512c16.1 0 31.7-6.1 43.4-17.2L232 393.4l0 94.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.6L361.5 272c29.8-.4 59.5-11.8 82.4-34.2l1-1 16-16 16-16zM361.9 224L325 187 288 150.1c.5-17.4 7.2-34.6 20.1-48L409.9 203.9c-13.4 12.9-30.7 19.6-48 20.1zm82-54L342.1 68.1c28.2-27.2 73-26.8 100.8 1s28.1 72.7 1 100.8zM80.4 464c-4.1 0-8.1-1.6-11-4.5L52.5 442.6c-2.9-2.9-4.5-6.9-4.5-11c0-3.9 1.5-7.7 4.2-10.6L264.6 194.5 291 221l26.5 26.5L91 459.8c-2.9 2.7-6.7 4.2-10.6 4.2z',
  ],
};
const faBookOpenReader = {
  prefix: 'far',
  iconName: 'book-open-reader',
  icon: [
    512,
    512,
    ['book-reader'],
    'f5da',
    'M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7l0 176.3c84.9 5 147.1 22.3 184 35.7L232 282l-4-3zm52 3l0 171.1c36.9-13.4 99.1-30.7 184-35.7l0-176.3c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5l0 208c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7L0 224c0-17.7 14.4-32.1 32-31.5z',
  ],
};
const faBookReader = faBookOpenReader;
const faFamilyDress = {
  prefix: 'far',
  iconName: 'family-dress',
  icon: [
    512,
    512,
    [],
    'e301',
    'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM112.3 208l15.7 0 15.7 0 38.9 0c-4.3-9.8-6.7-20.6-6.7-32c0-2.4 .1-4.8 .3-7.1c-9.6-5.7-20.8-8.9-32.6-8.9l-31.4 0c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 37.5 0c-3.5-10-5.5-20.8-5.5-32l0-16-80.4 0L96.9 219.6c2-6.9 8.2-11.6 15.4-11.6zM336 176c0 11.4-2.4 22.2-6.7 32l38.9 0 15.7 0 15.7 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336 368 336l0 16c0 11.2-1.9 22-5.5 32l37.5 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112l0 16c0 8.8-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z',
  ],
};
const faCircleX = {
  prefix: 'far',
  iconName: 'circle-x',
  icon: [
    512,
    512,
    [],
    'e12e',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8L224.6 256l-74.9 88.5c-8.6 10.1-7.3 25.3 2.8 33.8s25.3 7.3 33.8-2.8L256 293.2l69.7 82.3c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8L287.4 256l74.9-88.5c8.6-10.1 7.3-25.3-2.8-33.8s-25.3-7.3-33.8 2.8L256 218.8l-69.7-82.3z',
  ],
};
const faCabin = {
  prefix: 'far',
  iconName: 'cabin',
  icon: [
    512,
    512,
    [],
    'e46d',
    'M256 54.1L95.3 176l321.3 0L256 54.1zM231.8 12.2c14.3-10.8 34.1-10.8 48.4 0L432 127.4 432 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 107.8 22.5 17.1c8.2 6.2 11.5 17 8.2 26.8s-12.4 16.3-22.7 16.3L24 224c-10.3 0-19.5-6.6-22.7-16.3s0-20.5 8.2-26.8L231.8 12.2zM32 296c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 320c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 512c-13.3 0-24-10.7-24-24zM56 368l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 416c-13.3 0-24-10.7-24-24s10.7-24 24-24zm264-72c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm24 168l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM224 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faMountainSun = {
  prefix: 'far',
  iconName: 'mountain-sun',
  icon: [
    640,
    512,
    [],
    'e52f',
    'M480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM412.7 281.7l48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0s0 0 0 0L55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7zm28.5 45.4l62.2 99.2c5.6 8.9 8.6 19.2 8.6 29.7c0 2.7-.2 5.3-.6 7.9l67.4 0c7.2 0 13.1-5.9 13.1-13.1c0-2.4-.7-4.8-1.9-6.8L480 263.6l-38.8 63.6zM456.1 464c4.4 0 7.9-3.5 7.9-7.9c0-1.5-.4-2.9-1.2-4.2L256 122.3 49.2 451.9c-.8 1.3-1.2 2.7-1.2 4.2c0 4.4 3.5 7.9 7.9 7.9l400.2 0z',
  ],
};
const faChartSimpleHorizontal = {
  prefix: 'far',
  iconName: 'chart-simple-horizontal',
  icon: [
    448,
    512,
    [],
    'e474',
    'M400 240L48 240l0 32 352 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM208 400L48 400l0 32 160 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm80-320l0-32L48 80l0 32 288 0zm0 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z',
  ],
};
const faBluetooth = {
  prefix: 'far',
  iconName: 'bluetooth',
  icon: [
    384,
    512,
    [],
    'f293',
    'M182.1 2.1c8.6-3.9 18.7-2.4 25.8 3.9l136 120c5.3 4.7 8.2 11.4 8.1 18.4s-3.3 13.6-8.7 18.1L229.8 256l113.5 93.5c5.4 4.5 8.6 11.1 8.7 18.1s-2.8 13.8-8.1 18.4l-136 120c-7.1 6.2-17.2 7.8-25.8 3.9S168 497.4 168 488l0-181.1L71.3 386.5c-10.2 8.4-25.4 7-33.8-3.3s-7-25.4 3.3-33.8L154.2 256 40.7 162.5C30.5 154.1 29 139 37.5 128.7s23.6-11.7 33.8-3.3L168 205.1 168 24c0-9.4 5.5-18 14.1-21.9zM216 306.9l0 128 75-66.2-75-61.8zm0-101.7l75-61.8L216 77.2l0 128z',
  ],
};
const faArrowsLeftRightToLine = {
  prefix: 'far',
  iconName: 'arrows-left-right-to-line',
  icon: [
    640,
    512,
    [],
    'e4ba',
    'M24 64c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64zm217 71c9.4 9.4 9.4 24.6 0 33.9l-63 63 284.1 0-63-63c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L537 239c9.4 9.4 9.4 24.6 0 33.9L433 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l63-63-284.1 0 63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L207 135c9.4-9.4 24.6-9.4 33.9 0zM640 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHandBackPointLeft = {
  prefix: 'far',
  iconName: 'hand-back-point-left',
  icon: [
    512,
    512,
    [],
    'e19f',
    'M0 176c0-35.3 28.7-64 64-64l188.8 0c3.6-5.2 7.6-10.2 11.9-14.9l18.4-20.3C299.9 58.5 323.5 48 348.3 48l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 328c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-2.7 .2-5.4 .5-8L64 240c-35.3 0-64-28.7-64-64zm64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l136 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16l8 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1L301.5 128l42.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78 0-2 0L64 160z',
  ],
};
const faMessageDots = {
  prefix: 'far',
  iconName: 'message-dots',
  icon: [
    512,
    512,
    ['comment-alt-dots', 'messaging'],
    'f4a3',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCommentAltDots = faMessageDots;
const faMessaging = faMessageDots;
const faFileHeart = {
  prefix: 'far',
  iconName: 'file-heart',
  icon: [
    384,
    512,
    [],
    'e176',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM93.7 306.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z',
  ],
};
const faBeerMug = {
  prefix: 'far',
  iconName: 'beer-mug',
  icon: [
    512,
    512,
    ['beer-foam'],
    'e0b3',
    'M208 0c-26.8 0-51.1 11-68.5 28.8c0 0 0 0-.1 0C126.9 20.7 112 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c16 0 30.9-4.7 43.4-12.8c0 0 0 0 .1 0C156.9 181 181.2 192 208 192c26.5 0 50.6-10.8 68-28.2c0 0 0 0 0 0c12.8 8.5 28.2 13.5 44.6 13.5c44.5 0 80.6-36.1 80.6-80.6s-36.1-80.6-80.6-80.6c-16.1 0-31.2 4.8-43.9 13c0 0 0 0 0 0C259.3 11.1 234.9 0 208 0zM173.1 63c8.8-9.3 21.1-15 34.9-15c13.8 0 26.2 5.8 35 15.1c8.4 8.9 19.6 12.8 29.3 13.7c9.7 .9 20.9-1 30.4-7.4c5.2-3.4 11.3-5.4 18-5.4c18 0 32.6 14.6 32.6 32.6s-14.6 32.6-32.6 32.6c-6.8 0-13.1-2.1-18.3-5.6c-9.4-6.4-20.6-8.4-30.3-7.7c-9.7 .7-20.9 4.5-29.4 13.3c-8.8 9.1-21 14.7-34.6 14.7c-13.7 0-26.1-5.7-34.9-15c-8.4-8.9-19.6-12.7-29.2-13.6c-9.7-.8-20.8 1.1-30.3 7.3c-5 3.3-11.1 5.3-17.6 5.3c-17.7 0-32-14.3-32-32s14.3-32 32-32c6.5 0 12.6 1.9 17.6 5.3c9.5 6.3 20.6 8.2 30.3 7.3c9.7-.8 20.8-4.7 29.2-13.6zM32 187.9L32 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-.3 86.8-38c25-11 41.2-35.7 41.2-63l0-117.9c0-38-30.8-68.8-68.8-68.8l-29.4 0c-17.5 25.7-45.5 43.8-77.8 48.2l0 223.2c0 .4 0 .7 0 1.1l0 15.4c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-241.1c-17.7-2.5-34-9.2-48-18.9zM208 224c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zM320.3 97.2c.1 0 .1 .1 .1 .1s0 0 0 0s.1 0 .2 0c.1 0 .2 0 .2 0s0 0 0 0c0 0 .1-.1 .2-.2s.1-.2 .2-.2c0 0 0 0 0 0s0-.1 0-.2s0-.2 0-.2s0 0 0 0c0 0-.1-.1-.2-.2s-.2-.1-.2-.2c0 0 0 0 0 0s-.1 0-.2 0c-.1 0-.1 0-.2 0s0 0 0 0c0 0 0 0 0 0l-.1 0-.9 .6 .8 .6zM96 96s0 0 0 0s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0zM443.2 208c11.5 0 20.8 9.3 20.8 20.8l0 117.9c0 8.3-4.9 15.7-12.5 19.1L384 395.3 384 208l59.2 0zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z',
  ],
};
const faBeerFoam = faBeerMug;
const faDiceD20 = {
  prefix: 'far',
  iconName: 'dice-d20',
  icon: [
    512,
    512,
    [],
    'f6cf',
    'M243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6l0 224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368l0-224c0-8.4 4.4-16.2 11.7-20.6l200-120zM80 191.1l0 83.4L112.8 215 80 191.1zm65.5 63.9L94.9 347l115 9.2L145.5 255.1zm10.6 145L232 445.6l0-39.5-75.9-6.1zM280 406.2l0 39.5 75.9-45.5L280 406.2zM432 274.6l0-83.4L399.2 215 432 274.6zM375 173.3l37.6-27.3L327.1 94.6 375 173.3zM184.9 94.6L99.4 145.9 137 173.3l47.9-78.6zM256 70.2L186.7 184l138.6 0L256 70.2zM324.3 232l-136.6 0L256 339.3 324.3 232zM302.1 356.2l115-9.2-50.6-92L302.1 356.2z',
  ],
};
const faDrone = {
  prefix: 'far',
  iconName: 'drone',
  icon: [
    512,
    512,
    [],
    'f85f',
    'M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1L88.7 171.6C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64c27.1 0 50.3 16.9 59.6 40.7L223 127.2c.7-5 1-10.1 1-15.2zm-10.7 47.9l-39.8-29.9-29.7-22.3C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32c0 16.2 12.1 29.7 27.8 31.7l22.3 29.7 29.9 39.8 .1 .1 0 85.3-.1 .1-29.9 39.8-22.3 29.7C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32c16.2 0 29.7-12.1 31.7-27.8l29.7-22.3 39.8-29.9 .1-.1 85.3 0 .1 .1 39.8 29.9 29.7 22.3c2.1 15.7 15.5 27.8 31.7 27.8c17.7 0 32-14.3 32-32c0-16.2-12.1-29.7-27.8-31.7l-22.3-29.7-29.9-39.8-.1-.1 0-85.3 .1-.1 29.9-39.8 22.3-29.7c15.7-2.1 27.8-15.5 27.8-31.7c0-17.7-14.3-32-32-32c-16.2 0-29.7 12.1-31.7 27.8l-29.7 22.3-39.8 29.9-.1 .1-85.3 0-.1-.1zM223 384.8l-51.3 38.5C162.3 447.1 139.1 464 112 464c-35.3 0-64-28.7-64-64c0-27.1 16.9-50.3 40.7-59.6L127.2 289c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-5.2-.3-10.2-1-15.2zM288 112c0 5.2 .3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64c0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm1 272.8c-.7 5-1 10.1-1 15.2c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-5.2 0-10.2 .3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6c0 35.3-28.7 64-64 64c-27.1 0-50.3-16.9-59.6-40.7L289 384.8zM224 208l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
  ],
};
const faTruckDroplet = {
  prefix: 'far',
  iconName: 'truck-droplet',
  icon: [
    640,
    512,
    [],
    'e58c',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c-39.8 0-72-29.6-72-66c0-27 39.4-82.9 59.9-110.3c6.1-8.2 18.1-8.2 24.2 0C240.6 123 280 179 280 206c0 36.5-32.2 66-72 66z',
  ],
};
const faFileCircleXmark = {
  prefix: 'far',
  iconName: 'file-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e5a1',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z',
  ],
};
const faTemperatureArrowUp = {
  prefix: 'far',
  iconName: 'temperature-arrow-up',
  icon: [
    576,
    512,
    ['temperature-up'],
    'e040',
    'M176 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L240 112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L64 112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3zM448 32c6.8 0 13.3 2.9 17.8 7.9l72 80c8.9 9.9 8.1 25-1.8 33.9s-25 8.1-33.9-1.8L472 118.5 472 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-337.5-30.2 33.5c-8.9 9.9-24 10.7-33.9 1.8s-10.7-24-1.8-33.9l72-80c4.6-5.1 11-7.9 17.8-7.9z',
  ],
};
const faTemperatureUp = faTemperatureArrowUp;
const faMedal = {
  prefix: 'far',
  iconName: 'medal',
  icon: [
    512,
    512,
    [127941],
    'f5a2',
    'M4.1 38.2L106.4 191.5c11.2-11.6 23.7-21.9 37.3-30.6L68.4 48l64.5 0 54.9 91.5c15.8-5.5 32.4-9.1 49.6-10.6l-6.1-10.1L169.3 15.5C163.5 5.9 153.1 0 141.9 0L24.6 0C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6zm276.6 80.5l-6.1 10.1c17.2 1.5 33.8 5.2 49.6 10.6L379.2 48l64.5 0L368.4 160.9c13.6 8.7 26.1 19 37.3 30.6L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0L370.1 0c-11.2 0-21.7 5.9-27.4 15.5L280.8 118.7zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm7.2-257.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L180.7 304c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L252.3 386c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L302.4 355c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4l-19.2-38.9z',
  ],
};
const faPersonFairy = {
  prefix: 'far',
  iconName: 'person-fairy',
  icon: [
    640,
    512,
    [],
    'e608',
    'M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C372.9 220.8 359 208 342.4 208l-44.8 0zM336 352l-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L384 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136zM32 32c89.4 0 169.4 40.8 222.2 104.7c-15 6.3-28.4 15.9-39.3 27.8C174.1 116.6 114.7 84.9 48 80.5L48 112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c43.3-.2 82.5-17.6 111.2-45.7l0 61C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM425.1 164.5c-10.9-11.9-24.3-21.5-39.3-27.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-61c28.7 28.2 67.9 45.5 111.2 45.7c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112l0-31.5c-66.7 4.4-126.1 36.1-166.9 84z',
  ],
};
const faBed = {
  prefix: 'far',
  iconName: 'bed',
  icon: [
    640,
    512,
    [128716],
    'f236',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 360l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 264 0 280 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96 0-112c0-66.3-53.7-120-120-120l-176 0c-30.9 0-56 25.1-56 56l0 152L48 336 48 56zM592 248l0 88-256 0 0-152c0-4.4 3.6-8 8-8l176 0c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z',
  ],
};
const faBookCopy = {
  prefix: 'far',
  iconName: 'book-copy',
  icon: [
    576,
    512,
    [],
    'e0be',
    'M192 88c0-48.6 39.4-88 88-88L528 0c26.5 0 48 21.5 48 48l0 112 0 96c0 20.9-13.4 38.7-32 45.3l0 66.7 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-248 0c-44.2 0-80-35.8-80-80l0-248zM528 48L280 48c-22.1 0-40 17.9-40 40l0 174.7c9.8-4.3 20.6-6.7 32-6.7l248 0 8 0 0-96 0-112zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 0-64-224 0zM160 96l0 48-72 0c-22.1 0-40 17.9-40 40l0 174.7c9.8-4.3 20.6-6.7 32-6.7l81.1 0c2.5 17.7 9.2 34 18.9 48L80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 0-16 48 0 0 16 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L80 512c-44.2 0-80-35.8-80-80L0 184c0-48.6 39.4-88 88-88l72 0z',
  ],
};
const faSquareH = {
  prefix: 'far',
  iconName: 'square-h',
  icon: [
    448,
    512,
    ['h-square'],
    'f0fd',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm336 56l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faHSquare = faSquareH;
const faSquareC = {
  prefix: 'far',
  iconName: 'square-c',
  icon: [
    448,
    512,
    [],
    'e266',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z',
  ],
};
const faClockTwo = {
  prefix: 'far',
  iconName: 'clock-two',
  icon: [
    512,
    512,
    [],
    'e35a',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faSquareEllipsisVertical = {
  prefix: 'far',
  iconName: 'square-ellipsis-vertical',
  icon: [
    448,
    512,
    [],
    'e26f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCalendarUsers = {
  prefix: 'far',
  iconName: 'calendar-users',
  icon: [
    640,
    512,
    [],
    'e5e2',
    'M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-40 0c-35.3 0-64 28.7-64 64l0 16 0 48 16 0 32 0 16 0 320 0 16 0 32 0 16 0 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L248 64l0-40zm6.7 440c.9 5.2 1.3 10.5 1.3 16c0 11.7-3.1 22.6-8.6 32l145.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-5.5 .5-10.8 1.3-16l-130.7 0zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faPodcast = {
  prefix: 'far',
  iconName: 'podcast',
  icon: [
    448,
    512,
    [],
    'f2ce',
    'M400 224c0 61.1-31.1 115-78.4 146.5c-1.4 17-4.1 36.6-7.1 54.9l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-3-18.4-5.7-38.1-7.1-55.1C79.1 338.9 48 285.1 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zm-32 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c5.1-8.5 11.7-15.2 18.8-20.5C138 272.9 128 249.6 128 224c0-53 43-96 96-96s96 43 96 96c0 25.6-10 48.9-26.4 66.1c7.2 5.2 13.7 11.9 18.8 20.5c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM178.9 487.7c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2zM225.5 464c-.5 0-1 0-1.5 0s-1.1 0-1.5 0c-3.1-13.3-6.7-31.9-9.9-51.4c-3.9-23.7-6.5-45.4-7-59c.6-.1 1.4-.3 2.2-.4c4.3-.8 9.7-1.2 16.3-1.2s12 .4 16.3 1.2c.8 .1 1.5 .3 2.2 .4c-.5 13.5-3.1 35.1-7 58.8c-3.2 19.5-6.9 38.1-10 51.5z',
  ],
};
const faBee = {
  prefix: 'far',
  iconName: 'bee',
  icon: [
    576,
    512,
    [],
    'e0b2',
    'M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-11.2 1-22.2 3.1-32.8C74.5 266.1 48 237.2 48 208c0-32.2 32.3-64 80-64c37.3 0 65.2 19.5 75.6 43.3C167.5 213.5 144 256 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-48-23.5-90.5-59.6-116.7C382.8 163.5 410.7 144 448 144c47.7 0 80 31.8 80 64c0 29.2-26.5 58.1-67.1 63.2c2 10.6 3.1 21.6 3.1 32.8c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zm17.6 393.9c-3.8-4.9-7.5-9.8-10.9-14.6L350 384c-3.4 4.8-7 9.7-10.9 14.6c-17.6 22.5-36.7 42.2-51.1 56c-14.4-13.8-33.5-33.5-51.1-56zm140-62.6l-177.9 0c-4.6-11.7-7.1-22.5-7.1-32l192 0c0 9.5-2.5 20.3-7.1 32zm-5.8-80l-166.3 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48z',
  ],
};
const faTemperatureFull = {
  prefix: 'far',
  iconName: 'temperature-full',
  icon: [
    320,
    512,
    ['temperature-4', 'thermometer-4', 'thermometer-full'],
    'f2c7',
    'M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3z',
  ],
};
const faTemperature4 = faTemperatureFull;
const faThermometer4 = faTemperatureFull;
const faThermometerFull = faTemperatureFull;
const faBell = {
  prefix: 'far',
  iconName: 'bell',
  icon: [
    448,
    512,
    [128276, 61602],
    'f0f3',
    'M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z',
  ],
};
const faCandyBar = {
  prefix: 'far',
  iconName: 'candy-bar',
  icon: [
    640,
    512,
    [127851, 'chocolate-bar'],
    'e3e8',
    'M0 320l0-96 128 0 0 96L0 320zm0 64l0-32 128 0 0 96-64 0c-35.3 0-64-28.7-64-64zm288 64l-128 0 0-96 128 0 0-32-128 0 0-96 128 0 0-32-128 0 0-128 128 0 48 0 240 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-240 0-48 0zM36.7 177C43.9 165 48 151 48 136c0-4-.3-7.9-.9-11.7c-1-7 6.2-14.2 13.1-13.1c3.8 .6 7.7 .9 11.7 .9c15 0 29-4.1 41-11.3c6.1-3.6 15 .4 15 7.4l0 51.8s0 0 0 0l0 32-8 0s0 0 0 0l-75.8 0c-7.1 0-11.1-9-7.4-15zM336 112l0 288 240 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-240 0z',
  ],
};
const faChocolateBar = faCandyBar;
const faXmarkLarge = {
  prefix: 'far',
  iconName: 'xmark-large',
  icon: [
    448,
    512,
    [],
    'e59b',
    'M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z',
  ],
};
const faPinata = {
  prefix: 'far',
  iconName: 'pinata',
  icon: [
    512,
    512,
    [],
    'e3c3',
    'M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L84.4 48C37.8 48 0 85.8 0 132.4c0 36.3 23.3 68.6 57.7 80.1L96 225.3 96 440c0 39.8 32.2 72 72 72l22.4 0c36.2 0 65.6-29.4 65.6-65.6c0-21.2 17.2-38.4 38.4-38.4l19.2 0c21.2 0 38.4 17.2 38.4 38.4c0 36.2 29.4 65.6 65.6 65.6l22.4 0c39.8 0 72-32.2 72-72l0-112c0-57.4-46.6-104-104-104l-136 0 0-200zM84.4 96L224 96l0 125.2-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 224.4l0-4.8c0-17.2-11-32.5-27.4-37.9L72.9 167C58 162 48 148.1 48 132.4C48 112.3 64.3 96 84.4 96zM212.6 260.2l17.5-7c7.1 11.3 19.6 18.8 33.9 18.8l144 0c20.2 0 37.8 10.7 47.7 26.7c-6.7-1.8-13.8-1.4-20.3 1.2l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-3.4 1.4 0-42.3 23.3-9.3 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1zM144 335.6l15.3-6.1 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 16.7 8.4 0 54.5-11.4-4.6c-8.5-3.4-18-3-26.2 1.1l-19.1 9.6-32.3-12.9c-15.7-15.8-37.3-25.5-61.3-25.5l-19.2 0c-24 0-45.7 9.8-61.3 25.5l-32.3 12.9-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 392.4l0-56.7zm0 91.2l23.3-9.3 19.1 9.6c7.3 3.6 15.6 4.3 23.3 2.1c-1.1 5.6-1.7 11.3-1.7 17.2c0 9.7-7.9 17.6-17.6 17.6L168 464c-13.3 0-24-10.7-24-24l0-13.2zm296.7-9.3l23.3 9.3 0 13.2c0 13.3-10.7 24-24 24l-22.4 0c-9.7 0-17.6-7.9-17.6-17.6c0-5.9-.6-11.6-1.7-17.2c7.7 2.3 16 1.5 23.3-2.1l19.1-9.6zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faFilePpt = {
  prefix: 'far',
  iconName: 'file-ppt',
  icon: [
    512,
    512,
    [],
    'e64a',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-64c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-16 0c-8.8 0-16-7.2-16-16z',
  ],
};
const faArrowsFromLine = {
  prefix: 'far',
  iconName: 'arrows-from-line',
  icon: [
    448,
    512,
    [],
    'e0a4',
    'M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-86.1zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z',
  ],
};
const faSuperscript = {
  prefix: 'far',
  iconName: 'superscript',
  icon: [
    512,
    512,
    [],
    'f12b',
    'M472 24c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8L424 176l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-152zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l27.2 0 96 144-96 144L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-27.2 0-96-144 96-144 27.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64L24 64z',
  ],
};
const faBowlSpoon = {
  prefix: 'far',
  iconName: 'bowl-spoon',
  icon: [
    512,
    512,
    [129379],
    'e3e0',
    'M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48s64 28.2 64 48s-21.4 48-64 48zm0 48c52.2 0 96-30.6 108.5-72L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L220.5 72C208 30.6 164.2 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm64.5 266.9c-4.5-11.7-13.5-21.2-25-26.4C90.4 404.8 48 343.3 48 272l416 0c0 71.3-42.4 132.8-103.5 160.5c-11.5 5.2-20.4 14.7-25 26.4c-1.2 3.1-4.2 5.1-7.5 5.1l-144 0c-3.3 0-6.3-2-7.5-5.1zM48 224c-26.5 0-48 21.5-48 48c0 90.8 54.1 169 131.7 204.2c8.1 21 28.4 35.8 52.3 35.8l144 0c23.8 0 44.2-14.9 52.3-35.8C457.9 441 512 362.8 512 272c0-26.5-21.5-48-48-48L48 224z',
  ],
};
const faHexagonCheck = {
  prefix: 'far',
  iconName: 'hexagon-check',
  icon: [
    512,
    512,
    [],
    'e416',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faPlugCircleXmark = {
  prefix: 'far',
  iconName: 'plug-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e560',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faStarOfLife = {
  prefix: 'far',
  iconName: 'star-of-life',
  icon: [
    512,
    512,
    [],
    'f621',
    'M184 64c0-35.3 28.7-64 64-64l16 0c35.3 0 64 28.7 64 64l0 67.3 58.3-33.6c30.6-17.7 69.8-7.2 87.4 23.4l8 13.9c17.7 30.6 7.2 69.8-23.4 87.4L400 256l58.3 33.6c30.6 17.7 41.1 56.8 23.4 87.4l-8 13.9c-17.7 30.6-56.8 41.1-87.4 23.4L328 380.7l0 67.3c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-67.3-58.3 33.6C95.1 432 56 421.5 38.3 390.9l-8-13.9c-17.7-30.6-7.2-69.8 23.4-87.4L112 256 53.7 222.4c-30.6-17.7-41.1-56.8-23.4-87.4l8-13.9C56 90.5 95.1 80 125.7 97.6L184 131.3 184 64zm64-16c-8.8 0-16 7.2-16 16l0 108.9c0 8.6-4.6 16.5-12 20.8s-16.6 4.3-24 0l-94.3-54.4c-7.7-4.4-17.4-1.8-21.9 5.9l-8 13.9c-4.4 7.7-1.8 17.4 5.9 21.9L172 235.2c7.4 4.3 12 12.2 12 20.8s-4.6 16.5-12 20.8L77.7 331.2c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9L196 318.4c7.4-4.3 16.6-4.3 24 0s12 12.2 12 20.8L232 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-108.9c0-8.6 4.6-16.5 12-20.8s16.6-4.3 24 0l94.3 54.4c7.7 4.4 17.4 1.8 21.9-5.9l8-13.9c4.4-7.7 1.8-17.4-5.9-21.9L340 276.8c-7.4-4.3-12-12.2-12-20.8s4.6-16.5 12-20.8l94.3-54.4c7.7-4.4 10.3-14.2 5.9-21.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9L316 193.6c-7.4 4.3-16.6 4.3-24 0s-12-12.2-12-20.8L280 64c0-8.8-7.2-16-16-16l-16 0z',
  ],
};
const faPhoneSlash = {
  prefix: 'far',
  iconName: 'phone-slash',
  icon: [
    640,
    512,
    [],
    'f3dd',
    'M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c8.6 14.9 18.5 29 29.4 42.1L601.2 5.1zM240.4 287.9C228.1 273 217 257 207.2 240.2c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112 70.5c1.5 93.7 35.2 179.6 90.5 247.1l37.8-29.6zm-6 127.7L273.2 385c65 48.5 145.3 77.6 232.3 79l21.3-99.2-100.4-43L397 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-8-4.6-15.7-9.5-23.3-14.7l39.8-31.3c2.5 1.5 5 3.1 7.6 4.5L384 297.7l31.4-24.7c7.9-1.7 16.4-1.1 24.3 2.3l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2c-86.2-9.2-165.2-42.8-229.7-93.9z',
  ],
};
const faTrafficLightStop = {
  prefix: 'far',
  iconName: 'traffic-light-stop',
  icon: [
    320,
    512,
    [],
    'f63a',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
  ],
};
const faPaintRoller = {
  prefix: 'far',
  iconName: 'paint-roller',
  icon: [
    512,
    512,
    [],
    'f5aa',
    'M352 48L64 48c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM64 0L352 0c35.3 0 64 28.7 64 64l0 8 0 48 0 8c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zm96 352c0-17.7 14.3-32 32-32l8 0 0-16c0-39.8 32.2-72 72-72l152 0c22.1 0 40-17.9 40-40l0-48c0-10.4-6.7-19.3-16-22.6l0-48.9c36 4 64 34.5 64 71.6l0 48c0 48.6-39.4 88-88 88l-152 0c-13.3 0-24 10.7-24 24l0 16 8 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z',
  ],
};
const faAccentGrave = {
  prefix: 'far',
  iconName: 'accent-grave',
  icon: [
    192,
    512,
    [],
    '60',
    'M80 65.3C80 55.8 87.8 48 97.3 48c8.4 0 15.6 6 17 14.3l18.2 102.1L82.9 79.9C81 76.6 80 72.9 80 69.2l0-3.9zm-48 0l0 3.9c0 12.3 3.3 24.4 9.5 35.1l57.3 97.4c8.1 13.8 23 22.3 39 22.3c28.2 0 49.5-25.5 44.6-53.3L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z',
  ],
};
const faHandshakeAngle = {
  prefix: 'far',
  iconName: 'handshake-angle',
  icon: [
    640,
    512,
    ['hands-helping'],
    'f4c4',
    'M264 320c39.8 0 72-32.2 72-72l0-8 104 0c13.3 0 24 10.7 24 24c0 11.7-8.4 21.5-19.4 23.6c-7.7 1.5-14.2 6.6-17.4 13.8s-2.7 15.5 1.4 22.2c2.2 3.6 3.4 7.8 3.4 12.4c0 13.3-10.7 24-24 24s-24 10.7-24 24c0 8.8-7.2 16-16 16l-16 0-32 0-66.7 0c-14.9 0-29.1 5.9-39.6 16.4L159 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l54.6-54.6c1.5-1.5 3.5-2.3 5.7-2.3l66.7 0 32 0 16 0c28 0 51.8-17.9 60.5-42.9c29.8-8.8 51.5-36.4 51.5-69.1c0-3.9-.3-7.8-.9-11.5C498.9 311.7 512 289.4 512 264c0-39.8-32.2-72-72-72l-104 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-22.1 17.9-40 40-40l138.7 0c14.9 0 29.1-5.9 39.6-16.4L513 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L424.4 61.7c-1.5 1.5-3.5 2.3-5.7 2.3L280 64c-48.6 0-88 39.4-88 88l0 96c0 39.8 32.2 72 72 72zM160 132.5c-19 7.5-33.9 23.6-39.4 44.2L99 257.5c-.4 1.4-1.1 2.6-2.1 3.6L7 351c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L130.9 295c7-7 12-15.6 14.5-25.2L160 215.1l0-82.6zM543.2 250.8L633 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-75.3 75.3c10.3 13.9 17.1 30.5 19.4 48.5z',
  ],
};
const faHandsHelping = faHandshakeAngle;
const faCircle0 = {
  prefix: 'far',
  iconName: 'circle-0',
  icon: [
    512,
    512,
    [],
    'e0ed',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96l0 64c0 53 43 96 96 96s96-43 96-96l0-64c0-53-43-96-96-96zm-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64z',
  ],
};
const faDialMedLow = {
  prefix: 'far',
  iconName: 'dial-med-low',
  icon: [
    576,
    512,
    [],
    'e160',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 367.2c-37.9-37.9-43-96.2-15.1-139.6L271 305c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1c43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faLocationDot = {
  prefix: 'far',
  iconName: 'location-dot',
  icon: [
    384,
    512,
    ['map-marker-alt'],
    'f3c5',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
};
const faMapMarkerAlt = faLocationDot;
const faCrab = {
  prefix: 'far',
  iconName: 'crab',
  icon: [
    512,
    512,
    [129408],
    'e3ff',
    'M.2 120s0 0 0 0s0 0 0 0C4.4 53 60 0 128 0l44.7 0c7.1 0 10.7 8.6 5.7 13.7L141.7 50.3c-5 5-1.5 13.7 5.7 13.7L184 64c4.4 0 8.1 3.6 7.5 8c-3.9 31.6-30.9 56-63.5 56l-80 0 0 33.3c0 9.4 5.4 17.9 13.9 21.8L133.3 216c16.9-12.2 37-20.3 58.7-23l0-41c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 41c21.7 2.7 41.7 10.9 58.7 23l71.4-32.9c8.5-3.9 13.9-12.4 13.9-21.8l0-33.3-80 0c-32.6 0-59.6-24.4-63.5-56c-.5-4.4 3.1-8 7.5-8l36.7 0c7.1 0 10.7-8.6 5.7-13.7L333.7 13.7c-5-5-1.5-13.7 5.7-13.7L384 0c68 0 123.6 53 127.8 120c0 0 0 0 0 0s0 0 0 0c0 .1 0 .3 0 .4l.2 7.6-7.9 0c0 0-.1 0-.1 0l8 0 0 33.3c0 28.1-16.3 53.6-41.8 65.4L413.1 253c2.2 3.6 4.2 7.2 6 11l31.2 0 26.9-13.5c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-32 16c-3.3 1.7-7 2.5-10.7 2.5l-24.2 0c.2 2.6 .2 5.3 .2 8l0 1.4 23.6 7.9c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-30-10L387 381l36.6 12.2c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-54-18-2.2 2.2L371.7 435c7.6 4.2 12.3 12.3 12.3 21l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.9L297.9 449c-.6-.3-1.1-.6-1.6-1l-80.7 0c-.5 .3-1.1 .7-1.6 1L176 470.1l0 17.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-8.7 4.7-16.7 12.3-21l24.9-13.8L163 419l-54 18L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L125 381 107 363 77 373 49 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L80 321.4l0-1.4c0-2.7 .1-5.4 .2-8L56 312c-3.7 0-7.4-.9-10.7-2.5l-32-16C1.4 287.5-3.4 273.1 2.5 261.3s20.3-16.7 32.2-10.7L61.7 264l31.2 0c1.8-3.8 3.9-7.4 6-11L41.8 226.7C16.3 214.9 0 189.4 0 161.3L0 128l8 0c0 0-.1 0-.1 0L0 128l.2-7.6c0-.1 0-.3 0-.4zM296 240l-80 0-8 0c-42.9 0-77.9 33.8-79.9 76.2L211.9 400l88.2 0 83.8-83.8c-2-42.4-37-76.2-79.9-76.2l-8 0z',
  ],
};
const faBoxOpenFull = {
  prefix: 'far',
  iconName: 'box-open-full',
  icon: [
    640,
    512,
    ['box-full'],
    'f49c',
    'M480.9 3.1C456-6.2 428.4 6.3 419.1 31.2L384 124.8C382.2 55.6 325.6 0 256 0C185.3 0 128 57.3 128 128c0 2.2 .1 4.3 .2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7c0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6l7.2 .9 161.4-20.2 27.5-73.4c9.3-24.8-3.3-52.5-28.1-61.8zM58.9 170.1L17.2 253.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 192 75.2 161.4c-6.7-.8-13.3 2.7-16.3 8.7zM576 339.6l-48 13.7 0 57.2-184 46L344 312c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144.5-184-46 0-57.2L64 339.6l0 71c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-71zm46.8-86.1l-41.7-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z',
  ],
};
const faBoxFull = faBoxOpenFull;
const faFile = {
  prefix: 'far',
  iconName: 'file',
  icon: [
    384,
    512,
    [128196, 128459, 61462],
    'f15b',
    'M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z',
  ],
};
const faGreaterThan = {
  prefix: 'far',
  iconName: 'greater-than',
  icon: [
    384,
    512,
    [62769],
    '3e',
    'M2.5 77.3c-5.9 11.9-1.1 26.3 10.7 32.2L306.3 256 13.3 402.5C1.4 408.5-3.4 422.9 2.5 434.7s20.3 16.7 32.2 10.7l336-168c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-336-168C22.9 60.6 8.5 65.4 2.5 77.3z',
  ],
};
const faQuotes = {
  prefix: 'far',
  iconName: 'quotes',
  icon: [
    576,
    512,
    [],
    'e234',
    'M0 96C0 43 43 0 96 0l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0C69.5 48 48 69.5 48 96l48 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-24 0-24L0 96zm48 72l0 24 48 0 0-48-48 0 0 24zM176 96c0-53 43-96 96-96l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0c-26.5 0-48 21.5-48 48l48 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-24 0-24 0-48zm48 48l0 24 0 24 48 0 0-48-48 0zM576 416c0 53-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48l-48 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 48zm-48-48l0-24 0-24-48 0 0 48 48 0zM400 416c0 53-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48l-48 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 48zm-48-72l0-24-48 0 0 48 48 0 0-24z',
  ],
};
const faPretzel = {
  prefix: 'far',
  iconName: 'pretzel',
  icon: [
    512,
    512,
    [129384],
    'e441',
    'M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2l3.8 0c42 0 76 34 76 76l0 5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9-.1 .2-46.2 65.2-.1 .2-25.8 36.4c-5.1 7.2-3.4 17.2 3.8 22.3s17.2 3.4 22.3-3.8L163.7 382c6.2-8.7 17.3-12.3 27.4-8.8c20.3 7 42.2 10.8 65 10.8c11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9 .3-7.9 .4-11.9 .4c-9.2 0-18.3-.7-27.2-2.2c-8.2-1.3-15.1-6.8-18.3-14.4s-2.2-16.4 2.6-23.1l23.3-32.9c4.5-6.4 11.8-10.1 19.6-10.1s15.1 3.8 19.6 10.1l11.5 16.3 11.8 16.6 .1 .1 49.3 69.5c0 0 .1 .1 .1 .1l30.6 43.2c5.1 7.2 15.1 8.9 22.3 3.8s8.9-15.1 3.8-22.3l-25.8-36.4c-7.3-10.2-5.4-24.3 4.3-32.4c44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80L348 80c-29.3 0-55.8 11.6-75.3 30.6c-9.3 9.1-24.1 9.1-33.5 0C219.8 91.6 193.3 80 164 80l-3.8 0C102.7 80 56 126.7 56 184.2zM81.2 360C36.1 315.1 8 253 8 184.2C8 100.1 76.1 32 160.2 32l3.8 0c34.4 0 66.2 11.2 92 30c25.8-18.9 57.6-30 92-30l3.8 0C435.8 32 504 100.1 504 184.2c0 68.7-28.1 130.9-73.2 175.8l13.5 19c20.4 28.8 13.6 68.8-15.2 89.2s-68.8 13.6-89.2-15.2c0 0 0 0 0 0s0 0 0 0l-20.6-29.1C299 429.2 277.8 432 256 432s-43-2.8-63.2-8.1L172.2 453c-20.4 28.8-60.4 35.7-89.2 15.2l13.3-18.8L83 468.2C54.2 447.8 47.3 407.8 67.8 379c0 0 0 0 0 0l13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1l0-5.1c0-15.5-12.5-28-28-28l-3.8 0c-13.4 0-24.2 10.8-24.2 24.2zM320 188l0 5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3c0-13.4-10.8-24.2-24.2-24.2l-3.8 0c-15.5 0-28 12.5-28 28zm28-76l3.8 0c39.9 0 72.2 32.3 72.2 72.2c0 49.4-21.5 93.9-55.5 124.6c-5.1 4.6-11.9 6.8-18.7 6s-13-4.4-16.9-10L286.9 240c-9.7-13.7-14.9-30.1-14.9-46.9l0-5.1c0-42 34-76 76-76z',
  ],
};
const faTRex = {
  prefix: 'far',
  iconName: 't-rex',
  icon: [
    640,
    512,
    [],
    'e629',
    'M423.8 48C393.1 48 368 73.1 368 104c0 5.6-2 11.1-5.6 15.4l-40 48c-4.6 5.5-11.3 8.6-18.4 8.6l-41.9 0c-53.6 0-97.9 41.8-101 95.3c-1.3 22.9-20.3 40.7-43.2 40.7l-4.3 0c-21 0-39.5-13.7-45.7-33.7L57.6 244.7l-1 2.5c-5.7 14.2-8.6 29.3-8.6 44.6l0 4.3c0 57.4 46.6 104 104 104l40 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.1L297.9 464l86.1 0 0-16c0-8.8-7.2-16-16-16l-24 0c-8 0-15.5-4-20-10.7l-16-24c-5.8-8.7-5.3-20.1 1.2-28.3l18-22.5c5.7-7.1 8.8-15.9 8.8-25l0-1.6c0-26.5-21.5-48-48-48c-13.3 0-24-10.7-24-24s10.7-24 24-24c53 0 96 43 96 96l0 1.6c0 20-6.8 39.4-19.3 55l-6 7.5 9.3 0c35.3 0 64 28.7 64 64l0 40c0 13.3-10.7 24-24 24l-120 0c-6.4 0-12.5-2.5-17-7l-57-57L152 448C68.1 448 0 379.9 0 296l0-4.3c0-21.4 4.1-42.5 12-62.4l20.3-50.7C36.8 167.4 47.7 160 59.8 160c13 0 24.5 8.5 28.3 20.9l25.3 82.3C120.6 186.9 184.8 128 262.1 128l30.7 0 27.6-33.2C325 41.8 369.5 0 423.8 0c8.5 0 16.9 1 25 3.1C456.3 1.1 464.1 0 472 0c26.7 0 51.7 12 68.3 32.1C595.7 34.3 640 80 640 136l0 24c0 30.9-21.9 56.7-51 62.7l-5.8 7.7L564 216l19.2 14.4C571.1 246.5 552.1 256 532 256l-72 0-15.3 20.5 46.8 26c12.7 7.1 20.6 20.4 20.6 35l0 22.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.9-48.1-26.7c-.7-21.5-6.4-41.6-15.9-59.4l28.8-38.4c4.5-6 11.6-9.6 19.2-9.6l84 0c.8 0 1.5-.1 2.3-.2c-9.3-.8-18-4.9-24.6-11.5l-17.9-17.9c-1.5-1.5-3.5-2.3-5.7-2.3L464 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l22.1 0c10.6 0 20.8 4.2 28.3 11.7l17.9 17.9c1.5 1.5 3.5 2.3 5.7 2.3l38.1 0c8.8 0 16-7.2 16-16l0-24c0-30.9-25.1-56-56-56l-8.2 0c-8.5 0-16.4-4.5-20.7-11.9C499.9 55.7 486.5 48 472 48c-5 0-9.8 .9-14.3 2.6c-5.2 1.9-10.9 2-16.1 .3C435.9 49 429.9 48 423.8 48zM456 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faPersonSwimming = {
  prefix: 'far',
  iconName: 'person-swimming',
  icon: [
    576,
    512,
    [127946, 'swimmer'],
    'f5c4',
    'M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM80 334.1C62.8 349 41 360.8 18.8 365.8C5.9 368.7-2.3 381.5 .6 394.5s15.7 21.1 28.7 18.2C58 406.2 81.6 392.2 96 382.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM256.5 193.9L403 318.1c13.8-3.2 27.9-9.6 40.2-18c2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-119.3 0-216 96.7-216 216l0 2.2c10.8 4 21.9 6.2 32 6.2c5.4 0 10.7-.5 16-1.6l0-6.9c0-46.1 18.5-87.8 48.5-118.1z',
  ],
};
const faSwimmer = faPersonSwimming;
const faArrowDown = {
  prefix: 'far',
  iconName: 'arrow-down',
  icon: [
    384,
    512,
    [8595],
    'f063',
    'M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z',
  ],
};
const faUserRobotXmarks = {
  prefix: 'far',
  iconName: 'user-robot-xmarks',
  icon: [
    448,
    512,
    [],
    'e4a7',
    'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zm96 128l0 96c0 17.7-14.3 32-32 32l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32zm64 304l0 16-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-16c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM224 512l64 0 112 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l112 0 64 0zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM168 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0s-5.1 13.4 0 18.6L149.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L168 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L186.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L168 157.4zm78.7-14.7c-5.1 5.1-5.1 13.4 0 18.6L261.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L280 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L298.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L280 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0z',
  ],
};
const faMessageQuote = {
  prefix: 'far',
  iconName: 'message-quote',
  icon: [
    512,
    512,
    ['comment-alt-quote'],
    'e1e4',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM160 112c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0zm224 80l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3z',
  ],
};
const faCommentAltQuote = faMessageQuote;
const faCandyCorn = {
  prefix: 'far',
  iconName: 'candy-corn',
  icon: [
    640,
    512,
    [],
    'f6bd',
    'M612.6 18.1C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56c0 20.1 7 52 15.6 84c9.1 33.8 21.4 73 34.7 110.4c13.2 37.2 27.9 73.6 41.6 101.3c13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c13.8-27.7 28.4-64.1 41.6-101.3C603 213 615.3 173.8 624.4 140C633 108 640 76.1 640 56c0-17.2-11-32.5-27.4-37.9zM480 280c14.2 0 32.1 2.4 45.4 4.6c-6.9 17-13.8 32.6-20.3 45.7c-7 14-12.8 24.8-19.3 32.3c-2.9 3.4-4.9 4.8-5.7 5.2l-.1 .1-.1-.1c-.8-.5-2.8-1.8-5.7-5.2c-6.5-7.5-12.3-18.3-19.3-32.3c-6.5-13.1-13.4-28.7-20.3-45.7c13.3-2.2 31.2-4.6 45.4-4.6zM583.2 107.4C556.2 102.6 512.4 96 480 96s-76.2 6.6-103.2 11.4c-4.7-19.2-7.7-35-8.5-45.5C402.6 51.7 441 48 480 48c39.2 0 77.7 3.6 111.7 13.8c-.9 10.6-3.9 26.4-8.5 45.6zM191.7 122.3c-39.6 20.1-75.4 49.9-106.6 81C54 234.5 24.5 270.1 4.3 309.5c-7.7 15.4-4.9 34.4 7.3 46.6c14.2 14.2 41.8 31.8 70.4 48.3c30.3 17.5 66.8 36.5 102.6 53.6c35.7 16.9 71.8 32.4 101 42.2c28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-9.8-29.3-25.2-65.4-42.2-101c-17-35.9-36.1-72.3-53.6-102.6c-16.5-28.7-34.2-56.2-48.3-70.4c-12.2-12.2-30.8-15.2-46.2-7.5zm91.4 279c10-10 24.4-21 35.4-28.8c7.2 16.9 13.3 32.8 18 46.7c5 14.8 8.5 26.6 9.2 36.5c.3 4.5-.1 6.9-.3 7.8l0 .1-.1 0c-.9 .3-3.3 .7-7.8 .3c-9.9-.7-21.7-4.3-36.5-9.2c-13.9-4.7-29.7-10.8-46.7-18c7.8-10.9 18.8-25.3 28.8-35.4zM234 206.3c-22.5 15.8-58.1 42-81 64.9s-49.2 58.5-64.9 81c-16.9-10.3-30.1-19.3-38.2-26.2c17.1-31.4 41.6-61.2 69.2-88.8c27.7-27.7 57.5-52.4 88.8-69.2c6.8 8.1 15.9 21.4 26.2 38.3z',
  ],
};
const faFolderMagnifyingGlass = {
  prefix: 'far',
  iconName: 'folder-magnifying-glass',
  icon: [
    512,
    512,
    ['folder-search'],
    'e18b',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faFolderSearch = faFolderMagnifyingGlass;
const faNotebook = {
  prefix: 'far',
  iconName: 'notebook',
  icon: [
    512,
    512,
    [],
    'e201',
    'M240 48l176 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-176 0 0-416zm-48 0l0 416-64 0c-8.8 0-16-7.2-16-16l0-32 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-88 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-88 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-32c0-8.8 7.2-16 16-16l64 0zM64 416l0 32c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 32L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 88-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 88-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0z',
  ],
};
const faCircleWifi = {
  prefix: 'far',
  iconName: 'circle-wifi',
  icon: [
    512,
    512,
    [],
    'e67d',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.5-14.7c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c9.8 8.9 10.6 24 1.8 33.9s-24 10.6-33.9 1.8c-34-30.7-79-49.3-128.5-49.3s-94.4 18.6-128.5 49.3zM256 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-48c-22.7 0-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240s67.1 13.3 91.2 35.1c9.8 8.9 10.6 24.1 1.7 33.9s-24.1 10.6-33.9 1.7c-15.6-14.1-36.3-22.7-59-22.7z',
  ],
};
const faDroplet = {
  prefix: 'far',
  iconName: 'droplet',
  icon: [
    384,
    512,
    [128167, 'tint'],
    'f043',
    'M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z',
  ],
};
const faTint = faDroplet;
const faBullseyePointer = {
  prefix: 'far',
  iconName: 'bullseye-pointer',
  icon: [
    512,
    512,
    [],
    'f649',
    'M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 5.5 .2 10.9 .6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4 .4 10.8 .6 16.3 .6zm-2.4-48l14.3-48.6C324.2 361.4 368 313.8 368 256c0-61.9-50.1-112-112-112c-57.8 0-105.4 43.8-111.4 100.1L96 258.4c0-.8 0-1.6 0-2.4c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-.8 0-1.6 0-2.4 0zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z',
  ],
};
const faEraser = {
  prefix: 'far',
  iconName: 'eraser',
  icon: [
    576,
    512,
    [],
    'f12d',
    'M97 319c-9.4 9.4-9.4 24.6 0 33.9l72 72c4.5 4.5 10.6 7 17 7l108.1 0c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63c28.1-28.1 73.7-28.1 101.8 0L513 189.1c28.1 28.1 28.1 73.7 0 101.8L371.9 432 520 432c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0s0 0 0 0c-.6 0-1.3 0-1.9 0l-108.1 0c-19.1 0-37.4-7.6-50.9-21.1l-72-72c-28.1-28.1-28.1-73.7 0-101.8L285.1 63z',
  ],
};
const faHexagonImage = {
  prefix: 'far',
  iconName: 'hexagon-image',
  icon: [
    512,
    512,
    [],
    'e504',
    'M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-34.5 59.8-78.1-94c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8l-56.9 62.3L58.6 268zM232 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z',
  ],
};
const faEarthAmericas = {
  prefix: 'far',
  iconName: 'earth-americas',
  icon: [
    512,
    512,
    [127758, 'earth', 'earth-america', 'globe-americas'],
    'f57d',
    'M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
  ],
};
const faEarth = faEarthAmericas;
const faEarthAmerica = faEarthAmericas;
const faGlobeAmericas = faEarthAmericas;
const faFileSvg = {
  prefix: 'far',
  iconName: 'file-svg',
  icon: [
    512,
    512,
    [],
    'e64b',
    'M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM205.7 352l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L176 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm-152 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z',
  ],
};
const faCrateApple = {
  prefix: 'far',
  iconName: 'crate-apple',
  icon: [
    512,
    512,
    ['apple-crate'],
    'f6b1',
    'M160 54.9c0 5 4.1 9.1 9.1 9.1C199.4 64 224 39.4 224 9.1c0-5-4.1-9.1-9.1-9.1C184.6 0 160 24.6 160 54.9zM80 171.4c0-15.3 3.8-29 8.7-37.2c2.3-3.8 4.1-5.3 4.9-5.7c0 0 0 0 0 0c.4-.2 .8-.5 2.4-.5c2.2 0 6.5 .5 12.6 2.1c5.8 1.5 11.9 3.6 17.2 5.7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5c0 0 0 0 0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6l48.5 0c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6l48.5 0c-1.1-6.5-1.7-13.3-1.7-20.6zM430.3 192l48.5 0c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c7.8 12.9 13.2 27.5 16.4 42.3l1.7 .7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5c0 0 0 0 0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6zM406.9 0C376.6 0 352 24.6 352 54.9c0 5 4.1 9.1 9.1 9.1C391.4 64 416 39.4 416 9.1c0-5-4.1-9.1-9.1-9.1zM456 272c4.4 0 8 3.6 8 8l0 64L48 344l0-64c0-4.4 3.6-8 8-8l400 0zM48 456l0-64 416 0 0 64c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8zm8-232c-30.9 0-56 25.1-56 56L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-176c0-30.9-25.1-56-56-56L56 224zm360 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faAppleCrate = faCrateApple;
const faPersonBurst = {
  prefix: 'far',
  iconName: 'person-burst',
  icon: [
    640,
    512,
    [],
    'e53b',
    'M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L496 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM464 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6 416 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 49.9-7.8 23.5-41.6-53.7-37L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z',
  ],
};
const faGameBoard = {
  prefix: 'far',
  iconName: 'game-board',
  icon: [
    448,
    512,
    [],
    'f867',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 96l-80 0 0 80-80 0 0-80L64 96l0 80 80 0 0 80-80 0 0 80 80 0 0 80 80 0 0-80 80 0 0 80 80 0 0-80-80 0 0-80 80 0 0-80-80 0 0-80zM224 256l0 80-80 0 0-80 80 0zm0 0l0-80 80 0 0 80-80 0z',
  ],
};
const faHatChef = {
  prefix: 'far',
  iconName: 'hat-chef',
  icon: [
    512,
    512,
    [],
    'f86b',
    'M180.9 100.3C192.2 69.7 221.6 48 256 48s63.8 21.7 75.1 52.3c3.2 8.7 11.2 14.8 20.5 15.6s18.2-3.8 22.8-11.9c8.3-14.4 23.9-24 41.6-24c26.5 0 48 21.5 48 48c0 10.9-2.9 28.1-8.1 49.2c-5.1 20.6-11.9 43.2-18.8 64.4c-6.9 21.2-13.8 40.6-19 54.8c-1 2.7-1.9 5.3-2.8 7.6l-54.8 0 23.2-133.3c1.5-8.7-4.3-17-13-18.5s-17 4.3-18.5 13L328.1 304 272 304l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144-56.1 0L159.8 165.3c-1.5-8.7-9.8-14.5-18.5-13s-14.5 9.8-13 18.5L151.4 304l-54.8 0c-.9-2.3-1.8-4.9-2.8-7.6c-5.2-14.2-12.1-33.7-19-54.8c-6.9-21.2-13.7-43.8-18.8-64.4C50.9 156.1 48 138.9 48 128c0-26.5 21.5-48 48-48c17.7 0 33.3 9.6 41.6 24c4.7 8.1 13.6 12.7 22.8 11.9s17.3-6.9 20.5-15.6zM454.4 336.7L432 328l22.4 8.7s0 0 0 0s0 0 0 0l0-.1 .1-.3 .5-1.3c.4-1.1 1-2.7 1.8-4.8c1.6-4.1 3.8-10.1 6.4-17.3c5.3-14.6 12.4-34.6 19.5-56.4c7.1-21.8 14.3-45.7 19.7-67.8c5.3-21.7 9.4-43.5 9.4-60.6c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0s-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 17.1 4.1 38.9 9.4 60.6c5.4 22.2 12.6 46 19.7 67.8c7.1 21.8 14.2 41.9 19.5 56.4c2.7 7.3 4.9 13.2 6.4 17.3c.8 2.1 1.4 3.7 1.8 4.8l.5 1.3 .1 .3 0 .1s0 0 0 0s0 0 0 0L80 328l-22.4 8.7C61.2 345.9 70.1 352 80 352l352 0c9.9 0 18.8-6.1 22.4-15.3zM64 384l0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64-48 0 0 64c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-64-48 0z',
  ],
};
const faHandBackPointRight = {
  prefix: 'far',
  iconName: 'hand-back-point-right',
  icon: [
    512,
    512,
    [],
    'e1a1',
    'M512 176c0-35.3-28.7-64-64-64l-188.8 0c-3.6-5.2-7.6-10.2-11.9-14.9L228.8 76.8C212.1 58.5 188.5 48 163.7 48l-10.2 0C99.5 48 49.5 76.7 22.2 123.4L20.7 126C7.1 149.3 0 175.7 0 202.6L0 328c0 66.3 53.7 120 120 120l8 0 96 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-2.7-.2-5.4-.5-8l96.5 0c35.3 0 64-28.7 64-64zm-64-16c8.8 0 16 7.2 16 16s-7.2 16-16 16l-136 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16l-8 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1c2 2.7 3.2 6 3.2 9.6c0 8.8-7.2 16-16 16l-96 0-8 0c-39.8 0-72-32.2-72-72l0-125.4c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6l10.2 0c11.3 0 22 4.8 29.6 13.1L210.5 128 168 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l78 0 2 0 200 0z',
  ],
};
const faDove = {
  prefix: 'far',
  iconName: 'dove',
  icon: [
    512,
    512,
    [128330],
    'f4ba',
    'M256.3 159c1-14.8 4.3-28.9 9.6-42C251.3 91.3 241.7 61.6 240.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8C190.2 22.2 174.9 44.5 161 76.1c13.4 29 36.1 50.6 63.1 66.9c10.5 6.3 21.4 11.6 32.2 16zM400 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM177.1 208c45.8 29 96.4 42.7 132 47c6.8 .8 13.7-1.3 18.8-5.9s8.1-11.1 8.1-18l0-63.2c0-30.9 25.1-56 56-56l61.8 0L436 138.7c-2.6 3.9-4 8.6-4 13.3l0 144c0 57.4-46.6 104-104 104l-58.4 0c-5.4 0-10.7 1.9-15 5.3L181.2 464c-62.2-.9-106.4-30.9-126.8-51.6l99.7-27.2c8.9-2.4 15.6-9.8 17.3-18.9s-2.1-18.3-9.5-23.7C125.4 316.3 80 267.5 80 184c0-31.8 3.9-55.5 8.9-73.1c20.4 43.4 53.2 74.9 88.2 97.1zM91.2 32c-9.9 0-19.4 4.9-25 13.6C52.7 66.3 32 106.2 32 184c0 77.3 31.8 131.1 66.1 166.7L29.5 369.4c-12.8 3.5-23 13.1-27.3 25.6S.1 421.4 8 432c22.2 29.6 84.5 80 176 80c9.1 0 17.9-3.1 25-8.8L278 448l50 0c83.9 0 152-68.1 152-152l0-136.7 25.9-38.9c4-6 6.1-13 6.1-20.1c0-20-16.2-36.3-36.3-36.3L392 64c-57.4 0-104 46.6-104 104l0 34.5c-26.3-6.1-57-17.3-85.2-35.1c-38.3-24.2-70.7-60-82.3-111.9C117.5 42.3 105.7 32 91.2 32z',
  ],
};
const faSnowflakeDroplets = {
  prefix: 'far',
  iconName: 'snowflake-droplets',
  icon: [
    640,
    512,
    [],
    'e5c1',
    'M320 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L469 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L493 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L368 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L493 328.2l28 16.2-22 42.7L469 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L344 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.4-31.5-30.1 17.4-22-42.7 28-16.2-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L272 256l-66.2-38.2-77.8 20.9c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L171 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L296 214.4l0-76.5L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L296 24c0-13.3 10.7-24 24-24zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z',
  ],
};
const faBatteryEmpty = {
  prefix: 'far',
  iconName: 'battery-empty',
  icon: [
    576,
    512,
    ['battery-0'],
    'f244',
    'M80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L80 144zM0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176z',
  ],
};
const faBattery0 = faBatteryEmpty;
const faGrid4 = {
  prefix: 'far',
  iconName: 'grid-4',
  icon: [
    448,
    512,
    [],
    'e198',
    'M32 89.6L32 64l25.6 0 0 25.6L32 89.6zm57.6 16l0-57.6c0-8.8-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM16 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4L0 464c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zM32 209.1l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zM32 448l0-25.6 25.6 0 0 25.6L32 448zM151.5 89.6l0-25.6 25.6 0 0 25.6-25.6 0zm57.6 16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9s0 0 0 0l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM135.5 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zm16-181.3l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zM270.9 64l25.6 0 0 25.6-25.6 0 0-25.6zm48.6 56c5.3-2.6 9-8.1 9-14.4l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6c0 0 0 0 0 0l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6zm0 33.1c-2.1-1-4.5-1.6-7-1.6c0 0 0 0 0 0l-57.6 0s0 0 0 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4zm0 119.5c-2.1-1-4.5-1.6-7-1.6l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4zm-7 117.8l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM270.9 183.5l25.6 0 0 25.6-25.6 0 0-25.6zm0 119.5l25.6 0 0 25.6-25.6 0 0-25.6zm0 119.5l25.6 0 0 25.6-25.6 0 0-25.6zM390.4 89.6l0-25.6L416 64l0 25.6-25.6 0zm57.6 16L448 48c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6c0 0 0 0 0 0l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9s0 0 0 0l-57.6 0s0 0 0 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM374.4 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zm16-181.3l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0z',
  ],
};
const faSocks = {
  prefix: 'far',
  iconName: 'socks',
  icon: [
    512,
    512,
    [129510],
    'f696',
    'M288 48c0-17 5.3-32.8 14.4-45.8C297.9 .8 293 0 288 0L176 0c-26.5 0-48 21.5-48 48l0 186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54C12.8 362.2 0 389.1 0 417.5C0 469.7 42.3 512 94.5 512l6.9 0c22.6 0 44.6-7.6 62.5-21.5l12.9-10.1c-8.4-14.6-13.9-31-15.9-48.5l-26.6 20.8c-9.4 7.3-21 11.3-32.9 11.3l-6.9 0C68.8 464 48 443.2 48 417.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1l0-90.3 112 0 0-48L176 96l0-48 112 0zM368 0c-26.5 0-48 21.5-48 48l0 186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54c-22.1 17.9-34.9 44.9-34.9 73.3c0 52.2 42.3 94.5 94.5 94.5l6.3 0c23.1 0 45.5-7.9 63.4-22.5l111.3-90.1c28.1-22.8 44.5-57.1 44.5-93.3L512 48c0-26.5-21.5-48-48-48L368 0zm0 48l96 0 0 48-96 0 0-48zm0 96l96 0 0 162.2c0 21.7-9.8 42.3-26.7 56L326 452.2c-9.4 7.6-21.1 11.8-33.2 11.8l-6.3 0c-25.7 0-46.5-20.8-46.5-46.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1l0-90.3z',
  ],
};
const faFaceSunglasses = {
  prefix: 'far',
  iconName: 'face-sunglasses',
  icon: [
    512,
    512,
    [],
    'e398',
    'M256 464C141.1 464 48 370.9 48 256c0-16.3 1.9-32.2 5.4-47.4l3.9 23.3C61.2 255 81.2 272 104.7 272l78.7 0c23.5 0 43.5-17 47.3-40.1l6.6-39.9 37.3 0 6.6 39.9c3.9 23.1 23.9 40.1 47.3 40.1l78.7 0c23.5 0 43.5-17 47.3-40.1l3.9-23.3c3.6 15.2 5.4 31.1 5.4 47.4c0 114.9-93.1 208-208 208zM227.1 144c-8.7-9.8-21.4-16-35.8-16l-94.7 0c-1.6 0-3.2 .1-4.8 .2C129.9 79.4 189.3 48 256 48s126.1 31.4 164.1 80.2c-1.6-.2-3.2-.2-4.8-.2l-94.7 0c-14.4 0-27.1 6.2-35.8 16l-57.8 0zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4z',
  ],
};
const faInbox = {
  prefix: 'far',
  iconName: 'inbox',
  icon: [
    512,
    512,
    [],
    'f01c',
    'M48 336l81.2 0 20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1l140.2 0c15.1 0 29-8.6 35.8-22.1L382.8 336l81.2 0 0 80c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-80zm406.5-48l-76.6 0c-15.1 0-29 8.6-35.8 22.1L321.2 352l-130.3 0-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1l-76.6 0 49-195.9C108.2 85 114.6 80 122 80L390 80c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32L122 32C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z',
  ],
};
const faSquare0 = {
  prefix: 'far',
  iconName: 'square-0',
  icon: [
    448,
    512,
    [],
    'e255',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
  ],
};
const faSection = {
  prefix: 'far',
  iconName: 'section',
  icon: [
    256,
    512,
    [],
    'e447',
    'M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6c17.6-7.7 42.8-10.5 73.1-5.6L153.7 30l-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1c12.8 3.5 26-4 29.5-16.8s-4-26-16.8-29.5C200.7 11.1 168.6 4.8 158.1 3C121.8-2.8 86.5-.5 58 12.1C28.6 25.1 6.7 49 .9 83.3c-.1 .4-.1 .8-.2 1.2c-2.2 19.5 .4 37 7.9 52.3c7.4 15.2 18.8 26.6 31.4 35.3c2.4 1.7 4.9 3.3 7.4 4.8C24.2 189.8 6.8 210.7 1.7 239.4c-.1 .4-.1 .9-.2 1.3c-2.3 18.8 .4 35.8 8.1 50.7c7.6 14.6 19.1 25.5 31.6 33.7c22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7c7.1 5.1 11.4 10.2 13.7 15.6c2.3 5.3 3.6 12.8 1.6 24.2c-2.5 14.2-11.6 25.1-28.5 32.2c-17.7 7.4-43.1 9.9-73.3 5.3c-14.9-2.4-40.4-10.8-61-17.7c-4.5-1.5-8.9-2.9-12.7-4.2c-12.6-4.1-26.1 2.8-30.2 15.4s2.8 26.1 15.4 30.2c3 1 6.5 2.1 10.5 3.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c20.3 6.7 51.4 17.1 70.6 20.2l.1 0c36 5.5 70.9 3.3 99.1-8.5c29-12.1 51.4-34.8 57.3-68.1c3.4-19 1.9-36.3-4.8-51.8c-6.7-15.3-17.6-26.8-29.8-35.6c0 0 0 0 0 0c17.7-13.5 30.5-32.7 34.7-58c3.3-19.7 1.8-37.5-4.7-53.4c-6.5-15.8-17.3-27.9-29.6-37.2c-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1c-7.7-5.4-12.7-11-15.7-17c-2.8-5.8-4.6-13.7-3.4-25.1zM163.2 319.3c-8.6-2.8-17-5.2-25-7.6l-.8-.2C108.3 303 84.2 295.9 67.6 285c-7.8-5.1-12.6-10.3-15.4-15.7c-2.6-5-4.3-11.9-3.2-22.1c2.7-13.9 11.7-24.6 28.4-31.6c13-5.4 30.2-8.3 50.5-7.5c26.9 8.4 48.6 15.8 63.1 26.8c7.1 5.4 11.6 10.9 14.1 17.1c2.5 6.1 3.9 14.7 1.8 27.2c-3.3 19.4-17.2 33.8-43.7 40.1z',
  ],
};
const faSquareThisWayUp = {
  prefix: 'far',
  iconName: 'square-this-way-up',
  icon: [
    448,
    512,
    ['box-up'],
    'f49f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM120 352l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM328 192l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-25.5 0c-8 0-14.5-6.5-14.5-14.5c0-3.5 1.3-7 3.7-9.6L286.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5L328 192zM80 177.5c0-3.5 1.3-7 3.7-9.6L126.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5L168 192l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-25.5 0c-8 0-14.5-6.5-14.5-14.5z',
  ],
};
const faBoxUp = faSquareThisWayUp;
const faGaugeHigh = {
  prefix: 'far',
  iconName: 'gauge-high',
  icon: [
    512,
    512,
    [62461, 'tachometer-alt', 'tachometer-alt-fast'],
    'f625',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faTachometerAlt = faGaugeHigh;
const faTachometerAltFast = faGaugeHigh;
const faSquareAmpersand = {
  prefix: 'far',
  iconName: 'square-ampersand',
  icon: [
    448,
    512,
    [],
    'e260',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm184 95.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z',
  ],
};
const faEnvelopeOpenText = {
  prefix: 'far',
  iconName: 'envelope-open-text',
  icon: [
    512,
    512,
    [],
    'f658',
    'M392 48L120 48c-4.4 0-8 3.6-8 8l0 169.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2 400 56c0-4.4-3.6-8-8-8zM160 120c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM48 276.2L48 456c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-179.8L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9L512 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 237.9z',
  ],
};
const faLampDesk = {
  prefix: 'far',
  iconName: 'lamp-desk',
  icon: [
    512,
    512,
    [],
    'e014',
    'M347.3 97.9L309.3 59.9C301.6 52.3 291.3 48 280.6 48C258.2 48 240 66.2 240 88.6c0 10.8 4.3 21.1 11.9 28.7l38.1 38.1c9 9 14.1 21.2 14.1 33.9l0 60.1L441.4 112l-60.1 0c-12.7 0-24.9-5.1-33.9-14.1zm-4.1-72L381.3 64 480 64c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-98.7-13.7-13.7c-.6 .7-1.3 1.4-2 2.1l-93.1 86L204.4 464 360 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l130.5 0L96.9 262.6c-2.5-8.7 .1-18.1 6.8-24.2l104-96c.5-.5 1-.9 1.5-1.3C198.1 126 192 107.6 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z',
  ],
};
const faHospital = {
  prefix: 'far',
  iconName: 'hospital',
  icon: [
    640,
    512,
    [127973, 62589, 'hospital-alt', 'hospital-wide'],
    'f0f8',
    'M232 0c-39.8 0-72 32.2-72 72l0 8L72 80C32.2 80 0 112.2 0 152L0 440c0 39.8 32.2 72 72 72l.2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0s0 0 0 0l272 0 8 0s0 0 0 0l104 0c39.8 0 72-32.2 72-72l0-288c0-39.8-32.2-72-72-72l-88 0 0-8c0-39.8-32.2-72-72-72L232 0zM480 128l88 0c13.3 0 24 10.7 24 24l0 40-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 104c0 13.3-10.7 24-24 24l-88 0 0-128 0-208zM72 128l88 0 0 336c0 0 0 0-.1 0l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0c-13.2 0-24-10.7-24-24l0-104 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-40c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 264 0 128-64 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-64 0 0-392zm88 24l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faHospitalAlt = faHospital;
const faHospitalWide = faHospital;
const faPollPeople = {
  prefix: 'far',
  iconName: 'poll-people',
  icon: [
    640,
    512,
    [],
    'f759',
    'M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM592 80l0 64-112 0 0-64 112 0zM272 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 32zM592 368l0 64-240 0 0-64 240 0zM272 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-320 0zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0z',
  ],
};
const faWhiskeyGlassIce = {
  prefix: 'far',
  iconName: 'whiskey-glass-ice',
  icon: [
    512,
    512,
    ['glass-whiskey-rocks'],
    'f7a1',
    'M50.5 80l411 0L414.2 404.6c-2.3 15.7-15.8 27.4-31.7 27.4l-253 0c-15.9 0-29.4-11.7-31.7-27.4L50.5 80zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM255.4 179.3l.6-.6c-5-1.8-10.4-2.7-16-2.7l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l73.8 0-19-19c-8.5-8.5-14.7-18.4-18.6-29L144 320l0-96 66.7 0 44.7-44.7zM312 235.9l56.6 56.6L312 349l-56.6-56.6L312 235.9zm-33.9-33.9l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 383c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z',
  ],
};
const faGlassWhiskeyRocks = faWhiskeyGlassIce;
const faWineBottle = {
  prefix: 'far',
  iconName: 'wine-bottle',
  icon: [
    512,
    512,
    [],
    'f72f',
    'M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9c-7.5 7.5-18.8 9-27.9 4.4l-72.5 72.5c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0l36-36L88.7 312.7l-36 36L18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l72.5-72.5c-4.6-9-3.1-20.3 4.4-27.9zM200.7 200.7L311.3 311.3l13.5-13.5c17.4-17.4 24.9-41 22.5-63.8c-2.4-21.8 2.6-49.3 23.4-70l70.7-70.7L418.7 70.6l-70.7 70.7c-20.8 20.8-48.2 25.8-70 23.4c-22.9-2.5-46.4 5-63.8 22.4l-13.5 13.5z',
  ],
};
const faChessRook = {
  prefix: 'far',
  iconName: 'chess-rook',
  icon: [
    448,
    512,
    [9820],
    'f447',
    'M80 80l0 112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352l-48.3 0 9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192L32 72c0-22.1 17.9-40 40-40l304 0c22.1 0 40 17.9 40 40l0 120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85-48.3 0-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4l0-112-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L80 80zm4.7 384l278.7 0-16.6-32-245.6 0L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L72.8 512C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384l265 0zM208 288c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0z',
  ],
};
const faUserBountyHunter = {
  prefix: 'far',
  iconName: 'user-bounty-hunter',
  icon: [
    448,
    512,
    [],
    'e2bf',
    'M323 120C309.4 78 270 48 224 48s-85.4 30-99 72L323 120zm5.5 36.4L248 171.5l0 98.4 9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9 0-98.4-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6l-20.9 0c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7L64 16C64 7.2 71.2 0 80 0L96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 38zM313.6 400l-179.2 0c-40 0-73.6 27.1-83.5 64L160 464l59.2-44.4c2.8-2.1 6.8-2.1 9.6 0L288 464l109.1 0c-9.9-36.9-43.5-64-83.5-64zM0 486.4C0 412.2 60.2 352 134.4 352l179.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4z',
  ],
};
const faBarsStaggered = {
  prefix: 'far',
  iconName: 'bars-staggered',
  icon: [
    512,
    512,
    ['reorder', 'stream'],
    'f550',
    'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z',
  ],
};
const faReorder = faBarsStaggered;
const faStream = faBarsStaggered;
const faDiagramSankey = {
  prefix: 'far',
  iconName: 'diagram-sankey',
  icon: [
    576,
    512,
    [],
    'e158',
    'M329.9 80c-2.8 0-5.4 1.5-6.8 3.8L253.8 197.2c-10.2 16.6-28.3 26.8-47.8 26.8L24 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0c2.8 0 5.4-1.5 6.8-3.8L282.2 58.8C292.3 42.2 310.4 32 329.9 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L329.9 80zm-124 240l61.7 108c1.4 2.5 4.1 4 6.9 4L552 432c13.3 0 24 10.7 24 24s-10.7 24-24 24l-277.4 0c-20.1 0-38.7-10.8-48.6-28.2L150.6 320 24 320c-13.3 0-24-10.7-24-24s10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-346.1 0z',
  ],
};
const faCloudHailMixed = {
  prefix: 'far',
  iconName: 'cloud-hail-mixed',
  icon: [
    512,
    512,
    [],
    'f73a',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm232 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM326.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm256-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCircleUpLeft = {
  prefix: 'far',
  iconName: 'circle-up-left',
  icon: [
    512,
    512,
    [],
    'e128',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6L176 160c-8.8 0-16 7.2-16 16l0 137.4z',
  ],
};
const faDharmachakra = {
  prefix: 'far',
  iconName: 'dharmachakra',
  icon: [
    512,
    512,
    [9784],
    'f655',
    'M232.4 24.7l.4 8.5c-44.4 4.6-85 22.1-117.9 48.8l-5.7-6.3c-9.1-10-24.6-10.3-34.2-.8s-9.2 25.1 .8 34.2l6.3 5.7c-26.7 32.9-44.3 73.4-48.8 117.9l-8.5-.4C11.3 231.8 0 242.5 0 256s11.3 24.2 24.7 23.6l8.5-.4c4.6 44.4 22.1 85 48.8 117.9l-6.3 5.7c-10 9.1-10.3 24.6-.8 34.2s25.1 9.2 34.2-.8l5.7-6.3c32.9 26.7 73.4 44.3 117.9 48.8l-.4 8.5c-.6 13.5 10.1 24.7 23.6 24.7s24.2-11.3 23.6-24.7l-.4-8.5c44.4-4.6 85-22.1 117.9-48.8l5.7 6.3c9.1 10 24.6 10.3 34.2 .8s9.2-25.1-.8-34.2l-6.3-5.7c26.7-32.9 44.3-73.4 48.8-117.9l8.5 .4c13.5 .6 24.7-10.1 24.7-23.6s-11.3-24.2-24.7-23.6l-8.5 .4c-4.6-44.4-22.1-85-48.8-117.9l6.3-5.7c10-9.1 10.3-24.6 .8-34.2s-25.1-9.2-34.2 .8L397.1 82c-32.9-26.7-73.4-44.3-117.9-48.8l.4-8.5C280.2 11.3 269.5 0 256 0s-24.2 11.3-23.6 24.7zM147.3 394.4l54.2-59.4c10.9 7.5 23.5 12.9 37.1 15.4l-3.7 80.3c-32.8-3.9-62.9-16.9-87.6-36.3zm29.6-84l-59.4 54.2C98.1 340 85.2 309.9 81.2 277.1l80.3-3.7c2.5 13.6 7.8 26.1 15.4 37.1zM81.2 234.9c3.9-32.8 16.9-62.9 36.3-87.6l59.4 54.2c-7.5 10.9-12.9 23.5-15.4 37.1l-80.3-3.7zm120.3-58l-54.2-59.4c24.7-19.4 54.8-32.4 87.6-36.3l3.7 80.3c-13.6 2.5-26.1 7.8-37.1 15.4zm108.9 0c-10.9-7.5-23.5-12.9-37.1-15.4l3.7-80.3c32.8 3.9 62.9 16.9 87.6 36.3l-54.2 59.4zm54.2 217.5c-24.7 19.4-54.8 32.4-87.6 36.3l-3.7-80.3c13.6-2.5 26.1-7.8 37.1-15.4l54.2 59.4zm29.8-29.8l-59.4-54.2c7.5-10.9 12.9-23.5 15.4-37.1l80.3 3.7c-3.9 32.8-16.9 62.9-36.3 87.6zm0-217.4c19.4 24.7 32.4 54.8 36.3 87.6l-80.3 3.7c-2.5-13.6-7.8-26.1-15.4-37.1l59.4-54.2zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faObjectsAlignLeft = {
  prefix: 'far',
  iconName: 'objects-align-left',
  icon: [
    512,
    512,
    [],
    'e3be',
    'M0 24C0 10.7 10.7 0 24 0S48 10.7 48 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 24zM176 176l288 0 0-64-288 0 0 64zm-48-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm48 288l160 0 0-64-160 0 0 64zm-48-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z',
  ],
};
const faOilCanDrip = {
  prefix: 'far',
  iconName: 'oil-can-drip',
  icon: [
    640,
    512,
    [],
    'e205',
    'M352 88c0 13.3-10.7 24-24 24l-48 0 0 48 88.9 0c9.9 0 19.7 2.3 28.6 6.8L448 192l139.8-30 2.1-.4 11.3-2.4 13.9-3c18.1-3.9 30.7 17.6 18.4 31.5l-9.4 10.6-7.6 8.6-1.4 1.6L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-21.3-67.5-30C11.2 309 0 291.8 0 272.8L0 208c0-26.5 21.5-48 48-48l48 0 48 0 3.2 0 84.8 0 0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24zM458.7 242.1c-11.4 2.4-23.2 .9-33.6-4.3l-50.5-25.2c-1.8-.9-3.7-1.4-5.7-1.4l-221.7 0 0 153.6 255.9 0c3.7 0 7.2-1.6 9.6-4.3L530.8 226.6l-72.1 15.4zM96 211.2l0-3.2-48 0 0 64.8 48 21.3 0-82.9zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z',
  ],
};
const faFaceSmilingHands = {
  prefix: 'far',
  iconName: 'face-smiling-hands',
  icon: [
    640,
    512,
    [],
    'e396',
    'M320 352c-27.4 0-48.6-9.4-64-20.9l0 52.9 0 2.5c18 8.1 39.4 13.5 64 13.5s46-5.4 64-13.5l0-2.5 0-52.9c-15.4 11.5-36.6 20.9-64 20.9zM112 252.3C114 139.1 206.4 48 320 48s206 91.1 208 204.3c13.3-11.9 31.7-15.2 47.7-9.6C568.7 107.5 456.9 0 320 0S71.3 107.5 64.3 242.6c16-5.5 34.4-2.3 47.7 9.6zm139 200c-4.6 15.8-12.2 30.4-22.1 43c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7c-9.9-12.6-17.5-27.2-22.1-43c-21.6 7.6-44.8 11.7-69 11.7s-47.4-4.1-69-11.7zm30.6-223.5s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm129.7 70.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2l0-32.8 0-53.6c0-11-9-20-20-20s-20 9-20 20l0 19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0z',
  ],
};
const faBroccoli = {
  prefix: 'far',
  iconName: 'broccoli',
  icon: [
    512,
    512,
    [129382],
    'e3e2',
    'M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zM208.4 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7c1.1 8.6 6.9 16 15 19.2s17.3 1.8 24.1-3.8c6.9-5.7 15.7-9.1 25.4-9.1c22.1 0 40 17.9 40 40c0 12-5.3 22.8-13.7 30.2c-7.8 6.8-10.4 17.9-6.3 27.4s13.7 15.4 24.1 14.6c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48L96 304c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.3 0 2.7 .1 4 .2c10.3 .8 20-5 24.1-14.6s1.5-20.6-6.3-27.4C109.3 158.8 104 148 104 136c0-22.1 17.9-40 40-40c9.7 0 18.5 3.4 25.4 9.1c6.7 5.5 15.9 7 24.1 3.8s13.8-10.6 15-19.2zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7l65.9 0c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3L280 384l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384l-95.9 0c16.5 24.2 38.5 60.9 56.1 106.3z',
  ],
};
const faRouteInterstate = {
  prefix: 'far',
  iconName: 'route-interstate',
  icon: [
    512,
    512,
    [],
    'f61b',
    'M64 192l383.3 0c-3.3 42-12.4 79.6-27.6 113.3C391 369 338.9 421.2 255.5 461.7c-84.6-37.1-136.4-89.1-164.6-153.4C75.7 273.8 67 235.1 64 192zM272.6 6c-10.2-6.1-23-6.1-33.2 0c-53.2 31.8-107 33.5-178.8 20c-17.7-3.3-35 8.7-37.7 26.9C8 156.5 12.5 249.5 46.9 327.6c34.7 78.9 98.6 139.8 196.5 181.1c8.3 3.5 17.8 3.3 26-.5c95.4-44.7 158.9-105.4 194.1-183.2c34.9-77.2 40.4-168.5 25.5-272.2c-2.6-18.2-19.9-30.2-37.7-26.9C379.6 39.5 325.8 37.8 272.6 6z',
  ],
};
const faEarMuffs = {
  prefix: 'far',
  iconName: 'ear-muffs',
  icon: [
    640,
    512,
    [],
    'f795',
    'M320 48c-83.1 0-151.4 63.4-159.3 144.4c-2.9-.3-5.8-.4-8.7-.4c-14.4 0-27.9 3.4-39.9 9.5C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-12-6.1-25.5-9.5-39.9-9.5c-3 0-5.9 .1-8.7 .4C471.4 111.4 403.1 48 320 48zM480 224.6c2.6-.4 5.3-.6 8-.6c12 0 23.2 3.8 32.3 10.2c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-28.2 20.9-51.6 48-55.4zM152 224c2.7 0 5.4 .2 8 .6c27.1 3.9 48 27.2 48 55.4c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2C128.8 227.8 140 224 152 224zm7 108c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-4.4-3.6-8-8-8c-1.8 0-3.3 .5-4.6 1.4c-12 8.4-27.1 11-41.2 6.9c-.7-.2-1.4-.3-2.3-.3c-2.8 0-5.3 1.4-6.8 3.8c-6.3 10-16.1 17.3-27.4 20.5c-3.4 1-5.8 4.1-5.8 7.7c0 .8 .1 1.5 .3 2.2c4.8 17.3-.5 35.8-13.7 48c-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9c13.2 12.2 18.5 30.7 13.7 48c-.2 .6-.3 1.3-.3 2.2c0 3.6 2.4 6.7 5.8 7.7c11.4 3.2 21.1 10.5 27.4 20.5c1.5 2.4 4 3.8 6.8 3.8c.9 0 1.6-.1 2.3-.3c14-4.1 29.2-1.6 41.2 6.9c1.3 .9 2.8 1.4 4.6 1.4c4.4 0 8-3.6 8-8c0-1.5-.4-2.8-1-4c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-1.8-.5-3.3-1.4-4.5c-11.5-16.5-11.5-38.4 0-54.9c.9-1.3 1.4-2.8 1.4-4.5c0-1.5-.4-2.8-1-4zm321-52c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 1.8 .5 3.3 1.4 4.5c11.5 16.5 11.5 38.4 0 54.9c-.9 1.3-1.4 2.8-1.4 4.5c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 4.4 3.6 8 8 8c1.8 0 3.3-.5 4.6-1.4c12-8.4 27.1-11 41.2-6.9c.7 .2 1.4 .3 2.3 .3c2.8 0 5.3-1.4 6.8-3.8c6.3-10 16.1-17.3 27.4-20.5c3.4-1 5.8-4.1 5.8-7.7c0-.8-.1-1.5-.3-2.2c-4.7-17.3 .5-35.8 13.7-48c1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9c-13.2-12.2-18.5-30.7-13.7-48c.2-.6 .3-1.3 .3-2.2c0-3.6-2.4-6.7-5.8-7.7c-11.4-3.2-21.1-10.5-27.4-20.5c-1.5-2.4-4-3.8-6.8-3.8c-.9 0-1.6 .1-2.3 .3c-14 4.1-29.2 1.6-41.2-6.9c-1.3-.9-2.8-1.4-4.6-1.4c-4.4 0-8 3.6-8 8z',
  ],
};
const faHotdog = {
  prefix: 'far',
  iconName: 'hotdog',
  icon: [
    512,
    512,
    [127789],
    'f80f',
    'M496.2 208.2l-34 34c1.2 1.7 1.9 3.7 1.9 5.8c0 2.6-1 5.2-2.9 7L255 461.1c-1.9 1.9-4.4 2.9-7 2.9c-2.1 0-4.1-.7-5.8-1.9l-34 34c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8zM15.8 303.8l34-34c-1.2-1.7-1.9-3.7-1.9-5.8c0-2.6 1-5.2 2.9-7L17 223 50.9 257 257 50.9c1.9-1.9 4.4-2.9 7-2.9c2.1 0 4.1 .7 5.8 1.9l34-34C293.1 5.7 278.8 0 264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8zM447.6 143.6l-304 304c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l304-304c21.9-21.9 57.3-21.9 79.2 0s21.9 57.3 0 79.2zm33.9 33.9c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4s0 0 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9z',
  ],
};
const faTransporterEmpty = {
  prefix: 'far',
  iconName: 'transporter-empty',
  icon: [
    512,
    512,
    [],
    'e046',
    'M96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faPersonWalkingWithCane = {
  prefix: 'far',
  iconName: 'person-walking-with-cane',
  icon: [
    512,
    512,
    ['blind'],
    'f29d',
    'M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 32c-34.8 0-66.3 20.5-80.4 52.3l-47.1 106c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L120 211.1l0 68.7c0 17.8 8.5 34.6 22.9 45.2L240 396.2l0 91.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-95.9c0-12.7-6.1-24.7-16.3-32.3L240 336.6l0-129.4 68 102c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3L271 167.2c-16.3-24.5-43.8-39.2-73.2-39.2l-36.2 0zM168 279.8L168 176l24 0 0 125.4-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1L450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L370.4 332.6c-3.2 3.7-7 7.1-11.3 10c-5 3.3-10.3 5.7-15.7 7.3zM96.7 482.4c-3.1 12.9 4.8 25.8 17.7 28.9s25.8-4.8 28.9-17.7l26.3-109.4-42-30.8-31 129z',
  ],
};
const faBlind = faPersonWalkingWithCane;
const faAngle90 = {
  prefix: 'far',
  iconName: 'angle-90',
  icon: [
    448,
    512,
    [],
    'e08d',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 432 48 56zM96 97.6l0 48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384l48.3 0c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z',
  ],
};
const faRectangleTerminal = {
  prefix: 'far',
  iconName: 'rectangle-terminal',
  icon: [
    512,
    512,
    [],
    'e236',
    'M448 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faKite = {
  prefix: 'far',
  iconName: 'kite',
  icon: [
    640,
    512,
    [129665],
    'f6f4',
    'M368 48l216 0c2.2 0 4.2 .9 5.7 2.3L480 160 592 272l0 6.3c0 3.7-2.6 7-6.3 7.8L289.8 351.9c-.3-.3-.5-.6-.8-.9L480 160 368 48zm-61-4.1L234.1 372l-87.5 87.5c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6l0-88.6-24-12-24 12 0 88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L268 405.9 596.1 333c25.6-5.7 43.9-28.4 43.9-54.7L640 56c0-30.9-25.1-56-56-56L361.7 0c-26.2 0-49 18.2-54.7 43.9zM0 152c0 13.3 10.7 24 24 24l8 0c22.1 0 40 17.9 40 40l0 68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9l0 70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324s0 0 0 0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5c0 0 0 0 0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9l0-70.1c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284l0-68c0-48.6-39.4-88-88-88l-8 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faDrum = {
  prefix: 'far',
  iconName: 'drum',
  icon: [
    512,
    512,
    [129345],
    'f569',
    'M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208L0 368c0 24.9 14.9 44.5 33.2 58.7c18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9C497.1 412.5 512 392.9 512 368l0-160c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6zM424 293.2c15-5.6 28.4-12 40-19l0 93.8c0 4.1-2.3 11.2-14.5 20.7c-6.5 5-15 10-25.5 14.6l0-110.1zM280 319.5c34.4-1.3 66.9-5.6 96-12.2l0 111.7c-27.9 6.7-60.5 11.1-96 12.5l0-112zM136 307.4c29.1 6.6 61.6 10.8 96 12.2l0 112c-35.5-1.4-68.1-5.8-96-12.5l0-111.7zM48 274.2c11.6 7 25 13.4 40 19l0 110.1c-10.4-4.7-18.9-9.6-25.5-14.6C50.3 379.2 48 372.1 48 368l0-93.8z',
  ],
};
const faScrubber = {
  prefix: 'far',
  iconName: 'scrubber',
  icon: [
    512,
    512,
    [],
    'f2f8',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faIceCream = {
  prefix: 'far',
  iconName: 'ice-cream',
  icon: [
    448,
    512,
    [127848],
    'f810',
    'M224 0C140.9 0 72.6 63.3 64.8 144.4C28.4 148 0 178.7 0 216c0 39.8 32.2 72 72 72l64.4 0 175.3 0 64.4 0c39.8 0 72-32.2 72-72c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6c-.4 6.6 2 13.1 6.5 17.9s10.8 7.5 17.5 7.5l16.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64.4 0-175.3 0L72 240c-13.3 0-24-10.7-24-24s10.7-24 24-24l16.2 0c6.6 0 12.9-2.7 17.5-7.5s6.9-11.3 6.5-17.9c-.1-2.2-.2-4.4-.2-6.6zm88.1 338.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320 98.3 320 200.1 498.1z',
  ],
};
const faHeartCircleBolt = {
  prefix: 'far',
  iconName: 'heart-circle-bolt',
  icon: [
    576,
    512,
    [],
    'e4fc',
    'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z',
  ],
};
const faFishBones = {
  prefix: 'far',
  iconName: 'fish-bones',
  icon: [
    576,
    512,
    [],
    'e304',
    'M96 166.9c0-7.2-3.3-14.1-8.9-18.7l-48-38.9c-8.8-7.1-21.3-7.1-30.1-.1s-11.5 19.2-6.6 29.3L54.9 245.4c3.3 6.7 3.3 14.5 0 21.2L2.5 373.4c-5 10.1-2.2 22.3 6.6 29.3s21.3 7 30.1-.1l48-38.9c5.6-4.6 8.9-11.4 8.9-18.7L96 304s0 0 0 0l0-24 40 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 40 0 0 101.1c0 16.9 17.1 28.4 31.8 20c16-9.1 30.6-19.7 43.7-30.7c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-13.1-11-27.7-21.6-43.7-30.7c-14.7-8.4-31.8 3.1-31.8 20L416 232l-40 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-24s0 0 0 0l0-41.1zM464 330.8l0-149.5c28.5 24.9 49.7 53.6 61.8 74.8c-12.1 21.2-33.3 49.9-61.8 74.8z',
  ],
};
const faDeerRudolph = {
  prefix: 'far',
  iconName: 'deer-rudolph',
  icon: [
    576,
    512,
    [],
    'f78f',
    'M240 0c8.8 0 16 7.2 16 16l0 24c0 13.3 10.7 24 24 24l8 0 8 0c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 8.6-1.9 16.7-5.4 24l39.5 0L416 64c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2c22.1 0 40 17.9 40 40s-17.9 40-40 40l-.1 0c-2.3 35.7-31.9 64-68.2 64l-42.3 0-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6L392 472c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-96-6.8 0c-22 0-43.7-4.6-63.8-13.3c-4.3 17.1-14.7 32.3-29.9 42.4l-6.5 4.3 17.8 48.8c9.5 26.1-9.8 53.7-37.6 53.7l-46 0c-16.8 0-31.8-10.5-37.6-26.3L31.2 423.9c-5.6-15.3-5.8-32-.6-47.4l8.2-24.7c.8-2.4 1.2-5 1.2-7.6l0-4.3c0-6.4-2.5-12.5-7-17l-1.1-1.1c-1 8.4-8.4 14.7-16.9 14.1c-8.8-.6-15.5-8.1-15-17l3.3-53c1.1-17.6 6.9-33.9 16.2-47.6c16.2-30 48-50.4 84.5-50.4l191 0 7.2-24L274 144c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96l-24 0-8 0-8 0c-30.9 0-56-25.1-56-56l0-24c0-8.8 7.2-16 16-16zM354.9 135.2l-19 63.6c-3 10.2-12.4 17.1-23 17.1L104 216c-26.5 0-48 21.5-48 48l0 4.1c0 6.4 2.5 12.5 7 17l3.9 3.9C80.4 302.5 88 320.8 88 339.9l0 4.3c0 7.7-1.2 15.4-3.7 22.8l-8.2 24.7c-1.7 5.1-1.6 10.7 .2 15.8L96.8 464l28.9 0-20.3-55.8c-3.8-10.4 0-22 9.2-28.2l22.2-14.8c7.9-5.2 11.9-14.6 10.4-23.9l-2.9-17.4c-1.6-9.4 2.6-18.9 10.6-24.1s18.4-5.1 26.3 .2l13.7 9.2c18.4 12.3 40 18.8 62.1 18.8l30.8 0c13.3 0 24 10.7 24 24l0 112 32 0 0-152.2c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6c3.3-9.8 12.4-16.4 22.8-16.4l59.6 0c11.3 0 20.4-9.1 20.4-20.4c0-5.7-2.4-11.2-6.7-15.1L408 120.5c-6-5.5-13.8-8.5-21.9-8.5c-14.4 0-27.1 9.4-31.2 23.2zM400 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faFax = {
  prefix: 'far',
  iconName: 'fax',
  icon: [
    512,
    512,
    [128224, 128439],
    'f1ac',
    'M176 64c0-8.8 7.2-16 16-16l191.4 0c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3l0 63.4 48 0 0-63.4c0-17-6.7-33.3-18.7-45.3L428.7 18.7C416.7 6.7 400.4 0 383.4 0L192 0c-35.3 0-64 28.7-64 64l0 66c-5.1-1.3-10.5-2-16-2l-48 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l32 0 16 0 336 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-272 0 0-128zm0 176l272 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-274 0c1.3-5.1 2-10.5 2-16l0-208zM112 464l-16 0-32 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 24 0 232c0 8.8-7.2 16-16 16zM272 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM240 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM368 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM336 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faParagraph = {
  prefix: 'far',
  iconName: 'paragraph',
  icon: [
    448,
    512,
    [182],
    'f1dd',
    'M32 192c0-88.4 71.6-160 160-160l64 0 168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376-48 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-48 0c-88.4 0-160-71.6-160-160zM240 304l0-224-48 0C130.1 80 80 130.1 80 192s50.1 112 112 112l48 0z',
  ],
};
const faHeadSideHeart = {
  prefix: 'far',
  iconName: 'head-side-heart',
  icon: [
    512,
    512,
    [],
    'e1aa',
    'M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm64-34.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
  ],
};
const faSquareE = {
  prefix: 'far',
  iconName: 'square-e',
  icon: [
    448,
    512,
    [],
    'e26d',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104c0-13.3 10.7-24 24-24z',
  ],
};
const faMeterFire = {
  prefix: 'far',
  iconName: 'meter-fire',
  icon: [
    640,
    512,
    [],
    'e1eb',
    'M256 48c68.7 0 129.5 33.3 167.4 84.6c16.7-8 37.2-5.5 51.5 7.4c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-12.6-11.6-23.6-24.8-32.8-39.2c-19.7 6.2-40.6 9.5-62.3 9.5C141.1 464 48 370.9 48 256S141.1 48 256 48zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 11.2 7.6 20.6 18 23.2c9-12.9 19.1-25.7 30-38.3l0-32.9zm-176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm225.7 56.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z',
  ],
};
const faCloudHail = {
  prefix: 'far',
  iconName: 'cloud-hail',
  icon: [
    512,
    512,
    [],
    'f739',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM160 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faCheckToSlot = {
  prefix: 'far',
  iconName: 'check-to-slot',
  icon: [
    576,
    512,
    ['vote-yea'],
    'f772',
    'M144 80l0 280 288 0 0-280L144 80zM96 360L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 280c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-288 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288l0 48-16 0 0 96 480 0 0-96-16 0 0-48 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0zM385 179.6L278.3 286.3c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L191 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L351 145.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faVoteYea = faCheckToSlot;
const faMoneyFromBracket = {
  prefix: 'far',
  iconName: 'money-from-bracket',
  icon: [
    640,
    512,
    [],
    'e312',
    'M48 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L552 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88zm416 8l48 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352 48 0 0 304c35.3 0 64 28.7 64 64l160 0c0-35.3 28.7-64 64-64l0-304zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z',
  ],
};
const faStarHalf = {
  prefix: 'far',
  iconName: 'star-half',
  icon: [
    576,
    512,
    [61731],
    'f089',
    'M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4 0-265.9z',
  ],
};
const faCarBus = {
  prefix: 'far',
  iconName: 'car-bus',
  icon: [
    640,
    512,
    [],
    'f85a',
    'M64.5 80L192 80l129.4 0C302.1 65.3 263.5 48 192 48C126.6 48 86.2 64.8 64.5 80zM48 128l0 80 120 0 0-80L48 128zm0 128l0 96c0 13.3 10.7 24 24 24l120 0 0 48L80 424l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-44.1C12.7 399 0 377 0 352L0 118.2c0-22 4.6-51.9 28.8-71.4C58.6 22.7 111.5 0 192 0c84.9 0 135.8 22.1 164.5 46.6c23.4 20 27.5 49.9 27.5 71.6l0 9.8-35.8 0c-4.1 0-8.2 .3-12.2 .8l0-.8-120 0 0 80 36.9 0-13.7 48L192 256 48 256zm56 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm257.8-80c-10.1 0-19.2 6.4-22.6 15.9L322.1 272l219.9 0-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9l-140.3 0zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8l140.3 0c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368l0 32 0 16 0 32 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-320 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40 0-32 0-16 0-32c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320l-224 0c-26.5 0-48 21.5-48 48l0 32 320 0 0-32c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faSpeaker = {
  prefix: 'far',
  iconName: 'speaker',
  icon: [
    384,
    512,
    [],
    'f8df',
    'M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM232 120a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM192 432a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM136 328a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z',
  ],
};
const faTimer = {
  prefix: 'far',
  iconName: 'timer',
  icon: [
    512,
    512,
    [],
    'e29e',
    'M232 24c0-13.3 10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-37.9 8.2-73.8 23-106.1c6-13.2 13.1-25.8 21.2-37.6l.1-.2C53.4 98.7 63.6 86.3 75 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-9.2 9.2-17.6 19.3-25 30.1l-.1 .2c-21.2 31.2-34.2 68.5-35.7 108.7c-.1 2.7-.2 5.4-.2 8.1c0 114.9 93.1 208 208 208s208-93.1 208-208c0-106.8-80.4-194.7-184-206.6l0 54.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM159 159c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faBoxesStacked = {
  prefix: 'far',
  iconName: 'boxes-stacked',
  icon: [
    576,
    512,
    [62625, 'boxes', 'boxes-alt'],
    'f468',
    'M384 48c8.8 0 16 7.2 16 16l0 128 48 0 0-128c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 128 48 0 0-128c0-8.8 7.2-16 16-16l56 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0zM327.6 512L512 512c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-184.4 0c11.8 13.2 20.1 29.7 23.1 48l25.3 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-161.3 0c-3.1 18.3-11.3 34.8-23.1 48zM256 272c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l56 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0zM64 224c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L64 224z',
  ],
};
const faBoxes = faBoxesStacked;
const faBoxesAlt = faBoxesStacked;
const faLandmarkMagnifyingGlass = {
  prefix: 'far',
  iconName: 'landmark-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e622',
    'M448 288c-16.7 0-32.8-2.6-48-7.3L400 384l-64 0 0-141.7c-5.8-5.7-11.1-11.8-16-18.3l-32 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96zM267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l267.3 0c-6.5-14.9-10.8-31.1-12.5-48L88.2 144 256 51.4l41.3 22.8c5.5-15.3 13.2-29.5 22.8-42.3L267.6 3zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM448 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 313.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z',
  ],
};
const faGrillHot = {
  prefix: 'far',
  iconName: 'grill-hot',
  icon: [
    448,
    512,
    [],
    'e5a5',
    'M120 0C106.7 0 96 10.7 96 24l0 2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6c0-13.3-10.7-24-24-24zM48.9 208l350.2 0c-8 72-69 128-143.1 128l-64 0c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32c0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40L327 472l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L334.4 367.3c67-30 113.6-97.2 113.6-175.3c0-17.7-14.3-32-32-32L32 160zM147.5 410l12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7l64 0c11 0 21.7-.9 32.2-2.7L306.5 424l-151.1 0c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6z',
  ],
};
const faBallotCheck = {
  prefix: 'far',
  iconName: 'ballot-check',
  icon: [
    448,
    512,
    [],
    'f733',
    'M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L96 96c-8.8 0-16 7.2-16 16zM96 352c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80-224c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm32 128c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zM176 384c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm-4.7-140.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 257.4 99.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z',
  ],
};
const faLink = {
  prefix: 'far',
  iconName: 'link',
  icon: [
    640,
    512,
    [128279, 'chain'],
    'f0c1',
    'M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z',
  ],
};
const faChain = faLink;
const faEarListen = {
  prefix: 'far',
  iconName: 'ear-listen',
  icon: [
    512,
    512,
    ['assistive-listening-systems'],
    'f2a2',
    'M388.9 3.8C450.6 43 493.6 105.8 508 177.6l3.5 17.7c2.6 13-5.8 25.6-18.8 28.2s-25.6-5.8-28.2-18.8L460.9 187c-11.8-58.9-47.1-110.5-97.8-142.7c-11.2-7.1-14.5-22-7.4-33.1s21.9-14.5 33.1-7.4zM240 112c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40zM168 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L47 401c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faAssistiveListeningSystems = faEarListen;
const faFileMinus = {
  prefix: 'far',
  iconName: 'file-minus',
  icon: [
    384,
    512,
    [],
    'f318',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faTreeCity = {
  prefix: 'far',
  iconName: 'tree-city',
  icon: [
    640,
    512,
    [],
    'e587',
    'M336 56c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 160c0 13.3 10.7 24 24 24l80 0 16 0c4.4 0 8 3.6 8 8l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-28.2-20.9-51.6-48-55.4l0-72.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-32 0 0-136c0-30.9-25.1-56-56-56L344 0c-30.9 0-56 25.1-56 56l0 432c0 13.3 10.7 24 24 24s24-10.7 24-24l0-432zm32 40l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM368 288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM496 384l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM224 160c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240c0 45 35 80 80 80l16 0 0 160c0 18 14 32 32 32c17 0 32-14 32-32l0-160 16 0c44 0 80-35 80-80c0-26-14-50-34-64c1-5 2-10 2-16z',
  ],
};
const faPlay = {
  prefix: 'far',
  iconName: 'play',
  icon: [
    384,
    512,
    [9654],
    'f04b',
    'M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z',
  ],
};
const faFont = {
  prefix: 'far',
  iconName: 'font',
  icon: [
    448,
    512,
    [],
    'f031',
    'M246.2 46.9C242.5 37.9 233.8 32 224 32s-18.5 5.9-22.2 14.9L44.6 432 24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-39.5 0 32.7-80 189.8 0 32.7 80L312 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-20.6 0L246.2 46.9zM299.3 304l-150.6 0L224 119.5 299.3 304z',
  ],
};
const faCupTogo = {
  prefix: 'far',
  iconName: 'cup-togo',
  icon: [
    448,
    512,
    ['coffee-togo'],
    'f6c5',
    'M108.2 48l232 0c3 0 5.8 1.7 7.2 4.4L361.2 80 88 80l13-27.4c1.3-2.8 4.1-4.6 7.2-4.6zM414.8 80L390.3 31c-9.5-19-28.9-31-50.1-31l-232 0C86.6 0 66.9 12.4 57.6 32L34.8 80 24 80C10.7 80 0 90.7 0 104s10.7 24 24 24l26 0 350 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-9.2 0zM47.4 160L74.6 453.9c3 32.9 30.7 58.1 63.7 58.1l171.3 0c33.1 0 60.7-25.2 63.7-58.1L400.6 160l-48.2 0-5.9 64-244.9 0-5.9-64-48.2 0zm68.9 224l215.3 0-6.1 65.5c-.8 8.2-7.7 14.5-15.9 14.5l-171.3 0c-8.3 0-15.2-6.3-15.9-14.5L116.4 384z',
  ],
};
const faCoffeeTogo = faCupTogo;
const faSquareDownLeft = {
  prefix: 'far',
  iconName: 'square-down-left',
  icon: [
    448,
    512,
    [],
    'e26b',
    'M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 198.6L128 336c0 8.8 7.2 16 16 16l137.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z',
  ],
};
const faBurgerLettuce = {
  prefix: 'far',
  iconName: 'burger-lettuce',
  icon: [
    512,
    512,
    [],
    'e3e3',
    'M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zm48-56c-20.1 0-35.8-5.1-46.7-10.5c-5.4-2.7-9.6-5.5-12.7-7.8c-1.5-1.1-2.7-2.1-3.7-3c-.5-.4-.9-.8-1.2-1.1l-.4-.4-.2-.2-.1-.1c0 0 0 0 0 0s0 0 0 0l17-17L15 305c-9.4-9.4-9.4-24.6 0-33.9c9.2-9.2 24.2-9.4 33.6-.4c.1 .1 .4 .3 .8 .6c1 .7 2.8 1.9 5.3 3.2c5.1 2.5 13.4 5.5 25.3 5.5c8.2 0 15.2-3.8 30-12.6l.2-.1c13.2-7.9 32.3-19.3 57.8-19.3c25.1 0 42.2 11.1 54.1 18.8l1.6 1c12 7.7 19.8 12.2 32.3 12.2c12.2 0 19-4.2 30.7-12l.6-.4c12.3-8.2 29.4-19.6 56.7-19.6c27.2 0 46.1 11.3 59.6 19.6c14.5 9 20.5 12.4 28.4 12.4c11.9 0 20.2-2.9 25.3-5.5c2.6-1.3 4.4-2.5 5.3-3.2c.4-.3 .7-.6 .8-.6c9.4-9 24.3-8.9 33.6 .4c9.4 9.4 9.4 24.6 0 33.9l-17-17c17 17 17 17 17 17s0 0 0 0s0 0 0 0l-.1 .1-.2 .2-.4 .4c-.3 .3-.7 .7-1.2 1.1c-.9 .8-2.1 1.8-3.7 3c-3 2.3-7.2 5.1-12.7 7.8C467.8 322.9 452.1 328 432 328c-22.2 0-39.3-10.7-50.8-17.9c-1-.6-1.9-1.2-2.7-1.7C365.9 300.7 356.8 296 344 296c-12.2 0-19 4.2-30.7 12l-.6 .4C300.4 316.6 283.3 328 256 328c-27.5 0-45.5-11.6-58.3-19.8c0 0 0 0 0 0C184.8 299.9 178.4 296 168 296c-11 0-19.8 4.5-33.4 12.6l-2.3 1.4c-12.1 7.3-29.9 18-52.2 18z',
  ],
};
const faTableCellsRowLock = {
  prefix: 'far',
  iconName: 'table-cells-row-lock',
  icon: [
    640,
    512,
    [],
    'e67a',
    'M48 296l0-80 104 0 0 80L48 296zm0 120l0-72 104 0 0 88-88 0c-8.8 0-16-7.2-16-16zm264 16l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 216l112 0 0 80-112 0 0-80zm328 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faRupiahSign = {
  prefix: 'far',
  iconName: 'rupiah-sign',
  icon: [
    512,
    512,
    [],
    'e23d',
    'M0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176zm264-96l88 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-64 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-304c0-13.3 10.7-24 24-24zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64l-64 0 0 128 64 0z',
  ],
};
const faMagnifyingGlass = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [
    512,
    512,
    [128269, 'search'],
    'f002',
    'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z',
  ],
};
const faSearch = faMagnifyingGlass;
const faTableTennisPaddleBall = {
  prefix: 'far',
  iconName: 'table-tennis-paddle-ball',
  icon: [
    512,
    512,
    [127955, 'ping-pong-paddle-ball', 'table-tennis'],
    'f45d',
    'M412.4 99.5c52.2 52.2 64.8 129 37.7 193.1c15.8 4.4 30.4 11.7 43.1 21.3c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5l0 2.7c0 33.9 13.5 66.5 37.5 90.5c13.4 13.4 12 35.6-3 47.2l-49.3 38C6.3 403.1 0 416 0 429.7c0 11.7 4.7 22.9 12.9 31.2l38.1 38.1c8.3 8.3 19.5 12.9 31.2 12.9c13.7 0 26.6-6.3 35-17.2l38-49.3c11.6-15 33.8-16.5 47.2-3c24 24 56.6 37.5 90.5 37.5l2.7 0c3.1 0 6.1-.1 9.2-.3c-8.3-14.4-13.8-30.6-16-47.8c-19.7-1-38.5-9.3-52.5-23.3l-33.9 33.9 33.9-33.9c-33.9-33.9-89.9-30.3-119.2 7.7L81.9 462l-32-32 45.8-35.3c38-29.3 41.6-85.3 7.7-119.2C88.4 260.5 80 240.2 80 219l0-2.7c0-11 2.3-21.8 6.6-31.7L290.9 388.8c3.7-17.2 10.9-33.2 20.8-47.1L116.5 146.6l47-47c68.7-68.7 180.2-68.7 248.9 0zM368 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z',
  ],
};
const faPingPongPaddleBall = faTableTennisPaddleBall;
const faTableTennis = faTableTennisPaddleBall;
const faPersonDotsFromLine = {
  prefix: 'far',
  iconName: 'person-dots-from-line',
  icon: [
    576,
    512,
    ['diagnoses'],
    'f470',
    'M288 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM24 320L8.9 301.3C-1.4 309.7-3 324.8 5.3 335.1s23.4 11.9 33.7 3.6c0 0 0 0 0 0l.1-.1 .7-.6c.7-.5 1.8-1.4 3.3-2.4c3-2.2 7.5-5.4 13.4-9.2c11.9-7.7 29.3-18.2 51.5-28.6c19.4-9.2 42.3-18.3 68-25.6L176 432l48 0 0-170.7c20.2-3.3 41.6-5.3 64-5.3s43.8 1.9 64 5.3L352 432l48 0 0-159.9c25.7 7.4 48.5 16.5 68 25.6c22.2 10.5 39.6 20.9 51.5 28.6c5.9 3.9 10.4 7.1 13.4 9.2c1.5 1.1 2.6 1.9 3.3 2.4l.7 .6 .1 .1s0 0 0 0c10.3 8.3 25.4 6.7 33.7-3.6s6.7-25.4-3.6-33.8L552 320c15.1-18.7 15.1-18.7 15.1-18.7s0 0 0 0s0 0 0 0l-.1-.1-.3-.3-.6-.5-.6-.4c-1-.8-2.4-1.8-4.2-3.1c-3.6-2.6-8.8-6.3-15.5-10.7c-13.4-8.8-32.8-20.3-57.3-31.9C439.6 231.3 370.1 208 288 208s-151.6 23.3-200.4 46.3c-24.4 11.5-43.9 23.1-57.3 31.9c-6.7 4.4-11.9 8.1-15.5 10.7c-1.8 1.3-3.2 2.4-4.2 3.1c-.5 .4-.9 .7-1.2 .9l-.3 .3-.1 .1c0 0 0 0 0 0c0 0 0 0 0 0L24 320zM0 488c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM56 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM336 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faDiagnoses = faPersonDotsFromLine;
const faChevronsDown = {
  prefix: 'far',
  iconName: 'chevrons-down',
  icon: [
    512,
    512,
    ['chevron-double-down'],
    'f322',
    'M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z',
  ],
};
const faChevronDoubleDown = faChevronsDown;
const faTrashCanArrowUp = {
  prefix: 'far',
  iconName: 'trash-can-arrow-up',
  icon: [
    448,
    512,
    ['trash-restore-alt'],
    'f82a',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm144 48c6.4 0 12.5 2.5 17 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L248 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c4.5-4.5 10.6-7 17-7z',
  ],
};
const faTrashRestoreAlt = faTrashCanArrowUp;
const faSignalGood = {
  prefix: 'far',
  iconName: 'signal-good',
  icon: [
    640,
    512,
    ['signal-3'],
    'f68e',
    'M320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faSignal3 = faSignalGood;
const faLocationQuestion = {
  prefix: 'far',
  iconName: 'location-question',
  icon: [
    384,
    512,
    ['map-marker-question'],
    'f60b',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faMapMarkerQuestion = faLocationQuestion;
const faFloppyDiskCircleXmark = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-xmark',
  icon: [
    576,
    512,
    ['floppy-disk-times', 'save-circle-xmark', 'save-times'],
    'e181',
    'M48 96l0 320c0 8.8 7.2 16 16 16l204 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-24.4c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80l0 80 144 0 0-80L128 80zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z',
  ],
};
const faFloppyDiskTimes = faFloppyDiskCircleXmark;
const faSaveCircleXmark = faFloppyDiskCircleXmark;
const faSaveTimes = faFloppyDiskCircleXmark;
const faNairaSign = {
  prefix: 'far',
  iconName: 'naira-sign',
  icon: [
    448,
    512,
    [],
    'e1f6',
    'M107.8 42.5C101.9 33.8 91 30 80.9 33.1S64 45.5 64 56l0 200-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 115.6 0L340.2 469.5c5.9 8.7 16.8 12.5 26.9 9.4s16.9-12.4 16.9-22.9l0-152 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 200-83 0L107.8 42.5zM285.7 304l50.3 0 0 74-50.3-74zM195 256l-83 0 0-122 83 122z',
  ],
};
const faPeach = {
  prefix: 'far',
  iconName: 'peach',
  icon: [
    512,
    512,
    [],
    'e20b',
    'M96 32c0 34.7 18.4 65.1 46 82C61.6 126.5 0 196 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-84-61.6-153.5-142-166c27.6-16.9 46-47.3 46-82l0-8c0-13.3-10.7-24-24-24L352 0c-53 0-96 43-96 96c0-53-43-96-96-96L120 0C106.7 0 96 10.7 96 24l0 8zm72 128c58.1 0 106.6 41.3 117.6 96.2c2.6 13 13.1 23.8 26.4 23.8s24.2-10.8 22.3-23.9c-4.7-32.9-19-62.8-39.9-86.7c4.1-1 8.2-2.1 12.2-3.5c11.7-3.8 24.3-5.9 37.4-5.9c66.3 0 120 53.7 120 120c0 43.4-32.4 84.6-84.3 120.9c-49.2 34.4-103.9 55.9-123.7 63c-19.8-7.1-74.5-28.6-123.7-63C80.4 364.6 48 323.4 48 280c0-66.3 53.7-120 120-120z',
  ],
};
const faCirclesOverlap3 = {
  prefix: 'far',
  iconName: 'circles-overlap-3',
  icon: [
    512,
    512,
    ['pronoun'],
    'e6a1',
    'M157 192.1c38.2 1.2 72.9 16.6 99 41.1c26-24.4 60.7-39.8 99-41.1c3.3-10.1 5-20.9 5-32.1c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 11.2 1.8 22 5 32.1zm-48.2 6.1c-3.2-12.2-4.8-25-4.8-38.2C104 76.1 172.1 8 256 8s152 68.1 152 152c0 13.2-1.7 26-4.8 38.2C466.1 216.8 512 275 512 344c0 83.9-68.1 152-152 152c-40.2 0-76.8-15.6-104-41.1C228.8 480.4 192.2 496 152 496C68.1 496 0 427.9 0 344c0-69 45.9-127.2 108.8-145.8zm19.6 44.5C82.3 253.4 48 294.7 48 344c0 57.4 46.6 104 104 104c29.2 0 55.6-12 74.4-31.4C214.7 395 208 370.3 208 344c0-13.2 1.7-26 4.8-38.2c-35.1-10.4-64.9-33.1-84.4-63.1zm170.7 63.1c3.2 12.2 4.8 25 4.8 38.2c0 26.3-6.7 51-18.4 72.6C304.4 436 330.8 448 360 448c57.4 0 104-46.6 104-104c0-49.3-34.3-90.6-80.4-101.3c-19.5 30-49.3 52.7-84.4 63.1z',
  ],
};
const faPronoun = faCirclesOverlap3;
const faTaxiBus = {
  prefix: 'far',
  iconName: 'taxi-bus',
  icon: [
    640,
    512,
    [],
    'e298',
    'M192 48c71.5 0 110.1 17.3 129.4 32L192 80 64.5 80C86.2 64.8 126.6 48 192 48zM48 208l0-80 120 0 0 80L48 208zm0 144l0-96 144 0 47.2 0 13.7-48L216 208l0-80 112.6 0c3.6-25.4 24.3-45.2 50-47.7c-4-12.2-10.8-24-22-33.6C327.8 22.1 276.9 0 192 0C111.5 0 58.6 22.7 28.8 46.8C4.6 66.3 0 96.2 0 118.2L0 352c0 25 12.7 47 32 59.9L32 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 112 0 0-48L72 376c-13.3 0-24-10.7-24-24zm80-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 144l0 16-6.2 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-6.2 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm-6.2 64l38.2 0 64 0 38.2 0c10.1 0 19.2 6.4 22.6 15.9L541.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM320 320l224 0c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48zm40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faBracketCurly = {
  prefix: 'far',
  iconName: 'bracket-curly',
  icon: [
    256,
    512,
    ['bracket-curly-left'],
    '7b',
    'M64 120c0-48.6 39.4-88 88-88l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-22.1 0-40 17.9-40 40l0 45.5c0 23.3-9.3 45.7-25.8 62.2L57.9 256l28.3 28.3c16.5 16.5 25.8 38.9 25.8 62.2l0 45.5c0 22.1 17.9 40 40 40l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-48.6 0-88-39.4-88-88l0-45.5c0-10.6-4.2-20.8-11.7-28.3L7 273c-9.4-9.4-9.4-24.6 0-33.9l45.3-45.3c7.5-7.5 11.7-17.7 11.7-28.3L64 120z',
  ],
};
const faBracketCurlyLeft = faBracketCurly;
const faLobster = {
  prefix: 'far',
  iconName: 'lobster',
  icon: [
    512,
    512,
    [129438],
    'e421',
    'M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64l0 64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240l2.9 0 0 16-32.9 0c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4l32.9 0 0 16-53.6 0c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1l53.6 0 0 16-.9 0c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1l.9 0 23.8 66.6c-23.1 7.3-39.8 28.8-39.8 54.3c0 3.9 3.2 7.1 7.1 7.1l177.8 0c3.9 0 7.1-3.2 7.1-7.1c0-25.5-16.7-47-39.8-54.3L336 384l.9 0c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4l-.9 0 0-16 53.6 0c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5L336 304l0-16 32.9 0c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1L336 256l0-16 2.9 0c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5L432 72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9l0 64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192l-3.4 0c-2.6-22.5-16-42.9-31.5-59.2l0-52.1c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7l0 25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8l0-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7l0 52.1c-15.5 16.3-28.9 36.7-31.5 59.2l-3.4 0c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4l0-64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72L80 8.2zM262.2 448l-12.3 0L224 375.7 224 240l0-40c0-6.6 3.8-17 15.4-30.3c5.2-6 11-11.4 16.6-16c5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200l0 40 0 135.7L262.2 448z',
  ],
};
const faCartFlatbedEmpty = {
  prefix: 'far',
  iconName: 'cart-flatbed-empty',
  icon: [
    640,
    512,
    ['dolly-flatbed-empty'],
    'f476',
    'M0 24C0 10.7 10.7 0 24 0L72 0c30.9 0 56 25.1 56 56l0 352c0 4.4 3.6 8 8 8l72 0 288 0 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-192 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-24 0c-30.9 0-56-25.1-56-56L80 56c0-4.4-3.6-8-8-8L24 48C10.7 48 0 37.3 0 24z',
  ],
};
const faDollyFlatbedEmpty = faCartFlatbedEmpty;
const faColon = {
  prefix: 'far',
  iconName: 'colon',
  icon: [
    192,
    512,
    [],
    '3a',
    'M120 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 128zm96 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 384z',
  ],
};
const faCartArrowDown = {
  prefix: 'far',
  iconName: 'cart-arrow-down',
  icon: [
    576,
    512,
    [],
    'f218',
    'M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 24l0 102.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faWand = {
  prefix: 'far',
  iconName: 'wand',
  icon: [
    512,
    512,
    [],
    'f72a',
    'M459.1 48c-1.2 0-2.4 .4-3.3 1.3L52.4 414.7c-2.8 2.5-4.4 6.1-4.4 9.9c0 3.5 1.4 6.9 3.9 9.4L78 460.1c2.5 2.5 5.9 3.9 9.4 3.9c3.8 0 7.3-1.6 9.9-4.4L462.7 56.1c.8-.9 1.3-2.1 1.3-3.3c0-2.7-2.2-4.9-4.9-4.9zM423.6 13.7C433.4 4.9 446 0 459.1 0C488.3 0 512 23.7 512 52.9c0 13.1-4.9 25.8-13.7 35.5l-46.2 51c-2.7 2.9-4.1 6.8-4.1 10.7l0 25.9c0 8.8-7.2 16-16 16l-20.4 0c-4.5 0-8.8 1.9-11.9 5.3L132.9 491.8C121.3 504.7 104.8 512 87.5 512c-16.3 0-31.9-6.5-43.4-18L18 467.9C6.5 456.4 0 440.8 0 424.5c0-17.3 7.3-33.8 20.2-45.4l70.6-63.9c3.3-3 5.3-7.3 5.3-11.9L96 272c0-8.8 7.2-16 16-16l37.9 0c4 0 7.8-1.5 10.7-4.1l263-238.2z',
  ],
};
const faWalkieTalkie = {
  prefix: 'far',
  iconName: 'walkie-talkie',
  icon: [
    384,
    512,
    [],
    'f8ef',
    'M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72-8 0C25.1 96 0 121.1 0 152L0 305.4c0 10.6 4.2 20.8 11.7 28.3L32 353.9 32 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-102.1 20.3-20.3c7.5-7.5 11.7-17.7 11.7-28.3L384 152c0-30.9-25.1-56-56-56l-8 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0 0-72zm80 120l96 0 40 0c4.4 0 8 3.6 8 8l0 150.1-20.3 20.3c-7.5 7.5-11.7 17.7-11.7 28.3L304 456c0 4.4-3.6 8-8 8L88 464c-4.4 0-8-3.6-8-8l0-105.4c0-10.6-4.2-20.8-11.7-28.3L48 302.1 48 152c0-4.4 3.6-8 8-8l32 0 104 0zm-56 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faFilePen = {
  prefix: 'far',
  iconName: 'file-pen',
  icon: [
    576,
    512,
    [128221, 'file-edit'],
    'f31c',
    'M64 464l198.6 0-5.1 20.5c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 131.1-48 48L336 160l-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faFileEdit = faFilePen;
const faReceipt = {
  prefix: 'far',
  iconName: 'receipt',
  icon: [
    384,
    512,
    [129534],
    'f543',
    'M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24L0 488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8l0-464c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430L48 76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14 0 359.6-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM96 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faTablePicnic = {
  prefix: 'far',
  iconName: 'table-picnic',
  icon: [
    512,
    512,
    [],
    'e32d',
    'M88 64C74.7 64 64 74.7 64 88s10.7 24 24 24l71.4 0L106.3 240 24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.4 0 52 0 235.3 0 52 0 62.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-82.3 0L352.6 112l71.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64zM438.9 320l-52 0 46.9 113.2c5.1 12.2 19.1 18.1 31.4 13s18.1-19.1 13-31.4L438.9 320zm-313.8 0l-52 0L33.8 414.8c-5.1 12.2 .7 26.3 13 31.4s26.3-.7 31.4-13L125.1 320zm33.2-80l53.1-128 89.3 0 53.1 128-195.5 0z',
  ],
};
const faSquarePen = {
  prefix: 'far',
  iconName: 'square-pen',
  icon: [
    448,
    512,
    ['pen-square', 'pencil-square'],
    'f14b',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm325.8 43.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faPenSquare = faSquarePen;
const faPencilSquare = faSquarePen;
const faCircleMicrophoneLines = {
  prefix: 'far',
  iconName: 'circle-microphone-lines',
  icon: [
    512,
    512,
    ['microphone-circle-alt'],
    'e117',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-26.5 0-48 21.5-48 48l0 112c0 26.5 21.5 48 48 48s48-21.5 48-48l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-32-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-16c0-26.5-21.5-48-48-48zM176 256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 62.5 44.8 114.5 104 125.8l0 10.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-10.2c59.2-11.2 104-63.3 104-125.8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
  ],
};
const faMicrophoneCircleAlt = faCircleMicrophoneLines;
const faDisplaySlash = {
  prefix: 'far',
  iconName: 'display-slash',
  icon: [
    640,
    512,
    ['desktop-slash'],
    'e2fa',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9l0-288c0-35.3-28.7-64-64-64L96 0C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zm54.9 43c.7-.1 1.5-.2 2.3-.2l448 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-42.2 0L93.7 48.2zM80 352l0-192.8L32 121.4 32 352c0 35.3 28.7 64 64 64l147.7 0-8 48L184 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48 9.6 0L345 368l-72.6 0c-.2 0-.4 0-.6 0c-.1 0-.2 0-.3 0L96 368c-8.8 0-16-7.2-16-16zm212.3 64l55.3 0 8 48-71.3 0 8-48z',
  ],
};
const faDesktopSlash = faDisplaySlash;
const faSuitcaseRolling = {
  prefix: 'far',
  iconName: 'suitcase-rolling',
  icon: [
    384,
    512,
    [],
    'f5c1',
    'M144 56l0 72 96 0 0-72c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8zM96 128l0-72c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 72 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-160 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l32 0zM64 176c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L64 176zm32 72c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 112c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faPersonCircleExclamation = {
  prefix: 'far',
  iconName: 'person-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e53f',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z',
  ],
};
const faTransporter2 = {
  prefix: 'far',
  iconName: 'transporter-2',
  icon: [
    512,
    512,
    [],
    'e044',
    'M64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6L64 32zM480 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 352zM120 464l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM180.4 224l-60.2 0 46.4-61.2c16.6-21.9 42.6-34.8 70.1-34.8l38.6 0c27.5 0 53.5 12.9 70.1 34.8L391.8 224l-60.2 0L320 224l-48 0 0-48-32 0 0 48-48 0-11.6 0zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faUserHoodie = {
  prefix: 'far',
  iconName: 'user-hoodie',
  icon: [
    448,
    512,
    [],
    'e68a',
    'M321.1 259.4c-26.1 30.3-20 77.8 13.9 100.2c35 23 59.3 60.8 64.1 104.4L48.9 464C53.7 420.4 78 382.6 113 359.6c33.9-22.3 40-69.9 13.9-100.2C107.6 237 96 207.9 96 176c0-70.7 57.3-128 128-128s128 57.3 128 128c0 31.9-11.6 61-30.9 83.4zm36.4 31.3C384 259.9 400 219.8 400 176C400 78.8 321.2 0 224 0S48 78.8 48 176c0 43.8 16 83.9 42.5 114.7c7.4 8.6 5.5 22.5-4 28.8C34.4 353.8 0 412.9 0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32c0-67.1-34.4-126.2-86.6-160.5c-9.5-6.2-11.4-20.2-4-28.8zM176 352c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM144 176c0 45.8 40.9 83.4 64.2 101.1c9.4 7.1 22.1 7.1 31.5 0C263.1 259.4 304 221.8 304 176c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faHandsHoldingDiamond = {
  prefix: 'far',
  iconName: 'hands-holding-diamond',
  icon: [
    640,
    512,
    ['hand-receiving'],
    'f47c',
    'M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96zM72 64c39.8 0 72 32.2 72 72l0 128.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8L496 136c0-39.8 32.2-72 72-72s72 32.2 72 72l0 216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9L592 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9c0 0 0 0 0 0L473 393c0 0 0 0 0 0l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16c0 0 0 0 0 0l26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8l0 51.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359s0 0 0 0l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16c0 0 0 0 0 0l-26.7-26.7s0 0 0 0l-15.9-15.9C106.2 332.1 96 307.5 96 281.9L96 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2L0 136C0 96.2 32.2 64 72 64z',
  ],
};
const faHandReceiving = faHandsHoldingDiamond;
const faMoneyBillSimpleWave = {
  prefix: 'far',
  iconName: 'money-bill-simple-wave',
  icon: [
    576,
    512,
    [],
    'e1f2',
    'M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c73.7-18.9 160.5-41.1 248.8-20.9l0-291.7C461.8 68.7 393.6 83 310.3 104.1c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0C223.1 126.4 136.3 148.7 48 128.4l0 291.7c66.2 23.1 134.4 8.9 217.7-12.3zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z',
  ],
};
const faChevronDown = {
  prefix: 'far',
  iconName: 'chevron-down',
  icon: [
    512,
    512,
    [],
    'f078',
    'M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z',
  ],
};
const faBatteryFull = {
  prefix: 'far',
  iconName: 'battery-full',
  icon: [
    576,
    512,
    [128267, 'battery', 'battery-5'],
    'f240',
    'M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm368 96L96 192l0 128 352 0 0-128z',
  ],
};
const faBattery = faBatteryFull;
const faBattery5 = faBatteryFull;
const faBellPlus = {
  prefix: 'far',
  iconName: 'bell-plus',
  icon: [
    448,
    512,
    [],
    'f849',
    'M224 0c-17.7 0-32 14.3-32 32l0 17.9C119.5 61.4 64 124.2 64 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L256 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM224 152c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24z',
  ],
};
const faBookArrowRight = {
  prefix: 'far',
  iconName: 'book-arrow-right',
  icon: [
    640,
    512,
    [],
    'e0b9',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-56-48 0 0 56c0 4.4-3.6 8-8 8L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 72 48 0 0-72c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM553 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L280 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
  ],
};
const faHospitals = {
  prefix: 'far',
  iconName: 'hospitals',
  icon: [
    576,
    512,
    [],
    'f80e',
    'M320 48l192 0c8.8 0 16 7.2 16 16l0 192-208 0 0 48 208 0 0 48-208 0 0 48 208 0 0 48c0 8.8-7.2 16-16 16l-192 0c0 17.3-5.5 33.2-14.7 46.3c4.7 1.1 9.7 1.7 14.7 1.7l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L320 0c-35.3 0-64 28.7-64 64l0 1.6c19.5 4 36.5 15 48 30.4l0-32c0-8.8 7.2-16 16-16zm88 48l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM136 176c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0zM64 144l160 0c8.8 0 16 7.2 16 16l0 192L48 352l0-192c0-8.8 7.2-16 16-16zM48 400l192 0 0 48c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-48zM0 160L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160z',
  ],
};
const faClub = {
  prefix: 'far',
  iconName: 'club',
  icon: [
    512,
    512,
    [9827],
    'f327',
    'M352 146.4c0-.8 0-1.6 0-2.4c0-53-43-96-96-96s-96 43-96 96c0 .8 0 1.6 0 2.4c.6 22.9-15.1 42.9-37.4 48C79.9 204.1 48 242.4 48 288c0 53 43 96 96 96c30.1 0 57-13.8 74.7-35.7c9.1-11.3 22.8-17.8 37.3-17.8s28.2 6.5 37.3 17.8C311 370.2 337.9 384 368 384c53 0 96-43 96-96c0-45.6-31.9-83.9-74.6-93.6c-22.3-5.1-37.9-25.1-37.4-48zM368 432c-27.9 0-53.9-7.9-76-21.7c-4.1-2.6-8.1-5.4-12-8.3l0 62 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-62c-3.8 3-7.8 5.8-12 8.3c-22.1 13.7-48.1 21.7-76 21.7C64.5 432 0 367.5 0 288c0-68.5 47.9-125.9 112-140.4c0-1.2 0-2.4 0-3.6C112 64.5 176.5 0 256 0s144 64.5 144 144c0 1.2 0 2.4 0 3.6c64.1 14.5 112 71.9 112 140.4c0 79.5-64.5 144-144 144z',
  ],
};
const faSkullCrossbones = {
  prefix: 'far',
  iconName: 'skull-crossbones',
  icon: [
    448,
    512,
    [128369, 9760],
    'f714',
    'M290.1 185.8C309.6 170.4 320 149.5 320 128c0-39-37.5-80-96-80s-96 41-96 80c0 21.5 10.4 42.4 29.9 57.8c11.4 9.1 18.1 22.9 18.1 37.6l0 8.6c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-8.6c0-14.6 6.7-28.5 18.1-37.6zM320 232c0 30.9-25.1 56-56 56l-80 0c-30.9 0-56-25.1-56-56l0-8.6C98.5 200 80 165.9 80 128C80 57.3 144.5 0 224 0s144 57.3 144 128c0 37.9-18.5 72-48 95.4l0 8.6zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L224 357l188.9-98.2c11.8-6.1 26.2-1.5 32.4 10.2s1.5 26.3-10.2 32.4L276 384l159.1 82.7c11.8 6.1 16.3 20.6 10.2 32.4s-20.6 16.3-32.4 10.2L224 411 35.1 509.3c-11.8 6.1-26.3 1.5-32.4-10.2s-1.5-26.2 10.2-32.4L172 384 12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM160 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faDropletDegree = {
  prefix: 'far',
  iconName: 'droplet-degree',
  icon: [
    512,
    512,
    ['dewpoint'],
    'f748',
    'M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM400 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faDewpoint = faDropletDegree;
const faCodeCompare = {
  prefix: 'far',
  iconName: 'code-compare',
  icon: [
    512,
    512,
    [],
    'e13a',
    'M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 48 16 0c39.8 0 72-32.2 72-72l0-163.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3L456 320c0 66.3-53.7 120-120 120l-16 0 0 48zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-48-16 0c-39.8 0-72 32.2-72 72l0 163.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L56 192c0-66.3 53.7-120 120-120l16 0 0-48zM48 432a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faListUl = {
  prefix: 'far',
  iconName: 'list-ul',
  icon: [
    512,
    512,
    ['list-dots'],
    'f0ca',
    'M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 8c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
  ],
};
const faListDots = faListUl;
const faHandHoldingMagic = {
  prefix: 'far',
  iconName: 'hand-holding-magic',
  icon: [
    576,
    512,
    [],
    'f6e5',
    'M176 76c0 15.5 12.5 28 28 28l84 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0c-42 0-76-34-76-76s34-76 76-76L328 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-48 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l72 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L204 48c-15.5 0-28 12.5-28 28zm11.4 276c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faWatermelonSlice = {
  prefix: 'far',
  iconName: 'watermelon-slice',
  icon: [
    512,
    512,
    [],
    'e337',
    'M0 408c0-6.4 2.5-12.5 7-17L391 7c9.4-9.4 24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-4.5-4.5-7-10.6-7-17zm58.7-.8c97.4 80.4 241.5 75.3 332.6-15.8s96.2-235.2 15.8-332.6L384.8 81.2C414.3 118.1 432 165 432 216c0 119.3-96.7 216-216 216c-51 0-97.9-17.7-134.8-47.2L58.7 407.2zM384 216c0-37.7-12.4-72.6-33.4-100.6l-26.3 26.3 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-26.3 26.3c28 21 62.9 33.4 100.6 33.4c92.8 0 168-75.2 168-168zm-52.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
  ],
};
const faCircleEllipsis = {
  prefix: 'far',
  iconName: 'circle-ellipsis',
  icon: [
    512,
    512,
    [],
    'e10a',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
  ],
};
const faSchoolLock = {
  prefix: 'far',
  iconName: 'school-lock',
  icon: [
    640,
    512,
    [],
    'e56f',
    'M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92L568 96c39.8 0 72 32.2 72 72l0 104c0-38.1-19-71.7-48-91.9l0-12.1c0-13.3-10.7-24-24-24l-104 0c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4L72 144c-13.3 0-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l184 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 0 16c0 11.7 3.1 22.6 8.6 32l-8.6 0-128 0L72 512c-39.8 0-72-32.2-72-72L0 168c0-39.8 32.2-72 72-72l96.7 0 138-92zM112 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-8.8-7.2-16-16-16zm208 96c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z',
  ],
};
const faTowerCell = {
  prefix: 'far',
  iconName: 'tower-cell',
  icon: [
    576,
    512,
    [],
    'e585',
    'M51.8 1.6c12.4 4.8 18.5 18.7 13.8 31C54.3 62 48 94.2 48 128s6.3 66 17.6 95.4c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8C7.4 205.8 0 167.8 0 128S7.4 50.2 20.8 15.4C25.6 3 39.5-3.2 51.8 1.6zm472.4 0c12.4-4.8 26.3 1.4 31 13.8C568.6 50.2 576 88.2 576 128s-7.4 77.8-20.8 112.6c-4.8 12.4-18.7 18.5-31 13.8s-18.5-18.7-13.8-31C521.7 194 528 161.8 528 128s-6.3-66-17.6-95.4c-4.8-12.4 1.4-26.3 13.8-31zM291.3 191.9c-1.1 .1-2.2 .1-3.3 .1s-2.2 0-3.3-.1L239.8 288l96.4 0-44.8-96.1zM195 384l186 0-22.4-48-141.2 0L195 384zm-22.4 48l-30.9 66.2c-5.6 12-19.9 17.2-31.9 11.6s-17.2-19.9-11.6-31.9L241.2 171.6C230.5 160.2 224 144.9 224 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 16.9-6.5 32.2-17.2 43.6L477.7 477.9c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L403.4 432l-230.8 0zM163.3 73.6C156 90.2 152 108.6 152 128s4 37.8 11.3 54.4c5.3 12.1-.2 26.3-12.4 31.6s-26.3-.2-31.6-12.4C109.5 179 104 154.1 104 128s5.5-51 15.3-73.6c5.3-12.1 19.5-17.7 31.6-12.4s17.7 19.5 12.4 31.6zM456.7 54.4C466.5 77 472 101.9 472 128s-5.5 51-15.3 73.6c-5.3 12.1-19.5 17.7-31.6 12.4s-17.7-19.5-12.4-31.6c7.3-16.6 11.3-35 11.3-54.4s-4-37.8-11.3-54.4c-5.3-12.1 .2-26.3 12.4-31.6s26.3 .2 31.6 12.4z',
  ],
};
const faSdCards = {
  prefix: 'far',
  iconName: 'sd-cards',
  icon: [
    448,
    512,
    [],
    'e240',
    'M400 352l0-288c0-8.8-7.2-16-16-16L234.5 48c-4.2 0-8.3 1.7-11.3 4.7l-74.5 74.5c-3 3-4.7 7.1-4.7 11.3L144 352c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16zM114.7 93.3l74.5-74.5C201.3 6.7 217.5 0 234.5 0L384 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-213.5c0-17 6.7-33.3 18.7-45.3zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm280 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faJugBottle = {
  prefix: 'far',
  iconName: 'jug-bottle',
  icon: [
    640,
    512,
    [],
    'e5fb',
    'M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72s10.7-24 24-24l8 0 0-24zm32 152c-44.2 0-80 35.8-80 80l0 192c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192c0-44.2-35.8-80-80-80l-128 0zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm224 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zM472 64l80 0c13.3 0 24 10.7 24 24l0 40-128 0 0-40c0-13.3 10.7-24 24-24zM417 392c-.3-.2-.7-.4-1-.6L416 256c0-24.7-5.6-48.1-15.6-69c5.1-5.3 11.1-9.8 18-13l13.2-6.2c11-5.1 23-7.8 35.1-7.8l90.6 0c12.1 0 24.1 2.7 35.1 7.8l13.2 6.2c21 9.9 34.4 31 34.4 54.2c0 22.8-12.7 42.6-31.5 52.7C627.4 292 640 312.5 640 336c0 24.1-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56c0 35.3-28.7 64-64 64l-128 0c-17 0-32.5-6.7-44-17.5c7.6-13.8 12-29.6 12-46.5l0-55.4c.3-.2 .7-.4 1-.6z',
  ],
};
const faDownLong = {
  prefix: 'far',
  iconName: 'down-long',
  icon: [
    320,
    512,
    ['long-arrow-alt-down'],
    'f309',
    'M176.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L14.6 384.1C5.3 375.3 0 363.1 0 350.3C0 324.7 20.7 304 46.3 304L80 304 80 56c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 248 33.7 0c25.6 0 46.3 20.7 46.3 46.3c0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5L216 352c-13.3 0-24-10.7-24-24l0-272c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 272c0 6.4-2.5 12.5-7 17s-10.6 7-17 7l-53.5 0L160 455 269.5 352z',
  ],
};
const faLongArrowAltDown = faDownLong;
const faEnvelopes = {
  prefix: 'far',
  iconName: 'envelopes',
  icon: [
    576,
    512,
    [],
    'e170',
    'M512 80L160 80c-8.8 0-16 7.2-16 16l0 7.8L321.4 235.2c4.2 3.1 9.3 4.8 14.6 4.8s10.4-1.7 14.6-4.8L528 103.8l0-7.8c0-8.8-7.2-16-16-16zm16 83.5L379.1 273.8C366.7 283 351.5 288 336 288s-30.7-5-43.1-14.2L144 163.5 144 320c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-156.5zM160 32l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0C60.9 480 0 419.1 0 344L0 120c0-13.3 10.7-24 24-24z',
  ],
};
const faPhoneOffice = {
  prefix: 'far',
  iconName: 'phone-office',
  icon: [
    576,
    512,
    [],
    'f67d',
    'M160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-48 0zM104.6 32C115.6 12.9 136.3 0 160 0l48 0c23.7 0 44.4 12.9 55.4 32L320 32l24 0 24 0 144 0c35.3 0 64 28.7 64 64l0 48 0 24 0 24 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l40.6 0zM96 80L64 80c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256-168 0c-22.1 0-40-17.9-40-40l0-72-48 0 0 272c0 35.3-28.7 64-64 64l-48 0c-35.3 0-64-28.7-64-64L96 80zm272 0l0 64 160 0 0-48c0-8.8-7.2-16-16-16L368 80zm16 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM448 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
  ],
};
const faRankingStar = {
  prefix: 'far',
  iconName: 'ranking-star',
  icon: [
    640,
    512,
    [],
    'e561',
    'M353.8 54.1l52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8zM272 304l0 160 96 0 0-160-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM48 368l0 96 96 0 0-96-96 0zM0 368c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm592 32l-96 0 0 64 96 0 0-64zm-96-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z',
  ],
};
const faChessKing = {
  prefix: 'far',
  iconName: 'chess-king',
  icon: [
    448,
    512,
    [9818],
    'f43f',
    'M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 40L59.6 144C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352l52.3 0L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6L224 192l164.4 0c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352l52.3 0 54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L248 144l0-40 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM101.2 432l245.6 0 16.6 32L84.7 464l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z',
  ],
};
const faNfcPen = {
  prefix: 'far',
  iconName: 'nfc-pen',
  icon: [
    576,
    512,
    [],
    'e1fa',
    'M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l206.5 0-12 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 139.6-48 48L400 96c0-8.8-7.2-16-16-16zM289.3 394.3c-1.8 1.8-3.5 3.7-5 5.7L120 400c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 192 0 0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40l0 163.6-78.7 78.7zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faPersonHarassing = {
  prefix: 'far',
  iconName: 'person-harassing',
  icon: [
    576,
    512,
    [],
    'e549',
    'M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 209.5L44.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1S-3.4 287.7 3.1 276.2L61.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l35 0c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L224 214.2 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1L144 176l0 128 32 0 0-127.9zM304 32l56 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm116 56c33.1 0 60 26.9 60 60l0 96c0 31.8-24.7 57.8-56 59.9l0 .1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L456 413l0-57c0-33.1 26.9-60 60-60zm1.4 167.9c6-.7 10.6-5.8 10.6-11.9l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12l0 96c0 5.2 3.2 9.5 7.8 11.2c1.8 .3 3.7 .6 5.6 .7zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z',
  ],
};
const faMagnifyingGlassPlay = {
  prefix: 'far',
  iconName: 'magnifying-glass-play',
  icon: [
    512,
    512,
    [],
    'e660',
    'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1zM161.8 130.1c5-2.9 11.1-2.8 16 0l110.2 64c4.9 2.9 8 8.1 8 13.8s-3 11-8 13.8l-110.2 64c-4.9 2.9-11.1 2.9-16 0s-8-8.1-8-13.9l0-128c0-5.7 3.1-11 8-13.9z',
  ],
};
const faHatWinter = {
  prefix: 'far',
  iconName: 'hat-winter',
  icon: [
    512,
    512,
    [],
    'f7a8',
    'M256 0c-12.7 0-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C279 9.8 268.7 0 256 0zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416zM162.5 134.6C42.8 199.9 32 384 32 384l48.1 0c.1-1.5 .3-3.7 .6-6.3c.7-6.5 2-16 4.2-27.4c.9-4.9 2-10.1 3.2-15.5l36.3-18.1c2.3-1.1 4.9-1.1 7.2 0L167 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0L295 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0l36.3 18.1c1.2 5.4 2.3 10.6 3.2 15.5c2.1 11.5 3.4 21 4.2 27.4c.3 2.6 .5 4.7 .6 6.3l48.1 0s-10.8-184.1-130.5-249.4c-2.5 9-7.3 17.5-14.4 24.6c-5.6 5.6-12.2 9.8-19.2 12.6c41 17.8 67.7 53.9 86 95.6c.6 1.3 1.2 2.7 1.7 4c-14.5-5.5-30.8-4.7-44.9 2.3l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L281 273.7c-15.8-7.9-34.3-7.9-50.1 0l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L153 273.7c-14.1-7-30.3-7.8-44.9-2.3c.6-1.3 1.2-2.7 1.7-4c18.4-41.7 45.1-77.8 86-95.6c-7-2.7-13.5-6.9-19.2-12.6c-7.1-7.1-11.9-15.6-14.4-24.6z',
  ],
};
const faBrazilianRealSign = {
  prefix: 'far',
  iconName: 'brazilian-real-sign',
  icon: [
    512,
    512,
    [],
    'e46c',
    'M400 0c13.3 0 24 10.7 24 24l0 41.2c14.6 1.7 29 5.4 42.7 10.9l14.2 5.7c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-14.3-5.7c-14.2-5.7-29.3-8.6-44.6-8.6L392 112c-30.9 0-56 25.1-56 56c0 23.5 14.7 44.6 36.8 52.6l70.7 25.7c41.1 14.9 68.4 54 68.4 97.7c0 52-38.2 95.1-88 102.8l0 41.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-42.2c-17.1-3-33.7-8.9-48.9-17.6l-27-15.4c-11.5-6.6-15.5-21.2-8.9-32.7s21.2-15.5 32.7-8.9l27 15.4c15.4 8.8 32.8 13.4 50.6 13.4l6.6 0c30.9 0 56-25.1 56-56c0-23.5-14.7-44.6-36.8-52.6l-70.7-25.7c-41.1-14.9-68.4-54-68.4-97.7c0-52 38.2-95.1 88-102.8L376 24c0-13.3 10.7-24 24-24zM0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176z',
  ],
};
const faLandmarkDome = {
  prefix: 'far',
  iconName: 'landmark-dome',
  icon: [
    512,
    512,
    ['landmark-alt'],
    'f752',
    'M256 0c13.3 0 24 10.7 24 24l0 9.5C369.5 44.6 439.9 117.4 447.3 208l8.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-288 0-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8.7 0C72.1 117.4 142.5 44.6 232 33.5l0-9.5c0-13.3 10.7-24 24-24zM112.9 208l286.2 0c-8-72-69-128-143.1-128s-135.2 56-143.1 128zm-.9 80l0 96 64 0 0-96 48 0 0 96 64 0 0-96 48 0 0 96 64 0 0-96 48 0 0 96 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L64 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-96 48 0zM8 488c0-13.3 10.7-24 24-24l456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 512c-13.3 0-24-10.7-24-24z',
  ],
};
const faLandmarkAlt = faLandmarkDome;
const faBoneBreak = {
  prefix: 'far',
  iconName: 'bone-break',
  icon: [
    640,
    512,
    [],
    'f5d8',
    'M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM296.1 264.8c-1.9-13.4-14.5-22.6-27.9-20.2L180.1 260c-4.1 .7-8-1.8-9.4-5.7c-14.3-39.1-55.3-63.6-98-56.1C24.9 206.6-7.1 251.8 1.4 299.3c4.5 25.1 19.3 45.7 39.4 58.4c4.7 3 5.8 9.5 2.5 13.9c-14.5 18.7-21.3 43.2-16.8 68.3c8.4 47.5 54.1 79.1 101.9 70.8c42.7-7.5 72.8-44.4 72.7-86c0-4.1 2.8-7.8 6.9-8.5L320 396.6l112.1 19.6c4.1 .7 6.9 4.4 6.9 8.5c-.1 41.6 30 78.5 72.7 86c47.9 8.4 93.5-23.3 101.9-70.8c4.5-25.1-2.4-49.5-16.8-68.3c-3.4-4.4-2.2-11 2.5-13.9c20.1-12.7 34.9-33.4 39.4-58.4c8.4-47.5-23.5-92.7-71.4-101.1c-42.7-7.5-83.7 17-98 56.1c-1.4 3.9-5.3 6.4-9.4 5.7l-88.1-15.4c-13.3-2.3-26 6.8-27.9 20.2c-1.8 12.8 6.9 24.8 19.6 27l88.1 15.4c29.1 5.1 54.1-12.9 62.8-36.5c6.4-17.4 24.9-28.7 44.6-25.3c22.1 3.9 36.1 24.4 32.4 45.4c-2 11.2-8.5 20.4-17.8 26.3c-28.5 18-35.6 57-14.8 83.8c6.6 8.5 9.5 19.4 7.6 30.5c-3.7 21.1-24.3 35.8-46.4 31.9c-19.6-3.4-33-20.2-33-38.6c0-25.3-17.4-50.8-46.6-55.9L324.8 348.7c-1.6-.3-3.2-.4-4.8-.4c-1.6 0-3.2 .1-4.8 .4L199.7 368.9C170.5 374 153 399.5 153 424.8c0 18.4-13.4 35.2-33 38.6c-22.2 3.9-42.7-10.8-46.4-31.9c-2-11.1 1-22 7.6-30.5c20.8-26.9 13.7-65.9-14.8-83.8c-9.2-5.8-15.8-15.1-17.8-26.3c-3.7-20.9 10.3-41.5 32.4-45.4c19.7-3.4 38.3 7.9 44.6 25.3c8.6 23.6 33.7 41.6 62.8 36.5l88.1-15.4c12.8-2.2 21.5-14.2 19.6-27z',
  ],
};
const faArrowUp = {
  prefix: 'far',
  iconName: 'arrow-up',
  icon: [
    384,
    512,
    [8593],
    'f062',
    'M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z',
  ],
};
const faDownFromDottedLine = {
  prefix: 'far',
  iconName: 'down-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e407',
    'M114.2 320L224 430 333.8 320 280 320c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 480c-11.5 0-22.5-4.6-30.6-12.7L77.6 351.2C68.9 342.5 64 330.7 64 318.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faTv = {
  prefix: 'far',
  iconName: 'tv',
  icon: [
    640,
    512,
    [63717, 'television', 'tv-alt'],
    'f26c',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM120 464l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faTelevision = faTv;
const faTvAlt = faTv;
const faBorderLeft = {
  prefix: 'far',
  iconName: 'border-left',
  icon: [
    448,
    512,
    [],
    'f84f',
    'M24 480c-13.3 0-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24zm104-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
  ],
};
const faCircleDivide = {
  prefix: 'far',
  iconName: 'circle-divide',
  icon: [
    512,
    512,
    [],
    'e106',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faShrimp = {
  prefix: 'far',
  iconName: 'shrimp',
  icon: [
    512,
    512,
    [129424],
    'e448',
    'M0 104C0 64.2 32.2 32 72 32l352 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l264 0c97.2 0 176 78.8 176 176s-78.8 176-176 176l-88 0c-13.3 0-24-10.7-24-24c0-12 8.8-21.9 20.2-23.7l-4.9-1.9c-12.4-4.8-18.5-18.7-13.7-31.1s18.7-18.5 31.1-13.7l68.7 26.7c20.5 8 42.6-7.1 42.6-29.1c0-17.3-14-31.2-31.2-31.2l-77.3 0C158 352 74.5 274.6 64.9 175.7C28.5 172.1 0 141.4 0 104zM464 304c0-9.3-1-18.4-2.9-27.2L401 336.9c9.4 13 15 29 15 46.3c0 8.2-1.2 16-3.4 23.4C443.8 383.3 464 346 464 304zm-23.7-74.2c-21.8-30.5-56.6-51.1-96.3-53.5l0 128.1c6.2 .6 12.2 1.8 18 3.8l78.3-78.3zM296 176l-182.7 0c9.5 72.2 71.4 128 146.2 128l36.5 0 0-128zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faListCheck = {
  prefix: 'far',
  iconName: 'list-check',
  icon: [
    512,
    512,
    ['tasks'],
    'f0ae',
    'M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 72c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faTasks = faListCheck;
const faDiagramSubtask = {
  prefix: 'far',
  iconName: 'diagram-subtask',
  icon: [
    512,
    512,
    [],
    'e479',
    'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-296 0 0 96c0 22.1 17.9 40 40 40l32 0 0-8c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-8-32 0c-48.6 0-88-39.4-88-88l0-96-40 0c-35.3 0-64-28.7-64-64L0 96zM448 336l-160 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z',
  ],
};
const faJugDetergent = {
  prefix: 'far',
  iconName: 'jug-detergent',
  icon: [
    384,
    512,
    [],
    'e519',
    'M120 0C106.7 0 96 10.7 96 24l0 24-8 0C74.7 48 64 58.7 64 72s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24c0-13.3-10.7-24-24-24L120 0zM256 176c44.2 0 80 35.8 80 80l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-44.2 35.8-80 80-80l128 0zM128 128C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm128 96c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32z',
  ],
};
const faCircleUser = {
  prefix: 'far',
  iconName: 'circle-user',
  icon: [
    512,
    512,
    [62142, 'user-circle'],
    'f2bd',
    'M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z',
  ],
};
const faUserCircle = faCircleUser;
const faSquareY = {
  prefix: 'far',
  iconName: 'square-y',
  icon: [
    448,
    512,
    [],
    'e287',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm138.1 56.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z',
  ],
};
const faUserDoctorHair = {
  prefix: 'far',
  iconName: 'user-doctor-hair',
  icon: [
    448,
    512,
    [],
    'e458',
    'M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32zM96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm64 225c5.2-.7 10.6-1 16-1l96 0c5.4 0 10.8 .3 16 1l0 49c-27.6 7.1-48 32.2-48 62l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-32c0-29.8-20.4-54.9-48-62l0-40.7c46.9 19 80 65 80 118.7l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-97.2-78.8-176-176-176l-96 0C78.8 304 0 382.8 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-53.7 33.1-99.7 80-118.7l0 41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-49.3zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPlanetRinged = {
  prefix: 'far',
  iconName: 'planet-ringed',
  icon: [
    512,
    512,
    [129680],
    'e020',
    'M464 31.1c0 0 .1 .2 .1 .8c-.1-.5-.1-.8-.1-.8zm-5.2 22.1c-11.9 4.4-27 11.5-45 21.9c-13.4-11.8-27.9-21.8-43-30c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c8.3 15.1 18.3 29.6 30 43c-10.4 18-17.6 33-21.9 45c12.6-4.6 28.7-12.3 48.1-23.8c8.2-4.8 16.7-10.2 25.4-16C78.8 380.9 48 322 48 256C48 141.1 141.1 48 256 48c66 0 124.9 30.8 163 78.8c5.8-8.8 11.2-17.3 16-25.4c11.4-19.4 19.2-35.5 23.8-48.1zM389.6 167.9C361 124.6 311.8 96 256 96C167.6 96 96 167.6 96 256c0 55.8 28.6 105 71.9 133.6c37.1-28.2 77.4-63.4 117.8-103.8s75.6-80.8 103.8-117.8zM217.9 411.4c12.2 3 25 4.6 38.1 4.6c88.4 0 160-71.6 160-160c0-13.1-1.6-25.9-4.6-38.1c-26.5 33-57.4 67.5-91.7 101.8s-68.8 65.2-101.8 91.7zM31.1 464c0 0 .3 0 .8 .1c-.6 0-.8 0-.8-.1zm16.8 16c.1 .5 .1 .8 .1 .8s-.1-.2-.1-.8zM480 47.9c.6 0 .8 0 .8 .1s-.3 0-.8-.1z',
  ],
};
const faMushroom = {
  prefix: 'far',
  iconName: 'mushroom',
  icon: [
    512,
    512,
    [127812],
    'e425',
    'M24 258.1C24 133.2 125.2 32 250.1 32l11.8 0C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9l-105.5 0-129.1 0L85.9 320C51.7 320 24 292.3 24 258.1zm416 0c0-12-1.2-23.7-3.4-35C427.8 233.4 414.6 240 400 240c-26.5 0-48-21.5-48-48c0-26.1 20.8-47.3 46.7-48c-24.2-29-57.5-50.2-95.4-59.2c.5 3.7 .8 7.4 .8 11.2c0 44.2-35.8 80-80 80c-38.1 0-70-26.7-78.1-62.4C101.2 146 72 198.6 72 258.1c0 7.7 6.2 13.9 13.9 13.9l340.2 0c7.7 0 13.9-6.2 13.9-13.9zM234.3 352l-15 80 73.4 0-15-80 48.8 0 16.9 90.1c1.8 9.4-.7 19-6.8 26.3s-15.1 11.6-24.6 11.6l-112 0c-9.5 0-18.5-4.2-24.6-11.6s-8.6-17-6.8-26.3L185.4 352l48.8 0zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faUserShield = {
  prefix: 'far',
  iconName: 'user-shield',
  icon: [
    640,
    512,
    [],
    'f505',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l325.4 0c13.2 17.2 29.3 33.4 48.9 47.5c-1.7 .3-3.5 .5-5.3 .5L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c17.6 0 34.6 2.6 50.7 7.3c.9 16.6 3.4 35.3 8.3 54.8c-17.7-9-37.8-14.1-59-14.1l-91.4 0c-65.7 0-120.1 48.7-129 112zM487.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C634 277.4 640 286.2 640 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48zM591.4 312L496 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z',
  ],
};
const faMegaphone = {
  prefix: 'far',
  iconName: 'megaphone',
  icon: [
    576,
    512,
    [128227],
    'f675',
    'M552 32c-13.3 0-24 10.7-24 24l0 5.7L48 192.6l0-8.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21.7L0 224l0 64 0 18.3L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8.6 117.6 32.1C162 361.7 160 372.6 160 384c0 53 43 96 96 96c46.9 0 86-33.6 94.3-78.1L528 450.3l0 5.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-352 0-24c0-13.3-10.7-24-24-24zM528 400.6L48 269.7l0-27.3L528 111.4l0 289.2zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8c-26.5 0-48-21.5-48-48z',
  ],
};
const faWreathLaurel = {
  prefix: 'far',
  iconName: 'wreath-laurel',
  icon: [
    640,
    512,
    [],
    'e5d2',
    'M237.1 50.9l-11.8 .7c-20.3 1.1-36.6 17.4-37.7 37.7l-.7 11.8 11.8-.7c20.3-1.1 36.6-17.4 37.7-37.7l.7-11.8zM43.1 177.7c-11.4-30.3-9.7-65.3 7.8-95.6L71.5 46.4c6.3-10.9 20.2-14.6 31-8.3c15.9 9.2 28.9 21.4 38.8 35.5c8-38.5 41-67.7 81.3-70l38.6-2.1c14.3-.8 26.1 11 25.3 25.3l-2.1 38.6c-2.5 44.8-38.2 80.5-83 83l-24.6 1.4C155.6 180.8 144 217.8 144 256c0 97.2 78.8 176 176 176l11.6 0c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480L320 480l-11.6 0c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2c-5.5-3.1-10.8-6.5-15.9-10.1l-4.8 2.8-.3 .2c-4.6 2.7-9.4 4.9-14.2 6.9c-50.9 20.4-110.3 .8-138.5-48L14.2 366.4c-6.3-10.9-2.6-24.8 8.3-31c6-3.5 12.2-6.4 18.5-8.7C16 306.1 0 274.9 0 240l0-41.2C0 186.2 10.2 176 22.7 176c7 0 13.8 .6 20.4 1.7zm420-28l-24.6-1.4c-44.8-2.5-80.5-38.2-83-83l-2.1-38.6c-.8-14.3 11-26.1 25.3-25.3l38.6 2.1c40.3 2.2 73.3 31.5 81.3 70c9.9-14.1 22.9-26.3 38.8-35.5c10.9-6.3 24.8-2.6 31 8.3l20.6 35.7c17.5 30.3 19.2 65.3 7.8 95.6c6.6-1.1 13.4-1.7 20.4-1.7c12.6 0 22.7 10.2 22.7 22.7l0 41.2c0 34.9-16 66.1-41.1 86.7c6.3 2.3 12.5 5.2 18.5 8.7c10.9 6.3 14.6 20.2 8.3 31l-20.6 35.7c-21.6 37.4-61.5 57.6-101.8 55.9c-5.3-8.3-12.8-15.4-22.3-20.1l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-38.2-11.6-75.2-32.8-106.3zM414.7 51.6l-11.8-.7 .7 11.8c1.1 20.3 17.4 36.6 37.7 37.7l11.8 .7-.7-11.8c-1.1-20.3-17.4-36.6-37.7-37.7zM96 301.9l0-4.7c0-31.6-20-58.5-48-68.8L48 240c0 29.8 20.4 54.9 48 62zM544 297.2l0 4.7c27.6-7.1 48-32.2 48-62l0-11.5c-28 10.3-48 37.2-48 68.8zM149 407.8l-2.4-4.1c-15.8-27.3-46.5-40.6-75.9-35.6l5.7 9.9c14.9 25.8 45.1 37.3 72.5 29.7zM105.4 179.7c15.8-27.3 11.9-60.6-7.2-83.5l-5.7 9.9c-14.9 25.8-9.8 57.7 10.6 77.7l2.4-4.1zM537 183.8c20.3-20 25.5-51.8 10.6-77.7l-5.7-9.9c-19.1 22.9-22.9 56.2-7.2 83.5l2.4 4.1zM491 407.8c27.4 7.6 57.6-3.9 72.5-29.7l5.7-9.9c-29.4-5.1-60.1 8.2-75.9 35.6l-2.4 4.1z',
  ],
};
const faCircleExclamationCheck = {
  prefix: 'far',
  iconName: 'circle-exclamation-check',
  icon: [
    640,
    512,
    [],
    'e10d',
    'M48 256C48 141.1 141.1 48 256 48c84.1 0 156.7 50 189.4 121.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8C448.8 61.6 359.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c72.9 0 138.8-30.5 185.4-79.4c9.1-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8C368.7 439.2 315.3 464 256 464C141.1 464 48 370.9 48 256zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 175c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209c9.4-9.4 9.4-24.6 0-33.9z',
  ],
};
const faWind = {
  prefix: 'far',
  iconName: 'wind',
  icon: [
    512,
    512,
    [],
    'f72e',
    'M288 24c0 13.3 10.7 24 24 24l44 0c24.3 0 44 19.7 44 44s-19.7 44-44 44L24 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l332 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L312 0c-13.3 0-24 10.7-24 24zm64 368c0 13.3 10.7 24 24 24l44 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l396 0c24.3 0 44 19.7 44 44s-19.7 44-44 44l-44 0c-13.3 0-24 10.7-24 24zM120 512l44 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L24 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l140 0c24.3 0 44 19.7 44 44s-19.7 44-44 44l-44 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z',
  ],
};
const faBoxDollar = {
  prefix: 'far',
  iconName: 'box-dollar',
  icon: [
    448,
    512,
    ['box-usd'],
    'f4a0',
    'M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zm-5.7 128L400 208l0 208c0 8.8-7.2 16-16 16l-141.7 0c1.1-2.5 1.7-5.2 1.7-8l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9c0-2.8-.6-5.6-1.7-8zm-36.7 0c-1.1 2.4-1.7 5.2-1.7 8l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 2.8 .6 5.5 1.7 8L64 432c-8.8 0-16-7.2-16-16l0-208 157.7 0zM200 160L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70z',
  ],
};
const faBoxUsd = faBoxDollar;
const faCarBurst = {
  prefix: 'far',
  iconName: 'car-burst',
  icon: [
    640,
    512,
    ['car-crash'],
    'f5e1',
    'M197.2 20.7l30.1 56.7 63.1-11.8c1-.2 2.1-.3 3.1-.4c-3.6 4.1-7 8.4-10.2 13l-29.3 43-35.2 6.6c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c1.9-1.4 3.9-2.4 6-3.2l-19.5 72.7-24 17.7c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8s17 4.9 21.2 12.7zM536.5 148.5l-137-36.7c-16.4-4.4-33.8 2.1-43.4 16.1l-31 45.5c1.3 .3 2.5 .6 3.8 .9l237.6 63.7c1.3 .3 2.5 .7 3.7 1.1L566 184.1c-1.3-17-13.1-31.2-29.5-35.6zm77.4 32.1l7.2 96.4c15 22.2 20.7 50.6 13.2 78.6l-12.3 46-6.9 25.7-5.5 20.7-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.4-14.2-14.5-25.1l12.4-46.3-6.7-1.8L232.9 346.9l-6.7-1.8-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3 12.4-46.4 12.3-46c7.5-28 26.6-49.7 50.7-61.5l54.5-79.9c21.1-30.9 59.4-45.1 95.5-35.4l137 36.7c36.1 9.7 62.2 41.1 65 78.4zM554 284.3L316.4 220.6c-25.6-6.9-51.9 8.3-58.8 33.9l-12.3 46 330.3 88.5 12.3-46c6.9-25.6-8.3-51.9-33.9-58.8zm14.3 53.3a27.4 27.4 0 1 1 -52.9-14.2 27.4 27.4 0 1 1 52.9 14.2zM310.9 240.3a27.4 27.4 0 1 1 -14.2 52.9 27.4 27.4 0 1 1 14.2-52.9z',
  ],
};
const faCarCrash = faCarBurst;
const faY = {
  prefix: 'far',
  iconName: 'y',
  icon: [
    384,
    512,
    [121],
    '59',
    'M43.4 41.9C35.7 31.2 20.7 28.8 9.9 36.6S-3.2 59.3 4.6 70.1L168 295.8 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160.2L379.4 70.1c7.8-10.7 5.4-25.7-5.4-33.5s-25.7-5.4-33.5 5.4L192 247.1 43.4 41.9z',
  ],
};
const faUserHeadset = {
  prefix: 'far',
  iconName: 'user-headset',
  icon: [
    448,
    512,
    [],
    'f82d',
    'M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.6 0c-2.7-4.7-6.1-9.1-9.9-12.9C297.1 229.2 304 211.4 304 192c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352l16 0 16 0 57.4 0 6.6 0 9.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0 57.4 0zm105.6 48l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0c-9.9-36.9-43.5-64-83.5-64z',
  ],
};
const faArrowsRetweet = {
  prefix: 'far',
  iconName: 'arrows-retweet',
  icon: [
    640,
    512,
    ['retweet-alt'],
    'f361',
    'M145 71c-9.4-9.4-24.6-9.4-33.9 0L23 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L104 328c0 48.6 39.4 88 88 88l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0c-22.1 0-40-17.9-40-40l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 71zM312 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c22.1 0 40 17.9 40 40l0 182.1-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L536 184c0-48.6-39.4-88-88-88L312 96z',
  ],
};
const faRetweetAlt = faArrowsRetweet;
const faPersonSnowboarding = {
  prefix: 'far',
  iconName: 'person-snowboarding',
  icon: [
    512,
    512,
    [127938, 'snowboarding'],
    'f7ce',
    'M204.3 3c11.6-6.4 26.2-2.3 32.6 9.3l31.9 57.4c1.3 2.3 3.6 3.8 6.2 4.1l33.8 3.4c24.1 2.4 46.9 12 65.4 27.6L503.5 213.6c10.1 8.5 11.4 23.7 2.9 33.8s-23.7 11.4-33.8 2.9l-68.2-57.5-82.3 43.9 24.7 18.9c24.9 19 34.6 51.9 24.1 81.4l-28.2 79c-1.4 3.8-3.6 7-6.3 9.6l93.3 35.7c4.6 1.8 9.4 2.6 14.3 2.6l28.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-28.2 0c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l19.4 7.4c-2.9-11.4 2.9-23.4 14-28.1L192 272l0-68.2c0-21.2 12-40.6 31-50.1L284.4 123l-14.1-1.4c-18.3-1.8-34.5-12.5-43.4-28.5L195 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm91.8 407.2c-.3-3.4 .1-6.9 1.3-10.3l28.2-79c3.5-9.8 .3-20.8-8-27.1L240 234.4l0 42.9c0 16.1-9.7 30.7-24.6 36.9L134 348.2l162.1 62.1zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5L259.6 189zM384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faSnowboarding = faPersonSnowboarding;
const faSquareChevronRight = {
  prefix: 'far',
  iconName: 'square-chevron-right',
  icon: [
    448,
    512,
    ['chevron-square-right'],
    'f32b',
    'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z',
  ],
};
const faChevronSquareRight = faSquareChevronRight;
const faLacrosseStickBall = {
  prefix: 'far',
  iconName: 'lacrosse-stick-ball',
  icon: [
    576,
    512,
    [],
    'e3b6',
    'M344 48s0 0 0 0l.3 0c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8l0 .3s0 0 0 0c0 37.4-24 70.7-59.5 82.5l-19.7 6.6c-18.9 6.3-36.5 16-51.9 28.6l-42 34.4c-12.6 10.3-28.3 15.9-44.5 15.9c-38.8 0-70.3-31.5-70.3-70.3c0-16.2 5.6-32 15.9-44.5l34.4-42c12.6-15.4 22.3-33 28.6-51.9l6.6-19.7C273.3 72 306.6 48 344 48zm0-48s0 0 0 0C285.9 0 234.3 37.2 215.9 92.3L209.4 112c-4.5 13.4-11.3 25.8-20.2 36.7l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 24 7.1 46.3 19.4 65L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L181.4 364.6c18.6 12.3 41 19.4 65 19.4c27.3 0 53.8-9.4 74.9-26.7l42-34.4c10.9-8.9 23.3-15.8 36.7-20.2l19.7-6.6c55.1-18.4 92.3-70 92.3-128.1c0 0 0 0 0 0l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0L344 0zM464 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faTruckFast = {
  prefix: 'far',
  iconName: 'truck-fast',
  icon: [
    640,
    512,
    ['shipping-fast'],
    'f48b',
    'M352 48L128 48c-8.8 0-16 7.2-16 16l0 32 128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-32C64 28.7 92.7 0 128 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96s-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96l0-48 0-80 48 0 0 44.8c14.1-8.2 30.5-12.8 48-12.8c35.5 0 66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM48 160l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM16 224l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faShippingFast = faTruckFast;
const faUserMagnifyingGlass = {
  prefix: 'far',
  iconName: 'user-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e5c5',
    'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM49.3 464c8.9-63.3 63.3-112 129-112l91.4 0c7.5 0 14.8 .6 21.9 1.8c-2.3-10.9-3.6-22.2-3.6-33.8c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-25 0-48.7-5.8-69.8-16L49.3 464zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z',
  ],
};
const faStarSharp = {
  prefix: 'far',
  iconName: 'star-sharp',
  icon: [
    576,
    512,
    [],
    'e28b',
    'M288 0c10.5 0 19.7 6.8 22.9 16.7L361.5 176 520 176c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L403.9 320.7l50.9 160.1c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7L288 406.4 158.7 506.9c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176l158.5 0L265.1 16.7C268.3 6.8 277.5 0 288 0zm0 103.2L254.9 207.3c-3.2 10-12.4 16.7-22.9 16.7l-106.1 0 88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6l82.9-64.5c8.7-6.7 20.8-6.7 29.5 0l82.9 64.5L353.1 319.3c-3-9.6 .2-20 8.1-26.2L450.1 224 344 224c-10.5 0-19.7-6.8-22.9-16.7L288 103.2z',
  ],
};
const faCommentHeart = {
  prefix: 'far',
  iconName: 'comment-heart',
  icon: [
    512,
    512,
    [],
    'e5c8',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
  ],
};
const faCircle1 = {
  prefix: 'far',
  iconName: 'circle-1',
  icon: [
    512,
    512,
    [],
    'e0ee',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c7.4 4.3 12 12.2 12 20.8l0 184 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-142.6-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c7.4-4.2 16.6-4.2 24 .1z',
  ],
};
const faCircleStar = {
  prefix: 'far',
  iconName: 'circle-star',
  icon: [
    512,
    512,
    ['star-circle'],
    'e123',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-391c-6.1 0-11.7 3.5-14.3 8.9l-31.3 63.3-69.9 10.2c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4L182.2 280l-11.9 69.6c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L256 333.6l62.5 32.9c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6L329.8 280l50.6-49.3c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-69.9-10.2-31.3-63.3c-2.7-5.5-8.3-8.9-14.3-8.9z',
  ],
};
const faStarCircle = faCircleStar;
const faFish = {
  prefix: 'far',
  iconName: 'fish',
  icon: [
    576,
    512,
    [128031],
    'f578',
    'M180.8 303.7c9.2 10.4 19.4 20.6 30.7 30.1c33.7 28.5 76 50.2 124.5 50.2s90.8-21.8 124.5-50.2c30.3-25.5 52.7-55.7 65.3-77.8c-12.6-22.1-35-52.2-65.3-77.8C426.8 149.7 384.5 128 336 128s-90.8 21.7-124.5 50.2c-11.3 9.5-21.5 19.7-30.7 30.1c-14 15.8-36.7 20.6-56 11.8L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l54.3-24.9c19.2-8.8 41.9-4 56 11.8zM4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l99.5 45.6c10.5-11.9 22.5-23.8 35.7-35C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-13.2-11.2-25.1-23.1-35.7-35L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5S-2.7 348.2 4.2 336.1zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faCloudFog = {
  prefix: 'far',
  iconName: 'cloud-fog',
  icon: [
    640,
    512,
    [127787, 'fog'],
    'f74e',
    'M176 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C137.3 270.4 112 244.2 112 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM248 0C184 0 131.7 50.1 128.2 113.3C90.4 130.1 64 167.9 64 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C470.5 55 430.9 24 384 24c-18 0-34.9 4.6-49.7 12.6C312.5 14.1 281.9 0 248 0zM0 392c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 368c-13.3 0-24 10.7-24 24zm64 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464c-13.3 0-24 10.7-24 24zm208 0c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faFog = faCloudFog;
const faWaffle = {
  prefix: 'far',
  iconName: 'waffle',
  icon: [
    512,
    512,
    [129479],
    'e466',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 112l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128l64 0 0-64-64 0 0 64zm96 0l64 0 0-64-64 0 0 64zm0 32l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64z',
  ],
};
const faMusicNote = {
  prefix: 'far',
  iconName: 'music-note',
  icon: [
    384,
    512,
    ['music-alt'],
    'f8cf',
    'M384 31.1C384 13.9 370.1 0 352.9 0c-2.7 0-5.3 .3-7.9 1L193.9 40.8C183.3 43.6 176 53.1 176 64l0 302.3c-18.1-9-40.2-14.3-64-14.3C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80l0-236.6 141.9-36.1C376.6 156.6 384 147 384 136l0-104.9zM176 432c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM336 117.3L224 145.8l0-63.3L336 53l0 64.3z',
  ],
};
const faMusicAlt = faMusicNote;
const faHexagonExclamation = {
  prefix: 'far',
  iconName: 'hexagon-exclamation',
  icon: [
    512,
    512,
    [],
    'e417',
    'M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faCartShoppingFast = {
  prefix: 'far',
  iconName: 'cart-shopping-fast',
  icon: [
    640,
    512,
    [],
    'e0dc',
    'M64 24C64 10.7 74.7 0 88 0l45.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L552 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5L88 48C74.7 48 64 37.3 64 24zM225.6 240l297.6 0c10.9 0 20.4-7.3 23.2-17.8L584.7 80 195.1 80l30.5 160zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM24 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 304c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faObjectUnion = {
  prefix: 'far',
  iconName: 'object-union',
  icon: [
    512,
    512,
    [],
    'e49f',
    'M160 304c26.5 0 48 21.5 48 48l0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-96c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l96 0zm-48 48l-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 48 0 48 48 0 48 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-48 0-48-48 0z',
  ],
};
const faUserGraduate = {
  prefix: 'far',
  iconName: 'user-graduate',
  icon: [
    448,
    512,
    [],
    'f501',
    'M228.7 .5c-3.1-.6-6.3-.6-9.4 0l-200 40C8.1 42.7 0 52.6 0 64C0 74.3 6.5 83.3 16 86.6l0 71.8L.3 236.9c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9l32 0c4.8 0 9.3-2.1 12.4-5.9s4.3-8.6 3.3-13.3L48 158.4l0-65.1 171.3 34.3c3.1 .6 6.3 .6 9.4 0l200-40C439.9 85.3 448 75.4 448 64s-8.1-21.3-19.3-23.5l-200-40zM49.3 464c5.8-37.6 30-69.2 63.3-85.1l63.6 71.5c5 5.6 10.7 10.1 16.9 13.6L49.3 464zm349.4 0l-143.8 0c6.2-3.4 11.9-7.9 16.9-13.6l63.6-71.5c33.3 15.8 57.5 47.4 63.3 85.1zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM96 160c0 70.7 57.3 128 128 128s128-57.3 128-128l0-24.5-48 9.6 0 14.9c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-14.9-48-9.6L96 160z',
  ],
};
const faStarfighter = {
  prefix: 'far',
  iconName: 'starfighter',
  icon: [
    640,
    512,
    [],
    'e037',
    'M254.4 35C256.9 15 274 0 294.1 0l51.8 0c20.2 0 37.2 15 39.7 35l25.8 206.4c4.1-.9 8.3-1.4 12.6-1.4l32 0c30.9 0 56 25.1 56 56l0 56 56 0 0-184c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 280c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-2.7-88 29.3 0 5.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-.6c-8.8-1.3-17-4.6-24-9.5c-9.1 6.3-20.1 10-32 10l-80 0c-11.9 0-22.9-3.7-32-10c-7 4.9-15.2 8.2-24 9.5l0 .6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-5.3L72 445.3l0 2.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-280c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 184 56 0 0-56c0-30.9 25.1-56 56-56l32 0c4.3 0 8.6 .5 12.6 1.4L254.4 35zM368 424l0-128 0-14.5L338.8 48l-37.6 0L272 281.5l0 14.5 0 128c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8zm48-128l0 128c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-128c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8zm-200-8l-32 0c-4.4 0-8 3.6-8 8l0 128c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-128c0-4.4-3.6-8-8-8zm104-64c17.7 0 32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32z',
  ],
};
const faCircleHalfStroke = {
  prefix: 'far',
  iconName: 'circle-half-stroke',
  icon: [
    512,
    512,
    [9680, 'adjust'],
    'f042',
    'M464 256c0-114.9-93.1-208-208-208l0 416c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faAdjust = faCircleHalfStroke;
const faArrowRightLongToLine = {
  prefix: 'far',
  iconName: 'arrow-right-long-to-line',
  icon: [
    640,
    512,
    [],
    'e3d5',
    'M640 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24s24 10.7 24 24zM505 239c9.4 9.4 9.4 24.6 0 33.9L369 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l95-95L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l406.1 0-95-95c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 239z',
  ],
};
const faSquareArrowDown = {
  prefix: 'far',
  iconName: 'square-arrow-down',
  icon: [
    448,
    512,
    ['arrow-square-down'],
    'f339',
    'M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 393l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L200 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0z',
  ],
};
const faArrowSquareDown = faSquareArrowDown;
const faDiamondHalfStroke = {
  prefix: 'far',
  iconName: 'diamond-half-stroke',
  icon: [
    512,
    512,
    [],
    'e5b8',
    'M256 464l0-416c2.6 0 5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17z',
  ],
};
const faClapperboard = {
  prefix: 'far',
  iconName: 'clapperboard',
  icon: [
    512,
    512,
    [],
    'e131',
    'M48 208l416 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm352-48l-64 0 80-80 32 0c8.8 0 16 7.2 16 16l-64 64zM320 80l-80 80-64 0 80-80 64 0zM160 80L80 160l-32 0 0-32L96 80l64 0zm352 80l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 24 0 24L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208 0-24 0-24z',
  ],
};
const faSquareChevronLeft = {
  prefix: 'far',
  iconName: 'square-chevron-left',
  icon: [
    448,
    512,
    ['chevron-square-left'],
    'f32a',
    'M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm71-241L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faChevronSquareLeft = faSquareChevronLeft;
const faPhoneIntercom = {
  prefix: 'far',
  iconName: 'phone-intercom',
  icon: [
    512,
    512,
    [],
    'e434',
    'M112 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l48 0zm0 400c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L192 32c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l48 0zm64-64l0-320c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm80-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM240 112c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-160 0z',
  ],
};
const faLinkHorizontal = {
  prefix: 'far',
  iconName: 'link-horizontal',
  icon: [
    640,
    512,
    ['chain-horizontal'],
    'e1cb',
    'M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-52.9 42.9-95.9 95.9-95.9l160.3 0c52.9 0 95.9 42.9 95.9 95.9c0 50.5-39.1 92.3-89.5 95.6l-8.1 .5c-13.2 .9-23.2 12.3-22.4 25.5s12.3 23.2 25.5 22.3l8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64L143.9 64zM496.1 448C575.6 448 640 383.6 640 304.1c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 52.9-42.9 95.9-95.9 95.9l-160.2 0c-53 0-95.9-42.9-95.9-95.9c0-50.5 39.1-92.3 89.5-95.7l7.1-.5c13.2-.9 23.2-12.3 22.3-25.6s-12.3-23.2-25.6-22.3l-7.1 .5C250.7 165.6 192 228.4 192 304.1C192 383.6 256.4 448 335.9 448l160.2 0z',
  ],
};
const faChainHorizontal = faLinkHorizontal;
const faMango = {
  prefix: 'far',
  iconName: 'mango',
  icon: [
    512,
    512,
    [],
    'e30f',
    'M344 0l32 0 64 0c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24l-39.7 0c-32.1 0-61.1-14.5-80.3-37.5l0 43.6 0 50.1 0 15.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24c-36.9 0-73.7 14.1-101.8 42.2l-1.7 1.7-1.9 1.6c-36.7 29.8-55.1 60.9-74.5 95.7l-3.1 5.6c-18.4 33-40.6 72.9-83 104.8c-2.3 1.8-4.1 4.3-5.1 7.4c-2.8 8.4 1.8 17.4 10.2 20.2l2 .7 1.8 .8s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0l.5 .2c.5 .2 1.4 .6 2.6 1.1c2.5 1 6.4 2.5 11.6 4.3c10.4 3.6 26.1 8.6 46.1 13.6C163.7 453.9 220.7 464 288 464c66.9 0 109.2-28.7 136.2-64.3C452.6 362.2 464 316.5 464 288c0-36.9-14-73.7-42.2-101.8c-6.8-6.8-14.1-12.8-21.8-17.9l0-54.8c20.2 9.3 39.1 22.2 55.8 38.8C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3C10.3 457.6-7.9 421.4 3.3 387.9C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96l0-72c0-13.3 10.7-24 24-24zm56 288c8.8 0 16 7.2 16 16c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-8.8 7.2-16 16-16z',
  ],
};
const faMusicNoteSlash = {
  prefix: 'far',
  iconName: 'music-note-slash',
  icon: [
    640,
    512,
    ['music-alt-slash'],
    'f8d0',
    'M512 31.1C512 13.9 498.1 0 480.9 0c-2.7 0-5.3 .3-7.9 1L321.9 40.8C311.3 43.6 304 53.1 304 64l0 149L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L352 250.6l0-55.2 141.9-36.1C504.6 156.6 512 147 512 136l0-104.9zM304 366.3c-18.1-9-40.2-14.3-64-14.3c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-58.7-48-37.8 0 30.8zm0 65.7c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C177.4 441.4 176 434.6 176 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM464 117.3L352 145.8l0-63.3L464 53l0 64.3z',
  ],
};
const faMusicAltSlash = faMusicNoteSlash;
const faCircleRadiation = {
  prefix: 'far',
  iconName: 'circle-radiation',
  icon: [
    512,
    512,
    [9762, 'radiation-alt'],
    'f7ba',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faRadiationAlt = faCircleRadiation;
const faFaceTongueSweat = {
  prefix: 'far',
  iconName: 'face-tongue-sweat',
  icon: [
    576,
    512,
    [],
    'e39e',
    'M496 256c0 81.7-47.1 152.4-115.7 186.4c2.4-8.4 3.7-17.3 3.7-26.4l0-15.3c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7l0 15.3c0 9.2 1.3 18 3.7 26.4c-27.1-13.4-50.8-32.6-69.6-55.9c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-21.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 21.4z',
  ],
};
const faGlobeStand = {
  prefix: 'far',
  iconName: 'globe-stand',
  icon: [
    448,
    512,
    [],
    'f5f6',
    'M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm97-159a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm240 0A144 144 0 1 0 64 208a144 144 0 1 0 288 0z',
  ],
};
const faBaseball = {
  prefix: 'far',
  iconName: 'baseball',
  icon: [
    512,
    512,
    [129358, 9918, 'baseball-ball'],
    'f433',
    'M248 463.8c0-6 .3-11.9 .7-17.8c1.1-13.2 12.7-23 25.9-21.9s23 12.7 21.9 25.9c-.3 3.4-.5 6.8-.5 10.2C378.8 444 444 378.8 460.2 296c-3.4 .1-6.8 .3-10.2 .5c-13.2 1.1-24.8-8.7-25.9-21.9s8.7-24.8 21.9-25.9c5.9-.5 11.8-.7 17.8-.7C459.7 139.5 372.5 52.3 264 48.2c0 6-.3 11.9-.7 17.8c-1.1 13.2-12.7 23-25.9 21.9s-23-12.7-21.9-25.9c.3-3.4 .5-6.8 .5-10.2C133.2 68 68 133.2 51.9 216c3.4-.1 6.8-.3 10.2-.5c13.2-1.1 24.8 8.7 25.9 21.9s-8.7 24.8-21.9 25.9c-5.9 .5-11.8 .7-17.8 .7C52.3 372.5 139.5 459.7 248 463.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm118-55.2c36.5-16.8 66-46.3 82.8-82.8c5.5-12 19.8-17.3 31.8-11.8s17.3 19.8 11.8 31.8C222.8 185 185 222.8 138 244.4c-12 5.5-26.3 .2-31.8-11.8s-.2-26.3 11.8-31.8zM394 311.2c-36.5 16.8-66 46.3-82.8 82.8c-5.5 12-19.8 17.3-31.8 11.8s-17.3-19.8-11.8-31.8C289.2 327 327 289.2 374 267.6c12-5.5 26.3-.2 31.8 11.8s.2 26.3-11.8 31.8z',
  ],
};
const faBaseballBall = faBaseball;
const faCircleP = {
  prefix: 'far',
  iconName: 'circle-p',
  icon: [
    512,
    512,
    [],
    'e11a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 136 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 68 0c50.8 0 92-41.2 92-92s-41.2-92-92-92l-92 0zm92 136l-68 0 0-88 68 0c24.3 0 44 19.7 44 44s-19.7 44-44 44z',
  ],
};
const faAwardSimple = {
  prefix: 'far',
  iconName: 'award-simple',
  icon: [
    384,
    512,
    [],
    'e0ab',
    'M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64.4 492.4L88 390.1c11.7 5.2 24.5 7.9 37.8 7.6l11.1-.3 9.5 5.8c28 17 63.1 17 91.1 0l9.5-5.8 11.1 .3c13.3 .3 26.1-2.4 37.8-7.6l23.6 102.3c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9z',
  ],
};
const faJetFighterUp = {
  prefix: 'far',
  iconName: 'jet-fighter-up',
  icon: [
    512,
    512,
    [],
    'e518',
    'M277.2 12.8C273.1 4.9 264.9 0 256 0s-17.1 4.9-21.2 12.8L168.4 138.2c-5.5 10.4-8.4 21.9-8.4 33.7l0 31.6L48 281.9 48 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80 0 32 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 112 0 0 1.1-41.9 66.3c-4 6.3-6.1 13.6-6.1 21.1c0 21.8 17.7 39.5 39.5 39.5l209 0c21.8 0 39.5-17.7 39.5-39.5c0-7.5-2.1-14.8-6.1-21.1L352 385.1l0-1.1 112 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-32 0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 33.9L352 203.5l0-31.6c0-11.7-2.9-23.3-8.4-33.7L277.2 12.8zM457.6 336L352 336l0-73.9L457.6 336zM304 360l0 32c0 4.5 1.3 9 3.7 12.8L345.1 464 280 464l0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-65.1 0 37.4-59.2c2.4-3.8 3.7-8.3 3.7-12.8l0-32 0-143.7 0-.6 0-43.7c0-3.9 1-7.8 2.8-11.2L256 75.3l45.2 85.4c1.8 3.5 2.8 7.3 2.8 11.2l0 43.7 0 .6L304 360zM160 336L54.4 336 160 262.1l0 73.9z',
  ],
};
const faDiagramProject = {
  prefix: 'far',
  iconName: 'diagram-project',
  icon: [
    576,
    512,
    ['project-diagram'],
    'f542',
    'M136 80c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l80 0zM56 32C25.1 32 0 57.1 0 88l0 80c0 30.9 25.1 56 56 56l80 0c5.6 0 11.1-.8 16.2-2.4l75.9 101.2c-2.7 6.5-4.1 13.7-4.1 21.2l0 80c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-5.6 0-11.1 .8-16.2 2.4L187.9 189.2c2.7-6.5 4.1-13.7 4.1-21.2l0-16 192 0 0 16c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56l0 16-192 0 0-16c0-30.9-25.1-56-56-56L56 32zM360 336c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l80 0zM440 80l80 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z',
  ],
};
const faProjectDiagram = faDiagramProject;
const faPedestal = {
  prefix: 'far',
  iconName: 'pedestal',
  icon: [
    448,
    512,
    [],
    'e20d',
    'M352 48L96 48c-8.8 0-16 7.2-16 16l0 368-48 0L32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 368-48 0 0-368c0-8.8-7.2-16-16-16zM24 464l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96-352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM304 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faChartPyramid = {
  prefix: 'far',
  iconName: 'chart-pyramid',
  icon: [
    512,
    512,
    [],
    'e0e6',
    'M256 95.8L199.9 192l112.3 0L256 95.8zM125.2 320l261.6 0-46.7-80-168.3 0-46.7 80zm-28 48L59.9 432l392.3 0-37.3-64L97.2 368zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2L59.9 480c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z',
  ],
};
const faSidebar = {
  prefix: 'far',
  iconName: 'sidebar',
  icon: [
    512,
    512,
    [],
    'e24e',
    'M224 80l0 352 224 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L224 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM64 312c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faSnowmanHead = {
  prefix: 'far',
  iconName: 'snowman-head',
  icon: [
    448,
    512,
    ['frosty-head'],
    'f79b',
    'M336 144l0 48-224 0 0-48 224 0zM64 64l0 128-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.7 0C28 272.3 16 310.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-41.2-12-79.7-32.7-112l24.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-128c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64zm0 288c0-43.6 17.4-83.1 45.7-112l2.3 0 224 0 2.3 0c28.3 28.9 45.7 68.4 45.7 112c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7l-219.6 0c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352zm88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z',
  ],
};
const faFrostyHead = faSnowmanHead;
const faCopy = {
  prefix: 'far',
  iconName: 'copy',
  icon: [
    448,
    512,
    [],
    'f0c5',
    'M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z',
  ],
};
const faBurgerGlass = {
  prefix: 'far',
  iconName: 'burger-glass',
  icon: [
    640,
    512,
    [],
    'e0ce',
    'M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c5.6 0 11-.6 16.2-1.8c-13.1-12.8-23.3-28.5-29.4-46.2L108 464c-12.5 0-22.8-9.5-23.9-21.9L64 208l247.9 0c15.5-12.4 35-24.1 59.2-32.7L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM59.8 160L50.2 48l283.7 0-9.7 112L59.8 160zm390.1 80.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z',
  ],
};
const faVolumeXmark = {
  prefix: 'far',
  iconName: 'volume-xmark',
  icon: [
    576,
    512,
    ['volume-mute', 'volume-times'],
    'f6a9',
    'M159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM425 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55z',
  ],
};
const faVolumeMute = faVolumeXmark;
const faVolumeTimes = faVolumeXmark;
const faHandSparkles = {
  prefix: 'far',
  iconName: 'hand-sparkles',
  icon: [
    640,
    512,
    [],
    'e05d',
    'M262.4 36C272.8 14.7 294.7 0 320 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 163.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-29.3 8.4c7.7-14.9 12.8-31.4 14.5-48.9c.1-1.3 .4-2.5 .7-3.7L496 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L416 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L336 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L304 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c30.9-1.5 59.1-13.4 81.2-32.1l0 .3c0 17.6 10.8 33.3 27 39.6c-28.5 22.8-63.8 37.3-102.5 39.9c-1.4 .3-3 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L82.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L176 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zm50.3 290.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm257.5 33.1L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7zM104 88l40 11.4 0 25.1L104 136 90.2 184.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 136 7.7 122.2C3.1 120.9 0 116.7 0 112s3.1-8.9 7.7-10.2L56 88 69.8 39.7C71.1 35.1 75.3 32 80 32s8.9 3.1 10.2 7.7L104 88z',
  ],
};
const faBarsFilter = {
  prefix: 'far',
  iconName: 'bars-filter',
  icon: [
    448,
    512,
    [],
    'e0ad',
    'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24z',
  ],
};
const faPaintbrushPencil = {
  prefix: 'far',
  iconName: 'paintbrush-pencil',
  icon: [
    576,
    512,
    [],
    'e206',
    'M181.3 19.3c-25-25-65.5-25-90.5 0L51.3 58.7c-3.1 3.1-5.9 6.5-8.2 10c-16.4 24.8-13.7 58.6 8.2 80.5l88.8 88.8c13.9-4 28.6-6.1 43.9-6.1l1.5 0 8.2-8.2L161 191 223 129l32.8 32.8 33.9-33.9L181.3 19.3zM414.2 320.1l37.3 37.3c.6 .6 1.2 1.2 1.7 1.8c3.9 4.4 6.7 9.6 8.4 15.2l6.9 23.4 16.1 54.8-54.8-16.1-23.4-6.9c-6.4-1.9-12.3-5.4-17-10.1l-37.3-37.3-8.1 8.1 0 1.7c0 15.2-2.1 29.9-6.1 43.9l17.6 17.6c1.3 1.3 2.6 2.6 4 3.8c9.6 8.5 21 14.8 33.4 18.4l78.1 23L513.2 511c8.4 2.5 17.5 .2 23.7-6.1s8.5-15.3 6.1-23.7L530.6 439l-23-78.1c-4.2-14.1-11.8-27-22.2-37.4l-37.3-37.3-33.9 33.9zM519 57c8.3 8.3 8.3 21.8 0 30.1L336.3 269.8l-30.1-30.1L489 57c8.3-8.3 21.8-8.3 30.1 0zM184 320c9.4 0 18.3 1.8 26.5 5L251 365.5c3.3 8.2 5 17.2 5 26.5c0 39.8-32.2 72-72 72l-85.6 0 .7-.9c11.6-16.9 17.1-38.6 13.8-60c-.5-3.6-.8-7.3-.8-11.1c0-39.8 32.2-72 72-72zM455 23L204.3 273.7c-6.6-1.1-13.4-1.7-20.3-1.7c-66.3 0-120 53.7-120 120c0 6.2 .5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448l-6 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l152 0c66.3 0 120-53.7 120-120c0-6.9-.6-13.7-1.7-20.3L553 121c27-27 27-70.9 0-97.9s-70.9-27-97.9 0z',
  ],
};
const faPartyBell = {
  prefix: 'far',
  iconName: 'party-bell',
  icon: [
    512,
    512,
    [],
    'e31a',
    'M48 224c0-97.2 78.8-176 176-176c27.8 0 54.1 6.5 77.5 17.9c.7 .4 1.2 .8 1.7 1.6c.5 .9 .9 2.1 .9 3.2c0 1.7-.7 3.4-1.9 4.6L75.3 302.1c-1.2 1.2-2.9 1.9-4.6 1.9c-1.1 0-2.3-.3-3.2-.9c-.7-.4-1.2-.9-1.6-1.7C54.5 278.1 48 251.8 48 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM359 167c-9.4 9.4-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167c-9.4-9.4-24.6-9.4-33.9 0zM201 359c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359zM503.5 506.3c10.1-8.6 11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10c8.6 10.1 23.7 11.4 33.8 2.8z',
  ],
};
const faUserVneckHair = {
  prefix: 'far',
  iconName: 'user-vneck-hair',
  icon: [
    448,
    512,
    [],
    'e462',
    'M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM48.3 464l351.5 0c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9C81.2 377.8 51.3 417.3 48.3 464zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.2z',
  ],
};
const faJackOLantern = {
  prefix: 'far',
  iconName: 'jack-o-lantern',
  icon: [
    576,
    512,
    [127875],
    'f30e',
    'M275.5 10.4L231.6 110.6c-4 2.1-7.9 4.5-11.6 7.1C200 104.1 176.9 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-24.9 0-48 8.1-68 21.6c-1.3-.9-2.7-1.8-4-2.6l0-79.6c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4zM81.2 187.6C101.3 158.7 126.7 144 152 144c18 0 35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C252.2 151.4 270 144 288 144s35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C388.2 151.4 406 144 424 144c25.3 0 50.7 14.7 70.8 43.6c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4zm140.1 27.5c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM368 208c-5.4 0-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48c-3-4.5-8-7.1-13.3-7.1zM470.1 312c1.4-5-.3-10.2-4-13.8c-5.8-5.8-15.1-6.6-22.2-2.4C420.8 309.4 365.6 336 288 336l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-19.5c-52.4-7.7-89.9-26.2-107.9-36.8c-7.1-4.2-16.4-3.4-22.2 2.4c-3.7 3.7-5.4 8.8-4 13.8c4.2 14.7 17.2 46.8 54.1 71.4c.3-8.6 7.3-15.4 16-15.4l16 0c8.8 0 16 7.2 16 16l0 21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5l0-21.5c0-8.8 7.2-16 16-16l16 0c8.6 0 15.7 6.9 16 15.4c36.9-24.7 49.9-56.7 54.1-71.4z',
  ],
};
const faGrip = {
  prefix: 'far',
  iconName: 'grip',
  icon: [
    448,
    512,
    ['grip-horizontal'],
    'f58d',
    'M408 376l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 184l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z',
  ],
};
const faGripHorizontal = faGrip;
const faShareFromSquare = {
  prefix: 'far',
  iconName: 'share-from-square',
  icon: [
    576,
    512,
    [61509, 'share-square'],
    'f14d',
    'M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z',
  ],
};
const faShareSquare = faShareFromSquare;
const faKeynote = {
  prefix: 'far',
  iconName: 'keynote',
  icon: [
    512,
    512,
    [],
    'f66c',
    'M198.4 72L184 72c-22.1 0-40 17.9-40 40l0 48 278.3 0c16.1 0 31 8 39.9 21.4l41.7 62.5c5.3 7.9 8.1 17.1 8.1 26.6l0 49.5c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32l0-49.5c0-9.5 2.8-18.7 8.1-26.6l41.7-62.5C58.7 168 73.6 160 89.7 160l6.3 0 0-48c0-48.6 39.4-88 88-88l14.4 0C206.7 9.7 222.2 0 240 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24zM48 304l416 0 0-33.5L422.3 208 89.7 208 48 270.5 48 304zm80 184c0-13.3 10.7-24 24-24l80 0 0-80 48 0 0 80 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24z',
  ],
};
const faChildCombatant = {
  prefix: 'far',
  iconName: 'child-combatant',
  icon: [
    576,
    512,
    ['child-rifle'],
    'e4e0',
    'M160 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM176 208c5.5 0 10.9 .9 16 2.6L192 336l-32 0 0-125.4c5.1-1.7 10.5-2.6 16-2.6zM160 488l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-223.2 27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C241.8 177.5 210.1 160 176 160s-65.8 17.5-83.9 46.3L43.7 283.2c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44L112 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l32 0 0 48 0 64c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16L432 0 416 0zm16 336l-16 0-16 0 0-96 32 0 0 96z',
  ],
};
const faChildRifle = faChildCombatant;
const faGun = {
  prefix: 'far',
  iconName: 'gun',
  icon: [
    576,
    512,
    [],
    'e19b',
    'M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L40 64C17.9 64 0 81.9 0 104l0 96c0 22.1 17.9 40 40 40l2 0c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l112 0c14.7 0 27.5-10 31-24.2L233 352l88.5 0c23.7 0 44.8-14.9 52.7-37.2L400.9 240l32.5 0c10.6 0 20.8-4.2 28.3-11.7L481.9 208l54.1 0c22.1 0 40-17.9 40-40l0-64c0-22.1-17.9-40-40-40l-8 0 0-8zM245 304l16-64 89 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3L245 304zm-33.5-64l-48 192-79 0 35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4l96.1 0zM267 192l-48 0L68.8 192 48 192l0-80 456 0 24 0 0 48-49.4 0c-10.6 0-20.8 4.2-28.3 11.7L430.1 192l-163 0z',
  ],
};
const faSquarePhone = {
  prefix: 'far',
  iconName: 'square-phone',
  icon: [
    448,
    512,
    ['phone-square'],
    'f098',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.7 32.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z',
  ],
};
const faPhoneSquare = faSquarePhone;
const faHatBeach = {
  prefix: 'far',
  iconName: 'hat-beach',
  icon: [
    640,
    512,
    [],
    'e606',
    'M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4zM320 64c70.2 0 130.8 41.1 159 100.5c6.1-2.9 12.8-4.5 19.7-4.5c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8 .8 1.6 1.6 2.3 2.5l77.3 30.9c17.9 7.2 29.7 24.6 29.7 43.9c0 17.6-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4L25.1 369.8C8.9 354.5 0 337.6 0 320c0-19.3 11.8-36.7 29.7-43.9l8.6 21.6-8.6-21.6 114.6-45.8C149.3 137.6 226.1 64 320 64zM429.3 320c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-62.4 0-116.5-14.3-142.9-35.2c-.3 .1-.5 .2-.8 .3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5c10.3 9.8 27.8 20.8 53.4 31C162.5 386.3 236.2 400 320 400s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31c8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3zM464 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faPlus = {
  prefix: 'far',
  iconName: 'plus',
  icon: [
    448,
    512,
    [10133, 61543, 'add'],
    '2b',
    'M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z',
  ],
};
const faAdd = faPlus;
const faExpand = {
  prefix: 'far',
  iconName: 'expand',
  icon: [
    448,
    512,
    [],
    'f065',
    'M136 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L48 80l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32l112 0zM0 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24L0 344zM424 32c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zM400 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0 0-88z',
  ],
};
const faComputer = {
  prefix: 'far',
  iconName: 'computer',
  icon: [
    640,
    512,
    [],
    'e4e5',
    'M384 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-102.7 0L264 336l-80 0-17.3 0L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 384l86.7 0-16 48L88 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l30.7 0 33.3 0 144 0 33.3 0 30.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-46.7 0-16-48 86.7 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64zm121.3 48l16-48 45.4 0 16 48-77.4 0zM528 80l64 0 0 32-64 0 0-32zm0 80l64 0 0 32-64 0 0-32zm64 80l0 192-64 0 0-192 64 0zM480 80l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faFort = {
  prefix: 'far',
  iconName: 'fort',
  icon: [
    640,
    512,
    [],
    'e486',
    'M48 112l0 48c0 8.8 7.2 16 16 16l16 0 80 0c8.8 0 16-7.2 16-16l0-48-40 0-48 0-40 0zm176 48c0 5.5-.7 10.9-2 16l196 0c-1.3-5.1-2-10.5-2-16l0-48 0-8 0-40 0-40c0-13.3 10.7-24 24-24c7.1 0 13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C514.6 3.1 520.9 0 528 0s13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C602.6 3.1 608.9 0 616 0c13.3 0 24 10.7 24 24l0 40 0 40 0 8 0 48c0 23.7-12.9 44.4-32 55.4l0 8.6 0 224c0 35.3-28.7 64-64 64l-160 0-128 0L96 512c-35.3 0-64-28.7-64-64l0-224 0-8.6C12.9 204.4 0 183.7 0 160l0-48 0-8L0 64 0 24C0 10.7 10.7 0 24 0c7.1 0 13.4 3.1 17.8 7.9C45.7 12.2 48 17.8 48 24l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C98.6 3.1 104.9 0 112 0s13.4 3.1 17.8 7.9c3.9 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C186.6 3.1 192.9 0 200 0c13.3 0 24 10.7 24 24l0 40 0 40 0 8 0 48zM384 464l64 0 0-240-256 0 0 240 64 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80zm112 0l48 0c8.8 0 16-7.2 16-16l0-224-64 0 0 240zM96 464l48 0 0-240-64 0 0 224c0 8.8 7.2 16 16 16zM560 176l16 0c8.8 0 16-7.2 16-16l0-48-40 0-48 0-40 0 0 48c0 8.8 7.2 16 16 16l80 0z',
  ],
};
const faCloudCheck = {
  prefix: 'far',
  iconName: 'cloud-check',
  icon: [
    640,
    512,
    [],
    'e35c',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z',
  ],
};
const faXmark = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [
    384,
    512,
    [128473, 10005, 10006, 10060, 215, 'close', 'multiply', 'remove', 'times'],
    'f00d',
    'M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z',
  ],
};
const faClose = faXmark;
const faMultiply = faXmark;
const faRemove = faXmark;
const faTimes = faXmark;
const faFaceSmirking = {
  prefix: 'far',
  iconName: 'face-smirking',
  icon: [
    512,
    512,
    [],
    'e397',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm382.3 88.9l-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3L184 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l122.1 0c13.1 0 24.9-8 29.7-20.1l1.9-4.8c4.9-12.3 18.9-18.3 31.2-13.4s18.3 18.9 13.4 31.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
  ],
};
const faArrowsUpDownLeftRight = {
  prefix: 'far',
  iconName: 'arrows-up-down-left-right',
  icon: [
    512,
    512,
    ['arrows'],
    'f047',
    'M273 7c-9.4-9.4-24.6-9.4-33.9 0L167 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 232 81.9 232l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31L232 280l0 150.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 280l150.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L280 232l0-150.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7z',
  ],
};
const faArrows = faArrowsUpDownLeftRight;
const faChalkboardUser = {
  prefix: 'far',
  iconName: 'chalkboard-user',
  icon: [
    640,
    512,
    ['chalkboard-teacher'],
    'f51c',
    'M576 48L224 48c-8.8 0-16 7.2-16 16l0 41.3c-14.8-6-31-9.3-48-9.3l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-32 0-24 0-128 0-24 0-31.2 0c-8.3-18-19.8-34.2-33.7-48l64.9 0 0-40c0-30.9 25.1-56 56-56l64 0c30.9 0 56 25.1 56 56l0 40 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM496 368l0-40c0-4.4-3.6-8-8-8l-64 0c-4.4 0-8 3.6-8 8l0 40 80 0zM208 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM50.7 464l218.6 0c-9.5-36.8-42.9-64-82.6-64l-53.3 0c-39.8 0-73.2 27.2-82.6 64zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3z',
  ],
};
const faChalkboardTeacher = faChalkboardUser;
const faRhombus = {
  prefix: 'far',
  iconName: 'rhombus',
  icon: [
    448,
    512,
    [],
    'e23b',
    'M224 52.3L50.5 256 224 459.7 397.5 256 224 52.3zM9.6 230.1l184-216C201.2 5.1 212.3 0 224 0s22.8 5.1 30.4 14.1l184 216c12.7 14.9 12.7 36.9 0 51.9l-184 216c-7.6 8.9-18.7 14.1-30.4 14.1s-22.8-5.1-30.4-14.1l-184-216C-3.2 267-3.2 245 9.6 230.1z',
  ],
};
const faClawMarks = {
  prefix: 'far',
  iconName: 'claw-marks',
  icon: [
    576,
    512,
    [],
    'f6c2',
    'M39 7C48.4-2.3 63.6-2.3 73 7L176.6 110.6c15 15 23.4 35.4 23.4 56.6l0 16.8 16.8 0c21.2 0 41.6 8.4 56.6 23.4l95.2 95.2c15 15 23.4 35.4 23.4 56.6l0 16.8 16.8 0c21.2 0 41.6 8.4 56.6 23.4L537 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71.6-71.6c-6-6-14.1-9.4-22.6-9.4L368 424c-13.3 0-24-10.7-24-24l0-40.8c0-8.5-3.4-16.6-9.4-22.6l-95.2-95.2c-6-6-14.1-9.4-22.6-9.4L176 232c-13.3 0-24-10.7-24-24l0-40.8c0-8.5-3.4-16.6-9.4-22.6L39 41C29.7 31.6 29.7 16.4 39 7zm0 224c9.4-9.4 24.6-9.4 33.9 0L146.9 305c13.5 13.5 21.1 31.8 21.1 50.9l0 20.1 20.1 0c19.1 0 37.4 7.6 50.9 21.1L313 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L205.1 431c-4.5-4.5-10.6-7-17-7L144 424c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L39 265c-9.4-9.4-9.4-24.6 0-33.9zM297 7l9.9 9.9C320.4 30.5 328 48.8 328 67.9L328 88l20.1 0c19.1 0 37.4 7.6 50.9 21.1L434.9 145c13.5 13.5 21.1 31.8 21.1 50.9l0 20.1 20.1 0c19.1 0 37.4 7.6 50.9 21.1L537 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.9-9.9c-4.5-4.5-10.6-7-17-7L432 264c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L365.1 143c-4.5-4.5-10.6-7-17-7L304 136c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L263 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faPesoSign = {
  prefix: 'far',
  iconName: 'peso-sign',
  icon: [
    384,
    512,
    [],
    'e222',
    'M93.6 32C68.4 32 48 52.4 48 77.6L48 128l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 72 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c67 0 124.9-39.2 151.8-96l24.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-9.7 0c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24l9.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24.2 0C308.9 71.2 251 32 184 32L93.6 32zM280 128L96 128l0-48 88 0c39.3 0 74.1 18.9 96 48zM96 176l205.6 0c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24L96 224l0-48zm184 96c-21.9 29.1-56.7 48-96 48l-88 0 0-48 184 0z',
  ],
};
const faFaceSmileTongue = {
  prefix: 'far',
  iconName: 'face-smile-tongue',
  icon: [
    512,
    512,
    [],
    'e394',
    'M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 27.2-4.2 53.4-12.1 77.9c9.1 23.9 7.8 51.5-6 75.4c-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8l-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4c-70.4 0-130.1-43.8-157.5-105.5c-5.4-12.1 .1-26.3 12.2-31.7s26.3 .1 31.7 12.2c20.4 46.1 64.1 76.9 113.6 76.9c56.5 0 105.6-40.3 120.8-97.4c1.9-7.3 7.2-13.2 14.2-16.1s14.9-2.2 21.4 1.7l49 29.5c1.7-10.7 2.6-21.7 2.6-33c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8zM217.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zM398.5 399.6c18.8 11 42.9 4.7 53.8-14.2c11-19.1 4.5-43.6-14.6-54.6l-.4-.2s0 0 0 0l-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zM377.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z',
  ],
};
const faCartCircleXmark = {
  prefix: 'far',
  iconName: 'cart-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e3f4',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faBuildingShield = {
  prefix: 'far',
  iconName: 'building-shield',
  icon: [
    576,
    512,
    [],
    'e4d8',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 162.2L384 207l0-143c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c10.9 0 21.2-2.7 30.2-7.6c-15.4-12.4-28.5-26-39.5-40.4L240 464l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM296 232c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l24 0c.1-22.8 14-43.4 35.2-51.8l4.8-1.9 0-10.2zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm335.1-6.3l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L527.4 312z',
  ],
};
const faCirclePhoneFlip = {
  prefix: 'far',
  iconName: 'circle-phone-flip',
  icon: [
    512,
    512,
    ['phone-circle-alt'],
    'e11c',
    'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7l44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L231.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48c3.9-9.3 14-14.2 23.7-11.6z',
  ],
};
const faPhoneCircleAlt = faCirclePhoneFlip;
const faBaby = {
  prefix: 'far',
  iconName: 'baby',
  icon: [
    448,
    512,
    [],
    'f77c',
    'M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM107.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l18.7 18.7c12.8 12.8 27.5 23.4 43.4 31.5c8.1 4.1 13.1 12.4 13.1 21.4l0 13s0 0 0 0l128 0 0-13c0-9 5.1-17.3 13.1-21.4c15.9-8.1 30.6-18.6 43.4-31.5l18.7-18.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-18.7 18.7c-26 26-61.2 40.6-97.9 40.6s-72-14.6-97.9-40.6l-18.7-18.7zM304.6 341.5l-24.1 21.1L304 392.9c6.8 8.8 6.7 21.1-.2 29.7L291.5 438c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l32-40c4.6-5.8 4.7-14 .1-19.8l-44.1-56.7zm-137 21.1l-24.1-21.1L99.4 398.2c-4.5 5.8-4.5 14 .1 19.8l32 40c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.3-15.4c-6.9-8.7-7-21-.2-29.7l23.6-30.3zM50.7 146.7c25-25 65.5-25 90.5 0L160 165.5c17 17 40 26.5 64 26.5s47-9.5 64-26.5l18.7-18.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L378.5 256c-12.9 12.9-27.2 23.9-42.5 33.1l0 14.6 50.5 65c18.2 23.4 18 56.2-.5 79.3l-32 40c-22.1 27.6-62.4 32.1-90 10s-32.1-62.4-10-90l.5-.6-5.8-7.4-49.4 0-5.8 7.4 .5 .6c22.1 27.6 17.6 67.9-10 90s-67.9 17.6-90-10L62 448c-18.5-23.1-18.7-55.9-.5-79.3l50.5-65 0-14.6c-15.4-9.2-29.7-20.3-42.5-33.1L50.7 237.3c-25-25-25-65.5 0-90.5z',
  ],
};
const faUsersLine = {
  prefix: 'far',
  iconName: 'users-line',
  icon: [
    640,
    512,
    [],
    'e592',
    'M147.2 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 192c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l98.7 0c18.2-31.4 49.3-54.4 86-61.6C238.1 206 216.7 192 192 192l-96 0zm480 96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-24.5 0-45.7 13.7-56.5 33.9c38 6.6 70.3 29.9 89 62.1l95.5 0zm-134.8 0c-14.6-16.3-34.6-27.5-57.1-30.9c-.6-.1-1.3-.2-1.9-.3c-4.1-.5-8.3-.8-12.5-.8l-48 0-48 0c-4.2 0-8.4 .3-12.5 .8c-1.7 .2-3.4 .5-5.1 .8c-21.3 3.9-40.1 14.9-53.9 30.4c-15.2 17-24.4 39.4-24.4 64c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-24.6-9.2-47-24.4-64zm58-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM321.6 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-48 96s0 0 0 0c13.4 10 30 16 48 16s34.6-6 48-16c0 0 0 0 0 0c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64zM414.9 336l-186.5 0c6.6-18.6 24.4-32 45.3-32l96 0c20.9 0 38.7 13.4 45.3 32zM0 456c0 13.3 10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24z',
  ],
};
const faQuoteLeft = {
  prefix: 'far',
  iconName: 'quote-left',
  icon: [
    448,
    512,
    [8220, 'quote-left-alt'],
    'f10d',
    'M0 216C0 149.7 53.7 96 120 96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-39.8 0-72 32.2-72 72l0 10c5.1-1.3 10.5-2 16-2l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm48 72l0 32 0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm336-16l-64 0c-8.8 0-16 7.2-16 16l0 32 0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM256 320l0-32 0-72c0-66.3 53.7-120 120-120l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-39.8 0-72 32.2-72 72l0 10c5.1-1.3 10.5-2 16-2l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32z',
  ],
};
const faQuoteLeftAlt = faQuoteLeft;
const faTractor = {
  prefix: 'far',
  iconName: 'tractor',
  icon: [
    640,
    512,
    [128668],
    'f722',
    'M152 48l114.3 0c3.3 0 6.2 2 7.4 5l42.8 107L192 160l-32 0-16 0 0-104c0-4.4 3.6-8 8-8zM96 56l0 136.6c-11.2-3.9-24.2-1.4-33.1 7.6L40.2 222.9c-12.5 12.5-12.5 32.8 0 45.3l5.8 5.8c-2.2 4.6-4.1 9.3-5.8 14.1L32 288c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l8.2 0c1.7 4.8 3.7 9.5 5.8 14.1l-5.8 5.8c-12.5 12.5-12.5 32.8 0 45.3l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0l5.8-5.8c4.6 2.2 9.3 4.1 14.1 5.8l0 8.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-8.2c4.8-1.7 9.5-3.7 14.1-5.8l5.8 5.8c12.5 12.5 32.8 12.5 45.3 0l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3l-5.8-5.8c2.2-4.6 4.1-9.3 5.8-14.1l8.2 0 94.8 0c6.5-18.5 17.5-34.9 31.6-48L352 336l0-16c0-17.7-14.3-32-32-32l-8.2 0c-1.7-4.8-3.7-9.5-5.8-14.1l5.8-5.8c12.5-12.5 12.5-32.8 0-45.3L296.9 208l54.6 0c.4 0 .7 0 1.1 0L504 208l80 0c4.4 0 8 3.6 8 8l0 32.7c0 7.4-3.4 14.3-9.2 18.9l-46.7 36.7c20.1 1.3 38.9 7.7 55.1 17.7l21.3-16.7c17.4-13.6 27.5-34.5 27.5-56.6l0-32.7c0-30.9-25.1-56-56-56l-56 0 0-41.8c0-16.1 3.8-32.1 11-46.5l2.5-5c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.5 5c-10.6 21.1-16 44.4-16 68l0 41.8-111.8 0L318.3 35.2C309.8 13.9 289.2 0 266.3 0L152 0C121.1 0 96 25.1 96 56zm80 200a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM528 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128a88 88 0 1 0 0-176 88 88 0 1 0 0 176z',
  ],
};
const faDownFromBracket = {
  prefix: 'far',
  iconName: 'down-from-bracket',
  icon: [
    448,
    512,
    [],
    'e66b',
    'M333.8 352L224 462 114.2 352l53.8 0c13.3 0 24-10.7 24-24l0-120 64 0 0 120c0 13.3 10.7 24 24 24l53.8 0zM224 512c11.5 0 22.5-4.6 30.6-12.7L370.4 383.2c8.7-8.7 13.6-20.5 13.6-32.8c0-25.6-20.8-46.4-46.4-46.4L304 304l0-96c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 96-33.6 0C84.8 304 64 324.8 64 350.4c0 12.3 4.9 24.1 13.6 32.8L193.4 499.3c8.1 8.1 19.1 12.7 30.6 12.7zM400 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80z',
  ],
};
const faKeySkeleton = {
  prefix: 'far',
  iconName: 'key-skeleton',
  icon: [
    448,
    512,
    [128477],
    'f6f3',
    'M304 48a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 31.1 9.9 59.9 26.6 83.4L7 407c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L88 393.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 98.6-98.6C244.1 278.1 272.9 288 304 288z',
  ],
};
const faTrashArrowUp = {
  prefix: 'far',
  iconName: 'trash-arrow-up',
  icon: [
    448,
    512,
    ['trash-restore'],
    'f829',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zm154.5 65.9l64 64c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L244 256.3 244 384c0 11-9 20-20 20s-20-9-20-20l0-127.7-29.9 29.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l64-64c7.8-7.8 20.5-7.8 28.3 0z',
  ],
};
const faTrashRestore = faTrashArrowUp;
const faArrowDownUpLock = {
  prefix: 'far',
  iconName: 'arrow-down-up-lock',
  icon: [
    640,
    512,
    [],
    'e4b0',
    'M145 505l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 280l264 0 0-8c0-14.1 2.6-27.6 7.4-40L344 232l0-150.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L337 7c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L296 232l-144 0-48 0-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 150.1L49 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0zm7-313l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136 48 0zM296 320l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0zm232-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faArrowDownToBracket = {
  prefix: 'far',
  iconName: 'arrow-down-to-bracket',
  icon: [
    448,
    512,
    [],
    'e094',
    'M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L200 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 246.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344l0 80c0 22.1 17.9 40 40 40l272 0c22.1 0 40-17.9 40-40l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faLinesLeaning = {
  prefix: 'far',
  iconName: 'lines-leaning',
  icon: [
    384,
    512,
    [],
    'e51e',
    'M190.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5l-144 400c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5l144-400zm78.1-31.7c-13-2.6-25.6 5.8-28.2 18.8l-80 400c-2.6 13 5.8 25.6 18.8 28.2s25.6-5.8 28.2-18.8l80-400c2.6-13-5.8-25.6-18.8-28.2zM360 32c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24z',
  ],
};
const faSquareQ = {
  prefix: 'far',
  iconName: 'square-q',
  icon: [
    448,
    512,
    [],
    'e27b',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z',
  ],
};
const faRulerCombined = {
  prefix: 'far',
  iconName: 'ruler-combined',
  icon: [
    512,
    512,
    [],
    'f546',
    'M192 288l0-16 0-48-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 272 0 112c0 .6 0 1.2 .1 1.7c.8 8 7.7 14.3 15.9 14.3l112 0 272 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-48 0-16 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm96-16l160 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-272 0L64 512C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5L0 336 0 64C0 28.7 28.7 0 64 0L176 0c35.3 0 64 28.7 64 64l0 160 0 48 48 0z',
  ],
};
const faSymbols = {
  prefix: 'far',
  iconName: 'symbols',
  icon: [
    512,
    512,
    [128291, 'icons-alt'],
    'f86e',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm0 80C10.7 80 0 90.7 0 104s10.7 24 24 24l64 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 80zM464 53.3l0 76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-132.5c0-25.2-23.1-44.2-47.8-39.2l-128 25.6C317.5 33.6 304 50 304 69.1l0 92.4c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0 0 0 0 0 0l0-132.3L464 53.3zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm153-25c-9.4-9.4-24.6-9.4-33.9 0L295 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 329c9.4-9.4 9.4-24.6 0-33.9zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM84 256c-37.7 0-68 30.8-68 68.2c0 19.3 8.2 37.9 22.6 50.8l4.5 4-17 13C9.6 404.8 0 424.4 0 445.1l0 1.4C0 482.7 29.3 512 65.5 512c14.9 0 29.3-5.1 40.9-14.3l36.3-29 41.3 37.2c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-35.5-31.9L215 410.7c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-40.6 32.5L118 381.9l7.9-6c16.5-12.7 26.1-32.2 26.1-53c0-36.9-29.9-66.9-66.9-66.9L84 256zM70.7 339.4c-4.2-3.8-6.7-9.4-6.7-15.2C64 313 73.1 304 84 304l1.1 0c10.4 0 18.9 8.5 18.9 18.9c0 5.9-2.7 11.4-7.4 15L81.8 349.3l-11-9.9zM55.4 430.1l24-18.4 27.1 24.4L76.4 460.2c-3.1 2.5-6.9 3.8-10.9 3.8c-9.6 0-17.5-7.8-17.5-17.5l0-1.4c0-5.9 2.7-11.4 7.4-15z',
  ],
};
const faIconsAlt = faSymbols;
const faCopyright = {
  prefix: 'far',
  iconName: 'copyright',
  icon: [
    512,
    512,
    [169],
    'f1f9',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z',
  ],
};
const faFlaskGear = {
  prefix: 'far',
  iconName: 'flask-gear',
  icon: [
    640,
    512,
    [],
    'e5f1',
    'M176 48l0 148.8c0 20.7-5.8 41-16.6 58.7L100 352l225.8 0c.1 .1 .2 .1 .2 .2c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 48l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L288 0l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 148.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-5.2 9.1-9.6 18.4-13.1 27.9l-20.7-33.6c-10.9-17.7-16.6-38-16.6-58.7L272 48l-96 0zM447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faHighlighterLine = {
  prefix: 'far',
  iconName: 'highlighter-line',
  icon: [
    576,
    512,
    [],
    'e1af',
    'M169.9 330.6l-38.1 38.1 51.5 51.5 38.1-38.1c9-9 21.2-14.1 33.9-14.1l48 0 16.2-22.5-113-113L184 248.6l0 48c0 12.7-5.1 24.9-14.1 33.9zm178-24.6L502.8 90.2c.8-1.1 1.2-2.4 1.2-3.7c0-1.7-.7-3.3-1.9-4.5L470 49.9c-1.2-1.2-2.8-1.9-4.5-1.9c-1.3 0-2.6 .4-3.7 1.2L246 204.1 347.9 306zM303.4 416l-48 0-43.7 43.7c-10.7 10.7-26 14.1-39.5 10.1l-32.8 32.8c-6 6-14.1 9.4-22.6 9.4L32 512c-17.7 0-32-14.3-32-32l0-4.7c0-8.5 3.4-16.6 9.4-22.6l72.8-72.8c-4-13.6-.6-28.8 10.1-39.5L136 296.6l0-48c0-15.5 7.4-30 20-39L433.8 10.2C443 3.6 454.1 0 465.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L342.4 396c-9 12.6-23.5 20-39 20zm-190.7 1.3L65.9 464l44.1 0 24.7-24.7-22.1-22.1zM248 464l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faBracketSquare = {
  prefix: 'far',
  iconName: 'bracket-square',
  icon: [
    192,
    512,
    ['bracket', 'bracket-left'],
    '5b',
    'M0 88C0 57.1 25.1 32 56 32l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 80c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-30.9 0-56-25.1-56-56L0 88z',
  ],
};
const faBracket = faBracketSquare;
const faBracketLeft = faBracketSquare;
const faIslandTropical = {
  prefix: 'far',
  iconName: 'island-tropical',
  icon: [
    512,
    512,
    [127965, 'island-tree-palm'],
    'f811',
    'M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3L78.2 96c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8l-44.7 0c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3l-61.3 0c3.5 15.4 7.2 35.7 9.5 59.7c4.4 45.4 3.7 104.4-13.9 167.1c57.7 12.4 101 63.7 101 125.1c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128l24.9 0c26-56.3 38-110.2 43.3-151.1c1.3-9.9 2.2-19 2.8-27.1l-71.8 71.8c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24zM237.3 352l28.5 0c18.5-59.2 19.5-115.9 15.3-159.7c-.6-6.1-1.3-12-2-17.5c-.7 9.6-1.7 20.5-3.3 32.4c-5.2 39.6-16 90.6-38.5 144.9zM288 400l-128 0c-38.7 0-71 27.5-78.4 64l284.8 0c-7.4-36.5-39.7-64-78.4-64z',
  ],
};
const faIslandTreePalm = faIslandTropical;
const faArrowRightFromLine = {
  prefix: 'far',
  iconName: 'arrow-right-from-line',
  icon: [
    448,
    512,
    [8614, 'arrow-from-left'],
    'f343',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88zM440.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L363.5 232 280 232l-128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z',
  ],
};
const faArrowFromLeft = faArrowRightFromLine;
const faH2 = {
  prefix: 'far',
  iconName: 'h2',
  icon: [
    640,
    512,
    [],
    'f314',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm397.3 40.8C457.9 118 474 112 490.7 112l9.2 0c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-162.6 0L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64l-9.2 0c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z',
  ],
};
const faEquals = {
  prefix: 'far',
  iconName: 'equals',
  icon: [
    448,
    512,
    [62764],
    '3d',
    'M40 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 144zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 320z',
  ],
};
const faCakeSlice = {
  prefix: 'far',
  iconName: 'cake-slice',
  icon: [
    512,
    512,
    [127856, 'shortcake'],
    'e3e5',
    'M464 304l0 .2 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3L48 352l0-48 416 0zM48 416l0-32 416 0 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.6 64-64l0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z',
  ],
};
const faShortcake = faCakeSlice;
const faBuildingMagnifyingGlass = {
  prefix: 'far',
  iconName: 'building-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e61c',
    'M64 48l256 0c8.8 0 16 7.2 16 16l0 141.7c13.8-13.5 30-24.6 48-32.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c29.2 0 53.9-19.6 61.6-46.4c-17-7.8-32.4-18.4-45.6-31.3l0 13.7c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM296 232c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c4 0 7.6-1.5 10.4-3.9c1.3-7.6 3.2-15 5.6-22.2l0-37.9zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm360 8.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z',
  ],
};
const faPeanut = {
  prefix: 'far',
  iconName: 'peanut',
  icon: [
    512,
    512,
    [],
    'e430',
    'M435 218.4c18-18.1 29-42.9 29-70.4l0-68c0-17.7-14.3-32-32-32l-68 0c-13.6 0-26.5 2.7-38.3 7.6c0 0 0 0 0 0c-11.7 4.8-22.7 12-32.3 21.6l-.3 .3s0 0 0 0c-9.6 9.6-16.7 20.6-21.5 32.2c0 0 0 0 0 0c-2.7 6.4-4.7 13.2-5.9 20.2l-.1 .4-.1 .4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4 .1-.4 .1c-7 1.3-13.8 3.3-20.2 5.9c0 0 0 0 0 0C98 276.4 87 283.6 77.3 293.3c-9.7 9.7-16.9 20.7-21.7 32.4c0 0 0 0 0 0C50.7 337.5 48 350.4 48 364l0 68c0 17.7 14.3 32 32 32l68 0c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4 .8-.7 1.1-1.1c0 0 0 0 0 0c9.4-9.5 16.4-20.4 21.1-31.9c0 0 0 0 0 0c2.7-6.4 4.7-13.2 5.9-20.2l.1-.4 .1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1 .4-.1c7-1.3 13.8-3.3 20.2-5.9c0 0 0 0 0 0c11.6-4.8 22.6-11.9 32.2-21.4c0 0 0 0 0 0l.6-.6s0 0 0 0zM512 148c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.5 .6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512l-68 0c-44.2 0-80-35.8-80-80l0-68c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C234.4 74 245 57.8 259.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0l68 0c44.2 0 80 35.8 80 80l0 68zM372.8 136a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 372.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z',
  ],
};
const faWrenchSimple = {
  prefix: 'far',
  iconName: 'wrench-simple',
  icon: [
    384,
    512,
    [],
    'e2d1',
    'M133 10.3c6.9 4.4 11 12 11 20.2l0 119.6 48 48 48-48 0-119.6c0-8.2 4.2-15.8 11-20.2s15.5-5 23-1.6C338.3 38.2 384 98.5 384 176c0 64.3-31.6 121.1-80 156l0 156c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168.9c0-8.3 4.3-16.1 11.4-20.4C308.6 273.3 336 227.8 336 176c0-42.2-18.3-77.7-48-102.4l0 86.4c0 6.4-2.5 12.5-7 17l-72 72c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-72-72c-4.5-4.5-7-10.6-7-17l0-86.4C66.3 98.3 48 133.8 48 176c0 51.8 27.4 97.3 68.6 122.7c7.1 4.4 11.4 12.1 11.4 20.4L128 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-156C31.6 297.1 0 240.3 0 176C0 98.5 45.7 38.2 110 8.7c7.4-3.4 16.1-2.8 23 1.6z',
  ],
};
const faBlender = {
  prefix: 'far',
  iconName: 'blender',
  icon: [
    512,
    512,
    [],
    'f517',
    'M0 80C0 35.8 35.8 0 80 0l48 0 32 0 16.2 0L471 0c20.8 0 36.1 19.6 31 39.8L425.6 345.5C457.8 361 480 393.9 480 432l0 16c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-16c0-40.5 25.1-75.1 60.6-89.2L149.3 256 80 256c-44.2 0-80-35.8-80-80L0 80zM144 432l0 16c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-16c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48zM406.5 224L304 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l110.5 0 16-64L304 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l134.5 0 12-48L180.2 48l24 288 174.4 0 28-112zM80 48C62.3 48 48 62.3 48 80l0 96c0 17.7 14.3 32 32 32l65.3 0L132 48 80 48zM288 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faTeeth = {
  prefix: 'far',
  iconName: 'teeth',
  icon: [
    576,
    512,
    [],
    'f62e',
    'M96 80c-26.5 0-48 21.5-48 48l0 45.4C63.9 150.8 90.2 136 120 136c15.2 0 29.5 3.9 42 10.7c16.1-21.1 41.4-34.7 70-34.7c21.3 0 40.8 7.5 56 20.1c15.2-12.6 34.7-20.1 56-20.1c28.5 0 53.9 13.6 70 34.7c12.5-6.8 26.8-10.7 42-10.7c29.8 0 56.1 14.8 72 37.4l0-45.4c0-26.5-21.5-48-48-48L96 80zM48 362.6L48 384c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-21.4c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4zM0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm192 72l0 24 0 16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1l48 0c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2l0-40c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19zm64 88l-48 0c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.7-.1-1.3-.1-2-.1zm48 16l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.6-.1-1.3-.1-2-.1l-48 0c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2zm16-48l48 0c.7 0 1.3 0 2-.1c7.3-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2l0-16 0-24c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28l0 40c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1zm110-.1c.6 .1 1.3 .1 2 .1l48 0c8.2 0 14.9-6.1 15.9-14c.1-.7 .1-1.3 .1-2l0-16c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24l0 16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9zM416.1 302c-.1 .7-.1 1.3-.1 2l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40l0-8c0-.7 0-1.3-.1-2c-1-7.9-7.7-14-15.9-14l-48 0c-.7 0-1.3 0-2 .1c-7.3 .9-13 6.6-13.9 13.9zM146 288.1c-.7-.1-1.3-.1-2-.1l-48 0c-8.2 0-14.9 6.1-15.9 14c-.1 .7-.1 1.3-.1 2l0 8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9zM159.9 242c.1-.7 .1-1.3 .1-2l0-16c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40l0 16c0 .7 0 1.3 .1 2c1 7.9 7.7 14 15.9 14l48 0c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9z',
  ],
};
const faTally2 = {
  prefix: 'far',
  iconName: 'tally-2',
  icon: [
    640,
    512,
    [],
    'e295',
    'M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384z',
  ],
};
const faShekelSign = {
  prefix: 'far',
  iconName: 'shekel-sign',
  icon: [
    448,
    512,
    [8362, 'ils', 'shekel', 'sheqel', 'sheqel-sign'],
    'f20b',
    'M40 32C26.7 32 16 42.7 16 56l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24L64 80l120 0c39.8 0 72 32.2 72 72l0 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184c0-66.3-53.7-120-120-120L40 32zM312 480c66.3 0 120-53.7 120-120l0-304c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 304c0 39.8-32.2 72-72 72l-120 0 0-248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l144 0z',
  ],
};
const faIls = faShekelSign;
const faShekel = faShekelSign;
const faSheqel = faShekelSign;
const faSheqelSign = faShekelSign;
const faCars = {
  prefix: 'far',
  iconName: 'cars',
  icon: [
    640,
    512,
    [],
    'f85b',
    'M137.8 48l140.3 0c10.1 0 19.2 6.4 22.6 15.9L317.9 112 98.1 112l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM41.4 127.9c-.2 .5-.3 .9-.5 1.4C16.2 146.7 0 175.5 0 208l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 172.1 0c5.3-6.6 11.3-12.7 17.8-18.2L248.5 240 48 240l0-32c0-26.5 21.5-48 48-48l190.8 0c19.2-20 46.1-32 75.1-32l12.8 0c0 0 0 0 0-.1L346 47.8C335.7 19.1 308.6 0 278.2 0L137.8 0C107.4 0 80.3 19.1 70 47.8L41.4 127.9zM112 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm249.8-16l140.3 0c10.1 0 19.2 6.4 22.6 15.9L541.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM544 320c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48l224 0zM336 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faAxeBattle = {
  prefix: 'far',
  iconName: 'axe-battle',
  icon: [
    512,
    512,
    [],
    'f6b3',
    'M120.8 70.4c15 20 39.3 40.8 79.2 51.1l0 49.2c-57.2-11.6-94.4-40.5-117.6-71.5c-3.1-4.2-6.2-8.6-9.2-13.3C57.2 119.3 48 156.7 48 192c0 36.8 10 76.1 27.4 110.7c4.4-6.6 9-12.9 13.8-18.8l37.3 30.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3c-4.4-5.3-8.7-10.9-12.8-16.6l-1-1.4c-1.1-1.6-2.3-3.3-3.4-4.9l-.2-.3C18.6 307.4 0 247.9 0 192C0 136.2 18.5 77.4 50 29.8l.7-1c2.1-3.1 4.2-6.1 6.3-9.1l.5-.7c3.3-4.5 6.7-8.9 10.2-13.2C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c.9 6.4 2.6 12.8 4.7 19l.2 .6c.6 1.7 1.2 3.3 1.9 5l.1 .2c4.6 11.4 11 22.2 18 31.7zm5.6 243.7L89.2 283.8c23.4-28.8 59.1-57.3 110.8-69.5l0 49.7c-34.2 10.7-57.6 30.4-73.6 50.1zM312 170.7l0-49.2c40-10.3 64.3-31.1 79.3-51.1c7.1-9.5 13.4-20.3 18-31.7l.1-.2c.7-1.6 1.3-3.3 1.9-5l.2-.6c2.2-6.2 3.8-12.6 4.7-19c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c3.5 4.3 6.9 8.7 10.2 13.2l.5 .7c2.2 3 4.3 6 6.3 9.1l.7 1c27.1 41.1 44.6 90.5 48.9 139.2L488 192l23.1 23.1c-4.3 48.9-22 98.9-49.4 140l-.2 .3c-1.1 1.7-2.2 3.3-3.4 4.9l-1 1.4c-4.1 5.7-8.3 11.3-12.8 16.6c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-15.9-19.6-39.4-39.4-73.7-50.1l0-49.7c51.7 12.3 87.5 40.7 110.9 69.5c4.8 5.9 9.4 12.2 13.8 18.8c11.1-22.1 19.3-46.2 23.6-70.4l-6.3-6.3c-18.7-18.7-18.7-49.1 0-67.9l6.3-6.3c-4.1-22.6-11.5-45-21.5-65.9c-3 4.7-6 9.2-9.2 13.3c-23.2 31-60.5 59.9-117.7 71.5zM280 56l0 432c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-432c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faUserHairLong = {
  prefix: 'far',
  iconName: 'user-hair-long',
  icon: [
    448,
    512,
    [],
    'e45b',
    'M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM49.3 464l349.4 0c-8.3-54.4-55.3-96-112-96l-125.4 0c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320l125.4 0C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z',
  ],
};
const faMap = {
  prefix: 'far',
  iconName: 'map',
  icon: [
    576,
    512,
    [128506, 62072],
    'f279',
    'M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z',
  ],
};
const faArrowLeftFromArc = {
  prefix: 'far',
  iconName: 'arrow-left-from-arc',
  icon: [
    512,
    512,
    [],
    'e615',
    'M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM119.7 134.4c9.7-9 24.9-8.5 33.9 1.3s8.5 24.9-1.3 33.9L85.1 232 328 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L85.1 280l67.2 62.4c9.7 9 10.3 24.2 1.3 33.9s-24.2 10.3-33.9 1.3l-112-104C2.8 269 0 262.7 0 256s2.8-13 7.7-17.6l112-104z',
  ],
};
const faFileCircleInfo = {
  prefix: 'far',
  iconName: 'file-circle-info',
  icon: [
    576,
    512,
    [58604],
    'e493',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faFaceDisappointed = {
  prefix: 'far',
  iconName: 'face-disappointed',
  icon: [
    512,
    512,
    [],
    'e36f',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z',
  ],
};
const faLassoSparkles = {
  prefix: 'far',
  iconName: 'lasso-sparkles',
  icon: [
    576,
    512,
    [],
    'e1c9',
    'M290.7 0L288 0C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9c0 35.2-28.6 63.8-63.8 63.8L56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l88.2 0C205.9 512 256 461.9 256 400.2c0-17.8-4.2-34.9-11.9-50.2c14.3 1.3 29 2 43.9 2c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80l0 .6c49.1 23.4 80 57.5 80 95.4c0 70.7-107.5 128-240 128S48 246.7 48 176c0-60.7 79.2-111.5 185.5-124.7c5.4-7.3 12.9-13 21.8-16.3l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z',
  ],
};
const faClockEleven = {
  prefix: 'far',
  iconName: 'clock-eleven',
  icon: [
    512,
    512,
    [],
    'e347',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 56.7-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faRocket = {
  prefix: 'far',
  iconName: 'rocket',
  icon: [
    512,
    512,
    [],
    'f135',
    'M368.3 265c-44.5 30.1-129.3 68.2-175.7 88l-35-35c20.4-46.1 59.2-130 89.3-174.4C309.1 52 398.4 41.8 461.7 50.3c8.5 63.3-1.7 152.6-93.3 214.7zM118.5 288c-3.6 8-6.8 15.2-9.4 21.2c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8l0 96.2c0 8.6 4.6 16.6 12.1 20.9s16.7 4.2 24.1-.2l88.5-52.5c21.9-13 35.3-36.5 35.3-61.9l0-82.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-82.1 0c-25.4 0-49 13.4-61.9 35.3L3.4 251.8c-4.4 7.4-4.5 16.6-.2 24.1S15.4 288 24 288l94.5 0zM408 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z',
  ],
};
const faSirenOn = {
  prefix: 'far',
  iconName: 'siren-on',
  icon: [
    640,
    512,
    [],
    'e02e',
    'M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM490 304l-48.4 0L423.4 158c-1-8-7.8-14-15.9-14l-175 0c-8.1 0-14.9 6-15.9 14L198.4 304 150 304l19-151.9c4-32 31.2-56.1 63.5-56.1l175 0c32.3 0 59.5 24 63.5 56.1L490 304zm-246.1 0l12.2-98c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-11.8 94-32.2 0zM496 384l-352 0 0 48 352 0 0-48zM144 336l352 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-352 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48z',
  ],
};
const faClockTen = {
  prefix: 'far',
  iconName: 'clock-ten',
  icon: [
    512,
    512,
    [],
    'e354',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faCandleHolder = {
  prefix: 'far',
  iconName: 'candle-holder',
  icon: [
    448,
    512,
    [128367],
    'f6bc',
    'M128 112c0 17.7 14.3 32 32 32s32-14.3 32-32c0-3.2-3.6-14.8-17.4-33.6c-4.7-6.4-9.8-12.5-14.6-18.1c-4.9 5.5-9.9 11.7-14.6 18.1C131.6 97.2 128 108.8 128 112zm32 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 80l-32 0 0 192 128 0 0-192-48 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zM48 464l0-192c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 192 36.1 0c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72c0 0-.1 0-.1 0s0 0-.1 0l-104 0-48 0L96 512l-48 0-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0zm352-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faVideoArrowDownLeft = {
  prefix: 'far',
  iconName: 'video-arrow-down-left',
  icon: [
    576,
    512,
    [],
    'e2c8',
    'M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM232 352c13.3 0 24-10.7 24-24s-10.7-24-24-24l-54.1 0L281 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-103 103 0-54.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0z',
  ],
};
const faPhotoFilm = {
  prefix: 'far',
  iconName: 'photo-film',
  icon: [
    640,
    512,
    ['photo-video'],
    'f87c',
    'M256 48c-8.8 0-16 7.2-16 16l0 224c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 232.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L578.7 303.8c7.6-1.3 13.3-7.9 13.3-15.8l0-224c0-8.8-7.2-16-16-16L256 48zM192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224zm-56 64l24 0 0 48 0 88 0 112 0 8 0 80 192 0 0-80 48 0 0 80 48 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64l-48 0-24 0-24 0-192 0-24 0-24 0-48 0c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l48 0 24 0zm-24 48l-48 0c-8.8 0-16 7.2-16 16l0 48 64 0 0-64zm0 288l0-64-64 0 0 48c0 8.8 7.2 16 16 16l48 0zM48 352l64 0 0-64-64 0 0 64zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faPhotoVideo = faPhotoFilm;
const faFloppyDiskCircleArrowRight = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [
    576,
    512,
    ['save-circle-arrow-right'],
    'e180',
    'M48 96l0 320c0 8.8 7.2 16 16 16l204 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-24.4c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80l0 80 144 0 0-80L128 80zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L457.4 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z',
  ],
};
const faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
const faFolderMinus = {
  prefix: 'far',
  iconName: 'folder-minus',
  icon: [
    512,
    512,
    [],
    'f65d',
    'M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faHexagonNodesBolt = {
  prefix: 'far',
  iconName: 'hexagon-nodes-bolt',
  icon: [
    576,
    512,
    [],
    'e69a',
    'M224 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-24c0 26.9-16.5 49.9-40 59.3l0 73.3c23.5 9.5 40 32.5 40 59.3c0 3.4-.3 6.7-.8 10l1 .6c-9.2 13-16.7 27.4-22.1 42.7l-3.5-2.1c-4.4 3.3-9.3 6.1-14.5 8.2l0 73.3c3.4 1.4 6.7 3.1 9.9 5c3.8 26.3 13.5 50.8 27.7 72C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-3.4 .3-6.7 .8-10l-58.2-34.9c-4.5 3.4-9.4 6.1-14.6 8.2l0 73.3c5.1 2.1 10 4.8 14.5 8.2l29.4-17.6c4.7 15.8 13.3 29.9 24.7 41.1L127.2 342c4 25.4-7.6 51.8-31.2 65.4C65.4 425.1 26.3 414.6 8.6 384S1.4 314.3 32 296.6c2.6-1.5 5.3-2.8 8-3.9l0-73.3c-2.7-1.1-5.4-2.4-8-3.9C1.4 197.8-9.1 158.6 8.6 128S65.4 86.9 96 104.6c23.6 13.6 35.2 40 31.2 65.4l58.2 34.9c4.4-3.3 9.3-6.1 14.5-8.2l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-35.3 28.7-64 64-64s64 28.7 64 64zM432 192c-30.3 0-58.8 7.7-83.7 21.1c-1-.6-1.9-1.3-2.8-2l-29.4 17.6c-4.7-15.8-13.3-29.9-24.7-41.1l29.4-17.6c-4-25.4 7.7-51.7 31.2-65.4c30.6-17.7 69.8-7.2 87.4 23.4c11.9 20.6 11 45-.1 64.1c-2.4-.1-4.9-.2-7.4-.2zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm172-99.2a24 24 0 1 0 -24-41.6 24 24 0 1 0 24 41.6zM84.8 172A24 24 0 1 0 43.2 148a24 24 0 1 0 41.6 24zM248 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM43.2 364a24 24 0 1 0 41.6-24A24 24 0 1 0 43.2 364zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z',
  ],
};
const faPlanetMoon = {
  prefix: 'far',
  iconName: 'planet-moon',
  icon: [
    576,
    512,
    [],
    'e01f',
    'M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM224 464c97.2 0 176-78.8 176-176c0-82.2-56.4-151.3-132.6-170.6l-71 82.9c-11.5 13.4-10.7 33.4 1.8 45.9c6.3 6.3 14.9 9.9 23.9 9.9l66 0c17.7 0 32 14.3 32 32l0 15.9c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2c-13.8 0-25-11.2-25-25l0-47c-17.7 0-32-14.3-32-32l0-32-49.9-49.9c-9-9-21.2-14.1-33.9-14.1L60 224c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176zM0 288c0-52.3 17.9-100.5 48-138.6c1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288z',
  ],
};
const faFaceEyesXmarks = {
  prefix: 'far',
  iconName: 'face-eyes-xmarks',
  icon: [
    512,
    512,
    [],
    'e374',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM137 135l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm192 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z',
  ],
};
const faChartScatter = {
  prefix: 'far',
  iconName: 'chart-scatter',
  icon: [
    512,
    512,
    [],
    'f7ee',
    'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faCircleGf = {
  prefix: 'far',
  iconName: 'circle-gf',
  icon: [
    512,
    512,
    [],
    'e67f',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM184 128c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0c13.3 0 24 10.7 24 24l0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 24c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 64 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
  ],
};
const faDisplayArrowDown = {
  prefix: 'far',
  iconName: 'display-arrow-down',
  icon: [
    576,
    512,
    [],
    'e164',
    'M64 0L224 0l0 48L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L352 48l0-48L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM260.3 416l-8 48 71.3 0-8-48-55.3 0zM312 24l0 182.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faStore = {
  prefix: 'far',
  iconName: 'store',
  icon: [
    576,
    512,
    [],
    'f54e',
    'M507.1 129.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1c0 0 0 0 0 0s0 0 0 0L120.4 48l335.2 0 51.5 81.5zM483.5 224c4.1 0 8.1-.3 12-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c0 0 0 0 0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c0 0 0 0 0 0zM112 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 336l0 48 0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64 0-48 0-83.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6l0 81.6-352 0zm352 48l0 64c0 8.8-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16l0-64 352 0z',
  ],
};
const faArrowTrendUp = {
  prefix: 'far',
  iconName: 'arrow-trend-up',
  icon: [
    576,
    512,
    [],
    'e098',
    'M352 120c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1L337 369c-9.4 9.4-24.6 9.4-33.9 0l-111-111L41 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 207c9.4-9.4 24.6-9.4 33.9 0l111 111L494.1 144 376 144c-13.3 0-24-10.7-24-24z',
  ],
};
const faPlugCircleMinus = {
  prefix: 'far',
  iconName: 'plug-circle-minus',
  icon: [
    576,
    512,
    [],
    'e55e',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z',
  ],
};
const faOliveBranch = {
  prefix: 'far',
  iconName: 'olive-branch',
  icon: [
    640,
    512,
    [],
    'e317',
    'M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L425.2 48c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288l-16 0c-8.8 0-16-7.2-16-16l0-16c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM399.4 427c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37C253.3 238.7 240 276.4 240 320s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37zM336 512c-79.5 0-144-86-144-192s64.5-192 144-192s144 86 144 192s-64.5 192-144 192zm129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1c3.6 .8 7.1 1.5 10.5 2c31.1 4.6 55-3.6 70.2-19.3c15.4-16 23.9-42.1 19.2-76c-4.7-33.8-22.2-71.6-53.2-103.7c-18-18.7-37.7-32.5-57.2-41.7c-4.9-8.8-10.3-17.2-16.2-25c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z',
  ],
};
const faAngle = {
  prefix: 'far',
  iconName: 'angle',
  icon: [
    448,
    512,
    [],
    'e08c',
    'M253.3 67.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2l-208 400c-3.9 7.4-3.6 16.4 .8 23.5S15.6 480 24 480l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L63.5 432 253.3 67.1zM242 175.5l-22.6 43.4c19.3 15.8 36.5 34 51.3 54.1l40.8-25.6c-19.6-27.2-43-51.4-69.5-71.9zM322.7 392l48.8 0c-6-36.9-18-71.8-34.7-103.8l-40.8 25.6c12.4 24.3 21.5 50.6 26.8 78.2z',
  ],
};
const faVacuumRobot = {
  prefix: 'far',
  iconName: 'vacuum-robot',
  icon: [
    512,
    512,
    [],
    'e04e',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335-79c-43.6-43.6-114.4-43.6-158.1 0c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c43.6-43.6 43.6-114.4 0-158.1zM212.7 212.7c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z',
  ],
};
const faSignHanging = {
  prefix: 'far',
  iconName: 'sign-hanging',
  icon: [
    512,
    512,
    ['sign'],
    'f4d9',
    'M88 0c13.3 0 24 10.7 24 24l0 40 376 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-376 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376-40 0C10.7 112 0 101.3 0 88S10.7 64 24 64l40 0 0-40C64 10.7 74.7 0 88 0zM192 336l240 0 0-144-240 0 0 144zM144 176c0-17.7 14.3-32 32-32l272 0c17.7 0 32 14.3 32 32l0 176c0 17.7-14.3 32-32 32l-272 0c-17.7 0-32-14.3-32-32l0-176z',
  ],
};
const faSign = faSignHanging;
const faSquareDivide = {
  prefix: 'far',
  iconName: 'square-divide',
  icon: [
    448,
    512,
    [],
    'e26a',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faFolderCheck = {
  prefix: 'far',
  iconName: 'folder-check',
  icon: [
    512,
    512,
    [],
    'e64e',
    'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L289.9 96 247 53.1C233.5 39.6 215.2 32 196.1 32L64 32zM48 96c0-8.8 7.2-16 16-16l132.1 0c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM369 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 241z',
  ],
};
const faSignalStreamSlash = {
  prefix: 'far',
  iconName: 'signal-stream-slash',
  icon: [
    640,
    512,
    [],
    'e250',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-69.7-24.8-133.6-66-183.4c-8.4-10.2-23.6-11.6-33.8-3.2s-11.6 23.6-3.2 33.8c34.3 41.5 55 94.7 55 152.8c0 40.1-9.8 77.9-27.2 111.2l-51.6-40.4c9.5-21.7 14.8-45.6 14.8-70.8c0-40.7-13.8-78.2-37-108c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7C406 199.2 416 226.4 416 256c0 13.9-2.2 27.3-6.3 39.8L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 40.7 13.8 78.2 37 108c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7C170 312.8 160 285.6 160 256c0-10.7 1.3-21.1 3.8-31l-40.3-31.7zM33 122C11.9 162 0 207.6 0 256c0 69.7 24.8 133.6 66 183.4c8.4 10.2 23.6 11.6 33.8 3.2s11.6-23.6 3.2-33.8C68.6 367.3 48 314.1 48 256c0-37.1 8.4-72.3 23.5-103.7L33 122z',
  ],
};
const faBezierCurve = {
  prefix: 'far',
  iconName: 'bezier-curve',
  icon: [
    640,
    512,
    [],
    'f55b',
    'M352 80l0 64-64 0 0-64 64 0zM288 32c-26.5 0-48 21.5-48 48l0 8L123.3 88C113.9 64.5 90.9 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l79 0C138.2 173.8 93.9 241.5 88.5 320L80 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-7.3 0c5.9-68.4 49.2-126.1 109.4-152.6C254.3 182.1 270 192 288 192l64 0c18 0 33.7-9.9 41.9-24.6c60.2 26.4 103.5 84.1 109.4 152.6l-7.3 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8.5 0c-5.3-78.5-49.7-146.2-113.8-184l79 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L400 88l0-8c0-26.5-21.5-48-48-48l-64 0zM48 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm512 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 368l0 64-64 0 0-64 64 0zm352 0l64 0 0 64-64 0 0-64z',
  ],
};
const faEyeDropperHalf = {
  prefix: 'far',
  iconName: 'eye-dropper-half',
  icon: [
    512,
    512,
    [],
    'e173',
    'M233 202.9L199 169l-8-8s0 0 0 0c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-8-8L309.1 279 233 202.9zM343 245.1L448.2 139.9c10.1-10.1 15.8-23.8 15.8-38.1C464 72.1 439.9 48 410.2 48c-14.3 0-28 5.7-38.1 15.8L266.9 169 343 245.1zM183.4 198.6l33.9 33.9L129.9 320l124.1 0 25.4-25.4 33.9 33.9L183 458.9c-13.5 13.5-31.8 21.1-50.9 21.1l-52.9 0-42 28c-9.5 6.3-22.2 5.1-30.3-3s-9.3-20.8-3-30.3l28-42 0-52.9c0-19.1 7.6-37.4 21.1-50.9L183.4 198.6z',
  ],
};
const faStoreLock = {
  prefix: 'far',
  iconName: 'store-lock',
  icon: [
    640,
    512,
    [],
    'e4a6',
    'M507.1 129.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-.3 .7-.6 1.5-1 2.2c6.4-1.1 13-1.7 19.7-1.7c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c0 0 0 0 0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c9.7-14.3 22.6-26.3 37.7-34.9c-7.4-2.1-13.9-6.2-19-11.8c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1c0 0 0 0 0 0s0 0 0 0L120.4 48l335.2 0 51.5 81.5zM112 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 336l0 48 0 64c0 35.3 28.7 64 64 64l264.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-16-256 0c-8.8 0-16-7.2-16-16l0-64 272 0 0-32c0-5.5 .7-10.9 2-16l-274 0zm416-96c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
  ],
};
const faBellSlash = {
  prefix: 'far',
  iconName: 'bell-slash',
  icon: [
    640,
    512,
    [128277, 61943],
    'f1f6',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z',
  ],
};
const faCloudBoltSun = {
  prefix: 'far',
  iconName: 'cloud-bolt-sun',
  icon: [
    640,
    512,
    ['thunderstorm-sun'],
    'f76e',
    'M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm112.1 48c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48c0 20.6 12.9 38.1 31.1 44.9c-12.6 11.7-17.9 29.3-14 46c-37.9-12.9-65.1-48.7-65.1-90.9c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-16.1 0c3.5-10.1 3.7-21.3 0-31.8c-2.1-6.1-5.4-11.6-9.6-16.2l26.1 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-.6 .7-1.1 1.3-1.8 1.9c-6.1 1.1-12 3.5-17.4 7c-1.6 0-3.3-.2-4.9-.6c-8.9-2.1-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm154 35.6c5.8 4.7 7.6 12.9 4.2 19.6L425.9 352l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384 304 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z',
  ],
};
const faThunderstormSun = faCloudBoltSun;
const faCameraSlash = {
  prefix: 'far',
  iconName: 'camera-slash',
  icon: [
    640,
    512,
    [],
    'e0d9',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C422.4 47.4 401 32 376.9 32L263.1 32c-24.1 0-45.5 15.4-53.1 38.3L201.4 96l-46.6 0L38.8 5.1zM216 144l2.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 228.5-98.4-77.2c1.6-7.5 2.4-15.4 2.4-23.4c0-61.9-50.1-112-112-112c-17.5 0-34.1 4-48.9 11.2L216 144zM382.6 274.6L318.1 224c.6 0 1.3 0 1.9 0c30.7 0 56.4 21.7 62.6 50.6zM487.4 480l-60.9-48L128 432c-8.8 0-16-7.2-16-16l0-231.8L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6l0 256c0 35.3 28.7 64 64 64l359.4 0zM370.6 388l-45.9-36.1c-1.6 .1-3.1 .2-4.7 .2c-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8c0 61.9 50.1 112 112 112c18.2 0 35.4-4.3 50.6-12z',
  ],
};
const faCommentQuote = {
  prefix: 'far',
  iconName: 'comment-quote',
  icon: [
    512,
    512,
    [],
    'e14c',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM160 144c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0zm224 80l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3z',
  ],
};
const faTablet = {
  prefix: 'far',
  iconName: 'tablet',
  icon: [
    448,
    512,
    ['tablet-android'],
    'f3fb',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faTabletAndroid = faTablet;
const faSchoolFlag = {
  prefix: 'far',
  iconName: 'school-flag',
  icon: [
    576,
    512,
    [],
    'e56e',
    'M288 0L400 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-81.9 0 89.6 64 96.3 0c39.8 0 72 32.2 72 72l0 208c0 39.8-32.2 72-72 72l-168 0-96 0L72 512c-39.8 0-72-32.2-72-72L0 232c0-39.8 32.2-72 72-72l96.3 0L264 91.6 264 24c0-13.3 10.7-24 24-24zM504 464c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-104 0c-5 0-9.9-1.6-13.9-4.5l-98.1-70-98.1 70c-4.1 2.9-8.9 4.5-13.9 4.5L72 208c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l168 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 168 0zM240 240a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 256l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM112 352l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm320 0l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
  ],
};
const faMessageCode = {
  prefix: 'far',
  iconName: 'message-code',
  icon: [
    512,
    512,
    [],
    'e1df',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM217 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z',
  ],
};
const faGlassHalf = {
  prefix: 'far',
  iconName: 'glass-half',
  icon: [
    384,
    512,
    ['glass-half-empty', 'glass-half-full'],
    'e192',
    'M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM66.7 240L50.2 48l283.7 0L317.3 240 66.7 240zm4.1 48l242.3 0L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L70.8 288z',
  ],
};
const faGlassHalfEmpty = faGlassHalf;
const faGlassHalfFull = faGlassHalf;
const faFill = {
  prefix: 'far',
  iconName: 'fill',
  icon: [
    512,
    512,
    [],
    'f575',
    'M73 7C63.6-2.3 48.4-2.3 39 7s-9.4 24.6 0 33.9l89.4 89.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L162.3 96.4 73 7zm89.4 157.3L231 233c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-68.7-68.7L255 71.6c9.4-9.4 24.6-9.4 33.9 0L440.4 223c9.4 9.4 9.4 24.6 0 33.9l-31 31L51.2 288c1.6-9.5 6.1-18.6 13.4-25.9l97.8-97.8z',
  ],
};
const faMessageMinus = {
  prefix: 'far',
  iconName: 'message-minus',
  icon: [
    512,
    512,
    ['comment-alt-minus'],
    'f4a7',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faCommentAltMinus = faMessageMinus;
const faAngleUp = {
  prefix: 'far',
  iconName: 'angle-up',
  icon: [
    448,
    512,
    [8963],
    'f106',
    'M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z',
  ],
};
const faDinosaur = {
  prefix: 'far',
  iconName: 'dinosaur',
  icon: [
    640,
    512,
    [],
    'e5fe',
    'M449.1 0c-16.8 0-33 6-45.7 16.9L375.7 40.7C360.7 53.5 352 72.4 352 92.2c0 37.5 30.4 67.8 67.8 67.8l52.2 0c13.3 0 24 10.7 24 24l0 19.2c0 11.5-9.3 20.8-20.8 20.8c-13 0-25.6-3.8-36.4-11L413.3 196c-35.2-23.5-76.6-36-119-36l-9.1 0c-60.8 0-119.5 22.7-164.5 63.6l-80.2 73C14.7 320 0 353.3 0 388.2C0 456.6 55.4 512 123.8 512l131.2 0c35.9 0 64.9-29.1 64.9-64.9c0-33-24.7-60.7-57.4-64.5l-103.2-12c-2.5-10.6-12-18.6-23.4-18.6c-13.3 0-24 10.7-24 24c0 21.3 16 39.2 37.1 41.7L257 430.3c8.5 1 15 8.2 15 16.8c0 9.3-7.6 16.9-16.9 16.9l-131.2 0C82 464 48 430 48 388.2c0-21.4 9-41.7 24.8-56.1l80.2-73c36.2-32.9 83.3-51.1 132.2-51.1l9.1 0c32.9 0 65 9.7 92.4 28l25.4 16.9c18.7 12.5 40.6 19.1 63.1 19.1c38 0 68.8-30.8 68.8-68.8l0-19.2c0-39.8-32.2-72-72-72l-52.2 0c-11 0-19.8-8.9-19.8-19.8c0-5.8 2.5-11.3 6.9-15.1l27.7-23.8c4-3.4 9.1-5.3 14.4-5.3l11.6 0C533.2 48 592 106.8 592 179.3l0 26.9c0 65-28.9 126.6-78.8 168.2l-8.6 7.2c-6.2 5.2-9.2 12.9-8.6 20.4c-.1 .7-.1 1.3-.1 2l0 52c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-32c0-8-3.9-15.4-10.5-19.9c-6.6-4.4-14.9-5.4-22.3-2.4l-.1 0c-.2 .1-.5 .2-.9 .3c-.9 .3-2.4 .8-4.6 1.5c-4.2 1.3-10.8 3.1-19.5 5c-7.7 1.6-17.1 3.3-28.2 4.6c4 10.6 6.1 22 6.1 34c0 4.7-.3 9.3-1 13.8c12.7-1.5 23.7-3.4 32.9-5.4c0 0 0 0 .1 0l0 .5c0 30.9 25.1 56 56 56l48 0c30.9 0 56-25.1 56-56l0-44.8c60.8-50.7 96-125.8 96-205l0-26.9C640 80.3 559.7 0 460.7 0L449.1 0zM480 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
  ],
};
const faDrumstickBite = {
  prefix: 'far',
  iconName: 'drumstick-bite',
  icon: [
    512,
    512,
    [],
    'f6d7',
    'M208 272c0 17.7 14.3 32 32 32l16 0 51.2 0c-2.1-10.4-3.2-21.1-3.2-32c0-82.8 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128l0 64 0 32zm-48-32l0-64C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1l-80 0-12 0c-17.7 0-31.3 15.6-41.5 30c-1.7 2.4-3.6 4.6-5.7 6.7c-12 12-11.1 31.5-6.8 47.9c1.3 4.9 2 10 2 15.4c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5.3 0 10.5 .7 15.4 2c16.4 4.3 35.9 5.2 47.9-6.8c2.1-2.1 4.4-4 6.8-5.7c14.4-10.2 30-23.9 30-41.5l0-28z',
  ],
};
const faLinkHorizontalSlash = {
  prefix: 'far',
  iconName: 'link-horizontal-slash',
  icon: [
    640,
    512,
    ['chain-horizontal-slash'],
    'e1cc',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.4-44.2c39.5-25.6 65.6-70.1 65.6-120.7c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 39.8-24.3 74-58.8 88.4L414.8 299.8c20.8-25 33.2-57.1 33.2-91.9C448 128.4 383.6 64 304.1 64L143.9 64c-9.1 0-18.1 .9-26.8 2.5L38.8 5.1zM175.2 112l129 0c52.9 0 95.9 42.9 95.9 95.9c0 23.7-8.6 45.5-23 62.3L175.2 112zM446.8 448l-60.9-48-49.9 0c-53 0-95.9-42.9-95.9-95.9c0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8C192 383.6 256.4 448 335.9 448l110.9 0zM30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4L30.1 119.7z',
  ],
};
const faChainHorizontalSlash = faLinkHorizontalSlash;
const faHollyBerry = {
  prefix: 'far',
  iconName: 'holly-berry',
  icon: [
    512,
    512,
    [],
    'f7aa',
    'M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm160 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM161.4 264.5c-1.7 58.6-42.3 107.5-97 121.6c6.2 22 7.2 45.1 2.7 67.4c24.9-6.1 50.9-5.4 75.4 1.9c1.7-58.6 42.3-107.5 97-121.6c-6.2-22-7.1-45.1-2.7-67.4c-24.9 6.1-50.9 5.4-75.4-1.9zM113.4 232c0-16.2 15.6-27.7 31.1-22.9l29.8 9.2c16.8 5.2 34.8 5.7 51.8 1.3l39-9.9c11.1-2.8 21.5 2.5 26.6 11.2c15.2 2.8 30.9 1.9 45.7-2.7l29.8-9.2c15.4-4.8 31.1 6.8 31.1 22.9l0 28.8c0 44.9 36.4 81.4 81.4 81.4c16.6 0 28.2 16.5 22.6 32.1l-6.7 18.6c-6.9 19.2-7.5 40.1-1.8 59.6l8.1 27.7c5.2 17.8-10.9 34.6-28.9 30l-39-9.9c-17.1-4.3-35-3.8-51.8 1.3l-29.8 9.2c-15.4 4.8-31.1-6.8-31.1-22.9l0-28.8c0-39.5-28.1-72.4-65.4-79.8c0 0 0 0 0 0c-37.4 7.4-65.6 40.3-65.6 79.8l0 28.8c0 16.2-15.6 27.7-31.1 22.9l-29.8-9.2c-16.8-5.2-34.8-5.7-51.8-1.3l-39 9.9c-18 4.6-34.2-12.2-28.9-30l8.1-27.7c5.8-19.6 5.1-40.4-1.8-59.6L9.5 374.3c-5.6-15.6 6-32.1 22.6-32.1c44.9 0 81.4-36.4 81.4-81.4l0-28.8zM292.7 341c44.2 19.7 75.2 63.4 76.7 114.5c24.5-7.3 50.6-8 75.4-1.9c-4.5-22.4-3.5-45.5 2.7-67.4c-54.7-14.1-95.3-62.9-97-121.6c-21.1 6.3-43.3 7.7-64.9 4.1c-5.4 19.2-4.7 39.7 2.1 58.5l5 13.9z',
  ],
};
const faNose = {
  prefix: 'far',
  iconName: 'nose',
  icon: [
    448,
    512,
    [],
    'e5bd',
    'M205.3 12.9C199.2 1.2 184.7-3.4 172.9 2.7s-16.3 20.6-10.2 32.4C237 178 327.3 280.7 374.8 329.6c16 16.4 25.2 37.6 25.2 59.2c0 41.5-33.7 75.2-75.2 75.2l-10.8 0-17-17-30.1-30.1c-21.1-21.1-49.7-32.9-79.5-32.9c-32.8 0-59.4 26.6-59.4 59.4l0 4.6c0 35.3 28.7 64 64 64l132.8 0C392.8 512 448 456.8 448 388.8c0-35.4-15.1-68.3-38.8-92.7C363.7 249.4 276.8 150.4 205.3 12.9zm27.6 437.9L246.1 464 192 464c-8.8 0-16-7.2-16-16l0-4.6c0-6.3 5.1-11.4 11.4-11.4c17.1 0 33.5 6.8 45.6 18.9zM141 303.5c13-2.8 21.2-15.5 18.4-28.5s-15.5-21.2-28.5-18.4l-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2c10.2 8.5 25.3 7.1 33.8-3.1s7.1-25.3-3.1-33.8l-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8l22.8-4.9z',
  ],
};
const faArrowLeftToArc = {
  prefix: 'far',
  iconName: 'arrow-left-to-arc',
  icon: [
    512,
    512,
    [],
    'e616',
    'M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM279.7 134.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c9.7 9 24.9 8.5 33.9-1.3s8.5-24.9-1.3-33.9L245.1 280 488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-242.9 0 67.2-62.4c9.7-9 10.3-24.2 1.3-33.9s-24.2-10.3-33.9-1.3z',
  ],
};
const faChevronLeft = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [
    320,
    512,
    [9001],
    'f053',
    'M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z',
  ],
};
const faBacteria = {
  prefix: 'far',
  iconName: 'bacteria',
  icon: [
    640,
    512,
    [],
    'e059',
    'M304.9 .7c9.6 2.7 15.1 12.7 12.4 22.3l-2.9 10.3c15.4 7.9 28.3 20.5 36.4 36.4L361 66.7c9.6-2.7 19.5 2.8 22.3 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-7.9 5.1-16.8 8.9-26.4 11.1c-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6c2.7 9.6-2.8 19.5-12.4 22.3s-19.5-2.8-22.3-12.4l-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6c9.1 3.9 13.4 14.5 9.5 23.6s-14.5 13.4-23.6 9.5l-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7c-1.4 13.3-6 25.6-12.7 36.2l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11c-2.7 9.6-12.7 15.1-22.3 12.4S64 370.6 66.7 361l2.9-10.3c-15.7-8.1-28.4-20.9-36.4-36.4l-10.3 2.9C13.4 320 3.4 314.5 .7 304.9s2.8-19.5 12.4-22.3l11-3.1c-.2-3.7-.1-7.4 .3-11.2c1.1-12.1 3.8-24.2 7-35.9c.2-.8 .4-1.5 .7-2.3l-8.7-3.5c-9.2-3.7-13.7-14.2-10-23.4s14.2-13.7 23.4-10l7.4 3c4.6-10.7 10.3-22.2 17.4-34c1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9c-7.8-6.2-9-17.5-2.8-25.3s17.5-9 25.3-2.8L87.3 126c10.2-12.2 22-24.1 35.5-35.3L117 82c-5.5-8.3-3.3-19.4 5-25s19.4-3.3 25 5l4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5c-3.9-9.1 .3-19.7 9.5-23.6s19.7 .3 23.6 9.5l4.4 10.3c8.4-2.6 17.1-4.9 26.2-7c7.5-1.7 15.1-2.4 22.4-2.1l3.1-11C285.4 3.5 295.4-2 304.9 .7zM143.8 279.9c.1-.7 .2-1.4 .3-2.1c3.2-20.9 11.7-39.5 20.3-53.8c18-30 52.2-65.4 119.7-80.9c19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1c-13.3 22.1-20.8 42.9-25 58.3c-2.8 10-4.7 19.2-5.5 27.6c-1.8 19.8 12.8 37.2 32.6 39c19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8c-.1 .7-.2 1.4-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8c-18 30-52.2 65.4-119.7 80.9c-19.4 4.5-31.5 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1c13.3-22.1 20.8-42.9 25-58.3c2.8-10 4.7-19.2 5.5-27.6c1.8-19.8-12.8-37.2-32.6-39c-19.6-1.8-36.9 12.5-39 31.9zm39.3-80l3.1-11c2.7-9.6 12.7-15.1 22.3-12.4s15.1 12.7 12.4 22.3l-2.9 10.3c15.7 8.1 28.4 20.9 36.4 36.4l10.3-2.9c9.6-2.7 19.5 2.8 22.2 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.2 3.7 .1 7.4-.3 11.2c-1.1 12.1-3.8 24.2-7 35.9l-.2 .8-.4 1.5 8.7 3.5c9.2 3.7 13.7 14.2 10 23.4s-14.2 13.7-23.4 10l-7.4-3c-4.6 10.7-10.3 22.2-17.4 34c-1.4 2.4-3 4.8-4.5 7.3l11.2 9c7.8 6.2 9 17.5 2.8 25.3s-17.5 9-25.3 2.8L552.7 386c-10.2 12.2-22 24.1-35.5 35.3L523 430c5.5 8.3 3.3 19.4-5 25s-19.4 3.3-25-5l-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5c3.9 9.1-.3 19.7-9.5 23.6s-19.7-.3-23.6-9.5l-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7c-7.5 1.7-15.1 2.4-22.5 2.1l-3.1 11c-2.7 9.6-12.7 15.1-22.2 12.4s-15.1-12.7-12.4-22.3l3-10.3c-15.4-7.9-28.3-20.5-36.4-36.4l-10.3 2.9c-9.6 2.7-19.5-2.8-22.3-12.4s2.8-19.5 12.4-22.2l11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c7.9-5.1 16.8-8.9 26.4-11.1c5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6c-2.7-9.6 2.8-19.5 12.4-22.3s19.5 2.8 22.3 12.4l1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6c-9.1-3.9-13.4-14.5-9.5-23.6s14.5-13.4 23.6-9.5l9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7c1.4-13.3 5.9-25.6 12.7-36.2l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM400 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faClouds = {
  prefix: 'far',
  iconName: 'clouds',
  icon: [
    640,
    512,
    [],
    'f744',
    'M272 112c0 .7 0 1.4 0 2c-.3 10.3 6 19.7 15.6 23.2s20.5 .6 27-7.4c8.8-10.9 22.3-17.9 37.4-17.9c26.5 0 48 21.5 48 48c0 8.7-2.3 16.8-6.3 23.8c3.6 2.3 7.1 4.8 10.6 7.4c12.8-4.4 26.5-6.8 40.7-7.2c2-7.7 3-15.7 3-24c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96l65.9 0c2.7-17.1 8.3-33.3 16.2-48L96 240c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.4 1 16.6 2.9c7.9 2.9 16.8 1.5 23.4-3.8s9.9-13.7 8.7-22c-.4-2.9-.6-6-.6-9.1c0-35.3 28.7-64 64-64s64 28.7 64 64zM240 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C201.3 462.4 176 436.2 176 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C154.4 322.1 128 359.9 128 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C534.5 247 494.9 216 448 216c-18 0-34.9 4.6-49.7 12.6C376.5 206.1 345.9 192 312 192z',
  ],
};
const faMoneyBillSimple = {
  prefix: 'far',
  iconName: 'money-bill-simple',
  icon: [
    576,
    512,
    [],
    'e1f1',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faHandLizard = {
  prefix: 'far',
  iconName: 'hand-lizard',
  icon: [
    512,
    512,
    [],
    'f258',
    'M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.7L281.1 384 136 384c-39.8 0-72-32.2-72-72s32.2-72 72-72l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L72 208c-39.8 0-72-32.2-72-72S32.2 64 72 64l209.6 0c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7L512 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-107.9c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9L72 112z',
  ],
};
const faTablePivot = {
  prefix: 'far',
  iconName: 'table-pivot',
  icon: [
    512,
    512,
    [],
    'e291',
    'M464 416c0 8.8-7.2 16-16 16l-320 0 0-240L0 192 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L160 32l0 128 304 0 0 256zM64 32C28.7 32 0 60.7 0 96l0 64 128 0 0-128L64 32zM414.8 246.1c2.5-6 1.1-12.9-3.5-17.4l-32-32c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l16 0 0 48c0 8.8-7.2 16-16 16l-48 0 0-16c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-32 32c-6.2 6.2-6.2 16.4 0 22.6l32 32c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-16 48 0c26.5 0 48-21.5 48-48l0-48 16 0c6.5 0 12.3-3.9 14.8-9.9z',
  ],
};
const faFilterSlash = {
  prefix: 'far',
  iconName: 'filter-slash',
  icon: [
    640,
    512,
    [],
    'e17d',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7l-429 0c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80L521 80 370.3 265 134.4 80zM400 411.2l-48-37.8 0 41.9-64-50.8 0-41.5-48-37.8 0 83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3l0-36.5z',
  ],
};
const faTrashCanUndo = {
  prefix: 'far',
  iconName: 'trash-can-undo',
  icon: [
    448,
    512,
    ['trash-can-arrow-turn-left', 'trash-undo-alt'],
    'f896',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm145.9 64.1c8.8 9.9 7.9 25.1-2 33.9L199.1 248l40.9 0c48.6 0 88 39.4 88 88l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24c0-22.1-17.9-40-40-40l-40.9 0 24.8 22.1c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2z',
  ],
};
const faTrashCanArrowTurnLeft = faTrashCanUndo;
const faTrashUndoAlt = faTrashCanUndo;
const faNotdef = {
  prefix: 'far',
  iconName: 'notdef',
  icon: [
    384,
    512,
    [],
    'e1fe',
    'M48 421.8L162.8 256 48 90.2l0 331.7zM77.2 464l229.6 0L192 298.2 77.2 464zm144-208L336 421.8l0-331.7L221.2 256zM306.8 48L77.2 48 192 213.8 306.8 48zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z',
  ],
};
const faDisease = {
  prefix: 'far',
  iconName: 'disease',
  icon: [
    512,
    512,
    [],
    'f7fa',
    'M64.1 286.3c0-19.3-8.3-37.6-22.8-50.3L21.8 219C8 206.9 .1 189.5 .1 171.2c0-39.3 35.3-69.3 74.1-62.8l55.6 9.3c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3l-7.4 0c-9.6 0-19.2 1.2-28.5 3.5L91 433.2c-32.6 8.2-65.7-11.7-73.8-44.3c-5.7-22.6 2.1-46.4 20-61.4L49.8 317c9.1-7.6 14.3-18.9 14.3-30.7zM267 102.1c-31.8 47.7-88.6 72.3-145.1 62.9l-55.6-9.3c-9.5-1.6-18.2 5.8-18.2 15.4c0 4.5 1.9 8.8 5.3 11.7l19.5 17.1c24.9 21.8 39.2 53.3 39.2 86.4c0 26.1-11.5 50.8-31.5 67.5L68 364.3c-3.8 3.2-5.4 8.2-4.2 13c1.7 6.9 8.7 11.1 15.6 9.4l54.9-13.7c13.1-3.3 26.6-4.9 40.1-4.9l7.4 0c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5c6.2 0 11.3-5 11.3-11.3l0-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6c0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4L308.8 94c-1.8-8.2-9.1-14-17.5-14c-6 0-11.6 3-14.9 8L267 102.1zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48-128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faPersonToDoor = {
  prefix: 'far',
  iconName: 'person-to-door',
  icon: [
    576,
    512,
    [58704],
    'e433',
    'M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM528 48l0 416-96 0 0-160.8c-10.2 10.4-24.3 16.8-40 16.8c-2.7 0-5.4-.2-8-.6L384 464c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L432 0c-26.5 0-48 21.5-48 48l0 160.6c2.6-.4 5.3-.6 8-.6c15.7 0 29.8 6.4 40 16.8L432 48l96 0z',
  ],
};
const faTurntable = {
  prefix: 'far',
  iconName: 'turntable',
  icon: [
    576,
    512,
    [],
    'f8e4',
    'M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 135.7c0 6.7-1.7 13.3-4.9 19.2l-40.2 73.7c-6.3 11.6-2.1 26.2 9.6 32.6s26.2 2.1 32.6-9.6l40.2-73.7c7-12.9 10.7-27.4 10.7-42.1L496 136z',
  ],
};
const faBriefcaseMedical = {
  prefix: 'far',
  iconName: 'briefcase-medical',
  icon: [
    512,
    512,
    [],
    'f469',
    'M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm24 88l208 0 88 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l88 0zm72 64l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faGenderless = {
  prefix: 'far',
  iconName: 'genderless',
  icon: [
    384,
    512,
    [],
    'f22d',
    'M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352z',
  ],
};
const faChevronRight = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [
    320,
    512,
    [9002],
    'f054',
    'M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z',
  ],
};
const faSignalWeak = {
  prefix: 'far',
  iconName: 'signal-weak',
  icon: [
    640,
    512,
    ['signal-1'],
    'f68c',
    'M64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z',
  ],
};
const faSignal1 = faSignalWeak;
const faClockFive = {
  prefix: 'far',
  iconName: 'clock-five',
  icon: [
    512,
    512,
    [],
    'e349',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 128.7 60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faRetweet = {
  prefix: 'far',
  iconName: 'retweet',
  icon: [
    576,
    512,
    [],
    'f079',
    'M120 208l31 0c22.6 0 41-18.3 41-41c0-10.9-4.3-21.3-12-29L113 71c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-67 67c-7.7 7.7-12 18.1-12 29c0 22.6 18.3 41 41 41l31 0 0 120c0 48.6 39.4 88 88 88l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0c-22.1 0-40-17.9-40-40l0-120zM96 121.9L134.1 160l-76.1 0L96 121.9zM504 304l0-120c0-48.6-39.4-88-88-88L280 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c22.1 0 40 17.9 40 40l0 120-31 0c-22.6 0-41 18.3-41 41c0 10.9 4.3 21.3 12 29l67 67c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l67-67c7.7-7.7 12-18.1 12-29c0-22.6-18.3-41-41-41l-31 0zm-24 86.1L441.9 352l76.1 0L480 390.1z',
  ],
};
const faCarRear = {
  prefix: 'far',
  iconName: 'car-rear',
  icon: [
    512,
    512,
    ['car-alt'],
    'f5de',
    'M165.4 80l181.2 0c17 0 32.1 10.7 37.8 26.8L408.6 176l-305.1 0 24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM82.3 90.9L48.1 188.8C19.3 205.4 0 236.4 0 272l0 64c0 23.7 12.9 44.4 32 55.4L32 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 352 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64.6c19.1-11.1 32-31.7 32-55.4l0-64c0-35.6-19.4-66.6-48.1-83.2L429.7 90.9C417.3 55.6 384 32 346.6 32L165.4 32C128 32 94.7 55.6 82.3 90.9zM96 224l320 0c20.9 0 38.7 13.4 45.3 32L408 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 32c0 8.8-7.2 16-16 16l-128 0 0-32c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 32L64 352c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-53.3 0c6.6-18.6 24.4-32 45.3-32z',
  ],
};
const faCarAlt = faCarRear;
const faPumpSoap = {
  prefix: 'far',
  iconName: 'pump-soap',
  icon: [
    448,
    512,
    [],
    'e06b',
    'M112 56c0-30.9 25.1-56 56-56l48 0c25.4 0 46.8 16.9 53.7 40l46.4 0c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7L272 88l0 40-48 0 0-72c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 72-48 0 0-72zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464l186.4 0c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7l-149.1 0c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zm125.8 59.9c2.9-4.1 7.5-6.6 12.6-6.6s9.7 2.5 12.6 6.6l33.3 48.1c6.6 9.5 10.1 20.8 10.1 32.4l0 .9c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-.9c0-11.6 3.5-22.9 10.1-32.4l33.3-48.1z',
  ],
};
const faComputerClassic = {
  prefix: 'far',
  iconName: 'computer-classic',
  icon: [
    448,
    512,
    [],
    'f8b1',
    'M384 48c8.8 0 16 7.2 16 16l0 304c0 8.8-7.2 16-16 16L64 384c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 368c0 23.7 12.9 44.4 32 55.4L32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-304c0-35.3-28.7-64-64-64L64 0zM80 432l288 0 0 32L80 464l0-32zm0-320l0 96c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L112 80c-17.7 0-32 14.3-32 32zM208 320c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm-88 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faFrame = {
  prefix: 'far',
  iconName: 'frame',
  icon: [
    448,
    512,
    [],
    'e495',
    'M448 120c0-13.3-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L112 96l0-40c0-13.3-10.7-24-24-24S64 42.7 64 56l0 40L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 224-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 224 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-224 40 0c13.3 0 24-10.7 24-24zM112 368l0-224 224 0 0 224-224 0z',
  ],
};
const faVideoSlash = {
  prefix: 'far',
  iconName: 'video-slash',
  icon: [
    640,
    512,
    [],
    'f4e2',
    'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L113.9 64 352 64c35.3 0 64 28.7 64 64l0 33 0 127 0 12.8L560 413.6l0-50.3 0-11.4 0-64 0-139.4L448 199l0-52.6L552.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5L608 352l0 24.5 0 74.8 22.8 17.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM368 263.1L368 128c0-8.8-7.2-16-16-16l-176.8 0L368 263.1zM32 128c0-2.2 .1-4.4 .3-6.5L80 159l0 225c0 8.8 7.2 16 16 16l256 0c8.2 0 15-6.2 15.9-14.1L407 416.7c-11.2 18.7-31.6 31.3-55 31.3L96 448c-35.3 0-64-28.7-64-64l0-256z',
  ],
};
const faBatteryQuarter = {
  prefix: 'far',
  iconName: 'battery-quarter',
  icon: [
    576,
    512,
    ['battery-2'],
    'f243',
    'M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm112 96l-96 0 0 128 96 0 0-128z',
  ],
};
const faBattery2 = faBatteryQuarter;
const faEllipsisStroke = {
  prefix: 'far',
  iconName: 'ellipsis-stroke',
  icon: [
    512,
    512,
    ['ellipsis-h-alt'],
    'f39b',
    'M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z',
  ],
};
const faEllipsisHAlt = faEllipsisStroke;
const faRadio = {
  prefix: 'far',
  iconName: 'radio',
  icon: [
    512,
    512,
    [128251],
    'f8d7',
    'M494.4 47.1c12.8-3.5 20.3-16.7 16.8-29.5S494.4-2.7 481.6 .9L52.9 119.1C21.6 127.8 0 156.2 0 188.5L0 192 0 304 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-246.8 0L494.4 47.1zM48 192c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-144 0-112zm304 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM96 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 304zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z',
  ],
};
const faBabyCarriage = {
  prefix: 'far',
  iconName: 'baby-carriage',
  icon: [
    512,
    512,
    ['carriage-baby'],
    'f77d',
    'M138.9 22.9L256 192l144 0 0-40c0-30.9 25.1-56 56-56l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-4.4 0-8 3.6-8 8l0 40 0 32c0 28-6.1 55.6-17.7 81.1c-11.6 25.5-28.6 48.4-49.5 67.5c-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3s-51.5-25-72.5-44.1s-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224l0-32 .1 0C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM56.1 272c1.5 4.5 3.3 8.9 5.3 13.2c8.8 19.4 21.8 37 38.2 51.9s35.7 26.6 57.1 34.7s44.2 12.2 67.4 12.2s46-4.1 67.4-12.2s40.8-19.8 57.1-34.7s29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2c3.6-10.4 6-21.1 7.2-32L48.9 240c1.2 10.9 3.6 21.6 7.2 32z',
  ],
};
const faCarriageBaby = faBabyCarriage;
const faFaceExpressionless = {
  prefix: 'far',
  iconName: 'face-expressionless',
  icon: [
    512,
    512,
    [],
    'e373',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 72l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM128 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm176-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
const faDownToDottedLine = {
  prefix: 'far',
  iconName: 'down-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e408',
    'M114.2 224L224 334 333.8 224 280 224c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 384c-11.5 0-22.5-4.6-30.6-12.7L77.6 255.2C68.9 246.5 64 234.7 64 222.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0z',
  ],
};
const faCloudMusic = {
  prefix: 'far',
  iconName: 'cloud-music',
  icon: [
    640,
    512,
    [],
    'f8ae',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faTrafficLight = {
  prefix: 'far',
  iconName: 'traffic-light',
  icon: [
    320,
    512,
    [128678],
    'f637',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-168a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
  ],
};
const faCloudMinus = {
  prefix: 'far',
  iconName: 'cloud-minus',
  icon: [
    640,
    512,
    [],
    'e35d',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faThermometer = {
  prefix: 'far',
  iconName: 'thermometer',
  icon: [
    512,
    512,
    [],
    'f491',
    'M369.8 64.2c10.3-10.4 24.4-16.2 39-16.2c30.5 0 55.2 24.7 55.2 55.2c0 14.6-5.8 28.7-16.2 39L224.4 365.7c-1.5 1.5-3.5 2.3-5.7 2.3L144 368l0-74.7c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 45.5-45.5zM96 293.3l0 88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l89-89 88.8 0c14.9 0 29.1-5.9 39.6-16.4L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L112.4 253.7C101.9 264.2 96 278.4 96 293.3z',
  ],
};
const faShieldMinus = {
  prefix: 'far',
  iconName: 'shield-minus',
  icon: [
    512,
    512,
    [],
    'e249',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faVrCardboard = {
  prefix: 'far',
  iconName: 'vr-cardboard',
  icon: [
    640,
    512,
    [],
    'f729',
    'M560 112L80 112c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l110.6 0c12.1 0 23.2-6.8 28.6-17.7l34.7-69.5C266.4 287.8 292 272 320 272s53.6 15.8 66.1 40.8l34.7 69.5c5.4 10.8 16.5 17.7 28.6 17.7L560 400c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM80 64l480 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-110.6 0c-30.3 0-58-17.1-71.6-44.2l-34.7-69.5c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-34.7 69.5c-13.6 27.1-41.3 44.2-71.6 44.2L80 448c-44.2 0-80-35.8-80-80L0 144C0 99.8 35.8 64 80 64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faCarTilt = {
  prefix: 'far',
  iconName: 'car-tilt',
  icon: [
    640,
    512,
    [],
    'f5e5',
    'M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3L72.7 464 24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-495.5 0-9.7-36.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1s0 0 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5z',
  ],
};
const faGaugeCircleMinus = {
  prefix: 'far',
  iconName: 'gauge-circle-minus',
  icon: [
    640,
    512,
    [],
    'e497',
    'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
  ],
};
const faBrightnessLow = {
  prefix: 'far',
  iconName: 'brightness-low',
  icon: [
    512,
    512,
    [],
    'e0ca',
    'M288 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faHandMiddleFinger = {
  prefix: 'far',
  iconName: 'hand-middle-finger',
  icon: [
    448,
    512,
    [128405],
    'f806',
    'M224 0c-35.3 0-64 28.7-64 64l0 120.5c-2.6-.3-5.3-.5-8-.5c-35.3 0-64 28.7-64 64l0 10.8c-2.4 1.9-4.7 3.9-6.9 5.9L60.8 283.2C42.5 299.9 32 323.5 32 348.3l0 10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7L312 512c66.3 0 120-53.7 120-120l0-8 0-96c0-35.3-28.7-64-64-64c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5L288 64c0-35.3-28.7-64-64-64zM208 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 168c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 96 0 8c0 39.8-32.2 72-72 72l-125.4 0c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C99.6 429.7 80 395.5 80 358.5l0-10.2c0-11.3 4.8-22 13.1-29.6l10.9-9.9 0 35.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73 0-7 0-16c0-8.8 7.2-16 16-16c5.2 0 9.9 2.5 12.8 6.4c6.2 8.3 17 11.6 26.8 8.3s16.4-12.4 16.4-22.8l0-160z',
  ],
};
const faPercent = {
  prefix: 'far',
  iconName: 'percent',
  icon: [
    384,
    512,
    [62101, 62785, 'percentage'],
    '25',
    'M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faPercentage = faPercent;
const faTruckMoving = {
  prefix: 'far',
  iconName: 'truck-moving',
  icon: [
    640,
    512,
    [],
    'f4df',
    'M72 80c-13.3 0-24 10.7-24 24l0 222.7c9.8-4.3 20.6-6.7 32-6.7c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-248c0-13.3-10.7-24-24-24L72 80zM208 480c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-48 0-48L0 104C0 64.2 32.2 32 72 32l336 0c39.8 0 72 32.2 72 72l0 40 48.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l-8 0-8 0-144 0c0 44.2-35.8 80-80 80zM535 194.9c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faGlassWaterDroplet = {
  prefix: 'far',
  iconName: 'glass-water-droplet',
  icon: [
    384,
    512,
    [],
    'e4f5',
    'M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM73.5 319.2L50.2 48l283.7 0L310.5 319.2l-9.3 5.2c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 331.6 99 333.3 82.8 324.3l-9.3-5.2zm4.7 55c29 8.6 60.9 2.8 85.2-16.6c16.7-13.3 40.4-13.3 57 0c24.3 19.4 56.2 25.3 85.2 16.6l-5.9 67.9C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9l-5.9-67.9zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z',
  ],
};
const faConveyorBelt = {
  prefix: 'far',
  iconName: 'conveyor-belt',
  icon: [
    640,
    512,
    [],
    'f46e',
    'M384 48l80 0 0 160-288 0 0-160 80 0 0 80c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 115.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-80zM128 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zM592 400c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l416 0c35.3 0 64 28.7 64 64zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l416 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-416 0zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faLocationCheck = {
  prefix: 'far',
  iconName: 'location-check',
  icon: [
    384,
    512,
    ['map-marker-check'],
    'f606',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-95-20.4L182.3 278.3c-9.4 9.4-24.6 9.4-33.9 0L95 225c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L255 137.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};
const faMapMarkerCheck = faLocationCheck;
const faCoinVertical = {
  prefix: 'far',
  iconName: 'coin-vertical',
  icon: [
    384,
    512,
    [],
    'e3fd',
    'M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256s14.7-119.6 36-157.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5zM0 256C0 397.4 64.5 512 144 512l48 0 64 0c70.7 0 128-114.6 128-256S326.7 0 256 0L192 0 144 0C64.5 0 0 114.6 0 256zm286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40l48 0c1.1 12.9 1.7 26.3 1.7 40s-.6 27.1-1.7 40l-48 0zm-4 32l48.1 0c-3.9 23.7-9.6 45.3-16.6 64L266 392c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40l46.5 0c-18.9 33.8-36.3 40-43.1 40l-28 0zM330.3 184l-48.1 0c-3.8-22.8-9.2-44.3-16.2-64l47.7 0c7 18.7 12.7 40.3 16.6 64zM299.1 88l-46.5 0C245.3 73 237 59.6 228 48l28 0c6.8 0 24.2 6.2 43.1 40zM120 256c0-40.2 5.2-75.7 12.9-100.3c3.7-11.8 7.7-19.9 11.1-24.7c3.4 4.8 7.3 12.9 11.1 24.7c7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7c-3.4-4.8-7.3-12.9-11.1-24.7c-7.8-24.6-12.9-60-12.9-100.3zm27.4-128.8s-.1 0-.2 .1c.1-.1 .2-.1 .2-.1zm-6.6 .1c-.1-.1-.2-.1-.2-.1s.1 .1 .2 .1zm-.2 257.4s.1 0 .2-.1c-.1 .1-.2 .1-.2 .1zm6.6-.1c.1 .1 .2 .1 .2 .1s-.1-.1-.2-.1zM144 80c-17.7 0-30.3 11.3-37.9 21.6c-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7c7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7c9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80z',
  ],
};
const faDisplay = {
  prefix: 'far',
  iconName: 'display',
  icon: [
    576,
    512,
    [],
    'e163',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM211.7 416L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48zm48.7 0l-8 48 71.3 0-8-48-55.3 0z',
  ],
};
const faPersonSign = {
  prefix: 'far',
  iconName: 'person-sign',
  icon: [
    512,
    512,
    [],
    'f757',
    'M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7L316.5 226l-19.3-7.2c-12.1-4.6-22.8-12.3-30.9-22.4L238 161c-16.7-20.9-42-33-68.7-33l-39.6 0c-34.8 0-66.3 20.5-80.4 52.3L2.1 286.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L80 229.1 80 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 52.2 0 27.1 59.6c.5 1 .7 2.2 .7 3.3l0 73.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.1c0-8-1.7-15.9-5-23.2l-35-77 0-104.4 12.7 15.9c13.5 16.9 31.3 29.8 51.6 37.4l19.7 7.4-11 30.3c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM334.8 60l120.3 43.8L433.2 164 312.9 120.2 334.8 60zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 80l38.4 0 0 128-40 0 0-128c.5 0 1.1 0 1.6 0z',
  ],
};
const faFaceSmile = {
  prefix: 'far',
  iconName: 'face-smile',
  icon: [
    512,
    512,
    [128578, 'smile'],
    'f118',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faSmile = faFaceSmile;
const faPhoneHangup = {
  prefix: 'far',
  iconName: 'phone-hangup',
  icon: [
    640,
    512,
    [],
    'e225',
    'M320 144C193.1 144 98.7 205.9 53.3 250.2c-4.6 4.5-6.6 12.9-2.1 21.8l36.1 71.5c1.6 3.2 5.2 4.9 8.7 4.2l102.4-20.3c3.7-.7 6.4-4 6.4-7.8l0-71.1c0-10.4 6.6-19.5 16.5-22.8l3.4-1.1c61.9-20.4 128.7-20.4 190.7 0l3.4 1.1c9.8 3.2 16.5 12.4 16.5 22.8l0 71.1c0 3.8 2.7 7.1 6.4 7.8L544 347.7c3.5 .7 7.1-1 8.7-4.2L588.8 272c4.5-8.9 2.6-17.3-2.1-21.8C541.3 205.9 446.9 144 320 144zM19.8 215.8C71.5 165.4 177.4 96 320 96s248.5 69.4 300.2 119.8c22 21.5 23.8 53.4 11.4 77.8l-36.1 71.5c-11.3 22.4-36.2 34.6-60.9 29.7L432.3 374.5c-26.2-5.2-45.1-28.2-45.1-54.9l0-53.4c-44-12-90.4-12-134.4 0l0 53.4c0 26.7-18.9 49.7-45.1 54.9L105.3 394.8c-24.7 4.9-49.6-7.3-60.9-29.7L8.3 293.6C-4 269.2-2.3 237.3 19.8 215.8z',
  ],
};
const faSignatureSlash = {
  prefix: 'far',
  iconName: 'signature-slash',
  icon: [
    640,
    512,
    [],
    'e3cb',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.2 0-61.2-48L552 320c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM178 114.2C183.9 94.4 202.3 80 224 80c26.5 0 48 21.5 48 48l0 7.9c0 16.7-.9 33.4-2.6 50L178 114.2zM343.5 243.9l73.7-22.8-22.5 63-51.2-40.2zM406.2 416l-60.9-48-41.1 0c-7 16.3-14.8 32.4-23.3 48l125.4 0zM158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2l59.5-18.4-45.8-36.1L158 251.1zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42z',
  ],
};
const faThumbtack = {
  prefix: 'far',
  iconName: 'thumbtack',
  icon: [
    384,
    512,
    [128204, 128392, 'thumb-tack'],
    'f08d',
    'M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304 168 304l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 115.5 0-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7L134.8 48c0 1.2 0 2.5-.1 3.7zM168 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48L56 48c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0L86.8 0 297.2 0 328 0c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3l-30.8 0 3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-136 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
  ],
};
const faThumbTack = faThumbtack;
const faWheatSlash = {
  prefix: 'far',
  iconName: 'wheat-slash',
  icon: [
    640,
    512,
    [],
    'e339',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-174-136.4c3.6-2.8 7.1-5.9 10.5-9.3l16.9-16.9c8.5-8.5 9.3-21.7 2.4-31.1c21.9-3.8 42.9-14.2 59.8-31.1l16.9-16.9c9.4-9.4 9.4-24.6 0-33.9l-16.9-16.9c-11.6-11.6-24.8-20.4-38.9-26.7C546.8 140.9 576 105.9 576 64l0-40c0-13.3-10.7-24-24-24L512 0c-41.9 0-76.9 29.3-85.8 68.5C420 54.3 411 41 399.4 29.4L382.5 12.4c-9.4-9.4-24.6-9.4-33.9 0L331.6 29.4c-16.9 16.9-27.3 37.9-31.1 59.8c-9.4-6.9-22.6-6.1-31.1 2.4l-16.9 16.9c-12.5 12.5-21.5 27.3-26.8 43L38.8 5.1zM267.7 184.5c.8-15.3 7-30.3 18.6-42c19.9 20 27.1 47.8 21.6 73.5l-40.2-31.5zM372 266.3c22-1.3 44.5 6.4 61.3 23.3c-5 4.9-10.5 8.9-16.4 11.9L372 266.3zM173.3 346.1l11.3 11.3c0 0 0 0 0 0L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L218.5 391.4l11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l.5-.5-38.1-30c-25.1 21.5-63 20.4-86.8-3.4l-10.1-10.2c20.1-13.3 44.8-16.6 67.2-9.8l-90.2-71.1c.1 15.6-4.3 31.2-13.2 44.7l-10.1-10.1c-17.6-17.6-22.8-43-15.6-65.2l-39.1-30.8c-21.4 42.1-14.5 94.8 20.7 129.9zM512 48l16 0 0 16c0 22.1-17.9 40-40 40l-16 0 0-16c0-22.1 17.9-40 40-40zM365.5 153.8c-25-25-25-65.5 0-90.5c27.3 27.4 30.7 69.6 10.2 100.6l-10.1-10.1zm147 56.5c-25 25-65.5 25-90.5 0l-10.1-10.1c31-20.5 73.3-17.2 100.6 10.2z',
  ],
};
const faTrophy = {
  prefix: 'far',
  iconName: 'trophy',
  icon: [
    576,
    512,
    [127942],
    'f091',
    'M248.8 309.7c-27.6-30.3-65.5-101-71.8-261.7l222.2 0c-6.4 160.7-44.3 231.4-71.8 261.7c-13.7 15.1-25.9 21.4-33.1 24.1c-2.6 1-4.7 1.5-6.1 1.9c-1.4-.3-3.5-.9-6.1-1.9c-7.2-2.7-19.4-9-33.1-24.1zM400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88C0 196.5 45.9 265.7 101.5 308.6c53.9 41.7 115.7 57.6 149.5 63.7c4.7 2.5 9.1 4.5 13.1 6.1l0 85.6-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-85.6c4-1.6 8.4-3.6 13.1-6.1c33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm42.7 112l84.4 0c-6 78.4-41.3 127.3-81.9 158.6c-17.5 13.6-36.3 24-54.4 32c22.7-40.3 42.8-100.5 51.9-190.6zM185.2 302.6c-18.1-8-36.8-18.4-54.4-32C90.2 239.3 54.9 190.4 48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6z',
  ],
};
const faCloudsSun = {
  prefix: 'far',
  iconName: 'clouds-sun',
  icon: [
    640,
    512,
    [],
    'f746',
    'M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm409.8 32.1l12.4 0c.6 0 1.2 0 1.8 0c13.2 0 24-10.7 24-24s-10.7-24-24-24c-1.1 0-2.2 .1-3.2 .2c-25.1 3.3-48.5-13.5-53.4-38.4c-2.9-14.7-15.9-25.8-31.4-25.8c-13.6 0-25.3 8.5-29.9 20.6c-9.2 24.3-36.2 36.9-60.8 28.2c-1.6-.6-3.4-.9-5.3-.9c-8.8 0-15.9 7.1-16 15.9l-.1 0c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9c-9.5-17.7-23.6-32.5-40.8-42.9zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z',
  ],
};
const faPersonPraying = {
  prefix: 'far',
  iconName: 'person-praying',
  icon: [
    448,
    512,
    [128720, 'pray'],
    'f683',
    'M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM202.1 192c5.3 0 10.2 2.7 12.9 7.2l4.3 7.1L152.2 367.5l-9.4-6c-9.8-6.3-13.7-18.7-9.2-29.4l54.5-130.7c2.4-5.7 7.9-9.3 14-9.3zm48.3 64.7l7.4 12.1c12.8 20.9 41.2 25.4 59.9 9.6l89.8-76c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-82.7 70-37.9-61.6C244.4 155.4 224 144 202.1 144c-25.5 0-48.5 15.3-58.3 38.9L89.3 313.6c-13.4 32.3-1.8 69.5 27.6 88.3L214 464 56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c10.7 0 20-7 23-17.3s-1.1-21.2-10.1-27l-115.7-74 57.1-137.1z',
  ],
};
const faPray = faPersonPraying;
const faHammer = {
  prefix: 'far',
  iconName: 'hammer',
  icon: [
    576,
    512,
    [128296],
    'f6e3',
    'M432.8 204.9c-9.1-9.1-21.5-14.2-34.4-14.1c-11.3 .1-22.4-4.1-31-12.7L329.3 140c-5.9-5.9-9.3-14-9.3-22.4l0-12.1c0-17.6-9.6-33.7-25-42.1L273.3 51.5c8.4-2.3 17.1-3.5 25.8-3.5l18.1 0c24.5 0 48 9.3 65.8 26.1l44.6 42c9.7 9.1 14.3 21.7 13.5 34.1c-.8 13.7 4.3 27.1 14 36.8l37 37L472 244.1l-39.2-39.2zM216.7 75.3l.3 .2 55 30 0 12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1c18.1 18.1 41.8 26.9 65.4 26.7l39.2 39.2 1 1-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L569 217c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-8 8-1-1-37-37c1.6-26.1-8-52.7-28.5-72l-44.6-42C389.2 14 353.9 0 317.2 0L299.2 0C279 0 259.1 4.2 240.7 12.4L219.1 22l-.3 .1-6.2 2.8-19.1 8.5c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7l18.4 10 6 3.3zm44.2 107.3L27.4 377.1C10.1 391.6 0 413.1 0 435.7C0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L330 250.4c-6.8-4.5-13.2-9.7-19.2-15.7l-38.1-38.1c-4.3-4.3-8.3-9-11.8-14z',
  ],
};
const faFaceVomit = {
  prefix: 'far',
  iconName: 'face-vomit',
  icon: [
    576,
    512,
    [],
    'e3a0',
    'M496 256c0 63.4-28.3 120.1-73 158.3c5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM148 157.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 396.1l0-58.3c10.8 4.3 18.7 8.5 23.1 11.5c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4c4.4-3 12.3-7.2 23.1-11.5l0 58.3c0 31-19.8 58.5-49.2 68.3l-34.1 11.4c-7.6 2.5-12.7 9.6-12.7 17.6c0 10.3 8.3 18.6 18.6 18.6l346.8 0c10.3 0 18.6-8.3 18.6-18.6c0-8-5.1-15.1-12.7-17.6l-34.1-11.4c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faSpeakers = {
  prefix: 'far',
  iconName: 'speakers',
  icon: [
    640,
    512,
    [],
    'f8e0',
    'M64 0L248.4 0c-11.8 13.2-20.1 29.7-23.1 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l161.3 0c3.1 18.3 11.3 34.8 23.1 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM192 88c13.1 0 24.7 6.3 32 16l0 48c-7.3 9.7-18.9 16-32 16c-22.1 0-40-17.9-40-40s17.9-40 40-40zm0 120c11.1 0 21.9 1.6 32 4.6l0 51.9c-9.4-5.4-20.3-8.6-32-8.6c-35.3 0-64 28.7-64 64s28.7 64 64 64c11.7 0 22.6-3.1 32-8.6l0 51.9c-10.1 3-20.9 4.6-32 4.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zM320 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L320 48zM256 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-384zM448 88a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM336 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faTtyAnswer = {
  prefix: 'far',
  iconName: 'tty-answer',
  icon: [
    640,
    512,
    ['teletype-answer'],
    'e2b9',
    'M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM304 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM592 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM576 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 160l128 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
  ],
};
const faTeletypeAnswer = faTtyAnswer;
const faMugTeaSaucer = {
  prefix: 'far',
  iconName: 'mug-tea-saucer',
  icon: [
    640,
    512,
    [],
    'e1f5',
    'M144 288c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-208L248 80l0 10.7c0 8.5 3.4 16.6 9.4 22.6l21.3 21.3c6 6 9.4 14.1 9.4 22.6l0 66.7c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-66.7c0-8.5 3.4-16.6 9.4-22.6l21.3-21.3c6-6 9.4-14.1 9.4-22.6L216 80l-72 0 0 208zM96 64c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64zM480 240l32 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-32 0 0 160zM24 432l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faDiagramLeanCanvas = {
  prefix: 'far',
  iconName: 'diagram-lean-canvas',
  icon: [
    640,
    512,
    [],
    'e156',
    'M512 80l0 216 80 0 0-200c0-8.8-7.2-16-16-16l-64 0zm-48 0l-64 0 0 88 64 0 0-88zM352 80l-64 0 0 216 64 0 0-216zM240 80l-64 0 0 88 64 0 0-88zM128 80L64 80c-8.8 0-16 7.2-16 16l0 200 80 0 0-216zM48 344l0 72c0 8.8 7.2 16 16 16l232 0 0-88L48 344zm296 88l232 0c8.8 0 16-7.2 16-16l0-72-248 0 0 88zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM240 296l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z',
  ],
};
const faAlt = {
  prefix: 'far',
  iconName: 'alt',
  icon: [
    640,
    512,
    [],
    'e08a',
    'M467.9 120.4c4.6-5.3 11.2-8.4 18.2-8.4L616 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L486.1 64c-21 0-41 9.2-54.7 25.1L172.1 391.6c-4.6 5.3-11.2 8.4-18.2 8.4L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l129.9 0c21 0 41-9.2 54.7-25.1L467.9 120.4zM440 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z',
  ],
};
const faDial = {
  prefix: 'far',
  iconName: 'dial',
  icon: [
    576,
    512,
    ['dial-med-high'],
    'e15b',
    'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 208.8c37.9-37.9 96.2-43 139.6-15.1L271 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faDialMedHigh = faDial;
const faHandPeace = {
  prefix: 'far',
  iconName: 'hand-peace',
  icon: [
    512,
    512,
    [9996],
    'f25b',
    'M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192l0 48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2l-7.4 0-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240 144 240c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16z',
  ],
};
const faCircleTrash = {
  prefix: 'far',
  iconName: 'circle-trash',
  icon: [
    512,
    512,
    ['trash-circle'],
    'e126',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 128l41.4 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l64 0c4.2 0 8.3 1.7 11.3 4.7L310.6 128l41.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l192 0L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3l-101.1 0c-16.6 0-30.5-12.8-31.9-29.3L160 192z',
  ],
};
const faTrashCircle = faCircleTrash;
const faRotate = {
  prefix: 'far',
  iconName: 'rotate',
  icon: [
    512,
    512,
    [128260, 'sync-alt'],
    'f2f1',
    'M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25c0 19.5 15.8 35.3 35.3 35.3L472 224c13.3 0 24-10.7 24-24l0-116.7C496 63.8 480.2 48 460.7 48c-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9l-4.1-4.1 35.7-35.7c6.6-6.6 10.3-15.6 10.3-25c0-19.5-15.8-35.3-35.3-35.3L40 288c-13.3 0-24 10.7-24 24l0 116.7C16 448.2 31.8 464 51.3 464c9.4 0 18.3-3.7 25-10.3L112 417.9l4.1 4.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9zM448 176l-62.1 0L448 113.9l0 62.1zM64 336l62.1 0L64 398.1 64 336z',
  ],
};
const faSyncAlt = faRotate;
const faCircleQuarters = {
  prefix: 'far',
  iconName: 'circle-quarters',
  icon: [
    512,
    512,
    [],
    'e3f8',
    'M108.9 403.1L256 256 403.1 403.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faSpinner = {
  prefix: 'far',
  iconName: 'spinner',
  icon: [
    512,
    512,
    [],
    'f110',
    'M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z',
  ],
};
const faTowerControl = {
  prefix: 'far',
  iconName: 'tower-control',
  icon: [
    448,
    512,
    [],
    'e2a2',
    'M160 24c0-13.3 10.7-24 24-24l40 0 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 48 40 0c17.7 0 32 14.3 32 32l93.2 0c21.4 0 36.8 20.7 30.6 41.2L402.7 306.5c7.9 3.9 13.3 12.1 13.3 21.5c0 13.3-10.7 24-24 24l-24 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-192 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-24 0c-13.3 0-24-10.7-24-24c0-9.4 5.4-17.6 13.3-21.5L4.1 169.2C-2.1 148.7 13.3 128 34.8 128l93.2 0c0-17.7 14.3-32 32-32l40 0 0-48-16 0c-13.3 0-24-10.7-24-24zM94.7 304l33.3 0 0-128-71.7 0L94.7 304zm81.3 0l96 0 0-128-96 0 0 128zM320 176l0 128 33.3 0 38.4-128L320 176z',
  ],
};
const faArrowUpTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-up-triangle-square',
  icon: [
    576,
    512,
    ['sort-shapes-up'],
    'f88a',
    'M416 32c9.9 0 19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9L391.8 45.7C396.9 37.2 406.1 32 416 32zM368 432l96 0 0-96-96 0 0 96zM416 98.6L369.6 176l92.8 0L416 98.6zM320 432l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z',
  ],
};
const faSortShapesUp = faArrowUpTriangleSquare;
const faWhale = {
  prefix: 'far',
  iconName: 'whale',
  icon: [
    640,
    512,
    [128011],
    'f72c',
    'M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L79.2 176.8 43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480L544 480c53 0 96-43 96-96l0-108.3C640 194.1 573.9 128 492.3 128c-80.5 0-158.6 27.4-221.4 77.7L139 311.2c-7.1 5.7-15.9 8.8-25 8.8l-1 0c-19 0-35.2-13.7-38.4-32.5c-1.7-9.9 .6-20.1 6.3-28.4l35.4-51.4 9.1-13.2 47.6 7.9c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM50.5 341.5C66.4 358 88.7 368 113 368l1 0c20 0 39.4-6.8 55-19.3L300.9 243.1C355.2 199.7 422.7 176 492.3 176c55 0 99.7 44.6 99.7 99.7L592 384c0 26.5-21.5 48-48 48l-381.6 0c-55 0-100.9-38.8-111.9-90.5zM392 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faRobot = {
  prefix: 'far',
  iconName: 'robot',
  icon: [
    640,
    512,
    [129302],
    'f544',
    'M320 0c13.3 0 24 10.7 24 24l0 72 104 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96l0-224c0-53 43-96 96-96l104 0 0-72c0-13.3 10.7-24 24-24zM192 144c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-128 0-128 0zM48 224l16 0 0 192-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0-192 16 0zM208 384l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM200 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm200-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
  ],
};
const faPeace = {
  prefix: 'far',
  iconName: 'peace',
  icon: [
    512,
    512,
    [9774],
    'f67c',
    'M232 462.6l0-156L111.3 405.4c32 31 74 51.9 120.7 57.2zM80.9 368.3L232 244.6l0-195.3C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3zm319.8 37.1L280 306.6l0 156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6l0 195.3L431.1 368.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
};
const faPartyHorn = {
  prefix: 'far',
  iconName: 'party-horn',
  icon: [
    512,
    512,
    [],
    'e31b',
    'M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM59.3 452.7l86.9-32.6L91.9 365.8 59.3 452.7zm200.1-75l-125-125-23.9 63.8 85.1 85.1 63.8-23.9zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18.1 519.4-7.4 494 2 468.8L98.1 212.6z',
  ],
};
const faGears = {
  prefix: 'far',
  iconName: 'gears',
  icon: [
    640,
    512,
    ['cogs'],
    'f085',
    'M147.1 52.7l-6.5 23.5c-1.7 6.2-6.3 11.2-12.4 13.5c-10 3.7-19.1 9-27.2 15.7c-5 4.1-11.6 5.6-17.9 4l-23.6-6.2c-5 6.9-9.4 14.4-12.9 22.3l17.1 17.4c4.5 4.6 6.6 11.1 5.5 17.4c-.9 5.1-1.3 10.3-1.3 15.7s.5 10.6 1.3 15.7c1.1 6.4-.9 12.9-5.5 17.4L46.7 226.5c3.5 7.9 7.9 15.4 12.9 22.3l23.6-6.2c6.3-1.6 12.9-.1 17.9 4c8 6.7 17.2 12 27.2 15.7c6.1 2.2 10.7 7.2 12.4 13.5l6.5 23.5c4.2 .4 8.5 .7 12.9 .7s8.7-.2 12.9-.7l6.5-23.5c1.7-6.2 6.3-11.2 12.4-13.5c10-3.7 19.1-9 27.2-15.7c5-4.1 11.6-5.6 17.9-4l23.6 6.2c5-6.9 9.4-14.4 12.9-22.3l-17.1-17.4c-4.5-4.6-6.6-11.1-5.5-17.4c.9-5.1 1.3-10.3 1.3-15.7s-.5-10.6-1.3-15.7c-1.1-6.4 .9-12.9 5.5-17.4l17.1-17.4c-3.5-7.9-7.9-15.4-12.9-22.3l-23.6 6.2c-6.3 1.6-12.9 .1-17.9-4c-8-6.7-17.2-12-27.2-15.7c-6.1-2.2-10.7-7.2-12.4-13.5l-6.5-23.5c-4.2-.4-8.5-.7-12.9-.7s-8.7 .2-12.9 .7zM127.3 15.3C137.9 13.1 148.8 12 160 12s22.1 1.1 32.7 3.3c7.4 1.5 13.3 7 15.3 14.3l7.3 26.6c7.3 3.4 14.3 7.4 20.8 12l26.6-7c7.3-1.9 15 .4 20 6.1c14.4 16.3 25.7 35.5 32.8 56.7c2.4 7.1 .6 15-4.7 20.4L291.5 164c.4 4 .5 8 .5 12s-.2 8-.5 12l19.4 19.6c5.3 5.4 7.1 13.2 4.7 20.4c-7.1 21.2-18.3 40.4-32.8 56.7c-5 5.6-12.7 8-20 6.1l-26.6-7c-6.5 4.6-13.5 8.6-20.8 12L208 322.4c-2 7.3-7.9 12.8-15.3 14.3c-10.6 2.1-21.5 3.3-32.7 3.3s-22.1-1.1-32.7-3.3c-7.4-1.5-13.3-7-15.3-14.3l-7.3-26.6c-7.3-3.4-14.3-7.4-20.8-12l-26.6 7c-7.3 1.9-15-.4-20-6.1C22.8 268.4 11.5 249.2 4.4 228c-2.4-7.1-.6-15 4.7-20.4L28.5 188c-.4-4-.5-8-.5-12s.2-8 .5-12L9.2 144.4C3.9 139 2 131.1 4.4 124c7.1-21.2 18.3-40.4 32.8-56.7c5-5.6 12.7-8 20-6.1l26.6 7c6.5-4.6 13.5-8.6 20.8-12L112 29.6c2-7.3 7.9-12.8 15.3-14.3zM120 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM340.7 364.9l23.5 6.5c6.2 1.7 11.2 6.3 13.5 12.4c3.7 10 9 19.1 15.7 27.2c4.1 5 5.6 11.6 4 17.9l-6.2 23.6c6.9 5 14.4 9.4 22.3 12.9l17.4-17.1c4.6-4.5 11.1-6.6 17.4-5.5c5.1 .9 10.3 1.3 15.7 1.3s10.6-.5 15.7-1.3c6.4-1.1 12.8 .9 17.4 5.5l17.4 17.1c7.9-3.5 15.4-7.9 22.3-12.9l-6.2-23.6c-1.6-6.2-.1-12.9 4-17.9c6.7-8 12.1-17.2 15.7-27.2c2.2-6.1 7.2-10.7 13.5-12.4l23.5-6.5c.4-4.2 .7-8.5 .7-12.9s-.2-8.7-.7-12.9l-23.5-6.5c-6.2-1.7-11.2-6.3-13.5-12.4c-3.7-10-9-19.1-15.7-27.2c-4.1-5-5.6-11.6-4-17.9l6.2-23.6c-6.9-5-14.4-9.4-22.3-12.9l-17.4 17.1c-4.6 4.5-11.1 6.6-17.4 5.5c-5.1-.9-10.4-1.3-15.7-1.3s-10.6 .5-15.7 1.3c-6.4 1.1-12.9-.9-17.4-5.5l-17.4-17.1c-7.9 3.5-15.4 7.9-22.3 12.9l6.2 23.6c1.6 6.3 .1 12.9-4 17.9c-6.7 8-12.1 17.2-15.7 27.2c-2.2 6.1-7.2 10.7-13.5 12.4l-23.5 6.5c-.4 4.2-.7 8.5-.7 12.9s.2 8.7 .7 12.9zm-37.4 19.8c-2.1-10.6-3.3-21.5-3.3-32.7s1.1-22.1 3.3-32.7c1.5-7.4 7-13.3 14.3-15.3l26.6-7.3c3.4-7.3 7.4-14.3 12-20.8l-7-26.6c-1.9-7.3 .5-15 6.1-20c16.3-14.4 35.5-25.7 56.7-32.8c7.1-2.4 15-.6 20.4 4.7L452 220.5c4-.4 8-.5 12-.5s8 .2 12 .5l19.6-19.4c5.4-5.3 13.2-7.1 20.4-4.7c21.2 7.1 40.4 18.3 56.7 32.8c5.6 5 8 12.7 6.1 20l-7 26.6c4.6 6.5 8.6 13.5 12 20.8l26.6 7.3c7.3 2 12.8 7.9 14.3 15.3c2.1 10.6 3.3 21.5 3.3 32.7s-1.1 22.1-3.3 32.7c-1.5 7.4-7 13.3-14.3 15.3l-26.6 7.3c-3.4 7.3-7.4 14.3-12 20.8l7 26.6c1.9 7.3-.5 15-6.1 20c-16.3 14.4-35.5 25.7-56.7 32.8c-7.1 2.4-15 .6-20.4-4.7L476 483.5c-4 .4-8 .5-12 .5s-8-.2-12-.5l-19.6 19.4c-5.4 5.3-13.2 7.1-20.4 4.7c-21.2-7.1-40.4-18.3-56.7-32.8c-5.6-5-8-12.7-6.1-20l7-26.6c-4.6-6.5-8.6-13.5-12-20.8L317.6 400c-7.3-2-12.8-7.9-14.3-15.3zM464 392a40 40 0 1 1 0-80 40 40 0 1 1 0 80z',
  ],
};
const faCogs = faGears;
const faSunBright = {
  prefix: 'far',
  iconName: 'sun-bright',
  icon: [
    512,
    512,
    ['sun-alt'],
    'e28f',
    'M280 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9l-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8L108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9L437 403.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z',
  ],
};
const faSunAlt = faSunBright;
const faWarehouse = {
  prefix: 'far',
  iconName: 'warehouse',
  icon: [
    640,
    512,
    [],
    'f494',
    'M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 328l0 48 352 0 0-48-352 0zm0 136l352 0 0-40-352 0 0 40zm-23.7 48l-.3 0c-13.3 0-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24l-.3 0-399.4 0zM144 280l352 0 0-40-352 0 0 40z',
  ],
};
const faConveyorBeltArm = {
  prefix: 'far',
  iconName: 'conveyor-belt-arm',
  icon: [
    640,
    512,
    [],
    'e5f8',
    'M152 0L328 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-69 0-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5c13.1 1.8 22.4 13.8 20.6 27c-.8 5.9-3.7 11-7.8 14.7l0 30.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9L262 141.3c-8.8 11.4-22.6 18.7-38 18.7c-26.5 0-48-21.5-48-48c0-20.6 13-38.1 31.2-45l3.2-19L152 48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 16 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-416 0C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9L96 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24zM112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l416 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-40 0-48 0-112 0-48 0-112 0-48 0-8 0zm16 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faLockKeyholeOpen = {
  prefix: 'far',
  iconName: 'lock-keyhole-open',
  icon: [
    576,
    512,
    ['lock-open-alt'],
    'f3c2',
    'M432 48c-44.2 0-80 35.8-80 80l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l240 0 0-64C304 57.3 361.3 0 432 0s128 57.3 128 128l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-44.2-35.8-80-80-80zM384 240L64 240c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM256 376l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faLockOpenAlt = faLockKeyholeOpen;
const faSquareFragile = {
  prefix: 'far',
  iconName: 'square-fragile',
  icon: [
    448,
    512,
    ['box-fragile', 'square-wine-glass-crack'],
    'f49b',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 38.3c0-12.3 10-22.3 22.3-22.3l25.7 0 32 64-32 32 80 64-32-64 48-32-32-64 57.7 0c12.3 0 22.3 10 22.3 22.3l0 89.7c0 47.6-34.6 87.1-80 94.7l0 49.3 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-49.3c-45.4-7.6-80-47.1-80-94.7l0-89.7z',
  ],
};
const faBoxFragile = faSquareFragile;
const faSquareWineGlassCrack = faSquareFragile;
const faArrowUpRightDots = {
  prefix: 'far',
  iconName: 'arrow-up-right-dots',
  icon: [
    576,
    512,
    [],
    'e4b7',
    'M128 24c0 13.3 10.7 24 24 24l86.1 0L7 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l231-231 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faSquareN = {
  prefix: 'far',
  iconName: 'square-n',
  icon: [
    448,
    512,
    [],
    'e277',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.3 40.5L288 294.5 288 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5 160 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z',
  ],
};
const faSplotch = {
  prefix: 'far',
  iconName: 'splotch',
  icon: [
    512,
    512,
    [],
    'f5bc',
    'M187.7 400.2L84.9 409.5c-11.2 1-20.9-7.8-20.9-19.1c0-4.2 1.3-8.2 3.8-11.5l18.8-25c16.7-22.3 25.4-49.5 24.8-77.3c-.5-23.1-7.5-45.7-20.2-65L50.6 149.7c-1.7-2.6-2.6-5.7-2.6-8.8c0-10.1 9.1-17.7 19-15.9l42.8 7.8c52.6 9.6 106.3-9.9 140.6-51l22.3-26.8c3.7-4.4 9.1-6.9 14.8-6.9c8.3 0 15.7 5.3 18.3 13.2l15 45.1c15.7 47.2 51.9 84.7 98.5 102.2l32.3 12.1c7.4 2.8 12.4 9.9 12.4 17.8c0 6-2.8 11.6-7.6 15.2l-62 46.5c-37.9 28.4-57.9 74.7-52.7 121.8l2.5 22.7c1.1 10.3-6.9 19.3-17.3 19.3c-3.9 0-7.8-1.3-10.9-3.8L279 430.5c-24.7-19.8-55.4-30.5-87-30.5c-1.5 0-2.9 .1-4.3 .2zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z',
  ],
};
const faFaceGrinHearts = {
  prefix: 'far',
  iconName: 'face-grin-hearts',
  icon: [
    512,
    512,
    [128525, 'grin-hearts'],
    'f584',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z',
  ],
};
const faGrinHearts = faFaceGrinHearts;
const faMeter = {
  prefix: 'far',
  iconName: 'meter',
  icon: [
    512,
    512,
    [],
    'e1e8',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faMandolin = {
  prefix: 'far',
  iconName: 'mandolin',
  icon: [
    512,
    512,
    [],
    'f6f9',
    'M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4l-81.8 22.3-50.6 50.6C324.6 305.1 317.5 512 176 512C78.8 512 0 433.2 0 336C0 194.5 206.9 187.4 287.9 190.1l50.6-50.6 22.3-81.9c1.6-5.8 5.3-10.8 10.4-14l64-40zm-246.8 286l51.5-51.5c-22.3 .8-47.1 2.8-71.6 7.1c-36.9 6.5-68.6 17.3-90.1 32.8C58.9 292.1 48 309.4 48 336c0 70.7 57.3 128 128 128c26.6 0 43.9-10.9 57.9-30.2c15.6-21.5 26.4-53.2 32.8-90.1c4.3-24.5 6.3-49.3 7.1-71.6l-51.5 51.5c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6z',
  ],
};
const faDiceFour = {
  prefix: 'far',
  iconName: 'dice-four',
  icon: [
    448,
    512,
    [9859],
    'f524',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faSimCard = {
  prefix: 'far',
  iconName: 'sim-card',
  icon: [
    384,
    512,
    [],
    'f7c4',
    'M48 64l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-293.5c0-4.2-1.7-8.3-4.7-11.3L240.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16zM0 448L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64zM128 240l16 0 0 80-64 0 0-32c0-26.5 21.5-48 48-48zM80 384l0-32 80 0 48 0 0 80-80 0c-26.5 0-48-21.5-48-48zm176 48l-16 0 0-80 64 0 0 32c0 26.5-21.5 48-48 48zm48-144l0 32-80 0-48 0 0-80 80 0c26.5 0 48 21.5 48 48z',
  ],
};
const faTransgender = {
  prefix: 'far',
  iconName: 'transgender',
  icon: [
    512,
    512,
    [9895, 'transgender-alt'],
    'f225',
    'M128 24c0-13.3-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-22.1L78.1 112l-7 7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2l0 17.8-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-17.8c77-11.6 136-78 136-158.2c0-35.5-11.6-68.3-31.2-94.9L464 81.9l0 22.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-7 7L81.9 48 104 48c13.3 0 24-10.7 24-24zM256 368c-61.9 0-112-50.1-112-112c0-29.8 11.7-56.9 30.7-77c.8-.6 1.6-1.3 2.3-2s1.4-1.5 2-2.3c20.1-19 47.2-30.7 77-30.7s56.9 11.7 77 30.7c.6 .8 1.3 1.6 2 2.3s1.5 1.4 2.3 2c19 20.1 30.7 47.2 30.7 77c0 61.9-50.1 112-112 112z',
  ],
};
const faTransgenderAlt = faTransgender;
const faMercury = {
  prefix: 'far',
  iconName: 'mercury',
  icon: [
    384,
    512,
    [9791],
    'f223',
    'M73 5.3C83.3-3 98.4-1.4 106.7 9c18.5 23.1 51.4 38.9 84.9 39l.3 0 .3 0c33.5-.1 66.4-15.9 84.9-39C285.6-1.4 300.7-3 311 5.3s12 23.4 3.7 33.7c-9.9 12.4-22.2 23.1-36 31.8C332 101.1 368 158.3 368 224c0 89.1-66.2 162.7-152 174.4l0 25.6 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-25.6C82.2 386.7 16 313.1 16 224c0-65.7 36-122.9 89.3-153.2C91.5 62.1 79.2 51.4 69.3 39C61 28.7 62.6 13.6 73 5.3zM192 96l-.3 0C121.1 96.2 64 153.4 64 224c0 70.7 57.3 128 128 128s128-57.3 128-128c0-70.6-57.1-127.8-127.7-128l-.3 0z',
  ],
};
const faUpFromBracket = {
  prefix: 'far',
  iconName: 'up-from-bracket',
  icon: [
    448,
    512,
    [],
    'e590',
    'M114.2 160L224 50 333.8 160 280 160c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 0c-11.5 0-22.5 4.6-30.6 12.7L77.6 128.8C68.9 137.5 64 149.3 64 161.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 12.7C246.5 4.6 235.5 0 224 0zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z',
  ],
};
const faKnifeKitchen = {
  prefix: 'far',
  iconName: 'knife-kitchen',
  icon: [
    576,
    512,
    [128298],
    'f6f5',
    'M488 0c-9.4 0-18.3 3.7-25 10.3L284.6 188.7l11.3 11.3L400.3 304.4l31-17.2c15.2-8.5 24.7-24.5 24.7-42l0-31.9c0-4.2 1.7-8.3 4.7-11.3l97-97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L513 10.3C506.3 3.7 497.4 0 488 0zM432 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM4.7 468.7c-8.4 8.4-4.7 22.9 6.5 26.6C43.4 505.7 78.1 512 112 512c123.3 0 209.4-62.8 287.3-140.7c6.2-6.2 6.2-16.4 0-22.6l-23-23-33.9 33.9C275 422.2 205.5 464 112 464c-10.7 0-21.6-.8-32.6-2.2L262 279.3l33.9-33.9L262 211.4l-33.9 33.9L4.7 468.7z',
  ],
};
const faBorderRight = {
  prefix: 'far',
  iconName: 'border-right',
  icon: [
    448,
    512,
    [],
    'f852',
    'M424 32c13.3 0 24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faArrowTurnDown = {
  prefix: 'far',
  iconName: 'arrow-turn-down',
  icon: [
    384,
    512,
    ['level-down'],
    'f149',
    'M24 48C10.7 48 0 37.3 0 24S10.7 0 24 0L128 0c48.6 0 88 39.4 88 88l0 342.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 505c-9.4 9.4-24.6 9.4-33.9 0L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L168 88c0-22.1-17.9-40-40-40L24 48z',
  ],
};
const faLevelDown = faArrowTurnDown;
const faSpade = {
  prefix: 'far',
  iconName: 'spade',
  icon: [
    512,
    512,
    [9824],
    'f2f4',
    'M437.7 242.9s0 0 0 0L256.4 55 74.2 242.9c0 0 0 0 0 0c-37 38.4-34.9 102.3 6.7 138c0 0 0 0 0 0l.3 .2c32 27.9 86 25.1 120.8-10.2l19.7-20.7c9.2-9.7 22-15.1 35.4-14.9s26 5.9 35 15.8l18.3 20.2c34.3 34.4 87.3 38 121.7 9.5c40.6-35.7 42.6-99.6 5.7-138zM233.5 9.7c12-13 33-13 45.9 0L472.2 209.5c55.9 57.9 52.9 153.8-9 207.8c-50.7 42.6-122.8 39.2-173 .2c-3.5-2.7-6.9-5.6-10.2-8.7l0 55.2 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-55.3c-3.1 2.9-6.4 5.7-9.8 8.4c-50.4 39.4-123.4 43-172.5 .3c-62.9-53.9-65.9-149.8-10-207.8L233.5 9.7z',
  ],
};
const faCardSpade = {
  prefix: 'far',
  iconName: 'card-spade',
  icon: [
    384,
    512,
    [],
    'e3ec',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm175 77.2c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 59.7 59.7c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-3.2-3.2c-.3-.3-.6-.6-1-.9l0 37.4 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-37.4c-.3 .3-.7 .6-1 .9l-3.2 3.2c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l59.7-59.7L175 141.2z',
  ],
};
const faLineColumns = {
  prefix: 'far',
  iconName: 'line-columns',
  icon: [
    512,
    512,
    [],
    'f870',
    'M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424zM288 192c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zM312 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 40zM288 320c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z',
  ],
};
const faAnt = {
  prefix: 'far',
  iconName: 'ant',
  icon: [
    640,
    512,
    [],
    'e680',
    'M530.1 0c-19.7 0-37.9 10.3-48 27.2L469.6 48C413.3 49.3 368 95.4 368 152c0 15.5 3.4 30.2 9.5 43.4c-8.1-2.2-16.7-3.4-25.5-3.4c-24.5 0-46.8 9.1-63.7 24.2C270.8 169.4 225.7 136 172.8 136l-15.5 0C70.4 136 0 206.4 0 293.3C0 343.4 40.6 384 90.7 384l29.1 0L67.2 476.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l64-112c.7-1.3 1.3-2.6 1.8-3.9l9.4 0c5.6 0 11.1-.4 16.5-1.2l-53.3 93.3c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L276.2 347c4.6 5.9 9.8 11.2 15.7 15.9l-.5 .8-.3 .4-64 112c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l63.9-111.8 3.3-5.5c5.2 .9 10.6 1.3 16 1.3c13.6 0 26.5-2.8 38.2-7.9l39.6 39.6c3.8 3.8 6.8 8.4 8.9 13.4l27.1 67.8c4.9 12.3 18.9 18.3 31.2 13.4s18.3-18.9 13.4-31.2l-27.1-67.8c-4.4-11.1-11.1-21.1-19.5-29.5l-35.4-35.4c2.2-2.8 4.2-5.8 6.1-8.9l86.8 62c6.9 4.9 12 11.9 14.7 19.9l25.4 76.3c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-25.4-76.3c-5.9-17.6-17.2-33-32.3-43.8l-95.1-67.9-5.9-4.2 0-.2c0-13-2.6-25.5-7.3-36.8c9.9 3.1 20.4 4.8 31.3 4.8l58.7 0c42.7 0 77.3-34.6 77.3-77.3c0-56.8-36.3-105.2-86.9-123.2l2.2-3.6c1.4-2.4 4.1-3.9 6.9-3.9L584 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L530.1 0zM416 152c0-30.9 25.1-56 56-56l5.3 0C523 96 560 133 560 178.7c0 16.2-13.1 29.3-29.3 29.3L472 208c-30.9 0-56-25.1-56-56zM400 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM157.3 184l15.5 0c41.5 0 75.2 33.7 75.2 75.2l0 12.8c0 35.3-28.7 64-64 64l-93.3 0C67.1 336 48 316.9 48 293.3C48 233 97 184 157.3 184zM520 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faArrowRightToLine = {
  prefix: 'far',
  iconName: 'arrow-right-to-line',
  icon: [
    448,
    512,
    [8677, 'arrow-to-right'],
    'f340',
    'M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z',
  ],
};
const faArrowToRight = faArrowRightToLine;
const faPersonFallingBurst = {
  prefix: 'far',
  iconName: 'person-falling-burst',
  icon: [
    640,
    512,
    [],
    'e547',
    'M232 0c13.3 0 24 10.7 24 24l0 10.4c0 56.5-30.1 107.8-77.5 135.8L236.7 256l74.9 0c13.1 0 25.3 6.4 32.8 17.1l51.2 73.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L307.5 304l-49.6 0c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 84.8 131c7.2 11.1 4 26-7.1 33.2s-26 4-33.2-7.1L84.4 254.7C81.5 264.6 80 275 80 285.6L80 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-74.4c0-66.3 41.5-125.5 103.8-148.2c43.3-15.8 72.2-57 72.2-103.1L208 24c0-13.3 10.7-24 24-24zM173.3 303.6l26-17.3-64.8-95.5c-8.4 4.9-16.1 10.9-22.8 17.7l61.6 95.2zM0 80a48 48 0 1 1 96 0A48 48 0 1 1 0 80zM464 302.3l-33.3 24.5c-.7-1.2-1.5-2.3-2.3-3.4l-51.2-73.2c-15-21.4-39.4-34.1-65.5-34.1l-19.8 0c.5-6.2 3.4-12.1 8.2-16.3l48.6-42L323.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C447 12.9 455.1 8 464 8s17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9 48.6 42c6.7 5.8 9.7 14.8 7.7 23.5s-8.6 15.5-17.1 17.8l-62 16.7-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38zm0-219.1l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L464 83.2z',
  ],
};
const faFlagPennant = {
  prefix: 'far',
  iconName: 'flag-pennant',
  icon: [
    448,
    512,
    [128681, 'pennant'],
    'f456',
    'M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24l0 8L0 80 0 304l0 48L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-137.1L432.9 213.4c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L48 33.1 48 24zm0 60.1L350.1 192 48 299.9 48 84.1z',
  ],
};
const faPennant = faFlagPennant;
const faConveyorBeltEmpty = {
  prefix: 'far',
  iconName: 'conveyor-belt-empty',
  icon: [
    640,
    512,
    [],
    'e150',
    'M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l416 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-416 0zM0 400c0-61.9 50.1-112 112-112l416 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-416 0C50.1 512 0 461.9 0 400zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faUserGroupSimple = {
  prefix: 'far',
  iconName: 'user-group-simple',
  icon: [
    640,
    512,
    [],
    'e603',
    'M104 136a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm160 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM128 336l64 0c44.2 0 80 35.8 80 80l0 16L48 432l0-16c0-44.2 35.8-80 80-80zm0-48C57.3 288 0 345.3 0 416l0 16c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-16c0-70.7-57.3-128-128-128l-64 0zM448 480l64 0c70.7 0 128-57.3 128-128l0-16c0-26.5-21.5-48-48-48l-224 0c-21.8 0-40.3 14.6-46.1 34.6C340.8 348.9 352 381.1 352 416l0 16c0 1.5 0 3-.1 4.5C375.3 463.2 409.7 480 448 480z',
  ],
};
const faAward = {
  prefix: 'far',
  iconName: 'award',
  icon: [
    384,
    512,
    [],
    'f559',
    'M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z',
  ],
};
const faTicketSimple = {
  prefix: 'far',
  iconName: 'ticket-simple',
  icon: [
    576,
    512,
    ['ticket-alt'],
    'f3ff',
    'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 60.1c0 10.2-6.4 19.2-16 22.6c-18.7 6.6-32 24.4-32 45.3s13.3 38.7 32 45.3c9.6 3.4 16 12.5 16 22.6l0 60.1c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-60.1c0-10.2 6.4-19.2 16-22.6c18.7-6.6 32-24.4 32-45.3s-13.3-38.7-32-45.3c-9.6-3.4-16-12.5-16-22.6L0 128zm64-16c-8.8 0-16 7.2-16 16l0 44.9c28.7 16.6 48 47.6 48 83.1s-19.3 66.6-48 83.1L48 384c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-44.9c-28.7-16.6-48-47.6-48-83.1s19.3-66.6 48-83.1l0-44.9c0-8.8-7.2-16-16-16L64 112z',
  ],
};
const faTicketAlt = faTicketSimple;
const faBuilding = {
  prefix: 'far',
  iconName: 'building',
  icon: [
    384,
    512,
    [127970, 61687],
    'f1ad',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z',
  ],
};
const faAnglesLeft = {
  prefix: 'far',
  iconName: 'angles-left',
  icon: [
    512,
    512,
    [171, 'angle-double-left'],
    'f100',
    'M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z',
  ],
};
const faAngleDoubleLeft = faAnglesLeft;
const faCamcorder = {
  prefix: 'far',
  iconName: 'camcorder',
  icon: [
    576,
    512,
    [128249, 'video-handheld'],
    'f8a8',
    'M96 120c0-22.1 17.9-40 40-40l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 32c-48.6 0-88 39.4-88 88l0 42c-27.6 7.1-48 32.2-48 62L0 416c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-17 0-158 0-17c0-35.3-28.7-64-64-64L96 160l0-40zM64 208l256 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4l0 52.6 112-50.4 0 182.7L416 361l0 52.6 104.3 46.9zM80 264c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faVideoHandheld = faCamcorder;
const faPancakes = {
  prefix: 'far',
  iconName: 'pancakes',
  icon: [
    512,
    512,
    [129374],
    'e42d',
    'M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8L96 264c0 13.3 10.7 24 24 24s24-10.7 24-24l0-76.7c0-18.8 15.8-33.2 34.4-31.2c16 1.7 29.6 15 29.6 31l0 28.9c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24zM192 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3c-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40C506 332.6 512 319.3 512 304s-6-28.6-16.9-40C506 252.6 512 239.3 512 224s-6-28.6-16.9-40C506 172.6 512 159.3 512 144c0-8.8-2-16.9-5.7-24.3c-6.3 12.4-16.9 21.6-26 27.8C465 157.7 445 165.8 423.2 172c-8.2 2.3-17 4.5-26.2 6.5c-29.9 7.1-67 11.5-109 12.9l0 24.5c0 8.4-1.9 16.5-5.2 23.6c68.3-1.9 128.5-11.1 170.1-28.6c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 264.8 324.4 272 256 272c-6.5 0-13-.1-19.3-.2c-1.6 .1-3.1 .2-4.7 .2c-2.7 0-5.3-.2-7.8-.5c-17-.6-33.1-1.7-48.3-3.2c-1.5 19.4-12.8 36-29 44.9C180 317.8 217 320 256 320c79.2 0 150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.7-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c4.9 2.1 10.2 4.1 15.6 5.9C68 287.7 64 276.3 64 264l0-23.9c-4.8-2.8-8.5-5.5-11.1-7.9c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c1.6 .7 3.2 1.3 4.9 2l0-49.3zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.8-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9z',
  ],
};
const faAlbumCircleUser = {
  prefix: 'far',
  iconName: 'album-circle-user',
  icon: [
    576,
    512,
    [],
    'e48d',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faSubtitlesSlash = {
  prefix: 'far',
  iconName: 'subtitles-slash',
  icon: [
    640,
    512,
    [],
    'e610',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6L508.2 373c2.4-3.7 3.8-8.2 3.8-13c0-13.3-10.7-24-24-24l-27 0-67.2-52.6c4 2.9 8.9 4.6 14.2 4.6l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24c0 7.4 3.4 14 8.6 18.4L134.4 80zm353 400l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM365.5 384l-59.9-47.2C295.5 339.6 288 348.9 288 360c0 13.3 10.7 24 24 24l53.5 0zM243.7 288l-60.9-48L152 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l91.7 0zM152 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z',
  ],
};
const faQrcode = {
  prefix: 'far',
  iconName: 'qrcode',
  icon: [
    448,
    512,
    [],
    'f029',
    'M144 80l0 96-96 0 0-96 96 0zM48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32zm96 304l0 96-96 0 0-96 96 0zM48 288c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0zM304 80l96 0 0 96-96 0 0-96zm-48 0l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM72 120l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM328 120l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM256 304l0 160c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM368 448a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z',
  ],
};
const faDiceD10 = {
  prefix: 'far',
  iconName: 'dice-d10',
  icon: [
    512,
    512,
    [],
    'f6cd',
    'M256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zM91.6 247.4l50.9-12 36-86.9L91.6 247.4zM256 86.8L189.7 247 256 291.2 322.3 247 256 86.8zm100.6 195L280 332.8l0 102.8 156.7-135-80-18.8zm63.8-34.3l-86.9-98.9 36 86.9 50.9 12zM232 435.6l0-102.8-76.6-51.1-80 18.8L232 435.6z',
  ],
};
const faFireplace = {
  prefix: 'far',
  iconName: 'fireplace',
  icon: [
    640,
    512,
    [],
    'f79a',
    'M48 48l544 0 0 32L48 80l0-32zM32 0C14.3 0 0 14.3 0 32L0 96c0 17.7 14.3 32 32 32l0 360c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-120c0-88.4 71.6-160 160-160s160 71.6 160 160l0 120c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-360c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0zM80 464l0-336 480 0 0 336-32 0 0-96c0-114.9-93.1-208-208-208s-208 93.1-208 208l0 96-32 0zM338 299.4l-13.3-14c-1.4-1.5-2.8-3.1-4.2-4.7c0 0 0 0 0 0c-6.3-7.2-13.1-14.9-22.9-15.1c-5.1-.1-10.2 1.6-14.2 5.3c-16.4 14.8-35 34.2-49.6 56.1c-14.5 21.8-25.8 47-25.8 73.1c0 62 49.3 111.9 112 111.9c62.1 0 112-49.8 112-111.9c0-21-7.7-42.6-18.3-61.7C403 319.3 389 301.8 375.2 289c-3.9-3.6-8.9-5.5-13.9-5.5c-5.3 0-10.9 2-14.6 6.2l-8.6 9.7zm26.8 134.3c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8c0-25.6 25.9-51.1 38.3-61.9c3.8-3.3 9.2-3.3 12.9 0c12.4 10.8 38.3 36.3 38.3 61.9z',
  ],
};
const faBrowser = {
  prefix: 'far',
  iconName: 'browser',
  icon: [
    512,
    512,
    [128468],
    'f37e',
    'M.3 89.5C.1 91.6 0 93.8 0 96l0 64L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256 0-64c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 160l416 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256z',
  ],
};
const faPenPaintbrush = {
  prefix: 'far',
  iconName: 'pen-paintbrush',
  icon: [
    576,
    512,
    ['pencil-paintbrush'],
    'f618',
    'M68.4 360.9L45.4 439 33 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L105 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L524.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L485.3 19.3c-25-25-65.5-25-90.5 0L90.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L353 129 415 191 186.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L91.4 452.6l16.1-54.8 6.9-23.4zm170.2 71.4C304.4 485.1 345 512 391.9 512l152 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-6 0c-18.1 0-30.1-19.8-27.4-37.6c.9-6 1.4-12.1 1.4-18.4c0-46.9-26.9-87.5-66.1-107.3l-37.2 37.2c31.7 7.5 55.3 36 55.3 70.1c0 3.8-.3 7.5-.8 11.1c-3.3 21.4 2.2 43.1 13.8 60l.7 .9-85.6 0c-34 0-62.5-23.6-70.1-55.3l-37.2 37.2zM136 24C105.1-6.9 54.9-6.9 24 24S-6.9 105.1 24 136l98.7 98.7 33.9-33.9L57.9 102.1c-12.2-12.2-12.2-31.9 0-44.1s31.9-12.2 44.1 0l98.7 98.7 33.9-33.9L136 24z',
  ],
};
const faPencilPaintbrush = faPenPaintbrush;
const faFishCooked = {
  prefix: 'far',
  iconName: 'fish-cooked',
  icon: [
    576,
    512,
    [],
    'f7fe',
    'M150 203.2c19.9-22.7 47.5-45.8 78-63.1c30.7-17.4 62.8-28.1 92-28.1c44.8 0 97.6 25.1 140.5 58.9c21.1 16.6 38.7 34.5 50.7 50.7C524 238.8 528 250.7 528 256s-4 17.2-16.8 34.4c-12.1 16.2-29.6 34.1-50.7 50.7C417.6 374.9 364.8 400 320 400c-29.1 0-61.2-10.6-91.8-28c-30.5-17.3-58.1-40.3-78-63c-8.3-9.4-22.4-10.9-32.4-3.4L58.5 350.1l19.1-81.3c2-8.4 2-17.2 0-25.7L58.9 163.6l58.8 43.1c10 7.4 24 5.8 32.2-3.5zM320 64c-40.2 0-80.5 14.4-115.7 34.3c-28.2 16-54.1 36.1-75.3 57.2L56.8 102.6C51 98.3 43.9 96 36.7 96c-22 0-38.2 20.5-33.2 41.9L30.9 254.2c.3 1.2 .3 2.5 0 3.7L1.7 382.2c-2.5 10.8 .7 22.1 8.5 29.9l17-17-17 17c11.2 11.2 29 12.5 41.8 3l77.5-58.1c21.2 20.9 47 41 75.1 56.9C239.6 433.7 279.9 448 320 448c60.2 0 123.4-32.2 170.2-69.1c23.8-18.7 44.5-39.5 59.6-59.8C564.1 299.8 576 277.4 576 256s-11.9-43.8-26.2-63.1c-15-20.3-35.8-41.1-59.6-59.8C443.4 96.2 380.2 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z',
  ],
};
const faChairOffice = {
  prefix: 'far',
  iconName: 'chair-office',
  icon: [
    448,
    512,
    [],
    'f6c1',
    'M288 48c8.8 0 16 7.2 16 16l0 160 48 0 0-160c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 160 48 0 0-160c0-8.8 7.2-16 16-16l128 0zM64 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zm368 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zM248 400l122.5 0c25.2 0 45.5-20.4 45.5-45.5c0-5.5-1-10.9-2.9-16l-19.2-51.3c-7-18.7-24.9-31.1-44.9-31.1L99.1 256c-20 0-37.9 12.4-44.9 31.1L34.9 338.5C33 343.6 32 349 32 354.5C32 379.6 52.4 400 77.5 400L200 400l0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64zM99.1 304l249.8 0 18 48L224 352 81.1 352l18-48z',
  ],
};
const faMagnifyingGlassMusic = {
  prefix: 'far',
  iconName: 'magnifying-glass-music',
  icon: [
    512,
    512,
    [],
    'e65f',
    'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1zM271.6 158.8c12.6-4.2 19.4-17.8 15.2-30.4s-17.8-19.4-30.4-15.2l-48 16c-9.8 3.3-16.4 12.4-16.4 22.8l0 57.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c35.3 0 63.9-21.4 64-47.9c0 0 0-.1 0-.1c0 0 0 0 0 0l0-86.7 31.6-10.5z',
  ],
};
const faNestingDolls = {
  prefix: 'far',
  iconName: 'nesting-dolls',
  icon: [
    640,
    512,
    [],
    'e3ba',
    'M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112l0 112L80 224l0-112zM200.7 64.9c-4.1-5.3-13.2-5.3-17.3 0c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13l-304 0c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9c0 0 0 0 0 0l.2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1l0-8c0-75.1 60.9-136 136-136s136 60.9 136 136l0 8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3s0 0 0 0s0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM261.4 464c-7.1 15.1-7.3 32.7 0 48L74.5 512c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6l280.2 0c-11.3 14.3-20.3 30.5-26.5 48L71.9 304C57.9 332.9 48 358 48 384c0 35.9 12.8 63.3 23.2 79.6c.2 0 .4 .1 .6 .1c.7 .1 1.6 .3 2.7 .3l186.9 0z',
  ],
};
const faClockRotateLeft = {
  prefix: 'far',
  iconName: 'clock-rotate-left',
  icon: [
    512,
    512,
    ['history'],
    'f1da',
    'M48 106.7L48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 168c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.3 0c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z',
  ],
};
const faHistory = faClockRotateLeft;
const faTrumpet = {
  prefix: 'far',
  iconName: 'trumpet',
  icon: [
    640,
    512,
    [127930],
    'f8e3',
    'M592 128.7l0 222.7c-10-10.5-21.8-22-35.2-33.2C519.9 287.4 467.9 256 408 256l-50.6 0L168 256 48 256l0-32 360 0c59.9 0 111.9-31.4 148.8-62.2c13.4-11.2 25.2-22.6 35.2-33.2zM352 304l0 112-40 0 0-112 40 0zm48 112l0-112 8 0c43.4 0 84.6 23.1 118 51c33 27.6 55.5 57.3 61 64.9c5.7 7.9 14.6 12.1 23.7 12.1c16.2 0 29.2-13.1 29.2-29.2l0-325.5C640 61.1 626.9 48 610.8 48c-9.1 0-18.1 4.2-23.7 12.1c-5.5 7.6-27.9 37.3-61 64.9c-33.4 27.9-74.6 51-118 51l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-40 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-40 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L48 176l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32 0 80 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 32.3 0C70 320.2 64 339.4 64 360c0 57.4 46.6 104 104 104l32 0 88 0 88 0 32 0c49.6 0 91-34.7 101.5-81.1c-1.3-1.1-2.6-2.2-3.9-3.3c-13.7-11.4-27.9-21.2-42.3-28.6c.5 2.9 .7 5.9 .7 9c0 30.9-25.1 56-56 56l-8 0zm-136 0l-40 0 0-112 40 0 0 112zm-88 0l-8 0c-30.9 0-56-25.1-56-56s25.1-56 56-56l8 0 0 112z',
  ],
};
const faFaceGrinBeamSweat = {
  prefix: 'far',
  iconName: 'face-grin-beam-sweat',
  icon: [
    512,
    512,
    [128517, 'grin-beam-sweat'],
    'f583',
    'M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z',
  ],
};
const faGrinBeamSweat = faFaceGrinBeamSweat;
const faFireSmoke = {
  prefix: 'far',
  iconName: 'fire-smoke',
  icon: [
    640,
    512,
    [],
    'f74b',
    'M293.5 3.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 19.8 3.6 38.8 10.1 56.3c9.6 3.3 18.7 7.6 27.3 12.7c12.7-13.6 27.6-25 44.2-33.8c-1.1-5.5-1.6-11.3-1.6-17.4c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c8.6 15.8 11.3 33.7 8.4 50.4c16.6 8.8 31.5 20.2 44.2 33.8c8.5-5.1 17.6-9.3 27.1-12.6C476.4 231 480 212 480 192.2c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM233.2 361.3c7-41.6 43.2-73.3 86.8-73.3s79.8 31.7 86.8 73.3c1.8 10.7 10.5 18.8 21.2 19.9s20.9-5.1 24.8-15.2c10.4-27 36.6-46 67.2-46c39.8 0 72 32.2 72 72c0 37.7-29 68.7-66 71.8c-.7 .1-1.3 .1-2 .2l-4 0-200 0-200 0-4 0c-.7-.1-1.3-.2-2-.2c-36.9-3-66-34-66-71.8c0-39.8 32.2-72 72-72c30.6 0 56.7 19 67.2 46c3.9 10.1 14.1 16.3 24.8 15.2s19.4-9.2 21.2-19.9zM320 240c-49.4 0-92.7 26.4-116.5 65.8c-21.6-20.9-51-33.8-83.5-33.8C53.7 272 0 325.7 0 392c0 61.4 46.1 112 105.6 119.1c2 .6 4.2 .9 6.4 .9l8 0 200 0 200 0 8 0c2.2 0 4.3-.3 6.4-.9C593.9 504 640 453.4 640 392c0-66.3-53.7-120-120-120c-32.5 0-61.9 12.9-83.5 33.8C412.7 266.4 369.4 240 320 240z',
  ],
};
const faPhoneMissed = {
  prefix: 'far',
  iconName: 'phone-missed',
  icon: [
    640,
    512,
    [],
    'e226',
    'M120 0L232 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-54.1 0 55.4 55.4C254.2 124.3 282.5 136 312 136s57.8-11.7 78.6-32.6L487 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96.4 96.4C394.7 167.2 354.2 184 312 184s-82.7-16.8-112.6-46.6L144 81.9l0 54.1c0 13.3-10.7 24-24 24s-24-10.7-24-24L96 24c0-13.3 10.7-24 24-24zM448 392l0 49.3c0 3.9 2.8 7.2 6.6 7.9l85.8 15.6c3.7 .7 7.4-1.3 8.8-4.8l24.7-58.8c7.4-17.6 2.5-30.9-4.4-36.9C520 321.8 432.8 272 320 272s-200 49.8-249.5 92.3c-6.9 5.9-11.8 19.3-4.4 36.9L90.8 460c1.5 3.5 5.1 5.4 8.8 4.8l85.8-15.6c3.8-.7 6.6-4 6.6-7.9l0-49.3c0-19.6 11.9-37.3 30.2-44.6c62.8-25.1 132.9-25.1 195.7 0C436 354.7 448 372.4 448 392zm-48 49.3l0-49.3c-51.4-20.5-108.6-20.5-160 0l0 49.3c0 27.1-19.4 50.3-46 55.1L108.2 512c-25.8 4.7-51.4-9.2-61.6-33.4L21.8 419.8c-13.5-32-8.9-69.3 17.4-91.9C95 280 192.9 224 320 224s225 56 280.8 103.9c26.3 22.6 30.9 59.9 17.4 91.9l-24.8 58.8c-10.2 24.2-35.8 38.1-61.6 33.4L446 496.4c-26.6-4.8-46-28-46-55.1z',
  ],
};
const faFileExport = {
  prefix: 'far',
  iconName: 'file-export',
  icon: [
    576,
    512,
    ['arrow-right-from-file'],
    'f56e',
    'M336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 96 48 0 0-101.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-48 0 0 80zM489 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L216 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
  ],
};
const faArrowRightFromFile = faFileExport;
const faShield = {
  prefix: 'far',
  iconName: 'shield',
  icon: [
    512,
    512,
    [128737, 'shield-blank'],
    'f132',
    'M256 49.4L73 127c-5.9 2.5-9.1 7.8-9 12.8c.5 91.4 38.4 249.3 186.4 320.1c3.6 1.7 7.8 1.7 11.3 0C409.7 389 447.6 231.2 448 139.7c0-5-3.1-10.2-9-12.8L256 49.4zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z',
  ],
};
const faShieldBlank = faShield;
const faArrowUpShortWide = {
  prefix: 'far',
  iconName: 'arrow-up-short-wide',
  icon: [
    576,
    512,
    ['sort-amount-up-alt'],
    'f885',
    'M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L152 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm201 9l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faSortAmountUpAlt = faArrowUpShortWide;
const faArrowsRepeat1 = {
  prefix: 'far',
  iconName: 'arrows-repeat-1',
  icon: [
    512,
    512,
    ['repeat-1-alt'],
    'f366',
    'M22.5 280C9.3 279.1-.8 267.7 0 254.5l.5-8C5.6 166.4 72 104 152.2 104l213.8 0L311 49c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l96 96c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8l-271.8 0c-54.9 0-100.4 42.7-103.8 97.5l-.5 8c-.8 13.2-12.2 23.3-25.5 22.5zm467-47.9c13.2 .8 23.3 12.2 22.5 25.5l-.5 8C506.4 345.6 440 408 359.8 408l-213.8 0 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 401c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l271.8 0c54.9 0 100.4-42.7 103.8-97.5l.5-8c.8-13.2 12.2-23.3 25.4-22.5zM288 216l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z',
  ],
};
const faRepeat1Alt = faArrowsRepeat1;
const faGunSlash = {
  prefix: 'far',
  iconName: 'gun-slash',
  icon: [
    640,
    512,
    [],
    'e19c',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240l32.5 0c10.6 0 20.8-4.2 28.3-11.7L513.9 208l54.1 0c22.1 0 40-17.9 40-40l0-64c0-22.1-17.9-40-40-40l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L113.9 64 38.8 5.1zM175.2 112L536 112l24 0 0 48-49.4 0c-10.6 0-20.8 4.2-28.3 11.7L462.1 192l-163 0-21.8 0L175.2 112zM338.5 240l43.4 0-9.5 26.6L338.5 240zM80 192l0-33L32 121.2 32 200c0 22.1 17.9 40 40 40l2 0c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480l112 0c14.7 0 27.5-10 31-24.2L265 352l59.9 0-91.4-72-38 152-79 0 35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4l35.4 0-60.9-48-21.1 0L80 192z',
  ],
};
const faAvocado = {
  prefix: 'far',
  iconName: 'avocado',
  icon: [
    512,
    512,
    [],
    'e0aa',
    'M464 144c0 29.9-13.6 56.5-35.1 74.2c-24.2 19.9-47.3 49.3-54.7 86.9c-8.9 45.7-29.5 88.5-53.1 112c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c23.6-23.6 66.3-44.2 112-53.1c37.6-7.4 67-30.4 86.9-54.7C311.5 61.6 338.1 48 368 48c53 0 96 43 96 96zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z',
  ],
};
const faBinary = {
  prefix: 'far',
  iconName: 'binary',
  icon: [
    384,
    512,
    [],
    'e33b',
    'M328 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5S328 16.3 328 24zM104 312l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM0 72C0 32.2 32.2 0 72 0l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72L0 72zM72 48C58.7 48 48 58.7 48 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L72 48zM264 288l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72l0-80c0-39.8 32.2-72 72-72zm-24 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faCommentNodes = {
  prefix: 'far',
  iconName: 'comment-nodes',
  icon: [
    640,
    512,
    [],
    'e696',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160c101 0 174.9 52.8 199.3 115.2c7.9-2.1 16.2-3.2 24.7-3.2c9.1 0 17.8 1.3 26.2 3.6C481.1 102.1 378.6 32 256 32C114.6 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c10.8 0 21.5-.5 32-1.6c.3-15.8 4.4-31.7 12.9-46.4c.8-1.4 1.6-2.7 2.5-4.1c-15 2.6-30.8 4.1-47.4 4.1c-31.6 0-61.3-5.5-87.8-15.1zM328.6 416c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8c17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5c-25-3.4-50.6 8.3-64 31.4z',
  ],
};
const faGlassesRound = {
  prefix: 'far',
  iconName: 'glasses-round',
  icon: [
    576,
    512,
    [128083, 'glasses-alt'],
    'f5f5',
    'M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6l0 10.5c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4l0-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z',
  ],
};
const faGlassesAlt = faGlassesRound;
const faPhonePlus = {
  prefix: 'far',
  iconName: 'phone-plus',
  icon: [
    576,
    512,
    [],
    'f4d2',
    'M424 200l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-63 86.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C207.2 485.6 32 295.2 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zm133.8 78.1l-100.4-43L365 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L80.1 70.5C83.5 286.2 257.8 460.5 473.5 464l21.3-99.2z',
  ],
};
const faDitto = {
  prefix: 'far',
  iconName: 'ditto',
  icon: [
    320,
    512,
    [],
    '22',
    'M48 105.9c0 1.4 .1 2.8 .4 4.3L72 252 95.6 110.1s0 0 0 0c.2-1.4 .4-2.8 .4-4.3l0-1.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.9zm96 0c0 4.1-.3 8.1-1 12.1L118.6 264.5C114.8 287.3 95.1 304 72 304s-42.8-16.7-46.6-39.5L1 118c-.7-4-1-8.1-1-12.1L0 104C0 64.2 32.2 32 72 32s72 32.2 72 72l0 1.9zm80 0c0 1.4 .1 2.8 .4 4.3L248 252l23.6-141.9c.2-1.4 .4-2.8 .4-4.3l0-1.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.9zm96 0c0 4.1-.3 8.1-1 12.1L294.6 264.5C290.8 287.3 271.1 304 248 304s-42.8-16.7-46.6-39.5L177 118c-.7-4-1-8.1-1-12.1l0-1.9c0-39.8 32.2-72 72-72s72 32.2 72 72l0 1.9z',
  ],
};
const faPersonSeat = {
  prefix: 'far',
  iconName: 'person-seat',
  icon: [
    384,
    512,
    [],
    'e21e',
    'M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 92c0-6.6 5.4-12 12-12s12 5.4 12 12l0 92-16 0c-4.4 0-8-3.6-8-8l0-84zm72 92l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-57.2 0c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60l0 84c0 30.9 25.1 56 56 56l40 0 54 0c12 0 22.2 8.9 23.8 20.8l10.4 78.3C273.8 471.1 284 480 296 480l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-43 0-7.7-57.5C304.6 338.7 274.1 312 238 312l-30 0zM48 152c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 328c0 66.3 53.7 120 120 120l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-39.8 0-72-32.2-72-72l0-176z',
  ],
};
const faHouseMedical = {
  prefix: 'far',
  iconName: 'house-medical',
  icon: [
    576,
    512,
    [],
    'e3b2',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM288 55.5L112 204.8 112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
  ],
};
const faGolfBallTee = {
  prefix: 'far',
  iconName: 'golf-ball-tee',
  icon: [
    384,
    512,
    ['golf-ball'],
    'f450',
    'M336 192c0 55.7-31.7 104.1-78 128l77.1 0c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128l77.1 0c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144zM226.1 248.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM64 376c0 13.3 10.7 24 24 24l64 0c8.8 0 16 7.2 16 16l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72c0-8.8 7.2-16 16-16l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 352c-13.3 0-24 10.7-24 24z',
  ],
};
const faGolfBall = faGolfBallTee;
const faCircleChevronLeft = {
  prefix: 'far',
  iconName: 'circle-chevron-left',
  icon: [
    512,
    512,
    ['chevron-circle-left'],
    'f137',
    'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135L167 239c-9.4 9.4-9.4 24.6 0 33.9L271 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87 87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z',
  ],
};
const faChevronCircleLeft = faCircleChevronLeft;
const faHouseChimneyWindow = {
  prefix: 'far',
  iconName: 'house-chimney-window',
  icon: [
    576,
    512,
    [],
    'e00d',
    'M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM256 288l64 0 0-64-64 0 0 64zm-48-72c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-80 0c-22.1 0-40-17.9-40-40l0-80z',
  ],
};
const faScythe = {
  prefix: 'far',
  iconName: 'scythe',
  icon: [
    640,
    512,
    [],
    'f710',
    'M639.5 28.9c2.7-13-5.7-25.7-18.6-28.4s-25.7 5.7-28.4 18.6L536.9 288 408 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l118.9 0L496.5 483.1c-2.7 13 5.7 25.7 18.6 28.4s25.7-5.7 28.4-18.6l96-464zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224l491.5 0 9.9-48L68.7 176C108.6 126.8 196.8 48 352 48l201.8 0 7.3-35.3c.9-4.5 2.4-8.7 4.2-12.7L352 0z',
  ],
};
const faPenNib = {
  prefix: 'far',
  iconName: 'pen-nib',
  icon: [
    512,
    512,
    [10001],
    'f5ad',
    'M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71L412.2 225 371.6 374.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440L99.8 175.9c6.1-17.4 20.3-30.6 38.1-35.5L287 99.8l10.4-10.4 71-71zM296.9 146.8L150.5 186.7c-2.5 .7-4.6 2.6-5.4 5.1L62.5 426.9 164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L85.1 449.5l235.1-82.6c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z',
  ],
};
const faBanParking = {
  prefix: 'far',
  iconName: 'ban-parking',
  icon: [
    512,
    512,
    ['parking-circle-slash'],
    'f616',
    'M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm80-162c24.2-17.4 40-45.9 40-78c0-53-43-96-96-96l-80 0c-10.4 0-19.6 4.9-25.5 12.6L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L336 302zm-120-120l0-6.1 64 0c26.5 0 48 21.5 48 48c0 18.9-11 35.3-26.9 43.1L216 182.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 265.9l0 30.1 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 6.1 0L168 265.9z',
  ],
};
const faParkingCircleSlash = faBanParking;
const faTentArrowTurnLeft = {
  prefix: 'far',
  iconName: 'tent-arrow-turn-left',
  icon: [
    576,
    512,
    [],
    'e580',
    'M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z',
  ],
};
const faFaceDiagonalMouth = {
  prefix: 'far',
  iconName: 'face-diagonal-mouth',
  icon: [
    512,
    512,
    [129764],
    'e47e',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.1 79.2l-184 48c-12.8 3.3-25.9-4.3-29.3-17.2s4.3-25.9 17.2-29.3l184-48c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faDiagramCells = {
  prefix: 'far',
  iconName: 'diagram-cells',
  icon: [
    512,
    512,
    [],
    'e475',
    'M448 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0zm16 128l0 64c0 8.8-7.2 16-16 16l-80 0-224 0-80 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16zm48 64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64z',
  ],
};
const faCricketBatBall = {
  prefix: 'far',
  iconName: 'cricket-bat-ball',
  icon: [
    512,
    512,
    [127951, 'cricket'],
    'f449',
    'M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143-24.4-24.4c-21.9-21.9-57.3-21.9-79.2 0L16.1 334C6.1 344-.6 358.4 .5 374.4c.8 11.3 2.8 28.6 8.2 46.4C13.8 438.1 22.9 457.9 39 473c15 16.2 34.9 25.2 52.2 30.4c17.8 5.4 35.1 7.4 46.4 8.2c16 1.1 30.4-5.6 40.4-15.6L386.3 287.6c21.9-21.9 21.9-57.3 0-79.2L361.9 184 505 41zM269.7 159.6l41.2 41.2 .2 .2 .2 .2 41.2 41.2c3.1 3.1 3.1 8.2 0 11.3L318.1 288 232 288c-4.4 0-8-3.6-8-8l0-86.1 34.3-34.3c3.1-3.1 8.2-3.1 11.3 0zM176 241.9l0 38.1c0 30.9 25.1 56 56 56l38.1 0-126 126c-.7 .7-1.5 1.2-2.1 1.5c-.5 .2-.8 .2-1.1 .2c-9.3-.6-22.6-2.2-35.7-6.2s-24-9.7-30.9-17.2c-.8-.8-1.6-1.7-2.4-2.4c-7.5-6.9-13.2-17.8-17.2-30.9s-5.6-26.5-6.2-35.7c0-.3 0-.6 .2-1.1c.2-.6 .7-1.4 1.5-2.1l126-126zM400 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faCricket = faCricketBatBall;
const faTents = {
  prefix: 'far',
  iconName: 'tents',
  icon: [
    640,
    512,
    [],
    'e582',
    'M430.1 4.6c-8.4-6.1-19.8-6.1-28.2 0l-165 120c-1.7 1.2-3.3 2.6-4.8 4c10.9 1.4 21.5 5.6 30.7 12.6l16.1 12.3L416 53.7 566.8 163.4c1.8 1.3 2.9 3.2 3.2 5.4l17.2 126.1c.7 4.8-3.1 9.1-7.9 9.1L454 304c.6 2.1 1 4.3 1.3 6.5l6.2 41.5 117.8 0c33.9 0 60.1-29.9 55.5-63.6L617.6 162.3c-2.1-15.1-10.2-28.7-22.6-37.7l-165-120zM238.7 165c-8.6-6.7-20.7-6.7-29.3 0L43.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L5.5 448.1C.6 481.8 26.8 512 60.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L425.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L238.7 165zM73 331l127-98.2L200 464 60.9 464c-4.9 0-8.6-4.3-7.9-9.1L69.9 336.2c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L375 331c1.6 1.3 2.7 3.1 3 5.2L395 454.9c.7 4.8-3 9.1-7.9 9.1l-76.7 0L248 360z',
  ],
};
const faWandMagic = {
  prefix: 'far',
  iconName: 'wand-magic',
  icon: [
    512,
    512,
    ['magic'],
    'f0d0',
    'M319.7 157.7l34.6 34.6L464 82.6 429.4 48 319.7 157.7zm-33.9 33.9L48 429.4 82.6 464 320.3 226.2l-34.6-34.6zM14.1 395.4L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9z',
  ],
};
const faMagic = faWandMagic;
const faDog = {
  prefix: 'far',
  iconName: 'dog',
  icon: [
    576,
    512,
    [128021],
    'f6d3',
    'M318 342.2c11.4 9.1 18 22.9 18 37.4l0 68.4c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-173.7L300.5 223c-3.2 .7-6.5 1-9.9 1L144 224l-31.9 0-.1 .8L112 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2c14.2-3.1 29.1 .3 40.4 9.4zM336.9 189l53.4 32.8c7.2-17.7 24.6-29.8 44.4-29.8l45.3 0c26.5 0 48-21.5 48-48l0-32-32 0c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.3 1.7-.7 3.4-1.1 5.1zM64.2 220.2c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5c0 0 0 0 0 0l3.9 15.5C55.6 163.5 71.6 176 90 176l54 0 146.7 0L313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32l76.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 32c0 53-43 96-96 96l-45.3 0L432 256l0 192c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-19.4 0-48.9c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2l0 48.9 0 19.4c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-224c0-1.3 .1-2.6 .2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faPenLine = {
  prefix: 'far',
  iconName: 'pen-line',
  icon: [
    576,
    512,
    [],
    'e212',
    'M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM248 464l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faAtomSimple = {
  prefix: 'far',
  iconName: 'atom-simple',
  icon: [
    512,
    512,
    ['atom-alt'],
    'f5d3',
    'M89.6 422.4c7.9 7.9 31.4 16.9 80.4 .6c13.2-4.4 27.2-10.4 41.6-17.9c-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8c-7.5 14.4-13.5 28.4-17.9 41.6c-16.3 49-7.3 72.5 .6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zM107 211.6c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9c-49-16.3-72.5-7.3-80.4 .6s-16.9 31.4-.6 80.4c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8s-40.3 44.1-55.8 66.2c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2s-44.1-40.3-66.2-55.8zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6c16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9c18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9c49 16.3 72.5 7.3 80.4-.6s16.9-31.4 .6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
};
const faAtomAlt = faAtomSimple;
const faAmpersand = {
  prefix: 'far',
  iconName: 'ampersand',
  icon: [
    448,
    512,
    [],
    '26',
    'M178 80l44.4 0c27.4 0 49.7 22.2 49.7 49.7c0 16.2-7.9 31.4-21.2 40.7l-61.4 43-47.2-48.5C133.1 155.5 128 143 128 130c0-27.6 22.4-50 50-50zm45.3 168.2l55.1-38.5c26.1-18.3 41.7-48.1 41.7-80C320 75.7 276.3 32 222.3 32L178 32c-54.1 0-98 43.9-98 98c0 25.5 10 50 27.7 68.3l41.8 43L75.9 292.8C48.4 312 32 343.5 32 377.1C32 433.9 78.1 480 134.9 480l77.8 0c35.1 0 67.8-17.7 87-47.1l14.6-22.3 60.4 62.1c9.2 9.5 24.4 9.7 33.9 .5s9.7-24.4 .5-33.9l-67.9-69.8 70.8-108.3c7.3-11.1 4.1-26-7-33.2s-26-4.1-33.2 7L307 334.2l-83.7-86zm-39.8 27.9l96.6 99.3-20.5 31.3c-10.3 15.8-28 25.4-46.9 25.4l-77.8 0C104.6 432 80 407.4 80 377.1c0-17.9 8.7-34.7 23.4-45l80-56z',
  ],
};
const faCarrot = {
  prefix: 'far',
  iconName: 'carrot',
  icon: [
    512,
    512,
    [129365],
    'f787',
    'M320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72zM199.3 197.4c13.2-8.6 28.9-13.4 45.3-13.4c46.1 0 83.4 37.3 83.4 83.4c0 32.5-18.9 62-48.3 75.7l-42.8 19.8L209 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15.4 15.4L73.3 438.7l94.8-204.6L207 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41.7-41.7zM34.1 509.8L299.8 386.6c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136c-51.2 0-97.7 29.7-119.2 76.2L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8z',
  ],
};
const faArrowUpFromLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-line',
  icon: [
    384,
    512,
    [8613, 'arrow-from-bottom'],
    'f342',
    'M209.5 39.6C204.9 34.7 198.6 32 192 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 116.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faArrowFromBottom = faArrowUpFromLine;
const faMoon = {
  prefix: 'far',
  iconName: 'moon',
  icon: [
    384,
    512,
    [127769, 9214],
    'f186',
    'M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z',
  ],
};
const faPenSlash = {
  prefix: 'far',
  iconName: 'pen-slash',
  icon: [
    640,
    512,
    [],
    'e213',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.2 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zm38.9 153.1l-38-29.9-84.6 84.6c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8l77.3-77.3-38-29.9-73.2 73.2c-10.4 10.4-18 23.3-22.2 37.4L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6z',
  ],
};
const faWineGlassEmpty = {
  prefix: 'far',
  iconName: 'wine-glass-empty',
  icon: [
    320,
    512,
    ['wine-glass-alt'],
    'f5ce',
    'M56 0C43.5 0 33.1 9.6 32.1 22.1L18.1 198.5C12.3 273.1 64.8 337.9 136 350l0 114-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-114c71.2-12.1 123.7-76.9 117.9-151.5L287.9 22.1C286.9 9.6 276.5 0 264 0L56 0zM66 202.3L78.2 48l163.6 0L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7z',
  ],
};
const faWineGlassAlt = faWineGlassEmpty;
const faSquareStar = {
  prefix: 'far',
  iconName: 'square-star',
  icon: [
    448,
    512,
    [],
    'e27f',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 25c6.1 0 11.7 3.5 14.3 8.9l31.3 63.3 69.9 10.2c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4L297.8 280l11.9 69.6c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 333.6l-62.5 32.9c-5.4 2.8-11.9 2.4-16.9-1.2s-7.4-9.6-6.4-15.6L150.2 280 99.7 230.7c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l69.9-10.2 31.3-63.3c2.7-5.5 8.3-8.9 14.3-8.9z',
  ],
};
const faCheese = {
  prefix: 'far',
  iconName: 'cheese',
  icon: [
    512,
    512,
    [],
    'f7ef',
    'M464 240.2l0 15.8L48 256c0-3.9 2-7.6 5.3-9.8L301.5 80.7c.7-.4 1.5-.7 2.3-.7C392.3 80 464 151.7 464 240.2zM48 304l416 0 0 112c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-112zm464-48l0-15.8C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-160z',
  ],
};
const faSendBackward = {
  prefix: 'far',
  iconName: 'send-backward',
  icon: [
    512,
    512,
    [],
    'f87f',
    'M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-128c0-53 43-96 96-96l128 0 0-64c0-35.3-28.7-64-64-64L64 0zM224 208l224 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm-64 16l0 224c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faYinYang = {
  prefix: 'far',
  iconName: 'yin-yang',
  icon: [
    512,
    512,
    [9775],
    'f6ad',
    'M464 256c0 114.9-93.1 208-208 208c-50.9 0-92.2-41.2-92.2-92s41.3-92 92.2-92c77.3 0 140-62.7 140-140c0-15.4-2.5-30.1-7-44c45.9 38.2 75 95.7 75 160zM256 48c50.8 0 92 41.2 92 92s-41.2 92-92 92c-77.3 0-140.2 62.6-140.2 140c0 15.3 2.5 30 7 43.8C77.1 377.6 48 320.2 48 256C48 141.1 141.1 48 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faMusic = {
  prefix: 'far',
  iconName: 'music',
  icon: [
    512,
    512,
    [127925],
    'f001',
    'M512 31c0-17.1-13.9-31-31-31c-3.1 0-6.2 .5-9.1 1.4l-311 95.7C150.9 100.2 144 109.5 144 120l0 120 0 122.7c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-171.8 272-83.7 0 122.2c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-223.4c0-.4 0-.7 0-1.1L512 31zM464 368c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM144 432c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM464 126.3L192 210l0-72.2L464 54l0 72.2z',
  ],
};
const faCompassSlash = {
  prefix: 'far',
  iconName: 'compass-slash',
  icon: [
    640,
    512,
    [],
    'f5e9',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM172.2 109.7C209.9 71.6 262.2 48 320 48c114.9 0 208 93.1 208 208c0 39.8-11.2 77-30.6 108.6L397.1 285.9l47.5-123.5c7.5-19.4-11.6-38.5-31-31L270.3 186.5l-98.1-76.9zM320 464c-114.9 0-208-93.1-208-208c0-22.3 3.5-43.8 10-63.9L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256c55.2 0 106.3-17.5 148.1-47.2l-39.7-31.3C396.8 452.9 359.7 464 320 464zm-3-118.2l-92.2-72.6-29.4 76.5c-7.5 19.4 11.6 38.5 31 31L317 345.8z',
  ],
};
const faClockOne = {
  prefix: 'far',
  iconName: 'clock-one',
  icon: [
    512,
    512,
    [],
    'e34e',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 56.7 20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faFileMusic = {
  prefix: 'far',
  iconName: 'file-music',
  icon: [
    384,
    512,
    [],
    'f8b6',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM304 208c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
  ],
};
const faCodeCommit = {
  prefix: 'far',
  iconName: 'code-commit',
  icon: [
    640,
    512,
    [],
    'f386',
    'M320 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm158.2-88c-11.6 77-78 136-158.2 136s-146.6-59-158.2-136L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l137.8 0c11.6-77 78-136 158.2-136s146.6 59 158.2 136L616 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-137.8 0z',
  ],
};
const faTemperatureLow = {
  prefix: 'far',
  iconName: 'temperature-low',
  icon: [
    512,
    512,
    [],
    'f76b',
    'M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z',
  ],
};
const faPersonBiking = {
  prefix: 'far',
  iconName: 'person-biking',
  icon: [
    640,
    512,
    [128692, 'biking'],
    'f84a',
    'M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 384A80 80 0 1 1 48 384a80 80 0 1 1 160 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM592 384a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM341.5 149.6c3.5-2.5 8.3-1.9 11 1.4l44.8 56c4.6 5.7 11.5 9 18.7 9l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-52.5 0L390 121c-18.8-23.5-52.7-27.9-76.9-10.1l-74.6 55c-38.5 28.4-33.4 87.4 9.3 108.8L304 302.8 304 416c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-9.1-5.1-17.4-13.3-21.5l-69.6-34.8c-10.7-5.3-12-20.1-2.3-27.2l74.6-55z',
  ],
};
const faBiking = faPersonBiking;
const faDisplayChartUpCircleCurrency = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-currency',
  icon: [
    640,
    512,
    [],
    'e5e5',
    'M64 48l448 0c8.8 0 16 7.2 16 16l0 130.9c17 3.1 33.1 8.7 48 16.3L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 42.8 0c-18.3-12.9-34.1-29.2-46.3-48l-24.8 0L288 464l-35.7 0 8-48 27.7 0 27.7 0 11 0c-4.3-15.3-6.6-31.4-6.6-48l-79.6 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM480 192.7l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z',
  ],
};
const faSkeleton = {
  prefix: 'far',
  iconName: 'skeleton',
  icon: [
    512,
    512,
    [],
    'f620',
    'M256 0c13.3 0 24 10.7 24 24l0 40 144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0 0 48 208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 48 112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 85.7 75.5-32.3c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4l0 1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3l-204.3 0c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48l0-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4L232 389.7l0-85.7-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-48L24 208c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-48L88 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0 0-40c0-13.3 10.7-24 24-24zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faCircleG = {
  prefix: 'far',
  iconName: 'circle-g',
  icon: [
    512,
    512,
    [],
    'e10f',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c20.5 0 39.2 7.7 53.3 20.4c9.9 8.8 25.1 8 33.9-1.9s8-25-1.9-33.9C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.3 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80z',
  ],
};
const faCircleArrowUpLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-up-left',
  icon: [
    512,
    512,
    [],
    'e0fb',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368l-152 0c-13.3 0-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1L327 361c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-135-135 94.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
  ],
};
const faCoinBlank = {
  prefix: 'far',
  iconName: 'coin-blank',
  icon: [
    512,
    512,
    [],
    'e3fb',
    'M256 304c64 0 119.6-14.7 157.5-36c39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60C375.6 126.7 320 112 256 112s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 48 0 64c0 70.7-114.6 128-256 128S0 390.7 0 320l0-64 0-48zM256 352c-13.6 0-27-.6-40-1.7l0 48c12.9 1.1 26.3 1.7 40 1.7s27.1-.6 40-1.7l0-48c-13 1.1-26.4 1.7-40 1.7zM120 330l0 47.7c18.7 7 40.3 12.7 64 16.6l0-48.1c-22.8-3.8-44.3-9.2-64-16.2zM88 316.7C73 309.3 59.6 301 48 292l0 28c0 6.8 6.2 24.2 40 43.1l0-46.5zm240 29.6l0 48.1c23.7-3.9 45.3-9.6 64-16.6l0-47.7c-19.7 7-41.2 12.5-64 16.2zM464 320l0-28c-11.6 9.1-25 17.4-40 24.7l0 46.5c33.8-18.9 40-36.3 40-43.1z',
  ],
};
const faBroom = {
  prefix: 'far',
  iconName: 'broom',
  icon: [
    576,
    512,
    [129529],
    'f51a',
    'M569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 207l-39-39c-5.1-5.1-12.1-8-19.4-8c-12.2 0-23 8.1-26.3 19.9l-15.9 55.6-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5L97 287c-18.4 18.4-29.7 42.4-32.4 68c-.4 3.8-.6 7.7-.6 11.6c0 9.6 7.8 17.3 17.3 17.3l22.7 0L81.3 404.9 57.1 427.3 7.2 473.4C2.6 477.6 0 483.5 0 489.7C0 502 10 512 22.3 512l172.7 0c39.1 0 76.6-15.5 104.2-43.2c33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6 55.6-15.9c11.8-3.4 19.9-14.1 19.9-26.3c0-7.3-2.9-14.2-8-19.4l-39-39L569 41zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-52.3 28l9.8 1.5 55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4c-18.6 18.6-43.9 29.1-70.3 29.1L88.1 464l48.5-44.7c14.5-13.4 19.3-34.3 12.1-52.7c-5.4-13.7-16.6-23.9-30.1-28.3c3.1-6.4 7.3-12.2 12.4-17.3l10.2-10.2c22.4-22.4 54.1-32.8 85.4-28z',
  ],
};
const faVacuum = {
  prefix: 'far',
  iconName: 'vacuum',
  icon: [
    640,
    512,
    [],
    'e04d',
    'M290 48c-27.1 0-50.6 19-56.2 45.5L206 224l-49.1 0L186.8 83.5C197.2 34.8 240.2 0 290 0L528 0c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320l0 128c0 35.3-28.7 64-64 64l-75.3 0c14.8-13 26.5-29.4 34-48l41.3 0c8.8 0 16-7.2 16-16l0-128c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16l0 97c-5.2-.7-10.6-1-16-1c-11 0-21.8 1.4-32 4l0-100c0-35.3 28.7-64 64-64c47.9 0 91.8 17.6 125.4 46.6c28.9-6.1 50.6-31.9 50.6-62.6c0-35.3-28.7-64-64-64L290 48zM150.1 256l49.1 0L171.7 385.1c29.8 5.5 52.3 31.6 52.3 62.9c0 35.3-28.7 64-64 64L32 512c-17.7 0-32-14.3-32-32c0-53 43-96 96-96l26.9 0 27.2-128zM432 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM176 448c0-8.8-7.2-16-16-16l-64 0c-20.9 0-38.7 13.4-45.3 32L160 464c8.8 0 16-7.2 16-16zm208-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faShieldHeart = {
  prefix: 'far',
  iconName: 'shield-heart',
  icon: [
    512,
    512,
    [],
    'e574',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
  ],
};
const faCardHeart = {
  prefix: 'far',
  iconName: 'card-heart',
  icon: [
    384,
    512,
    [],
    'e3eb',
    'M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z',
  ],
};
const faLightbulbCflOn = {
  prefix: 'far',
  iconName: 'lightbulb-cfl-on',
  icon: [
    640,
    512,
    [],
    'e5a7',
    'M343.3 18.2C340.1 5.3 327-2.5 314.2 .7l-128 32c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l128-32c12.9-3.2 20.7-16.2 17.5-29.1zm110.5 93.1c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zm0 96c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zM416 416c0-17.7-14.3-32-32-32l-80 0 0-89.8-48 12 0 77.8c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l40 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 40 0c17.7 0 32-14.3 32-32l0-32zm37.8-112.7c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16-16 4s0 0 0 0l-8 2c-11.1 2.8-18.5 12.9-18.2 23.9l0 81.4 48 0 0-63.3 5.8-1.5 64-16zM53.3 4C42.3-3.3 27.4-.3 20 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L53.3 4zM613.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM101.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm464-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z',
  ],
};
const faMelon = {
  prefix: 'far',
  iconName: 'melon',
  icon: [
    512,
    512,
    [],
    'e310',
    'M464 256c0-25.8-4.7-50.4-13.2-73.2c-14.9 51.3-51.2 110.5-104.3 163.6s-112.3 89.4-163.6 104.3c22.8 8.6 47.4 13.2 73.2 13.2c114.9 0 208-93.1 208-208zM61.2 329.2c14.9-51.3 51.2-110.5 104.3-163.6s112.3-89.4 163.6-104.3C306.4 52.7 281.8 48 256 48C141.1 48 48 141.1 48 256c0 25.8 4.7 50.4 13.2 73.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM403 109c-5.2-5.2-24.1-13.9-67.8 .7c-40.7 13.6-89.8 44-135.7 89.9s-76.3 95-89.9 135.7c-14.6 43.7-5.8 62.6-.7 67.8s24.1 13.9 67.8-.7c40.7-13.6 89.9-44 135.7-89.9s76.3-95 89.9-135.7c14.6-43.7 5.8-62.6 .7-67.8z',
  ],
};
const faGopuram = {
  prefix: 'far',
  iconName: 'gopuram',
  icon: [
    512,
    512,
    [],
    'f664',
    'M120 0c13.3 0 24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 16 0 48 0 2.7c18.6 6.6 32 24.4 32 45.3l0 48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 64c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 80c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-80c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7l0-64c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7l0-48c0-20.9 13.4-38.7 32-45.3l0-2.7 0-48 0-16 0-32 0-8c0-13.3 10.7-24 24-24zm24 80l0 48 224 0 0-48L144 80zm-32 96l0 48 48 0 0-48-16 0-32 0zm208 48l0-48-128 0 0 48 32 0c0-17.7 14.3-32 32-32s32 14.3 32 32l32 0zm32-48l0 48 48 0 0-48-32 0-16 0zm0 96l-192 0 0 64 64 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 64 0 0-64zm32 64l48 0 0-64-32 0-16 0 0 64zM128 464l80 0 0-16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 80 0 0-80-32 0-192 0-32 0 0 80zm288 0l48 0 0-80-32 0-16 0 0 80zM128 272l-16 0-32 0 0 64 48 0 0-64zM96 384l-16 0-32 0 0 80 48 0 0-80z',
  ],
};
const faEarthOceania = {
  prefix: 'far',
  iconName: 'earth-oceania',
  icon: [
    512,
    512,
    ['globe-oceania'],
    'e47b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3l-29.9 0c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 416c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16zM423.2 290.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
};
const faGlobeOceania = faEarthOceania;
const faContainerStorage = {
  prefix: 'far',
  iconName: 'container-storage',
  icon: [
    640,
    512,
    [],
    'f4b7',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 352-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 528 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-352 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 32 24 32zM80 432L80 80l480 0 0 352L80 432zm96-280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208z',
  ],
};
const faFacePouting = {
  prefix: 'far',
  iconName: 'face-pouting',
  icon: [
    512,
    512,
    [],
    'e387',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z',
  ],
};
const faSquareXmark = {
  prefix: 'far',
  iconName: 'square-xmark',
  icon: [
    448,
    512,
    [10062, 'times-square', 'xmark-square'],
    'f2d3',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm143 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faTimesSquare = faSquareXmark;
const faXmarkSquare = faSquareXmark;
const faFaceExplode = {
  prefix: 'far',
  iconName: 'face-explode',
  icon: [
    512,
    512,
    ['exploding-head'],
    'e2fe',
    'M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0c-17.7 0-32 14.3-32 32l0 4.5c0 10.3 4.4 20.1 11.9 27l9.5 6c10.4 6.5 23.5 6.5 33.9 0l17.3-10.8c10.4-6.5 23.5-6.5 33.9 0l20.7 12.9c4.8 3 10.3 4.6 15.8 4.8c4.2 .2 8.5-.5 12.6-2.1l33.9-13.1c1.5 11.4 2.3 23 2.3 34.8c0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9 .5 271.9C.2 266.7 0 261.3 0 256c0-11.8 .8-23.4 2.3-34.8l34 13.1c4.1 1.6 8.4 2.3 12.6 2.1c5.5-.2 11-1.8 15.8-4.8l20.7-12.9c10.4-6.5 23.5-6.5 33.9 0l17.3 10.8c10.4 6.5 23.5 6.5 33.9 0l9.5-6c7.5-6.9 11.9-16.6 11.9-27l0-4.5c0-17.7-14.3-32-32-32l-40 0zm-8.8 110.1l-8.8-5.5-12.2 7.6C77.9 279.9 64 284 49.9 284.4C63.8 385.8 150.7 464 256 464s192.2-78.2 206.1-179.6c-14.1-.4-28-4.5-40.3-12.1l-12.2-7.6-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0zM176.4 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 368c26.5 0 48 21.5 48 48l0 5.3c0 5.9-4.8 10.7-10.7 10.7l-74.7 0c-5.9 0-10.7-4.8-10.7-10.7l0-5.3c0-26.5 21.5-48 48-48z',
  ],
};
const faExplodingHead = faFaceExplode;
const faHashtag = {
  prefix: 'far',
  iconName: 'hashtag',
  icon: [
    448,
    512,
    [62098],
    '23',
    'M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136l111 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136l71.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-81.1 0L314.1 328l77.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-87.5 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144L56 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l87.5 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144-111 0z',
  ],
};
const faUpRightAndDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'up-right-and-down-left-from-center',
  icon: [
    512,
    512,
    ['expand-alt'],
    'f424',
    'M323.3 0C303.8 0 288 15.8 288 35.3c0 9.4 3.7 18.3 10.3 25L326.1 88 264 150.1c-18.7 18.7-18.7 49.1 0 67.9L294.1 248c18.7 18.7 49.1 18.7 67.9 0L424 185.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3L512 40c0-22.1-17.9-40-40-40L323.3 0zM377 71l-23-23L464 48l0 110.1-23-23c-9.4-9.4-24.6-9.4-33.9 0l-79 79L297.9 184l79-79c9.4-9.4 9.4-24.6 0-33.9zM188.7 512c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L185.9 424 248 361.9c18.7-18.7 18.7-49.1 0-67.9L217.9 264c-18.7-18.7-49.1-18.7-67.9 0L88 326.1 60.3 298.3c-6.6-6.6-15.6-10.3-25-10.3C15.8 288 0 303.8 0 323.3L0 472c0 22.1 17.9 40 40 40l148.7 0zM135 441l23 23L48 464l0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0l79-79L214.1 328l-79 79c-9.4 9.4-9.4 24.6 0 33.9z',
  ],
};
const faExpandAlt = faUpRightAndDownLeftFromCenter;
const faOilCan = {
  prefix: 'far',
  iconName: 'oil-can',
  icon: [
    640,
    512,
    [],
    'f613',
    'M328 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48-84.8 0-3.2 0-48 0-48 0c-26.5 0-48 21.5-48 48l0 64.8c0 19 11.2 36.2 28.5 43.9l67.5 30L96 368c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L615 208.6l1.4-1.6 7.6-8.6 9.4-10.6c12.3-13.9-.3-35.4-18.4-31.5l-13.9 3-11.3 2.4-2.1 .4L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8L280 160l0-48 48 0zm97.1 125.8c10.4 5.2 22.3 6.7 33.6 4.3l72.1-15.4L412.7 360.5c-2.4 2.8-5.9 4.3-9.6 4.3l-255.9 0 0-153.6 221.7 0c2 0 3.9 .5 5.7 1.4l50.5 25.2zM96 294.1L48 272.8 48 208l48 0 0 3.2 0 82.9z',
  ],
};
const faT = {
  prefix: 'far',
  iconName: 't',
  icon: [
    384,
    512,
    [116],
    '54',
    'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l144 0 0 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-376 144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L192 32 24 32z',
  ],
};
const faTransformerBolt = {
  prefix: 'far',
  iconName: 'transformer-bolt',
  icon: [
    384,
    512,
    [],
    'e2a4',
    'M136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 8L64 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8zM48 112c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 256-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 272 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-256 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 160l-32 0zM80 464l0-256 224 0 0 256L80 464zM233.4 243.1c-5.9-4.3-14-4-19.6 .7l-96 80c-5.2 4.3-7.1 11.4-4.8 17.7s8.3 10.6 15 10.6l40.4 0-23.2 58.1c-2.7 6.8-.5 14.6 5.5 18.9s14 4 19.6-.7l96-80c5.2-4.3 7.1-11.4 4.8-17.7s-8.3-10.6-15-10.6l-40.4 0 23.2-58.1c2.7-6.8 .5-14.6-5.5-18.9z',
  ],
};
const faHippo = {
  prefix: 'far',
  iconName: 'hippo',
  icon: [
    640,
    512,
    [129435],
    'f6ed',
    'M391 39c9.4-9.4 24.6-9.4 33.9 0l14.2 14.2C449.5 49.9 460.5 48 472 48l32 0c15.8 0 30.8 3.5 44.2 9.8L559 47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7c13.8 17.7 22 39.9 22 64c0 .3 .1 .6 .3 .7c19.4 17.6 31.7 43 31.7 71.3c0 28.4-12.4 54-32 71.6l0 .4 0 32c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-8-64 0 0 8c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-13.5c-37.3-13.2-64-48.7-64-90.5c0-16.2 4-31.4 11.1-44.8c2.9-5.6 4.9-11.7 4.9-18l0-9.2c0-8.9 1.1-17.5 3.2-25.8c-25.6-9.4-52.7-14.2-80-14.2L256 112l-24.8 0C147.7 112 80 179.7 80 263.2c0 19.7-4.1 39.2-12.1 57.2L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 153.2 121.2 64 231.2 64L256 64l35.2 0c35.1 0 69.9 6.6 102.6 19.5c1.2-1.4 2.4-2.7 3.7-4L391 73c-9.4-9.4-9.4-24.6 0-33.9zm81 57c-30.9 0-56 25.1-56 56l0 9.2c0 16.4-5.1 30.3-10.5 40.4c-3.5 6.6-5.5 14.2-5.5 22.4c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48c0-14.1-6-26.8-15.8-35.6C566 179.2 560 166 560 152c0-30.9-25.1-56-56-56l-32 0zM408 377.6c7.1 4.1 15.3 6.4 24 6.4l24 0 0 40c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56l0-16.4c-26.4 5.4-53.6 5.4-80 0l0 16.4c0 30.9-25.1 56-56 56l-40 0c-30.9 0-56-25.1-56-56l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 4.4 3.6 8 8 8l40 0c4.4 0 8-3.6 8-8l0-48c0-7.6 3.6-14.8 9.8-19.3s14.1-5.8 21.4-3.6l11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6c7.3-2.3 15.2-1 21.4 3.6s9.8 11.7 9.8 19.3l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-46.4zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
};
const faChartColumn = {
  prefix: 'far',
  iconName: 'chart-column',
  icon: [
    512,
    512,
    [],
    'e0e3',
    'M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm120-72l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM480 88l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faCassetteVhs = {
  prefix: 'far',
  iconName: 'cassette-vhs',
  icon: [
    576,
    512,
    [128252, 'vhs'],
    'f8ec',
    'M48 416l0-256 480 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM352 336l-128 0 0-80 128 0 0 80zM144 296c0-19.4 13.7-35.5 32-39.2l0 78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2l0-78.4c18.3 3.7 32 19.8 32 39.2zM96 296c0 48.6 39.4 88 88 88l208 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-208 0c-48.6 0-88 39.4-88 88z',
  ],
};
const faVhs = faCassetteVhs;
const faInfinity = {
  prefix: 'far',
  iconName: 'infinity',
  icon: [
    640,
    512,
    [8734, 9854],
    'f534',
    'M0 237.3C0 159.3 63.3 96 141.3 96c39 0 76.2 16.1 102.9 44.5L320 221l75.8-80.5C422.5 112.1 459.7 96 498.7 96c78 0 141.3 63.3 141.3 141.3l0 37.4c0 78-63.3 141.3-141.3 141.3c-39 0-76.2-16.1-102.9-44.5L320 291l-75.8 80.5C217.5 399.9 180.3 416 141.3 416C63.3 416 0 352.7 0 274.7l0-37.4zM287 256l-77.8-82.6c-17.6-18.7-42.2-29.4-68-29.4C89.8 144 48 185.8 48 237.3l0 37.4c0 51.5 41.8 93.3 93.3 93.3c25.7 0 50.3-10.6 68-29.4L287 256zm65.9 0l77.8 82.6c17.6 18.7 42.2 29.4 68 29.4c51.5 0 93.3-41.8 93.3-93.3l0-37.4c0-51.5-41.8-93.3-93.3-93.3c-25.7 0-50.3 10.6-68 29.4L353 256z',
  ],
};
const faVialCircleCheck = {
  prefix: 'far',
  iconName: 'vial-circle-check',
  icon: [
    512,
    512,
    [],
    'e596',
    'M0 56C0 42.7 10.7 32 24 32l8 0 48 0 96 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 186.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 112 96 0 0-112L80 80zm0 160l0 144c0 26.5 21.5 48 48 48s48-21.5 48-48l0-144-96 0zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faChimney = {
  prefix: 'far',
  iconName: 'chimney',
  icon: [
    448,
    512,
    [],
    'f78b',
    'M48 176l352 0 0-96L48 80l0 96zM0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l0 136 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-80 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-56 0L80 384l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104 0-136c-17.7 0-32-14.3-32-32L0 64zM80 224l0 112 80 0 0-112-80 0zm128 0l0 112 56 0 104 0 0-112-160 0z',
  ],
};
const faObjectIntersect = {
  prefix: 'far',
  iconName: 'object-intersect',
  icon: [
    512,
    512,
    [],
    'e49d',
    'M96 48L64 48c-8.8 0-16 7.2-16 16l0 32L0 96 0 64C0 28.7 28.7 0 64 0L96 0l0 48zm32 0l0-48 96 0 0 48-96 0zM0 128l48 0 0 96L0 224l0-96zm352 32l0 48 0 48 0 32c0 35.3-28.7 64-64 64l-64 0-16 0-48 0 0-48 0-48 0-32c0-35.3 28.7-64 64-64l64 0 16 0 48 0zM160 416l48 0 0 32c0 8.8 7.2 16 16 16l32 0 0 48-32 0c-35.3 0-64-28.7-64-64l0-32zM352 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0 0-48 32 0c35.3 0 64 28.7 64 64zm64 144l0-48 32 0c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0zM96 304l0 48-32 0c-35.3 0-64-28.7-64-64l0-32 48 0 0 32c0 8.8 7.2 16 16 16l32 0zM288 464l96 0 0 48-96 0 0-48zm160 48l-32 0 0-48 32 0c8.8 0 16-7.2 16-16l0-32 48 0 0 32c0 35.3-28.7 64-64 64zm64-128l-48 0 0-96 48 0 0 96zM304 208l-80 0c-8.8 0-16 7.2-16 16l0 80 80 0c8.8 0 16-7.2 16-16l0-80z',
  ],
};
const faPersonArrowDownToLine = {
  prefix: 'far',
  iconName: 'person-arrow-down-to-line',
  icon: [
    640,
    512,
    [],
    'e538',
    'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L208 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 464l0-112 32 0 0 112-32 0zm-48 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 80 0 384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-360 0 0-240.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 464zM472 56l0 281.7-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L520 337.7 520 56c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
};
const faVoicemail = {
  prefix: 'far',
  iconName: 'voicemail',
  icon: [
    640,
    512,
    [],
    'f897',
    'M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM251.3 336c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96l-137.3 0zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
  ],
};
const faBlockBrick = {
  prefix: 'far',
  iconName: 'block-brick',
  icon: [
    448,
    512,
    ['wall-brick'],
    'e3db',
    'M144 80l0 48 56 0 48 0 56 0 0-48L144 80zM96 128l0-48L64 80c-8.8 0-16 7.2-16 16l0 32 48 0zM48 176l0 56 152 0 0-56L48 176zm0 160l48 0 0-56-48 0 0 56zm0 48l0 32c0 8.8 7.2 16 16 16l136 0 0-48-56 0-48 0-48 0zm96-48l160 0 0-56-160 0 0 56zm208 0l48 0 0-56-48 0 0 56zm48 48l-48 0-48 0-56 0 0 48 136 0c8.8 0 16-7.2 16-16l0-32zm0-208l-152 0 0 56 152 0 0-56zm0-48l0-32c0-8.8-7.2-16-16-16l-32 0 0 48 48 0zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faWallBrick = faBlockBrick;
const faFan = {
  prefix: 'far',
  iconName: 'fan',
  icon: [
    512,
    512,
    [],
    'f863',
    'M304 40l-4.1 38.2-5.7 52.7c9.4-4 18.9-6.9 28.5-8.6c7-1.2 14-1.9 21-2.2c79-2.9 151.9 53.9 167.7 132.1c.5 2.5 .7 5.1 .7 7.7l0 4.2c0 22.1-17.9 40-40 40l-38.2-4.1-52.7-5.7c4 9.4 6.9 18.9 8.6 28.5c1.2 7 1.9 14 2.2 21c2.9 79-53.9 151.9-132.1 167.7c-2.5 .5-5.1 .7-7.7 .7l-4.2 0c-22.1 0-40-17.9-40-40l4.1-38.2 5.7-52.7c-9.4 4-18.9 6.9-28.5 8.6c-7 1.2-14 1.9-21 2.2C89.4 394.8 16.4 338 .7 259.8c-.5-2.5-.7-5.1-.7-7.7L0 248c0-22.1 17.9-40 40-40l38.2 4.1 52.7 5.7c-4-9.4-6.9-18.9-8.6-28.5c-1.2-7-1.9-14-2.2-21C117.2 89.4 174 16.4 252.2 .7c2.5-.5 5.1-.7 7.7-.7L264 0c22.1 0 40 17.9 40 40zm82.3 206.5l76.3 8.3c-15.2-56.4-73.6-95.1-131.8-85.1c-5.5 .9-11.4 2.7-17.8 5.4c-15.7 6.7-33.7 4.6-47.4-5.6s-21-26.8-19.2-43.7l8.3-76.3c-56.4 15.2-95.1 73.6-85.1 131.8c.9 5.5 2.7 11.4 5.4 17.8c6.7 15.7 4.6 33.7-5.6 47.4s-26.8 21-43.7 19.2l-76.3-8.3c15.2 56.4 73.6 95.1 131.8 85.1c5.5-.9 11.4-2.7 17.8-5.4c15.7-6.7 33.7-4.6 47.4 5.6s21 26.8 19.2 43.7l-8.3 76.3c56.4-15.2 95.1-73.6 85.1-131.8c-.9-5.5-2.7-11.4-5.4-17.8c-6.7-15.7-4.6-33.7 5.6-47.4s26.8-21 43.7-19.2zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faBagsShopping = {
  prefix: 'far',
  iconName: 'bags-shopping',
  icon: [
    576,
    512,
    [128717],
    'f847',
    'M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64-96 0 0-64zm-48 64l-64 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l48 0c0-35.3-28.7-64-64-64l-64 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zm128 96c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-256 0zm64 80l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faParagraphLeft = {
  prefix: 'far',
  iconName: 'paragraph-left',
  icon: [
    384,
    512,
    ['paragraph-rtl'],
    'f878',
    'M304 48l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L224 0 200 0 168 0 144 0C82.1 0 32 50.1 32 112s50.1 112 112 112l32 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-24 0-152 32 0 0 248c0 13.3 10.7 24 24 24s24-10.7 24-24l0-248zM176 48l0 128-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l24 0 8 0zM120.1 361.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C2.9 402.7 0 409.2 0 416s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 440 360 440c13.3 0 24-10.7 24-24s-10.7-24-24-24L86.5 392l33.5-30.2z',
  ],
};
const faParagraphRtl = faParagraphLeft;
const faPersonWalkingLuggage = {
  prefix: 'far',
  iconName: 'person-walking-luggage',
  icon: [
    576,
    512,
    [],
    'e554',
    'M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM365.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L384.7 288.6l-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L503 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C484.1 162.8 437.9 128 385.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7c-39.9 13.3-72.4 42.8-89.5 81.3l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.4 30.9-43.5 55.6-53.3l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L488.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21l-24.1 60.4L231 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zm-75.7-52c-7.6-4.4-17.4-1.8-21.9 5.8L203 335.9 147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c.6-1 1.1-1.9 1.5-2.9L253.8 312c4.4-7.6 1.8-17.4-5.8-21.9z',
  ],
};
const faCaravanSimple = {
  prefix: 'far',
  iconName: 'caravan-simple',
  icon: [
    640,
    512,
    ['caravan-alt'],
    'e000',
    'M80 80c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l28.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L528 368l0-176c0-61.9-50.1-112-112-112L80 80zM96 416l-16 0c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 176 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0-48 0-240 0c0 53-43 96-96 96s-96-43-96-96zm0-256c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-64zm256-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM240 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
  ],
};
const faCaravanAlt = faCaravanSimple;
const faTurtle = {
  prefix: 'far',
  iconName: 'turtle',
  icon: [
    576,
    512,
    [128034],
    'f726',
    'M336 240l0-32c0-70.7-57.3-128-128-128S80 137.3 80 208l0 32 256 0zm48-32l0 41.2c0 21.4-17.4 38.8-38.8 38.8L70.8 288C49.4 288 32 270.6 32 249.2L32 208c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 80c-8.3 0-16.3-1.6-23.6-4.5C440.3 328 400.4 361 352 367l0 1 0 72c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-72-32 0 0 72c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-72-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 48 0 32 0 48 0 32 0 48 0 32 0 32 0c44.2 0 80-35.8 80-80l0-16 0-32 0-16c0-35.3 28.7-64 64-64c53 0 96 43 96 96l0 16c0 35.3-28.7 64-64 64l-32 0zM272 368l0 64 32 0 0-64-32 0zm-160 0l0 64 32 0 0-64-32 0zM496 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faPencilMechanical = {
  prefix: 'far',
  iconName: 'pencil-mechanical',
  icon: [
    512,
    512,
    [],
    'e5ca',
    'M500.7 36.7L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L389.5 42.5c-4.3-1.6-8.9-2.5-13.5-2.5c-10.2 0-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L460.7 163.3c7.2-7.2 11.3-17.1 11.3-27.3c0-4.7-.8-9.3-2.5-13.5l31.1-31.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zM376 91.9L420.1 136 183 373.1 138.9 329 376 91.9zM89.1 422.9l16.9-59 42.2 42.2-59 16.9z',
  ],
};
const faUpDown = {
  prefix: 'far',
  iconName: 'up-down',
  icon: [
    256,
    512,
    [8597, 11021, 'arrows-alt-v'],
    'f338',
    'M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34c0 25.5-20.7 46.3-46.3 46.3l-9.7 0 0 160 9.7 0c25.5 0 46.3 20.7 46.3 46.3c0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0L14.9 416.2C5.4 407.5 0 395.2 0 382.3C0 356.7 20.7 336 46.3 336l9.7 0 0-160-9.7 0C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34L111.7 6.4zM50.7 128L80 128c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24l-29.3 0L128 455.3 205.3 384 176 384c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24l29.3 0L128 56.7 50.7 128zM47.4 381s0 0 0 0l-1.2 1.3 1.2-1.3s0 0 0 0z',
  ],
};
const faArrowsAltV = faUpDown;
const faCloudMoonRain = {
  prefix: 'far',
  iconName: 'cloud-moon-rain',
  icon: [
    576,
    512,
    [],
    'f73c',
    'M353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C417 0 363.5 46.5 353.7 107.6zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zM128.1 192c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.2 0-.4 0-.6 0c-.1 0-.2 0-.4 0l-266.9 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 201 .1 240.5 .1 288c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1l266 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9C238.1 112.6 209.1 96 176.1 96z',
  ],
};
const faBoothCurtain = {
  prefix: 'far',
  iconName: 'booth-curtain',
  icon: [
    512,
    512,
    [],
    'f734',
    'M56 48c-4.4 0-8 3.6-8 8l0 432c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0l88 0 0 48L56 48zM416 0l40 0c30.9 0 56 25.1 56 56l0 40 0 296 0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-28.1c-7.5 2.7-15.6 4.1-24 4.1c-18.4 0-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3c-39.8 0-72-32.2-72-72l0-360c0-17.7 14.3-32 32-32l64 0 48 0 48 0 7.8 0L416 0zM368 48l-48 0 0 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-344zm96 344l0-296 0-40c0-4.4-3.6-8-8-8l-40 0 0 48 0 296c0 13.3 10.7 24 24 24s24-10.7 24-24zm-240 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-344-48 0 0 344z',
  ],
};
const faCalendar = {
  prefix: 'far',
  iconName: 'calendar',
  icon: [
    448,
    512,
    [128197, 128198],
    'f133',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z',
  ],
};
const faBoxHeart = {
  prefix: 'far',
  iconName: 'box-heart',
  icon: [
    448,
    512,
    [],
    'f49d',
    'M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zM48 208l352 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm152-48L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM212.7 404.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 267.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z',
  ],
};
const faTrailer = {
  prefix: 'far',
  iconName: 'trailer',
  icon: [
    640,
    512,
    [],
    'e041',
    'M64 80l432 0c8.8 0 16 7.2 16 16l0 240-236.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zM288 384l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-240c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l32 0c0 53 43 96 96 96s96-43 96-96zM136 112c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zM144 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faUserDoctorMessage = {
  prefix: 'far',
  iconName: 'user-doctor-message',
  icon: [
    640,
    512,
    ['user-md-chat'],
    'f82e',
    'M144 128a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zm-48 96c-5.4 0-10.8 .3-16 1l0 49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-41c-46.9 19-80 65-80 118.7l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-97.2 78.8-176 176-176l96 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-53.7-33.1-99.7-80-118.7l0 40.7c27.6 7.1 48 32.2 48 62l0 32c0 8.8-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-29.8 20.4-54.9 48-62l0-49c-5.2-.7-10.6-1-16-1l-96 0zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM432 0L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z',
  ],
};
const faUserMdChat = faUserDoctorMessage;
const faBahai = {
  prefix: 'far',
  iconName: 'bahai',
  icon: [
    576,
    512,
    ['haykal'],
    'f666',
    'M288 0c10.9 0 20.4 7.3 23.2 17.8l28.1 105.3 89.2-62.6c8.9-6.2 20.9-5.7 29.2 1.3s10.9 18.7 6.3 28.6L417.8 189l108.6 9.4c10.8 .9 19.7 9 21.6 19.7s-3.7 21.3-13.5 25.9L435.6 290l77.2 77c7.7 7.7 9.3 19.6 3.8 29s-16.5 14-27 11.2L384.4 378.8 394 487.4c1 10.8-5.5 21-15.7 24.7s-21.7 .1-27.9-8.8L288 413.9l-62.4 89.4c-6.2 8.9-17.7 12.5-27.9 8.8s-16.7-13.8-15.7-24.7l9.6-108.6L86.4 407.2c-10.5 2.8-21.6-1.8-27-11.2s-3.9-21.3 3.8-29l77.2-77L41.5 244.1c-9.9-4.6-15.4-15.2-13.5-25.9s10.7-18.8 21.6-19.7L158.2 189 112 90.3c-4.6-9.8-2-21.6 6.3-28.6s20.3-7.5 29.2-1.3l89.2 62.6L264.8 17.8C267.6 7.3 277.1 0 288 0zm0 117.1l-13.7 51.6c-2 7.6-7.6 13.7-15 16.4s-15.6 1.6-22-2.9l-43.7-30.7 22.6 48.3c3.3 7.1 3 15.4-1 22.2s-10.9 11.2-18.7 11.9l-53.2 4.6L191.8 261c7.1 3.3 12.2 9.9 13.5 17.6s-1.1 15.6-6.7 21.2l-37.8 37.7 51.5-13.9c7.6-2 15.7-.2 21.7 4.8s9.2 12.7 8.5 20.5L237.8 402l30.6-43.7c4.5-6.4 11.8-10.3 19.7-10.3s15.2 3.8 19.7 10.3L338.2 402l-4.7-53.1c-.7-7.8 2.5-15.5 8.5-20.5s14.1-6.8 21.7-4.8l51.5 13.9-37.8-37.7c-5.5-5.5-8-13.4-6.7-21.2s6.4-14.3 13.5-17.6l48.4-22.5-53.2-4.6c-7.8-.7-14.8-5.1-18.7-11.9s-4.3-15.1-1-22.2l22.6-48.3-43.7 30.7c-6.4 4.5-14.6 5.6-22 2.9s-13-8.8-15-16.4L288 117.1z',
  ],
};
const faHaykal = faBahai;
const faLighthouse = {
  prefix: 'far',
  iconName: 'lighthouse',
  icon: [
    640,
    512,
    [],
    'e612',
    'M33.5 1.9l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48C2.4 40.8-3.3 26.7 1.9 14.5S21.3-3.3 33.5 1.9zm112 204.1l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5zM308.6 2.9c7.1-3.8 15.7-3.8 22.8 0l104 56c11.7 6.3 16 20.8 9.8 32.5c-5.7 10.6-18.2 15.1-29.1 11.3l0 25.4-48 0 0-50.9L320 51.3 272 77.1l0 50.9-48 0 0-25.4c-11 3.9-23.4-.7-29.1-11.3c-6.3-11.7-1.9-26.2 9.8-32.5l104-56zM263.4 208L212.2 464l75.8 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48 75.8 0L376.6 208l-113.3 0zM352 512l-64 0-98.9 0L152 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l11.2 0 51.2-256.1c-12.5-.8-22.4-11.2-22.4-23.9c0-13.3 10.7-24 24-24l8 0 192 0 8 0c13.3 0 24 10.7 24 24c0 12.7-9.9 23.1-22.4 23.9L476.8 464l11.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-37.1 0L352 512zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6zm-156.1 160c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z',
  ],
};
const faAmpGuitar = {
  prefix: 'far',
  iconName: 'amp-guitar',
  icon: [
    512,
    512,
    [],
    'f8a1',
    'M256 0c-48.9 0-92.5 28.8-121.6 53.8c-10.7 9.2-20 18.3-27.5 26.2L64 80C28.7 80 0 108.7 0 144l0 80 0 24 0 24L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-176 0-24 0-24 0-80c0-35.3-28.7-64-64-64l-42.9 0c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0zm0 48c26.4 0 53.6 13.8 77.7 32L178.3 80c24.1-18.2 51.4-32 77.7-32zM464 272l0 176c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-176 416 0zm0-48L48 224l0-80c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 80zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM384 304a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm288-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z',
  ],
};
const faSdCard = {
  prefix: 'far',
  iconName: 'sd-card',
  icon: [
    384,
    512,
    [],
    'f7c2',
    'M336 64l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-293.5c0-4.2 1.7-8.3 4.7-11.3l90.5-90.5c3-3 7.1-4.7 11.3-4.7L320 48c8.8 0 16 7.2 16 16zm48 384l0-384c0-35.3-28.7-64-64-64L154.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64zM176 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z',
  ],
};
const faVolumeSlash = {
  prefix: 'far',
  iconName: 'volume-slash',
  icon: [
    640,
    512,
    [128263],
    'f2e2',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6l0-188.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5L199.5 131 38.8 5.1zm199.1 156L304 102.3 304 213l-66.1-51.8zM32 216l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-76.9-48-37.8 0 74.2L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l54.2 0L81.7 160.4C53.7 163.5 32 187.2 32 216z',
  ],
};
const faBorderBottom = {
  prefix: 'far',
  iconName: 'border-bottom',
  icon: [
    448,
    512,
    [],
    'f84d',
    'M448 456c0 13.3-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24zM384 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
  ],
};
const faWifiWeak = {
  prefix: 'far',
  iconName: 'wifi-weak',
  icon: [640, 512, ['wifi-1'], 'f6aa', 'M264 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'],
};
const faWifi1 = faWifiWeak;
const faDragon = {
  prefix: 'far',
  iconName: 'dragon',
  icon: [
    640,
    512,
    [128009],
    'f6d5',
    'M273 17c3.1-10.1 12.4-17 23-17L424 0l24 0 27.8 0c35 0 68.3 15.3 91.1 41.9l56 65.4c11 12.8 17 29.1 17 46c0 39.1-31.7 70.7-70.7 70.7l-22.8 0c-23.3 0-45.7-9.3-62.2-25.8l-3.9-3.9c1.7 12.7 8.4 24.3 18.8 32L592 296c30.2 22.7 48 58.2 48 96c0 66.3-53.7 120-120 120l-88 0L56.5 512C27.7 512.3 3 490.4 .2 461.3c-2.9-30.8 19.7-58.1 50.5-61l345.6-32.6-12-13.1C353.3 320.6 336 276.2 336 230.2l0-42.1s0 0 0 0c0 0 0-.1 0-.1c0 0 0 0 0 0l0-32-49.7-22.1c-8.3-3.7-13.8-11.8-14.2-20.9s4.4-17.6 12.3-22l37.6-20.9L282.7 44C273.9 38.1 270 27.2 273 17zM375.3 48l6 4c7 4.6 11 12.6 10.7 20.9s-5 15.9-12.3 20l-29.9 16.6 20 8.9c8.7 3.9 14.3 12.4 14.3 21.9l0 47.5s0 0 0 0c0 0 0 .1 0 .1c0 0 0 0 0 0l0 42.1c0 34 12.8 66.8 35.7 91.9l44.6 48.7c6.2 6.7 8 16.3 4.7 24.8s-11.1 14.4-20.1 15.3L55.2 448c-4.4 .4-7.6 4.3-7.2 8.7c.4 4.2 3.9 7.3 8 7.3l.3 0s0 0 0 0L432 464l88 0c39.8 0 72-32.2 72-72c0-22.7-10.7-44-28.8-57.6l-92.8-69.6C446.2 246.7 432 218.2 432 188l0-20c0-13.3 10.7-24 24-24l32 0c6.4 0 12.5 2.5 17 7l13.3 13.3c7.5 7.5 17.7 11.7 28.3 11.7l22.8 0c12.5 0 22.7-10.2 22.7-22.7c0-5.4-1.9-10.7-5.5-14.8l-56-65.4C516.8 57.2 496.9 48 475.8 48L448 48l-24 0-48.7 0zM514.6 95.2c-1.8 2.2-4 4.1-6.6 5.6c-11.5 6.6-26.2 2.7-32.8-8.8c-1.3-2.3-2.2-4.8-2.7-7.3c-.9-4.6 3.7-7.7 8.3-6.5l29.6 7.4c4.5 1.1 7.2 6 4.2 9.6zM520 79.5l0 .9c0-.3 0-.6 0-.9zM189.4 112.4L304 188.8l0 41.4c0 31.2 6.8 61.8 19.5 89.8L112 320c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1z',
  ],
};
const faShoePrints = {
  prefix: 'far',
  iconName: 'shoe-prints',
  icon: [
    640,
    512,
    [],
    'f54b',
    'M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1c-29.4 11.1-67 14.9-92.1 14.9c-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33l0-49.1c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32l0 80 0 48s0 0 0 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2l0-49.1c34-7.3 58.5-21.3 79.1-33l.7-.4C282.5 346.4 301.3 336 336 336c25.2 0 62.7 3.7 92.1 14.9C458.9 362.5 464 374.6 464 384c0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352s0 0 0 0l0 48 0 80s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z',
  ],
};
const faCirclePlus = {
  prefix: 'far',
  iconName: 'circle-plus',
  icon: [
    512,
    512,
    ['plus-circle'],
    'f055',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faPlusCircle = faCirclePlus;
const faFaceGrinTongueWink = {
  prefix: 'far',
  iconName: 'face-grin-tongue-wink',
  icon: [
    512,
    512,
    [128540, 'grin-tongue-wink'],
    'f58b',
    'M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4l0-52.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1l0 52.4c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z',
  ],
};
const faGrinTongueWink = faFaceGrinTongueWink;
const faHandHolding = {
  prefix: 'far',
  iconName: 'hand-holding',
  icon: [
    576,
    512,
    [],
    'f4bd',
    'M165.2 358.7c6.6-4.4 14.3-6.7 22.2-6.7L344 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 24 0 48 0c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9l7.4 0c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l363.7 0c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3l-7.4 0c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64l-156.6 0c-17.4 0-34.4 5.1-48.8 14.8L64.7 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.7 0 9.4-1.4 13.3-4l79.9-53.3z',
  ],
};
const faPlugCircleExclamation = {
  prefix: 'far',
  iconName: 'plug-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e55d',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faLinkSlash = {
  prefix: 'far',
  iconName: 'link-slash',
  icon: [
    640,
    512,
    ['chain-broken', 'chain-slash', 'unlink'],
    'f127',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l91-91c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6l-95.1 95.1-45.5-35.7c24.2-53.3 14.1-117.9-29.3-161.3c-52.1-52.1-134.4-55.9-190.8-11.2L38.8 5.1zm186.3 146c36.9-22.3 85.6-17.6 117.4 14.3c26 26 34 63.3 23.7 96.4L225.1 151.1zM352.6 373.8c-20.2-2.7-39.7-11.7-55.2-27.3c-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9c38.8 38.8 94.2 50.8 143.4 36l-54.2-42.7zm-236-186L59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z',
  ],
};
const faChainBroken = faLinkSlash;
const faChainSlash = faLinkSlash;
const faUnlink = faLinkSlash;
const faClone = {
  prefix: 'far',
  iconName: 'clone',
  icon: [
    512,
    512,
    [],
    'f24d',
    'M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z',
  ],
};
const faPersonWalkingArrowLoopLeft = {
  prefix: 'far',
  iconName: 'person-walking-arrow-loop-left',
  icon: [
    640,
    512,
    [],
    'e551',
    'M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM447 449c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-39-39 42.1 0c86.2 0 156-69.8 156-156s-69.8-156-156-156L344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l140 0c59.6 0 108 48.4 108 108s-48.4 108-108 108l-42.1 0 39-39c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9l80 80z',
  ],
};
const faArrowUpZA = {
  prefix: 'far',
  iconName: 'arrow-up-z-a',
  icon: [
    576,
    512,
    ['sort-alpha-up-alt'],
    'f882',
    'M352 32l128 0c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 176l74.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 80 352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM416 272c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5l-85.2 0-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160c4.1-8.1 12.4-13.3 21.5-13.3zM394.8 392l42.3 0L416 349.7 394.8 392z',
  ],
};
const faSortAlphaUpAlt = faArrowUpZA;
const faFireFlameCurved = {
  prefix: 'far',
  iconName: 'fire-flame-curved',
  icon: [
    384,
    512,
    ['fire-alt'],
    'f7e4',
    'M53.9 186.1C19.4 220.6 0 267.4 0 316.2l0 11.5C0 429.5 82.5 512 184.3 512l15.1 0C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L225.9 73.5c-6.3-6-9.9-14.4-9.9-23.2l0-13 0-16C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5L168 21.3l-9.9 13.2c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.3 3.9-.5 7.8-.4 11.7c.2 22.9 6.6 45.4 18.4 65c2.2 3.7 4.6 7.2 7.2 10.6L168 213.3l21.2 28.3c7 9.3 10.8 20.7 10.8 32.4l0 14c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-58.7 0-2.5 0-38.5c0-15.6-12.7-28.3-28.3-28.3c-1.3 0-2.6 .1-3.9 .3c-6 .8-11.7 3.6-16.1 8L53.9 186.1zm18.1 53L72 288c0 48.6 39.4 88 88 88s88-39.4 88-88l0-14c0-22.1-7.2-43.5-20.4-61.2l-32-42.7c-11.8-15.7-17.4-35.1-15.7-54.6l.9-10.8c.3-3.1 .7-6.1 1.3-9.1c3.1 4.5 6.7 8.8 10.8 12.6L276 187.4c38.3 36.5 60 87.1 60 140C336 402.9 274.9 464 199.4 464l-15.1 0C109 464 48 403 48 327.7l0-11.5c0-27.7 8.5-54.6 24-77.2z',
  ],
};
const faFireAlt = faFireFlameCurved;
const faTornado = {
  prefix: 'far',
  iconName: 'tornado',
  icon: [
    448,
    512,
    [127786],
    'f76f',
    'M332.4 48L48 48c.3 28 6.3 55.1 17 80l239.1 0c-.1-1.8-.1-3.6-.1-5.4C304 95 314.2 68.5 332.4 48zM317.5 176L94 176c15.5 19.3 34.6 35.9 56.6 48.9L203.5 256 376 256l-49.6-66.1c-3.3-4.4-6.3-9.1-8.9-13.9zm80.9 128l-115.6 0c19.9 15.1 36.1 34.6 47.3 57c8.9 17.8 14.4 37 16.4 56.5l23.6-23.6c19.1-19.1 29.8-45 29.8-72c0-6-.5-12.1-1.6-17.9zm5.7 123.9L340 492l-.4 .4L336 496l-10.1 10.1c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l2.4-14.1 .8-5 .1-.5 2.7-16c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6L0 32C0 14.3 14.3 0 32 0L393.4 0C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9z',
  ],
};
const faFileCirclePlus = {
  prefix: 'far',
  iconName: 'file-circle-plus',
  icon: [
    576,
    512,
    [58606],
    'e494',
    'M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z',
  ],
};
const faDeleteRight = {
  prefix: 'far',
  iconName: 'delete-right',
  icon: [
    576,
    512,
    [],
    'e154',
    'M370.7 64c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l306.7 0zM48 128l0 256c0 8.8 7.2 16 16 16l306.7 0c4.2 0 8.3-1.7 11.3-4.7L521.4 256 382.1 116.7c-3-3-7.1-4.7-11.3-4.7L64 112c-8.8 0-16 7.2-16 16zm95 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faBookQuran = {
  prefix: 'far',
  iconName: 'book-quran',
  icon: [
    448,
    512,
    ['quran'],
    'f687',
    'M360 0c48.6 0 88 39.4 88 88l0 336-.4 0c.3 2.6 .4 5.3 .4 8c0 44.2-35.8 80-80 80L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-69.4c-18.9-9-32-28.3-32-50.6L0 56C0 25.1 25.1 0 56 0L360 0zM80 400l0 64 288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 400zm288-48c11.4 0 22.2 2.4 32 6.7L400 88c0-22.1-17.9-40-40-40L56 48c-4.4 0-8 3.6-8 8l0 288c0 4.4 3.6 8 8 8l312 0zM282.1 150.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L312 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L288 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zm-24.6-45.6c4.1 1.8 6.5 5.9 6.5 10.3c0 7.6-7.1 13.2-14.7 13.1c-.4 0-.8 0-1.3 0c-39.8 0-72 32.2-72 72s32.2 72 72 72c.4 0 .8 0 1.3 0c7.6-.1 14.7 5.5 14.7 13.1c0 4.4-2.4 8.5-6.5 10.3c-12.7 5.5-26.8 8.6-41.5 8.6c-57.4 0-104-46.6-104-104s46.6-104 104-104c14.8 0 28.8 3.1 41.5 8.6z',
  ],
};
const faQuran = faBookQuran;
const faCircleQuarter = {
  prefix: 'far',
  iconName: 'circle-quarter',
  icon: [
    512,
    512,
    [],
    'e11f',
    'M208 53.6L208 208 53.6 208C71.6 131.7 131.7 71.6 208 53.6zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z',
  ],
};
const faAnchor = {
  prefix: 'far',
  iconName: 'anchor',
  icon: [
    576,
    512,
    [9875],
    'f13d',
    'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c100.2 0 181.8-80.2 184-179.9l16.4 14.1c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.2-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.3-14C469.7 405.4 409.7 464 336 464l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80z',
  ],
};
const faBorderAll = {
  prefix: 'far',
  iconName: 'border-all',
  icon: [
    448,
    512,
    [],
    'f84c',
    'M384 80c8.8 0 16 7.2 16 16l0 136-152 0 0-152 136 0zm16 200l0 136c0 8.8-7.2 16-16 16l-136 0 0-152 152 0zM200 232L48 232 48 96c0-8.8 7.2-16 16-16l136 0 0 152zM48 280l152 0 0 152L64 432c-8.8 0-16-7.2-16-16l0-136zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
  ],
};
const faFunction = {
  prefix: 'far',
  iconName: 'function',
  icon: [
    640,
    512,
    [],
    'f661',
    'M72 88c0-48.6 39.4-88 88-88l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-22.1 0-40 17.9-40 40l0 104 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 150.7c0 44.8-33.7 82.5-78.3 87.5l-15.1 1.7c-13.2 1.5-25-8-26.5-21.2s8-25 21.2-26.5l15.1-1.7C56.7 428.2 72 411.1 72 390.7L72 240l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0L72 88zm244.3 76.8C288.4 209.1 272 262.5 272 320s16.4 110.9 44.3 155.2c7.1 11.2 3.7 26-7.5 33.1s-26 3.7-33.1-7.5C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8c7.1-11.2 21.9-14.6 33.1-7.5s14.6 21.9 7.5 33.1zm231.4 0c-7.1-11.2-3.7-26 7.5-33.1s26-3.7 33.1 7.5C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8c-7.1 11.2-21.9 14.6-33.1 7.5s-14.6-21.9-7.5-33.1C575.6 430.9 592 377.5 592 320s-16.4-110.9-44.3-155.2zM393 247l39 39 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faFaceAngry = {
  prefix: 'far',
  iconName: 'face-angry',
  icon: [
    512,
    512,
    [128544, 'angry'],
    'f556',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z',
  ],
};
const faAngry = faFaceAngry;
const faPeopleSimple = {
  prefix: 'far',
  iconName: 'people-simple',
  icon: [
    512,
    512,
    [],
    'e21b',
    'M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L192 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM352.9 219.6L319.6 336l128.7 0L415.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.4 0c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z',
  ],
};
const faCookieBite = {
  prefix: 'far',
  iconName: 'cookie-bite',
  icon: [
    512,
    512,
    [],
    'f564',
    'M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm34.9 37.5c19 54.5 63.9 96.7 120 111.9c17.7 50.9 58.1 91.1 109.1 108.7c-1 4.8-2.5 9.5-4.7 13.9L405.4 376c-5.4 11-14.1 20.1-24.8 25.8l-74 39.5c-10.8 5.7-23 7.9-35.1 6.2l-83-11.7c-12-1.7-23.3-7.2-32-15.7l-29.7 30.7 29.7-30.7L96.2 361.7c-8.8-8.5-14.7-19.6-16.8-31.7L64.9 247.2c-2.1-12.1-.4-24.6 5-35.6L106.6 136c5.4-11 14.1-20.1 24.8-25.8l74-39.5c3.9-2.1 8.1-3.7 12.4-4.9zM192 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faArrowTrendDown = {
  prefix: 'far',
  iconName: 'arrow-trend-down',
  icon: [
    576,
    512,
    [],
    'e097',
    'M352 392c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1L337 143c-9.4-9.4-24.6-9.4-33.9 0l-111 111L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 305c9.4 9.4 24.6 9.4 33.9 0l111-111L494.1 368 376 368c-13.3 0-24 10.7-24 24z',
  ],
};
const faRss = {
  prefix: 'far',
  iconName: 'rss',
  icon: [
    448,
    512,
    ['feed'],
    'f09e',
    'M0 56C0 42.7 10.7 32 24 32c234.2 0 424 189.8 424 424c0 13.3-10.7 24-24 24s-24-10.7-24-24C400 248.3 231.7 80 24 80C10.7 80 0 69.3 0 56zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM24 176c154.6 0 280 125.4 280 280c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faFeed = faRss;
const faFaceMonocle = {
  prefix: 'far',
  iconName: 'face-monocle',
  icon: [
    512,
    512,
    [],
    'e380',
    'M448 336.1L448 224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 86.5C377.8 434.8 320.3 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7c-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c5.7 3.8 12.9 3.5 18.2-.3c48 38.1 78.7 96.9 78.7 163c0 28.4-5.7 55.5-16 80.1zm3.9 84.7C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16z',
  ],
};
const faDrawPolygon = {
  prefix: 'far',
  iconName: 'draw-polygon',
  icon: [
    448,
    512,
    [],
    'f5ee',
    'M80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zm8 59.3l0 201.3c16 6.5 28.9 19.3 35.3 35.3l201.3 0c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2 .5-6.6 .8-10 .8c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7 .3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5l-201.3 0c-6.5 16-19.3 28.9-35.3 35.3zM374.1 352.8c3.2-.5 6.6-.8 9.9-.8c35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40l-201.3 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-201.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40l201.3 0c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faScaleBalanced = {
  prefix: 'far',
  iconName: 'scale-balanced',
  icon: [
    640,
    512,
    [9878, 'balance-scale'],
    'f24e',
    'M520 48L393.3 48C381 19.7 352.8 0 320 0s-61 19.7-73.3 48L120 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l121.6 0c5.8 28.6 26.9 51.7 54.4 60.3L296 464l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0 200 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0 0-307.7c27.5-8.6 48.6-31.7 54.4-60.3L520 96c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 147.8L584.4 320l-144.9 0L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 305.1c-5.7 9.8-9.3 21.1-6.7 32.1zM54.4 320l72.4-124.2L199.3 320 54.4 320zm72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1C11.7 382 64 416 126.8 416zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faBalanceScale = faScaleBalanced;
const faCalendarLines = {
  prefix: 'far',
  iconName: 'calendar-lines',
  icon: [
    448,
    512,
    ['calendar-note'],
    'e0d5',
    'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm48 88c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
  ],
};
const faCalendarNote = faCalendarLines;
const faArrowDownBigSmall = {
  prefix: 'far',
  iconName: 'arrow-down-big-small',
  icon: [
    576,
    512,
    ['sort-size-down'],
    'f88c',
    'M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L136 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 342.1 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 368l0 64 64 0 0-64-64 0zm-48 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zm48-160l128 0 0-128L368 80l0 128zm-48 0l0-128c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48z',
  ],
};
const faSortSizeDown = faArrowDownBigSmall;
const faGaugeSimpleHigh = {
  prefix: 'far',
  iconName: 'gauge-simple-high',
  icon: [
    512,
    512,
    [61668, 'tachometer', 'tachometer-fast'],
    'f62a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56s56-25.1 56-56z',
  ],
};
const faTachometer = faGaugeSimpleHigh;
const faTachometerFast = faGaugeSimpleHigh;
const faDoNotEnter = {
  prefix: 'far',
  iconName: 'do-not-enter',
  icon: [
    512,
    512,
    [],
    'f5ec',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-48l256 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
  ],
};
const faShower = {
  prefix: 'far',
  iconName: 'shower',
  icon: [
    512,
    512,
    [128703],
    'f2cc',
    'M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7C139.6 41.7 116.3 32 91.9 32C41.1 32 0 73.1 0 123.9L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-332.1zM269.5 115l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2c0 0 0 0 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faDiceD8 = {
  prefix: 'far',
  iconName: 'dice-d8',
  icon: [
    512,
    512,
    [],
    'f6d2',
    'M239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7zM126.2 324.3L232 430.1l0-62L126.2 324.3zM280 368l0 62L385.8 324.3 280 368zM445.6 247.6L280 81.9l0 234.2 165.6-68.5zM232 81.9L66.4 247.6 232 316.1l0-234.2z',
  ],
};
const faDesktop = {
  prefix: 'far',
  iconName: 'desktop',
  icon: [
    576,
    512,
    [128421, 61704, 'desktop-alt'],
    'f390',
    'M512 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16zm64 208l0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 192zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48z',
  ],
};
const faDesktopAlt = faDesktop;
const faM = {
  prefix: 'far',
  iconName: 'm',
  icon: [
    448,
    512,
    [109],
    '4d',
    'M17.1 33C27.3 30 38.2 34 44 42.8L224 316.3 403.9 42.8C409.8 34 420.7 30 430.9 33S448 45.4 448 56l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-319.9-156 237c-4.4 6.7-12 10.8-20 10.8s-15.6-4.1-20-10.8L48 136.1 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 45.4 7 36.1 17.1 33z',
  ],
};
const faSpinnerScale = {
  prefix: 'far',
  iconName: 'spinner-scale',
  icon: [
    512,
    512,
    [],
    'e62a',
    'M256 52a12 12 0 1 1 0 24 12 12 0 1 1 0-24zM204 64a52 52 0 1 0 104 0A52 52 0 1 0 204 64zm20 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM480 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 220a36 36 0 1 0 0 72 36 36 0 1 0 0-72zm339.1-88.5a16 16 0 1 1 -22.6-22.6 16 16 0 1 1 22.6 22.6zm28.3-50.9a56 56 0 1 0 -79.2 79.2 56 56 0 1 0 79.2-79.2zM97.6 369.1a32 32 0 1 0 45.3 45.3A32 32 0 1 0 97.6 369.1zm316.8 45.3a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zM125.9 125.9a8 8 0 1 1 -11.3-11.3 8 8 0 1 1 11.3 11.3zm28.3-39.6A48 48 0 1 0 86.3 154.2a48 48 0 1 0 67.9-67.9z',
  ],
};
const faGripDotsVertical = {
  prefix: 'far',
  iconName: 'grip-dots-vertical',
  icon: [
    256,
    512,
    [],
    'e411',
    'M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faFaceViewfinder = {
  prefix: 'far',
  iconName: 'face-viewfinder',
  icon: [
    512,
    512,
    [],
    'e2ff',
    'M0 56l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-4.4 3.6-8 8-8l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C25.1 0 0 25.1 0 56zM352 24c0 13.3 10.7 24 24 24l80 0c4.4 0 8 3.6 8 8l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-30.9-25.1-56-56-56L376 0c-13.3 0-24 10.7-24 24zM24 352c-13.3 0-24 10.7-24 24l0 80c0 30.9 25.1 56 56 56l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-4.4 0-8-3.6-8-8l0-80c0-13.3-10.7-24-24-24zm464 0c-13.3 0-24 10.7-24 24l0 80c0 4.4-3.6 8-8 8l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c30.9 0 56-25.1 56-56l0-80c0-13.3-10.7-24-24-24zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z',
  ],
};
const faSoftServe = {
  prefix: 'far',
  iconName: 'soft-serve',
  icon: [
    384,
    512,
    [127846, 'creemee'],
    'e400',
    'M192 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L140 64c-42 0-76 34-76 76c0 5.4 .6 10.7 1.7 15.8C27.7 167.2 0 202.3 0 244c0 34.9 19.4 65.2 48 80.8L48 352c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l134.7 0c16.3 0 30-12.3 31.8-28.5L302.2 384l1.8 0c17.7 0 32-14.3 32-32l0-27.2c28.6-15.6 48-45.9 48-80.8c0-41.9-28.1-77.3-66.4-88.4c1.6-6.3 2.4-12.8 2.4-19.6l0-8C320 57.3 262.7 0 192 0zM292 288L92 288c-24.3 0-44-19.7-44-44s19.7-44 44-44l4 0 6.5 0 9.5 0c13.3 0 24-10.7 24-24c0-12.3-9.3-22.5-21.2-23.8c-1.8-3.7-2.8-7.8-2.8-12.2c0-15.5 12.5-28 28-28l37.3 0c29.7 0 53.9-23.7 54.7-53.3c23.9 13.8 40 39.7 40 69.3l0 8c0 5.8-1.5 11.3-4.3 16L216 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l63.2 0 8.8 0 4 0c24.3 0 44 19.7 44 44s-19.7 44-44 44z',
  ],
};
const faCreemee = faSoftServe;
const faH5 = {
  prefix: 'far',
  iconName: 'h5',
  icon: [
    640,
    512,
    [],
    'e412',
    'M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM440 64c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1 .4 14.4 5 19.9s11.4 8.8 18.6 8.8l120 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-63.6 0c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2s-19.4 17.8-15.2 30.4l3.2 9.7C399.4 426 429.9 448 464.4 448l63.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-90.7 0 22.4-112L584 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L440 64z',
  ],
};
const faHandBackPointDown = {
  prefix: 'far',
  iconName: 'hand-back-point-down',
  icon: [
    448,
    512,
    [],
    'e19e',
    'M144 512c-35.3 0-64-28.7-64-64l0-188.8c-5.2-3.6-10.2-7.6-14.9-11.9L44.8 228.8C26.5 212.1 16 188.5 16 163.7l0-10.2C16 99.5 44.7 49.5 91.4 22.2L94 20.7C117.3 7.1 143.7 0 170.6 0L296 0c66.3 0 120 53.7 120 120l0 8 0 96c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-2.7 0-5.4-.2-8-.5l0 96.5c0 35.3-28.7 64-64 64zm-16-64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-136c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16l0-8c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16c0-9.1 5.1-17.4 13.3-21.5s17.9-3.2 25.1 2.3c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-96 0-8c0-39.8-32.2-72-72-72L170.6 48c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5l0 10.2c0 11.3 4.8 22 13.1 29.6L96 210.5 96 168c0-8.8 7.2-16 16-16s16 7.2 16 16l0 78 0 2 0 200z',
  ],
};
const faTableList = {
  prefix: 'far',
  iconName: 'table-list',
  icon: [
    512,
    512,
    ['th-list'],
    'f00b',
    'M192 80l0 88 272 0 0-72c0-8.8-7.2-16-16-16L192 80zm-48 0L64 80c-8.8 0-16 7.2-16 16l0 72 96 0 0-88zM48 216l0 80 96 0 0-80-96 0zm0 128l0 72c0 8.8 7.2 16 16 16l80 0 0-88-96 0zm144 88l256 0c8.8 0 16-7.2 16-16l0-72-272 0 0 88zM464 296l0-80-272 0 0 80 272 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faThList = faTableList;
const faBasketShoppingMinus = {
  prefix: 'far',
  iconName: 'basket-shopping-minus',
  icon: [
    576,
    512,
    [],
    'e652',
    'M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192l-36.1 0L32 192l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l20 0L99.9 463.5C107 492 132.6 512 162 512L414 512c29.4 0 55-20 62.1-48.5L532 240l20 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-49.5 0-36.1 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM93.5 240l389 0-53 211.9C427.8 459 421.4 464 414 464L162 464c-7.3 0-13.7-5-15.5-12.1L93.5 240zM224 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z',
  ],
};
const faCommentSms = {
  prefix: 'far',
  iconName: 'comment-sms',
  icon: [
    512,
    512,
    ['sms'],
    'f7cd',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 176 96 192.5 96 212.8zM372.8 176c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9z',
  ],
};
const faSms = faCommentSms;
const faRectangle = {
  prefix: 'far',
  iconName: 'rectangle',
  icon: [
    512,
    512,
    [9644, 'rectangle-landscape'],
    'f2fa',
    'M448 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z',
  ],
};
const faRectangleLandscape = faRectangle;
const faClipboardListCheck = {
  prefix: 'far',
  iconName: 'clipboard-list-check',
  icon: [
    384,
    512,
    [],
    'f737',
    'M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm3.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faTurkey = {
  prefix: 'far',
  iconName: 'turkey',
  icon: [
    640,
    512,
    [],
    'f725',
    'M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-3.2 2.3-6.2 5-9 8.3C505.8 285.7 528 334.2 528 384c0 21-6.1 32.8-13.9 41c-8.9 9.4-23.9 18.1-47.3 24.8C418.6 463.6 354 464 288 464s-130.6-.4-178.8-14.2c-23.4-6.7-38.4-15.4-47.3-24.8C54.1 416.8 48 405 48 384c0-62 34.5-122 86-168.3C186.4 168.8 247.4 144 288 144c20.5 0 46.3 6.4 73.6 18.7c-15.2 .8-30.8-.5-45.8-2.1c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c18.6-15 31.1-34.8 37.2-56.2c.2-.7 .4-1.3 .6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z',
  ],
};
const faBook = {
  prefix: 'far',
  iconName: 'book',
  icon: [
    448,
    512,
    [128212],
    'f02d',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM152 112l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faUserPlus = {
  prefix: 'far',
  iconName: 'user-plus',
  icon: [
    640,
    512,
    [],
    'f234',
    'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faIceSkate = {
  prefix: 'far',
  iconName: 'ice-skate',
  icon: [
    576,
    512,
    [9976],
    'f7ac',
    'M296 0c13.3 0 24 10.7 24 24l0 120 0 38 128.6 37.5c37.5 11 63.4 45.4 63.4 84.5l0 24c0 30.9-25.1 56-56 56L88 384c-30.9 0-56-25.1-56-56l0-191.6c0-25.2 16.8-47.3 41.1-54L272 27.5l0-3.5c0-13.3 10.7-24 24-24zM272 128l0-50.7L85.9 128.7c-3.5 1-5.9 4.1-5.9 7.7L80 328c0 4.4 3.6 8 8 8l368 0c4.4 0 8-3.6 8-8l0-24c0-17.8-11.7-33.4-28.8-38.4L292.6 224 240 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0zM552 408c13.3 0 24 10.7 24 24l0 8c0 39.8-32.2 72-72 72l-96 0-288 0-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 0-48 48 0 0 48 240 0 0-48 48 0 0 48 72 0c13.3 0 24-10.7 24-24l0-8c0-13.3 10.7-24 24-24z',
  ],
};
const faCheck = {
  prefix: 'far',
  iconName: 'check',
  icon: [
    448,
    512,
    [10003, 10004],
    'f00c',
    'M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z',
  ],
};
const faBatteryThreeQuarters = {
  prefix: 'far',
  iconName: 'battery-three-quarters',
  icon: [
    576,
    512,
    ['battery-4'],
    'f241',
    'M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm272 96L96 192l0 128 256 0 0-128z',
  ],
};
const faBattery4 = faBatteryThreeQuarters;
const faTomato = {
  prefix: 'far',
  iconName: 'tomato',
  icon: [
    512,
    512,
    [],
    'e330',
    'M241 7L224 24C241 7 241 7 241 7s0 0 0 0s0 0 0 0l.1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3l-34.6 0 15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.4 6.6 .7 13.3 3.1 19.6C67.1 219.8 48 256.7 48 304c0 49.8 21.1 88 56.2 115c36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115c0-47.3-19.1-84.2-51.1-110.9c2.4-6.3 3.4-13 3.1-19.6c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z',
  ],
};
const faSwordLaser = {
  prefix: 'far',
  iconName: 'sword-laser',
  icon: [
    512,
    512,
    [],
    'e03b',
    'M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L230.7 226.8l54.4 54.4L505.7 40.2zM185 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l.7 .7-59 59c0 0 0 0 0 0s0 0 0 0L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l82.3-82.3 59-59 .7 .7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96-96zm-20.3 143l-26.7-26.7 12.4-12.4 26.7 26.7-12.4 12.4zm-49.4-4.1l26.7 26.7L80 458.7 53.3 432l62.1-62.1zM173 312.3l12.7-12.7 26.7 26.7L199.7 339 173 312.3z',
  ],
};
const faHouseCircleCheck = {
  prefix: 'far',
  iconName: 'house-circle-check',
  icon: [
    640,
    512,
    [],
    'e509',
    'M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z',
  ],
};
const faBuildings = {
  prefix: 'far',
  iconName: 'buildings',
  icon: [
    512,
    512,
    [],
    'e0cc',
    'M448 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-384c0-8.8 7.2-16 16-16l160 0zM288 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L288 0zM192 128L72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l144.4 0c-11.8-13.2-20.1-29.7-23.1-48L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l120 0 0-48zM112 320c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm224 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM112 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM336 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 144l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16z',
  ],
};
const faAngleLeft = {
  prefix: 'far',
  iconName: 'angle-left',
  icon: [
    320,
    512,
    [8249],
    'f104',
    'M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z',
  ],
};
const faCartFlatbedBoxes = {
  prefix: 'far',
  iconName: 'cart-flatbed-boxes',
  icon: [
    640,
    512,
    ['dolly-flatbed-alt'],
    'f475',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l48 0c4.4 0 8 3.6 8 8l0 352c0 30.9 25.1 56 56 56l24 0c0 26.5 21.5 48 48 48s48-21.5 48-48l192 0c0 26.5 21.5 48 48 48s48-21.5 48-48l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0-288 0-72 0c-4.4 0-8-3.6-8-8l0-352c0-30.9-25.1-56-56-56L24 0zM240 80l128 0 0 224-128 0 0-224zm-48 0l0 224c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L240 32c-26.5 0-48 21.5-48 48zm368 0l0 64-64 0 0-64 64 0zM496 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0zm0 240l96 0 0 32-96 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
  ],
};
const faDollyFlatbedAlt = faCartFlatbedBoxes;
const faDiagramSuccessor = {
  prefix: 'far',
  iconName: 'diagram-successor',
  icon: [
    512,
    512,
    [],
    'e47a',
    'M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM240 160c0 8.8-7.2 16-16 16L64 176c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l144 0 16 0c8.8 0 16 7.2 16 16l0 64zm48-64c0-5.5-.7-10.9-2-16l82 0c13.3 0 24 10.7 24 24l0 38.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-38.1c0-39.8-32.2-72-72-72L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64z',
  ],
};
const faTruckArrowRight = {
  prefix: 'far',
  iconName: 'truck-arrow-right',
  icon: [
    640,
    512,
    [],
    'e58b',
    'M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM241 95l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L112 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l134.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faSquareW = {
  prefix: 'far',
  iconName: 'square-w',
  icon: [
    448,
    512,
    [],
    'e285',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm118.9 64.7L160 289.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 289.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 246.7 182.9 375.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z',
  ],
};
const faArrowsSplitUpAndLeft = {
  prefix: 'far',
  iconName: 'arrows-split-up-and-left',
  icon: [
    512,
    512,
    [],
    'e4bc',
    'M241 137c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L344 384l0 8c0 39.8 32.2 72 72 72l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-66.3 0-120-53.7-120-120l0-8c0-39.8-32.2-72-72-72L81.9 312l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55L224 264c27 0 51.9 8.9 72 24l0-206.1-55 55z',
  ],
};
const faLamp = {
  prefix: 'far',
  iconName: 'lamp',
  icon: [
    448,
    512,
    [],
    'f4ca',
    'M2.5 211.7l80-192C87.4 7.8 99.1 0 112 0L336 0c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2L32 256c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1zM56 208l336 0L325.3 48 122.7 48 56 208zm88 105.4l0-25.4 48 0 0 25.4c0 17-6.7 32-16.2 42.9C165.7 368 144 398.1 144 432c0 12.2 3.7 23.1 8.4 31.9c.6 .1 1.3 .1 2.1 .1l139 0c.8 0 1.5-.1 2.1-.1c4.6-8.8 8.4-19.7 8.4-31.9c0-32.3-22.1-63.8-32.6-76.4c-9.2-10.9-15.4-25.6-15.4-42l0-25.6 48 0 0 25.6c0 4.1 1.6 8 4.2 11.2c11.7 14 43.8 56.9 43.8 107.2c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3l-139 0c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-51.9 31.6-93.4 43.5-107.1c2.8-3.2 4.5-7.3 4.5-11.5z',
  ],
};
const faAirplay = {
  prefix: 'far',
  iconName: 'airplay',
  icon: [
    576,
    512,
    [],
    'e089',
    'M480 80L96 80c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l53.5 0-34.7 34.7c-4 4-7.4 8.5-10.2 13.3L96 416c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 192c0 53-43 96-96 96l-8.6 0c-2.8-4.8-6.2-9.2-10.2-13.3L426.5 368l53.5 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48zM198.6 432l178.7 0L288 342.6 198.6 432zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0z',
  ],
};
const faHandFist = {
  prefix: 'far',
  iconName: 'hand-fist',
  icon: [
    448,
    512,
    [9994, 'fist-raised'],
    'f6de',
    'M112 80c8.8 0 16 7.2 16 16l0 80-16 0c-5.5 0-10.8 .6-16 1.6L96 96c0-8.8 7.2-16 16-16zm0 144l40 0 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.2 0 10.2-.6 15-1.8c-4.4 32.4-23.8 60.1-51.1 75.9c-7.4 4.3-12 12.2-12 20.8L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-108.1c38.7-27.5 64-72.8 64-123.9l0-48 0-16 0-32c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C239.2 14.7 217.3 0 192 0s-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4C76.7 32 48 60.7 48 96l0 104c0 2.3 .3 4.6 1 6.7C38.3 220.3 32 237.4 32 256c0 64.2 39.8 119 96 141.3l0 90.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-108c0-11-7.4-20.5-18-23.2C113.1 345.2 80 304.4 80 256c0-17.7 14.3-32 32-32zm256-32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zM176 176l0-80 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 80 0 2c-5.1-1.3-10.5-2-16-2l-16 0zm80 0l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
  ],
};
const faFistRaised = faHandFist;
const faShieldQuartered = {
  prefix: 'far',
  iconName: 'shield-quartered',
  icon: [
    512,
    512,
    [],
    'e575',
    'M73 127c-5.9 2.5-9.1 7.8-9 12.8c.1 17.9 1.6 38.4 5.1 60.3L232 200l0-140.4L73 127zm6.7 121c20.9 73.9 65.9 153.7 152.3 202.3L232 248 79.7 248zM280 248l0 202.4C366.4 401.8 411.4 322 432.3 248L280 248zm162.9-48c3.5-21.9 5-42.3 5.1-60.3c0-5-3.1-10.2-9-12.8L280 59.6 280 200l162.9 0zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z',
  ],
};
const faSlashForward = {
  prefix: 'far',
  iconName: 'slash-forward',
  icon: [
    320,
    512,
    [],
    '2f',
    'M308.1 3.3c11.4 6.7 15.3 21.4 8.6 32.8l-272 464c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9l272-464C282 .4 296.7-3.4 308.1 3.3z',
  ],
};
const faLocationPen = {
  prefix: 'far',
  iconName: 'location-pen',
  icon: [
    384,
    512,
    ['map-marker-edit'],
    'f607',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z',
  ],
};
const faMapMarkerEdit = faLocationPen;
const faCloudMoon = {
  prefix: 'far',
  iconName: 'cloud-moon',
  icon: [
    640,
    512,
    [],
    'f6c3',
    'M495.8 0C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c58.8 1.4 106.4 48.2 109.2 106.7c22.8 10.8 41.4 29.1 52.6 51.7c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7zM128.1 320c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0l-266.9 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 329 .1 368.5 .1 416c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1l266 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9c-17.3-25.3-46.3-41.9-79.3-41.9z',
  ],
};
const faPotFood = {
  prefix: 'far',
  iconName: 'pot-food',
  icon: [
    640,
    512,
    [127858],
    'e43f',
    'M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80l-214.7 0c13.8-46.3 56.6-80 107.4-80zM16 280c0-13.3 10.7-24 24-24l26.7 0c6.6-18.6 24.4-32 45.3-32l416 0c20.9 0 38.7 13.4 45.3 32l26.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-26.3 0c-11 76.9-61.1 141.2-129.5 172.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C127.3 445.2 77.3 380.9 66.3 304L40 304c-13.3 0-24-10.7-24-24zM240.5 458.9c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C485.6 404.8 528 343.3 528 272l-416 0c0 71.3 42.4 132.8 103.5 160.5c11.5 5.2 20.4 14.7 25 26.4z',
  ],
};
const faBriefcase = {
  prefix: 'far',
  iconName: 'briefcase',
  icon: [
    512,
    512,
    [128188],
    'f0b1',
    'M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 120 0 136c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-144 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L48 304zm144-48l128 0 144 0 0-96c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0z',
  ],
};
const faPersonFalling = {
  prefix: 'far',
  iconName: 'person-falling',
  icon: [
    512,
    512,
    [],
    'e546',
    'M320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 10.4c0 46.1-28.9 87.3-72.2 103.1C137.5 160.1 96 219.3 96 285.6L96 360c0 13.3 10.7 24 24 24s24-10.7 24-24l0-74.4c0-10.7 1.5-21.1 4.4-30.9L307.9 501c7.2 11.1 22.1 14.3 33.2 7.1s14.3-22.1 7.1-33.2L263.6 344.3 327 304l46.3 0 64.8 72.1c8.9 9.9 24 10.6 33.9 1.8s10.6-24 1.8-33.9l-67.2-74.7c-7.6-8.4-18.4-13.2-29.7-13.2l-56.6 0-.6 0-19 0-58.2-85.9c47.4-28 77.5-79.3 77.5-135.8L320 24zM263.9 287.2L237.5 304l-61.8-95.5c6.7-6.8 14.4-12.8 22.8-17.7l65.4 96.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
};
const faImagePortrait = {
  prefix: 'far',
  iconName: 'image-portrait',
  icon: [
    384,
    512,
    ['portrait'],
    'f3e0',
    'M320 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16zm0-48c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0C92.3 384 80 371.7 80 356.6z',
  ],
};
const faPortrait = faImagePortrait;
const faUserTag = {
  prefix: 'far',
  iconName: 'user-tag',
  icon: [
    640,
    512,
    [],
    'f507',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM398.7 464c-.5-3.4-1.1-6.7-1.8-10l45.6 45.6c-5.4 7.5-14.2 12.5-24.2 12.5L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c17.5 0 34.3 2.5 50.3 7.2l0 33c0 6.4 .8 12.7 2.3 18.8c-16.1-7.1-33.9-11-52.6-11l-91.4 0c-65.7 0-120.1 48.7-129 112l349.5 0zM384 224l82.7 0c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3l0-82.7c0-17.7 14.3-32 32-32zm72 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faRug = {
  prefix: 'far',
  iconName: 'rug',
  icon: [
    640,
    512,
    [],
    'e569',
    'M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 24 0 480 0 24 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0-24 0L80 64 56 64 24 64zm56 48l48 0 0 288-48 0 0-64 0-80 0-80 0-64zM464 400l-288 0 0-288 288 0 0 288zm48 0l0-288 48 0 0 64 0 80 0 80 0 64-48 0z',
  ],
};
const faPrintSlash = {
  prefix: 'far',
  iconName: 'print-slash',
  icon: [
    640,
    512,
    [],
    'f686',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400l1.4 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64l-234.8 0L176 112.6 176 64c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM338.5 240L512 240c8.8 0 16 7.2 16 16l0 96-16 0-16 0-14.6 0L338.5 240zm-155.7 0l-60.6-47.7C89.6 195.2 64 222.6 64 256l0 112c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c15.5 0 28.5-11 31.4-25.7L448 449l0 15-256 0 0-96 153.2 0-60.9-48L176 320c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l54.8 0z',
  ],
};
const faEarthEurope = {
  prefix: 'far',
  iconName: 'earth-europe',
  icon: [
    512,
    512,
    ['globe-europe'],
    'f7a2',
    'M256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c3.5 0 6.9 .1 10.3 .3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c-4.1 12.6-9.3 24.7-15.6 36.1c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c-5.6 .5-11.4 .7-17.1 .7zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z',
  ],
};
const faGlobeEurope = faEarthEurope;
const faCartFlatbedSuitcase = {
  prefix: 'far',
  iconName: 'cart-flatbed-suitcase',
  icon: [
    640,
    512,
    ['luggage-cart'],
    'f59d',
    'M0 24C0 10.7 10.7 0 24 0L72 0c30.9 0 56 25.1 56 56l0 352c0 4.4 3.6 8 8 8l72 0 288 0 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-192 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-24 0c-30.9 0-56-25.1-56-56L80 56c0-4.4-3.6-8-8-8L24 48C10.7 48 0 37.3 0 24zM360 48c-4.4 0-8 3.6-8 8l0 40 96 0 0-40c0-4.4-3.6-8-8-8l-80 0zM496 96l48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l48 0 0-40c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 40zM256 144c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0 0-160-32 0zm80 0l0 160 128 0 0-160-128 0zM544 304c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-32 0 0 160 32 0z',
  ],
};
const faLuggageCart = faCartFlatbedSuitcase;
const faHandBackPointRibbon = {
  prefix: 'far',
  iconName: 'hand-back-point-ribbon',
  icon: [
    448,
    512,
    [],
    'e1a0',
    'M96 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32 0 64 0 .5c2.6-.3 5.3-.5 8-.5c24.5 0 45.7 13.7 56.5 33.9c5-1.2 10.2-1.9 15.5-1.9c23.9 0 44.8 13.1 55.7 32.5c2.7-.3 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64l0 96 0 8c0 66.3-53.7 120-120 120l-125.4 0c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5l0-10.2c0-24.8 10.5-48.4 28.8-65.1l20.3-18.4c4.8-4.3 9.7-8.3 14.9-11.9L96 176l-52.2 0c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 128 37.1 101.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 85.3 37.3 80 43.8 80L96 80l0-16zm48 112l0 88 0 2 0 78c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-42.5L93.1 318.7C84.8 326.3 80 337 80 348.3l0 10.2c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2L312 464c39.8 0 72-32.2 72-72l0-8 0-96c0-8.8-7.2-16-16-16c-3.6 0-6.9 1.2-9.6 3.2c-7.3 5.5-17 6.3-25.1 2.3s-13.3-12.4-13.3-21.5c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8l0-8c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8l0-24-32 0zm32-96l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 32 0z',
  ],
};
const faRectangleXmark = {
  prefix: 'far',
  iconName: 'rectangle-xmark',
  icon: [
    512,
    512,
    [62164, 'rectangle-times', 'times-rectangle', 'window-close'],
    'f410',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
};
const faRectangleTimes = faRectangleXmark;
const faTimesRectangle = faRectangleXmark;
const faWindowClose = faRectangleXmark;
const faTireRugged = {
  prefix: 'far',
  iconName: 'tire-rugged',
  icon: [
    512,
    512,
    [],
    'f634',
    'M213.1 62c1-8 7.8-14 15.9-14l54.1 0c8.1 0 14.9 6 15.9 14c1.2 9.1 7.4 16.8 16.1 19.7c7.7 2.6 15.2 5.7 22.4 9.3c8.2 4.1 18.1 3.1 25.3-2.5c6.3-4.9 15.4-4.4 21.1 1.3l38.3 38.3c5.7 5.7 6.3 14.8 1.3 21.1c-5.6 7.3-6.6 17.1-2.5 25.3c3.6 7.2 6.7 14.7 9.3 22.4c2.9 8.7 10.6 15 19.7 16.1c8 1 14 7.8 14 15.9l0 54.1c0 8.1-6 14.9-14 15.9c-9.1 1.2-16.8 7.4-19.7 16.1c-2.6 7.7-5.7 15.2-9.3 22.4c-4.1 8.2-3.1 18.1 2.5 25.3c4.9 6.3 4.4 15.4-1.3 21.1l-38.3 38.3c-5.7 5.7-14.8 6.3-21.1 1.3c-7.3-5.6-17.1-6.6-25.3-2.5c-7.2 3.6-14.7 6.7-22.4 9.3c-8.7 2.9-15 10.6-16.1 19.7c-1 8-7.8 14-15.9 14l-54.1 0c-8.1 0-14.9-6-15.9-14c-1.2-9.1-7.4-16.8-16.1-19.7c-7.7-2.6-15.2-5.7-22.4-9.3c-8.2-4.1-18.1-3.1-25.3 2.5c-6.3 4.9-15.4 4.4-21.1-1.3L89.8 383.9c-5.7-5.7-6.3-14.8-1.3-21.1c5.6-7.3 6.6-17.1 2.5-25.3c-3.6-7.2-6.7-14.7-9.3-22.4c-2.9-8.7-10.6-15-19.7-16.1c-8-1-14-7.8-14-15.9l0-54.1c0-8.1 6-14.9 14-15.9c9.1-1.2 16.8-7.4 19.7-16.1c2.6-7.7 5.7-15.2 9.3-22.4c4.1-8.2 3.1-18.1-2.5-25.3c-4.9-6.3-4.4-15.4 1.3-21.1l38.3-38.3c5.7-5.7 14.8-6.3 21.1-1.3c7.3 5.6 17.1 6.6 25.3 2.5c7.2-3.6 14.7-6.7 22.4-9.3c8.7-2.9 15-10.6 16.1-19.7zM228.9 0C202 0 178.6 16.7 169.3 40.8c-1.4 .6-2.8 1.1-4.2 1.7c-23.6-10.4-51.9-5.7-71 13.4L55.8 94.1c-19 19-23.7 47.4-13.4 71c-.6 1.4-1.2 2.8-1.7 4.2C16.7 178.6 0 202 0 228.9l0 54.1c0 26.9 16.7 50.3 40.8 59.6c.6 1.4 1.1 2.8 1.7 4.2c-10.4 23.6-5.7 51.9 13.4 71l38.3 38.3c19 19 47.4 23.7 71 13.4c1.4 .6 2.8 1.2 4.2 1.7c9.4 24 32.7 40.8 59.6 40.8l54.1 0c26.9 0 50.3-16.7 59.6-40.8c1.4-.6 2.8-1.1 4.2-1.7c23.6 10.4 51.9 5.7 71-13.4l38.3-38.3c19-19 23.7-47.4 13.4-71c.6-1.4 1.2-2.8 1.7-4.2c24-9.4 40.8-32.7 40.8-59.6l0-54.1c0-26.9-16.7-50.3-40.8-59.6c-.6-1.4-1.1-2.8-1.7-4.2c10.4-23.6 5.7-51.9-13.4-71L417.9 55.8c-19-19-47.4-23.7-71-13.4c-1.4-.6-2.8-1.2-4.2-1.7C333.4 16.7 310 0 283.1 0L228.9 0zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1 -45.7-14.8zm152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1 -14.8-45.7zm-4.6 122.7a24 24 0 1 1 -28.2-38.8 24 24 0 1 1 28.2 38.8zm-79.3-5.3a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2z',
  ],
};
const faLightbulbDollar = {
  prefix: 'far',
  iconName: 'lightbulb-dollar',
  icon: [
    384,
    512,
    [],
    'f670',
    'M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zm16-400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4z',
  ],
};
const faCowbell = {
  prefix: 'far',
  iconName: 'cowbell',
  icon: [
    448,
    512,
    [],
    'f8b3',
    'M176 48l96 0 0 48-96 0 0-48zm-48-8l0 56-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l352 0c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96l-16 0 0-56c0-22.1-17.9-40-40-40L168 0c-22.1 0-40 17.9-40 40zM112 144l224 0 64 224L48 368l64-224zM288 448l-128 0c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faBahtSign = {
  prefix: 'far',
  iconName: 'baht-sign',
  icon: [
    320,
    512,
    [],
    'e0ac',
    'M136 0c-13.3 0-24 10.7-24 24l0 40L37.6 64C16.8 64 0 80.8 0 101.6L0 232l0 41.7L0 280 0 406.3c0 23 18.7 41.7 41.7 41.7l70.3 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 52 0c59.6 0 108-48.4 108-108c0-42.1-24.1-78.5-59.2-96.4C277.7 224.6 288 199.5 288 172c0-59.6-48.4-108-108-108l-20 0 0-40c0-13.3-10.7-24-24-24zM112 112l0 120-64 0 0-120 64 0zm48 120l0-120 20 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-20 0zm-48 48l0 120-64 0 0-120 64 0zm48 120l0-120 20 0 32 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-52 0z',
  ],
};
const faCorner = {
  prefix: 'far',
  iconName: 'corner',
  icon: [
    448,
    512,
    [],
    'e3fe',
    'M0 184c0-13.3 10.7-24 24-24l368 0c30.9 0 56 25.1 56 56l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-4.4-3.6-8-8-8L24 208c-13.3 0-24-10.7-24-24z',
  ],
};
const faChevronsRight = {
  prefix: 'far',
  iconName: 'chevrons-right',
  icon: [
    512,
    512,
    ['chevron-double-right'],
    'f324',
    'M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
  ],
};
const faChevronDoubleRight = faChevronsRight;
const faBookOpen = {
  prefix: 'far',
  iconName: 'book-open',
  icon: [
    576,
    512,
    [128214, 128366],
    'f518',
    'M156 32C100.6 32 48.8 46.6 27.1 53.6C10.3 59 0 74.5 0 91.1L0 403.5c0 26.1 24 44.2 48 40.2c19.8-3.3 54.8-7.7 100-7.7c54 0 97.5 25.5 112.5 35.6c7.5 5 16.8 8.4 27 8.4c11.5 0 21.6-4.2 29.3-9.9C330.2 460.3 369.1 436 428 436c47.7 0 80.5 4 99 7.2c23.9 4.1 49-13.8 49-40.6l0-311.5c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7c-12.8 3.2-23.5 6.3-30.9 8.7c-1.3 .4-2.6 .8-3.7 1.2c-1.1-.4-2.4-.8-3.7-1.2c-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zM264 97.3l0 320.6C238 404.2 196.8 388 148 388c-42.9 0-77.4 3.7-100 7.1L48 97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3c8.6 2.1 16.1 4.2 22.1 6zm48 319.2l0-319.2c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3l0 297.4c-21.7-3.3-54.9-6.7-100-6.7c-51.4 0-90.8 15-116 28.6z',
  ],
};
const faBookJournalWhills = {
  prefix: 'far',
  iconName: 'book-journal-whills',
  icon: [
    448,
    512,
    ['journal-whills'],
    'f66a',
    'M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM148.8 190.5c3.4 3.4 8.9 3.4 12.3 0s3.4-8.9 0-12.3l-28.8-28.9c8.2-17 20.2-31.8 35-43.4c3.9-3.1 9.3 1.9 7.9 6.7c-6.9 23.5-.9 49.4 16.5 67.2c3.3 3.4 3.6 8.8 .9 12.6c-11 15.4-14.4 35.2-8.7 53.5c6.4 21.1 24 37.2 45.7 41.7L231 252l-11.3 7.8c-.7 .4-1.6 .7-2.5 .7c-1.1 0-2.2-.4-3-1.1c-.8-1-1.4-2-1.4-3.3c0-.7 .3-1.5 .5-2.2l9.4-15.5-19.6-4.1c-1.9-.4-3.4-2.3-3.4-4.4s1.5-3.8 3.4-4.2l19.6-4.1L213.4 206c-1-1.8-.7-4.1 .8-5.5s3.8-1.6 5.5-.4l13.1 8.9 5-120.8c.1-2.5 2-4.2 4.4-4.2s4.2 1.8 4.4 4.2l5.2 122.5 15.4-10.5c.6-.5 1.5-.7 2.3-.8l.1 0c1.6 0 3 .8 3.8 2.2s.7 3.1-.1 4.5L264 221.6l19.6 4.1c1.9 .4 3.4 2.2 3.4 4.2s-1.5 4-3.4 4.4l-19.6 4 9.3 15.7c.8 1.4 1 3 .1 4.4s-2.2 2.2-3.8 2.2c-.8 0-1.8-.3-2.5-.7l-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.7c5.7-18.3 2.3-38.2-8.7-53.5c-2.8-3.8-2.4-9.3 .9-12.7c17.4-17.9 23.4-43.8 16.4-67.3c-1.4-4.8 4-9.7 7.9-6.7c14.8 11.5 26.8 26.4 35 43.5l-28.8 28.9c-3.4 3.4-3.4 8.9 0 12.3s8.9 3.4 12.3 0l23.2-23.2c3.3 11 5.6 22.5 5.6 34.5c0 .3 0 .5-.1 .8s-.1 .5-.1 .8l-40.5 35.5c-1.8 1.8-2.9 4.1-3 6.5c.1 2 .8 4.1 2.2 5.7c1.8 1.8 4.1 2.9 6.5 3c2.2 0 4.2-.8 5.7-2.2L361 229.5C348.3 283.6 300.1 324 242.2 324s-106.1-40.4-118.8-94.5L149.2 252c1.6 1.4 3.7 2 5.7 2.2c3.7 0 6.8-2.3 8.2-5.6c1.2-3.4 .3-7.4-2.5-9.7l-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5l23.2 23.2z',
  ],
};
const faJournalWhills = faBookJournalWhills;
const faInhaler = {
  prefix: 'far',
  iconName: 'inhaler',
  icon: [
    576,
    512,
    [],
    'f5f9',
    'M429.8 32.7l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248 386.9 101.6l14-51.8c3.4-12.6 16.3-20.2 29-17zM389 216.9l-2.1 7.8C379.4 252.6 354 272 325.1 272L240 272l0 160 209.9 0 33-121.2-94-94zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480l-224 0c-22.1 0-40-17.9-40-40l0-176c0-22.1 17.9-40 40-40l93.1 0c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM0 256a32 32 0 1 1 64 0A32 32 0 1 1 0 256zm0 96a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faHandcuffs = {
  prefix: 'far',
  iconName: 'handcuffs',
  icon: [
    640,
    512,
    [],
    'e4f8',
    'M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32zm0 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 352c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32s32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm240 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faSnake = {
  prefix: 'far',
  iconName: 'snake',
  icon: [
    512,
    512,
    [128013],
    'f716',
    'M305.6 96l-22.7 0L168 96C110.6 96 64 142.6 64 200s46.6 104 104 104l152 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-63.9 0c0 0 0 0-.1 0c0 0 0 0 0 0l-137.3 0c-7.5 0-14.8 1.7-21.5 5.1L75.3 448l21.9 10.9c6.7 3.3 14 5.1 21.5 5.1l57.2 0c0 0 0 0 .1 0c0 0 .1 0 .1 0c0 0 0 0 .1 0L320 464c53 0 96-43 96-96s-43-96-96-96l-152 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l114.9 0 22.7 0L320 145.5c11.6 14.1 29 22.5 47.6 22.5c9 0 17.9-2 26.1-5.8l54.4-25.4c9.6-4.5 15.8-14.2 15.8-24.8s-6.2-20.3-15.8-24.8L393.8 61.8C385.6 58 376.7 56 367.7 56c-18.6 0-36 8.4-47.6 22.5L305.6 96zM176 512l-.1 0-57.2 0c-14.9 0-29.6-3.5-42.9-10.1L14.3 471.2C5.5 466.8 0 457.8 0 448s5.5-18.8 14.3-23.2l61.4-30.7c6.5-3.3 13.3-5.7 20.4-7.4c7.4-1.8 14.9-2.7 22.6-2.7l49.3 0 88 0 .1 0 36.2 0 27.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-27.7 0-36.1 0c0 0 0 0 0 0s0 0-.1 0s0 0 0 0l-88 0c-17.3 0-33.9-2.9-49.3-8.2c-5.7-2-11.3-4.2-16.7-6.8c-50.9-24.6-86-76.7-86-137C16 116.1 84.1 48 168 48l114.9 0c20.6-25.1 51.6-40 84.7-40c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-49.6 23.1-4.9 2.3c-14.5 6.8-30.4 10.3-46.4 10.3c-16.8 0-33-3.8-47.7-10.9c-14.2-6.9-26.9-16.7-37.1-29.1L168 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.7 0 20.2 0 37.1 0c16.7 0 32.7 2.8 47.7 8.1c16.5 5.8 31.6 14.5 44.7 25.5C443.9 283.9 464 323.6 464 368c0 79.5-64.5 144-144 144l-144 0zM352 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faTriangleExclamation = {
  prefix: 'far',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    [9888, 'exclamation-triangle', 'warning'],
    'f071',
    'M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z',
  ],
};
const faExclamationTriangle = faTriangleExclamation;
const faWarning = faTriangleExclamation;
const faNoteMedical = {
  prefix: 'far',
  iconName: 'note-medical',
  icon: [
    448,
    512,
    [],
    'e200',
    'M384 80c8.8 0 16 7.2 16 16l0 224-80 0c-17.7 0-32 14.3-32 32l0 80L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 480l224 0 5.5 0c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3l0-5.5 0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64zM192 144l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faDatabase = {
  prefix: 'far',
  iconName: 'database',
  icon: [
    448,
    512,
    [],
    'f1c0',
    'M400 86l0 88.7c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 203 269.5 208 224 208s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7L48 86l.6-.5C53.9 81 64.5 74.8 81.8 68.6C115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6 .5zm0 141.5l0 75.2c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 331 269.5 336 224 336s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7l0-75.2c13.3 5.3 27.9 9.9 43.3 13.7C129.5 250.6 175.2 256 224 256s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7zM48 426l0-70.4c13.3 5.3 27.9 9.9 43.3 13.7C129.5 378.6 175.2 384 224 384s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7l0 70.4-.6 .5c-5.3 4.5-15.9 10.7-33.2 16.9C332.1 455.5 281.8 464 224 464s-108.1-8.5-142.2-20.6c-17.3-6.2-27.8-12.4-33.2-16.9L48 426zm354.1-2.1s0 .1-.2 .2l.1-.2c0 0 0 0 0-.1zm-356.1 0s0 .1 .2 .2c-.1-.1-.1-.2-.2-.2zm0-335.8s.1-.1 .2-.2c-.1 .1-.2 .2-.2 .2zm356-.2c.1 .1 .2 .2 .2 .2s0-.1-.2-.2zM448 432l0-352C448 35.8 347.7 0 224 0S0 35.8 0 80L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80z',
  ],
};
const faDownLeft = {
  prefix: 'far',
  iconName: 'down-left',
  icon: [
    384,
    512,
    [],
    'e16a',
    'M64 384l0-193.4c0-1.7 .8-3.2 2.1-4.2c2.1-1.6 5-1.4 6.9 .5L127 241c9.4 9.4 24.6 9.4 33.9 0L285.7 116.3c2.7-2.7 6.5-4.3 10.3-4.3s7.6 1.5 10.3 4.3l25.4 25.4c2.7 2.7 4.3 6.5 4.3 10.3s-1.5 7.6-4.3 10.3L207 287c-9.4 9.4-9.4 24.6 0 33.9L261.1 375c1.8 1.8 2.1 4.8 .5 6.9c-1 1.3-2.5 2.1-4.2 2.1L64 384zm-48 8c0 22.1 17.9 40 40 40l201.4 0c16.8 0 32.5-7.9 42.6-21.3c15.9-21.2 13.8-50.9-4.9-69.6L257.9 304 365.7 196.3C377.4 184.5 384 168.6 384 152s-6.6-32.5-18.3-44.3L340.3 82.4C328.5 70.6 312.6 64 296 64s-32.5 6.6-44.3 18.3L144 190.1 106.9 153c-18.7-18.7-48.4-20.8-69.6-5C23.9 158.1 16 173.9 16 190.6L16 392z',
  ],
};
const faShare = {
  prefix: 'far',
  iconName: 'share',
  icon: [
    512,
    512,
    ['mail-forward'],
    'f064',
    'M288 240l-96 0c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128l112 0 24 0c13.3 0 24-10.7 24-24l0-24 0-28.1L456.1 208 336 316.1l0-28.1 0-24c0-13.3-10.7-24-24-24l-24 0zm0 48l0 48 0 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2l0 16 0 48-48 0-64 0C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96l48 0 48 0z',
  ],
};
const faMailForward = faShare;
const faFaceThinking = {
  prefix: 'far',
  iconName: 'face-thinking',
  icon: [
    512,
    512,
    [],
    'e39b',
    'M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352l0 28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8 .2 7.7 .3 11.6 .3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352l0 48.4 167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1 .4-.3 .8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6L112 512c-26.5 0-48-21.5-48-48l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faTurnDownRight = {
  prefix: 'far',
  iconName: 'turn-down-right',
  icon: [
    512,
    512,
    [],
    'e455',
    'M505.5 271.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-41.7-144 0C71.6 360 0 288.4 0 200L0 88C0 57.1 25.1 32 56 32l32 0c30.9 0 56 25.1 56 56l0 120c0 4.4 3.6 8 8 8l152 0 0-41.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 178.5l0 61.5c0 13.3-10.7 24-24 24l-176 0c-30.9 0-56-25.1-56-56L96 88c0-4.4-3.6-8-8-8L56 80c-4.4 0-8 3.6-8 8l0 112c0 61.9 50.1 112 112 112l168 0c13.3 0 24 10.7 24 24l0 61.5L455 288 352 178.5z',
  ],
};
const faBottleDroplet = {
  prefix: 'far',
  iconName: 'bottle-droplet',
  icon: [
    320,
    512,
    [],
    'e4c4',
    'M128 48l0 104.2c0 16-8 31-21.3 39.9C80.9 209.4 64 238.8 64 272l0 176c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-176c0-33.2-16.9-62.6-42.7-79.9C200 183.2 192 168.3 192 152.2L192 48l-64 0zM256 24c0 10.4-6.7 19.3-16 22.6l0 105.6c38.6 25.8 64 69.8 64 119.8l0 176c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64l0-176c0-49.9 25.4-93.9 64-119.8L80 46.6C70.7 43.3 64 34.5 64 24C64 10.7 74.7 0 88 0L232 0c13.3 0 24 10.7 24 24zM160 384c-26.5 0-48-21.5-48-48c0-22.2 23-52 37.2-68.2c5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48z',
  ],
};
const faMaskFace = {
  prefix: 'far',
  iconName: 'mask-face',
  icon: [
    640,
    512,
    [],
    'e1d7',
    'M320 112c17.7 0 35 5.2 49.8 15.1l37.1 24.8c23.7 15.8 51.4 24.2 79.9 24.2l9.2 0 0 48c0 59.5-29.5 112.1-74.7 143.9l-3.1 .8 .3 1.2c-28.1 19-62 30.1-98.5 30.1s-70.4-11.1-98.5-30.1l.3-1.2-3.1-.8C173.5 336.1 144 283.5 144 224l0-48 9.2 0c28.4 0 56.2-8.4 79.9-24.2l37.1-24.8c14.7-9.8 32-15.1 49.8-15.1zM96 224c0 45.1 13.4 87.2 36.3 122.3l-29.8-7.4C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l40 0 0 48zM90.9 385.5l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-72 0-16 0-9.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1l-9.2 0-16 0-72 0c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4zm446.6-46.6l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3l0-48 40 0c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-16 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
  ],
};
const faHillRockslide = {
  prefix: 'far',
  iconName: 'hill-rockslide',
  icon: [
    576,
    512,
    [],
    'e508',
    'M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm124.4 71.8c-2.7-4.9-2.7-10.8 0-15.7l27-48c2.8-5 8.2-8.2 13.9-8.2l53.3 0c5.8 0 11.1 3.1 13.9 8.2l27 48c2.7 4.9 2.7 10.8 0 15.7l-27 48c-2.8 5-8.2 8.2-13.9 8.2l-53.3 0c-5.8 0-11.1-3.1-13.9-8.2l-27-48zM48 145.9L48 440c0 13.3 10.7 24 24 24l294.1 0L48 145.9zM0 126.6C0 91 43.1 73.1 68.3 98.3L413.7 443.7c25.2 25.2 7.4 68.3-28.3 68.3L72 512c-39.8 0-72-32.2-72-72L0 126.6zm504.2 277l-48-27c-5-2.8-8.2-8.2-8.2-13.9l0-53.3c0-5.8 3.1-11.1 8.2-13.9l48-27c4.9-2.7 10.8-2.7 15.7 0l48 27c5 2.8 8.2 8.2 8.2 13.9l0 53.3c0 5.8-3.1 11.1-8.2 13.9l-48 27c-4.9 2.7-10.8 2.7-15.7 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faScannerKeyboard = {
  prefix: 'far',
  iconName: 'scanner-keyboard',
  icon: [
    512,
    512,
    [],
    'f489',
    'M128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zM384 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-13.3-10.7-24-24-24zM64 144l224 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 80c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-144 0zM96 304c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0zM80 400l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm128-96c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0zm-16 96l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faCircleO = {
  prefix: 'far',
  iconName: 'circle-o',
  icon: [
    512,
    512,
    [],
    'e119',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-256a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z',
  ],
};
const faGridHorizontal = {
  prefix: 'far',
  iconName: 'grid-horizontal',
  icon: [
    448,
    512,
    [],
    'e307',
    'M40 168l0 48 48 0 0-48-48 0zM0 168c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM40 328l0 48 48 0 0-48-48 0zM0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM248 168l-48 0 0 48 48 0 0-48zm-48-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 200l0 48 48 0 0-48-48 0zm-40 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM408 168l-48 0 0 48 48 0 0-48zm-48-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 200l0 48 48 0 0-48-48 0zm-40 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48z',
  ],
};
const faMessageDollar = {
  prefix: 'far',
  iconName: 'message-dollar',
  icon: [
    512,
    512,
    ['comment-alt-dollar'],
    'f650',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
  ],
};
const faCommentAltDollar = faMessageDollar;
const faRightLeft = {
  prefix: 'far',
  iconName: 'right-left',
  icon: [
    512,
    512,
    ['exchange-alt'],
    'f362',
    'M336 215c0 22.6 18.3 41 41 41c10.9 0 21.3-4.3 29-12l99-99c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17l-99-99c-7.7-7.7-18.1-12-29-12c-22.6 0-41 18.3-41 41l0 63L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l312 0 0 63zm118.1-87L384 198.1l0-140.1L454.1 128zM135 256c-10.9 0-21.3 4.3-29 12L7 367c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l99 99c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41l0-63 312 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-312 0 0-63c0-22.6-18.3-41-41-41zm-7 198.1L57.9 384 128 313.9l0 140.1z',
  ],
};
const faExchangeAlt = faRightLeft;
const faColumns3 = {
  prefix: 'far',
  iconName: 'columns-3',
  icon: [
    640,
    512,
    [],
    'e361',
    'M448 80l0 352 128 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L448 80zm-48 0L240 80l0 352 160 0 0-352zM192 432l0-352L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l128 0zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
  ],
};
const faPaperPlane = {
  prefix: 'far',
  iconName: 'paper-plane',
  icon: [
    512,
    512,
    [61913],
    'f1d8',
    'M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z',
  ],
};
const faRoadCircleExclamation = {
  prefix: 'far',
  iconName: 'road-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e565',
    'M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
  ],
};
const faDungeon = {
  prefix: 'far',
  iconName: 'dungeon',
  icon: [
    512,
    512,
    [],
    'f6d9',
    'M256 128c-6.9 0-13.7 .5-20.4 1.4l-.2 0c-7.8 1-15.6-3-18.5-10.3l-.7-1.8L199 74.3l-.2-.5c-3-7.6 .2-16.2 7.2-19.5c.9-.4 1.9-.8 2.9-1C224.1 49.8 239.8 48 256 48s31.9 1.8 47.1 5.3c1 .2 2 .6 2.9 1c7 3.3 10.3 11.9 7.2 19.5l-.2 .5-17.2 43.1-.7 1.8c-2.9 7.3-10.7 11.3-18.5 10.3l-.2 0c-6.6-.9-13.4-1.4-20.4-1.4zM96 512l32 0 256 0 32 0 32 0c35.3 0 64-28.7 64-64l0-40c0-11.7-3.1-22.6-8.6-32c5.4-9.4 8.6-20.3 8.6-32l0-40c0-11.7-3.1-22.6-8.6-32c5.8-10.2 8.9-22.3 7.8-35.6c-2.2-28.6-9.1-56-19.9-81.2c-6.1-14.3-16.2-24.5-28-30.6c-.6-13.3-5.5-26.7-15.8-38.3c-16.8-18.9-36.4-35.4-58.1-48.7c-13.2-8.1-27.3-10.6-40.5-8.8c-8.2-10.5-20-18.7-35.1-22.1C295.2 2.3 275.9 0 256 0s-39.2 2.3-57.9 6.6C183 10.1 171.2 18.2 163 28.7c-13.2-1.8-27.3 .7-40.5 8.8C100.8 50.8 81.2 67.3 64.4 86.2c-10.2 11.6-15.2 25-15.8 38.3c-11.8 6.2-21.9 16.3-28 30.6C9.8 180.4 2.9 207.8 .7 236.4c-1 13.3 2 25.4 7.8 35.6C3.1 281.4 0 292.3 0 304l0 40c0 11.7 3.1 22.6 8.6 32C3.1 385.4 0 396.3 0 408l0 40c0 35.3 28.7 64 64 64l32 0zM371.4 165.2c-6.4 4.3-14.8 3.3-20.7-1.6l-.2-.2c-5.5-4.8-11.4-9.2-17.6-13.1l-.2-.2c-6.3-4.2-9.6-11.8-7.7-19c.2-.6 .4-1.2 .6-1.8l17.2-43.1 .2-.5c3.2-7.4 11.4-11.1 18.7-8.6c1 .3 1.9 .8 2.8 1.3c17.7 10.8 33.6 24.2 47.2 39.6c.7 .8 1.3 1.7 1.8 2.6c3.8 6.7 1.5 15.4-5.2 19.9l-1.1 .8-32.6 21.7-3.2 2.1zm15.4 46.4l-.2-.4c-2.8-6.5-1.8-14 2.8-19c.9-.9 1.8-1.8 2.9-2.5l32.6-21.7c.4-.3 .8-.5 1.2-.7c6.8-3.8 15.3-2 19.6 4.1c.6 .8 1.1 1.7 1.5 2.7c8.8 20.5 14.4 42.7 16.2 66c0 .6 .1 1.2 0 1.9c-.4 7.9-7.2 14.1-15.4 14.1l-32 0-2.6 0c-7.8 0-14.3-5.7-16.4-13.2c-.1-.3-.2-.7-.2-1c-2.2-10.6-5.7-20.7-10.1-30.3zM400 304c0-.5 0-.9 .1-1.4c.6-7.3 6.2-13.3 13.4-14.4c.8-.1 1.7-.2 2.6-.2l32 0c8.1 0 14.9 6.1 15.9 14c.1 .7 .1 1.4 .1 2l0 40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14l-32 0c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2l0-40zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14l32 0c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2l0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40zM147.6 78.5c.9-.6 1.8-1 2.8-1.3c7.3-2.6 15.5 1.2 18.7 8.6l.2 .5 17.2 43.1c.2 .6 .4 1.2 .6 1.8c1.9 7.2-1.4 14.8-7.7 19l-.3 .2c-6.2 3.9-12.1 8.3-17.6 13.1l-.2 .2c-5.9 4.9-14.3 5.9-20.7 1.6l-3.2-2.1-32.6-21.7-1.1-.8c-6.7-4.5-9-13.2-5.2-19.9c.5-.9 1.1-1.8 1.8-2.6c13.7-15.4 29.6-28.8 47.2-39.6zM64.8 174.1c.4-1 .9-1.9 1.5-2.7c4.3-6.1 12.8-7.9 19.6-4.1c.4 .2 .8 .5 1.2 .7l32.6 21.7c1.1 .7 2.1 1.6 2.9 2.5c4.6 5 5.6 12.6 2.8 19l-.2 .4c-4.4 9.6-7.8 19.7-10.1 30.3c-.1 .3-.1 .7-.2 1c-2 7.5-8.6 13.2-16.4 13.2L96 256l-32 0c-8.2 0-15-6.2-15.4-14.1c0-.6 0-1.2 0-1.9c1.8-23.3 7.4-45.5 16.2-66zM48 304c0-.7 0-1.4 .1-2c1-7.9 7.7-14 15.9-14l32 0c.9 0 1.7 .1 2.6 .2c7.2 1.2 12.8 7.1 13.4 14.4c0 .5 .1 .9 .1 1.4l0 40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14l-32 0c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2l0-40zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14l32 0c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2l0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40zM272 192l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 32l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
};
const faHandHoldingBox = {
  prefix: 'far',
  iconName: 'hand-holding-box',
  icon: [
    576,
    512,
    [],
    'f47b',
    'M432 48l-80 0 0 73.7c0 3.5-2.8 6.3-6.3 6.3c-1.1 0-2.2-.3-3.1-.8l-46.6-26.6c-4.9-2.8-11-2.8-15.9 0l-46.6 26.6c-1 .5-2 .8-3.1 .8c-3.5 0-6.3-2.8-6.3-6.3L224 48l-80 0 0 160 288 0 0-160zm0-48c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48L96 48c0-26.5 21.5-48 48-48l80 0L352 0l80 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faInputText = {
  prefix: 'far',
  iconName: 'input-text',
  icon: [
    640,
    512,
    [],
    'e1bf',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7-75.5 0-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280l32.8 0L184 243.1zM304 184c0-13.3 10.7-24 24-24l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0c-13.3 0-24-10.7-24-24l0-8 0-64 0-64 0-8zm48 24l0 24 28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0zm0 96l44 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24z',
  ],
};
const faWindowFlip = {
  prefix: 'far',
  iconName: 'window-flip',
  icon: [
    512,
    512,
    ['window-alt'],
    'f40f',
    'M512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 48 0 16L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-16 0-48 0-64zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192zM416 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faWindowAlt = faWindowFlip;
const faAlignRight = {
  prefix: 'far',
  iconName: 'align-right',
  icon: [
    448,
    512,
    [],
    'f038',
    'M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24L184 88c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0zm24 152c0 13.3-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0c13.3 0 24 10.7 24 24zM424 424c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 472c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0z',
  ],
};
const faScannerGun = {
  prefix: 'far',
  iconName: 'scanner-gun',
  icon: [
    576,
    512,
    ['scanner'],
    'f488',
    'M112 80c-35.3 0-64 28.7-64 64s28.7 64 64 64l120.4 0 55.6 0 16 0 0-128L112 80zM79.1 251.1C33.3 237.1 0 194.4 0 144C0 82.1 50.1 32 112 32l192 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-44 0L144.3 454.4c-13.4 23-42.9 30.7-65.8 17.2L25 440.1C2.3 426.8-5.4 397.6 7.8 374.8L79.1 251.1zm52.6 4.9L49.4 398.8l53.5 31.4L204.4 256l-72.7 0zM440 32l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 216c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm24 216l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm16 144l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
  ],
};
const faScanner = faScannerGun;
const faTire = {
  prefix: 'far',
  iconName: 'tire',
  icon: [
    512,
    512,
    [],
    'f631',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 .9l39.2 12.8c.5-4.5 .8-9 .8-13.6c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5c0 .3 0 .6 0 .9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 373.6l0-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104L176 256.9c0-.3 0-.6 0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6 .3 9.2 .8 13.6zm93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 178l1.6 2.2zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336z',
  ],
};
const faEngine = {
  prefix: 'far',
  iconName: 'engine',
  icon: [
    640,
    512,
    [],
    'e16e',
    'M424 88c0 13.3-10.7 24-24 24l-72 0 0 32 68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-35.3 0-64-28.7-64-64l0-40-32 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 32 0 0-24c0-35.3 28.7-64 64-64l16 0 32 0 88 0 0-32-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c13.3 0 24 10.7 24 24zM288 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM172.8 336c14.6 0 28.4 6.6 37.5 18l32 40c3 3.8 7.6 6 12.5 6L448 400c8.8 0 16-7.2 16-16l0-141.7c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7L192 192l-32 0-16 0c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l28.8 0zM576 192l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32z',
  ],
};
const faMoneyBill1Wave = {
  prefix: 'far',
  iconName: 'money-bill-1-wave',
  icon: [
    576,
    512,
    ['money-bill-wave-alt'],
    'f53b',
    'M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7l0-176c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192l0 176c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM256 208c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faMoneyBillWaveAlt = faMoneyBill1Wave;
const faLifeRing = {
  prefix: 'far',
  iconName: 'life-ring',
  icon: [
    512,
    512,
    [],
    'f1cd',
    'M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
  ],
};
const faHands = {
  prefix: 'far',
  iconName: 'hands',
  icon: [
    576,
    512,
    ['sign-language', 'signing'],
    'f2a7',
    'M528 143.8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 37.4c0 10.9-7.3 20.4-17.8 23.2s-21.6-1.8-27-11.2L369.7 52c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9c0 0 0 0 0 .1l48 83.1c6.2 10.7 3.2 24.3-6.7 31.4c-15.1-14.3-32.3-26.5-51.5-36.1L314.3 84l-8-13.9c0 0 0 0 0-.1l-8-13.8c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9l8 13.9 8 13.9c0 0 0 0 0 .1l20.2 35-53-23.5c-22.8-10.1-47.6-9.8-69-1c4.1-12.6 12.8-23.9 25.2-31c3.8-2.2 7.7-3.9 11.7-5.1c-2.3-21.4 7.8-43.2 27.7-54.6s43.8-9.4 61.1 3.3c3.1-2.9 6.5-5.4 10.3-7.6C361.6-8 395.8 1.2 411.3 28l46.9 81.2c11.4-17.7 31.3-29.4 53.9-29.4c35.3 0 64 28.7 64 64l0 84.6c0 69.4-36.7 133.6-96.5 168.8c-10.4 6.1-21 11.1-31.9 15.1c8-19.2 13.3-39.9 15.4-61.4c40.5-27.4 65-73.2 65-122.4l0-84.6zm-353.9 13c15.1-32 53.2-45.7 85.2-30.7l56.4 26.5c36 16.9 65.4 43.7 85.7 76.1c19.6 29.4 30.7 64.4 30.7 101.2c0 1 0 2 0 3c0 1 0 2.1 0 3.1c0 1.2-.1 2.3-.2 3.4c-5 96.1-84.5 172.6-181.8 172.6L120 512c-30.9 0-56-25.1-56-56c0-4.4 .5-8.6 1.5-12.7C45.8 434.6 32 414.9 32 392c0-4.4 .5-8.6 1.5-12.7C13.8 370.6 0 350.9 0 328s13.8-42.6 33.5-51.3c-.9-4.1-1.5-8.3-1.5-12.7c0-30.9 25.1-56 56-56l84.7 0c-6.4-16-6.5-34.5 1.4-51.3zM72 320l-.2 0L56 320c-4.4 0-8 3.6-8 8s3.6 8 8 8l32 0 .2 0 95.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96.1 0c-4.4 0-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8l31.9 0 .2 0 63.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64.1 0c-4.4 .1-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8l129.9 0c72.3 0 131.3-57.3 134-128.9c0-.4 0-.9 .1-1.3l0-.5 0-.6 0-.3c0-.8 0-1.7 0-2.5c0-27.2-8.2-53.1-22.8-74.8c-.2-.2-.3-.5-.5-.7c-15.5-24.9-38-45.4-65.5-58.4l-56.4-26.5c-8-3.8-17.5-.3-21.3 7.7s-.3 17.5 7.7 21.3l25.1 11.8c10.2 4.8 15.7 16 13.2 27s-12.2 18.8-23.4 18.8L88 256c-4.4 0-8 3.6-8 8s3.6 8 8 8l.2 0 95.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 320z',
  ],
};
const faSignLanguage = faHands;
const faSigning = faHands;
const faCircleCaretRight = {
  prefix: 'far',
  iconName: 'circle-caret-right',
  icon: [
    512,
    512,
    ['caret-circle-right'],
    'f330',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0-6.7-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6z',
  ],
};
const faCaretCircleRight = faCircleCaretRight;
const faTurnLeft = {
  prefix: 'far',
  iconName: 'turn-left',
  icon: [
    512,
    512,
    [],
    'e636',
    'M6.5 240.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 41.7 144 0c88.4 0 160 71.6 160 160l0 112c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-120c0-4.4-3.6-8-8-8l-152 0 0 41.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6L6.5 240.4zm153.5 93l0-61.5c0-13.3 10.7-24 24-24l176 0c30.9 0 56 25.1 56 56l0 120c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-112c0-61.9-50.1-112-112-112l-168 0c-13.3 0-24-10.7-24-24l0-61.5L57 224 160 333.5z',
  ],
};
const faWheat = {
  prefix: 'far',
  iconName: 'wheat',
  icon: [
    512,
    512,
    [],
    'f72d',
    'M448 48c-22.1 0-40 17.9-40 40l0 16 16 0c22.1 0 40-17.9 40-40l0-16-16 0zM362.2 68.5C371.1 29.3 406.1 0 448 0l40 0c13.3 0 24 10.7 24 24l0 40c0 41.9-29.2 76.9-68.4 85.8c14.1 6.2 27.3 15.1 38.9 26.7l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.2-11.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L120.6 357.5c0 0 0 0 0 0l-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9C347 41 356 54.3 362.2 68.5zm-60.6 85.4L311.7 164c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM222.4 233l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm-79.2 79.2l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm147 56.5c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.2c25 25 65.5 25 90.5 0zm79.2-79.2c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1c25 25 65.5 25 90.5 0zm79.2-79.2C421.2 183 379 179.7 347.9 200.2l10.1 10.1c25 25 65.5 25 90.5 0z',
  ],
};
const faFileSpreadsheet = {
  prefix: 'far',
  iconName: 'file-spreadsheet',
  icon: [
    384,
    512,
    [],
    'f65b',
    'M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM176 256l0 48-64 0 0-48 64 0zm-64 80l64 0 0 48-64 0 0-48zm96 0l64 0 0 48-64 0 0-48zm-16 80l16 0 64 0c17.7 0 32-14.3 32-32l0-48 0-16 0-16 0-48c0-17.7-14.3-32-32-32l-64 0-16 0-16 0-64 0c-17.7 0-32 14.3-32 32l0 48 0 16 0 16 0 48c0 17.7 14.3 32 32 32l64 0 16 0zm16-112l0-48 64 0 0 48-64 0z',
  ],
};
const faAudioDescriptionSlash = {
  prefix: 'far',
  iconName: 'audio-description-slash',
  icon: [
    640,
    512,
    [],
    'e0a8',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6-95.4-74.8C493 322.1 512 291.3 512 256c0-53-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24l0 54L134.4 80zM419.9 303.8L384 275.7l0-67.7 32 0c26.5 0 48 21.5 48 48c0 25.2-19.4 45.8-44.1 47.8zM487.4 480l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM130.5 317.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l9.4-18.9 82.2 0 9.4 18.9c5.9 11.9 20.3 16.7 32.2 10.7c3-1.5 5.5-3.5 7.5-5.9l-80.9-63.8-30.4 0 8.6-17.2L173 232.3l-42.5 85z',
  ],
};
const faBellRing = {
  prefix: 'far',
  iconName: 'bell-ring',
  icon: [
    512,
    512,
    [],
    'e62c',
    'M256 0c-17.7 0-32 14.3-32 32l0 19.2C151 66 96 130.6 96 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L37.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C431.5 322.9 416 278.8 416 233.4l0-25.4c0-77.4-55-142-128-156.8L288 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6l-303.4 0c25.8-40 39.7-86.7 39.7-134.6l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM113.4 15.4c-9.1-9.6-24.3-10-33.9-.8C30.5 61.2 0 127.1 0 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-59.3 24.8-112.7 64.6-150.6c9.6-9.1 10-24.3 .8-33.9zM399.4 49.4C439.2 87.3 464 140.7 464 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-72.9-30.5-138.8-79.4-185.4c-9.6-9.1-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z',
  ],
};
const faCalendarDay = {
  prefix: 'far',
  iconName: 'calendar-day',
  icon: [
    448,
    512,
    [],
    'f783',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z',
  ],
};
const faWaterLadder = {
  prefix: 'far',
  iconName: 'water-ladder',
  icon: [
    576,
    512,
    ['ladder-water', 'swimming-pool'],
    'f5c5',
    'M128 128c0-53 43-96 96-96s96 43 96 96l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96.2 208 0 0-96.2c0-53 43-96 96-96s96 43 96 96l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 120.2L432 371c-15.5 8.4-32.8 13.5-48 13.5c0 0 0 0 0 0l0-112.3-208 0 0 110.6c-14.7-2.9-30-9.6-43.1-18.7c-1.6-1.1-3.2-2.2-4.9-3.1l0-112.9L128 128zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z',
  ],
};
const faLadderWater = faWaterLadder;
const faSwimmingPool = faWaterLadder;
const faArrowsUpDown = {
  prefix: 'far',
  iconName: 'arrows-up-down',
  icon: [
    320,
    512,
    ['arrows-v'],
    'f07d',
    'M177 7c-9.4-9.4-24.6-9.4-33.9 0L47 103c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 0 348.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55 0-348.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 7z',
  ],
};
const faArrowsV = faArrowsUpDown;
const faChessPawnPiece = {
  prefix: 'far',
  iconName: 'chess-pawn-piece',
  icon: [
    256,
    512,
    ['chess-pawn-alt'],
    'f444',
    'M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm73.4 144c12.6-.7 22.6-11.2 22.6-24c0-9.7-5.8-18.1-14.1-21.9c8.9-14.6 14.1-31.8 14.1-50.1c0-53-43-96-96-96s-96 43-96 96c0 18.4 5.2 35.5 14.1 50.1C37.8 245.9 32 254.3 32 264c0 12.8 10 23.3 22.6 24l-3.6 64 48.1 0 3.6-64 25.3 0 25.3 0 3.6 64 48.1 0-3.6-64zM52.7 464l16.6-32 117.6 0 16.6 32L52.7 464zm143.9-80l-137 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l174.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z',
  ],
};
const faChessPawnAlt = faChessPawnPiece;
const faFaceGrimace = {
  prefix: 'far',
  iconName: 'face-grimace',
  icon: [
    512,
    512,
    [128556, 'grimace'],
    'f57f',
    'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faGrimace = faFaceGrimace;
const faWheelchairMove = {
  prefix: 'far',
  iconName: 'wheelchair-move',
  icon: [
    448,
    512,
    ['wheelchair-alt'],
    'e2ce',
    'M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208.6 113c-8-3.4-17.2-2.2-24 3.2l-49.8 38.7c-10.5 8.1-25.5 6.3-33.7-4.2s-6.3-25.5 4.2-33.7l49.8-38.7c20.6-16 48.1-19.6 72.1-9.5l84.2 35.5c35.7 15 45.7 60.9 19.5 89.5L288.6 240l113.9 0c26.8 0 46 25.8 38.3 51.5L399 430.9c-3.8 12.7-17.2 19.9-29.9 16.1s-19.9-17.2-16.1-29.9L391.7 288l-85.1 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c1.2 0 2.5 0 3.7 0l68.9-68.9-24-10.1zm87 48.2c3.7-4.1 2.3-10.6-2.8-12.8l-20.4-8.6-60.7 60.7c11.8 4 22.9 9.4 33.3 15.9l50.6-55.2zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
  ],
};
const faWheelchairAlt = faWheelchairMove;
const faTurnDown = {
  prefix: 'far',
  iconName: 'turn-down',
  icon: [
    384,
    512,
    [10549, 'level-down-alt'],
    'f3be',
    'M175.6 505.5c9.2 8.7 23.7 8.7 32.9 0l129-121.4c9.3-8.8 14.6-21 14.6-33.7c0-25.6-20.7-46.3-46.3-46.3L264 304l0-144C264 71.6 192.4 0 104 0L56 0C25.1 0 0 25.1 0 56L0 88c0 30.9 25.1 56 56 56l56 0c4.4 0 8 3.6 8 8l0 152-41.7 0C52.7 304 32 324.7 32 350.3c0 12.8 5.3 25 14.6 33.7l129 121.4zM82.5 352l61.5 0c13.3 0 24-10.7 24-24l0-176c0-30.9-25.1-56-56-56L56 96c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l48 0c61.9 0 112 50.1 112 112l0 168c0 13.3 10.7 24 24 24l61.5 0L192 455 82.5 352z',
  ],
};
const faLevelDownAlt = faTurnDown;
const faSquareS = {
  prefix: 'far',
  iconName: 'square-s',
  icon: [
    448,
    512,
    [],
    'e27d',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6s0 0 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z',
  ],
};
const faRectangleBarcode = {
  prefix: 'far',
  iconName: 'rectangle-barcode',
  icon: [
    576,
    512,
    ['barcode-alt'],
    'f463',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm120 32c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm136-24c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z',
  ],
};
const faBarcodeAlt = faRectangleBarcode;
const faPersonWalkingArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-arrow-right',
  icon: [
    640,
    512,
    [],
    'e552',
    'M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
  ],
};
const faSquareEnvelope = {
  prefix: 'far',
  iconName: 'square-envelope',
  icon: [
    448,
    512,
    ['envelope-square'],
    'f199',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM216.7 255.6L96.1 189.3C97.5 172.9 111.3 160 128 160l192 0c16.7 0 30.5 12.9 31.9 29.3L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9zm30 28L352 225.7l0 94.3c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-94.3 105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8z',
  ],
};
const faEnvelopeSquare = faSquareEnvelope;
const faDice = {
  prefix: 'far',
  iconName: 'dice',
  icon: [
    640,
    512,
    [127922],
    'f522',
    'M241 68.3c-9.4-9.4-24.6-9.4-33.9 0L68.3 207c-9.4 9.4-9.4 24.6 0 33.9L207 379.7c9.4 9.4 24.6 9.4 33.9 0L379.7 241c9.4-9.4 9.4-24.6 0-33.9L241 68.3zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 413.8L436.3 297.5c28.6-28.6 37-69.6 25.4-105.5L576 192c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-34.2zM504 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 208a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faUnicorn = {
  prefix: 'far',
  iconName: 'unicorn',
  icon: [
    640,
    512,
    [129412],
    'f727',
    'M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 32 0 .5 0c2.5 0 5 .1 7.5 .3l0-.3 56 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c3.5 6.1 6.3 12.7 8.3 19.7l73.5 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1l22.6 0 33.1 0 61.3 0C309.8 51.5 362.6 6.1 426.8 .6zM416 239l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-32 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-1.5 12-11.7 21-23.8 21l-81 0-33.1 0-22.6 0c-35.5 0-64.2 28.8-64.2 64.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faBowlingBall = {
  prefix: 'far',
  iconName: 'bowling-ball',
  icon: [
    512,
    512,
    [],
    'f436',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
};
const faPompebled = {
  prefix: 'far',
  iconName: 'pompebled',
  icon: [
    512,
    512,
    [],
    'e43d',
    'M254.4 22.8c45.2 31.3 55.3 91.3 38 147.2c45.1-35.6 103.5-47.2 148.3-15c64.6 45.8 71.6 140.2 25.7 208.1c0 0 0 0 0 0C386.7 480.8 219.2 542 98.5 455.5C-21.8 369.5-25.9 190 53.9 72.2c46-68.6 135.3-95.4 200.5-49.4zm21.5 185.1c0 0 0 0 0 0c0 0 0 0 0 0zM226.7 62.1c-38-26.9-98.3-15-133 36.9l-.1 .1c-69.9 103.1-60.2 251 32.8 317.4c0 0 0 0 0 0c91.7 65.7 230.3 23 300.2-80.2c34.9-51.7 24.7-114.9-13.8-142.1l-.1-.1c-25.6-18.4-73.5-11.7-111.5 33.9c-12.9 17.5-37.4 21.8-55.4 8.7c-17.6-12.7-21.9-36.7-10.4-54.7c28.6-52.7 17.8-101.6-8.5-119.7l-.2-.2s0 0 0 0z',
  ],
};
const faBrain = {
  prefix: 'far',
  iconName: 'brain',
  icon: [
    512,
    512,
    [129504],
    'f5dc',
    'M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44l0-332c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c16.7 19.6 26.8 45 26.8 72.7c0 30.5-12.2 58.2-32 78.4c0 .5 0 1.1 0 1.6c0 47.3-34.1 86.5-79.1 94.5c-16.4 25-44.7 41.5-76.9 41.5c-26.9 0-51.2-11.6-68-30zm24-62c0 24.3 19.7 44 44 44c17.8 0 33.2-10.6 40.1-25.9c3.8-8.4 12-13.9 21.2-14.1c25.9-.7 46.7-21.9 46.7-48c0-2.6-.2-5.2-.6-7.6c-1.4-8.5 2-17.1 8.7-22.5C454.7 334.1 464 316.2 464 296c0-19.3-8.5-36.6-22.1-48.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40l0 332z',
  ],
};
const faWatchSmart = {
  prefix: 'far',
  iconName: 'watch-smart',
  icon: [
    384,
    512,
    [],
    'e2cc',
    'M64 48.3C64 21.6 85.6 0 112.3 0L271.7 0C298.4 0 320 21.6 320 48.3l0 17.3c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4l0-17.3zM80 112c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L80 112zm136 72l0 60.8 39.4 32.8c10.2 8.5 11.6 23.6 3.1 33.8s-23.6 11.6-33.8 3.1l-48-40c-5.5-4.6-8.6-11.3-8.6-18.4l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faBookUser = {
  prefix: 'far',
  iconName: 'book-user',
  icon: [
    448,
    512,
    [],
    'f7e7',
    'M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8l-40 0 0-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l0 16-48 0zM240 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
  ],
};
const faSensorCloud = {
  prefix: 'far',
  iconName: 'sensor-cloud',
  icon: [
    640,
    512,
    ['sensor-smoke'],
    'e02c',
    'M64 80l320 0c8.8 0 16 7.2 16 16l0 128c17.2 0 33.5 3.9 48 10.8L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l170.8 0c-6.9-14.5-10.8-30.8-10.8-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 360l224 0c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z',
  ],
};
const faSensorSmoke = faSensorCloud;
const faClapperboardPlay = {
  prefix: 'far',
  iconName: 'clapperboard-play',
  icon: [
    512,
    512,
    [],
    'e132',
    'M48 416c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-208L48 208l0 208zM336 160l64 0 64-64c0-8.8-7.2-16-16-16l-32 0-80 80zm-96 0l80-80-64 0-80 80 64 0zM80 160l80-80L96 80 48 128l0 32 32 0zM512 96l0 64 0 24 0 24 0 208c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 208l0-24 0-24L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64zM216.5 241.9c5.2-2.8 11.5-2.5 16.4 .8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-128c0-5.9 3.2-11.3 8.5-14.1z',
  ],
};
const faBandage = {
  prefix: 'far',
  iconName: 'bandage',
  icon: [
    640,
    512,
    [129657, 'band-aid'],
    'f462',
    'M448 144l0 224 112 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-112 0zM192 96l256 0 112 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80l-112 0-256 0L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l112 0zm0 272l0-224L80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l112 0zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
};
const faBandAid = faBandage;
const faCalendarMinus = {
  prefix: 'far',
  iconName: 'calendar-minus',
  icon: [
    448,
    512,
    [],
    'f272',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM296 352l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
  ],
};
const faCircleXmark = {
  prefix: 'far',
  iconName: 'circle-xmark',
  icon: [
    512,
    512,
    [61532, 'times-circle', 'xmark-circle'],
    'f057',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faTimesCircle = faCircleXmark;
const faXmarkCircle = faCircleXmark;
const faCircle4 = {
  prefix: 'far',
  iconName: 'circle-4',
  icon: [
    512,
    512,
    [],
    'e0f1',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c12.6 4.2 19.4 17.8 15.2 30.4L201.3 272l70.7 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-104 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l48-144c4.2-12.6 17.8-19.4 30.4-15.2z',
  ],
};
const faGifts = {
  prefix: 'far',
  iconName: 'gifts',
  icon: [
    640,
    512,
    [],
    'f79c',
    'M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l136.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l80 0c0 0 0 0 .1 0l80 0 32.4 0c5.3-8.2 11.7-15.7 19-22.1C263.8 106.2 245.1 96 224 96l-6.2 0 28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24l-4.1 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-4.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zm0 72l72 0 56 0 8 0 0 72-136 0 0-72zm0 120l136 0 0 72-136 0 0-72zm320 0l0 72-136 0 0-72 136 0zM456 344l0-72 8 0 56 0 72 0 0 72-136 0zm88-144c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z',
  ],
};
const faAlbumCollection = {
  prefix: 'far',
  iconName: 'album-collection',
  icon: [
    512,
    512,
    [],
    'f8a0',
    'M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c38.7 0 68.5 34 63.5 72.3l-29.5 224C472.2 488.2 445 512 412.9 512L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM69.6 208c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l313.8 0c8 0 14.8-6 15.9-13.9l29.5-224c1.3-9.6-6.2-18.1-15.9-18.1L69.6 208zM400 336c0 57.4-64.5 104-144 104s-144-46.6-144-104s64.5-104 144-104s144 46.6 144 104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24z',
  ],
};
const faHotel = {
  prefix: 'far',
  iconName: 'hotel',
  icon: [
    512,
    512,
    [127976],
    'f594',
    'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 416-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-416 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM432 48l0 416-128 0 0-80 32 0c8.8 0 16.1-7.2 14.7-15.9C343.1 322.6 303.6 288 256 288s-87.1 34.6-94.7 80.1c-1.5 8.7 5.8 15.9 14.7 15.9l32 0 0 80L80 464 80 48l352 0zM144 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM336 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM128 208l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
  ],
};
const faEarthAsia = {
  prefix: 'far',
  iconName: 'earth-asia',
  icon: [
    512,
    512,
    [127759, 'globe-asia'],
    'f57e',
    'M464 256c0-90.7-58.1-167.9-139.1-196.3l-16.4 40.9c-2.9 7.2-9 12.5-16.5 14.4l-17 4.3c-16.7 4.2-23.7 24-13.4 37.7l16.1 21.5c6.1 8.1 6.4 19.2 .8 27.7l-10.7 16.1C260.5 233.3 248 240 234.6 240l-2.3 0c-16.1 0-27.6 15.5-23 30.9l6 19.9c4.4 14.6-6.5 29.2-21.7 29.2c-10.7 0-20.6-6.1-25.4-15.7l-9.3-18.5c-7.3-14.7-26.9-17.8-38.4-6.2l-15.4 15.4c-5.7 5.7-13.8 8.1-21.7 6.6l-31.7-6.3C70 391.3 154.5 464 256 464c48.1 0 92.3-16.3 127.5-43.7l-5.9-4.3L359 422.9c-19.8 7.4-41.8-1.9-50.4-21.1L303 389.4c-8.5-18.9-1.1-41.2 17-51.3L356.2 318c2.3-1.3 4.3-3.1 5.7-5.3l6.1-9.5c6-9.4 16.4-15.1 27.6-15.1s21.6 5.7 27.6 15.1l2 3.1c3.7 5.8 10.8 8.6 17.5 6.7l14.6-4.1c4.4-16.9 6.8-34.5 6.8-52.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 80.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 11c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM350.3 135.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z',
  ],
};
const faGlobeAsia = faEarthAsia;
const faIdCardClip = {
  prefix: 'far',
  iconName: 'id-card-clip',
  icon: [
    576,
    512,
    ['id-card-alt'],
    'f47f',
    'M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L256 0zM192 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L384 64l0 48 128 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l128 0 0-48zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z',
  ],
};
const faIdCardAlt = faIdCardClip;
const faMagnifyingGlassPlus = {
  prefix: 'far',
  iconName: 'magnifying-glass-plus',
  icon: [
    512,
    512,
    ['search-plus'],
    'f00e',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z',
  ],
};
const faSearchPlus = faMagnifyingGlassPlus;
const faThumbsUp = {
  prefix: 'far',
  iconName: 'thumbs-up',
  icon: [
    512,
    512,
    [128077, 61575],
    'f164',
    'M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z',
  ],
};
const faCloudShowers = {
  prefix: 'far',
  iconName: 'cloud-showers',
  icon: [
    512,
    512,
    [],
    'f73f',
    'M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM112 352c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm192 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm-72 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm168-24c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z',
  ],
};
const faUserClock = {
  prefix: 'far',
  iconName: 'user-clock',
  icon: [
    640,
    512,
    [],
    'f4fd',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l299.2 0c12.3 18.8 28 35.1 46.3 48L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c20.6 0 40.4 3.5 58.8 9.9c-4.9 15.3-7.8 31.4-8.4 48.2c-15.5-6.5-32.5-10.1-50.4-10.1l-91.4 0c-65.7 0-120.1 48.7-129 112zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
  ],
};
const faOnion = {
  prefix: 'far',
  iconName: 'onion',
  icon: [
    448,
    512,
    [129477],
    'e427',
    'M171.3 33.9c.2-.7 .4-1.5 .6-2.2c1-3.8 1.9-7.8 2.5-11.9C176.2 9 184.9 0 195.8 0c6.3 0 12.1 3 15.8 7.9c0 0 0 0 0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3c0 0 0 0 0 0C240.1 3 245.9 0 252.2 0c10.9 0 19.6 9 21.3 19.8c.6 4.1 1.5 8.1 2.5 11.9c.2 .7 .4 1.5 .6 2.2c0 0 0 0 0 .1c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80.4-58 135.2-131.9 160.3l10.7 32.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2L269.4 460c-7.1 1.2-14.2 2.1-21.4 2.7l0 25.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.3c-7.2-.7-14.3-1.6-21.4-2.7l-11.9 35.6c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l10.7-32.1C58 423.2 0 368.4 0 288c0-84.5 49-124.3 95.3-162c32.9-26.7 64.4-52.4 76-92c0 0 0 0 0-.1zm31.3 48.2c-7.9 13.9-17.4 26-27.5 36.8c-.5 .5-1 1.1-1.5 1.6c-.4 .8-.9 1.9-1.5 3.2c-1.5 3.2-3.6 7.9-6.2 13.7c-5.1 11.7-12 28.2-18.9 46.9c-13.9 38.1-27 83.8-27 119.5c0 32.5 9.2 60.2 18.5 79.8c3.8 8.1 7.6 14.7 10.8 19.7c17.4 5.8 36.1 9.6 55.3 11.4C194.2 389.7 184 354.2 184 312c0-61.9 6.1-128.6 12.1-179.6c2.3-19.3 4.6-36.4 6.5-50.2zm34.3-13.5c-.3 1.8-.6 3.8-.9 5.8c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c1.7 4 3.3 7.7 4.9 11c21.3-1.7 41.9-5.9 61-12.4c3.3-4.4 7.1-10.2 11-17.2c9.9-17.9 19.7-43.2 19.7-73.6c0-37.1-15.8-88.6-32.6-132.5c-8.3-21.6-16.6-40.7-22.8-54.5c-.8-1.9-1.7-3.7-2.4-5.3c-.2-.2-.4-.5-.7-.7c-13.2-14.2-25.6-30.8-34.5-50.7c-.5 .1-.9 .2-1.4 .3zm91.9 99.9c16.8 43.9 34.6 100.1 34.6 143.5c0 25.2-5.5 47.4-12.6 65.7C382.1 355.2 400 325.3 400 288c0-53.7-25.3-81.3-63.6-113.2c-2.4-2-5-4.1-7.6-6.3zM102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5c.6-1.5 1.1-3.1 1.7-4.6c-2.5 2-4.8 4-7.1 5.8C73.3 206.7 48 234.3 48 288c0 37.7 18.2 67.7 50 90.2c1.5 1.1 3.1 2.1 4.6 3.2z',
  ],
};
const faClockTwelveThirty = {
  prefix: 'far',
  iconName: 'clock-twelve-thirty',
  icon: [
    512,
    512,
    [],
    'e359',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 152l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
};
const faArrowDownToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e095',
    'M32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM241.5 360.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 283.5l0-83.5 0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128 0 83.5 86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136z',
  ],
};
const faHandDots = {
  prefix: 'far',
  iconName: 'hand-dots',
  icon: [
    512,
    512,
    ['allergies'],
    'f461',
    'M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 176c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L112 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9L432 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L352 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L240 232zm0 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
  ],
};
const faAllergies = faHandDots;
const faFileInvoice = {
  prefix: 'far',
  iconName: 'file-invoice',
  icon: [
    384,
    512,
    [],
    'f570',
    'M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm80 48c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zM192 400c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zM112 224l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
  ],
};
const faWindowMinimize = {
  prefix: 'far',
  iconName: 'window-minimize',
  icon: [
    512,
    512,
    [128469],
    'f2d1',
    'M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faRectangleWide = {
  prefix: 'far',
  iconName: 'rectangle-wide',
  icon: [
    640,
    512,
    [],
    'f2fc',
    'M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z',
  ],
};
const faCommentArrowUp = {
  prefix: 'far',
  iconName: 'comment-arrow-up',
  icon: [
    512,
    512,
    [],
    'e144',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 217.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-110.1z',
  ],
};
const faGarlic = {
  prefix: 'far',
  iconName: 'garlic',
  icon: [
    512,
    512,
    [129476],
    'e40e',
    'M376 131.2c-15.2-12.1-24-30.5-24-50L352 48c0-26.5-21.5-48-48-48L208 0c-26.5 0-48 21.5-48 48l0 33.2c0 19.4-8.8 37.8-24 50L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448l-4.5 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-4.5 0C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2zm-168-56L208 48l32 0 0 27.2c0 48.1 15 95 43 134.1l17.4 24.4c12.7 17.8 19.6 39.2 19.6 61.1l0 9.2c0 53-43 96-96 96s-96-43-96-96l0-9.2c0-21.9 6.8-43.3 19.6-61.1L165 209.3c24.1-33.7 38.6-73.2 42.1-114.2c.6-4.6 .9-9.2 .9-13.9l0-6.1zM272 48l32 0 0 33.2c0 34 15.5 66.2 42 87.5l83.3 66.6c21.9 17.6 34.7 44.1 34.7 72.2c0 51.1-41.4 92.5-92.5 92.5l-62.9 0c26.6-23.5 43.3-57.8 43.3-96l0-9.2c0-28.6-8.9-56.5-25.5-79.7L309 190.7c-24.1-33.7-37-74.1-37-115.5L272 48zM139.3 400C88.8 399.4 48 358.2 48 307.5c0-28.1 12.8-54.7 34.7-72.2l57-45.6c-.2 .3-.5 .6-.7 1l-17.4 24.4C104.9 238.4 96 266.2 96 294.8l0 9.2c0 38.2 16.8 72.5 43.3 96z',
  ],
};
const faMugSaucer = {
  prefix: 'far',
  iconName: 'mug-saucer',
  icon: [
    640,
    512,
    ['coffee'],
    'f0f4',
    'M144 80l288 0 0 208c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-208zM128 32c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96l32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L128 32zM512 240l-32 0 0-160 32 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
  ],
};
const faCoffee = faMugSaucer;
const faBrush = {
  prefix: 'far',
  iconName: 'brush',
  icon: [
    384,
    512,
    [],
    'f55d',
    'M48 288L48 64c0-8.8 7.2-16 16-16l32 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 96 0c8.8 0 16 7.2 16 16l0 224L48 288zM0 320c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 320zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faFileHalfDashed = {
  prefix: 'far',
  iconName: 'file-half-dashed',
  icon: [
    384,
    512,
    [],
    'e698',
    'M48 272L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 112L48 272zm288 48l16 0 32 0 0-165.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 320l32 0 16 0 288 0zM0 352l0 64 48 0 0-64L0 352zM64 512l0-48c-8.8 0-16-7.2-16-16L0 448c0 35.3 28.7 64 64 64zm256-48l0 48c35.3 0 64-28.7 64-64l-48 0c0 8.8-7.2 16-16 16zm64-112l-48 0 0 64 48 0 0-64zM96 464l0 48 80 0 0-48-80 0zm112 0l0 48 80 0 0-48-80 0z',
  ],
};
const faTreeDecorated = {
  prefix: 'far',
  iconName: 'tree-decorated',
  icon: [
    448,
    512,
    [],
    'f7dc',
    'M242.9 9.3C238.4 3.4 231.4 0 224 0s-14.4 3.4-18.9 9.3L66.8 186.9c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l16.5 0L35.1 326.2c-4.9 7.4-5.4 16.8-1.2 24.6s12.3 12.7 21.2 12.7l24 0L4.1 474.6c-5 7.4-5.5 16.9-1.3 24.7S15.1 512 24 512l400 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.3-24.7L369 363.5l24 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6L345.7 225.6l16.5 0c9.2 0 17.5-5.2 21.6-13.5s3-18-2.6-25.3L242.9 9.3zM147.2 177.6l-12.3 0L224 63.1l89.1 114.5-12.3 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l67.2 100.6-24.2 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.3 24.7L378.9 464 69.1 464l74.9-111.1c5-7.4 5.5-16.9 1.3-24.7s-12.3-12.7-21.2-12.7l-24.2 0 67.2-100.6c4.9-7.4 5.4-16.8 1.2-24.6s-12.3-12.7-21.2-12.7zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faMask = {
  prefix: 'far',
  iconName: 'mask',
  icon: [
    576,
    512,
    [],
    'f6fa',
    'M91.4 162.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95c22 20.6 53.7 33 91.2 33l8.4 0c6.1 0 11.6-3.4 14.3-8.8l23.2-46.3 39 19.5-39-19.5C234.4 319.8 260 304 288 304s53.6 15.8 66.1 40.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8l8.4 0c37.4 0 69.2-12.4 91.2-33c21.5-20.2 36.8-51.1 36.8-95c0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3zM0 272C0 160 64 64 288 64s288 96 288 208s-80 176-176 176l-8.4 0c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4l-8.4 0C80 448 0 384 0 272zm96-16a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
  ],
};
const faCalendarHeart = {
  prefix: 'far',
  iconName: 'calendar-heart',
  icon: [
    448,
    512,
    [],
    'e0d3',
    'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
  ],
};
const faMagnifyingGlassMinus = {
  prefix: 'far',
  iconName: 'magnifying-glass-minus',
  icon: [
    512,
    512,
    ['search-minus'],
    'f010',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
  ],
};
const faSearchMinus = faMagnifyingGlassMinus;
const faFlower = {
  prefix: 'far',
  iconName: 'flower',
  icon: [
    448,
    512,
    [127804, 10047],
    'f7ff',
    'M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM192.9 100.9C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88c0 21.8 7.8 41.6 20.9 56.9c15.2 17.9 15.2 44.2 0 62.2C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88c21.8 0 41.6-7.8 56.9-20.9c17.9-15.2 44.2-15.2 62.2 0C270.4 424.2 290.2 432 312 432c48.6 0 88-39.4 88-88c0-21.8-7.8-41.6-20.9-56.9c-15.2-17.9-15.2-44.2 0-62.2C392.2 209.6 400 189.8 400 168c0-48.6-39.4-88-88-88c-21.8 0-41.6 7.8-56.9 20.9c-17.9 15.2-44.2 15.2-62.2 0zM256 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
};
const faArrowDownFromArc = {
  prefix: 'far',
  iconName: 'arrow-down-from-arc',
  icon: [
    512,
    512,
    [],
    'e614',
    'M256 48C141.1 48 48 141.1 48 256c0 13.3-10.7 24-24 24s-24-10.7-24-24C0 114.6 114.6 0 256 0S512 114.6 512 256c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-114.9-93.1-208-208-208zM134.4 392.3c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 426.9 232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112z',
  ],
};
const faRightLeftLarge = {
  prefix: 'far',
  iconName: 'right-left-large',
  icon: [
    640,
    512,
    [],
    'e5e1',
    'M182.1 504c-15.4 0-30.1-6.1-41-17L20.7 366.6C12.6 358.5 8 347.5 8 336s4.6-22.5 12.7-30.6L141.1 185c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9V232H432c8.8 0 16 7.2 16 16v38.1c0 5.5 4.5 9.9 9.9 9.9c2.6 0 5.2-1 7-2.9L582.1 176 465 58.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9V104c0 8.8-7.2 16-16 16H320c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V65.9C400 33.9 425.9 8 457.9 8c15.4 0 30.1 6.1 41 17L619.3 145.4c8.1 8.1 12.7 19.1 12.7 30.6s-4.6 22.5-12.7 30.6L498.9 327c-10.9 10.9-25.6 17-41 17c-32 0-57.9-25.9-57.9-57.9V280H208c-8.8 0-16-7.2-16-16V225.9c0-5.5-4.5-9.9-9.9-9.9c-2.6 0-5.2 1-7 2.9L57.9 336 175 453.1c1.9 1.9 4.4 2.9 7 2.9c5.5 0 9.9-4.5 9.9-9.9V408c0-8.8 7.2-16 16-16H320c13.3 0 24 10.7 24 24s-10.7 24-24 24H240v6.1c0 32-25.9 57.9-57.9 57.9z',
  ],
};
const faRulerVertical = {
  prefix: 'far',
  iconName: 'ruler-vertical',
  icon: [
    256,
    512,
    [],
    'f548',
    'M192 48c8.8 0 16 7.2 16 16l0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l128 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0z',
  ],
};
const faCirclesOverlap = {
  prefix: 'far',
  iconName: 'circles-overlap',
  icon: [
    640,
    512,
    [],
    'e600',
    'M192 288c0 40.8 10.9 79 30 112c-96.3-1.1-174-79.5-174-176c0-97.2 78.8-176 176-176c38.9 0 74.8 12.6 104 34C248 116.2 192 195.5 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 16c-38.9 0-74.8-12.6-104-34C392 395.8 448 316.5 448 224c0-40.8-10.9-79-30-112c96.3 1.1 174 79.5 174 176c0 97.2-78.8 176-176 176z',
  ],
};
const faUserLarge = {
  prefix: 'far',
  iconName: 'user-large',
  icon: [
    512,
    512,
    ['user-alt'],
    'f406',
    'M352 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM49.3 464l413.4 0c-8.3-54.4-55.3-96-112-96l-189.4 0c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320l189.4 0C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z',
  ],
};
const faUserAlt = faUserLarge;
const faStarshipFreighter = {
  prefix: 'far',
  iconName: 'starship-freighter',
  icon: [
    576,
    512,
    [],
    'e03a',
    'M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7c0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7C392.7 313.3 400 285.5 400 256zm40 112c1.1 0 2.3 0 3.4 .1L528 335.2l0-55.2-81.3 0c-3.4 31.8-13.4 61.6-28.7 88l22 0zm6.7-136l81.3 0 0-55.2-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zM555.6 375.9l-57 22.2C507 409.9 512 424.4 512 440c0 39.8-32.2 72-72 72l-72 0c-22.3 0-43.3-10.3-57-28l-9.9-12.9C275.9 477 250 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8l0 90.1 0 90.1c0 13.2-8.1 25-20.4 29.8zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm152-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm77 198.7c4.5 5.9 11.6 9.3 19 9.3l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-60.2 0L300.7 313.7c-9.7 12.9-22.6 23.3-37.5 30l85.8 111z',
  ],
};
const faTrainTram = {
  prefix: 'far',
  iconName: 'train-tram',
  icon: [
    448,
    512,
    [128650],
    'e5b4',
    'M55.5 63c7.6-9.5 19.1-15 31.2-15L200 48l0 48-40 0c-53 0-96 43-96 96l0 160c0 26 10.3 49.6 27.2 66.9L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l60.6-60.6c8.4 2.4 17.2 3.7 26.4 3.7l128 0c9.2 0 18-1.3 26.4-3.7L375 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-52.1-52.1C373.7 401.6 384 378 384 352l0-160c0-53-43-96-96-96l-40 0 0-48 113.2 0c12.2 0 23.6 5.5 31.2 15l12.8 16c8.3 10.4 23.4 12 33.7 3.7s12-23.4 3.8-33.7L430 33C413.3 12.2 388 0 361.2 0L86.8 0C60 0 34.7 12.2 18 33L5.3 49C-3 59.4-1.3 74.5 9 82.7S34.5 89.3 42.7 79L55.5 63zM160 144l128 0c26.5 0 48 21.5 48 48l0 48-224 0 0-48c0-26.5 21.5-48 48-48zM112 288l224 0 0 64c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-64zm72 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
};
const faBridgeSuspension = {
  prefix: 'far',
  iconName: 'bridge-suspension',
  icon: [
    640,
    512,
    [],
    'e4cd',
    'M149.1 12.5C145 5 137.1 0 128 0c-8.8 0-16.5 4.7-20.7 11.8C94.3 33 80.7 53.9 65.3 71.5c-15.5 17.7-31.7 30.6-49.4 36.9C3.4 113-3.1 126.7 1.4 139.2s18.2 18.9 30.7 14.4c28.2-10.2 50.8-29.4 69.2-50.4c.9-1 1.8-2 2.6-3L104 240l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-139.8c.9 1 1.7 2 2.6 3c18.4 21 41.1 40.3 69.2 50.4c12.5 4.5 26.2-2 30.7-14.4s-2-26.2-14.4-30.7c-17.7-6.4-33.9-19.3-49.4-36.9c-15.4-17.6-29-38.6-42-59.8C528.5 4.7 520.8 0 512 0c-9.1 0-17 5-21.1 12.5C455.8 73.6 390.3 112 320 112s-135.8-38.4-170.9-99.5zM200 240l-48 0 0-147.2c14.5 13.7 30.7 25.6 48 35.4L200 240zm96 0l-48 0 0-91c15.5 4.8 31.6 8.1 48 9.8l0 81.2zm96 0l-48 0 0-81.2c16.4-1.6 32.5-4.9 48-9.8l0 91zm96 0l-48 0 0-111.7c17.3-9.8 33.5-21.7 48-35.4L488 240zM0 360c0 13.3 10.7 24 24 24l16 0c30.9 0 56 25.1 56 56l0 24c0 26.5 21.5 48 48 48l49.4 0c25.7 0 46.6-20.9 46.6-46.6l0-1.4c0-44.2 35.8-80 80-80s80 35.8 80 80l0 1.4c0 25.7 20.9 46.6 46.6 46.6l49.4 0c26.5 0 48-21.5 48-48l0-24c0-30.9 25.1-56 56-56l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-57.4 0-104 46.6-104 104l0 24-48 0c0-70.7-57.3-128-128-128s-128 57.3-128 128l-48 0 0-24c0-57.4-46.6-104-104-104l-16 0c-13.3 0-24 10.7-24 24z',
  ],
};
const faTrashCheck = {
  prefix: 'far',
  iconName: 'trash-check',
  icon: [
    448,
    512,
    [],
    'e2af',
    'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zM318.1 246.1l-104 104c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L200 307.7l89.9-89.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z',
  ],
};
const faUserNurse = {
  prefix: 'far',
  iconName: 'user-nurse',
  icon: [
    448,
    512,
    [],
    'f82f',
    'M96 128l0-57.8c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zM216 40c-4.4 0-8 3.6-8 8l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0zM49.3 461.9l349.4 0c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7l-386.6 0c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4z',
  ],
};
const faBoombox = {
  prefix: 'far',
  iconName: 'boombox',
  icon: [
    640,
    512,
    [128254],
    'f8a5',
    'M136 48l368 0c22.1 0 40 17.9 40 40l0 72-96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-96 0 0-72c0-22.1 17.9-40 40-40zM48 88l0 74c-27.6 7.1-48 32.2-48 62L0 448c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-29.8-20.4-54.9-48-62l0-74c0-48.6-39.4-88-88-88L136 0C87.4 0 48 39.4 48 88zM64 208l512 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM176 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-48-96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm432 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
  ],
};
const faSyringe = {
  prefix: 'far',
  iconName: 'syringe',
  icon: [
    512,
    512,
    [128137],
    'f48e',
    'M407 7c-9.4 9.4-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7c-9.4-9.4-24.6-9.4-33.9 0zM271.4 94.6l-191 191C69.9 296.2 64 310.4 64 325.3l0 88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 88.8 0c14.9 0 29.1-5.9 39.6-16.4l191-191c-.3-.3-.7-.6-1-1l-33-33-191 191c-1.5 1.5-3.5 2.3-5.7 2.3L112 400l0-74.7c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 13.1-13.1-33-33c-.3-.3-.6-.7-1-1z',
  ],
};
const faCloudSun = {
  prefix: 'far',
  iconName: 'cloud-sun',
  icon: [
    640,
    512,
    [9925],
    'f6c4',
    'M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z',
  ],
};
const faShieldExclamation = {
  prefix: 'far',
  iconName: 'shield-exclamation',
  icon: [
    512,
    512,
    [],
    'e247',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faStopwatch20 = {
  prefix: 'far',
  iconName: 'stopwatch-20',
  icon: [
    448,
    512,
    [],
    'e06f',
    'M168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9L248 48l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L168 0zM64 304a160 160 0 1 1 320 0A160 160 0 1 1 64 304zm172-48l0 96c0 28.7 23.3 52 52 52s52-23.3 52-52l0-96c0-28.7-23.3-52-52-52s-52 23.3-52 52zm52-12c6.6 0 12 5.4 12 12l0 96c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-96c0-6.6 5.4-12 12-12zm-132.4 8.6c1.7-5.1 6.5-8.6 11.9-8.6c6.9 0 12.5 5.6 12.5 12.5l0 2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8l0 15.7c0 11 9 20 20 20l64 0c11 0 20-9 20-20s-9-20-20-20l-43.8 0c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4l0-2.2c0-29-23.5-52.5-52.5-52.5c-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7z',
  ],
};
const faSquareFull = {
  prefix: 'far',
  iconName: 'square-full',
  icon: [
    512,
    512,
    [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036],
    'f45c',
    'M464 48l0 416L48 464 48 48l416 0zM48 0L0 0 0 48 0 464l0 48 48 0 416 0 48 0 0-48 0-416 0-48L464 0 48 0z',
  ],
};
const faGripDots = {
  prefix: 'far',
  iconName: 'grip-dots',
  icon: [
    448,
    512,
    [],
    'e410',
    'M352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
  ],
};
const faCommentExclamation = {
  prefix: 'far',
  iconName: 'comment-exclamation',
  icon: [
    512,
    512,
    [],
    'f4af',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM256 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faPenSwirl = {
  prefix: 'far',
  iconName: 'pen-swirl',
  icon: [
    512,
    512,
    [],
    'e214',
    'M441.2 59.1L453.1 71c9.4 9.4 9.4 24.6 0 33.9L432 126.1 386.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM231.9 236.8L352.6 114.5 398.1 160 276.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L215 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM373 25.5L197.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.3-9.7 36.1-19.6L487.1 138.9c28.1-28.1 28.1-73.7 0-101.8L475.1 25.2C446.9-3.1 401-2.9 373 25.5zm-48.3-7.9C302.9 11.4 279.8 8 256 8C119 8 8 119 8 256S119 504 256 504c13.3 0 24-10.7 24-24s-10.7-24-24-24C145.5 456 56 366.5 56 256S145.5 56 256 56c9.7 0 19.3 .7 28.7 2l40-40.4zM454.1 228.4c1.2 9 1.9 18.2 1.9 27.6c0 57.4-46.6 104-104 104c-13.3 0-24 10.7-24 24s10.7 24 24 24c83.9 0 152-68.1 152-152c0-23.6-3.3-46.4-9.4-68l-40.4 40.5z',
  ],
};
const faFalafel = {
  prefix: 'far',
  iconName: 'falafel',
  icon: [
    576,
    512,
    [129478],
    'e40a',
    'M147.4 120.3c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-2.3 9-1.9 18.2 .6 26.6c-20.8-9-45-2.4-58.5 15.9c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-5.8 23 5.4 47.3 27.3 57.3c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .5-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c10.2-4.7 18.1-12.4 23-21.7c4.9 9.3 12.8 17.1 23 21.7c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .6-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c16.4-7.5 26.7-22.9 28.5-39.9c-18.6 7.3-39.4 6-56.9 1.2c0 0 0 0-.1 0c-10 7.3-17 18.2-19.4 30.6c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3s-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 0-.1 0-.1 .1c0 0 0 0-.1 0s0 0-.1 0s0 0-.1 0s0 0-.1 0c-.1 0-.2-.1-.2-.1s-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c8.7 .2 17.1-1.8 24.5-5.9c-.9-11.7 .3-23.8 4.6-35.2c7.1-4.1 16-4.4 23.7-.4l.4 .2c13.8-12.1 20-31.3 15.4-49.7c-.2-.6 0-1.3 .3-1.6c15.2-18.4 15.2-45.1 0-63.5c-.3-.4-.5-1-.3-1.6c5.8-23-5.4-47.3-27.3-57.3c-.2-.1-.6-.4-.7-1.1c-4.6-23.4-25.2-40.6-49.4-39.9c-.1 0-.4 0-.7-.4C335.9 .6 309.7-5.7 288.3 5.6c-.1 .1-.2 .1-.3 .1s-.2 0-.3-.1c-21.5-11.3-47.7-5-61.9 14.3c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6zM324.5 243.4c-5 3.2-9.4 7.3-13 12.2c-.1 .2-.2 .2-.3 .3s-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1s-.1 0-.1 0c0 0 0 0-.1 0c-.1 0-.2 0-.2-.1s-.2-.1-.3-.3c-3.6-4.9-8-9-13-12.2c-7.8-8.2-18.4-13.6-30.2-14.9c-4.2-12.9-13.7-23.7-26.3-29.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0c0 0 0 0 .1 0s0 0 .1 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.4-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-12.6 5.8-22.1 16.6-26.3 29.5c-11.8 1.2-22.4 6.7-30.2 14.9zM48.4 361.1c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0c0 0 .1 0 .1 0c0 0 0 0 0 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.3-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-14.6 6.7-24.8 20-27.9 35.5c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3c0 0-.1 0-.1 .1c0 0-.1 0-.1 0c0 0 0 0-.1 0s0 0-.1 0s0 0-.1 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1c0 0-.1 0-.2 0s-.2-.1-.2-.1s-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44zM416 261c-1 24.2 13.6 56 40.3 82.7c19.3 19.3 41.4 32.3 61.3 37.6c19.5 5.2 37 3 47.9-7.9c5.5-5.5 8.8-12.7 10-20.9c2.1-14.2-1.8-31.6-10.9-49.3c-5.2-10.1-12.1-20.3-20.6-30.1c-2.6-3-5.4-5.9-8.2-8.8l-.5-.5c-33.5-33.3-74.9-47.5-99.3-35.9c-3.5 1.7-6.6 3.8-9.4 6.6c-6.7 6.7-10.1 15.9-10.5 26.5zM112 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
  ],
};
const faCircle2 = {
  prefix: 'far',
  iconName: 'circle-2',
  icon: [
    512,
    512,
    [],
    'e0ef',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-83.3 0 64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z',
  ],
};
const faMagnet = {
  prefix: 'far',
  iconName: 'magnet',
  icon: [
    448,
    512,
    [129522],
    'f076',
    'M48 256c0 97.2 78.8 176 176 176s176-78.8 176-176l0-64-64 0 0 64c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-64-64 0 0 64zM0 88C0 57.1 25.1 32 56 32l48 0c30.9 0 56 25.1 56 56l0 168c0 35.3 28.7 64 64 64s64-28.7 64-64l0-168c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 168c0 123.7-100.3 224-224 224S0 379.7 0 256L0 88z',
  ],
};
const faJar = {
  prefix: 'far',
  iconName: 'jar',
  icon: [
    320,
    512,
    [],
    'e516',
    'M32 24c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16l0 80L48 224l0-80c0-8.8 7.2-16 16-16l192 0zm16 240l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80 224 0zM64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64L64 80z',
  ],
};
const faGramophone = {
  prefix: 'far',
  iconName: 'gramophone',
  icon: [
    384,
    512,
    [],
    'f8bd',
    'M127 0c10.5-.4 20 6 23.6 15.9c0 0 0 .1 0 .1l.3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4L184 352c-13.3 0-24-10.7-24-24c0-1.7 .2-3.3 .5-4.8c2.2-10.9 11.9-19.2 23.5-19.2l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.4-.3-2.7-.8-4-1.3c-.4-.2-.8-.4-1.2-.6c-1.4-.7-2.7-1.5-3.9-2.4c-.7-.5-1.3-1.1-1.9-1.7c-1.3-1.2-2.4-2.6-3.4-4.1c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM94.8 243.4c54.3-29.5 103.6-42.4 144.6-46.7c-41.1-30.1-70.7-62.3-91.5-90.2c-4.5-6.1-8.6-11.9-12.3-17.5L94.8 243.4zM0 488c0-13.3 10.7-24 24-24l8 0 0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24zm304-24l0-32L80 432l0 32 224 0z',
  ],
};
const faDiceD12 = {
  prefix: 'far',
  iconName: 'dice-d12',
  icon: [
    512,
    512,
    [],
    'f6ce',
    'M200.3 48L158.7 72 256 102.8 353.3 72 311.7 48 200.3 48zm-97.1 56.7L49.7 197.3l83.9 93.1L232 241.2l0-95.6L103.2 104.7zM48 267.1l0 44.7 55.7 96.5L140 429.2l-33.1-96.8L48 267.1zM202.7 464l108 0 43.9-131.8L256 282.8l-98.5 49.3L202.7 464zm170.5-35.4l35.2-20.3L464 311.7l0-44.7-58.8 65.3-32.1 96.2zm89.2-231.3l-53.4-92.5L280 145.6l0 95.6 98.4 49.2 83.9-93.1zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4L311.7 0c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24l0 111.5c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4l-111.5 0c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24L0 200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z',
  ],
};
const faNoteSticky = {
  prefix: 'far',
  iconName: 'note-sticky',
  icon: [
    448,
    512,
    [62026, 'sticky-note'],
    'f249',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l224 0 0-80c0-17.7 14.3-32 32-32l80 0 0-224c0-8.8-7.2-16-16-16L64 80zM288 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z',
  ],
};
const faStickyNote = faNoteSticky;
const faDown = {
  prefix: 'far',
  iconName: 'down',
  icon: [
    384,
    512,
    ['arrow-alt-down'],
    'f354',
    'M192 429.6L49.3 279.7c-.8-.8-1.3-2-1.3-3.2c0-2.5 2-4.6 4.6-4.6l83.4 0c13.3 0 24-10.7 24-24l0-168 64 0 0 168c0 13.3 10.7 24 24 24l83.4 0c2.5 0 4.6 2 4.6 4.6c0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3L161.1 466.8c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2L369.5 312.8c9.3-9.8 14.5-22.8 14.5-36.3c0-29-23.5-52.6-52.6-52.6L272 224l0-144c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 144-59.4 0C23.5 224 0 247.5 0 276.6z',
  ],
};
const faArrowAltDown = faDown;
const faHundredPoints = {
  prefix: 'far',
  iconName: 'hundred-points',
  icon: [
    512,
    512,
    [128175, '100'],
    'e41c',
    'M171.2 99.6C175.3 61.2 207.8 32 246.5 32c45 0 80.1 39 75.3 83.8L308.8 236.4c-4.1 38.5-36.6 67.6-75.3 67.6c-45 0-80.1-39-75.3-83.8L171.2 99.6zM246.5 80c-14.2 0-26 10.7-27.5 24.8L206 225.3c-1.8 16.4 11.1 30.7 27.5 30.7c14.2 0 26-10.7 27.5-24.8L274 110.7C275.8 94.3 262.9 80 246.5 80zm-128-43.4c6.9 5.1 10.4 13.4 9.4 22l-32 256c-1.6 13.2-13.6 22.7-26.8 21.3s-22.5-13.3-20.8-26.4L75 95 41.4 109.9c-12.2 5.4-26.3 0-31.5-12.1s.4-26.3 12.6-31.7l72-32c7.9-3.5 17-2.6 23.9 2.5zM431.7 32c44.4 0 79.2 37.9 75.6 82.1l-7.4 88.4c-3.3 39.3-36.1 69.5-75.6 69.5c-44.4 0-79.2-37.9-75.6-82.1l7.4-88.4C359.4 62.2 392.2 32 431.7 32zM404 105.5l-7.4 88.4C395.2 210.1 408 224 424.3 224c14.5 0 26.5-11.1 27.7-25.5l7.4-88.4C460.8 93.9 448 80 431.7 80c-14.5 0-26.5 11.1-27.7 25.5zM511.7 323.9c2.3 13.1-6.5 25.5-19.6 27.7l-464 80C15 433.9 2.6 425.1 .3 412.1s6.5-25.5 19.6-27.7l464-80c13.1-2.3 25.5 6.5 27.7 19.6zM459.9 439.7l-240 40c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l240-40c13.1-2.2 25.4 6.7 27.6 19.7s-6.7 25.4-19.7 27.6z',
  ],
};
const fa100 = faHundredPoints;
const faPaperclipVertical = {
  prefix: 'far',
  iconName: 'paperclip-vertical',
  icon: [
    384,
    512,
    [],
    'e3c2',
    'M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108l0 236c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236c0-33.1-26.9-60-60-60s-60 26.9-60 60l0 260c0 53 43 96 96 96s96-43 96-96l0-216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-260z',
  ],
};
const faWindWarning = {
  prefix: 'far',
  iconName: 'wind-warning',
  icon: [
    640,
    512,
    ['wind-circle-exclamation'],
    'f776',
    'M224 432c61.8 0 116.1-31.8 147.5-80l54.9 0c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208l-48.2 0C391.2 150.3 315.8 80 224 80C126.8 80 48 158.8 48 256s78.8 176 176 176zm0-304c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM478 224c-2.1-16.5-5.7-32.6-10.8-48l76.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c53 0 96 43 96 96s-43 96-96 96l-66 0zm-6 256c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-192 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c57.4 0 104 46.6 104 104s-46.6 104-104 104l-64 0z',
  ],
};
const faWindCircleExclamation = faWindWarning;
const faLocationPinSlash = {
  prefix: 'far',
  iconName: 'location-pin-slash',
  icon: [
    640,
    512,
    ['map-marker-slash'],
    'f60c',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4L192.3 125.4zm-2.5 120.1l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9c-.5-1.2-1-2.5-1.5-3.7z',
  ],
};
const faMapMarkerSlash = faLocationPinSlash;
const faFaceSadSweat = {
  prefix: 'far',
  iconName: 'face-sad-sweat',
  icon: [
    576,
    512,
    [],
    'e38a',
    'M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM35.7 299.4C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1zM360.4 409.5c9.7-9 10.2-24.2 1.2-33.9C347.3 360.3 322.6 344 288 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM367.6 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm121.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0z',
  ],
};
const faBugSlash = {
  prefix: 'far',
  iconName: 'bug-slash',
  icon: [
    640,
    512,
    [],
    'e490',
    'M224 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zm73.7 112L432 313.3l0-49.3c0-30.9-25.1-56-56-56l-78.3 0zM477.4 348.9L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L240 162.8c7.7-1.8 15.8-2.8 24-2.8l112 0c20 0 38.7 5.7 54.6 15.5L503 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C474.3 225.3 480 244 480 264l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0 0 8c0 9.9-.9 19.5-2.6 28.9zm-46.6 86.5C402.1 463 363 480 320 480c-43.7 0-83.3-17.5-112.2-45.9L137 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8c-12-22.4-18.8-48.1-18.8-75.3l0-8-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c0-12.9 2.4-25.3 6.7-36.7L208.1 260c-.1 1.3-.1 2.7-.1 4l0 56c0 53.6 37.7 98.4 88 109.4l0-100.2L344 367l0 62.4c18.3-4 34.8-12.4 48.6-24.1l38.2 30.1z',
  ],
};
const faCupcake = {
  prefix: 'far',
  iconName: 'cupcake',
  icon: [
    448,
    512,
    [129473],
    'e402',
    'M224 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L152 64c-39.8 0-72 32.2-72 72l0 .8C34.9 142.7 0 181.3 0 228c0 50.8 41.2 92 92 92l264 0c50.8 0 92-41.2 92-92c0-46.8-35-85.5-80.2-91.3c.2-2 .2-4 .2-6.1C368 58.5 309.5 0 237.3 0L224 0zm40 57.3c0-1.7-.1-3.3-.2-5c32.7 11 56.2 41.9 56.2 78.3c0 6-1.8 11.5-4.8 16.1c-4.9 7.4-5.3 16.8-1.1 24.6s12.3 12.6 21.1 12.6l20.8 0c24.3 0 44 19.7 44 44s-19.7 44-44 44L92 272c-24.3 0-44-19.7-44-44s19.7-44 44-44l18.4 0c8.6 0 16.5-4.6 20.8-12s4.3-16.6 0-24c-2-3.5-3.2-7.6-3.2-12c0-13.3 10.7-24 24-24l57.3 0c30.2 0 54.7-24.5 54.7-54.7zM89.3 471.9C93.2 495 113.2 512 136.7 512l11.2 0-20-160-58.5 0 20 119.9zM180.1 512l87.8 0 20-160-127.8 0 20 160zm120 0l11.2 0c23.5 0 43.5-17 47.3-40.1l20-119.9-58.5 0-20 160z',
  ],
};
const faLightSwitchOff = {
  prefix: 'far',
  iconName: 'light-switch-off',
  icon: [
    384,
    512,
    [],
    'e018',
    'M169.4 464c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16L320 464c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L214.6 48c-3.3 9.3-12.2 16-22.6 16s-19.3-6.7-22.6-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l105.4 0zM64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512zm80-256l96 0 0-112-96 0 0 112zm0 160c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0z',
  ],
};
const faToggleLargeOff = {
  prefix: 'far',
  iconName: 'toggle-large-off',
  icon: [
    576,
    512,
    [],
    'e5b0',
    'M192 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zm0 48l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448zm127-48c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144l65 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-65 0z',
  ],
};
const faPenFancySlash = {
  prefix: 'far',
  iconName: 'pen-fancy-slash',
  icon: [
    640,
    512,
    [],
    'e210',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L398.9 287.3 548.8 147.8C566.2 131.6 576 109 576 85.3C576 38.2 537.8 0 490.7 0C467 0 444.4 9.8 428.2 27.2L275.8 190.9 38.8 5.1zM313.7 220.6L463.4 59.9c7.1-7.6 17-11.9 27.3-11.9C511.3 48 528 64.7 528 85.3c0 10.4-4.3 20.2-11.9 27.3L360.6 257.4l-46.9-36.8zm19.9 144.6l-40.4-31.8-20.7 67.3c-2.3 7.6-8.3 13.5-15.9 15.9L149 449.7 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L126.3 427l33.1-107.7c2.3-7.6 8.3-13.5 15.9-15.9l57.5-17.7L187 249.7l-25.8 7.9c-22.8 7-40.6 24.9-47.6 47.6L65.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l15.3-49.6z',
  ],
};
const faTruckContainer = {
  prefix: 'far',
  iconName: 'truck-container',
  icon: [
    640,
    512,
    [],
    'f4dc',
    'M0 104C0 64.2 32.2 32 72 32l256 0c39.8 0 72 32.2 72 72l0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-184c0-13.3-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24l0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 104zM608 400c0 44.2-35.8 80-80 80s-80-35.8-80-80l-16 0-144 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-96 0-88c0-13.3 10.7-24 24-24l72.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32zM585 256l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0zM136 136l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faBoot = {
  prefix: 'far',
  iconName: 'boot',
  icon: [
    512,
    512,
    [129406],
    'f782',
    'M32 0L352 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L0 128 0 32C0 14.3 14.3 0 32 0zM0 464l0-6.6L0 448l0-32L0 160l48 0 0 256 416 0 0-56.6c0-21.2-13.9-39.9-34.2-46L345 288l-105 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l66.7 0c-1.8-5-2.7-10.4-2.7-16l0-16-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32 48 0 0 80 91.6 27.5c40.6 12.2 68.4 49.6 68.4 92l0 56.6 0 32 0 9.4 0 6.6-.4 0c-1.5 12-6.9 23.3-15.6 32c-10.2 10.2-24.1 16-38.6 16l-14.9 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-14.9 0c-14.5 0-28.4-5.8-38.6-16C7.3 487.3 1.9 476 .4 464L0 464z',
  ],
};
const faArrowUpFromWaterPump = {
  prefix: 'far',
  iconName: 'arrow-up-from-water-pump',
  icon: [
    576,
    512,
    [],
    'e4b6',
    'M112 0C85.5 0 64 21.5 64 48l0 208c-35.3 0-64 28.7-64 64L0 425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5L48 320c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 84.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9l0-105c0-35.3-28.7-64-64-64l-40 0 0-174.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 7c-9.4-9.4-24.6-9.4-33.9 0L351 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L424 256l-136 0 0-208c0-26.5-21.5-48-48-48L112 0zm-.1 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z',
  ],
};
const faFileCheck = {
  prefix: 'far',
  iconName: 'file-check',
  icon: [
    384,
    512,
    [],
    'f316',
    'M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z',
  ],
};
const faBone = {
  prefix: 'far',
  iconName: 'bone',
  icon: [
    576,
    512,
    [129460],
    'f5d7',
    'M127.4 177c-3.3-18.8-19.7-33-39.4-33c-22.1 0-40 17.9-40 40c0 11.7 4.9 22.1 13 29.5c24.8 22.8 24.8 62.2 0 85c-8 7.4-13 17.8-13 29.5c0 22.1 17.9 40 40 40c19.7 0 36.1-14.3 39.4-33c4.3-24.6 25.7-47 55.6-47L393 288c29.9 0 51.3 22.4 55.6 47c3.3 18.8 19.7 33 39.4 33c22.1 0 40-17.9 40-40c0-11.7-4.9-22.1-13-29.5c-24.8-22.8-24.8-62.2 0-85c8-7.4 13-17.8 13-29.5c0-22.1-17.9-40-40-40c-19.7 0-36.1 14.3-39.4 33c-4.3 24.6-25.7 47-55.6 47L183 224c-29.9 0-51.3-22.4-55.6-47zm47.3-8.3c.7 4.1 4.1 7.3 8.3 7.3L393 176c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3L183 336c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z',
  ],
};
const faCardsBlank = {
  prefix: 'far',
  iconName: 'cards-blank',
  icon: [
    640,
    512,
    [],
    'e4df',
    'M51.8 160.4c-3.7 2.1-4.9 6.8-2.8 10.5l167 289.3c2.1 3.7 6.8 4.9 10.5 2.8L419.4 351.6c3.7-2.1 4.9-6.8 2.8-10.5L255.2 51.8c-2.1-3.7-6.8-4.9-10.5-2.8L51.8 160.4zM7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zm451.9 226c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-13.7 0-26.2-4.9-35.9-13l135.3-78.1z',
  ],
};
const faCircle3 = {
  prefix: 'far',
  iconName: 'circle-3',
  icon: [
    512,
    512,
    [],
    'e0f0',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l66.3 0-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2L240 336c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384l27.8 0c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4s-12.5-15.3-22.4-15.3l-128 0z',
  ],
};
const faBenchTree = {
  prefix: 'far',
  iconName: 'bench-tree',
  icon: [
    640,
    512,
    [],
    'e2e7',
    'M578.7 150c-14.7-10.6-22.1-28.5-19.3-46.4c.4-2.5 .6-5 .6-7.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 2.6 .2 5.2 .6 7.6c2.8 17.9-4.6 35.8-19.3 46.4c-8.2 5.9-13.3 15.3-13.3 26c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-10.6-5.1-20.1-13.3-26zM608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80l-24 0 0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232-24 0c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM80 272l224 0 0-32L80 240l0 32zM32 224c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 14.9-10.2 27.4-24 31l0 33 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88L80 400l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-33c-13.8-3.6-24-16.1-24-31l0-64zm72 96l0 32 176 0 0-32-176 0z',
  ],
};
const faKeyboardBrightnessLow = {
  prefix: 'far',
  iconName: 'keyboard-brightness-low',
  icon: [
    640,
    512,
    [],
    'e1c1',
    'M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm88-16c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0z',
  ],
};
const faSkiBootSki = {
  prefix: 'far',
  iconName: 'ski-boot-ski',
  icon: [
    640,
    512,
    [],
    'e3cd',
    'M415.6 28.5c2.5-13-6-25.6-19-28.1s-25.6 6-28.1 19L366 32 176 32c-11.3 0-21.1 7.9-23.5 19L88.8 348.3c-7.5 34.9 19.1 67.7 54.8 67.7L424 416c30.9 0 56-25.1 56-56l0-52.9c0-20.6-11.3-39.5-29.4-49.3l-71.7-38.6L415.6 28.5zM275 80l81.8 0-15.4 80L304 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.3 0-6.2 32L288 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.9 0 81.8 44.1c2.6 1.4 4.2 4.1 4.2 7l0 52.9c0 4.4-3.6 8-8 8l-280.4 0c-5.1 0-8.9-4.7-7.8-9.7l26-121.3C202 215.7 249.2 171.2 275 80zm-33.4 0c-17.9 57.7-44.8 92-70.3 112.5L195.4 80l46.2 0zM640 408c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 30.9-25.1 56-56 56L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l512 0c57.4 0 104-46.6 104-104z',
  ],
};
const faBrainCircuit = {
  prefix: 'far',
  iconName: 'brain-circuit',
  icon: [
    512,
    512,
    [],
    'e0c6',
    'M192 48c22.1 0 40 17.9 40 40l0 40-19.3 0c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24l19.3 0 0 96-40 0c-26.5 0-48 21.5-48 48l0 11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3c0-8.8 7.2-16 16-16l40 0 0 132c0 24.3-19.7 44-44 44c-17.8 0-33.2-10.6-40.1-25.9c-3.8-8.4-12-13.9-21.2-14.1c-25.9-.7-46.7-21.9-46.7-48c0-2.6 .2-5.2 .6-7.6c1.4-8.5-2-17.1-8.7-22.5C57.3 334.1 48 316.2 48 296c0-19.3 8.5-36.6 22.1-48.3c8-6.9 10.5-18.3 6.1-28c-2.7-6-4.2-12.6-4.2-19.7c0-18.8 10.8-35.1 26.7-43c8.1-4 13.3-12.3 13.3-21.3c.1-19.3 11.7-36 28.3-43.5c6.4-2.9 11.3-8.5 13.2-15.3C158.3 60.2 173.8 48 192 48zm-4 464c26.9 0 51.2-11.6 68-30c16.8 18.5 41.1 30 68 30c32.2 0 60.5-16.5 76.9-41.5c45-8 79.1-47.3 79.1-94.5c0-.5 0-1.1 0-1.6c19.8-20.2 32-47.9 32-78.4c0-27.8-10.1-53.2-26.8-72.7C487 215.8 488 208 488 200c0-32.6-16.3-61.5-41.1-78.8c-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0c-25.2 0-48 10.6-64 27.6C240 10.6 217.2 0 192 0c-36.3 0-67.5 22-80.9 53.4C86.9 67.7 69.6 92.3 65.1 121.2C40.3 138.5 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.5 12.2 58.2 32 78.4c0 .5 0 1.1 0 1.6c0 47.3 34.1 86.5 79.1 94.5c16.4 25 44.7 41.5 76.9 41.5zm136-48c-24.3 0-44-19.7-44-44l0-68 51.3 0c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L280 320l0-160 40 0c8.8 0 16 7.2 16 16l0 11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3c0-26.5-21.5-48-48-48l-40 0 0-40c0-22.1 17.9-40 40-40c18.2 0 33.7 12.2 38.5 28.9c1.9 6.8 6.8 12.4 13.2 15.3c16.6 7.5 28.2 24.1 28.3 43.5c.1 9.1 5.2 17.3 13.3 21.3c15.9 7.9 26.7 24.2 26.7 43c0 7.1-1.5 13.7-4.2 19.7c-4.4 9.7-1.9 21 6.1 28c13.5 11.8 22.1 29 22.1 48.3c0 20.2-9.3 38.1-23.9 49.9c-6.7 5.4-10 14-8.7 22.5c.4 2.5 .6 5 .6 7.6c0 26.1-20.8 47.3-46.7 48c-9.2 .3-17.4 5.7-21.2 14.1C357.2 453.4 341.8 464 324 464zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
  ],
};
const faTableCellsRowUnlock = {
  prefix: 'far',
  iconName: 'table-cells-row-unlock',
  icon: [
    640,
    512,
    [],
    'e691',
    'M48 296l0-80 104 0 0 80L48 296zm0 120l0-72 104 0 0 88-88 0c-8.8 0-16-7.2-16-16zm264 16l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 216l112 0 0 80-112 0 0-80zm296 56c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0-32 0-32 0 0-48z',
  ],
};
const faUserInjured = {
  prefix: 'far',
  iconName: 'user-injured',
  icon: [
    448,
    512,
    [],
    'f728',
    'M224 208c-44.2 0-80-35.8-80-80l32 0 128 0c0 44.2-35.8 80-80 80zM150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7 .1L170.2 96l-19.6 0zM264.6 59c14.5 8.5 26 21.5 32.8 37l-77.2 0 44.4-37zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM49.3 464c4.7-33.3 21.9-62.5 46.7-82.7L96 464l-46.7 0zm246.3 0l-34.3 0-32-48 46.7 0c15.5 0 28 12.5 28 28c0 7.8-3.2 14.9-8.4 20zm37 0c2.2-6.3 3.4-13 3.4-20c0-33.1-26.9-60-60-60l-68 0-21.3-32 83 0c65.7 0 120.1 48.7 129 112l-66.1 0zM178.3 304C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z',
  ],
};
const faBlockBrickFire = {
  prefix: 'far',
  iconName: 'block-brick-fire',
  icon: [
    640,
    512,
    ['firewall'],
    'e3dc',
    'M176 80l0 48 32 0 48 0 80 0 0-48L176 80zm-48 48l0-48L96 80c-8.8 0-16 7.2-16 16l0 32 48 0zM80 176l0 56 128 0 0-56L80 176zm0 160l48 0 0-56-48 0 0 56zm0 48l0 32c0 8.8 7.2 16 16 16l112 0 0-48-32 0-48 0-48 0zm96-48l112.8 0c-.5 4.7-.8 9.4-.8 14.1c0 11.5 1 22.9 3 33.9l-35 0 0 48 50.1 0c8.1 17.5 18.8 33.7 31.5 48L96 480c-35.3 0-64-28.7-64-64L32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 48.6c-1.7-1.5-3.3-3.1-5-4.6c-17.7-16-44.7-16-62.5-.1c-12.9 11.5-25.1 23.7-36.5 36.1L256 176l0 56 76 0c-2.4 3.6-4.7 7.2-6.9 10.7c-7.4 12-14.2 24.5-19.9 37.3L176 280l0 56zM432 128l0-32c0-8.8-7.2-16-16-16l-32 0 0 48 48 0zm73.7 80.3L518 194.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.2 640 322.2 640 352.2C640 440.8 568.7 512 480 512c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z',
  ],
};
const faFirewall = faBlockBrickFire;
const faFaceSadTear = {
  prefix: 'far',
  iconName: 'face-sad-tear',
  icon: [
    512,
    512,
    [128546, 'sad-tear'],
    'f5b4',
    'M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faSadTear = faFaceSadTear;
const faPlane = {
  prefix: 'far',
  iconName: 'plane',
  icon: [
    576,
    512,
    [],
    'f072',
    'M557.3 215.3c9.9 9.7 18.7 23.3 18.7 40.7c0 17.4-8.6 31.2-18.7 41.1c-9.9 9.7-22.6 17-34.9 22.4C497.8 330.2 468.6 336 448 336l-66.2 0L285.7 486.2c-10.3 16.1-28.1 25.8-47.2 25.8l-40.6 0c-27.1 0-46.4-26.4-38.1-52.2L199.4 336 148 336l-36 48L92.8 369.6 112 384c-7.6 10.1-19.4 16-32 16l-42.1 0C17 400 0 383 0 362.1c0-3.8 .6-7.5 1.7-11.1c0 0 0 0 0 0L30.9 256 1.7 161.1s0 0 0 0C.6 157.4 0 153.7 0 149.9C0 129 17 112 37.9 112L80 112c12.6 0 24.4 5.9 32 16l36 48 51.4 0L159.8 52.2C151.6 26.4 170.8 0 197.9 0l40.6 0c19.1 0 36.9 9.7 47.2 25.8L381.8 176l66.2 0c20.7 0 50 6.1 74.5 16.9c12.3 5.5 24.9 12.8 34.8 22.4zm-54.2 21.5c-19-8.4-41.7-12.8-55.1-12.8l-79.4 0c-8.2 0-15.8-4.2-20.2-11.1L245.2 51.7l20.2-12.9L245.2 51.7c-1.5-2.3-4-3.7-6.7-3.7l-29.6 0 46.3 144.7c2.3 7.3 1 15.3-3.5 21.5s-11.7 9.8-19.4 9.8L136 224c-7.6 0-14.7-3.6-19.2-9.6L76 160l-24.4 0 27.4 88.9c1.4 4.6 1.4 9.5 0 14.1L51.6 352 76 352l40.8-54.4c4.5-6 11.6-9.6 19.2-9.6l96.3 0c7.7 0 14.9 3.7 19.4 9.8s5.8 14.2 3.5 21.5L208.9 464l29.6 0c2.7 0 5.3-1.4 6.7-3.7L348.4 299.1c4.4-6.9 12-11.1 20.2-11.1l79.4 0c13.6 0 36.3-4.2 55.2-12.5c9.4-4.1 16.3-8.5 20.6-12.7c4.1-4 4.2-6.2 4.2-6.8c0 0 0 0 0 0c0-.2 0-2.2-4.2-6.3c-4.3-4.2-11.3-8.7-20.7-12.9zM47.6 365s0 0 0 0s0 0 0 0s0 0 0 0zm0-218.1s0 0 0 0s0 0 0 0s0 0 0 0z',
  ],
};
const faTentArrowsDown = {
  prefix: 'far',
  iconName: 'tent-arrows-down',
  icon: [
    576,
    512,
    [],
    'e581',
    'M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z',
  ],
};
const faExclamation = {
  prefix: 'far',
  iconName: 'exclamation',
  icon: [
    128,
    512,
    [10069, 10071, 61738],
    '21',
    'M88 56c0-13.3-10.7-24-24-24S40 42.7 40 56l0 288c0 13.3 10.7 24 24 24s24-10.7 24-24L88 56zM64 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faArrowsSpin = {
  prefix: 'far',
  iconName: 'arrows-spin',
  icon: [
    512,
    512,
    [],
    'e4bb',
    'M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3l0-48.7c10.8-1.7 21.9-2.5 33.1-2.5c56 0 107 21.3 145.4 56.2l35.1-35.1c10.1-10.1 27.3-2.9 27.3 11.3l0 105.4c0 8.8-7.2 16-16 16l-105.4 0c-14.3 0-21.4-17.2-11.3-27.3l36.3-36.3c-29.6-26.3-68.7-42.2-111.4-42.2zM129.9 145.9c-25.4 29.4-40.7 67.8-40.7 109.7c0 11.1 1.1 22 3.1 32.5l-48.7 0c-1.6-10.6-2.4-21.4-2.4-32.5c0-55.2 20.7-105.5 54.7-143.7L60.7 76.7C50.6 66.6 57.7 49.4 72 49.4l105.4 0c8.8 0 16 7.2 16 16l0 105.4c0 14.3-17.2 21.4-27.3 11.3l-36.2-36.2zm52.2 202.4l-34.6 34.6c29.4 25.4 67.8 40.7 109.7 40.7c10.5 0 20.9-1 30.9-2.8l0 48.6c-10.1 1.4-20.4 2.2-30.9 2.2c-55.2 0-105.5-20.7-143.7-54.7L76.7 453.6c-10.1 10.1-27.3 2.9-27.3-11.3l0-105.4c0-8.8 7.2-16 16-16l105.4 0c14.3 0 21.4 17.2 11.3 27.3zm166.2-16l34.7 34.7c26.3-29.6 42.2-68.7 42.2-111.4c0-10.8-1-21.3-3-31.5l48.7 0c1.5 10.3 2.3 20.8 2.3 31.5c0 56-21.3 107-56.2 145.4l36.7 36.7c10.1 10.1 2.9 27.3-11.3 27.3l-105.4 0c-8.8 0-16-7.2-16-16l0-105.4c0-14.3 17.2-21.4 27.3-11.3z',
  ],
};
const faFaceSmileRelaxed = {
  prefix: 'far',
  iconName: 'face-smile-relaxed',
  icon: [
    512,
    512,
    [],
    'e392',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm-2-98.1c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z',
  ],
};
const faCommentXmark = {
  prefix: 'far',
  iconName: 'comment-xmark',
  icon: [
    512,
    512,
    ['comment-times'],
    'f4b5',
    'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM175 159c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
  ],
};
const faCommentTimes = faCommentXmark;
const faPrint = {
  prefix: 'far',
  iconName: 'print',
  icon: [
    512,
    512,
    [128424, 128438, 9113],
    'f02f',
    'M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z',
  ],
};
const faTurkishLiraSign = {
  prefix: 'far',
  iconName: 'turkish-lira-sign',
  icon: [
    384,
    512,
    ['try', 'turkish-lira'],
    'e2bb',
    'M88 32c13.3 0 24 10.7 24 24l0 56.2L249.4 72.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 162.1l0 46.1 137.4-39.3c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 258.1 112 432l71.8 0c81.3 0 148.2-63.9 151.8-145.1l.4-8c.6-13.2 11.8-23.5 25.1-22.9s23.5 11.8 22.9 25.1l-.4 8C378.8 395.9 290.7 480 183.8 480L88 480c-13.3 0-24-10.7-24-24l0-184.2-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11 0-46.1-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11L64 56c0-13.3 10.7-24 24-24z',
  ],
};
const faTry = faTurkishLiraSign;
const faTurkishLira = faTurkishLiraSign;
const faFaceNoseSteam = {
  prefix: 'far',
  iconName: 'face-nose-steam',
  icon: [
    576,
    512,
    [],
    'e382',
    'M288 464c-21.6 0-42.4-3.3-61.9-9.4c-3.1 8.6-8.1 16.7-15 23.6c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-7-7-12-15.2-15.1-23.9c-19 5.7-39.2 8.8-60 8.8zM496 256c0 21.3-3.2 41.8-9.1 61.1c8.5 3.1 16.5 8.1 23.4 14.9c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c7.2-7.2 15.7-12.3 24.7-15.4C83 296.8 80 276.8 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM377.9 443.6s0 0 0 0c1.5 4.7 4.1 9.1 7.9 12.9c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.8 3.7-2.8 7.7-3.1 11.7c-.1 1.3-.1 2.7 0 4c0 .6 .1 1.3 .2 1.9c.8 6.9 3.9 13.6 9.2 18.9c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5c0 0 0 0 0 0c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-3.6-3.6-7.9-6.2-12.5-7.7c0 0 0 0 0 0c-11.1-3.7-23.9-1.1-32.8 7.7c-4.4 4.4-7.2 9.7-8.5 15.3l-69.1-46.8c-2.7-1.9-6.4-1.5-8.7 .8c-2.3 2.3-2.7 5.9-.9 8.7l46 70c-5.6 1.3-10.9 4.2-15.3 8.5c-8.8 8.8-11.4 21.3-7.9 32.4zM174.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c3.7-3.7 6.3-8.2 7.9-12.9c3.5-11 .9-23.6-7.9-32.4c-4.4-4.4-9.7-7.2-15.3-8.5l47.6-69.1c1.9-2.7 1.5-6.4-.8-8.8c-2.3-2.3-5.9-2.7-8.6-.9l-70.9 46.1c-1.3-5.6-4.2-10.9-8.5-15.3c-8.6-8.6-20.8-11.3-31.6-8.1c-5 1.5-9.7 4.2-13.6 8.1c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2c-14.4 18.8-13.1 45.9 4.2 63.1s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM144 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm95.2-101.1c-2.8-8.4-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1c8.4-2.8 12.9-11.9 10.1-20.2zm-286.4 0c-2.8 8.4 1.7 17.4 10.1 20.2c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1z',
  ],
};
const faCircleWaveformLines = {
  prefix: 'far',
  iconName: 'circle-waveform-lines',
  icon: [
    512,
    512,
    ['waveform-circle'],
    'e12d',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 224c0 13.3 10.7 24 24 24s24-10.7 24-24l0-224zm80 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM176 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm240 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32z',
  ],
};
const faWaveformCircle = faCircleWaveformLines;
const faDollarSign = {
  prefix: 'far',
  iconName: 'dollar-sign',
  icon: [
    320,
    512,
    [128178, 61781, 'dollar', 'usd'],
    '24',
    'M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 47.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1c-12.1-5.4-26.3 .1-31.7 12.2s.1 26.3 12.2 31.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2l0 49.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48.6c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5c12.9 3.1 25.8-4.9 28.9-17.8S268.4 89 255.5 86c-18.7-4.4-44.2-9.7-71.5-12.5L184 24z',
  ],
};
const faDollar = faDollarSign;
const faUsd = faDollarSign;
const faFerrisWheel = {
  prefix: 'far',
  iconName: 'ferris-wheel',
  icon: [
    512,
    512,
    [],
    'e174',
    'M371.4 73.4c-20.4-13-43.2-22.6-67.5-28.1C302.5 20.1 281.6 0 256 0s-46.5 20.1-47.9 45.3c-24.3 5.5-47.1 15.1-67.5 28.1c-8-5.9-17.9-9.4-28.5-9.4c-26.5 0-48 21.5-48 48c0 10.7 3.5 20.6 9.4 28.5c-13 20.4-22.6 43.2-28.1 67.5C20.1 209.5 0 230.4 0 256s20.1 46.5 45.3 47.9c5.5 24.3 15.1 47.1 28.1 67.5c-5.9 8-9.4 17.9-9.4 28.6c0 25.6 20 46.4 45.1 47.9l38.5-80c-7.4-8.3-17.7-13.9-29.3-15.5c-14.8-21.1-24.9-45.7-28.7-72.4l90 0c-2.4-7.6-3.7-15.6-3.7-24s1.3-16.4 3.7-24l-90 0c3.8-26.7 13.9-51.3 28.7-72.4c2.1-.3 4.1-.7 6-1.2L185.1 219c7.6-14.5 19.5-26.4 33.9-33.9l-60.6-60.6c.5-2 .9-4 1.2-6c21.1-14.8 45.7-24.9 72.4-28.7l0 90c7.6-2.4 15.6-3.7 24-3.7s16.4 1.3 24 3.7l0-90c26.7 3.8 51.3 13.9 72.4 28.7c.3 2.1 .7 4.1 1.2 6L293 185.1c14.5 7.6 26.4 19.5 33.9 33.9l60.6-60.6c2 .5 4 .9 6 1.2c14.8 21.1 24.9 45.7 28.7 72.4l-90 0c2.4 7.6 3.7 15.6 3.7 24s-1.3 16.4-3.7 24l90 0c-3.8 26.7-13.9 51.3-28.7 72.4c-11.6 1.5-21.8 7.2-29.3 15.5l38.5 80C428 446.4 448 425.6 448 400c0-10.7-3.5-20.6-9.4-28.6c13-20.4 22.6-43.2 28.1-67.5c25.3-1.4 45.3-22.3 45.3-47.9s-20.1-46.5-45.3-47.9c-5.5-24.3-15.1-47.1-28.1-67.5c5.9-8 9.4-17.9 9.4-28.5c0-26.5-21.5-48-48-48c-10.7 0-20.6 3.5-28.6 9.4zM304 256c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.6 4.1 22.3 11 30.6L130.2 477.9c-3.5 7.4-2.9 16.1 1.5 23s12 11.1 20.2 11.1l208 0c8.2 0 15.8-4.2 20.2-11.1s5-15.6 1.5-23L293 286.6c6.9-8.3 11-19 11-30.6zm18.4 208l-132.8 0L256 321l66.4 143z',
  ],
};
const faComputerSpeaker = {
  prefix: 'far',
  iconName: 'computer-speaker',
  icon: [
    640,
    512,
    [],
    'f8b2',
    'M312.4 480c-11.8-13.2-20.1-29.7-23.1-48L120 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l192.4 0zM64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l224 0 0-48L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l225.3 0c3.1-18.3 11.3-34.8 23.1-48L64 32zM576 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l192 0zM384 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L384 32zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM448 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
  ],
};
const faSkullCow = {
  prefix: 'far',
  iconName: 'skull-cow',
  icon: [
    640,
    512,
    [],
    'f8de',
    'M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224c0 0 0 0 0 0l16 0 0 64c0 45 31 82.8 72.7 93.2l25.6 85.2c8.1 27.1 33 45.6 61.3 45.6l32.8 0c28.3 0 53.2-18.5 61.3-45.6l25.6-85.2C465 370.8 496 333 496 288l0-64 16 0s0 0 0 0c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1s-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128l-23 0s0 0 0 0l-40.4 0C454 108.4 428.4 96 400 96L240 96c-28.4 0-54 12.4-71.6 32L128 128s0 0 0 0l-23 0c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM228.3 334.6C207.4 329.4 192 310.4 192 288l0-64 0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32 0 64c0 22.4-15.4 41.4-36.3 46.6c-16.4 4.1-29.5 16.6-34.4 32.8l-25.6 85.2c-2 6.8-8.3 11.4-15.3 11.4l-32.8 0c-7.1 0-13.3-4.6-15.3-11.4l-25.6-85.2c-4.9-16.2-17.9-28.7-34.4-32.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
};
const faX = {
  prefix: 'far',
  iconName: 'x',
  icon: [
    384,
    512,
    [120],
    '58',
    'M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.2 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z',
  ],
};
const faMagnifyingGlassDollar = {
  prefix: 'far',
  iconName: 'magnifying-glass-dollar',
  icon: [
    512,
    512,
    ['search-dollar'],
    'f688',
    'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm20-312c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
  ],
};
const faSearchDollar = faMagnifyingGlassDollar;
const faUsersGear = {
  prefix: 'far',
  iconName: 'users-gear',
  icon: [
    640,
    512,
    ['users-cog'],
    'f509',
    'M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2l-103.2 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l300.6 0c-2.1-5.2-3.2-10.9-3.2-16.4l0-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-199.4 0c9.5-36.8 42.9-64 82.6-64l110.5 0c3.6-5 8.2-9.1 13.5-12.2l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3l0-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6l0 3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM624.6 355.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6l0-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6l0 21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z',
  ],
};
const faUsersCog = faUsersGear;
const faPersonMilitaryPointing = {
  prefix: 'far',
  iconName: 'person-military-pointing',
  icon: [
    576,
    512,
    [],
    'e54a',
    'M224 39c0-13 10-23.8 22.9-24.9L398.7 1.4C408 .7 416 8 416 17.4L416 48c0 8.8-7.2 16-16 16L249 64c-13.8 0-25-11.2-25-25zM32 248c0-13.3 10.7-24 24-24l176 0 8 0 104 0 .6 0c42.9 0 82.5 22.9 103.9 60l92.3 160c6.6 11.5 2.7 26.2-8.8 32.8s-26.2 2.7-32.8-8.8L416 323.8 416 480c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-208L56 272c-13.3 0-24-10.7-24-24zm240 24l0 82.1L345.4 272c-.5 0-1 0-1.4 0l-72 0zm0 192l96 0 0-32-96 0 0 32zm96-145.2L309.7 384l58.3 0 0-65.2zM240 112c0-5.5 .6-10.8 1.6-16l50.7 0c-2.7 4.7-4.3 10.2-4.3 16c0 17.7 14.3 32 32 32s32-14.3 32-32c0-5.8-1.6-11.3-4.3-16l50.7 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
  ],
};
const faBuildingColumns = {
  prefix: 'far',
  iconName: 'building-columns',
  icon: [
    512,
    512,
    ['bank', 'institution', 'museum', 'university'],
    'f19c',
    'M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z',
  ],
};
const faBank = faBuildingColumns;
const faInstitution = faBuildingColumns;
const faMuseum = faBuildingColumns;
const faUniversity = faBuildingColumns;
const faCircleT = {
  prefix: 'far',
  iconName: 'circle-t',
  icon: [
    512,
    512,
    [],
    'e124',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168 80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0-104 0z',
  ],
};
const faSack = {
  prefix: 'far',
  iconName: 'sack',
  icon: [
    512,
    512,
    [],
    'f81c',
    'M293.3 152l-74.6 0-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48 187.4 48l31.1 45.2L226 104l60 0 7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96z',
  ],
};
const faGrid2 = {
  prefix: 'far',
  iconName: 'grid-2',
  icon: [
    512,
    512,
    [],
    'e196',
    'M80 80l0 96 96 0 0-96L80 80zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 336l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 80l-96 0 0 96 96 0 0-96zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 304l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z',
  ],
};
const faCameraCctv = {
  prefix: 'far',
  iconName: 'camera-cctv',
  icon: [
    576,
    512,
    ['cctv'],
    'f8ac',
    'M54.9 192.2l169.3 70.5 .2 .1c.6 .2 1.1 .4 1.6 .7l92.2 38.4 160-106.7L134.9 52.2l-80 140zM185.2 298.5l-165.5-69c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9L229.5 317 182.4 440.5C178.9 449.8 170 456 160 456L48 456l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 95.5 0 41.7-109.5zm211.8 47.1l132.9-88.6 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-1.7 4-4.9 7.2-8.9 8.7s-8.5 1.5-12.5-.3L396.9 345.6z',
  ],
};
const faCctv = faCameraCctv;
const faUmbrella = {
  prefix: 'far',
  iconName: 'umbrella',
  icon: [
    576,
    512,
    [],
    'f0e9',
    'M288 0c13.3 0 24 10.7 24 24l0 24.9c123.7 9.6 226.1 93 255.5 204.4c.4 1.4 .7 2.9 1.1 4.3c1.4 5.8 2.7 11.7 3.7 17.6c.6 3.5 1.1 7.1 1.6 10.7c2 15.6-17.3 24.4-27.8 12.7c-2.5-2.8-5.5-5.5-8.8-8c-3.4-2.5-7.1-4.9-11.1-7l-.7-.4-.6-.3c-13.5-6.8-29.7-11-44.9-11c-30.1 0-56.3 16.6-70 41.2c-.5 .9-1 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6c-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-.5 .9-.9 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6C152.3 288.6 126.1 272 96 272c-15.2 0-31.4 4.2-44.9 11c-.4 .2-.9 .5-1.3 .7c-4 2.1-7.7 4.4-11.1 7c-3.3 2.5-6.3 5.2-8.8 8C19.4 310.4 .1 301.5 2.1 285.9c.5-3.6 1-7.2 1.6-10.7c1-5.9 2.3-11.8 3.7-17.6c.4-1.4 .7-2.9 1.1-4.3C37.9 141.9 140.3 58.6 264 48.9L264 24c0-13.3 10.7-24 24-24zm96 267.3c23.4-26.6 57.7-43.3 96-43.3c8.6 0 17.5 .9 26.4 2.6C468.9 150.2 386.1 96 288 96s-180.9 54.2-218.4 130.6c8.9-1.7 17.8-2.6 26.4-2.6c38.3 0 72.6 16.8 96 43.3c23.4-26.6 57.7-43.3 96-43.3s72.6 16.8 96 43.3zM288 304c8.7 0 16.9 2.3 24 6.4l0 128.1c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4l0-128.1c7.1-4.1 15.3-6.4 24-6.4z',
  ],
};
const faTrowel = {
  prefix: 'far',
  iconName: 'trowel',
  icon: [
    512,
    512,
    [],
    'e589',
    'M340.4 142L370 171.6l87.9-87.9c8.2-8.2 8.2-21.4 0-29.6s-21.4-8.2-29.6 0L340.4 142zM491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-5.4-5.4L237.9 308l75 75c5.9 5.9 8.3 14.5 6.4 22.6s-8 14.6-15.9 17.2l-272 88c-8.6 2.8-18 .5-24.4-5.9s-8.6-15.8-5.9-24.4l88-272c2.6-7.9 9.1-14 17.2-15.9s16.7 .5 22.6 6.4l75 75L304.3 173.8l-5.4-5.4c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM251.3 389.2L122.8 260.7l-61.5 190 190-61.5z',
  ],
};
const faHorizontalRule = {
  prefix: 'far',
  iconName: 'horizontal-rule',
  icon: [
    640,
    512,
    [8213],
    'f86c',
    'M0 256c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
  ],
};
const faBedFront = {
  prefix: 'far',
  iconName: 'bed-front',
  icon: [
    512,
    512,
    ['bed-alt'],
    'f8f7',
    'M32 80l0 125.8c14.5-7.7 30.8-12.4 48-13.6l0-.3 0-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 32 32 0 0-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 32 0 .3c17.2 1.1 33.5 5.9 48 13.6L480 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80zM88 224c-48.6 0-88 39.4-88 88l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 416 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 0-80c0-48.6-39.4-88-88-88L88 224zM464 368L48 368l0-56c0-22.1 17.9-40 40-40l336 0c22.1 0 40 17.9 40 40l0 56z',
  ],
};
const faBedAlt = faBedFront;
const faD = {
  prefix: 'far',
  iconName: 'd',
  icon: [
    384,
    512,
    [100],
    '44',
    'M56 80c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l104 0c97.2 0 176-78.8 176-176s-78.8-176-176-176L56 80zM0 88C0 57.1 25.1 32 56 32l104 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L56 480c-30.9 0-56-25.1-56-56L0 88z',
  ],
};
const faStapler = {
  prefix: 'far',
  iconName: 'stapler',
  icon: [
    640,
    512,
    [],
    'e5af',
    'M448 384l0 48L56 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0 48 0 24 0 72 0c26.5 0 48-21.5 48-48l0-96 0-36.7 0-11.3-.7-.1c-3.8-31.8-23.3-59.9-52.4-74.4L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L64 240l0 104c0 22.1 17.9 40 40 40l344 0zm0-48l-336 0 0-84 336 84zm72 96l-24 0 0-96c0-22-15-41.2-36.4-46.6L55.2 188.3c-4.2-1.1-7.2-4.8-7.2-9.2c0-2 .7-4 1.9-5.7l32.3-43.1C106 98.7 143.3 80 182.9 80c19.5 0 38.8 4.6 56.3 13.3L565.5 256.4c14.5 7.3 24.3 21.3 26.2 37.2c.1 .8 .2 1.6 .3 2.4l0 3.4 0 36.7 0 96-72 0z',
  ],
};
const faMasksTheater = {
  prefix: 'far',
  iconName: 'masks-theater',
  icon: [
    640,
    512,
    [127917, 'theater-masks'],
    'f630',
    'M376.1 32.1c-41.2 .7-71.8 7.8-94.3 16.7c-23.1-2-53.9-1.4-94 5.2C95.6 69.1 60.7 98 49.3 110.7L76.8 271.9c4.9 28.7 17.5 52.2 36.1 67.2c20.3 16.4 45.2 34 70.7 46.2c10.4 5 20 8.6 28.8 11.1c1.7 3.1 3.4 6.1 5.3 9.2c8.1 13 17.9 27.5 29.1 42.1c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28c1.7 1.2 3.2 2.5 4.5 4zM194 282.3c-15.6 5.8-29.7 14-42.1 24.2c-6.6 5.4-16.8 1.7-15.6-6.6c5.4-35 31.3-64.6 67.2-74.3l-8.5 49.6c-.4 2.3-.8 4.7-1.1 7zM176.7 153.7c4.5-3.2 11.1-2.2 12.2 3.1c.1 .5 .2 1.1 .3 1.6c3.7 21.7-11.2 42.2-33.4 45.8s-43.1-11-46.8-32.7c-.1-.5-.2-1.1-.2-1.6c-.7-5.4 5.3-8.4 10.5-6.9c9.3 2.8 19.5 3.6 29.8 1.9s19.6-5.7 27.5-11.3zM385.1 510.6c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-47-80.7c20.7 20.3 39.5 31 55 33.6s36.9-1.6 63.2-14.2c25.5-12.2 50.4-29.8 70.7-46.2c18.6-15.1 31.2-38.6 36.1-67.3l27.5-161.2C579.3 162 544.4 133.1 452.1 118s-134.9 1-149.9 9.4L274.7 288.6c-4.9 28.7-.8 54.9 11.8 75.1c13.7 22 31.5 46.6 51.5 66.2zm57.3-193.4c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6c-1.1 5.3-7.8 6.3-12.2 3.1zm140.4 17.9c-1.1 5.3-7.8 6.3-12.2 3.1c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6zm-20.3 56.6c7.9-3.2 16.5 3.5 12.8 11.1c-21.1 44.3-70.3 71.2-121.9 62.8s-89.2-49.7-94.4-98.2c-.9-8.3 9.4-12 15.8-6.4c24.3 21.2 54.8 36.2 89.3 41.8s68.3 1.2 98.3-11.1z',
  ],
};
const faTheaterMasks = faMasksTheater;
const faFileGif = {
  prefix: 'far',
  iconName: 'file-gif',
  icon: [
    512,
    512,
    [],
    'e645',
    'M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm160-72c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm160-24l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64c0-8.8 7.2-16 16-16z',
  ],
};
const faKipSign = {
  prefix: 'far',
  iconName: 'kip-sign',
  icon: [
    384,
    512,
    [],
    'e1c4',
    'M88 32c13.3 0 24 10.7 24 24l0 154.5L312.3 37.8c10-8.7 25.2-7.5 33.8 2.5s7.5 25.2-2.5 33.8L160.6 232 360 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-199.4 0L343.7 437.8c10 8.7 11.2 23.8 2.5 33.8s-23.8 11.2-33.8 2.5L112 301.5 112 457c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-177-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L64 56c0-13.3 10.7-24 24-24z',
  ],
};
const faFaceWoozy = {
  prefix: 'far',
  iconName: 'face-woozy',
  icon: [
    512,
    512,
    [],
    'e3a2',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 208c0-35.3-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64s32-28.7 32-64zM213.8 247.3c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l64-16zM200.9 98.7c-7.4-4.9-17.3-2.9-22.2 4.4c-23.2 34.8-58.4 53.2-71.7 57.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3c4.9-7.4 2.9-17.3-4.4-22.2zM385.8 360.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L319 362.3c-3.3 3.6-7.9 5.7-12.8 5.7c-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7c-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9c-10.7-7.8-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6l9.4 6.9c24.2 17.8 56 21.2 83.4 9.1c11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5c18.4 0 36-7.8 48.3-21.4l31.3-34.5z',
  ],
};
const faCloudQuestion = {
  prefix: 'far',
  iconName: 'cloud-question',
  icon: [
    640,
    512,
    [],
    'e492',
    'M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM233.8 197.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
};
const faPineapple = {
  prefix: 'far',
  iconName: 'pineapple',
  icon: [
    512,
    512,
    [],
    'e31f',
    'M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16l5.5 0c8.8 0 16 7.2 16 16l0 5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.6 1.1 8.4 4.2 10.5 8.4s2.2 9.1 .4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6c-15.4 15.4-35.3 23.6-55.5 24.5c8 18.9 12.2 39.3 12.2 60.2c0 41-16.3 80.3-45.3 109.3L301.3 466.7C272.3 495.7 233 512 192 512s-80.3-16.3-109.3-45.3L45.3 429.3l33.9-33.9 37.5 37.5c20 20 47.1 31.2 75.3 31.2s55.3-11.2 75.3-31.2L368.8 331.3c20-20 31.2-47.1 31.2-75.3s-11.2-55.3-31.2-75.3l-37.5-37.5c-20-20-47.1-31.2-75.3-31.2s-55.3 11.2-75.3 31.2L79.2 244.7C59.2 264.7 48 291.8 48 320s11.2 55.3 31.2 75.3L45.3 429.3C16.3 400.3 0 361 0 320s16.3-80.3 45.3-109.3L146.7 109.3C175.7 80.3 215 64 256 64c20.9 0 41.3 4.2 60.2 12.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l14.7 14.7C383 20.8 393.8 8.1 409.7 1.3c4.3-1.8 9.2-1.7 13.4 .4zm-235.8 211L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 313.4zM164.7 372.7c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z',
  ],
};
const faHandPointLeft = {
  prefix: 'far',
  iconName: 'hand-point-left',
  icon: [
    512,
    512,
    [],
    'f0a5',
    'M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z',
  ],
};
const faGalleryThumbnails = {
  prefix: 'far',
  iconName: 'gallery-thumbnails',
  icon: [
    576,
    512,
    [],
    'e3aa',
    'M512 48c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 304c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0zM0 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm128 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0z',
  ],
};
const faCircleJ = {
  prefix: 'far',
  iconName: 'circle-j',
  icon: [
    512,
    512,
    [],
    'e112',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 53 43 96 96 96s96-43 96-96l0-136z',
  ],
};
const faEyes = {
  prefix: 'far',
  iconName: 'eyes',
  icon: [
    640,
    512,
    [],
    'e367',
    'M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2c9.2 5.1 19.8 8 31.1 8c35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4c2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2zM320 141.8C290 76.1 235 32 172 32C77 32 0 132.3 0 256S77 480 172 480c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224s-77-224-172-224c-63 0-118 44.1-148 109.8zm42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5c3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z',
  ],
};
const faHandshakeSimple = {
  prefix: 'far',
  iconName: 'handshake-simple',
  icon: [
    640,
    512,
    [129309, 'handshake-alt'],
    'f4c6',
    'M272.2 64.6c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-37.2 0-73.2 13.7-101 38.4L121.1 126c-1.5 1.3-3.4 2-5.3 2L56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l59.8 0c13.7 0 27-5 37.2-14.1l26.5-23.6c12-10.7 26.2-18.3 41.5-22.5l51.1-51.1zM377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-70.1 66.2c-30.8 29.1-30.1 78.3 1.6 106.5c27.8 24.7 69.7 24.3 97-.9l35.8-33 75.8 75.8c9.4 9.4 9.4 24.6 0 33.9c-8.4 8.4-21.6 9.3-30.9 2.6c-7.1-5.1-16.5-5.9-24.4-2.1s-13.1 11.6-13.6 20.4c-.4 7.1-3.2 14-8.6 19.4c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4L56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l37.7 0c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c6.1-6.1 10.9-12.9 14.6-20.2c22.2 3.8 45.8-2.9 63-20.1c5.6-5.6 10.1-11.9 13.5-18.7L584 368c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.8 0c-2.9-12.9-9.3-25.1-19.4-35.1l-74.4-74.4 .8-.8c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-71.9 66.4c-9.2 8.5-23.2 8.6-32.5 .3c-10.6-9.4-10.9-26-.5-35.7l70.1-66.2c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-78.9 0L475 101.2C448 77.3 413.2 64 377.1 64z',
  ],
};
const faHandshakeAlt = faHandshakeSimple;
const faPageCaretUp = {
  prefix: 'far',
  iconName: 'page-caret-up',
  icon: [
    384,
    512,
    ['file-caret-up'],
    'e42a',
    'M48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384zm272 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2l-139.6 0c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z',
  ],
};
const faFileCaretUp = faPageCaretUp;
const faJetFighter = {
  prefix: 'far',
  iconName: 'jet-fighter',
  icon: [
    640,
    512,
    ['fighter-jet'],
    'f0fb',
    'M216 0l23.8 0 .4 0L296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-6.9 0c4.7 6.1 9.8 12.6 15.1 19.6c25.3 32.8 56.8 74.1 81.8 108.4l97.1 0c5.7 0 11.3 .9 16.7 2.5l108.1 33.8C627 218.3 640 236 640 256s-13 37.7-32.1 43.7L499.8 333.4c-5.4 1.7-11 2.6-16.7 2.6L386 336 288.5 464l7.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-55.8 0-.5 0L216 512l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-128-14.1 0-31.6 31.6c-10.5 10.5-24.7 16.4-39.6 16.4L88 384c-30.9 0-56-25.1-56-56l0-48-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-48c0-30.9 25.1-56 56-56l18.7 0c14.9 0 29.1 5.9 39.6 16.4L177.9 176l14.1 0 0-128-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0zm24 176l86.4 0c-19.9-26.7-41.6-55.1-60.1-79.1C256.3 84 247.3 72.4 240 63l0 113zM80 280l0 48c0 4.4 3.6 8 8 8l18.7 0c2.1 0 4.2-.8 5.7-2.3L151 295c4.5-4.5 10.6-7 17-7l315.1 0c.8 0 1.6-.1 2.4-.4L586.7 256 485.5 224.4c-.8-.2-1.6-.4-2.4-.4L168 224c-6.4 0-12.5-2.5-17-7l-38.6-38.6c-1.5-1.5-3.5-2.3-5.7-2.3L88 176c-4.4 0-8 3.6-8 8l0 48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0zm160 56l0 112.4L325.6 336 240 336z',
  ],
};
const faFighterJet = faJetFighter;
const faComet = {
  prefix: 'far',
  iconName: 'comet',
  icon: [
    512,
    512,
    [],
    'e003',
    'M459.8 3.2c4.7-2.1 9.8-3.2 15-3.2C495.3 0 512 16.7 512 37.2c0 5.2-1.1 10.3-3.2 15L449.3 187.5l10.7-.8c33.9-2.6 55.4 35.5 35.6 63.1L369.2 426.7C331 480.2 269.3 512 203.6 512C91 512 0 419.8 0 307.5c0-64.8 30.6-126.3 82.7-165L261.6 9.6c27.5-20.4 66.3 .9 63.7 35.1L324 62.9 459.8 3.2zm-6 55.1l-147 64.7c-7.7 3.4-16.6 2.5-23.5-2.4s-10.7-13-10.1-21.4l3-40.6L111.4 181C71.6 210.6 48 257.8 48 307.5C48 393.6 117.8 464 203.6 464c50.2 0 97.4-24.3 126.6-65.2l116.4-163L413 238.5c-8.4 .6-16.5-3.2-21.4-10.1s-5.8-15.8-2.4-23.5L453.8 58.3zM208 200c6.1 0 11.7 3.5 14.3 8.9l24.5 49.6 54.8 8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-39.6 38.6 9.4 54.5c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2l-49-25.8-49 25.8c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l9.4-54.5-39.6-38.6c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l54.8-8 24.5-49.6c2.7-5.5 8.3-8.9 14.3-8.9z',
  ],
};
const faSquareShareNodes = {
  prefix: 'far',
  iconName: 'square-share-nodes',
  icon: [
    448,
    512,
    ['share-alt-square'],
    'f1e1',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm352 80c0 26.5-21.5 48-48 48c-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9c26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48z',
  ],
};
const faShareAltSquare = faSquareShareNodes;
const faReflectVertical = {
  prefix: 'far',
  iconName: 'reflect-vertical',
  icon: [
    512,
    512,
    [],
    'e665',
    'M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24zM166.6 464l178.7 0L256 374.6 166.6 464zM128 512c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0zM256 137.4L345.4 48 166.6 48 256 137.4zM98.4 19.8C103.4 7.8 115.1 0 128 0L384 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9z',
  ],
};
const faShieldKeyhole = {
  prefix: 'far',
  iconName: 'shield-keyhole',
  icon: [
    512,
    512,
    [],
    'e248',
    'M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-69.4c18.9-9 32-28.3 32-50.6z',
  ],
};
const faFileMp4 = {
  prefix: 'far',
  iconName: 'file-mp4',
  icon: [
    512,
    512,
    [],
    'e649',
    'M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm93.7-104.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm84.7 11.3c-3-3-4.7-7.1-4.7-11.3l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-4.2 0-8.3-1.7-11.3-4.7z',
  ],
};
const faBarcode = {
  prefix: 'far',
  iconName: 'barcode',
  icon: [
    512,
    512,
    [],
    'f02a',
    'M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24L48 56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zM464 56l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
  ],
};
const faBulldozer = {
  prefix: 'far',
  iconName: 'bulldozer',
  icon: [
    640,
    512,
    [],
    'e655',
    'M80 88l0 88 141.9 0-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6L88 80c-4.4 0-8 3.6-8 8zM32 176l0-88c0-30.9 25.1-56 56-56l83.7 0c21.7 0 41.4 12.5 50.7 32.2L275 176l53 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56c39.8 0 72 32.2 72 72l0 48 64 0 0-31.3c0-21.9 8.2-43 22.9-59.2l63.4-69.7c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9l-63.4 69.7c-6.7 7.4-10.4 17-10.4 26.9l0 110.5c0 9.9 3.7 19.5 10.4 26.9l63.4 69.7c8.9 9.8 8.2 25-1.6 33.9s-25 8.2-33.9-1.6l-63.4-69.7c-14.7-16.2-22.9-37.3-22.9-59.2l0-31.3-47 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400c0-30.5 12.2-58.2 32-78.4L32 224l0-24 0-24zM80 292.6c10.1-3 20.9-4.6 32-4.6l256 0c11.1 0 21.9 1.6 32 4.6l0-44.6c0-13.3-10.7-24-24-24L80 224l0 68.6zM112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l256 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-256 0zM96 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
const faPlusMinus = {
  prefix: 'far',
  iconName: 'plus-minus',
  icon: [
    384,
    512,
    [],
    'e43c',
    'M216 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120L48 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l120 0 0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-120zM8 488c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464c-13.3 0-24 10.7-24 24z',
  ],
};
const faSquareSlidersVertical = {
  prefix: 'far',
  iconName: 'square-sliders-vertical',
  icon: [
    448,
    512,
    ['sliders-v-square'],
    'f3f2',
    'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 96c-13.3 0-24 10.7-24 24l0 32-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-32c0-13.3-10.7-24-24-24zm184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-128z',
  ],
};
const faSlidersVSquare = faSquareSlidersVertical;
const faVideo = {
  prefix: 'far',
  iconName: 'video',
  icon: [
    576,
    512,
    ['video-camera'],
    'f03d',
    'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 33 0 190 0 33c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM528 363.4l0-214.7L416 199l0-52.6L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5l0 241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6l0-52.6 112 50.4z',
  ],
};
const faVideoCamera = faVideo;
const faMessageMiddle = {
  prefix: 'far',
  iconName: 'message-middle',
  icon: [
    512,
    512,
    ['comment-middle-alt'],
    'e1e1',
    'M343.5 368L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l104.5 0c14.2 0 27.8 6.3 36.9 17.3L256 446l50.6-60.7c9.1-10.9 22.6-17.3 36.9-17.3zm-175 48L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-104.5 0-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z',
  ],
};
const faCommentMiddleAlt = faMessageMiddle;
const faGraduationCap = {
  prefix: 'far',
  iconName: 'graduation-cap',
  icon: [
    640,
    512,
    [127891, 'mortar-board'],
    'f19d',
    'M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z',
  ],
};
const faMortarBoard = faGraduationCap;
const faHandHoldingMedical = {
  prefix: 'far',
  iconName: 'hand-holding-medical',
  icon: [
    576,
    512,
    [],
    'e05c',
    'M224 24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l56 0 0-56zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z',
  ],
};
const faPersonCircleCheck = {
  prefix: 'far',
  iconName: 'person-circle-check',
  icon: [
    576,
    512,
    [],
    'e53e',
    'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
  ],
};
const faSquareZ = {
  prefix: 'far',
  iconName: 'square-z',
  icon: [
    448,
    512,
    [],
    'e288',
    'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm136 32l176 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336 312 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176 136 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
  ],
};
const faMessageText = {
  prefix: 'far',
  iconName: 'message-text',
  icon: [
    512,
    512,
    ['comment-alt-text'],
    'e1e6',
    'M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM168 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0-88 0z',
  ],
};
const faCommentAltText = faMessageText;
const faTurnUp = {
  prefix: 'far',
  iconName: 'turn-up',
  icon: [
    384,
    512,
    [10548, 'level-up-alt'],
    'f3bf',
    'M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3L264 208l0 144c0 88.4-71.6 160-160 160l-48 0c-30.9 0-56-25.1-56-56l0-32c0-30.9 25.1-56 56-56l56 0c4.4 0 8-3.6 8-8l0-152-41.7 0C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7L175.6 6.5zM82.5 160l61.5 0c13.3 0 24 10.7 24 24l0 176c0 30.9-25.1 56-56 56l-56 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l48 0c61.9 0 112-50.1 112-112l0-168c0-13.3 10.7-24 24-24l61.5 0L192 57 82.5 160z',
  ],
};
const faLevelUpAlt = faTurnUp;
var icons = {
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCarpool,
  faCarPeople,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faChartSine,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faSquareBinary,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faChartFft,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faChartDiagram,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faFileFragment,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faHexagonNodes,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faCirclesOverlap3,
  faPronoun,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faHexagonNodesBolt,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faCommentNodes,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faFileHalfDashed,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt,
};

export {
  icons as far,
  prefix,
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCarpool,
  faCarPeople,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faChartSine,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faSquareBinary,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faChartFft,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faChartDiagram,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faFileFragment,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faHexagonNodes,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faCirclesOverlap3,
  faPronoun,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faHexagonNodesBolt,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faCommentNodes,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faFileHalfDashed,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt,
};
